webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1078)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(1399),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1071)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(899),
  /* template */
  __webpack_require__(1362),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6fdc936e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1058)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(905),
  /* template */
  __webpack_require__(1282),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-11e3b457",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aws_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_aws_sdk__);






var http = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/itembank',
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_3_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getListMataPelajaran(callback) {
  var config = getConfig();
  http.get('/mapels', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getItemsByMataPelajaran(params, callback) {
  var config = getConfig();
  var code = '';
  var label = '';
  var babName = '';
  var subbabName = '';
  var subsubabName = '';
  var jenjang = '';
  var jenis = '';
  var kelas = '';
  if (params.itemCode !== '') code = '&item_code=' + params.itemCode;
  if (params.label !== '') label = '&label=' + params.label;
  if (params.babName !== '') babName = '&bab=' + params.babName;
  if (params.subbabName !== '') subbabName = '&subbab=' + params.subbabName;
  if (params.subsubabName !== '') subsubabName = '&subsubbab=' + params.subsubabName;
  if (params.jenjang !== '') jenjang = '&jenjang=' + params.jenjang;
  if (params.jenis !== '') jenis = '&jenis=' + params.jenis;
  if (params.kelas !== '') kelas = '&grade=' + params.kelas;

  http.get('/items?mapel_id=' + params.mapelId + code + label + babName + subbabName + subsubabName + jenjang + jenis + kelas + '&page=' + params.page, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfSchoolGrade(callback) {
  var config = getConfig();
  http.get('/grades', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfTopicGrade(callback) {
  var config = getConfig();
  http.get('/topic_grades', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfItemType(callback) {
  var config = getConfig();
  http.get('/types', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfTopic(mapelCode, callback) {
  var config = getConfig();
  http.get('/topics?mapel_code=' + mapelCode, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfTopicV2(mapelCode, callback) {
  var config = getConfig();
  http.get('/v2/topics?mapel_code=' + mapelCode, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createItem(data, callback) {
  var _postData;

  var config = getConfig();
  var postData = (_postData = {
    sumber: data.sumber,
    wacana_id: data.wacana ? data.wacana.id : 0,
    isi: data.soal,
    pilihan_1: data.opsiA,
    pilihan_2: data.opsiB,
    pilihan_3: data.opsiC,
    pilihan_4: data.opsiD,
    pilihan_5: data.opsiE,
    jawaban: data.jawaban,
    pembahasan: data.pembahasan,
    nilai_eigen: data.eigen,
    mapel_id: data.mapelId,
    jenjang_id: data.jenjang,
    jenis_soal_id: data.jenis,
    bab_id: data.babId,
    sub_bab_id: data.subBabId,
    sub_sub_bab_id: data.subSubBabId
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postData, 'sumber', data.sumber), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postData, 'pembahasan', data.pembahasan), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postData, 'is_restricted', data.is_restricted), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postData, 'label', data.label), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_postData, 'grades', data.grades), _postData);

  http.post('/item', postData, config).then(function (response) {
    callback({
      success: true,
      data: null
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateItem(id, data, callback) {
  var _requestData;

  var config = getConfig();
  var requestData = (_requestData = {
    sumber: data.sumber,
    wacana_id: data.wacana ? data.wacana.id : 0,
    isi: data.soal,
    pilihan_1: data.opsiA,
    pilihan_2: data.opsiB,
    pilihan_3: data.opsiC,
    pilihan_4: data.opsiD,
    pilihan_5: data.opsiE,
    jawaban: data.jawaban,
    pembahasan: data.pembahasan,
    nilai_eigen: data.eigen,
    mapel_id: data.mapelId,
    jenjang_id: data.jenjang,
    jenis_soal_id: data.jenis,
    bab_id: data.babId,
    sub_bab_id: data.subBabId,
    sub_sub_bab_id: data.subSubBabId
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_requestData, 'sumber', data.sumber), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_requestData, 'pembahasan', data.pembahasan), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_requestData, 'is_restricted', data.is_restricted), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_requestData, 'label', data.label), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_requestData, 'grades', data.grades), _requestData);

  http.put('/item/' + id, requestData, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteItem(id, callback) {
  var config = getConfig();
  http.delete('/item/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getItemById(id, callback) {
  var config = getConfig();
  http.get('/item/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createWacana(data, callback) {
  var config = getConfig();
  var postData = {
    mapel_id: data.mapelId,
    isi: data.wacana
  };

  http.post('/wacana', postData, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateWacana(id, data, callback) {
  var config = getConfig();
  var putData = {
    mapel_id: data.mapelId,
    isi: data.wacana
  };

  http.put('/wacana/' + id, putData, config).then(function (response) {
    callback({
      success: true,
      data: null
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListWacana(mapelId, callback) {
  var config = getConfig();
  http.get('/wacanas?mapel_id=' + mapelId, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function searchItemByItemCode(itemcode, callback) {
  var config = getConfig();
  http.get('/items?random=false&item_code=' + itemcode, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function searchItemByItemCodeAndGrade(itemcode, grade, callback) {
  var config = getConfig();
  var gr = '';
  if (grade) gr = '&grade=' + parseInt(grade);
  http.get('/items?random=false&item_code=' + itemcode + gr, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function searchRandomItemByItemCodeAndGrade(itemcode, callback) {
  var config = getConfig();
  http.get('/items?random=false&page=1&limit=1&item_code=' + itemcode, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function searchRandomItemByItemNameV2(params, callback) {
  var config = getConfig();
  var level = '';
  var code = '';
  var mapel_code = '';
  var bab_name = '';
  var subbab_name = '';
  var subsubbab_name = '';
  var question_type = '';
  var item_type = '';
  if (params.level) level = 'level=' + params.level;
  if (params.mapel_code) mapel_code = '&mapel_code=' + params.mapel_code;
  if (params.bab_name) bab_name = '&bab_name=' + params.bab_name;
  if (params.subbab_name) subbab_name = '&subbab_name=' + params.subbab_name;
  if (params.subsubbab_name) subsubbab_name = '&subsubbab_name=' + params.subsubbab_name;
  if (params.question_type) question_type = '&question_type=' + params.question_type;
  if (params.item_type) item_type = '&item_type=' + params.item_type;
  // https://api.dev.nfjuara.id/itembank/v2/items?
  // bab_name=EJAAN
  // &subbab_name=PENULISAN%2FPENERAPAN%20EJAAN
  // &question_type=MTF
  // &mapel_code=05

  http.get('/v2/items?' + level + mapel_code + bab_name + subbab_name + subsubbab_name + question_type + item_type, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addBab(data, callback) {
  var config = getConfig();
  http.post('/bab/', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateBab(id, data, callback) {
  var config = getConfig();
  http.put('/bab/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteBab(id, callback) {
  var config = getConfig();
  http.delete('/bab/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addSubBab(data, callback) {
  var config = getConfig();
  http.post('/subbab/', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateSubBab(id, data, callback) {
  var config = getConfig();
  http.put('/subbab/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteSubBab(id, callback) {
  var config = getConfig();
  http.delete('/subbab/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addSubSubBab(data, callback) {
  var config = getConfig();
  http.post('/subsubbab/', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateSubSubBab(id, data, callback) {
  var config = getConfig();
  http.put('/subsubbab/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteSubSubBab(id, callback) {
  var config = getConfig();
  http.delete('/subsubbab/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getTopicMappings(gradeId, interest, callback) {
  var config = getConfig();
  http.get('/topic_mappings?grade_id=' + gradeId + "&interest=" + interest, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createTopicMapping(mapelId, babId, subBabId, subSubBabId, gradeId, interest, callback) {
  var config = getConfig();
  var data = {
    mapel_id: mapelId,
    bab_id: babId,
    sub_bab_id: subBabId,
    sub_sub_bab_id: subSubBabId,
    grade_id: gradeId,
    interest: interest
  };

  http.post('/topic_mapping', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteTopicMapping(mapelId, babId, subBabId, subSubBabId, gradeId, interest, callback) {
  var config = getConfig();
  var url = '/topic_mapping?grade_id=' + gradeId + '&interest=' + interest + '&mapel_id=' + mapelId + '&bab_id=' + babId;
  if (subBabId != null) url += '&sub_bab_id=' + subBabId;
  if (subSubBabId != null) url += '&sub_sub_bab_id=' + subSubBabId;

  http.delete(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListModulBelajar(callback) {
  var config = getConfig();
  http.get('/modules', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.message
    });
  });
}

function getLiveStream(id, callback) {
  var config = getConfig();
  http.get('/streaming/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createModulBelajar(data, callback) {
  var config = getConfig();
  http.post('/module', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateModulBelajar(id, data, callback) {
  var config = getConfig();
  http.put('/module/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getModulBelajar(id, callback) {
  var config = getConfig();
  http.get('/module/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.message
    });
  });
}

function deleteModulBelajar(id, callback) {
  var config = getConfig();
  http.delete('/module/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getListMataPelajaran: getListMataPelajaran,
  getItemsByMataPelajaran: getItemsByMataPelajaran,
  getListOfItemType: getListOfItemType,
  getListOfSchoolGrade: getListOfSchoolGrade,
  getListOfTopicGrade: getListOfTopicGrade,
  getListOfTopic: getListOfTopic,
  createItem: createItem,
  updateItem: updateItem,
  deleteItem: deleteItem,
  getItemById: getItemById,
  updateWacana: updateWacana,
  createWacana: createWacana,
  getListWacana: getListWacana,
  searchItemByItemCode: searchItemByItemCode,
  addBab: addBab,
  updateBab: updateBab,
  deleteBab: deleteBab,
  addSubBab: addSubBab,
  updateSubBab: updateSubBab,
  deleteSubBab: deleteSubBab,
  addSubSubBab: addSubSubBab,
  updateSubSubBab: updateSubSubBab,
  deleteSubSubBab: deleteSubSubBab,
  getTopicMappings: getTopicMappings,
  createTopicMapping: createTopicMapping,
  deleteTopicMapping: deleteTopicMapping,
  getListModulBelajar: getListModulBelajar,
  createModulBelajar: createModulBelajar,
  getModulBelajar: getModulBelajar,
  updateModulBelajar: updateModulBelajar,
  deleteModulBelajar: deleteModulBelajar,
  getLiveStream: getLiveStream,
  searchItemByItemCodeAndGrade: searchItemByItemCodeAndGrade,
  searchRandomItemByItemCodeAndGrade: searchRandomItemByItemCodeAndGrade,
  getListOfTopicV2: getListOfTopicV2,
  searchRandomItemByItemNameV2: searchRandomItemByItemNameV2
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/tryout-service',
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/tryout-service',
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getTryoutById(id, callback) {
  var config = getConfig();
  http.get('/tryout/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListTryout(pagination, search, callback) {
  var config = getConfig();
  var url = '/tryouts?';

  if (pagination && pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination && pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination && pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListPublishedTryout(pagination, search, callback) {
  var config = getConfig();
  var url = '/tryouts?status=PUBLISHED&create_group=true';

  if (pagination && pagination.perPage !== undefined && pagination.perPage !== null) url += '&per_page=' + pagination.perPage;
  if (pagination && pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination && pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;

  // http.get('/tryouts?state=PUBLISHED', config).then(function (response) {
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function saveTryout(tryout, callback) {
  var config = getConfig();
  http.post('/tryout', tryout, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateTryout(tryout, callback) {
  var config = getConfig();
  http.put('/tryout/' + tryout.id, tryout, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function saveSubtest(subtest, callback) {
  var config = getConfig();
  http.post('/subtest', subtest, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateSubtest(subtest, callback) {
  var config = getConfig();
  http.put('/subtest/' + subtest.id, subtest, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function reviewTryout(id, callback) {
  var config = getConfig();
  http.put('/tryout/' + id + '/review', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function publishTryout(id, callback) {
  var config = getConfig();
  http.put('/tryout/' + id + '/publish', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function draftTryout(id, callback) {
  var config = getConfig();
  http.put('/tryout/' + id + '/draft', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/**
* Tryout Group Related Endpoint
*/

function getListOfTryoutGroups(pagination, search, params, callback) {
  var config = getConfig();
  var url = '/tryout_groups?';

  if (pagination && pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination && pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination && pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.by) url += '&search=' + search.query + '&search_by=' + search.by;
  if (params) config.params = params;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createTryoutGroup(data, callback) {
  var config = getConfig();
  http.post('/tryout_group', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getTryoutGroup(id, callback) {
  var config = getConfig();
  http.get('/tryout_group/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function editTryoutGroup(id, data, callback) {
  var config = getConfig();
  http.put('/tryout_group/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteTryoutGroup(id, callback) {
  var config = getConfig();
  http.delete('/tryout_group/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function publishTryoutGroup(id, callback) {
  var config = getConfig();
  http.put('/tryout_group/' + id + '/publish', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function unPublishTryoutGroup(id, callback) {
  var config = getConfig();
  http.put('/tryout_group/' + id + '/draft', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function listTryoutSource(callback) {
  var config = getConfig();
  http.get('/tryout_sources', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addTryoutIntoGroup(tryoutId, groupId, callback) {
  var config = getConfig();
  http.put('tryout/' + tryoutId + '/group/' + groupId, {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function removeTryoutFromGroup(tryoutId, groupId, callback) {
  var config = getConfig();
  http.delete('/tryout/' + tryoutId + '/group/' + groupId, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfTryoutSeries(callback) {
  var config = getConfig();
  http.get('/series', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createTryoutSeries(data, callback) {
  var config = getConfig();
  http.post('/series', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getTryoutSeries(id, callback) {
  var config = getConfig();
  http.get('/series/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function attachGroupIntoSeries(groupId, seriesId, callback) {
  var config = getConfig();
  var url = '/tryout_group/' + groupId + '/series/' + seriesId;
  http.put(url, {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function dettachGroupFromSeries(groupId, seriesId, callback) {
  var config = getConfig();
  var url = '/tryout_group/' + groupId + '/series/' + seriesId;
  http.delete(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function resetStateTryout(body, callback) {
  var config = getConfig();
  http.post('/membership/reset', body, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function resetStateTryoutv2(membershipid, callback) {
  var config = getConfig();
  http.post('/membership/' + membershipid + '/reset', null, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function gradingStateTryout(body, callback) {
  var config = getConfig();
  http.post('/membership/grading', body, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteTryoutSerial(id, callback) {
  var config = getConfig();
  http.delete('/series/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function generateTryout(id, callback) {
  var config = getConfig();
  http.put('/tryout/' + id + '/regenerate', {}, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function exportTryout(data, callback) {
  var ht = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: "https://api.nfjuara.id" + '/tryout-service',
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(localStorage.getItem('token')).value,
      'Accept': 'application/octet-stream'
    } });
  ht.post('/tryouts/export', data, { responseType: 'blob' }).then(function (res) {
    var blob = new Blob([res.data], { type: res.headers['content-type'] });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'tryout_export_' + new Date().getTime() + '.json';
    link.click();
  }).catch(function (err) {
    console.log(err);
  });
}

function importTryout(dataBody, callback) {
  var config = getConfig();

  httpupload.post('/tryouts/import', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function gradingUtbkScore(id, callback) {
  var config = getConfig();
  var url = '/administration/' + id + '/grading_utbk';
  http.post(url, {}, config).then(function (response) {
    callback({
      success: true,
      data: {}
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getTop10UtbkRank(id, callback) {
  var config = getConfig();
  var url = '/administration/' + id + '/top10_utbk';
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getTryoutById: getTryoutById,
  getListTryout: getListTryout,
  getListPublishedTryout: getListPublishedTryout,
  saveTryout: saveTryout,
  updateTryout: updateTryout,
  reviewTryout: reviewTryout,
  publishTryout: publishTryout,
  draftTryout: draftTryout,
  saveSubtest: saveSubtest,
  updateSubtest: updateSubtest,
  getListOfTryoutGroups: getListOfTryoutGroups,
  createTryoutGroup: createTryoutGroup,
  getTryoutGroup: getTryoutGroup,
  editTryoutGroup: editTryoutGroup,
  deleteTryoutGroup: deleteTryoutGroup,
  publishTryoutGroup: publishTryoutGroup,
  unPublishTryoutGroup: unPublishTryoutGroup,
  addTryoutIntoGroup: addTryoutIntoGroup,
  removeTryoutFromGroup: removeTryoutFromGroup,
  getListOfTryoutSeries: getListOfTryoutSeries,
  createTryoutSeries: createTryoutSeries,
  getTryoutSeries: getTryoutSeries,
  attachGroupIntoSeries: attachGroupIntoSeries,
  dettachGroupFromSeries: dettachGroupFromSeries,
  resetStateTryout: resetStateTryout,
  resetStateTryoutv2: resetStateTryoutv2,
  deleteTryoutSerial: deleteTryoutSerial,
  gradingStateTryout: gradingStateTryout,
  exportTryout: exportTryout,
  importTryout: importTryout,
  generateTryout: generateTryout,
  gradingUtbkScore: gradingUtbkScore,
  getTop10UtbkRank: getTop10UtbkRank,
  listTryoutSource: listTryoutSource
});

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

// function getContentSectionList (params,callback)
// {
//   var config = getConfig()
//   http.get('/promotion/sections?page='+ params.page, config).then(function(response) {
//     callback({
//       success: true,
//       data: response.data
//     })
//   }).catch(function(error) {
//     callback({
//       success: false,
//       message: error.response.data.message
//     })
//   })
// }
function getContentSectionList(pagination, search, callback) {
  var config = getConfig();

  var url = '/promotion/sections?';

  // if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function getContentDetailList(pagination, search, callback) {
  var config = getConfig();

  var url = '/promotion/section-details?';

  if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type;
  if (pagination.isbanner !== undefined && pagination.isbanner !== null) url += 'is_banner=true';
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function getContentDetailByType(type, callback) {
  var config = getConfig();

  var url = '/promotion/sections?type=' + type;
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function contentSectionCreate(dataBody, callback) {
  var config = getConfig();

  http.post('/promotion/section', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function deleteContentSection(id, callback) {
  var config = getConfig();

  http.delete('/promotion/section/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function contentSectionUpdate(id, data, callback) {
  var config = getConfig();

  http.put('/promotion/section/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function createContentDetail(formData, callback) {
  var config = getConfig();
  var param = formData;
  config.headers['Content-Type'] = 'multipart/form-data';
  httpupload.post('/promotion/section-detail', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data,
      dd: response
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message,
      dd: error
    });
  });
}

function updateContentDetail(idData, formData, callback) {
  var config = getConfig();
  var param = formData;
  config.headers['Content-Type'] = 'multipart/form-data';
  httpupload.put('/promotion/section-detail/' + idData, param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function deleteContentDetail(id, callback) {
  var config = getConfig();

  http.delete('/promotion/section-detail/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

//=====================VIDEO CONTENT API =======================//
function getContentVideoList(pagination, search, callback) {
  var config = getConfig();

  var url = '/promotion/videos?';

  // if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage;
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function createContentVideo(formData, callback) {
  var config = getConfig();
  var param = formData;
  http.post('/promotion/video', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function updateContentVideo(idData, formData, callback) {
  var config = getConfig();
  var param = formData;
  http.put('/promotion/video/' + idData, param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function deleteContentVideo(id, callback) {
  var config = getConfig();

  http.delete('/promotion/video/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function exportItemBank(data, callback) {
  var ht = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: "https://api.nfjuara.id",
    responseType: 'arraybuffer',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': JSON.parse(localStorage.getItem('token')).value,
      'Accept': 'application/octet-stream'
    } });
  ht.post('/itembank/items/export', data, { responseType: 'blob' }).then(function (res) {
    var blob = new Blob([res.data], { type: res.headers['content-type'] });
    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.download = 'itembank_export' + new Date().getTime() + '.json';
    link.click();
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (err) {
    callback({
      success: false,
      message: err.message
    });
  });
}

// MENU API ===============================================================

function getMenuList(pagination, search, callback) {
  var config = getConfig();

  var url = '/promotion/menus?';

  // if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage;
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function menuHomeCreate(dataBody, callback) {
  var config = getConfig();

  http.post('/promotion/menu', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function updateMenu(idData, formData, callback) {
  var config = getConfig();
  var param = formData;
  http.put('/promotion/menu/' + idData, param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function deleteMenu(id, callback) {
  var config = getConfig();

  http.delete('/promotion/menu/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

//================================ BANK SOAL GRATIS aAPI =========================================================================================================

function importItems(dataBody, callback) {
  var config = getConfig();

  http.post('/promotion/items/bulk-add', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function getFreeItems(pagination, callback) {
  var config = getConfig();

  var url = '/promotion/items?mapel=' + pagination.mapelId;

  // if (pagination.type !== undefined && pagination.type !== null) url += 'section_type=' + pagination.type
  if (pagination.page !== undefined && pagination.page !== null) url += '&page=' + pagination.page;
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}
//================================================================================================================================================

// ================================================= GET MENU PREVIEW SETTING ==================================================================

function getMenuPreview(pagination, callback) {
  var config = getConfig();

  var url = '/promotion/menus?';

  if (pagination.status !== undefined && pagination.status !== null) url += 'status=' + pagination.status;
  // if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function updateMenuSort(formData, callback) {
  var config = getConfig();
  var param = formData;
  http.put('/promotion/menu/sort/', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

// ================================================= GET HOME CONTENT =========================================================================
function getHomeContent(pagination, callback) {
  var config = getConfig();

  var url = '/promotion/section/home-preview?';

  if (pagination.status !== undefined && pagination.status !== null) url += 'status=' + pagination.status;
  // if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += 'page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  // url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.response.data.message
    });
  });
}

function updateSectionSort(formData, callback) {
  var config = getConfig();
  var param = formData;
  http.put('/promotion/section/sort', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function getAllDeeplinks(callback) {
  var config = getConfig();
  var url = '/promotion/deeplinks';
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

/**
 * TOGGLE PUBLISH MENU / SECTION
 */
function togglePublishMenu(id, callback) {
  var config = getConfig();
  var data = {};
  var url = '/promotion/menu/' + id + '/publish';
  http.put(url, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function togglePublishSection(id, callback) {
  var config = getConfig();
  var data = {};
  var url = '/promotion/section/' + id + '/publish';
  http.put(url, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function getMenuTypes(callback) {
  var config = getConfig();
  var url = '/promotion/types';

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function getMapels(callback) {
  var config = getConfig();
  var url = '/promotion/mapels';

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getContentSectionList: getContentSectionList,
  contentSectionCreate: contentSectionCreate,
  contentSectionUpdate: contentSectionUpdate,
  deleteContentSection: deleteContentSection,
  getContentDetailList: getContentDetailList,
  createContentDetail: createContentDetail,
  deleteContentDetail: deleteContentDetail,
  getContentDetailByType: getContentDetailByType,
  updateContentDetail: updateContentDetail,
  getContentVideoList: getContentVideoList,
  createContentVideo: createContentVideo,
  updateContentVideo: updateContentVideo,
  deleteContentVideo: deleteContentVideo,
  exportItemBank: exportItemBank,
  menuHomeCreate: menuHomeCreate,
  getMenuList: getMenuList,
  deleteMenu: deleteMenu,
  updateMenu: updateMenu,
  importItems: importItems,
  getHomeContent: getHomeContent,
  getMenuPreview: getMenuPreview,
  getFreeItems: getFreeItems,
  updateMenuSort: updateMenuSort,
  updateSectionSort: updateSectionSort,
  getAllDeeplinks: getAllDeeplinks,
  togglePublishMenu: togglePublishMenu,
  togglePublishSection: togglePublishSection,
  getMenuTypes: getMenuTypes,
  getMapels: getMapels
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aws_sdk__);





var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/sales',
  headers: {
    'Content-Type': 'application/json'
  }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getPembayaranList(pagination, search, callback) {
  var config = getConfig();

  var url = '/transactions?';

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getPembayaranDetail(id, callback) {
  var config = getConfig();

  http.get('/transaction/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updatePembayaranStatus(id, status, callback) {
  var config = getConfig();
  var param = {
    status: status
  };

  http.put('/transaction/' + id, param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getProdukList(pagination, search, callback) {
  var config = getConfig();
  var url = '/products?';

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getProdukDetail(id, callback) {
  var config = getConfig();

  http.get('/product/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addProduk(data, callback) {
  var config = getConfig();
  var param = {
    type: data.type,
    title: data.title,
    value: data.value,
    bonus_value: data.bonus_value,
    description: data.description,
    currency: data.currency,
    price: data.price,
    net_price: data.net_price,
    status: data.status,
    platform: data.platform,
    grade: data.grade,
    features: data.features
  };

  http.post('/product', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateProduk(id, data, callback) {
  var config = getConfig();
  var param = {
    type: data.type,
    title: data.title,
    picture: data.picture,
    value: data.value,
    bonus_value: data.bonus_value,
    description: data.description,
    currency: data.currency,
    price: data.price,
    net_price: data.net_price,
    status: data.status,
    platform: data.platform,
    grade: data.grade,
    features: data.features
  };

  http.put('/product/' + id, param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function uploadProdukPicture(id, formData, callback) {
  var config = getConfig();
  var param = formData;
  config.headers['Content-Type'] = 'multipart/form-data';

  http.put('/product/' + id + '/upload_picture', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateAllProdukStatus(status, callback) {
  var config = getConfig();
  var param = {
    'status': status
  };

  http.put('/product/all_products', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteProduk(id, callback) {
  var config = getConfig();

  http.delete('/product/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getMetodePembayaranList(pagination, search, callback) {
  var config = getConfig();

  var url = '/payment_methods?';

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getMetodePembayaranDetail(id, callback) {
  var config = getConfig();

  http.get('/payment_method/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addMetodePembayaran(data, callback) {
  var config = getConfig();
  var param = {
    bank_name: data.bank_name,
    bank_code: data.bank_code,
    description: data.description,
    account_number: data.account_number,
    account_name: data.account_name,
    status: data.status,
    type: data.type
  };

  http.post('/payment_method', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addMetodePembayaranV2(data, callback) {
  var config = getConfig();
  // var param = {
  //   bank_name: data.bank_name,
  //   bank_code: data.bank_code,
  //   description: data.description,
  //   account_number: data.account_number,
  //   account_name: data.account_name,
  //   status: data.status,
  //   type: data.type
  // }

  http.post('/payment_method', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateMetodePembayaranV2(id, data, callback) {
  var config = getConfig();
  // var param = {
  //   bank_name: data.bank_name,
  //   bank_logo: data.bank_logo,
  //   bank_code: data.bank_code,
  //   description: data.description,
  //   account_number: data.account_number,
  //   account_name: data.account_name,
  //   status: data.status,
  //   type: data.type
  // }

  http.put('/payment_method/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateMetodePembayaran(id, data, callback) {
  var config = getConfig();
  var param = {
    bank_name: data.bank_name,
    bank_logo: data.bank_logo,
    bank_code: data.bank_code,
    description: data.description,
    account_number: data.account_number,
    account_name: data.account_name,
    status: data.status,
    type: data.type
  };

  http.put('/payment_method/' + id, param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function uploadMetodePembayaranBankLogo(id, formData, callback) {
  var config = getConfig();
  var param = formData;
  config.headers['Content-Type'] = 'multipart/form-data';

  http.put('/payment_method/' + id + '/upload_logo', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateAllMetodePembayaranStatus(status, callback) {
  var config = getConfig();
  var param = {
    'status': status
  };

  http.put('/payment_method/all_methods', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteMetodePembayaran(id, callback) {
  var config = getConfig();

  http.delete('/payment_method/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getTicketUsageList(pagination, search, callback) {
  var config = getConfig();

  var url = '/tickets_usage?';

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getTicketUsageDetail(id, callback) {
  var config = getConfig();

  http.get('/ticket_usage/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getKatalogTiketList(pagination, search, callback) {
  var config = getConfig();

  var url = '/features_activation?';

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.response.data,
      message: error.message
    });
  });
}

function getKatalogTiketDetail(id, callback) {
  var config = getConfig();

  http.get('/feature_activation/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addKatalogTiket(data, callback) {
  var config = getConfig();
  var param = {
    type: data.type,
    title: data.title,
    value: data.type === 'DUEL' ? 1 : data.value,
    description: data.description,
    ticket: data.ticket,
    status: data.status,
    is_subscription: data.is_subscription
  };

  http.post('/feature_activation', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateKatalogTiket(id, data, callback) {
  var config = getConfig();
  var param = {
    type: data.type,
    title: data.title,
    value: data.type === 'DUEL' ? 1 : data.value,
    picture: data.picture,
    description: data.description,
    ticket: data.ticket,
    status: data.status,
    is_subscription: data.is_subscription
  };

  http.put('/feature_activation/' + id, param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateAllKatalogTiketStatus(status, callback) {
  var config = getConfig();
  var param = {
    'status': status
  };

  http.put('/feature_activation/all_features', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteKatalogTiket(id, callback) {
  var config = getConfig();

  http.delete('/feature_activation/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function uploadKatalogTiketPicture(id, formData, callback) {
  var config = getConfig();
  var param = formData;
  config.headers['Content-Type'] = 'multipart/form-data';

  http.put('/feature_activation/' + id + '/upload_picture', param, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createManualTransaction(data, callback) {
  var config = getConfig();
  var url = '/transaction';

  http.post(url, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    }).catch(function (error) {
      callback({
        success: false,
        data: error.message
      });
    });
  });
}

function getChannelList(pagination, search, callback) {
  var config = getConfig();
  var url = '/channels?';

  if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage;
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getPembayaranList: getPembayaranList,
  getPembayaranDetail: getPembayaranDetail,
  updatePembayaranStatus: updatePembayaranStatus,
  getProdukList: getProdukList,
  getProdukDetail: getProdukDetail,
  addProduk: addProduk,
  uploadProdukPicture: uploadProdukPicture,
  updateProduk: updateProduk,
  updateAllProdukStatus: updateAllProdukStatus,
  deleteProduk: deleteProduk,
  getMetodePembayaranList: getMetodePembayaranList,
  getMetodePembayaranDetail: getMetodePembayaranDetail,
  addMetodePembayaran: addMetodePembayaran,
  updateMetodePembayaranV2: updateMetodePembayaranV2,
  addMetodePembayaranV2: addMetodePembayaranV2,
  updateMetodePembayaran: updateMetodePembayaran,
  uploadMetodePembayaranBankLogo: uploadMetodePembayaranBankLogo,
  updateAllMetodePembayaranStatus: updateAllMetodePembayaranStatus,
  deleteMetodePembayaran: deleteMetodePembayaran,
  getTicketUsageList: getTicketUsageList,
  getTicketUsageDetail: getTicketUsageDetail,
  getKatalogTiketList: getKatalogTiketList,
  getKatalogTiketDetail: getKatalogTiketDetail,
  addKatalogTiket: addKatalogTiket,
  updateKatalogTiket: updateKatalogTiket,
  updateAllKatalogTiketStatus: updateAllKatalogTiketStatus,
  uploadKatalogTiketPicture: uploadKatalogTiketPicture,
  deleteKatalogTiket: deleteKatalogTiket,
  createManualTransaction: createManualTransaction,
  getChannelList: getChannelList
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getAllBlock(params, callback) {
  var config = getConfig();
  // if(params) config.params = params[0]
  var url = '/lms/block_package/' + params;
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListPackage(callback, params) {
  var config = getConfig();
  // if(params) config.params = params[0]
  var url = '/lms/block_packages';
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListBimbel(callback, params) {
  var config = getConfig();
  // if(params) config.params = params[0]
  var url = '/lms/packages';
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addBimbel(dataBody, callback) {
  var config = getConfig();

  http.post('/lms/package', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function editBimbel(dataBody, callback) {
  var config = getConfig();

  http.put('/lms/package/' + dataBody[1], dataBody[0], config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListKurikulum(callback) {
  var config = getConfig();
  http.get('/lms/curriculums', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}
function deleteBimbel(id, callback) {
  var config = getConfig();
  http.delete('/lms/package/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function getbimbelDetailById(id, callback) {
  var config = getConfig();
  http.get('/lms/package/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function publishBimbel(id, callback) {
  var config = getConfig();
  http.put('/lms/package/' + id + '/publish', '', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function statPublishedBimbel(grade, callback) {
  var config = getConfig();
  http.get('/lms/packages/?status=PUBLISHED&grade=' + grade, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}
//paket mapel

function addMapelPackage(dataBody, callback) {
  var config = getConfig();

  http.post('/lms/block_package', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteMapelPackage(id, callback) {
  var config = getConfig();
  http.delete('/lms/block_package/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function publishMapel(id, callback) {
  var config = getConfig();
  http.put('/lms/block_package/' + id + '/publish', '', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function getMapelDetailById(id, callback) {
  var config = getConfig();
  http.get('/lms/block_package/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function editMapelPackage(dataBody, callback) {
  var config = getConfig();

  http.put('/lms/block_package/' + dataBody[1], dataBody[0], config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function initializeBlockPackage(dataBody, callback) {
  var config = getConfig();
  http.post('/lms/init_package', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getAllBlock: getAllBlock,
  getListPackage: getListPackage,
  getListBimbel: getListBimbel,
  getListKurikulum: getListKurikulum,
  addBimbel: addBimbel,
  deleteBimbel: deleteBimbel,
  getbimbelDetailById: getbimbelDetailById,
  editBimbel: editBimbel,
  publishBimbel: publishBimbel,
  statPublishedBimbel: statPublishedBimbel,

  //paket mapel
  addMapelPackage: addMapelPackage,
  deleteMapelPackage: deleteMapelPackage,
  publishMapel: publishMapel,
  getMapelDetailById: getMapelDetailById,
  editMapelPackage: editMapelPackage,
  initializeBlockPackage: initializeBlockPackage
});

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/account',
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function doLogin(email, password, callback) {
  http.post('/basic_login', {
    email: email,
    password: password
  }).then(function (response) {
    var data = {
      success: true,
      data: {
        email: response.data.email,
        name: response.data.name,
        firstName: response.data.first_name,
        lastName: response.data.lastName,
        phoneNumber: response.data.phone_number,
        token: response.data.token,
        picture: response.data.picture,
        refreshToken: response.data.refresh_token
      }
    };
    callback(data);
  }).catch(function (error) {
    var data = {
      success: false,
      message: error.response.data.message
    };
    callback(data);
  });
}

function doLogout(token, callback) {
  var data = {};
  var config = getConfig();
  http.post('/logout', data, config).then(function (response) {
    var data = {
      success: true,
      message: 'You have successfully logged out'
    };
    callback(data);
  }).catch(function (error) {
    console.log(error);
    var data = {
      success: false,
      message: error.response.data.message
    };
    callback(data);
  });
}

function doValidateToken(token, callback) {
  http.post('/validate_token', {
    token: token
  }).then(function (response) {
    var data = {
      success: true,
      scopes: response.data.user_scopes
    };
    callback(data);
  }).catch(function (error) {
    var data = {
      success: false,
      message: error.response.data.message
    };
    callback(data);
  });
}

function userActivation(userId, email, studentNumber, callback) {
  var data = {
    user_id: userId,
    email: email,
    student_number: studentNumber
  };

  var config = getConfig();
  http.post('/activation/third_party', data, config).then(function (response) {
    var data = {
      success: true,
      data: response.data
    };
    callback(data);
  }).catch(function (error) {
    var data = {
      success: false,
      message: error.response.data.message
    };
    callback(data);
  });
}

function queryUser(data, callback) {

  var config = getConfig();
  http.post('/query/user', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      messaeg: error.response.data.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({ doLogin: doLogin, doLogout: doLogout, doValidateToken: doValidateToken, userActivation: userActivation, queryUser: queryUser });

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/file',
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  return { data: 'error'
    // if (error.response.status && error.response.status !== 401) return Promise.reject(error)
    // var refreshAndRetry = new Promise(function (resolve) {
    //   axios.post(process.env.API_BASE_URL + '/account/refresh_token',
    //     {
    //       'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    //     },
    //     {
    //       headers: {
    //         'Content-Type': 'application/json',
    //         'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
    //       }
    //     }).then(function (response) {
    //     localStorage.setItem('refresh_token', JSON.stringify({
    //       value: response.data.refresh_token,
    //       expire: null
    //     }))

    //     localStorage.setItem('token', JSON.stringify({
    //       value: response.data.token,
    //       expire: null
    //     }))

    //     return Promise.resolve(response)
    //   }).then(function (response) {
    //     var failedRequest = error.config
    //     failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
    //     axios.request(failedRequest).then(function (retryResponse) {
    //       resolve(retryResponse)
    //     })
    //   })
    // })

    // return refreshAndRetry
  };
});

var http2 = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/file',
  responseType: 'arraybuffer',
  headers: { 'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function upload(file, path, callback) {
  var config = getConfig();
  config.headers['Content-Type'] = 'multipart/form-data';

  var url = '/upload';
  var formData = new FormData();
  formData.append('file', file);
  formData.append('key_name', path);

  http.post(url, formData, config).then(function (response) {
    if (response.data === 'error') {
      callback({
        success: false,
        data: response.data
      });
    } else {
      callback({
        success: true,
        data: response.data
      });
    }
  });
}

function adminBundleUpload(file, path, callback) {
  var config = getConfig();
  config.headers['Content-Type'] = 'multipart/form-data';

  var url = '/admin_upload_bundle';
  var formData = new FormData();
  formData.append('file', file);
  formData.append('key_name', path);

  http.post(url, formData, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    }).catch(function (error) {
      callback({
        success: false,
        data: error.response.data.message
      });
    });
  });
}

function download(path, callback) {
  var config = getConfig();
  var url = '/download?key_name=' + path;

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}

function download2(path, callback) {
  var config = getConfig();
  var url = '/download?key_name=' + path;

  http2.get(url, config).then(function (response) {
    var url = URL.createObjectURL(new Blob([response.data], {
      type: 'application/vnd.ms-excel'
    }));
    var link = document.createElement('a');
    link.href = url;
    var fileName = path.split('/');
    link.setAttribute('download', fileName[1]);
    document.body.appendChild(link);
    link.click();
    this.notify('success', 'File Hasil Rasionalisasi berhasil diunduh');
  }).catch(function (error) {
    callback({
      success: false,
      message: error.response.data.message
    });
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({ upload: upload, download: download, download2: download2, adminBundleUpload: adminBundleUpload });

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/itembank',
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getVideoDetail(id, callback) {
  var config = getConfig();
  http.get('/video_info?source=youtube&video_id=' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    alert('error');
    callback({
      success: false,
      message: error.message
    });
  });
}

function getVideoDetailById(id, callback) {
  var config = getConfig();
  http.get('/video/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function getListVideo(callback) {
  var config = getConfig();
  http.get('/videos', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListVideoByModuleId(moduleId, callback) {
  var config = getConfig();
  http.get('/videos?module_id=' + moduleId, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListVideoLiveStreamByModuleId(moduleId, callback) {
  var config = getConfig();
  http.get('/streamings?module_id=' + moduleId, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteVideo(id, callback) {
  var config = getConfig();
  http.delete('/video/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function addVideo(dataBody, callback) {
  var config = getConfig();

  http.post('/video', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addVideoLiveStreaming(dataBody, callback) {
  var config = getConfig();

  http.post('/streaming', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function editVideo(id, dataBody, callback) {
  var config = getConfig();
  http.put('/video/' + id, dataBody, config).then(function (response) {
    alert('ubah data berhasil');
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    alert('error');
    callback({
      success: true,
      message: error.message
    });
  });
}
function editVideoLiveStreaming(id, dataBody, callback) {
  var config = getConfig();
  http.put('/streaming/' + id, dataBody, config).then(function (response) {
    alert('ubah data berhasil');
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    alert('error');
    callback({
      success: true,
      message: error.message
    });
  });
}

function deleteVideoStreaming(id, callback) {
  var config = getConfig();
  http.delete('/streaming/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function setPublishing(id, dataBody, callback) {
  var config = getConfig();
  http.put('/streaming/' + id + '/publish', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getVideoDetail: getVideoDetail,
  getListVideo: getListVideo,
  deleteVideo: deleteVideo,
  addVideo: addVideo,
  getVideoDetailById: getVideoDetailById,
  editVideo: editVideo,
  getListVideoByModuleId: getListVideoByModuleId,
  getListVideoLiveStreamByModuleId: getListVideoLiveStreamByModuleId,
  addVideoLiveStreaming: addVideoLiveStreaming,
  deleteVideoStreaming: deleteVideoStreaming,
  editVideoLiveStreaming: editVideoLiveStreaming,
  setPublishing: setPublishing
});

/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/launcher.be30db2.png";

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(898),
  /* template */
  __webpack_require__(1372),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(1307),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(1391),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1074)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(1375),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8271b3f8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
	baseURL: "https://api.nfjuara.id" + '/duel',
	headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
	return response;
}, function (error) {
	if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

	var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
		__WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
			'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
		}, {
			headers: {
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
			}
		}).then(function (response) {
			localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
				value: response.data.refresh_token,
				expire: null
			}));

			localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
				value: response.data.token,
				expire: null
			}));

			return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
		}).then(function (response) {
			var failedRequest = error.config;
			failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
			__WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
				resolve(retryResponse);
			});
		});
	});

	return refreshAndRetry;
});

function getConfig() {
	return {
		headers: {
			'Authorization': JSON.parse(localStorage.getItem('token')).value
		}
	};
}

function getSeason(callback) {
	var config = getConfig();

	http.get('/list_season', config).then(function (response) {
		callback({
			success: true,
			data: response.data
		});
	}).catch(function (error) {
		callback({
			success: false,
			message: error.message
		});
	});
}

function getSeasonDetail(id, callback) {
	var config = getConfig();

	http.get('/season_detail/' + id, config).then(function (response) {
		callback({
			success: true,
			data: response.data
		});
	}).catch(function (error) {
		callback({
			success: false,
			message: error.message
		});
	});
}

function addSeason(data, callback) {
	var config = getConfig();
	var param = {
		name: data.name,
		description: data.description,
		picture: data.picture,
		started_at: data.started_at,
		ended_at: data.ended_at
	};

	http.post('/add_season', param, config).then(function (response) {
		callback({
			success: true,
			data: response.data
		});
	}).catch(function (error) {
		callback({
			success: false,
			data: error.response.data,
			message: error.message
		});
	});
}

function updateSeason(id, data, callback) {
	var config = getConfig();
	var param = {
		id: id,
		name: data.name,
		description: data.description,
		picture: data.picture,
		started_at: data.started_at,
		ended_at: data.ended_at
	};

	http.put('/edit_season', param, config).then(function (response) {
		callback({
			success: true,
			data: response.data
		});
	}).catch(function (error) {
		callback({
			success: false,
			data: error.response.data,
			message: error.message
		});
	});
}

function deleteSeason(id, callback) {
	var config = getConfig();

	http.delete('/delete_season/' + id, config).then(function (response) {
		callback({
			success: true,
			data: response.data
		});
	}).catch(function (error) {
		callback({
			success: false,
			message: error.message
		});
	});
}

/* harmony default export */ __webpack_exports__["a"] = ({
	getSeason: getSeason,
	getSeasonDetail: getSeasonDetail,
	addSeason: addSeason,
	updateSeason: updateSeason,
	deleteSeason: deleteSeason
});

/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(901),
  /* template */
  __webpack_require__(1286),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_loader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);





// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getConfigAffiliate(callback) {
  var config = getConfig();

  http.get('/sales/configs', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

//   function getProductAffiliate (callback) {
//     var config = getConfig()

//     http.get('/sales/products', config)
//       .then(function (response) {
//         callback({
//           success: true,
//           data: response.data
//         })
//       }).catch(function (error) {
//         callback({
//           success: false,
//           message: error.message
//         })
//       })
//   }

function saveConfig(dataBody, callback) {
  var config = getConfig();

  http.put('/sales/configs', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateProduct(dataBody, callback) {
  var config = getConfig();
  dataBody.persentate_commission = parseInt(dataBody.persentate_commission);
  http.put('/sales/product/' + dataBody.id, dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getRedeemList(params, callback) {
  var config = getConfig();
  var query = '';
  // start_date: null,
  //     end_date: null,
  //     wallet_type: '',
  //     status: '',
  //     page_size: '',
  //     page: 0,
  //     sort_mode: 'ASC',
  //     page_size: 10
  if (params.page !== '') query += 'page=' + params.page;
  if (params.start_date !== null && params.start_date !== '') query += '&started_date=' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(params.start_date, "DD/MM/YYYY").valueOf() / 1000;
  if (params.end_date !== null && params.end_date !== '') query += '&ended_date=' + (__WEBPACK_IMPORTED_MODULE_4_moment___default()(params.end_date, "DD/MM/YYYY").valueOf() / 1000 + 86100);
  if (params.wallet_type !== '') query += '&wallet_type=' + params.wallet_type;
  if (params.status !== '') query += '&status=' + params.status;
  if (params.page_size !== '') query += '&page_size=' + params.page_size;
  if (params.search !== '') query += '&search=' + params.search;
  if (params.sort_mode !== '') query += '&sort_mode=' + params.sort_mode;

  http.get('/sales/affiliate/redeems?' + query, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getRedeemStatus(callback) {
  var config = getConfig();

  http.get('/sales/affiliate/redeem/status', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getRedeemWallets(callback) {
  var config = getConfig();

  http.get('/sales/affiliate/redeem/wallets', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getDetailRedeem(id, callback) {
  var config = getConfig();

  http.get('/sales/affiliate/redeem/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateStatusRedeem(dataBody, callback) {
  var config = getConfig();
  http.put('/sales/affiliate/redeem/' + dataBody[0], dataBody[1], config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getDataDashboardAffiliate(params, callback) {
  var config = getConfig();
  var query = '?';
  console.log(params);

  if (params.start_date !== null && params.start_date !== '') query += 'started_date=' + __WEBPACK_IMPORTED_MODULE_4_moment___default()(params.start_date, "DD/MM/YYYY").valueOf() / 1000;
  if (params.end_date !== null && params.end_date !== '') query += '&ended_date=' + (__WEBPACK_IMPORTED_MODULE_4_moment___default()(params.end_date, "DD/MM/YYYY").valueOf() / 1000 + 86100);

  http.get('/sales/affiliate/dashboard' + query, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListAffiliator(params, callback) {
  var config = getConfig();
  var query = '?';
  // if(params.start_date !== null && params.start_date !== '') query += 'start_date=' + moment(params.start_date).unix();
  // if(params.end_date !== null && params.end_date !== '') query += '&end_date=' + moment(params.end_date).unix();
  if (params.page !== null && params.page !== '') query += 'page=' + params.page;
  if (params.page_size !== null && params.page_size !== '') query += '&page_size=' + params.page_size;
  if (params.search !== null && params.search !== '') query += '&search=' + params.search;
  if (params.sort_by !== null && params.sort_by !== '') query += '&sort_by=' + params.sort_by;
  if (params.sort_mode !== null && params.sort_mode !== '') query += '&sort_mode=' + params.sort_mode;

  http.get('/sales/affiliate/members' + query, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getConfigAffiliate: getConfigAffiliate,
  getRedeemList: getRedeemList,
  saveConfig: saveConfig,
  updateProduct: updateProduct,
  getDetailRedeem: getDetailRedeem,
  updateStatusRedeem: updateStatusRedeem,
  getRedeemWallets: getRedeemWallets,
  getRedeemStatus: getRedeemStatus,
  getDataDashboardAffiliate: getDataDashboardAffiliate,
  getListAffiliator: getListAffiliator
});

/***/ }),
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(926),
  /* template */
  __webpack_require__(1328),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 127 */,
/* 128 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */
/***/ (function(module, exports) {

module.exports = {"acm":{"name":"ACM","cors":true},"apigateway":{"name":"APIGateway","cors":true},"applicationautoscaling":{"prefix":"application-autoscaling","name":"ApplicationAutoScaling","cors":true},"appstream":{"name":"AppStream"},"autoscaling":{"name":"AutoScaling","cors":true},"batch":{"name":"Batch"},"budgets":{"name":"Budgets"},"clouddirectory":{"name":"CloudDirectory","versions":["2016-05-10*"]},"cloudformation":{"name":"CloudFormation","cors":true},"cloudfront":{"name":"CloudFront","versions":["2013-05-12*","2013-11-11*","2014-05-31*","2014-10-21*","2014-11-06*","2015-04-17*","2015-07-27*","2015-09-17*","2016-01-13*","2016-01-28*","2016-08-01*","2016-08-20*","2016-09-07*","2016-09-29*","2016-11-25*","2017-03-25*","2017-10-30*","2018-06-18*","2018-11-05*","2019-03-26*"],"cors":true},"cloudhsm":{"name":"CloudHSM","cors":true},"cloudsearch":{"name":"CloudSearch"},"cloudsearchdomain":{"name":"CloudSearchDomain"},"cloudtrail":{"name":"CloudTrail","cors":true},"cloudwatch":{"prefix":"monitoring","name":"CloudWatch","cors":true},"cloudwatchevents":{"prefix":"events","name":"CloudWatchEvents","versions":["2014-02-03*"],"cors":true},"cloudwatchlogs":{"prefix":"logs","name":"CloudWatchLogs","cors":true},"codebuild":{"name":"CodeBuild","cors":true},"codecommit":{"name":"CodeCommit","cors":true},"codedeploy":{"name":"CodeDeploy","cors":true},"codepipeline":{"name":"CodePipeline","cors":true},"cognitoidentity":{"prefix":"cognito-identity","name":"CognitoIdentity","cors":true},"cognitoidentityserviceprovider":{"prefix":"cognito-idp","name":"CognitoIdentityServiceProvider","cors":true},"cognitosync":{"prefix":"cognito-sync","name":"CognitoSync","cors":true},"configservice":{"prefix":"config","name":"ConfigService","cors":true},"cur":{"name":"CUR","cors":true},"datapipeline":{"name":"DataPipeline"},"devicefarm":{"name":"DeviceFarm","cors":true},"directconnect":{"name":"DirectConnect","cors":true},"directoryservice":{"prefix":"ds","name":"DirectoryService"},"discovery":{"name":"Discovery"},"dms":{"name":"DMS"},"dynamodb":{"name":"DynamoDB","cors":true},"dynamodbstreams":{"prefix":"streams.dynamodb","name":"DynamoDBStreams","cors":true},"ec2":{"name":"EC2","versions":["2013-06-15*","2013-10-15*","2014-02-01*","2014-05-01*","2014-06-15*","2014-09-01*","2014-10-01*","2015-03-01*","2015-04-15*","2015-10-01*","2016-04-01*","2016-09-15*"],"cors":true},"ecr":{"name":"ECR","cors":true},"ecs":{"name":"ECS","cors":true},"efs":{"prefix":"elasticfilesystem","name":"EFS","cors":true},"elasticache":{"name":"ElastiCache","versions":["2012-11-15*","2014-03-24*","2014-07-15*","2014-09-30*"],"cors":true},"elasticbeanstalk":{"name":"ElasticBeanstalk","cors":true},"elb":{"prefix":"elasticloadbalancing","name":"ELB","cors":true},"elbv2":{"prefix":"elasticloadbalancingv2","name":"ELBv2","cors":true},"emr":{"prefix":"elasticmapreduce","name":"EMR","cors":true},"es":{"name":"ES"},"elastictranscoder":{"name":"ElasticTranscoder","cors":true},"firehose":{"name":"Firehose","cors":true},"gamelift":{"name":"GameLift","cors":true},"glacier":{"name":"Glacier"},"health":{"name":"Health"},"iam":{"name":"IAM","cors":true},"importexport":{"name":"ImportExport"},"inspector":{"name":"Inspector","versions":["2015-08-18*"],"cors":true},"iot":{"name":"Iot","cors":true},"iotdata":{"prefix":"iot-data","name":"IotData","cors":true},"kinesis":{"name":"Kinesis","cors":true},"kinesisanalytics":{"name":"KinesisAnalytics"},"kms":{"name":"KMS","cors":true},"lambda":{"name":"Lambda","cors":true},"lexruntime":{"prefix":"runtime.lex","name":"LexRuntime","cors":true},"lightsail":{"name":"Lightsail"},"machinelearning":{"name":"MachineLearning","cors":true},"marketplacecommerceanalytics":{"name":"MarketplaceCommerceAnalytics","cors":true},"marketplacemetering":{"prefix":"meteringmarketplace","name":"MarketplaceMetering"},"mturk":{"prefix":"mturk-requester","name":"MTurk","cors":true},"mobileanalytics":{"name":"MobileAnalytics","cors":true},"opsworks":{"name":"OpsWorks","cors":true},"opsworkscm":{"name":"OpsWorksCM"},"organizations":{"name":"Organizations"},"pinpoint":{"name":"Pinpoint"},"polly":{"name":"Polly","cors":true},"rds":{"name":"RDS","versions":["2014-09-01*"],"cors":true},"redshift":{"name":"Redshift","cors":true},"rekognition":{"name":"Rekognition","cors":true},"resourcegroupstaggingapi":{"name":"ResourceGroupsTaggingAPI"},"route53":{"name":"Route53","cors":true},"route53domains":{"name":"Route53Domains","cors":true},"s3":{"name":"S3","dualstackAvailable":true,"cors":true},"s3control":{"name":"S3Control","dualstackAvailable":true,"xmlNoDefaultLists":true},"servicecatalog":{"name":"ServiceCatalog","cors":true},"ses":{"prefix":"email","name":"SES","cors":true},"shield":{"name":"Shield"},"simpledb":{"prefix":"sdb","name":"SimpleDB"},"sms":{"name":"SMS"},"snowball":{"name":"Snowball"},"sns":{"name":"SNS","cors":true},"sqs":{"name":"SQS","cors":true},"ssm":{"name":"SSM","cors":true},"storagegateway":{"name":"StorageGateway","cors":true},"stepfunctions":{"prefix":"states","name":"StepFunctions"},"sts":{"name":"STS","cors":true},"support":{"name":"Support"},"swf":{"name":"SWF"},"xray":{"name":"XRay","cors":true},"waf":{"name":"WAF","cors":true},"wafregional":{"prefix":"waf-regional","name":"WAFRegional"},"workdocs":{"name":"WorkDocs","cors":true},"workspaces":{"name":"WorkSpaces"},"codestar":{"name":"CodeStar"},"lexmodelbuildingservice":{"prefix":"lex-models","name":"LexModelBuildingService","cors":true},"marketplaceentitlementservice":{"prefix":"entitlement.marketplace","name":"MarketplaceEntitlementService"},"athena":{"name":"Athena","cors":true},"greengrass":{"name":"Greengrass"},"dax":{"name":"DAX"},"migrationhub":{"prefix":"AWSMigrationHub","name":"MigrationHub"},"cloudhsmv2":{"name":"CloudHSMV2","cors":true},"glue":{"name":"Glue"},"mobile":{"name":"Mobile"},"pricing":{"name":"Pricing","cors":true},"costexplorer":{"prefix":"ce","name":"CostExplorer","cors":true},"mediaconvert":{"name":"MediaConvert"},"medialive":{"name":"MediaLive"},"mediapackage":{"name":"MediaPackage"},"mediastore":{"name":"MediaStore"},"mediastoredata":{"prefix":"mediastore-data","name":"MediaStoreData","cors":true},"appsync":{"name":"AppSync"},"guardduty":{"name":"GuardDuty"},"mq":{"name":"MQ"},"comprehend":{"name":"Comprehend","cors":true},"iotjobsdataplane":{"prefix":"iot-jobs-data","name":"IoTJobsDataPlane"},"kinesisvideoarchivedmedia":{"prefix":"kinesis-video-archived-media","name":"KinesisVideoArchivedMedia","cors":true},"kinesisvideomedia":{"prefix":"kinesis-video-media","name":"KinesisVideoMedia","cors":true},"kinesisvideo":{"name":"KinesisVideo","cors":true},"sagemakerruntime":{"prefix":"runtime.sagemaker","name":"SageMakerRuntime"},"sagemaker":{"name":"SageMaker"},"translate":{"name":"Translate","cors":true},"resourcegroups":{"prefix":"resource-groups","name":"ResourceGroups","cors":true},"cloud9":{"name":"Cloud9"},"serverlessapplicationrepository":{"prefix":"serverlessrepo","name":"ServerlessApplicationRepository"},"servicediscovery":{"name":"ServiceDiscovery"},"workmail":{"name":"WorkMail"},"autoscalingplans":{"prefix":"autoscaling-plans","name":"AutoScalingPlans"},"transcribeservice":{"prefix":"transcribe","name":"TranscribeService"},"connect":{"name":"Connect","cors":true},"acmpca":{"prefix":"acm-pca","name":"ACMPCA"},"fms":{"name":"FMS"},"secretsmanager":{"name":"SecretsManager","cors":true},"iotanalytics":{"name":"IoTAnalytics","cors":true},"iot1clickdevicesservice":{"prefix":"iot1click-devices","name":"IoT1ClickDevicesService"},"iot1clickprojects":{"prefix":"iot1click-projects","name":"IoT1ClickProjects"},"pi":{"name":"PI"},"neptune":{"name":"Neptune"},"mediatailor":{"name":"MediaTailor"},"eks":{"name":"EKS"},"dlm":{"name":"DLM"},"signer":{"name":"Signer"},"chime":{"name":"Chime"},"pinpointemail":{"prefix":"pinpoint-email","name":"PinpointEmail"},"ram":{"name":"RAM"},"route53resolver":{"name":"Route53Resolver"},"pinpointsmsvoice":{"prefix":"sms-voice","name":"PinpointSMSVoice"},"quicksight":{"name":"QuickSight"},"rdsdataservice":{"prefix":"rds-data","name":"RDSDataService"},"amplify":{"name":"Amplify"},"datasync":{"name":"DataSync"},"robomaker":{"name":"RoboMaker"},"transfer":{"name":"Transfer"},"globalaccelerator":{"name":"GlobalAccelerator"},"comprehendmedical":{"name":"ComprehendMedical","cors":true},"kinesisanalyticsv2":{"name":"KinesisAnalyticsV2"},"mediaconnect":{"name":"MediaConnect"},"fsx":{"name":"FSx"},"securityhub":{"name":"SecurityHub"},"appmesh":{"name":"AppMesh","versions":["2018-10-01*"]},"licensemanager":{"prefix":"license-manager","name":"LicenseManager"},"kafka":{"name":"Kafka"},"apigatewaymanagementapi":{"name":"ApiGatewayManagementApi"},"apigatewayv2":{"name":"ApiGatewayV2"},"docdb":{"name":"DocDB"},"backup":{"name":"Backup"},"worklink":{"name":"WorkLink"},"textract":{"name":"Textract"},"managedblockchain":{"name":"ManagedBlockchain"},"mediapackagevod":{"prefix":"mediapackage-vod","name":"MediaPackageVod"},"groundstation":{"name":"GroundStation"},"iotthingsgraph":{"name":"IoTThingsGraph"},"iotevents":{"name":"IoTEvents"},"ioteventsdata":{"prefix":"iotevents-data","name":"IoTEventsData"},"personalize":{"name":"Personalize","cors":true},"personalizeevents":{"prefix":"personalize-events","name":"PersonalizeEvents","cors":true},"personalizeruntime":{"prefix":"personalize-runtime","name":"PersonalizeRuntime","cors":true},"applicationinsights":{"prefix":"application-insights","name":"ApplicationInsights"},"servicequotas":{"prefix":"service-quotas","name":"ServiceQuotas"},"ec2instanceconnect":{"prefix":"ec2-instance-connect","name":"EC2InstanceConnect"},"eventbridge":{"name":"EventBridge"},"lakeformation":{"name":"LakeFormation"},"forecastservice":{"prefix":"forecast","name":"ForecastService","cors":true},"forecastqueryservice":{"prefix":"forecastquery","name":"ForecastQueryService","cors":true},"qldb":{"name":"QLDB"},"qldbsession":{"prefix":"qldb-session","name":"QLDBSession"},"workmailmessageflow":{"name":"WorkMailMessageFlow"},"codestarnotifications":{"prefix":"codestar-notifications","name":"CodeStarNotifications"},"savingsplans":{"name":"SavingsPlans"},"sso":{"name":"SSO"},"ssooidc":{"prefix":"sso-oidc","name":"SSOOIDC"},"marketplacecatalog":{"prefix":"marketplace-catalog","name":"MarketplaceCatalog","cors":true},"dataexchange":{"name":"DataExchange"},"sesv2":{"name":"SESV2"},"migrationhubconfig":{"prefix":"migrationhub-config","name":"MigrationHubConfig"},"connectparticipant":{"name":"ConnectParticipant"},"appconfig":{"name":"AppConfig"},"iotsecuretunneling":{"name":"IoTSecureTunneling"},"wafv2":{"name":"WAFV2"},"elasticinference":{"prefix":"elastic-inference","name":"ElasticInference"},"imagebuilder":{"name":"Imagebuilder"},"schemas":{"name":"Schemas"},"accessanalyzer":{"name":"AccessAnalyzer"},"codegurureviewer":{"prefix":"codeguru-reviewer","name":"CodeGuruReviewer"},"codeguruprofiler":{"name":"CodeGuruProfiler"},"computeoptimizer":{"prefix":"compute-optimizer","name":"ComputeOptimizer"},"frauddetector":{"name":"FraudDetector"},"kendra":{"name":"Kendra"},"networkmanager":{"name":"NetworkManager"},"outposts":{"name":"Outposts"},"augmentedairuntime":{"prefix":"sagemaker-a2i-runtime","name":"AugmentedAIRuntime"},"ebs":{"name":"EBS"},"kinesisvideosignalingchannels":{"prefix":"kinesis-video-signaling","name":"KinesisVideoSignalingChannels","cors":true},"detective":{"name":"Detective"},"codestarconnections":{"prefix":"codestar-connections","name":"CodeStarconnections"},"synthetics":{"name":"Synthetics"},"iotsitewise":{"name":"IoTSiteWise"},"macie2":{"name":"Macie2"},"codeartifact":{"name":"CodeArtifact"},"ivs":{"name":"IVS"},"braket":{"name":"Braket"},"identitystore":{"name":"IdentityStore"},"appflow":{"name":"Appflow"},"redshiftdata":{"prefix":"redshift-data","name":"RedshiftData"},"ssoadmin":{"prefix":"sso-admin","name":"SSOAdmin"},"timestreamquery":{"prefix":"timestream-query","name":"TimestreamQuery"},"timestreamwrite":{"prefix":"timestream-write","name":"TimestreamWrite"},"s3outposts":{"name":"S3Outposts"},"databrew":{"name":"DataBrew"},"servicecatalogappregistry":{"prefix":"servicecatalog-appregistry","name":"ServiceCatalogAppRegistry"},"networkfirewall":{"prefix":"network-firewall","name":"NetworkFirewall"},"mwaa":{"name":"MWAA"},"amplifybackend":{"name":"AmplifyBackend"},"appintegrations":{"name":"AppIntegrations"},"connectcontactlens":{"prefix":"connect-contact-lens","name":"ConnectContactLens"},"devopsguru":{"prefix":"devops-guru","name":"DevOpsGuru"},"ecrpublic":{"prefix":"ecr-public","name":"ECRPUBLIC"},"lookoutvision":{"name":"LookoutVision"},"sagemakerfeaturestoreruntime":{"prefix":"sagemaker-featurestore-runtime","name":"SageMakerFeatureStoreRuntime"},"customerprofiles":{"prefix":"customer-profiles","name":"CustomerProfiles"},"auditmanager":{"name":"AuditManager"},"emrcontainers":{"prefix":"emr-containers","name":"EMRcontainers"},"healthlake":{"name":"HealthLake"},"sagemakeredge":{"prefix":"sagemaker-edge","name":"SagemakerEdge"},"amp":{"name":"Amp","cors":true},"greengrassv2":{"name":"GreengrassV2"},"iotdeviceadvisor":{"name":"IotDeviceAdvisor"},"iotfleethub":{"name":"IoTFleetHub"},"iotwireless":{"name":"IoTWireless"},"location":{"name":"Location","cors":true},"wellarchitected":{"name":"WellArchitected"},"lexmodelsv2":{"prefix":"models.lex.v2","name":"LexModelsV2"},"lexruntimev2":{"prefix":"runtime.lex.v2","name":"LexRuntimeV2","cors":true},"fis":{"name":"Fis"},"lookoutmetrics":{"name":"LookoutMetrics"},"mgn":{"name":"Mgn"},"lookoutequipment":{"name":"LookoutEquipment"},"nimble":{"name":"Nimble"},"finspace":{"name":"Finspace"},"finspacedata":{"prefix":"finspace-data","name":"Finspacedata"},"ssmcontacts":{"prefix":"ssm-contacts","name":"SSMContacts"},"ssmincidents":{"prefix":"ssm-incidents","name":"SSMIncidents"},"applicationcostprofiler":{"name":"ApplicationCostProfiler"},"apprunner":{"name":"AppRunner"},"proton":{"name":"Proton"},"route53recoverycluster":{"prefix":"route53-recovery-cluster","name":"Route53RecoveryCluster"},"route53recoverycontrolconfig":{"prefix":"route53-recovery-control-config","name":"Route53RecoveryControlConfig"},"route53recoveryreadiness":{"prefix":"route53-recovery-readiness","name":"Route53RecoveryReadiness"},"chimesdkidentity":{"prefix":"chime-sdk-identity","name":"ChimeSDKIdentity"},"chimesdkmessaging":{"prefix":"chime-sdk-messaging","name":"ChimeSDKMessaging"},"snowdevicemanagement":{"prefix":"snow-device-management","name":"SnowDeviceManagement"},"memorydb":{"name":"MemoryDB"},"opensearch":{"name":"OpenSearch"},"kafkaconnect":{"name":"KafkaConnect"},"voiceid":{"prefix":"voice-id","name":"VoiceID"},"wisdom":{"name":"Wisdom"},"account":{"name":"Account"},"cloudcontrol":{"name":"CloudControl"},"grafana":{"name":"Grafana"},"panorama":{"name":"Panorama"},"chimesdkmeetings":{"prefix":"chime-sdk-meetings","name":"ChimeSDKMeetings"},"resiliencehub":{"name":"Resiliencehub"},"migrationhubstrategy":{"name":"MigrationHubStrategy"},"appconfigdata":{"name":"AppConfigData"},"drs":{"name":"Drs"},"migrationhubrefactorspaces":{"prefix":"migration-hub-refactor-spaces","name":"MigrationHubRefactorSpaces"},"evidently":{"name":"Evidently"},"inspector2":{"name":"Inspector2"},"rbin":{"name":"Rbin"},"rum":{"name":"RUM"},"backupgateway":{"prefix":"backup-gateway","name":"BackupGateway"},"iottwinmaker":{"name":"IoTTwinMaker"},"workspacesweb":{"prefix":"workspaces-web","name":"WorkSpacesWeb"},"amplifyuibuilder":{"name":"AmplifyUIBuilder"},"keyspaces":{"name":"Keyspaces"},"billingconductor":{"name":"Billingconductor"},"pinpointsmsvoicev2":{"prefix":"pinpoint-sms-voice-v2","name":"PinpointSMSVoiceV2"},"ivschat":{"name":"Ivschat"},"chimesdkmediapipelines":{"prefix":"chime-sdk-media-pipelines","name":"ChimeSDKMediaPipelines"},"emrserverless":{"prefix":"emr-serverless","name":"EMRServerless"},"m2":{"name":"M2"},"connectcampaigns":{"name":"ConnectCampaigns"},"redshiftserverless":{"prefix":"redshift-serverless","name":"RedshiftServerless"},"rolesanywhere":{"name":"RolesAnywhere"},"licensemanagerusersubscriptions":{"prefix":"license-manager-user-subscriptions","name":"LicenseManagerUserSubscriptions"},"backupstorage":{"name":"BackupStorage"},"privatenetworks":{"name":"PrivateNetworks"},"supportapp":{"prefix":"support-app","name":"SupportApp"},"controltower":{"name":"ControlTower"},"iotfleetwise":{"name":"IoTFleetWise"},"migrationhuborchestrator":{"name":"MigrationHubOrchestrator"},"connectcases":{"name":"ConnectCases"},"resourceexplorer2":{"prefix":"resource-explorer-2","name":"ResourceExplorer2"},"scheduler":{"name":"Scheduler"},"chimesdkvoice":{"prefix":"chime-sdk-voice","name":"ChimeSDKVoice"},"ssmsap":{"prefix":"ssm-sap","name":"SsmSap"},"oam":{"name":"OAM"},"arczonalshift":{"prefix":"arc-zonal-shift","name":"ARCZonalShift"},"omics":{"name":"Omics"},"opensearchserverless":{"name":"OpenSearchServerless"},"securitylake":{"name":"SecurityLake"},"simspaceweaver":{"name":"SimSpaceWeaver"},"docdbelastic":{"prefix":"docdb-elastic","name":"DocDBElastic"},"sagemakergeospatial":{"prefix":"sagemaker-geospatial","name":"SageMakerGeospatial"},"codecatalyst":{"name":"CodeCatalyst"},"pipes":{"name":"Pipes"},"sagemakermetrics":{"prefix":"sagemaker-metrics","name":"SageMakerMetrics"},"kinesisvideowebrtcstorage":{"prefix":"kinesis-video-webrtc-storage","name":"KinesisVideoWebRTCStorage"},"licensemanagerlinuxsubscriptions":{"prefix":"license-manager-linux-subscriptions","name":"LicenseManagerLinuxSubscriptions"},"kendraranking":{"prefix":"kendra-ranking","name":"KendraRanking"},"cleanrooms":{"name":"CleanRooms"},"cloudtraildata":{"prefix":"cloudtrail-data","name":"CloudTrailData"},"tnb":{"name":"Tnb"},"internetmonitor":{"name":"InternetMonitor"},"ivsrealtime":{"prefix":"ivs-realtime","name":"IVSRealTime"},"vpclattice":{"prefix":"vpc-lattice","name":"VPCLattice"},"osis":{"name":"OSIS"},"mediapackagev2":{"name":"MediaPackageV2"},"paymentcryptography":{"prefix":"payment-cryptography","name":"PaymentCryptography"},"paymentcryptographydata":{"prefix":"payment-cryptography-data","name":"PaymentCryptographyData"},"codegurusecurity":{"prefix":"codeguru-security","name":"CodeGuruSecurity"},"verifiedpermissions":{"name":"VerifiedPermissions"},"appfabric":{"name":"AppFabric"},"medicalimaging":{"prefix":"medical-imaging","name":"MedicalImaging"},"entityresolution":{"name":"EntityResolution"},"managedblockchainquery":{"prefix":"managedblockchain-query","name":"ManagedBlockchainQuery"},"neptunedata":{"name":"Neptunedata"},"pcaconnectorad":{"prefix":"pca-connector-ad","name":"PcaConnectorAd"},"bedrock":{"name":"Bedrock"},"bedrockruntime":{"prefix":"bedrock-runtime","name":"BedrockRuntime"},"datazone":{"name":"DataZone"},"launchwizard":{"prefix":"launch-wizard","name":"LaunchWizard"},"trustedadvisor":{"name":"TrustedAdvisor"},"inspectorscan":{"prefix":"inspector-scan","name":"InspectorScan"},"bcmdataexports":{"prefix":"bcm-data-exports","name":"BCMDataExports"},"costoptimizationhub":{"prefix":"cost-optimization-hub","name":"CostOptimizationHub"},"eksauth":{"prefix":"eks-auth","name":"EKSAuth"},"freetier":{"name":"FreeTier"},"repostspace":{"name":"Repostspace"},"workspacesthinclient":{"prefix":"workspaces-thin-client","name":"WorkSpacesThinClient"},"b2bi":{"name":"B2bi"},"bedrockagent":{"prefix":"bedrock-agent","name":"BedrockAgent"},"bedrockagentruntime":{"prefix":"bedrock-agent-runtime","name":"BedrockAgentRuntime"},"qbusiness":{"name":"QBusiness"},"qconnect":{"name":"QConnect"},"cleanroomsml":{"name":"CleanRoomsML"},"marketplaceagreement":{"prefix":"marketplace-agreement","name":"MarketplaceAgreement"},"marketplacedeployment":{"prefix":"marketplace-deployment","name":"MarketplaceDeployment"},"networkmonitor":{"name":"NetworkMonitor"},"supplychain":{"name":"SupplyChain"},"artifact":{"name":"Artifact"},"chatbot":{"name":"Chatbot"},"timestreaminfluxdb":{"prefix":"timestream-influxdb","name":"TimestreamInfluxDB"},"codeconnections":{"name":"CodeConnections"},"deadline":{"name":"Deadline"},"controlcatalog":{"name":"ControlCatalog"},"route53profiles":{"name":"Route53Profiles"},"mailmanager":{"name":"MailManager"}}

/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

//paket mapel

function addBab(dataBody, callback) {
  var config = getConfig();

  http.post('/lms/section', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getItemBab(id, callback) {
  var config = getConfig();
  http.get('/itembank/topics?mapel_code=' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function deleteBab(id, callback) {
  var config = getConfig();
  http.delete('/lms/section/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function getMapelDetailById(id, callback) {
  var config = getConfig();
  http.get('/lms/block_package/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function editBab(dataBody, callback) {
  var config = getConfig();

  http.put('/lms/section/' + dataBody[1], dataBody[0], config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function reOrderKonten(dataBody, callback) {
  var config = getConfig();

  http.put('/lms/section/' + dataBody[1] + '/reorder', dataBody[0], config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  getItemBab: getItemBab,
  addBab: addBab,
  deleteBab: deleteBab,
  reOrderKonten: reOrderKonten,
  getMapelDetailById: getMapelDetailById,
  editBab: editBab
});

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

//paket mapel

function addContent(dataBody, callback) {
  var config = getConfig();

  http.post('/lms/detail', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListVideo(id, callback) {
  var config = getConfig();
  http.get('/itembank/videos?mapel_id=' + id.mapel_id + '&grade_id=' + id.grade, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function deleteContent(id, callback) {
  var config = getConfig();
  http.delete('/lms/detail/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function editBab(dataBody, callback) {
  var config = getConfig();

  http.put('/lms/section/' + dataBody[1], dataBody[0], config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateContent(dataBody, callback) {
  var config = getConfig();

  http.put('/lms/detail/' + dataBody.id, dataBody.body, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function uploadFile(dataBody, callback) {
  var config = getConfig();

  httpupload.post('/lms/upload', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getBabSubbab(id, callback) {
  var config = getConfig();
  http.get('/itembank/topics?mapel_code=' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

function getOneContent(id, callback) {
  var config = getConfig();
  http.get('/lms/detail/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: true,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getListVideo: getListVideo,
  addContent: addContent,
  deleteContent: deleteContent,
  getBabSubbab: getBabSubbab,
  editBab: editBab,
  uploadFile: uploadFile,
  getOneContent: getOneContent,
  updateContent: updateContent
});

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_aws_sdk__);





var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id" + '/promotion',
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getListMataPelajaran(callback) {
  var config = getConfig();
  http.get('/mapels', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getItemsByMataPelajaran(params, callback) {
  var config = getConfig();
  var code = '';
  var label = '';
  var babName = '';
  var subbabName = '';
  var subsubabName = '';
  var jenjang = '';
  var jenis = '';
  var kelas = '';
  if (params.itemCode !== '') code = '&item_code=' + params.itemCode;
  if (params.label !== '') label = '&label=' + params.label;
  if (params.babName !== '') babName = '&bab=' + params.babName;
  if (params.subbabName !== '') subbabName = '&subbab=' + params.subbabName;
  if (params.subsubabName !== '') subsubabName = '&subsubbab=' + params.subsubabName;
  if (params.jenjang !== '') jenjang = '&jenjang=' + params.jenjang;
  if (params.jenis !== '') jenis = '&jenis=' + params.jenis;
  if (params.kelas !== '') kelas = '&grade=' + params.kelas;

  http.get('/items?mapel_id=' + params.mapelId + code + label + babName + subbabName + subsubabName + jenjang + jenis + kelas + '&page=' + params.page, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfSchoolGrade(callback) {
  var config = getConfig();
  http.get('/grades', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfTopicGrade(callback) {
  var config = getConfig();
  http.get('/topic_grades', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfItemType(callback) {
  var config = getConfig();
  http.get('/types', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListOfTopic(mapelCode, callback) {
  var config = getConfig();
  http.get('/topics?mapel_code=' + mapelCode, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createItem(data, callback) {
  var config = getConfig();
  var postData = {
    wacana: data.wacana,
    isi: data.soal,
    pilihan_1: data.opsiA,
    pilihan_2: data.opsiB,
    pilihan_3: data.opsiC,
    pilihan_4: data.opsiD,
    pilihan_5: data.opsiE,
    jawaban: data.jawaban,
    pembahasan: data.pembahasan,
    mapel_id: data.mapelId,
    // jenjang_id: data.jenjang,
    // jenis_soal_id: data.jenis,
    // bab_id: data.babId,
    // sub_bab_id: data.subBabId,
    // sub_sub_bab_id: data.subSubBabId,
    // sumber: data.sumber,
    // pembahasan: data.pembahasan,
    // is_restricted: data.is_restricted,
    // label: data.label,
    arr_grades: data.grades
  };

  http.post('/item', postData, config).then(function (response) {
    callback({
      success: true,
      data: null
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateItem(id, data, callback) {
  var config = getConfig();
  var postData = {
    wacana: data.wacana,
    isi: data.soal,
    pilihan_1: data.opsiA,
    pilihan_2: data.opsiB,
    pilihan_3: data.opsiC,
    pilihan_4: data.opsiD,
    pilihan_5: data.opsiE,
    jawaban: data.jawaban,
    pembahasan: data.pembahasan,
    mapel_id: data.mapelId,
    // jenjang_id: data.jenjang,
    // jenis_soal_id: data.jenis,
    // bab_id: data.babId,
    // sub_bab_id: data.subBabId,
    // sub_sub_bab_id: data.subSubBabId,
    // sumber: data.sumber,
    // pembahasan: data.pembahasan,
    // is_restricted: data.is_restricted,
    // label: data.label,
    arr_grades: data.grades
  };

  http.put('/item/' + id, postData, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteItem(id, callback) {
  var config = getConfig();
  http.delete('/item/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getItemById(id, callback) {
  var config = getConfig();
  http.get('/item/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createWacana(data, callback) {
  var config = getConfig();
  var postData = {
    mapel_id: data.mapelId,
    isi: data.wacana
  };

  http.post('/wacana', postData, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateWacana(id, data, callback) {
  var config = getConfig();
  var putData = {
    mapel_id: data.mapelId,
    isi: data.wacana
  };

  http.put('/wacana/' + id, putData, config).then(function (response) {
    callback({
      success: true,
      data: null
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListWacana(mapelId, callback) {
  var config = getConfig();
  http.get('/wacanas?mapel_id=' + mapelId, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function searchItemByItemCode(itemcode, callback) {
  var config = getConfig();
  http.get('/items?random=false&item_code=' + itemcode, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function searchItemByItemCodeAndGrade(itemcode, grade, callback) {
  var config = getConfig();
  var gr = '';
  if (grade) gr = '&grade=' + parseInt(grade);
  http.get('/items?random=false&item_code=' + itemcode + gr, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addBab(data, callback) {
  var config = getConfig();
  http.post('/bab/', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateBab(id, data, callback) {
  var config = getConfig();
  http.put('/bab/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteBab(id, callback) {
  var config = getConfig();
  http.delete('/bab/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addSubBab(data, callback) {
  var config = getConfig();
  http.post('/subbab/', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateSubBab(id, data, callback) {
  var config = getConfig();
  http.put('/subbab/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteSubBab(id, callback) {
  var config = getConfig();
  http.delete('/subbab/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function addSubSubBab(data, callback) {
  var config = getConfig();
  http.post('/subsubbab/', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateSubSubBab(id, data, callback) {
  var config = getConfig();
  http.put('/subsubbab/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteSubSubBab(id, callback) {
  var config = getConfig();
  http.delete('/subsubbab/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getTopicMappings(gradeId, interest, callback) {
  var config = getConfig();
  http.get('/topic_mappings?grade_id=' + gradeId + "&interest=" + interest, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createTopicMapping(mapelId, babId, subBabId, subSubBabId, gradeId, interest, callback) {
  var config = getConfig();
  var data = {
    mapel_id: mapelId,
    bab_id: babId,
    sub_bab_id: subBabId,
    sub_sub_bab_id: subSubBabId,
    grade_id: gradeId,
    interest: interest
  };

  http.post('/topic_mapping', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteTopicMapping(mapelId, babId, subBabId, subSubBabId, gradeId, interest, callback) {
  var config = getConfig();
  var url = '/topic_mapping?grade_id=' + gradeId + '&interest=' + interest + '&mapel_id=' + mapelId + '&bab_id=' + babId;
  if (subBabId != null) url += '&sub_bab_id=' + subBabId;
  if (subSubBabId != null) url += '&sub_sub_bab_id=' + subSubBabId;

  http.delete(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListModulBelajar(callback) {
  var config = getConfig();
  http.get('/modules', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.message
    });
  });
}

function getLiveStream(id, callback) {
  var config = getConfig();
  http.get('/streaming/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function createModulBelajar(data, callback) {
  var config = getConfig();
  http.post('/module', data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateModulBelajar(id, data, callback) {
  var config = getConfig();
  http.put('/module/' + id, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getModulBelajar(id, callback) {
  var config = getConfig();
  http.get('/module/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      data: error.message
    });
  });
}

function deleteModulBelajar(id, callback) {
  var config = getConfig();
  http.delete('/module/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getListMataPelajaran: getListMataPelajaran,
  getItemsByMataPelajaran: getItemsByMataPelajaran,
  getListOfItemType: getListOfItemType,
  getListOfSchoolGrade: getListOfSchoolGrade,
  getListOfTopicGrade: getListOfTopicGrade,
  getListOfTopic: getListOfTopic,
  createItem: createItem,
  updateItem: updateItem,
  deleteItem: deleteItem,
  getItemById: getItemById,
  updateWacana: updateWacana,
  createWacana: createWacana,
  getListWacana: getListWacana,
  searchItemByItemCode: searchItemByItemCode,
  addBab: addBab,
  updateBab: updateBab,
  deleteBab: deleteBab,
  addSubBab: addSubBab,
  updateSubBab: updateSubBab,
  deleteSubBab: deleteSubBab,
  addSubSubBab: addSubSubBab,
  updateSubSubBab: updateSubSubBab,
  deleteSubSubBab: deleteSubSubBab,
  getTopicMappings: getTopicMappings,
  createTopicMapping: createTopicMapping,
  deleteTopicMapping: deleteTopicMapping,
  getListModulBelajar: getListModulBelajar,
  createModulBelajar: createModulBelajar,
  getModulBelajar: getModulBelajar,
  updateModulBelajar: updateModulBelajar,
  deleteModulBelajar: deleteModulBelajar,
  getLiveStream: getLiveStream,
  searchItemByItemCodeAndGrade: searchItemByItemCodeAndGrade
});

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function validate(text) {
  var pattern = /[(http(s)?):\/\/(www\.)?a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
  return pattern.test(text);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  validate: validate
});

/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_loader__);





// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

//user manajemen

function uploadFile(dataBody, callback) {
  var config = getConfig();

  httpupload.post('/account/activation/bulk', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateUserGrade(dataBody, callback) {
  var config = getConfig();
  http.post('/account/usman/user/update_grade', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateUserSchool(dataBody, callback) {
  var config = getConfig();
  http.post('/account/usman/user/update', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  uploadFile: uploadFile,
  updateUserGrade: updateUserGrade,
  updateUserSchool: updateUserSchool
});

/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getListVoucher(pagination, search, callback) {
  var config = getConfig();
  // if(params) config.params = params[0]
  var url = '/sales/vouchers?';

  // if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per=' + pagination.perPage
  if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage;
  if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
    url += '&sort_mode=' + pagination.sortMode.toUpperCase();
  }
  if (search && search.product_id) url += '&product_id=' + search.product_id;
  if (search && search.channel_id) url += '&channel_id=' + search.channel_id;
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data,
      pagination: {
        page: response.headers['pagination-page'],
        limit: response.headers['pagination-limit'],
        total_page: response.headers['pagination-total-pages'],
        total_data: response.headers['pagination-total-elements']
      }
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getListChannels(pagination, search, callback) {
  var config = getConfig();
  // if(params) config.params = params[0]
  var url = '/sales/channels';

  // if (pagination.perPage !== undefined && pagination.perPage !== null) url += 'per_page=' + pagination.perPage
  // if (pagination.currentPage !== undefined && pagination.currentPage !== null) url += '&page=' + pagination.currentPage
  // if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
  //   url += '&sort_mode=' + pagination.sortMode.toUpperCase()
  // }
  // if (search && search.query && search.by) url += '&search=' + search.query + '&search_by=' + search.by

  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}
function generateVoucher(dataBody, callback) {
  var config = getConfig();

  http.post('/sales/voucher', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getListVoucher: getListVoucher,
  getListChannels: getListChannels,
  generateVoucher: generateVoucher
  //   addBimbel,
  //   deleteBimbel,
  //   editBimbel,
  //   publishBimbel,

});

/***/ }),
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 169 */,
/* 170 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1068)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(1346),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(1393),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(903),
  /* template */
  __webpack_require__(1276),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1080)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(934),
  /* template */
  __webpack_require__(1402),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Home__ = __webpack_require__(1178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_home_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_home_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_itembank_ItemBank__ = __webpack_require__(1198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_itembank_ItemBank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_itembank_ItemBank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_itembank_Form__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_itembank_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_itembank_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tryout_Tryout__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_tryout_Tryout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_tryout_Tryout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tryout_Form__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tryout_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_tryout_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tryout_TryoutExport__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_tryout_TryoutExport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_tryout_TryoutExport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tryout_TryoutImport__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_tryout_TryoutImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_tryout_TryoutImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tryout_Revisi__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_tryout_Revisi___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_tryout_Revisi__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tryout_SubtestForm__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_tryout_SubtestForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_tryout_SubtestForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_tryout_group_TryoutGroup__ = __webpack_require__(1261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_tryout_group_TryoutGroup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_tryout_group_TryoutGroup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_tryout_group_Form__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_tryout_group_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_tryout_group_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_usman_UserManagement__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_usman_UserManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_usman_UserManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_usman_UserManagementDetail__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_usman_UserManagementDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_usman_UserManagementDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_usman_UserBulkActivation__ = __webpack_require__(1263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_usman_UserBulkActivation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_usman_UserBulkActivation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_kodifikasi_TopicManagement__ = __webpack_require__(1204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_kodifikasi_TopicManagement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_kodifikasi_TopicManagement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_kodifikasi_TopicManagementDetail__ = __webpack_require__(1205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_kodifikasi_TopicManagementDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_kodifikasi_TopicManagementDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_kodifikasi_TopicMapping__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_kodifikasi_TopicMapping___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_kodifikasi_TopicMapping__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_kodifikasi_TopicMappingDetail__ = __webpack_require__(1207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_kodifikasi_TopicMappingDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_kodifikasi_TopicMappingDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_serial_Serial__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_serial_Serial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_serial_Serial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_serial_Form__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_serial_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_serial_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_vd_pembelajaran_VdPembelajaran__ = __webpack_require__(1268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_vd_pembelajaran_VdPembelajaran___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_vd_pembelajaran_VdPembelajaran__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_vd_pembelajaran_Form__ = __webpack_require__(1266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_vd_pembelajaran_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_vd_pembelajaran_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_modul_pembelajaran_ModulBelajar__ = __webpack_require__(1213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_modul_pembelajaran_ModulBelajar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_modul_pembelajaran_ModulBelajar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_modul_pembelajaran_Form__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_modul_pembelajaran_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_modul_pembelajaran_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_modul_pembelajaran_ModulBelajarMaterial__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_modul_pembelajaran_ModulBelajarMaterial___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_modul_pembelajaran_ModulBelajarMaterial__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_modul_pembelajaran_ModulBelajarLiveStream__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_modul_pembelajaran_ModulBelajarLiveStream___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_modul_pembelajaran_ModulBelajarLiveStream__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pembayaran_Pembayaran__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_pembayaran_Pembayaran___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_pembayaran_Pembayaran__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_pembayaran_PembayaranDetail__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_pembayaran_PembayaranDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_pembayaran_PembayaranDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_pembayaran_MetodePembayaran__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_pembayaran_MetodePembayaran___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_pembayaran_MetodePembayaran__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_pembayaran_MetodePembayaranFormV2__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_pembayaran_MetodePembayaranFormV2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_pembayaran_MetodePembayaranFormV2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_pembayaran_Form__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_pembayaran_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_pembayaran_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_pembayaran_Produk__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_pembayaran_Produk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_pembayaran_Produk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_pembayaran_ProdukForm__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_pembayaran_ProdukForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_pembayaran_ProdukForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_pembayaran_TicketUsage__ = __webpack_require__(1233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_pembayaran_TicketUsage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_pembayaran_TicketUsage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_pembayaran_TicketUsageDetail__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_pembayaran_TicketUsageDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_pembayaran_TicketUsageDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_pembayaran_KatalogTiket__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_pembayaran_KatalogTiket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_pembayaran_KatalogTiket__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_pembayaran_KatalogTiketForm__ = __webpack_require__(1225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_pembayaran_KatalogTiketForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_pembayaran_KatalogTiketForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_duel_register_liga_RegisterLiga__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__components_duel_register_liga_RegisterLiga___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40__components_duel_register_liga_RegisterLiga__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_duel_register_liga_RegisterLigaForm__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__components_duel_register_liga_RegisterLigaForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41__components_duel_register_liga_RegisterLigaForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_duel_season_Season__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__components_duel_season_Season___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42__components_duel_season_Season__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_duel_season_SeasonForm__ = __webpack_require__(1177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__components_duel_season_SeasonForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43__components_duel_season_SeasonForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_duel_liga_personal_LigaPersonalMenu__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__components_duel_liga_personal_LigaPersonalMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44__components_duel_liga_personal_LigaPersonalMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_duel_liga_personal_LigaPersonalBrackets__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__components_duel_liga_personal_LigaPersonalBrackets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45__components_duel_liga_personal_LigaPersonalBrackets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_duel_liga_sekolah_LigaSekolahMenu__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__components_duel_liga_sekolah_LigaSekolahMenu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46__components_duel_liga_sekolah_LigaSekolahMenu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_duel_liga_sekolah_LigaSekolahBrackets__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__components_duel_liga_sekolah_LigaSekolahBrackets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47__components_duel_liga_sekolah_LigaSekolahBrackets__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_bimbel_online_paket_mapel_ListPaketMapel__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__components_bimbel_online_paket_mapel_ListPaketMapel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48__components_bimbel_online_paket_mapel_ListPaketMapel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_bimbel_online_paket_mapel_PaketMapel__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__components_bimbel_online_paket_mapel_PaketMapel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49__components_bimbel_online_paket_mapel_PaketMapel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_bimbel_online_paket_mapel_Form__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__components_bimbel_online_paket_mapel_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50__components_bimbel_online_paket_mapel_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_bimbel_online_paket_bimbel_ListPaketBimbel__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__components_bimbel_online_paket_bimbel_ListPaketBimbel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51__components_bimbel_online_paket_bimbel_ListPaketBimbel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_bimbel_online_paket_bimbel_Form__ = __webpack_require__(1160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__components_bimbel_online_paket_bimbel_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52__components_bimbel_online_paket_bimbel_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_home_setting_content_Content__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__components_home_setting_content_Content___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53__components_home_setting_content_Content__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_home_setting_content_Form__ = __webpack_require__(1185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__components_home_setting_content_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54__components_home_setting_content_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_home_setting_article_Article__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__components_home_setting_article_Article___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55__components_home_setting_article_Article__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_home_setting_article_Form__ = __webpack_require__(1181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__components_home_setting_article_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56__components_home_setting_article_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_home_setting_menu_Menu__ = __webpack_require__(1193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__components_home_setting_menu_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57__components_home_setting_menu_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_home_setting_menu_Form__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__components_home_setting_menu_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58__components_home_setting_menu_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_home_setting_free_video_FreeVideo__ = __webpack_require__(1191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__components_home_setting_free_video_FreeVideo___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59__components_home_setting_free_video_FreeVideo__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_home_setting_free_video_Form__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__components_home_setting_free_video_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60__components_home_setting_free_video_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_home_setting_banner_Banner__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__components_home_setting_banner_Banner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61__components_home_setting_banner_Banner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_home_setting_banner_Form__ = __webpack_require__(1183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__components_home_setting_banner_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62__components_home_setting_banner_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_home_setting_free_itembank_FreeItemBank__ = __webpack_require__(1187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__components_home_setting_free_itembank_FreeItemBank___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63__components_home_setting_free_itembank_FreeItemBank__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_home_setting_free_itembank_Form__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__components_home_setting_free_itembank_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64__components_home_setting_free_itembank_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_home_setting_free_itembank_ItemBankImport__ = __webpack_require__(1189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__components_home_setting_free_itembank_ItemBankImport___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65__components_home_setting_free_itembank_ItemBankImport__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_home_setting_preview_setting_content_Preview__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__components_home_setting_preview_setting_content_Preview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66__components_home_setting_preview_setting_content_Preview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_organizations_Organizations__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__components_organizations_Organizations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67__components_organizations_Organizations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_organizations_OrganizationDetail__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__components_organizations_OrganizationDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68__components_organizations_OrganizationDetail__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_organizations_OrganizationForm__ = __webpack_require__(1219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__components_organizations_OrganizationForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69__components_organizations_OrganizationForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_organizations_OrganizationsActivation__ = __webpack_require__(1221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__components_organizations_OrganizationsActivation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70__components_organizations_OrganizationsActivation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_config_management_Form__ = __webpack_require__(1167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__components_config_management_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71__components_config_management_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_sbmptn_Sbmptn__ = __webpack_require__(1240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__components_sbmptn_Sbmptn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72__components_sbmptn_Sbmptn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_sbmptn_Top10Ranking__ = __webpack_require__(1241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__components_sbmptn_Top10Ranking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73__components_sbmptn_Top10Ranking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_voucher_Voucher__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__components_voucher_Voucher___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74__components_voucher_Voucher__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_voucher_Form__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__components_voucher_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75__components_voucher_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_iklan_Form__ = __webpack_require__(1195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__components_iklan_Form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76__components_iklan_Form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_affiliate_dashboard_AffiliateDashboard__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__components_affiliate_dashboard_AffiliateDashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77__components_affiliate_dashboard_AffiliateDashboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_affiliate_redeem_AffiliateRedeem__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__components_affiliate_redeem_AffiliateRedeem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78__components_affiliate_redeem_AffiliateRedeem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_affiliate_setting_AffiliateSetting__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__components_affiliate_setting_AffiliateSetting___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79__components_affiliate_setting_AffiliateSetting__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_regrading_Regrading__ = __webpack_require__(1238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__components_regrading_Regrading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80__components_regrading_Regrading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_push_notif_PushNotif__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__components_push_notif_PushNotif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81__components_push_notif_PushNotif__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_teacher_Teachers__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__components_teacher_Teachers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82__components_teacher_Teachers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_teacher_TeacherDetail__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__components_teacher_TeacherDetail___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83__components_teacher_TeacherDetail__);

































// import MetodePembayaranForm from '@/components/pembayaran/MetodePembayaranForm'







































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_home_Home___default.a
  }, {
    path: '/login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_3__components_auth_Login___default.a
  }, {
    path: '/items',
    name: 'ItemBank',
    component: __WEBPACK_IMPORTED_MODULE_4__components_itembank_ItemBank___default.a
  }, {
    path: '/item-form',
    name: 'ItemBankForm',
    component: __WEBPACK_IMPORTED_MODULE_5__components_itembank_Form___default.a
  }, {
    path: '/tryouts',
    name: 'Tryout',
    component: __WEBPACK_IMPORTED_MODULE_6__components_tryout_Tryout___default.a
  }, {
    path: '/tryout-form',
    name: 'TryoutForm',
    component: __WEBPACK_IMPORTED_MODULE_7__components_tryout_Form___default.a
  }, {
    path: '/tryout-export',
    name: 'TryoutExport',
    component: __WEBPACK_IMPORTED_MODULE_8__components_tryout_TryoutExport___default.a
  }, {
    path: '/tryout-revisi',
    name: 'TryoutRevision',
    component: __WEBPACK_IMPORTED_MODULE_10__components_tryout_Revisi___default.a
  }, {
    path: '/tryout-import',
    name: 'TryoutImport',
    component: __WEBPACK_IMPORTED_MODULE_9__components_tryout_TryoutImport___default.a
  }, {
    path: '/subtest-form',
    name: 'SubtestForm',
    component: __WEBPACK_IMPORTED_MODULE_11__components_tryout_SubtestForm___default.a
  }, {
    path: '/tryout-groups',
    name: 'TryoutGroup',
    component: __WEBPACK_IMPORTED_MODULE_12__components_tryout_group_TryoutGroup___default.a
  }, {
    path: '/tryout-group/form',
    name: 'TryoutGroupForm',
    component: __WEBPACK_IMPORTED_MODULE_13__components_tryout_group_Form___default.a
  }, {
    path: '/user-management',
    name: 'UserManagement',
    component: __WEBPACK_IMPORTED_MODULE_14__components_usman_UserManagement___default.a
  }, {
    path: '/user-management/bulk-activation',
    name: 'UserManagement',
    component: __WEBPACK_IMPORTED_MODULE_16__components_usman_UserBulkActivation___default.a
  }, {
    path: '/user-detail',
    name: 'UserManagementDetail',
    component: __WEBPACK_IMPORTED_MODULE_15__components_usman_UserManagementDetail___default.a
  }, {
    path: '/topic-management',
    name: 'TopicManagement',
    component: __WEBPACK_IMPORTED_MODULE_17__components_kodifikasi_TopicManagement___default.a
  }, {
    path: '/topic-management/detail',
    name: 'TopicManagementDetail',
    component: __WEBPACK_IMPORTED_MODULE_18__components_kodifikasi_TopicManagementDetail___default.a
  }, {
    path: '/topic-mapping',
    name: 'TopicMapping',
    component: __WEBPACK_IMPORTED_MODULE_19__components_kodifikasi_TopicMapping___default.a
  }, {
    path: '/topic-mapping/detail',
    name: 'TopicMappingDetail',
    component: __WEBPACK_IMPORTED_MODULE_20__components_kodifikasi_TopicMappingDetail___default.a
  }, {
    path: '/serial',
    name: 'TryoutSerial',
    component: __WEBPACK_IMPORTED_MODULE_21__components_serial_Serial___default.a
  }, {
    path: '/serial/form',
    name: 'TryoutSerialForm',
    component: __WEBPACK_IMPORTED_MODULE_22__components_serial_Form___default.a
  }, {
    path: '/video',
    name: 'VideoPembelajaran',
    component: __WEBPACK_IMPORTED_MODULE_23__components_vd_pembelajaran_VdPembelajaran___default.a
  }, {
    path: '/video/form',
    name: 'VideoPembelajaranForm',
    component: __WEBPACK_IMPORTED_MODULE_24__components_vd_pembelajaran_Form___default.a
  }, {
    path: '/video/material/form',
    name: 'VideoMaterial',
    component: __WEBPACK_IMPORTED_MODULE_24__components_vd_pembelajaran_Form___default.a
  }, {
    path: '/video/material/live-stream/form',
    name: 'VideoMaterialLiveStream',
    component: __WEBPACK_IMPORTED_MODULE_24__components_vd_pembelajaran_Form___default.a
  }, {
    path: '/modul-belajar',
    name: 'ModulBelajar',
    component: __WEBPACK_IMPORTED_MODULE_25__components_modul_pembelajaran_ModulBelajar___default.a
  }, {
    path: '/modul-belajar/form',
    name: 'ModulBelajarForm',
    component: __WEBPACK_IMPORTED_MODULE_26__components_modul_pembelajaran_Form___default.a
  }, {
    path: '/modul-belajar/materials',
    name: 'ModulBelajarMaterial',
    component: __WEBPACK_IMPORTED_MODULE_27__components_modul_pembelajaran_ModulBelajarMaterial___default.a
  }, {
    path: '/modul-belajar/live-stream',
    name: 'ModuleBelajarLiveStream',
    component: __WEBPACK_IMPORTED_MODULE_28__components_modul_pembelajaran_ModulBelajarLiveStream___default.a
  }, {
    path: '/pembayaran',
    name: 'Pembayaran',
    component: __WEBPACK_IMPORTED_MODULE_29__components_pembayaran_Pembayaran___default.a
  }, {
    path: '/pembayaran/detail',
    name: 'PembayaranDetail',
    component: __WEBPACK_IMPORTED_MODULE_30__components_pembayaran_PembayaranDetail___default.a
  }, {
    path: '/pembayaran/form',
    name: 'PembayaranForm',
    component: __WEBPACK_IMPORTED_MODULE_33__components_pembayaran_Form___default.a
  }, {
    path: '/metode-pembayaran',
    name: 'MetodePembayaran',
    component: __WEBPACK_IMPORTED_MODULE_31__components_pembayaran_MetodePembayaran___default.a
  }, {
    path: '/metode-pembayaran/form',
    name: 'MetodePembayaranForm',
    component: __WEBPACK_IMPORTED_MODULE_32__components_pembayaran_MetodePembayaranFormV2___default.a
  }, {
    path: '/produk',
    name: 'Produk',
    component: __WEBPACK_IMPORTED_MODULE_34__components_pembayaran_Produk___default.a
  }, {
    path: '/produk/form',
    name: 'ProdukForm',
    component: __WEBPACK_IMPORTED_MODULE_35__components_pembayaran_ProdukForm___default.a
  }, {
    path: '/ticket-usage',
    name: 'TicketUsage',
    component: __WEBPACK_IMPORTED_MODULE_36__components_pembayaran_TicketUsage___default.a
  }, {
    path: '/ticket-usage/detail',
    name: 'TicketUsageDetail',
    component: __WEBPACK_IMPORTED_MODULE_37__components_pembayaran_TicketUsageDetail___default.a
  }, {
    path: '/katalog-tiket',
    name: 'KatalogTiket',
    component: __WEBPACK_IMPORTED_MODULE_38__components_pembayaran_KatalogTiket___default.a
  }, {
    path: '/katalog-tiket/form',
    name: 'KatalogTiketForm',
    component: __WEBPACK_IMPORTED_MODULE_39__components_pembayaran_KatalogTiketForm___default.a
  }, {
    path: '/register-liga/',
    name: 'RegisterLiga',
    component: __WEBPACK_IMPORTED_MODULE_40__components_duel_register_liga_RegisterLiga___default.a
  }, {
    path: '/register-liga/form',
    name: 'RegisterLigaForm',
    component: __WEBPACK_IMPORTED_MODULE_41__components_duel_register_liga_RegisterLigaForm___default.a
  }, {
    path: '/season/',
    name: 'Season',
    component: __WEBPACK_IMPORTED_MODULE_42__components_duel_season_Season___default.a
  }, {
    path: '/season/form',
    name: 'SeasonForm',
    component: __WEBPACK_IMPORTED_MODULE_43__components_duel_season_SeasonForm___default.a
  }, {
    path: '/liga-personal',
    name: 'LigaPersonalMenu',
    component: __WEBPACK_IMPORTED_MODULE_44__components_duel_liga_personal_LigaPersonalMenu___default.a
  }, {
    path: '/liga-personal/brackets',
    name: 'LigaPersonalBrackets',
    component: __WEBPACK_IMPORTED_MODULE_45__components_duel_liga_personal_LigaPersonalBrackets___default.a
  }, {
    path: '/liga-sekolah',
    name: 'LigaSekolahMenu',
    component: __WEBPACK_IMPORTED_MODULE_46__components_duel_liga_sekolah_LigaSekolahMenu___default.a
  }, {
    path: '/paket-mapel',
    name: 'ListPaketMapel',
    component: __WEBPACK_IMPORTED_MODULE_48__components_bimbel_online_paket_mapel_ListPaketMapel___default.a
  }, {
    path: '/paket-mapel/form',
    name: 'FormMapel',
    component: __WEBPACK_IMPORTED_MODULE_50__components_bimbel_online_paket_mapel_Form___default.a
  }, {
    path: '/paket-mapel/:id',
    name: 'DetailPaketMapel',
    component: __WEBPACK_IMPORTED_MODULE_49__components_bimbel_online_paket_mapel_PaketMapel___default.a
  }, {
    path: '/paket-mapel/form/:id',
    name: 'FormEditMapel',
    component: __WEBPACK_IMPORTED_MODULE_50__components_bimbel_online_paket_mapel_Form___default.a
  }, {
    path: '/paket-bimbel',
    name: 'ListPaketBimbel',
    component: __WEBPACK_IMPORTED_MODULE_51__components_bimbel_online_paket_bimbel_ListPaketBimbel___default.a
  }, {
    path: '/paket-bimbel/form',
    name: 'FormBimbel',
    component: __WEBPACK_IMPORTED_MODULE_52__components_bimbel_online_paket_bimbel_Form___default.a
  }, {
    path: '/paket-bimbel/:id',
    name: 'FormBimbel-edit',
    component: __WEBPACK_IMPORTED_MODULE_52__components_bimbel_online_paket_bimbel_Form___default.a
  }, {
    path: '/liga-sekolah/brackets',
    name: 'LigaSekolahBrackets',
    component: __WEBPACK_IMPORTED_MODULE_47__components_duel_liga_sekolah_LigaSekolahBrackets___default.a
  }, {
    path: '/liga-sekolah/brackets',
    name: 'LigaSekolahBrackets',
    component: __WEBPACK_IMPORTED_MODULE_47__components_duel_liga_sekolah_LigaSekolahBrackets___default.a
  }, {
    path: '/content/article',
    name: 'ContentArticle',
    component: __WEBPACK_IMPORTED_MODULE_55__components_home_setting_article_Article___default.a
  }, {
    path: '/content/article-form',
    name: 'FormArticle',
    component: __WEBPACK_IMPORTED_MODULE_56__components_home_setting_article_Form___default.a
  }, {
    path: '/content/article/:id',
    name: 'FormArticle-edit',
    component: __WEBPACK_IMPORTED_MODULE_56__components_home_setting_article_Form___default.a
  }, {
    path: '/content/section',
    name: 'ContentSection',
    component: __WEBPACK_IMPORTED_MODULE_53__components_home_setting_content_Content___default.a
  }, {
    path: '/content/section-form',
    name: 'FormContent',
    component: __WEBPACK_IMPORTED_MODULE_54__components_home_setting_content_Form___default.a
  }, {
    path: '/content/section/:id',
    name: 'FormContent-edit',
    component: __WEBPACK_IMPORTED_MODULE_54__components_home_setting_content_Form___default.a
  }, {
    path: '/content/menu',
    name: 'ContentMenu',
    component: __WEBPACK_IMPORTED_MODULE_57__components_home_setting_menu_Menu___default.a
  }, {
    path: '/content/menu-form',
    name: 'FormMenu',
    component: __WEBPACK_IMPORTED_MODULE_58__components_home_setting_menu_Form___default.a
  }, {
    path: '/content/menu/:id',
    name: 'FormMenu-edit',
    component: __WEBPACK_IMPORTED_MODULE_58__components_home_setting_menu_Form___default.a
  }, {
    path: '/content/video',
    name: 'ContentVideo',
    component: __WEBPACK_IMPORTED_MODULE_59__components_home_setting_free_video_FreeVideo___default.a
  }, {
    path: '/content/video-form',
    name: 'FormVideo',
    component: __WEBPACK_IMPORTED_MODULE_60__components_home_setting_free_video_Form___default.a
  }, {
    path: '/content/video/:id',
    name: 'FormVideo-edit',
    component: __WEBPACK_IMPORTED_MODULE_60__components_home_setting_free_video_Form___default.a
  }, {
    path: '/content/banner',
    name: 'ContentBanner',
    component: __WEBPACK_IMPORTED_MODULE_61__components_home_setting_banner_Banner___default.a
  }, {
    path: '/content/banner-form',
    name: 'FormBanner',
    component: __WEBPACK_IMPORTED_MODULE_62__components_home_setting_banner_Form___default.a
  }, {
    path: '/content/banner/:id',
    name: 'FormBanner-edit',
    component: __WEBPACK_IMPORTED_MODULE_62__components_home_setting_banner_Form___default.a
  }, {
    path: '/content/itembank',
    name: 'FreeItemBank',
    component: __WEBPACK_IMPORTED_MODULE_63__components_home_setting_free_itembank_FreeItemBank___default.a
  }, {
    path: '/content/itembank-form',
    name: 'ContentFreeItemBankForm',
    component: __WEBPACK_IMPORTED_MODULE_64__components_home_setting_free_itembank_Form___default.a
  }, {
    path: '/content/itembank-import',
    name: 'FreeItemBankImport',
    component: __WEBPACK_IMPORTED_MODULE_65__components_home_setting_free_itembank_ItemBankImport___default.a
  }, {
    path: '/content/preview',
    name: 'PreviewContent',
    component: __WEBPACK_IMPORTED_MODULE_66__components_home_setting_preview_setting_content_Preview___default.a
  }, {
    path: '/organizations',
    name: 'Organizations',
    component: __WEBPACK_IMPORTED_MODULE_67__components_organizations_Organizations___default.a
  }, {
    path: '/organization/:id',
    name: 'Organization',
    component: __WEBPACK_IMPORTED_MODULE_68__components_organizations_OrganizationDetail___default.a
  }, {
    path: '/organizations/form/:id?',
    name: 'OrganizationForm',
    component: __WEBPACK_IMPORTED_MODULE_69__components_organizations_OrganizationForm___default.a
  }, {
    path: '/organizations-activation',
    name: 'OrganizationsActivation',
    component: __WEBPACK_IMPORTED_MODULE_70__components_organizations_OrganizationsActivation___default.a
  }, {
    path: '/config',
    name: 'ConfigurationManagementForm',
    component: __WEBPACK_IMPORTED_MODULE_71__components_config_management_Form___default.a
  }, {
    path: '/sbmptn',
    name: 'SbmptnAdministration',
    component: __WEBPACK_IMPORTED_MODULE_72__components_sbmptn_Sbmptn___default.a
  }, {
    path: '/sbmptn/top10',
    name: 'Top10UtbkRankinig',
    component: __WEBPACK_IMPORTED_MODULE_73__components_sbmptn_Top10Ranking___default.a
  }, {
    path: '/voucher',
    name: 'Voucher',
    component: __WEBPACK_IMPORTED_MODULE_74__components_voucher_Voucher___default.a
  }, {
    path: '/voucher/form',
    name: 'VoucherForm',
    component: __WEBPACK_IMPORTED_MODULE_75__components_voucher_Form___default.a
  }, {
    path: '/ads-setting',
    name: 'AdsForm',
    component: __WEBPACK_IMPORTED_MODULE_76__components_iklan_Form___default.a
  }, {
    path: '/affiliate-dashboard',
    name: 'affiliate-dashboard',
    component: __WEBPACK_IMPORTED_MODULE_77__components_affiliate_dashboard_AffiliateDashboard___default.a
  }, {
    path: '/affiliate-redeem',
    name: 'affiliate-redeem',
    component: __WEBPACK_IMPORTED_MODULE_78__components_affiliate_redeem_AffiliateRedeem___default.a
  }, {
    path: '/affiliate-setting',
    name: 'affiliate-setting',
    component: __WEBPACK_IMPORTED_MODULE_79__components_affiliate_setting_AffiliateSetting___default.a
  }, {
    path: '/tryout-regrading',
    name: 'tryout-regrading',
    component: __WEBPACK_IMPORTED_MODULE_80__components_regrading_Regrading___default.a
  }, {
    path: '/push-notification',
    name: 'push-notification',
    component: __WEBPACK_IMPORTED_MODULE_81__components_push_notif_PushNotif___default.a
  }, {
    path: '/teachers',
    name: 'list-teacher',
    component: __WEBPACK_IMPORTED_MODULE_82__components_teacher_Teachers___default.a
  }, {
    path: '/teacher-detail/:id',
    name: 'form-teacher',
    component: __WEBPACK_IMPORTED_MODULE_83__components_teacher_TeacherDetail___default.a
  }],
  linkExactActiveClass: 'active'
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_auth__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_tryout__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_datatable__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_tryout_group__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_usman__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_video__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_bimbel__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_content__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_error__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_ads__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_ads___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__modules_ads__);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    auth: __WEBPACK_IMPORTED_MODULE_2__modules_auth__["a" /* default */],
    tryout: __WEBPACK_IMPORTED_MODULE_3__modules_tryout__["a" /* default */],
    datatable: __WEBPACK_IMPORTED_MODULE_4__modules_datatable__["a" /* default */],
    tryoutgroup: __WEBPACK_IMPORTED_MODULE_5__modules_tryout_group__["a" /* default */],
    usman: __WEBPACK_IMPORTED_MODULE_6__modules_usman__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_7__modules_video__["a" /* default */],
    bimbel: __WEBPACK_IMPORTED_MODULE_8__modules_bimbel__["a" /* default */],
    error: __WEBPACK_IMPORTED_MODULE_10__modules_error__["a" /* default */],
    ads: __WEBPACK_IMPORTED_MODULE_11__modules_ads___default.a,
    content: __WEBPACK_IMPORTED_MODULE_9__modules_content__["a" /* default */]
  }
}));

/***/ }),
/* 381 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */,
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1066)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(1338),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-08","endpointPrefix":"acm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ACM","serviceFullName":"AWS Certificate Manager","serviceId":"ACM","signatureVersion":"v4","targetPrefix":"CertificateManager","uid":"acm-2015-12-08"},"operations":{"AddTagsToCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"DeleteCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"DescribeCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{"type":"structure","members":{"CertificateArn":{},"DomainName":{},"SubjectAlternativeNames":{"shape":"Sc"},"DomainValidationOptions":{"shape":"Sd"},"Serial":{},"Subject":{},"Issuer":{},"CreatedAt":{"type":"timestamp"},"IssuedAt":{"type":"timestamp"},"ImportedAt":{"type":"timestamp"},"Status":{},"RevokedAt":{"type":"timestamp"},"RevocationReason":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"KeyAlgorithm":{},"SignatureAlgorithm":{},"InUseBy":{"type":"list","member":{}},"FailureReason":{},"Type":{},"RenewalSummary":{"type":"structure","required":["RenewalStatus","DomainValidationOptions","UpdatedAt"],"members":{"RenewalStatus":{},"DomainValidationOptions":{"shape":"Sd"},"RenewalStatusReason":{},"UpdatedAt":{"type":"timestamp"}}},"KeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"ExtendedKeyUsages":{"type":"list","member":{"type":"structure","members":{"Name":{},"OID":{}}}},"CertificateAuthorityArn":{},"RenewalEligibility":{},"Options":{"shape":"S11"}}}}}},"ExportCertificate":{"input":{"type":"structure","required":["CertificateArn","Passphrase"],"members":{"CertificateArn":{},"Passphrase":{"type":"blob","sensitive":true}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{},"PrivateKey":{"type":"string","sensitive":true}}}},"GetAccountConfiguration":{"output":{"type":"structure","members":{"ExpiryEvents":{"shape":"S1a"}}}},"GetCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Certificate":{},"CertificateChain":{}}}},"ImportCertificate":{"input":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"CertificateArn":{},"Certificate":{"type":"blob"},"PrivateKey":{"type":"blob","sensitive":true},"CertificateChain":{"type":"blob"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ListCertificates":{"input":{"type":"structure","members":{"CertificateStatuses":{"type":"list","member":{}},"Includes":{"type":"structure","members":{"extendedKeyUsage":{"type":"list","member":{}},"keyUsage":{"type":"list","member":{}},"keyTypes":{"type":"list","member":{}}}},"NextToken":{},"MaxItems":{"type":"integer"},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"NextToken":{},"CertificateSummaryList":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"DomainName":{},"SubjectAlternativeNameSummaries":{"shape":"Sc"},"HasAdditionalSubjectAlternativeNames":{"type":"boolean"},"Status":{},"Type":{},"KeyAlgorithm":{},"KeyUsages":{"type":"list","member":{}},"ExtendedKeyUsages":{"type":"list","member":{}},"InUse":{"type":"boolean"},"Exported":{"type":"boolean"},"RenewalEligibility":{},"NotBefore":{"type":"timestamp"},"NotAfter":{"type":"timestamp"},"CreatedAt":{"type":"timestamp"},"IssuedAt":{"type":"timestamp"},"ImportedAt":{"type":"timestamp"},"RevokedAt":{"type":"timestamp"}}}}}}},"ListTagsForCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"}}}},"PutAccountConfiguration":{"input":{"type":"structure","required":["IdempotencyToken"],"members":{"ExpiryEvents":{"shape":"S1a"},"IdempotencyToken":{}}}},"RemoveTagsFromCertificate":{"input":{"type":"structure","required":["CertificateArn","Tags"],"members":{"CertificateArn":{},"Tags":{"shape":"S3"}}}},"RenewCertificate":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}}},"RequestCertificate":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationMethod":{},"SubjectAlternativeNames":{"shape":"Sc"},"IdempotencyToken":{},"DomainValidationOptions":{"type":"list","member":{"type":"structure","required":["DomainName","ValidationDomain"],"members":{"DomainName":{},"ValidationDomain":{}}}},"Options":{"shape":"S11"},"CertificateAuthorityArn":{},"Tags":{"shape":"S3"},"KeyAlgorithm":{}}},"output":{"type":"structure","members":{"CertificateArn":{}}}},"ResendValidationEmail":{"input":{"type":"structure","required":["CertificateArn","Domain","ValidationDomain"],"members":{"CertificateArn":{},"Domain":{},"ValidationDomain":{}}}},"UpdateCertificateOptions":{"input":{"type":"structure","required":["CertificateArn","Options"],"members":{"CertificateArn":{},"Options":{"shape":"S11"}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"ValidationEmails":{"type":"list","member":{}},"ValidationDomain":{},"ValidationStatus":{},"ResourceRecord":{"type":"structure","required":["Name","Type","Value"],"members":{"Name":{},"Type":{},"Value":{}}},"ValidationMethod":{}}}},"S11":{"type":"structure","members":{"CertificateTransparencyLoggingPreference":{}}},"S1a":{"type":"structure","members":{"DaysBeforeExpiry":{"type":"integer"}}}}}

/***/ }),
/* 395 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCertificates":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"CertificateSummaryList"}}}

/***/ }),
/* 396 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"CertificateValidated":{"delay":60,"maxAttempts":40,"operation":"DescribeCertificate","acceptors":[{"matcher":"pathAll","expected":"SUCCESS","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"success"},{"matcher":"pathAny","expected":"PENDING_VALIDATION","argument":"Certificate.DomainValidationOptions[].ValidationStatus","state":"retry"},{"matcher":"path","expected":"FAILED","argument":"Certificate.Status","state":"failure"},{"matcher":"error","expected":"ResourceNotFoundException","state":"failure"}]}}}

/***/ }),
/* 397 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-01","endpointPrefix":"aps","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Prometheus Service","serviceId":"amp","signatureVersion":"v4","signingName":"aps","uid":"amp-2020-08-01"},"operations":{"CreateAlertManagerDefinition":{"http":{"requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":202},"input":{"type":"structure","required":["data","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"S6"}}},"idempotent":true},"CreateLoggingConfiguration":{"http":{"requestUri":"/workspaces/{workspaceId}/logging","responseCode":202},"input":{"type":"structure","required":["logGroupArn","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"logGroupArn":{},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"Sc"}}},"idempotent":true},"CreateRuleGroupsNamespace":{"http":{"requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces","responseCode":202},"input":{"type":"structure","required":["data","name","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"name":{},"tags":{"shape":"Sh"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","name","status"],"members":{"arn":{},"name":{},"status":{"shape":"Sm"},"tags":{"shape":"Sh"}}},"idempotent":true},"CreateScraper":{"http":{"requestUri":"/scrapers","responseCode":202},"input":{"type":"structure","required":["destination","scrapeConfiguration","source"],"members":{"alias":{},"clientToken":{"idempotencyToken":true},"destination":{"shape":"Sq"},"scrapeConfiguration":{"shape":"St"},"source":{"shape":"Sv"},"tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["arn","scraperId","status"],"members":{"arn":{},"scraperId":{},"status":{"shape":"S15"},"tags":{"shape":"Sh"}}},"idempotent":true},"CreateWorkspace":{"http":{"requestUri":"/workspaces","responseCode":202},"input":{"type":"structure","members":{"alias":{},"clientToken":{"idempotencyToken":true},"kmsKeyArn":{},"tags":{"shape":"Sh"}}},"output":{"type":"structure","required":["arn","status","workspaceId"],"members":{"arn":{},"kmsKeyArn":{},"status":{"shape":"S1b"},"tags":{"shape":"Sh"},"workspaceId":{}}},"idempotent":true},"DeleteAlertManagerDefinition":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":202},"input":{"type":"structure","required":["workspaceId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true},"DeleteLoggingConfiguration":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/logging","responseCode":202},"input":{"type":"structure","required":["workspaceId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true},"DeleteRuleGroupsNamespace":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces/{name}","responseCode":202},"input":{"type":"structure","required":["name","workspaceId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"name":{"location":"uri","locationName":"name"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true},"DeleteScraper":{"http":{"method":"DELETE","requestUri":"/scrapers/{scraperId}","responseCode":202},"input":{"type":"structure","required":["scraperId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"scraperId":{"location":"uri","locationName":"scraperId"}}},"output":{"type":"structure","required":["scraperId","status"],"members":{"scraperId":{},"status":{"shape":"S15"}}},"idempotent":true},"DeleteWorkspace":{"http":{"method":"DELETE","requestUri":"/workspaces/{workspaceId}","responseCode":202},"input":{"type":"structure","required":["workspaceId"],"members":{"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true},"DescribeAlertManagerDefinition":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["alertManagerDefinition"],"members":{"alertManagerDefinition":{"type":"structure","required":["createdAt","data","modifiedAt","status"],"members":{"createdAt":{"type":"timestamp"},"data":{"type":"blob"},"modifiedAt":{"type":"timestamp"},"status":{"shape":"S6"}}}}}},"DescribeLoggingConfiguration":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/logging","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["loggingConfiguration"],"members":{"loggingConfiguration":{"type":"structure","required":["createdAt","logGroupArn","modifiedAt","status","workspace"],"members":{"createdAt":{"type":"timestamp"},"logGroupArn":{},"modifiedAt":{"type":"timestamp"},"status":{"shape":"Sc"},"workspace":{}}}}}},"DescribeRuleGroupsNamespace":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces/{name}","responseCode":200},"input":{"type":"structure","required":["name","workspaceId"],"members":{"name":{"location":"uri","locationName":"name"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["ruleGroupsNamespace"],"members":{"ruleGroupsNamespace":{"type":"structure","required":["arn","createdAt","data","modifiedAt","name","status"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"data":{"type":"blob"},"modifiedAt":{"type":"timestamp"},"name":{},"status":{"shape":"Sm"},"tags":{"shape":"Sh"}}}}}},"DescribeScraper":{"http":{"method":"GET","requestUri":"/scrapers/{scraperId}","responseCode":200},"input":{"type":"structure","required":["scraperId"],"members":{"scraperId":{"location":"uri","locationName":"scraperId"}}},"output":{"type":"structure","required":["scraper"],"members":{"scraper":{"type":"structure","required":["arn","createdAt","destination","lastModifiedAt","roleArn","scrapeConfiguration","scraperId","source","status"],"members":{"alias":{},"arn":{},"createdAt":{"type":"timestamp"},"destination":{"shape":"Sq"},"lastModifiedAt":{"type":"timestamp"},"roleArn":{},"scrapeConfiguration":{"shape":"St"},"scraperId":{},"source":{"shape":"Sv"},"status":{"shape":"S15"},"statusReason":{},"tags":{"shape":"Sh"}}}}}},"DescribeWorkspace":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["workspace"],"members":{"workspace":{"type":"structure","required":["arn","createdAt","status","workspaceId"],"members":{"alias":{},"arn":{},"createdAt":{"type":"timestamp"},"kmsKeyArn":{},"prometheusEndpoint":{},"status":{"shape":"S1b"},"tags":{"shape":"Sh"},"workspaceId":{}}}}}},"GetDefaultScraperConfiguration":{"http":{"method":"GET","requestUri":"/scraperconfiguration","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["configuration"],"members":{"configuration":{"type":"blob"}}}},"ListRuleGroupsNamespaces":{"http":{"method":"GET","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces","responseCode":200},"input":{"type":"structure","required":["workspaceId"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"name":{"location":"querystring","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["ruleGroupsNamespaces"],"members":{"nextToken":{},"ruleGroupsNamespaces":{"type":"list","member":{"type":"structure","required":["arn","createdAt","modifiedAt","name","status"],"members":{"arn":{},"createdAt":{"type":"timestamp"},"modifiedAt":{"type":"timestamp"},"name":{},"status":{"shape":"Sm"},"tags":{"shape":"Sh"}}}}}}},"ListScrapers":{"http":{"method":"GET","requestUri":"/scrapers","responseCode":200},"input":{"type":"structure","members":{"filters":{"location":"querystring","type":"map","key":{},"value":{"type":"list","member":{}}},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["scrapers"],"members":{"nextToken":{},"scrapers":{"type":"list","member":{"type":"structure","required":["arn","createdAt","destination","lastModifiedAt","roleArn","scraperId","source","status"],"members":{"alias":{},"arn":{},"createdAt":{"type":"timestamp"},"destination":{"shape":"Sq"},"lastModifiedAt":{"type":"timestamp"},"roleArn":{},"scraperId":{},"source":{"shape":"Sv"},"status":{"shape":"S15"},"statusReason":{},"tags":{"shape":"Sh"}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sh"}}}},"ListWorkspaces":{"http":{"method":"GET","requestUri":"/workspaces","responseCode":200},"input":{"type":"structure","members":{"alias":{"location":"querystring","locationName":"alias"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["workspaces"],"members":{"nextToken":{},"workspaces":{"type":"list","member":{"type":"structure","required":["arn","createdAt","status","workspaceId"],"members":{"alias":{},"arn":{},"createdAt":{"type":"timestamp"},"kmsKeyArn":{},"status":{"shape":"S1b"},"tags":{"shape":"Sh"},"workspaceId":{}}}}}}},"PutAlertManagerDefinition":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/alertmanager/definition","responseCode":202},"input":{"type":"structure","required":["data","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"S6"}}},"idempotent":true},"PutRuleGroupsNamespace":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/rulegroupsnamespaces/{name}","responseCode":202},"input":{"type":"structure","required":["data","name","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"data":{"type":"blob"},"name":{"location":"uri","locationName":"name"},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["arn","name","status"],"members":{"arn":{},"name":{},"status":{"shape":"Sm"},"tags":{"shape":"Sh"}}},"idempotent":true},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateLoggingConfiguration":{"http":{"method":"PUT","requestUri":"/workspaces/{workspaceId}/logging","responseCode":202},"input":{"type":"structure","required":["logGroupArn","workspaceId"],"members":{"clientToken":{"idempotencyToken":true},"logGroupArn":{},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"output":{"type":"structure","required":["status"],"members":{"status":{"shape":"Sc"}}},"idempotent":true},"UpdateWorkspaceAlias":{"http":{"requestUri":"/workspaces/{workspaceId}/alias","responseCode":204},"input":{"type":"structure","required":["workspaceId"],"members":{"alias":{},"clientToken":{"idempotencyToken":true},"workspaceId":{"location":"uri","locationName":"workspaceId"}}},"idempotent":true}},"shapes":{"S6":{"type":"structure","required":["statusCode"],"members":{"statusCode":{},"statusReason":{}}},"Sc":{"type":"structure","required":["statusCode"],"members":{"statusCode":{},"statusReason":{}}},"Sh":{"type":"map","key":{},"value":{}},"Sm":{"type":"structure","required":["statusCode"],"members":{"statusCode":{},"statusReason":{}}},"Sq":{"type":"structure","members":{"ampConfiguration":{"type":"structure","required":["workspaceArn"],"members":{"workspaceArn":{}}}},"union":true},"St":{"type":"structure","members":{"configurationBlob":{"type":"blob"}},"union":true},"Sv":{"type":"structure","members":{"eksConfiguration":{"type":"structure","required":["clusterArn","subnetIds"],"members":{"clusterArn":{},"securityGroupIds":{"type":"list","member":{}},"subnetIds":{"type":"list","member":{}}}}},"union":true},"S15":{"type":"structure","required":["statusCode"],"members":{"statusCode":{}}},"S1b":{"type":"structure","required":["statusCode"],"members":{"statusCode":{}}}}}

/***/ }),
/* 398 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListRuleGroupsNamespaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"ruleGroupsNamespaces"},"ListScrapers":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"scrapers"},"ListWorkspaces":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"workspaces"}}}

/***/ }),
/* 399 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ScraperActive":{"description":"Wait until a scraper reaches ACTIVE status","delay":2,"maxAttempts":60,"operation":"DescribeScraper","acceptors":[{"matcher":"path","argument":"scraper.status.statusCode","state":"success","expected":"ACTIVE"},{"matcher":"path","argument":"scraper.status.statusCode","state":"failure","expected":"CREATION_FAILED"}]},"ScraperDeleted":{"description":"Wait until a scraper reaches DELETED status","delay":2,"maxAttempts":60,"operation":"DescribeScraper","acceptors":[{"matcher":"error","state":"success","expected":"ResourceNotFoundException"},{"matcher":"path","argument":"scraper.status.statusCode","state":"failure","expected":"DELETION_FAILED"}]},"WorkspaceActive":{"description":"Wait until a workspace reaches ACTIVE status","delay":2,"maxAttempts":60,"operation":"DescribeWorkspace","acceptors":[{"matcher":"path","argument":"workspace.status.statusCode","state":"success","expected":"ACTIVE"},{"matcher":"path","argument":"workspace.status.statusCode","state":"retry","expected":"UPDATING"},{"matcher":"path","argument":"workspace.status.statusCode","state":"retry","expected":"CREATING"}]},"WorkspaceDeleted":{"description":"Wait until a workspace reaches DELETED status","delay":2,"maxAttempts":60,"operation":"DescribeWorkspace","acceptors":[{"matcher":"error","state":"success","expected":"ResourceNotFoundException"},{"matcher":"path","argument":"workspace.status.statusCode","state":"retry","expected":"DELETING"}]}}}

/***/ }),
/* 400 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"apigateway","protocol":"rest-json","serviceFullName":"Amazon API Gateway","serviceId":"API Gateway","signatureVersion":"v4","uid":"apigateway-2015-07-09"},"operations":{"CreateApiKey":{"http":{"requestUri":"/apikeys","responseCode":201},"input":{"type":"structure","members":{"name":{},"description":{},"enabled":{"type":"boolean"},"generateDistinctId":{"type":"boolean"},"value":{},"stageKeys":{"type":"list","member":{"type":"structure","members":{"restApiId":{},"stageName":{}}}},"customerId":{},"tags":{"shape":"S6"}}},"output":{"shape":"S7"}},"CreateAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers","responseCode":201},"input":{"type":"structure","required":["restApiId","name","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"output":{"shape":"Sf"}},"CreateBasePathMapping":{"http":{"requestUri":"/domainnames/{domain_name}/basepathmappings","responseCode":201},"input":{"type":"structure","required":["domainName","restApiId"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{},"restApiId":{},"stage":{}}},"output":{"shape":"Sh"}},"CreateDeployment":{"http":{"requestUri":"/restapis/{restapi_id}/deployments","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"stageDescription":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"canarySettings":{"type":"structure","members":{"percentTraffic":{"type":"double"},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"tracingEnabled":{"type":"boolean"}}},"output":{"shape":"Sn"}},"CreateDocumentationPart":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/parts","responseCode":201},"input":{"type":"structure","required":["restApiId","location","properties"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"location":{"shape":"Ss"},"properties":{}}},"output":{"shape":"Sv"}},"CreateDocumentationVersion":{"http":{"requestUri":"/restapis/{restapi_id}/documentation/versions","responseCode":201},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{},"stageName":{},"description":{}}},"output":{"shape":"Sx"}},"CreateDomainName":{"http":{"requestUri":"/domainnames","responseCode":201},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{},"certificateName":{},"certificateBody":{},"certificatePrivateKey":{},"certificateChain":{},"certificateArn":{},"regionalCertificateName":{},"regionalCertificateArn":{},"endpointConfiguration":{"shape":"Sz"},"tags":{"shape":"S6"},"securityPolicy":{},"mutualTlsAuthentication":{"type":"structure","members":{"truststoreUri":{},"truststoreVersion":{}}},"ownershipVerificationCertificateArn":{}}},"output":{"shape":"S14"}},"CreateModel":{"http":{"requestUri":"/restapis/{restapi_id}/models","responseCode":201},"input":{"type":"structure","required":["restApiId","name","contentType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"description":{},"schema":{},"contentType":{}}},"output":{"shape":"S18"}},"CreateRequestValidator":{"http":{"requestUri":"/restapis/{restapi_id}/requestvalidators","responseCode":201},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"output":{"shape":"S1a"}},"CreateResource":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{parent_id}","responseCode":201},"input":{"type":"structure","required":["restApiId","parentId","pathPart"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"parentId":{"location":"uri","locationName":"parent_id"},"pathPart":{}}},"output":{"shape":"S1c"}},"CreateRestApi":{"http":{"requestUri":"/restapis","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"version":{},"cloneFrom":{},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"},"disableExecuteApiEndpoint":{"type":"boolean"}}},"output":{"shape":"S1t"}},"CreateStage":{"http":{"requestUri":"/restapis/{restapi_id}/stages","responseCode":201},"input":{"type":"structure","required":["restApiId","stageName","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{},"deploymentId":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"variables":{"shape":"S6"},"documentationVersion":{},"canarySettings":{"shape":"S1v"},"tracingEnabled":{"type":"boolean"},"tags":{"shape":"S6"}}},"output":{"shape":"S1w"}},"CreateUsagePlan":{"http":{"requestUri":"/usageplans","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"apiStages":{"shape":"S23"},"throttle":{"shape":"S26"},"quota":{"shape":"S27"},"tags":{"shape":"S6"}}},"output":{"shape":"S29"}},"CreateUsagePlanKey":{"http":{"requestUri":"/usageplans/{usageplanId}/keys","responseCode":201},"input":{"type":"structure","required":["usagePlanId","keyId","keyType"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{},"keyType":{}}},"output":{"shape":"S2b"}},"CreateVpcLink":{"http":{"requestUri":"/vpclinks","responseCode":202},"input":{"type":"structure","required":["name","targetArns"],"members":{"name":{},"description":{},"targetArns":{"shape":"S9"},"tags":{"shape":"S6"}}},"output":{"shape":"S2d"}},"DeleteApiKey":{"http":{"method":"DELETE","requestUri":"/apikeys/{api_Key}","responseCode":202},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"}}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}}},"DeleteBasePathMapping":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}","responseCode":202},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}}},"DeleteClientCertificate":{"http":{"method":"DELETE","requestUri":"/clientcertificates/{clientcertificate_id}","responseCode":202},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}}},"DeleteDeployment":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"}}}},"DeleteDocumentationPart":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}}},"DeleteDocumentationVersion":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}","responseCode":202},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}}},"DeleteDomainName":{"http":{"method":"DELETE","requestUri":"/domainnames/{domain_name}","responseCode":202},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}}},"DeleteGatewayResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":202},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}}},"DeleteIntegration":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteIntegrationResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteMethod":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}}},"DeleteMethodResponse":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":204},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}}},"DeleteModel":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/models/{model_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}}},"DeleteRequestValidator":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}}},"DeleteResource":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/resources/{resource_id}","responseCode":202},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"}}}},"DeleteRestApi":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}","responseCode":202},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}}},"DeleteStage":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"DeleteUsagePlan":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}}},"DeleteUsagePlanKey":{"http":{"method":"DELETE","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":202},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}}},"DeleteVpcLink":{"http":{"method":"DELETE","requestUri":"/vpclinks/{vpclink_id}","responseCode":202},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}}},"FlushStageAuthorizersCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/authorizers","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"FlushStageCache":{"http":{"method":"DELETE","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/cache/data","responseCode":202},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}}},"GenerateClientCertificate":{"http":{"requestUri":"/clientcertificates","responseCode":201},"input":{"type":"structure","members":{"description":{},"tags":{"shape":"S6"}}},"output":{"shape":"S34"}},"GetAccount":{"http":{"method":"GET","requestUri":"/account"},"input":{"type":"structure","members":{}},"output":{"shape":"S36"}},"GetApiKey":{"http":{"method":"GET","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"includeValue":{"location":"querystring","locationName":"includeValue","type":"boolean"}}},"output":{"shape":"S7"}},"GetApiKeys":{"http":{"method":"GET","requestUri":"/apikeys"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"},"customerId":{"location":"querystring","locationName":"customerId"},"includeValues":{"location":"querystring","locationName":"includeValues","type":"boolean"}}},"output":{"type":"structure","members":{"warnings":{"shape":"S9"},"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S7"}}}}},"GetAuthorizer":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"}}},"output":{"shape":"Sf"}},"GetAuthorizers":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/authorizers"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sf"}}}}},"GetBasePathMapping":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"}}},"output":{"shape":"Sh"}},"GetBasePathMappings":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}/basepathmappings"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sh"}}}}},"GetClientCertificate":{"http":{"method":"GET","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"}}},"output":{"shape":"S34"}},"GetClientCertificates":{"http":{"method":"GET","requestUri":"/clientcertificates"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S34"}}}}},"GetDeployment":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"Sn"}},"GetDeployments":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/deployments"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sn"}}}}},"GetDocumentationPart":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"}}},"output":{"shape":"Sv"}},"GetDocumentationParts":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"type":{"location":"querystring","locationName":"type"},"nameQuery":{"location":"querystring","locationName":"name"},"path":{"location":"querystring","locationName":"path"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"locationStatus":{"location":"querystring","locationName":"locationStatus"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sv"}}}}},"GetDocumentationVersion":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"}}},"output":{"shape":"Sx"}},"GetDocumentationVersions":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/documentation/versions"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"Sx"}}}}},"GetDomainName":{"http":{"method":"GET","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"}}},"output":{"shape":"S14"}},"GetDomainNames":{"http":{"method":"GET","requestUri":"/domainnames"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S14"}}}}},"GetExport":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/exports/{export_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","exportType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"exportType":{"location":"uri","locationName":"export_type"},"parameters":{"shape":"S6","location":"querystring"},"accepts":{"location":"header","locationName":"Accept"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetGatewayResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"}}},"output":{"shape":"S48"}},"GetGatewayResponses":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/gatewayresponses"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S48"}}}}},"GetIntegration":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1j"}},"GetIntegrationResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1p"}},"GetMethod":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"}}},"output":{"shape":"S1e"}},"GetMethodResponse":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"}}},"output":{"shape":"S1h"}},"GetModel":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"flatten":{"location":"querystring","locationName":"flatten","type":"boolean"}}},"output":{"shape":"S18"}},"GetModelTemplate":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models/{model_name}/default_template"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"}}},"output":{"type":"structure","members":{"value":{}}}},"GetModels":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/models"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S18"}}}}},"GetRequestValidator":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"}}},"output":{"shape":"S1a"}},"GetRequestValidators":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/requestvalidators"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1a"}}}}},"GetResource":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"shape":"S1c"}},"GetResources":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/resources"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"embed":{"shape":"S9","location":"querystring","locationName":"embed"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1c"}}}}},"GetRestApi":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"}}},"output":{"shape":"S1t"}},"GetRestApis":{"http":{"method":"GET","requestUri":"/restapis"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S1t"}}}}},"GetSdk":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}/sdks/{sdk_type}","responseCode":200},"input":{"type":"structure","required":["restApiId","stageName","sdkType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"sdkType":{"location":"uri","locationName":"sdk_type"},"parameters":{"shape":"S6","location":"querystring"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"contentDisposition":{"location":"header","locationName":"Content-Disposition"},"body":{"type":"blob"}},"payload":"body"}},"GetSdkType":{"http":{"method":"GET","requestUri":"/sdktypes/{sdktype_id}"},"input":{"type":"structure","required":["id"],"members":{"id":{"location":"uri","locationName":"sdktype_id"}}},"output":{"shape":"S51"}},"GetSdkTypes":{"http":{"method":"GET","requestUri":"/sdktypes"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S51"}}}}},"GetStage":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"}}},"output":{"shape":"S1w"}},"GetStages":{"http":{"method":"GET","requestUri":"/restapis/{restapi_id}/stages"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"querystring","locationName":"deploymentId"}}},"output":{"type":"structure","members":{"item":{"type":"list","member":{"shape":"S1w"}}}}},"GetTags":{"http":{"method":"GET","requestUri":"/tags/{resource_arn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"S6"}}}},"GetUsage":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/usage"},"input":{"type":"structure","required":["usagePlanId","startDate","endDate"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"querystring","locationName":"keyId"},"startDate":{"location":"querystring","locationName":"startDate"},"endDate":{"location":"querystring","locationName":"endDate"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"shape":"S5e"}},"GetUsagePlan":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"}}},"output":{"shape":"S29"}},"GetUsagePlanKey":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys/{keyId}","responseCode":200},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"}}},"output":{"shape":"S2b"}},"GetUsagePlanKeys":{"http":{"method":"GET","requestUri":"/usageplans/{usageplanId}/keys"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"},"nameQuery":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2b"}}}}},"GetUsagePlans":{"http":{"method":"GET","requestUri":"/usageplans"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"keyId":{"location":"querystring","locationName":"keyId"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S29"}}}}},"GetVpcLink":{"http":{"method":"GET","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"}}},"output":{"shape":"S2d"}},"GetVpcLinks":{"http":{"method":"GET","requestUri":"/vpclinks"},"input":{"type":"structure","members":{"position":{"location":"querystring","locationName":"position"},"limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"position":{},"items":{"locationName":"item","type":"list","member":{"shape":"S2d"}}}}},"ImportApiKeys":{"http":{"requestUri":"/apikeys?mode=import","responseCode":201},"input":{"type":"structure","required":["body","format"],"members":{"body":{"type":"blob"},"format":{"location":"querystring","locationName":"format"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportDocumentationParts":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/documentation/parts"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"body":{"type":"blob"}},"payload":"body"},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"warnings":{"shape":"S9"}}}},"ImportRestApi":{"http":{"requestUri":"/restapis?mode=import","responseCode":201},"input":{"type":"structure","required":["body"],"members":{"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1t"}},"PutGatewayResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}","responseCode":201},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"}}},"output":{"shape":"S48"}},"PutIntegration":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","type"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"type":{},"integrationHttpMethod":{"locationName":"httpMethod"},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"tlsConfig":{"shape":"S1q"}}},"output":{"shape":"S1j"}},"PutIntegrationResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"output":{"shape":"S1p"}},"PutMethod":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","authorizationType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"operationName":{},"requestParameters":{"shape":"S1f"},"requestModels":{"shape":"S6"},"requestValidatorId":{},"authorizationScopes":{"shape":"S9"}}},"output":{"shape":"S1e"}},"PutMethodResponse":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"responseParameters":{"shape":"S1f"},"responseModels":{"shape":"S6"}}},"output":{"shape":"S1h"}},"PutRestApi":{"http":{"method":"PUT","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId","body"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"mode":{"location":"querystring","locationName":"mode"},"failOnWarnings":{"location":"querystring","locationName":"failonwarnings","type":"boolean"},"parameters":{"shape":"S6","location":"querystring"},"body":{"type":"blob"}},"payload":"body"},"output":{"shape":"S1t"}},"TagResource":{"http":{"method":"PUT","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tags":{"shape":"S6"}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S6a"},"pathWithQueryString":{},"body":{},"stageVariables":{"shape":"S6"},"additionalContext":{"shape":"S6"}}},"output":{"type":"structure","members":{"clientStatus":{"type":"integer"},"log":{},"latency":{"type":"long"},"principalId":{},"policy":{},"authorization":{"shape":"S6a"},"claims":{"shape":"S6"}}}},"TestInvokeMethod":{"http":{"requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"pathWithQueryString":{},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S6a"},"clientCertificateId":{},"stageVariables":{"shape":"S6"}}},"output":{"type":"structure","members":{"status":{"type":"integer"},"body":{},"headers":{"shape":"S6"},"multiValueHeaders":{"shape":"S6a"},"log":{},"latency":{"type":"long"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resource_arn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resource_arn"},"tagKeys":{"shape":"S9","location":"querystring","locationName":"tagKeys"}}}},"UpdateAccount":{"http":{"method":"PATCH","requestUri":"/account"},"input":{"type":"structure","members":{"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S36"}},"UpdateApiKey":{"http":{"method":"PATCH","requestUri":"/apikeys/{api_Key}"},"input":{"type":"structure","required":["apiKey"],"members":{"apiKey":{"location":"uri","locationName":"api_Key"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S7"}},"UpdateAuthorizer":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/authorizers/{authorizer_id}"},"input":{"type":"structure","required":["restApiId","authorizerId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"authorizerId":{"location":"uri","locationName":"authorizer_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sf"}},"UpdateBasePathMapping":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}/basepathmappings/{base_path}"},"input":{"type":"structure","required":["domainName","basePath"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"basePath":{"location":"uri","locationName":"base_path"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sh"}},"UpdateClientCertificate":{"http":{"method":"PATCH","requestUri":"/clientcertificates/{clientcertificate_id}"},"input":{"type":"structure","required":["clientCertificateId"],"members":{"clientCertificateId":{"location":"uri","locationName":"clientcertificate_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S34"}},"UpdateDeployment":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/deployments/{deployment_id}"},"input":{"type":"structure","required":["restApiId","deploymentId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"deploymentId":{"location":"uri","locationName":"deployment_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sn"}},"UpdateDocumentationPart":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/parts/{part_id}"},"input":{"type":"structure","required":["restApiId","documentationPartId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationPartId":{"location":"uri","locationName":"part_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sv"}},"UpdateDocumentationVersion":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/documentation/versions/{doc_version}"},"input":{"type":"structure","required":["restApiId","documentationVersion"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"documentationVersion":{"location":"uri","locationName":"doc_version"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"Sx"}},"UpdateDomainName":{"http":{"method":"PATCH","requestUri":"/domainnames/{domain_name}"},"input":{"type":"structure","required":["domainName"],"members":{"domainName":{"location":"uri","locationName":"domain_name"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S14"}},"UpdateGatewayResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/gatewayresponses/{response_type}"},"input":{"type":"structure","required":["restApiId","responseType"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"responseType":{"location":"uri","locationName":"response_type"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S48"}},"UpdateIntegration":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1j"}},"UpdateIntegrationResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/integration/responses/{status_code}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1p"}},"UpdateMethod":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}"},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1e"}},"UpdateMethodResponse":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}/methods/{http_method}/responses/{status_code}","responseCode":201},"input":{"type":"structure","required":["restApiId","resourceId","httpMethod","statusCode"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"httpMethod":{"location":"uri","locationName":"http_method"},"statusCode":{"location":"uri","locationName":"status_code"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1h"}},"UpdateModel":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/models/{model_name}"},"input":{"type":"structure","required":["restApiId","modelName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"modelName":{"location":"uri","locationName":"model_name"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S18"}},"UpdateRequestValidator":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/requestvalidators/{requestvalidator_id}"},"input":{"type":"structure","required":["restApiId","requestValidatorId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"requestValidatorId":{"location":"uri","locationName":"requestvalidator_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1a"}},"UpdateResource":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/resources/{resource_id}"},"input":{"type":"structure","required":["restApiId","resourceId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"resourceId":{"location":"uri","locationName":"resource_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1c"}},"UpdateRestApi":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}"},"input":{"type":"structure","required":["restApiId"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1t"}},"UpdateStage":{"http":{"method":"PATCH","requestUri":"/restapis/{restapi_id}/stages/{stage_name}"},"input":{"type":"structure","required":["restApiId","stageName"],"members":{"restApiId":{"location":"uri","locationName":"restapi_id"},"stageName":{"location":"uri","locationName":"stage_name"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S1w"}},"UpdateUsage":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}/keys/{keyId}/usage"},"input":{"type":"structure","required":["usagePlanId","keyId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"keyId":{"location":"uri","locationName":"keyId"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S5e"}},"UpdateUsagePlan":{"http":{"method":"PATCH","requestUri":"/usageplans/{usageplanId}"},"input":{"type":"structure","required":["usagePlanId"],"members":{"usagePlanId":{"location":"uri","locationName":"usageplanId"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S29"}},"UpdateVpcLink":{"http":{"method":"PATCH","requestUri":"/vpclinks/{vpclink_id}"},"input":{"type":"structure","required":["vpcLinkId"],"members":{"vpcLinkId":{"location":"uri","locationName":"vpclink_id"},"patchOperations":{"shape":"S6g"}}},"output":{"shape":"S2d"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"id":{},"value":{},"name":{},"customerId":{},"description":{},"enabled":{"type":"boolean"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"},"stageKeys":{"shape":"S9"},"tags":{"shape":"S6"}}},"S9":{"type":"list","member":{}},"Sc":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"id":{},"name":{},"type":{},"providerARNs":{"shape":"Sc"},"authType":{},"authorizerUri":{},"authorizerCredentials":{},"identitySource":{},"identityValidationExpression":{},"authorizerResultTtlInSeconds":{"type":"integer"}}},"Sh":{"type":"structure","members":{"basePath":{},"restApiId":{},"stage":{}}},"Sn":{"type":"structure","members":{"id":{},"description":{},"createdDate":{"type":"timestamp"},"apiSummary":{"type":"map","key":{},"value":{"type":"map","key":{},"value":{"type":"structure","members":{"authorizationType":{},"apiKeyRequired":{"type":"boolean"}}}}}}},"Ss":{"type":"structure","required":["type"],"members":{"type":{},"path":{},"method":{},"statusCode":{},"name":{}}},"Sv":{"type":"structure","members":{"id":{},"location":{"shape":"Ss"},"properties":{}}},"Sx":{"type":"structure","members":{"version":{},"createdDate":{"type":"timestamp"},"description":{}}},"Sz":{"type":"structure","members":{"types":{"type":"list","member":{}},"vpcEndpointIds":{"shape":"S9"}}},"S14":{"type":"structure","members":{"domainName":{},"certificateName":{},"certificateArn":{},"certificateUploadDate":{"type":"timestamp"},"regionalDomainName":{},"regionalHostedZoneId":{},"regionalCertificateName":{},"regionalCertificateArn":{},"distributionDomainName":{},"distributionHostedZoneId":{},"endpointConfiguration":{"shape":"Sz"},"domainNameStatus":{},"domainNameStatusMessage":{},"securityPolicy":{},"tags":{"shape":"S6"},"mutualTlsAuthentication":{"type":"structure","members":{"truststoreUri":{},"truststoreVersion":{},"truststoreWarnings":{"shape":"S9"}}},"ownershipVerificationCertificateArn":{}}},"S18":{"type":"structure","members":{"id":{},"name":{},"description":{},"schema":{},"contentType":{}}},"S1a":{"type":"structure","members":{"id":{},"name":{},"validateRequestBody":{"type":"boolean"},"validateRequestParameters":{"type":"boolean"}}},"S1c":{"type":"structure","members":{"id":{},"parentId":{},"pathPart":{},"path":{},"resourceMethods":{"type":"map","key":{},"value":{"shape":"S1e"}}}},"S1e":{"type":"structure","members":{"httpMethod":{},"authorizationType":{},"authorizerId":{},"apiKeyRequired":{"type":"boolean"},"requestValidatorId":{},"operationName":{},"requestParameters":{"shape":"S1f"},"requestModels":{"shape":"S6"},"methodResponses":{"type":"map","key":{},"value":{"shape":"S1h"}},"methodIntegration":{"shape":"S1j"},"authorizationScopes":{"shape":"S9"}}},"S1f":{"type":"map","key":{},"value":{"type":"boolean"}},"S1h":{"type":"structure","members":{"statusCode":{},"responseParameters":{"shape":"S1f"},"responseModels":{"shape":"S6"}}},"S1j":{"type":"structure","members":{"type":{},"httpMethod":{},"uri":{},"connectionType":{},"connectionId":{},"credentials":{},"requestParameters":{"shape":"S6"},"requestTemplates":{"shape":"S6"},"passthroughBehavior":{},"contentHandling":{},"timeoutInMillis":{"type":"integer"},"cacheNamespace":{},"cacheKeyParameters":{"shape":"S9"},"integrationResponses":{"type":"map","key":{},"value":{"shape":"S1p"}},"tlsConfig":{"shape":"S1q"}}},"S1p":{"type":"structure","members":{"statusCode":{},"selectionPattern":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"contentHandling":{}}},"S1q":{"type":"structure","members":{"insecureSkipVerification":{"type":"boolean"}}},"S1t":{"type":"structure","members":{"id":{},"name":{},"description":{},"createdDate":{"type":"timestamp"},"version":{},"warnings":{"shape":"S9"},"binaryMediaTypes":{"shape":"S9"},"minimumCompressionSize":{"type":"integer"},"apiKeySource":{},"endpointConfiguration":{"shape":"Sz"},"policy":{},"tags":{"shape":"S6"},"disableExecuteApiEndpoint":{"type":"boolean"},"rootResourceId":{}}},"S1v":{"type":"structure","members":{"percentTraffic":{"type":"double"},"deploymentId":{},"stageVariableOverrides":{"shape":"S6"},"useStageCache":{"type":"boolean"}}},"S1w":{"type":"structure","members":{"deploymentId":{},"clientCertificateId":{},"stageName":{},"description":{},"cacheClusterEnabled":{"type":"boolean"},"cacheClusterSize":{},"cacheClusterStatus":{},"methodSettings":{"type":"map","key":{},"value":{"type":"structure","members":{"metricsEnabled":{"type":"boolean"},"loggingLevel":{},"dataTraceEnabled":{"type":"boolean"},"throttlingBurstLimit":{"type":"integer"},"throttlingRateLimit":{"type":"double"},"cachingEnabled":{"type":"boolean"},"cacheTtlInSeconds":{"type":"integer"},"cacheDataEncrypted":{"type":"boolean"},"requireAuthorizationForCacheControl":{"type":"boolean"},"unauthorizedCacheControlHeaderStrategy":{}}}},"variables":{"shape":"S6"},"documentationVersion":{},"accessLogSettings":{"type":"structure","members":{"format":{},"destinationArn":{}}},"canarySettings":{"shape":"S1v"},"tracingEnabled":{"type":"boolean"},"webAclArn":{},"tags":{"shape":"S6"},"createdDate":{"type":"timestamp"},"lastUpdatedDate":{"type":"timestamp"}}},"S23":{"type":"list","member":{"type":"structure","members":{"apiId":{},"stage":{},"throttle":{"type":"map","key":{},"value":{"shape":"S26"}}}}},"S26":{"type":"structure","members":{"burstLimit":{"type":"integer"},"rateLimit":{"type":"double"}}},"S27":{"type":"structure","members":{"limit":{"type":"integer"},"offset":{"type":"integer"},"period":{}}},"S29":{"type":"structure","members":{"id":{},"name":{},"description":{},"apiStages":{"shape":"S23"},"throttle":{"shape":"S26"},"quota":{"shape":"S27"},"productCode":{},"tags":{"shape":"S6"}}},"S2b":{"type":"structure","members":{"id":{},"type":{},"value":{},"name":{}}},"S2d":{"type":"structure","members":{"id":{},"name":{},"description":{},"targetArns":{"shape":"S9"},"status":{},"statusMessage":{},"tags":{"shape":"S6"}}},"S34":{"type":"structure","members":{"clientCertificateId":{},"description":{},"pemEncodedCertificate":{},"createdDate":{"type":"timestamp"},"expirationDate":{"type":"timestamp"},"tags":{"shape":"S6"}}},"S36":{"type":"structure","members":{"cloudwatchRoleArn":{},"throttleSettings":{"shape":"S26"},"features":{"shape":"S9"},"apiKeyVersion":{}}},"S48":{"type":"structure","members":{"responseType":{},"statusCode":{},"responseParameters":{"shape":"S6"},"responseTemplates":{"shape":"S6"},"defaultResponse":{"type":"boolean"}}},"S51":{"type":"structure","members":{"id":{},"friendlyName":{},"description":{},"configurationProperties":{"type":"list","member":{"type":"structure","members":{"name":{},"friendlyName":{},"description":{},"required":{"type":"boolean"},"defaultValue":{}}}}}},"S5e":{"type":"structure","members":{"usagePlanId":{},"startDate":{},"endDate":{},"position":{},"items":{"locationName":"values","type":"map","key":{},"value":{"type":"list","member":{"type":"list","member":{"type":"long"}}}}}},"S6a":{"type":"map","key":{},"value":{"shape":"S9"}},"S6g":{"type":"list","member":{"type":"structure","members":{"op":{},"path":{},"value":{},"from":{}}}}}}

/***/ }),
/* 401 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetApiKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetBasePathMappings":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetClientCertificates":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDeployments":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetDomainNames":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetModels":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetResources":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetRestApis":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsage":{"input_token":"position","limit_key":"limit","non_aggregate_keys":["usagePlanId","startDate","endDate"],"output_token":"position","result_key":"items"},"GetUsagePlanKeys":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetUsagePlans":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"},"GetVpcLinks":{"input_token":"position","limit_key":"limit","output_token":"position","result_key":"items"}}}

/***/ }),
/* 402 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-06","endpointPrefix":"application-autoscaling","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceFullName":"Application Auto Scaling","serviceId":"Application Auto Scaling","signatureVersion":"v4","signingName":"application-autoscaling","targetPrefix":"AnyScaleFrontendService","uid":"application-autoscaling-2016-02-06"},"operations":{"DeleteScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DeregisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{}}},"output":{"type":"structure","members":{}}},"DescribeScalableTargets":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceIds":{"shape":"Sb"},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalableTargets":{"type":"list","member":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension","MinCapacity","MaxCapacity","RoleARN","CreationTime"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"CreationTime":{"type":"timestamp"},"SuspendedState":{"shape":"Sj"},"ScalableTargetARN":{}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{},"IncludeNotScaledActivities":{"type":"boolean"}}},"output":{"type":"structure","members":{"ScalingActivities":{"type":"list","member":{"type":"structure","required":["ActivityId","ServiceNamespace","ResourceId","ScalableDimension","Description","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Details":{},"NotScaledReasons":{"type":"list","member":{"type":"structure","required":["Code"],"members":{"Code":{},"MaxCapacity":{"type":"integer"},"MinCapacity":{"type":"integer"},"CurrentCapacity":{"type":"integer"}}}}}}},"NextToken":{}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"PolicyNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","required":["PolicyARN","PolicyName","ServiceNamespace","ResourceId","ScalableDimension","PolicyType","CreationTime"],"members":{"PolicyARN":{},"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"S10"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S19"},"Alarms":{"shape":"S21"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeScheduledActions":{"input":{"type":"structure","required":["ServiceNamespace"],"members":{"ScheduledActionNames":{"shape":"Sb"},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName","ScheduledActionARN","ServiceNamespace","Schedule","ResourceId","CreationTime"],"members":{"ScheduledActionName":{},"ScheduledActionARN":{},"ServiceNamespace":{},"Schedule":{},"Timezone":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S28"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2c"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["PolicyName","ServiceNamespace","ResourceId","ScalableDimension"],"members":{"PolicyName":{},"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"PolicyType":{},"StepScalingPolicyConfiguration":{"shape":"S10"},"TargetTrackingScalingPolicyConfiguration":{"shape":"S19"}}},"output":{"type":"structure","required":["PolicyARN"],"members":{"PolicyARN":{},"Alarms":{"shape":"S21"}}}},"PutScheduledAction":{"input":{"type":"structure","required":["ServiceNamespace","ScheduledActionName","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"Schedule":{},"Timezone":{},"ScheduledActionName":{},"ResourceId":{},"ScalableDimension":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ScalableTargetAction":{"shape":"S28"}}},"output":{"type":"structure","members":{}}},"RegisterScalableTarget":{"input":{"type":"structure","required":["ServiceNamespace","ResourceId","ScalableDimension"],"members":{"ServiceNamespace":{},"ResourceId":{},"ScalableDimension":{},"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"RoleARN":{},"SuspendedState":{"shape":"Sj"},"Tags":{"shape":"S2c"}}},"output":{"type":"structure","members":{"ScalableTargetARN":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S2c"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sb":{"type":"list","member":{}},"Sj":{"type":"structure","members":{"DynamicScalingInSuspended":{"type":"boolean"},"DynamicScalingOutSuspended":{"type":"boolean"},"ScheduledScalingSuspended":{"type":"boolean"}}},"S10":{"type":"structure","members":{"AdjustmentType":{},"StepAdjustments":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"MinAdjustmentMagnitude":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{}}},"S19":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","members":{"MetricName":{},"Namespace":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Statistic":{},"Unit":{},"Metrics":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Expression":{},"Id":{},"Label":{},"MetricStat":{"type":"structure","required":["Metric","Stat"],"members":{"Metric":{"type":"structure","members":{"Dimensions":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"MetricName":{},"Namespace":{}}},"Stat":{},"Unit":{}}},"ReturnData":{"type":"boolean"}}}}}},"ScaleOutCooldown":{"type":"integer"},"ScaleInCooldown":{"type":"integer"},"DisableScaleIn":{"type":"boolean"}}},"S21":{"type":"list","member":{"type":"structure","required":["AlarmName","AlarmARN"],"members":{"AlarmName":{},"AlarmARN":{}}}},"S28":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}},"S2c":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 403 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeScalableTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalableTargets"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingActivities"},"DescribeScalingPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledActions"}}}

/***/ }),
/* 404 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-05-18","endpointPrefix":"athena","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Athena","serviceId":"Athena","signatureVersion":"v4","targetPrefix":"AmazonAthena","uid":"athena-2017-05-18"},"operations":{"BatchGetNamedQuery":{"input":{"type":"structure","required":["NamedQueryIds"],"members":{"NamedQueryIds":{"shape":"S2"}}},"output":{"type":"structure","members":{"NamedQueries":{"type":"list","member":{"shape":"S6"}},"UnprocessedNamedQueryIds":{"type":"list","member":{"type":"structure","members":{"NamedQueryId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"BatchGetPreparedStatement":{"input":{"type":"structure","required":["PreparedStatementNames","WorkGroup"],"members":{"PreparedStatementNames":{"type":"list","member":{}},"WorkGroup":{}}},"output":{"type":"structure","members":{"PreparedStatements":{"type":"list","member":{"shape":"Sl"}},"UnprocessedPreparedStatementNames":{"type":"list","member":{"type":"structure","members":{"StatementName":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"BatchGetQueryExecution":{"input":{"type":"structure","required":["QueryExecutionIds"],"members":{"QueryExecutionIds":{"shape":"Sq"}}},"output":{"type":"structure","members":{"QueryExecutions":{"type":"list","member":{"shape":"Su"}},"UnprocessedQueryExecutionIds":{"type":"list","member":{"type":"structure","members":{"QueryExecutionId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"CancelCapacityReservation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateCapacityReservation":{"input":{"type":"structure","required":["TargetDpus","Name"],"members":{"TargetDpus":{"type":"integer"},"Name":{},"Tags":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CreateDataCatalog":{"input":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"Description":{},"Parameters":{"shape":"S22"},"Tags":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"CreateNamedQuery":{"input":{"type":"structure","required":["Name","Database","QueryString"],"members":{"Name":{},"Description":{},"Database":{},"QueryString":{},"ClientRequestToken":{"idempotencyToken":true},"WorkGroup":{}}},"output":{"type":"structure","members":{"NamedQueryId":{}}},"idempotent":true},"CreateNotebook":{"input":{"type":"structure","required":["WorkGroup","Name"],"members":{"WorkGroup":{},"Name":{},"ClientRequestToken":{}}},"output":{"type":"structure","members":{"NotebookId":{}}}},"CreatePreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup","QueryStatement"],"members":{"StatementName":{},"WorkGroup":{},"QueryStatement":{},"Description":{}}},"output":{"type":"structure","members":{}}},"CreatePresignedNotebookUrl":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","required":["NotebookUrl","AuthToken","AuthTokenExpirationTime"],"members":{"NotebookUrl":{},"AuthToken":{},"AuthTokenExpirationTime":{"type":"long"}}}},"CreateWorkGroup":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Configuration":{"shape":"S2l"},"Description":{},"Tags":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"DeleteCapacityReservation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteDataCatalog":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteNamedQuery":{"input":{"type":"structure","required":["NamedQueryId"],"members":{"NamedQueryId":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteNotebook":{"input":{"type":"structure","required":["NotebookId"],"members":{"NotebookId":{}}},"output":{"type":"structure","members":{}}},"DeletePreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup"],"members":{"StatementName":{},"WorkGroup":{}}},"output":{"type":"structure","members":{}}},"DeleteWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"RecursiveDeleteOption":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"ExportNotebook":{"input":{"type":"structure","required":["NotebookId"],"members":{"NotebookId":{}}},"output":{"type":"structure","members":{"NotebookMetadata":{"shape":"S38"},"Payload":{}}}},"GetCalculationExecution":{"input":{"type":"structure","required":["CalculationExecutionId"],"members":{"CalculationExecutionId":{}}},"output":{"type":"structure","members":{"CalculationExecutionId":{},"SessionId":{},"Description":{},"WorkingDirectory":{},"Status":{"shape":"S3f"},"Statistics":{"shape":"S3h"},"Result":{"type":"structure","members":{"StdOutS3Uri":{},"StdErrorS3Uri":{},"ResultS3Uri":{},"ResultType":{}}}}}},"GetCalculationExecutionCode":{"input":{"type":"structure","required":["CalculationExecutionId"],"members":{"CalculationExecutionId":{}}},"output":{"type":"structure","members":{"CodeBlock":{}}}},"GetCalculationExecutionStatus":{"input":{"type":"structure","required":["CalculationExecutionId"],"members":{"CalculationExecutionId":{}}},"output":{"type":"structure","members":{"Status":{"shape":"S3f"},"Statistics":{"shape":"S3h"}}}},"GetCapacityAssignmentConfiguration":{"input":{"type":"structure","required":["CapacityReservationName"],"members":{"CapacityReservationName":{}}},"output":{"type":"structure","required":["CapacityAssignmentConfiguration"],"members":{"CapacityAssignmentConfiguration":{"type":"structure","members":{"CapacityReservationName":{},"CapacityAssignments":{"shape":"S3s"}}}}}},"GetCapacityReservation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","required":["CapacityReservation"],"members":{"CapacityReservation":{"shape":"S3x"}}}},"GetDataCatalog":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WorkGroup":{}}},"output":{"type":"structure","members":{"DataCatalog":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Description":{},"Type":{},"Parameters":{"shape":"S22"}}}}}},"GetDatabase":{"input":{"type":"structure","required":["CatalogName","DatabaseName"],"members":{"CatalogName":{},"DatabaseName":{},"WorkGroup":{}}},"output":{"type":"structure","members":{"Database":{"shape":"S48"}}}},"GetNamedQuery":{"input":{"type":"structure","required":["NamedQueryId"],"members":{"NamedQueryId":{}}},"output":{"type":"structure","members":{"NamedQuery":{"shape":"S6"}}}},"GetNotebookMetadata":{"input":{"type":"structure","required":["NotebookId"],"members":{"NotebookId":{}}},"output":{"type":"structure","members":{"NotebookMetadata":{"shape":"S38"}}}},"GetPreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup"],"members":{"StatementName":{},"WorkGroup":{}}},"output":{"type":"structure","members":{"PreparedStatement":{"shape":"Sl"}}}},"GetQueryExecution":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{}}},"output":{"type":"structure","members":{"QueryExecution":{"shape":"Su"}}}},"GetQueryResults":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UpdateCount":{"type":"long"},"ResultSet":{"type":"structure","members":{"Rows":{"type":"list","member":{"type":"structure","members":{"Data":{"type":"list","member":{"type":"structure","members":{"VarCharValue":{}}}}}}},"ResultSetMetadata":{"type":"structure","members":{"ColumnInfo":{"type":"list","member":{"type":"structure","required":["Name","Type"],"members":{"CatalogName":{},"SchemaName":{},"TableName":{},"Name":{},"Label":{},"Type":{},"Precision":{"type":"integer"},"Scale":{"type":"integer"},"Nullable":{},"CaseSensitive":{"type":"boolean"}}}}}}}},"NextToken":{}}}},"GetQueryRuntimeStatistics":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{}}},"output":{"type":"structure","members":{"QueryRuntimeStatistics":{"type":"structure","members":{"Timeline":{"type":"structure","members":{"QueryQueueTimeInMillis":{"type":"long"},"ServicePreProcessingTimeInMillis":{"type":"long"},"QueryPlanningTimeInMillis":{"type":"long"},"EngineExecutionTimeInMillis":{"type":"long"},"ServiceProcessingTimeInMillis":{"type":"long"},"TotalExecutionTimeInMillis":{"type":"long"}}},"Rows":{"type":"structure","members":{"InputRows":{"type":"long"},"InputBytes":{"type":"long"},"OutputBytes":{"type":"long"},"OutputRows":{"type":"long"}}},"OutputStage":{"shape":"S51"}}}}}},"GetSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{},"Description":{},"WorkGroup":{},"EngineVersion":{},"EngineConfiguration":{"shape":"S58"},"NotebookVersion":{},"SessionConfiguration":{"type":"structure","members":{"ExecutionRole":{},"WorkingDirectory":{},"IdleTimeoutSeconds":{"type":"long"},"EncryptionConfiguration":{"shape":"Sy"}}},"Status":{"shape":"S5d"},"Statistics":{"type":"structure","members":{"DpuExecutionInMillis":{"type":"long"}}}}}},"GetSessionStatus":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{},"Status":{"shape":"S5d"}}}},"GetTableMetadata":{"input":{"type":"structure","required":["CatalogName","DatabaseName","TableName"],"members":{"CatalogName":{},"DatabaseName":{},"TableName":{},"WorkGroup":{}}},"output":{"type":"structure","members":{"TableMetadata":{"shape":"S5k"}}}},"GetWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{}}},"output":{"type":"structure","members":{"WorkGroup":{"type":"structure","required":["Name"],"members":{"Name":{},"State":{},"Configuration":{"shape":"S2l"},"Description":{},"CreationTime":{"type":"timestamp"},"IdentityCenterApplicationArn":{}}}}}},"ImportNotebook":{"input":{"type":"structure","required":["WorkGroup","Name","Type"],"members":{"WorkGroup":{},"Name":{},"Payload":{},"Type":{},"NotebookS3LocationUri":{},"ClientRequestToken":{}}},"output":{"type":"structure","members":{"NotebookId":{}}}},"ListApplicationDPUSizes":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ApplicationDPUSizes":{"type":"list","member":{"type":"structure","members":{"ApplicationRuntimeId":{},"SupportedDPUSizes":{"type":"list","member":{"type":"integer"}}}}},"NextToken":{}}}},"ListCalculationExecutions":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{},"StateFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Calculations":{"type":"list","member":{"type":"structure","members":{"CalculationExecutionId":{},"Description":{},"Status":{"shape":"S3f"}}}}}}},"ListCapacityReservations":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["CapacityReservations"],"members":{"NextToken":{},"CapacityReservations":{"type":"list","member":{"shape":"S3x"}}}}},"ListDataCatalogs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"DataCatalogsSummary":{"type":"list","member":{"type":"structure","members":{"CatalogName":{},"Type":{}}}},"NextToken":{}}}},"ListDatabases":{"input":{"type":"structure","required":["CatalogName"],"members":{"CatalogName":{},"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"DatabaseList":{"type":"list","member":{"shape":"S48"}},"NextToken":{}}}},"ListEngineVersions":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EngineVersions":{"type":"list","member":{"shape":"S1i"}},"NextToken":{}}}},"ListExecutors":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{},"ExecutorStateFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["SessionId"],"members":{"SessionId":{},"NextToken":{},"ExecutorsSummary":{"type":"list","member":{"type":"structure","required":["ExecutorId"],"members":{"ExecutorId":{},"ExecutorType":{},"StartDateTime":{"type":"long"},"TerminationDateTime":{"type":"long"},"ExecutorState":{},"ExecutorSize":{"type":"long"}}}}}}},"ListNamedQueries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"NamedQueryIds":{"shape":"S2"},"NextToken":{}}}},"ListNotebookMetadata":{"input":{"type":"structure","required":["WorkGroup"],"members":{"Filters":{"type":"structure","members":{"Name":{}}},"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"NextToken":{},"NotebookMetadataList":{"type":"list","member":{"shape":"S38"}}}}},"ListNotebookSessions":{"input":{"type":"structure","required":["NotebookId"],"members":{"NotebookId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["NotebookSessionsList"],"members":{"NotebookSessionsList":{"type":"list","member":{"type":"structure","members":{"SessionId":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListPreparedStatements":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PreparedStatements":{"type":"list","member":{"type":"structure","members":{"StatementName":{},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListQueryExecutions":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"QueryExecutionIds":{"shape":"Sq"},"NextToken":{}}}},"ListSessions":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"StateFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Sessions":{"type":"list","member":{"type":"structure","members":{"SessionId":{},"Description":{},"EngineVersion":{"shape":"S1i"},"NotebookVersion":{},"Status":{"shape":"S5d"}}}}}}},"ListTableMetadata":{"input":{"type":"structure","required":["CatalogName","DatabaseName"],"members":{"CatalogName":{},"DatabaseName":{},"Expression":{},"NextToken":{},"MaxResults":{"type":"integer"},"WorkGroup":{}}},"output":{"type":"structure","members":{"TableMetadataList":{"type":"list","member":{"shape":"S5k"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1v"},"NextToken":{}}}},"ListWorkGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"WorkGroups":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"Description":{},"CreationTime":{"type":"timestamp"},"EngineVersion":{"shape":"S1i"},"IdentityCenterApplicationArn":{}}}},"NextToken":{}}}},"PutCapacityAssignmentConfiguration":{"input":{"type":"structure","required":["CapacityReservationName","CapacityAssignments"],"members":{"CapacityReservationName":{},"CapacityAssignments":{"shape":"S3s"}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartCalculationExecution":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{},"Description":{},"CalculationConfiguration":{"deprecated":true,"deprecatedMessage":"Kepler Post GA Tasks : https://sim.amazon.com/issues/ATHENA-39828","type":"structure","members":{"CodeBlock":{}}},"CodeBlock":{},"ClientRequestToken":{}}},"output":{"type":"structure","members":{"CalculationExecutionId":{},"State":{}}}},"StartQueryExecution":{"input":{"type":"structure","required":["QueryString"],"members":{"QueryString":{},"ClientRequestToken":{"idempotencyToken":true},"QueryExecutionContext":{"shape":"S18"},"ResultConfiguration":{"shape":"Sw"},"WorkGroup":{},"ExecutionParameters":{"shape":"S1j"},"ResultReuseConfiguration":{"shape":"S14"}}},"output":{"type":"structure","members":{"QueryExecutionId":{}}},"idempotent":true},"StartSession":{"input":{"type":"structure","required":["WorkGroup","EngineConfiguration"],"members":{"Description":{},"WorkGroup":{},"EngineConfiguration":{"shape":"S58"},"NotebookVersion":{},"SessionIdleTimeoutInMinutes":{"type":"integer"},"ClientRequestToken":{}}},"output":{"type":"structure","members":{"SessionId":{},"State":{}}}},"StopCalculationExecution":{"input":{"type":"structure","required":["CalculationExecutionId"],"members":{"CalculationExecutionId":{}}},"output":{"type":"structure","members":{"State":{}}}},"StopQueryExecution":{"input":{"type":"structure","required":["QueryExecutionId"],"members":{"QueryExecutionId":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1v"}}},"output":{"type":"structure","members":{}}},"TerminateSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"State":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateCapacityReservation":{"input":{"type":"structure","required":["TargetDpus","Name"],"members":{"TargetDpus":{"type":"integer"},"Name":{}}},"output":{"type":"structure","members":{}}},"UpdateDataCatalog":{"input":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"Description":{},"Parameters":{"shape":"S22"}}},"output":{"type":"structure","members":{}}},"UpdateNamedQuery":{"input":{"type":"structure","required":["NamedQueryId","Name","QueryString"],"members":{"NamedQueryId":{},"Name":{},"Description":{},"QueryString":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateNotebook":{"input":{"type":"structure","required":["NotebookId","Payload","Type"],"members":{"NotebookId":{},"Payload":{},"Type":{},"SessionId":{},"ClientRequestToken":{}}},"output":{"type":"structure","members":{}}},"UpdateNotebookMetadata":{"input":{"type":"structure","required":["NotebookId","Name"],"members":{"NotebookId":{},"ClientRequestToken":{},"Name":{}}},"output":{"type":"structure","members":{}}},"UpdatePreparedStatement":{"input":{"type":"structure","required":["StatementName","WorkGroup","QueryStatement"],"members":{"StatementName":{},"WorkGroup":{},"QueryStatement":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateWorkGroup":{"input":{"type":"structure","required":["WorkGroup"],"members":{"WorkGroup":{},"Description":{},"ConfigurationUpdates":{"type":"structure","members":{"EnforceWorkGroupConfiguration":{"type":"boolean"},"ResultConfigurationUpdates":{"type":"structure","members":{"OutputLocation":{},"RemoveOutputLocation":{"type":"boolean"},"EncryptionConfiguration":{"shape":"Sy"},"RemoveEncryptionConfiguration":{"type":"boolean"},"ExpectedBucketOwner":{},"RemoveExpectedBucketOwner":{"type":"boolean"},"AclConfiguration":{"shape":"S12"},"RemoveAclConfiguration":{"type":"boolean"}}},"PublishCloudWatchMetricsEnabled":{"type":"boolean"},"BytesScannedCutoffPerQuery":{"type":"long"},"RemoveBytesScannedCutoffPerQuery":{"type":"boolean"},"RequesterPaysEnabled":{"type":"boolean"},"EngineVersion":{"shape":"S1i"},"RemoveCustomerContentEncryptionConfiguration":{"type":"boolean"},"AdditionalConfiguration":{},"ExecutionRole":{},"CustomerContentEncryptionConfiguration":{"shape":"S2o"},"EnableMinimumEncryptionConfiguration":{"type":"boolean"},"QueryResultsS3AccessGrantsConfiguration":{"shape":"S1l"}}},"State":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"structure","required":["Name","Database","QueryString"],"members":{"Name":{},"Description":{},"Database":{},"QueryString":{},"NamedQueryId":{},"WorkGroup":{}}},"Sl":{"type":"structure","members":{"StatementName":{},"QueryStatement":{},"WorkGroupName":{},"Description":{},"LastModifiedTime":{"type":"timestamp"}}},"Sq":{"type":"list","member":{}},"Su":{"type":"structure","members":{"QueryExecutionId":{},"Query":{},"StatementType":{},"ResultConfiguration":{"shape":"Sw"},"ResultReuseConfiguration":{"shape":"S14"},"QueryExecutionContext":{"shape":"S18"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{},"SubmissionDateTime":{"type":"timestamp"},"CompletionDateTime":{"type":"timestamp"},"AthenaError":{"type":"structure","members":{"ErrorCategory":{"type":"integer"},"ErrorType":{"type":"integer"},"Retryable":{"type":"boolean"},"ErrorMessage":{}}}}},"Statistics":{"type":"structure","members":{"EngineExecutionTimeInMillis":{"type":"long"},"DataScannedInBytes":{"type":"long"},"DataManifestLocation":{},"TotalExecutionTimeInMillis":{"type":"long"},"QueryQueueTimeInMillis":{"type":"long"},"ServicePreProcessingTimeInMillis":{"type":"long"},"QueryPlanningTimeInMillis":{"type":"long"},"ServiceProcessingTimeInMillis":{"type":"long"},"ResultReuseInformation":{"type":"structure","required":["ReusedPreviousResult"],"members":{"ReusedPreviousResult":{"type":"boolean"}}}}},"WorkGroup":{},"EngineVersion":{"shape":"S1i"},"ExecutionParameters":{"shape":"S1j"},"SubstatementType":{},"QueryResultsS3AccessGrantsConfiguration":{"shape":"S1l"}}},"Sw":{"type":"structure","members":{"OutputLocation":{},"EncryptionConfiguration":{"shape":"Sy"},"ExpectedBucketOwner":{},"AclConfiguration":{"shape":"S12"}}},"Sy":{"type":"structure","required":["EncryptionOption"],"members":{"EncryptionOption":{},"KmsKey":{}}},"S12":{"type":"structure","required":["S3AclOption"],"members":{"S3AclOption":{}}},"S14":{"type":"structure","members":{"ResultReuseByAgeConfiguration":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxAgeInMinutes":{"type":"integer"}}}}},"S18":{"type":"structure","members":{"Database":{},"Catalog":{}}},"S1i":{"type":"structure","members":{"SelectedEngineVersion":{},"EffectiveEngineVersion":{}}},"S1j":{"type":"list","member":{}},"S1l":{"type":"structure","required":["EnableS3AccessGrants","AuthenticationType"],"members":{"EnableS3AccessGrants":{"type":"boolean"},"CreateUserLevelPrefix":{"type":"boolean"},"AuthenticationType":{}}},"S1v":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S22":{"type":"map","key":{},"value":{}},"S2l":{"type":"structure","members":{"ResultConfiguration":{"shape":"Sw"},"EnforceWorkGroupConfiguration":{"type":"boolean"},"PublishCloudWatchMetricsEnabled":{"type":"boolean"},"BytesScannedCutoffPerQuery":{"type":"long"},"RequesterPaysEnabled":{"type":"boolean"},"EngineVersion":{"shape":"S1i"},"AdditionalConfiguration":{},"ExecutionRole":{},"CustomerContentEncryptionConfiguration":{"shape":"S2o"},"EnableMinimumEncryptionConfiguration":{"type":"boolean"},"IdentityCenterConfiguration":{"type":"structure","members":{"EnableIdentityCenter":{"type":"boolean"},"IdentityCenterInstanceArn":{}}},"QueryResultsS3AccessGrantsConfiguration":{"shape":"S1l"}}},"S2o":{"type":"structure","required":["KmsKey"],"members":{"KmsKey":{}}},"S38":{"type":"structure","members":{"NotebookId":{},"Name":{},"WorkGroup":{},"CreationTime":{"type":"timestamp"},"Type":{},"LastModifiedTime":{"type":"timestamp"}}},"S3f":{"type":"structure","members":{"SubmissionDateTime":{"type":"timestamp"},"CompletionDateTime":{"type":"timestamp"},"State":{},"StateChangeReason":{}}},"S3h":{"type":"structure","members":{"DpuExecutionInMillis":{"type":"long"},"Progress":{}}},"S3s":{"type":"list","member":{"type":"structure","members":{"WorkGroupNames":{"type":"list","member":{}}}}},"S3x":{"type":"structure","required":["Name","Status","TargetDpus","AllocatedDpus","CreationTime"],"members":{"Name":{},"Status":{},"TargetDpus":{"type":"integer"},"AllocatedDpus":{"type":"integer"},"LastAllocation":{"type":"structure","required":["Status","RequestTime"],"members":{"Status":{},"StatusMessage":{},"RequestTime":{"type":"timestamp"},"RequestCompletionTime":{"type":"timestamp"}}},"LastSuccessfulAllocationTime":{"type":"timestamp"},"CreationTime":{"type":"timestamp"}}},"S48":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"Parameters":{"shape":"S22"}}},"S51":{"type":"structure","members":{"StageId":{"type":"long"},"State":{},"OutputBytes":{"type":"long"},"OutputRows":{"type":"long"},"InputBytes":{"type":"long"},"InputRows":{"type":"long"},"ExecutionTime":{"type":"long"},"QueryStagePlan":{"shape":"S52"},"SubStages":{"type":"list","member":{"shape":"S51"}}}},"S52":{"type":"structure","members":{"Name":{},"Identifier":{},"Children":{"type":"list","member":{"shape":"S52"}},"RemoteSources":{"type":"list","member":{}}}},"S58":{"type":"structure","required":["MaxConcurrentDpus"],"members":{"CoordinatorDpuSize":{"type":"integer"},"MaxConcurrentDpus":{"type":"integer"},"DefaultExecutorDpuSize":{"type":"integer"},"AdditionalConfigs":{"shape":"S22"},"SparkProperties":{"shape":"S22"}}},"S5d":{"type":"structure","members":{"StartDateTime":{"type":"timestamp"},"LastModifiedDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"IdleSinceDateTime":{"type":"timestamp"},"State":{},"StateChangeReason":{}}},"S5k":{"type":"structure","required":["Name"],"members":{"Name":{},"CreateTime":{"type":"timestamp"},"LastAccessTime":{"type":"timestamp"},"TableType":{},"Columns":{"shape":"S5m"},"PartitionKeys":{"shape":"S5m"},"Parameters":{"shape":"S22"}}},"S5m":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Type":{},"Comment":{}}}}}}

/***/ }),
/* 405 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetQueryResults":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListApplicationDPUSizes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCalculationExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCapacityReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDataCatalogs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DataCatalogsSummary"},"ListDatabases":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatabaseList"},"ListEngineVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListExecutors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListNamedQueries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPreparedStatements":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListQueryExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTableMetadata":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TableMetadataList"},"ListTagsForResource":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"ListWorkGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 406 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-01-01","endpointPrefix":"autoscaling","protocol":"query","serviceFullName":"Auto Scaling","serviceId":"Auto Scaling","signatureVersion":"v4","uid":"autoscaling-2011-01-01","xmlNamespace":"http://autoscaling.amazonaws.com/doc/2011-01-01/"},"operations":{"AttachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}}},"AttachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"AttachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"AttachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"AttachLoadBalancersResult","type":"structure","members":{}}},"AttachTrafficSources":{"input":{"type":"structure","required":["AutoScalingGroupName","TrafficSources"],"members":{"AutoScalingGroupName":{},"TrafficSources":{"shape":"Sd"}}},"output":{"resultWrapper":"AttachTrafficSourcesResult","type":"structure","members":{}}},"BatchDeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionNames"],"members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Sh"}}},"output":{"resultWrapper":"BatchDeleteScheduledActionResult","type":"structure","members":{"FailedScheduledActions":{"shape":"Sj"}}}},"BatchPutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledUpdateGroupActions"],"members":{"AutoScalingGroupName":{},"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"TimeZone":{}}}}}},"output":{"resultWrapper":"BatchPutScheduledUpdateGroupActionResult","type":"structure","members":{"FailedScheduledUpdateGroupActions":{"shape":"Sj"}}}},"CancelInstanceRefresh":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{}}},"output":{"resultWrapper":"CancelInstanceRefreshResult","type":"structure","members":{"InstanceRefreshId":{}}}},"CompleteLifecycleAction":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName","LifecycleActionResult"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"LifecycleActionResult":{},"InstanceId":{}}},"output":{"resultWrapper":"CompleteLifecycleActionResult","type":"structure","members":{}}},"CreateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S14"},"MixedInstancesPolicy":{"shape":"S16"},"InstanceId":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S2d"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S2g"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"CapacityRebalance":{"type":"boolean"},"LifecycleHookSpecificationList":{"type":"list","member":{"type":"structure","required":["LifecycleHookName","LifecycleTransition"],"members":{"LifecycleHookName":{},"LifecycleTransition":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{},"NotificationTargetARN":{},"RoleARN":{}}}},"Tags":{"shape":"S2q"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"},"Context":{},"DesiredCapacityType":{},"DefaultInstanceWarmup":{"type":"integer"},"TrafficSources":{"shape":"Sd"},"InstanceMaintenancePolicy":{"shape":"S2y"}}}},"CreateLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S32"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S33"},"UserData":{},"InstanceId":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S35"},"InstanceMonitoring":{"shape":"S3f"},"SpotPrice":{},"IamInstanceProfile":{},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{},"MetadataOptions":{"shape":"S3k"}}}},"CreateOrUpdateTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2q"}}}},"DeleteAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}}},"DeleteLaunchConfiguration":{"input":{"type":"structure","required":["LaunchConfigurationName"],"members":{"LaunchConfigurationName":{}}}},"DeleteLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"DeleteLifecycleHookResult","type":"structure","members":{}}},"DeleteNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN"],"members":{"AutoScalingGroupName":{},"TopicARN":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{}}}},"DeleteTags":{"input":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2q"}}}},"DeleteWarmPool":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ForceDelete":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteWarmPoolResult","type":"structure","members":{}}},"DescribeAccountLimits":{"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"MaxNumberOfAutoScalingGroups":{"type":"integer"},"MaxNumberOfLaunchConfigurations":{"type":"integer"},"NumberOfAutoScalingGroups":{"type":"integer"},"NumberOfLaunchConfigurations":{"type":"integer"}}}},"DescribeAdjustmentTypes":{"output":{"resultWrapper":"DescribeAdjustmentTypesResult","type":"structure","members":{"AdjustmentTypes":{"type":"list","member":{"type":"structure","members":{"AdjustmentType":{}}}}}}},"DescribeAutoScalingGroups":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S49"},"NextToken":{},"MaxRecords":{"type":"integer"},"Filters":{"shape":"S4b"}}},"output":{"resultWrapper":"DescribeAutoScalingGroupsResult","type":"structure","required":["AutoScalingGroups"],"members":{"AutoScalingGroups":{"type":"list","member":{"type":"structure","required":["AutoScalingGroupName","MinSize","MaxSize","DesiredCapacity","DefaultCooldown","AvailabilityZones","HealthCheckType","CreatedTime"],"members":{"AutoScalingGroupName":{},"AutoScalingGroupARN":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S14"},"MixedInstancesPolicy":{"shape":"S16"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"PredictedCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S2d"},"LoadBalancerNames":{"shape":"Sa"},"TargetGroupARNs":{"shape":"S6"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"Instances":{"shape":"S4i"},"CreatedTime":{"type":"timestamp"},"SuspendedProcesses":{"type":"list","member":{"type":"structure","members":{"ProcessName":{},"SuspensionReason":{}}}},"PlacementGroup":{},"VPCZoneIdentifier":{},"EnabledMetrics":{"type":"list","member":{"type":"structure","members":{"Metric":{},"Granularity":{}}}},"Status":{},"Tags":{"shape":"S4p"},"TerminationPolicies":{"shape":"S2g"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"},"CapacityRebalance":{"type":"boolean"},"WarmPoolConfiguration":{"shape":"S4r"},"WarmPoolSize":{"type":"integer"},"Context":{},"DesiredCapacityType":{},"DefaultInstanceWarmup":{"type":"integer"},"TrafficSources":{"shape":"Sd"},"InstanceMaintenancePolicy":{"shape":"S2y"}}}},"NextToken":{}}}},"DescribeAutoScalingInstances":{"input":{"type":"structure","members":{"InstanceIds":{"shape":"S2"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAutoScalingInstancesResult","type":"structure","members":{"AutoScalingInstances":{"type":"list","member":{"type":"structure","required":["InstanceId","AutoScalingGroupName","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"InstanceType":{},"AutoScalingGroupName":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S14"},"ProtectedFromScaleIn":{"type":"boolean"},"WeightedCapacity":{}}}},"NextToken":{}}}},"DescribeAutoScalingNotificationTypes":{"output":{"resultWrapper":"DescribeAutoScalingNotificationTypesResult","type":"structure","members":{"AutoScalingNotificationTypes":{"shape":"S54"}}}},"DescribeInstanceRefreshes":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"InstanceRefreshIds":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeInstanceRefreshesResult","type":"structure","members":{"InstanceRefreshes":{"type":"list","member":{"type":"structure","members":{"InstanceRefreshId":{},"AutoScalingGroupName":{},"Status":{},"StatusReason":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"PercentageComplete":{"type":"integer"},"InstancesToUpdate":{"type":"integer"},"ProgressDetails":{"shape":"S5e"},"Preferences":{"shape":"S5h"},"DesiredConfiguration":{"shape":"S5t"},"RollbackDetails":{"type":"structure","members":{"RollbackReason":{},"RollbackStartTime":{"type":"timestamp"},"PercentageCompleteOnRollback":{"type":"integer"},"InstancesToUpdateOnRollback":{"type":"integer"},"ProgressDetailsOnRollback":{"shape":"S5e"}}}}}},"NextToken":{}}}},"DescribeLaunchConfigurations":{"input":{"type":"structure","members":{"LaunchConfigurationNames":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLaunchConfigurationsResult","type":"structure","required":["LaunchConfigurations"],"members":{"LaunchConfigurations":{"type":"list","member":{"type":"structure","required":["LaunchConfigurationName","ImageId","InstanceType","CreatedTime"],"members":{"LaunchConfigurationName":{},"LaunchConfigurationARN":{},"ImageId":{},"KeyName":{},"SecurityGroups":{"shape":"S32"},"ClassicLinkVPCId":{},"ClassicLinkVPCSecurityGroups":{"shape":"S33"},"UserData":{},"InstanceType":{},"KernelId":{},"RamdiskId":{},"BlockDeviceMappings":{"shape":"S35"},"InstanceMonitoring":{"shape":"S3f"},"SpotPrice":{},"IamInstanceProfile":{},"CreatedTime":{"type":"timestamp"},"EbsOptimized":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"PlacementTenancy":{},"MetadataOptions":{"shape":"S3k"}}}},"NextToken":{}}}},"DescribeLifecycleHookTypes":{"output":{"resultWrapper":"DescribeLifecycleHookTypesResult","type":"structure","members":{"LifecycleHookTypes":{"shape":"S54"}}}},"DescribeLifecycleHooks":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LifecycleHookNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLifecycleHooksResult","type":"structure","members":{"LifecycleHooks":{"type":"list","member":{"type":"structure","members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"NotificationTargetARN":{},"RoleARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"GlobalTimeout":{"type":"integer"},"DefaultResult":{}}}}}}},"DescribeLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancerTargetGroupsResult","type":"structure","members":{"LoadBalancerTargetGroups":{"type":"list","member":{"type":"structure","members":{"LoadBalancerTargetGroupARN":{},"State":{}}}},"NextToken":{}}}},"DescribeLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"State":{}}}},"NextToken":{}}}},"DescribeMetricCollectionTypes":{"output":{"resultWrapper":"DescribeMetricCollectionTypesResult","type":"structure","members":{"Metrics":{"type":"list","member":{"type":"structure","members":{"Metric":{}}}},"Granularities":{"type":"list","member":{"type":"structure","members":{"Granularity":{}}}}}}},"DescribeNotificationConfigurations":{"input":{"type":"structure","members":{"AutoScalingGroupNames":{"shape":"S49"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNotificationConfigurationsResult","type":"structure","required":["NotificationConfigurations"],"members":{"NotificationConfigurations":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationType":{}}}},"NextToken":{}}}},"DescribePolicies":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyNames":{"type":"list","member":{}},"PolicyTypes":{"type":"list","member":{}},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePoliciesResult","type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyARN":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S6u"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"StepAdjustments":{"shape":"S6x"},"MetricAggregationType":{},"EstimatedInstanceWarmup":{"type":"integer"},"Alarms":{"shape":"S71"},"TargetTrackingConfiguration":{"shape":"S73"},"Enabled":{"type":"boolean"},"PredictiveScalingConfiguration":{"shape":"S7o"}}}},"NextToken":{}}}},"DescribeScalingActivities":{"input":{"type":"structure","members":{"ActivityIds":{"type":"list","member":{}},"AutoScalingGroupName":{},"IncludeDeletedGroups":{"type":"boolean"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeScalingActivitiesResult","type":"structure","required":["Activities"],"members":{"Activities":{"shape":"S8b"},"NextToken":{}}}},"DescribeScalingProcessTypes":{"output":{"resultWrapper":"DescribeScalingProcessTypesResult","type":"structure","members":{"Processes":{"type":"list","member":{"type":"structure","required":["ProcessName"],"members":{"ProcessName":{}}}}}}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionNames":{"shape":"Sh"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"ScheduledUpdateGroupActions":{"type":"list","member":{"type":"structure","members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"ScheduledActionARN":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"TimeZone":{}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"Filters":{"shape":"S4b"},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"Tags":{"shape":"S4p"},"NextToken":{}}}},"DescribeTerminationPolicyTypes":{"output":{"resultWrapper":"DescribeTerminationPolicyTypesResult","type":"structure","members":{"TerminationPolicyTypes":{"shape":"S2g"}}}},"DescribeTrafficSources":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"TrafficSourceType":{},"NextToken":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTrafficSourcesResult","type":"structure","members":{"TrafficSources":{"type":"list","member":{"type":"structure","members":{"TrafficSource":{"deprecated":true,"deprecatedMessage":"TrafficSource has been replaced by Identifier"},"State":{},"Identifier":{},"Type":{}}}},"NextToken":{}}}},"DescribeWarmPool":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeWarmPoolResult","type":"structure","members":{"WarmPoolConfiguration":{"shape":"S4r"},"Instances":{"shape":"S4i"},"NextToken":{}}}},"DetachInstances":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"DetachInstancesResult","type":"structure","members":{"Activities":{"shape":"S8b"}}}},"DetachLoadBalancerTargetGroups":{"input":{"type":"structure","required":["AutoScalingGroupName","TargetGroupARNs"],"members":{"AutoScalingGroupName":{},"TargetGroupARNs":{"shape":"S6"}}},"output":{"resultWrapper":"DetachLoadBalancerTargetGroupsResult","type":"structure","members":{}}},"DetachLoadBalancers":{"input":{"type":"structure","required":["AutoScalingGroupName","LoadBalancerNames"],"members":{"AutoScalingGroupName":{},"LoadBalancerNames":{"shape":"Sa"}}},"output":{"resultWrapper":"DetachLoadBalancersResult","type":"structure","members":{}}},"DetachTrafficSources":{"input":{"type":"structure","required":["AutoScalingGroupName","TrafficSources"],"members":{"AutoScalingGroupName":{},"TrafficSources":{"shape":"Sd"}}},"output":{"resultWrapper":"DetachTrafficSourcesResult","type":"structure","members":{}}},"DisableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S96"}}}},"EnableMetricsCollection":{"input":{"type":"structure","required":["AutoScalingGroupName","Granularity"],"members":{"AutoScalingGroupName":{},"Metrics":{"shape":"S96"},"Granularity":{}}}},"EnterStandby":{"input":{"type":"structure","required":["AutoScalingGroupName","ShouldDecrementDesiredCapacity"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"EnterStandbyResult","type":"structure","members":{"Activities":{"shape":"S8b"}}}},"ExecutePolicy":{"input":{"type":"structure","required":["PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"HonorCooldown":{"type":"boolean"},"MetricValue":{"type":"double"},"BreachThreshold":{"type":"double"}}}},"ExitStandby":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{}}},"output":{"resultWrapper":"ExitStandbyResult","type":"structure","members":{"Activities":{"shape":"S8b"}}}},"GetPredictiveScalingForecast":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName","StartTime","EndTime"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"output":{"resultWrapper":"GetPredictiveScalingForecastResult","type":"structure","required":["LoadForecast","CapacityForecast","UpdateTime"],"members":{"LoadForecast":{"type":"list","member":{"type":"structure","required":["Timestamps","Values","MetricSpecification"],"members":{"Timestamps":{"shape":"S9i"},"Values":{"shape":"S9j"},"MetricSpecification":{"shape":"S7q"}}}},"CapacityForecast":{"type":"structure","required":["Timestamps","Values"],"members":{"Timestamps":{"shape":"S9i"},"Values":{"shape":"S9j"}}},"UpdateTime":{"type":"timestamp"}}}},"PutLifecycleHook":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleTransition":{},"RoleARN":{},"NotificationTargetARN":{},"NotificationMetadata":{},"HeartbeatTimeout":{"type":"integer"},"DefaultResult":{}}},"output":{"resultWrapper":"PutLifecycleHookResult","type":"structure","members":{}}},"PutNotificationConfiguration":{"input":{"type":"structure","required":["AutoScalingGroupName","TopicARN","NotificationTypes"],"members":{"AutoScalingGroupName":{},"TopicARN":{},"NotificationTypes":{"shape":"S54"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["AutoScalingGroupName","PolicyName"],"members":{"AutoScalingGroupName":{},"PolicyName":{},"PolicyType":{},"AdjustmentType":{},"MinAdjustmentStep":{"shape":"S6u"},"MinAdjustmentMagnitude":{"type":"integer"},"ScalingAdjustment":{"type":"integer"},"Cooldown":{"type":"integer"},"MetricAggregationType":{},"StepAdjustments":{"shape":"S6x"},"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"shape":"S73"},"Enabled":{"type":"boolean"},"PredictiveScalingConfiguration":{"shape":"S7o"}}},"output":{"resultWrapper":"PutScalingPolicyResult","type":"structure","members":{"PolicyARN":{},"Alarms":{"shape":"S71"}}}},"PutScheduledUpdateGroupAction":{"input":{"type":"structure","required":["AutoScalingGroupName","ScheduledActionName"],"members":{"AutoScalingGroupName":{},"ScheduledActionName":{},"Time":{"type":"timestamp"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Recurrence":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"TimeZone":{}}}},"PutWarmPool":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"MaxGroupPreparedCapacity":{"type":"integer"},"MinSize":{"type":"integer"},"PoolState":{},"InstanceReusePolicy":{"shape":"S4w"}}},"output":{"resultWrapper":"PutWarmPoolResult","type":"structure","members":{}}},"RecordLifecycleActionHeartbeat":{"input":{"type":"structure","required":["LifecycleHookName","AutoScalingGroupName"],"members":{"LifecycleHookName":{},"AutoScalingGroupName":{},"LifecycleActionToken":{},"InstanceId":{}}},"output":{"resultWrapper":"RecordLifecycleActionHeartbeatResult","type":"structure","members":{}}},"ResumeProcesses":{"input":{"shape":"S9v"}},"RollbackInstanceRefresh":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{}}},"output":{"resultWrapper":"RollbackInstanceRefreshResult","type":"structure","members":{"InstanceRefreshId":{}}}},"SetDesiredCapacity":{"input":{"type":"structure","required":["AutoScalingGroupName","DesiredCapacity"],"members":{"AutoScalingGroupName":{},"DesiredCapacity":{"type":"integer"},"HonorCooldown":{"type":"boolean"}}}},"SetInstanceHealth":{"input":{"type":"structure","required":["InstanceId","HealthStatus"],"members":{"InstanceId":{},"HealthStatus":{},"ShouldRespectGracePeriod":{"type":"boolean"}}}},"SetInstanceProtection":{"input":{"type":"structure","required":["InstanceIds","AutoScalingGroupName","ProtectedFromScaleIn"],"members":{"InstanceIds":{"shape":"S2"},"AutoScalingGroupName":{},"ProtectedFromScaleIn":{"type":"boolean"}}},"output":{"resultWrapper":"SetInstanceProtectionResult","type":"structure","members":{}}},"StartInstanceRefresh":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"Strategy":{},"DesiredConfiguration":{"shape":"S5t"},"Preferences":{"shape":"S5h"}}},"output":{"resultWrapper":"StartInstanceRefreshResult","type":"structure","members":{"InstanceRefreshId":{}}}},"SuspendProcesses":{"input":{"shape":"S9v"}},"TerminateInstanceInAutoScalingGroup":{"input":{"type":"structure","required":["InstanceId","ShouldDecrementDesiredCapacity"],"members":{"InstanceId":{},"ShouldDecrementDesiredCapacity":{"type":"boolean"}}},"output":{"resultWrapper":"TerminateInstanceInAutoScalingGroupResult","type":"structure","members":{"Activity":{"shape":"S8c"}}}},"UpdateAutoScalingGroup":{"input":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S14"},"MixedInstancesPolicy":{"shape":"S16"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"DesiredCapacity":{"type":"integer"},"DefaultCooldown":{"type":"integer"},"AvailabilityZones":{"shape":"S2d"},"HealthCheckType":{},"HealthCheckGracePeriod":{"type":"integer"},"PlacementGroup":{},"VPCZoneIdentifier":{},"TerminationPolicies":{"shape":"S2g"},"NewInstancesProtectedFromScaleIn":{"type":"boolean"},"ServiceLinkedRoleARN":{},"MaxInstanceLifetime":{"type":"integer"},"CapacityRebalance":{"type":"boolean"},"Context":{},"DesiredCapacityType":{},"DefaultInstanceWarmup":{"type":"integer"},"InstanceMaintenancePolicy":{"shape":"S2y"}}}}},"shapes":{"S2":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{}},"Sd":{"type":"list","member":{"type":"structure","required":["Identifier"],"members":{"Identifier":{},"Type":{}}}},"Sh":{"type":"list","member":{}},"Sj":{"type":"list","member":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"ErrorCode":{},"ErrorMessage":{}}}},"S14":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"S16":{"type":"structure","members":{"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"S14"},"Overrides":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{},"LaunchTemplateSpecification":{"shape":"S14"},"InstanceRequirements":{"type":"structure","required":["VCpuCount","MemoryMiB"],"members":{"VCpuCount":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"MemoryMiB":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"CpuManufacturers":{"type":"list","member":{}},"MemoryGiBPerVCpu":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"ExcludedInstanceTypes":{"type":"list","member":{}},"InstanceGenerations":{"type":"list","member":{}},"SpotMaxPricePercentageOverLowestPrice":{"type":"integer"},"MaxSpotPriceAsPercentageOfOptimalOnDemandPrice":{"type":"integer"},"OnDemandMaxPricePercentageOverLowestPrice":{"type":"integer"},"BareMetal":{},"BurstablePerformance":{},"RequireHibernateSupport":{"type":"boolean"},"NetworkInterfaceCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"LocalStorage":{},"LocalStorageTypes":{"type":"list","member":{}},"TotalLocalStorageGB":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"BaselineEbsBandwidthMbps":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorTypes":{"type":"list","member":{}},"AcceleratorCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorManufacturers":{"type":"list","member":{}},"AcceleratorNames":{"type":"list","member":{}},"AcceleratorTotalMemoryMiB":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"NetworkBandwidthGbps":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"AllowedInstanceTypes":{"type":"list","member":{}}}}}}}}},"InstancesDistribution":{"type":"structure","members":{"OnDemandAllocationStrategy":{},"OnDemandBaseCapacity":{"type":"integer"},"OnDemandPercentageAboveBaseCapacity":{"type":"integer"},"SpotAllocationStrategy":{},"SpotInstancePools":{"type":"integer"},"SpotMaxPrice":{}}}}},"S2d":{"type":"list","member":{}},"S2g":{"type":"list","member":{}},"S2q":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S2y":{"type":"structure","members":{"MinHealthyPercentage":{"type":"integer"},"MaxHealthyPercentage":{"type":"integer"}}},"S32":{"type":"list","member":{}},"S33":{"type":"list","member":{}},"S35":{"type":"list","member":{"type":"structure","required":["DeviceName"],"members":{"VirtualName":{},"DeviceName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"},"Throughput":{"type":"integer"}}},"NoDevice":{"type":"boolean"}}}},"S3f":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"S3k":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{}}},"S49":{"type":"list","member":{}},"S4b":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{"type":"list","member":{}}}}},"S4i":{"type":"list","member":{"type":"structure","required":["InstanceId","AvailabilityZone","LifecycleState","HealthStatus","ProtectedFromScaleIn"],"members":{"InstanceId":{},"InstanceType":{},"AvailabilityZone":{},"LifecycleState":{},"HealthStatus":{},"LaunchConfigurationName":{},"LaunchTemplate":{"shape":"S14"},"ProtectedFromScaleIn":{"type":"boolean"},"WeightedCapacity":{}}}},"S4p":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Key":{},"Value":{},"PropagateAtLaunch":{"type":"boolean"}}}},"S4r":{"type":"structure","members":{"MaxGroupPreparedCapacity":{"type":"integer"},"MinSize":{"type":"integer"},"PoolState":{},"Status":{},"InstanceReusePolicy":{"shape":"S4w"}}},"S4w":{"type":"structure","members":{"ReuseOnScaleIn":{"type":"boolean"}}},"S54":{"type":"list","member":{}},"S5e":{"type":"structure","members":{"LivePoolProgress":{"type":"structure","members":{"PercentageComplete":{"type":"integer"},"InstancesToUpdate":{"type":"integer"}}},"WarmPoolProgress":{"type":"structure","members":{"PercentageComplete":{"type":"integer"},"InstancesToUpdate":{"type":"integer"}}}}},"S5h":{"type":"structure","members":{"MinHealthyPercentage":{"type":"integer"},"InstanceWarmup":{"type":"integer"},"CheckpointPercentages":{"type":"list","member":{"type":"integer"}},"CheckpointDelay":{"type":"integer"},"SkipMatching":{"type":"boolean"},"AutoRollback":{"type":"boolean"},"ScaleInProtectedInstances":{},"StandbyInstances":{},"AlarmSpecification":{"type":"structure","members":{"Alarms":{"type":"list","member":{}}}},"MaxHealthyPercentage":{"type":"integer"}}},"S5t":{"type":"structure","members":{"LaunchTemplate":{"shape":"S14"},"MixedInstancesPolicy":{"shape":"S16"}}},"S6u":{"type":"integer","deprecated":true},"S6x":{"type":"list","member":{"type":"structure","required":["ScalingAdjustment"],"members":{"MetricIntervalLowerBound":{"type":"double"},"MetricIntervalUpperBound":{"type":"double"},"ScalingAdjustment":{"type":"integer"}}}},"S71":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmARN":{}}}},"S73":{"type":"structure","required":["TargetValue"],"members":{"PredefinedMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedMetricSpecification":{"type":"structure","members":{"MetricName":{},"Namespace":{},"Dimensions":{"shape":"S79"},"Statistic":{},"Unit":{},"Metrics":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"Expression":{},"MetricStat":{"type":"structure","required":["Metric","Stat"],"members":{"Metric":{"shape":"S7i"},"Stat":{},"Unit":{}}},"Label":{},"ReturnData":{"type":"boolean"}}}}}},"TargetValue":{"type":"double"},"DisableScaleIn":{"type":"boolean"}}},"S79":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S7i":{"type":"structure","required":["Namespace","MetricName"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S79"}}},"S7o":{"type":"structure","required":["MetricSpecifications"],"members":{"MetricSpecifications":{"type":"list","member":{"shape":"S7q"}},"Mode":{},"SchedulingBufferTime":{"type":"integer"},"MaxCapacityBreachBehavior":{},"MaxCapacityBuffer":{"type":"integer"}}},"S7q":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"},"PredefinedMetricPairSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"PredefinedScalingMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"PredefinedLoadMetricSpecification":{"type":"structure","required":["PredefinedMetricType"],"members":{"PredefinedMetricType":{},"ResourceLabel":{}}},"CustomizedScalingMetricSpecification":{"type":"structure","required":["MetricDataQueries"],"members":{"MetricDataQueries":{"shape":"S7y"}}},"CustomizedLoadMetricSpecification":{"type":"structure","required":["MetricDataQueries"],"members":{"MetricDataQueries":{"shape":"S7y"}}},"CustomizedCapacityMetricSpecification":{"type":"structure","required":["MetricDataQueries"],"members":{"MetricDataQueries":{"shape":"S7y"}}}}},"S7y":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"Expression":{},"MetricStat":{"type":"structure","required":["Metric","Stat"],"members":{"Metric":{"shape":"S7i"},"Stat":{},"Unit":{}}},"Label":{},"ReturnData":{"type":"boolean"}}}},"S8b":{"type":"list","member":{"shape":"S8c"}},"S8c":{"type":"structure","required":["ActivityId","AutoScalingGroupName","Cause","StartTime","StatusCode"],"members":{"ActivityId":{},"AutoScalingGroupName":{},"Description":{},"Cause":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"StatusCode":{},"StatusMessage":{},"Progress":{"type":"integer"},"Details":{},"AutoScalingGroupState":{},"AutoScalingGroupARN":{}}},"S96":{"type":"list","member":{}},"S9i":{"type":"list","member":{"type":"timestamp"}},"S9j":{"type":"list","member":{"type":"double"}},"S9v":{"type":"structure","required":["AutoScalingGroupName"],"members":{"AutoScalingGroupName":{},"ScalingProcesses":{"type":"list","member":{}}}}}}

/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAutoScalingGroups":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingGroups"},"DescribeAutoScalingInstances":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AutoScalingInstances"},"DescribeInstanceRefreshes":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken"},"DescribeLaunchConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"LaunchConfigurations"},"DescribeLoadBalancerTargetGroups":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken"},"DescribeLoadBalancers":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken"},"DescribeNotificationConfigurations":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"NotificationConfigurations"},"DescribePolicies":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScalingPolicies"},"DescribeScalingActivities":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Activities"},"DescribeScheduledActions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"ScheduledUpdateGroupActions"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Tags"},"DescribeTrafficSources":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken"},"DescribeWarmPool":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Instances"}}}

/***/ }),
/* 408 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-25","endpointPrefix":"ce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Cost Explorer","serviceFullName":"AWS Cost Explorer Service","serviceId":"Cost Explorer","signatureVersion":"v4","signingName":"ce","targetPrefix":"AWSInsightsIndexService","uid":"ce-2017-10-25"},"operations":{"CreateAnomalyMonitor":{"input":{"type":"structure","required":["AnomalyMonitor"],"members":{"AnomalyMonitor":{"shape":"S2"},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}}},"CreateAnomalySubscription":{"input":{"type":"structure","required":["AnomalySubscription"],"members":{"AnomalySubscription":{"shape":"Sq"},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"CreateCostCategoryDefinition":{"input":{"type":"structure","required":["Name","RuleVersion","Rules"],"members":{"Name":{},"EffectiveStart":{},"RuleVersion":{},"Rules":{"shape":"S14"},"DefaultValue":{},"SplitChargeRules":{"shape":"S1a"},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveStart":{}}}},"DeleteAnomalyMonitor":{"input":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}},"output":{"type":"structure","members":{}}},"DeleteAnomalySubscription":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"type":"structure","members":{}}},"DeleteCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn"],"members":{"CostCategoryArn":{}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveEnd":{}}}},"DescribeCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn"],"members":{"CostCategoryArn":{},"EffectiveOn":{}}},"output":{"type":"structure","members":{"CostCategory":{"type":"structure","required":["CostCategoryArn","EffectiveStart","Name","RuleVersion","Rules"],"members":{"CostCategoryArn":{},"EffectiveStart":{},"EffectiveEnd":{},"Name":{},"RuleVersion":{},"Rules":{"shape":"S14"},"SplitChargeRules":{"shape":"S1a"},"ProcessingStatus":{"shape":"S1s"},"DefaultValue":{}}}}}},"GetAnomalies":{"input":{"type":"structure","required":["DateInterval"],"members":{"MonitorArn":{},"DateInterval":{"type":"structure","required":["StartDate"],"members":{"StartDate":{},"EndDate":{}}},"Feedback":{},"TotalImpact":{"type":"structure","required":["NumericOperator","StartValue"],"members":{"NumericOperator":{},"StartValue":{"type":"double"},"EndValue":{"type":"double"}}},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["Anomalies"],"members":{"Anomalies":{"type":"list","member":{"type":"structure","required":["AnomalyId","AnomalyScore","Impact","MonitorArn"],"members":{"AnomalyId":{},"AnomalyStartDate":{},"AnomalyEndDate":{},"DimensionValue":{},"RootCauses":{"type":"list","member":{"type":"structure","members":{"Service":{},"Region":{},"LinkedAccount":{},"UsageType":{},"LinkedAccountName":{}}}},"AnomalyScore":{"type":"structure","required":["MaxScore","CurrentScore"],"members":{"MaxScore":{"type":"double"},"CurrentScore":{"type":"double"}}},"Impact":{"type":"structure","required":["MaxImpact"],"members":{"MaxImpact":{"type":"double"},"TotalImpact":{"type":"double"},"TotalActualSpend":{"type":"double"},"TotalExpectedSpend":{"type":"double"},"TotalImpactPercentage":{"type":"double"}}},"MonitorArn":{},"Feedback":{}}}},"NextPageToken":{}}}},"GetAnomalyMonitors":{"input":{"type":"structure","members":{"MonitorArnList":{"shape":"Sb"},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["AnomalyMonitors"],"members":{"AnomalyMonitors":{"type":"list","member":{"shape":"S2"}},"NextPageToken":{}}}},"GetAnomalySubscriptions":{"input":{"type":"structure","members":{"SubscriptionArnList":{"shape":"Sb"},"MonitorArn":{},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["AnomalySubscriptions"],"members":{"AnomalySubscriptions":{"type":"list","member":{"shape":"Sq"}},"NextPageToken":{}}}},"GetApproximateUsageRecords":{"input":{"type":"structure","required":["Granularity","ApproximationDimension"],"members":{"Granularity":{},"Services":{"type":"list","member":{}},"ApproximationDimension":{}}},"output":{"type":"structure","members":{"Services":{"type":"map","key":{},"value":{"type":"long"}},"TotalRecords":{"type":"long"},"LookbackPeriod":{"shape":"S2o"}}}},"GetCostAndUsage":{"input":{"type":"structure","required":["TimePeriod","Granularity","Metrics"],"members":{"TimePeriod":{"shape":"S2o"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2q"},"GroupBy":{"shape":"S2s"},"NextPageToken":{}}},"output":{"type":"structure","members":{"NextPageToken":{},"GroupDefinitions":{"shape":"S2s"},"ResultsByTime":{"shape":"S2x"},"DimensionValueAttributes":{"shape":"S38"}}}},"GetCostAndUsageWithResources":{"input":{"type":"structure","required":["TimePeriod","Granularity","Filter"],"members":{"TimePeriod":{"shape":"S2o"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2q"},"GroupBy":{"shape":"S2s"},"NextPageToken":{}}},"output":{"type":"structure","members":{"NextPageToken":{},"GroupDefinitions":{"shape":"S2s"},"ResultsByTime":{"shape":"S2x"},"DimensionValueAttributes":{"shape":"S38"}}}},"GetCostCategories":{"input":{"type":"structure","required":["TimePeriod"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2o"},"CostCategoryName":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3h"},"MaxResults":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","required":["ReturnSize","TotalSize"],"members":{"NextPageToken":{},"CostCategoryNames":{"type":"list","member":{}},"CostCategoryValues":{"shape":"S3o"},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"}}}},"GetCostForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"S2o"},"Metric":{},"Granularity":{},"Filter":{"shape":"S7"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"S30"},"ForecastResultsByTime":{"shape":"S3t"}}}},"GetDimensionValues":{"input":{"type":"structure","required":["TimePeriod","Dimension"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2o"},"Dimension":{},"Context":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3h"},"MaxResults":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","required":["DimensionValues","ReturnSize","TotalSize"],"members":{"DimensionValues":{"shape":"S38"},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"},"NextPageToken":{}}}},"GetReservationCoverage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2o"},"GroupBy":{"shape":"S2s"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2q"},"NextPageToken":{},"SortBy":{"shape":"S3i"},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["CoveragesByTime"],"members":{"CoveragesByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2o"},"Groups":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S3a"},"Coverage":{"shape":"S44"}}}},"Total":{"shape":"S44"}}}},"Total":{"shape":"S44"},"NextPageToken":{}}}},"GetReservationPurchaseRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"AccountId":{},"Service":{},"Filter":{"shape":"S7"},"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S4m"},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{},"AdditionalMetadata":{}}},"Recommendations":{"type":"list","member":{"type":"structure","members":{"AccountScope":{},"LookbackPeriodInDays":{},"TermInYears":{},"PaymentOption":{},"ServiceSpecification":{"shape":"S4m"},"RecommendationDetails":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"InstanceDetails":{"type":"structure","members":{"EC2InstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"AvailabilityZone":{},"Platform":{},"Tenancy":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RDSInstanceDetails":{"type":"structure","members":{"Family":{},"InstanceType":{},"Region":{},"DatabaseEngine":{},"DatabaseEdition":{},"DeploymentOption":{},"LicenseModel":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"RedshiftInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ElastiCacheInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"ProductDescription":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"ESInstanceDetails":{"type":"structure","members":{"InstanceClass":{},"InstanceSize":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}},"MemoryDBInstanceDetails":{"type":"structure","members":{"Family":{},"NodeType":{},"Region":{},"CurrentGeneration":{"type":"boolean"},"SizeFlexEligible":{"type":"boolean"}}}}},"RecommendedNumberOfInstancesToPurchase":{},"RecommendedNormalizedUnitsToPurchase":{},"MinimumNumberOfInstancesUsedPerHour":{},"MinimumNormalizedUnitsUsedPerHour":{},"MaximumNumberOfInstancesUsedPerHour":{},"MaximumNormalizedUnitsUsedPerHour":{},"AverageNumberOfInstancesUsedPerHour":{},"AverageNormalizedUnitsUsedPerHour":{},"AverageUtilization":{},"EstimatedBreakEvenInMonths":{},"CurrencyCode":{},"EstimatedMonthlySavingsAmount":{},"EstimatedMonthlySavingsPercentage":{},"EstimatedMonthlyOnDemandCost":{},"EstimatedReservationCostForLookbackPeriod":{},"UpfrontCost":{},"RecurringStandardMonthlyCost":{}}}},"RecommendationSummary":{"type":"structure","members":{"TotalEstimatedMonthlySavingsAmount":{},"TotalEstimatedMonthlySavingsPercentage":{},"CurrencyCode":{}}}}}},"NextPageToken":{}}}},"GetReservationUtilization":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2o"},"GroupBy":{"shape":"S2s"},"Granularity":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3i"},"NextPageToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["UtilizationsByTime"],"members":{"UtilizationsByTime":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2o"},"Groups":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Attributes":{"shape":"S3a"},"Utilization":{"shape":"S5c"}}}},"Total":{"shape":"S5c"}}}},"Total":{"shape":"S5c"},"NextPageToken":{}}}},"GetRightsizingRecommendation":{"input":{"type":"structure","required":["Service"],"members":{"Filter":{"shape":"S7"},"Configuration":{"shape":"S5v"},"Service":{},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{},"LookbackPeriodInDays":{},"AdditionalMetadata":{}}},"Summary":{"type":"structure","members":{"TotalRecommendationCount":{},"EstimatedTotalMonthlySavingsAmount":{},"SavingsCurrencyCode":{},"SavingsPercentage":{}}},"RightsizingRecommendations":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"CurrentInstance":{"type":"structure","members":{"ResourceId":{},"InstanceName":{},"Tags":{"type":"list","member":{"shape":"Sf"}},"ResourceDetails":{"shape":"S64"},"ResourceUtilization":{"shape":"S66"},"ReservationCoveredHoursInLookbackPeriod":{},"SavingsPlansCoveredHoursInLookbackPeriod":{},"OnDemandHoursInLookbackPeriod":{},"TotalRunningHoursInLookbackPeriod":{},"MonthlyCost":{},"CurrencyCode":{}}},"RightsizingType":{},"ModifyRecommendationDetail":{"type":"structure","members":{"TargetInstances":{"type":"list","member":{"type":"structure","members":{"EstimatedMonthlyCost":{},"EstimatedMonthlySavings":{},"CurrencyCode":{},"DefaultTargetInstance":{"type":"boolean"},"ResourceDetails":{"shape":"S64"},"ExpectedResourceUtilization":{"shape":"S66"},"PlatformDifferences":{"type":"list","member":{}}}}}}},"TerminateRecommendationDetail":{"type":"structure","members":{"EstimatedMonthlySavings":{},"CurrencyCode":{}}},"FindingReasonCodes":{"type":"list","member":{}}}}},"NextPageToken":{},"Configuration":{"shape":"S5v"}}}},"GetSavingsPlanPurchaseRecommendationDetails":{"input":{"type":"structure","required":["RecommendationDetailId"],"members":{"RecommendationDetailId":{}}},"output":{"type":"structure","members":{"RecommendationDetailId":{},"RecommendationDetailData":{"type":"structure","members":{"AccountScope":{},"LookbackPeriodInDays":{},"SavingsPlansType":{},"TermInYears":{},"PaymentOption":{},"AccountId":{},"CurrencyCode":{},"InstanceFamily":{},"Region":{},"OfferingId":{},"GenerationTimestamp":{},"LatestUsageTimestamp":{},"CurrentAverageHourlyOnDemandSpend":{},"CurrentMaximumHourlyOnDemandSpend":{},"CurrentMinimumHourlyOnDemandSpend":{},"EstimatedAverageUtilization":{},"EstimatedMonthlySavingsAmount":{},"EstimatedOnDemandCost":{},"EstimatedOnDemandCostWithCurrentCommitment":{},"EstimatedROI":{},"EstimatedSPCost":{},"EstimatedSavingsAmount":{},"EstimatedSavingsPercentage":{},"ExistingHourlyCommitment":{},"HourlyCommitmentToPurchase":{},"UpfrontCost":{},"CurrentAverageCoverage":{},"EstimatedAverageCoverage":{},"MetricsOverLookbackPeriod":{"type":"list","member":{"type":"structure","members":{"StartTime":{},"EstimatedOnDemandCost":{},"CurrentCoverage":{},"EstimatedCoverage":{},"EstimatedNewCommitmentUtilization":{}}}}}}}}},"GetSavingsPlansCoverage":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2o"},"GroupBy":{"shape":"S2s"},"Granularity":{},"Filter":{"shape":"S7"},"Metrics":{"shape":"S2q"},"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{"shape":"S3i"}}},"output":{"type":"structure","required":["SavingsPlansCoverages"],"members":{"SavingsPlansCoverages":{"type":"list","member":{"type":"structure","members":{"Attributes":{"shape":"S3a"},"Coverage":{"type":"structure","members":{"SpendCoveredBySavingsPlans":{},"OnDemandCost":{},"TotalCost":{},"CoveragePercentage":{}}},"TimePeriod":{"shape":"S2o"}}}},"NextToken":{}}}},"GetSavingsPlansPurchaseRecommendation":{"input":{"type":"structure","required":["SavingsPlansType","TermInYears","PaymentOption","LookbackPeriodInDays"],"members":{"SavingsPlansType":{},"TermInYears":{},"PaymentOption":{},"AccountScope":{},"NextPageToken":{},"PageSize":{"type":"integer"},"LookbackPeriodInDays":{},"Filter":{"shape":"S7"}}},"output":{"type":"structure","members":{"Metadata":{"type":"structure","members":{"RecommendationId":{},"GenerationTimestamp":{},"AdditionalMetadata":{}}},"SavingsPlansPurchaseRecommendation":{"type":"structure","members":{"AccountScope":{},"SavingsPlansType":{},"TermInYears":{},"PaymentOption":{},"LookbackPeriodInDays":{},"SavingsPlansPurchaseRecommendationDetails":{"type":"list","member":{"type":"structure","members":{"SavingsPlansDetails":{"type":"structure","members":{"Region":{},"InstanceFamily":{},"OfferingId":{}}},"AccountId":{},"UpfrontCost":{},"EstimatedROI":{},"CurrencyCode":{},"EstimatedSPCost":{},"EstimatedOnDemandCost":{},"EstimatedOnDemandCostWithCurrentCommitment":{},"EstimatedSavingsAmount":{},"EstimatedSavingsPercentage":{},"HourlyCommitmentToPurchase":{},"EstimatedAverageUtilization":{},"EstimatedMonthlySavingsAmount":{},"CurrentMinimumHourlyOnDemandSpend":{},"CurrentMaximumHourlyOnDemandSpend":{},"CurrentAverageHourlyOnDemandSpend":{},"RecommendationDetailId":{}}}},"SavingsPlansPurchaseRecommendationSummary":{"type":"structure","members":{"EstimatedROI":{},"CurrencyCode":{},"EstimatedTotalCost":{},"CurrentOnDemandSpend":{},"EstimatedSavingsAmount":{},"TotalRecommendationCount":{},"DailyCommitmentToPurchase":{},"HourlyCommitmentToPurchase":{},"EstimatedSavingsPercentage":{},"EstimatedMonthlySavingsAmount":{},"EstimatedOnDemandCostWithCurrentCommitment":{}}}}},"NextPageToken":{}}}},"GetSavingsPlansUtilization":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2o"},"Granularity":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3i"}}},"output":{"type":"structure","required":["Total"],"members":{"SavingsPlansUtilizationsByTime":{"type":"list","member":{"type":"structure","required":["TimePeriod","Utilization"],"members":{"TimePeriod":{"shape":"S2o"},"Utilization":{"shape":"S78"},"Savings":{"shape":"S79"},"AmortizedCommitment":{"shape":"S7a"}}}},"Total":{"shape":"S7b"}}}},"GetSavingsPlansUtilizationDetails":{"input":{"type":"structure","required":["TimePeriod"],"members":{"TimePeriod":{"shape":"S2o"},"Filter":{"shape":"S7"},"DataType":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"},"SortBy":{"shape":"S3i"}}},"output":{"type":"structure","required":["SavingsPlansUtilizationDetails","TimePeriod"],"members":{"SavingsPlansUtilizationDetails":{"type":"list","member":{"type":"structure","members":{"SavingsPlanArn":{},"Attributes":{"shape":"S3a"},"Utilization":{"shape":"S78"},"Savings":{"shape":"S79"},"AmortizedCommitment":{"shape":"S7a"}}}},"Total":{"shape":"S7b"},"TimePeriod":{"shape":"S2o"},"NextToken":{}}}},"GetTags":{"input":{"type":"structure","required":["TimePeriod"],"members":{"SearchString":{},"TimePeriod":{"shape":"S2o"},"TagKey":{},"Filter":{"shape":"S7"},"SortBy":{"shape":"S3h"},"MaxResults":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","required":["Tags","ReturnSize","TotalSize"],"members":{"NextPageToken":{},"Tags":{"type":"list","member":{}},"ReturnSize":{"type":"integer"},"TotalSize":{"type":"integer"}}}},"GetUsageForecast":{"input":{"type":"structure","required":["TimePeriod","Metric","Granularity"],"members":{"TimePeriod":{"shape":"S2o"},"Metric":{},"Granularity":{},"Filter":{"shape":"S7"},"PredictionIntervalLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"Total":{"shape":"S30"},"ForecastResultsByTime":{"shape":"S3t"}}}},"ListCostAllocationTagBackfillHistory":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"BackfillRequests":{"type":"list","member":{"shape":"S7t"}},"NextToken":{}}}},"ListCostAllocationTags":{"input":{"type":"structure","members":{"Status":{},"TagKeys":{"type":"list","member":{}},"Type":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CostAllocationTags":{"type":"list","member":{"type":"structure","required":["TagKey","Type","Status"],"members":{"TagKey":{},"Type":{},"Status":{},"LastUpdatedDate":{},"LastUsedDate":{}}}},"NextToken":{}}}},"ListCostCategoryDefinitions":{"input":{"type":"structure","members":{"EffectiveOn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CostCategoryReferences":{"type":"list","member":{"type":"structure","members":{"CostCategoryArn":{},"Name":{},"EffectiveStart":{},"EffectiveEnd":{},"NumberOfRules":{"type":"integer"},"ProcessingStatus":{"shape":"S1s"},"Values":{"shape":"S3o"},"DefaultValue":{}}}},"NextToken":{}}}},"ListSavingsPlansPurchaseRecommendationGeneration":{"input":{"type":"structure","members":{"GenerationStatus":{},"RecommendationIds":{"type":"list","member":{}},"PageSize":{"type":"integer"},"NextPageToken":{}}},"output":{"type":"structure","members":{"GenerationSummaryList":{"type":"list","member":{"type":"structure","members":{"RecommendationId":{},"GenerationStatus":{},"GenerationStartedTime":{},"GenerationCompletionTime":{},"EstimatedCompletionTime":{}}}},"NextPageToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceTags":{"shape":"Sk"}}}},"ProvideAnomalyFeedback":{"input":{"type":"structure","required":["AnomalyId","Feedback"],"members":{"AnomalyId":{},"Feedback":{}}},"output":{"type":"structure","required":["AnomalyId"],"members":{"AnomalyId":{}}}},"StartCostAllocationTagBackfill":{"input":{"type":"structure","required":["BackfillFrom"],"members":{"BackfillFrom":{}}},"output":{"type":"structure","members":{"BackfillRequest":{"shape":"S7t"}}}},"StartSavingsPlansPurchaseRecommendationGeneration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"RecommendationId":{},"GenerationStartedTime":{},"EstimatedCompletionTime":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","ResourceTags"],"members":{"ResourceArn":{},"ResourceTags":{"shape":"Sk"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","ResourceTagKeys"],"members":{"ResourceArn":{},"ResourceTagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAnomalyMonitor":{"input":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{},"MonitorName":{}}},"output":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}}},"UpdateAnomalySubscription":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{},"Threshold":{"deprecated":true,"deprecatedMessage":"Threshold has been deprecated in favor of ThresholdExpression","type":"double"},"Frequency":{},"MonitorArnList":{"shape":"Sr"},"Subscribers":{"shape":"St"},"SubscriptionName":{},"ThresholdExpression":{"shape":"S7"}}},"output":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"UpdateCostAllocationTagsStatus":{"input":{"type":"structure","required":["CostAllocationTagsStatus"],"members":{"CostAllocationTagsStatus":{"type":"list","member":{"type":"structure","required":["TagKey","Status"],"members":{"TagKey":{},"Status":{}}}}}},"output":{"type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"TagKey":{},"Code":{},"Message":{}}}}}}},"UpdateCostCategoryDefinition":{"input":{"type":"structure","required":["CostCategoryArn","RuleVersion","Rules"],"members":{"CostCategoryArn":{},"EffectiveStart":{},"RuleVersion":{},"Rules":{"shape":"S14"},"DefaultValue":{},"SplitChargeRules":{"shape":"S1a"}}},"output":{"type":"structure","members":{"CostCategoryArn":{},"EffectiveStart":{}}}}},"shapes":{"S2":{"type":"structure","required":["MonitorName","MonitorType"],"members":{"MonitorArn":{},"MonitorName":{},"CreationDate":{},"LastUpdatedDate":{},"LastEvaluatedDate":{},"MonitorType":{},"MonitorDimension":{},"MonitorSpecification":{"shape":"S7"},"DimensionalValueCount":{"type":"integer"}}},"S7":{"type":"structure","members":{"Or":{"shape":"S8"},"And":{"shape":"S8"},"Not":{"shape":"S7"},"Dimensions":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}},"Tags":{"shape":"Sf"},"CostCategories":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}}}},"S8":{"type":"list","member":{"shape":"S7"}},"Sb":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Sf":{"type":"structure","members":{"Key":{},"Values":{"shape":"Sb"},"MatchOptions":{"shape":"Sd"}}},"Sk":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sq":{"type":"structure","required":["MonitorArnList","Subscribers","Frequency","SubscriptionName"],"members":{"SubscriptionArn":{},"AccountId":{},"MonitorArnList":{"shape":"Sr"},"Subscribers":{"shape":"St"},"Threshold":{"deprecated":true,"deprecatedMessage":"Threshold has been deprecated in favor of ThresholdExpression","type":"double"},"Frequency":{},"SubscriptionName":{},"ThresholdExpression":{"shape":"S7"}}},"Sr":{"type":"list","member":{}},"St":{"type":"list","member":{"type":"structure","members":{"Address":{},"Type":{},"Status":{}}}},"S14":{"type":"list","member":{"type":"structure","members":{"Value":{},"Rule":{"shape":"S7"},"InheritedValue":{"type":"structure","members":{"DimensionName":{},"DimensionKey":{}}},"Type":{}}}},"S1a":{"type":"list","member":{"type":"structure","required":["Source","Targets","Method"],"members":{"Source":{},"Targets":{"type":"list","member":{}},"Method":{},"Parameters":{"type":"list","member":{"type":"structure","required":["Type","Values"],"members":{"Type":{},"Values":{"type":"list","member":{}}}}}}}},"S1s":{"type":"list","member":{"type":"structure","members":{"Component":{},"Status":{}}}},"S2o":{"type":"structure","required":["Start","End"],"members":{"Start":{},"End":{}}},"S2q":{"type":"list","member":{}},"S2s":{"type":"list","member":{"type":"structure","members":{"Type":{},"Key":{}}}},"S2x":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2o"},"Total":{"shape":"S2z"},"Groups":{"type":"list","member":{"type":"structure","members":{"Keys":{"type":"list","member":{}},"Metrics":{"shape":"S2z"}}}},"Estimated":{"type":"boolean"}}}},"S2z":{"type":"map","key":{},"value":{"shape":"S30"}},"S30":{"type":"structure","members":{"Amount":{},"Unit":{}}},"S38":{"type":"list","member":{"type":"structure","members":{"Value":{},"Attributes":{"shape":"S3a"}}}},"S3a":{"type":"map","key":{},"value":{}},"S3h":{"type":"list","member":{"shape":"S3i"}},"S3i":{"type":"structure","required":["Key"],"members":{"Key":{},"SortOrder":{}}},"S3o":{"type":"list","member":{}},"S3t":{"type":"list","member":{"type":"structure","members":{"TimePeriod":{"shape":"S2o"},"MeanValue":{},"PredictionIntervalLowerBound":{},"PredictionIntervalUpperBound":{}}}},"S44":{"type":"structure","members":{"CoverageHours":{"type":"structure","members":{"OnDemandHours":{},"ReservedHours":{},"TotalRunningHours":{},"CoverageHoursPercentage":{}}},"CoverageNormalizedUnits":{"type":"structure","members":{"OnDemandNormalizedUnits":{},"ReservedNormalizedUnits":{},"TotalRunningNormalizedUnits":{},"CoverageNormalizedUnitsPercentage":{}}},"CoverageCost":{"type":"structure","members":{"OnDemandCost":{}}}}},"S4m":{"type":"structure","members":{"EC2Specification":{"type":"structure","members":{"OfferingClass":{}}}}},"S5c":{"type":"structure","members":{"UtilizationPercentage":{},"UtilizationPercentageInUnits":{},"PurchasedHours":{},"PurchasedUnits":{},"TotalActualHours":{},"TotalActualUnits":{},"UnusedHours":{},"UnusedUnits":{},"OnDemandCostOfRIHoursUsed":{},"NetRISavings":{},"TotalPotentialRISavings":{},"AmortizedUpfrontFee":{},"AmortizedRecurringFee":{},"TotalAmortizedFee":{},"RICostForUnusedHours":{},"RealizedSavings":{},"UnrealizedSavings":{}}},"S5v":{"type":"structure","required":["RecommendationTarget","BenefitsConsidered"],"members":{"RecommendationTarget":{},"BenefitsConsidered":{"type":"boolean"}}},"S64":{"type":"structure","members":{"EC2ResourceDetails":{"type":"structure","members":{"HourlyOnDemandRate":{},"InstanceType":{},"Platform":{},"Region":{},"Sku":{},"Memory":{},"NetworkPerformance":{},"Storage":{},"Vcpu":{}}}}},"S66":{"type":"structure","members":{"EC2ResourceUtilization":{"type":"structure","members":{"MaxCpuUtilizationPercentage":{},"MaxMemoryUtilizationPercentage":{},"MaxStorageUtilizationPercentage":{},"EBSResourceUtilization":{"type":"structure","members":{"EbsReadOpsPerSecond":{},"EbsWriteOpsPerSecond":{},"EbsReadBytesPerSecond":{},"EbsWriteBytesPerSecond":{}}},"DiskResourceUtilization":{"type":"structure","members":{"DiskReadOpsPerSecond":{},"DiskWriteOpsPerSecond":{},"DiskReadBytesPerSecond":{},"DiskWriteBytesPerSecond":{}}},"NetworkResourceUtilization":{"type":"structure","members":{"NetworkInBytesPerSecond":{},"NetworkOutBytesPerSecond":{},"NetworkPacketsInPerSecond":{},"NetworkPacketsOutPerSecond":{}}}}}}},"S78":{"type":"structure","members":{"TotalCommitment":{},"UsedCommitment":{},"UnusedCommitment":{},"UtilizationPercentage":{}}},"S79":{"type":"structure","members":{"NetSavings":{},"OnDemandCostEquivalent":{}}},"S7a":{"type":"structure","members":{"AmortizedRecurringCommitment":{},"AmortizedUpfrontCommitment":{},"TotalAmortizedCommitment":{}}},"S7b":{"type":"structure","required":["Utilization"],"members":{"Utilization":{"shape":"S78"},"Savings":{"shape":"S79"},"AmortizedCommitment":{"shape":"S7a"}}},"S7t":{"type":"structure","members":{"BackfillFrom":{},"RequestedAt":{},"CompletedAt":{},"BackfillStatus":{},"LastUpdatedAt":{}}}}}

/***/ }),
/* 409 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetSavingsPlansCoverage":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"GetSavingsPlansUtilizationDetails":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCostAllocationTagBackfillHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCostAllocationTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListCostCategoryDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-15","endpointPrefix":"cloudformation","protocol":"query","serviceFullName":"AWS CloudFormation","serviceId":"CloudFormation","signatureVersion":"v4","uid":"cloudformation-2010-05-15","xmlNamespace":"http://cloudformation.amazonaws.com/doc/2010-05-15/"},"operations":{"ActivateOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ActivateOrganizationsAccessResult","type":"structure","members":{}}},"ActivateType":{"input":{"type":"structure","members":{"Type":{},"PublicTypeArn":{},"PublisherId":{},"TypeName":{},"TypeNameAlias":{},"AutoUpdate":{"type":"boolean"},"LoggingConfig":{"shape":"S9"},"ExecutionRoleArn":{},"VersionBump":{},"MajorVersion":{"type":"long"}}},"output":{"resultWrapper":"ActivateTypeResult","type":"structure","members":{"Arn":{}}},"idempotent":true},"BatchDescribeTypeConfigurations":{"input":{"type":"structure","required":["TypeConfigurationIdentifiers"],"members":{"TypeConfigurationIdentifiers":{"type":"list","member":{"shape":"Si"}}}},"output":{"resultWrapper":"BatchDescribeTypeConfigurationsResult","type":"structure","members":{"Errors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{},"TypeConfigurationIdentifier":{"shape":"Si"}}}},"UnprocessedTypeConfigurations":{"type":"list","member":{"shape":"Si"}},"TypeConfigurations":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Alias":{},"Configuration":{},"LastUpdated":{"type":"timestamp"},"TypeArn":{},"TypeName":{},"IsDefaultConfiguration":{"type":"boolean"}}}}}}},"CancelUpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"ClientRequestToken":{}}}},"ContinueUpdateRollback":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ResourcesToSkip":{"type":"list","member":{}},"ClientRequestToken":{}}},"output":{"resultWrapper":"ContinueUpdateRollbackResult","type":"structure","members":{}}},"CreateChangeSet":{"input":{"type":"structure","required":["StackName","ChangeSetName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"S1a"},"Capabilities":{"shape":"S1f"},"ResourceTypes":{"shape":"S1h"},"RoleARN":{},"RollbackConfiguration":{"shape":"S1j"},"NotificationARNs":{"shape":"S1p"},"Tags":{"shape":"S1r"},"ChangeSetName":{},"ClientToken":{},"Description":{},"ChangeSetType":{},"ResourcesToImport":{"type":"list","member":{"type":"structure","required":["ResourceType","LogicalResourceId","ResourceIdentifier"],"members":{"ResourceType":{},"LogicalResourceId":{},"ResourceIdentifier":{"shape":"S22"}}}},"IncludeNestedStacks":{"type":"boolean"},"OnStackFailure":{},"ImportExistingResources":{"type":"boolean"}}},"output":{"resultWrapper":"CreateChangeSetResult","type":"structure","members":{"Id":{},"StackId":{}}}},"CreateGeneratedTemplate":{"input":{"type":"structure","required":["GeneratedTemplateName"],"members":{"Resources":{"shape":"S2c"},"GeneratedTemplateName":{},"StackName":{},"TemplateConfiguration":{"shape":"S2f"}}},"output":{"resultWrapper":"CreateGeneratedTemplateResult","type":"structure","members":{"GeneratedTemplateId":{}}}},"CreateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"S1a"},"DisableRollback":{"type":"boolean"},"RollbackConfiguration":{"shape":"S1j"},"TimeoutInMinutes":{"type":"integer"},"NotificationARNs":{"shape":"S1p"},"Capabilities":{"shape":"S1f"},"ResourceTypes":{"shape":"S1h"},"RoleARN":{},"OnFailure":{},"StackPolicyBody":{},"StackPolicyURL":{},"Tags":{"shape":"S1r"},"ClientRequestToken":{},"EnableTerminationProtection":{"type":"boolean"},"RetainExceptOnCreate":{"type":"boolean"}}},"output":{"resultWrapper":"CreateStackResult","type":"structure","members":{"StackId":{}}}},"CreateStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S2v"},"DeploymentTargets":{"shape":"S2x"},"Regions":{"shape":"S32"},"ParameterOverrides":{"shape":"S1a"},"OperationPreferences":{"shape":"S34"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"CreateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"CreateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"StackId":{},"Parameters":{"shape":"S1a"},"Capabilities":{"shape":"S1f"},"Tags":{"shape":"S1r"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"PermissionModel":{},"AutoDeployment":{"shape":"S3g"},"CallAs":{},"ClientRequestToken":{"idempotencyToken":true},"ManagedExecution":{"shape":"S3j"}}},"output":{"resultWrapper":"CreateStackSetResult","type":"structure","members":{"StackSetId":{}}}},"DeactivateOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DeactivateOrganizationsAccessResult","type":"structure","members":{}}},"DeactivateType":{"input":{"type":"structure","members":{"TypeName":{},"Type":{},"Arn":{}}},"output":{"resultWrapper":"DeactivateTypeResult","type":"structure","members":{}},"idempotent":true},"DeleteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{}}},"output":{"resultWrapper":"DeleteChangeSetResult","type":"structure","members":{}}},"DeleteGeneratedTemplate":{"input":{"type":"structure","required":["GeneratedTemplateName"],"members":{"GeneratedTemplateName":{}}}},"DeleteStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RetainResources":{"type":"list","member":{}},"RoleARN":{},"ClientRequestToken":{}}}},"DeleteStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions","RetainStacks"],"members":{"StackSetName":{},"Accounts":{"shape":"S2v"},"DeploymentTargets":{"shape":"S2x"},"Regions":{"shape":"S32"},"OperationPreferences":{"shape":"S34"},"RetainStacks":{"type":"boolean"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"DeleteStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"DeleteStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"CallAs":{}}},"output":{"resultWrapper":"DeleteStackSetResult","type":"structure","members":{}}},"DeregisterType":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{}}},"output":{"resultWrapper":"DeregisterTypeResult","type":"structure","members":{}},"idempotent":true},"DescribeAccountLimits":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"AccountLimits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"integer"}}}},"NextToken":{}}}},"DescribeChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{},"IncludePropertyValues":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeChangeSetResult","type":"structure","members":{"ChangeSetName":{},"ChangeSetId":{},"StackId":{},"StackName":{},"Description":{},"Parameters":{"shape":"S1a"},"CreationTime":{"type":"timestamp"},"ExecutionStatus":{},"Status":{},"StatusReason":{},"NotificationARNs":{"shape":"S1p"},"RollbackConfiguration":{"shape":"S1j"},"Capabilities":{"shape":"S1f"},"Tags":{"shape":"S1r"},"Changes":{"type":"list","member":{"type":"structure","members":{"Type":{},"HookInvocationCount":{"type":"integer"},"ResourceChange":{"type":"structure","members":{"PolicyAction":{},"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{},"Path":{},"BeforeValue":{},"AfterValue":{},"AttributeChangeType":{}}},"Evaluation":{},"ChangeSource":{},"CausingEntity":{}}}},"ChangeSetId":{},"ModuleInfo":{"shape":"S57"},"BeforeContext":{},"AfterContext":{}}}}}},"NextToken":{},"IncludeNestedStacks":{"type":"boolean"},"ParentChangeSetId":{},"RootChangeSetId":{},"OnStackFailure":{},"ImportExistingResources":{"type":"boolean"}}}},"DescribeChangeSetHooks":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"NextToken":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeChangeSetHooksResult","type":"structure","members":{"ChangeSetId":{},"ChangeSetName":{},"Hooks":{"type":"list","member":{"type":"structure","members":{"InvocationPoint":{},"FailureMode":{},"TypeName":{},"TypeVersionId":{},"TypeConfigurationVersionId":{},"TargetDetails":{"type":"structure","members":{"TargetType":{},"ResourceTargetDetails":{"type":"structure","members":{"LogicalResourceId":{},"ResourceType":{},"ResourceAction":{}}}}}}}},"Status":{},"NextToken":{},"StackId":{},"StackName":{}}}},"DescribeGeneratedTemplate":{"input":{"type":"structure","required":["GeneratedTemplateName"],"members":{"GeneratedTemplateName":{}}},"output":{"resultWrapper":"DescribeGeneratedTemplateResult","type":"structure","members":{"GeneratedTemplateId":{},"GeneratedTemplateName":{},"Resources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"LogicalResourceId":{},"ResourceIdentifier":{"shape":"S22"},"ResourceStatus":{},"ResourceStatusReason":{},"Warnings":{"type":"list","member":{"type":"structure","members":{"Type":{},"Properties":{"type":"list","member":{"type":"structure","members":{"PropertyPath":{},"Required":{"type":"boolean"},"Description":{}}}}}}}}}},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"Progress":{"type":"structure","members":{"ResourcesSucceeded":{"type":"integer"},"ResourcesFailed":{"type":"integer"},"ResourcesProcessing":{"type":"integer"},"ResourcesPending":{"type":"integer"}}},"StackId":{},"TemplateConfiguration":{"shape":"S2f"},"TotalWarnings":{"type":"integer"}}}},"DescribeOrganizationsAccess":{"input":{"type":"structure","members":{"CallAs":{}}},"output":{"resultWrapper":"DescribeOrganizationsAccessResult","type":"structure","members":{"Status":{}}}},"DescribePublisher":{"input":{"type":"structure","members":{"PublisherId":{}}},"output":{"resultWrapper":"DescribePublisherResult","type":"structure","members":{"PublisherId":{},"PublisherStatus":{},"IdentityProvider":{},"PublisherProfile":{}}},"idempotent":true},"DescribeResourceScan":{"input":{"type":"structure","required":["ResourceScanId"],"members":{"ResourceScanId":{}}},"output":{"resultWrapper":"DescribeResourceScanResult","type":"structure","members":{"ResourceScanId":{},"Status":{},"StatusReason":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"PercentageCompleted":{"type":"double"},"ResourceTypes":{"shape":"S1h"},"ResourcesScanned":{"type":"integer"},"ResourcesRead":{"type":"integer"}}}},"DescribeStackDriftDetectionStatus":{"input":{"type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}},"output":{"resultWrapper":"DescribeStackDriftDetectionStatusResult","type":"structure","required":["StackId","StackDriftDetectionId","DetectionStatus","Timestamp"],"members":{"StackId":{},"StackDriftDetectionId":{},"StackDriftStatus":{},"DetectionStatus":{},"DetectionStatusReason":{},"DriftedStackResourceCount":{"type":"integer"},"Timestamp":{"type":"timestamp"}}}},"DescribeStackEvents":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStackEventsResult","type":"structure","members":{"StackEvents":{"type":"list","member":{"type":"structure","required":["StackId","EventId","StackName","Timestamp"],"members":{"StackId":{},"EventId":{},"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"ResourceProperties":{},"ClientRequestToken":{},"HookType":{},"HookStatus":{},"HookStatusReason":{},"HookInvocationPoint":{},"HookFailureMode":{},"DetailedStatus":{}}}},"NextToken":{}}}},"DescribeStackInstance":{"input":{"type":"structure","required":["StackSetName","StackInstanceAccount","StackInstanceRegion"],"members":{"StackSetName":{},"StackInstanceAccount":{},"StackInstanceRegion":{},"CallAs":{}}},"output":{"resultWrapper":"DescribeStackInstanceResult","type":"structure","members":{"StackInstance":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"ParameterOverrides":{"shape":"S1a"},"Status":{},"StackInstanceStatus":{"shape":"S7f"},"StatusReason":{},"OrganizationalUnitId":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"},"LastOperationId":{}}}}}},"DescribeStackResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourceResult","type":"structure","members":{"StackResourceDetail":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"Metadata":{},"DriftInformation":{"shape":"S7m"},"ModuleInfo":{"shape":"S57"}}}}}},"DescribeStackResourceDrifts":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackResourceDriftStatusFilters":{"shape":"S7p"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeStackResourceDriftsResult","type":"structure","required":["StackResourceDrifts"],"members":{"StackResourceDrifts":{"type":"list","member":{"shape":"S7t"}},"NextToken":{}}}},"DescribeStackResources":{"input":{"type":"structure","members":{"StackName":{},"LogicalResourceId":{},"PhysicalResourceId":{}}},"output":{"resultWrapper":"DescribeStackResourcesResult","type":"structure","members":{"StackResources":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","Timestamp","ResourceStatus"],"members":{"StackName":{},"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Timestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"Description":{},"DriftInformation":{"shape":"S7m"},"ModuleInfo":{"shape":"S57"}}}}}}},"DescribeStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"CallAs":{}}},"output":{"resultWrapper":"DescribeStackSetResult","type":"structure","members":{"StackSet":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"TemplateBody":{},"Parameters":{"shape":"S1a"},"Capabilities":{"shape":"S1f"},"Tags":{"shape":"S1r"},"StackSetARN":{},"AdministrationRoleARN":{},"ExecutionRoleName":{},"StackSetDriftDetectionDetails":{"shape":"S8c"},"AutoDeployment":{"shape":"S3g"},"PermissionModel":{},"OrganizationalUnitIds":{"shape":"S2z"},"ManagedExecution":{"shape":"S3j"},"Regions":{"shape":"S32"}}}}}},"DescribeStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"CallAs":{}}},"output":{"resultWrapper":"DescribeStackSetOperationResult","type":"structure","members":{"StackSetOperation":{"type":"structure","members":{"OperationId":{},"StackSetId":{},"Action":{},"Status":{},"OperationPreferences":{"shape":"S34"},"RetainStacks":{"type":"boolean"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"},"DeploymentTargets":{"shape":"S2x"},"StackSetDriftDetectionDetails":{"shape":"S8c"},"StatusReason":{},"StatusDetails":{"shape":"S8r"}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"DescribeStacksResult","type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"ChangeSetId":{},"Description":{},"Parameters":{"shape":"S1a"},"CreationTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"RollbackConfiguration":{"shape":"S1j"},"StackStatus":{},"StackStatusReason":{},"DisableRollback":{"type":"boolean"},"NotificationARNs":{"shape":"S1p"},"TimeoutInMinutes":{"type":"integer"},"Capabilities":{"shape":"S1f"},"Outputs":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{},"ExportName":{}}}},"RoleARN":{},"Tags":{"shape":"S1r"},"EnableTerminationProtection":{"type":"boolean"},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}},"RetainExceptOnCreate":{"type":"boolean"},"DetailedStatus":{}}}},"NextToken":{}}}},"DescribeType":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"Arn":{},"VersionId":{},"PublisherId":{},"PublicVersionNumber":{}}},"output":{"resultWrapper":"DescribeTypeResult","type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"DefaultVersionId":{},"IsDefaultVersion":{"type":"boolean"},"TypeTestsStatus":{},"TypeTestsStatusDescription":{},"Description":{},"Schema":{},"ProvisioningType":{},"DeprecatedStatus":{},"LoggingConfig":{"shape":"S9"},"RequiredActivatedTypes":{"type":"list","member":{"type":"structure","members":{"TypeNameAlias":{},"OriginalTypeName":{},"PublisherId":{},"SupportedMajorVersions":{"type":"list","member":{"type":"integer"}}}}},"ExecutionRoleArn":{},"Visibility":{},"SourceUrl":{},"DocumentationUrl":{},"LastUpdated":{"type":"timestamp"},"TimeCreated":{"type":"timestamp"},"ConfigurationSchema":{},"PublisherId":{},"OriginalTypeName":{},"OriginalTypeArn":{},"PublicVersionNumber":{},"LatestPublicVersion":{},"IsActivated":{"type":"boolean"},"AutoUpdate":{"type":"boolean"}}},"idempotent":true},"DescribeTypeRegistration":{"input":{"type":"structure","required":["RegistrationToken"],"members":{"RegistrationToken":{}}},"output":{"resultWrapper":"DescribeTypeRegistrationResult","type":"structure","members":{"ProgressStatus":{},"Description":{},"TypeArn":{},"TypeVersionArn":{}}},"idempotent":true},"DetectStackDrift":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"LogicalResourceIds":{"shape":"S9r"}}},"output":{"resultWrapper":"DetectStackDriftResult","type":"structure","required":["StackDriftDetectionId"],"members":{"StackDriftDetectionId":{}}}},"DetectStackResourceDrift":{"input":{"type":"structure","required":["StackName","LogicalResourceId"],"members":{"StackName":{},"LogicalResourceId":{}}},"output":{"resultWrapper":"DetectStackResourceDriftResult","type":"structure","required":["StackResourceDrift"],"members":{"StackResourceDrift":{"shape":"S7t"}}}},"DetectStackSetDrift":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"OperationPreferences":{"shape":"S34"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"DetectStackSetDriftResult","type":"structure","members":{"OperationId":{}}}},"EstimateTemplateCost":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"Parameters":{"shape":"S1a"}}},"output":{"resultWrapper":"EstimateTemplateCostResult","type":"structure","members":{"Url":{}}}},"ExecuteChangeSet":{"input":{"type":"structure","required":["ChangeSetName"],"members":{"ChangeSetName":{},"StackName":{},"ClientRequestToken":{},"DisableRollback":{"type":"boolean"},"RetainExceptOnCreate":{"type":"boolean"}}},"output":{"resultWrapper":"ExecuteChangeSetResult","type":"structure","members":{}}},"GetGeneratedTemplate":{"input":{"type":"structure","required":["GeneratedTemplateName"],"members":{"Format":{},"GeneratedTemplateName":{}}},"output":{"resultWrapper":"GetGeneratedTemplateResult","type":"structure","members":{"Status":{},"TemplateBody":{}}}},"GetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{}}},"output":{"resultWrapper":"GetStackPolicyResult","type":"structure","members":{"StackPolicyBody":{}}}},"GetTemplate":{"input":{"type":"structure","members":{"StackName":{},"ChangeSetName":{},"TemplateStage":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"TemplateBody":{},"StagesAvailable":{"type":"list","member":{}}}}},"GetTemplateSummary":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{},"StackName":{},"StackSetName":{},"CallAs":{},"TemplateSummaryConfig":{"type":"structure","members":{"TreatUnrecognizedResourceTypesAsWarnings":{"type":"boolean"}}}}},"output":{"resultWrapper":"GetTemplateSummaryResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"NoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}}}}}}},"Description":{},"Capabilities":{"shape":"S1f"},"CapabilitiesReason":{},"ResourceTypes":{"shape":"S1h"},"Version":{},"Metadata":{},"DeclaredTransforms":{"shape":"Sap"},"ResourceIdentifierSummaries":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"LogicalResourceIds":{"shape":"S9r"},"ResourceIdentifiers":{"type":"list","member":{}}}}},"Warnings":{"type":"structure","members":{"UnrecognizedResourceTypes":{"shape":"S1h"}}}}}},"ImportStacksToStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"StackIds":{"type":"list","member":{}},"StackIdsUrl":{},"OrganizationalUnitIds":{"shape":"S2z"},"OperationPreferences":{"shape":"S34"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"ImportStacksToStackSetResult","type":"structure","members":{"OperationId":{}}}},"ListChangeSets":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListChangeSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackId":{},"StackName":{},"ChangeSetId":{},"ChangeSetName":{},"ExecutionStatus":{},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"Description":{},"IncludeNestedStacks":{"type":"boolean"},"ParentChangeSetId":{},"RootChangeSetId":{},"ImportExistingResources":{"type":"boolean"}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListExportsResult","type":"structure","members":{"Exports":{"type":"list","member":{"type":"structure","members":{"ExportingStackId":{},"Name":{},"Value":{}}}},"NextToken":{}}}},"ListGeneratedTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListGeneratedTemplatesResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"GeneratedTemplateId":{},"GeneratedTemplateName":{},"Status":{},"StatusReason":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"NumberOfResources":{"type":"integer"}}}},"NextToken":{}}}},"ListImports":{"input":{"type":"structure","required":["ExportName"],"members":{"ExportName":{},"NextToken":{}}},"output":{"resultWrapper":"ListImportsResult","type":"structure","members":{"Imports":{"type":"list","member":{}},"NextToken":{}}}},"ListResourceScanRelatedResources":{"input":{"type":"structure","required":["ResourceScanId","Resources"],"members":{"ResourceScanId":{},"Resources":{"type":"list","member":{"type":"structure","required":["ResourceType","ResourceIdentifier"],"members":{"ResourceType":{},"ResourceIdentifier":{"shape":"Sbk"}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListResourceScanRelatedResourcesResult","type":"structure","members":{"RelatedResources":{"type":"list","member":{"shape":"Sbp"}},"NextToken":{}}}},"ListResourceScanResources":{"input":{"type":"structure","required":["ResourceScanId"],"members":{"ResourceScanId":{},"ResourceIdentifier":{},"ResourceTypePrefix":{},"TagKey":{},"TagValue":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListResourceScanResourcesResult","type":"structure","members":{"Resources":{"type":"list","member":{"shape":"Sbp"}},"NextToken":{}}}},"ListResourceScans":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListResourceScansResult","type":"structure","members":{"ResourceScanSummaries":{"type":"list","member":{"type":"structure","members":{"ResourceScanId":{},"Status":{},"StatusReason":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"PercentageCompleted":{"type":"double"}}}},"NextToken":{}}}},"ListStackInstanceResourceDrifts":{"input":{"type":"structure","required":["StackSetName","StackInstanceAccount","StackInstanceRegion","OperationId"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"StackInstanceResourceDriftStatuses":{"shape":"S7p"},"StackInstanceAccount":{},"StackInstanceRegion":{},"OperationId":{},"CallAs":{}}},"output":{"resultWrapper":"ListStackInstanceResourceDriftsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","required":["StackId","LogicalResourceId","ResourceType","StackResourceDriftStatus","Timestamp"],"members":{"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"PhysicalResourceIdContext":{"shape":"S7u"},"ResourceType":{},"PropertyDifferences":{"shape":"S7z"},"StackResourceDriftStatus":{},"Timestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStackInstances":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{}}}},"StackInstanceAccount":{},"StackInstanceRegion":{},"CallAs":{}}},"output":{"resultWrapper":"ListStackInstancesResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetId":{},"Region":{},"Account":{},"StackId":{},"Status":{},"StatusReason":{},"StackInstanceStatus":{"shape":"S7f"},"OrganizationalUnitId":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"},"LastOperationId":{}}}},"NextToken":{}}}},"ListStackResources":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"NextToken":{}}},"output":{"resultWrapper":"ListStackResourcesResult","type":"structure","members":{"StackResourceSummaries":{"type":"list","member":{"type":"structure","required":["LogicalResourceId","ResourceType","LastUpdatedTimestamp","ResourceStatus"],"members":{"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"LastUpdatedTimestamp":{"type":"timestamp"},"ResourceStatus":{},"ResourceStatusReason":{},"DriftInformation":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}},"ModuleInfo":{"shape":"S57"}}}},"NextToken":{}}}},"ListStackSetAutoDeploymentTargets":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"CallAs":{}}},"output":{"resultWrapper":"ListStackSetAutoDeploymentTargetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"OrganizationalUnitId":{},"Regions":{"shape":"S32"}}}},"NextToken":{}}}},"ListStackSetOperationResults":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"CallAs":{},"Filters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Values":{}}}}}},"output":{"resultWrapper":"ListStackSetOperationResultsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"Status":{},"StatusReason":{},"AccountGateResult":{"type":"structure","members":{"Status":{},"StatusReason":{}}},"OrganizationalUnitId":{}}}},"NextToken":{}}}},"ListStackSetOperations":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"NextToken":{},"MaxResults":{"type":"integer"},"CallAs":{}}},"output":{"resultWrapper":"ListStackSetOperationsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"OperationId":{},"Action":{},"Status":{},"CreationTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"},"StatusReason":{},"StatusDetails":{"shape":"S8r"},"OperationPreferences":{"shape":"S34"}}}},"NextToken":{}}}},"ListStackSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Status":{},"CallAs":{}}},"output":{"resultWrapper":"ListStackSetsResult","type":"structure","members":{"Summaries":{"type":"list","member":{"type":"structure","members":{"StackSetName":{},"StackSetId":{},"Description":{},"Status":{},"AutoDeployment":{"shape":"S3g"},"PermissionModel":{},"DriftStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"},"ManagedExecution":{"shape":"S3j"}}}},"NextToken":{}}}},"ListStacks":{"input":{"type":"structure","members":{"NextToken":{},"StackStatusFilter":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListStacksResult","type":"structure","members":{"StackSummaries":{"type":"list","member":{"type":"structure","required":["StackName","CreationTime","StackStatus"],"members":{"StackId":{},"StackName":{},"TemplateDescription":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"DeletionTime":{"type":"timestamp"},"StackStatus":{},"StackStatusReason":{},"ParentId":{},"RootId":{},"DriftInformation":{"type":"structure","required":["StackDriftStatus"],"members":{"StackDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}}}}},"NextToken":{}}}},"ListTypeRegistrations":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"TypeArn":{},"RegistrationStatusFilter":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListTypeRegistrationsResult","type":"structure","members":{"RegistrationTokenList":{"type":"list","member":{}},"NextToken":{}}},"idempotent":true},"ListTypeVersions":{"input":{"type":"structure","members":{"Type":{},"TypeName":{},"Arn":{},"MaxResults":{"type":"integer"},"NextToken":{},"DeprecatedStatus":{},"PublisherId":{}}},"output":{"resultWrapper":"ListTypeVersionsResult","type":"structure","members":{"TypeVersionSummaries":{"type":"list","member":{"type":"structure","members":{"Type":{},"TypeName":{},"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"Arn":{},"TimeCreated":{"type":"timestamp"},"Description":{},"PublicVersionNumber":{}}}},"NextToken":{}}},"idempotent":true},"ListTypes":{"input":{"type":"structure","members":{"Visibility":{},"ProvisioningType":{},"DeprecatedStatus":{},"Type":{},"Filters":{"type":"structure","members":{"Category":{},"PublisherId":{},"TypeNamePrefix":{}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListTypesResult","type":"structure","members":{"TypeSummaries":{"type":"list","member":{"type":"structure","members":{"Type":{},"TypeName":{},"DefaultVersionId":{},"TypeArn":{},"LastUpdated":{"type":"timestamp"},"Description":{},"PublisherId":{},"OriginalTypeName":{},"PublicVersionNumber":{},"LatestPublicVersion":{},"PublisherIdentity":{},"PublisherName":{},"IsActivated":{"type":"boolean"}}}},"NextToken":{}}},"idempotent":true},"PublishType":{"input":{"type":"structure","members":{"Type":{},"Arn":{},"TypeName":{},"PublicVersionNumber":{}}},"output":{"resultWrapper":"PublishTypeResult","type":"structure","members":{"PublicTypeArn":{}}},"idempotent":true},"RecordHandlerProgress":{"input":{"type":"structure","required":["BearerToken","OperationStatus"],"members":{"BearerToken":{},"OperationStatus":{},"CurrentOperationStatus":{},"StatusMessage":{},"ErrorCode":{},"ResourceModel":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"RecordHandlerProgressResult","type":"structure","members":{}},"idempotent":true},"RegisterPublisher":{"input":{"type":"structure","members":{"AcceptTermsAndConditions":{"type":"boolean"},"ConnectionArn":{}}},"output":{"resultWrapper":"RegisterPublisherResult","type":"structure","members":{"PublisherId":{}}},"idempotent":true},"RegisterType":{"input":{"type":"structure","required":["TypeName","SchemaHandlerPackage"],"members":{"Type":{},"TypeName":{},"SchemaHandlerPackage":{},"LoggingConfig":{"shape":"S9"},"ExecutionRoleArn":{},"ClientRequestToken":{}}},"output":{"resultWrapper":"RegisterTypeResult","type":"structure","members":{"RegistrationToken":{}}},"idempotent":true},"RollbackStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"RoleARN":{},"ClientRequestToken":{},"RetainExceptOnCreate":{"type":"boolean"}}},"output":{"resultWrapper":"RollbackStackResult","type":"structure","members":{"StackId":{}}}},"SetStackPolicy":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"StackPolicyBody":{},"StackPolicyURL":{}}}},"SetTypeConfiguration":{"input":{"type":"structure","required":["Configuration"],"members":{"TypeArn":{},"Configuration":{},"ConfigurationAlias":{},"TypeName":{},"Type":{}}},"output":{"resultWrapper":"SetTypeConfigurationResult","type":"structure","members":{"ConfigurationArn":{}}}},"SetTypeDefaultVersion":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{}}},"output":{"resultWrapper":"SetTypeDefaultVersionResult","type":"structure","members":{}},"idempotent":true},"SignalResource":{"input":{"type":"structure","required":["StackName","LogicalResourceId","UniqueId","Status"],"members":{"StackName":{},"LogicalResourceId":{},"UniqueId":{},"Status":{}}}},"StartResourceScan":{"input":{"type":"structure","members":{"ClientRequestToken":{}}},"output":{"resultWrapper":"StartResourceScanResult","type":"structure","members":{"ResourceScanId":{}}}},"StopStackSetOperation":{"input":{"type":"structure","required":["StackSetName","OperationId"],"members":{"StackSetName":{},"OperationId":{},"CallAs":{}}},"output":{"resultWrapper":"StopStackSetOperationResult","type":"structure","members":{}}},"TestType":{"input":{"type":"structure","members":{"Arn":{},"Type":{},"TypeName":{},"VersionId":{},"LogDeliveryBucket":{}}},"output":{"resultWrapper":"TestTypeResult","type":"structure","members":{"TypeVersionArn":{}}},"idempotent":true},"UpdateGeneratedTemplate":{"input":{"type":"structure","required":["GeneratedTemplateName"],"members":{"GeneratedTemplateName":{},"NewGeneratedTemplateName":{},"AddResources":{"shape":"S2c"},"RemoveResources":{"type":"list","member":{}},"RefreshAllResources":{"type":"boolean"},"TemplateConfiguration":{"shape":"S2f"}}},"output":{"resultWrapper":"UpdateGeneratedTemplateResult","type":"structure","members":{"GeneratedTemplateId":{}}}},"UpdateStack":{"input":{"type":"structure","required":["StackName"],"members":{"StackName":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"StackPolicyDuringUpdateBody":{},"StackPolicyDuringUpdateURL":{},"Parameters":{"shape":"S1a"},"Capabilities":{"shape":"S1f"},"ResourceTypes":{"shape":"S1h"},"RoleARN":{},"RollbackConfiguration":{"shape":"S1j"},"StackPolicyBody":{},"StackPolicyURL":{},"NotificationARNs":{"shape":"S1p"},"Tags":{"shape":"S1r"},"DisableRollback":{"type":"boolean"},"ClientRequestToken":{},"RetainExceptOnCreate":{"type":"boolean"}}},"output":{"resultWrapper":"UpdateStackResult","type":"structure","members":{"StackId":{}}}},"UpdateStackInstances":{"input":{"type":"structure","required":["StackSetName","Regions"],"members":{"StackSetName":{},"Accounts":{"shape":"S2v"},"DeploymentTargets":{"shape":"S2x"},"Regions":{"shape":"S32"},"ParameterOverrides":{"shape":"S1a"},"OperationPreferences":{"shape":"S34"},"OperationId":{"idempotencyToken":true},"CallAs":{}}},"output":{"resultWrapper":"UpdateStackInstancesResult","type":"structure","members":{"OperationId":{}}}},"UpdateStackSet":{"input":{"type":"structure","required":["StackSetName"],"members":{"StackSetName":{},"Description":{},"TemplateBody":{},"TemplateURL":{},"UsePreviousTemplate":{"type":"boolean"},"Parameters":{"shape":"S1a"},"Capabilities":{"shape":"S1f"},"Tags":{"shape":"S1r"},"OperationPreferences":{"shape":"S34"},"AdministrationRoleARN":{},"ExecutionRoleName":{},"DeploymentTargets":{"shape":"S2x"},"PermissionModel":{},"AutoDeployment":{"shape":"S3g"},"OperationId":{"idempotencyToken":true},"Accounts":{"shape":"S2v"},"Regions":{"shape":"S32"},"CallAs":{},"ManagedExecution":{"shape":"S3j"}}},"output":{"resultWrapper":"UpdateStackSetResult","type":"structure","members":{"OperationId":{}}}},"UpdateTerminationProtection":{"input":{"type":"structure","required":["EnableTerminationProtection","StackName"],"members":{"EnableTerminationProtection":{"type":"boolean"},"StackName":{}}},"output":{"resultWrapper":"UpdateTerminationProtectionResult","type":"structure","members":{"StackId":{}}}},"ValidateTemplate":{"input":{"type":"structure","members":{"TemplateBody":{},"TemplateURL":{}}},"output":{"resultWrapper":"ValidateTemplateResult","type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"NoEcho":{"type":"boolean"},"Description":{}}}},"Description":{},"Capabilities":{"shape":"S1f"},"CapabilitiesReason":{},"DeclaredTransforms":{"shape":"Sap"}}}}},"shapes":{"S9":{"type":"structure","required":["LogRoleArn","LogGroupName"],"members":{"LogRoleArn":{},"LogGroupName":{}}},"Si":{"type":"structure","members":{"TypeArn":{},"TypeConfigurationAlias":{},"TypeConfigurationArn":{},"Type":{},"TypeName":{}}},"S1a":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"ParameterValue":{},"UsePreviousValue":{"type":"boolean"},"ResolvedValue":{}}}},"S1f":{"type":"list","member":{}},"S1h":{"type":"list","member":{}},"S1j":{"type":"structure","members":{"RollbackTriggers":{"type":"list","member":{"type":"structure","required":["Arn","Type"],"members":{"Arn":{},"Type":{}}}},"MonitoringTimeInMinutes":{"type":"integer"}}},"S1p":{"type":"list","member":{}},"S1r":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S22":{"type":"map","key":{},"value":{}},"S2c":{"type":"list","member":{"type":"structure","required":["ResourceType","ResourceIdentifier"],"members":{"ResourceType":{},"LogicalResourceId":{},"ResourceIdentifier":{"shape":"S22"}}}},"S2f":{"type":"structure","members":{"DeletionPolicy":{},"UpdateReplacePolicy":{}}},"S2v":{"type":"list","member":{}},"S2x":{"type":"structure","members":{"Accounts":{"shape":"S2v"},"AccountsUrl":{},"OrganizationalUnitIds":{"shape":"S2z"},"AccountFilterType":{}}},"S2z":{"type":"list","member":{}},"S32":{"type":"list","member":{}},"S34":{"type":"structure","members":{"RegionConcurrencyType":{},"RegionOrder":{"shape":"S32"},"FailureToleranceCount":{"type":"integer"},"FailureTolerancePercentage":{"type":"integer"},"MaxConcurrentCount":{"type":"integer"},"MaxConcurrentPercentage":{"type":"integer"},"ConcurrencyMode":{}}},"S3g":{"type":"structure","members":{"Enabled":{"type":"boolean"},"RetainStacksOnAccountRemoval":{"type":"boolean"}}},"S3j":{"type":"structure","members":{"Active":{"type":"boolean"}}},"S57":{"type":"structure","members":{"TypeHierarchy":{},"LogicalIdHierarchy":{}}},"S7f":{"type":"structure","members":{"DetailedStatus":{}}},"S7m":{"type":"structure","required":["StackResourceDriftStatus"],"members":{"StackResourceDriftStatus":{},"LastCheckTimestamp":{"type":"timestamp"}}},"S7p":{"type":"list","member":{}},"S7t":{"type":"structure","required":["StackId","LogicalResourceId","ResourceType","StackResourceDriftStatus","Timestamp"],"members":{"StackId":{},"LogicalResourceId":{},"PhysicalResourceId":{},"PhysicalResourceIdContext":{"shape":"S7u"},"ResourceType":{},"ExpectedProperties":{},"ActualProperties":{},"PropertyDifferences":{"shape":"S7z"},"StackResourceDriftStatus":{},"Timestamp":{"type":"timestamp"},"ModuleInfo":{"shape":"S57"}}},"S7u":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S7z":{"type":"list","member":{"type":"structure","required":["PropertyPath","ExpectedValue","ActualValue","DifferenceType"],"members":{"PropertyPath":{},"ExpectedValue":{},"ActualValue":{},"DifferenceType":{}}}},"S8c":{"type":"structure","members":{"DriftStatus":{},"DriftDetectionStatus":{},"LastDriftCheckTimestamp":{"type":"timestamp"},"TotalStackInstancesCount":{"type":"integer"},"DriftedStackInstancesCount":{"type":"integer"},"InSyncStackInstancesCount":{"type":"integer"},"InProgressStackInstancesCount":{"type":"integer"},"FailedStackInstancesCount":{"type":"integer"}}},"S8r":{"type":"structure","members":{"FailedStackInstancesCount":{"type":"integer"}}},"S9r":{"type":"list","member":{}},"Sap":{"type":"list","member":{}},"Sbk":{"type":"map","key":{},"value":{}},"Sbp":{"type":"structure","members":{"ResourceType":{},"ResourceIdentifier":{"shape":"Sbk"},"ManagedByStack":{"type":"boolean"}}}}}

/***/ }),
/* 411 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccountLimits":{"input_token":"NextToken","output_token":"NextToken","result_key":"AccountLimits"},"DescribeStackEvents":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackEvents"},"DescribeStackResourceDrifts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribeStackResources":{"result_key":"StackResources"},"DescribeStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"Stacks"},"ListChangeSets":{"input_token":"NextToken","output_token":"NextToken","result_key":"Summaries"},"ListExports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Exports"},"ListGeneratedTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListImports":{"input_token":"NextToken","output_token":"NextToken","result_key":"Imports"},"ListResourceScanRelatedResources":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RelatedResources"},"ListResourceScanResources":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Resources"},"ListResourceScans":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceScanSummaries"},"ListStackInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackResources":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackResourceSummaries"},"ListStackSetOperationResults":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackSetOperations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStackSets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListStacks":{"input_token":"NextToken","output_token":"NextToken","result_key":"StackSummaries"},"ListTypeRegistrations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTypeVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TypeSummaries"}}}

/***/ }),
/* 412 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StackExists":{"delay":5,"operation":"DescribeStacks","maxAttempts":20,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"ValidationError","state":"retry"}]},"StackCreateComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is CREATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"CREATE_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_IN_PROGRESS","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE_CLEANUP_IN_PROGRESS","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_FAILED","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_IN_PROGRESS","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE_CLEANUP_IN_PROGRESS","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackDeleteComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is DELETE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"DELETE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ValidationError","matcher":"error","state":"success"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"CREATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAny","state":"failure"}]},"StackUpdateComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is UPDATE_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackImportComplete":{"delay":30,"maxAttempts":120,"operation":"DescribeStacks","description":"Wait until stack status is IMPORT_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"IMPORT_COMPLETE","matcher":"pathAll","state":"success"},{"expected":"ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ROLLBACK_FAILED","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"argument":"Stacks[].StackStatus","expected":"IMPORT_ROLLBACK_IN_PROGRESS","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"IMPORT_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"expected":"IMPORT_ROLLBACK_COMPLETE","matcher":"pathAny","state":"failure","argument":"Stacks[].StackStatus"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"StackRollbackComplete":{"delay":30,"operation":"DescribeStacks","maxAttempts":120,"description":"Wait until stack status is UPDATE_ROLLBACK_COMPLETE.","acceptors":[{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_COMPLETE","matcher":"pathAll","state":"success"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"UPDATE_ROLLBACK_FAILED","matcher":"pathAny","state":"failure"},{"argument":"Stacks[].StackStatus","expected":"DELETE_FAILED","matcher":"pathAny","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"ChangeSetCreateComplete":{"delay":30,"operation":"DescribeChangeSet","maxAttempts":120,"description":"Wait until change set status is CREATE_COMPLETE.","acceptors":[{"argument":"Status","expected":"CREATE_COMPLETE","matcher":"path","state":"success"},{"argument":"Status","expected":"FAILED","matcher":"path","state":"failure"},{"expected":"ValidationError","matcher":"error","state":"failure"}]},"TypeRegistrationComplete":{"delay":30,"operation":"DescribeTypeRegistration","maxAttempts":120,"description":"Wait until type registration is COMPLETE.","acceptors":[{"argument":"ProgressStatus","expected":"COMPLETE","matcher":"path","state":"success"},{"argument":"ProgressStatus","expected":"FAILED","matcher":"path","state":"failure"}]}}}

/***/ }),
/* 413 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2016-11-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2016-11-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2016-11-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2016-11-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2016-11-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2016-11-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2016-11-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2016-11-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2016-11-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3a"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2016-11-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2016-11-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2016-11-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2016-11-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2016-11-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2016-11-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2016-11-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3a":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 414 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","output_token":"DistributionList.NextMarker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","output_token":"InvalidationList.NextMarker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","output_token":"StreamingDistributionList.NextMarker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-03-25","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-03-25"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-03-25/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-03-25/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-03-25/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S21"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateInvalidation":{"http":{"requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S28","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-03-25/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-03-25/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S2e"},"Tags":{"shape":"S21"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteServiceLinkedRole":{"http":{"method":"DELETE","requestUri":"/2017-03-25/service-linked-role/{RoleName}","responseCode":204},"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{"location":"uri","locationName":"RoleName"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-03-25/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2c"}},"payload":"Invalidation"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S2e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-03-25/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-03-25/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S3b"}},"payload":"DistributionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-03-25/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-03-25/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-03-25/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S21"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S21","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-03-25/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-03-25/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1s"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-03-25/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S2e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-03-25/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1a":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"}}}}}},"S1d":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1i":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1m":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1s":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"DistributionConfig":{"shape":"S7"}}},"S1u":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S21":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S28":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S28"}}},"S2e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S2f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S2f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S2i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1u"},"StreamingDistributionConfig":{"shape":"S2e"}}},"S3b":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1a"},"CustomErrorResponses":{"shape":"S1d"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1i"},"Restrictions":{"shape":"S1m"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-30","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2017-10-30"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2017-10-30/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2017-10-30/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2017-10-30/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2017-10-30/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2017-10-30/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2017-10-30/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2017-10-30/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2017-10-30/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2017-10-30/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2017-10-30/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2017-10-30/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2017-10-30/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2017-10-30/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2017-10-30/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2017-10-30/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2017-10-30/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2017-10-30/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2017-10-30/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2017-10-30/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2017-10-30/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2017-10-30/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2017-10-30/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2017-10-30/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 420 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 422 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-18","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-06-18"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-06-18/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-06-18/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-06-18/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S22"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-06-18/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-06-18/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S2v","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-06-18/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-06-18/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-06-18/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S35"},"Tags":{"shape":"S22"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-06-18/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-06-18/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S29"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S2z"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S31"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S35"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-06-18/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-06-18/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4g"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-06-18/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2n"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-06-18/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-06-18/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-06-18/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"Sy"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-06-18/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S22"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S22","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-06-18/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-06-18/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S1t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S29","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2k"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-06-18/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-06-18/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S31","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S33"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-06-18/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S35","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-06-18/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S39"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}},"So":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Sy":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S12":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S13"}}}}},"S13":{"type":"list","member":{"locationName":"Method"}},"S16":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1b":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"So"},"TrustedSigners":{"shape":"Sy"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S12"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S16"},"FieldLevelEncryptionId":{}}}}}},"S1e":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1j":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1n":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S1t":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"DistributionConfig":{"shape":"S7"}}},"S1v":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S22":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S29":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2a"},"ContentTypeProfileConfig":{"shape":"S2e"}}},"S2a":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2e":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2k":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S29"}}},"S2m":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2n"}}},"S2n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2m"}}},"S2v":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S2z":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S2v"}}},"S31":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S33":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S31"}}},"S35":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S36"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"Sy"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S36":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S39":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S1v"},"StreamingDistributionConfig":{"shape":"S35"}}},"S4g":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"DefaultCacheBehavior":{"shape":"Sn"},"CacheBehaviors":{"shape":"S1b"},"CustomErrorResponses":{"shape":"S1e"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1j"},"Restrictions":{"shape":"S1n"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 424 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 425 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-11-05","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2018-11-05"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2018-11-05/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2018-11-05/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2018-11-05/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2b"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2018-11-05/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2018-11-05/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S34","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2018-11-05/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2018-11-05/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2018-11-05/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3e"},"Tags":{"shape":"S2b"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2018-11-05/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2018-11-05/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S38"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3a"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2018-11-05/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2018-11-05/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4p"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2018-11-05/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S2w"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2018-11-05/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2018-11-05/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2018-11-05/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2018-11-05/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2b"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2b","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2018-11-05/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2018-11-05/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S22"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2i","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2018-11-05/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2v","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2018-11-05/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3a","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2018-11-05/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3e","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2018-11-05/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1s":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1w":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S22":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"DistributionConfig":{"shape":"S7"}}},"S24":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2b":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2i":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2j"},"ContentTypeProfileConfig":{"shape":"S2n"}}},"S2j":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2n":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2t":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2i"}}},"S2v":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S2w"}}},"S2w":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S32":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2v"}}},"S34":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S38":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S34"}}},"S3a":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3c":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3a"}}},"S3e":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3f"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3f":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3i":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S24"},"StreamingDistributionConfig":{"shape":"S3e"}}},"S4p":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1s"},"Restrictions":{"shape":"S1w"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}}}}}}}

/***/ }),
/* 426 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 427 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":25,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 428 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-03-26","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2019-03-26"},"operations":{"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2019-03-26/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateDistribution":{"http":{"requestUri":"/2019-03-26/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2019-03-26/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"S7"},"Tags":{"shape":"S2f"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2019-03-26/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2019-03-26/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateInvalidation":{"http":{"requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S38","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"CreatePublicKey":{"http":{"requestUri":"/2019-03-26/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2019-03-26/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2019-03-26/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S3i"},"Tags":{"shape":"S2f"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2019-03-26/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2019-03-26/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"S7"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S2m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S3c"}},"payload":"Invalidation"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S3i"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2019-03-26/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2019-03-26/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"S4t"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2019-03-26/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S30"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2019-03-26/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2019-03-26/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2019-03-26/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"TrustedSigners":{"shape":"S17"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2019-03-26/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S2f"}},"payload":"Tags"}},"TagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S2f","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}}},"payload":"Tags"}},"UntagResource":{"http":{"requestUri":"/2019-03-26/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2019-03-26/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S2","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S5"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"S7","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S23"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S2m","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S2x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2019-03-26/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S2z","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S36"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2019-03-26/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S3e","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S3g"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2019-03-26/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S3i","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2019-03-26/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S3m"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S2":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S5":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S2"}}},"S7":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"S8"},"DefaultRootObject":{},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{"type":"string","sensitive":true},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"}}},"S8":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sb":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}},"ConnectionAttempts":{"type":"integer"},"ConnectionTimeout":{"type":"integer"}}}}}},"Sn":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"Sw":{"type":"structure","required":["TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}},"Sx":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"Headers":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S17":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1c"}}}}},"S1c":{"type":"list","member":{"locationName":"Method"}},"S1f":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1k":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ForwardedValues","TrustedSigners","ViewerProtocolPolicy","MinTTL"],"members":{"PathPattern":{},"TargetOriginId":{},"ForwardedValues":{"shape":"Sx"},"TrustedSigners":{"shape":"S17"},"ViewerProtocolPolicy":{},"MinTTL":{"type":"long"},"AllowedMethods":{"shape":"S1b"},"SmoothStreaming":{"type":"boolean"},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1f"},"FieldLevelEncryptionId":{}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S1t":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S1x":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S23":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","ActiveTrustedSigners","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"DistributionConfig":{"shape":"S7"},"AliasICPRecordals":{"shape":"S2a"}}},"S25":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}}}}}}},"S2a":{"type":"list","member":{"locationName":"AliasICPRecordal","type":"structure","members":{"CNAME":{},"ICPRecordalStatus":{}}}},"S2f":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S2m":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S2n"},"ContentTypeProfileConfig":{"shape":"S2r"}}},"S2n":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S2r":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S2x":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S2m"}}},"S2z":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S30"}}},"S30":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S36":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S2z"}}},"S38":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S3c":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S38"}}},"S3e":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S3g":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S3e"}}},"S3i":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S3j"},"Aliases":{"shape":"S8"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S17"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S3j":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S3m":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S25"},"StreamingDistributionConfig":{"shape":"S3i"}}},"S4t":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"S8"},"Origins":{"shape":"Sb"},"OriginGroups":{"shape":"Sn"},"DefaultCacheBehavior":{"shape":"Sw"},"CacheBehaviors":{"shape":"S1k"},"CustomErrorResponses":{"shape":"S1n"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S1t"},"Restrictions":{"shape":"S1x"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"},"AliasICPRecordals":{"shape":"S2a"}}}}}}}}

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 430 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":35,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 431 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-05-31","endpointPrefix":"cloudfront","globalEndpoint":"cloudfront.amazonaws.com","protocol":"rest-xml","protocols":["rest-xml"],"serviceAbbreviation":"CloudFront","serviceFullName":"Amazon CloudFront","serviceId":"CloudFront","signatureVersion":"v4","uid":"cloudfront-2020-05-31"},"operations":{"AssociateAlias":{"http":{"method":"PUT","requestUri":"/2020-05-31/distribution/{TargetDistributionId}/associate-alias","responseCode":200},"input":{"type":"structure","required":["TargetDistributionId","Alias"],"members":{"TargetDistributionId":{"location":"uri","locationName":"TargetDistributionId"},"Alias":{"location":"querystring","locationName":"Alias"}}}},"CopyDistribution":{"http":{"requestUri":"/2020-05-31/distribution/{PrimaryDistributionId}/copy","responseCode":201},"input":{"locationName":"CopyDistributionRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["PrimaryDistributionId","CallerReference"],"members":{"PrimaryDistributionId":{"location":"uri","locationName":"PrimaryDistributionId"},"Staging":{"location":"header","locationName":"Staging","type":"boolean"},"IfMatch":{"location":"header","locationName":"If-Match"},"CallerReference":{},"Enabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S6"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateCachePolicy":{"http":{"requestUri":"/2020-05-31/cache-policy","responseCode":201},"input":{"type":"structure","required":["CachePolicyConfig"],"members":{"CachePolicyConfig":{"shape":"S2n","locationName":"CachePolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"CachePolicyConfig"},"output":{"type":"structure","members":{"CachePolicy":{"shape":"S2y"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicy"}},"CreateCloudFrontOriginAccessIdentity":{"http":{"requestUri":"/2020-05-31/origin-access-identity/cloudfront","responseCode":201},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S30","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S32"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"CreateContinuousDeploymentPolicy":{"http":{"requestUri":"/2020-05-31/continuous-deployment-policy","responseCode":201},"input":{"type":"structure","required":["ContinuousDeploymentPolicyConfig"],"members":{"ContinuousDeploymentPolicyConfig":{"shape":"S34","locationName":"ContinuousDeploymentPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"ContinuousDeploymentPolicyConfig"},"output":{"type":"structure","members":{"ContinuousDeploymentPolicy":{"shape":"S3e"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ContinuousDeploymentPolicy"}},"CreateDistribution":{"http":{"requestUri":"/2020-05-31/distribution","responseCode":201},"input":{"type":"structure","required":["DistributionConfig"],"members":{"DistributionConfig":{"shape":"Sh","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S6"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateDistributionWithTags":{"http":{"requestUri":"/2020-05-31/distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["DistributionConfigWithTags"],"members":{"DistributionConfigWithTags":{"locationName":"DistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["DistributionConfig","Tags"],"members":{"DistributionConfig":{"shape":"Sh"},"Tags":{"shape":"S3j"}}}},"payload":"DistributionConfigWithTags"},"output":{"type":"structure","members":{"Distribution":{"shape":"S6"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"CreateFieldLevelEncryptionConfig":{"http":{"requestUri":"/2020-05-31/field-level-encryption","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionConfig"],"members":{"FieldLevelEncryptionConfig":{"shape":"S3q","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S41"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"CreateFieldLevelEncryptionProfile":{"http":{"requestUri":"/2020-05-31/field-level-encryption-profile","responseCode":201},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S43","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S4a"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"CreateFunction":{"http":{"requestUri":"/2020-05-31/function","responseCode":201},"input":{"locationName":"CreateFunctionRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["Name","FunctionConfig","FunctionCode"],"members":{"Name":{},"FunctionConfig":{"shape":"S4d"},"FunctionCode":{"shape":"S4j"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S4l"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FunctionSummary"}},"CreateInvalidation":{"http":{"requestUri":"/2020-05-31/distribution/{DistributionId}/invalidation","responseCode":201},"input":{"type":"structure","required":["DistributionId","InvalidationBatch"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"InvalidationBatch":{"shape":"S4p","locationName":"InvalidationBatch","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"InvalidationBatch"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"},"Invalidation":{"shape":"S4t"}},"payload":"Invalidation"}},"CreateKeyGroup":{"http":{"requestUri":"/2020-05-31/key-group","responseCode":201},"input":{"type":"structure","required":["KeyGroupConfig"],"members":{"KeyGroupConfig":{"shape":"S4v","locationName":"KeyGroupConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"KeyGroupConfig"},"output":{"type":"structure","members":{"KeyGroup":{"shape":"S4y"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroup"}},"CreateKeyValueStore":{"http":{"requestUri":"/2020-05-31/key-value-store/","responseCode":201},"input":{"locationName":"CreateKeyValueStoreRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["Name"],"members":{"Name":{},"Comment":{},"ImportSource":{"type":"structure","required":["SourceType","SourceARN"],"members":{"SourceType":{},"SourceARN":{}}}}},"output":{"type":"structure","members":{"KeyValueStore":{"shape":"S55"},"ETag":{"location":"header","locationName":"ETag"},"Location":{"location":"header","locationName":"Location"}},"payload":"KeyValueStore"}},"CreateMonitoringSubscription":{"http":{"requestUri":"/2020-05-31/distributions/{DistributionId}/monitoring-subscription/"},"input":{"type":"structure","required":["MonitoringSubscription","DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"MonitoringSubscription":{"shape":"S57","locationName":"MonitoringSubscription","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"MonitoringSubscription"},"output":{"type":"structure","members":{"MonitoringSubscription":{"shape":"S57"}},"payload":"MonitoringSubscription"}},"CreateOriginAccessControl":{"http":{"requestUri":"/2020-05-31/origin-access-control","responseCode":201},"input":{"type":"structure","required":["OriginAccessControlConfig"],"members":{"OriginAccessControlConfig":{"shape":"S5c","locationName":"OriginAccessControlConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"OriginAccessControlConfig"},"output":{"type":"structure","members":{"OriginAccessControl":{"shape":"S5h"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginAccessControl"}},"CreateOriginRequestPolicy":{"http":{"requestUri":"/2020-05-31/origin-request-policy","responseCode":201},"input":{"type":"structure","required":["OriginRequestPolicyConfig"],"members":{"OriginRequestPolicyConfig":{"shape":"S5j","locationName":"OriginRequestPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"OriginRequestPolicyConfig"},"output":{"type":"structure","members":{"OriginRequestPolicy":{"shape":"S5r"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicy"}},"CreatePublicKey":{"http":{"requestUri":"/2020-05-31/public-key","responseCode":201},"input":{"type":"structure","required":["PublicKeyConfig"],"members":{"PublicKeyConfig":{"shape":"S5t","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S5v"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"CreateRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/realtime-log-config","responseCode":201},"input":{"locationName":"CreateRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["EndPoints","Fields","Name","SamplingRate"],"members":{"EndPoints":{"shape":"S5x"},"Fields":{"shape":"S60"},"Name":{},"SamplingRate":{"type":"long"}}},"output":{"type":"structure","members":{"RealtimeLogConfig":{"shape":"S62"}}}},"CreateResponseHeadersPolicy":{"http":{"requestUri":"/2020-05-31/response-headers-policy","responseCode":201},"input":{"type":"structure","required":["ResponseHeadersPolicyConfig"],"members":{"ResponseHeadersPolicyConfig":{"shape":"S64","locationName":"ResponseHeadersPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"ResponseHeadersPolicyConfig"},"output":{"type":"structure","members":{"ResponseHeadersPolicy":{"shape":"S6x"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicy"}},"CreateStreamingDistribution":{"http":{"requestUri":"/2020-05-31/streaming-distribution","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfig"],"members":{"StreamingDistributionConfig":{"shape":"S6z","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S73"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"CreateStreamingDistributionWithTags":{"http":{"requestUri":"/2020-05-31/streaming-distribution?WithTags","responseCode":201},"input":{"type":"structure","required":["StreamingDistributionConfigWithTags"],"members":{"StreamingDistributionConfigWithTags":{"locationName":"StreamingDistributionConfigWithTags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["StreamingDistributionConfig","Tags"],"members":{"StreamingDistributionConfig":{"shape":"S6z"},"Tags":{"shape":"S3j"}}}},"payload":"StreamingDistributionConfigWithTags"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S73"},"Location":{"location":"header","locationName":"Location"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"DeleteCachePolicy":{"http":{"method":"DELETE","requestUri":"/2020-05-31/cache-policy/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteCloudFrontOriginAccessIdentity":{"http":{"method":"DELETE","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteContinuousDeploymentPolicy":{"http":{"method":"DELETE","requestUri":"/2020-05-31/continuous-deployment-policy/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteDistribution":{"http":{"method":"DELETE","requestUri":"/2020-05-31/distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionConfig":{"http":{"method":"DELETE","requestUri":"/2020-05-31/field-level-encryption/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFieldLevelEncryptionProfile":{"http":{"method":"DELETE","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2020-05-31/function/{Name}","responseCode":204},"input":{"type":"structure","required":["IfMatch","Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteKeyGroup":{"http":{"method":"DELETE","requestUri":"/2020-05-31/key-group/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteKeyValueStore":{"http":{"method":"DELETE","requestUri":"/2020-05-31/key-value-store/{Name}","responseCode":204},"input":{"type":"structure","required":["IfMatch","Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"}}},"idempotent":true},"DeleteMonitoringSubscription":{"http":{"method":"DELETE","requestUri":"/2020-05-31/distributions/{DistributionId}/monitoring-subscription/"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"}}},"output":{"type":"structure","members":{}}},"DeleteOriginAccessControl":{"http":{"method":"DELETE","requestUri":"/2020-05-31/origin-access-control/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteOriginRequestPolicy":{"http":{"method":"DELETE","requestUri":"/2020-05-31/origin-request-policy/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeletePublicKey":{"http":{"method":"DELETE","requestUri":"/2020-05-31/public-key/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/delete-realtime-log-config/","responseCode":204},"input":{"locationName":"DeleteRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Name":{},"ARN":{}}}},"DeleteResponseHeadersPolicy":{"http":{"method":"DELETE","requestUri":"/2020-05-31/response-headers-policy/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DeleteStreamingDistribution":{"http":{"method":"DELETE","requestUri":"/2020-05-31/streaming-distribution/{Id}","responseCode":204},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}}}},"DescribeFunction":{"http":{"method":"GET","requestUri":"/2020-05-31/function/{Name}/describe"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"Stage":{"location":"querystring","locationName":"Stage"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S4l"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FunctionSummary"}},"DescribeKeyValueStore":{"http":{"method":"GET","requestUri":"/2020-05-31/key-value-store/{Name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"KeyValueStore":{"shape":"S55"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyValueStore"}},"GetCachePolicy":{"http":{"method":"GET","requestUri":"/2020-05-31/cache-policy/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CachePolicy":{"shape":"S2y"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicy"}},"GetCachePolicyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/cache-policy/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CachePolicyConfig":{"shape":"S2n"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicyConfig"}},"GetCloudFrontOriginAccessIdentity":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"GetCloudFrontOriginAccessIdentityConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S30"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentityConfig"}},"GetContinuousDeploymentPolicy":{"http":{"method":"GET","requestUri":"/2020-05-31/continuous-deployment-policy/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"ContinuousDeploymentPolicy":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ContinuousDeploymentPolicy"}},"GetContinuousDeploymentPolicyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/continuous-deployment-policy/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"ContinuousDeploymentPolicyConfig":{"shape":"S34"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ContinuousDeploymentPolicyConfig"}},"GetDistribution":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S6"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"GetDistributionConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"DistributionConfig":{"shape":"Sh"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"DistributionConfig"}},"GetFieldLevelEncryption":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S41"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"GetFieldLevelEncryptionConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionConfig":{"shape":"S3q"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionConfig"}},"GetFieldLevelEncryptionProfile":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S4a"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"GetFieldLevelEncryptionProfileConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileConfig":{"shape":"S43"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfileConfig"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2020-05-31/function/{Name}"},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"Stage":{"location":"querystring","locationName":"Stage"}}},"output":{"type":"structure","members":{"FunctionCode":{"shape":"S4j"},"ETag":{"location":"header","locationName":"ETag"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"FunctionCode"}},"GetInvalidation":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{DistributionId}/invalidation/{Id}"},"input":{"type":"structure","required":["DistributionId","Id"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Invalidation":{"shape":"S4t"}},"payload":"Invalidation"}},"GetKeyGroup":{"http":{"method":"GET","requestUri":"/2020-05-31/key-group/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"KeyGroup":{"shape":"S4y"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroup"}},"GetKeyGroupConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/key-group/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"KeyGroupConfig":{"shape":"S4v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroupConfig"}},"GetMonitoringSubscription":{"http":{"method":"GET","requestUri":"/2020-05-31/distributions/{DistributionId}/monitoring-subscription/"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"}}},"output":{"type":"structure","members":{"MonitoringSubscription":{"shape":"S57"}},"payload":"MonitoringSubscription"}},"GetOriginAccessControl":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-control/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"OriginAccessControl":{"shape":"S5h"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginAccessControl"}},"GetOriginAccessControlConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-control/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"OriginAccessControlConfig":{"shape":"S5c"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginAccessControlConfig"}},"GetOriginRequestPolicy":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-request-policy/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"OriginRequestPolicy":{"shape":"S5r"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicy"}},"GetOriginRequestPolicyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-request-policy/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"OriginRequestPolicyConfig":{"shape":"S5j"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicyConfig"}},"GetPublicKey":{"http":{"method":"GET","requestUri":"/2020-05-31/public-key/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKey":{"shape":"S5v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"GetPublicKeyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/public-key/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"PublicKeyConfig":{"shape":"S5t"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKeyConfig"}},"GetRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/get-realtime-log-config/"},"input":{"locationName":"GetRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Name":{},"ARN":{}}},"output":{"type":"structure","members":{"RealtimeLogConfig":{"shape":"S62"}}}},"GetResponseHeadersPolicy":{"http":{"method":"GET","requestUri":"/2020-05-31/response-headers-policy/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"ResponseHeadersPolicy":{"shape":"S6x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicy"}},"GetResponseHeadersPolicyConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/response-headers-policy/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"ResponseHeadersPolicyConfig":{"shape":"S64"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicyConfig"}},"GetStreamingDistribution":{"http":{"method":"GET","requestUri":"/2020-05-31/streaming-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S73"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}},"GetStreamingDistributionConfig":{"http":{"method":"GET","requestUri":"/2020-05-31/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"StreamingDistributionConfig":{"shape":"S6z"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistributionConfig"}},"ListCachePolicies":{"http":{"method":"GET","requestUri":"/2020-05-31/cache-policy"},"input":{"type":"structure","members":{"Type":{"location":"querystring","locationName":"Type"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CachePolicyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CachePolicySummary","type":"structure","required":["Type","CachePolicy"],"members":{"Type":{},"CachePolicy":{"shape":"S2y"}}}}}}},"payload":"CachePolicyList"}},"ListCloudFrontOriginAccessIdentities":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-identity/cloudfront"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentityList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CloudFrontOriginAccessIdentitySummary","type":"structure","required":["Id","S3CanonicalUserId","Comment"],"members":{"Id":{},"S3CanonicalUserId":{},"Comment":{}}}}}}},"payload":"CloudFrontOriginAccessIdentityList"}},"ListConflictingAliases":{"http":{"method":"GET","requestUri":"/2020-05-31/conflicting-alias","responseCode":200},"input":{"type":"structure","required":["DistributionId","Alias"],"members":{"DistributionId":{"location":"querystring","locationName":"DistributionId"},"Alias":{"location":"querystring","locationName":"Alias"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"ConflictingAliasesList":{"type":"structure","members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ConflictingAlias","type":"structure","members":{"Alias":{},"DistributionId":{},"AccountId":{}}}}}}},"payload":"ConflictingAliasesList"}},"ListContinuousDeploymentPolicies":{"http":{"method":"GET","requestUri":"/2020-05-31/continuous-deployment-policy"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"ContinuousDeploymentPolicyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContinuousDeploymentPolicySummary","type":"structure","required":["ContinuousDeploymentPolicy"],"members":{"ContinuousDeploymentPolicy":{"shape":"S3e"}}}}}}},"payload":"ContinuousDeploymentPolicyList"}},"ListDistributions":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"Sa2"}},"payload":"DistributionList"}},"ListDistributionsByCachePolicyId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByCachePolicyId/{CachePolicyId}"},"input":{"type":"structure","required":["CachePolicyId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"CachePolicyId":{"location":"uri","locationName":"CachePolicyId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"Sa7"}},"payload":"DistributionIdList"}},"ListDistributionsByKeyGroup":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByKeyGroupId/{KeyGroupId}"},"input":{"type":"structure","required":["KeyGroupId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"KeyGroupId":{"location":"uri","locationName":"KeyGroupId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"Sa7"}},"payload":"DistributionIdList"}},"ListDistributionsByOriginRequestPolicyId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByOriginRequestPolicyId/{OriginRequestPolicyId}"},"input":{"type":"structure","required":["OriginRequestPolicyId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"OriginRequestPolicyId":{"location":"uri","locationName":"OriginRequestPolicyId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"Sa7"}},"payload":"DistributionIdList"}},"ListDistributionsByRealtimeLogConfig":{"http":{"requestUri":"/2020-05-31/distributionsByRealtimeLogConfig/"},"input":{"locationName":"ListDistributionsByRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Marker":{},"MaxItems":{},"RealtimeLogConfigName":{},"RealtimeLogConfigArn":{}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"Sa2"}},"payload":"DistributionList"}},"ListDistributionsByResponseHeadersPolicyId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByResponseHeadersPolicyId/{ResponseHeadersPolicyId}"},"input":{"type":"structure","required":["ResponseHeadersPolicyId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"ResponseHeadersPolicyId":{"location":"uri","locationName":"ResponseHeadersPolicyId"}}},"output":{"type":"structure","members":{"DistributionIdList":{"shape":"Sa7"}},"payload":"DistributionIdList"}},"ListDistributionsByWebACLId":{"http":{"method":"GET","requestUri":"/2020-05-31/distributionsByWebACLId/{WebACLId}"},"input":{"type":"structure","required":["WebACLId"],"members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"WebACLId":{"location":"uri","locationName":"WebACLId"}}},"output":{"type":"structure","members":{"DistributionList":{"shape":"Sa2"}},"payload":"DistributionList"}},"ListFieldLevelEncryptionConfigs":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionSummary","type":"structure","required":["Id","LastModifiedTime"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Comment":{},"QueryArgProfileConfig":{"shape":"S3r"},"ContentTypeProfileConfig":{"shape":"S3v"}}}}}}},"payload":"FieldLevelEncryptionList"}},"ListFieldLevelEncryptionProfiles":{"http":{"method":"GET","requestUri":"/2020-05-31/field-level-encryption-profile"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"FieldLevelEncryptionProfileList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldLevelEncryptionProfileSummary","type":"structure","required":["Id","LastModifiedTime","Name","EncryptionEntities"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"Name":{},"EncryptionEntities":{"shape":"S44"},"Comment":{}}}}}}},"payload":"FieldLevelEncryptionProfileList"}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2020-05-31/function"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"Stage":{"location":"querystring","locationName":"Stage"}}},"output":{"type":"structure","members":{"FunctionList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"shape":"S4l","locationName":"FunctionSummary"}}}}},"payload":"FunctionList"}},"ListInvalidations":{"http":{"method":"GET","requestUri":"/2020-05-31/distribution/{DistributionId}/invalidation"},"input":{"type":"structure","required":["DistributionId"],"members":{"DistributionId":{"location":"uri","locationName":"DistributionId"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"InvalidationList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"InvalidationSummary","type":"structure","required":["Id","CreateTime","Status"],"members":{"Id":{},"CreateTime":{"type":"timestamp"},"Status":{}}}}}}},"payload":"InvalidationList"}},"ListKeyGroups":{"http":{"method":"GET","requestUri":"/2020-05-31/key-group"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"KeyGroupList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyGroupSummary","type":"structure","required":["KeyGroup"],"members":{"KeyGroup":{"shape":"S4y"}}}}}}},"payload":"KeyGroupList"}},"ListKeyValueStores":{"http":{"method":"GET","requestUri":"/2020-05-31/key-value-store"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"},"Status":{"location":"querystring","locationName":"Status"}}},"output":{"type":"structure","members":{"KeyValueStoreList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"shape":"S55","locationName":"KeyValueStore"}}}}},"payload":"KeyValueStoreList"}},"ListOriginAccessControls":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-access-control"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"OriginAccessControlList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginAccessControlSummary","type":"structure","required":["Id","Description","Name","SigningProtocol","SigningBehavior","OriginAccessControlOriginType"],"members":{"Id":{},"Description":{},"Name":{},"SigningProtocol":{},"SigningBehavior":{},"OriginAccessControlOriginType":{}}}}}}},"payload":"OriginAccessControlList"}},"ListOriginRequestPolicies":{"http":{"method":"GET","requestUri":"/2020-05-31/origin-request-policy"},"input":{"type":"structure","members":{"Type":{"location":"querystring","locationName":"Type"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"OriginRequestPolicyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginRequestPolicySummary","type":"structure","required":["Type","OriginRequestPolicy"],"members":{"Type":{},"OriginRequestPolicy":{"shape":"S5r"}}}}}}},"payload":"OriginRequestPolicyList"}},"ListPublicKeys":{"http":{"method":"GET","requestUri":"/2020-05-31/public-key"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"PublicKeySummary","type":"structure","required":["Id","Name","CreatedTime","EncodedKey"],"members":{"Id":{},"Name":{},"CreatedTime":{"type":"timestamp"},"EncodedKey":{},"Comment":{}}}}}}},"payload":"PublicKeyList"}},"ListRealtimeLogConfigs":{"http":{"method":"GET","requestUri":"/2020-05-31/realtime-log-config"},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems"},"Marker":{"location":"querystring","locationName":"Marker"}}},"output":{"type":"structure","members":{"RealtimeLogConfigs":{"type":"structure","required":["MaxItems","IsTruncated","Marker"],"members":{"MaxItems":{"type":"integer"},"Items":{"type":"list","member":{"shape":"S62"}},"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{}}}},"payload":"RealtimeLogConfigs"}},"ListResponseHeadersPolicies":{"http":{"method":"GET","requestUri":"/2020-05-31/response-headers-policy"},"input":{"type":"structure","members":{"Type":{"location":"querystring","locationName":"Type"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"ResponseHeadersPolicyList":{"type":"structure","required":["MaxItems","Quantity"],"members":{"NextMarker":{},"MaxItems":{"type":"integer"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ResponseHeadersPolicySummary","type":"structure","required":["Type","ResponseHeadersPolicy"],"members":{"Type":{},"ResponseHeadersPolicy":{"shape":"S6x"}}}}}}},"payload":"ResponseHeadersPolicyList"}},"ListStreamingDistributions":{"http":{"method":"GET","requestUri":"/2020-05-31/streaming-distribution"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems"}}},"output":{"type":"structure","members":{"StreamingDistributionList":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StreamingDistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","S3Origin","Aliases","TrustedSigners","Comment","PriceClass","Enabled"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"S3Origin":{"shape":"S70"},"Aliases":{"shape":"Si"},"TrustedSigners":{"shape":"S19"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"}}}}}}},"payload":"StreamingDistributionList"}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2020-05-31/tagging"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"querystring","locationName":"Resource"}}},"output":{"type":"structure","required":["Tags"],"members":{"Tags":{"shape":"S3j"}},"payload":"Tags"}},"PublishFunction":{"http":{"requestUri":"/2020-05-31/function/{Name}/publish"},"input":{"type":"structure","required":["Name","IfMatch"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S4l"}},"payload":"FunctionSummary"}},"TagResource":{"http":{"requestUri":"/2020-05-31/tagging?Operation=Tag","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"Tags":{"shape":"S3j","locationName":"Tags","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}}},"payload":"Tags"}},"TestFunction":{"http":{"requestUri":"/2020-05-31/function/{Name}/test"},"input":{"locationName":"TestFunctionRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["Name","IfMatch","EventObject"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"},"Stage":{},"EventObject":{"type":"blob","sensitive":true}}},"output":{"type":"structure","members":{"TestResult":{"type":"structure","members":{"FunctionSummary":{"shape":"S4l"},"ComputeUtilization":{},"FunctionExecutionLogs":{"type":"list","member":{},"sensitive":true},"FunctionErrorMessage":{"shape":"Sq"},"FunctionOutput":{"shape":"Sq"}}}},"payload":"TestResult"}},"UntagResource":{"http":{"requestUri":"/2020-05-31/tagging?Operation=Untag","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"querystring","locationName":"Resource"},"TagKeys":{"locationName":"TagKeys","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Key"}}}}},"payload":"TagKeys"}},"UpdateCachePolicy":{"http":{"method":"PUT","requestUri":"/2020-05-31/cache-policy/{Id}"},"input":{"type":"structure","required":["CachePolicyConfig","Id"],"members":{"CachePolicyConfig":{"shape":"S2n","locationName":"CachePolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CachePolicyConfig"},"output":{"type":"structure","members":{"CachePolicy":{"shape":"S2y"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CachePolicy"}},"UpdateCloudFrontOriginAccessIdentity":{"http":{"method":"PUT","requestUri":"/2020-05-31/origin-access-identity/cloudfront/{Id}/config"},"input":{"type":"structure","required":["CloudFrontOriginAccessIdentityConfig","Id"],"members":{"CloudFrontOriginAccessIdentityConfig":{"shape":"S30","locationName":"CloudFrontOriginAccessIdentityConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"CloudFrontOriginAccessIdentityConfig"},"output":{"type":"structure","members":{"CloudFrontOriginAccessIdentity":{"shape":"S32"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"CloudFrontOriginAccessIdentity"}},"UpdateContinuousDeploymentPolicy":{"http":{"method":"PUT","requestUri":"/2020-05-31/continuous-deployment-policy/{Id}"},"input":{"type":"structure","required":["ContinuousDeploymentPolicyConfig","Id"],"members":{"ContinuousDeploymentPolicyConfig":{"shape":"S34","locationName":"ContinuousDeploymentPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"ContinuousDeploymentPolicyConfig"},"output":{"type":"structure","members":{"ContinuousDeploymentPolicy":{"shape":"S3e"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ContinuousDeploymentPolicy"}},"UpdateDistribution":{"http":{"method":"PUT","requestUri":"/2020-05-31/distribution/{Id}/config"},"input":{"type":"structure","required":["DistributionConfig","Id"],"members":{"DistributionConfig":{"shape":"Sh","locationName":"DistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"DistributionConfig"},"output":{"type":"structure","members":{"Distribution":{"shape":"S6"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateDistributionWithStagingConfig":{"http":{"method":"PUT","requestUri":"/2020-05-31/distribution/{Id}/promote-staging-config"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"StagingDistributionId":{"location":"querystring","locationName":"StagingDistributionId"},"IfMatch":{"location":"header","locationName":"If-Match"}}},"output":{"type":"structure","members":{"Distribution":{"shape":"S6"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"Distribution"}},"UpdateFieldLevelEncryptionConfig":{"http":{"method":"PUT","requestUri":"/2020-05-31/field-level-encryption/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionConfig","Id"],"members":{"FieldLevelEncryptionConfig":{"shape":"S3q","locationName":"FieldLevelEncryptionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionConfig"},"output":{"type":"structure","members":{"FieldLevelEncryption":{"shape":"S41"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryption"}},"UpdateFieldLevelEncryptionProfile":{"http":{"method":"PUT","requestUri":"/2020-05-31/field-level-encryption-profile/{Id}/config"},"input":{"type":"structure","required":["FieldLevelEncryptionProfileConfig","Id"],"members":{"FieldLevelEncryptionProfileConfig":{"shape":"S43","locationName":"FieldLevelEncryptionProfileConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"FieldLevelEncryptionProfileConfig"},"output":{"type":"structure","members":{"FieldLevelEncryptionProfile":{"shape":"S4a"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"FieldLevelEncryptionProfile"}},"UpdateFunction":{"http":{"method":"PUT","requestUri":"/2020-05-31/function/{Name}"},"input":{"locationName":"UpdateFunctionRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["IfMatch","FunctionConfig","FunctionCode","Name"],"members":{"Name":{"location":"uri","locationName":"Name"},"IfMatch":{"location":"header","locationName":"If-Match"},"FunctionConfig":{"shape":"S4d"},"FunctionCode":{"shape":"S4j"}}},"output":{"type":"structure","members":{"FunctionSummary":{"shape":"S4l"},"ETag":{"location":"header","locationName":"ETtag"}},"payload":"FunctionSummary"}},"UpdateKeyGroup":{"http":{"method":"PUT","requestUri":"/2020-05-31/key-group/{Id}"},"input":{"type":"structure","required":["KeyGroupConfig","Id"],"members":{"KeyGroupConfig":{"shape":"S4v","locationName":"KeyGroupConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"KeyGroupConfig"},"output":{"type":"structure","members":{"KeyGroup":{"shape":"S4y"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyGroup"}},"UpdateKeyValueStore":{"http":{"method":"PUT","requestUri":"/2020-05-31/key-value-store/{Name}"},"input":{"locationName":"UpdateKeyValueStoreRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","required":["Name","Comment","IfMatch"],"members":{"Name":{"location":"uri","locationName":"Name"},"Comment":{},"IfMatch":{"location":"header","locationName":"If-Match"}}},"output":{"type":"structure","members":{"KeyValueStore":{"shape":"S55"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"KeyValueStore"},"idempotent":true},"UpdateOriginAccessControl":{"http":{"method":"PUT","requestUri":"/2020-05-31/origin-access-control/{Id}/config"},"input":{"type":"structure","required":["OriginAccessControlConfig","Id"],"members":{"OriginAccessControlConfig":{"shape":"S5c","locationName":"OriginAccessControlConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"OriginAccessControlConfig"},"output":{"type":"structure","members":{"OriginAccessControl":{"shape":"S5h"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginAccessControl"}},"UpdateOriginRequestPolicy":{"http":{"method":"PUT","requestUri":"/2020-05-31/origin-request-policy/{Id}"},"input":{"type":"structure","required":["OriginRequestPolicyConfig","Id"],"members":{"OriginRequestPolicyConfig":{"shape":"S5j","locationName":"OriginRequestPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"OriginRequestPolicyConfig"},"output":{"type":"structure","members":{"OriginRequestPolicy":{"shape":"S5r"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"OriginRequestPolicy"}},"UpdatePublicKey":{"http":{"method":"PUT","requestUri":"/2020-05-31/public-key/{Id}/config"},"input":{"type":"structure","required":["PublicKeyConfig","Id"],"members":{"PublicKeyConfig":{"shape":"S5t","locationName":"PublicKeyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"PublicKeyConfig"},"output":{"type":"structure","members":{"PublicKey":{"shape":"S5v"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"PublicKey"}},"UpdateRealtimeLogConfig":{"http":{"method":"PUT","requestUri":"/2020-05-31/realtime-log-config/"},"input":{"locationName":"UpdateRealtimeLogConfigRequest","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"},"type":"structure","members":{"EndPoints":{"shape":"S5x"},"Fields":{"shape":"S60"},"Name":{},"ARN":{},"SamplingRate":{"type":"long"}}},"output":{"type":"structure","members":{"RealtimeLogConfig":{"shape":"S62"}}}},"UpdateResponseHeadersPolicy":{"http":{"method":"PUT","requestUri":"/2020-05-31/response-headers-policy/{Id}"},"input":{"type":"structure","required":["ResponseHeadersPolicyConfig","Id"],"members":{"ResponseHeadersPolicyConfig":{"shape":"S64","locationName":"ResponseHeadersPolicyConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"ResponseHeadersPolicyConfig"},"output":{"type":"structure","members":{"ResponseHeadersPolicy":{"shape":"S6x"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"ResponseHeadersPolicy"}},"UpdateStreamingDistribution":{"http":{"method":"PUT","requestUri":"/2020-05-31/streaming-distribution/{Id}/config"},"input":{"type":"structure","required":["StreamingDistributionConfig","Id"],"members":{"StreamingDistributionConfig":{"shape":"S6z","locationName":"StreamingDistributionConfig","xmlNamespace":{"uri":"http://cloudfront.amazonaws.com/doc/2020-05-31/"}},"Id":{"location":"uri","locationName":"Id"},"IfMatch":{"location":"header","locationName":"If-Match"}},"payload":"StreamingDistributionConfig"},"output":{"type":"structure","members":{"StreamingDistribution":{"shape":"S73"},"ETag":{"location":"header","locationName":"ETag"}},"payload":"StreamingDistribution"}}},"shapes":{"S6":{"type":"structure","required":["Id","ARN","Status","LastModifiedTime","InProgressInvalidationBatches","DomainName","DistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"InProgressInvalidationBatches":{"type":"integer"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S9"},"ActiveTrustedKeyGroups":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyGroup","type":"structure","members":{"KeyGroupId":{},"KeyPairIds":{"shape":"Sc"}}}}}},"DistributionConfig":{"shape":"Sh"},"AliasICPRecordals":{"shape":"S2j"}}},"S9":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Signer","type":"structure","members":{"AwsAccountNumber":{},"KeyPairIds":{"shape":"Sc"}}}}}},"Sc":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyPairId"}}}},"Sh":{"type":"structure","required":["CallerReference","Origins","DefaultCacheBehavior","Comment","Enabled"],"members":{"CallerReference":{},"Aliases":{"shape":"Si"},"DefaultRootObject":{},"Origins":{"shape":"Sk"},"OriginGroups":{"shape":"Sz"},"DefaultCacheBehavior":{"shape":"S18"},"CacheBehaviors":{"shape":"S21"},"CustomErrorResponses":{"shape":"S24"},"Comment":{"type":"string","sensitive":true},"Logging":{"type":"structure","required":["Enabled","IncludeCookies","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"IncludeCookies":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S2a"},"Restrictions":{"shape":"S2e"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"},"ContinuousDeploymentPolicyId":{},"Staging":{"type":"boolean"}}},"Si":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CNAME"}}}},"Sk":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin","type":"structure","required":["Id","DomainName"],"members":{"Id":{},"DomainName":{},"OriginPath":{},"CustomHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginCustomHeader","type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{"shape":"Sq"}}}}}},"S3OriginConfig":{"type":"structure","required":["OriginAccessIdentity"],"members":{"OriginAccessIdentity":{}}},"CustomOriginConfig":{"type":"structure","required":["HTTPPort","HTTPSPort","OriginProtocolPolicy"],"members":{"HTTPPort":{"type":"integer"},"HTTPSPort":{"type":"integer"},"OriginProtocolPolicy":{},"OriginSslProtocols":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"SslProtocol"}}}},"OriginReadTimeout":{"type":"integer"},"OriginKeepaliveTimeout":{"type":"integer"}}},"ConnectionAttempts":{"type":"integer"},"ConnectionTimeout":{"type":"integer"},"OriginShield":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"OriginShieldRegion":{}}},"OriginAccessControlId":{}}}}}},"Sq":{"type":"string","sensitive":true},"Sz":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroup","type":"structure","required":["Id","FailoverCriteria","Members"],"members":{"Id":{},"FailoverCriteria":{"type":"structure","required":["StatusCodes"],"members":{"StatusCodes":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"StatusCode","type":"integer"}}}}}},"Members":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"OriginGroupMember","type":"structure","required":["OriginId"],"members":{"OriginId":{}}}}}}}}}}},"S18":{"type":"structure","required":["TargetOriginId","ViewerProtocolPolicy"],"members":{"TargetOriginId":{},"TrustedSigners":{"shape":"S19"},"TrustedKeyGroups":{"shape":"S1b"},"ViewerProtocolPolicy":{},"AllowedMethods":{"shape":"S1e"},"SmoothStreaming":{"type":"boolean"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1i"},"FunctionAssociations":{"shape":"S1n"},"FieldLevelEncryptionId":{},"RealtimeLogConfigArn":{},"CachePolicyId":{},"OriginRequestPolicyId":{},"ResponseHeadersPolicyId":{},"ForwardedValues":{"shape":"S1r","deprecated":true},"MinTTL":{"deprecated":true,"type":"long"},"DefaultTTL":{"deprecated":true,"type":"long"},"MaxTTL":{"deprecated":true,"type":"long"}}},"S19":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"AwsAccountNumber"}}}},"S1b":{"type":"structure","required":["Enabled","Quantity"],"members":{"Enabled":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyGroup"}}}},"S1e":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1f"},"CachedMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"shape":"S1f"}}}}},"S1f":{"type":"list","member":{"locationName":"Method"}},"S1i":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"LambdaFunctionAssociation","type":"structure","required":["LambdaFunctionARN","EventType"],"members":{"LambdaFunctionARN":{},"EventType":{},"IncludeBody":{"type":"boolean"}}}}}},"S1n":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FunctionAssociation","type":"structure","required":["FunctionARN","EventType"],"members":{"FunctionARN":{},"EventType":{}}}}}},"S1r":{"type":"structure","required":["QueryString","Cookies"],"members":{"QueryString":{"type":"boolean"},"Cookies":{"type":"structure","required":["Forward"],"members":{"Forward":{},"WhitelistedNames":{"shape":"S1u"}}},"Headers":{"shape":"S1w"},"QueryStringCacheKeys":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}}}},"S1u":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"S1w":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"S21":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CacheBehavior","type":"structure","required":["PathPattern","TargetOriginId","ViewerProtocolPolicy"],"members":{"PathPattern":{},"TargetOriginId":{},"TrustedSigners":{"shape":"S19"},"TrustedKeyGroups":{"shape":"S1b"},"ViewerProtocolPolicy":{},"AllowedMethods":{"shape":"S1e"},"SmoothStreaming":{"type":"boolean"},"Compress":{"type":"boolean"},"LambdaFunctionAssociations":{"shape":"S1i"},"FunctionAssociations":{"shape":"S1n"},"FieldLevelEncryptionId":{},"RealtimeLogConfigArn":{},"CachePolicyId":{},"OriginRequestPolicyId":{},"ResponseHeadersPolicyId":{},"ForwardedValues":{"shape":"S1r","deprecated":true},"MinTTL":{"deprecated":true,"type":"long"},"DefaultTTL":{"deprecated":true,"type":"long"},"MaxTTL":{"deprecated":true,"type":"long"}}}}}},"S24":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"CustomErrorResponse","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{"type":"integer"},"ResponsePagePath":{},"ResponseCode":{},"ErrorCachingMinTTL":{"type":"long"}}}}}},"S2a":{"type":"structure","members":{"CloudFrontDefaultCertificate":{"type":"boolean"},"IAMCertificateId":{},"ACMCertificateArn":{},"SSLSupportMethod":{},"MinimumProtocolVersion":{},"Certificate":{"deprecated":true},"CertificateSource":{"deprecated":true}}},"S2e":{"type":"structure","required":["GeoRestriction"],"members":{"GeoRestriction":{"type":"structure","required":["RestrictionType","Quantity"],"members":{"RestrictionType":{},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Location"}}}}}},"S2j":{"type":"list","member":{"locationName":"AliasICPRecordal","type":"structure","members":{"CNAME":{},"ICPRecordalStatus":{}}}},"S2n":{"type":"structure","required":["Name","MinTTL"],"members":{"Comment":{},"Name":{},"DefaultTTL":{"type":"long"},"MaxTTL":{"type":"long"},"MinTTL":{"type":"long"},"ParametersInCacheKeyAndForwardedToOrigin":{"type":"structure","required":["EnableAcceptEncodingGzip","HeadersConfig","CookiesConfig","QueryStringsConfig"],"members":{"EnableAcceptEncodingGzip":{"type":"boolean"},"EnableAcceptEncodingBrotli":{"type":"boolean"},"HeadersConfig":{"type":"structure","required":["HeaderBehavior"],"members":{"HeaderBehavior":{},"Headers":{"shape":"S1w"}}},"CookiesConfig":{"type":"structure","required":["CookieBehavior"],"members":{"CookieBehavior":{},"Cookies":{"shape":"S1u"}}},"QueryStringsConfig":{"type":"structure","required":["QueryStringBehavior"],"members":{"QueryStringBehavior":{},"QueryStrings":{"shape":"S2v"}}}}}}},"S2v":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Name"}}}},"S2y":{"type":"structure","required":["Id","LastModifiedTime","CachePolicyConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"CachePolicyConfig":{"shape":"S2n"}}},"S30":{"type":"structure","required":["CallerReference","Comment"],"members":{"CallerReference":{},"Comment":{}}},"S32":{"type":"structure","required":["Id","S3CanonicalUserId"],"members":{"Id":{},"S3CanonicalUserId":{},"CloudFrontOriginAccessIdentityConfig":{"shape":"S30"}}},"S34":{"type":"structure","required":["StagingDistributionDnsNames","Enabled"],"members":{"StagingDistributionDnsNames":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DnsName"}}}},"Enabled":{"type":"boolean"},"TrafficConfig":{"type":"structure","required":["Type"],"members":{"SingleWeightConfig":{"type":"structure","required":["Weight"],"members":{"Weight":{"type":"float"},"SessionStickinessConfig":{"type":"structure","required":["IdleTTL","MaximumTTL"],"members":{"IdleTTL":{"type":"integer"},"MaximumTTL":{"type":"integer"}}}}},"SingleHeaderConfig":{"type":"structure","required":["Header","Value"],"members":{"Header":{},"Value":{}}},"Type":{}}}}},"S3e":{"type":"structure","required":["Id","LastModifiedTime","ContinuousDeploymentPolicyConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"ContinuousDeploymentPolicyConfig":{"shape":"S34"}}},"S3j":{"type":"structure","members":{"Items":{"type":"list","member":{"locationName":"Tag","type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}}}},"S3q":{"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"Comment":{},"QueryArgProfileConfig":{"shape":"S3r"},"ContentTypeProfileConfig":{"shape":"S3v"}}},"S3r":{"type":"structure","required":["ForwardWhenQueryArgProfileIsUnknown"],"members":{"ForwardWhenQueryArgProfileIsUnknown":{"type":"boolean"},"QueryArgProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"QueryArgProfile","type":"structure","required":["QueryArg","ProfileId"],"members":{"QueryArg":{},"ProfileId":{}}}}}}}},"S3v":{"type":"structure","required":["ForwardWhenContentTypeIsUnknown"],"members":{"ForwardWhenContentTypeIsUnknown":{"type":"boolean"},"ContentTypeProfiles":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ContentTypeProfile","type":"structure","required":["Format","ContentType"],"members":{"Format":{},"ProfileId":{},"ContentType":{}}}}}}}},"S41":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionConfig":{"shape":"S3q"}}},"S43":{"type":"structure","required":["Name","CallerReference","EncryptionEntities"],"members":{"Name":{},"CallerReference":{},"Comment":{},"EncryptionEntities":{"shape":"S44"}}},"S44":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"EncryptionEntity","type":"structure","required":["PublicKeyId","ProviderId","FieldPatterns"],"members":{"PublicKeyId":{},"ProviderId":{},"FieldPatterns":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"FieldPattern"}}}}}}}}},"S4a":{"type":"structure","required":["Id","LastModifiedTime","FieldLevelEncryptionProfileConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"FieldLevelEncryptionProfileConfig":{"shape":"S43"}}},"S4d":{"type":"structure","required":["Comment","Runtime"],"members":{"Comment":{},"Runtime":{},"KeyValueStoreAssociations":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"KeyValueStoreAssociation","type":"structure","required":["KeyValueStoreARN"],"members":{"KeyValueStoreARN":{}}}}}}}},"S4j":{"type":"blob","sensitive":true},"S4l":{"type":"structure","required":["Name","FunctionConfig","FunctionMetadata"],"members":{"Name":{},"Status":{},"FunctionConfig":{"shape":"S4d"},"FunctionMetadata":{"type":"structure","required":["FunctionARN","LastModifiedTime"],"members":{"FunctionARN":{},"Stage":{},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}}},"S4p":{"type":"structure","required":["Paths","CallerReference"],"members":{"Paths":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Path"}}}},"CallerReference":{}}},"S4t":{"type":"structure","required":["Id","Status","CreateTime","InvalidationBatch"],"members":{"Id":{},"Status":{},"CreateTime":{"type":"timestamp"},"InvalidationBatch":{"shape":"S4p"}}},"S4v":{"type":"structure","required":["Name","Items"],"members":{"Name":{},"Items":{"type":"list","member":{"locationName":"PublicKey"}},"Comment":{}}},"S4y":{"type":"structure","required":["Id","LastModifiedTime","KeyGroupConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"KeyGroupConfig":{"shape":"S4v"}}},"S55":{"type":"structure","required":["Name","Id","Comment","ARN","LastModifiedTime"],"members":{"Name":{},"Id":{},"Comment":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"}}},"S57":{"type":"structure","members":{"RealtimeMetricsSubscriptionConfig":{"type":"structure","required":["RealtimeMetricsSubscriptionStatus"],"members":{"RealtimeMetricsSubscriptionStatus":{}}}}},"S5c":{"type":"structure","required":["Name","SigningProtocol","SigningBehavior","OriginAccessControlOriginType"],"members":{"Name":{},"Description":{},"SigningProtocol":{},"SigningBehavior":{},"OriginAccessControlOriginType":{}}},"S5h":{"type":"structure","required":["Id"],"members":{"Id":{},"OriginAccessControlConfig":{"shape":"S5c"}}},"S5j":{"type":"structure","required":["Name","HeadersConfig","CookiesConfig","QueryStringsConfig"],"members":{"Comment":{},"Name":{},"HeadersConfig":{"type":"structure","required":["HeaderBehavior"],"members":{"HeaderBehavior":{},"Headers":{"shape":"S1w"}}},"CookiesConfig":{"type":"structure","required":["CookieBehavior"],"members":{"CookieBehavior":{},"Cookies":{"shape":"S1u"}}},"QueryStringsConfig":{"type":"structure","required":["QueryStringBehavior"],"members":{"QueryStringBehavior":{},"QueryStrings":{"shape":"S2v"}}}}},"S5r":{"type":"structure","required":["Id","LastModifiedTime","OriginRequestPolicyConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"OriginRequestPolicyConfig":{"shape":"S5j"}}},"S5t":{"type":"structure","required":["CallerReference","Name","EncodedKey"],"members":{"CallerReference":{},"Name":{},"EncodedKey":{},"Comment":{}}},"S5v":{"type":"structure","required":["Id","CreatedTime","PublicKeyConfig"],"members":{"Id":{},"CreatedTime":{"type":"timestamp"},"PublicKeyConfig":{"shape":"S5t"}}},"S5x":{"type":"list","member":{"type":"structure","required":["StreamType"],"members":{"StreamType":{},"KinesisStreamConfig":{"type":"structure","required":["RoleARN","StreamARN"],"members":{"RoleARN":{},"StreamARN":{}}}}}},"S60":{"type":"list","member":{"locationName":"Field"}},"S62":{"type":"structure","required":["ARN","Name","SamplingRate","EndPoints","Fields"],"members":{"ARN":{},"Name":{},"SamplingRate":{"type":"long"},"EndPoints":{"shape":"S5x"},"Fields":{"shape":"S60"}}},"S64":{"type":"structure","required":["Name"],"members":{"Comment":{},"Name":{},"CorsConfig":{"type":"structure","required":["AccessControlAllowOrigins","AccessControlAllowHeaders","AccessControlAllowMethods","AccessControlAllowCredentials","OriginOverride"],"members":{"AccessControlAllowOrigins":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Origin"}}}},"AccessControlAllowHeaders":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Header"}}}},"AccessControlAllowMethods":{"type":"structure","required":["Quantity","Items"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Method"}}}},"AccessControlAllowCredentials":{"type":"boolean"},"AccessControlExposeHeaders":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"Header"}}}},"AccessControlMaxAgeSec":{"type":"integer"},"OriginOverride":{"type":"boolean"}}},"SecurityHeadersConfig":{"type":"structure","members":{"XSSProtection":{"type":"structure","required":["Override","Protection"],"members":{"Override":{"type":"boolean"},"Protection":{"type":"boolean"},"ModeBlock":{"type":"boolean"},"ReportUri":{}}},"FrameOptions":{"type":"structure","required":["Override","FrameOption"],"members":{"Override":{"type":"boolean"},"FrameOption":{}}},"ReferrerPolicy":{"type":"structure","required":["Override","ReferrerPolicy"],"members":{"Override":{"type":"boolean"},"ReferrerPolicy":{}}},"ContentSecurityPolicy":{"type":"structure","required":["Override","ContentSecurityPolicy"],"members":{"Override":{"type":"boolean"},"ContentSecurityPolicy":{}}},"ContentTypeOptions":{"type":"structure","required":["Override"],"members":{"Override":{"type":"boolean"}}},"StrictTransportSecurity":{"type":"structure","required":["Override","AccessControlMaxAgeSec"],"members":{"Override":{"type":"boolean"},"IncludeSubdomains":{"type":"boolean"},"Preload":{"type":"boolean"},"AccessControlMaxAgeSec":{"type":"integer"}}}}},"ServerTimingHeadersConfig":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"SamplingRate":{"type":"double"}}},"CustomHeadersConfig":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ResponseHeadersPolicyCustomHeader","type":"structure","required":["Header","Value","Override"],"members":{"Header":{},"Value":{},"Override":{"type":"boolean"}}}}}},"RemoveHeadersConfig":{"type":"structure","required":["Quantity"],"members":{"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"ResponseHeadersPolicyRemoveHeader","type":"structure","required":["Header"],"members":{"Header":{}}}}}}}},"S6x":{"type":"structure","required":["Id","LastModifiedTime","ResponseHeadersPolicyConfig"],"members":{"Id":{},"LastModifiedTime":{"type":"timestamp"},"ResponseHeadersPolicyConfig":{"shape":"S64"}}},"S6z":{"type":"structure","required":["CallerReference","S3Origin","Comment","TrustedSigners","Enabled"],"members":{"CallerReference":{},"S3Origin":{"shape":"S70"},"Aliases":{"shape":"Si"},"Comment":{},"Logging":{"type":"structure","required":["Enabled","Bucket","Prefix"],"members":{"Enabled":{"type":"boolean"},"Bucket":{},"Prefix":{}}},"TrustedSigners":{"shape":"S19"},"PriceClass":{},"Enabled":{"type":"boolean"}}},"S70":{"type":"structure","required":["DomainName","OriginAccessIdentity"],"members":{"DomainName":{},"OriginAccessIdentity":{}}},"S73":{"type":"structure","required":["Id","ARN","Status","DomainName","ActiveTrustedSigners","StreamingDistributionConfig"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"ActiveTrustedSigners":{"shape":"S9"},"StreamingDistributionConfig":{"shape":"S6z"}}},"Sa2":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionSummary","type":"structure","required":["Id","ARN","Status","LastModifiedTime","DomainName","Aliases","Origins","DefaultCacheBehavior","CacheBehaviors","CustomErrorResponses","Comment","PriceClass","Enabled","ViewerCertificate","Restrictions","WebACLId","HttpVersion","IsIPV6Enabled","Staging"],"members":{"Id":{},"ARN":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"DomainName":{},"Aliases":{"shape":"Si"},"Origins":{"shape":"Sk"},"OriginGroups":{"shape":"Sz"},"DefaultCacheBehavior":{"shape":"S18"},"CacheBehaviors":{"shape":"S21"},"CustomErrorResponses":{"shape":"S24"},"Comment":{},"PriceClass":{},"Enabled":{"type":"boolean"},"ViewerCertificate":{"shape":"S2a"},"Restrictions":{"shape":"S2e"},"WebACLId":{},"HttpVersion":{},"IsIPV6Enabled":{"type":"boolean"},"AliasICPRecordals":{"shape":"S2j"},"Staging":{"type":"boolean"}}}}}},"Sa7":{"type":"structure","required":["Marker","MaxItems","IsTruncated","Quantity"],"members":{"Marker":{},"NextMarker":{},"MaxItems":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Quantity":{"type":"integer"},"Items":{"type":"list","member":{"locationName":"DistributionId"}}}}}}

/***/ }),
/* 432 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCloudFrontOriginAccessIdentities":{"input_token":"Marker","limit_key":"MaxItems","more_results":"CloudFrontOriginAccessIdentityList.IsTruncated","output_token":"CloudFrontOriginAccessIdentityList.NextMarker","result_key":"CloudFrontOriginAccessIdentityList.Items"},"ListDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"DistributionList.IsTruncated","output_token":"DistributionList.NextMarker","result_key":"DistributionList.Items"},"ListInvalidations":{"input_token":"Marker","limit_key":"MaxItems","more_results":"InvalidationList.IsTruncated","output_token":"InvalidationList.NextMarker","result_key":"InvalidationList.Items"},"ListKeyValueStores":{"input_token":"Marker","limit_key":"MaxItems","output_token":"KeyValueStoreList.NextMarker","result_key":"KeyValueStoreList.Items"},"ListStreamingDistributions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"StreamingDistributionList.IsTruncated","output_token":"StreamingDistributionList.NextMarker","result_key":"StreamingDistributionList.Items"}}}

/***/ }),
/* 433 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DistributionDeployed":{"delay":60,"operation":"GetDistribution","maxAttempts":35,"description":"Wait until a distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"Distribution.Status"}]},"InvalidationCompleted":{"delay":20,"operation":"GetInvalidation","maxAttempts":30,"description":"Wait until an invalidation has completed.","acceptors":[{"expected":"Completed","matcher":"path","state":"success","argument":"Invalidation.Status"}]},"StreamingDistributionDeployed":{"delay":60,"operation":"GetStreamingDistribution","maxAttempts":25,"description":"Wait until a streaming distribution is deployed.","acceptors":[{"expected":"Deployed","matcher":"path","state":"success","argument":"StreamingDistribution.Status"}]}}}

/***/ }),
/* 434 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-30","endpointPrefix":"cloudhsm","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM","serviceFullName":"Amazon CloudHSM","serviceId":"CloudHSM","signatureVersion":"v4","targetPrefix":"CloudHsmFrontendService","uid":"cloudhsm-2014-05-30"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceArn","TagList"],"members":{"ResourceArn":{},"TagList":{"shape":"S3"}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"CreateHapg":{"input":{"type":"structure","required":["Label"],"members":{"Label":{}}},"output":{"type":"structure","members":{"HapgArn":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"CreateHsm":{"input":{"type":"structure","required":["SubnetId","SshKey","IamRoleArn","SubscriptionType"],"members":{"SubnetId":{},"SshKey":{},"EniIp":{},"IamRoleArn":{},"ExternalId":{},"SubscriptionType":{},"ClientToken":{},"SyslogIp":{}}},"output":{"type":"structure","members":{"HsmArn":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"CreateLunaClient":{"input":{"type":"structure","required":["Certificate"],"members":{"Label":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"DeleteHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"DeleteHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"DeleteLunaClient":{"input":{"type":"structure","required":["ClientArn"],"members":{"ClientArn":{}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"DescribeHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{}}},"output":{"type":"structure","members":{"HapgArn":{},"HapgSerial":{},"HsmsLastActionFailed":{"shape":"Sz"},"HsmsPendingDeletion":{"shape":"Sz"},"HsmsPendingRegistration":{"shape":"Sz"},"Label":{},"LastModifiedTimestamp":{},"PartitionSerialList":{"shape":"S11"},"State":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"DescribeHsm":{"input":{"type":"structure","members":{"HsmArn":{},"HsmSerialNumber":{}}},"output":{"type":"structure","members":{"HsmArn":{},"Status":{},"StatusDetails":{},"AvailabilityZone":{},"EniId":{},"EniIp":{},"SubscriptionType":{},"SubscriptionStartDate":{},"SubscriptionEndDate":{},"VpcId":{},"SubnetId":{},"IamRoleArn":{},"SerialNumber":{},"VendorName":{},"HsmType":{},"SoftwareVersion":{},"SshPublicKey":{},"SshKeyLastUpdated":{},"ServerCertUri":{},"ServerCertLastUpdated":{},"Partitions":{"type":"list","member":{}}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"DescribeLunaClient":{"input":{"type":"structure","members":{"ClientArn":{},"CertificateFingerprint":{}}},"output":{"type":"structure","members":{"ClientArn":{},"Certificate":{},"CertificateFingerprint":{},"LastModifiedTimestamp":{},"Label":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"GetConfig":{"input":{"type":"structure","required":["ClientArn","ClientVersion","HapgList"],"members":{"ClientArn":{},"ClientVersion":{},"HapgList":{"shape":"S1i"}}},"output":{"type":"structure","members":{"ConfigType":{},"ConfigFile":{},"ConfigCred":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ListAvailableZones":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AZList":{"type":"list","member":{}}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ListHapgs":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["HapgList"],"members":{"HapgList":{"shape":"S1i"},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ListHsms":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"HsmList":{"shape":"Sz"},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ListLunaClients":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","required":["ClientList"],"members":{"ClientList":{"type":"list","member":{}},"NextToken":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S3"}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ModifyHapg":{"input":{"type":"structure","required":["HapgArn"],"members":{"HapgArn":{},"Label":{},"PartitionSerialList":{"shape":"S11"}}},"output":{"type":"structure","members":{"HapgArn":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ModifyHsm":{"input":{"type":"structure","required":["HsmArn"],"members":{"HsmArn":{},"SubnetId":{},"EniIp":{},"IamRoleArn":{},"ExternalId":{},"SyslogIp":{}}},"output":{"type":"structure","members":{"HsmArn":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"ModifyLunaClient":{"input":{"type":"structure","required":["ClientArn","Certificate"],"members":{"ClientArn":{},"Certificate":{}}},"output":{"type":"structure","members":{"ClientArn":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceArn","TagKeyList"],"members":{"ResourceArn":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Status"],"members":{"Status":{}}},"deprecated":true,"deprecatedMessage":"This API is deprecated."}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sz":{"type":"list","member":{}},"S11":{"type":"list","member":{}},"S1i":{"type":"list","member":{}}}}

/***/ }),
/* 435 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 436 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-28","endpointPrefix":"cloudhsmv2","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudHSM V2","serviceFullName":"AWS CloudHSM V2","serviceId":"CloudHSM V2","signatureVersion":"v4","signingName":"cloudhsm","targetPrefix":"BaldrApiService","uid":"cloudhsmv2-2017-04-28"},"operations":{"CopyBackupToRegion":{"input":{"type":"structure","required":["DestinationRegion","BackupId"],"members":{"DestinationRegion":{},"BackupId":{},"TagList":{"shape":"S4"}}},"output":{"type":"structure","members":{"DestinationBackup":{"type":"structure","members":{"CreateTimestamp":{"type":"timestamp"},"SourceRegion":{},"SourceBackup":{},"SourceCluster":{}}}}}},"CreateCluster":{"input":{"type":"structure","required":["HsmType","SubnetIds"],"members":{"BackupRetentionPolicy":{"shape":"Sd"},"HsmType":{},"SourceBackupId":{},"SubnetIds":{"type":"list","member":{}},"TagList":{"shape":"S4"}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sk"}}}},"CreateHsm":{"input":{"type":"structure","required":["ClusterId","AvailabilityZone"],"members":{"ClusterId":{},"AvailabilityZone":{},"IpAddress":{}}},"output":{"type":"structure","members":{"Hsm":{"shape":"Sn"}}}},"DeleteBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"S16"}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sk"}}}},"DeleteHsm":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"HsmId":{},"EniId":{},"EniIp":{}}},"output":{"type":"structure","members":{"HsmId":{}}}},"DescribeBackups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S1g"},"SortAscending":{"type":"boolean"}}},"output":{"type":"structure","members":{"Backups":{"type":"list","member":{"shape":"S16"}},"NextToken":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"Filters":{"shape":"S1g"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"shape":"Sk"}},"NextToken":{}}}},"InitializeCluster":{"input":{"type":"structure","required":["ClusterId","SignedCert","TrustAnchor"],"members":{"ClusterId":{},"SignedCert":{},"TrustAnchor":{}}},"output":{"type":"structure","members":{"State":{},"StateMessage":{}}}},"ListTags":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["TagList"],"members":{"TagList":{"shape":"S4"},"NextToken":{}}}},"ModifyBackupAttributes":{"input":{"type":"structure","required":["BackupId","NeverExpires"],"members":{"BackupId":{},"NeverExpires":{"type":"boolean"}}},"output":{"type":"structure","members":{"Backup":{"shape":"S16"}}}},"ModifyCluster":{"input":{"type":"structure","required":["BackupRetentionPolicy","ClusterId"],"members":{"BackupRetentionPolicy":{"shape":"Sd"},"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"shape":"Sk"}}}},"RestoreBackup":{"input":{"type":"structure","required":["BackupId"],"members":{"BackupId":{}}},"output":{"type":"structure","members":{"Backup":{"shape":"S16"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceId","TagList"],"members":{"ResourceId":{},"TagList":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceId","TagKeyList"],"members":{"ResourceId":{},"TagKeyList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"Type":{},"Value":{}}},"Sk":{"type":"structure","members":{"BackupPolicy":{},"BackupRetentionPolicy":{"shape":"Sd"},"ClusterId":{},"CreateTimestamp":{"type":"timestamp"},"Hsms":{"type":"list","member":{"shape":"Sn"}},"HsmType":{},"PreCoPassword":{},"SecurityGroup":{},"SourceBackupId":{},"State":{},"StateMessage":{},"SubnetMapping":{"type":"map","key":{},"value":{}},"VpcId":{},"Certificates":{"type":"structure","members":{"ClusterCsr":{},"HsmCertificate":{},"AwsHardwareCertificate":{},"ManufacturerHardwareCertificate":{},"ClusterCertificate":{}}},"TagList":{"shape":"S4"}}},"Sn":{"type":"structure","required":["HsmId"],"members":{"AvailabilityZone":{},"ClusterId":{},"SubnetId":{},"EniId":{},"EniIp":{},"HsmId":{},"State":{},"StateMessage":{}}},"S16":{"type":"structure","required":["BackupId"],"members":{"BackupId":{},"BackupState":{},"ClusterId":{},"CreateTimestamp":{"type":"timestamp"},"CopyTimestamp":{"type":"timestamp"},"NeverExpires":{"type":"boolean"},"SourceRegion":{},"SourceBackup":{},"SourceCluster":{},"DeleteTimestamp":{"type":"timestamp"},"TagList":{"shape":"S4"}}},"S1g":{"type":"map","key":{},"value":{"type":"list","member":{}}}}}

/***/ }),
/* 437 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeBackups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"DescribeClusters":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 438 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-11-01","endpointPrefix":"cloudtrail","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CloudTrail","serviceFullName":"AWS CloudTrail","serviceId":"CloudTrail","signatureVersion":"v4","targetPrefix":"com.amazonaws.cloudtrail.v20131101.CloudTrail_20131101","uid":"cloudtrail-2013-11-01"},"operations":{"AddTags":{"input":{"type":"structure","required":["ResourceId","TagsList"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"CancelQuery":{"input":{"type":"structure","required":["QueryId"],"members":{"EventDataStore":{"deprecated":true,"deprecatedMessage":"EventDataStore is no longer required by CancelQueryRequest"},"QueryId":{}}},"output":{"type":"structure","required":["QueryId","QueryStatus"],"members":{"QueryId":{},"QueryStatus":{}}},"idempotent":true},"CreateChannel":{"input":{"type":"structure","required":["Name","Source","Destinations"],"members":{"Name":{},"Source":{},"Destinations":{"shape":"Sg"},"Tags":{"shape":"S3"}}},"output":{"type":"structure","members":{"ChannelArn":{},"Name":{},"Source":{},"Destinations":{"shape":"Sg"},"Tags":{"shape":"S3"}}}},"CreateEventDataStore":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"AdvancedEventSelectors":{"shape":"So"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"TagsList":{"shape":"S3"},"KmsKeyId":{},"StartIngestion":{"type":"boolean"},"BillingMode":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"So"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"TagsList":{"shape":"S3"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"},"KmsKeyId":{},"BillingMode":{}}}},"CreateTrail":{"input":{"type":"structure","required":["Name","S3BucketName"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true},"DeleteChannel":{"input":{"type":"structure","required":["Channel"],"members":{"Channel":{}}},"output":{"type":"structure","members":{}}},"DeleteEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeregisterOrganizationDelegatedAdmin":{"input":{"type":"structure","required":["DelegatedAdminAccountId"],"members":{"DelegatedAdminAccountId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DescribeQuery":{"input":{"type":"structure","members":{"EventDataStore":{"deprecated":true,"deprecatedMessage":"EventDataStore is no longer required by DescribeQueryRequest"},"QueryId":{},"QueryAlias":{}}},"output":{"type":"structure","members":{"QueryId":{},"QueryString":{},"QueryStatus":{},"QueryStatistics":{"type":"structure","members":{"EventsMatched":{"type":"long"},"EventsScanned":{"type":"long"},"BytesScanned":{"type":"long"},"ExecutionTimeInMillis":{"type":"integer"},"CreationTime":{"type":"timestamp"}}},"ErrorMessage":{},"DeliveryS3Uri":{},"DeliveryStatus":{}}},"idempotent":true},"DescribeTrails":{"input":{"type":"structure","members":{"trailNameList":{"type":"list","member":{}},"includeShadowTrails":{"type":"boolean"}}},"output":{"type":"structure","members":{"trailList":{"type":"list","member":{"shape":"S1w"}}}},"idempotent":true},"DisableFederation":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"FederationStatus":{}}}},"EnableFederation":{"input":{"type":"structure","required":["EventDataStore","FederationRoleArn"],"members":{"EventDataStore":{},"FederationRoleArn":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"FederationStatus":{},"FederationRoleArn":{}}}},"GetChannel":{"input":{"type":"structure","required":["Channel"],"members":{"Channel":{}}},"output":{"type":"structure","members":{"ChannelArn":{},"Name":{},"Source":{},"SourceConfig":{"type":"structure","members":{"ApplyToAllRegions":{"type":"boolean"},"AdvancedEventSelectors":{"shape":"So"}}},"Destinations":{"shape":"Sg"},"IngestionStatus":{"type":"structure","members":{"LatestIngestionSuccessTime":{"type":"timestamp"},"LatestIngestionSuccessEventID":{},"LatestIngestionErrorCode":{},"LatestIngestionAttemptTime":{"type":"timestamp"},"LatestIngestionAttemptEventID":{}}}}},"idempotent":true},"GetEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"So"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"},"KmsKeyId":{},"BillingMode":{},"FederationStatus":{},"FederationRoleArn":{}}},"idempotent":true},"GetEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"S2b"},"AdvancedEventSelectors":{"shape":"So"}}},"idempotent":true},"GetImport":{"input":{"type":"structure","required":["ImportId"],"members":{"ImportId":{}}},"output":{"type":"structure","members":{"ImportId":{},"Destinations":{"shape":"S2k"},"ImportSource":{"shape":"S2l"},"StartEventTime":{"type":"timestamp"},"EndEventTime":{"type":"timestamp"},"ImportStatus":{},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"},"ImportStatistics":{"shape":"S2o"}}}},"GetInsightSelectors":{"input":{"type":"structure","members":{"TrailName":{},"EventDataStore":{}}},"output":{"type":"structure","members":{"TrailARN":{},"InsightSelectors":{"shape":"S2r"},"EventDataStoreArn":{},"InsightsDestination":{}}},"idempotent":true},"GetQueryResults":{"input":{"type":"structure","required":["QueryId"],"members":{"EventDataStore":{"deprecated":true,"deprecatedMessage":"EventDataStore is no longer required by GetQueryResultsRequest"},"QueryId":{},"NextToken":{},"MaxQueryResults":{"type":"integer"}}},"output":{"type":"structure","members":{"QueryStatus":{},"QueryStatistics":{"type":"structure","members":{"ResultsCount":{"type":"integer"},"TotalResultsCount":{"type":"integer"},"BytesScanned":{"type":"long"}}},"QueryResultRows":{"type":"list","member":{"type":"list","member":{"type":"map","key":{},"value":{}}}},"NextToken":{},"ErrorMessage":{}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"ResourcePolicy":{}}},"idempotent":true},"GetTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Trail":{"shape":"S1w"}}},"idempotent":true},"GetTrailStatus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"IsLogging":{"type":"boolean"},"LatestDeliveryError":{},"LatestNotificationError":{},"LatestDeliveryTime":{"type":"timestamp"},"LatestNotificationTime":{"type":"timestamp"},"StartLoggingTime":{"type":"timestamp"},"StopLoggingTime":{"type":"timestamp"},"LatestCloudWatchLogsDeliveryError":{},"LatestCloudWatchLogsDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryTime":{"type":"timestamp"},"LatestDigestDeliveryError":{},"LatestDeliveryAttemptTime":{},"LatestNotificationAttemptTime":{},"LatestNotificationAttemptSucceeded":{},"LatestDeliveryAttemptSucceeded":{},"TimeLoggingStarted":{},"TimeLoggingStopped":{}}},"idempotent":true},"ListChannels":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Channels":{"type":"list","member":{"type":"structure","members":{"ChannelArn":{},"Name":{}}}},"NextToken":{}}},"idempotent":true},"ListEventDataStores":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EventDataStores":{"type":"list","member":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"TerminationProtectionEnabled":{"deprecated":true,"deprecatedMessage":"TerminationProtectionEnabled is no longer returned by ListEventDataStores","type":"boolean"},"Status":{"deprecated":true,"deprecatedMessage":"Status is no longer returned by ListEventDataStores"},"AdvancedEventSelectors":{"shape":"So","deprecated":true,"deprecatedMessage":"AdvancedEventSelectors is no longer returned by ListEventDataStores"},"MultiRegionEnabled":{"deprecated":true,"deprecatedMessage":"MultiRegionEnabled is no longer returned by ListEventDataStores","type":"boolean"},"OrganizationEnabled":{"deprecated":true,"deprecatedMessage":"OrganizationEnabled is no longer returned by ListEventDataStores","type":"boolean"},"RetentionPeriod":{"deprecated":true,"deprecatedMessage":"RetentionPeriod is no longer returned by ListEventDataStores","type":"integer"},"CreatedTimestamp":{"deprecated":true,"deprecatedMessage":"CreatedTimestamp is no longer returned by ListEventDataStores","type":"timestamp"},"UpdatedTimestamp":{"deprecated":true,"deprecatedMessage":"UpdatedTimestamp is no longer returned by ListEventDataStores","type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListImportFailures":{"input":{"type":"structure","required":["ImportId"],"members":{"ImportId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Failures":{"type":"list","member":{"type":"structure","members":{"Location":{},"Status":{},"ErrorType":{},"ErrorMessage":{},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListImports":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"Destination":{},"ImportStatus":{},"NextToken":{}}},"output":{"type":"structure","members":{"Imports":{"type":"list","member":{"type":"structure","members":{"ImportId":{},"ImportStatus":{},"Destinations":{"shape":"S2k"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListInsightsMetricData":{"input":{"type":"structure","required":["EventSource","EventName","InsightType"],"members":{"EventSource":{},"EventName":{},"InsightType":{},"ErrorCode":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"DataType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EventSource":{},"EventName":{},"InsightType":{},"ErrorCode":{},"Timestamps":{"type":"list","member":{"type":"timestamp"}},"Values":{"type":"list","member":{"type":"double"}},"NextToken":{}}},"idempotent":true},"ListPublicKeys":{"input":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"PublicKeyList":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"blob"},"ValidityStartTime":{"type":"timestamp"},"ValidityEndTime":{"type":"timestamp"},"Fingerprint":{}}}},"NextToken":{}}},"idempotent":true},"ListQueries":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{},"NextToken":{},"MaxResults":{"type":"integer"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"QueryStatus":{}}},"output":{"type":"structure","members":{"Queries":{"type":"list","member":{"type":"structure","members":{"QueryId":{},"QueryStatus":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListTags":{"input":{"type":"structure","required":["ResourceIdList"],"members":{"ResourceIdList":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceTagList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"TagsList":{"shape":"S3"}}}},"NextToken":{}}},"idempotent":true},"ListTrails":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Trails":{"type":"list","member":{"type":"structure","members":{"TrailARN":{},"Name":{},"HomeRegion":{}}}},"NextToken":{}}},"idempotent":true},"LookupEvents":{"input":{"type":"structure","members":{"LookupAttributes":{"type":"list","member":{"type":"structure","required":["AttributeKey","AttributeValue"],"members":{"AttributeKey":{},"AttributeValue":{}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EventCategory":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventName":{},"ReadOnly":{},"AccessKeyId":{},"EventTime":{"type":"timestamp"},"EventSource":{},"Username":{},"Resources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceName":{}}}},"CloudTrailEvent":{}}}},"NextToken":{}}},"idempotent":true},"PutEventSelectors":{"input":{"type":"structure","required":["TrailName"],"members":{"TrailName":{},"EventSelectors":{"shape":"S2b"},"AdvancedEventSelectors":{"shape":"So"}}},"output":{"type":"structure","members":{"TrailARN":{},"EventSelectors":{"shape":"S2b"},"AdvancedEventSelectors":{"shape":"So"}}},"idempotent":true},"PutInsightSelectors":{"input":{"type":"structure","required":["InsightSelectors"],"members":{"TrailName":{},"InsightSelectors":{"shape":"S2r"},"EventDataStore":{},"InsightsDestination":{}}},"output":{"type":"structure","members":{"TrailARN":{},"InsightSelectors":{"shape":"S2r"},"EventDataStoreArn":{},"InsightsDestination":{}}},"idempotent":true},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","ResourcePolicy"],"members":{"ResourceArn":{},"ResourcePolicy":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"ResourcePolicy":{}}},"idempotent":true},"RegisterOrganizationDelegatedAdmin":{"input":{"type":"structure","required":["MemberAccountId"],"members":{"MemberAccountId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagsList"],"members":{"ResourceId":{},"TagsList":{"shape":"S3"}}},"output":{"type":"structure","members":{}},"idempotent":true},"RestoreEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"So"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"},"KmsKeyId":{},"BillingMode":{}}}},"StartEventDataStoreIngestion":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{}}},"StartImport":{"input":{"type":"structure","members":{"Destinations":{"shape":"S2k"},"ImportSource":{"shape":"S2l"},"StartEventTime":{"type":"timestamp"},"EndEventTime":{"type":"timestamp"},"ImportId":{}}},"output":{"type":"structure","members":{"ImportId":{},"Destinations":{"shape":"S2k"},"ImportSource":{"shape":"S2l"},"StartEventTime":{"type":"timestamp"},"EndEventTime":{"type":"timestamp"},"ImportStatus":{},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"}}}},"StartLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"StartQuery":{"input":{"type":"structure","members":{"QueryStatement":{},"DeliveryS3Uri":{},"QueryAlias":{},"QueryParameters":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"QueryId":{}}},"idempotent":true},"StopEventDataStoreIngestion":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{}}},"output":{"type":"structure","members":{}}},"StopImport":{"input":{"type":"structure","required":["ImportId"],"members":{"ImportId":{}}},"output":{"type":"structure","members":{"ImportId":{},"ImportSource":{"shape":"S2l"},"Destinations":{"shape":"S2k"},"ImportStatus":{},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"},"StartEventTime":{"type":"timestamp"},"EndEventTime":{"type":"timestamp"},"ImportStatistics":{"shape":"S2o"}}}},"StopLogging":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateChannel":{"input":{"type":"structure","required":["Channel"],"members":{"Channel":{},"Destinations":{"shape":"Sg"},"Name":{}}},"output":{"type":"structure","members":{"ChannelArn":{},"Name":{},"Source":{},"Destinations":{"shape":"Sg"}}},"idempotent":true},"UpdateEventDataStore":{"input":{"type":"structure","required":["EventDataStore"],"members":{"EventDataStore":{},"Name":{},"AdvancedEventSelectors":{"shape":"So"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"KmsKeyId":{},"BillingMode":{}}},"output":{"type":"structure","members":{"EventDataStoreArn":{},"Name":{},"Status":{},"AdvancedEventSelectors":{"shape":"So"},"MultiRegionEnabled":{"type":"boolean"},"OrganizationEnabled":{"type":"boolean"},"RetentionPeriod":{"type":"integer"},"TerminationProtectionEnabled":{"type":"boolean"},"CreatedTimestamp":{"type":"timestamp"},"UpdatedTimestamp":{"type":"timestamp"},"KmsKeyId":{},"BillingMode":{},"FederationStatus":{},"FederationRoleArn":{}}},"idempotent":true},"UpdateTrail":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"EnableLogFileValidation":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"output":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"IsOrganizationTrail":{"type":"boolean"}}},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sg":{"type":"list","member":{"type":"structure","required":["Type","Location"],"members":{"Type":{},"Location":{}}}},"So":{"type":"list","member":{"type":"structure","required":["FieldSelectors"],"members":{"Name":{},"FieldSelectors":{"type":"list","member":{"type":"structure","required":["Field"],"members":{"Field":{},"Equals":{"shape":"Su"},"StartsWith":{"shape":"Su"},"EndsWith":{"shape":"Su"},"NotEquals":{"shape":"Su"},"NotStartsWith":{"shape":"Su"},"NotEndsWith":{"shape":"Su"}}}}}}},"Su":{"type":"list","member":{}},"S1w":{"type":"structure","members":{"Name":{},"S3BucketName":{},"S3KeyPrefix":{},"SnsTopicName":{"deprecated":true},"SnsTopicARN":{},"IncludeGlobalServiceEvents":{"type":"boolean"},"IsMultiRegionTrail":{"type":"boolean"},"HomeRegion":{},"TrailARN":{},"LogFileValidationEnabled":{"type":"boolean"},"CloudWatchLogsLogGroupArn":{},"CloudWatchLogsRoleArn":{},"KmsKeyId":{},"HasCustomEventSelectors":{"type":"boolean"},"HasInsightSelectors":{"type":"boolean"},"IsOrganizationTrail":{"type":"boolean"}}},"S2b":{"type":"list","member":{"type":"structure","members":{"ReadWriteType":{},"IncludeManagementEvents":{"type":"boolean"},"DataResources":{"type":"list","member":{"type":"structure","members":{"Type":{},"Values":{"type":"list","member":{}}}}},"ExcludeManagementEventSources":{"type":"list","member":{}}}}},"S2k":{"type":"list","member":{}},"S2l":{"type":"structure","required":["S3"],"members":{"S3":{"type":"structure","required":["S3LocationUri","S3BucketRegion","S3BucketAccessRoleArn"],"members":{"S3LocationUri":{},"S3BucketRegion":{},"S3BucketAccessRoleArn":{}}}}},"S2o":{"type":"structure","members":{"PrefixesFound":{"type":"long"},"PrefixesCompleted":{"type":"long"},"FilesCompleted":{"type":"long"},"EventsCompleted":{"type":"long"},"FailedEntries":{"type":"long"}}},"S2r":{"type":"list","member":{"type":"structure","members":{"InsightType":{}}}}}}

/***/ }),
/* 439 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeTrails":{"result_key":"trailList"},"GetQueryResults":{"input_token":"NextToken","output_token":"NextToken"},"ListChannels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListEventDataStores":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListImportFailures":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Failures"},"ListImports":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Imports"},"ListInsightsMetricData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPublicKeys":{"input_token":"NextToken","output_token":"NextToken","result_key":"PublicKeyList"},"ListQueries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTags":{"input_token":"NextToken","output_token":"NextToken","result_key":"ResourceTagList"},"ListTrails":{"input_token":"NextToken","output_token":"NextToken","result_key":"Trails"},"LookupEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Events"}}}

/***/ }),
/* 440 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-10-06","endpointPrefix":"codebuild","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceFullName":"AWS CodeBuild","serviceId":"CodeBuild","signatureVersion":"v4","targetPrefix":"CodeBuild_20161006","uid":"codebuild-2016-10-06"},"operations":{"BatchDeleteBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"buildsDeleted":{"shape":"S2"},"buildsNotDeleted":{"shape":"S5"}}}},"BatchGetBuildBatches":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S9"}}},"output":{"type":"structure","members":{"buildBatches":{"type":"list","member":{"shape":"Sc"}},"buildBatchesNotFound":{"shape":"S9"}}}},"BatchGetBuilds":{"input":{"type":"structure","required":["ids"],"members":{"ids":{"shape":"S2"}}},"output":{"type":"structure","members":{"builds":{"type":"list","member":{"shape":"S24"}},"buildsNotFound":{"shape":"S2"}}}},"BatchGetFleets":{"input":{"type":"structure","required":["names"],"members":{"names":{"shape":"S2f"}}},"output":{"type":"structure","members":{"fleets":{"type":"list","member":{"shape":"S2i"}},"fleetsNotFound":{"shape":"S2f"}}}},"BatchGetProjects":{"input":{"type":"structure","required":["names"],"members":{"names":{"shape":"S30"}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"S33"}},"projectsNotFound":{"shape":"S30"}}}},"BatchGetReportGroups":{"input":{"type":"structure","required":["reportGroupArns"],"members":{"reportGroupArns":{"shape":"S3l"}}},"output":{"type":"structure","members":{"reportGroups":{"type":"list","member":{"shape":"S3o"}},"reportGroupsNotFound":{"shape":"S3l"}}}},"BatchGetReports":{"input":{"type":"structure","required":["reportArns"],"members":{"reportArns":{"shape":"S3x"}}},"output":{"type":"structure","members":{"reports":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"name":{},"reportGroupArn":{},"executionId":{},"status":{},"created":{"type":"timestamp"},"expired":{"type":"timestamp"},"exportConfig":{"shape":"S3r"},"truncated":{"type":"boolean"},"testSummary":{"type":"structure","required":["total","statusCounts","durationInNanoSeconds"],"members":{"total":{"type":"integer"},"statusCounts":{"type":"map","key":{},"value":{"type":"integer"}},"durationInNanoSeconds":{"type":"long"}}},"codeCoverageSummary":{"type":"structure","members":{"lineCoveragePercentage":{"type":"double"},"linesCovered":{"type":"integer"},"linesMissed":{"type":"integer"},"branchCoveragePercentage":{"type":"double"},"branchesCovered":{"type":"integer"},"branchesMissed":{"type":"integer"}}}}}},"reportsNotFound":{"shape":"S3x"}}}},"CreateFleet":{"input":{"type":"structure","required":["name","baseCapacity","environmentType","computeType"],"members":{"name":{},"baseCapacity":{"type":"integer"},"environmentType":{},"computeType":{},"scalingConfiguration":{"shape":"S48"},"overflowBehavior":{},"vpcConfig":{"shape":"S1j"},"fleetServiceRole":{},"tags":{"shape":"S2v"}}},"output":{"type":"structure","members":{"fleet":{"shape":"S2i"}}}},"CreateProject":{"input":{"type":"structure","required":["name","source","artifacts","environment","serviceRole"],"members":{"name":{},"description":{},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"S36"},"secondaryArtifacts":{"shape":"S39"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S2v"},"vpcConfig":{"shape":"S1j"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S1d"},"fileSystemLocations":{"shape":"S1m"},"buildBatchConfig":{"shape":"S1p"},"concurrentBuildLimit":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"S33"}}}},"CreateReportGroup":{"input":{"type":"structure","required":["name","type","exportConfig"],"members":{"name":{},"type":{},"exportConfig":{"shape":"S3r"},"tags":{"shape":"S2v"}}},"output":{"type":"structure","members":{"reportGroup":{"shape":"S3o"}}}},"CreateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"filterGroups":{"shape":"S3d"},"buildType":{}}},"output":{"type":"structure","members":{"webhook":{"shape":"S3c"}}}},"DeleteBuildBatch":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"statusCode":{},"buildsDeleted":{"shape":"S2"},"buildsNotDeleted":{"shape":"S5"}}}},"DeleteFleet":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeleteReport":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteReportGroup":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"deleteReports":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteSourceCredentials":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"arn":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"DescribeCodeCoverages":{"input":{"type":"structure","required":["reportArn"],"members":{"reportArn":{},"nextToken":{},"maxResults":{"type":"integer"},"sortOrder":{},"sortBy":{},"minLineCoveragePercentage":{"type":"double"},"maxLineCoveragePercentage":{"type":"double"}}},"output":{"type":"structure","members":{"nextToken":{},"codeCoverages":{"type":"list","member":{"type":"structure","members":{"id":{},"reportARN":{},"filePath":{},"lineCoveragePercentage":{"type":"double"},"linesCovered":{"type":"integer"},"linesMissed":{"type":"integer"},"branchCoveragePercentage":{"type":"double"},"branchesCovered":{"type":"integer"},"branchesMissed":{"type":"integer"},"expired":{"type":"timestamp"}}}}}}},"DescribeTestCases":{"input":{"type":"structure","required":["reportArn"],"members":{"reportArn":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"status":{},"keyword":{}}}}},"output":{"type":"structure","members":{"nextToken":{},"testCases":{"type":"list","member":{"type":"structure","members":{"reportArn":{},"testRawDataPath":{},"prefix":{},"name":{},"status":{},"durationInNanoSeconds":{"type":"long"},"message":{},"expired":{"type":"timestamp"}}}}}}},"GetReportGroupTrend":{"input":{"type":"structure","required":["reportGroupArn","trendField"],"members":{"reportGroupArn":{},"numOfReports":{"type":"integer"},"trendField":{}}},"output":{"type":"structure","members":{"stats":{"type":"structure","members":{"average":{},"max":{},"min":{}}},"rawData":{"type":"list","member":{"type":"structure","members":{"reportArn":{},"data":{}}}}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"policy":{}}}},"ImportSourceCredentials":{"input":{"type":"structure","required":["token","serverType","authType"],"members":{"username":{},"token":{"type":"string","sensitive":true},"serverType":{},"authType":{},"shouldOverwrite":{"type":"boolean"}}},"output":{"type":"structure","members":{"arn":{}}}},"InvalidateProjectCache":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{}}},"output":{"type":"structure","members":{}}},"ListBuildBatches":{"input":{"type":"structure","members":{"filter":{"shape":"S5o"},"maxResults":{"type":"integer"},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"nextToken":{}}}},"ListBuildBatchesForProject":{"input":{"type":"structure","members":{"projectName":{},"filter":{"shape":"S5o"},"maxResults":{"type":"integer"},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S9"},"nextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListBuildsForProject":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"ids":{"shape":"S2"},"nextToken":{}}}},"ListCuratedEnvironmentImages":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"platforms":{"type":"list","member":{"type":"structure","members":{"platform":{},"languages":{"type":"list","member":{"type":"structure","members":{"language":{},"images":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"versions":{"type":"list","member":{}}}}}}}}}}}}}},"ListFleets":{"input":{"type":"structure","members":{"nextToken":{"type":"string","sensitive":true},"maxResults":{"type":"integer"},"sortOrder":{},"sortBy":{}}},"output":{"type":"structure","members":{"nextToken":{},"fleets":{"type":"list","member":{}}}}},"ListProjects":{"input":{"type":"structure","members":{"sortBy":{},"sortOrder":{},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"shape":"S30"}}}},"ListReportGroups":{"input":{"type":"structure","members":{"sortOrder":{},"sortBy":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"reportGroups":{"shape":"S3l"}}}},"ListReports":{"input":{"type":"structure","members":{"sortOrder":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"shape":"S6j"}}},"output":{"type":"structure","members":{"nextToken":{},"reports":{"shape":"S3x"}}}},"ListReportsForReportGroup":{"input":{"type":"structure","required":["reportGroupArn"],"members":{"reportGroupArn":{},"nextToken":{},"sortOrder":{},"maxResults":{"type":"integer"},"filter":{"shape":"S6j"}}},"output":{"type":"structure","members":{"nextToken":{},"reports":{"shape":"S3x"}}}},"ListSharedProjects":{"input":{"type":"structure","members":{"sortBy":{},"sortOrder":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"nextToken":{},"projects":{"type":"list","member":{}}}}},"ListSharedReportGroups":{"input":{"type":"structure","members":{"sortOrder":{},"sortBy":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"nextToken":{},"reportGroups":{"shape":"S3l"}}}},"ListSourceCredentials":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"sourceCredentialsInfos":{"type":"list","member":{"type":"structure","members":{"arn":{},"serverType":{},"authType":{},"resource":{}}}}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["policy","resourceArn"],"members":{"policy":{},"resourceArn":{}}},"output":{"type":"structure","members":{"resourceArn":{}}}},"RetryBuild":{"input":{"type":"structure","members":{"id":{},"idempotencyToken":{}}},"output":{"type":"structure","members":{"build":{"shape":"S24"}}}},"RetryBuildBatch":{"input":{"type":"structure","members":{"id":{},"idempotencyToken":{},"retryType":{}}},"output":{"type":"structure","members":{"buildBatch":{"shape":"Sc"}}}},"StartBuild":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"secondarySourcesOverride":{"shape":"St"},"secondarySourcesVersionOverride":{"shape":"Su"},"sourceVersion":{},"artifactsOverride":{"shape":"S36"},"secondaryArtifactsOverride":{"shape":"S39"},"environmentVariablesOverride":{"shape":"S17"},"sourceTypeOverride":{},"sourceLocationOverride":{},"sourceAuthOverride":{"shape":"Sq"},"gitCloneDepthOverride":{"type":"integer"},"gitSubmodulesConfigOverride":{"shape":"So"},"buildspecOverride":{},"insecureSslOverride":{"type":"boolean"},"reportBuildStatusOverride":{"type":"boolean"},"buildStatusConfigOverride":{"shape":"Ss"},"environmentTypeOverride":{},"imageOverride":{},"computeTypeOverride":{},"certificateOverride":{},"cacheOverride":{"shape":"Sz"},"serviceRoleOverride":{},"privilegedModeOverride":{"type":"boolean"},"timeoutInMinutesOverride":{"type":"integer"},"queuedTimeoutInMinutesOverride":{"type":"integer"},"encryptionKeyOverride":{},"idempotencyToken":{},"logsConfigOverride":{"shape":"S1d"},"registryCredentialOverride":{"shape":"S1a"},"imagePullCredentialsTypeOverride":{},"debugSessionEnabled":{"type":"boolean"},"fleetOverride":{"shape":"S16"}}},"output":{"type":"structure","members":{"build":{"shape":"S24"}}}},"StartBuildBatch":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"secondarySourcesOverride":{"shape":"St"},"secondarySourcesVersionOverride":{"shape":"Su"},"sourceVersion":{},"artifactsOverride":{"shape":"S36"},"secondaryArtifactsOverride":{"shape":"S39"},"environmentVariablesOverride":{"shape":"S17"},"sourceTypeOverride":{},"sourceLocationOverride":{},"sourceAuthOverride":{"shape":"Sq"},"gitCloneDepthOverride":{"type":"integer"},"gitSubmodulesConfigOverride":{"shape":"So"},"buildspecOverride":{},"insecureSslOverride":{"type":"boolean"},"reportBuildBatchStatusOverride":{"type":"boolean"},"environmentTypeOverride":{},"imageOverride":{},"computeTypeOverride":{},"certificateOverride":{},"cacheOverride":{"shape":"Sz"},"serviceRoleOverride":{},"privilegedModeOverride":{"type":"boolean"},"buildTimeoutInMinutesOverride":{"type":"integer"},"queuedTimeoutInMinutesOverride":{"type":"integer"},"encryptionKeyOverride":{},"idempotencyToken":{},"logsConfigOverride":{"shape":"S1d"},"registryCredentialOverride":{"shape":"S1a"},"imagePullCredentialsTypeOverride":{},"buildBatchConfigOverride":{"shape":"S1p"},"debugSessionEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"buildBatch":{"shape":"Sc"}}}},"StopBuild":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"build":{"shape":"S24"}}}},"StopBuildBatch":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"buildBatch":{"shape":"Sc"}}}},"UpdateFleet":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"baseCapacity":{"type":"integer"},"environmentType":{},"computeType":{},"scalingConfiguration":{"shape":"S48"},"overflowBehavior":{},"vpcConfig":{"shape":"S1j"},"fleetServiceRole":{},"tags":{"shape":"S2v"}}},"output":{"type":"structure","members":{"fleet":{"shape":"S2i"}}}},"UpdateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"S36"},"secondaryArtifacts":{"shape":"S39"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S2v"},"vpcConfig":{"shape":"S1j"},"badgeEnabled":{"type":"boolean"},"logsConfig":{"shape":"S1d"},"fileSystemLocations":{"shape":"S1m"},"buildBatchConfig":{"shape":"S1p"},"concurrentBuildLimit":{"type":"integer"}}},"output":{"type":"structure","members":{"project":{"shape":"S33"}}}},"UpdateProjectVisibility":{"input":{"type":"structure","required":["projectArn","projectVisibility"],"members":{"projectArn":{},"projectVisibility":{},"resourceAccessRole":{}}},"output":{"type":"structure","members":{"projectArn":{},"publicProjectAlias":{},"projectVisibility":{}}}},"UpdateReportGroup":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"exportConfig":{"shape":"S3r"},"tags":{"shape":"S2v"}}},"output":{"type":"structure","members":{"reportGroup":{"shape":"S3o"}}}},"UpdateWebhook":{"input":{"type":"structure","required":["projectName"],"members":{"projectName":{},"branchFilter":{},"rotateSecret":{"type":"boolean"},"filterGroups":{"shape":"S3d"},"buildType":{}}},"output":{"type":"structure","members":{"webhook":{"shape":"S3c"}}}}},"shapes":{"S2":{"type":"list","member":{}},"S5":{"type":"list","member":{"type":"structure","members":{"id":{},"statusCode":{}}}},"S9":{"type":"list","member":{}},"Sc":{"type":"structure","members":{"id":{},"arn":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"currentPhase":{},"buildBatchStatus":{},"sourceVersion":{},"resolvedSourceVersion":{},"projectName":{},"phases":{"type":"list","member":{"type":"structure","members":{"phaseType":{},"phaseStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"durationInSeconds":{"type":"long"},"contexts":{"shape":"Sj"}}}},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"Sw"},"secondaryArtifacts":{"shape":"Sy"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"logConfig":{"shape":"S1d"},"buildTimeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"complete":{"type":"boolean"},"initiator":{},"vpcConfig":{"shape":"S1j"},"encryptionKey":{},"buildBatchNumber":{"type":"long"},"fileSystemLocations":{"shape":"S1m"},"buildBatchConfig":{"shape":"S1p"},"buildGroups":{"type":"list","member":{"type":"structure","members":{"identifier":{},"dependsOn":{"type":"list","member":{}},"ignoreFailure":{"type":"boolean"},"currentBuildSummary":{"shape":"S1w"},"priorBuildSummaryList":{"type":"list","member":{"shape":"S1w"}}}}},"debugSessionEnabled":{"type":"boolean"}}},"Sj":{"type":"list","member":{"type":"structure","members":{"statusCode":{},"message":{}}}},"Sl":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"gitCloneDepth":{"type":"integer"},"gitSubmodulesConfig":{"shape":"So"},"buildspec":{},"auth":{"shape":"Sq"},"reportBuildStatus":{"type":"boolean"},"buildStatusConfig":{"shape":"Ss"},"insecureSsl":{"type":"boolean"},"sourceIdentifier":{}}},"So":{"type":"structure","required":["fetchSubmodules"],"members":{"fetchSubmodules":{"type":"boolean"}}},"Sq":{"type":"structure","required":["type"],"members":{"type":{},"resource":{}}},"Ss":{"type":"structure","members":{"context":{},"targetUrl":{}}},"St":{"type":"list","member":{"shape":"Sl"}},"Su":{"type":"list","member":{"type":"structure","required":["sourceIdentifier","sourceVersion"],"members":{"sourceIdentifier":{},"sourceVersion":{}}}},"Sw":{"type":"structure","members":{"location":{},"sha256sum":{},"md5sum":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{},"bucketOwnerAccess":{}}},"Sy":{"type":"list","member":{"shape":"Sw"}},"Sz":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"modes":{"type":"list","member":{}}}},"S13":{"type":"structure","required":["type","image","computeType"],"members":{"type":{},"image":{},"computeType":{},"fleet":{"shape":"S16"},"environmentVariables":{"shape":"S17"},"privilegedMode":{"type":"boolean"},"certificate":{},"registryCredential":{"shape":"S1a"},"imagePullCredentialsType":{}}},"S16":{"type":"structure","members":{"fleetArn":{}}},"S17":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"type":{}}}},"S1a":{"type":"structure","required":["credential","credentialProvider"],"members":{"credential":{},"credentialProvider":{}}},"S1d":{"type":"structure","members":{"cloudWatchLogs":{"shape":"S1e"},"s3Logs":{"shape":"S1g"}}},"S1e":{"type":"structure","required":["status"],"members":{"status":{},"groupName":{},"streamName":{}}},"S1g":{"type":"structure","required":["status"],"members":{"status":{},"location":{},"encryptionDisabled":{"type":"boolean"},"bucketOwnerAccess":{}}},"S1j":{"type":"structure","members":{"vpcId":{},"subnets":{"type":"list","member":{}},"securityGroupIds":{"type":"list","member":{}}}},"S1m":{"type":"list","member":{"type":"structure","members":{"type":{},"location":{},"mountPoint":{},"identifier":{},"mountOptions":{}}}},"S1p":{"type":"structure","members":{"serviceRole":{},"combineArtifacts":{"type":"boolean"},"restrictions":{"type":"structure","members":{"maximumBuildsAllowed":{"type":"integer"},"computeTypesAllowed":{"type":"list","member":{}}}},"timeoutInMins":{"type":"integer"},"batchReportMode":{}}},"S1w":{"type":"structure","members":{"arn":{},"requestedOn":{"type":"timestamp"},"buildStatus":{},"primaryArtifact":{"shape":"S1x"},"secondaryArtifacts":{"type":"list","member":{"shape":"S1x"}}}},"S1x":{"type":"structure","members":{"type":{},"location":{},"identifier":{}}},"S24":{"type":"structure","members":{"id":{},"arn":{},"buildNumber":{"type":"long"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"currentPhase":{},"buildStatus":{},"sourceVersion":{},"resolvedSourceVersion":{},"projectName":{},"phases":{"type":"list","member":{"type":"structure","members":{"phaseType":{},"phaseStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"durationInSeconds":{"type":"long"},"contexts":{"shape":"Sj"}}}},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"Sw"},"secondaryArtifacts":{"shape":"Sy"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"logs":{"type":"structure","members":{"groupName":{},"streamName":{},"deepLink":{},"s3DeepLink":{},"cloudWatchLogsArn":{},"s3LogsArn":{},"cloudWatchLogs":{"shape":"S1e"},"s3Logs":{"shape":"S1g"}}},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"buildComplete":{"type":"boolean"},"initiator":{},"vpcConfig":{"shape":"S1j"},"networkInterface":{"type":"structure","members":{"subnetId":{},"networkInterfaceId":{}}},"encryptionKey":{},"exportedEnvironmentVariables":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"reportArns":{"type":"list","member":{}},"fileSystemLocations":{"shape":"S1m"},"debugSession":{"type":"structure","members":{"sessionEnabled":{"type":"boolean"},"sessionTarget":{}}},"buildBatchArn":{}}},"S2f":{"type":"list","member":{}},"S2i":{"type":"structure","members":{"arn":{},"name":{},"id":{},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"status":{"type":"structure","members":{"statusCode":{},"context":{},"message":{}}},"baseCapacity":{"type":"integer"},"environmentType":{},"computeType":{},"scalingConfiguration":{"type":"structure","members":{"scalingType":{},"targetTrackingScalingConfigs":{"shape":"S2q"},"maxCapacity":{"type":"integer"},"desiredCapacity":{"type":"integer"}}},"overflowBehavior":{},"vpcConfig":{"shape":"S1j"},"fleetServiceRole":{},"tags":{"shape":"S2v"}}},"S2q":{"type":"list","member":{"type":"structure","members":{"metricType":{},"targetValue":{"type":"double"}}}},"S2v":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S30":{"type":"list","member":{}},"S33":{"type":"structure","members":{"name":{},"arn":{},"description":{},"source":{"shape":"Sl"},"secondarySources":{"shape":"St"},"sourceVersion":{},"secondarySourceVersions":{"shape":"Su"},"artifacts":{"shape":"S36"},"secondaryArtifacts":{"shape":"S39"},"cache":{"shape":"Sz"},"environment":{"shape":"S13"},"serviceRole":{},"timeoutInMinutes":{"type":"integer"},"queuedTimeoutInMinutes":{"type":"integer"},"encryptionKey":{},"tags":{"shape":"S2v"},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"webhook":{"shape":"S3c"},"vpcConfig":{"shape":"S1j"},"badge":{"type":"structure","members":{"badgeEnabled":{"type":"boolean"},"badgeRequestUrl":{}}},"logsConfig":{"shape":"S1d"},"fileSystemLocations":{"shape":"S1m"},"buildBatchConfig":{"shape":"S1p"},"concurrentBuildLimit":{"type":"integer"},"projectVisibility":{},"publicProjectAlias":{},"resourceAccessRole":{}}},"S36":{"type":"structure","required":["type"],"members":{"type":{},"location":{},"path":{},"namespaceType":{},"name":{},"packaging":{},"overrideArtifactName":{"type":"boolean"},"encryptionDisabled":{"type":"boolean"},"artifactIdentifier":{},"bucketOwnerAccess":{}}},"S39":{"type":"list","member":{"shape":"S36"}},"S3c":{"type":"structure","members":{"url":{},"payloadUrl":{},"secret":{},"branchFilter":{},"filterGroups":{"shape":"S3d"},"buildType":{},"lastModifiedSecret":{"type":"timestamp"}}},"S3d":{"type":"list","member":{"type":"list","member":{"type":"structure","required":["type","pattern"],"members":{"type":{},"pattern":{},"excludeMatchedPattern":{"type":"boolean"}}}}},"S3l":{"type":"list","member":{}},"S3o":{"type":"structure","members":{"arn":{},"name":{},"type":{},"exportConfig":{"shape":"S3r"},"created":{"type":"timestamp"},"lastModified":{"type":"timestamp"},"tags":{"shape":"S2v"},"status":{}}},"S3r":{"type":"structure","members":{"exportConfigType":{},"s3Destination":{"type":"structure","members":{"bucket":{},"bucketOwner":{},"path":{},"packaging":{},"encryptionKey":{},"encryptionDisabled":{"type":"boolean"}}}}},"S3x":{"type":"list","member":{}},"S48":{"type":"structure","members":{"scalingType":{},"targetTrackingScalingConfigs":{"shape":"S2q"},"maxCapacity":{"type":"integer"}}},"S5o":{"type":"structure","members":{"status":{}}},"S6j":{"type":"structure","members":{"status":{}}}}}

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCodeCoverages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"codeCoverages"},"DescribeTestCases":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"testCases"},"ListBuildBatches":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"ids"},"ListBuildBatchesForProject":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"ids"},"ListBuilds":{"input_token":"nextToken","output_token":"nextToken","result_key":"ids"},"ListBuildsForProject":{"input_token":"nextToken","output_token":"nextToken","result_key":"ids"},"ListFleets":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListReportGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reportGroups"},"ListReports":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reports"},"ListReportsForReportGroup":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reports"},"ListSharedProjects":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"projects"},"ListSharedReportGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"reportGroups"}}}

/***/ }),
/* 442 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-04-13","endpointPrefix":"codecommit","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeCommit","serviceFullName":"AWS CodeCommit","serviceId":"CodeCommit","signatureVersion":"v4","targetPrefix":"CodeCommit_20150413","uid":"codecommit-2015-04-13"},"operations":{"AssociateApprovalRuleTemplateWithRepository":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryName"],"members":{"approvalRuleTemplateName":{},"repositoryName":{}}}},"BatchAssociateApprovalRuleTemplateWithRepositories":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryNames"],"members":{"approvalRuleTemplateName":{},"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","required":["associatedRepositoryNames","errors"],"members":{"associatedRepositoryNames":{"shape":"S5"},"errors":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchDescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"maxConflictFiles":{"type":"integer"},"filePaths":{"type":"list","member":{}},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflicts","destinationCommitId","sourceCommitId"],"members":{"conflicts":{"type":"list","member":{"type":"structure","members":{"conflictMetadata":{"shape":"Sn"},"mergeHunks":{"shape":"S12"}}}},"nextToken":{},"errors":{"type":"list","member":{"type":"structure","required":["filePath","exceptionName","message"],"members":{"filePath":{},"exceptionName":{},"message":{}}}},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"BatchDisassociateApprovalRuleTemplateFromRepositories":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryNames"],"members":{"approvalRuleTemplateName":{},"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","required":["disassociatedRepositoryNames","errors"],"members":{"disassociatedRepositoryNames":{"shape":"S5"},"errors":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchGetCommits":{"input":{"type":"structure","required":["commitIds","repositoryName"],"members":{"commitIds":{"type":"list","member":{}},"repositoryName":{}}},"output":{"type":"structure","members":{"commits":{"type":"list","member":{"shape":"S1l"}},"errors":{"type":"list","member":{"type":"structure","members":{"commitId":{},"errorCode":{},"errorMessage":{}}}}}}},"BatchGetRepositories":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"shape":"S5"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1x"}},"repositoriesNotFound":{"type":"list","member":{}},"errors":{"type":"list","member":{"type":"structure","members":{"repositoryId":{},"repositoryName":{},"errorCode":{},"errorMessage":{}}}}}}},"CreateApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName","approvalRuleTemplateContent"],"members":{"approvalRuleTemplateName":{},"approvalRuleTemplateContent":{},"approvalRuleTemplateDescription":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2g"}}}},"CreateBranch":{"input":{"type":"structure","required":["repositoryName","branchName","commitId"],"members":{"repositoryName":{},"branchName":{},"commitId":{}}}},"CreateCommit":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{},"parentCommitId":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"putFiles":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{},"fileMode":{},"fileContent":{"type":"blob"},"sourceFile":{"type":"structure","required":["filePath"],"members":{"filePath":{},"isMove":{"type":"boolean"}}}}}},"deleteFiles":{"shape":"S2s"},"setFileModes":{"shape":"S2u"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{},"filesAdded":{"shape":"S2x"},"filesUpdated":{"shape":"S2x"},"filesDeleted":{"shape":"S2x"}}}},"CreatePullRequest":{"input":{"type":"structure","required":["title","targets"],"members":{"title":{},"description":{},"targets":{"type":"list","member":{"type":"structure","required":["repositoryName","sourceReference"],"members":{"repositoryName":{},"sourceReference":{},"destinationReference":{}}}},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S37"}}}},"CreatePullRequestApprovalRule":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName","approvalRuleContent"],"members":{"pullRequestId":{},"approvalRuleName":{},"approvalRuleContent":{}}},"output":{"type":"structure","required":["approvalRule"],"members":{"approvalRule":{"shape":"S3g"}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{},"tags":{"shape":"S3o"},"kmsKeyId":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1x"}}}},"CreateUnreferencedMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3t"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"DeleteApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplateId"],"members":{"approvalRuleTemplateId":{}}}},"DeleteBranch":{"input":{"type":"structure","required":["repositoryName","branchName"],"members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"deletedBranch":{"shape":"S42"}}}},"DeleteCommentContent":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S46"}}}},"DeleteFile":{"input":{"type":"structure","required":["repositoryName","branchName","filePath","parentCommitId"],"members":{"repositoryName":{},"branchName":{},"filePath":{},"parentCommitId":{},"keepEmptyFolders":{"type":"boolean"},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId","filePath"],"members":{"commitId":{},"blobId":{},"treeId":{},"filePath":{}}}},"DeletePullRequestApprovalRule":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName"],"members":{"pullRequestId":{},"approvalRuleName":{}}},"output":{"type":"structure","required":["approvalRuleId"],"members":{"approvalRuleId":{}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryId":{}}}},"DescribeMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption","filePath"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"maxMergeHunks":{"type":"integer"},"filePath":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["conflictMetadata","mergeHunks","destinationCommitId","sourceCommitId"],"members":{"conflictMetadata":{"shape":"Sn"},"mergeHunks":{"shape":"S12"},"nextToken":{},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{}}}},"DescribePullRequestEvents":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"pullRequestEventType":{},"actorArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestEvents"],"members":{"pullRequestEvents":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"eventDate":{"type":"timestamp"},"pullRequestEventType":{},"actorArn":{},"pullRequestCreatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"sourceCommitId":{},"destinationCommitId":{},"mergeBase":{}}},"pullRequestStatusChangedEventMetadata":{"type":"structure","members":{"pullRequestStatus":{}}},"pullRequestSourceReferenceUpdatedEventMetadata":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"mergeBase":{}}},"pullRequestMergedStateChangedEventMetadata":{"type":"structure","members":{"repositoryName":{},"destinationReference":{},"mergeMetadata":{"shape":"S3c"}}},"approvalRuleEventMetadata":{"type":"structure","members":{"approvalRuleName":{},"approvalRuleId":{},"approvalRuleContent":{}}},"approvalStateChangedEventMetadata":{"type":"structure","members":{"revisionId":{},"approvalStatus":{}}},"approvalRuleOverriddenEventMetadata":{"type":"structure","members":{"revisionId":{},"overrideStatus":{}}}}}},"nextToken":{}}}},"DisassociateApprovalRuleTemplateFromRepository":{"input":{"type":"structure","required":["approvalRuleTemplateName","repositoryName"],"members":{"approvalRuleTemplateName":{},"repositoryName":{}}}},"EvaluatePullRequestApprovalRules":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","required":["evaluation"],"members":{"evaluation":{"type":"structure","members":{"approved":{"type":"boolean"},"overridden":{"type":"boolean"},"approvalRulesSatisfied":{"type":"list","member":{}},"approvalRulesNotSatisfied":{"type":"list","member":{}}}}}}},"GetApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2g"}}}},"GetBlob":{"input":{"type":"structure","required":["repositoryName","blobId"],"members":{"repositoryName":{},"blobId":{}}},"output":{"type":"structure","required":["content"],"members":{"content":{"type":"blob"}}}},"GetBranch":{"input":{"type":"structure","members":{"repositoryName":{},"branchName":{}}},"output":{"type":"structure","members":{"branch":{"shape":"S42"}}}},"GetComment":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S46"}}}},"GetCommentReactions":{"input":{"type":"structure","required":["commentId"],"members":{"commentId":{},"reactionUserArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["reactionsForComment"],"members":{"reactionsForComment":{"type":"list","member":{"type":"structure","members":{"reaction":{"type":"structure","members":{"emoji":{},"shortCode":{},"unicode":{}}},"reactionUsers":{"type":"list","member":{}},"reactionsFromDeletedUsersCount":{"type":"integer"}}}},"nextToken":{}}}},"GetCommentsForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForComparedCommitData":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5u"},"comments":{"shape":"S5x"}}}},"nextToken":{}}}},"GetCommentsForPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"commentsForPullRequestData":{"type":"list","member":{"type":"structure","members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5u"},"comments":{"shape":"S5x"}}}},"nextToken":{}}}},"GetCommit":{"input":{"type":"structure","required":["repositoryName","commitId"],"members":{"repositoryName":{},"commitId":{}}},"output":{"type":"structure","required":["commit"],"members":{"commit":{"shape":"S1l"}}}},"GetDifferences":{"input":{"type":"structure","required":["repositoryName","afterCommitSpecifier"],"members":{"repositoryName":{},"beforeCommitSpecifier":{},"afterCommitSpecifier":{},"beforePath":{},"afterPath":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"differences":{"type":"list","member":{"type":"structure","members":{"beforeBlob":{"shape":"S69"},"afterBlob":{"shape":"S69"},"changeType":{}}}},"NextToken":{}}}},"GetFile":{"input":{"type":"structure","required":["repositoryName","filePath"],"members":{"repositoryName":{},"commitSpecifier":{},"filePath":{}}},"output":{"type":"structure","required":["commitId","blobId","filePath","fileMode","fileSize","fileContent"],"members":{"commitId":{},"blobId":{},"filePath":{},"fileMode":{},"fileSize":{"type":"long"},"fileContent":{"type":"blob"}}}},"GetFolder":{"input":{"type":"structure","required":["repositoryName","folderPath"],"members":{"repositoryName":{},"commitSpecifier":{},"folderPath":{}}},"output":{"type":"structure","required":["commitId","folderPath"],"members":{"commitId":{},"folderPath":{},"treeId":{},"subFolders":{"type":"list","member":{"type":"structure","members":{"treeId":{},"absolutePath":{},"relativePath":{}}}},"files":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"symbolicLinks":{"type":"list","member":{"type":"structure","members":{"blobId":{},"absolutePath":{},"relativePath":{},"fileMode":{}}}},"subModules":{"type":"list","member":{"type":"structure","members":{"commitId":{},"absolutePath":{},"relativePath":{}}}}}}},"GetMergeCommit":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","members":{"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{},"mergedCommitId":{}}}},"GetMergeConflicts":{"input":{"type":"structure","required":["repositoryName","destinationCommitSpecifier","sourceCommitSpecifier","mergeOption"],"members":{"repositoryName":{},"destinationCommitSpecifier":{},"sourceCommitSpecifier":{},"mergeOption":{},"conflictDetailLevel":{},"maxConflictFiles":{"type":"integer"},"conflictResolutionStrategy":{},"nextToken":{}}},"output":{"type":"structure","required":["mergeable","destinationCommitId","sourceCommitId","conflictMetadataList"],"members":{"mergeable":{"type":"boolean"},"destinationCommitId":{},"sourceCommitId":{},"baseCommitId":{},"conflictMetadataList":{"type":"list","member":{"shape":"Sn"}},"nextToken":{}}}},"GetMergeOptions":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{}}},"output":{"type":"structure","required":["mergeOptions","sourceCommitId","destinationCommitId","baseCommitId"],"members":{"mergeOptions":{"type":"list","member":{}},"sourceCommitId":{},"destinationCommitId":{},"baseCommitId":{}}}},"GetPullRequest":{"input":{"type":"structure","required":["pullRequestId"],"members":{"pullRequestId":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S37"}}}},"GetPullRequestApprovalStates":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","members":{"approvals":{"type":"list","member":{"type":"structure","members":{"userArn":{},"approvalState":{}}}}}}},"GetPullRequestOverrideState":{"input":{"type":"structure","required":["pullRequestId","revisionId"],"members":{"pullRequestId":{},"revisionId":{}}},"output":{"type":"structure","members":{"overridden":{"type":"boolean"},"overrider":{}}}},"GetRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"repositoryMetadata":{"shape":"S1x"}}}},"GetRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{}}},"output":{"type":"structure","members":{"configurationId":{},"triggers":{"shape":"S7a"}}}},"ListApprovalRuleTemplates":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"approvalRuleTemplateNames":{"shape":"S7j"},"nextToken":{}}}},"ListAssociatedApprovalRuleTemplatesForRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"approvalRuleTemplateNames":{"shape":"S7j"},"nextToken":{}}}},"ListBranches":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"nextToken":{}}},"output":{"type":"structure","members":{"branches":{"shape":"S7e"},"nextToken":{}}}},"ListFileCommitHistory":{"input":{"type":"structure","required":["repositoryName","filePath"],"members":{"repositoryName":{},"commitSpecifier":{},"filePath":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","required":["revisionDag"],"members":{"revisionDag":{"type":"list","member":{"type":"structure","members":{"commit":{"shape":"S1l"},"blobId":{},"path":{},"revisionChildren":{"type":"list","member":{}}}}},"nextToken":{}}}},"ListPullRequests":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"authorArn":{},"pullRequestStatus":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["pullRequestIds"],"members":{"pullRequestIds":{"type":"list","member":{}},"nextToken":{}}}},"ListRepositories":{"input":{"type":"structure","members":{"nextToken":{},"sortBy":{},"order":{}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"repositoryId":{}}}},"nextToken":{}}}},"ListRepositoriesForApprovalRuleTemplate":{"input":{"type":"structure","required":["approvalRuleTemplateName"],"members":{"approvalRuleTemplateName":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositoryNames":{"shape":"S5"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S3o"},"nextToken":{}}}},"MergeBranchesByFastForward":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesBySquash":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3t"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergeBranchesByThreeWay":{"input":{"type":"structure","required":["repositoryName","sourceCommitSpecifier","destinationCommitSpecifier"],"members":{"repositoryName":{},"sourceCommitSpecifier":{},"destinationCommitSpecifier":{},"targetBranch":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"authorName":{},"email":{},"commitMessage":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3t"}}},"output":{"type":"structure","members":{"commitId":{},"treeId":{}}}},"MergePullRequestByFastForward":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S37"}}}},"MergePullRequestBySquash":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3t"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S37"}}}},"MergePullRequestByThreeWay":{"input":{"type":"structure","required":["pullRequestId","repositoryName"],"members":{"pullRequestId":{},"repositoryName":{},"sourceCommitId":{},"conflictDetailLevel":{},"conflictResolutionStrategy":{},"commitMessage":{},"authorName":{},"email":{},"keepEmptyFolders":{"type":"boolean"},"conflictResolution":{"shape":"S3t"}}},"output":{"type":"structure","members":{"pullRequest":{"shape":"S37"}}}},"OverridePullRequestApprovalRules":{"input":{"type":"structure","required":["pullRequestId","revisionId","overrideStatus"],"members":{"pullRequestId":{},"revisionId":{},"overrideStatus":{}}}},"PostCommentForComparedCommit":{"input":{"type":"structure","required":["repositoryName","afterCommitId","content"],"members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S5u"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5u"},"comment":{"shape":"S46"}}},"idempotent":true},"PostCommentForPullRequest":{"input":{"type":"structure","required":["pullRequestId","repositoryName","beforeCommitId","afterCommitId","content"],"members":{"pullRequestId":{},"repositoryName":{},"beforeCommitId":{},"afterCommitId":{},"location":{"shape":"S5u"},"content":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"repositoryName":{},"pullRequestId":{},"beforeCommitId":{},"afterCommitId":{},"beforeBlobId":{},"afterBlobId":{},"location":{"shape":"S5u"},"comment":{"shape":"S46"}}},"idempotent":true},"PostCommentReply":{"input":{"type":"structure","required":["inReplyTo","content"],"members":{"inReplyTo":{},"clientRequestToken":{"idempotencyToken":true},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S46"}}},"idempotent":true},"PutCommentReaction":{"input":{"type":"structure","required":["commentId","reactionValue"],"members":{"commentId":{},"reactionValue":{}}}},"PutFile":{"input":{"type":"structure","required":["repositoryName","branchName","fileContent","filePath"],"members":{"repositoryName":{},"branchName":{},"fileContent":{"type":"blob"},"filePath":{},"fileMode":{},"parentCommitId":{},"commitMessage":{},"name":{},"email":{}}},"output":{"type":"structure","required":["commitId","blobId","treeId"],"members":{"commitId":{},"blobId":{},"treeId":{}}}},"PutRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S7a"}}},"output":{"type":"structure","members":{"configurationId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S3o"}}}},"TestRepositoryTriggers":{"input":{"type":"structure","required":["repositoryName","triggers"],"members":{"repositoryName":{},"triggers":{"shape":"S7a"}}},"output":{"type":"structure","members":{"successfulExecutions":{"type":"list","member":{}},"failedExecutions":{"type":"list","member":{"type":"structure","members":{"trigger":{},"failureMessage":{}}}}}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}}},"UpdateApprovalRuleTemplateContent":{"input":{"type":"structure","required":["approvalRuleTemplateName","newRuleContent"],"members":{"approvalRuleTemplateName":{},"newRuleContent":{},"existingRuleContentSha256":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2g"}}}},"UpdateApprovalRuleTemplateDescription":{"input":{"type":"structure","required":["approvalRuleTemplateName","approvalRuleTemplateDescription"],"members":{"approvalRuleTemplateName":{},"approvalRuleTemplateDescription":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2g"}}}},"UpdateApprovalRuleTemplateName":{"input":{"type":"structure","required":["oldApprovalRuleTemplateName","newApprovalRuleTemplateName"],"members":{"oldApprovalRuleTemplateName":{},"newApprovalRuleTemplateName":{}}},"output":{"type":"structure","required":["approvalRuleTemplate"],"members":{"approvalRuleTemplate":{"shape":"S2g"}}}},"UpdateComment":{"input":{"type":"structure","required":["commentId","content"],"members":{"commentId":{},"content":{}}},"output":{"type":"structure","members":{"comment":{"shape":"S46"}}}},"UpdateDefaultBranch":{"input":{"type":"structure","required":["repositoryName","defaultBranchName"],"members":{"repositoryName":{},"defaultBranchName":{}}}},"UpdatePullRequestApprovalRuleContent":{"input":{"type":"structure","required":["pullRequestId","approvalRuleName","newRuleContent"],"members":{"pullRequestId":{},"approvalRuleName":{},"existingRuleContentSha256":{},"newRuleContent":{}}},"output":{"type":"structure","required":["approvalRule"],"members":{"approvalRule":{"shape":"S3g"}}}},"UpdatePullRequestApprovalState":{"input":{"type":"structure","required":["pullRequestId","revisionId","approvalState"],"members":{"pullRequestId":{},"revisionId":{},"approvalState":{}}}},"UpdatePullRequestDescription":{"input":{"type":"structure","required":["pullRequestId","description"],"members":{"pullRequestId":{},"description":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S37"}}}},"UpdatePullRequestStatus":{"input":{"type":"structure","required":["pullRequestId","pullRequestStatus"],"members":{"pullRequestId":{},"pullRequestStatus":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S37"}}}},"UpdatePullRequestTitle":{"input":{"type":"structure","required":["pullRequestId","title"],"members":{"pullRequestId":{},"title":{}}},"output":{"type":"structure","required":["pullRequest"],"members":{"pullRequest":{"shape":"S37"}}}},"UpdateRepositoryDescription":{"input":{"type":"structure","required":["repositoryName"],"members":{"repositoryName":{},"repositoryDescription":{}}}},"UpdateRepositoryEncryptionKey":{"input":{"type":"structure","required":["repositoryName","kmsKeyId"],"members":{"repositoryName":{},"kmsKeyId":{}}},"output":{"type":"structure","members":{"repositoryId":{},"kmsKeyId":{},"originalKmsKeyId":{}}}},"UpdateRepositoryName":{"input":{"type":"structure","required":["oldName","newName"],"members":{"oldName":{},"newName":{}}}}},"shapes":{"S5":{"type":"list","member":{}},"Sn":{"type":"structure","members":{"filePath":{},"fileSizes":{"type":"structure","members":{"source":{"type":"long"},"destination":{"type":"long"},"base":{"type":"long"}}},"fileModes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"objectTypes":{"type":"structure","members":{"source":{},"destination":{},"base":{}}},"numberOfConflicts":{"type":"integer"},"isBinaryFile":{"type":"structure","members":{"source":{"type":"boolean"},"destination":{"type":"boolean"},"base":{"type":"boolean"}}},"contentConflict":{"type":"boolean"},"fileModeConflict":{"type":"boolean"},"objectTypeConflict":{"type":"boolean"},"mergeOperations":{"type":"structure","members":{"source":{},"destination":{}}}}},"S12":{"type":"list","member":{"type":"structure","members":{"isConflict":{"type":"boolean"},"source":{"shape":"S15"},"destination":{"shape":"S15"},"base":{"shape":"S15"}}}},"S15":{"type":"structure","members":{"startLine":{"type":"integer"},"endLine":{"type":"integer"},"hunkContent":{}}},"S1l":{"type":"structure","members":{"commitId":{},"treeId":{},"parents":{"type":"list","member":{}},"message":{},"author":{"shape":"S1n"},"committer":{"shape":"S1n"},"additionalData":{}}},"S1n":{"type":"structure","members":{"name":{},"email":{},"date":{}}},"S1x":{"type":"structure","members":{"accountId":{},"repositoryId":{},"repositoryName":{},"repositoryDescription":{},"defaultBranch":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"cloneUrlHttp":{},"cloneUrlSsh":{},"Arn":{},"kmsKeyId":{}}},"S2g":{"type":"structure","members":{"approvalRuleTemplateId":{},"approvalRuleTemplateName":{},"approvalRuleTemplateDescription":{},"approvalRuleTemplateContent":{},"ruleContentSha256":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"lastModifiedUser":{}}},"S2s":{"type":"list","member":{"type":"structure","required":["filePath"],"members":{"filePath":{}}}},"S2u":{"type":"list","member":{"type":"structure","required":["filePath","fileMode"],"members":{"filePath":{},"fileMode":{}}}},"S2x":{"type":"list","member":{"type":"structure","members":{"absolutePath":{},"blobId":{},"fileMode":{}}}},"S37":{"type":"structure","members":{"pullRequestId":{},"title":{},"description":{},"lastActivityDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"pullRequestStatus":{},"authorArn":{},"pullRequestTargets":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"sourceReference":{},"destinationReference":{},"destinationCommit":{},"sourceCommit":{},"mergeBase":{},"mergeMetadata":{"shape":"S3c"}}}},"clientRequestToken":{},"revisionId":{},"approvalRules":{"type":"list","member":{"shape":"S3g"}}}},"S3c":{"type":"structure","members":{"isMerged":{"type":"boolean"},"mergedBy":{},"mergeCommitId":{},"mergeOption":{}}},"S3g":{"type":"structure","members":{"approvalRuleId":{},"approvalRuleName":{},"approvalRuleContent":{},"ruleContentSha256":{},"lastModifiedDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"},"lastModifiedUser":{},"originApprovalRuleTemplate":{"type":"structure","members":{"approvalRuleTemplateId":{},"approvalRuleTemplateName":{}}}}},"S3o":{"type":"map","key":{},"value":{}},"S3t":{"type":"structure","members":{"replaceContents":{"type":"list","member":{"type":"structure","required":["filePath","replacementType"],"members":{"filePath":{},"replacementType":{},"content":{"type":"blob"},"fileMode":{}}}},"deleteFiles":{"shape":"S2s"},"setFileModes":{"shape":"S2u"}}},"S42":{"type":"structure","members":{"branchName":{},"commitId":{}}},"S46":{"type":"structure","members":{"commentId":{},"content":{},"inReplyTo":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"authorArn":{},"deleted":{"type":"boolean"},"clientRequestToken":{},"callerReactions":{"type":"list","member":{}},"reactionCounts":{"type":"map","key":{},"value":{"type":"integer"}}}},"S5u":{"type":"structure","members":{"filePath":{},"filePosition":{"type":"long"},"relativeFileVersion":{}}},"S5x":{"type":"list","member":{"shape":"S46"}},"S69":{"type":"structure","members":{"blobId":{},"path":{},"mode":{}}},"S7a":{"type":"list","member":{"type":"structure","required":["name","destinationArn","events"],"members":{"name":{},"destinationArn":{},"customData":{},"branches":{"shape":"S7e"},"events":{"type":"list","member":{}}}}},"S7e":{"type":"list","member":{}},"S7j":{"type":"list","member":{}}}}

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeMergeConflicts":{"input_token":"nextToken","limit_key":"maxMergeHunks","output_token":"nextToken"},"DescribePullRequestEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentReactions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForComparedCommit":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetCommentsForPullRequest":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"GetDifferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMergeConflicts":{"input_token":"nextToken","limit_key":"maxConflictFiles","output_token":"nextToken"},"ListApprovalRuleTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListAssociatedApprovalRuleTemplatesForRepository":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListBranches":{"input_token":"nextToken","output_token":"nextToken","result_key":"branches"},"ListFileCommitHistory":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListPullRequests":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"},"ListRepositories":{"input_token":"nextToken","output_token":"nextToken","result_key":"repositories"},"ListRepositoriesForApprovalRuleTemplate":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken"}}}

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-06","endpointPrefix":"codedeploy","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"CodeDeploy","serviceFullName":"AWS CodeDeploy","serviceId":"CodeDeploy","signatureVersion":"v4","targetPrefix":"CodeDeploy_20141006","uid":"codedeploy-2014-10-06"},"operations":{"AddTagsToOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"BatchGetApplicationRevisions":{"input":{"type":"structure","required":["applicationName","revisions"],"members":{"applicationName":{},"revisions":{"shape":"Sa"}}},"output":{"type":"structure","members":{"applicationName":{},"errorMessage":{},"revisions":{"type":"list","member":{"type":"structure","members":{"revisionLocation":{"shape":"Sb"},"genericRevisionInfo":{"shape":"Su"}}}}}}},"BatchGetApplications":{"input":{"type":"structure","required":["applicationNames"],"members":{"applicationNames":{"shape":"S10"}}},"output":{"type":"structure","members":{"applicationsInfo":{"type":"list","member":{"shape":"S13"}}}}},"BatchGetDeploymentGroups":{"input":{"type":"structure","required":["applicationName","deploymentGroupNames"],"members":{"applicationName":{},"deploymentGroupNames":{"shape":"Sw"}}},"output":{"type":"structure","members":{"deploymentGroupsInfo":{"type":"list","member":{"shape":"S1b"}},"errorMessage":{}}}},"BatchGetDeploymentInstances":{"input":{"type":"structure","required":["deploymentId","instanceIds"],"members":{"deploymentId":{},"instanceIds":{"shape":"S32"}}},"output":{"type":"structure","members":{"instancesSummary":{"type":"list","member":{"shape":"S36"}},"errorMessage":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use BatchGetDeploymentTargets instead."},"BatchGetDeploymentTargets":{"input":{"type":"structure","required":["deploymentId","targetIds"],"members":{"deploymentId":{},"targetIds":{"shape":"S3j"}}},"output":{"type":"structure","members":{"deploymentTargets":{"type":"list","member":{"shape":"S3n"}}}}},"BatchGetDeployments":{"input":{"type":"structure","required":["deploymentIds"],"members":{"deploymentIds":{"shape":"S49"}}},"output":{"type":"structure","members":{"deploymentsInfo":{"type":"list","member":{"shape":"S4c"}}}}},"BatchGetOnPremisesInstances":{"input":{"type":"structure","required":["instanceNames"],"members":{"instanceNames":{"shape":"S6"}}},"output":{"type":"structure","members":{"instanceInfos":{"type":"list","member":{"shape":"S4t"}}}}},"ContinueDeployment":{"input":{"type":"structure","members":{"deploymentId":{},"deploymentWaitType":{}}}},"CreateApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"computePlatform":{},"tags":{"shape":"S2"}}},"output":{"type":"structure","members":{"applicationId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"deploymentGroupName":{},"revision":{"shape":"Sb"},"deploymentConfigName":{},"description":{},"ignoreApplicationStopFailures":{"type":"boolean"},"targetInstances":{"shape":"S4j"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"fileExistsBehavior":{},"overrideAlarmConfiguration":{"shape":"S1v"}}},"output":{"type":"structure","members":{"deploymentId":{}}}},"CreateDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S54"},"trafficRoutingConfig":{"shape":"S57"},"computePlatform":{},"zonalConfig":{"shape":"S5d"}}},"output":{"type":"structure","members":{"deploymentConfigId":{}}}},"CreateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName","serviceRoleArn"],"members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4k"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"outdatedInstancesStrategy":{},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"ec2TagSet":{"shape":"S2t"},"ecsServices":{"shape":"S2x"},"onPremisesTagSet":{"shape":"S2v"},"tags":{"shape":"S2"},"terminationHookEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"deploymentGroupId":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}}},"DeleteDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}}},"DeleteDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}},"DeleteGitHubAccountToken":{"input":{"type":"structure","members":{"tokenName":{}}},"output":{"type":"structure","members":{"tokenName":{}}}},"DeleteResourcesByExternalId":{"input":{"type":"structure","members":{"externalId":{}}},"output":{"type":"structure","members":{}}},"DeregisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}}},"GetApplication":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{}}},"output":{"type":"structure","members":{"application":{"shape":"S13"}}}},"GetApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"revision":{"shape":"Sb"}}},"output":{"type":"structure","members":{"applicationName":{},"revision":{"shape":"Sb"},"revisionInfo":{"shape":"Su"}}}},"GetDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{}}},"output":{"type":"structure","members":{"deploymentInfo":{"shape":"S4c"}}}},"GetDeploymentConfig":{"input":{"type":"structure","required":["deploymentConfigName"],"members":{"deploymentConfigName":{}}},"output":{"type":"structure","members":{"deploymentConfigInfo":{"type":"structure","members":{"deploymentConfigId":{},"deploymentConfigName":{},"minimumHealthyHosts":{"shape":"S54"},"createTime":{"type":"timestamp"},"computePlatform":{},"trafficRoutingConfig":{"shape":"S57"},"zonalConfig":{"shape":"S5d"}}}}}},"GetDeploymentGroup":{"input":{"type":"structure","required":["applicationName","deploymentGroupName"],"members":{"applicationName":{},"deploymentGroupName":{}}},"output":{"type":"structure","members":{"deploymentGroupInfo":{"shape":"S1b"}}}},"GetDeploymentInstance":{"input":{"type":"structure","required":["deploymentId","instanceId"],"members":{"deploymentId":{},"instanceId":{}}},"output":{"type":"structure","members":{"instanceSummary":{"shape":"S36"}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use GetDeploymentTarget instead."},"GetDeploymentTarget":{"input":{"type":"structure","required":["deploymentId","targetId"],"members":{"deploymentId":{},"targetId":{}}},"output":{"type":"structure","members":{"deploymentTarget":{"shape":"S3n"}}}},"GetOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{}}},"output":{"type":"structure","members":{"instanceInfo":{"shape":"S4t"}}}},"ListApplicationRevisions":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"sortBy":{},"sortOrder":{},"s3Bucket":{},"s3KeyPrefix":{},"deployed":{},"nextToken":{}}},"output":{"type":"structure","members":{"revisions":{"shape":"Sa"},"nextToken":{}}}},"ListApplications":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"applications":{"shape":"S10"},"nextToken":{}}}},"ListDeploymentConfigs":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"deploymentConfigsList":{"type":"list","member":{}},"nextToken":{}}}},"ListDeploymentGroups":{"input":{"type":"structure","required":["applicationName"],"members":{"applicationName":{},"nextToken":{}}},"output":{"type":"structure","members":{"applicationName":{},"deploymentGroups":{"shape":"Sw"},"nextToken":{}}}},"ListDeploymentInstances":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"nextToken":{},"instanceStatusFilter":{"type":"list","member":{"shape":"S37"}},"instanceTypeFilter":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"instancesList":{"shape":"S32"},"nextToken":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ListDeploymentTargets instead."},"ListDeploymentTargets":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"nextToken":{},"targetFilters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"targetIds":{"shape":"S3j"},"nextToken":{}}}},"ListDeployments":{"input":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"externalId":{},"includeOnlyStatuses":{"type":"list","member":{}},"createTimeRange":{"type":"structure","members":{"start":{"type":"timestamp"},"end":{"type":"timestamp"}}},"nextToken":{}}},"output":{"type":"structure","members":{"deployments":{"shape":"S49"},"nextToken":{}}}},"ListGitHubAccountTokenNames":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"tokenNameList":{"type":"list","member":{}},"nextToken":{}}}},"ListOnPremisesInstances":{"input":{"type":"structure","members":{"registrationStatus":{},"tagFilters":{"shape":"S1h"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceNames":{"shape":"S6"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S2"},"NextToken":{}}}},"PutLifecycleEventHookExecutionStatus":{"input":{"type":"structure","members":{"deploymentId":{},"lifecycleEventHookExecutionId":{},"status":{}}},"output":{"type":"structure","members":{"lifecycleEventHookExecutionId":{}}}},"RegisterApplicationRevision":{"input":{"type":"structure","required":["applicationName","revision"],"members":{"applicationName":{},"description":{},"revision":{"shape":"Sb"}}}},"RegisterOnPremisesInstance":{"input":{"type":"structure","required":["instanceName"],"members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{}}}},"RemoveTagsFromOnPremisesInstances":{"input":{"type":"structure","required":["tags","instanceNames"],"members":{"tags":{"shape":"S2"},"instanceNames":{"shape":"S6"}}}},"SkipWaitTimeForInstanceTermination":{"input":{"type":"structure","members":{"deploymentId":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use ContinueDeployment with DeploymentWaitType instead."},"StopDeployment":{"input":{"type":"structure","required":["deploymentId"],"members":{"deploymentId":{},"autoRollbackEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"status":{},"statusMessage":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S2"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApplication":{"input":{"type":"structure","members":{"applicationName":{},"newApplicationName":{}}}},"UpdateDeploymentGroup":{"input":{"type":"structure","required":["applicationName","currentDeploymentGroupName"],"members":{"applicationName":{},"currentDeploymentGroupName":{},"newDeploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S4k"},"serviceRoleArn":{},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"outdatedInstancesStrategy":{},"deploymentStyle":{"shape":"S22"},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"ec2TagSet":{"shape":"S2t"},"ecsServices":{"shape":"S2x"},"onPremisesTagSet":{"shape":"S2v"},"terminationHookEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"hooksNotCleanedUp":{"shape":"S1k"}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S6":{"type":"list","member":{}},"Sa":{"type":"list","member":{"shape":"Sb"}},"Sb":{"type":"structure","members":{"revisionType":{},"s3Location":{"type":"structure","members":{"bucket":{},"key":{},"bundleType":{},"version":{},"eTag":{}}},"gitHubLocation":{"type":"structure","members":{"repository":{},"commitId":{}}},"string":{"type":"structure","members":{"content":{},"sha256":{}},"deprecated":true,"deprecatedMessage":"RawString and String revision type are deprecated, use AppSpecContent type instead."},"appSpecContent":{"type":"structure","members":{"content":{},"sha256":{}}}}},"Su":{"type":"structure","members":{"description":{},"deploymentGroups":{"shape":"Sw"},"firstUsedTime":{"type":"timestamp"},"lastUsedTime":{"type":"timestamp"},"registerTime":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","members":{"applicationId":{},"applicationName":{},"createTime":{"type":"timestamp"},"linkedToGitHub":{"type":"boolean"},"gitHubAccountName":{},"computePlatform":{}}},"S1b":{"type":"structure","members":{"applicationName":{},"deploymentGroupId":{},"deploymentGroupName":{},"deploymentConfigName":{},"ec2TagFilters":{"shape":"S1e"},"onPremisesInstanceTagFilters":{"shape":"S1h"},"autoScalingGroups":{"shape":"S1k"},"serviceRoleArn":{},"targetRevision":{"shape":"Sb"},"triggerConfigurations":{"shape":"S1p"},"alarmConfiguration":{"shape":"S1v"},"autoRollbackConfiguration":{"shape":"S1z"},"deploymentStyle":{"shape":"S22"},"outdatedInstancesStrategy":{},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"lastSuccessfulDeployment":{"shape":"S2q"},"lastAttemptedDeployment":{"shape":"S2q"},"ec2TagSet":{"shape":"S2t"},"onPremisesTagSet":{"shape":"S2v"},"computePlatform":{},"ecsServices":{"shape":"S2x"},"terminationHookEnabled":{"type":"boolean"}}},"S1e":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"Type":{}}}},"S1k":{"type":"list","member":{"type":"structure","members":{"name":{},"hook":{},"terminationHook":{}}}},"S1p":{"type":"list","member":{"type":"structure","members":{"triggerName":{},"triggerTargetArn":{},"triggerEvents":{"type":"list","member":{}}}}},"S1v":{"type":"structure","members":{"enabled":{"type":"boolean"},"ignorePollAlarmFailure":{"type":"boolean"},"alarms":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}},"S1z":{"type":"structure","members":{"enabled":{"type":"boolean"},"events":{"type":"list","member":{}}}},"S22":{"type":"structure","members":{"deploymentType":{},"deploymentOption":{}}},"S26":{"type":"structure","members":{"terminateBlueInstancesOnDeploymentSuccess":{"type":"structure","members":{"action":{},"terminationWaitTimeInMinutes":{"type":"integer"}}},"deploymentReadyOption":{"type":"structure","members":{"actionOnTimeout":{},"waitTimeInMinutes":{"type":"integer"}}},"greenFleetProvisioningOption":{"type":"structure","members":{"action":{}}}}},"S2e":{"type":"structure","members":{"elbInfoList":{"type":"list","member":{"type":"structure","members":{"name":{}}}},"targetGroupInfoList":{"shape":"S2i"},"targetGroupPairInfoList":{"type":"list","member":{"type":"structure","members":{"targetGroups":{"shape":"S2i"},"prodTrafficRoute":{"shape":"S2n"},"testTrafficRoute":{"shape":"S2n"}}}}}},"S2i":{"type":"list","member":{"shape":"S2j"}},"S2j":{"type":"structure","members":{"name":{}}},"S2n":{"type":"structure","members":{"listenerArns":{"type":"list","member":{}}}},"S2q":{"type":"structure","members":{"deploymentId":{},"status":{},"endTime":{"type":"timestamp"},"createTime":{"type":"timestamp"}}},"S2t":{"type":"structure","members":{"ec2TagSetList":{"type":"list","member":{"shape":"S1e"}}}},"S2v":{"type":"structure","members":{"onPremisesTagSetList":{"type":"list","member":{"shape":"S1h"}}}},"S2x":{"type":"list","member":{"type":"structure","members":{"serviceName":{},"clusterName":{}}}},"S32":{"type":"list","member":{}},"S36":{"type":"structure","members":{"deploymentId":{},"instanceId":{},"status":{"shape":"S37"},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"instanceType":{}},"deprecated":true,"deprecatedMessage":"InstanceSummary is deprecated, use DeploymentTarget instead."},"S37":{"type":"string","deprecated":true,"deprecatedMessage":"InstanceStatus is deprecated, use TargetStatus instead."},"S38":{"type":"list","member":{"type":"structure","members":{"lifecycleEventName":{},"diagnostics":{"type":"structure","members":{"errorCode":{},"scriptName":{},"message":{},"logTail":{}}},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"status":{}}}},"S3j":{"type":"list","member":{}},"S3n":{"type":"structure","members":{"deploymentTargetType":{},"instanceTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"instanceLabel":{}}},"lambdaTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"status":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"lambdaFunctionInfo":{"type":"structure","members":{"functionName":{},"functionAlias":{},"currentVersion":{},"targetVersion":{},"targetVersionWeight":{"type":"double"}}}}},"ecsTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"targetArn":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"status":{},"taskSetsInfo":{"type":"list","member":{"type":"structure","members":{"identifer":{},"desiredCount":{"type":"long"},"pendingCount":{"type":"long"},"runningCount":{"type":"long"},"status":{},"trafficWeight":{"type":"double"},"targetGroup":{"shape":"S2j"},"taskSetLabel":{}}}}}},"cloudFormationTarget":{"type":"structure","members":{"deploymentId":{},"targetId":{},"lastUpdatedAt":{"type":"timestamp"},"lifecycleEvents":{"shape":"S38"},"status":{},"resourceType":{},"targetVersionWeight":{"type":"double"}}}}},"S49":{"type":"list","member":{}},"S4c":{"type":"structure","members":{"applicationName":{},"deploymentGroupName":{},"deploymentConfigName":{},"deploymentId":{},"previousRevision":{"shape":"Sb"},"revision":{"shape":"Sb"},"status":{},"errorInformation":{"type":"structure","members":{"code":{},"message":{}}},"createTime":{"type":"timestamp"},"startTime":{"type":"timestamp"},"completeTime":{"type":"timestamp"},"deploymentOverview":{"type":"structure","members":{"Pending":{"type":"long"},"InProgress":{"type":"long"},"Succeeded":{"type":"long"},"Failed":{"type":"long"},"Skipped":{"type":"long"},"Ready":{"type":"long"}}},"description":{},"creator":{},"ignoreApplicationStopFailures":{"type":"boolean"},"autoRollbackConfiguration":{"shape":"S1z"},"updateOutdatedInstancesOnly":{"type":"boolean"},"rollbackInfo":{"type":"structure","members":{"rollbackDeploymentId":{},"rollbackTriggeringDeploymentId":{},"rollbackMessage":{}}},"deploymentStyle":{"shape":"S22"},"targetInstances":{"shape":"S4j"},"instanceTerminationWaitTimeStarted":{"type":"boolean"},"blueGreenDeploymentConfiguration":{"shape":"S26"},"loadBalancerInfo":{"shape":"S2e"},"additionalDeploymentStatusInfo":{"type":"string","deprecated":true,"deprecatedMessage":"AdditionalDeploymentStatusInfo is deprecated, use DeploymentStatusMessageList instead."},"fileExistsBehavior":{},"deploymentStatusMessages":{"type":"list","member":{}},"computePlatform":{},"externalId":{},"relatedDeployments":{"type":"structure","members":{"autoUpdateOutdatedInstancesRootDeploymentId":{},"autoUpdateOutdatedInstancesDeploymentIds":{"shape":"S49"}}},"overrideAlarmConfiguration":{"shape":"S1v"}}},"S4j":{"type":"structure","members":{"tagFilters":{"shape":"S1e"},"autoScalingGroups":{"shape":"S4k"},"ec2TagSet":{"shape":"S2t"}}},"S4k":{"type":"list","member":{}},"S4t":{"type":"structure","members":{"instanceName":{},"iamSessionArn":{},"iamUserArn":{},"instanceArn":{},"registerTime":{"type":"timestamp"},"deregisterTime":{"type":"timestamp"},"tags":{"shape":"S2"}}},"S54":{"type":"structure","members":{"type":{},"value":{"type":"integer"}}},"S57":{"type":"structure","members":{"type":{},"timeBasedCanary":{"type":"structure","members":{"canaryPercentage":{"type":"integer"},"canaryInterval":{"type":"integer"}}},"timeBasedLinear":{"type":"structure","members":{"linearPercentage":{"type":"integer"},"linearInterval":{"type":"integer"}}}}},"S5d":{"type":"structure","members":{"firstZoneMonitorDurationInSeconds":{"type":"long"},"monitorDurationInSeconds":{"type":"long"},"minimumHealthyHostsPerZone":{"type":"structure","members":{"type":{},"value":{"type":"integer"}}}}}}}

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListApplicationRevisions":{"input_token":"nextToken","output_token":"nextToken","result_key":"revisions"},"ListApplications":{"input_token":"nextToken","output_token":"nextToken","result_key":"applications"},"ListDeploymentConfigs":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentConfigsList"},"ListDeploymentGroups":{"input_token":"nextToken","output_token":"nextToken","result_key":"deploymentGroups"},"ListDeploymentInstances":{"input_token":"nextToken","output_token":"nextToken","result_key":"instancesList"},"ListDeployments":{"input_token":"nextToken","output_token":"nextToken","result_key":"deployments"}}}

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DeploymentSuccessful":{"delay":15,"operation":"GetDeployment","maxAttempts":120,"acceptors":[{"expected":"Succeeded","matcher":"path","state":"success","argument":"deploymentInfo.status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"deploymentInfo.status"},{"expected":"Stopped","matcher":"path","state":"failure","argument":"deploymentInfo.status"}]}}}

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-09","endpointPrefix":"codepipeline","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceAbbreviation":"CodePipeline","serviceFullName":"AWS CodePipeline","serviceId":"CodePipeline","signatureVersion":"v4","targetPrefix":"CodePipeline_20150709","uid":"codepipeline-2015-07-09"},"operations":{"AcknowledgeJob":{"input":{"type":"structure","required":["jobId","nonce"],"members":{"jobId":{},"nonce":{}}},"output":{"type":"structure","members":{"status":{}}}},"AcknowledgeThirdPartyJob":{"input":{"type":"structure","required":["jobId","nonce","clientToken"],"members":{"jobId":{},"nonce":{},"clientToken":{}}},"output":{"type":"structure","members":{"status":{}}}},"CreateCustomActionType":{"input":{"type":"structure","required":["category","provider","version","inputArtifactDetails","outputArtifactDetails"],"members":{"category":{},"provider":{},"version":{},"settings":{"shape":"Se"},"configurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"Sv"},"tags":{"shape":"Sq"}}}},"CreatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"tags":{"shape":"Sq"}}}},"DeleteCustomActionType":{"input":{"type":"structure","required":["category","provider","version"],"members":{"category":{},"provider":{},"version":{}}}},"DeletePipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeleteWebhook":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{}}},"DeregisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"DisableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType","reason"],"members":{"pipelineName":{},"stageName":{},"transitionType":{},"reason":{}}}},"EnableStageTransition":{"input":{"type":"structure","required":["pipelineName","stageName","transitionType"],"members":{"pipelineName":{},"stageName":{},"transitionType":{}}}},"GetActionType":{"input":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"output":{"type":"structure","members":{"actionType":{"shape":"S32"}}}},"GetJobDetails":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"shape":"S3u"},"accountId":{}}}}}},"GetPipeline":{"input":{"type":"structure","required":["name"],"members":{"name":{},"version":{"type":"integer"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"},"metadata":{"type":"structure","members":{"pipelineArn":{},"created":{"type":"timestamp"},"updated":{"type":"timestamp"},"pollingDisabledAt":{"type":"timestamp"}}}}}},"GetPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{}}},"output":{"type":"structure","members":{"pipelineExecution":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"pipelineExecutionId":{},"status":{},"statusSummary":{},"artifactRevisions":{"type":"list","member":{"type":"structure","members":{"name":{},"revisionId":{},"revisionChangeIdentifier":{},"revisionSummary":{},"created":{"type":"timestamp"},"revisionUrl":{}}}},"variables":{"type":"list","member":{"type":"structure","members":{"name":{},"resolvedValue":{}}}},"trigger":{"shape":"S4v"},"executionMode":{},"executionType":{},"rollbackMetadata":{"shape":"S4z"}}}}}},"GetPipelineState":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineVersion":{"type":"integer"},"stageStates":{"type":"list","member":{"type":"structure","members":{"stageName":{},"inboundExecution":{"shape":"S54"},"inboundExecutions":{"type":"list","member":{"shape":"S54"}},"inboundTransitionState":{"type":"structure","members":{"enabled":{"type":"boolean"},"lastChangedBy":{},"lastChangedAt":{"type":"timestamp"},"disabledReason":{}}},"actionStates":{"type":"list","member":{"type":"structure","members":{"actionName":{},"currentRevision":{"shape":"S5d"},"latestExecution":{"type":"structure","members":{"actionExecutionId":{},"status":{},"summary":{},"lastStatusChange":{"type":"timestamp"},"token":{},"lastUpdatedBy":{},"externalExecutionId":{},"externalExecutionUrl":{},"percentComplete":{"type":"integer"},"errorDetails":{"shape":"S5l"}}},"entityUrl":{},"revisionUrl":{}}}},"latestExecution":{"shape":"S54"}}}},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"GetThirdPartyJobDetails":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{}}},"output":{"type":"structure","members":{"jobDetails":{"type":"structure","members":{"id":{},"data":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S3v"},"pipelineContext":{"shape":"S3w"},"inputArtifacts":{"shape":"S42"},"outputArtifacts":{"shape":"S42"},"artifactCredentials":{"shape":"S4a"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"nonce":{}}}}}},"ListActionExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"filter":{"type":"structure","members":{"pipelineExecutionId":{},"latestInPipelineExecution":{"type":"structure","required":["pipelineExecutionId","startTimeRange"],"members":{"pipelineExecutionId":{},"startTimeRange":{}}}}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"actionExecutionDetails":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"actionExecutionId":{},"pipelineVersion":{"type":"integer"},"stageName":{},"actionName":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"updatedBy":{},"status":{},"input":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"configuration":{"shape":"S1l"},"resolvedConfiguration":{"type":"map","key":{},"value":{}},"roleArn":{},"region":{},"inputArtifacts":{"shape":"S63"},"namespace":{}}},"output":{"type":"structure","members":{"outputArtifacts":{"shape":"S63"},"executionResult":{"type":"structure","members":{"externalExecutionId":{},"externalExecutionSummary":{},"externalExecutionUrl":{},"errorDetails":{"shape":"S5l"}}},"outputVariables":{"shape":"S6c"}}}}}},"nextToken":{}}}},"ListActionTypes":{"input":{"type":"structure","members":{"actionOwnerFilter":{},"nextToken":{},"regionFilter":{}}},"output":{"type":"structure","required":["actionTypes"],"members":{"actionTypes":{"type":"list","member":{"shape":"Sv"}},"nextToken":{}}}},"ListPipelineExecutions":{"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"succeededInStage":{"type":"structure","members":{"stageName":{}}}}},"nextToken":{}}},"output":{"type":"structure","members":{"pipelineExecutionSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineExecutionId":{},"status":{},"statusSummary":{},"startTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"sourceRevisions":{"type":"list","member":{"type":"structure","required":["actionName"],"members":{"actionName":{},"revisionId":{},"revisionSummary":{},"revisionUrl":{}}}},"trigger":{"shape":"S4v"},"stopTrigger":{"type":"structure","members":{"reason":{}}},"executionMode":{},"executionType":{},"rollbackMetadata":{"shape":"S4z"}}}},"nextToken":{}}}},"ListPipelines":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"pipelines":{"type":"list","member":{"type":"structure","members":{"name":{},"version":{"type":"integer"},"pipelineType":{},"executionMode":{},"created":{"type":"timestamp"},"updated":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"},"nextToken":{}}}},"ListWebhooks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"webhooks":{"type":"list","member":{"shape":"S73"}},"NextToken":{}}}},"PollForJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"},"queryParam":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"id":{},"data":{"shape":"S3u"},"nonce":{},"accountId":{}}}}}}},"PollForThirdPartyJobs":{"input":{"type":"structure","required":["actionTypeId"],"members":{"actionTypeId":{"shape":"Sw"},"maxBatchSize":{"type":"integer"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"clientId":{},"jobId":{}}}}}}},"PutActionRevision":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","actionRevision"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"actionRevision":{"shape":"S5d"}}},"output":{"type":"structure","members":{"newRevision":{"type":"boolean"},"pipelineExecutionId":{}}}},"PutApprovalResult":{"input":{"type":"structure","required":["pipelineName","stageName","actionName","result","token"],"members":{"pipelineName":{},"stageName":{},"actionName":{},"result":{"type":"structure","required":["summary","status"],"members":{"summary":{},"status":{}}},"token":{}}},"output":{"type":"structure","members":{"approvedAt":{"type":"timestamp"}}}},"PutJobFailureResult":{"input":{"type":"structure","required":["jobId","failureDetails"],"members":{"jobId":{},"failureDetails":{"shape":"S83"}}}},"PutJobSuccessResult":{"input":{"type":"structure","required":["jobId"],"members":{"jobId":{},"currentRevision":{"shape":"S86"},"continuationToken":{},"executionDetails":{"shape":"S88"},"outputVariables":{"shape":"S6c"}}}},"PutThirdPartyJobFailureResult":{"input":{"type":"structure","required":["jobId","clientToken","failureDetails"],"members":{"jobId":{},"clientToken":{},"failureDetails":{"shape":"S83"}}}},"PutThirdPartyJobSuccessResult":{"input":{"type":"structure","required":["jobId","clientToken"],"members":{"jobId":{},"clientToken":{},"currentRevision":{"shape":"S86"},"continuationToken":{},"executionDetails":{"shape":"S88"}}}},"PutWebhook":{"input":{"type":"structure","required":["webhook"],"members":{"webhook":{"shape":"S74"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"webhook":{"shape":"S73"}}}},"RegisterWebhookWithThirdParty":{"input":{"type":"structure","members":{"webhookName":{}}},"output":{"type":"structure","members":{}}},"RetryStageExecution":{"input":{"type":"structure","required":["pipelineName","stageName","pipelineExecutionId","retryMode"],"members":{"pipelineName":{},"stageName":{},"pipelineExecutionId":{},"retryMode":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"RollbackStage":{"input":{"type":"structure","required":["pipelineName","stageName","targetPipelineExecutionId"],"members":{"pipelineName":{},"stageName":{},"targetPipelineExecutionId":{}}},"output":{"type":"structure","required":["pipelineExecutionId"],"members":{"pipelineExecutionId":{}}}},"StartPipelineExecution":{"input":{"type":"structure","required":["name"],"members":{"name":{},"variables":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"clientRequestToken":{"idempotencyToken":true},"sourceRevisions":{"type":"list","member":{"type":"structure","required":["actionName","revisionType","revisionValue"],"members":{"actionName":{},"revisionType":{},"revisionValue":{}}}}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"StopPipelineExecution":{"input":{"type":"structure","required":["pipelineName","pipelineExecutionId"],"members":{"pipelineName":{},"pipelineExecutionId":{},"abandon":{"type":"boolean"},"reason":{}}},"output":{"type":"structure","members":{"pipelineExecutionId":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateActionType":{"input":{"type":"structure","required":["actionType"],"members":{"actionType":{"shape":"S32"}}}},"UpdatePipeline":{"input":{"type":"structure","required":["pipeline"],"members":{"pipeline":{"shape":"Sz"}}},"output":{"type":"structure","members":{"pipeline":{"shape":"Sz"}}}}},"shapes":{"Se":{"type":"structure","members":{"thirdPartyConfigurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}},"Sh":{"type":"list","member":{"type":"structure","required":["name","required","key","secret"],"members":{"name":{},"required":{"type":"boolean"},"key":{"type":"boolean"},"secret":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{},"type":{}}}},"Sn":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sv":{"type":"structure","required":["id","inputArtifactDetails","outputArtifactDetails"],"members":{"id":{"shape":"Sw"},"settings":{"shape":"Se"},"actionConfigurationProperties":{"shape":"Sh"},"inputArtifactDetails":{"shape":"Sn"},"outputArtifactDetails":{"shape":"Sn"}}},"Sw":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"Sz":{"type":"structure","required":["name","roleArn","stages"],"members":{"name":{},"roleArn":{},"artifactStore":{"shape":"S12"},"artifactStores":{"type":"map","key":{},"value":{"shape":"S12"}},"stages":{"type":"list","member":{"type":"structure","required":["name","actions"],"members":{"name":{},"blockers":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}},"actions":{"type":"list","member":{"type":"structure","required":["name","actionTypeId"],"members":{"name":{},"actionTypeId":{"shape":"Sw"},"runOrder":{"type":"integer"},"configuration":{"shape":"S1l"},"outputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"inputArtifacts":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"roleArn":{},"region":{},"namespace":{},"timeoutInMinutes":{"type":"integer"}}}},"onFailure":{"type":"structure","members":{"result":{}}}}}},"version":{"type":"integer"},"executionMode":{},"pipelineType":{},"variables":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"defaultValue":{},"description":{}}}},"triggers":{"type":"list","member":{"type":"structure","required":["providerType","gitConfiguration"],"members":{"providerType":{},"gitConfiguration":{"type":"structure","required":["sourceActionName"],"members":{"sourceActionName":{},"push":{"type":"list","member":{"type":"structure","members":{"tags":{"type":"structure","members":{"includes":{"shape":"S2b"},"excludes":{"shape":"S2b"}}},"branches":{"shape":"S2d"},"filePaths":{"shape":"S2g"}}}},"pullRequest":{"type":"list","member":{"type":"structure","members":{"events":{"type":"list","member":{}},"branches":{"shape":"S2d"},"filePaths":{"shape":"S2g"}}}}}}}}}}},"S12":{"type":"structure","required":["type","location"],"members":{"type":{},"location":{},"encryptionKey":{"shape":"S15"}}},"S15":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}},"S1l":{"type":"map","key":{},"value":{}},"S2b":{"type":"list","member":{}},"S2d":{"type":"structure","members":{"includes":{"shape":"S2e"},"excludes":{"shape":"S2e"}}},"S2e":{"type":"list","member":{}},"S2g":{"type":"structure","members":{"includes":{"shape":"S2h"},"excludes":{"shape":"S2h"}}},"S2h":{"type":"list","member":{}},"S32":{"type":"structure","required":["executor","id","inputArtifactDetails","outputArtifactDetails"],"members":{"description":{},"executor":{"type":"structure","required":["configuration","type"],"members":{"configuration":{"type":"structure","members":{"lambdaExecutorConfiguration":{"type":"structure","required":["lambdaFunctionArn"],"members":{"lambdaFunctionArn":{}}},"jobWorkerExecutorConfiguration":{"type":"structure","members":{"pollingAccounts":{"type":"list","member":{}},"pollingServicePrincipals":{"type":"list","member":{}}}}}},"type":{},"policyStatementsTemplate":{},"jobTimeout":{"type":"integer"}}},"id":{"type":"structure","required":["category","owner","provider","version"],"members":{"category":{},"owner":{},"provider":{},"version":{}}},"inputArtifactDetails":{"shape":"S3h"},"outputArtifactDetails":{"shape":"S3h"},"permissions":{"type":"structure","required":["allowedAccounts"],"members":{"allowedAccounts":{"type":"list","member":{}}}},"properties":{"type":"list","member":{"type":"structure","required":["name","optional","key","noEcho"],"members":{"name":{},"optional":{"type":"boolean"},"key":{"type":"boolean"},"noEcho":{"type":"boolean"},"queryable":{"type":"boolean"},"description":{}}}},"urls":{"type":"structure","members":{"configurationUrl":{},"entityUrlTemplate":{},"executionUrlTemplate":{},"revisionUrlTemplate":{}}}}},"S3h":{"type":"structure","required":["minimumCount","maximumCount"],"members":{"minimumCount":{"type":"integer"},"maximumCount":{"type":"integer"}}},"S3u":{"type":"structure","members":{"actionTypeId":{"shape":"Sw"},"actionConfiguration":{"shape":"S3v"},"pipelineContext":{"shape":"S3w"},"inputArtifacts":{"shape":"S42"},"outputArtifacts":{"shape":"S42"},"artifactCredentials":{"shape":"S4a"},"continuationToken":{},"encryptionKey":{"shape":"S15"}}},"S3v":{"type":"structure","members":{"configuration":{"shape":"S1l"}}},"S3w":{"type":"structure","members":{"pipelineName":{},"stage":{"type":"structure","members":{"name":{}}},"action":{"type":"structure","members":{"name":{},"actionExecutionId":{}}},"pipelineArn":{},"pipelineExecutionId":{}}},"S42":{"type":"list","member":{"type":"structure","members":{"name":{},"revision":{},"location":{"type":"structure","members":{"type":{},"s3Location":{"type":"structure","required":["bucketName","objectKey"],"members":{"bucketName":{},"objectKey":{}}}}}}}},"S4a":{"type":"structure","required":["accessKeyId","secretAccessKey","sessionToken"],"members":{"accessKeyId":{"type":"string","sensitive":true},"secretAccessKey":{"type":"string","sensitive":true},"sessionToken":{"type":"string","sensitive":true}},"sensitive":true},"S4v":{"type":"structure","members":{"triggerType":{},"triggerDetail":{}}},"S4z":{"type":"structure","members":{"rollbackTargetPipelineExecutionId":{}}},"S54":{"type":"structure","required":["pipelineExecutionId","status"],"members":{"pipelineExecutionId":{},"status":{},"type":{}}},"S5d":{"type":"structure","required":["revisionId","revisionChangeId","created"],"members":{"revisionId":{},"revisionChangeId":{},"created":{"type":"timestamp"}}},"S5l":{"type":"structure","members":{"code":{},"message":{}}},"S63":{"type":"list","member":{"type":"structure","members":{"name":{},"s3location":{"type":"structure","members":{"bucket":{},"key":{}}}}}},"S6c":{"type":"map","key":{},"value":{}},"S73":{"type":"structure","required":["definition","url"],"members":{"definition":{"shape":"S74"},"url":{},"errorMessage":{},"errorCode":{},"lastTriggered":{"type":"timestamp"},"arn":{},"tags":{"shape":"Sq"}}},"S74":{"type":"structure","required":["name","targetPipeline","targetAction","filters","authentication","authenticationConfiguration"],"members":{"name":{},"targetPipeline":{},"targetAction":{},"filters":{"type":"list","member":{"type":"structure","required":["jsonPath"],"members":{"jsonPath":{},"matchEquals":{}}}},"authentication":{},"authenticationConfiguration":{"type":"structure","members":{"AllowedIPRange":{},"SecretToken":{}}}}},"S83":{"type":"structure","required":["type","message"],"members":{"type":{},"message":{},"externalExecutionId":{}}},"S86":{"type":"structure","required":["revision","changeIdentifier"],"members":{"revision":{},"changeIdentifier":{},"created":{"type":"timestamp"},"revisionSummary":{}}},"S88":{"type":"structure","members":{"summary":{},"externalExecutionId":{},"percentComplete":{"type":"integer"}}}}}

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListActionExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"actionExecutionDetails"},"ListActionTypes":{"input_token":"nextToken","output_token":"nextToken","result_key":"actionTypes"},"ListPipelineExecutions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"pipelineExecutionSummaries"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"pipelines"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults","result_key":"tags"},"ListWebhooks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"webhooks"}}}

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-identity","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Cognito Identity","serviceId":"Cognito Identity","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityService","uid":"cognito-identity-2014-06-30"},"operations":{"CreateIdentityPool":{"input":{"type":"structure","required":["IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"output":{"shape":"Sk"}},"DeleteIdentities":{"input":{"type":"structure","required":["IdentityIdsToDelete"],"members":{"IdentityIdsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedIdentityIds":{"type":"list","member":{"type":"structure","members":{"IdentityId":{},"ErrorCode":{}}}}}}},"DeleteIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}}},"DescribeIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{}}},"output":{"shape":"Sv"}},"DescribeIdentityPool":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"shape":"Sk"}},"GetCredentialsForIdentity":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"CustomRoleArn":{}}},"output":{"type":"structure","members":{"IdentityId":{},"Credentials":{"type":"structure","members":{"AccessKeyId":{},"SecretKey":{},"SessionToken":{},"Expiration":{"type":"timestamp"}}}}},"authtype":"none"},"GetId":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"AccountId":{},"IdentityPoolId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{}}},"authtype":"none"},"GetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"GetOpenIdToken":{"input":{"type":"structure","required":["IdentityId"],"members":{"IdentityId":{},"Logins":{"shape":"S10"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}},"authtype":"none"},"GetOpenIdTokenForDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId","Logins"],"members":{"IdentityPoolId":{},"IdentityId":{},"Logins":{"shape":"S10"},"PrincipalTags":{"shape":"S1s"},"TokenDuration":{"type":"long"}}},"output":{"type":"structure","members":{"IdentityId":{},"Token":{}}}},"GetPrincipalTagAttributeMap":{"input":{"type":"structure","required":["IdentityPoolId","IdentityProviderName"],"members":{"IdentityPoolId":{},"IdentityProviderName":{}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"IdentityProviderName":{},"UseDefaults":{"type":"boolean"},"PrincipalTags":{"shape":"S1s"}}}},"ListIdentities":{"input":{"type":"structure","required":["IdentityPoolId","MaxResults"],"members":{"IdentityPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{},"HideDisabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"Identities":{"type":"list","member":{"shape":"Sv"}},"NextToken":{}}}},"ListIdentityPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityPools":{"type":"list","member":{"type":"structure","members":{"IdentityPoolId":{},"IdentityPoolName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sh"}}}},"LookupDeveloperIdentity":{"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{},"IdentityId":{},"DeveloperUserIdentifier":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IdentityId":{},"DeveloperUserIdentifierList":{"type":"list","member":{}},"NextToken":{}}}},"MergeDeveloperIdentities":{"input":{"type":"structure","required":["SourceUserIdentifier","DestinationUserIdentifier","DeveloperProviderName","IdentityPoolId"],"members":{"SourceUserIdentifier":{},"DestinationUserIdentifier":{},"DeveloperProviderName":{},"IdentityPoolId":{}}},"output":{"type":"structure","members":{"IdentityId":{}}}},"SetIdentityPoolRoles":{"input":{"type":"structure","required":["IdentityPoolId","Roles"],"members":{"IdentityPoolId":{},"Roles":{"shape":"S1c"},"RoleMappings":{"shape":"S1e"}}}},"SetPrincipalTagAttributeMap":{"input":{"type":"structure","required":["IdentityPoolId","IdentityProviderName"],"members":{"IdentityPoolId":{},"IdentityProviderName":{},"UseDefaults":{"type":"boolean"},"PrincipalTags":{"shape":"S1s"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"IdentityProviderName":{},"UseDefaults":{"type":"boolean"},"PrincipalTags":{"shape":"S1s"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sh"}}},"output":{"type":"structure","members":{}}},"UnlinkDeveloperIdentity":{"input":{"type":"structure","required":["IdentityId","IdentityPoolId","DeveloperProviderName","DeveloperUserIdentifier"],"members":{"IdentityId":{},"IdentityPoolId":{},"DeveloperProviderName":{},"DeveloperUserIdentifier":{}}}},"UnlinkIdentity":{"input":{"type":"structure","required":["IdentityId","Logins","LoginsToRemove"],"members":{"IdentityId":{},"Logins":{"shape":"S10"},"LoginsToRemove":{"shape":"Sw"}}},"authtype":"none"},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateIdentityPool":{"input":{"shape":"Sk"},"output":{"shape":"Sk"}}},"shapes":{"S5":{"type":"map","key":{},"value":{}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ClientId":{},"ServerSideTokenCheck":{"type":"boolean"}}}},"Sg":{"type":"list","member":{}},"Sh":{"type":"map","key":{},"value":{}},"Sk":{"type":"structure","required":["IdentityPoolId","IdentityPoolName","AllowUnauthenticatedIdentities"],"members":{"IdentityPoolId":{},"IdentityPoolName":{},"AllowUnauthenticatedIdentities":{"type":"boolean"},"AllowClassicFlow":{"type":"boolean"},"SupportedLoginProviders":{"shape":"S5"},"DeveloperProviderName":{},"OpenIdConnectProviderARNs":{"shape":"S9"},"CognitoIdentityProviders":{"shape":"Sb"},"SamlProviderARNs":{"shape":"Sg"},"IdentityPoolTags":{"shape":"Sh"}}},"Sv":{"type":"structure","members":{"IdentityId":{},"Logins":{"shape":"Sw"},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"Sw":{"type":"list","member":{}},"S10":{"type":"map","key":{},"value":{}},"S1c":{"type":"map","key":{},"value":{}},"S1e":{"type":"map","key":{},"value":{"type":"structure","required":["Type"],"members":{"Type":{},"AmbiguousRoleResolution":{},"RulesConfiguration":{"type":"structure","required":["Rules"],"members":{"Rules":{"type":"list","member":{"type":"structure","required":["Claim","MatchType","Value","RoleARN"],"members":{"Claim":{},"MatchType":{},"Value":{},"RoleARN":{}}}}}}}}},"S1s":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListIdentityPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IdentityPools"}}}

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-18","endpointPrefix":"cognito-idp","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceFullName":"Amazon Cognito Identity Provider","serviceId":"Cognito Identity Provider","signatureVersion":"v4","targetPrefix":"AWSCognitoIdentityProviderService","uid":"cognito-idp-2016-04-18"},"operations":{"AddCustomAttributes":{"input":{"type":"structure","required":["UserPoolId","CustomAttributes"],"members":{"UserPoolId":{},"CustomAttributes":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{}}},"AdminAddUserToGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminConfirmSignUp":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminCreateUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"ValidationData":{"shape":"Sj"},"TemporaryPassword":{"shape":"Sn"},"ForceAliasCreation":{"type":"boolean"},"MessageAction":{},"DesiredDeliveryMediums":{"type":"list","member":{}},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"User":{"shape":"St"}}}},"AdminDeleteUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}}},"AdminDeleteUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributeNames"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributeNames":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"AdminDisableProviderForUser":{"input":{"type":"structure","required":["UserPoolId","User"],"members":{"UserPoolId":{},"User":{"shape":"S13"}}},"output":{"type":"structure","members":{}}},"AdminDisableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminEnableUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AdminForgetDevice":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{}}}},"AdminGetDevice":{"input":{"type":"structure","required":["DeviceKey","UserPoolId","Username"],"members":{"DeviceKey":{},"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1e"}}}},"AdminGetUser":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","required":["Username"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sw"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1h"}}}},"AdminInitiateAuth":{"input":{"type":"structure","required":["UserPoolId","ClientId","AuthFlow"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"AuthFlow":{},"AuthParameters":{"shape":"S1l"},"ClientMetadata":{"shape":"Sg"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{"shape":"S1s"},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminLinkProviderForUser":{"input":{"type":"structure","required":["UserPoolId","DestinationUser","SourceUser"],"members":{"UserPoolId":{},"DestinationUser":{"shape":"S13"},"SourceUser":{"shape":"S13"}}},"output":{"type":"structure","members":{}}},"AdminListDevices":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}}},"AdminListGroupsForUser":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"Username":{"shape":"Sd"},"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"AdminListUserAuthEvents":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AuthEvents":{"type":"list","member":{"type":"structure","members":{"EventId":{},"EventType":{},"CreationDate":{"type":"timestamp"},"EventResponse":{},"EventRisk":{"type":"structure","members":{"RiskDecision":{},"RiskLevel":{},"CompromisedCredentialsDetected":{"type":"boolean"}}},"ChallengeResponses":{"type":"list","member":{"type":"structure","members":{"ChallengeName":{},"ChallengeResponse":{}}}},"EventContextData":{"type":"structure","members":{"IpAddress":{},"DeviceName":{},"Timezone":{},"City":{},"Country":{}}},"EventFeedback":{"type":"structure","required":["FeedbackValue","Provider"],"members":{"FeedbackValue":{},"Provider":{},"FeedbackDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"AdminRemoveUserFromGroup":{"input":{"type":"structure","required":["UserPoolId","Username","GroupName"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"GroupName":{}}}},"AdminResetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminRespondToAuthChallenge":{"input":{"type":"structure","required":["UserPoolId","ClientId","ChallengeName"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ChallengeName":{},"ChallengeResponses":{"shape":"S2y"},"Session":{"shape":"S1s"},"AnalyticsMetadata":{"shape":"S1m"},"ContextData":{"shape":"S1n"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{"shape":"S1s"},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}}},"AdminSetUserMFAPreference":{"input":{"type":"structure","required":["Username","UserPoolId"],"members":{"SMSMfaSettings":{"shape":"S31"},"SoftwareTokenMfaSettings":{"shape":"S32"},"Username":{"shape":"Sd"},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"AdminSetUserPassword":{"input":{"type":"structure","required":["UserPoolId","Username","Password"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"Password":{"shape":"Sn"},"Permanent":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AdminSetUserSettings":{"input":{"type":"structure","required":["UserPoolId","Username","MFAOptions"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"MFAOptions":{"shape":"Sw"}}},"output":{"type":"structure","members":{}}},"AdminUpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackValue":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateDeviceStatus":{"input":{"type":"structure","required":["UserPoolId","Username","DeviceKey"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}}},"AdminUpdateUserAttributes":{"input":{"type":"structure","required":["UserPoolId","Username","UserAttributes"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}}},"AdminUserGlobalSignOut":{"input":{"type":"structure","required":["UserPoolId","Username"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"}}},"output":{"type":"structure","members":{}}},"AssociateSoftwareToken":{"input":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"Session":{"shape":"S1s"}}},"output":{"type":"structure","members":{"SecretCode":{"type":"string","sensitive":true},"Session":{"shape":"S1s"}}},"authtype":"none"},"ChangePassword":{"input":{"type":"structure","required":["PreviousPassword","ProposedPassword","AccessToken"],"members":{"PreviousPassword":{"shape":"Sn"},"ProposedPassword":{"shape":"Sn"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmDevice":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceSecretVerifierConfig":{"type":"structure","members":{"PasswordVerifier":{},"Salt":{}}},"DeviceName":{}}},"output":{"type":"structure","members":{"UserConfirmationNecessary":{"type":"boolean"}}},"authtype":"none"},"ConfirmForgotPassword":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode","Password"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"Password":{"shape":"Sn"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"ConfirmSignUp":{"input":{"type":"structure","required":["ClientId","Username","ConfirmationCode"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"ConfirmationCode":{},"ForceAliasCreation":{"type":"boolean"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"CreateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"CreateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName","ProviderType","ProviderDetails"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"CreateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"CreateUserImportJob":{"input":{"type":"structure","required":["JobName","UserPoolId","CloudWatchLogsRoleArn"],"members":{"JobName":{},"UserPoolId":{},"CloudWatchLogsRoleArn":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"CreateUserPool":{"input":{"type":"structure","required":["PoolName"],"members":{"PoolName":{},"Policies":{"shape":"S4u"},"DeletionProtection":{},"LambdaConfig":{"shape":"S4z"},"AutoVerifiedAttributes":{"shape":"S56"},"AliasAttributes":{"shape":"S58"},"UsernameAttributes":{"shape":"S5a"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S5f"},"SmsAuthenticationMessage":{},"MfaConfiguration":{},"UserAttributeUpdateSettings":{"shape":"S5k"},"DeviceConfiguration":{"shape":"S5m"},"EmailConfiguration":{"shape":"S5n"},"SmsConfiguration":{"shape":"S5r"},"UserPoolTags":{"shape":"S5t"},"AdminCreateUserConfig":{"shape":"S5w"},"Schema":{"shape":"S5z"},"UserPoolAddOns":{"shape":"S60"},"UsernameConfiguration":{"shape":"S62"},"AccountRecoverySetting":{"shape":"S63"}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S69"}}}},"CreateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientName"],"members":{"UserPoolId":{},"ClientName":{},"GenerateSecret":{"type":"boolean"},"RefreshTokenValidity":{"type":"integer"},"AccessTokenValidity":{"type":"integer"},"IdTokenValidity":{"type":"integer"},"TokenValidityUnits":{"shape":"S6i"},"ReadAttributes":{"shape":"S6k"},"WriteAttributes":{"shape":"S6k"},"ExplicitAuthFlows":{"shape":"S6m"},"SupportedIdentityProviders":{"shape":"S6o"},"CallbackURLs":{"shape":"S6p"},"LogoutURLs":{"shape":"S6r"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6s"},"AllowedOAuthScopes":{"shape":"S6u"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6w"},"PreventUserExistenceErrors":{},"EnableTokenRevocation":{"type":"boolean"},"EnablePropagateAdditionalUserContextData":{"type":"boolean"},"AuthSessionValidity":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S71"}}}},"CreateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S74"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"DeleteGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}}},"DeleteIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}}},"DeleteResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}}},"DeleteUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"authtype":"none"},"DeleteUserAttributes":{"input":{"type":"structure","required":["UserAttributeNames","AccessToken"],"members":{"UserAttributeNames":{"shape":"S10"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"DeleteUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}}},"DeleteUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}}},"DeleteUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId"],"members":{"Domain":{},"UserPoolId":{}}},"output":{"type":"structure","members":{}}},"DescribeIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"DescribeResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier"],"members":{"UserPoolId":{},"Identifier":{}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"DescribeRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S7m"}}}},"DescribeUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"DescribeUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPool":{"shape":"S69"}}}},"DescribeUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S71"}}}},"DescribeUserPoolDomain":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"type":"structure","members":{"DomainDescription":{"type":"structure","members":{"UserPoolId":{},"AWSAccountId":{},"Domain":{},"S3Bucket":{},"CloudFrontDistribution":{},"Version":{},"Status":{},"CustomDomainConfig":{"shape":"S74"}}}}}},"ForgetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{}}},"authtype":"none"},"ForgotPassword":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"UserContextData":{"shape":"S3u"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S8k"}}},"authtype":"none"},"GetCSVHeader":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"UserPoolId":{},"CSVHeader":{"type":"list","member":{}}}}},"GetDevice":{"input":{"type":"structure","required":["DeviceKey"],"members":{"DeviceKey":{},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Device"],"members":{"Device":{"shape":"S1e"}}},"authtype":"none"},"GetGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"GetIdentityProviderByIdentifier":{"input":{"type":"structure","required":["UserPoolId","IdpIdentifier"],"members":{"UserPoolId":{},"IdpIdentifier":{}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"GetLogDeliveryConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"LogDeliveryConfiguration":{"shape":"S8w"}}}},"GetSigningCertificate":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"Certificate":{}}}},"GetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S96"}}}},"GetUser":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","required":["Username","UserAttributes"],"members":{"Username":{"shape":"Sd"},"UserAttributes":{"shape":"Sj"},"MFAOptions":{"shape":"Sw"},"PreferredMfaSetting":{},"UserMFASettingList":{"shape":"S1h"}}},"authtype":"none"},"GetUserAttributeVerificationCode":{"input":{"type":"structure","required":["AccessToken","AttributeName"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S8k"}}},"authtype":"none"},"GetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S9g"},"SoftwareTokenMfaConfiguration":{"shape":"S9h"},"MfaConfiguration":{}}}},"GlobalSignOut":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"InitiateAuth":{"input":{"type":"structure","required":["AuthFlow","ClientId"],"members":{"AuthFlow":{},"AuthParameters":{"shape":"S1l"},"ClientMetadata":{"shape":"Sg"},"ClientId":{"shape":"S1j"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{"shape":"S1s"},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}},"authtype":"none"},"ListDevices":{"input":{"type":"structure","required":["AccessToken"],"members":{"AccessToken":{"shape":"S1v"},"Limit":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"Devices":{"shape":"S24"},"PaginationToken":{}}},"authtype":"none"},"ListGroups":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"shape":"S28"},"NextToken":{}}}},"ListIdentityProviders":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Providers"],"members":{"Providers":{"type":"list","member":{"type":"structure","members":{"ProviderName":{},"ProviderType":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceServers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ResourceServers"],"members":{"ResourceServers":{"type":"list","member":{"shape":"S4i"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S5t"}}}},"ListUserImportJobs":{"input":{"type":"structure","required":["UserPoolId","MaxResults"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"PaginationToken":{}}},"output":{"type":"structure","members":{"UserImportJobs":{"type":"list","member":{"shape":"S4m"}},"PaginationToken":{}}}},"ListUserPoolClients":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"UserPoolClients":{"type":"list","member":{"type":"structure","members":{"ClientId":{"shape":"S1j"},"UserPoolId":{},"ClientName":{}}}},"NextToken":{}}}},"ListUserPools":{"input":{"type":"structure","required":["MaxResults"],"members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPools":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"LambdaConfig":{"shape":"S4z"},"Status":{"deprecated":true,"deprecatedMessage":"This property is no longer available."},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListUsers":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"AttributesToGet":{"type":"list","member":{}},"Limit":{"type":"integer"},"PaginationToken":{},"Filter":{}}},"output":{"type":"structure","members":{"Users":{"shape":"Saj"},"PaginationToken":{}}}},"ListUsersInGroup":{"input":{"type":"structure","required":["UserPoolId","GroupName"],"members":{"UserPoolId":{},"GroupName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"shape":"Saj"},"NextToken":{}}}},"ResendConfirmationCode":{"input":{"type":"structure","required":["ClientId","Username"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"UserContextData":{"shape":"S3u"},"Username":{"shape":"Sd"},"AnalyticsMetadata":{"shape":"S1m"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetails":{"shape":"S8k"}}},"authtype":"none"},"RespondToAuthChallenge":{"input":{"type":"structure","required":["ClientId","ChallengeName"],"members":{"ClientId":{"shape":"S1j"},"ChallengeName":{},"Session":{"shape":"S1s"},"ChallengeResponses":{"shape":"S2y"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"ChallengeName":{},"Session":{"shape":"S1s"},"ChallengeParameters":{"shape":"S1t"},"AuthenticationResult":{"shape":"S1u"}}},"authtype":"none"},"RevokeToken":{"input":{"type":"structure","required":["Token","ClientId"],"members":{"Token":{"shape":"S1v"},"ClientId":{"shape":"S1j"},"ClientSecret":{"shape":"S72"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SetLogDeliveryConfiguration":{"input":{"type":"structure","required":["UserPoolId","LogConfigurations"],"members":{"UserPoolId":{},"LogConfigurations":{"shape":"S8x"}}},"output":{"type":"structure","members":{"LogDeliveryConfiguration":{"shape":"S8w"}}}},"SetRiskConfiguration":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CompromisedCredentialsRiskConfiguration":{"shape":"S7n"},"AccountTakeoverRiskConfiguration":{"shape":"S7s"},"RiskExceptionConfiguration":{"shape":"S81"}}},"output":{"type":"structure","required":["RiskConfiguration"],"members":{"RiskConfiguration":{"shape":"S7m"}}}},"SetUICustomization":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CSS":{},"ImageFile":{"type":"blob"}}},"output":{"type":"structure","required":["UICustomization"],"members":{"UICustomization":{"shape":"S96"}}}},"SetUserMFAPreference":{"input":{"type":"structure","required":["AccessToken"],"members":{"SMSMfaSettings":{"shape":"S31"},"SoftwareTokenMfaSettings":{"shape":"S32"},"AccessToken":{"shape":"S1v"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SetUserPoolMfaConfig":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"SmsMfaConfiguration":{"shape":"S9g"},"SoftwareTokenMfaConfiguration":{"shape":"S9h"},"MfaConfiguration":{}}},"output":{"type":"structure","members":{"SmsMfaConfiguration":{"shape":"S9g"},"SoftwareTokenMfaConfiguration":{"shape":"S9h"},"MfaConfiguration":{}}}},"SetUserSettings":{"input":{"type":"structure","required":["AccessToken","MFAOptions"],"members":{"AccessToken":{"shape":"S1v"},"MFAOptions":{"shape":"Sw"}}},"output":{"type":"structure","members":{}},"authtype":"none"},"SignUp":{"input":{"type":"structure","required":["ClientId","Username","Password"],"members":{"ClientId":{"shape":"S1j"},"SecretHash":{"shape":"S3s"},"Username":{"shape":"Sd"},"Password":{"shape":"Sn"},"UserAttributes":{"shape":"Sj"},"ValidationData":{"shape":"Sj"},"AnalyticsMetadata":{"shape":"S1m"},"UserContextData":{"shape":"S3u"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","required":["UserConfirmed","UserSub"],"members":{"UserConfirmed":{"type":"boolean"},"CodeDeliveryDetails":{"shape":"S8k"},"UserSub":{}}},"authtype":"none"},"StartUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"StopUserImportJob":{"input":{"type":"structure","required":["UserPoolId","JobId"],"members":{"UserPoolId":{},"JobId":{}}},"output":{"type":"structure","members":{"UserImportJob":{"shape":"S4m"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S5t"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAuthEventFeedback":{"input":{"type":"structure","required":["UserPoolId","Username","EventId","FeedbackToken","FeedbackValue"],"members":{"UserPoolId":{},"Username":{"shape":"Sd"},"EventId":{},"FeedbackToken":{"shape":"S1v"},"FeedbackValue":{}}},"output":{"type":"structure","members":{}},"authtype":"none"},"UpdateDeviceStatus":{"input":{"type":"structure","required":["AccessToken","DeviceKey"],"members":{"AccessToken":{"shape":"S1v"},"DeviceKey":{},"DeviceRememberedStatus":{}}},"output":{"type":"structure","members":{}},"authtype":"none"},"UpdateGroup":{"input":{"type":"structure","required":["GroupName","UserPoolId"],"members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"}}},"output":{"type":"structure","members":{"Group":{"shape":"S29"}}}},"UpdateIdentityProvider":{"input":{"type":"structure","required":["UserPoolId","ProviderName"],"members":{"UserPoolId":{},"ProviderName":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"}}},"output":{"type":"structure","required":["IdentityProvider"],"members":{"IdentityProvider":{"shape":"S49"}}}},"UpdateResourceServer":{"input":{"type":"structure","required":["UserPoolId","Identifier","Name"],"members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"output":{"type":"structure","required":["ResourceServer"],"members":{"ResourceServer":{"shape":"S4i"}}}},"UpdateUserAttributes":{"input":{"type":"structure","required":["UserAttributes","AccessToken"],"members":{"UserAttributes":{"shape":"Sj"},"AccessToken":{"shape":"S1v"},"ClientMetadata":{"shape":"Sg"}}},"output":{"type":"structure","members":{"CodeDeliveryDetailsList":{"type":"list","member":{"shape":"S8k"}}}},"authtype":"none"},"UpdateUserPool":{"input":{"type":"structure","required":["UserPoolId"],"members":{"UserPoolId":{},"Policies":{"shape":"S4u"},"DeletionProtection":{},"LambdaConfig":{"shape":"S4z"},"AutoVerifiedAttributes":{"shape":"S56"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S5f"},"SmsAuthenticationMessage":{},"UserAttributeUpdateSettings":{"shape":"S5k"},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5m"},"EmailConfiguration":{"shape":"S5n"},"SmsConfiguration":{"shape":"S5r"},"UserPoolTags":{"shape":"S5t"},"AdminCreateUserConfig":{"shape":"S5w"},"UserPoolAddOns":{"shape":"S60"},"AccountRecoverySetting":{"shape":"S63"}}},"output":{"type":"structure","members":{}}},"UpdateUserPoolClient":{"input":{"type":"structure","required":["UserPoolId","ClientId"],"members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ClientName":{},"RefreshTokenValidity":{"type":"integer"},"AccessTokenValidity":{"type":"integer"},"IdTokenValidity":{"type":"integer"},"TokenValidityUnits":{"shape":"S6i"},"ReadAttributes":{"shape":"S6k"},"WriteAttributes":{"shape":"S6k"},"ExplicitAuthFlows":{"shape":"S6m"},"SupportedIdentityProviders":{"shape":"S6o"},"CallbackURLs":{"shape":"S6p"},"LogoutURLs":{"shape":"S6r"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6s"},"AllowedOAuthScopes":{"shape":"S6u"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6w"},"PreventUserExistenceErrors":{},"EnableTokenRevocation":{"type":"boolean"},"EnablePropagateAdditionalUserContextData":{"type":"boolean"},"AuthSessionValidity":{"type":"integer"}}},"output":{"type":"structure","members":{"UserPoolClient":{"shape":"S71"}}}},"UpdateUserPoolDomain":{"input":{"type":"structure","required":["Domain","UserPoolId","CustomDomainConfig"],"members":{"Domain":{},"UserPoolId":{},"CustomDomainConfig":{"shape":"S74"}}},"output":{"type":"structure","members":{"CloudFrontDomain":{}}}},"VerifySoftwareToken":{"input":{"type":"structure","required":["UserCode"],"members":{"AccessToken":{"shape":"S1v"},"Session":{"shape":"S1s"},"UserCode":{"type":"string","sensitive":true},"FriendlyDeviceName":{}}},"output":{"type":"structure","members":{"Status":{},"Session":{"shape":"S1s"}}},"authtype":"none"},"VerifyUserAttribute":{"input":{"type":"structure","required":["AccessToken","AttributeName","Code"],"members":{"AccessToken":{"shape":"S1v"},"AttributeName":{},"Code":{}}},"output":{"type":"structure","members":{}},"authtype":"none"}},"shapes":{"S4":{"type":"structure","members":{"Name":{},"AttributeDataType":{},"DeveloperOnlyAttribute":{"type":"boolean"},"Mutable":{"type":"boolean"},"Required":{"type":"boolean"},"NumberAttributeConstraints":{"type":"structure","members":{"MinValue":{},"MaxValue":{}}},"StringAttributeConstraints":{"type":"structure","members":{"MinLength":{},"MaxLength":{}}}}},"Sd":{"type":"string","sensitive":true},"Sg":{"type":"map","key":{},"value":{}},"Sj":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}},"Sn":{"type":"string","sensitive":true},"St":{"type":"structure","members":{"Username":{"shape":"Sd"},"Attributes":{"shape":"Sj"},"UserCreateDate":{"type":"timestamp"},"UserLastModifiedDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"UserStatus":{},"MFAOptions":{"shape":"Sw"}}},"Sw":{"type":"list","member":{"type":"structure","members":{"DeliveryMedium":{},"AttributeName":{}}}},"S10":{"type":"list","member":{}},"S13":{"type":"structure","members":{"ProviderName":{},"ProviderAttributeName":{},"ProviderAttributeValue":{}}},"S1e":{"type":"structure","members":{"DeviceKey":{},"DeviceAttributes":{"shape":"Sj"},"DeviceCreateDate":{"type":"timestamp"},"DeviceLastModifiedDate":{"type":"timestamp"},"DeviceLastAuthenticatedDate":{"type":"timestamp"}}},"S1h":{"type":"list","member":{}},"S1j":{"type":"string","sensitive":true},"S1l":{"type":"map","key":{},"value":{},"sensitive":true},"S1m":{"type":"structure","members":{"AnalyticsEndpointId":{}}},"S1n":{"type":"structure","required":["IpAddress","ServerName","ServerPath","HttpHeaders"],"members":{"IpAddress":{},"ServerName":{},"ServerPath":{},"HttpHeaders":{"type":"list","member":{"type":"structure","members":{"headerName":{},"headerValue":{}}}},"EncodedData":{}}},"S1s":{"type":"string","sensitive":true},"S1t":{"type":"map","key":{},"value":{}},"S1u":{"type":"structure","members":{"AccessToken":{"shape":"S1v"},"ExpiresIn":{"type":"integer"},"TokenType":{},"RefreshToken":{"shape":"S1v"},"IdToken":{"shape":"S1v"},"NewDeviceMetadata":{"type":"structure","members":{"DeviceKey":{},"DeviceGroupKey":{}}}}},"S1v":{"type":"string","sensitive":true},"S24":{"type":"list","member":{"shape":"S1e"}},"S28":{"type":"list","member":{"shape":"S29"}},"S29":{"type":"structure","members":{"GroupName":{},"UserPoolId":{},"Description":{},"RoleArn":{},"Precedence":{"type":"integer"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S2y":{"type":"map","key":{},"value":{},"sensitive":true},"S31":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S32":{"type":"structure","members":{"Enabled":{"type":"boolean"},"PreferredMfa":{"type":"boolean"}}},"S3s":{"type":"string","sensitive":true},"S3u":{"type":"structure","members":{"IpAddress":{},"EncodedData":{}},"sensitive":true},"S43":{"type":"map","key":{},"value":{}},"S44":{"type":"map","key":{},"value":{}},"S46":{"type":"list","member":{}},"S49":{"type":"structure","members":{"UserPoolId":{},"ProviderName":{},"ProviderType":{},"ProviderDetails":{"shape":"S43"},"AttributeMapping":{"shape":"S44"},"IdpIdentifiers":{"shape":"S46"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S4d":{"type":"list","member":{"type":"structure","required":["ScopeName","ScopeDescription"],"members":{"ScopeName":{},"ScopeDescription":{}}}},"S4i":{"type":"structure","members":{"UserPoolId":{},"Identifier":{},"Name":{},"Scopes":{"shape":"S4d"}}},"S4m":{"type":"structure","members":{"JobName":{},"JobId":{},"UserPoolId":{},"PreSignedUrl":{},"CreationDate":{"type":"timestamp"},"StartDate":{"type":"timestamp"},"CompletionDate":{"type":"timestamp"},"Status":{},"CloudWatchLogsRoleArn":{},"ImportedUsers":{"type":"long"},"SkippedUsers":{"type":"long"},"FailedUsers":{"type":"long"},"CompletionMessage":{}}},"S4u":{"type":"structure","members":{"PasswordPolicy":{"type":"structure","members":{"MinimumLength":{"type":"integer"},"RequireUppercase":{"type":"boolean"},"RequireLowercase":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireSymbols":{"type":"boolean"},"TemporaryPasswordValidityDays":{"type":"integer"}}}}},"S4z":{"type":"structure","members":{"PreSignUp":{},"CustomMessage":{},"PostConfirmation":{},"PreAuthentication":{},"PostAuthentication":{},"DefineAuthChallenge":{},"CreateAuthChallenge":{},"VerifyAuthChallengeResponse":{},"PreTokenGeneration":{},"UserMigration":{},"PreTokenGenerationConfig":{"type":"structure","required":["LambdaVersion","LambdaArn"],"members":{"LambdaVersion":{},"LambdaArn":{}}},"CustomSMSSender":{"type":"structure","required":["LambdaVersion","LambdaArn"],"members":{"LambdaVersion":{},"LambdaArn":{}}},"CustomEmailSender":{"type":"structure","required":["LambdaVersion","LambdaArn"],"members":{"LambdaVersion":{},"LambdaArn":{}}},"KMSKeyID":{}}},"S56":{"type":"list","member":{}},"S58":{"type":"list","member":{}},"S5a":{"type":"list","member":{}},"S5f":{"type":"structure","members":{"SmsMessage":{},"EmailMessage":{},"EmailSubject":{},"EmailMessageByLink":{},"EmailSubjectByLink":{},"DefaultEmailOption":{}}},"S5k":{"type":"structure","members":{"AttributesRequireVerificationBeforeUpdate":{"type":"list","member":{}}}},"S5m":{"type":"structure","members":{"ChallengeRequiredOnNewDevice":{"type":"boolean"},"DeviceOnlyRememberedOnUserPrompt":{"type":"boolean"}}},"S5n":{"type":"structure","members":{"SourceArn":{},"ReplyToEmailAddress":{},"EmailSendingAccount":{},"From":{},"ConfigurationSet":{}}},"S5r":{"type":"structure","required":["SnsCallerArn"],"members":{"SnsCallerArn":{},"ExternalId":{},"SnsRegion":{}}},"S5t":{"type":"map","key":{},"value":{}},"S5w":{"type":"structure","members":{"AllowAdminCreateUserOnly":{"type":"boolean"},"UnusedAccountValidityDays":{"type":"integer"},"InviteMessageTemplate":{"type":"structure","members":{"SMSMessage":{},"EmailMessage":{},"EmailSubject":{}}}}},"S5z":{"type":"list","member":{"shape":"S4"}},"S60":{"type":"structure","required":["AdvancedSecurityMode"],"members":{"AdvancedSecurityMode":{}}},"S62":{"type":"structure","required":["CaseSensitive"],"members":{"CaseSensitive":{"type":"boolean"}}},"S63":{"type":"structure","members":{"RecoveryMechanisms":{"type":"list","member":{"type":"structure","required":["Priority","Name"],"members":{"Priority":{"type":"integer"},"Name":{}}}}}},"S69":{"type":"structure","members":{"Id":{},"Name":{},"Policies":{"shape":"S4u"},"DeletionProtection":{},"LambdaConfig":{"shape":"S4z"},"Status":{"deprecated":true,"deprecatedMessage":"This property is no longer available."},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"SchemaAttributes":{"shape":"S5z"},"AutoVerifiedAttributes":{"shape":"S56"},"AliasAttributes":{"shape":"S58"},"UsernameAttributes":{"shape":"S5a"},"SmsVerificationMessage":{},"EmailVerificationMessage":{},"EmailVerificationSubject":{},"VerificationMessageTemplate":{"shape":"S5f"},"SmsAuthenticationMessage":{},"UserAttributeUpdateSettings":{"shape":"S5k"},"MfaConfiguration":{},"DeviceConfiguration":{"shape":"S5m"},"EstimatedNumberOfUsers":{"type":"integer"},"EmailConfiguration":{"shape":"S5n"},"SmsConfiguration":{"shape":"S5r"},"UserPoolTags":{"shape":"S5t"},"SmsConfigurationFailure":{},"EmailConfigurationFailure":{},"Domain":{},"CustomDomain":{},"AdminCreateUserConfig":{"shape":"S5w"},"UserPoolAddOns":{"shape":"S60"},"UsernameConfiguration":{"shape":"S62"},"Arn":{},"AccountRecoverySetting":{"shape":"S63"}}},"S6i":{"type":"structure","members":{"AccessToken":{},"IdToken":{},"RefreshToken":{}}},"S6k":{"type":"list","member":{}},"S6m":{"type":"list","member":{}},"S6o":{"type":"list","member":{}},"S6p":{"type":"list","member":{}},"S6r":{"type":"list","member":{}},"S6s":{"type":"list","member":{}},"S6u":{"type":"list","member":{}},"S6w":{"type":"structure","members":{"ApplicationId":{},"ApplicationArn":{},"RoleArn":{},"ExternalId":{},"UserDataShared":{"type":"boolean"}}},"S71":{"type":"structure","members":{"UserPoolId":{},"ClientName":{},"ClientId":{"shape":"S1j"},"ClientSecret":{"shape":"S72"},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"},"RefreshTokenValidity":{"type":"integer"},"AccessTokenValidity":{"type":"integer"},"IdTokenValidity":{"type":"integer"},"TokenValidityUnits":{"shape":"S6i"},"ReadAttributes":{"shape":"S6k"},"WriteAttributes":{"shape":"S6k"},"ExplicitAuthFlows":{"shape":"S6m"},"SupportedIdentityProviders":{"shape":"S6o"},"CallbackURLs":{"shape":"S6p"},"LogoutURLs":{"shape":"S6r"},"DefaultRedirectURI":{},"AllowedOAuthFlows":{"shape":"S6s"},"AllowedOAuthScopes":{"shape":"S6u"},"AllowedOAuthFlowsUserPoolClient":{"type":"boolean"},"AnalyticsConfiguration":{"shape":"S6w"},"PreventUserExistenceErrors":{},"EnableTokenRevocation":{"type":"boolean"},"EnablePropagateAdditionalUserContextData":{"type":"boolean"},"AuthSessionValidity":{"type":"integer"}}},"S72":{"type":"string","sensitive":true},"S74":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{}}},"S7m":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"CompromisedCredentialsRiskConfiguration":{"shape":"S7n"},"AccountTakeoverRiskConfiguration":{"shape":"S7s"},"RiskExceptionConfiguration":{"shape":"S81"},"LastModifiedDate":{"type":"timestamp"}}},"S7n":{"type":"structure","required":["Actions"],"members":{"EventFilter":{"type":"list","member":{}},"Actions":{"type":"structure","required":["EventAction"],"members":{"EventAction":{}}}}},"S7s":{"type":"structure","required":["Actions"],"members":{"NotifyConfiguration":{"type":"structure","required":["SourceArn"],"members":{"From":{},"ReplyTo":{},"SourceArn":{},"BlockEmail":{"shape":"S7u"},"NoActionEmail":{"shape":"S7u"},"MfaEmail":{"shape":"S7u"}}},"Actions":{"type":"structure","members":{"LowAction":{"shape":"S7y"},"MediumAction":{"shape":"S7y"},"HighAction":{"shape":"S7y"}}}}},"S7u":{"type":"structure","required":["Subject"],"members":{"Subject":{},"HtmlBody":{},"TextBody":{}}},"S7y":{"type":"structure","required":["Notify","EventAction"],"members":{"Notify":{"type":"boolean"},"EventAction":{}}},"S81":{"type":"structure","members":{"BlockedIPRangeList":{"type":"list","member":{}},"SkippedIPRangeList":{"type":"list","member":{}}}},"S8k":{"type":"structure","members":{"Destination":{},"DeliveryMedium":{},"AttributeName":{}}},"S8w":{"type":"structure","required":["UserPoolId","LogConfigurations"],"members":{"UserPoolId":{},"LogConfigurations":{"shape":"S8x"}}},"S8x":{"type":"list","member":{"type":"structure","required":["LogLevel","EventSource"],"members":{"LogLevel":{},"EventSource":{},"CloudWatchLogsConfiguration":{"type":"structure","members":{"LogGroupArn":{}}}}}},"S96":{"type":"structure","members":{"UserPoolId":{},"ClientId":{"shape":"S1j"},"ImageUrl":{},"CSS":{},"CSSVersion":{},"LastModifiedDate":{"type":"timestamp"},"CreationDate":{"type":"timestamp"}}},"S9g":{"type":"structure","members":{"SmsAuthenticationMessage":{},"SmsConfiguration":{"shape":"S5r"}}},"S9h":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Saj":{"type":"list","member":{"shape":"St"}}}}

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"AdminListGroupsForUser":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"AdminListUserAuthEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthEvents"},"ListGroups":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Groups"},"ListIdentityProviders":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Providers"},"ListResourceServers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceServers"},"ListUserPoolClients":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPoolClients"},"ListUserPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserPools"},"ListUsers":{"input_token":"PaginationToken","limit_key":"Limit","output_token":"PaginationToken","result_key":"Users"},"ListUsersInGroup":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Users"}}}

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-30","endpointPrefix":"cognito-sync","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Cognito Sync","serviceId":"Cognito Sync","signatureVersion":"v4","uid":"cognito-sync-2014-06-30"},"operations":{"BulkPublish":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/bulkpublish","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"}}},"output":{"type":"structure","members":{"Dataset":{"shape":"S8"}}}},"DescribeIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolUsage":{"shape":"Sg"}}}},"DescribeIdentityUsage":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"}}},"output":{"type":"structure","members":{"IdentityUsage":{"type":"structure","members":{"IdentityId":{},"IdentityPoolId":{},"LastModifiedDate":{"type":"timestamp"},"DatasetCount":{"type":"integer"},"DataStorage":{"type":"long"}}}}}},"GetBulkPublishDetails":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/getBulkPublishDetails","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"BulkPublishStartTime":{"type":"timestamp"},"BulkPublishCompleteTime":{"type":"timestamp"},"BulkPublishStatus":{},"FailureMessage":{}}}},"GetCognitoEvents":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"Events":{"shape":"Sq"}}}},"GetIdentityPoolConfiguration":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets","responseCode":200},"input":{"type":"structure","required":["IdentityId","IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"shape":"S8"}},"Count":{"type":"integer"},"NextToken":{}}}},"ListIdentityPoolUsage":{"http":{"method":"GET","requestUri":"/identitypools","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"IdentityPoolUsages":{"type":"list","member":{"shape":"Sg"}},"MaxResults":{"type":"integer"},"Count":{"type":"integer"},"NextToken":{}}}},"ListRecords":{"http":{"method":"GET","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/records","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"LastSyncCount":{"location":"querystring","locationName":"lastSyncCount","type":"long"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"SyncSessionToken":{"location":"querystring","locationName":"syncSessionToken"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"},"NextToken":{},"Count":{"type":"integer"},"DatasetSyncCount":{"type":"long"},"LastModifiedBy":{},"MergedDatasetNames":{"type":"list","member":{}},"DatasetExists":{"type":"boolean"},"DatasetDeletedAfterRequestedSyncCount":{"type":"boolean"},"SyncSessionToken":{}}}},"RegisterDevice":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identity/{IdentityId}/device","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","Platform","Token"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"Platform":{},"Token":{}}},"output":{"type":"structure","members":{"DeviceId":{}}}},"SetCognitoEvents":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/events","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","Events"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"Events":{"shape":"Sq"}}}},"SetIdentityPoolConfiguration":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/configuration","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}},"output":{"type":"structure","members":{"IdentityPoolId":{},"PushSync":{"shape":"Sv"},"CognitoStreams":{"shape":"Sz"}}}},"SubscribeToDataset":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UnsubscribeFromDataset":{"http":{"method":"DELETE","requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}/subscriptions/{DeviceId}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","DeviceId"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{"location":"uri","locationName":"DeviceId"}}},"output":{"type":"structure","members":{}}},"UpdateRecords":{"http":{"requestUri":"/identitypools/{IdentityPoolId}/identities/{IdentityId}/datasets/{DatasetName}","responseCode":200},"input":{"type":"structure","required":["IdentityPoolId","IdentityId","DatasetName","SyncSessionToken"],"members":{"IdentityPoolId":{"location":"uri","locationName":"IdentityPoolId"},"IdentityId":{"location":"uri","locationName":"IdentityId"},"DatasetName":{"location":"uri","locationName":"DatasetName"},"DeviceId":{},"RecordPatches":{"type":"list","member":{"type":"structure","required":["Op","Key","SyncCount"],"members":{"Op":{},"Key":{},"Value":{},"SyncCount":{"type":"long"},"DeviceLastModifiedDate":{"type":"timestamp"}}}},"SyncSessionToken":{},"ClientContext":{"location":"header","locationName":"x-amz-Client-Context"}}},"output":{"type":"structure","members":{"Records":{"shape":"S1c"}}}}},"shapes":{"S8":{"type":"structure","members":{"IdentityId":{},"DatasetName":{},"CreationDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DataStorage":{"type":"long"},"NumRecords":{"type":"long"}}},"Sg":{"type":"structure","members":{"IdentityPoolId":{},"SyncSessionsCount":{"type":"long"},"DataStorage":{"type":"long"},"LastModifiedDate":{"type":"timestamp"}}},"Sq":{"type":"map","key":{},"value":{}},"Sv":{"type":"structure","members":{"ApplicationArns":{"type":"list","member":{}},"RoleArn":{}}},"Sz":{"type":"structure","members":{"StreamName":{},"RoleArn":{},"StreamingStatus":{}}},"S1c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"SyncCount":{"type":"long"},"LastModifiedDate":{"type":"timestamp"},"LastModifiedBy":{},"DeviceLastModifiedDate":{"type":"timestamp"}}}}}}

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"comprehend","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Comprehend","serviceId":"Comprehend","signatureVersion":"v4","signingName":"comprehend","targetPrefix":"Comprehend_20171127","uid":"comprehend-2017-11-27"},"operations":{"BatchDetectDominantLanguage":{"input":{"type":"structure","required":["TextList"],"members":{"TextList":{"shape":"S2"}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Languages":{"shape":"S8"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectEntities":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Entities":{"shape":"Sj"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectKeyPhrases":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"KeyPhrases":{"shape":"Su"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectSentiment":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Sentiment":{},"SentimentScore":{"shape":"S11"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectSyntax":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"SyntaxTokens":{"shape":"S17"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"BatchDetectTargetedSentiment":{"input":{"type":"structure","required":["TextList","LanguageCode"],"members":{"TextList":{"shape":"S2"},"LanguageCode":{}}},"output":{"type":"structure","required":["ResultList","ErrorList"],"members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"Entities":{"shape":"S1f"}}}},"ErrorList":{"shape":"Sc"}},"sensitive":true}},"ClassifyDocument":{"input":{"type":"structure","required":["EndpointArn"],"members":{"Text":{"shape":"S3"},"EndpointArn":{},"Bytes":{"type":"blob"},"DocumentReaderConfig":{"shape":"S1p"}}},"output":{"type":"structure","members":{"Classes":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"},"Page":{"type":"integer"}}}},"Labels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"},"Page":{"type":"integer"}}}},"DocumentMetadata":{"shape":"S1z"},"DocumentType":{"shape":"S22"},"Errors":{"shape":"S25"},"Warnings":{"type":"list","member":{"type":"structure","members":{"Page":{"type":"integer"},"WarnCode":{},"WarnMessage":{}}}}},"sensitive":true}},"ContainsPiiEntities":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}}}}},"CreateDataset":{"input":{"type":"structure","required":["FlywheelArn","DatasetName","InputDataConfig"],"members":{"FlywheelArn":{},"DatasetName":{},"DatasetType":{},"Description":{},"InputDataConfig":{"type":"structure","members":{"AugmentedManifests":{"type":"list","member":{"type":"structure","required":["AttributeNames","S3Uri"],"members":{"AttributeNames":{"shape":"S2o"},"S3Uri":{},"AnnotationDataS3Uri":{},"SourceDocumentsS3Uri":{},"DocumentType":{}}}},"DataFormat":{},"DocumentClassifierInputDataConfig":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"LabelDelimiter":{}}},"EntityRecognizerInputDataConfig":{"type":"structure","required":["Documents"],"members":{"Annotations":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"Documents":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"InputFormat":{}}},"EntityList":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}}}}}},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"DatasetArn":{}}}},"CreateDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"DocumentClassifierName":{},"VersionName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S31"},"InputDataConfig":{"shape":"S3a"},"OutputDataConfig":{"shape":"S3h"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Mode":{},"ModelKmsKeyId":{},"ModelPolicy":{}}},"output":{"type":"structure","members":{"DocumentClassifierArn":{}}}},"CreateEndpoint":{"input":{"type":"structure","required":["EndpointName","DesiredInferenceUnits"],"members":{"EndpointName":{},"ModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S31"},"DataAccessRoleArn":{},"FlywheelArn":{}}},"output":{"type":"structure","members":{"EndpointArn":{},"ModelArn":{}}}},"CreateEntityRecognizer":{"input":{"type":"structure","required":["RecognizerName","DataAccessRoleArn","InputDataConfig","LanguageCode"],"members":{"RecognizerName":{},"VersionName":{},"DataAccessRoleArn":{},"Tags":{"shape":"S31"},"InputDataConfig":{"shape":"S3z"},"ClientRequestToken":{"idempotencyToken":true},"LanguageCode":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"ModelKmsKeyId":{},"ModelPolicy":{}}},"output":{"type":"structure","members":{"EntityRecognizerArn":{}}}},"CreateFlywheel":{"input":{"type":"structure","required":["FlywheelName","DataAccessRoleArn","DataLakeS3Uri"],"members":{"FlywheelName":{},"ActiveModelArn":{},"DataAccessRoleArn":{},"TaskConfig":{"shape":"S4b"},"ModelType":{},"DataLakeS3Uri":{},"DataSecurityConfig":{"shape":"S4i"},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"FlywheelArn":{},"ActiveModelArn":{}}}},"DeleteDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{}}},"DeleteEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"DeleteFlywheel":{"input":{"type":"structure","required":["FlywheelArn"],"members":{"FlywheelArn":{}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"PolicyRevisionId":{}}},"output":{"type":"structure","members":{}}},"DescribeDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{"DatasetProperties":{"shape":"S4x"}}}},"DescribeDocumentClassificationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DocumentClassificationJobProperties":{"shape":"S55"}}}},"DescribeDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{"DocumentClassifierProperties":{"shape":"S5d"}}}},"DescribeDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobProperties":{"shape":"S5k"}}}},"DescribeEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"type":"structure","members":{"EndpointProperties":{"shape":"S5n"}}}},"DescribeEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"EntitiesDetectionJobProperties":{"shape":"S5r"}}}},"DescribeEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{"EntityRecognizerProperties":{"shape":"S5u"}}}},"DescribeEventsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"EventsDetectionJobProperties":{"shape":"S63"}}}},"DescribeFlywheel":{"input":{"type":"structure","required":["FlywheelArn"],"members":{"FlywheelArn":{}}},"output":{"type":"structure","members":{"FlywheelProperties":{"shape":"S68"}}}},"DescribeFlywheelIteration":{"input":{"type":"structure","required":["FlywheelArn","FlywheelIterationId"],"members":{"FlywheelArn":{},"FlywheelIterationId":{}}},"output":{"type":"structure","members":{"FlywheelIterationProperties":{"shape":"S6d"}}}},"DescribeKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobProperties":{"shape":"S6i"}}}},"DescribePiiEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"PiiEntitiesDetectionJobProperties":{"shape":"S6l"}}}},"DescribeResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourcePolicy":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"PolicyRevisionId":{}}}},"DescribeSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"SentimentDetectionJobProperties":{"shape":"S6w"}}}},"DescribeTargetedSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TargetedSentimentDetectionJobProperties":{"shape":"S6z"}}}},"DescribeTopicsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TopicsDetectionJobProperties":{"shape":"S72"}}}},"DetectDominantLanguage":{"input":{"type":"structure","required":["Text"],"members":{"Text":{"shape":"S3"}}},"output":{"type":"structure","members":{"Languages":{"shape":"S8"}},"sensitive":true}},"DetectEntities":{"input":{"type":"structure","members":{"Text":{"shape":"S3"},"LanguageCode":{},"EndpointArn":{},"Bytes":{"type":"blob"},"DocumentReaderConfig":{"shape":"S1p"}}},"output":{"type":"structure","members":{"Entities":{"shape":"Sj"},"DocumentMetadata":{"shape":"S1z"},"DocumentType":{"shape":"S22"},"Blocks":{"type":"list","member":{"type":"structure","members":{"Id":{},"BlockType":{},"Text":{},"Page":{"type":"integer"},"Geometry":{"type":"structure","members":{"BoundingBox":{"type":"structure","members":{"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"},"Width":{"type":"float"}}},"Polygon":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}}}},"Relationships":{"type":"list","member":{"type":"structure","members":{"Ids":{"type":"list","member":{}},"Type":{}}}}}}},"Errors":{"shape":"S25"}},"sensitive":true}},"DetectKeyPhrases":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{"shape":"S3"},"LanguageCode":{}}},"output":{"type":"structure","members":{"KeyPhrases":{"shape":"Su"}},"sensitive":true}},"DetectPiiEntities":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Type":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}}}}},"DetectSentiment":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{"shape":"S3"},"LanguageCode":{}}},"output":{"type":"structure","members":{"Sentiment":{},"SentimentScore":{"shape":"S11"}},"sensitive":true}},"DetectSyntax":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{"shape":"S3"},"LanguageCode":{}}},"output":{"type":"structure","members":{"SyntaxTokens":{"shape":"S17"}},"sensitive":true}},"DetectTargetedSentiment":{"input":{"type":"structure","required":["Text","LanguageCode"],"members":{"Text":{"shape":"S3"},"LanguageCode":{}}},"output":{"type":"structure","members":{"Entities":{"shape":"S1f"}},"sensitive":true}},"DetectToxicContent":{"input":{"type":"structure","required":["TextSegments","LanguageCode"],"members":{"TextSegments":{"type":"list","member":{"type":"structure","required":["Text"],"members":{"Text":{"shape":"S3"}}},"sensitive":true},"LanguageCode":{}}},"output":{"type":"structure","members":{"ResultList":{"type":"list","member":{"type":"structure","members":{"Labels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"Toxicity":{"type":"float"}}}}}}},"ImportModel":{"input":{"type":"structure","required":["SourceModelArn"],"members":{"SourceModelArn":{},"ModelName":{},"VersionName":{},"ModelKmsKeyId":{},"DataAccessRoleArn":{},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"ModelArn":{}}}},"ListDatasets":{"input":{"type":"structure","members":{"FlywheelArn":{},"Filter":{"type":"structure","members":{"Status":{},"DatasetType":{},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetPropertiesList":{"type":"list","member":{"shape":"S4x"}},"NextToken":{}}}},"ListDocumentClassificationJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassificationJobPropertiesList":{"type":"list","member":{"shape":"S55"}},"NextToken":{}}}},"ListDocumentClassifierSummaries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassifierSummariesList":{"type":"list","member":{"type":"structure","members":{"DocumentClassifierName":{},"NumberOfVersions":{"type":"integer"},"LatestVersionCreatedAt":{"type":"timestamp"},"LatestVersionName":{},"LatestVersionStatus":{}}}},"NextToken":{}}}},"ListDocumentClassifiers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"DocumentClassifierName":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DocumentClassifierPropertiesList":{"type":"list","member":{"shape":"S5d"}},"NextToken":{}}}},"ListDominantLanguageDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DominantLanguageDetectionJobPropertiesList":{"type":"list","member":{"shape":"S5k"}},"NextToken":{}}}},"ListEndpoints":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"ModelArn":{},"Status":{},"CreationTimeBefore":{"type":"timestamp"},"CreationTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EndpointPropertiesList":{"type":"list","member":{"shape":"S5n"}},"NextToken":{}}}},"ListEntitiesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntitiesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S5r"}},"NextToken":{}}}},"ListEntityRecognizerSummaries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntityRecognizerSummariesList":{"type":"list","member":{"type":"structure","members":{"RecognizerName":{},"NumberOfVersions":{"type":"integer"},"LatestVersionCreatedAt":{"type":"timestamp"},"LatestVersionName":{},"LatestVersionStatus":{}}}},"NextToken":{}}}},"ListEntityRecognizers":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"RecognizerName":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EntityRecognizerPropertiesList":{"type":"list","member":{"shape":"S5u"}},"NextToken":{}}}},"ListEventsDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EventsDetectionJobPropertiesList":{"type":"list","member":{"shape":"S63"}},"NextToken":{}}}},"ListFlywheelIterationHistory":{"input":{"type":"structure","required":["FlywheelArn"],"members":{"FlywheelArn":{},"Filter":{"type":"structure","members":{"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FlywheelIterationPropertiesList":{"type":"list","member":{"shape":"S6d"}},"NextToken":{}}}},"ListFlywheels":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"Status":{},"CreationTimeAfter":{"type":"timestamp"},"CreationTimeBefore":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FlywheelSummaryList":{"type":"list","member":{"type":"structure","members":{"FlywheelArn":{},"ActiveModelArn":{},"DataLakeS3Uri":{},"Status":{},"ModelType":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LatestFlywheelIteration":{}}}},"NextToken":{}}}},"ListKeyPhrasesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyPhrasesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S6i"}},"NextToken":{}}}},"ListPiiEntitiesDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PiiEntitiesDetectionJobPropertiesList":{"type":"list","member":{"shape":"S6l"}},"NextToken":{}}}},"ListSentimentDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SentimentDetectionJobPropertiesList":{"type":"list","member":{"shape":"S6w"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"S31"}}}},"ListTargetedSentimentDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TargetedSentimentDetectionJobPropertiesList":{"type":"list","member":{"shape":"S6z"}},"NextToken":{}}}},"ListTopicsDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TopicsDetectionJobPropertiesList":{"type":"list","member":{"shape":"S72"}},"NextToken":{}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","ResourcePolicy"],"members":{"ResourceArn":{},"ResourcePolicy":{},"PolicyRevisionId":{}}},"output":{"type":"structure","members":{"PolicyRevisionId":{}}}},"StartDocumentClassificationJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"JobName":{},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Tags":{"shape":"S31"},"FlywheelArn":{}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{},"DocumentClassifierArn":{}}}},"StartDominantLanguageDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartEntitiesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"JobName":{},"EntityRecognizerArn":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Tags":{"shape":"S31"},"FlywheelArn":{}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{},"EntityRecognizerArn":{}}}},"StartEventsDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode","TargetEventTypes"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"TargetEventTypes":{"shape":"S64"},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartFlywheelIteration":{"input":{"type":"structure","required":["FlywheelArn"],"members":{"FlywheelArn":{},"ClientRequestToken":{}}},"output":{"type":"structure","members":{"FlywheelArn":{},"FlywheelIterationId":{}}}},"StartKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartPiiEntitiesDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","Mode","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"Mode":{},"RedactionConfig":{"shape":"S6n"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartSentimentDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartTargetedSentimentDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"JobName":{},"LanguageCode":{},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StartTopicsDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn"],"members":{"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"JobName":{},"NumberOfTopics":{"type":"integer"},"ClientRequestToken":{"idempotencyToken":true},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobStatus":{}}}},"StopDominantLanguageDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopEventsDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopKeyPhrasesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopPiiEntitiesDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTargetedSentimentDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTrainingDocumentClassifier":{"input":{"type":"structure","required":["DocumentClassifierArn"],"members":{"DocumentClassifierArn":{}}},"output":{"type":"structure","members":{}}},"StopTrainingEntityRecognizer":{"input":{"type":"structure","required":["EntityRecognizerArn"],"members":{"EntityRecognizerArn":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S31"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{},"DesiredModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"DesiredDataAccessRoleArn":{},"FlywheelArn":{}}},"output":{"type":"structure","members":{"DesiredModelArn":{}}}},"UpdateFlywheel":{"input":{"type":"structure","required":["FlywheelArn"],"members":{"FlywheelArn":{},"ActiveModelArn":{},"DataAccessRoleArn":{},"DataSecurityConfig":{"type":"structure","members":{"ModelKmsKeyId":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"}}}}},"output":{"type":"structure","members":{"FlywheelProperties":{"shape":"S68"}}}}},"shapes":{"S2":{"type":"list","member":{"shape":"S3"},"sensitive":true},"S3":{"type":"string","sensitive":true},"S8":{"type":"list","member":{"type":"structure","members":{"LanguageCode":{},"Score":{"type":"float"}}}},"Sc":{"type":"list","member":{"type":"structure","members":{"Index":{"type":"integer"},"ErrorCode":{},"ErrorMessage":{}}}},"Sj":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Type":{},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"BlockReferences":{"type":"list","member":{"type":"structure","members":{"BlockId":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"ChildBlocks":{"type":"list","member":{"type":"structure","members":{"ChildBlockId":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}}}}}}}},"Su":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}},"S11":{"type":"structure","members":{"Positive":{"type":"float"},"Negative":{"type":"float"},"Neutral":{"type":"float"},"Mixed":{"type":"float"}}},"S17":{"type":"list","member":{"type":"structure","members":{"TokenId":{"type":"integer"},"Text":{},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"PartOfSpeech":{"type":"structure","members":{"Tag":{},"Score":{"type":"float"}}}}}},"S1f":{"type":"list","member":{"type":"structure","members":{"DescriptiveMentionIndex":{"type":"list","member":{"type":"integer"}},"Mentions":{"type":"list","member":{"type":"structure","members":{"Score":{"type":"float"},"GroupScore":{"type":"float"},"Text":{},"Type":{},"MentionSentiment":{"type":"structure","members":{"Sentiment":{},"SentimentScore":{"shape":"S11"}}},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"}}}}}}},"S1p":{"type":"structure","required":["DocumentReadAction"],"members":{"DocumentReadAction":{},"DocumentReadMode":{},"FeatureTypes":{"type":"list","member":{}}}},"S1z":{"type":"structure","members":{"Pages":{"type":"integer"},"ExtractedCharacters":{"type":"list","member":{"type":"structure","members":{"Page":{"type":"integer"},"Count":{"type":"integer"}}}}}},"S22":{"type":"list","member":{"type":"structure","members":{"Page":{"type":"integer"},"Type":{}}}},"S25":{"type":"list","member":{"type":"structure","members":{"Page":{"type":"integer"},"ErrorCode":{},"ErrorMessage":{}}}},"S2o":{"type":"list","member":{}},"S31":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S3a":{"type":"structure","members":{"DataFormat":{},"S3Uri":{},"TestS3Uri":{},"LabelDelimiter":{},"AugmentedManifests":{"type":"list","member":{"shape":"S3d"}},"DocumentType":{},"Documents":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"TestS3Uri":{}}},"DocumentReaderConfig":{"shape":"S1p"}}},"S3d":{"type":"structure","required":["S3Uri","AttributeNames"],"members":{"S3Uri":{},"Split":{},"AttributeNames":{"shape":"S2o"},"AnnotationDataS3Uri":{},"SourceDocumentsS3Uri":{},"DocumentType":{}}},"S3h":{"type":"structure","members":{"S3Uri":{},"KmsKeyId":{},"FlywheelStatsS3Prefix":{}}},"S3j":{"type":"structure","required":["SecurityGroupIds","Subnets"],"members":{"SecurityGroupIds":{"type":"list","member":{}},"Subnets":{"type":"list","member":{}}}},"S3z":{"type":"structure","required":["EntityTypes"],"members":{"DataFormat":{},"EntityTypes":{"shape":"S41"},"Documents":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"TestS3Uri":{},"InputFormat":{}}},"Annotations":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"TestS3Uri":{}}},"EntityList":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{}}},"AugmentedManifests":{"type":"list","member":{"shape":"S3d"}}}},"S41":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{}}}},"S4b":{"type":"structure","required":["LanguageCode"],"members":{"LanguageCode":{},"DocumentClassificationConfig":{"type":"structure","required":["Mode"],"members":{"Mode":{},"Labels":{"type":"list","member":{}}}},"EntityRecognitionConfig":{"type":"structure","required":["EntityTypes"],"members":{"EntityTypes":{"shape":"S41"}}}}},"S4i":{"type":"structure","members":{"ModelKmsKeyId":{},"VolumeKmsKeyId":{},"DataLakeKmsKeyId":{},"VpcConfig":{"shape":"S3j"}}},"S4x":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"DatasetType":{},"DatasetS3Uri":{},"Description":{},"Status":{},"Message":{},"NumberOfDocuments":{"type":"long"},"CreationTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S55":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"DocumentClassifierArn":{},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"FlywheelArn":{}}},"S59":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"InputFormat":{},"DocumentReaderConfig":{"shape":"S1p"}}},"S5a":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"KmsKeyId":{}}},"S5d":{"type":"structure","members":{"DocumentClassifierArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3a"},"OutputDataConfig":{"shape":"S3h"},"ClassifierMetadata":{"type":"structure","members":{"NumberOfLabels":{"type":"integer"},"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Accuracy":{"type":"double"},"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"},"MicroPrecision":{"type":"double"},"MicroRecall":{"type":"double"},"MicroF1Score":{"type":"double"},"HammingLoss":{"type":"double"}}}},"sensitive":true},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"Mode":{},"ModelKmsKeyId":{},"VersionName":{},"SourceModelArn":{},"FlywheelArn":{}}},"S5k":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"}}},"S5n":{"type":"structure","members":{"EndpointArn":{},"Status":{},"Message":{},"ModelArn":{},"DesiredModelArn":{},"DesiredInferenceUnits":{"type":"integer"},"CurrentInferenceUnits":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"DataAccessRoleArn":{},"DesiredDataAccessRoleArn":{},"FlywheelArn":{}}},"S5r":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"EntityRecognizerArn":{},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"FlywheelArn":{}}},"S5u":{"type":"structure","members":{"EntityRecognizerArn":{},"LanguageCode":{},"Status":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TrainingStartTime":{"type":"timestamp"},"TrainingEndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S3z"},"RecognizerMetadata":{"type":"structure","members":{"NumberOfTrainedDocuments":{"type":"integer"},"NumberOfTestDocuments":{"type":"integer"},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"EntityTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"EvaluationMetrics":{"type":"structure","members":{"Precision":{"type":"double"},"Recall":{"type":"double"},"F1Score":{"type":"double"}}},"NumberOfTrainMentions":{"type":"integer"}}}}},"sensitive":true},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"},"ModelKmsKeyId":{},"VersionName":{},"SourceModelArn":{},"FlywheelArn":{},"OutputDataConfig":{"type":"structure","members":{"FlywheelStatsS3Prefix":{}}}}},"S63":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"LanguageCode":{},"DataAccessRoleArn":{},"TargetEventTypes":{"shape":"S64"}}},"S64":{"type":"list","member":{}},"S68":{"type":"structure","members":{"FlywheelArn":{},"ActiveModelArn":{},"DataAccessRoleArn":{},"TaskConfig":{"shape":"S4b"},"DataLakeS3Uri":{},"DataSecurityConfig":{"shape":"S4i"},"Status":{},"ModelType":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LatestFlywheelIteration":{}}},"S6d":{"type":"structure","members":{"FlywheelArn":{},"FlywheelIterationId":{},"CreationTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Status":{},"Message":{},"EvaluatedModelArn":{},"EvaluatedModelMetrics":{"shape":"S6f"},"TrainedModelArn":{},"TrainedModelMetrics":{"shape":"S6f"},"EvaluationManifestS3Prefix":{}}},"S6f":{"type":"structure","members":{"AverageF1Score":{"type":"double"},"AveragePrecision":{"type":"double"},"AverageRecall":{"type":"double"},"AverageAccuracy":{"type":"double"}}},"S6i":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"}}},"S6l":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"KmsKeyId":{}}},"RedactionConfig":{"shape":"S6n"},"LanguageCode":{},"DataAccessRoleArn":{},"Mode":{}}},"S6n":{"type":"structure","members":{"PiiEntityTypes":{"type":"list","member":{}},"MaskMode":{},"MaskCharacter":{}}},"S6w":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"}}},"S6z":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"LanguageCode":{},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"}}},"S72":{"type":"structure","members":{"JobId":{},"JobArn":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S59"},"OutputDataConfig":{"shape":"S5a"},"NumberOfTopics":{"type":"integer"},"DataAccessRoleArn":{},"VolumeKmsKeyId":{},"VpcConfig":{"shape":"S3j"}}}}}

/***/ }),
/* 456 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDatasets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDocumentClassificationJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDocumentClassifierSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDocumentClassifiers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListDominantLanguageDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EndpointPropertiesList"},"ListEntitiesDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListEntityRecognizerSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListEntityRecognizers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListEventsDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListFlywheelIterationHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListFlywheels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListKeyPhrasesDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListPiiEntitiesDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PiiEntitiesDetectionJobPropertiesList"},"ListSentimentDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTargetedSentimentDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTopicsDetectionJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 457 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-10-30","endpointPrefix":"comprehendmedical","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"ComprehendMedical","serviceFullName":"AWS Comprehend Medical","serviceId":"ComprehendMedical","signatureVersion":"v4","signingName":"comprehendmedical","targetPrefix":"ComprehendMedical_20181030","uid":"comprehendmedical-2018-10-30"},"operations":{"DescribeEntitiesDetectionV2Job":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeICD10CMInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribePHIDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeRxNormInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DescribeSNOMEDCTInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobProperties":{"shape":"S4"}}}},"DetectEntities":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"St"},"UnmappedAttributes":{"shape":"S16"},"PaginationToken":{},"ModelVersion":{}}},"deprecated":true,"deprecatedMessage":"This operation is deprecated, use DetectEntitiesV2 instead."},"DetectEntitiesV2":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"St"},"UnmappedAttributes":{"shape":"S16"},"PaginationToken":{},"ModelVersion":{}}}},"DetectPHI":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities","ModelVersion"],"members":{"Entities":{"shape":"St"},"PaginationToken":{},"ModelVersion":{}}}},"InferICD10CM":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S1m"},"Category":{},"RelationshipType":{}}}},"Traits":{"shape":"S1m"},"ICD10CMConcepts":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}}}}},"PaginationToken":{},"ModelVersion":{}}}},"InferRxNorm":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S21"}}}},"Traits":{"shape":"S21"},"RxNormConcepts":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}}}}},"PaginationToken":{},"ModelVersion":{}}}},"InferSNOMEDCT":{"input":{"type":"structure","required":["Text"],"members":{"Text":{}}},"output":{"type":"structure","required":["Entities"],"members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"Text":{},"Category":{},"Type":{},"Score":{"type":"float"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Attributes":{"type":"list","member":{"type":"structure","members":{"Category":{},"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"RelationshipType":{},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Traits":{"shape":"S2g"},"SNOMEDCTConcepts":{"shape":"S2j"}}}},"Traits":{"shape":"S2g"},"SNOMEDCTConcepts":{"shape":"S2j"}}}},"PaginationToken":{},"ModelVersion":{},"SNOMEDCTDetails":{"type":"structure","members":{"Edition":{},"Language":{},"VersionDate":{}}},"Characters":{"type":"structure","members":{"OriginalTextCharacters":{"type":"integer"}}}}}},"ListEntitiesDetectionV2Jobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListICD10CMInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListPHIDetectionJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListRxNormInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"ListSNOMEDCTInferenceJobs":{"input":{"type":"structure","members":{"Filter":{"shape":"S2o"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComprehendMedicalAsyncJobPropertiesList":{"shape":"S2r"},"NextToken":{}}}},"StartEntitiesDetectionV2Job":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartICD10CMInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartPHIDetectionJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartRxNormInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StartSNOMEDCTInferenceJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","LanguageCode"],"members":{"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"DataAccessRoleArn":{},"JobName":{},"ClientRequestToken":{"idempotencyToken":true},"KMSKey":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopEntitiesDetectionV2Job":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopICD10CMInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopPHIDetectionJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopRxNormInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}},"StopSNOMEDCTInferenceJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{}}}}},"shapes":{"S4":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"Message":{},"SubmitTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"InputDataConfig":{"shape":"S9"},"OutputDataConfig":{"shape":"Sc"},"LanguageCode":{},"DataAccessRoleArn":{},"ManifestFilePath":{},"KMSKey":{},"ModelVersion":{}}},"S9":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Key":{}}},"Sc":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Key":{}}},"St":{"type":"list","member":{"type":"structure","members":{"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Score":{"type":"float"},"Text":{},"Category":{},"Type":{},"Traits":{"shape":"S10"},"Attributes":{"type":"list","member":{"shape":"S14"}}}}},"S10":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S14":{"type":"structure","members":{"Type":{},"Score":{"type":"float"},"RelationshipScore":{"type":"float"},"RelationshipType":{},"Id":{"type":"integer"},"BeginOffset":{"type":"integer"},"EndOffset":{"type":"integer"},"Text":{},"Category":{},"Traits":{"shape":"S10"}}},"S16":{"type":"list","member":{"type":"structure","members":{"Type":{},"Attribute":{"shape":"S14"}}}},"S1m":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S21":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S2g":{"type":"list","member":{"type":"structure","members":{"Name":{},"Score":{"type":"float"}}}},"S2j":{"type":"list","member":{"type":"structure","members":{"Description":{},"Code":{},"Score":{"type":"float"}}}},"S2o":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmitTimeBefore":{"type":"timestamp"},"SubmitTimeAfter":{"type":"timestamp"}}},"S2r":{"type":"list","member":{"shape":"S4"}}}}

/***/ }),
/* 458 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 459 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-12","endpointPrefix":"config","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Config Service","serviceFullName":"AWS Config","serviceId":"Config Service","signatureVersion":"v4","targetPrefix":"StarlingDoveService","uid":"config-2014-11-12"},"operations":{"BatchGetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifiers"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}},"output":{"type":"structure","members":{"BaseConfigurationItems":{"shape":"Sb"},"UnprocessedResourceIdentifiers":{"type":"list","member":{"shape":"S4"}}}}},"BatchGetResourceConfig":{"input":{"type":"structure","required":["resourceKeys"],"members":{"resourceKeys":{"shape":"Ss"}}},"output":{"type":"structure","members":{"baseConfigurationItems":{"shape":"Sb"},"unprocessedResourceKeys":{"shape":"Ss"}}}},"DeleteAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{}}}},"DeleteConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}}},"DeleteConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{}}}},"DeleteConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"DeleteConformancePack":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{}}}},"DeleteDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannelName"],"members":{"DeliveryChannelName":{}}}},"DeleteEvaluationResults":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{}}},"DeleteOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{}}}},"DeleteOrganizationConformancePack":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{}}}},"DeletePendingAggregationRequest":{"input":{"type":"structure","required":["RequesterAccountId","RequesterAwsRegion"],"members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"DeleteRemediationConfiguration":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceType":{}}},"output":{"type":"structure","members":{}}},"DeleteRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1h"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S1h"}}}}}}},"DeleteResourceConfig":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}}},"DeleteRetentionConfiguration":{"input":{"type":"structure","required":["RetentionConfigurationName"],"members":{"RetentionConfigurationName":{}}}},"DeleteStoredQuery":{"input":{"type":"structure","required":["QueryName"],"members":{"QueryName":{}}},"output":{"type":"structure","members":{}}},"DeliverConfigSnapshot":{"input":{"type":"structure","required":["deliveryChannelName"],"members":{"deliveryChannelName":{}}},"output":{"type":"structure","members":{"configSnapshotId":{}}}},"DescribeAggregateComplianceByConfigRules":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ConfigRuleName":{},"ComplianceType":{},"AccountId":{},"AwsRegion":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S25"},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"DescribeAggregateComplianceByConformancePacks":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ConformancePackName":{},"ComplianceType":{},"AccountId":{},"AwsRegion":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateComplianceByConformancePacks":{"type":"list","member":{"type":"structure","members":{"ConformancePackName":{},"Compliance":{"type":"structure","members":{"ComplianceType":{},"CompliantRuleCount":{"type":"integer"},"NonCompliantRuleCount":{"type":"integer"},"TotalRuleCount":{"type":"integer"}}},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"DescribeAggregationAuthorizations":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregationAuthorizations":{"type":"list","member":{"shape":"S2k"}},"NextToken":{}}}},"DescribeComplianceByConfigRule":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2n"},"ComplianceTypes":{"shape":"S2o"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByConfigRules":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"Compliance":{"shape":"S25"}}}},"NextToken":{}}}},"DescribeComplianceByResource":{"input":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S2o"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ComplianceByResources":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Compliance":{"shape":"S25"}}}},"NextToken":{}}}},"DescribeConfigRuleEvaluationStatus":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2n"},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigRulesEvaluationStatus":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"LastSuccessfulInvocationTime":{"type":"timestamp"},"LastFailedInvocationTime":{"type":"timestamp"},"LastSuccessfulEvaluationTime":{"type":"timestamp"},"LastFailedEvaluationTime":{"type":"timestamp"},"FirstActivatedTime":{"type":"timestamp"},"LastDeactivatedTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{},"FirstEvaluationStarted":{"type":"boolean"},"LastDebugLogDeliveryStatus":{},"LastDebugLogDeliveryStatusReason":{},"LastDebugLogDeliveryTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeConfigRules":{"input":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S2n"},"NextToken":{},"Filters":{"type":"structure","members":{"EvaluationMode":{}}}}},"output":{"type":"structure","members":{"ConfigRules":{"type":"list","member":{"shape":"S37"}},"NextToken":{}}}},"DescribeConfigurationAggregatorSourcesStatus":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"UpdateStatus":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"AggregatedSourceStatusList":{"type":"list","member":{"type":"structure","members":{"SourceId":{},"SourceType":{},"AwsRegion":{},"LastUpdateStatus":{},"LastUpdateTime":{"type":"timestamp"},"LastErrorCode":{},"LastErrorMessage":{}}}},"NextToken":{}}}},"DescribeConfigurationAggregators":{"input":{"type":"structure","members":{"ConfigurationAggregatorNames":{"type":"list","member":{}},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ConfigurationAggregators":{"type":"list","member":{"shape":"S40"}},"NextToken":{}}}},"DescribeConfigurationRecorderStatus":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S48"}}},"output":{"type":"structure","members":{"ConfigurationRecordersStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"lastStartTime":{"type":"timestamp"},"lastStopTime":{"type":"timestamp"},"recording":{"type":"boolean"},"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}},"DescribeConfigurationRecorders":{"input":{"type":"structure","members":{"ConfigurationRecorderNames":{"shape":"S48"}}},"output":{"type":"structure","members":{"ConfigurationRecorders":{"type":"list","member":{"shape":"S4g"}}}}},"DescribeConformancePackCompliance":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"Filters":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S4v"},"ComplianceType":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConformancePackName","ConformancePackRuleComplianceList"],"members":{"ConformancePackName":{},"ConformancePackRuleComplianceList":{"type":"list","member":{"type":"structure","members":{"ConfigRuleName":{},"ComplianceType":{},"Controls":{"type":"list","member":{}}}}},"NextToken":{}}}},"DescribeConformancePackStatus":{"input":{"type":"structure","members":{"ConformancePackNames":{"shape":"S52"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackStatusDetails":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackId","ConformancePackArn","ConformancePackState","StackArn","LastUpdateRequestedTime"],"members":{"ConformancePackName":{},"ConformancePackId":{},"ConformancePackArn":{},"ConformancePackState":{},"StackArn":{},"ConformancePackStatusReason":{},"LastUpdateRequestedTime":{"type":"timestamp"},"LastUpdateCompletedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeConformancePacks":{"input":{"type":"structure","members":{"ConformancePackNames":{"shape":"S52"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackDetails":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackArn","ConformancePackId"],"members":{"ConformancePackName":{},"ConformancePackArn":{},"ConformancePackId":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S5i"},"LastUpdateRequestedTime":{"type":"timestamp"},"CreatedBy":{},"TemplateSSMDocumentDetails":{"shape":"S5m"}}}},"NextToken":{}}}},"DescribeDeliveryChannelStatus":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S5q"}}},"output":{"type":"structure","members":{"DeliveryChannelsStatus":{"type":"list","member":{"type":"structure","members":{"name":{},"configSnapshotDeliveryInfo":{"shape":"S5u"},"configHistoryDeliveryInfo":{"shape":"S5u"},"configStreamDeliveryInfo":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastStatusChangeTime":{"type":"timestamp"}}}}}}}}},"DescribeDeliveryChannels":{"input":{"type":"structure","members":{"DeliveryChannelNames":{"shape":"S5q"}}},"output":{"type":"structure","members":{"DeliveryChannels":{"type":"list","member":{"shape":"S60"}}}}},"DescribeOrganizationConfigRuleStatuses":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S63"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleStatuses":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationRuleStatus"],"members":{"OrganizationConfigRuleName":{},"OrganizationRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConfigRules":{"input":{"type":"structure","members":{"OrganizationConfigRuleNames":{"shape":"S63"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRules":{"type":"list","member":{"type":"structure","required":["OrganizationConfigRuleName","OrganizationConfigRuleArn"],"members":{"OrganizationConfigRuleName":{},"OrganizationConfigRuleArn":{},"OrganizationManagedRuleMetadata":{"shape":"S6d"},"OrganizationCustomRuleMetadata":{"shape":"S6i"},"ExcludedAccounts":{"shape":"S6l"},"LastUpdateTime":{"type":"timestamp"},"OrganizationCustomPolicyRuleMetadata":{"type":"structure","members":{"Description":{},"OrganizationConfigRuleTriggerTypes":{"shape":"S6n"},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S6g"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{},"PolicyRuntime":{},"DebugLogDeliveryAccounts":{"shape":"S6p"}}}}}},"NextToken":{}}}},"DescribeOrganizationConformancePackStatuses":{"input":{"type":"structure","members":{"OrganizationConformancePackNames":{"shape":"S6r"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePackStatuses":{"type":"list","member":{"type":"structure","required":["OrganizationConformancePackName","Status"],"members":{"OrganizationConformancePackName":{},"Status":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeOrganizationConformancePacks":{"input":{"type":"structure","members":{"OrganizationConformancePackNames":{"shape":"S6r"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePacks":{"type":"list","member":{"type":"structure","required":["OrganizationConformancePackName","OrganizationConformancePackArn","LastUpdateTime"],"members":{"OrganizationConformancePackName":{},"OrganizationConformancePackArn":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S5i"},"ExcludedAccounts":{"shape":"S6l"},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribePendingAggregationRequests":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PendingAggregationRequests":{"type":"list","member":{"type":"structure","members":{"RequesterAccountId":{},"RequesterAwsRegion":{}}}},"NextToken":{}}}},"DescribeRemediationConfigurations":{"input":{"type":"structure","required":["ConfigRuleNames"],"members":{"ConfigRuleNames":{"shape":"S2n"}}},"output":{"type":"structure","members":{"RemediationConfigurations":{"shape":"S77"}}}},"DescribeRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1h"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"RemediationExceptions":{"shape":"S7n"},"NextToken":{}}}},"DescribeRemediationExecutionStatus":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Ss"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"RemediationExecutionStatuses":{"type":"list","member":{"type":"structure","members":{"ResourceKey":{"shape":"St"},"State":{},"StepDetails":{"type":"list","member":{"type":"structure","members":{"Name":{},"State":{},"ErrorMessage":{},"StartTime":{"type":"timestamp"},"StopTime":{"type":"timestamp"}}}},"InvocationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeRetentionConfigurations":{"input":{"type":"structure","members":{"RetentionConfigurationNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"type":"structure","members":{"RetentionConfigurations":{"type":"list","member":{"shape":"S81"}},"NextToken":{}}}},"GetAggregateComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ConfigRuleName","AccountId","AwsRegion"],"members":{"ConfigurationAggregatorName":{},"ConfigRuleName":{},"AccountId":{},"AwsRegion":{},"ComplianceType":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateEvaluationResults":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S87"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"AccountId":{},"AwsRegion":{}}}},"NextToken":{}}}},"GetAggregateConfigRuleComplianceSummary":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"AccountId":{},"AwsRegion":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GroupByKey":{},"AggregateComplianceCounts":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"ComplianceSummary":{"shape":"S8g"}}}},"NextToken":{}}}},"GetAggregateConformancePackComplianceSummary":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"AccountId":{},"AwsRegion":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AggregateConformancePackComplianceSummaries":{"type":"list","member":{"type":"structure","members":{"ComplianceSummary":{"type":"structure","members":{"CompliantConformancePackCount":{"type":"integer"},"NonCompliantConformancePackCount":{"type":"integer"}}},"GroupName":{}}}},"GroupByKey":{},"NextToken":{}}}},"GetAggregateDiscoveredResourceCounts":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"Filters":{"type":"structure","members":{"ResourceType":{},"AccountId":{},"Region":{}}},"GroupByKey":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["TotalDiscoveredResources"],"members":{"TotalDiscoveredResources":{"type":"long"},"GroupByKey":{},"GroupedResourceCounts":{"type":"list","member":{"type":"structure","required":["GroupName","ResourceCount"],"members":{"GroupName":{},"ResourceCount":{"type":"long"}}}},"NextToken":{}}}},"GetAggregateResourceConfig":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceIdentifier"],"members":{"ConfigurationAggregatorName":{},"ResourceIdentifier":{"shape":"S4"}}},"output":{"type":"structure","members":{"ConfigurationItem":{"shape":"S8x"}}}},"GetComplianceDetailsByConfigRule":{"input":{"type":"structure","required":["ConfigRuleName"],"members":{"ConfigRuleName":{},"ComplianceTypes":{"shape":"S2o"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S99"},"NextToken":{}}}},"GetComplianceDetailsByResource":{"input":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"ComplianceTypes":{"shape":"S2o"},"NextToken":{},"ResourceEvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationResults":{"shape":"S99"},"NextToken":{}}}},"GetComplianceSummaryByConfigRule":{"output":{"type":"structure","members":{"ComplianceSummary":{"shape":"S8g"}}}},"GetComplianceSummaryByResourceType":{"input":{"type":"structure","members":{"ResourceTypes":{"shape":"S9f"}}},"output":{"type":"structure","members":{"ComplianceSummariesByResourceType":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ComplianceSummary":{"shape":"S8g"}}}}}}},"GetConformancePackComplianceDetails":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"Filters":{"type":"structure","members":{"ConfigRuleNames":{"shape":"S4v"},"ComplianceType":{},"ResourceType":{},"ResourceIds":{"type":"list","member":{}}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"ConformancePackRuleEvaluationResults":{"type":"list","member":{"type":"structure","required":["ComplianceType","EvaluationResultIdentifier","ConfigRuleInvokedTime","ResultRecordedTime"],"members":{"ComplianceType":{},"EvaluationResultIdentifier":{"shape":"S87"},"ConfigRuleInvokedTime":{"type":"timestamp"},"ResultRecordedTime":{"type":"timestamp"},"Annotation":{}}}},"NextToken":{}}}},"GetConformancePackComplianceSummary":{"input":{"type":"structure","required":["ConformancePackNames"],"members":{"ConformancePackNames":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConformancePackComplianceSummaryList":{"type":"list","member":{"type":"structure","required":["ConformancePackName","ConformancePackComplianceStatus"],"members":{"ConformancePackName":{},"ConformancePackComplianceStatus":{}}}},"NextToken":{}}}},"GetCustomRulePolicy":{"input":{"type":"structure","members":{"ConfigRuleName":{}}},"output":{"type":"structure","members":{"PolicyText":{}}}},"GetDiscoveredResourceCounts":{"input":{"type":"structure","members":{"resourceTypes":{"shape":"S9f"},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"totalDiscoveredResources":{"type":"long"},"resourceCounts":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"count":{"type":"long"}}}},"nextToken":{}}}},"GetOrganizationConfigRuleDetailedStatus":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"Filters":{"type":"structure","members":{"AccountId":{},"MemberAccountRuleStatus":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConfigRuleDetailedStatus":{"type":"list","member":{"type":"structure","required":["AccountId","ConfigRuleName","MemberAccountRuleStatus"],"members":{"AccountId":{},"ConfigRuleName":{},"MemberAccountRuleStatus":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetOrganizationConformancePackDetailedStatus":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{},"Filters":{"type":"structure","members":{"AccountId":{},"Status":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OrganizationConformancePackDetailedStatuses":{"type":"list","member":{"type":"structure","required":["AccountId","ConformancePackName","Status"],"members":{"AccountId":{},"ConformancePackName":{},"Status":{},"ErrorCode":{},"ErrorMessage":{},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetOrganizationCustomRulePolicy":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{}}},"output":{"type":"structure","members":{"PolicyText":{}}}},"GetResourceConfigHistory":{"input":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{},"laterTime":{"type":"timestamp"},"earlierTime":{"type":"timestamp"},"chronologicalOrder":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"configurationItems":{"type":"list","member":{"shape":"S8x"}},"nextToken":{}}}},"GetResourceEvaluationSummary":{"input":{"type":"structure","required":["ResourceEvaluationId"],"members":{"ResourceEvaluationId":{}}},"output":{"type":"structure","members":{"ResourceEvaluationId":{},"EvaluationMode":{},"EvaluationStatus":{"type":"structure","required":["Status"],"members":{"Status":{},"FailureReason":{}}},"EvaluationStartTimestamp":{"type":"timestamp"},"Compliance":{},"EvaluationContext":{"shape":"Saq"},"ResourceDetails":{"shape":"Sas"}}}},"GetStoredQuery":{"input":{"type":"structure","required":["QueryName"],"members":{"QueryName":{}}},"output":{"type":"structure","members":{"StoredQuery":{"shape":"Sax"}}}},"ListAggregateDiscoveredResources":{"input":{"type":"structure","required":["ConfigurationAggregatorName","ResourceType"],"members":{"ConfigurationAggregatorName":{},"ResourceType":{},"Filters":{"type":"structure","members":{"AccountId":{},"ResourceId":{},"ResourceName":{},"Region":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"type":"list","member":{"shape":"S4"}},"NextToken":{}}}},"ListConformancePackComplianceScores":{"input":{"type":"structure","members":{"Filters":{"type":"structure","required":["ConformancePackNames"],"members":{"ConformancePackNames":{"type":"list","member":{}}}},"SortOrder":{},"SortBy":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["ConformancePackComplianceScores"],"members":{"NextToken":{},"ConformancePackComplianceScores":{"type":"list","member":{"type":"structure","members":{"Score":{},"ConformancePackName":{},"LastUpdatedTime":{"type":"timestamp"}}}}}}},"ListDiscoveredResources":{"input":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"resourceIds":{"type":"list","member":{}},"resourceName":{},"limit":{"type":"integer"},"includeDeletedResources":{"type":"boolean"},"nextToken":{}}},"output":{"type":"structure","members":{"resourceIdentifiers":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"resourceDeletionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListResourceEvaluations":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"EvaluationMode":{},"TimeWindow":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"EvaluationContextIdentifier":{}}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceEvaluations":{"type":"list","member":{"type":"structure","members":{"ResourceEvaluationId":{},"EvaluationMode":{},"EvaluationStartTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStoredQueries":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"StoredQueryMetadata":{"type":"list","member":{"type":"structure","required":["QueryId","QueryArn","QueryName"],"members":{"QueryId":{},"QueryArn":{},"QueryName":{},"Description":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sc0"},"NextToken":{}}}},"PutAggregationAuthorization":{"input":{"type":"structure","required":["AuthorizedAccountId","AuthorizedAwsRegion"],"members":{"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"Tags":{"shape":"Sc5"}}},"output":{"type":"structure","members":{"AggregationAuthorization":{"shape":"S2k"}}}},"PutConfigRule":{"input":{"type":"structure","required":["ConfigRule"],"members":{"ConfigRule":{"shape":"S37"},"Tags":{"shape":"Sc5"}}}},"PutConfigurationAggregator":{"input":{"type":"structure","required":["ConfigurationAggregatorName"],"members":{"ConfigurationAggregatorName":{},"AccountAggregationSources":{"shape":"S42"},"OrganizationAggregationSource":{"shape":"S46"},"Tags":{"shape":"Sc5"}}},"output":{"type":"structure","members":{"ConfigurationAggregator":{"shape":"S40"}}}},"PutConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorder"],"members":{"ConfigurationRecorder":{"shape":"S4g"}}}},"PutConformancePack":{"input":{"type":"structure","required":["ConformancePackName"],"members":{"ConformancePackName":{},"TemplateS3Uri":{},"TemplateBody":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S5i"},"TemplateSSMDocumentDetails":{"shape":"S5m"}}},"output":{"type":"structure","members":{"ConformancePackArn":{}}}},"PutDeliveryChannel":{"input":{"type":"structure","required":["DeliveryChannel"],"members":{"DeliveryChannel":{"shape":"S60"}}}},"PutEvaluations":{"input":{"type":"structure","required":["ResultToken"],"members":{"Evaluations":{"shape":"Sch"},"ResultToken":{},"TestMode":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEvaluations":{"shape":"Sch"}}}},"PutExternalEvaluation":{"input":{"type":"structure","required":["ConfigRuleName","ExternalEvaluation"],"members":{"ConfigRuleName":{},"ExternalEvaluation":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{}}},"PutOrganizationConfigRule":{"input":{"type":"structure","required":["OrganizationConfigRuleName"],"members":{"OrganizationConfigRuleName":{},"OrganizationManagedRuleMetadata":{"shape":"S6d"},"OrganizationCustomRuleMetadata":{"shape":"S6i"},"ExcludedAccounts":{"shape":"S6l"},"OrganizationCustomPolicyRuleMetadata":{"type":"structure","required":["PolicyRuntime","PolicyText"],"members":{"Description":{},"OrganizationConfigRuleTriggerTypes":{"shape":"S6n"},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S6g"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{},"PolicyRuntime":{},"PolicyText":{},"DebugLogDeliveryAccounts":{"shape":"S6p"}}}}},"output":{"type":"structure","members":{"OrganizationConfigRuleArn":{}}}},"PutOrganizationConformancePack":{"input":{"type":"structure","required":["OrganizationConformancePackName"],"members":{"OrganizationConformancePackName":{},"TemplateS3Uri":{},"TemplateBody":{},"DeliveryS3Bucket":{},"DeliveryS3KeyPrefix":{},"ConformancePackInputParameters":{"shape":"S5i"},"ExcludedAccounts":{"shape":"S6l"}}},"output":{"type":"structure","members":{"OrganizationConformancePackArn":{}}}},"PutRemediationConfigurations":{"input":{"type":"structure","required":["RemediationConfigurations"],"members":{"RemediationConfigurations":{"shape":"S77"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S77"}}}}}}},"PutRemediationExceptions":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"S1h"},"Message":{},"ExpirationTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"FailedBatches":{"type":"list","member":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"S7n"}}}}}}},"PutResourceConfig":{"input":{"type":"structure","required":["ResourceType","SchemaVersionId","ResourceId","Configuration"],"members":{"ResourceType":{},"SchemaVersionId":{},"ResourceId":{},"ResourceName":{},"Configuration":{},"Tags":{"shape":"S8z"}}}},"PutRetentionConfiguration":{"input":{"type":"structure","required":["RetentionPeriodInDays"],"members":{"RetentionPeriodInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"RetentionConfiguration":{"shape":"S81"}}}},"PutStoredQuery":{"input":{"type":"structure","required":["StoredQuery"],"members":{"StoredQuery":{"shape":"Sax"},"Tags":{"shape":"Sc5"}}},"output":{"type":"structure","members":{"QueryArn":{}}}},"SelectAggregateResourceConfig":{"input":{"type":"structure","required":["Expression","ConfigurationAggregatorName"],"members":{"Expression":{},"ConfigurationAggregatorName":{},"Limit":{"type":"integer"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Results":{"shape":"Sda"},"QueryInfo":{"shape":"Sdb"},"NextToken":{}}}},"SelectResourceConfig":{"input":{"type":"structure","required":["Expression"],"members":{"Expression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Results":{"shape":"Sda"},"QueryInfo":{"shape":"Sdb"},"NextToken":{}}}},"StartConfigRulesEvaluation":{"input":{"type":"structure","members":{"ConfigRuleNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"StartRemediationExecution":{"input":{"type":"structure","required":["ConfigRuleName","ResourceKeys"],"members":{"ConfigRuleName":{},"ResourceKeys":{"shape":"Ss"}}},"output":{"type":"structure","members":{"FailureMessage":{},"FailedItems":{"shape":"Ss"}}}},"StartResourceEvaluation":{"input":{"type":"structure","required":["ResourceDetails","EvaluationMode"],"members":{"ResourceDetails":{"shape":"Sas"},"EvaluationContext":{"shape":"Saq"},"EvaluationMode":{},"EvaluationTimeout":{"type":"integer"},"ClientToken":{}}},"output":{"type":"structure","members":{"ResourceEvaluationId":{}}}},"StopConfigurationRecorder":{"input":{"type":"structure","required":["ConfigurationRecorderName"],"members":{"ConfigurationRecorderName":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sc0"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}}},"shapes":{"S4":{"type":"structure","required":["SourceAccountId","SourceRegion","ResourceId","ResourceType"],"members":{"SourceAccountId":{},"SourceRegion":{},"ResourceId":{},"ResourceType":{},"ResourceName":{}}},"Sb":{"type":"list","member":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"},"recordingFrequency":{},"configurationItemDeliveryTime":{"type":"timestamp"}}}},"Sl":{"type":"map","key":{},"value":{}},"Ss":{"type":"list","member":{"shape":"St"}},"St":{"type":"structure","required":["resourceType","resourceId"],"members":{"resourceType":{},"resourceId":{}}},"S1h":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"ResourceId":{}}}},"S25":{"type":"structure","members":{"ComplianceType":{},"ComplianceContributorCount":{"shape":"S26"}}},"S26":{"type":"structure","members":{"CappedCount":{"type":"integer"},"CapExceeded":{"type":"boolean"}}},"S2k":{"type":"structure","members":{"AggregationAuthorizationArn":{},"AuthorizedAccountId":{},"AuthorizedAwsRegion":{},"CreationTime":{"type":"timestamp"}}},"S2n":{"type":"list","member":{}},"S2o":{"type":"list","member":{}},"S37":{"type":"structure","required":["Source"],"members":{"ConfigRuleName":{},"ConfigRuleArn":{},"ConfigRuleId":{},"Description":{},"Scope":{"type":"structure","members":{"ComplianceResourceTypes":{"type":"list","member":{}},"TagKey":{},"TagValue":{},"ComplianceResourceId":{}}},"Source":{"type":"structure","required":["Owner"],"members":{"Owner":{},"SourceIdentifier":{},"SourceDetails":{"type":"list","member":{"type":"structure","members":{"EventSource":{},"MessageType":{},"MaximumExecutionFrequency":{}}}},"CustomPolicyDetails":{"type":"structure","required":["PolicyRuntime","PolicyText"],"members":{"PolicyRuntime":{},"PolicyText":{},"EnableDebugLogDelivery":{"type":"boolean"}}}}},"InputParameters":{},"MaximumExecutionFrequency":{},"ConfigRuleState":{},"CreatedBy":{},"EvaluationModes":{"type":"list","member":{"type":"structure","members":{"Mode":{}}}}}},"S40":{"type":"structure","members":{"ConfigurationAggregatorName":{},"ConfigurationAggregatorArn":{},"AccountAggregationSources":{"shape":"S42"},"OrganizationAggregationSource":{"shape":"S46"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"CreatedBy":{}}},"S42":{"type":"list","member":{"type":"structure","required":["AccountIds"],"members":{"AccountIds":{"type":"list","member":{}},"AllAwsRegions":{"type":"boolean"},"AwsRegions":{"shape":"S45"}}}},"S45":{"type":"list","member":{}},"S46":{"type":"structure","required":["RoleArn"],"members":{"RoleArn":{},"AwsRegions":{"shape":"S45"},"AllAwsRegions":{"type":"boolean"}}},"S48":{"type":"list","member":{}},"S4g":{"type":"structure","members":{"name":{},"roleARN":{},"recordingGroup":{"type":"structure","members":{"allSupported":{"type":"boolean"},"includeGlobalResourceTypes":{"type":"boolean"},"resourceTypes":{"shape":"S4k"},"exclusionByResourceTypes":{"type":"structure","members":{"resourceTypes":{"shape":"S4k"}}},"recordingStrategy":{"type":"structure","members":{"useOnly":{}}}}},"recordingMode":{"type":"structure","required":["recordingFrequency"],"members":{"recordingFrequency":{},"recordingModeOverrides":{"type":"list","member":{"type":"structure","required":["resourceTypes","recordingFrequency"],"members":{"description":{},"resourceTypes":{"type":"list","member":{}},"recordingFrequency":{}}}}}}}},"S4k":{"type":"list","member":{}},"S4v":{"type":"list","member":{}},"S52":{"type":"list","member":{}},"S5i":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}},"S5m":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{}}},"S5q":{"type":"list","member":{}},"S5u":{"type":"structure","members":{"lastStatus":{},"lastErrorCode":{},"lastErrorMessage":{},"lastAttemptTime":{"type":"timestamp"},"lastSuccessfulTime":{"type":"timestamp"},"nextDeliveryTime":{"type":"timestamp"}}},"S60":{"type":"structure","members":{"name":{},"s3BucketName":{},"s3KeyPrefix":{},"s3KmsKeyArn":{},"snsTopicARN":{},"configSnapshotDeliveryProperties":{"type":"structure","members":{"deliveryFrequency":{}}}}},"S63":{"type":"list","member":{}},"S6d":{"type":"structure","required":["RuleIdentifier"],"members":{"Description":{},"RuleIdentifier":{},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S6g"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S6g":{"type":"list","member":{}},"S6i":{"type":"structure","required":["LambdaFunctionArn","OrganizationConfigRuleTriggerTypes"],"members":{"Description":{},"LambdaFunctionArn":{},"OrganizationConfigRuleTriggerTypes":{"type":"list","member":{}},"InputParameters":{},"MaximumExecutionFrequency":{},"ResourceTypesScope":{"shape":"S6g"},"ResourceIdScope":{},"TagKeyScope":{},"TagValueScope":{}}},"S6l":{"type":"list","member":{}},"S6n":{"type":"list","member":{}},"S6p":{"type":"list","member":{}},"S6r":{"type":"list","member":{}},"S77":{"type":"list","member":{"type":"structure","required":["ConfigRuleName","TargetType","TargetId"],"members":{"ConfigRuleName":{},"TargetType":{},"TargetId":{},"TargetVersion":{},"Parameters":{"type":"map","key":{},"value":{"type":"structure","members":{"ResourceValue":{"type":"structure","required":["Value"],"members":{"Value":{}}},"StaticValue":{"type":"structure","required":["Values"],"members":{"Values":{"type":"list","member":{}}}}}}},"ResourceType":{},"Automatic":{"type":"boolean"},"ExecutionControls":{"type":"structure","members":{"SsmControls":{"type":"structure","members":{"ConcurrentExecutionRatePercentage":{"type":"integer"},"ErrorPercentage":{"type":"integer"}}}}},"MaximumAutomaticAttempts":{"type":"integer"},"RetryAttemptSeconds":{"type":"long"},"Arn":{},"CreatedByService":{}}}},"S7n":{"type":"list","member":{"type":"structure","required":["ConfigRuleName","ResourceType","ResourceId"],"members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{},"Message":{},"ExpirationTime":{"type":"timestamp"}}}},"S81":{"type":"structure","required":["Name","RetentionPeriodInDays"],"members":{"Name":{},"RetentionPeriodInDays":{"type":"integer"}}},"S87":{"type":"structure","members":{"EvaluationResultQualifier":{"type":"structure","members":{"ConfigRuleName":{},"ResourceType":{},"ResourceId":{},"EvaluationMode":{}}},"OrderingTimestamp":{"type":"timestamp"},"ResourceEvaluationId":{}}},"S8g":{"type":"structure","members":{"CompliantResourceCount":{"shape":"S26"},"NonCompliantResourceCount":{"shape":"S26"},"ComplianceSummaryTimestamp":{"type":"timestamp"}}},"S8x":{"type":"structure","members":{"version":{},"accountId":{},"configurationItemCaptureTime":{"type":"timestamp"},"configurationItemStatus":{},"configurationStateId":{},"configurationItemMD5Hash":{},"arn":{},"resourceType":{},"resourceId":{},"resourceName":{},"awsRegion":{},"availabilityZone":{},"resourceCreationTime":{"type":"timestamp"},"tags":{"shape":"S8z"},"relatedEvents":{"type":"list","member":{}},"relationships":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceId":{},"resourceName":{},"relationshipName":{}}}},"configuration":{},"supplementaryConfiguration":{"shape":"Sl"},"recordingFrequency":{},"configurationItemDeliveryTime":{"type":"timestamp"}}},"S8z":{"type":"map","key":{},"value":{}},"S99":{"type":"list","member":{"type":"structure","members":{"EvaluationResultIdentifier":{"shape":"S87"},"ComplianceType":{},"ResultRecordedTime":{"type":"timestamp"},"ConfigRuleInvokedTime":{"type":"timestamp"},"Annotation":{},"ResultToken":{}}}},"S9f":{"type":"list","member":{}},"Saq":{"type":"structure","members":{"EvaluationContextIdentifier":{}}},"Sas":{"type":"structure","required":["ResourceId","ResourceType","ResourceConfiguration"],"members":{"ResourceId":{},"ResourceType":{},"ResourceConfiguration":{},"ResourceConfigurationSchemaType":{}}},"Sax":{"type":"structure","required":["QueryName"],"members":{"QueryId":{},"QueryArn":{},"QueryName":{},"Description":{},"Expression":{}}},"Sc0":{"type":"list","member":{"shape":"Sc1"}},"Sc1":{"type":"structure","members":{"Key":{},"Value":{}}},"Sc5":{"type":"list","member":{"shape":"Sc1"}},"Sch":{"type":"list","member":{"type":"structure","required":["ComplianceResourceType","ComplianceResourceId","ComplianceType","OrderingTimestamp"],"members":{"ComplianceResourceType":{},"ComplianceResourceId":{},"ComplianceType":{},"Annotation":{},"OrderingTimestamp":{"type":"timestamp"}}}},"Sda":{"type":"list","member":{}},"Sdb":{"type":"structure","members":{"SelectFields":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}}}

/***/ }),
/* 460 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAggregateComplianceByConfigRules":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeAggregateComplianceByConformancePacks":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregateComplianceByConformancePacks"},"DescribeAggregationAuthorizations":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregationAuthorizations"},"DescribeComplianceByConfigRule":{"input_token":"NextToken","output_token":"NextToken","result_key":"ComplianceByConfigRules"},"DescribeComplianceByResource":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ComplianceByResources"},"DescribeConfigRuleEvaluationStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConfigRulesEvaluationStatus"},"DescribeConfigRules":{"input_token":"NextToken","output_token":"NextToken","result_key":"ConfigRules"},"DescribeConfigurationAggregatorSourcesStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregatedSourceStatusList"},"DescribeConfigurationAggregators":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConfigurationAggregators"},"DescribeConformancePackCompliance":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeConformancePackStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConformancePackStatusDetails"},"DescribeConformancePacks":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConformancePackDetails"},"DescribeOrganizationConfigRuleStatuses":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConfigRuleStatuses"},"DescribeOrganizationConfigRules":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConfigRules"},"DescribeOrganizationConformancePackStatuses":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConformancePackStatuses"},"DescribeOrganizationConformancePacks":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConformancePacks"},"DescribePendingAggregationRequests":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"PendingAggregationRequests"},"DescribeRemediationExceptions":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"DescribeRemediationExecutionStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"RemediationExecutionStatuses"},"DescribeRetentionConfigurations":{"input_token":"NextToken","output_token":"NextToken","result_key":"RetentionConfigurations"},"GetAggregateComplianceDetailsByConfigRule":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"AggregateEvaluationResults"},"GetAggregateConfigRuleComplianceSummary":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetAggregateConformancePackComplianceSummary":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetAggregateDiscoveredResourceCounts":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetComplianceDetailsByConfigRule":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"EvaluationResults"},"GetComplianceDetailsByResource":{"input_token":"NextToken","output_token":"NextToken","result_key":"EvaluationResults"},"GetConformancePackComplianceDetails":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"GetConformancePackComplianceSummary":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ConformancePackComplianceSummaryList"},"GetDiscoveredResourceCounts":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken"},"GetOrganizationConfigRuleDetailedStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConfigRuleDetailedStatus"},"GetOrganizationConformancePackDetailedStatus":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"OrganizationConformancePackDetailedStatuses"},"GetResourceConfigHistory":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"configurationItems"},"ListAggregateDiscoveredResources":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ResourceIdentifiers"},"ListConformancePackComplianceScores":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken"},"ListDiscoveredResources":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"resourceIdentifiers"},"ListResourceEvaluations":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"ResourceEvaluations"},"ListStoredQueries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTagsForResource":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Tags"},"SelectAggregateResourceConfig":{"input_token":"NextToken","limit_key":"Limit","non_aggregate_keys":["QueryInfo"],"output_token":"NextToken","result_key":"Results"},"SelectResourceConfig":{"input_token":"NextToken","limit_key":"Limit","non_aggregate_keys":["QueryInfo"],"output_token":"NextToken","result_key":"Results"}}}

/***/ }),
/* 461 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-08-08","endpointPrefix":"connect","jsonVersion":"1.1","protocol":"rest-json","protocols":["rest-json"],"serviceAbbreviation":"Amazon Connect","serviceFullName":"Amazon Connect Service","serviceId":"Connect","signatureVersion":"v4","signingName":"connect","uid":"connect-2017-08-08"},"operations":{"ActivateEvaluationForm":{"http":{"requestUri":"/evaluation-forms/{InstanceId}/{EvaluationFormId}/activate"},"input":{"type":"structure","required":["InstanceId","EvaluationFormId","EvaluationFormVersion"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationFormId":{"location":"uri","locationName":"EvaluationFormId"},"EvaluationFormVersion":{"type":"integer"}}},"output":{"type":"structure","required":["EvaluationFormId","EvaluationFormArn","EvaluationFormVersion"],"members":{"EvaluationFormId":{},"EvaluationFormArn":{},"EvaluationFormVersion":{"type":"integer"}}}},"AssociateAnalyticsDataSet":{"http":{"method":"PUT","requestUri":"/analytics-data/instance/{InstanceId}/association"},"input":{"type":"structure","required":["InstanceId","DataSetId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"DataSetId":{},"TargetAccountId":{}}},"output":{"type":"structure","members":{"DataSetId":{},"TargetAccountId":{},"ResourceShareId":{},"ResourceShareArn":{}}}},"AssociateApprovedOrigin":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/approved-origin"},"input":{"type":"structure","required":["InstanceId","Origin"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Origin":{}}}},"AssociateBot":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/bot"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LexBot":{"shape":"Sf"},"LexV2Bot":{"shape":"Si"}}}},"AssociateDefaultVocabulary":{"http":{"method":"PUT","requestUri":"/default-vocabulary/{InstanceId}/{LanguageCode}"},"input":{"type":"structure","required":["InstanceId","LanguageCode"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LanguageCode":{"location":"uri","locationName":"LanguageCode"},"VocabularyId":{}}},"output":{"type":"structure","members":{}}},"AssociateFlow":{"http":{"method":"PUT","requestUri":"/flow-associations/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","ResourceId","FlowId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceId":{},"FlowId":{},"ResourceType":{}}},"output":{"type":"structure","members":{}}},"AssociateInstanceStorageConfig":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/storage-config"},"input":{"type":"structure","required":["InstanceId","ResourceType","StorageConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceType":{},"StorageConfig":{"shape":"St"}}},"output":{"type":"structure","members":{"AssociationId":{}}}},"AssociateLambdaFunction":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/lambda-function"},"input":{"type":"structure","required":["InstanceId","FunctionArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"FunctionArn":{}}}},"AssociateLexBot":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/lex-bot"},"input":{"type":"structure","required":["InstanceId","LexBot"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LexBot":{"shape":"Sf"}}}},"AssociatePhoneNumberContactFlow":{"http":{"method":"PUT","requestUri":"/phone-number/{PhoneNumberId}/contact-flow"},"input":{"type":"structure","required":["PhoneNumberId","InstanceId","ContactFlowId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"InstanceId":{},"ContactFlowId":{}}}},"AssociateQueueQuickConnects":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/associate-quick-connects"},"input":{"type":"structure","required":["InstanceId","QueueId","QuickConnectIds"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"QuickConnectIds":{"shape":"S1f"}}}},"AssociateRoutingProfileQueues":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/associate-queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","QueueConfigs"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"QueueConfigs":{"shape":"S1j"}}}},"AssociateSecurityKey":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/security-key"},"input":{"type":"structure","required":["InstanceId","Key"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Key":{}}},"output":{"type":"structure","members":{"AssociationId":{}}}},"AssociateTrafficDistributionGroupUser":{"http":{"method":"PUT","requestUri":"/traffic-distribution-group/{TrafficDistributionGroupId}/user"},"input":{"type":"structure","required":["TrafficDistributionGroupId","UserId","InstanceId"],"members":{"TrafficDistributionGroupId":{"location":"uri","locationName":"TrafficDistributionGroupId"},"UserId":{},"InstanceId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateUserProficiencies":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/associate-proficiencies"},"input":{"type":"structure","required":["InstanceId","UserId","UserProficiencies"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"},"UserProficiencies":{"shape":"S1x"}}}},"BatchAssociateAnalyticsDataSet":{"http":{"method":"PUT","requestUri":"/analytics-data/instance/{InstanceId}/associations"},"input":{"type":"structure","required":["InstanceId","DataSetIds"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"DataSetIds":{"shape":"S23"},"TargetAccountId":{}}},"output":{"type":"structure","members":{"Created":{"shape":"S25"},"Errors":{"shape":"S27"}}}},"BatchDisassociateAnalyticsDataSet":{"http":{"requestUri":"/analytics-data/instance/{InstanceId}/associations"},"input":{"type":"structure","required":["InstanceId","DataSetIds"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"DataSetIds":{"shape":"S23"},"TargetAccountId":{}}},"output":{"type":"structure","members":{"Deleted":{"shape":"S23"},"Errors":{"shape":"S27"}}}},"BatchGetAttachedFileMetadata":{"http":{"requestUri":"/attached-files/{InstanceId}"},"input":{"type":"structure","required":["FileIds","InstanceId","AssociatedResourceArn"],"members":{"FileIds":{"type":"list","member":{}},"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociatedResourceArn":{"location":"querystring","locationName":"associatedResourceArn"}}},"output":{"type":"structure","members":{"Files":{"type":"list","member":{"type":"structure","required":["CreationTime","FileArn","FileId","FileName","FileSizeInBytes","FileStatus"],"members":{"CreationTime":{},"FileArn":{},"FileId":{},"FileName":{},"FileSizeInBytes":{"type":"long"},"FileStatus":{},"CreatedBy":{"shape":"S2l"},"FileUseCaseType":{},"AssociatedResourceArn":{},"Tags":{"shape":"S2n"}}}},"Errors":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{},"FileId":{}}}}}}},"BatchGetFlowAssociation":{"http":{"requestUri":"/flow-associations-batch/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","ResourceIds"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceIds":{"type":"list","member":{}},"ResourceType":{}}},"output":{"type":"structure","members":{"FlowAssociationSummaryList":{"shape":"S2y"}}}},"BatchPutContact":{"http":{"method":"PUT","requestUri":"/contact/batch/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","ContactDataRequestList"],"members":{"ClientToken":{"idempotencyToken":true},"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactDataRequestList":{"type":"list","member":{"type":"structure","members":{"SystemEndpoint":{"shape":"S34"},"CustomerEndpoint":{"shape":"S34"},"RequestIdentifier":{},"QueueId":{},"Attributes":{"shape":"S38"},"Campaign":{"type":"structure","members":{"CampaignId":{}}}}}}}},"output":{"type":"structure","members":{"SuccessfulRequestList":{"type":"list","member":{"type":"structure","members":{"RequestIdentifier":{},"ContactId":{}}}},"FailedRequestList":{"type":"list","member":{"type":"structure","members":{"RequestIdentifier":{},"FailureReasonCode":{},"FailureReasonMessage":{}}}}}},"idempotent":true},"ClaimPhoneNumber":{"http":{"requestUri":"/phone-number/claim"},"input":{"type":"structure","required":["PhoneNumber"],"members":{"TargetArn":{},"InstanceId":{},"PhoneNumber":{},"PhoneNumberDescription":{},"Tags":{"shape":"S2n"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{}}}},"CompleteAttachedFileUpload":{"http":{"requestUri":"/attached-files/{InstanceId}/{FileId}"},"input":{"type":"structure","required":["InstanceId","FileId","AssociatedResourceArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"FileId":{"location":"uri","locationName":"FileId"},"AssociatedResourceArn":{"location":"querystring","locationName":"associatedResourceArn"}}},"output":{"type":"structure","members":{}}},"CreateAgentStatus":{"http":{"method":"PUT","requestUri":"/agent-status/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","State"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"State":{},"DisplayOrder":{"type":"integer"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"AgentStatusARN":{},"AgentStatusId":{}}}},"CreateContactFlow":{"http":{"method":"PUT","requestUri":"/contact-flows/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","Type","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Type":{},"Description":{},"Content":{},"Status":{},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"ContactFlowId":{},"ContactFlowArn":{}}}},"CreateContactFlowModule":{"http":{"method":"PUT","requestUri":"/contact-flow-modules/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"Content":{},"Tags":{"shape":"S2n"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Id":{},"Arn":{}}}},"CreateEvaluationForm":{"http":{"method":"PUT","requestUri":"/evaluation-forms/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Title","Items"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Title":{},"Description":{},"Items":{"shape":"S4d"},"ScoringStrategy":{"shape":"S58"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["EvaluationFormId","EvaluationFormArn"],"members":{"EvaluationFormId":{},"EvaluationFormArn":{}}},"idempotent":true},"CreateHoursOfOperation":{"http":{"method":"PUT","requestUri":"/hours-of-operations/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","TimeZone","Config"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"TimeZone":{},"Config":{"shape":"S5g"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"HoursOfOperationId":{},"HoursOfOperationArn":{}}}},"CreateInstance":{"http":{"method":"PUT","requestUri":"/instance"},"input":{"type":"structure","required":["IdentityManagementType","InboundCallsEnabled","OutboundCallsEnabled"],"members":{"ClientToken":{},"IdentityManagementType":{},"InstanceAlias":{"shape":"S5q"},"DirectoryId":{},"InboundCallsEnabled":{"type":"boolean"},"OutboundCallsEnabled":{"type":"boolean"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"Id":{},"Arn":{}}}},"CreateIntegrationAssociation":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/integration-associations"},"input":{"type":"structure","required":["InstanceId","IntegrationType","IntegrationArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationType":{},"IntegrationArn":{},"SourceApplicationUrl":{},"SourceApplicationName":{},"SourceType":{},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"IntegrationAssociationId":{},"IntegrationAssociationArn":{}}}},"CreateParticipant":{"http":{"requestUri":"/contact/create-participant"},"input":{"type":"structure","required":["InstanceId","ContactId","ParticipantDetails"],"members":{"InstanceId":{},"ContactId":{},"ClientToken":{"idempotencyToken":true},"ParticipantDetails":{"type":"structure","members":{"ParticipantRole":{},"DisplayName":{}}}}},"output":{"type":"structure","members":{"ParticipantCredentials":{"type":"structure","members":{"ParticipantToken":{},"Expiry":{}}},"ParticipantId":{}}}},"CreatePersistentContactAssociation":{"http":{"requestUri":"/contact/persistent-contact-association/{InstanceId}/{InitialContactId}"},"input":{"type":"structure","required":["InstanceId","InitialContactId","RehydrationType","SourceContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"InitialContactId":{"location":"uri","locationName":"InitialContactId"},"RehydrationType":{},"SourceContactId":{},"ClientToken":{}}},"output":{"type":"structure","members":{"ContinuedFromContactId":{}}}},"CreatePredefinedAttribute":{"http":{"method":"PUT","requestUri":"/predefined-attributes/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","Values"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Values":{"shape":"S6e"}}}},"CreatePrompt":{"http":{"method":"PUT","requestUri":"/prompts/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","S3Uri"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"S3Uri":{},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"PromptARN":{},"PromptId":{}}}},"CreateQueue":{"http":{"method":"PUT","requestUri":"/queues/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"OutboundCallerConfig":{"shape":"S6n"},"HoursOfOperationId":{},"MaxContacts":{"type":"integer"},"QuickConnectIds":{"shape":"S1f"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"QueueArn":{},"QueueId":{}}}},"CreateQuickConnect":{"http":{"method":"PUT","requestUri":"/quick-connects/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","QuickConnectConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"QuickConnectConfig":{"shape":"S6u"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"QuickConnectARN":{},"QuickConnectId":{}}}},"CreateRoutingProfile":{"http":{"method":"PUT","requestUri":"/routing-profiles/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","Description","DefaultOutboundQueueId","MediaConcurrencies"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"DefaultOutboundQueueId":{},"QueueConfigs":{"shape":"S1j"},"MediaConcurrencies":{"shape":"S73"},"Tags":{"shape":"S2n"},"AgentAvailabilityTimer":{}}},"output":{"type":"structure","members":{"RoutingProfileArn":{},"RoutingProfileId":{}}}},"CreateRule":{"http":{"requestUri":"/rules/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Name","TriggerEventSource","Function","Actions","PublishStatus"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"TriggerEventSource":{"shape":"S7c"},"Function":{},"Actions":{"shape":"S7f"},"PublishStatus":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["RuleArn","RuleId"],"members":{"RuleArn":{},"RuleId":{}}}},"CreateSecurityProfile":{"http":{"method":"PUT","requestUri":"/security-profiles/{InstanceId}"},"input":{"type":"structure","required":["SecurityProfileName","InstanceId"],"members":{"SecurityProfileName":{},"Description":{},"Permissions":{"shape":"S8k"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Tags":{"shape":"S2n"},"AllowedAccessControlTags":{"shape":"S8m"},"TagRestrictedResources":{"shape":"S8p"},"Applications":{"shape":"S8r"},"HierarchyRestrictedResources":{"shape":"S8w"},"AllowedAccessControlHierarchyGroupId":{}}},"output":{"type":"structure","members":{"SecurityProfileId":{},"SecurityProfileArn":{}}}},"CreateTaskTemplate":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/task/template"},"input":{"type":"structure","required":["InstanceId","Name","Fields"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"ContactFlowId":{},"Constraints":{"shape":"S94"},"Defaults":{"shape":"S9d"},"Status":{},"Fields":{"shape":"S9i"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{}}}},"CreateTrafficDistributionGroup":{"http":{"method":"PUT","requestUri":"/traffic-distribution-group"},"input":{"type":"structure","required":["Name","InstanceId"],"members":{"Name":{},"Description":{},"InstanceId":{},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"Id":{},"Arn":{}}}},"CreateUseCase":{"http":{"method":"PUT","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId","UseCaseType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"},"UseCaseType":{},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"UseCaseId":{},"UseCaseArn":{}}}},"CreateUser":{"http":{"method":"PUT","requestUri":"/users/{InstanceId}"},"input":{"type":"structure","required":["Username","PhoneConfig","SecurityProfileIds","RoutingProfileId","InstanceId"],"members":{"Username":{},"Password":{"type":"string","sensitive":true},"IdentityInfo":{"shape":"Sa5"},"PhoneConfig":{"shape":"Sa9"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"Sae"},"RoutingProfileId":{},"HierarchyGroupId":{},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"UserId":{},"UserArn":{}}}},"CreateUserHierarchyGroup":{"http":{"method":"PUT","requestUri":"/user-hierarchy-groups/{InstanceId}"},"input":{"type":"structure","required":["Name","InstanceId"],"members":{"Name":{},"ParentGroupId":{},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"HierarchyGroupId":{},"HierarchyGroupArn":{}}}},"CreateView":{"http":{"method":"PUT","requestUri":"/views/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Status","Content","Name"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ClientToken":{},"Status":{},"Content":{"shape":"San"},"Description":{},"Name":{"shape":"Sas"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"View":{"shape":"Sau"}}},"idempotent":true},"CreateViewVersion":{"http":{"method":"PUT","requestUri":"/views/{InstanceId}/{ViewId}/versions"},"input":{"type":"structure","required":["InstanceId","ViewId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ViewId":{"location":"uri","locationName":"ViewId"},"VersionDescription":{},"ViewContentSha256":{}}},"output":{"type":"structure","members":{"View":{"shape":"Sau"}}},"idempotent":true},"CreateVocabulary":{"http":{"requestUri":"/vocabulary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","VocabularyName","LanguageCode","Content"],"members":{"ClientToken":{"idempotencyToken":true},"InstanceId":{"location":"uri","locationName":"InstanceId"},"VocabularyName":{},"LanguageCode":{},"Content":{},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","required":["VocabularyArn","VocabularyId","State"],"members":{"VocabularyArn":{},"VocabularyId":{},"State":{}}}},"DeactivateEvaluationForm":{"http":{"requestUri":"/evaluation-forms/{InstanceId}/{EvaluationFormId}/deactivate"},"input":{"type":"structure","required":["InstanceId","EvaluationFormId","EvaluationFormVersion"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationFormId":{"location":"uri","locationName":"EvaluationFormId"},"EvaluationFormVersion":{"type":"integer"}}},"output":{"type":"structure","required":["EvaluationFormId","EvaluationFormArn","EvaluationFormVersion"],"members":{"EvaluationFormId":{},"EvaluationFormArn":{},"EvaluationFormVersion":{"type":"integer"}}}},"DeleteAttachedFile":{"http":{"method":"DELETE","requestUri":"/attached-files/{InstanceId}/{FileId}"},"input":{"type":"structure","required":["InstanceId","FileId","AssociatedResourceArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"FileId":{"location":"uri","locationName":"FileId"},"AssociatedResourceArn":{"location":"querystring","locationName":"associatedResourceArn"}}},"output":{"type":"structure","members":{}}},"DeleteContactEvaluation":{"http":{"method":"DELETE","requestUri":"/contact-evaluations/{InstanceId}/{EvaluationId}"},"input":{"type":"structure","required":["InstanceId","EvaluationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationId":{"location":"uri","locationName":"EvaluationId"}}},"idempotent":true},"DeleteContactFlow":{"http":{"method":"DELETE","requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"}}},"output":{"type":"structure","members":{}}},"DeleteContactFlowModule":{"http":{"method":"DELETE","requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"}}},"output":{"type":"structure","members":{}}},"DeleteEvaluationForm":{"http":{"method":"DELETE","requestUri":"/evaluation-forms/{InstanceId}/{EvaluationFormId}"},"input":{"type":"structure","required":["InstanceId","EvaluationFormId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationFormId":{"location":"uri","locationName":"EvaluationFormId"},"EvaluationFormVersion":{"location":"querystring","locationName":"version","type":"integer"}}},"idempotent":true},"DeleteHoursOfOperation":{"http":{"method":"DELETE","requestUri":"/hours-of-operations/{InstanceId}/{HoursOfOperationId}"},"input":{"type":"structure","required":["InstanceId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"HoursOfOperationId":{"location":"uri","locationName":"HoursOfOperationId"}}}},"DeleteInstance":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"DeleteIntegrationAssociation":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"}}}},"DeletePredefinedAttribute":{"http":{"method":"DELETE","requestUri":"/predefined-attributes/{InstanceId}/{Name}"},"input":{"type":"structure","required":["InstanceId","Name"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{"location":"uri","locationName":"Name"}}},"idempotent":true},"DeletePrompt":{"http":{"method":"DELETE","requestUri":"/prompts/{InstanceId}/{PromptId}"},"input":{"type":"structure","required":["InstanceId","PromptId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PromptId":{"location":"uri","locationName":"PromptId"}}}},"DeleteQueue":{"http":{"method":"DELETE","requestUri":"/queues/{InstanceId}/{QueueId}"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"}}}},"DeleteQuickConnect":{"http":{"method":"DELETE","requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}"},"input":{"type":"structure","required":["InstanceId","QuickConnectId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"}}}},"DeleteRoutingProfile":{"http":{"method":"DELETE","requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"}}}},"DeleteRule":{"http":{"method":"DELETE","requestUri":"/rules/{InstanceId}/{RuleId}"},"input":{"type":"structure","required":["InstanceId","RuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RuleId":{"location":"uri","locationName":"RuleId"}}}},"DeleteSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["InstanceId","SecurityProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"}}}},"DeleteTaskTemplate":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/task/template/{TaskTemplateId}"},"input":{"type":"structure","required":["InstanceId","TaskTemplateId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"TaskTemplateId":{"location":"uri","locationName":"TaskTemplateId"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficDistributionGroup":{"http":{"method":"DELETE","requestUri":"/traffic-distribution-group/{TrafficDistributionGroupId}"},"input":{"type":"structure","required":["TrafficDistributionGroupId"],"members":{"TrafficDistributionGroupId":{"location":"uri","locationName":"TrafficDistributionGroupId"}}},"output":{"type":"structure","members":{}}},"DeleteUseCase":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases/{UseCaseId}"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId","UseCaseId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"},"UseCaseId":{"location":"uri","locationName":"UseCaseId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["InstanceId","UserId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DeleteUserHierarchyGroup":{"http":{"method":"DELETE","requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"},"input":{"type":"structure","required":["HierarchyGroupId","InstanceId"],"members":{"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"DeleteView":{"http":{"method":"DELETE","requestUri":"/views/{InstanceId}/{ViewId}"},"input":{"type":"structure","required":["InstanceId","ViewId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ViewId":{"location":"uri","locationName":"ViewId"}}},"output":{"type":"structure","members":{}}},"DeleteViewVersion":{"http":{"method":"DELETE","requestUri":"/views/{InstanceId}/{ViewId}/versions/{ViewVersion}"},"input":{"type":"structure","required":["InstanceId","ViewId","ViewVersion"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ViewId":{"location":"uri","locationName":"ViewId"},"ViewVersion":{"location":"uri","locationName":"ViewVersion","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteVocabulary":{"http":{"requestUri":"/vocabulary-remove/{InstanceId}/{VocabularyId}"},"input":{"type":"structure","required":["InstanceId","VocabularyId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"VocabularyId":{"location":"uri","locationName":"VocabularyId"}}},"output":{"type":"structure","required":["VocabularyArn","VocabularyId","State"],"members":{"VocabularyArn":{},"VocabularyId":{},"State":{}}}},"DescribeAgentStatus":{"http":{"method":"GET","requestUri":"/agent-status/{InstanceId}/{AgentStatusId}"},"input":{"type":"structure","required":["InstanceId","AgentStatusId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AgentStatusId":{"location":"uri","locationName":"AgentStatusId"}}},"output":{"type":"structure","members":{"AgentStatus":{"type":"structure","members":{"AgentStatusARN":{},"AgentStatusId":{},"Name":{},"Description":{},"Type":{},"DisplayOrder":{"type":"integer"},"State":{},"Tags":{"shape":"S2n"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}}}},"DescribeContact":{"http":{"method":"GET","requestUri":"/contacts/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"}}},"output":{"type":"structure","members":{"Contact":{"type":"structure","members":{"Arn":{},"Id":{},"InitialContactId":{},"PreviousContactId":{},"InitiationMethod":{},"Name":{"shape":"Scf"},"Description":{"shape":"Scg"},"Channel":{},"QueueInfo":{"type":"structure","members":{"Id":{},"EnqueueTimestamp":{"type":"timestamp"}}},"AgentInfo":{"type":"structure","members":{"Id":{},"ConnectedToAgentTimestamp":{"type":"timestamp"},"AgentPauseDurationInSeconds":{"type":"integer"}}},"InitiationTimestamp":{"type":"timestamp"},"DisconnectTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"LastPausedTimestamp":{"type":"timestamp"},"LastResumedTimestamp":{"type":"timestamp"},"TotalPauseCount":{"type":"integer"},"TotalPauseDurationInSeconds":{"type":"integer"},"ScheduledTimestamp":{"type":"timestamp"},"RelatedContactId":{},"WisdomInfo":{"type":"structure","members":{"SessionArn":{}}},"QueueTimeAdjustmentSeconds":{"type":"integer"},"QueuePriority":{"type":"long"},"Tags":{"shape":"Scr"}}}}}},"DescribeContactEvaluation":{"http":{"method":"GET","requestUri":"/contact-evaluations/{InstanceId}/{EvaluationId}"},"input":{"type":"structure","required":["InstanceId","EvaluationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationId":{"location":"uri","locationName":"EvaluationId"}}},"output":{"type":"structure","required":["Evaluation","EvaluationForm"],"members":{"Evaluation":{"type":"structure","required":["EvaluationId","EvaluationArn","Metadata","Answers","Notes","Status","CreatedTime","LastModifiedTime"],"members":{"EvaluationId":{},"EvaluationArn":{},"Metadata":{"type":"structure","required":["ContactId","EvaluatorArn"],"members":{"ContactId":{},"EvaluatorArn":{},"ContactAgentId":{},"Score":{"shape":"Scy"}}},"Answers":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"Sd2"},"SystemSuggestedValue":{"shape":"Sd2"}}}},"Notes":{"shape":"Sd5"},"Status":{},"Scores":{"type":"map","key":{},"value":{"shape":"Scy"}},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"Tags":{"shape":"S2n"}}},"EvaluationForm":{"type":"structure","required":["EvaluationFormVersion","EvaluationFormId","EvaluationFormArn","Title","Items"],"members":{"EvaluationFormVersion":{"type":"integer"},"EvaluationFormId":{},"EvaluationFormArn":{},"Title":{},"Description":{},"Items":{"shape":"S4d"},"ScoringStrategy":{"shape":"S58"}}}}}},"DescribeContactFlow":{"http":{"method":"GET","requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"}}},"output":{"type":"structure","members":{"ContactFlow":{"shape":"Sdd"}}}},"DescribeContactFlowModule":{"http":{"method":"GET","requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"}}},"output":{"type":"structure","members":{"ContactFlowModule":{"shape":"Sdh"}}}},"DescribeEvaluationForm":{"http":{"method":"GET","requestUri":"/evaluation-forms/{InstanceId}/{EvaluationFormId}"},"input":{"type":"structure","required":["InstanceId","EvaluationFormId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationFormId":{"location":"uri","locationName":"EvaluationFormId"},"EvaluationFormVersion":{"location":"querystring","locationName":"version","type":"integer"}}},"output":{"type":"structure","required":["EvaluationForm"],"members":{"EvaluationForm":{"type":"structure","required":["EvaluationFormId","EvaluationFormVersion","Locked","EvaluationFormArn","Title","Status","Items","CreatedTime","CreatedBy","LastModifiedTime","LastModifiedBy"],"members":{"EvaluationFormId":{},"EvaluationFormVersion":{"type":"integer"},"Locked":{"type":"boolean"},"EvaluationFormArn":{},"Title":{},"Description":{},"Status":{},"Items":{"shape":"S4d"},"ScoringStrategy":{"shape":"S58"},"CreatedTime":{"type":"timestamp"},"CreatedBy":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{},"Tags":{"shape":"S2n"}}}}}},"DescribeHoursOfOperation":{"http":{"method":"GET","requestUri":"/hours-of-operations/{InstanceId}/{HoursOfOperationId}"},"input":{"type":"structure","required":["InstanceId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"HoursOfOperationId":{"location":"uri","locationName":"HoursOfOperationId"}}},"output":{"type":"structure","members":{"HoursOfOperation":{"shape":"Sdr"}}}},"DescribeInstance":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"Instance":{"type":"structure","members":{"Id":{},"Arn":{},"IdentityManagementType":{},"InstanceAlias":{"shape":"S5q"},"CreatedTime":{"type":"timestamp"},"ServiceRole":{},"InstanceStatus":{},"StatusReason":{"type":"structure","members":{"Message":{}}},"InboundCallsEnabled":{"type":"boolean"},"OutboundCallsEnabled":{"type":"boolean"},"InstanceAccessUrl":{},"Tags":{"shape":"S2n"}}}}}},"DescribeInstanceAttribute":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/attribute/{AttributeType}"},"input":{"type":"structure","required":["InstanceId","AttributeType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AttributeType":{"location":"uri","locationName":"AttributeType"}}},"output":{"type":"structure","members":{"Attribute":{"shape":"Se1"}}}},"DescribeInstanceStorageConfig":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/storage-config/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"},"ResourceType":{"location":"querystring","locationName":"resourceType"}}},"output":{"type":"structure","members":{"StorageConfig":{"shape":"St"}}}},"DescribePhoneNumber":{"http":{"method":"GET","requestUri":"/phone-number/{PhoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"}}},"output":{"type":"structure","members":{"ClaimedPhoneNumberSummary":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{},"PhoneNumber":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{},"PhoneNumberDescription":{},"TargetArn":{},"InstanceId":{},"Tags":{"shape":"S2n"},"PhoneNumberStatus":{"type":"structure","members":{"Status":{},"Message":{}}},"SourcePhoneNumberArn":{}}}}}},"DescribePredefinedAttribute":{"http":{"method":"GET","requestUri":"/predefined-attributes/{InstanceId}/{Name}"},"input":{"type":"structure","required":["InstanceId","Name"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","members":{"PredefinedAttribute":{"shape":"Sef"}}}},"DescribePrompt":{"http":{"method":"GET","requestUri":"/prompts/{InstanceId}/{PromptId}"},"input":{"type":"structure","required":["InstanceId","PromptId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PromptId":{"location":"uri","locationName":"PromptId"}}},"output":{"type":"structure","members":{"Prompt":{"shape":"Sei"}}}},"DescribeQueue":{"http":{"method":"GET","requestUri":"/queues/{InstanceId}/{QueueId}"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"}}},"output":{"type":"structure","members":{"Queue":{"shape":"Sel"}}}},"DescribeQuickConnect":{"http":{"method":"GET","requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}"},"input":{"type":"structure","required":["InstanceId","QuickConnectId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"}}},"output":{"type":"structure","members":{"QuickConnect":{"shape":"Sep"}}}},"DescribeRoutingProfile":{"http":{"method":"GET","requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"}}},"output":{"type":"structure","members":{"RoutingProfile":{"shape":"Ses"}}}},"DescribeRule":{"http":{"method":"GET","requestUri":"/rules/{InstanceId}/{RuleId}"},"input":{"type":"structure","required":["InstanceId","RuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RuleId":{"location":"uri","locationName":"RuleId"}}},"output":{"type":"structure","required":["Rule"],"members":{"Rule":{"type":"structure","required":["Name","RuleId","RuleArn","TriggerEventSource","Function","Actions","PublishStatus","CreatedTime","LastUpdatedTime","LastUpdatedBy"],"members":{"Name":{},"RuleId":{},"RuleArn":{},"TriggerEventSource":{"shape":"S7c"},"Function":{},"Actions":{"shape":"S7f"},"PublishStatus":{},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"LastUpdatedBy":{},"Tags":{"shape":"S2n"}}}}}},"DescribeSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["SecurityProfileId","InstanceId"],"members":{"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"SecurityProfile":{"type":"structure","members":{"Id":{},"OrganizationResourceId":{},"Arn":{},"SecurityProfileName":{},"Description":{},"Tags":{"shape":"S2n"},"AllowedAccessControlTags":{"shape":"S8m"},"TagRestrictedResources":{"shape":"S8p"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{},"HierarchyRestrictedResources":{"shape":"S8w"},"AllowedAccessControlHierarchyGroupId":{}}}}}},"DescribeTrafficDistributionGroup":{"http":{"method":"GET","requestUri":"/traffic-distribution-group/{TrafficDistributionGroupId}"},"input":{"type":"structure","required":["TrafficDistributionGroupId"],"members":{"TrafficDistributionGroupId":{"location":"uri","locationName":"TrafficDistributionGroupId"}}},"output":{"type":"structure","members":{"TrafficDistributionGroup":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"InstanceArn":{},"Status":{},"Tags":{"shape":"S2n"},"IsDefault":{"type":"boolean"}}}}}},"DescribeUser":{"http":{"method":"GET","requestUri":"/users/{InstanceId}/{UserId}"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"User":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{},"IdentityInfo":{"shape":"Sa5"},"PhoneConfig":{"shape":"Sa9"},"DirectoryUserId":{},"SecurityProfileIds":{"shape":"Sae"},"RoutingProfileId":{},"HierarchyGroupId":{},"Tags":{"shape":"S2n"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}}}},"DescribeUserHierarchyGroup":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}"},"input":{"type":"structure","required":["HierarchyGroupId","InstanceId"],"members":{"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyGroup":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LevelId":{},"HierarchyPath":{"type":"structure","members":{"LevelOne":{"shape":"Sfe"},"LevelTwo":{"shape":"Sfe"},"LevelThree":{"shape":"Sfe"},"LevelFour":{"shape":"Sfe"},"LevelFive":{"shape":"Sfe"}}},"Tags":{"shape":"S2n"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}}}},"DescribeUserHierarchyStructure":{"http":{"method":"GET","requestUri":"/user-hierarchy-structure/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"HierarchyStructure":{"type":"structure","members":{"LevelOne":{"shape":"Sfi"},"LevelTwo":{"shape":"Sfi"},"LevelThree":{"shape":"Sfi"},"LevelFour":{"shape":"Sfi"},"LevelFive":{"shape":"Sfi"}}}}}},"DescribeView":{"http":{"method":"GET","requestUri":"/views/{InstanceId}/{ViewId}"},"input":{"type":"structure","required":["InstanceId","ViewId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ViewId":{"location":"uri","locationName":"ViewId"}}},"output":{"type":"structure","members":{"View":{"shape":"Sau"}}}},"DescribeVocabulary":{"http":{"method":"GET","requestUri":"/vocabulary/{InstanceId}/{VocabularyId}"},"input":{"type":"structure","required":["InstanceId","VocabularyId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"VocabularyId":{"location":"uri","locationName":"VocabularyId"}}},"output":{"type":"structure","required":["Vocabulary"],"members":{"Vocabulary":{"type":"structure","required":["Name","Id","Arn","LanguageCode","State","LastModifiedTime"],"members":{"Name":{},"Id":{},"Arn":{},"LanguageCode":{},"State":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{},"Content":{},"Tags":{"shape":"S2n"}}}}}},"DisassociateAnalyticsDataSet":{"http":{"requestUri":"/analytics-data/instance/{InstanceId}/association"},"input":{"type":"structure","required":["InstanceId","DataSetId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"DataSetId":{},"TargetAccountId":{}}}},"DisassociateApprovedOrigin":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/approved-origin"},"input":{"type":"structure","required":["InstanceId","Origin"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Origin":{"location":"querystring","locationName":"origin"}}}},"DisassociateBot":{"http":{"requestUri":"/instance/{InstanceId}/bot"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LexBot":{"shape":"Sf"},"LexV2Bot":{"shape":"Si"}}}},"DisassociateFlow":{"http":{"method":"DELETE","requestUri":"/flow-associations/{InstanceId}/{ResourceId}/{ResourceType}"},"input":{"type":"structure","required":["InstanceId","ResourceId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"ResourceType":{"location":"uri","locationName":"ResourceType"}}},"output":{"type":"structure","members":{}}},"DisassociateInstanceStorageConfig":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/storage-config/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"},"ResourceType":{"location":"querystring","locationName":"resourceType"}}}},"DisassociateLambdaFunction":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/lambda-function"},"input":{"type":"structure","required":["InstanceId","FunctionArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"FunctionArn":{"location":"querystring","locationName":"functionArn"}}}},"DisassociateLexBot":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/lex-bot"},"input":{"type":"structure","required":["InstanceId","BotName","LexRegion"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"BotName":{"location":"querystring","locationName":"botName"},"LexRegion":{"location":"querystring","locationName":"lexRegion"}}}},"DisassociatePhoneNumberContactFlow":{"http":{"method":"DELETE","requestUri":"/phone-number/{PhoneNumberId}/contact-flow"},"input":{"type":"structure","required":["PhoneNumberId","InstanceId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"InstanceId":{"location":"querystring","locationName":"instanceId"}}}},"DisassociateQueueQuickConnects":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/disassociate-quick-connects"},"input":{"type":"structure","required":["InstanceId","QueueId","QuickConnectIds"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"QuickConnectIds":{"shape":"S1f"}}}},"DisassociateRoutingProfileQueues":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/disassociate-queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","QueueReferences"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"QueueReferences":{"type":"list","member":{"shape":"S1l"}}}}},"DisassociateSecurityKey":{"http":{"method":"DELETE","requestUri":"/instance/{InstanceId}/security-key/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"}}}},"DisassociateTrafficDistributionGroupUser":{"http":{"method":"DELETE","requestUri":"/traffic-distribution-group/{TrafficDistributionGroupId}/user"},"input":{"type":"structure","required":["TrafficDistributionGroupId","UserId","InstanceId"],"members":{"TrafficDistributionGroupId":{"location":"uri","locationName":"TrafficDistributionGroupId"},"UserId":{"location":"querystring","locationName":"UserId"},"InstanceId":{"location":"querystring","locationName":"InstanceId"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateUserProficiencies":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/disassociate-proficiencies"},"input":{"type":"structure","required":["InstanceId","UserId","UserProficiencies"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"},"UserProficiencies":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeValue"],"members":{"AttributeName":{},"AttributeValue":{}}}}}}},"DismissUserContact":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/contact"},"input":{"type":"structure","required":["UserId","InstanceId","ContactId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{}}},"output":{"type":"structure","members":{}}},"GetAttachedFile":{"http":{"method":"GET","requestUri":"/attached-files/{InstanceId}/{FileId}"},"input":{"type":"structure","required":["InstanceId","FileId","AssociatedResourceArn"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"FileId":{"location":"uri","locationName":"FileId"},"UrlExpiryInSeconds":{"location":"querystring","locationName":"urlExpiryInSeconds","type":"integer"},"AssociatedResourceArn":{"location":"querystring","locationName":"associatedResourceArn"}}},"output":{"type":"structure","required":["FileSizeInBytes"],"members":{"FileArn":{},"FileId":{},"CreationTime":{},"FileStatus":{},"FileName":{},"FileSizeInBytes":{"type":"long"},"AssociatedResourceArn":{},"FileUseCaseType":{},"CreatedBy":{"shape":"S2l"},"DownloadUrlMetadata":{"type":"structure","members":{"Url":{},"UrlExpiry":{}}},"Tags":{"shape":"S2n"}}}},"GetContactAttributes":{"http":{"method":"GET","requestUri":"/contact/attributes/{InstanceId}/{InitialContactId}"},"input":{"type":"structure","required":["InstanceId","InitialContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"InitialContactId":{"location":"uri","locationName":"InitialContactId"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"S38"}}}},"GetCurrentMetricData":{"http":{"requestUri":"/metrics/current/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Filters","CurrentMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Filters":{"shape":"Sgj"},"Groupings":{"shape":"Sgp"},"CurrentMetrics":{"type":"list","member":{"shape":"Sgs"}},"NextToken":{},"MaxResults":{"type":"integer"},"SortCriteria":{"type":"list","member":{"type":"structure","members":{"SortByMetric":{},"SortOrder":{}}}}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"Sh3"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"Sgs"},"Value":{"type":"double"}}}}}}},"DataSnapshotTime":{"type":"timestamp"},"ApproximateTotalCount":{"type":"long"}}}},"GetCurrentUserData":{"http":{"requestUri":"/metrics/userdata/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","Filters"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Filters":{"type":"structure","members":{"Queues":{"shape":"Sgk"},"ContactFilter":{"type":"structure","members":{"ContactStates":{"type":"list","member":{}}}},"RoutingProfiles":{"shape":"Sgm"},"Agents":{"type":"list","member":{}},"UserHierarchyGroups":{"type":"list","member":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"UserDataList":{"type":"list","member":{"type":"structure","members":{"User":{"type":"structure","members":{"Id":{},"Arn":{}}},"RoutingProfile":{"shape":"Sh5"},"HierarchyPath":{"type":"structure","members":{"LevelOne":{"shape":"Shm"},"LevelTwo":{"shape":"Shm"},"LevelThree":{"shape":"Shm"},"LevelFour":{"shape":"Shm"},"LevelFive":{"shape":"Shm"}}},"Status":{"type":"structure","members":{"StatusStartTimestamp":{"type":"timestamp"},"StatusArn":{},"StatusName":{}}},"AvailableSlotsByChannel":{"shape":"Sho"},"MaxSlotsByChannel":{"shape":"Sho"},"ActiveSlotsByChannel":{"shape":"Sho"},"Contacts":{"type":"list","member":{"type":"structure","members":{"ContactId":{},"Channel":{},"InitiationMethod":{},"AgentContactState":{},"StateStartTimestamp":{"type":"timestamp"},"ConnectedToAgentTimestamp":{"type":"timestamp"},"Queue":{"shape":"Sh4"}}}},"NextStatus":{}}}},"ApproximateTotalCount":{"type":"long"}}}},"GetFederationToken":{"http":{"method":"GET","requestUri":"/user/federate/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"}}},"output":{"type":"structure","members":{"Credentials":{"type":"structure","members":{"AccessToken":{"shape":"Shv"},"AccessTokenExpiration":{"type":"timestamp"},"RefreshToken":{"shape":"Shv"},"RefreshTokenExpiration":{"type":"timestamp"}},"sensitive":true},"SignInUrl":{},"UserArn":{},"UserId":{}}}},"GetFlowAssociation":{"http":{"method":"GET","requestUri":"/flow-associations/{InstanceId}/{ResourceId}/{ResourceType}"},"input":{"type":"structure","required":["InstanceId","ResourceId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"ResourceType":{"location":"uri","locationName":"ResourceType"}}},"output":{"type":"structure","members":{"ResourceId":{},"FlowId":{},"ResourceType":{}}}},"GetMetricData":{"http":{"requestUri":"/metrics/historical/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","StartTime","EndTime","Filters","HistoricalMetrics"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Filters":{"shape":"Sgj"},"Groupings":{"shape":"Sgp"},"HistoricalMetrics":{"type":"list","member":{"shape":"Si0"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"shape":"Sh3"},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"Si0"},"Value":{"type":"double"}}}}}}}}}},"GetMetricDataV2":{"http":{"requestUri":"/metrics/data"},"input":{"type":"structure","required":["ResourceArn","StartTime","EndTime","Filters","Metrics"],"members":{"ResourceArn":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Interval":{"type":"structure","members":{"TimeZone":{},"IntervalPeriod":{}}},"Filters":{"type":"list","member":{"type":"structure","members":{"FilterKey":{},"FilterValues":{"type":"list","member":{}}}}},"Groupings":{"type":"list","member":{}},"Metrics":{"type":"list","member":{"shape":"Sil"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"MetricResults":{"type":"list","member":{"type":"structure","members":{"Dimensions":{"type":"map","key":{},"value":{}},"MetricInterval":{"type":"structure","members":{"Interval":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"Collections":{"type":"list","member":{"type":"structure","members":{"Metric":{"shape":"Sil"},"Value":{"type":"double"}}}}}}}}}},"GetPromptFile":{"http":{"method":"GET","requestUri":"/prompts/{InstanceId}/{PromptId}/file"},"input":{"type":"structure","required":["InstanceId","PromptId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PromptId":{"location":"uri","locationName":"PromptId"}}},"output":{"type":"structure","members":{"PromptPresignedUrl":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"GetTaskTemplate":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/task/template/{TaskTemplateId}"},"input":{"type":"structure","required":["InstanceId","TaskTemplateId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"TaskTemplateId":{"location":"uri","locationName":"TaskTemplateId"},"SnapshotVersion":{"location":"querystring","locationName":"snapshotVersion"}}},"output":{"type":"structure","required":["Id","Arn","Name"],"members":{"InstanceId":{},"Id":{},"Arn":{},"Name":{},"Description":{},"ContactFlowId":{},"Constraints":{"shape":"S94"},"Defaults":{"shape":"S9d"},"Fields":{"shape":"S9i"},"Status":{},"LastModifiedTime":{"type":"timestamp"},"CreatedTime":{"type":"timestamp"},"Tags":{"shape":"S2n"}}}},"GetTrafficDistribution":{"http":{"method":"GET","requestUri":"/traffic-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"TelephonyConfig":{"shape":"Sja"},"Id":{},"Arn":{},"SignInConfig":{"shape":"Sjf"},"AgentConfig":{"shape":"Sji"}}}},"ImportPhoneNumber":{"http":{"requestUri":"/phone-number/import"},"input":{"type":"structure","required":["InstanceId","SourcePhoneNumberArn"],"members":{"InstanceId":{},"SourcePhoneNumberArn":{},"PhoneNumberDescription":{},"Tags":{"shape":"S2n"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{}}}},"ListAgentStatuses":{"http":{"method":"GET","requestUri":"/agent-status/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"AgentStatusTypes":{"location":"querystring","locationName":"AgentStatusTypes","type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"AgentStatusSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Type":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}}}}},"ListAnalyticsDataAssociations":{"http":{"method":"GET","requestUri":"/analytics-data/instance/{InstanceId}/association"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"DataSetId":{"location":"querystring","locationName":"DataSetId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Results":{"shape":"S25"},"NextToken":{}}}},"ListApprovedOrigins":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/approved-origins"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Origins":{"type":"list","member":{}},"NextToken":{}}}},"ListBots":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/bots"},"input":{"type":"structure","required":["InstanceId","LexVersion"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"LexVersion":{"location":"querystring","locationName":"lexVersion"}}},"output":{"type":"structure","members":{"LexBots":{"type":"list","member":{"type":"structure","members":{"LexBot":{"shape":"Sf"},"LexV2Bot":{"shape":"Si"}}}},"NextToken":{}}}},"ListContactEvaluations":{"http":{"method":"GET","requestUri":"/contact-evaluations/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","ContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"querystring","locationName":"contactId"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["EvaluationSummaryList"],"members":{"EvaluationSummaryList":{"type":"list","member":{"type":"structure","required":["EvaluationId","EvaluationArn","EvaluationFormTitle","EvaluationFormId","Status","EvaluatorArn","CreatedTime","LastModifiedTime"],"members":{"EvaluationId":{},"EvaluationArn":{},"EvaluationFormTitle":{},"EvaluationFormId":{},"Status":{},"EvaluatorArn":{},"Score":{"shape":"Scy"},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListContactFlowModules":{"http":{"method":"GET","requestUri":"/contact-flow-modules-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"ContactFlowModuleState":{"location":"querystring","locationName":"state"}}},"output":{"type":"structure","members":{"ContactFlowModulesSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"State":{}}}},"NextToken":{}}}},"ListContactFlows":{"http":{"method":"GET","requestUri":"/contact-flows-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowTypes":{"location":"querystring","locationName":"contactFlowTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"ContactFlowSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"ContactFlowType":{},"ContactFlowState":{},"ContactFlowStatus":{}}}},"NextToken":{}}}},"ListContactReferences":{"http":{"method":"GET","requestUri":"/contact/references/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId","ReferenceTypes"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"},"ReferenceTypes":{"location":"querystring","locationName":"referenceTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"ReferenceSummaryList":{"type":"list","member":{"type":"structure","members":{"Url":{"type":"structure","members":{"Name":{},"Value":{}}},"Attachment":{"type":"structure","members":{"Name":{},"Value":{},"Status":{}}},"String":{"type":"structure","members":{"Name":{},"Value":{}}},"Number":{"type":"structure","members":{"Name":{},"Value":{}}},"Date":{"type":"structure","members":{"Name":{},"Value":{}}},"Email":{"type":"structure","members":{"Name":{},"Value":{}}}},"union":true}},"NextToken":{}}}},"ListDefaultVocabularies":{"http":{"requestUri":"/default-vocabulary-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"LanguageCode":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["DefaultVocabularyList"],"members":{"DefaultVocabularyList":{"type":"list","member":{"type":"structure","required":["InstanceId","LanguageCode","VocabularyId","VocabularyName"],"members":{"InstanceId":{},"LanguageCode":{},"VocabularyId":{},"VocabularyName":{}}}},"NextToken":{}}}},"ListEvaluationFormVersions":{"http":{"method":"GET","requestUri":"/evaluation-forms/{InstanceId}/{EvaluationFormId}/versions"},"input":{"type":"structure","required":["InstanceId","EvaluationFormId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationFormId":{"location":"uri","locationName":"EvaluationFormId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["EvaluationFormVersionSummaryList"],"members":{"EvaluationFormVersionSummaryList":{"type":"list","member":{"type":"structure","required":["EvaluationFormArn","EvaluationFormId","EvaluationFormVersion","Locked","Status","CreatedTime","CreatedBy","LastModifiedTime","LastModifiedBy"],"members":{"EvaluationFormArn":{},"EvaluationFormId":{},"EvaluationFormVersion":{"type":"integer"},"Locked":{"type":"boolean"},"Status":{},"CreatedTime":{"type":"timestamp"},"CreatedBy":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{}}}},"NextToken":{}}}},"ListEvaluationForms":{"http":{"method":"GET","requestUri":"/evaluation-forms/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["EvaluationFormSummaryList"],"members":{"EvaluationFormSummaryList":{"type":"list","member":{"type":"structure","required":["EvaluationFormId","EvaluationFormArn","Title","CreatedTime","CreatedBy","LastModifiedTime","LastModifiedBy","LatestVersion"],"members":{"EvaluationFormId":{},"EvaluationFormArn":{},"Title":{},"CreatedTime":{"type":"timestamp"},"CreatedBy":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedBy":{},"LastActivatedTime":{"type":"timestamp"},"LastActivatedBy":{},"LatestVersion":{"type":"integer"},"ActiveVersion":{"type":"integer"}}}},"NextToken":{}}}},"ListFlowAssociations":{"http":{"method":"GET","requestUri":"/flow-associations-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceType":{"location":"querystring","locationName":"ResourceType"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"FlowAssociationSummaryList":{"shape":"S2y"},"NextToken":{}}}},"ListHoursOfOperations":{"http":{"method":"GET","requestUri":"/hours-of-operations-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"HoursOfOperationSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"NextToken":{}}}},"ListInstanceAttributes":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/attributes"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Attributes":{"type":"list","member":{"shape":"Se1"}},"NextToken":{}}}},"ListInstanceStorageConfigs":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/storage-configs"},"input":{"type":"structure","required":["InstanceId","ResourceType"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"StorageConfigs":{"type":"list","member":{"shape":"St"}},"NextToken":{}}}},"ListInstances":{"http":{"method":"GET","requestUri":"/instance"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"InstanceSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"IdentityManagementType":{},"InstanceAlias":{"shape":"S5q"},"CreatedTime":{"type":"timestamp"},"ServiceRole":{},"InstanceStatus":{},"InboundCallsEnabled":{"type":"boolean"},"OutboundCallsEnabled":{"type":"boolean"},"InstanceAccessUrl":{}}}},"NextToken":{}}}},"ListIntegrationAssociations":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/integration-associations"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationType":{"location":"querystring","locationName":"integrationType"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"IntegrationArn":{"location":"querystring","locationName":"integrationArn"}}},"output":{"type":"structure","members":{"IntegrationAssociationSummaryList":{"type":"list","member":{"type":"structure","members":{"IntegrationAssociationId":{},"IntegrationAssociationArn":{},"InstanceId":{},"IntegrationType":{},"IntegrationArn":{},"SourceApplicationUrl":{},"SourceApplicationName":{},"SourceType":{}}}},"NextToken":{}}}},"ListLambdaFunctions":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/lambda-functions"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"LambdaFunctions":{"type":"list","member":{}},"NextToken":{}}}},"ListLexBots":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/lex-bots"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"LexBots":{"type":"list","member":{"shape":"Sf"}},"NextToken":{}}}},"ListPhoneNumbers":{"http":{"method":"GET","requestUri":"/phone-numbers-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PhoneNumberTypes":{"shape":"Sly","location":"querystring","locationName":"phoneNumberTypes"},"PhoneNumberCountryCodes":{"shape":"Slz","location":"querystring","locationName":"phoneNumberCountryCodes"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"PhoneNumberSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"PhoneNumber":{},"PhoneNumberType":{},"PhoneNumberCountryCode":{}}}},"NextToken":{}}}},"ListPhoneNumbersV2":{"http":{"requestUri":"/phone-number/list"},"input":{"type":"structure","members":{"TargetArn":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"PhoneNumberCountryCodes":{"shape":"Slz"},"PhoneNumberTypes":{"shape":"Sly"},"PhoneNumberPrefix":{}}},"output":{"type":"structure","members":{"NextToken":{},"ListPhoneNumbersSummaryList":{"type":"list","member":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{},"PhoneNumber":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{},"TargetArn":{},"InstanceId":{},"PhoneNumberDescription":{},"SourcePhoneNumberArn":{}}}}}}},"ListPredefinedAttributes":{"http":{"method":"GET","requestUri":"/predefined-attributes/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"PredefinedAttributeSummaryList":{"type":"list","member":{"type":"structure","members":{"Name":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}}}}},"ListPrompts":{"http":{"method":"GET","requestUri":"/prompts-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"PromptSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"NextToken":{}}}},"ListQueueQuickConnects":{"http":{"method":"GET","requestUri":"/queues/{InstanceId}/{QueueId}/quick-connects"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"QuickConnectSummaryList":{"shape":"Smk"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"ListQueues":{"http":{"method":"GET","requestUri":"/queues-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueTypes":{"location":"querystring","locationName":"queueTypes","type":"list","member":{}},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"QueueSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"QueueType":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"NextToken":{}}}},"ListQuickConnects":{"http":{"method":"GET","requestUri":"/quick-connects/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"QuickConnectTypes":{"location":"querystring","locationName":"QuickConnectTypes","type":"list","member":{}}}},"output":{"type":"structure","members":{"QuickConnectSummaryList":{"shape":"Smk"},"NextToken":{}}}},"ListRealtimeContactAnalysisSegmentsV2":{"http":{"requestUri":"/contact/list-real-time-analysis-segments-v2/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId","OutputType","SegmentTypes"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"},"MaxResults":{"type":"integer"},"NextToken":{},"OutputType":{},"SegmentTypes":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Channel","Status","Segments"],"members":{"Channel":{},"Status":{},"Segments":{"type":"list","member":{"type":"structure","members":{"Transcript":{"type":"structure","required":["Id","ParticipantId","ParticipantRole","Content","Time"],"members":{"Id":{},"ParticipantId":{},"ParticipantRole":{},"DisplayName":{},"Content":{},"ContentType":{},"Time":{"shape":"Sn9"},"Redaction":{"type":"structure","members":{"CharacterOffsets":{"type":"list","member":{"shape":"Snd"}}}},"Sentiment":{}}},"Categories":{"type":"structure","required":["MatchedDetails"],"members":{"MatchedDetails":{"type":"map","key":{},"value":{"type":"structure","required":["PointsOfInterest"],"members":{"PointsOfInterest":{"type":"list","member":{"type":"structure","members":{"TranscriptItems":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"CharacterOffsets":{"shape":"Snd"}}}}}}}}}}}},"Issues":{"type":"structure","required":["IssuesDetected"],"members":{"IssuesDetected":{"type":"list","member":{"type":"structure","required":["TranscriptItems"],"members":{"TranscriptItems":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Content":{},"Id":{},"CharacterOffsets":{"shape":"Snd"}}}}}}}}},"Event":{"type":"structure","required":["Id","EventType","Time"],"members":{"Id":{},"ParticipantId":{},"ParticipantRole":{},"DisplayName":{},"EventType":{},"Time":{"shape":"Sn9"}}},"Attachments":{"type":"structure","required":["Id","ParticipantId","ParticipantRole","Attachments","Time"],"members":{"Id":{},"ParticipantId":{},"ParticipantRole":{},"DisplayName":{},"Attachments":{"type":"list","member":{"type":"structure","required":["AttachmentName","AttachmentId"],"members":{"AttachmentName":{},"ContentType":{},"AttachmentId":{},"Status":{}}}},"Time":{"shape":"Sn9"}}}},"union":true}},"NextToken":{}}}},"ListRoutingProfileQueues":{"http":{"method":"GET","requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"RoutingProfileQueueConfigSummaryList":{"type":"list","member":{"type":"structure","required":["QueueId","QueueArn","QueueName","Priority","Delay","Channel"],"members":{"QueueId":{},"QueueArn":{},"QueueName":{},"Priority":{"type":"integer"},"Delay":{"type":"integer"},"Channel":{}}}},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"ListRoutingProfiles":{"http":{"method":"GET","requestUri":"/routing-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"RoutingProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"NextToken":{}}}},"ListRules":{"http":{"method":"GET","requestUri":"/rules/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PublishStatus":{"location":"querystring","locationName":"publishStatus"},"EventSourceName":{"location":"querystring","locationName":"eventSourceName"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","required":["RuleSummaryList"],"members":{"RuleSummaryList":{"type":"list","member":{"type":"structure","required":["Name","RuleId","RuleArn","EventSourceName","PublishStatus","ActionSummaries","CreatedTime","LastUpdatedTime"],"members":{"Name":{},"RuleId":{},"RuleArn":{},"EventSourceName":{},"PublishStatus":{},"ActionSummaries":{"type":"list","member":{"type":"structure","required":["ActionType"],"members":{"ActionType":{}}}},"CreatedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListSecurityKeys":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/security-keys"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"SecurityKeys":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Key":{},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListSecurityProfileApplications":{"http":{"method":"GET","requestUri":"/security-profiles-applications/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["SecurityProfileId","InstanceId"],"members":{"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Applications":{"shape":"S8r"},"NextToken":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"ListSecurityProfilePermissions":{"http":{"method":"GET","requestUri":"/security-profiles-permissions/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["SecurityProfileId","InstanceId"],"members":{"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"Permissions":{"shape":"S8k"},"NextToken":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"SecurityProfileSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S2n"}}}},"ListTaskTemplates":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/task/template"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"Status":{"location":"querystring","locationName":"status"},"Name":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"TaskTemplates":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Status":{},"LastModifiedTime":{"type":"timestamp"},"CreatedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTrafficDistributionGroupUsers":{"http":{"method":"GET","requestUri":"/traffic-distribution-group/{TrafficDistributionGroupId}/user"},"input":{"type":"structure","required":["TrafficDistributionGroupId"],"members":{"TrafficDistributionGroupId":{"location":"uri","locationName":"TrafficDistributionGroupId"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{},"TrafficDistributionGroupUserSummaryList":{"type":"list","member":{"type":"structure","members":{"UserId":{}}}}}}},"ListTrafficDistributionGroups":{"http":{"method":"GET","requestUri":"/traffic-distribution-groups"},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"},"InstanceId":{"location":"querystring","locationName":"instanceId"}}},"output":{"type":"structure","members":{"NextToken":{},"TrafficDistributionGroupSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"InstanceArn":{},"Status":{},"IsDefault":{"type":"boolean"}}}}}}},"ListUseCases":{"http":{"method":"GET","requestUri":"/instance/{InstanceId}/integration-associations/{IntegrationAssociationId}/use-cases"},"input":{"type":"structure","required":["InstanceId","IntegrationAssociationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"IntegrationAssociationId":{"location":"uri","locationName":"IntegrationAssociationId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UseCaseSummaryList":{"type":"list","member":{"type":"structure","members":{"UseCaseId":{},"UseCaseArn":{},"UseCaseType":{}}}},"NextToken":{}}}},"ListUserHierarchyGroups":{"http":{"method":"GET","requestUri":"/user-hierarchy-groups-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserHierarchyGroupSummaryList":{"type":"list","member":{"shape":"Sfe"}},"NextToken":{}}}},"ListUserProficiencies":{"http":{"method":"GET","requestUri":"/users/{InstanceId}/{UserId}/proficiencies"},"input":{"type":"structure","required":["InstanceId","UserId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"UserProficiencyList":{"shape":"S1x"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"ListUsers":{"http":{"method":"GET","requestUri":"/users-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"UserSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Username":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"NextToken":{}}}},"ListViewVersions":{"http":{"method":"GET","requestUri":"/views/{InstanceId}/{ViewId}/versions"},"input":{"type":"structure","required":["InstanceId","ViewId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ViewId":{"location":"uri","locationName":"ViewId"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"ViewVersionSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Description":{},"Name":{"shape":"Sas"},"Type":{},"Version":{"type":"integer"},"VersionDescription":{}}}},"NextToken":{}}}},"ListViews":{"http":{"method":"GET","requestUri":"/views/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Type":{"location":"querystring","locationName":"type"},"NextToken":{"location":"querystring","locationName":"nextToken"},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"ViewsSummaryList":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{"shape":"Sas"},"Type":{},"Status":{},"Description":{}}}},"NextToken":{}}}},"MonitorContact":{"http":{"requestUri":"/contact/monitor"},"input":{"type":"structure","required":["InstanceId","ContactId","UserId"],"members":{"InstanceId":{},"ContactId":{},"UserId":{},"AllowedMonitorCapabilities":{"type":"list","member":{}},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ContactId":{},"ContactArn":{}}}},"PauseContact":{"http":{"requestUri":"/contact/pause"},"input":{"type":"structure","required":["ContactId","InstanceId"],"members":{"ContactId":{},"InstanceId":{},"ContactFlowId":{}}},"output":{"type":"structure","members":{}}},"PutUserStatus":{"http":{"method":"PUT","requestUri":"/users/{InstanceId}/{UserId}/status"},"input":{"type":"structure","required":["UserId","InstanceId","AgentStatusId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"AgentStatusId":{}}},"output":{"type":"structure","members":{}}},"ReleasePhoneNumber":{"http":{"method":"DELETE","requestUri":"/phone-number/{PhoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"ClientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}}},"ReplicateInstance":{"http":{"requestUri":"/instance/{InstanceId}/replicate"},"input":{"type":"structure","required":["InstanceId","ReplicaRegion","ReplicaAlias"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ReplicaRegion":{},"ClientToken":{"idempotencyToken":true},"ReplicaAlias":{"shape":"S5q"}}},"output":{"type":"structure","members":{"Id":{},"Arn":{}}}},"ResumeContact":{"http":{"requestUri":"/contact/resume"},"input":{"type":"structure","required":["ContactId","InstanceId"],"members":{"ContactId":{},"InstanceId":{},"ContactFlowId":{}}},"output":{"type":"structure","members":{}}},"ResumeContactRecording":{"http":{"requestUri":"/contact/resume-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{}}},"output":{"type":"structure","members":{}}},"SearchAvailablePhoneNumbers":{"http":{"requestUri":"/phone-number/search-available"},"input":{"type":"structure","required":["PhoneNumberCountryCode","PhoneNumberType"],"members":{"TargetArn":{},"InstanceId":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{},"PhoneNumberPrefix":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"AvailableNumbersList":{"type":"list","member":{"type":"structure","members":{"PhoneNumber":{},"PhoneNumberCountryCode":{},"PhoneNumberType":{}}}}}}},"SearchContactFlowModules":{"http":{"requestUri":"/search-contact-flow-modules"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}},"SearchCriteria":{"shape":"Sqk"}}},"output":{"type":"structure","members":{"ContactFlowModules":{"type":"list","member":{"shape":"Sdh"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchContactFlows":{"http":{"requestUri":"/search-contact-flows"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}},"SearchCriteria":{"shape":"Sqs"}}},"output":{"type":"structure","members":{"ContactFlows":{"type":"list","member":{"shape":"Sdd"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchContacts":{"http":{"requestUri":"/search-contacts"},"input":{"type":"structure","required":["InstanceId","TimeRange"],"members":{"InstanceId":{},"TimeRange":{"type":"structure","required":["Type","StartTime","EndTime"],"members":{"Type":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"SearchCriteria":{"type":"structure","members":{"AgentIds":{"type":"list","member":{}},"AgentHierarchyGroups":{"type":"structure","members":{"L1Ids":{"shape":"Sr2"},"L2Ids":{"shape":"Sr2"},"L3Ids":{"shape":"Sr2"},"L4Ids":{"shape":"Sr2"},"L5Ids":{"shape":"Sr2"}}},"Channels":{"type":"list","member":{}},"ContactAnalysis":{"type":"structure","members":{"Transcript":{"type":"structure","required":["Criteria"],"members":{"Criteria":{"type":"list","member":{"type":"structure","required":["ParticipantRole","SearchText","MatchType"],"members":{"ParticipantRole":{},"SearchText":{"type":"list","member":{"type":"string","sensitive":true}},"MatchType":{}}}},"MatchType":{}}}}},"InitiationMethods":{"type":"list","member":{}},"QueueIds":{"type":"list","member":{}},"SearchableContactAttributes":{"type":"structure","required":["Criteria"],"members":{"Criteria":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{"type":"string","sensitive":true},"Values":{"type":"list","member":{"type":"string","sensitive":true}}}}},"MatchType":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{},"Sort":{"type":"structure","required":["FieldName","Order"],"members":{"FieldName":{},"Order":{}}}}},"output":{"type":"structure","required":["Contacts"],"members":{"Contacts":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Id":{},"InitialContactId":{},"PreviousContactId":{},"InitiationMethod":{},"Channel":{},"QueueInfo":{"type":"structure","members":{"Id":{},"EnqueueTimestamp":{"type":"timestamp"}}},"AgentInfo":{"type":"structure","members":{"Id":{},"ConnectedToAgentTimestamp":{"type":"timestamp"}}},"InitiationTimestamp":{"type":"timestamp"},"DisconnectTimestamp":{"type":"timestamp"},"ScheduledTimestamp":{"type":"timestamp"}}}},"NextToken":{},"TotalCount":{"type":"long"}}}},"SearchHoursOfOperations":{"http":{"requestUri":"/search-hours-of-operations"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}},"SearchCriteria":{"shape":"Srt"}}},"output":{"type":"structure","members":{"HoursOfOperations":{"type":"list","member":{"shape":"Sdr"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchPredefinedAttributes":{"http":{"requestUri":"/search-predefined-attributes"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchCriteria":{"shape":"Sry"}}},"output":{"type":"structure","members":{"PredefinedAttributes":{"type":"list","member":{"shape":"Sef"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchPrompts":{"http":{"requestUri":"/search-prompts"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}},"SearchCriteria":{"shape":"Ss4"}}},"output":{"type":"structure","members":{"Prompts":{"type":"list","member":{"shape":"Sei"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchQueues":{"http":{"requestUri":"/search-queues"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}},"SearchCriteria":{"shape":"Ssb"}}},"output":{"type":"structure","members":{"Queues":{"type":"list","member":{"shape":"Sel"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchQuickConnects":{"http":{"requestUri":"/search-quick-connects"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}},"SearchCriteria":{"shape":"Ssi"}}},"output":{"type":"structure","members":{"QuickConnects":{"type":"list","member":{"shape":"Sep"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchResourceTags":{"http":{"requestUri":"/search-resource-tags"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ResourceTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"},"SearchCriteria":{"type":"structure","members":{"TagSearchCondition":{"type":"structure","members":{"tagKey":{},"tagValue":{},"tagKeyComparisonType":{},"tagValueComparisonType":{}}}}}}},"output":{"type":"structure","members":{"Tags":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"NextToken":{}}}},"SearchRoutingProfiles":{"http":{"requestUri":"/search-routing-profiles"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}},"SearchCriteria":{"shape":"Ssx"}}},"output":{"type":"structure","members":{"RoutingProfiles":{"type":"list","member":{"shape":"Ses"}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchSecurityProfiles":{"http":{"requestUri":"/search-security-profiles"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchCriteria":{"shape":"St2"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"}}}}},"output":{"type":"structure","members":{"SecurityProfiles":{"type":"list","member":{"type":"structure","members":{"Id":{},"OrganizationResourceId":{},"Arn":{},"SecurityProfileName":{},"Description":{},"Tags":{"shape":"S2n"}}}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchUsers":{"http":{"requestUri":"/search-users"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"NextToken":{},"MaxResults":{"type":"integer"},"SearchFilter":{"type":"structure","members":{"TagFilter":{"shape":"Sqg"},"UserAttributeFilter":{"type":"structure","members":{"OrConditions":{"type":"list","member":{"shape":"Stc"}},"AndCondition":{"shape":"Stc"},"TagCondition":{"shape":"Sqj"},"HierarchyGroupCondition":{"shape":"Std"}}}}},"SearchCriteria":{"shape":"Stf"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","members":{"Arn":{},"DirectoryUserId":{},"HierarchyGroupId":{},"Id":{},"IdentityInfo":{"type":"structure","members":{"FirstName":{"shape":"Sa6"},"LastName":{"shape":"Sa7"}}},"PhoneConfig":{"shape":"Sa9"},"RoutingProfileId":{},"SecurityProfileIds":{"shape":"Sae"},"Tags":{"shape":"S2n"},"Username":{}}}},"NextToken":{},"ApproximateTotalCount":{"type":"long"}}}},"SearchVocabularies":{"http":{"requestUri":"/vocabulary-summary/{InstanceId}"},"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"State":{},"NameStartsWith":{},"LanguageCode":{}}},"output":{"type":"structure","members":{"VocabularySummaryList":{"type":"list","member":{"type":"structure","required":["Name","Id","Arn","LanguageCode","State","LastModifiedTime"],"members":{"Name":{},"Id":{},"Arn":{},"LanguageCode":{},"State":{},"LastModifiedTime":{"type":"timestamp"},"FailureReason":{}}}},"NextToken":{}}}},"SendChatIntegrationEvent":{"http":{"requestUri":"/chat-integration-event"},"input":{"type":"structure","required":["SourceId","DestinationId","Event"],"members":{"SourceId":{},"DestinationId":{},"Subtype":{},"Event":{"type":"structure","required":["Type"],"members":{"Type":{},"ContentType":{},"Content":{}}},"NewSessionDetails":{"type":"structure","members":{"SupportedMessagingContentTypes":{"shape":"Sty"},"ParticipantDetails":{"shape":"Su0"},"Attributes":{"shape":"S38"},"StreamingConfiguration":{"shape":"Su1"}}}}},"output":{"type":"structure","members":{"InitialContactId":{},"NewChatCreated":{"type":"boolean"}}}},"StartAttachedFileUpload":{"http":{"method":"PUT","requestUri":"/attached-files/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","FileName","FileSizeInBytes","FileUseCaseType","AssociatedResourceArn"],"members":{"ClientToken":{"idempotencyToken":true},"InstanceId":{"location":"uri","locationName":"InstanceId"},"FileName":{},"FileSizeInBytes":{"type":"long"},"UrlExpiryInSeconds":{"type":"integer"},"FileUseCaseType":{},"AssociatedResourceArn":{"location":"querystring","locationName":"associatedResourceArn"},"CreatedBy":{"shape":"S2l"},"Tags":{"shape":"S2n"}}},"output":{"type":"structure","members":{"FileArn":{},"FileId":{},"CreationTime":{},"FileStatus":{},"CreatedBy":{"shape":"S2l"},"UploadUrlMetadata":{"type":"structure","members":{"Url":{},"UrlExpiry":{},"HeadersToInclude":{"type":"map","key":{},"value":{}}}}}}},"StartChatContact":{"http":{"method":"PUT","requestUri":"/contact/chat"},"input":{"type":"structure","required":["InstanceId","ContactFlowId","ParticipantDetails"],"members":{"InstanceId":{},"ContactFlowId":{},"Attributes":{"shape":"S38"},"ParticipantDetails":{"shape":"Su0"},"InitialMessage":{"type":"structure","required":["ContentType","Content"],"members":{"ContentType":{},"Content":{}}},"ClientToken":{"idempotencyToken":true},"ChatDurationInMinutes":{"type":"integer"},"SupportedMessagingContentTypes":{"shape":"Sty"},"PersistentChat":{"type":"structure","members":{"RehydrationType":{},"SourceContactId":{}}},"RelatedContactId":{},"SegmentAttributes":{"type":"map","key":{},"value":{"type":"structure","members":{"ValueString":{}}}}}},"output":{"type":"structure","members":{"ContactId":{},"ParticipantId":{},"ParticipantToken":{},"ContinuedFromContactId":{}}}},"StartContactEvaluation":{"http":{"method":"PUT","requestUri":"/contact-evaluations/{InstanceId}"},"input":{"type":"structure","required":["InstanceId","ContactId","EvaluationFormId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{},"EvaluationFormId":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["EvaluationId","EvaluationArn"],"members":{"EvaluationId":{},"EvaluationArn":{}}},"idempotent":true},"StartContactRecording":{"http":{"requestUri":"/contact/start-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId","VoiceRecordingConfiguration"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{},"VoiceRecordingConfiguration":{"type":"structure","members":{"VoiceRecordingTrack":{}}}}},"output":{"type":"structure","members":{}}},"StartContactStreaming":{"http":{"requestUri":"/contact/start-streaming"},"input":{"type":"structure","required":["InstanceId","ContactId","ChatStreamingConfiguration","ClientToken"],"members":{"InstanceId":{},"ContactId":{},"ChatStreamingConfiguration":{"shape":"Su1"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["StreamingId"],"members":{"StreamingId":{}}}},"StartOutboundVoiceContact":{"http":{"method":"PUT","requestUri":"/contact/outbound-voice"},"input":{"type":"structure","required":["DestinationPhoneNumber","ContactFlowId","InstanceId"],"members":{"Name":{"shape":"Scf"},"Description":{"shape":"Scg"},"References":{"shape":"S7l"},"RelatedContactId":{},"DestinationPhoneNumber":{},"ContactFlowId":{},"InstanceId":{},"ClientToken":{"idempotencyToken":true},"SourcePhoneNumber":{},"QueueId":{},"Attributes":{"shape":"S38"},"AnswerMachineDetectionConfig":{"type":"structure","members":{"EnableAnswerMachineDetection":{"type":"boolean"},"AwaitAnswerMachinePrompt":{"type":"boolean"}}},"CampaignId":{},"TrafficType":{}}},"output":{"type":"structure","members":{"ContactId":{}}}},"StartTaskContact":{"http":{"method":"PUT","requestUri":"/contact/task"},"input":{"type":"structure","required":["InstanceId","Name"],"members":{"InstanceId":{},"PreviousContactId":{},"ContactFlowId":{},"Attributes":{"shape":"S38"},"Name":{"shape":"Scf"},"References":{"shape":"S7l"},"Description":{"shape":"Scg"},"ClientToken":{"idempotencyToken":true},"ScheduledTime":{"type":"timestamp"},"TaskTemplateId":{},"QuickConnectId":{},"RelatedContactId":{}}},"output":{"type":"structure","members":{"ContactId":{}}}},"StartWebRTCContact":{"http":{"method":"PUT","requestUri":"/contact/webrtc"},"input":{"type":"structure","required":["ContactFlowId","InstanceId","ParticipantDetails"],"members":{"Attributes":{"shape":"S38"},"ClientToken":{"idempotencyToken":true},"ContactFlowId":{},"InstanceId":{},"AllowedCapabilities":{"type":"structure","members":{"Customer":{"shape":"Sv1"},"Agent":{"shape":"Sv1"}}},"ParticipantDetails":{"shape":"Su0"},"RelatedContactId":{},"References":{"shape":"S7l"},"Description":{"shape":"Scg"}}},"output":{"type":"structure","members":{"ConnectionData":{"type":"structure","members":{"Attendee":{"type":"structure","members":{"AttendeeId":{},"JoinToken":{"type":"string","sensitive":true}}},"Meeting":{"type":"structure","members":{"MediaRegion":{},"MediaPlacement":{"type":"structure","members":{"AudioHostUrl":{},"AudioFallbackUrl":{},"SignalingUrl":{},"TurnControlUrl":{},"EventIngestionUrl":{}}},"MeetingFeatures":{"type":"structure","members":{"Audio":{"type":"structure","members":{"EchoReduction":{}}}}},"MeetingId":{}}}}},"ContactId":{},"ParticipantId":{},"ParticipantToken":{}}}},"StopContact":{"http":{"requestUri":"/contact/stop"},"input":{"type":"structure","required":["ContactId","InstanceId"],"members":{"ContactId":{},"InstanceId":{},"DisconnectReason":{"type":"structure","members":{"Code":{}}}}},"output":{"type":"structure","members":{}}},"StopContactRecording":{"http":{"requestUri":"/contact/stop-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{}}},"output":{"type":"structure","members":{}}},"StopContactStreaming":{"http":{"requestUri":"/contact/stop-streaming"},"input":{"type":"structure","required":["InstanceId","ContactId","StreamingId"],"members":{"InstanceId":{},"ContactId":{},"StreamingId":{}}},"output":{"type":"structure","members":{}}},"SubmitContactEvaluation":{"http":{"requestUri":"/contact-evaluations/{InstanceId}/{EvaluationId}/submit"},"input":{"type":"structure","required":["InstanceId","EvaluationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationId":{"location":"uri","locationName":"EvaluationId"},"Answers":{"shape":"Svo"},"Notes":{"shape":"Sd5"}}},"output":{"type":"structure","required":["EvaluationId","EvaluationArn"],"members":{"EvaluationId":{},"EvaluationArn":{}}}},"SuspendContactRecording":{"http":{"requestUri":"/contact/suspend-recording"},"input":{"type":"structure","required":["InstanceId","ContactId","InitialContactId"],"members":{"InstanceId":{},"ContactId":{},"InitialContactId":{}}},"output":{"type":"structure","members":{}}},"TagContact":{"http":{"requestUri":"/contact/tags"},"input":{"type":"structure","required":["ContactId","InstanceId","Tags"],"members":{"ContactId":{},"InstanceId":{},"Tags":{"shape":"Scr"}}},"output":{"type":"structure","members":{}},"idempotent":true},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S2n"}}}},"TransferContact":{"http":{"requestUri":"/contact/transfer"},"input":{"type":"structure","required":["InstanceId","ContactId","ContactFlowId"],"members":{"InstanceId":{},"ContactId":{},"QueueId":{},"UserId":{},"ContactFlowId":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ContactId":{},"ContactArn":{}}}},"UntagContact":{"http":{"method":"DELETE","requestUri":"/contact/tags/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["ContactId","InstanceId","TagKeys"],"members":{"ContactId":{"location":"uri","locationName":"ContactId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"TagKeys":{"location":"querystring","locationName":"TagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"idempotent":true},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAgentStatus":{"http":{"requestUri":"/agent-status/{InstanceId}/{AgentStatusId}"},"input":{"type":"structure","required":["InstanceId","AgentStatusId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AgentStatusId":{"location":"uri","locationName":"AgentStatusId"},"Name":{},"Description":{},"State":{},"DisplayOrder":{"type":"integer"},"ResetOrderNumber":{"type":"boolean"}}}},"UpdateContact":{"http":{"requestUri":"/contacts/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"},"Name":{"shape":"Scf"},"Description":{"shape":"Scg"},"References":{"shape":"S7l"}}},"output":{"type":"structure","members":{}}},"UpdateContactAttributes":{"http":{"requestUri":"/contact/attributes"},"input":{"type":"structure","required":["InitialContactId","InstanceId","Attributes"],"members":{"InitialContactId":{},"InstanceId":{},"Attributes":{"shape":"S38"}}},"output":{"type":"structure","members":{}}},"UpdateContactEvaluation":{"http":{"requestUri":"/contact-evaluations/{InstanceId}/{EvaluationId}"},"input":{"type":"structure","required":["InstanceId","EvaluationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationId":{"location":"uri","locationName":"EvaluationId"},"Answers":{"shape":"Svo"},"Notes":{"shape":"Sd5"}}},"output":{"type":"structure","required":["EvaluationId","EvaluationArn"],"members":{"EvaluationId":{},"EvaluationArn":{}}}},"UpdateContactFlowContent":{"http":{"requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}/content"},"input":{"type":"structure","required":["InstanceId","ContactFlowId","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"},"Content":{}}},"output":{"type":"structure","members":{}}},"UpdateContactFlowMetadata":{"http":{"requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}/metadata"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"},"Name":{},"Description":{},"ContactFlowState":{}}},"output":{"type":"structure","members":{}}},"UpdateContactFlowModuleContent":{"http":{"requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}/content"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"},"Content":{}}},"output":{"type":"structure","members":{}}},"UpdateContactFlowModuleMetadata":{"http":{"requestUri":"/contact-flow-modules/{InstanceId}/{ContactFlowModuleId}/metadata"},"input":{"type":"structure","required":["InstanceId","ContactFlowModuleId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowModuleId":{"location":"uri","locationName":"ContactFlowModuleId"},"Name":{},"Description":{},"State":{}}},"output":{"type":"structure","members":{}}},"UpdateContactFlowName":{"http":{"requestUri":"/contact-flows/{InstanceId}/{ContactFlowId}/name"},"input":{"type":"structure","required":["InstanceId","ContactFlowId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactFlowId":{"location":"uri","locationName":"ContactFlowId"},"Name":{},"Description":{}}},"output":{"type":"structure","members":{}}},"UpdateContactRoutingData":{"http":{"requestUri":"/contacts/{InstanceId}/{ContactId}/routing-data"},"input":{"type":"structure","required":["InstanceId","ContactId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"},"QueueTimeAdjustmentSeconds":{"type":"integer"},"QueuePriority":{"type":"long"}}},"output":{"type":"structure","members":{}}},"UpdateContactSchedule":{"http":{"requestUri":"/contact/schedule"},"input":{"type":"structure","required":["InstanceId","ContactId","ScheduledTime"],"members":{"InstanceId":{},"ContactId":{},"ScheduledTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{}}},"UpdateEvaluationForm":{"http":{"method":"PUT","requestUri":"/evaluation-forms/{InstanceId}/{EvaluationFormId}"},"input":{"type":"structure","required":["InstanceId","EvaluationFormId","EvaluationFormVersion","Title","Items"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"EvaluationFormId":{"location":"uri","locationName":"EvaluationFormId"},"EvaluationFormVersion":{"type":"integer"},"CreateNewVersion":{"type":"boolean"},"Title":{},"Description":{},"Items":{"shape":"S4d"},"ScoringStrategy":{"shape":"S58"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","required":["EvaluationFormId","EvaluationFormArn","EvaluationFormVersion"],"members":{"EvaluationFormId":{},"EvaluationFormArn":{},"EvaluationFormVersion":{"type":"integer"}}},"idempotent":true},"UpdateHoursOfOperation":{"http":{"requestUri":"/hours-of-operations/{InstanceId}/{HoursOfOperationId}"},"input":{"type":"structure","required":["InstanceId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"HoursOfOperationId":{"location":"uri","locationName":"HoursOfOperationId"},"Name":{},"Description":{},"TimeZone":{},"Config":{"shape":"S5g"}}}},"UpdateInstanceAttribute":{"http":{"requestUri":"/instance/{InstanceId}/attribute/{AttributeType}"},"input":{"type":"structure","required":["InstanceId","AttributeType","Value"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AttributeType":{"location":"uri","locationName":"AttributeType"},"Value":{}}}},"UpdateInstanceStorageConfig":{"http":{"requestUri":"/instance/{InstanceId}/storage-config/{AssociationId}"},"input":{"type":"structure","required":["InstanceId","AssociationId","ResourceType","StorageConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"AssociationId":{"location":"uri","locationName":"AssociationId"},"ResourceType":{"location":"querystring","locationName":"resourceType"},"StorageConfig":{"shape":"St"}}}},"UpdateParticipantRoleConfig":{"http":{"method":"PUT","requestUri":"/contact/participant-role-config/{InstanceId}/{ContactId}"},"input":{"type":"structure","required":["InstanceId","ContactId","ChannelConfiguration"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ContactId":{"location":"uri","locationName":"ContactId"},"ChannelConfiguration":{"type":"structure","members":{"Chat":{"type":"structure","required":["ParticipantTimerConfigList"],"members":{"ParticipantTimerConfigList":{"type":"list","member":{"type":"structure","required":["ParticipantRole","TimerType","TimerValue"],"members":{"ParticipantRole":{},"TimerType":{},"TimerValue":{"type":"structure","members":{"ParticipantTimerAction":{},"ParticipantTimerDurationInMinutes":{"type":"integer"}},"union":true}}}}}}},"union":true}}},"output":{"type":"structure","members":{}}},"UpdatePhoneNumber":{"http":{"method":"PUT","requestUri":"/phone-number/{PhoneNumberId}"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"TargetArn":{},"InstanceId":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PhoneNumberId":{},"PhoneNumberArn":{}}}},"UpdatePhoneNumberMetadata":{"http":{"method":"PUT","requestUri":"/phone-number/{PhoneNumberId}/metadata"},"input":{"type":"structure","required":["PhoneNumberId"],"members":{"PhoneNumberId":{"location":"uri","locationName":"PhoneNumberId"},"PhoneNumberDescription":{},"ClientToken":{"idempotencyToken":true}}}},"UpdatePredefinedAttribute":{"http":{"requestUri":"/predefined-attributes/{InstanceId}/{Name}"},"input":{"type":"structure","required":["InstanceId","Name"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{"location":"uri","locationName":"Name"},"Values":{"shape":"S6e"}}}},"UpdatePrompt":{"http":{"requestUri":"/prompts/{InstanceId}/{PromptId}"},"input":{"type":"structure","required":["InstanceId","PromptId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"PromptId":{"location":"uri","locationName":"PromptId"},"Name":{},"Description":{},"S3Uri":{}}},"output":{"type":"structure","members":{"PromptARN":{},"PromptId":{}}}},"UpdateQueueHoursOfOperation":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/hours-of-operation"},"input":{"type":"structure","required":["InstanceId","QueueId","HoursOfOperationId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"HoursOfOperationId":{}}}},"UpdateQueueMaxContacts":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/max-contacts"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"MaxContacts":{"type":"integer"}}}},"UpdateQueueName":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/name"},"input":{"type":"structure","required":["InstanceId","QueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"Name":{},"Description":{}}}},"UpdateQueueOutboundCallerConfig":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/outbound-caller-config"},"input":{"type":"structure","required":["InstanceId","QueueId","OutboundCallerConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"OutboundCallerConfig":{"shape":"S6n"}}}},"UpdateQueueStatus":{"http":{"requestUri":"/queues/{InstanceId}/{QueueId}/status"},"input":{"type":"structure","required":["InstanceId","QueueId","Status"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QueueId":{"location":"uri","locationName":"QueueId"},"Status":{}}}},"UpdateQuickConnectConfig":{"http":{"requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}/config"},"input":{"type":"structure","required":["InstanceId","QuickConnectId","QuickConnectConfig"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"},"QuickConnectConfig":{"shape":"S6u"}}}},"UpdateQuickConnectName":{"http":{"requestUri":"/quick-connects/{InstanceId}/{QuickConnectId}/name"},"input":{"type":"structure","required":["InstanceId","QuickConnectId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"QuickConnectId":{"location":"uri","locationName":"QuickConnectId"},"Name":{},"Description":{}}}},"UpdateRoutingProfileAgentAvailabilityTimer":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/agent-availability-timer"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","AgentAvailabilityTimer"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"AgentAvailabilityTimer":{}}}},"UpdateRoutingProfileConcurrency":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/concurrency"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","MediaConcurrencies"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"MediaConcurrencies":{"shape":"S73"}}}},"UpdateRoutingProfileDefaultOutboundQueue":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/default-outbound-queue"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","DefaultOutboundQueueId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"DefaultOutboundQueueId":{}}}},"UpdateRoutingProfileName":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/name"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"Name":{},"Description":{}}}},"UpdateRoutingProfileQueues":{"http":{"requestUri":"/routing-profiles/{InstanceId}/{RoutingProfileId}/queues"},"input":{"type":"structure","required":["InstanceId","RoutingProfileId","QueueConfigs"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"RoutingProfileId":{"location":"uri","locationName":"RoutingProfileId"},"QueueConfigs":{"shape":"S1j"}}}},"UpdateRule":{"http":{"method":"PUT","requestUri":"/rules/{InstanceId}/{RuleId}"},"input":{"type":"structure","required":["RuleId","InstanceId","Name","Function","Actions","PublishStatus"],"members":{"RuleId":{"location":"uri","locationName":"RuleId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Function":{},"Actions":{"shape":"S7f"},"PublishStatus":{}}}},"UpdateSecurityProfile":{"http":{"requestUri":"/security-profiles/{InstanceId}/{SecurityProfileId}"},"input":{"type":"structure","required":["SecurityProfileId","InstanceId"],"members":{"Description":{},"Permissions":{"shape":"S8k"},"SecurityProfileId":{"location":"uri","locationName":"SecurityProfileId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"AllowedAccessControlTags":{"shape":"S8m"},"TagRestrictedResources":{"shape":"S8p"},"Applications":{"shape":"S8r"},"HierarchyRestrictedResources":{"shape":"S8w"},"AllowedAccessControlHierarchyGroupId":{}}}},"UpdateTaskTemplate":{"http":{"requestUri":"/instance/{InstanceId}/task/template/{TaskTemplateId}"},"input":{"type":"structure","required":["TaskTemplateId","InstanceId"],"members":{"TaskTemplateId":{"location":"uri","locationName":"TaskTemplateId"},"InstanceId":{"location":"uri","locationName":"InstanceId"},"Name":{},"Description":{},"ContactFlowId":{},"Constraints":{"shape":"S94"},"Defaults":{"shape":"S9d"},"Status":{},"Fields":{"shape":"S9i"}}},"output":{"type":"structure","members":{"InstanceId":{},"Id":{},"Arn":{},"Name":{},"Description":{},"ContactFlowId":{},"Constraints":{"shape":"S94"},"Defaults":{"shape":"S9d"},"Fields":{"shape":"S9i"},"Status":{},"LastModifiedTime":{"type":"timestamp"},"CreatedTime":{"type":"timestamp"}}}},"UpdateTrafficDistribution":{"http":{"method":"PUT","requestUri":"/traffic-distribution/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"TelephonyConfig":{"shape":"Sja"},"SignInConfig":{"shape":"Sjf"},"AgentConfig":{"shape":"Sji"}}},"output":{"type":"structure","members":{}}},"UpdateUserHierarchy":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/hierarchy"},"input":{"type":"structure","required":["UserId","InstanceId"],"members":{"HierarchyGroupId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserHierarchyGroupName":{"http":{"requestUri":"/user-hierarchy-groups/{InstanceId}/{HierarchyGroupId}/name"},"input":{"type":"structure","required":["Name","HierarchyGroupId","InstanceId"],"members":{"Name":{},"HierarchyGroupId":{"location":"uri","locationName":"HierarchyGroupId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserHierarchyStructure":{"http":{"requestUri":"/user-hierarchy-structure/{InstanceId}"},"input":{"type":"structure","required":["HierarchyStructure","InstanceId"],"members":{"HierarchyStructure":{"type":"structure","members":{"LevelOne":{"shape":"Sy0"},"LevelTwo":{"shape":"Sy0"},"LevelThree":{"shape":"Sy0"},"LevelFour":{"shape":"Sy0"},"LevelFive":{"shape":"Sy0"}}},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserIdentityInfo":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/identity-info"},"input":{"type":"structure","required":["IdentityInfo","UserId","InstanceId"],"members":{"IdentityInfo":{"shape":"Sa5"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserPhoneConfig":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/phone-config"},"input":{"type":"structure","required":["PhoneConfig","UserId","InstanceId"],"members":{"PhoneConfig":{"shape":"Sa9"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserProficiencies":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/proficiencies"},"input":{"type":"structure","required":["InstanceId","UserId","UserProficiencies"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"UserId":{"location":"uri","locationName":"UserId"},"UserProficiencies":{"shape":"S1x"}}}},"UpdateUserRoutingProfile":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/routing-profile"},"input":{"type":"structure","required":["RoutingProfileId","UserId","InstanceId"],"members":{"RoutingProfileId":{},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateUserSecurityProfiles":{"http":{"requestUri":"/users/{InstanceId}/{UserId}/security-profiles"},"input":{"type":"structure","required":["SecurityProfileIds","UserId","InstanceId"],"members":{"SecurityProfileIds":{"shape":"Sae"},"UserId":{"location":"uri","locationName":"UserId"},"InstanceId":{"location":"uri","locationName":"InstanceId"}}}},"UpdateViewContent":{"http":{"requestUri":"/views/{InstanceId}/{ViewId}"},"input":{"type":"structure","required":["InstanceId","ViewId","Status","Content"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ViewId":{"location":"uri","locationName":"ViewId"},"Status":{},"Content":{"shape":"San"}}},"output":{"type":"structure","members":{"View":{"shape":"Sau"}}}},"UpdateViewMetadata":{"http":{"requestUri":"/views/{InstanceId}/{ViewId}/metadata"},"input":{"type":"structure","required":["InstanceId","ViewId"],"members":{"InstanceId":{"location":"uri","locationName":"InstanceId"},"ViewId":{"location":"uri","locationName":"ViewId"},"Name":{"shape":"Sas"},"Description":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sf":{"type":"structure","required":["Name","LexRegion"],"members":{"Name":{},"LexRegion":{}}},"Si":{"type":"structure","members":{"AliasArn":{}}},"St":{"type":"structure","required":["StorageType"],"members":{"AssociationId":{},"StorageType":{},"S3Config":{"type":"structure","required":["BucketName","BucketPrefix"],"members":{"BucketName":{},"BucketPrefix":{},"EncryptionConfig":{"shape":"Sz"}}},"KinesisVideoStreamConfig":{"type":"structure","required":["Prefix","RetentionPeriodHours","EncryptionConfig"],"members":{"Prefix":{},"RetentionPeriodHours":{"type":"integer"},"EncryptionConfig":{"shape":"Sz"}}},"KinesisStreamConfig":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{}}},"KinesisFirehoseConfig":{"type":"structure","required":["FirehoseArn"],"members":{"FirehoseArn":{}}}}},"Sz":{"type":"structure","required":["EncryptionType","KeyId"],"members":{"EncryptionType":{},"KeyId":{}}},"S1f":{"type":"list","member":{}},"S1j":{"type":"list","member":{"type":"structure","required":["QueueReference","Priority","Delay"],"members":{"QueueReference":{"shape":"S1l"},"Priority":{"type":"integer"},"Delay":{"type":"integer"}}}},"S1l":{"type":"structure","required":["QueueId","Channel"],"members":{"QueueId":{},"Channel":{}}},"S1x":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeValue","Level"],"members":{"AttributeName":{},"AttributeValue":{},"Level":{"type":"float"}}}},"S23":{"type":"list","member":{}},"S25":{"type":"list","member":{"type":"structure","members":{"DataSetId":{},"TargetAccountId":{},"ResourceShareId":{},"ResourceShareArn":{}}}},"S27":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}},"S2l":{"type":"structure","members":{"ConnectUserArn":{},"AWSIdentityArn":{}},"union":true},"S2n":{"type":"map","key":{},"value":{}},"S2y":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"FlowId":{},"ResourceType":{}}}},"S34":{"type":"structure","members":{"Type":{},"Address":{}}},"S38":{"type":"map","key":{},"value":{}},"S4d":{"type":"list","member":{"type":"structure","members":{"Section":{"type":"structure","required":["Title","RefId","Items"],"members":{"Title":{},"RefId":{},"Instructions":{},"Items":{"shape":"S4d"},"Weight":{"type":"double"}}},"Question":{"type":"structure","required":["Title","RefId","QuestionType"],"members":{"Title":{},"Instructions":{},"RefId":{},"NotApplicableEnabled":{"type":"boolean"},"QuestionType":{},"QuestionTypeProperties":{"type":"structure","members":{"Numeric":{"type":"structure","required":["MinValue","MaxValue"],"members":{"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"Options":{"type":"list","member":{"type":"structure","required":["MinValue","MaxValue"],"members":{"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"Score":{"type":"integer"},"AutomaticFail":{"type":"boolean"}}}},"Automation":{"type":"structure","members":{"PropertyValue":{"type":"structure","required":["Label"],"members":{"Label":{}}}},"union":true}}},"SingleSelect":{"type":"structure","required":["Options"],"members":{"Options":{"type":"list","member":{"type":"structure","required":["RefId","Text"],"members":{"RefId":{},"Text":{},"Score":{"type":"integer"},"AutomaticFail":{"type":"boolean"}}}},"DisplayAs":{},"Automation":{"type":"structure","required":["Options"],"members":{"Options":{"type":"list","member":{"type":"structure","members":{"RuleCategory":{"type":"structure","required":["Category","Condition","OptionRefId"],"members":{"Category":{},"Condition":{},"OptionRefId":{}}}},"union":true}},"DefaultOptionRefId":{}}}}}},"union":true},"Weight":{"type":"double"}}}},"union":true}},"S58":{"type":"structure","required":["Mode","Status"],"members":{"Mode":{},"Status":{}}},"S5g":{"type":"list","member":{"type":"structure","required":["Day","StartTime","EndTime"],"members":{"Day":{},"StartTime":{"shape":"S5j"},"EndTime":{"shape":"S5j"}}}},"S5j":{"type":"structure","required":["Hours","Minutes"],"members":{"Hours":{"type":"integer"},"Minutes":{"type":"integer"}}},"S5q":{"type":"string","sensitive":true},"S6e":{"type":"structure","members":{"StringList":{"type":"list","member":{}}},"union":true},"S6n":{"type":"structure","members":{"OutboundCallerIdName":{},"OutboundCallerIdNumberId":{},"OutboundFlowId":{}}},"S6u":{"type":"structure","required":["QuickConnectType"],"members":{"QuickConnectType":{},"UserConfig":{"type":"structure","required":["UserId","ContactFlowId"],"members":{"UserId":{},"ContactFlowId":{}}},"QueueConfig":{"type":"structure","required":["QueueId","ContactFlowId"],"members":{"QueueId":{},"ContactFlowId":{}}},"PhoneConfig":{"type":"structure","required":["PhoneNumber"],"members":{"PhoneNumber":{}}}}},"S73":{"type":"list","member":{"type":"structure","required":["Channel","Concurrency"],"members":{"Channel":{},"Concurrency":{"type":"integer"},"CrossChannelBehavior":{"type":"structure","required":["BehaviorType"],"members":{"BehaviorType":{}}}}}},"S7c":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"IntegrationAssociationId":{}}},"S7f":{"type":"list","member":{"type":"structure","required":["ActionType"],"members":{"ActionType":{},"TaskAction":{"type":"structure","required":["Name","ContactFlowId"],"members":{"Name":{},"Description":{},"ContactFlowId":{},"References":{"shape":"S7l"}}},"EventBridgeAction":{"type":"structure","required":["Name"],"members":{"Name":{}}},"AssignContactCategoryAction":{"type":"structure","members":{}},"SendNotificationAction":{"type":"structure","required":["DeliveryMethod","Content","ContentType","Recipient"],"members":{"DeliveryMethod":{},"Subject":{},"Content":{},"ContentType":{},"Recipient":{"type":"structure","members":{"UserTags":{"type":"map","key":{},"value":{}},"UserIds":{"type":"list","member":{}}}}}},"CreateCaseAction":{"type":"structure","required":["Fields","TemplateId"],"members":{"Fields":{"shape":"S82"},"TemplateId":{}}},"UpdateCaseAction":{"type":"structure","required":["Fields"],"members":{"Fields":{"shape":"S82"}}},"EndAssociatedTasksAction":{"type":"structure","members":{}},"SubmitAutoEvaluationAction":{"type":"structure","required":["EvaluationFormId"],"members":{"EvaluationFormId":{}}}}}},"S7l":{"type":"map","key":{},"value":{"type":"structure","required":["Value","Type"],"members":{"Value":{},"Type":{}}}},"S82":{"type":"list","member":{"type":"structure","required":["Id","Value"],"members":{"Id":{},"Value":{"type":"structure","members":{"BooleanValue":{"type":"boolean"},"DoubleValue":{"type":"double"},"EmptyValue":{"type":"structure","members":{}},"StringValue":{}}}}}},"S8k":{"type":"list","member":{}},"S8m":{"type":"map","key":{},"value":{}},"S8p":{"type":"list","member":{}},"S8r":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"ApplicationPermissions":{"type":"list","member":{}}}}},"S8w":{"type":"list","member":{}},"S94":{"type":"structure","members":{"RequiredFields":{"type":"list","member":{"type":"structure","members":{"Id":{"shape":"S97"}}}},"ReadOnlyFields":{"type":"list","member":{"type":"structure","members":{"Id":{"shape":"S97"}}}},"InvisibleFields":{"type":"list","member":{"type":"structure","members":{"Id":{"shape":"S97"}}}}}},"S97":{"type":"structure","members":{"Name":{}}},"S9d":{"type":"structure","members":{"DefaultFieldValues":{"type":"list","member":{"type":"structure","members":{"Id":{"shape":"S97"},"DefaultValue":{}}}}}},"S9i":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{"shape":"S97"},"Description":{},"Type":{},"SingleSelectOptions":{"type":"list","member":{}}}}},"Sa5":{"type":"structure","members":{"FirstName":{"shape":"Sa6"},"LastName":{"shape":"Sa7"},"Email":{"shape":"Sa8"},"SecondaryEmail":{"shape":"Sa8"},"Mobile":{}}},"Sa6":{"type":"string","sensitive":true},"Sa7":{"type":"string","sensitive":true},"Sa8":{"type":"string","sensitive":true},"Sa9":{"type":"structure","required":["PhoneType"],"members":{"PhoneType":{},"AutoAccept":{"type":"boolean"},"AfterContactWorkTimeLimit":{"type":"integer"},"DeskPhoneNumber":{}}},"Sae":{"type":"list","member":{}},"San":{"type":"structure","members":{"Template":{},"Actions":{"shape":"Sap"}}},"Sap":{"type":"list","member":{"type":"string","sensitive":true}},"Sas":{"type":"string","sensitive":true},"Sau":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{"shape":"Sas"},"Status":{},"Type":{},"Description":{},"Version":{"type":"integer"},"VersionDescription":{},"Content":{"type":"structure","members":{"InputSchema":{"type":"string","sensitive":true},"Template":{},"Actions":{"shape":"Sap"}}},"Tags":{"shape":"S2n"},"CreatedTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"ViewContentSha256":{}}},"Scf":{"type":"string","sensitive":true},"Scg":{"type":"string","sensitive":true},"Scr":{"type":"map","key":{},"value":{}},"Scy":{"type":"structure","members":{"Percentage":{"type":"double"},"NotApplicable":{"type":"boolean"},"AutomaticFail":{"type":"boolean"}}},"Sd2":{"type":"structure","members":{"StringValue":{},"NumericValue":{"type":"double"},"NotApplicable":{"type":"boolean"}},"union":true},"Sd5":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{}}}},"Sdd":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Type":{},"State":{},"Status":{},"Description":{},"Content":{},"Tags":{"shape":"S2n"}}},"Sdh":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Content":{},"Description":{},"State":{},"Status":{},"Tags":{"shape":"S2n"}}},"Sdr":{"type":"structure","members":{"HoursOfOperationId":{},"HoursOfOperationArn":{},"Name":{},"Description":{},"TimeZone":{},"Config":{"shape":"S5g"},"Tags":{"shape":"S2n"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}},"Se1":{"type":"structure","members":{"AttributeType":{},"Value":{}}},"Sef":{"type":"structure","members":{"Name":{},"Values":{"shape":"S6e"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}},"Sei":{"type":"structure","members":{"PromptARN":{},"PromptId":{},"Name":{},"Description":{},"Tags":{"shape":"S2n"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}},"Sel":{"type":"structure","members":{"Name":{},"QueueArn":{},"QueueId":{},"Description":{},"OutboundCallerConfig":{"shape":"S6n"},"HoursOfOperationId":{},"MaxContacts":{"type":"integer"},"Status":{},"Tags":{"shape":"S2n"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}},"Sep":{"type":"structure","members":{"QuickConnectARN":{},"QuickConnectId":{},"Name":{},"Description":{},"QuickConnectConfig":{"shape":"S6u"},"Tags":{"shape":"S2n"},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}},"Ses":{"type":"structure","members":{"InstanceId":{},"Name":{},"RoutingProfileArn":{},"RoutingProfileId":{},"Description":{},"MediaConcurrencies":{"shape":"S73"},"DefaultOutboundQueueId":{},"Tags":{"shape":"S2n"},"NumberOfAssociatedQueues":{"type":"long"},"NumberOfAssociatedUsers":{"type":"long"},"AgentAvailabilityTimer":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{},"IsDefault":{"type":"boolean"}}},"Sfe":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}},"Sfi":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}},"Sgj":{"type":"structure","members":{"Queues":{"shape":"Sgk"},"Channels":{"type":"list","member":{}},"RoutingProfiles":{"shape":"Sgm"},"RoutingStepExpressions":{"type":"list","member":{}}}},"Sgk":{"type":"list","member":{}},"Sgm":{"type":"list","member":{}},"Sgp":{"type":"list","member":{}},"Sgs":{"type":"structure","members":{"Name":{},"Unit":{}}},"Sh3":{"type":"structure","members":{"Queue":{"shape":"Sh4"},"Channel":{},"RoutingProfile":{"shape":"Sh5"},"RoutingStepExpression":{}}},"Sh4":{"type":"structure","members":{"Id":{},"Arn":{}}},"Sh5":{"type":"structure","members":{"Id":{},"Arn":{}}},"Shm":{"type":"structure","members":{"Id":{},"Arn":{}}},"Sho":{"type":"map","key":{},"value":{"type":"integer"}},"Shv":{"type":"string","sensitive":true},"Si0":{"type":"structure","members":{"Name":{},"Threshold":{"type":"structure","members":{"Comparison":{},"ThresholdValue":{"type":"double"}}},"Statistic":{},"Unit":{}}},"Sil":{"type":"structure","members":{"Name":{},"Threshold":{"type":"list","member":{"type":"structure","members":{"Comparison":{},"ThresholdValue":{"type":"double"}}}},"MetricFilters":{"type":"list","member":{"type":"structure","members":{"MetricFilterKey":{},"MetricFilterValues":{"type":"list","member":{}},"Negate":{"type":"boolean"}}}}}},"Sja":{"type":"structure","required":["Distributions"],"members":{"Distributions":{"shape":"Sjb"}}},"Sjb":{"type":"list","member":{"type":"structure","required":["Region","Percentage"],"members":{"Region":{},"Percentage":{"type":"integer"}}}},"Sjf":{"type":"structure","required":["Distributions"],"members":{"Distributions":{"type":"list","member":{"type":"structure","required":["Region","Enabled"],"members":{"Region":{},"Enabled":{"type":"boolean"}}}}}},"Sji":{"type":"structure","required":["Distributions"],"members":{"Distributions":{"shape":"Sjb"}}},"Sly":{"type":"list","member":{}},"Slz":{"type":"list","member":{}},"Smk":{"type":"list","member":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"QuickConnectType":{},"LastModifiedTime":{"type":"timestamp"},"LastModifiedRegion":{}}}},"Sn9":{"type":"structure","members":{"AbsoluteTime":{"type":"timestamp","timestampFormat":"iso8601"}},"union":true},"Snd":{"type":"structure","required":["BeginOffsetChar","EndOffsetChar"],"members":{"BeginOffsetChar":{"type":"integer"},"EndOffsetChar":{"type":"integer"}}},"Sqg":{"type":"structure","members":{"OrConditions":{"type":"list","member":{"shape":"Sqi"}},"AndConditions":{"shape":"Sqi"},"TagCondition":{"shape":"Sqj"}}},"Sqi":{"type":"list","member":{"shape":"Sqj"}},"Sqj":{"type":"structure","members":{"TagKey":{},"TagValue":{}}},"Sqk":{"type":"structure","members":{"OrConditions":{"shape":"Sql"},"AndConditions":{"shape":"Sql"},"StringCondition":{"shape":"Sqm"}}},"Sql":{"type":"list","member":{"shape":"Sqk"}},"Sqm":{"type":"structure","members":{"FieldName":{},"Value":{},"ComparisonType":{}}},"Sqs":{"type":"structure","members":{"OrConditions":{"shape":"Sqt"},"AndConditions":{"shape":"Sqt"},"StringCondition":{"shape":"Sqm"},"TypeCondition":{},"StateCondition":{},"StatusCondition":{}}},"Sqt":{"type":"list","member":{"shape":"Sqs"}},"Sr2":{"type":"list","member":{}},"Srt":{"type":"structure","members":{"OrConditions":{"shape":"Sru"},"AndConditions":{"shape":"Sru"},"StringCondition":{"shape":"Sqm"}}},"Sru":{"type":"list","member":{"shape":"Srt"}},"Sry":{"type":"structure","members":{"OrConditions":{"shape":"Srz"},"AndConditions":{"shape":"Srz"},"StringCondition":{"shape":"Sqm"}}},"Srz":{"type":"list","member":{"shape":"Sry"}},"Ss4":{"type":"structure","members":{"OrConditions":{"shape":"Ss5"},"AndConditions":{"shape":"Ss5"},"StringCondition":{"shape":"Sqm"}}},"Ss5":{"type":"list","member":{"shape":"Ss4"}},"Ssb":{"type":"structure","members":{"OrConditions":{"shape":"Ssc"},"AndConditions":{"shape":"Ssc"},"StringCondition":{"shape":"Sqm"},"QueueTypeCondition":{}}},"Ssc":{"type":"list","member":{"shape":"Ssb"}},"Ssi":{"type":"structure","members":{"OrConditions":{"shape":"Ssj"},"AndConditions":{"shape":"Ssj"},"StringCondition":{"shape":"Sqm"}}},"Ssj":{"type":"list","member":{"shape":"Ssi"}},"Ssx":{"type":"structure","members":{"OrConditions":{"shape":"Ssy"},"AndConditions":{"shape":"Ssy"},"StringCondition":{"shape":"Sqm"}}},"Ssy":{"type":"list","member":{"shape":"Ssx"}},"St2":{"type":"structure","members":{"OrConditions":{"shape":"St3"},"AndConditions":{"shape":"St3"},"StringCondition":{"shape":"Sqm"}}},"St3":{"type":"list","member":{"shape":"St2"}},"Stc":{"type":"structure","members":{"TagConditions":{"shape":"Sqi"},"HierarchyGroupCondition":{"shape":"Std"}}},"Std":{"type":"structure","members":{"Value":{},"HierarchyGroupMatchType":{}}},"Stf":{"type":"structure","members":{"OrConditions":{"shape":"Stg"},"AndConditions":{"shape":"Stg"},"StringCondition":{"shape":"Sqm"},"HierarchyGroupCondition":{"shape":"Std"}}},"Stg":{"type":"list","member":{"shape":"Stf"}},"Sty":{"type":"list","member":{}},"Su0":{"type":"structure","required":["DisplayName"],"members":{"DisplayName":{}}},"Su1":{"type":"structure","required":["StreamingEndpointArn"],"members":{"StreamingEndpointArn":{}}},"Sv1":{"type":"structure","members":{"Video":{}}},"Svo":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"Sd2"}}}},"Sy0":{"type":"structure","required":["Name"],"members":{"Name":{}}}}}

/***/ }),
/* 462 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetCurrentMetricData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetCurrentUserData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMetricData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMetricDataV2":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListAgentStatuses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AgentStatusSummaryList"},"ListApprovedOrigins":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Origins"},"ListBots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LexBots"},"ListContactEvaluations":{"input_token":"NextToken","output_token":"NextToken","result_key":"EvaluationSummaryList"},"ListContactFlowModules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ContactFlowModulesSummaryList"},"ListContactFlows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ContactFlowSummaryList"},"ListContactReferences":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReferenceSummaryList"},"ListDefaultVocabularies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DefaultVocabularyList"},"ListEvaluationFormVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EvaluationFormVersionSummaryList"},"ListEvaluationForms":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EvaluationFormSummaryList"},"ListFlowAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FlowAssociationSummaryList"},"ListHoursOfOperations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HoursOfOperationSummaryList"},"ListInstanceAttributes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Attributes"},"ListInstanceStorageConfigs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StorageConfigs"},"ListInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceSummaryList"},"ListIntegrationAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IntegrationAssociationSummaryList"},"ListLambdaFunctions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LambdaFunctions"},"ListLexBots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LexBots"},"ListPhoneNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PhoneNumberSummaryList"},"ListPhoneNumbersV2":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ListPhoneNumbersSummaryList"},"ListPredefinedAttributes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PredefinedAttributeSummaryList"},"ListPrompts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PromptSummaryList"},"ListQueueQuickConnects":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["LastModifiedRegion","LastModifiedTime"],"output_token":"NextToken","result_key":"QuickConnectSummaryList"},"ListQueues":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueueSummaryList"},"ListQuickConnects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QuickConnectSummaryList"},"ListRealtimeContactAnalysisSegmentsV2":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListRoutingProfileQueues":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["LastModifiedRegion","LastModifiedTime"],"output_token":"NextToken","result_key":"RoutingProfileQueueConfigSummaryList"},"ListRoutingProfiles":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RoutingProfileSummaryList"},"ListRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RuleSummaryList"},"ListSecurityKeys":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityKeys"},"ListSecurityProfileApplications":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["LastModifiedRegion","LastModifiedTime"],"output_token":"NextToken","result_key":"Applications"},"ListSecurityProfilePermissions":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["LastModifiedRegion","LastModifiedTime"],"output_token":"NextToken","result_key":"Permissions"},"ListSecurityProfiles":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityProfileSummaryList"},"ListTaskTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TaskTemplates"},"ListTrafficDistributionGroupUsers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficDistributionGroupUserSummaryList"},"ListTrafficDistributionGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficDistributionGroupSummaryList"},"ListUseCases":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UseCaseSummaryList"},"ListUserHierarchyGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserHierarchyGroupSummaryList"},"ListUserProficiencies":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["LastModifiedTime","LastModifiedRegion"],"output_token":"NextToken","result_key":"UserProficiencyList"},"ListUsers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"UserSummaryList"},"ListViewVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ViewVersionSummaryList"},"ListViews":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ViewsSummaryList"},"SearchAvailablePhoneNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AvailableNumbersList"},"SearchContactFlowModules":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"ContactFlowModules"},"SearchContactFlows":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"ContactFlows"},"SearchContacts":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["TotalCount"],"output_token":"NextToken","result_key":"Contacts"},"SearchHoursOfOperations":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"HoursOfOperations"},"SearchPredefinedAttributes":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"PredefinedAttributes"},"SearchPrompts":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"Prompts"},"SearchQueues":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"Queues"},"SearchQuickConnects":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"QuickConnects"},"SearchResourceTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"SearchRoutingProfiles":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"RoutingProfiles"},"SearchSecurityProfiles":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"SecurityProfiles"},"SearchUsers":{"input_token":"NextToken","limit_key":"MaxResults","non_aggregate_keys":["ApproximateTotalCount"],"output_token":"NextToken","result_key":"Users"},"SearchVocabularies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VocabularySummaryList"}}}

/***/ }),
/* 463 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-06","endpointPrefix":"cur","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Cost and Usage Report Service","serviceId":"Cost and Usage Report Service","signatureVersion":"v4","signingName":"cur","targetPrefix":"AWSOrigamiServiceGatewayService","uid":"cur-2017-01-06"},"operations":{"DeleteReportDefinition":{"input":{"type":"structure","required":["ReportName"],"members":{"ReportName":{}}},"output":{"type":"structure","members":{"ResponseMessage":{}}}},"DescribeReportDefinitions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ReportDefinitions":{"type":"list","member":{"shape":"Sa"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ReportName"],"members":{"ReportName":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"St"}}}},"ModifyReportDefinition":{"input":{"type":"structure","required":["ReportName","ReportDefinition"],"members":{"ReportName":{},"ReportDefinition":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"PutReportDefinition":{"input":{"type":"structure","required":["ReportDefinition"],"members":{"ReportDefinition":{"shape":"Sa"},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ReportName","Tags"],"members":{"ReportName":{},"Tags":{"shape":"St"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ReportName","TagKeys"],"members":{"ReportName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sa":{"type":"structure","required":["ReportName","TimeUnit","Format","Compression","AdditionalSchemaElements","S3Bucket","S3Prefix","S3Region"],"members":{"ReportName":{},"TimeUnit":{},"Format":{},"Compression":{},"AdditionalSchemaElements":{"type":"list","member":{}},"S3Bucket":{},"S3Prefix":{},"S3Region":{},"AdditionalArtifacts":{"type":"list","member":{}},"RefreshClosedReports":{"type":"boolean"},"ReportVersioning":{},"BillingViewArn":{},"ReportStatus":{"type":"structure","members":{"lastDelivery":{},"lastStatus":{}}}}},"St":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 464 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeReportDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 465 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-06-23","endpointPrefix":"devicefarm","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Device Farm","serviceId":"Device Farm","signatureVersion":"v4","targetPrefix":"DeviceFarm_20150623","uid":"devicefarm-2015-06-23"},"operations":{"CreateDevicePool":{"input":{"type":"structure","required":["projectArn","name","rules"],"members":{"projectArn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"CreateNetworkProfile":{"input":{"type":"structure","required":["projectArn","name"],"members":{"projectArn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"CreateProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"vpcConfig":{"shape":"Sr"}}},"output":{"type":"structure","members":{"project":{"shape":"Sy"}}}},"CreateRemoteAccessSession":{"input":{"type":"structure","required":["projectArn","deviceArn"],"members":{"projectArn":{},"deviceArn":{},"instanceArn":{},"sshPublicKey":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"name":{},"clientId":{},"configuration":{"type":"structure","members":{"billingMethod":{},"vpceConfigurationArns":{"shape":"S15"}}},"interactionMode":{},"skipAppResign":{"type":"boolean"}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S18"}}}},"CreateTestGridProject":{"input":{"type":"structure","required":["name"],"members":{"name":{},"description":{},"vpcConfig":{"shape":"S1s"}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1w"}}}},"CreateTestGridUrl":{"input":{"type":"structure","required":["projectArn","expiresInSeconds"],"members":{"projectArn":{},"expiresInSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"url":{"shape":"S21"},"expires":{"type":"timestamp"}}}},"CreateUpload":{"input":{"type":"structure","required":["projectArn","name","type"],"members":{"projectArn":{},"name":{},"type":{},"contentType":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S26"}}}},"CreateVPCEConfiguration":{"input":{"type":"structure","required":["vpceConfigurationName","vpceServiceName","serviceDnsName"],"members":{"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S2h"}}}},"DeleteDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{}}},"output":{"type":"structure","members":{}}},"DeleteUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"DeleteVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{}}},"GetAccountSettings":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"accountSettings":{"type":"structure","members":{"awsAccountNumber":{},"unmeteredDevices":{"shape":"S34"},"unmeteredRemoteAccessDevices":{"shape":"S34"},"maxJobTimeoutMinutes":{"type":"integer"},"trialMinutes":{"type":"structure","members":{"total":{"type":"double"},"remaining":{"type":"double"}}},"maxSlots":{"type":"map","key":{},"value":{"type":"integer"}},"defaultJobTimeoutMinutes":{"type":"integer"},"skipAppResign":{"type":"boolean"}}}}}},"GetDevice":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"device":{"shape":"S1b"}}}},"GetDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1i"}}}},"GetDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"GetDevicePoolCompatibility":{"input":{"type":"structure","required":["devicePoolArn"],"members":{"devicePoolArn":{},"appArn":{},"testType":{},"test":{"shape":"S3f"},"configuration":{"shape":"S3i"}}},"output":{"type":"structure","members":{"compatibleDevices":{"shape":"S3q"},"incompatibleDevices":{"shape":"S3q"}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"GetJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3y"}}}},"GetNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"GetOfferingStatus":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"current":{"shape":"S46"},"nextPeriod":{"shape":"S46"},"nextToken":{}}}},"GetProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"project":{"shape":"Sy"}}}},"GetRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S18"}}}},"GetRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S4n"}}}},"GetSuite":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"suite":{"shape":"S4w"}}}},"GetTest":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"test":{"shape":"S4z"}}}},"GetTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1w"}}}},"GetTestGridSession":{"input":{"type":"structure","members":{"projectArn":{},"sessionId":{},"sessionArn":{}}},"output":{"type":"structure","members":{"testGridSession":{"shape":"S55"}}}},"GetUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"upload":{"shape":"S26"}}}},"GetVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S2h"}}}},"InstallToRemoteAccessSession":{"input":{"type":"structure","required":["remoteAccessSessionArn","appArn"],"members":{"remoteAccessSessionArn":{},"appArn":{}}},"output":{"type":"structure","members":{"appUpload":{"shape":"S26"}}}},"ListArtifacts":{"input":{"type":"structure","required":["arn","type"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"arn":{},"name":{},"type":{},"extension":{},"url":{}}}},"nextToken":{}}}},"ListDeviceInstances":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"deviceInstances":{"shape":"S1h"},"nextToken":{}}}},"ListDevicePools":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"devicePools":{"type":"list","member":{"shape":"Sc"}},"nextToken":{}}}},"ListDevices":{"input":{"type":"structure","members":{"arn":{},"nextToken":{},"filters":{"shape":"S4q"}}},"output":{"type":"structure","members":{"devices":{"type":"list","member":{"shape":"S1b"}},"nextToken":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"instanceProfiles":{"type":"list","member":{"shape":"Si"}},"nextToken":{}}}},"ListJobs":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"shape":"S3y"}},"nextToken":{}}}},"ListNetworkProfiles":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"networkProfiles":{"type":"list","member":{"shape":"So"}},"nextToken":{}}}},"ListOfferingPromotions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringPromotions":{"type":"list","member":{"type":"structure","members":{"id":{},"description":{}}}},"nextToken":{}}}},"ListOfferingTransactions":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offeringTransactions":{"type":"list","member":{"shape":"S69"}},"nextToken":{}}}},"ListOfferings":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"type":"structure","members":{"offerings":{"type":"list","member":{"shape":"S4a"}},"nextToken":{}}}},"ListProjects":{"input":{"type":"structure","members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"projects":{"type":"list","member":{"shape":"Sy"}},"nextToken":{}}}},"ListRemoteAccessSessions":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"remoteAccessSessions":{"type":"list","member":{"shape":"S18"}},"nextToken":{}}}},"ListRuns":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"runs":{"type":"list","member":{"shape":"S4n"}},"nextToken":{}}}},"ListSamples":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"samples":{"type":"list","member":{"type":"structure","members":{"arn":{},"type":{},"url":{}}}},"nextToken":{}}}},"ListSuites":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"suites":{"type":"list","member":{"shape":"S4w"}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S6x"}}}},"ListTestGridProjects":{"input":{"type":"structure","members":{"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"testGridProjects":{"type":"list","member":{"shape":"S1w"}},"nextToken":{}}}},"ListTestGridSessionActions":{"input":{"type":"structure","required":["sessionArn"],"members":{"sessionArn":{},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"actions":{"type":"list","member":{"type":"structure","members":{"action":{},"started":{"type":"timestamp"},"duration":{"type":"long"},"statusCode":{},"requestMethod":{}}}},"nextToken":{}}}},"ListTestGridSessionArtifacts":{"input":{"type":"structure","required":["sessionArn"],"members":{"sessionArn":{},"type":{},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"artifacts":{"type":"list","member":{"type":"structure","members":{"filename":{},"type":{},"url":{"shape":"S21"}}}},"nextToken":{}}}},"ListTestGridSessions":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{},"status":{},"creationTimeAfter":{"type":"timestamp"},"creationTimeBefore":{"type":"timestamp"},"endTimeAfter":{"type":"timestamp"},"endTimeBefore":{"type":"timestamp"},"maxResult":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"testGridSessions":{"type":"list","member":{"shape":"S55"}},"nextToken":{}}}},"ListTests":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"tests":{"type":"list","member":{"shape":"S4z"}},"nextToken":{}}}},"ListUniqueProblems":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"nextToken":{}}},"output":{"type":"structure","members":{"uniqueProblems":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"message":{},"problems":{"type":"list","member":{"type":"structure","members":{"run":{"shape":"S7s"},"job":{"shape":"S7s"},"suite":{"shape":"S7s"},"test":{"shape":"S7s"},"device":{"shape":"S1b"},"result":{},"message":{}}}}}}}},"nextToken":{}}}},"ListUploads":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"type":{},"nextToken":{}}},"output":{"type":"structure","members":{"uploads":{"type":"list","member":{"shape":"S26"}},"nextToken":{}}}},"ListVPCEConfigurations":{"input":{"type":"structure","members":{"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"vpceConfigurations":{"type":"list","member":{"shape":"S2h"}},"nextToken":{}}}},"PurchaseOffering":{"input":{"type":"structure","required":["offeringId","quantity"],"members":{"offeringId":{},"quantity":{"type":"integer"},"offeringPromotionId":{}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S69"}}}},"RenewOffering":{"input":{"type":"structure","required":["offeringId","quantity"],"members":{"offeringId":{},"quantity":{"type":"integer"}}},"output":{"type":"structure","members":{"offeringTransaction":{"shape":"S69"}}}},"ScheduleRun":{"input":{"type":"structure","required":["projectArn","test"],"members":{"projectArn":{},"appArn":{},"devicePoolArn":{},"deviceSelectionConfiguration":{"type":"structure","required":["filters","maxDevices"],"members":{"filters":{"shape":"S4q"},"maxDevices":{"type":"integer"}}},"name":{},"test":{"shape":"S3f"},"configuration":{"shape":"S3i"},"executionConfiguration":{"type":"structure","members":{"jobTimeoutMinutes":{"type":"integer"},"accountsCleanup":{"type":"boolean"},"appPackagesCleanup":{"type":"boolean"},"videoCapture":{"type":"boolean"},"skipAppResign":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"run":{"shape":"S4n"}}}},"StopJob":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"job":{"shape":"S3y"}}}},"StopRemoteAccessSession":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"remoteAccessSession":{"shape":"S18"}}}},"StopRun":{"input":{"type":"structure","required":["arn"],"members":{"arn":{}}},"output":{"type":"structure","members":{"run":{"shape":"S4n"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S6x"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDeviceInstance":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"profileArn":{},"labels":{"shape":"S1j"}}},"output":{"type":"structure","members":{"deviceInstance":{"shape":"S1i"}}}},"UpdateDevicePool":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"},"clearMaxDevices":{"type":"boolean"}}},"output":{"type":"structure","members":{"devicePool":{"shape":"Sc"}}}},"UpdateInstanceProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"}}},"output":{"type":"structure","members":{"instanceProfile":{"shape":"Si"}}}},"UpdateNetworkProfile":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"output":{"type":"structure","members":{"networkProfile":{"shape":"So"}}}},"UpdateProject":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"vpcConfig":{"shape":"Sr"}}},"output":{"type":"structure","members":{"project":{"shape":"Sy"}}}},"UpdateTestGridProject":{"input":{"type":"structure","required":["projectArn"],"members":{"projectArn":{},"name":{},"description":{},"vpcConfig":{"shape":"S1s"}}},"output":{"type":"structure","members":{"testGridProject":{"shape":"S1w"}}}},"UpdateUpload":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"name":{},"contentType":{},"editContent":{"type":"boolean"}}},"output":{"type":"structure","members":{"upload":{"shape":"S26"}}}},"UpdateVPCEConfiguration":{"input":{"type":"structure","required":["arn"],"members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"output":{"type":"structure","members":{"vpceConfiguration":{"shape":"S2h"}}}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"attribute":{},"operator":{},"value":{}}}},"Sc":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"rules":{"shape":"S5"},"maxDevices":{"type":"integer"}}},"Sg":{"type":"list","member":{}},"Si":{"type":"structure","members":{"arn":{},"packageCleanup":{"type":"boolean"},"excludeAppPackagesFromCleanup":{"shape":"Sg"},"rebootAfterUse":{"type":"boolean"},"name":{},"description":{}}},"So":{"type":"structure","members":{"arn":{},"name":{},"description":{},"type":{},"uplinkBandwidthBits":{"type":"long"},"downlinkBandwidthBits":{"type":"long"},"uplinkDelayMs":{"type":"long"},"downlinkDelayMs":{"type":"long"},"uplinkJitterMs":{"type":"long"},"downlinkJitterMs":{"type":"long"},"uplinkLossPercent":{"type":"integer"},"downlinkLossPercent":{"type":"integer"}}},"Sr":{"type":"structure","required":["securityGroupIds","subnetIds","vpcId"],"members":{"securityGroupIds":{"type":"list","member":{}},"subnetIds":{"type":"list","member":{}},"vpcId":{}}},"Sy":{"type":"structure","members":{"arn":{},"name":{},"defaultJobTimeoutMinutes":{"type":"integer"},"created":{"type":"timestamp"},"vpcConfig":{"shape":"Sr"}}},"S15":{"type":"list","member":{}},"S18":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"status":{},"result":{},"message":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"device":{"shape":"S1b"},"instanceArn":{},"remoteDebugEnabled":{"type":"boolean"},"remoteRecordEnabled":{"type":"boolean"},"remoteRecordAppArn":{},"hostAddress":{},"clientId":{},"billingMethod":{},"deviceMinutes":{"shape":"S1n"},"endpoint":{},"deviceUdid":{},"interactionMode":{},"skipAppResign":{"type":"boolean"},"vpcConfig":{"shape":"Sr"}}},"S1b":{"type":"structure","members":{"arn":{},"name":{},"manufacturer":{},"model":{},"modelId":{},"formFactor":{},"platform":{},"os":{},"cpu":{"type":"structure","members":{"frequency":{},"architecture":{},"clock":{"type":"double"}}},"resolution":{"type":"structure","members":{"width":{"type":"integer"},"height":{"type":"integer"}}},"heapSize":{"type":"long"},"memory":{"type":"long"},"image":{},"carrier":{},"radio":{},"remoteAccessEnabled":{"type":"boolean"},"remoteDebugEnabled":{"type":"boolean"},"fleetType":{},"fleetName":{},"instances":{"shape":"S1h"},"availability":{}}},"S1h":{"type":"list","member":{"shape":"S1i"}},"S1i":{"type":"structure","members":{"arn":{},"deviceArn":{},"labels":{"shape":"S1j"},"status":{},"udid":{},"instanceProfile":{"shape":"Si"}}},"S1j":{"type":"list","member":{}},"S1n":{"type":"structure","members":{"total":{"type":"double"},"metered":{"type":"double"},"unmetered":{"type":"double"}}},"S1s":{"type":"structure","required":["securityGroupIds","subnetIds","vpcId"],"members":{"securityGroupIds":{"type":"list","member":{}},"subnetIds":{"type":"list","member":{}},"vpcId":{}}},"S1w":{"type":"structure","members":{"arn":{},"name":{},"description":{},"vpcConfig":{"shape":"S1s"},"created":{"type":"timestamp"}}},"S21":{"type":"string","sensitive":true},"S26":{"type":"structure","members":{"arn":{},"name":{},"created":{"type":"timestamp"},"type":{},"status":{},"url":{"type":"string","sensitive":true},"metadata":{},"contentType":{},"message":{},"category":{}}},"S2h":{"type":"structure","members":{"arn":{},"vpceConfigurationName":{},"vpceServiceName":{},"serviceDnsName":{},"vpceConfigurationDescription":{}}},"S34":{"type":"map","key":{},"value":{"type":"integer"}},"S3f":{"type":"structure","required":["type"],"members":{"type":{},"testPackageArn":{},"testSpecArn":{},"filter":{},"parameters":{"type":"map","key":{},"value":{}}}},"S3i":{"type":"structure","members":{"extraDataPackageArn":{},"networkProfileArn":{},"locale":{},"location":{"shape":"S3j"},"vpceConfigurationArns":{"shape":"S15"},"customerArtifactPaths":{"shape":"S3k"},"radios":{"shape":"S3o"},"auxiliaryApps":{"shape":"S15"},"billingMethod":{}}},"S3j":{"type":"structure","required":["latitude","longitude"],"members":{"latitude":{"type":"double"},"longitude":{"type":"double"}}},"S3k":{"type":"structure","members":{"iosPaths":{"type":"list","member":{}},"androidPaths":{"type":"list","member":{}},"deviceHostPaths":{"type":"list","member":{}}}},"S3o":{"type":"structure","members":{"wifi":{"type":"boolean"},"bluetooth":{"type":"boolean"},"nfc":{"type":"boolean"},"gps":{"type":"boolean"}}},"S3q":{"type":"list","member":{"type":"structure","members":{"device":{"shape":"S1b"},"compatible":{"type":"boolean"},"incompatibilityMessages":{"type":"list","member":{"type":"structure","members":{"message":{},"type":{}}}}}}},"S3y":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3z"},"message":{},"device":{"shape":"S1b"},"instanceArn":{},"deviceMinutes":{"shape":"S1n"},"videoEndpoint":{},"videoCapture":{"type":"boolean"}}},"S3z":{"type":"structure","members":{"total":{"type":"integer"},"passed":{"type":"integer"},"failed":{"type":"integer"},"warned":{"type":"integer"},"errored":{"type":"integer"},"stopped":{"type":"integer"},"skipped":{"type":"integer"}}},"S46":{"type":"map","key":{},"value":{"shape":"S48"}},"S48":{"type":"structure","members":{"type":{},"offering":{"shape":"S4a"},"quantity":{"type":"integer"},"effectiveOn":{"type":"timestamp"}}},"S4a":{"type":"structure","members":{"id":{},"description":{},"type":{},"platform":{},"recurringCharges":{"type":"list","member":{"type":"structure","members":{"cost":{"shape":"S4e"},"frequency":{}}}}}},"S4e":{"type":"structure","members":{"amount":{"type":"double"},"currencyCode":{}}},"S4n":{"type":"structure","members":{"arn":{},"name":{},"type":{},"platform":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3z"},"message":{},"totalJobs":{"type":"integer"},"completedJobs":{"type":"integer"},"billingMethod":{},"deviceMinutes":{"shape":"S1n"},"networkProfile":{"shape":"So"},"parsingResultUrl":{},"resultCode":{},"seed":{"type":"integer"},"appUpload":{},"eventCount":{"type":"integer"},"jobTimeoutMinutes":{"type":"integer"},"devicePoolArn":{},"locale":{},"radios":{"shape":"S3o"},"location":{"shape":"S3j"},"customerArtifactPaths":{"shape":"S3k"},"webUrl":{},"skipAppResign":{"type":"boolean"},"testSpecArn":{},"deviceSelectionResult":{"type":"structure","members":{"filters":{"shape":"S4q"},"matchedDevicesCount":{"type":"integer"},"maxDevices":{"type":"integer"}}},"vpcConfig":{"shape":"Sr"}}},"S4q":{"type":"list","member":{"type":"structure","required":["attribute","operator","values"],"members":{"attribute":{},"operator":{},"values":{"type":"list","member":{}}}}},"S4w":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3z"},"message":{},"deviceMinutes":{"shape":"S1n"}}},"S4z":{"type":"structure","members":{"arn":{},"name":{},"type":{},"created":{"type":"timestamp"},"status":{},"result":{},"started":{"type":"timestamp"},"stopped":{"type":"timestamp"},"counters":{"shape":"S3z"},"message":{},"deviceMinutes":{"shape":"S1n"}}},"S55":{"type":"structure","members":{"arn":{},"status":{},"created":{"type":"timestamp"},"ended":{"type":"timestamp"},"billingMinutes":{"type":"double"},"seleniumProperties":{}}},"S69":{"type":"structure","members":{"offeringStatus":{"shape":"S48"},"transactionId":{},"offeringPromotionId":{},"createdOn":{"type":"timestamp"},"cost":{"shape":"S4e"}}},"S6x":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S7s":{"type":"structure","members":{"arn":{},"name":{}}}}}

/***/ }),
/* 466 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetOfferingStatus":{"input_token":"nextToken","output_token":"nextToken","result_key":["current","nextPeriod"]},"ListArtifacts":{"input_token":"nextToken","output_token":"nextToken","result_key":"artifacts"},"ListDevicePools":{"input_token":"nextToken","output_token":"nextToken","result_key":"devicePools"},"ListDevices":{"input_token":"nextToken","output_token":"nextToken","result_key":"devices"},"ListJobs":{"input_token":"nextToken","output_token":"nextToken","result_key":"jobs"},"ListOfferingTransactions":{"input_token":"nextToken","output_token":"nextToken","result_key":"offeringTransactions"},"ListOfferings":{"input_token":"nextToken","output_token":"nextToken","result_key":"offerings"},"ListProjects":{"input_token":"nextToken","output_token":"nextToken","result_key":"projects"},"ListRuns":{"input_token":"nextToken","output_token":"nextToken","result_key":"runs"},"ListSamples":{"input_token":"nextToken","output_token":"nextToken","result_key":"samples"},"ListSuites":{"input_token":"nextToken","output_token":"nextToken","result_key":"suites"},"ListTestGridProjects":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessionActions":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessionArtifacts":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTestGridSessions":{"input_token":"nextToken","limit_key":"maxResult","output_token":"nextToken"},"ListTests":{"input_token":"nextToken","output_token":"nextToken","result_key":"tests"},"ListUniqueProblems":{"input_token":"nextToken","output_token":"nextToken","result_key":"uniqueProblems"},"ListUploads":{"input_token":"nextToken","output_token":"nextToken","result_key":"uploads"}}}

/***/ }),
/* 467 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-10-25","endpointPrefix":"directconnect","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Direct Connect","serviceId":"Direct Connect","signatureVersion":"v4","targetPrefix":"OvertureService","uid":"directconnect-2012-10-25"},"operations":{"AcceptDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","proposalId","associatedGatewayOwnerAccount"],"members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayOwnerAccount":{},"overrideAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"AllocateConnectionOnInterconnect":{"input":{"type":"structure","required":["bandwidth","connectionName","ownerAccount","interconnectId","vlan"],"members":{"bandwidth":{},"connectionName":{},"ownerAccount":{},"interconnectId":{},"vlan":{"type":"integer"}}},"output":{"shape":"So"},"deprecated":true},"AllocateHostedConnection":{"input":{"type":"structure","required":["connectionId","ownerAccount","bandwidth","connectionName","vlan"],"members":{"connectionId":{},"ownerAccount":{},"bandwidth":{},"connectionName":{},"vlan":{"type":"integer"},"tags":{"shape":"S10"}}},"output":{"shape":"So"}},"AllocatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPrivateVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPrivateVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"addressFamily":{},"customerAddress":{},"tags":{"shape":"S10"}}}}},"output":{"shape":"S1o"}},"AllocatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newPublicVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newPublicVirtualInterfaceAllocation":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"S10"}}}}},"output":{"shape":"S1o"}},"AllocateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","ownerAccount","newTransitVirtualInterfaceAllocation"],"members":{"connectionId":{},"ownerAccount":{},"newTransitVirtualInterfaceAllocation":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"tags":{"shape":"S10"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"AssociateConnectionWithLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"AssociateHostedConnection":{"input":{"type":"structure","required":["connectionId","parentConnectionId"],"members":{"connectionId":{},"parentConnectionId":{}}},"output":{"shape":"So"}},"AssociateMacSecKey":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"secretARN":{},"ckn":{},"cak":{}}},"output":{"type":"structure","members":{"connectionId":{},"macSecKeys":{"shape":"S18"}}}},"AssociateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","connectionId"],"members":{"virtualInterfaceId":{},"connectionId":{}}},"output":{"shape":"S1o"}},"ConfirmConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"type":"structure","members":{"connectionState":{}}}},"ConfirmCustomerAgreement":{"input":{"type":"structure","members":{"agreementName":{}}},"output":{"type":"structure","members":{"status":{}}}},"ConfirmPrivateVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"virtualGatewayId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmPublicVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"ConfirmTransitVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId","directConnectGatewayId"],"members":{"virtualInterfaceId":{},"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"CreateBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"newBGPPeer":{"type":"structure","members":{"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"CreateConnection":{"input":{"type":"structure","required":["location","bandwidth","connectionName"],"members":{"location":{},"bandwidth":{},"connectionName":{},"lagId":{},"tags":{"shape":"S10"},"providerName":{},"requestMACSec":{"type":"boolean"}}},"output":{"shape":"So"}},"CreateDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayName"],"members":{"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2v"}}}},"CreateDirectConnectGatewayAssociation":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"CreateDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["directConnectGatewayId","directConnectGatewayOwnerAccount","gatewayId"],"members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"gatewayId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S32"}}}},"CreateInterconnect":{"input":{"type":"structure","required":["interconnectName","bandwidth","location"],"members":{"interconnectName":{},"bandwidth":{},"location":{},"lagId":{},"tags":{"shape":"S10"},"providerName":{}}},"output":{"shape":"S36"}},"CreateLag":{"input":{"type":"structure","required":["numberOfConnections","location","connectionsBandwidth","lagName"],"members":{"numberOfConnections":{"type":"integer"},"location":{},"connectionsBandwidth":{},"lagName":{},"connectionId":{},"tags":{"shape":"S10"},"childConnectionTags":{"shape":"S10"},"providerName":{},"requestMACSec":{"type":"boolean"}}},"output":{"shape":"S3b"}},"CreatePrivateVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPrivateVirtualInterface"],"members":{"connectionId":{},"newPrivateVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualGatewayId":{},"directConnectGatewayId":{},"tags":{"shape":"S10"},"enableSiteLink":{"type":"boolean"}}}}},"output":{"shape":"S1o"}},"CreatePublicVirtualInterface":{"input":{"type":"structure","required":["connectionId","newPublicVirtualInterface"],"members":{"connectionId":{},"newPublicVirtualInterface":{"type":"structure","required":["virtualInterfaceName","vlan","asn"],"members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"routeFilterPrefixes":{"shape":"S5"},"tags":{"shape":"S10"}}}}},"output":{"shape":"S1o"}},"CreateTransitVirtualInterface":{"input":{"type":"structure","required":["connectionId","newTransitVirtualInterface"],"members":{"connectionId":{},"newTransitVirtualInterface":{"type":"structure","members":{"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"mtu":{"type":"integer"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"directConnectGatewayId":{},"tags":{"shape":"S10"},"enableSiteLink":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"DeleteBGPPeer":{"input":{"type":"structure","members":{"virtualInterfaceId":{},"asn":{"type":"integer"},"customerAddress":{},"bgpPeerId":{}}},"output":{"type":"structure","members":{"virtualInterface":{"shape":"S1o"}}}},"DeleteConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"So"}},"DeleteDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayId"],"members":{"directConnectGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2v"}}}},"DeleteDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"directConnectGatewayId":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"DeleteDirectConnectGatewayAssociationProposal":{"input":{"type":"structure","required":["proposalId"],"members":{"proposalId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposal":{"shape":"S32"}}}},"DeleteInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnectState":{}}}},"DeleteLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{}}},"output":{"shape":"S3b"}},"DeleteVirtualInterface":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceState":{}}}},"DescribeConnectionLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S44"}}},"deprecated":true},"DescribeConnections":{"input":{"type":"structure","members":{"connectionId":{}}},"output":{"shape":"S47"}},"DescribeConnectionsOnInterconnect":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{}}},"output":{"shape":"S47"},"deprecated":true},"DescribeCustomerMetadata":{"output":{"type":"structure","members":{"agreements":{"type":"list","member":{"type":"structure","members":{"agreementName":{},"status":{}}}},"nniPartnerType":{}}}},"DescribeDirectConnectGatewayAssociationProposals":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"proposalId":{},"associatedGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociationProposals":{"type":"list","member":{"shape":"S32"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAssociations":{"input":{"type":"structure","members":{"associationId":{},"associatedGatewayId":{},"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{},"virtualGatewayId":{}}},"output":{"type":"structure","members":{"directConnectGatewayAssociations":{"type":"list","member":{"shape":"S9"}},"nextToken":{}}}},"DescribeDirectConnectGatewayAttachments":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGatewayAttachments":{"type":"list","member":{"type":"structure","members":{"directConnectGatewayId":{},"virtualInterfaceId":{},"virtualInterfaceRegion":{},"virtualInterfaceOwnerAccount":{},"attachmentState":{},"attachmentType":{},"stateChangeError":{}}}},"nextToken":{}}}},"DescribeDirectConnectGateways":{"input":{"type":"structure","members":{"directConnectGatewayId":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"directConnectGateways":{"type":"list","member":{"shape":"S2v"}},"nextToken":{}}}},"DescribeHostedConnections":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{}}},"output":{"shape":"S47"}},"DescribeInterconnectLoa":{"input":{"type":"structure","required":["interconnectId"],"members":{"interconnectId":{},"providerName":{},"loaContentType":{}}},"output":{"type":"structure","members":{"loa":{"shape":"S44"}}},"deprecated":true},"DescribeInterconnects":{"input":{"type":"structure","members":{"interconnectId":{}}},"output":{"type":"structure","members":{"interconnects":{"type":"list","member":{"shape":"S36"}}}}},"DescribeLags":{"input":{"type":"structure","members":{"lagId":{}}},"output":{"type":"structure","members":{"lags":{"type":"list","member":{"shape":"S3b"}}}}},"DescribeLoa":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"providerName":{},"loaContentType":{}}},"output":{"shape":"S44"}},"DescribeLocations":{"output":{"type":"structure","members":{"locations":{"type":"list","member":{"type":"structure","members":{"locationCode":{},"locationName":{},"region":{},"availablePortSpeeds":{"type":"list","member":{}},"availableProviders":{"type":"list","member":{}},"availableMacSecPortSpeeds":{"type":"list","member":{}}}}}}}},"DescribeRouterConfiguration":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"routerTypeIdentifier":{}}},"output":{"type":"structure","members":{"customerRouterConfig":{},"router":{"type":"structure","members":{"vendor":{},"platform":{},"software":{},"xsltTemplateName":{},"xsltTemplateNameForMacSec":{},"routerTypeIdentifier":{}}},"virtualInterfaceId":{},"virtualInterfaceName":{}}}},"DescribeTags":{"input":{"type":"structure","required":["resourceArns"],"members":{"resourceArns":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"resourceTags":{"type":"list","member":{"type":"structure","members":{"resourceArn":{},"tags":{"shape":"S10"}}}}}}},"DescribeVirtualGateways":{"output":{"type":"structure","members":{"virtualGateways":{"type":"list","member":{"type":"structure","members":{"virtualGatewayId":{},"virtualGatewayState":{}}}}}}},"DescribeVirtualInterfaces":{"input":{"type":"structure","members":{"connectionId":{},"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaces":{"type":"list","member":{"shape":"S1o"}}}}},"DisassociateConnectionFromLag":{"input":{"type":"structure","required":["connectionId","lagId"],"members":{"connectionId":{},"lagId":{}}},"output":{"shape":"So"}},"DisassociateMacSecKey":{"input":{"type":"structure","required":["connectionId","secretARN"],"members":{"connectionId":{},"secretARN":{}}},"output":{"type":"structure","members":{"connectionId":{},"macSecKeys":{"shape":"S18"}}}},"ListVirtualInterfaceTestHistory":{"input":{"type":"structure","members":{"testId":{},"virtualInterfaceId":{},"bgpPeers":{"shape":"S65"},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"virtualInterfaceTestHistory":{"type":"list","member":{"shape":"S69"}},"nextToken":{}}}},"StartBgpFailoverTest":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"bgpPeers":{"shape":"S65"},"testDurationInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"virtualInterfaceTest":{"shape":"S69"}}}},"StopBgpFailoverTest":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{}}},"output":{"type":"structure","members":{"virtualInterfaceTest":{"shape":"S69"}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S10"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateConnection":{"input":{"type":"structure","required":["connectionId"],"members":{"connectionId":{},"connectionName":{},"encryptionMode":{}}},"output":{"shape":"So"}},"UpdateDirectConnectGateway":{"input":{"type":"structure","required":["directConnectGatewayId","newDirectConnectGatewayName"],"members":{"directConnectGatewayId":{},"newDirectConnectGatewayName":{}}},"output":{"type":"structure","members":{"directConnectGateway":{"shape":"S2v"}}}},"UpdateDirectConnectGatewayAssociation":{"input":{"type":"structure","members":{"associationId":{},"addAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"removeAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"output":{"type":"structure","members":{"directConnectGatewayAssociation":{"shape":"S9"}}}},"UpdateLag":{"input":{"type":"structure","required":["lagId"],"members":{"lagId":{},"lagName":{},"minimumLinks":{"type":"integer"},"encryptionMode":{}}},"output":{"shape":"S3b"}},"UpdateVirtualInterfaceAttributes":{"input":{"type":"structure","required":["virtualInterfaceId"],"members":{"virtualInterfaceId":{},"mtu":{"type":"integer"},"enableSiteLink":{"type":"boolean"},"virtualInterfaceName":{}}},"output":{"shape":"S1o"}}},"shapes":{"S5":{"type":"list","member":{"type":"structure","members":{"cidr":{}}}},"S9":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"associationState":{},"stateChangeError":{},"associatedGateway":{"shape":"Sc"},"associationId":{},"allowedPrefixesToDirectConnectGateway":{"shape":"S5"},"virtualGatewayId":{},"virtualGatewayRegion":{"type":"string","deprecated":true},"virtualGatewayOwnerAccount":{}}},"Sc":{"type":"structure","members":{"id":{},"type":{},"ownerAccount":{},"region":{}}},"So":{"type":"structure","members":{"ownerAccount":{},"connectionId":{},"connectionName":{},"connectionState":{},"region":{},"location":{},"bandwidth":{},"vlan":{"type":"integer"},"partnerName":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"awsLogicalDeviceId":{},"hasLogicalRedundancy":{},"tags":{"shape":"S10"},"providerName":{},"macSecCapable":{"type":"boolean"},"portEncryptionStatus":{},"encryptionMode":{},"macSecKeys":{"shape":"S18"}}},"Sv":{"type":"string","deprecated":true},"S10":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"S18":{"type":"list","member":{"type":"structure","members":{"secretARN":{},"ckn":{},"state":{},"startOn":{}}}},"S1o":{"type":"structure","members":{"ownerAccount":{},"virtualInterfaceId":{},"location":{},"connectionId":{},"virtualInterfaceType":{},"virtualInterfaceName":{},"vlan":{"type":"integer"},"asn":{"type":"integer"},"amazonSideAsn":{"type":"long"},"authKey":{},"amazonAddress":{},"customerAddress":{},"addressFamily":{},"virtualInterfaceState":{},"customerRouterConfig":{},"mtu":{"type":"integer"},"jumboFrameCapable":{"type":"boolean"},"virtualGatewayId":{},"directConnectGatewayId":{},"routeFilterPrefixes":{"shape":"S5"},"bgpPeers":{"type":"list","member":{"type":"structure","members":{"bgpPeerId":{},"asn":{"type":"integer"},"authKey":{},"addressFamily":{},"amazonAddress":{},"customerAddress":{},"bgpPeerState":{},"bgpStatus":{},"awsDeviceV2":{},"awsLogicalDeviceId":{}}}},"region":{},"awsDeviceV2":{},"awsLogicalDeviceId":{},"tags":{"shape":"S10"},"siteLinkEnabled":{"type":"boolean"}}},"S2v":{"type":"structure","members":{"directConnectGatewayId":{},"directConnectGatewayName":{},"amazonSideAsn":{"type":"long"},"ownerAccount":{},"directConnectGatewayState":{},"stateChangeError":{}}},"S32":{"type":"structure","members":{"proposalId":{},"directConnectGatewayId":{},"directConnectGatewayOwnerAccount":{},"proposalState":{},"associatedGateway":{"shape":"Sc"},"existingAllowedPrefixesToDirectConnectGateway":{"shape":"S5"},"requestedAllowedPrefixesToDirectConnectGateway":{"shape":"S5"}}},"S36":{"type":"structure","members":{"interconnectId":{},"interconnectName":{},"interconnectState":{},"region":{},"location":{},"bandwidth":{},"loaIssueTime":{"type":"timestamp"},"lagId":{},"awsDevice":{"shape":"Sv"},"jumboFrameCapable":{"type":"boolean"},"awsDeviceV2":{},"awsLogicalDeviceId":{},"hasLogicalRedundancy":{},"tags":{"shape":"S10"},"providerName":{}}},"S3b":{"type":"structure","members":{"connectionsBandwidth":{},"numberOfConnections":{"type":"integer"},"lagId":{},"ownerAccount":{},"lagName":{},"lagState":{},"location":{},"region":{},"minimumLinks":{"type":"integer"},"awsDevice":{"shape":"Sv"},"awsDeviceV2":{},"awsLogicalDeviceId":{},"connections":{"shape":"S3d"},"allowsHostedConnections":{"type":"boolean"},"jumboFrameCapable":{"type":"boolean"},"hasLogicalRedundancy":{},"tags":{"shape":"S10"},"providerName":{},"macSecCapable":{"type":"boolean"},"encryptionMode":{},"macSecKeys":{"shape":"S18"}}},"S3d":{"type":"list","member":{"shape":"So"}},"S44":{"type":"structure","members":{"loaContent":{"type":"blob"},"loaContentType":{}}},"S47":{"type":"structure","members":{"connections":{"shape":"S3d"}}},"S65":{"type":"list","member":{}},"S69":{"type":"structure","members":{"testId":{},"virtualInterfaceId":{},"bgpPeers":{"shape":"S65"},"status":{},"ownerAccount":{},"testDurationInMinutes":{"type":"integer"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}}}}

/***/ }),
/* 468 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeConnections":{"result_key":"connections"},"DescribeConnectionsOnInterconnect":{"result_key":"connections"},"DescribeInterconnects":{"result_key":"interconnects"},"DescribeLocations":{"result_key":"locations"},"DescribeVirtualGateways":{"result_key":"virtualGateways"},"DescribeVirtualInterfaces":{"result_key":"virtualInterfaces"}}}

/***/ }),
/* 469 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-12-05","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20111205","uid":"dynamodb-2011-12-05"},"operations":{"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S2"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"Items":{"shape":"Sk"},"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedKeys":{"shape":"S2"}}}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"So"}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"type":"structure","members":{"ConsumedCapacityUnits":{"type":"double"}}}},"UnprocessedItems":{"shape":"So"}}}},"CreateTable":{"input":{"type":"structure","required":["TableName","KeySchema","ProvisionedThroughput"],"members":{"TableName":{},"KeySchema":{"shape":"Sy"},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S15"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"Ss"},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"Query":{"input":{"type":"structure","required":["TableName","HashKeyValue"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"Count":{"type":"boolean"},"HashKeyValue":{"shape":"S7"},"RangeKeyCondition":{"shape":"S1u"},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"AttributesToGet":{"shape":"Se"},"Limit":{"type":"integer"},"Count":{"type":"boolean"},"ScanFilter":{"type":"map","key":{},"value":{"shape":"S1u"}},"ExclusiveStartKey":{"shape":"S6"}}},"output":{"type":"structure","members":{"Items":{"shape":"Sk"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S6"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key","AttributeUpdates"],"members":{"TableName":{},"Key":{"shape":"S6"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Action":{}}}},"Expected":{"shape":"S1b"},"ReturnValues":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sl"},"ConsumedCapacityUnits":{"type":"double"}}}},"UpdateTable":{"input":{"type":"structure","required":["TableName","ProvisionedThroughput"],"members":{"TableName":{},"ProvisionedThroughput":{"shape":"S12"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S15"}}}}},"shapes":{"S2":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S6"}},"AttributesToGet":{"shape":"Se"},"ConsistentRead":{"type":"boolean"}}}},"S6":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"S7"},"RangeKeyElement":{"shape":"S7"}}},"S7":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}}}},"Se":{"type":"list","member":{}},"Sk":{"type":"list","member":{"shape":"Sl"}},"Sl":{"type":"map","key":{},"value":{"shape":"S7"}},"So":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"Ss"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S6"}}}}}}},"Ss":{"type":"map","key":{},"value":{"shape":"S7"}},"Sy":{"type":"structure","required":["HashKeyElement"],"members":{"HashKeyElement":{"shape":"Sz"},"RangeKeyElement":{"shape":"Sz"}}},"Sz":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}},"S12":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S15":{"type":"structure","members":{"TableName":{},"KeySchema":{"shape":"Sy"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"}}},"S1b":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S7"},"Exists":{"type":"boolean"}}}},"S1u":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"type":"list","member":{"shape":"S7"}},"ComparisonOperator":{}}}}}

/***/ }),
/* 470 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 471 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 472 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"dynamodb","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"DynamoDB","serviceFullName":"Amazon DynamoDB","serviceId":"DynamoDB","signatureVersion":"v4","targetPrefix":"DynamoDB_20120810","uid":"dynamodb-2012-08-10"},"operations":{"BatchExecuteStatement":{"input":{"type":"structure","required":["Statements"],"members":{"Statements":{"type":"list","member":{"type":"structure","required":["Statement"],"members":{"Statement":{},"Parameters":{"shape":"S5"},"ConsistentRead":{"type":"boolean"},"ReturnValuesOnConditionCheckFailure":{}}}},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"list","member":{"type":"structure","members":{"Error":{"type":"structure","members":{"Code":{},"Message":{},"Item":{"shape":"Sr"}}},"TableName":{},"Item":{"shape":"Sr"}}}},"ConsumedCapacity":{"shape":"St"}}}},"BatchGetItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S11"},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"type":"map","key":{},"value":{"shape":"S1b"}},"UnprocessedKeys":{"shape":"S11"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"BatchWriteItem":{"input":{"type":"structure","required":["RequestItems"],"members":{"RequestItems":{"shape":"S1d"},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{}}},"output":{"type":"structure","members":{"UnprocessedItems":{"shape":"S1d"},"ItemCollectionMetrics":{"shape":"S1l"},"ConsumedCapacity":{"shape":"St"}}},"endpointdiscovery":{}},"CreateBackup":{"input":{"type":"structure","required":["TableName","BackupName"],"members":{"TableName":{},"BackupName":{}}},"output":{"type":"structure","members":{"BackupDetails":{"shape":"S1u"}}},"endpointdiscovery":{}},"CreateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicationGroup"],"members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S22"}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S26"}}},"endpointdiscovery":{}},"CreateTable":{"input":{"type":"structure","required":["AttributeDefinitions","TableName","KeySchema"],"members":{"AttributeDefinitions":{"shape":"S2o"},"TableName":{},"KeySchema":{"shape":"S2s"},"LocalSecondaryIndexes":{"shape":"S2v"},"GlobalSecondaryIndexes":{"shape":"S31"},"BillingMode":{},"ProvisionedThroughput":{"shape":"S33"},"StreamSpecification":{"shape":"S36"},"SSESpecification":{"shape":"S39"},"Tags":{"shape":"S3c"},"TableClass":{},"DeletionProtectionEnabled":{"type":"boolean"},"ResourcePolicy":{},"OnDemandThroughput":{"shape":"S34"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3j"}}},"endpointdiscovery":{}},"DeleteBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S45"}}},"endpointdiscovery":{}},"DeleteItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S14"},"Expected":{"shape":"S4i"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ReturnValuesOnConditionCheckFailure":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sr"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1n"}}},"endpointdiscovery":{}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"ExpectedRevisionId":{}}},"output":{"type":"structure","members":{"RevisionId":{}}},"endpointdiscovery":{}},"DeleteTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3j"}}},"endpointdiscovery":{}},"DescribeBackup":{"input":{"type":"structure","required":["BackupArn"],"members":{"BackupArn":{}}},"output":{"type":"structure","members":{"BackupDescription":{"shape":"S45"}}},"endpointdiscovery":{}},"DescribeContinuousBackups":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S53"}}},"endpointdiscovery":{}},"DescribeContributorInsights":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{}}},"output":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsRuleList":{"type":"list","member":{}},"ContributorInsightsStatus":{},"LastUpdateDateTime":{"type":"timestamp"},"FailureException":{"type":"structure","members":{"ExceptionName":{},"ExceptionDescription":{}}}}}},"DescribeEndpoints":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["Endpoints"],"members":{"Endpoints":{"type":"list","member":{"type":"structure","required":["Address","CachePeriodInMinutes"],"members":{"Address":{},"CachePeriodInMinutes":{"type":"long"}}}}}},"endpointoperation":true},"DescribeExport":{"input":{"type":"structure","required":["ExportArn"],"members":{"ExportArn":{}}},"output":{"type":"structure","members":{"ExportDescription":{"shape":"S5o"}}}},"DescribeGlobalTable":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S26"}}},"endpointdiscovery":{}},"DescribeGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S6d"}}},"endpointdiscovery":{}},"DescribeImport":{"input":{"type":"structure","required":["ImportArn"],"members":{"ImportArn":{}}},"output":{"type":"structure","required":["ImportTableDescription"],"members":{"ImportTableDescription":{"shape":"S6r"}}}},"DescribeKinesisStreamingDestination":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableName":{},"KinesisDataStreamDestinations":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"DestinationStatus":{},"DestinationStatusDescription":{},"ApproximateCreationDateTimePrecision":{}}}}}},"endpointdiscovery":{}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountMaxReadCapacityUnits":{"type":"long"},"AccountMaxWriteCapacityUnits":{"type":"long"},"TableMaxReadCapacityUnits":{"type":"long"},"TableMaxWriteCapacityUnits":{"type":"long"}}},"endpointdiscovery":{}},"DescribeTable":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"Table":{"shape":"S3j"}}},"endpointdiscovery":{}},"DescribeTableReplicaAutoScaling":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TableAutoScalingDescription":{"shape":"S7k"}}}},"DescribeTimeToLive":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{}}},"output":{"type":"structure","members":{"TimeToLiveDescription":{"shape":"S4e"}}},"endpointdiscovery":{}},"DisableKinesisStreamingDestination":{"input":{"shape":"S7r"},"output":{"shape":"S7t"},"endpointdiscovery":{}},"EnableKinesisStreamingDestination":{"input":{"shape":"S7r"},"output":{"shape":"S7t"},"endpointdiscovery":{}},"ExecuteStatement":{"input":{"type":"structure","required":["Statement"],"members":{"Statement":{},"Parameters":{"shape":"S5"},"ConsistentRead":{"type":"boolean"},"NextToken":{},"ReturnConsumedCapacity":{},"Limit":{"type":"integer"},"ReturnValuesOnConditionCheckFailure":{}}},"output":{"type":"structure","members":{"Items":{"shape":"S1b"},"NextToken":{},"ConsumedCapacity":{"shape":"Su"},"LastEvaluatedKey":{"shape":"S14"}}}},"ExecuteTransaction":{"input":{"type":"structure","required":["TransactStatements"],"members":{"TransactStatements":{"type":"list","member":{"type":"structure","required":["Statement"],"members":{"Statement":{},"Parameters":{"shape":"S5"},"ReturnValuesOnConditionCheckFailure":{}}}},"ClientRequestToken":{"idempotencyToken":true},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"Responses":{"shape":"S83"},"ConsumedCapacity":{"shape":"St"}}}},"ExportTableToPointInTime":{"input":{"type":"structure","required":["TableArn","S3Bucket"],"members":{"TableArn":{},"ExportTime":{"type":"timestamp"},"ClientToken":{"idempotencyToken":true},"S3Bucket":{},"S3BucketOwner":{},"S3Prefix":{},"S3SseAlgorithm":{},"S3SseKmsKeyId":{},"ExportFormat":{},"ExportType":{},"IncrementalExportSpecification":{"shape":"S65"}}},"output":{"type":"structure","members":{"ExportDescription":{"shape":"S5o"}}}},"GetItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S14"},"AttributesToGet":{"shape":"S15"},"ConsistentRead":{"type":"boolean"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"S17"}}},"output":{"type":"structure","members":{"Item":{"shape":"Sr"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"GetResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}},"endpointdiscovery":{}},"ImportTable":{"input":{"type":"structure","required":["S3BucketSource","InputFormat","TableCreationParameters"],"members":{"ClientToken":{"idempotencyToken":true},"S3BucketSource":{"shape":"S6t"},"InputFormat":{},"InputFormatOptions":{"shape":"S6x"},"InputCompressionType":{},"TableCreationParameters":{"shape":"S73"}}},"output":{"type":"structure","required":["ImportTableDescription"],"members":{"ImportTableDescription":{"shape":"S6r"}}}},"ListBackups":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"TimeRangeLowerBound":{"type":"timestamp"},"TimeRangeUpperBound":{"type":"timestamp"},"ExclusiveStartBackupArn":{},"BackupType":{}}},"output":{"type":"structure","members":{"BackupSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"TableId":{},"TableArn":{},"BackupArn":{},"BackupName":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"},"BackupStatus":{},"BackupType":{},"BackupSizeBytes":{"type":"long"}}}},"LastEvaluatedBackupArn":{}}},"endpointdiscovery":{}},"ListContributorInsights":{"input":{"type":"structure","members":{"TableName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ContributorInsightsSummaries":{"type":"list","member":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsStatus":{}}}},"NextToken":{}}}},"ListExports":{"input":{"type":"structure","members":{"TableArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ExportSummaries":{"type":"list","member":{"type":"structure","members":{"ExportArn":{},"ExportStatus":{},"ExportType":{}}}},"NextToken":{}}}},"ListGlobalTables":{"input":{"type":"structure","members":{"ExclusiveStartGlobalTableName":{},"Limit":{"type":"integer"},"RegionName":{}}},"output":{"type":"structure","members":{"GlobalTables":{"type":"list","member":{"type":"structure","members":{"GlobalTableName":{},"ReplicationGroup":{"shape":"S22"}}}},"LastEvaluatedGlobalTableName":{}}},"endpointdiscovery":{}},"ListImports":{"input":{"type":"structure","members":{"TableArn":{},"PageSize":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportSummaryList":{"type":"list","member":{"type":"structure","members":{"ImportArn":{},"ImportStatus":{},"TableArn":{},"S3BucketSource":{"shape":"S6t"},"CloudWatchLogGroupArn":{},"InputFormat":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListTables":{"input":{"type":"structure","members":{"ExclusiveStartTableName":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TableNames":{"type":"list","member":{}},"LastEvaluatedTableName":{}}},"endpointdiscovery":{}},"ListTagsOfResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3c"},"NextToken":{}}},"endpointdiscovery":{}},"PutItem":{"input":{"type":"structure","required":["TableName","Item"],"members":{"TableName":{},"Item":{"shape":"S1h"},"Expected":{"shape":"S4i"},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ConditionalOperator":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ReturnValuesOnConditionCheckFailure":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sr"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1n"}}},"endpointdiscovery":{}},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{},"ExpectedRevisionId":{},"ConfirmRemoveSelfResourceAccess":{"type":"boolean"}}},"output":{"type":"structure","members":{"RevisionId":{}}},"endpointdiscovery":{}},"Query":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"Select":{},"AttributesToGet":{"shape":"S15"},"Limit":{"type":"integer"},"ConsistentRead":{"type":"boolean"},"KeyConditions":{"type":"map","key":{},"value":{"shape":"S9l"}},"QueryFilter":{"shape":"S9m"},"ConditionalOperator":{},"ScanIndexForward":{"type":"boolean"},"ExclusiveStartKey":{"shape":"S14"},"ReturnConsumedCapacity":{},"ProjectionExpression":{},"FilterExpression":{},"KeyConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"}}},"output":{"type":"structure","members":{"Items":{"shape":"S1b"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S14"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"RestoreTableFromBackup":{"input":{"type":"structure","required":["TargetTableName","BackupArn"],"members":{"TargetTableName":{},"BackupArn":{},"BillingModeOverride":{},"GlobalSecondaryIndexOverride":{"shape":"S31"},"LocalSecondaryIndexOverride":{"shape":"S2v"},"ProvisionedThroughputOverride":{"shape":"S33"},"OnDemandThroughputOverride":{"shape":"S34"},"SSESpecificationOverride":{"shape":"S39"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3j"}}},"endpointdiscovery":{}},"RestoreTableToPointInTime":{"input":{"type":"structure","required":["TargetTableName"],"members":{"SourceTableArn":{},"SourceTableName":{},"TargetTableName":{},"UseLatestRestorableTime":{"type":"boolean"},"RestoreDateTime":{"type":"timestamp"},"BillingModeOverride":{},"GlobalSecondaryIndexOverride":{"shape":"S31"},"LocalSecondaryIndexOverride":{"shape":"S2v"},"ProvisionedThroughputOverride":{"shape":"S33"},"OnDemandThroughputOverride":{"shape":"S34"},"SSESpecificationOverride":{"shape":"S39"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3j"}}},"endpointdiscovery":{}},"Scan":{"input":{"type":"structure","required":["TableName"],"members":{"TableName":{},"IndexName":{},"AttributesToGet":{"shape":"S15"},"Limit":{"type":"integer"},"Select":{},"ScanFilter":{"shape":"S9m"},"ConditionalOperator":{},"ExclusiveStartKey":{"shape":"S14"},"ReturnConsumedCapacity":{},"TotalSegments":{"type":"integer"},"Segment":{"type":"integer"},"ProjectionExpression":{},"FilterExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ConsistentRead":{"type":"boolean"}}},"output":{"type":"structure","members":{"Items":{"shape":"S1b"},"Count":{"type":"integer"},"ScannedCount":{"type":"integer"},"LastEvaluatedKey":{"shape":"S14"},"ConsumedCapacity":{"shape":"Su"}}},"endpointdiscovery":{}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S3c"}}},"endpointdiscovery":{}},"TransactGetItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","required":["Get"],"members":{"Get":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S14"},"TableName":{},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"S17"}}}}}},"ReturnConsumedCapacity":{}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"St"},"Responses":{"shape":"S83"}}},"endpointdiscovery":{}},"TransactWriteItems":{"input":{"type":"structure","required":["TransactItems"],"members":{"TransactItems":{"type":"list","member":{"type":"structure","members":{"ConditionCheck":{"type":"structure","required":["Key","TableName","ConditionExpression"],"members":{"Key":{"shape":"S14"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ReturnValuesOnConditionCheckFailure":{}}},"Put":{"type":"structure","required":["Item","TableName"],"members":{"Item":{"shape":"S1h"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ReturnValuesOnConditionCheckFailure":{}}},"Delete":{"type":"structure","required":["Key","TableName"],"members":{"Key":{"shape":"S14"},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ReturnValuesOnConditionCheckFailure":{}}},"Update":{"type":"structure","required":["Key","UpdateExpression","TableName"],"members":{"Key":{"shape":"S14"},"UpdateExpression":{},"TableName":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ReturnValuesOnConditionCheckFailure":{}}}}}},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConsumedCapacity":{"shape":"St"},"ItemCollectionMetrics":{"shape":"S1l"}}},"endpointdiscovery":{}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"endpointdiscovery":{}},"UpdateContinuousBackups":{"input":{"type":"structure","required":["TableName","PointInTimeRecoverySpecification"],"members":{"TableName":{},"PointInTimeRecoverySpecification":{"type":"structure","required":["PointInTimeRecoveryEnabled"],"members":{"PointInTimeRecoveryEnabled":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"ContinuousBackupsDescription":{"shape":"S53"}}},"endpointdiscovery":{}},"UpdateContributorInsights":{"input":{"type":"structure","required":["TableName","ContributorInsightsAction"],"members":{"TableName":{},"IndexName":{},"ContributorInsightsAction":{}}},"output":{"type":"structure","members":{"TableName":{},"IndexName":{},"ContributorInsightsStatus":{}}}},"UpdateGlobalTable":{"input":{"type":"structure","required":["GlobalTableName","ReplicaUpdates"],"members":{"GlobalTableName":{},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}}}},"output":{"type":"structure","members":{"GlobalTableDescription":{"shape":"S26"}}},"endpointdiscovery":{}},"UpdateGlobalTableSettings":{"input":{"type":"structure","required":["GlobalTableName"],"members":{"GlobalTableName":{},"GlobalTableBillingMode":{},"GlobalTableProvisionedWriteCapacityUnits":{"type":"long"},"GlobalTableProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"Sas"},"GlobalTableGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettingsUpdate":{"shape":"Sas"}}}},"ReplicaSettingsUpdate":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"Sas"},"ReplicaGlobalSecondaryIndexSettingsUpdate":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettingsUpdate":{"shape":"Sas"}}}},"ReplicaTableClass":{}}}}}},"output":{"type":"structure","members":{"GlobalTableName":{},"ReplicaSettings":{"shape":"S6d"}}},"endpointdiscovery":{}},"UpdateItem":{"input":{"type":"structure","required":["TableName","Key"],"members":{"TableName":{},"Key":{"shape":"S14"},"AttributeUpdates":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S6"},"Action":{}}}},"Expected":{"shape":"S4i"},"ConditionalOperator":{},"ReturnValues":{},"ReturnConsumedCapacity":{},"ReturnItemCollectionMetrics":{},"UpdateExpression":{},"ConditionExpression":{},"ExpressionAttributeNames":{"shape":"S17"},"ExpressionAttributeValues":{"shape":"S4q"},"ReturnValuesOnConditionCheckFailure":{}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sr"},"ConsumedCapacity":{"shape":"Su"},"ItemCollectionMetrics":{"shape":"S1n"}}},"endpointdiscovery":{}},"UpdateKinesisStreamingDestination":{"input":{"type":"structure","required":["TableName","StreamArn"],"members":{"TableName":{},"StreamArn":{},"UpdateKinesisStreamingConfiguration":{"shape":"Sb9"}}},"output":{"type":"structure","members":{"TableName":{},"StreamArn":{},"DestinationStatus":{},"UpdateKinesisStreamingConfiguration":{"shape":"Sb9"}}},"endpointdiscovery":{}},"UpdateTable":{"input":{"type":"structure","required":["TableName"],"members":{"AttributeDefinitions":{"shape":"S2o"},"TableName":{},"BillingMode":{},"ProvisionedThroughput":{"shape":"S33"},"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"Update":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedThroughput":{"shape":"S33"},"OnDemandThroughput":{"shape":"S34"}}},"Create":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2s"},"Projection":{"shape":"S2x"},"ProvisionedThroughput":{"shape":"S33"},"OnDemandThroughput":{"shape":"S34"}}},"Delete":{"type":"structure","required":["IndexName"],"members":{"IndexName":{}}}}}},"StreamSpecification":{"shape":"S36"},"SSESpecification":{"shape":"S39"},"ReplicaUpdates":{"type":"list","member":{"type":"structure","members":{"Create":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S2d"},"OnDemandThroughputOverride":{"shape":"S2f"},"GlobalSecondaryIndexes":{"shape":"Sbk"},"TableClassOverride":{}}},"Update":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S2d"},"OnDemandThroughputOverride":{"shape":"S2f"},"GlobalSecondaryIndexes":{"shape":"Sbk"},"TableClassOverride":{}}},"Delete":{"type":"structure","required":["RegionName"],"members":{"RegionName":{}}}}}},"TableClass":{},"DeletionProtectionEnabled":{"type":"boolean"},"OnDemandThroughput":{"shape":"S34"}}},"output":{"type":"structure","members":{"TableDescription":{"shape":"S3j"}}},"endpointdiscovery":{}},"UpdateTableReplicaAutoScaling":{"input":{"type":"structure","required":["TableName"],"members":{"GlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedWriteCapacityAutoScalingUpdate":{"shape":"Sas"}}}},"TableName":{},"ProvisionedWriteCapacityAutoScalingUpdate":{"shape":"Sas"},"ReplicaUpdates":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaGlobalSecondaryIndexUpdates":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedReadCapacityAutoScalingUpdate":{"shape":"Sas"}}}},"ReplicaProvisionedReadCapacityAutoScalingUpdate":{"shape":"Sas"}}}}}},"output":{"type":"structure","members":{"TableAutoScalingDescription":{"shape":"S7k"}}}},"UpdateTimeToLive":{"input":{"type":"structure","required":["TableName","TimeToLiveSpecification"],"members":{"TableName":{},"TimeToLiveSpecification":{"shape":"Sby"}}},"output":{"type":"structure","members":{"TimeToLiveSpecification":{"shape":"Sby"}}},"endpointdiscovery":{}}},"shapes":{"S5":{"type":"list","member":{"shape":"S6"}},"S6":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"S6"}},"L":{"type":"list","member":{"shape":"S6"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}},"Sr":{"type":"map","key":{},"value":{"shape":"S6"}},"St":{"type":"list","member":{"shape":"Su"}},"Su":{"type":"structure","members":{"TableName":{},"CapacityUnits":{"type":"double"},"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"Table":{"shape":"Sx"},"LocalSecondaryIndexes":{"shape":"Sy"},"GlobalSecondaryIndexes":{"shape":"Sy"}}},"Sx":{"type":"structure","members":{"ReadCapacityUnits":{"type":"double"},"WriteCapacityUnits":{"type":"double"},"CapacityUnits":{"type":"double"}}},"Sy":{"type":"map","key":{},"value":{"shape":"Sx"}},"S11":{"type":"map","key":{},"value":{"type":"structure","required":["Keys"],"members":{"Keys":{"type":"list","member":{"shape":"S14"}},"AttributesToGet":{"shape":"S15"},"ConsistentRead":{"type":"boolean"},"ProjectionExpression":{},"ExpressionAttributeNames":{"shape":"S17"}}}},"S14":{"type":"map","key":{},"value":{"shape":"S6"}},"S15":{"type":"list","member":{}},"S17":{"type":"map","key":{},"value":{}},"S1b":{"type":"list","member":{"shape":"Sr"}},"S1d":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"PutRequest":{"type":"structure","required":["Item"],"members":{"Item":{"shape":"S1h"}}},"DeleteRequest":{"type":"structure","required":["Key"],"members":{"Key":{"shape":"S14"}}}}}}},"S1h":{"type":"map","key":{},"value":{"shape":"S6"}},"S1l":{"type":"map","key":{},"value":{"type":"list","member":{"shape":"S1n"}}},"S1n":{"type":"structure","members":{"ItemCollectionKey":{"type":"map","key":{},"value":{"shape":"S6"}},"SizeEstimateRangeGB":{"type":"list","member":{"type":"double"}}}},"S1u":{"type":"structure","required":["BackupArn","BackupName","BackupStatus","BackupType","BackupCreationDateTime"],"members":{"BackupArn":{},"BackupName":{},"BackupSizeBytes":{"type":"long"},"BackupStatus":{},"BackupType":{},"BackupCreationDateTime":{"type":"timestamp"},"BackupExpiryDateTime":{"type":"timestamp"}}},"S22":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"S26":{"type":"structure","members":{"ReplicationGroup":{"shape":"S27"},"GlobalTableArn":{},"CreationDateTime":{"type":"timestamp"},"GlobalTableStatus":{},"GlobalTableName":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"RegionName":{},"ReplicaStatus":{},"ReplicaStatusDescription":{},"ReplicaStatusPercentProgress":{},"KMSMasterKeyId":{},"ProvisionedThroughputOverride":{"shape":"S2d"},"OnDemandThroughputOverride":{"shape":"S2f"},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"ProvisionedThroughputOverride":{"shape":"S2d"},"OnDemandThroughputOverride":{"shape":"S2f"}}}},"ReplicaInaccessibleDateTime":{"type":"timestamp"},"ReplicaTableClassSummary":{"shape":"S2j"}}}},"S2d":{"type":"structure","members":{"ReadCapacityUnits":{"type":"long"}}},"S2f":{"type":"structure","members":{"MaxReadRequestUnits":{"type":"long"}}},"S2j":{"type":"structure","members":{"TableClass":{},"LastUpdateDateTime":{"type":"timestamp"}}},"S2o":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeType"],"members":{"AttributeName":{},"AttributeType":{}}}},"S2s":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"S2v":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2s"},"Projection":{"shape":"S2x"}}}},"S2x":{"type":"structure","members":{"ProjectionType":{},"NonKeyAttributes":{"type":"list","member":{}}}},"S31":{"type":"list","member":{"type":"structure","required":["IndexName","KeySchema","Projection"],"members":{"IndexName":{},"KeySchema":{"shape":"S2s"},"Projection":{"shape":"S2x"},"ProvisionedThroughput":{"shape":"S33"},"OnDemandThroughput":{"shape":"S34"}}}},"S33":{"type":"structure","required":["ReadCapacityUnits","WriteCapacityUnits"],"members":{"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S34":{"type":"structure","members":{"MaxReadRequestUnits":{"type":"long"},"MaxWriteRequestUnits":{"type":"long"}}},"S36":{"type":"structure","required":["StreamEnabled"],"members":{"StreamEnabled":{"type":"boolean"},"StreamViewType":{}}},"S39":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SSEType":{},"KMSMasterKeyId":{}}},"S3c":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S3j":{"type":"structure","members":{"AttributeDefinitions":{"shape":"S2o"},"TableName":{},"KeySchema":{"shape":"S2s"},"TableStatus":{},"CreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S3l"},"TableSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"TableArn":{},"TableId":{},"BillingModeSummary":{"shape":"S3o"},"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2s"},"Projection":{"shape":"S2x"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2s"},"Projection":{"shape":"S2x"},"IndexStatus":{},"Backfilling":{"type":"boolean"},"ProvisionedThroughput":{"shape":"S3l"},"IndexSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"IndexArn":{},"OnDemandThroughput":{"shape":"S34"}}}},"StreamSpecification":{"shape":"S36"},"LatestStreamLabel":{},"LatestStreamArn":{},"GlobalTableVersion":{},"Replicas":{"shape":"S27"},"RestoreSummary":{"type":"structure","required":["RestoreDateTime","RestoreInProgress"],"members":{"SourceBackupArn":{},"SourceTableArn":{},"RestoreDateTime":{"type":"timestamp"},"RestoreInProgress":{"type":"boolean"}}},"SSEDescription":{"shape":"S3y"},"ArchivalSummary":{"type":"structure","members":{"ArchivalDateTime":{"type":"timestamp"},"ArchivalReason":{},"ArchivalBackupArn":{}}},"TableClassSummary":{"shape":"S2j"},"DeletionProtectionEnabled":{"type":"boolean"},"OnDemandThroughput":{"shape":"S34"}}},"S3l":{"type":"structure","members":{"LastIncreaseDateTime":{"type":"timestamp"},"LastDecreaseDateTime":{"type":"timestamp"},"NumberOfDecreasesToday":{"type":"long"},"ReadCapacityUnits":{"type":"long"},"WriteCapacityUnits":{"type":"long"}}},"S3o":{"type":"structure","members":{"BillingMode":{},"LastUpdateToPayPerRequestDateTime":{"type":"timestamp"}}},"S3y":{"type":"structure","members":{"Status":{},"SSEType":{},"KMSMasterKeyArn":{},"InaccessibleEncryptionDateTime":{"type":"timestamp"}}},"S45":{"type":"structure","members":{"BackupDetails":{"shape":"S1u"},"SourceTableDetails":{"type":"structure","required":["TableName","TableId","KeySchema","TableCreationDateTime","ProvisionedThroughput"],"members":{"TableName":{},"TableId":{},"TableArn":{},"TableSizeBytes":{"type":"long"},"KeySchema":{"shape":"S2s"},"TableCreationDateTime":{"type":"timestamp"},"ProvisionedThroughput":{"shape":"S33"},"OnDemandThroughput":{"shape":"S34"},"ItemCount":{"type":"long"},"BillingMode":{}}},"SourceTableFeatureDetails":{"type":"structure","members":{"LocalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2s"},"Projection":{"shape":"S2x"}}}},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"KeySchema":{"shape":"S2s"},"Projection":{"shape":"S2x"},"ProvisionedThroughput":{"shape":"S33"},"OnDemandThroughput":{"shape":"S34"}}}},"StreamDescription":{"shape":"S36"},"TimeToLiveDescription":{"shape":"S4e"},"SSEDescription":{"shape":"S3y"}}}}},"S4e":{"type":"structure","members":{"TimeToLiveStatus":{},"AttributeName":{}}},"S4i":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{"shape":"S6"},"Exists":{"type":"boolean"},"ComparisonOperator":{},"AttributeValueList":{"shape":"S4m"}}}},"S4m":{"type":"list","member":{"shape":"S6"}},"S4q":{"type":"map","key":{},"value":{"shape":"S6"}},"S53":{"type":"structure","required":["ContinuousBackupsStatus"],"members":{"ContinuousBackupsStatus":{},"PointInTimeRecoveryDescription":{"type":"structure","members":{"PointInTimeRecoveryStatus":{},"EarliestRestorableDateTime":{"type":"timestamp"},"LatestRestorableDateTime":{"type":"timestamp"}}}}},"S5o":{"type":"structure","members":{"ExportArn":{},"ExportStatus":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ExportManifest":{},"TableArn":{},"TableId":{},"ExportTime":{"type":"timestamp"},"ClientToken":{},"S3Bucket":{},"S3BucketOwner":{},"S3Prefix":{},"S3SseAlgorithm":{},"S3SseKmsKeyId":{},"FailureCode":{},"FailureMessage":{},"ExportFormat":{},"BilledSizeBytes":{"type":"long"},"ItemCount":{"type":"long"},"ExportType":{},"IncrementalExportSpecification":{"shape":"S65"}}},"S65":{"type":"structure","members":{"ExportFromTime":{"type":"timestamp"},"ExportToTime":{"type":"timestamp"},"ExportViewType":{}}},"S6d":{"type":"list","member":{"type":"structure","required":["RegionName"],"members":{"RegionName":{},"ReplicaStatus":{},"ReplicaBillingModeSummary":{"shape":"S3o"},"ReplicaProvisionedReadCapacityUnits":{"type":"long"},"ReplicaProvisionedReadCapacityAutoScalingSettings":{"shape":"S6f"},"ReplicaProvisionedWriteCapacityUnits":{"type":"long"},"ReplicaProvisionedWriteCapacityAutoScalingSettings":{"shape":"S6f"},"ReplicaGlobalSecondaryIndexSettings":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"IndexStatus":{},"ProvisionedReadCapacityUnits":{"type":"long"},"ProvisionedReadCapacityAutoScalingSettings":{"shape":"S6f"},"ProvisionedWriteCapacityUnits":{"type":"long"},"ProvisionedWriteCapacityAutoScalingSettings":{"shape":"S6f"}}}},"ReplicaTableClassSummary":{"shape":"S2j"}}}},"S6f":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}}},"S6r":{"type":"structure","members":{"ImportArn":{},"ImportStatus":{},"TableArn":{},"TableId":{},"ClientToken":{},"S3BucketSource":{"shape":"S6t"},"ErrorCount":{"type":"long"},"CloudWatchLogGroupArn":{},"InputFormat":{},"InputFormatOptions":{"shape":"S6x"},"InputCompressionType":{},"TableCreationParameters":{"shape":"S73"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ProcessedSizeBytes":{"type":"long"},"ProcessedItemCount":{"type":"long"},"ImportedItemCount":{"type":"long"},"FailureCode":{},"FailureMessage":{}}},"S6t":{"type":"structure","required":["S3Bucket"],"members":{"S3BucketOwner":{},"S3Bucket":{},"S3KeyPrefix":{}}},"S6x":{"type":"structure","members":{"Csv":{"type":"structure","members":{"Delimiter":{},"HeaderList":{"type":"list","member":{}}}}}},"S73":{"type":"structure","required":["TableName","AttributeDefinitions","KeySchema"],"members":{"TableName":{},"AttributeDefinitions":{"shape":"S2o"},"KeySchema":{"shape":"S2s"},"BillingMode":{},"ProvisionedThroughput":{"shape":"S33"},"OnDemandThroughput":{"shape":"S34"},"SSESpecification":{"shape":"S39"},"GlobalSecondaryIndexes":{"shape":"S31"}}},"S7k":{"type":"structure","members":{"TableName":{},"TableStatus":{},"Replicas":{"type":"list","member":{"type":"structure","members":{"RegionName":{},"GlobalSecondaryIndexes":{"type":"list","member":{"type":"structure","members":{"IndexName":{},"IndexStatus":{},"ProvisionedReadCapacityAutoScalingSettings":{"shape":"S6f"},"ProvisionedWriteCapacityAutoScalingSettings":{"shape":"S6f"}}}},"ReplicaProvisionedReadCapacityAutoScalingSettings":{"shape":"S6f"},"ReplicaProvisionedWriteCapacityAutoScalingSettings":{"shape":"S6f"},"ReplicaStatus":{}}}}}},"S7r":{"type":"structure","required":["TableName","StreamArn"],"members":{"TableName":{},"StreamArn":{},"EnableKinesisStreamingConfiguration":{"shape":"S7s"}}},"S7s":{"type":"structure","members":{"ApproximateCreationDateTimePrecision":{}}},"S7t":{"type":"structure","members":{"TableName":{},"StreamArn":{},"DestinationStatus":{},"EnableKinesisStreamingConfiguration":{"shape":"S7s"}}},"S83":{"type":"list","member":{"type":"structure","members":{"Item":{"shape":"Sr"}}}},"S9l":{"type":"structure","required":["ComparisonOperator"],"members":{"AttributeValueList":{"shape":"S4m"},"ComparisonOperator":{}}},"S9m":{"type":"map","key":{},"value":{"shape":"S9l"}},"Sas":{"type":"structure","members":{"MinimumUnits":{"type":"long"},"MaximumUnits":{"type":"long"},"AutoScalingDisabled":{"type":"boolean"},"AutoScalingRoleArn":{},"ScalingPolicyUpdate":{"type":"structure","required":["TargetTrackingScalingPolicyConfiguration"],"members":{"PolicyName":{},"TargetTrackingScalingPolicyConfiguration":{"type":"structure","required":["TargetValue"],"members":{"DisableScaleIn":{"type":"boolean"},"ScaleInCooldown":{"type":"integer"},"ScaleOutCooldown":{"type":"integer"},"TargetValue":{"type":"double"}}}}}}},"Sb9":{"type":"structure","members":{"ApproximateCreationDateTimePrecision":{}}},"Sbk":{"type":"list","member":{"type":"structure","required":["IndexName"],"members":{"IndexName":{},"ProvisionedThroughputOverride":{"shape":"S2d"},"OnDemandThroughputOverride":{"shape":"S2f"}}}},"Sby":{"type":"structure","required":["Enabled","AttributeName"],"members":{"Enabled":{"type":"boolean"},"AttributeName":{}}}}}

/***/ }),
/* 473 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetItem":{"input_token":"RequestItems","output_token":"UnprocessedKeys"},"ListContributorInsights":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListExports":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListImports":{"input_token":"NextToken","limit_key":"PageSize","output_token":"NextToken"},"ListTables":{"input_token":"ExclusiveStartTableName","limit_key":"Limit","output_token":"LastEvaluatedTableName","result_key":"TableNames"},"Query":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"},"Scan":{"input_token":"ExclusiveStartKey","limit_key":"Limit","output_token":"LastEvaluatedKey","result_key":"Items"}}}

/***/ }),
/* 474 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TableExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"Table.TableStatus"},{"expected":"ResourceNotFoundException","matcher":"error","state":"retry"}]},"TableNotExists":{"delay":20,"operation":"DescribeTable","maxAttempts":25,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 475 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-15","endpointPrefix":"ec2","protocol":"ec2","serviceAbbreviation":"Amazon EC2","serviceFullName":"Amazon Elastic Compute Cloud","serviceId":"EC2","signatureVersion":"v4","uid":"ec2-2016-11-15","xmlNamespace":"http://ec2.amazonaws.com/doc/2016-11-15"},"operations":{"AcceptAddressTransfer":{"input":{"type":"structure","required":["Address"],"members":{"Address":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AddressTransfer":{"shape":"Sa","locationName":"addressTransfer"}}}},"AcceptReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"Se","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"Sg","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"ExchangeId":{"locationName":"exchangeId"}}}},"AcceptTransitGatewayMulticastDomainAssociations":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"So"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sq","locationName":"associations"}}}},"AcceptTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sx","locationName":"transitGatewayPeeringAttachment"}}}},"AcceptTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"S16","locationName":"transitGatewayVpcAttachment"}}}},"AcceptVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"S1e","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S1h","locationName":"unsuccessful"}}}},"AcceptVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"S1n","locationName":"vpcPeeringConnection"}}}},"AdvertiseByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"Asn":{},"DryRun":{"type":"boolean"},"NetworkBorderGroup":{}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1y","locationName":"byoipCidr"}}}},"AllocateAddress":{"input":{"type":"structure","members":{"Domain":{},"Address":{},"PublicIpv4Pool":{},"NetworkBorderGroup":{},"CustomerOwnedIpv4Pool":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Domain":{"locationName":"domain"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"},"CarrierIp":{"locationName":"carrierIp"}}}},"AllocateHosts":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"ClientToken":{"locationName":"clientToken"},"InstanceType":{"locationName":"instanceType"},"InstanceFamily":{},"Quantity":{"locationName":"quantity","type":"integer"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"HostRecovery":{},"OutpostArn":{},"HostMaintenance":{},"AssetIds":{"locationName":"AssetId","type":"list","member":{}}}},"output":{"type":"structure","members":{"HostIds":{"shape":"S2f","locationName":"hostIdSet"}}}},"AllocateIpamPoolCidr":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{},"NetmaskLength":{"type":"integer"},"ClientToken":{"idempotencyToken":true},"Description":{},"PreviewNextCidr":{"type":"boolean"},"AllowedCidrs":{"locationName":"AllowedCidr","type":"list","member":{"locationName":"item"}},"DisallowedCidrs":{"locationName":"DisallowedCidr","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"IpamPoolAllocation":{"shape":"S2l","locationName":"ipamPoolAllocation"}}}},"ApplySecurityGroupsToClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","VpcId","SecurityGroupIds"],"members":{"ClientVpnEndpointId":{},"VpcId":{},"SecurityGroupIds":{"shape":"S2r","locationName":"SecurityGroupId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SecurityGroupIds":{"shape":"S2r","locationName":"securityGroupIds"}}}},"AssignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"S2v","locationName":"ipv6Addresses"},"Ipv6PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"S2w","locationName":"Ipv6Prefix"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"AssignedIpv6Addresses":{"shape":"S2v","locationName":"assignedIpv6Addresses"},"AssignedIpv6Prefixes":{"shape":"S2w","locationName":"assignedIpv6PrefixSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"AssignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"AllowReassignment":{"locationName":"allowReassignment","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S30","locationName":"privateIpAddress"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"Ipv4Prefixes":{"shape":"S2w","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AssignedPrivateIpAddresses":{"locationName":"assignedPrivateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"AssignedIpv4Prefixes":{"shape":"S34","locationName":"assignedIpv4PrefixSet"}}}},"AssignPrivateNatGatewayAddress":{"input":{"type":"structure","required":["NatGatewayId"],"members":{"NatGatewayId":{},"PrivateIpAddresses":{"shape":"S38","locationName":"PrivateIpAddress"},"PrivateIpAddressCount":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"},"NatGatewayAddresses":{"shape":"S3b","locationName":"natGatewayAddressSet"}}}},"AssociateAddress":{"input":{"type":"structure","members":{"AllocationId":{},"InstanceId":{},"PublicIp":{},"AllowReassociation":{"locationName":"allowReassociation","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"}}}},"AssociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","SubnetId"],"members":{"ClientVpnEndpointId":{},"SubnetId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S3m","locationName":"status"}}}},"AssociateDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId","VpcId"],"members":{"DhcpOptionsId":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"AssociateEnclaveCertificateIamRole":{"input":{"type":"structure","required":["CertificateArn","RoleArn"],"members":{"CertificateArn":{},"RoleArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CertificateS3BucketName":{"locationName":"certificateS3BucketName"},"CertificateS3ObjectKey":{"locationName":"certificateS3ObjectKey"},"EncryptionKmsKeyId":{"locationName":"encryptionKmsKeyId"}}}},"AssociateIamInstanceProfile":{"input":{"type":"structure","required":["IamInstanceProfile","InstanceId"],"members":{"IamInstanceProfile":{"shape":"S3v"},"InstanceId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S3x","locationName":"iamInstanceProfileAssociation"}}}},"AssociateInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId","AssociationTarget"],"members":{"DryRun":{"type":"boolean"},"InstanceEventWindowId":{},"AssociationTarget":{"type":"structure","members":{"InstanceIds":{"shape":"S43","locationName":"InstanceId"},"InstanceTags":{"shape":"S6","locationName":"InstanceTag"},"DedicatedHostIds":{"shape":"S44","locationName":"DedicatedHostId"}}}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S47","locationName":"instanceEventWindow"}}}},"AssociateIpamByoasn":{"input":{"type":"structure","required":["Asn","Cidr"],"members":{"DryRun":{"type":"boolean"},"Asn":{},"Cidr":{}}},"output":{"type":"structure","members":{"AsnAssociation":{"shape":"S20","locationName":"asnAssociation"}}}},"AssociateIpamResourceDiscovery":{"input":{"type":"structure","required":["IpamId","IpamResourceDiscoveryId"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"IpamResourceDiscoveryId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"IpamResourceDiscoveryAssociation":{"shape":"S4l","locationName":"ipamResourceDiscoveryAssociation"}}}},"AssociateNatGatewayAddress":{"input":{"type":"structure","required":["NatGatewayId","AllocationIds"],"members":{"NatGatewayId":{},"AllocationIds":{"shape":"S4r","locationName":"AllocationId"},"PrivateIpAddresses":{"shape":"S38","locationName":"PrivateIpAddress"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"},"NatGatewayAddresses":{"shape":"S3b","locationName":"natGatewayAddressSet"}}}},"AssociateRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"},"GatewayId":{}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"AssociationState":{"shape":"S4x","locationName":"associationState"}}}},"AssociateSubnetCidrBlock":{"input":{"type":"structure","required":["SubnetId"],"members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"SubnetId":{"locationName":"subnetId"},"Ipv6IpamPoolId":{},"Ipv6NetmaskLength":{"type":"integer"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S52","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"AssociateTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId","TransitGatewayAttachmentId","SubnetIds"],"members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"S57"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sq","locationName":"associations"}}}},"AssociateTransitGatewayPolicyTable":{"input":{"type":"structure","required":["TransitGatewayPolicyTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayPolicyTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S5c","locationName":"association"}}}},"AssociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S5h","locationName":"association"}}}},"AssociateTrunkInterface":{"input":{"type":"structure","required":["BranchInterfaceId","TrunkInterfaceId"],"members":{"BranchInterfaceId":{},"TrunkInterfaceId":{},"VlanId":{"type":"integer"},"GreKey":{"type":"integer"},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfaceAssociation":{"shape":"S5k","locationName":"interfaceAssociation"},"ClientToken":{"locationName":"clientToken"}}}},"AssociateVpcCidrBlock":{"input":{"type":"structure","required":["VpcId"],"members":{"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"CidrBlock":{},"VpcId":{"locationName":"vpcId"},"Ipv6CidrBlockNetworkBorderGroup":{},"Ipv6Pool":{},"Ipv6CidrBlock":{},"Ipv4IpamPoolId":{},"Ipv4NetmaskLength":{"type":"integer"},"Ipv6IpamPoolId":{},"Ipv6NetmaskLength":{"type":"integer"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S5q","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S5t","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"AttachClassicLinkVpc":{"input":{"type":"structure","required":["Groups","InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"S5v","locationName":"SecurityGroupId"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"AttachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"AttachNetworkInterface":{"input":{"type":"structure","required":["DeviceIndex","InstanceId","NetworkInterfaceId"],"members":{"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkCardIndex":{"type":"integer"},"EnaSrdSpecification":{"shape":"S60"}}},"output":{"type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"}}}},"AttachVerifiedAccessTrustProvider":{"input":{"type":"structure","required":["VerifiedAccessInstanceId","VerifiedAccessTrustProviderId"],"members":{"VerifiedAccessInstanceId":{},"VerifiedAccessTrustProviderId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessTrustProvider":{"shape":"S67","locationName":"verifiedAccessTrustProvider"},"VerifiedAccessInstance":{"shape":"S6g","locationName":"verifiedAccessInstance"}}}},"AttachVolume":{"input":{"type":"structure","required":["Device","InstanceId","VolumeId"],"members":{"Device":{},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S6l"}},"AttachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcAttachment":{"shape":"S6q","locationName":"attachment"}}}},"AuthorizeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"AuthorizeAllGroups":{"type":"boolean"},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S6u","locationName":"status"}}}},"AuthorizeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S6x","locationName":"ipPermissions"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"SecurityGroupRules":{"shape":"S78","locationName":"securityGroupRuleSet"}}}},"AuthorizeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S6x"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"SecurityGroupRules":{"shape":"S78","locationName":"securityGroupRuleSet"}}}},"BundleInstance":{"input":{"type":"structure","required":["InstanceId","Storage"],"members":{"InstanceId":{},"Storage":{"shape":"S7h"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S7m","locationName":"bundleInstanceTask"}}}},"CancelBundleTask":{"input":{"type":"structure","required":["BundleId"],"members":{"BundleId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTask":{"shape":"S7m","locationName":"bundleInstanceTask"}}}},"CancelCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CancelCapacityReservationFleets":{"input":{"type":"structure","required":["CapacityReservationFleetIds"],"members":{"DryRun":{"type":"boolean"},"CapacityReservationFleetIds":{"shape":"S7w","locationName":"CapacityReservationFleetId"}}},"output":{"type":"structure","members":{"SuccessfulFleetCancellations":{"locationName":"successfulFleetCancellationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentFleetState":{"locationName":"currentFleetState"},"PreviousFleetState":{"locationName":"previousFleetState"},"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"}}}},"FailedFleetCancellations":{"locationName":"failedFleetCancellationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"CancelCapacityReservationFleetError":{"locationName":"cancelCapacityReservationFleetError","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"CancelConversionTask":{"input":{"type":"structure","required":["ConversionTaskId"],"members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"ReasonMessage":{"locationName":"reasonMessage"}}}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskId"],"members":{"ExportTaskId":{"locationName":"exportTaskId"}}}},"CancelImageLaunchPermission":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CancelImportTask":{"input":{"type":"structure","members":{"CancelReason":{},"DryRun":{"type":"boolean"},"ImportTaskId":{}}},"output":{"type":"structure","members":{"ImportTaskId":{"locationName":"importTaskId"},"PreviousState":{"locationName":"previousState"},"State":{"locationName":"state"}}}},"CancelReservedInstancesListing":{"input":{"type":"structure","required":["ReservedInstancesListingId"],"members":{"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S8k","locationName":"reservedInstancesListingsSet"}}}},"CancelSpotFleetRequests":{"input":{"type":"structure","required":["SpotFleetRequestIds","TerminateInstances"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestIds":{"shape":"S8w","locationName":"spotFleetRequestId"},"TerminateInstances":{"locationName":"terminateInstances","type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetRequests":{"locationName":"successfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentSpotFleetRequestState":{"locationName":"currentSpotFleetRequestState"},"PreviousSpotFleetRequestState":{"locationName":"previousSpotFleetRequestState"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"UnsuccessfulFleetRequests":{"locationName":"unsuccessfulFleetRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}}}}},"CancelSpotInstanceRequests":{"input":{"type":"structure","required":["SpotInstanceRequestIds"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S97","locationName":"SpotInstanceRequestId"}}},"output":{"type":"structure","members":{"CancelledSpotInstanceRequests":{"locationName":"spotInstanceRequestSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"State":{"locationName":"state"}}}}}}},"ConfirmProductInstance":{"input":{"type":"structure","required":["InstanceId","ProductCode"],"members":{"InstanceId":{},"ProductCode":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"Return":{"locationName":"return","type":"boolean"}}}},"CopyFpgaImage":{"input":{"type":"structure","required":["SourceFpgaImageId","SourceRegion"],"members":{"DryRun":{"type":"boolean"},"SourceFpgaImageId":{},"Description":{},"Name":{},"SourceRegion":{},"ClientToken":{}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"}}}},"CopyImage":{"input":{"type":"structure","required":["Name","SourceImageId","SourceRegion"],"members":{"ClientToken":{},"Description":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"Name":{},"SourceImageId":{},"SourceRegion":{},"DestinationOutpostArn":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"CopyImageTags":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceRegion","SourceSnapshotId"],"members":{"Description":{},"DestinationOutpostArn":{},"DestinationRegion":{"locationName":"destinationRegion"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"PresignedUrl":{"locationName":"presignedUrl","type":"string","sensitive":true},"SourceRegion":{},"SourceSnapshotId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"CreateCapacityReservation":{"input":{"type":"structure","required":["InstanceType","InstancePlatform","InstanceCount"],"members":{"ClientToken":{},"InstanceType":{},"InstancePlatform":{},"AvailabilityZone":{},"AvailabilityZoneId":{},"Tenancy":{},"InstanceCount":{"type":"integer"},"EbsOptimized":{"type":"boolean"},"EphemeralStorage":{"type":"boolean"},"EndDate":{"type":"timestamp"},"EndDateType":{},"InstanceMatchCriteria":{},"TagSpecifications":{"shape":"S3"},"DryRun":{"type":"boolean"},"OutpostArn":{},"PlacementGroupArn":{}}},"output":{"type":"structure","members":{"CapacityReservation":{"shape":"S9x","locationName":"capacityReservation"}}}},"CreateCapacityReservationFleet":{"input":{"type":"structure","required":["InstanceTypeSpecifications","TotalTargetCapacity"],"members":{"AllocationStrategy":{},"ClientToken":{"idempotencyToken":true},"InstanceTypeSpecifications":{"locationName":"InstanceTypeSpecification","type":"list","member":{"type":"structure","members":{"InstanceType":{},"InstancePlatform":{},"Weight":{"type":"double"},"AvailabilityZone":{},"AvailabilityZoneId":{},"EbsOptimized":{"type":"boolean"},"Priority":{"type":"integer"}}}},"Tenancy":{},"TotalTargetCapacity":{"type":"integer"},"EndDate":{"type":"timestamp"},"InstanceMatchCriteria":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"State":{"locationName":"state"},"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"TotalFulfilledCapacity":{"locationName":"totalFulfilledCapacity","type":"double"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"AllocationStrategy":{"locationName":"allocationStrategy"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"Tenancy":{"locationName":"tenancy"},"FleetCapacityReservations":{"shape":"Sac","locationName":"fleetCapacityReservationSet"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"CreateCarrierGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CarrierGateway":{"shape":"Sag","locationName":"carrierGateway"}}}},"CreateClientVpnEndpoint":{"input":{"type":"structure","required":["ClientCidrBlock","ServerCertificateArn","AuthenticationOptions","ConnectionLogOptions"],"members":{"ClientCidrBlock":{},"ServerCertificateArn":{},"AuthenticationOptions":{"locationName":"Authentication","type":"list","member":{"type":"structure","members":{"Type":{},"ActiveDirectory":{"type":"structure","members":{"DirectoryId":{}}},"MutualAuthentication":{"type":"structure","members":{"ClientRootCertificateChainArn":{}}},"FederatedAuthentication":{"type":"structure","members":{"SAMLProviderArn":{},"SelfServiceSAMLProviderArn":{}}}}}},"ConnectionLogOptions":{"shape":"Saq"},"DnsServers":{"shape":"So"},"TransportProtocol":{},"VpnPort":{"type":"integer"},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"SecurityGroupIds":{"shape":"S2r","locationName":"SecurityGroupId"},"VpcId":{},"SelfServicePortal":{},"ClientConnectOptions":{"shape":"Sat"},"SessionTimeoutHours":{"type":"integer"},"ClientLoginBannerOptions":{"shape":"Sau"}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"Saw","locationName":"status"},"DnsName":{"locationName":"dnsName"}}}},"CreateClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock","TargetVpcSubnetId"],"members":{"ClientVpnEndpointId":{},"DestinationCidrBlock":{},"TargetVpcSubnetId":{},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"Sb0","locationName":"status"}}}},"CreateCoipCidr":{"input":{"type":"structure","required":["Cidr","CoipPoolId"],"members":{"Cidr":{},"CoipPoolId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipCidr":{"shape":"Sb5","locationName":"coipCidr"}}}},"CreateCoipPool":{"input":{"type":"structure","required":["LocalGatewayRouteTableId"],"members":{"LocalGatewayRouteTableId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPool":{"shape":"Sb9","locationName":"coipPool"}}}},"CreateCustomerGateway":{"input":{"type":"structure","required":["Type"],"members":{"BgpAsn":{"type":"integer"},"PublicIp":{},"CertificateArn":{},"Type":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DeviceName":{},"IpAddress":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateway":{"shape":"Sbd","locationName":"customerGateway"}}}},"CreateDefaultSubnet":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"DryRun":{"type":"boolean"},"Ipv6Native":{"type":"boolean"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"Sbg","locationName":"subnet"}}}},"CreateDefaultVpc":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"Sbo","locationName":"vpc"}}}},"CreateDhcpOptions":{"input":{"type":"structure","required":["DhcpConfigurations"],"members":{"DhcpConfigurations":{"locationName":"dhcpConfiguration","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{},"Values":{"shape":"So","locationName":"Value"}}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"DhcpOptions":{"shape":"Sbx","locationName":"dhcpOptions"}}}},"CreateEgressOnlyInternetGateway":{"input":{"type":"structure","required":["VpcId"],"members":{"ClientToken":{},"DryRun":{"type":"boolean"},"VpcId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"EgressOnlyInternetGateway":{"shape":"Sc4","locationName":"egressOnlyInternetGateway"}}}},"CreateFleet":{"input":{"type":"structure","required":["LaunchTemplateConfigs","TargetCapacitySpecification"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"SpotOptions":{"type":"structure","members":{"AllocationStrategy":{},"MaintenanceStrategies":{"type":"structure","members":{"CapacityRebalance":{"type":"structure","members":{"ReplacementStrategy":{},"TerminationDelay":{"type":"integer"}}}}},"InstanceInterruptionBehavior":{},"InstancePoolsToUseCount":{"type":"integer"},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"OnDemandOptions":{"type":"structure","members":{"AllocationStrategy":{},"CapacityReservationOptions":{"type":"structure","members":{"UsageStrategy":{}}},"SingleInstanceType":{"type":"boolean"},"SingleAvailabilityZone":{"type":"boolean"},"MinTargetCapacity":{"type":"integer"},"MaxTotalPrice":{}}},"ExcessCapacityTerminationPolicy":{},"LaunchTemplateConfigs":{"shape":"Sck"},"TargetCapacitySpecification":{"shape":"Sdn"},"TerminateInstancesWithExpiration":{"type":"boolean"},"Type":{},"ValidFrom":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"},"ReplaceUnhealthyInstances":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"Context":{}}},"output":{"type":"structure","members":{"FleetId":{"locationName":"fleetId"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sdv","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sdv","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"Sec","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}}}}},"CreateFlowLogs":{"input":{"type":"structure","required":["ResourceIds","ResourceType"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"DeliverLogsPermissionArn":{},"DeliverCrossAccountRole":{},"LogGroupName":{},"ResourceIds":{"locationName":"ResourceId","type":"list","member":{"locationName":"item"}},"ResourceType":{},"TrafficType":{},"LogDestinationType":{},"LogDestination":{},"LogFormat":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"MaxAggregationInterval":{"type":"integer"},"DestinationOptions":{"type":"structure","members":{"FileFormat":{},"HiveCompatiblePartitions":{"type":"boolean"},"PerHourPartition":{"type":"boolean"}}}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"FlowLogIds":{"shape":"So","locationName":"flowLogIdSet"},"Unsuccessful":{"shape":"S1h","locationName":"unsuccessful"}}}},"CreateFpgaImage":{"input":{"type":"structure","required":["InputStorageLocation"],"members":{"DryRun":{"type":"boolean"},"InputStorageLocation":{"shape":"Seo"},"LogsStorageLocation":{"shape":"Seo"},"Description":{},"Name":{},"ClientToken":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"}}}},"CreateImage":{"input":{"type":"structure","required":["InstanceId","Name"],"members":{"BlockDeviceMappings":{"shape":"Ser","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"Name":{"locationName":"name"},"NoReboot":{"locationName":"noReboot","type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateInstanceConnectEndpoint":{"input":{"type":"structure","required":["SubnetId"],"members":{"DryRun":{"type":"boolean"},"SubnetId":{},"SecurityGroupIds":{"locationName":"SecurityGroupId","type":"list","member":{"locationName":"SecurityGroupId"}},"PreserveClientIp":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"InstanceConnectEndpoint":{"shape":"Sf0","locationName":"instanceConnectEndpoint"},"ClientToken":{"locationName":"clientToken"}}}},"CreateInstanceEventWindow":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Name":{},"TimeRanges":{"shape":"Sf6","locationName":"TimeRange"},"CronExpression":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S47","locationName":"instanceEventWindow"}}}},"CreateInstanceExportTask":{"input":{"type":"structure","required":["ExportToS3Task","InstanceId","TargetEnvironment"],"members":{"Description":{"locationName":"description"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ExportTask":{"shape":"Sff","locationName":"exportTask"}}}},"CreateInternetGateway":{"input":{"type":"structure","members":{"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InternetGateway":{"shape":"Sfl","locationName":"internetGateway"}}}},"CreateIpam":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Description":{},"OperatingRegions":{"shape":"Sfn","locationName":"OperatingRegion"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"Tier":{}}},"output":{"type":"structure","members":{"Ipam":{"shape":"Sfr","locationName":"ipam"}}}},"CreateIpamPool":{"input":{"type":"structure","required":["IpamScopeId","AddressFamily"],"members":{"DryRun":{"type":"boolean"},"IpamScopeId":{},"Locale":{},"SourceIpamPoolId":{},"Description":{},"AddressFamily":{},"AutoImport":{"type":"boolean"},"PubliclyAdvertisable":{"type":"boolean"},"AllocationMinNetmaskLength":{"type":"integer"},"AllocationMaxNetmaskLength":{"type":"integer"},"AllocationDefaultNetmaskLength":{"type":"integer"},"AllocationResourceTags":{"shape":"Sfz","locationName":"AllocationResourceTag"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"AwsService":{},"PublicIpSource":{},"SourceResource":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"ResourceRegion":{},"ResourceOwner":{}}}}},"output":{"type":"structure","members":{"IpamPool":{"shape":"Sg6","locationName":"ipamPool"}}}},"CreateIpamResourceDiscovery":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Description":{},"OperatingRegions":{"shape":"Sfn","locationName":"OperatingRegion"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"IpamResourceDiscovery":{"shape":"Sge","locationName":"ipamResourceDiscovery"}}}},"CreateIpamScope":{"input":{"type":"structure","required":["IpamId"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Description":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"IpamScope":{"shape":"Sgi","locationName":"ipamScope"}}}},"CreateKeyPair":{"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyType":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"KeyFormat":{}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyMaterial":{"shape":"Sgo","locationName":"keyMaterial"},"KeyName":{"locationName":"keyName"},"KeyPairId":{"locationName":"keyPairId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"CreateLaunchTemplate":{"input":{"type":"structure","required":["LaunchTemplateName","LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateName":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"Sgr"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sic","locationName":"launchTemplate"},"Warning":{"shape":"Sid","locationName":"warning"}}}},"CreateLaunchTemplateVersion":{"input":{"type":"structure","required":["LaunchTemplateData"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"SourceVersion":{},"VersionDescription":{},"LaunchTemplateData":{"shape":"Sgr"},"ResolveAlias":{"type":"boolean"}}},"output":{"type":"structure","members":{"LaunchTemplateVersion":{"shape":"Sii","locationName":"launchTemplateVersion"},"Warning":{"shape":"Sid","locationName":"warning"}}}},"CreateLocalGatewayRoute":{"input":{"type":"structure","required":["LocalGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"LocalGatewayRouteTableId":{},"LocalGatewayVirtualInterfaceGroupId":{},"DryRun":{"type":"boolean"},"NetworkInterfaceId":{},"DestinationPrefixListId":{}}},"output":{"type":"structure","members":{"Route":{"shape":"Sjo","locationName":"route"}}}},"CreateLocalGatewayRouteTable":{"input":{"type":"structure","required":["LocalGatewayId"],"members":{"LocalGatewayId":{},"Mode":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTable":{"shape":"Sjv","locationName":"localGatewayRouteTable"}}}},"CreateLocalGatewayRouteTableVirtualInterfaceGroupAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableId","LocalGatewayVirtualInterfaceGroupId"],"members":{"LocalGatewayRouteTableId":{},"LocalGatewayVirtualInterfaceGroupId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociation":{"shape":"Sjz","locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociation"}}}},"CreateLocalGatewayRouteTableVpcAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableId","VpcId"],"members":{"LocalGatewayRouteTableId":{},"VpcId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociation":{"shape":"Sk3","locationName":"localGatewayRouteTableVpcAssociation"}}}},"CreateManagedPrefixList":{"input":{"type":"structure","required":["PrefixListName","MaxEntries","AddressFamily"],"members":{"DryRun":{"type":"boolean"},"PrefixListName":{},"Entries":{"shape":"Sk6","locationName":"Entry"},"MaxEntries":{"type":"integer"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"AddressFamily":{},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sk9","locationName":"prefixList"}}}},"CreateNatGateway":{"input":{"type":"structure","required":["SubnetId"],"members":{"AllocationId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SubnetId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ConnectivityType":{},"PrivateIpAddress":{},"SecondaryAllocationIds":{"shape":"S4r","locationName":"SecondaryAllocationId"},"SecondaryPrivateIpAddresses":{"shape":"S38","locationName":"SecondaryPrivateIpAddress"},"SecondaryPrivateIpAddressCount":{"type":"integer"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"NatGateway":{"shape":"Ske","locationName":"natGateway"}}}},"CreateNetworkAcl":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkAcl":{"shape":"Skj","locationName":"networkAcl"},"ClientToken":{"locationName":"clientToken"}}}},"CreateNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Sko","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Skp","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"CreateNetworkInsightsAccessScope":{"input":{"type":"structure","required":["ClientToken"],"members":{"MatchPaths":{"shape":"Sku","locationName":"MatchPath"},"ExcludePaths":{"shape":"Sku","locationName":"ExcludePath"},"ClientToken":{"idempotencyToken":true},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScope":{"shape":"Sl4","locationName":"networkInsightsAccessScope"},"NetworkInsightsAccessScopeContent":{"shape":"Sl6","locationName":"networkInsightsAccessScopeContent"}}}},"CreateNetworkInsightsPath":{"input":{"type":"structure","required":["Source","Protocol","ClientToken"],"members":{"SourceIp":{},"DestinationIp":{},"Source":{},"Destination":{},"Protocol":{},"DestinationPort":{"type":"integer"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"FilterAtSource":{"shape":"Sli"},"FilterAtDestination":{"shape":"Sli"}}},"output":{"type":"structure","members":{"NetworkInsightsPath":{"shape":"Sll","locationName":"networkInsightsPath"}}}},"CreateNetworkInterface":{"input":{"type":"structure","required":["SubnetId"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"Sgz","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Siq","locationName":"ipv6Addresses"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"Sh2","locationName":"privateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"Ipv4Prefixes":{"shape":"Sh4","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"Sh6","locationName":"Ipv6Prefix"},"Ipv6PrefixCount":{"type":"integer"},"InterfaceType":{},"SubnetId":{"locationName":"subnetId"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"EnablePrimaryIpv6":{"type":"boolean"},"ConnectionTrackingSpecification":{"shape":"Sha"}}},"output":{"type":"structure","members":{"NetworkInterface":{"shape":"Sls","locationName":"networkInterface"},"ClientToken":{"locationName":"clientToken"}}}},"CreateNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfaceId","Permission"],"members":{"NetworkInterfaceId":{},"AwsAccountId":{},"AwsService":{},"Permission":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InterfacePermission":{"shape":"Smb","locationName":"interfacePermission"}}}},"CreatePlacementGroup":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"type":"integer"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"SpreadLevel":{}}},"output":{"type":"structure","members":{"PlacementGroup":{"shape":"Smi","locationName":"placementGroup"}}}},"CreatePublicIpv4Pool":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"PoolId":{"locationName":"poolId"}}}},"CreateReplaceRootVolumeTask":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"SnapshotId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ImageId":{},"DeleteReplacedRootVolume":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReplaceRootVolumeTask":{"shape":"Smo","locationName":"replaceRootVolumeTask"}}}},"CreateReservedInstancesListing":{"input":{"type":"structure","required":["ClientToken","InstanceCount","PriceSchedules","ReservedInstancesId"],"members":{"ClientToken":{"locationName":"clientToken"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S8k","locationName":"reservedInstancesListingsSet"}}}},"CreateRestoreImageTask":{"input":{"type":"structure","required":["Bucket","ObjectKey"],"members":{"Bucket":{},"ObjectKey":{},"Name":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"CreateRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcEndpointId":{},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"LocalGatewayId":{},"CarrierGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"CoreNetworkArn":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"CreateRouteTable":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RouteTable":{"shape":"Sn4","locationName":"routeTable"},"ClientToken":{"locationName":"clientToken"}}}},"CreateSecurityGroup":{"input":{"type":"structure","required":["Description","GroupName"],"members":{"Description":{"locationName":"GroupDescription"},"GroupName":{},"VpcId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"GroupId":{"locationName":"groupId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeId"],"members":{"Description":{},"OutpostArn":{},"VolumeId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"Sng"}},"CreateSnapshots":{"input":{"type":"structure","required":["InstanceSpecification"],"members":{"Description":{},"InstanceSpecification":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ExcludeBootVolume":{"type":"boolean"},"ExcludeDataVolumeIds":{"shape":"Snn","locationName":"ExcludeDataVolumeId"}}},"OutpostArn":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"CopyTagsFromSource":{}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"Tags":{"shape":"S6","locationName":"tagSet"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"VolumeId":{"locationName":"volumeId"},"State":{"locationName":"state"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"StartTime":{"locationName":"startTime","type":"timestamp"},"Progress":{"locationName":"progress"},"OwnerId":{"locationName":"ownerId"},"SnapshotId":{"locationName":"snapshotId"},"OutpostArn":{"locationName":"outpostArn"},"SseType":{"locationName":"sseType"}}}}}}},"CreateSpotDatafeedSubscription":{"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"locationName":"bucket"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Prefix":{"locationName":"prefix"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Snu","locationName":"spotDatafeedSubscription"}}}},"CreateStoreImageTask":{"input":{"type":"structure","required":["ImageId","Bucket"],"members":{"ImageId":{},"Bucket":{},"S3ObjectTags":{"locationName":"S3ObjectTag","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{},"Value":{}}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ObjectKey":{"locationName":"objectKey"}}}},"CreateSubnet":{"input":{"type":"structure","required":["VpcId"],"members":{"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"AvailabilityZone":{},"AvailabilityZoneId":{},"CidrBlock":{},"Ipv6CidrBlock":{},"OutpostArn":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Ipv6Native":{"type":"boolean"},"Ipv4IpamPoolId":{},"Ipv4NetmaskLength":{"type":"integer"},"Ipv6IpamPoolId":{},"Ipv6NetmaskLength":{"type":"integer"}}},"output":{"type":"structure","members":{"Subnet":{"shape":"Sbg","locationName":"subnet"}}}},"CreateSubnetCidrReservation":{"input":{"type":"structure","required":["SubnetId","Cidr","ReservationType"],"members":{"SubnetId":{},"Cidr":{},"ReservationType":{},"Description":{},"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"SubnetCidrReservation":{"shape":"So6","locationName":"subnetCidrReservation"}}}},"CreateTags":{"input":{"type":"structure","required":["Resources","Tags"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"So9","locationName":"ResourceId"},"Tags":{"shape":"S6","locationName":"Tag"}}}},"CreateTrafficMirrorFilter":{"input":{"type":"structure","members":{"Description":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sod","locationName":"trafficMirrorFilter"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterId","TrafficDirection","RuleNumber","RuleAction","DestinationCidrBlock","SourceCidrBlock"],"members":{"TrafficMirrorFilterId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Son"},"SourcePortRange":{"shape":"Son"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sof","locationName":"trafficMirrorFilterRule"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorSession":{"input":{"type":"structure","required":["NetworkInterfaceId","TrafficMirrorTargetId","TrafficMirrorFilterId","SessionNumber"],"members":{"NetworkInterfaceId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sos","locationName":"trafficMirrorSession"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTrafficMirrorTarget":{"input":{"type":"structure","members":{"NetworkInterfaceId":{},"NetworkLoadBalancerArn":{},"Description":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"GatewayLoadBalancerEndpointId":{}}},"output":{"type":"structure","members":{"TrafficMirrorTarget":{"shape":"Sov","locationName":"trafficMirrorTarget"},"ClientToken":{"locationName":"clientToken"}}}},"CreateTransitGateway":{"input":{"type":"structure","members":{"Description":{},"Options":{"type":"structure","members":{"AmazonSideAsn":{"type":"long"},"AutoAcceptSharedAttachments":{},"DefaultRouteTableAssociation":{},"DefaultRouteTablePropagation":{},"VpnEcmpSupport":{},"DnsSupport":{},"SecurityGroupReferencingSupport":{},"MulticastSupport":{},"TransitGatewayCidrBlocks":{"shape":"Sp4"}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Sp6","locationName":"transitGateway"}}}},"CreateTransitGatewayConnect":{"input":{"type":"structure","required":["TransportTransitGatewayAttachmentId","Options"],"members":{"TransportTransitGatewayAttachmentId":{},"Options":{"type":"structure","required":["Protocol"],"members":{"Protocol":{}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnect":{"shape":"Spd","locationName":"transitGatewayConnect"}}}},"CreateTransitGatewayConnectPeer":{"input":{"type":"structure","required":["TransitGatewayAttachmentId","PeerAddress","InsideCidrBlocks"],"members":{"TransitGatewayAttachmentId":{},"TransitGatewayAddress":{},"PeerAddress":{},"BgpOptions":{"type":"structure","members":{"PeerAsn":{"type":"long"}}},"InsideCidrBlocks":{"shape":"Sph"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeer":{"shape":"Spj","locationName":"transitGatewayConnectPeer"}}}},"CreateTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"Options":{"type":"structure","members":{"Igmpv2Support":{},"StaticSourcesSupport":{},"AutoAcceptSharedAssociations":{}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomain":{"shape":"Spw","locationName":"transitGatewayMulticastDomain"}}}},"CreateTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayId","PeerTransitGatewayId","PeerAccountId","PeerRegion"],"members":{"TransitGatewayId":{},"PeerTransitGatewayId":{},"PeerAccountId":{},"PeerRegion":{},"Options":{"type":"structure","members":{"DynamicRouting":{}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sx","locationName":"transitGatewayPeeringAttachment"}}}},"CreateTransitGatewayPolicyTable":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"TagSpecifications":{"shape":"S3"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPolicyTable":{"shape":"Sq5","locationName":"transitGatewayPolicyTable"}}}},"CreateTransitGatewayPrefixListReference":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","PrefixListId"],"members":{"TransitGatewayRouteTableId":{},"PrefixListId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReference":{"shape":"Sq9","locationName":"transitGatewayPrefixListReference"}}}},"CreateTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sqe","locationName":"route"}}}},"CreateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"TagSpecifications":{"shape":"S3"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sqm","locationName":"transitGatewayRouteTable"}}}},"CreateTransitGatewayRouteTableAnnouncement":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","PeeringAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"PeeringAttachmentId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTableAnnouncement":{"shape":"Sqq","locationName":"transitGatewayRouteTableAnnouncement"}}}},"CreateTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayId","VpcId","SubnetIds"],"members":{"TransitGatewayId":{},"VpcId":{},"SubnetIds":{"shape":"S57"},"Options":{"type":"structure","members":{"DnsSupport":{},"SecurityGroupReferencingSupport":{},"Ipv6Support":{},"ApplianceModeSupport":{}}},"TagSpecifications":{"shape":"S3"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"S16","locationName":"transitGatewayVpcAttachment"}}}},"CreateVerifiedAccessEndpoint":{"input":{"type":"structure","required":["VerifiedAccessGroupId","EndpointType","AttachmentType","DomainCertificateArn","ApplicationDomain","EndpointDomainPrefix"],"members":{"VerifiedAccessGroupId":{},"EndpointType":{},"AttachmentType":{},"DomainCertificateArn":{},"ApplicationDomain":{},"EndpointDomainPrefix":{},"SecurityGroupIds":{"shape":"Sr1","locationName":"SecurityGroupId"},"LoadBalancerOptions":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"},"LoadBalancerArn":{},"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"item"}}}},"NetworkInterfaceOptions":{"type":"structure","members":{"NetworkInterfaceId":{},"Protocol":{},"Port":{"type":"integer"}}},"Description":{},"PolicyDocument":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SseSpecification":{"shape":"Sr8"}}},"output":{"type":"structure","members":{"VerifiedAccessEndpoint":{"shape":"Sra","locationName":"verifiedAccessEndpoint"}}}},"CreateVerifiedAccessGroup":{"input":{"type":"structure","required":["VerifiedAccessInstanceId"],"members":{"VerifiedAccessInstanceId":{},"Description":{},"PolicyDocument":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SseSpecification":{"shape":"Sr8"}}},"output":{"type":"structure","members":{"VerifiedAccessGroup":{"shape":"Sri","locationName":"verifiedAccessGroup"}}}},"CreateVerifiedAccessInstance":{"input":{"type":"structure","members":{"Description":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"FIPSEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessInstance":{"shape":"S6g","locationName":"verifiedAccessInstance"}}}},"CreateVerifiedAccessTrustProvider":{"input":{"type":"structure","required":["TrustProviderType","PolicyReferenceName"],"members":{"TrustProviderType":{},"UserTrustProviderType":{},"DeviceTrustProviderType":{},"OidcOptions":{"type":"structure","members":{"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"ClientId":{},"ClientSecret":{"shape":"S6c"},"Scope":{}}},"DeviceOptions":{"type":"structure","members":{"TenantId":{},"PublicSigningKeyUrl":{}}},"PolicyReferenceName":{},"Description":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SseSpecification":{"shape":"Sr8"}}},"output":{"type":"structure","members":{"VerifiedAccessTrustProvider":{"shape":"S67","locationName":"verifiedAccessTrustProvider"}}}},"CreateVolume":{"input":{"type":"structure","required":["AvailabilityZone"],"members":{"AvailabilityZone":{},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"OutpostArn":{},"Size":{"type":"integer"},"SnapshotId":{},"VolumeType":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"MultiAttachEnabled":{"type":"boolean"},"Throughput":{"type":"integer"},"ClientToken":{"idempotencyToken":true}}},"output":{"shape":"Srq"}},"CreateVpc":{"input":{"type":"structure","members":{"CidrBlock":{},"AmazonProvidedIpv6CidrBlock":{"locationName":"amazonProvidedIpv6CidrBlock","type":"boolean"},"Ipv6Pool":{},"Ipv6CidrBlock":{},"Ipv4IpamPoolId":{},"Ipv4NetmaskLength":{"type":"integer"},"Ipv6IpamPoolId":{},"Ipv6NetmaskLength":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockNetworkBorderGroup":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Vpc":{"shape":"Sbo","locationName":"vpc"}}}},"CreateVpcEndpoint":{"input":{"type":"structure","required":["VpcId","ServiceName"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointType":{},"VpcId":{},"ServiceName":{},"PolicyDocument":{},"RouteTableIds":{"shape":"Srx","locationName":"RouteTableId"},"SubnetIds":{"shape":"Sry","locationName":"SubnetId"},"SecurityGroupIds":{"shape":"Srz","locationName":"SecurityGroupId"},"IpAddressType":{},"DnsOptions":{"shape":"Ss1"},"ClientToken":{},"PrivateDnsEnabled":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"SubnetConfigurations":{"shape":"Ss3","locationName":"SubnetConfiguration"}}},"output":{"type":"structure","members":{"VpcEndpoint":{"shape":"Ss6","locationName":"vpcEndpoint"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationArn","ConnectionEvents"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"So"},"ClientToken":{}}},"output":{"type":"structure","members":{"ConnectionNotification":{"shape":"Ssg","locationName":"connectionNotification"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcEndpointServiceConfiguration":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"PrivateDnsName":{},"NetworkLoadBalancerArns":{"shape":"So","locationName":"NetworkLoadBalancerArn"},"GatewayLoadBalancerArns":{"shape":"So","locationName":"GatewayLoadBalancerArn"},"SupportedIpAddressTypes":{"shape":"So","locationName":"SupportedIpAddressType"},"ClientToken":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ServiceConfiguration":{"shape":"Ssl","locationName":"serviceConfiguration"},"ClientToken":{"locationName":"clientToken"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PeerOwnerId":{"locationName":"peerOwnerId"},"PeerVpcId":{"locationName":"peerVpcId"},"VpcId":{"locationName":"vpcId"},"PeerRegion":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"VpcPeeringConnection":{"shape":"S1n","locationName":"vpcPeeringConnection"}}}},"CreateVpnConnection":{"input":{"type":"structure","required":["CustomerGatewayId","Type"],"members":{"CustomerGatewayId":{},"Type":{},"VpnGatewayId":{},"TransitGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Options":{"locationName":"options","type":"structure","members":{"EnableAcceleration":{"type":"boolean"},"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"TunnelInsideIpVersion":{},"TunnelOptions":{"type":"list","member":{"type":"structure","members":{"TunnelInsideCidr":{},"TunnelInsideIpv6Cidr":{},"PreSharedKey":{"shape":"St3"},"Phase1LifetimeSeconds":{"type":"integer"},"Phase2LifetimeSeconds":{"type":"integer"},"RekeyMarginTimeSeconds":{"type":"integer"},"RekeyFuzzPercentage":{"type":"integer"},"ReplayWindowSize":{"type":"integer"},"DPDTimeoutSeconds":{"type":"integer"},"DPDTimeoutAction":{},"Phase1EncryptionAlgorithms":{"shape":"St4","locationName":"Phase1EncryptionAlgorithm"},"Phase2EncryptionAlgorithms":{"shape":"St6","locationName":"Phase2EncryptionAlgorithm"},"Phase1IntegrityAlgorithms":{"shape":"St8","locationName":"Phase1IntegrityAlgorithm"},"Phase2IntegrityAlgorithms":{"shape":"Sta","locationName":"Phase2IntegrityAlgorithm"},"Phase1DHGroupNumbers":{"shape":"Stc","locationName":"Phase1DHGroupNumber"},"Phase2DHGroupNumbers":{"shape":"Ste","locationName":"Phase2DHGroupNumber"},"IKEVersions":{"shape":"Stg","locationName":"IKEVersion"},"StartupAction":{},"LogOptions":{"shape":"Sti"},"EnableTunnelLifecycleControl":{"type":"boolean"}}}},"LocalIpv4NetworkCidr":{},"RemoteIpv4NetworkCidr":{},"LocalIpv6NetworkCidr":{},"RemoteIpv6NetworkCidr":{},"OutsideIpAddressType":{},"TransportTransitGatewayAttachmentId":{}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Stm","locationName":"vpnConnection"}}}},"CreateVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"CreateVpnGateway":{"input":{"type":"structure","required":["Type"],"members":{"AvailabilityZone":{},"Type":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"AmazonSideAsn":{"type":"long"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateway":{"shape":"Suj","locationName":"vpnGateway"}}}},"DeleteCarrierGateway":{"input":{"type":"structure","required":["CarrierGatewayId"],"members":{"CarrierGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CarrierGateway":{"shape":"Sag","locationName":"carrierGateway"}}}},"DeleteClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"Saw","locationName":"status"}}}},"DeleteClientVpnRoute":{"input":{"type":"structure","required":["ClientVpnEndpointId","DestinationCidrBlock"],"members":{"ClientVpnEndpointId":{},"TargetVpcSubnetId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"Sb0","locationName":"status"}}}},"DeleteCoipCidr":{"input":{"type":"structure","required":["Cidr","CoipPoolId"],"members":{"Cidr":{},"CoipPoolId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipCidr":{"shape":"Sb5","locationName":"coipCidr"}}}},"DeleteCoipPool":{"input":{"type":"structure","required":["CoipPoolId"],"members":{"CoipPoolId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPool":{"shape":"Sb9","locationName":"coipPool"}}}},"DeleteCustomerGateway":{"input":{"type":"structure","required":["CustomerGatewayId"],"members":{"CustomerGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteDhcpOptions":{"input":{"type":"structure","required":["DhcpOptionsId"],"members":{"DhcpOptionsId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteEgressOnlyInternetGateway":{"input":{"type":"structure","required":["EgressOnlyInternetGatewayId"],"members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayId":{}}},"output":{"type":"structure","members":{"ReturnCode":{"locationName":"returnCode","type":"boolean"}}}},"DeleteFleets":{"input":{"type":"structure","required":["FleetIds","TerminateInstances"],"members":{"DryRun":{"type":"boolean"},"FleetIds":{"shape":"Sv1","locationName":"FleetId"},"TerminateInstances":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuccessfulFleetDeletions":{"locationName":"successfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentFleetState":{"locationName":"currentFleetState"},"PreviousFleetState":{"locationName":"previousFleetState"},"FleetId":{"locationName":"fleetId"}}}},"UnsuccessfulFleetDeletions":{"locationName":"unsuccessfulFleetDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"FleetId":{"locationName":"fleetId"}}}}}}},"DeleteFlowLogs":{"input":{"type":"structure","required":["FlowLogIds"],"members":{"DryRun":{"type":"boolean"},"FlowLogIds":{"shape":"Svb","locationName":"FlowLogId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S1h","locationName":"unsuccessful"}}}},"DeleteFpgaImage":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteInstanceConnectEndpoint":{"input":{"type":"structure","required":["InstanceConnectEndpointId"],"members":{"DryRun":{"type":"boolean"},"InstanceConnectEndpointId":{}}},"output":{"type":"structure","members":{"InstanceConnectEndpoint":{"shape":"Sf0","locationName":"instanceConnectEndpoint"}}}},"DeleteInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId"],"members":{"DryRun":{"type":"boolean"},"ForceDelete":{"type":"boolean"},"InstanceEventWindowId":{}}},"output":{"type":"structure","members":{"InstanceEventWindowState":{"locationName":"instanceEventWindowState","type":"structure","members":{"InstanceEventWindowId":{"locationName":"instanceEventWindowId"},"State":{"locationName":"state"}}}}}},"DeleteInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"}}}},"DeleteIpam":{"input":{"type":"structure","required":["IpamId"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Cascade":{"type":"boolean"}}},"output":{"type":"structure","members":{"Ipam":{"shape":"Sfr","locationName":"ipam"}}}},"DeleteIpamPool":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cascade":{"type":"boolean"}}},"output":{"type":"structure","members":{"IpamPool":{"shape":"Sg6","locationName":"ipamPool"}}}},"DeleteIpamResourceDiscovery":{"input":{"type":"structure","required":["IpamResourceDiscoveryId"],"members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryId":{}}},"output":{"type":"structure","members":{"IpamResourceDiscovery":{"shape":"Sge","locationName":"ipamResourceDiscovery"}}}},"DeleteIpamScope":{"input":{"type":"structure","required":["IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"IpamScopeId":{}}},"output":{"type":"structure","members":{"IpamScope":{"shape":"Sgi","locationName":"ipamScope"}}}},"DeleteKeyPair":{"input":{"type":"structure","members":{"KeyName":{},"KeyPairId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"KeyPairId":{"locationName":"keyPairId"}}}},"DeleteLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sic","locationName":"launchTemplate"}}}},"DeleteLaunchTemplateVersions":{"input":{"type":"structure","required":["Versions"],"members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sw1","locationName":"LaunchTemplateVersion"}}},"output":{"type":"structure","members":{"SuccessfullyDeletedLaunchTemplateVersions":{"locationName":"successfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"}}}},"UnsuccessfullyDeletedLaunchTemplateVersions":{"locationName":"unsuccessfullyDeletedLaunchTemplateVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"ResponseError":{"locationName":"responseError","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"DeleteLocalGatewayRoute":{"input":{"type":"structure","required":["LocalGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"LocalGatewayRouteTableId":{},"DryRun":{"type":"boolean"},"DestinationPrefixListId":{}}},"output":{"type":"structure","members":{"Route":{"shape":"Sjo","locationName":"route"}}}},"DeleteLocalGatewayRouteTable":{"input":{"type":"structure","required":["LocalGatewayRouteTableId"],"members":{"LocalGatewayRouteTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTable":{"shape":"Sjv","locationName":"localGatewayRouteTable"}}}},"DeleteLocalGatewayRouteTableVirtualInterfaceGroupAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableVirtualInterfaceGroupAssociationId"],"members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociation":{"shape":"Sjz","locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociation"}}}},"DeleteLocalGatewayRouteTableVpcAssociation":{"input":{"type":"structure","required":["LocalGatewayRouteTableVpcAssociationId"],"members":{"LocalGatewayRouteTableVpcAssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociation":{"shape":"Sk3","locationName":"localGatewayRouteTableVpcAssociation"}}}},"DeleteManagedPrefixList":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sk9","locationName":"prefixList"}}}},"DeleteNatGateway":{"input":{"type":"structure","required":["NatGatewayId"],"members":{"DryRun":{"type":"boolean"},"NatGatewayId":{}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"}}}},"DeleteNetworkAcl":{"input":{"type":"structure","required":["NetworkAclId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}}},"DeleteNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","RuleNumber"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"DeleteNetworkInsightsAccessScope":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeId"],"members":{"DryRun":{"type":"boolean"},"NetworkInsightsAccessScopeId":{}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"}}}},"DeleteNetworkInsightsAccessScopeAnalysis":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeAnalysisId"],"members":{"NetworkInsightsAccessScopeAnalysisId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"}}}},"DeleteNetworkInsightsAnalysis":{"input":{"type":"structure","required":["NetworkInsightsAnalysisId"],"members":{"DryRun":{"type":"boolean"},"NetworkInsightsAnalysisId":{}}},"output":{"type":"structure","members":{"NetworkInsightsAnalysisId":{"locationName":"networkInsightsAnalysisId"}}}},"DeleteNetworkInsightsPath":{"input":{"type":"structure","required":["NetworkInsightsPathId"],"members":{"DryRun":{"type":"boolean"},"NetworkInsightsPathId":{}}},"output":{"type":"structure","members":{"NetworkInsightsPathId":{"locationName":"networkInsightsPathId"}}}},"DeleteNetworkInterface":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}}},"DeleteNetworkInterfacePermission":{"input":{"type":"structure","required":["NetworkInterfacePermissionId"],"members":{"NetworkInterfacePermissionId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeletePlacementGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupName":{"locationName":"groupName"}}}},"DeletePublicIpv4Pool":{"input":{"type":"structure","required":["PoolId"],"members":{"DryRun":{"type":"boolean"},"PoolId":{}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"returnValue","type":"boolean"}}}},"DeleteQueuedReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstancesIds":{"locationName":"ReservedInstancesId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SuccessfulQueuedPurchaseDeletions":{"locationName":"successfulQueuedPurchaseDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"FailedQueuedPurchaseDeletions":{"locationName":"failedQueuedPurchaseDeletionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}}}}},"DeleteRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteRouteTable":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}}},"DeleteSecurityGroup":{"input":{"type":"structure","members":{"GroupId":{},"GroupName":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnet":{"input":{"type":"structure","required":["SubnetId"],"members":{"SubnetId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteSubnetCidrReservation":{"input":{"type":"structure","required":["SubnetCidrReservationId"],"members":{"SubnetCidrReservationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeletedSubnetCidrReservation":{"shape":"So6","locationName":"deletedSubnetCidrReservation"}}}},"DeleteTags":{"input":{"type":"structure","required":["Resources"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Resources":{"shape":"So9","locationName":"resourceId"},"Tags":{"shape":"S6","locationName":"tag"}}}},"DeleteTrafficMirrorFilter":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"}}}},"DeleteTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"}}}},"DeleteTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"}}}},"DeleteTrafficMirrorTarget":{"input":{"type":"structure","required":["TrafficMirrorTargetId"],"members":{"TrafficMirrorTargetId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"}}}},"DeleteTransitGateway":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Sp6","locationName":"transitGateway"}}}},"DeleteTransitGatewayConnect":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnect":{"shape":"Spd","locationName":"transitGatewayConnect"}}}},"DeleteTransitGatewayConnectPeer":{"input":{"type":"structure","required":["TransitGatewayConnectPeerId"],"members":{"TransitGatewayConnectPeerId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeer":{"shape":"Spj","locationName":"transitGatewayConnectPeer"}}}},"DeleteTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId"],"members":{"TransitGatewayMulticastDomainId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomain":{"shape":"Spw","locationName":"transitGatewayMulticastDomain"}}}},"DeleteTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sx","locationName":"transitGatewayPeeringAttachment"}}}},"DeleteTransitGatewayPolicyTable":{"input":{"type":"structure","required":["TransitGatewayPolicyTableId"],"members":{"TransitGatewayPolicyTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPolicyTable":{"shape":"Sq5","locationName":"transitGatewayPolicyTable"}}}},"DeleteTransitGatewayPrefixListReference":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","PrefixListId"],"members":{"TransitGatewayRouteTableId":{},"PrefixListId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReference":{"shape":"Sq9","locationName":"transitGatewayPrefixListReference"}}}},"DeleteTransitGatewayRoute":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","DestinationCidrBlock"],"members":{"TransitGatewayRouteTableId":{},"DestinationCidrBlock":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sqe","locationName":"route"}}}},"DeleteTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTable":{"shape":"Sqm","locationName":"transitGatewayRouteTable"}}}},"DeleteTransitGatewayRouteTableAnnouncement":{"input":{"type":"structure","required":["TransitGatewayRouteTableAnnouncementId"],"members":{"TransitGatewayRouteTableAnnouncementId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTableAnnouncement":{"shape":"Sqq","locationName":"transitGatewayRouteTableAnnouncement"}}}},"DeleteTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"S16","locationName":"transitGatewayVpcAttachment"}}}},"DeleteVerifiedAccessEndpoint":{"input":{"type":"structure","required":["VerifiedAccessEndpointId"],"members":{"VerifiedAccessEndpointId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessEndpoint":{"shape":"Sra","locationName":"verifiedAccessEndpoint"}}}},"DeleteVerifiedAccessGroup":{"input":{"type":"structure","required":["VerifiedAccessGroupId"],"members":{"VerifiedAccessGroupId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessGroup":{"shape":"Sri","locationName":"verifiedAccessGroup"}}}},"DeleteVerifiedAccessInstance":{"input":{"type":"structure","required":["VerifiedAccessInstanceId"],"members":{"VerifiedAccessInstanceId":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"VerifiedAccessInstance":{"shape":"S6g","locationName":"verifiedAccessInstance"}}}},"DeleteVerifiedAccessTrustProvider":{"input":{"type":"structure","required":["VerifiedAccessTrustProviderId"],"members":{"VerifiedAccessTrustProviderId":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"VerifiedAccessTrustProvider":{"shape":"S67","locationName":"verifiedAccessTrustProvider"}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpc":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpcEndpointConnectionNotifications":{"input":{"type":"structure","required":["ConnectionNotificationIds"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationIds":{"locationName":"ConnectionNotificationId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S1h","locationName":"unsuccessful"}}}},"DeleteVpcEndpointServiceConfigurations":{"input":{"type":"structure","required":["ServiceIds"],"members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Syy","locationName":"ServiceId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S1h","locationName":"unsuccessful"}}}},"DeleteVpcEndpoints":{"input":{"type":"structure","required":["VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"S1e","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S1h","locationName":"unsuccessful"}}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DeleteVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeleteVpnConnectionRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","VpnConnectionId"],"members":{"DestinationCidrBlock":{},"VpnConnectionId":{}}}},"DeleteVpnGateway":{"input":{"type":"structure","required":["VpnGatewayId"],"members":{"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeprovisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1y","locationName":"byoipCidr"}}}},"DeprovisionIpamByoasn":{"input":{"type":"structure","required":["IpamId","Asn"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Asn":{}}},"output":{"type":"structure","members":{"Byoasn":{"shape":"Szb","locationName":"byoasn"}}}},"DeprovisionIpamPoolCidr":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{}}},"output":{"type":"structure","members":{"IpamPoolCidr":{"shape":"Szf","locationName":"ipamPoolCidr"}}}},"DeprovisionPublicIpv4PoolCidr":{"input":{"type":"structure","required":["PoolId","Cidr"],"members":{"DryRun":{"type":"boolean"},"PoolId":{},"Cidr":{}}},"output":{"type":"structure","members":{"PoolId":{"locationName":"poolId"},"DeprovisionedAddresses":{"locationName":"deprovisionedAddressSet","type":"list","member":{"locationName":"item"}}}}},"DeregisterImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DeregisterInstanceEventNotificationAttributes":{"input":{"type":"structure","required":["InstanceTagAttribute"],"members":{"DryRun":{"type":"boolean"},"InstanceTagAttribute":{"type":"structure","members":{"IncludeAllTagsOfInstance":{"type":"boolean"},"InstanceTagKeys":{"shape":"Szq","locationName":"InstanceTagKey"}}}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Szs","locationName":"instanceTagAttribute"}}}},"DeregisterTransitGatewayMulticastGroupMembers":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Szu"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeregisteredMulticastGroupMembers":{"locationName":"deregisteredMulticastGroupMembers","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"DeregisteredNetworkInterfaceIds":{"shape":"So","locationName":"deregisteredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"DeregisterTransitGatewayMulticastGroupSources":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Szu"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DeregisteredMulticastGroupSources":{"locationName":"deregisteredMulticastGroupSources","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"DeregisteredNetworkInterfaceIds":{"shape":"So","locationName":"deregisteredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"locationName":"attributeName","type":"list","member":{"locationName":"attributeName"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AccountAttributes":{"locationName":"accountAttributeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeName":{"locationName":"attributeName"},"AttributeValues":{"locationName":"attributeValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AttributeValue":{"locationName":"attributeValue"}}}}}}}}}},"DescribeAddressTransfers":{"input":{"type":"structure","members":{"AllocationIds":{"shape":"S4r","locationName":"AllocationId"},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AddressTransfers":{"locationName":"addressTransferSet","type":"list","member":{"shape":"Sa","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"PublicIps":{"locationName":"PublicIp","type":"list","member":{"locationName":"PublicIp"}},"AllocationIds":{"shape":"S4r","locationName":"AllocationId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"Domain":{"locationName":"domain"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkInterfaceOwnerId":{"locationName":"networkInterfaceOwnerId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"Tags":{"shape":"S6","locationName":"tagSet"},"PublicIpv4Pool":{"locationName":"publicIpv4Pool"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"},"CarrierIp":{"locationName":"carrierIp"}}}}}}},"DescribeAddressesAttribute":{"input":{"type":"structure","members":{"AllocationIds":{"locationName":"AllocationId","type":"list","member":{"locationName":"item"}},"Attribute":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Addresses":{"locationName":"addressSet","type":"list","member":{"shape":"S10q","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeAggregateIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"UseLongIdsAggregated":{"locationName":"useLongIdsAggregated","type":"boolean"},"Statuses":{"shape":"S10u","locationName":"statusSet"}}}},"DescribeAvailabilityZones":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"ZoneNames":{"locationName":"ZoneName","type":"list","member":{"locationName":"ZoneName"}},"ZoneIds":{"locationName":"ZoneId","type":"list","member":{"locationName":"ZoneId"}},"AllAvailabilityZones":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AvailabilityZones":{"locationName":"availabilityZoneInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"zoneState"},"OptInStatus":{"locationName":"optInStatus"},"Messages":{"locationName":"messageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Message":{"locationName":"message"}}}},"RegionName":{"locationName":"regionName"},"ZoneName":{"locationName":"zoneName"},"ZoneId":{"locationName":"zoneId"},"GroupName":{"locationName":"groupName"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"ZoneType":{"locationName":"zoneType"},"ParentZoneName":{"locationName":"parentZoneName"},"ParentZoneId":{"locationName":"parentZoneId"}}}}}}},"DescribeAwsNetworkPerformanceMetricSubscriptions":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Subscriptions":{"locationName":"subscriptionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Source":{"locationName":"source"},"Destination":{"locationName":"destination"},"Metric":{"locationName":"metric"},"Statistic":{"locationName":"statistic"},"Period":{"locationName":"period"}}}}}}},"DescribeBundleTasks":{"input":{"type":"structure","members":{"BundleIds":{"locationName":"BundleId","type":"list","member":{"locationName":"BundleId"}},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BundleTasks":{"locationName":"bundleInstanceTasksSet","type":"list","member":{"shape":"S7m","locationName":"item"}}}}},"DescribeByoipCidrs":{"input":{"type":"structure","required":["MaxResults"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ByoipCidrs":{"locationName":"byoipCidrSet","type":"list","member":{"shape":"S1y","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCapacityBlockOfferings":{"input":{"type":"structure","required":["InstanceType","InstanceCount","CapacityDurationHours"],"members":{"DryRun":{"type":"boolean"},"InstanceType":{},"InstanceCount":{"type":"integer"},"StartDateRange":{"type":"timestamp"},"EndDateRange":{"type":"timestamp"},"CapacityDurationHours":{"type":"integer"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CapacityBlockOfferings":{"locationName":"capacityBlockOfferingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CapacityBlockOfferingId":{"locationName":"capacityBlockOfferingId"},"InstanceType":{"locationName":"instanceType"},"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"StartDate":{"locationName":"startDate","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"CapacityBlockDurationHours":{"locationName":"capacityBlockDurationHours","type":"integer"},"UpfrontFee":{"locationName":"upfrontFee"},"CurrencyCode":{"locationName":"currencyCode"},"Tenancy":{"locationName":"tenancy"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCapacityReservationFleets":{"input":{"type":"structure","members":{"CapacityReservationFleetIds":{"shape":"S7w","locationName":"CapacityReservationFleetId"},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CapacityReservationFleets":{"locationName":"capacityReservationFleetSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"CapacityReservationFleetArn":{"locationName":"capacityReservationFleetArn"},"State":{"locationName":"state"},"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"TotalFulfilledCapacity":{"locationName":"totalFulfilledCapacity","type":"double"},"Tenancy":{"locationName":"tenancy"},"EndDate":{"locationName":"endDate","type":"timestamp"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"AllocationStrategy":{"locationName":"allocationStrategy"},"InstanceTypeSpecifications":{"shape":"Sac","locationName":"instanceTypeSpecificationSet"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCapacityReservations":{"input":{"type":"structure","members":{"CapacityReservationIds":{"locationName":"CapacityReservationId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservations":{"locationName":"capacityReservationSet","type":"list","member":{"shape":"S9x","locationName":"item"}}}}},"DescribeCarrierGateways":{"input":{"type":"structure","members":{"CarrierGatewayIds":{"locationName":"CarrierGatewayId","type":"list","member":{}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CarrierGateways":{"locationName":"carrierGatewaySet","type":"list","member":{"shape":"Sag","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClassicLinkInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Groups":{"shape":"Sly","locationName":"groupSet"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"S6","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnAuthorizationRules":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AuthorizationRules":{"locationName":"authorizationRule","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"AccessAll":{"locationName":"accessAll","type":"boolean"},"DestinationCidr":{"locationName":"destinationCidr"},"Status":{"shape":"S6u","locationName":"status"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Connections":{"locationName":"connections","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Timestamp":{"locationName":"timestamp"},"ConnectionId":{"locationName":"connectionId"},"Username":{"locationName":"username"},"ConnectionEstablishedTime":{"locationName":"connectionEstablishedTime"},"IngressBytes":{"locationName":"ingressBytes"},"EgressBytes":{"locationName":"egressBytes"},"IngressPackets":{"locationName":"ingressPackets"},"EgressPackets":{"locationName":"egressPackets"},"ClientIp":{"locationName":"clientIp"},"CommonName":{"locationName":"commonName"},"Status":{"shape":"S12n","locationName":"status"},"ConnectionEndTime":{"locationName":"connectionEndTime"},"PostureComplianceStatuses":{"shape":"So","locationName":"postureComplianceStatusSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnEndpoints":{"input":{"type":"structure","members":{"ClientVpnEndpointIds":{"locationName":"ClientVpnEndpointId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpoints":{"locationName":"clientVpnEndpoint","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Description":{"locationName":"description"},"Status":{"shape":"Saw","locationName":"status"},"CreationTime":{"locationName":"creationTime"},"DeletionTime":{"locationName":"deletionTime"},"DnsName":{"locationName":"dnsName"},"ClientCidrBlock":{"locationName":"clientCidrBlock"},"DnsServers":{"shape":"So","locationName":"dnsServer"},"SplitTunnel":{"locationName":"splitTunnel","type":"boolean"},"VpnProtocol":{"locationName":"vpnProtocol"},"TransportProtocol":{"locationName":"transportProtocol"},"VpnPort":{"locationName":"vpnPort","type":"integer"},"AssociatedTargetNetworks":{"deprecated":true,"deprecatedMessage":"This property is deprecated. To view the target networks associated with a Client VPN endpoint, call DescribeClientVpnTargetNetworks and inspect the clientVpnTargetNetworks response element.","locationName":"associatedTargetNetwork","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkId":{"locationName":"networkId"},"NetworkType":{"locationName":"networkType"}}}},"ServerCertificateArn":{"locationName":"serverCertificateArn"},"AuthenticationOptions":{"locationName":"authenticationOptions","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"},"ActiveDirectory":{"locationName":"activeDirectory","type":"structure","members":{"DirectoryId":{"locationName":"directoryId"}}},"MutualAuthentication":{"locationName":"mutualAuthentication","type":"structure","members":{"ClientRootCertificateChain":{"locationName":"clientRootCertificateChain"}}},"FederatedAuthentication":{"locationName":"federatedAuthentication","type":"structure","members":{"SamlProviderArn":{"locationName":"samlProviderArn"},"SelfServiceSamlProviderArn":{"locationName":"selfServiceSamlProviderArn"}}}}}},"ConnectionLogOptions":{"locationName":"connectionLogOptions","type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"Tags":{"shape":"S6","locationName":"tagSet"},"SecurityGroupIds":{"shape":"S2r","locationName":"securityGroupIdSet"},"VpcId":{"locationName":"vpcId"},"SelfServicePortalUrl":{"locationName":"selfServicePortalUrl"},"ClientConnectOptions":{"locationName":"clientConnectOptions","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"LambdaFunctionArn":{"locationName":"lambdaFunctionArn"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}},"SessionTimeoutHours":{"locationName":"sessionTimeoutHours","type":"integer"},"ClientLoginBannerOptions":{"locationName":"clientLoginBannerOptions","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"BannerText":{"locationName":"bannerText"}}}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnRoutes":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"DestinationCidr":{"locationName":"destinationCidr"},"TargetSubnet":{"locationName":"targetSubnet"},"Type":{"locationName":"type"},"Origin":{"locationName":"origin"},"Status":{"shape":"Sb0","locationName":"status"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeClientVpnTargetNetworks":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"AssociationIds":{"shape":"So"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnTargetNetworks":{"locationName":"clientVpnTargetNetworks","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociationId":{"locationName":"associationId"},"VpcId":{"locationName":"vpcId"},"TargetNetworkId":{"locationName":"targetNetworkId"},"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Status":{"shape":"S3m","locationName":"status"},"SecurityGroups":{"shape":"So","locationName":"securityGroups"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeCoipPools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPools":{"locationName":"coipPoolSet","type":"list","member":{"shape":"Sb9","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeConversionTasks":{"input":{"type":"structure","members":{"ConversionTaskIds":{"locationName":"conversionTaskId","type":"list","member":{"locationName":"item"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"ConversionTasks":{"locationName":"conversionTasks","type":"list","member":{"shape":"S13s","locationName":"item"}}}}},"DescribeCustomerGateways":{"input":{"type":"structure","members":{"CustomerGatewayIds":{"locationName":"CustomerGatewayId","type":"list","member":{"locationName":"CustomerGatewayId"}},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CustomerGateways":{"locationName":"customerGatewaySet","type":"list","member":{"shape":"Sbd","locationName":"item"}}}}},"DescribeDhcpOptions":{"input":{"type":"structure","members":{"DhcpOptionsIds":{"locationName":"DhcpOptionsId","type":"list","member":{"locationName":"DhcpOptionsId"}},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DhcpOptions":{"locationName":"dhcpOptionsSet","type":"list","member":{"shape":"Sbx","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeEgressOnlyInternetGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"EgressOnlyInternetGatewayIds":{"locationName":"EgressOnlyInternetGatewayId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"EgressOnlyInternetGateways":{"locationName":"egressOnlyInternetGatewaySet","type":"list","member":{"shape":"Sc4","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeElasticGpus":{"input":{"type":"structure","members":{"ElasticGpuIds":{"locationName":"ElasticGpuId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ElasticGpuSet":{"locationName":"elasticGpuSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"AvailabilityZone":{"locationName":"availabilityZone"},"ElasticGpuType":{"locationName":"elasticGpuType"},"ElasticGpuHealth":{"locationName":"elasticGpuHealth","type":"structure","members":{"Status":{"locationName":"status"}}},"ElasticGpuState":{"locationName":"elasticGpuState"},"InstanceId":{"locationName":"instanceId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"ExportImageTaskIds":{"locationName":"ExportImageTaskId","type":"list","member":{"locationName":"ExportImageTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ExportImageTasks":{"locationName":"exportImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"S14w","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIds":{"locationName":"exportTaskId","type":"list","member":{"locationName":"ExportTaskId"}},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"ExportTasks":{"locationName":"exportTaskSet","type":"list","member":{"shape":"Sff","locationName":"item"}}}}},"DescribeFastLaunchImages":{"input":{"type":"structure","members":{"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"ImageId"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"FastLaunchImages":{"locationName":"fastLaunchImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ImageId":{"locationName":"imageId"},"ResourceType":{"locationName":"resourceType"},"SnapshotConfiguration":{"shape":"S159","locationName":"snapshotConfiguration"},"LaunchTemplate":{"shape":"S15a","locationName":"launchTemplate"},"MaxParallelLaunches":{"locationName":"maxParallelLaunches","type":"integer"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"StateTransitionTime":{"locationName":"stateTransitionTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFastSnapshotRestores":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"FastSnapshotRestores":{"locationName":"fastSnapshotRestoreSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFleetHistory":{"input":{"type":"structure","required":["FleetId","StartTime"],"members":{"DryRun":{"type":"boolean"},"EventType":{},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"StartTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"S15n","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeFleetInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetId":{},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"S15q","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"FleetId":{"locationName":"fleetId"}}}},"DescribeFleets":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"FleetIds":{"shape":"Sv1","locationName":"FleetId"},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Fleets":{"locationName":"fleetSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"FleetId":{"locationName":"fleetId"},"FleetState":{"locationName":"fleetState"},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"FulfilledOnDemandCapacity":{"locationName":"fulfilledOnDemandCapacity","type":"double"},"LaunchTemplateConfigs":{"locationName":"launchTemplateConfigs","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"Sdw","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"shape":"Sdx","locationName":"item"}}}}},"TargetCapacitySpecification":{"locationName":"targetCapacitySpecification","type":"structure","members":{"TotalTargetCapacity":{"locationName":"totalTargetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"SpotTargetCapacity":{"locationName":"spotTargetCapacity","type":"integer"},"DefaultTargetCapacityType":{"locationName":"defaultTargetCapacityType"},"TargetCapacityUnitType":{"locationName":"targetCapacityUnitType"}}},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"MaintenanceStrategies":{"locationName":"maintenanceStrategies","type":"structure","members":{"CapacityRebalance":{"locationName":"capacityRebalance","type":"structure","members":{"ReplacementStrategy":{"locationName":"replacementStrategy"},"TerminationDelay":{"locationName":"terminationDelay","type":"integer"}}}}},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"OnDemandOptions":{"locationName":"onDemandOptions","type":"structure","members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"CapacityReservationOptions":{"locationName":"capacityReservationOptions","type":"structure","members":{"UsageStrategy":{"locationName":"usageStrategy"}}},"SingleInstanceType":{"locationName":"singleInstanceType","type":"boolean"},"SingleAvailabilityZone":{"locationName":"singleAvailabilityZone","type":"boolean"},"MinTargetCapacity":{"locationName":"minTargetCapacity","type":"integer"},"MaxTotalPrice":{"locationName":"maxTotalPrice"}}},"Tags":{"shape":"S6","locationName":"tagSet"},"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sdv","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"ErrorCode":{"locationName":"errorCode"},"ErrorMessage":{"locationName":"errorMessage"}}}},"Instances":{"locationName":"fleetInstanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateAndOverrides":{"shape":"Sdv","locationName":"launchTemplateAndOverrides"},"Lifecycle":{"locationName":"lifecycle"},"InstanceIds":{"shape":"Sec","locationName":"instanceIds"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"}}}},"Context":{"locationName":"context"}}}}}}},"DescribeFlowLogs":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filter":{"shape":"S10d"},"FlowLogIds":{"shape":"Svb","locationName":"FlowLogId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FlowLogs":{"locationName":"flowLogSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CreationTime":{"locationName":"creationTime","type":"timestamp"},"DeliverLogsErrorMessage":{"locationName":"deliverLogsErrorMessage"},"DeliverLogsPermissionArn":{"locationName":"deliverLogsPermissionArn"},"DeliverCrossAccountRole":{"locationName":"deliverCrossAccountRole"},"DeliverLogsStatus":{"locationName":"deliverLogsStatus"},"FlowLogId":{"locationName":"flowLogId"},"FlowLogStatus":{"locationName":"flowLogStatus"},"LogGroupName":{"locationName":"logGroupName"},"ResourceId":{"locationName":"resourceId"},"TrafficType":{"locationName":"trafficType"},"LogDestinationType":{"locationName":"logDestinationType"},"LogDestination":{"locationName":"logDestination"},"LogFormat":{"locationName":"logFormat"},"Tags":{"shape":"S6","locationName":"tagSet"},"MaxAggregationInterval":{"locationName":"maxAggregationInterval","type":"integer"},"DestinationOptions":{"locationName":"destinationOptions","type":"structure","members":{"FileFormat":{"locationName":"fileFormat"},"HiveCompatiblePartitions":{"locationName":"hiveCompatiblePartitions","type":"boolean"},"PerHourPartition":{"locationName":"perHourPartition","type":"boolean"}}}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId","Attribute"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"S16j","locationName":"fpgaImageAttribute"}}}},"DescribeFpgaImages":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"FpgaImageIds":{"locationName":"FpgaImageId","type":"list","member":{"locationName":"item"}},"Owners":{"shape":"S16s","locationName":"Owner"},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FpgaImages":{"locationName":"fpgaImageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"FpgaImageGlobalId":{"locationName":"fpgaImageGlobalId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"ShellVersion":{"locationName":"shellVersion"},"PciId":{"locationName":"pciId","type":"structure","members":{"DeviceId":{},"VendorId":{},"SubsystemId":{},"SubsystemVendorId":{}}},"State":{"locationName":"state","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"CreateTime":{"locationName":"createTime","type":"timestamp"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"ProductCodes":{"shape":"S16n","locationName":"productCodes"},"Tags":{"shape":"S6","locationName":"tags"},"Public":{"locationName":"public","type":"boolean"},"DataRetentionSupport":{"locationName":"dataRetentionSupport","type":"boolean"},"InstanceTypes":{"locationName":"instanceTypes","type":"list","member":{"locationName":"item"}}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHostReservationOfferings":{"input":{"type":"structure","members":{"Filter":{"shape":"S10d"},"MaxDuration":{"type":"integer"},"MaxResults":{"type":"integer"},"MinDuration":{"type":"integer"},"NextToken":{},"OfferingId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"OfferingSet":{"locationName":"offeringSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}}}}},"DescribeHostReservations":{"input":{"type":"structure","members":{"Filter":{"shape":"S10d"},"HostReservationIdSet":{"type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HostReservationSet":{"locationName":"hostReservationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"End":{"locationName":"end","type":"timestamp"},"HostIdSet":{"shape":"S17d","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"OfferingId":{"locationName":"offeringId"},"PaymentOption":{"locationName":"paymentOption"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UpfrontPrice":{"locationName":"upfrontPrice"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeHosts":{"input":{"type":"structure","members":{"Filter":{"shape":"S10d","locationName":"filter"},"HostIds":{"shape":"S17g","locationName":"hostId"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Hosts":{"locationName":"hostSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AutoPlacement":{"locationName":"autoPlacement"},"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableCapacity":{"locationName":"availableCapacity","type":"structure","members":{"AvailableInstanceCapacity":{"locationName":"availableInstanceCapacity","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailableCapacity":{"locationName":"availableCapacity","type":"integer"},"InstanceType":{"locationName":"instanceType"},"TotalCapacity":{"locationName":"totalCapacity","type":"integer"}}}},"AvailableVCpus":{"locationName":"availableVCpus","type":"integer"}}},"ClientToken":{"locationName":"clientToken"},"HostId":{"locationName":"hostId"},"HostProperties":{"locationName":"hostProperties","type":"structure","members":{"Cores":{"locationName":"cores","type":"integer"},"InstanceType":{"locationName":"instanceType"},"InstanceFamily":{"locationName":"instanceFamily"},"Sockets":{"locationName":"sockets","type":"integer"},"TotalVCpus":{"locationName":"totalVCpus","type":"integer"}}},"HostReservationId":{"locationName":"hostReservationId"},"Instances":{"locationName":"instances","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"OwnerId":{"locationName":"ownerId"}}}},"State":{"locationName":"state"},"AllocationTime":{"locationName":"allocationTime","type":"timestamp"},"ReleaseTime":{"locationName":"releaseTime","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"},"HostRecovery":{"locationName":"hostRecovery"},"AllowsMultipleInstanceTypes":{"locationName":"allowsMultipleInstanceTypes"},"OwnerId":{"locationName":"ownerId"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"MemberOfServiceLinkedResourceGroup":{"locationName":"memberOfServiceLinkedResourceGroup","type":"boolean"},"OutpostArn":{"locationName":"outpostArn"},"HostMaintenance":{"locationName":"hostMaintenance"},"AssetId":{"locationName":"assetId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIamInstanceProfileAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"AssociationId"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociations":{"locationName":"iamInstanceProfileAssociationSet","type":"list","member":{"shape":"S3x","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIdFormat":{"input":{"type":"structure","members":{"Resource":{}}},"output":{"type":"structure","members":{"Statuses":{"shape":"S10u","locationName":"statusSet"}}}},"DescribeIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"}}},"output":{"type":"structure","members":{"Statuses":{"shape":"S10u","locationName":"statusSet"}}}},"DescribeImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"BlockDeviceMappings":{"shape":"S185","locationName":"blockDeviceMapping"},"ImageId":{"locationName":"imageId"},"LaunchPermissions":{"shape":"S186","locationName":"launchPermission"},"ProductCodes":{"shape":"S16n","locationName":"productCodes"},"Description":{"shape":"Sc1","locationName":"description"},"KernelId":{"shape":"Sc1","locationName":"kernel"},"RamdiskId":{"shape":"Sc1","locationName":"ramdisk"},"SriovNetSupport":{"shape":"Sc1","locationName":"sriovNetSupport"},"BootMode":{"shape":"Sc1","locationName":"bootMode"},"TpmSupport":{"shape":"Sc1","locationName":"tpmSupport"},"UefiData":{"shape":"Sc1","locationName":"uefiData"},"LastLaunchedTime":{"shape":"Sc1","locationName":"lastLaunchedTime"},"ImdsSupport":{"shape":"Sc1","locationName":"imdsSupport"},"DeregistrationProtection":{"shape":"Sc1","locationName":"deregistrationProtection"}}}},"DescribeImages":{"input":{"type":"structure","members":{"ExecutableUsers":{"locationName":"ExecutableBy","type":"list","member":{"locationName":"ExecutableBy"}},"Filters":{"shape":"S10d","locationName":"Filter"},"ImageIds":{"shape":"S18a","locationName":"ImageId"},"Owners":{"shape":"S16s","locationName":"Owner"},"IncludeDeprecated":{"type":"boolean"},"IncludeDisabled":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Images":{"locationName":"imagesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"CreationDate":{"locationName":"creationDate"},"ImageId":{"locationName":"imageId"},"ImageLocation":{"locationName":"imageLocation"},"ImageType":{"locationName":"imageType"},"Public":{"locationName":"isPublic","type":"boolean"},"KernelId":{"locationName":"kernelId"},"OwnerId":{"locationName":"imageOwnerId"},"Platform":{"locationName":"platform"},"PlatformDetails":{"locationName":"platformDetails"},"UsageOperation":{"locationName":"usageOperation"},"ProductCodes":{"shape":"S16n","locationName":"productCodes"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"locationName":"imageState"},"BlockDeviceMappings":{"shape":"S185","locationName":"blockDeviceMapping"},"Description":{"locationName":"description"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageOwnerAlias":{"locationName":"imageOwnerAlias"},"Name":{"locationName":"name"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Sjw","locationName":"stateReason"},"Tags":{"shape":"S6","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"},"BootMode":{"locationName":"bootMode"},"TpmSupport":{"locationName":"tpmSupport"},"DeprecationTime":{"locationName":"deprecationTime"},"ImdsSupport":{"locationName":"imdsSupport"},"SourceInstanceId":{"locationName":"sourceInstanceId"},"DeregistrationProtection":{"locationName":"deregistrationProtection"},"LastLaunchedTime":{"locationName":"lastLaunchedTime"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeImportImageTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d"},"ImportTaskIds":{"locationName":"ImportTaskId","type":"list","member":{"locationName":"ImportTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportImageTasks":{"locationName":"importImageTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"S18t","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"S6","locationName":"tagSet"},"LicenseSpecifications":{"shape":"S18x","locationName":"licenseSpecifications"},"UsageOperation":{"locationName":"usageOperation"},"BootMode":{"locationName":"bootMode"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeImportSnapshotTasks":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d"},"ImportTaskIds":{"locationName":"ImportTaskId","type":"list","member":{"locationName":"ImportTaskId"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ImportSnapshotTasks":{"locationName":"importSnapshotTaskSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"S195","locationName":"snapshotTaskDetail"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}},"output":{"type":"structure","members":{"Groups":{"shape":"Sly","locationName":"groupSet"},"BlockDeviceMappings":{"shape":"S199","locationName":"blockDeviceMapping"},"DisableApiTermination":{"shape":"S19c","locationName":"disableApiTermination"},"EnaSupport":{"shape":"S19c","locationName":"enaSupport"},"EnclaveOptions":{"shape":"S19d","locationName":"enclaveOptions"},"EbsOptimized":{"shape":"S19c","locationName":"ebsOptimized"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"Sc1","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"Sc1","locationName":"instanceType"},"KernelId":{"shape":"Sc1","locationName":"kernel"},"ProductCodes":{"shape":"S16n","locationName":"productCodes"},"RamdiskId":{"shape":"Sc1","locationName":"ramdisk"},"RootDeviceName":{"shape":"Sc1","locationName":"rootDeviceName"},"SourceDestCheck":{"shape":"S19c","locationName":"sourceDestCheck"},"SriovNetSupport":{"shape":"Sc1","locationName":"sriovNetSupport"},"UserData":{"shape":"Sc1","locationName":"userData"},"DisableApiStop":{"shape":"S19c","locationName":"disableApiStop"}}}},"DescribeInstanceConnectEndpoints":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"InstanceConnectEndpointIds":{"shape":"So","locationName":"InstanceConnectEndpointId"}}},"output":{"type":"structure","members":{"InstanceConnectEndpoints":{"locationName":"instanceConnectEndpointSet","type":"list","member":{"shape":"Sf0","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceCreditSpecifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceCreditSpecifications":{"locationName":"instanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"CpuCredits":{"locationName":"cpuCredits"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceEventNotificationAttributes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Szs","locationName":"instanceTagAttribute"}}}},"DescribeInstanceEventWindows":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceEventWindowIds":{"locationName":"InstanceEventWindowId","type":"list","member":{"locationName":"InstanceEventWindowId"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceEventWindows":{"locationName":"instanceEventWindowSet","type":"list","member":{"shape":"S47","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludeAllInstances":{"locationName":"includeAllInstances","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceStatuses":{"locationName":"instanceStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"OutpostArn":{"locationName":"outpostArn"},"Events":{"locationName":"eventsSet","type":"list","member":{"shape":"S19z","locationName":"item"}},"InstanceId":{"locationName":"instanceId"},"InstanceState":{"shape":"S1a2","locationName":"instanceState"},"InstanceStatus":{"shape":"S1a4","locationName":"instanceStatus"},"SystemStatus":{"shape":"S1a4","locationName":"systemStatus"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceTopology":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"},"InstanceIds":{"locationName":"InstanceId","type":"list","member":{}},"GroupNames":{"locationName":"GroupName","type":"list","member":{}},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"Instances":{"locationName":"instanceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"GroupName":{"locationName":"groupName"},"NetworkNodes":{"locationName":"networkNodeSet","type":"list","member":{"locationName":"item"}},"AvailabilityZone":{"locationName":"availabilityZone"},"ZoneId":{"locationName":"zoneId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceTypeOfferings":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LocationType":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypeOfferings":{"locationName":"instanceTypeOfferingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"LocationType":{"locationName":"locationType"},"Location":{"locationName":"location"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstanceTypes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypes":{"locationName":"instanceTypeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"CurrentGeneration":{"locationName":"currentGeneration","type":"boolean"},"FreeTierEligible":{"locationName":"freeTierEligible","type":"boolean"},"SupportedUsageClasses":{"locationName":"supportedUsageClasses","type":"list","member":{"locationName":"item"}},"SupportedRootDeviceTypes":{"locationName":"supportedRootDeviceTypes","type":"list","member":{"locationName":"item"}},"SupportedVirtualizationTypes":{"locationName":"supportedVirtualizationTypes","type":"list","member":{"locationName":"item"}},"BareMetal":{"locationName":"bareMetal","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ProcessorInfo":{"locationName":"processorInfo","type":"structure","members":{"SupportedArchitectures":{"locationName":"supportedArchitectures","type":"list","member":{"locationName":"item"}},"SustainedClockSpeedInGhz":{"locationName":"sustainedClockSpeedInGhz","type":"double"},"SupportedFeatures":{"locationName":"supportedFeatures","type":"list","member":{"locationName":"item"}},"Manufacturer":{"locationName":"manufacturer"}}},"VCpuInfo":{"locationName":"vCpuInfo","type":"structure","members":{"DefaultVCpus":{"locationName":"defaultVCpus","type":"integer"},"DefaultCores":{"locationName":"defaultCores","type":"integer"},"DefaultThreadsPerCore":{"locationName":"defaultThreadsPerCore","type":"integer"},"ValidCores":{"locationName":"validCores","type":"list","member":{"locationName":"item","type":"integer"}},"ValidThreadsPerCore":{"locationName":"validThreadsPerCore","type":"list","member":{"locationName":"item","type":"integer"}}}},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"long"}}},"InstanceStorageSupported":{"locationName":"instanceStorageSupported","type":"boolean"},"InstanceStorageInfo":{"locationName":"instanceStorageInfo","type":"structure","members":{"TotalSizeInGB":{"locationName":"totalSizeInGB","type":"long"},"Disks":{"locationName":"disks","type":"list","member":{"locationName":"item","type":"structure","members":{"SizeInGB":{"locationName":"sizeInGB","type":"long"},"Count":{"locationName":"count","type":"integer"},"Type":{"locationName":"type"}}}},"NvmeSupport":{"locationName":"nvmeSupport"},"EncryptionSupport":{"locationName":"encryptionSupport"}}},"EbsInfo":{"locationName":"ebsInfo","type":"structure","members":{"EbsOptimizedSupport":{"locationName":"ebsOptimizedSupport"},"EncryptionSupport":{"locationName":"encryptionSupport"},"EbsOptimizedInfo":{"locationName":"ebsOptimizedInfo","type":"structure","members":{"BaselineBandwidthInMbps":{"locationName":"baselineBandwidthInMbps","type":"integer"},"BaselineThroughputInMBps":{"locationName":"baselineThroughputInMBps","type":"double"},"BaselineIops":{"locationName":"baselineIops","type":"integer"},"MaximumBandwidthInMbps":{"locationName":"maximumBandwidthInMbps","type":"integer"},"MaximumThroughputInMBps":{"locationName":"maximumThroughputInMBps","type":"double"},"MaximumIops":{"locationName":"maximumIops","type":"integer"}}},"NvmeSupport":{"locationName":"nvmeSupport"}}},"NetworkInfo":{"locationName":"networkInfo","type":"structure","members":{"NetworkPerformance":{"locationName":"networkPerformance"},"MaximumNetworkInterfaces":{"locationName":"maximumNetworkInterfaces","type":"integer"},"MaximumNetworkCards":{"locationName":"maximumNetworkCards","type":"integer"},"DefaultNetworkCardIndex":{"locationName":"defaultNetworkCardIndex","type":"integer"},"NetworkCards":{"locationName":"networkCards","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"},"NetworkPerformance":{"locationName":"networkPerformance"},"MaximumNetworkInterfaces":{"locationName":"maximumNetworkInterfaces","type":"integer"},"BaselineBandwidthInGbps":{"locationName":"baselineBandwidthInGbps","type":"double"},"PeakBandwidthInGbps":{"locationName":"peakBandwidthInGbps","type":"double"}}}},"Ipv4AddressesPerInterface":{"locationName":"ipv4AddressesPerInterface","type":"integer"},"Ipv6AddressesPerInterface":{"locationName":"ipv6AddressesPerInterface","type":"integer"},"Ipv6Supported":{"locationName":"ipv6Supported","type":"boolean"},"EnaSupport":{"locationName":"enaSupport"},"EfaSupported":{"locationName":"efaSupported","type":"boolean"},"EfaInfo":{"locationName":"efaInfo","type":"structure","members":{"MaximumEfaInterfaces":{"locationName":"maximumEfaInterfaces","type":"integer"}}},"EncryptionInTransitSupported":{"locationName":"encryptionInTransitSupported","type":"boolean"},"EnaSrdSupported":{"locationName":"enaSrdSupported","type":"boolean"}}},"GpuInfo":{"locationName":"gpuInfo","type":"structure","members":{"Gpus":{"locationName":"gpus","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"Count":{"locationName":"count","type":"integer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalGpuMemoryInMiB":{"locationName":"totalGpuMemoryInMiB","type":"integer"}}},"FpgaInfo":{"locationName":"fpgaInfo","type":"structure","members":{"Fpgas":{"locationName":"fpgas","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"Count":{"locationName":"count","type":"integer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalFpgaMemoryInMiB":{"locationName":"totalFpgaMemoryInMiB","type":"integer"}}},"PlacementGroupInfo":{"locationName":"placementGroupInfo","type":"structure","members":{"SupportedStrategies":{"locationName":"supportedStrategies","type":"list","member":{"locationName":"item"}}}},"InferenceAcceleratorInfo":{"locationName":"inferenceAcceleratorInfo","type":"structure","members":{"Accelerators":{"locationName":"item","type":"list","member":{"type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalInferenceMemoryInMiB":{"locationName":"totalInferenceMemoryInMiB","type":"integer"}}},"HibernationSupported":{"locationName":"hibernationSupported","type":"boolean"},"BurstablePerformanceSupported":{"locationName":"burstablePerformanceSupported","type":"boolean"},"DedicatedHostsSupported":{"locationName":"dedicatedHostsSupported","type":"boolean"},"AutoRecoverySupported":{"locationName":"autoRecoverySupported","type":"boolean"},"SupportedBootModes":{"locationName":"supportedBootModes","type":"list","member":{"locationName":"item"}},"NitroEnclavesSupport":{"locationName":"nitroEnclavesSupport"},"NitroTpmSupport":{"locationName":"nitroTpmSupport"},"NitroTpmInfo":{"locationName":"nitroTpmInfo","type":"structure","members":{"SupportedVersions":{"locationName":"supportedVersions","type":"list","member":{"locationName":"item"}}}},"MediaAcceleratorInfo":{"locationName":"mediaAcceleratorInfo","type":"structure","members":{"Accelerators":{"locationName":"accelerators","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Name":{"locationName":"name"},"Manufacturer":{"locationName":"manufacturer"},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalMediaMemoryInMiB":{"locationName":"totalMediaMemoryInMiB","type":"integer"}}},"NeuronInfo":{"locationName":"neuronInfo","type":"structure","members":{"NeuronDevices":{"locationName":"neuronDevices","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Name":{"locationName":"name"},"CoreInfo":{"locationName":"coreInfo","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Version":{"locationName":"version","type":"integer"}}},"MemoryInfo":{"locationName":"memoryInfo","type":"structure","members":{"SizeInMiB":{"locationName":"sizeInMiB","type":"integer"}}}}}},"TotalNeuronDeviceMemoryInMiB":{"locationName":"totalNeuronDeviceMemoryInMiB","type":"integer"}}},"PhcSupport":{"locationName":"phcSupport"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Reservations":{"locationName":"reservationSet","type":"list","member":{"shape":"S1ef","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeInternetGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayIds":{"locationName":"internetGatewayId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InternetGateways":{"locationName":"internetGatewaySet","type":"list","member":{"shape":"Sfl","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIpamByoasn":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Byoasns":{"locationName":"byoasnSet","type":"list","member":{"shape":"Szb","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIpamPools":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamPoolIds":{"shape":"So","locationName":"IpamPoolId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"IpamPools":{"locationName":"ipamPoolSet","type":"list","member":{"shape":"Sg6","locationName":"item"}}}}},"DescribeIpamResourceDiscoveries":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryIds":{"shape":"So","locationName":"IpamResourceDiscoveryId"},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"IpamResourceDiscoveries":{"locationName":"ipamResourceDiscoverySet","type":"list","member":{"shape":"Sge","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIpamResourceDiscoveryAssociations":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryAssociationIds":{"shape":"So","locationName":"IpamResourceDiscoveryAssociationId"},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"IpamResourceDiscoveryAssociations":{"locationName":"ipamResourceDiscoveryAssociationSet","type":"list","member":{"shape":"S4l","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeIpamScopes":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamScopeIds":{"shape":"So","locationName":"IpamScopeId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"IpamScopes":{"locationName":"ipamScopeSet","type":"list","member":{"shape":"Sgi","locationName":"item"}}}}},"DescribeIpams":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamIds":{"shape":"So","locationName":"IpamId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Ipams":{"locationName":"ipamSet","type":"list","member":{"shape":"Sfr","locationName":"item"}}}}},"DescribeIpv6Pools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"Ipv6Pools":{"locationName":"ipv6PoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"Description":{"locationName":"description"},"PoolCidrBlocks":{"locationName":"poolCidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidr":{"locationName":"poolCidrBlock"}}}},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeKeyPairs":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"KeyNames":{"locationName":"KeyName","type":"list","member":{"locationName":"KeyName"}},"KeyPairIds":{"locationName":"KeyPairId","type":"list","member":{"locationName":"KeyPairId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"IncludePublicKey":{"type":"boolean"}}},"output":{"type":"structure","members":{"KeyPairs":{"locationName":"keySet","type":"list","member":{"locationName":"item","type":"structure","members":{"KeyPairId":{"locationName":"keyPairId"},"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"},"KeyType":{"locationName":"keyType"},"Tags":{"shape":"S6","locationName":"tagSet"},"PublicKey":{"locationName":"publicKey"},"CreateTime":{"locationName":"createTime","type":"timestamp"}}}}}}},"DescribeLaunchTemplateVersions":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateId":{},"LaunchTemplateName":{},"Versions":{"shape":"Sw1","locationName":"LaunchTemplateVersion"},"MinVersion":{},"MaxVersion":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S10d","locationName":"Filter"},"ResolveAlias":{"type":"boolean"}}},"output":{"type":"structure","members":{"LaunchTemplateVersions":{"locationName":"launchTemplateVersionSet","type":"list","member":{"shape":"Sii","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLaunchTemplates":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"LaunchTemplateIds":{"locationName":"LaunchTemplateId","type":"list","member":{"locationName":"item"}},"LaunchTemplateNames":{"locationName":"LaunchTemplateName","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"LaunchTemplates":{"locationName":"launchTemplates","type":"list","member":{"shape":"Sic","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"input":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociationIds":{"locationName":"LocalGatewayRouteTableVirtualInterfaceGroupAssociationId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociationSet","type":"list","member":{"shape":"Sjz","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTableVpcAssociations":{"input":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociationIds":{"locationName":"LocalGatewayRouteTableVpcAssociationId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociations":{"locationName":"localGatewayRouteTableVpcAssociationSet","type":"list","member":{"shape":"Sk3","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayRouteTables":{"input":{"type":"structure","members":{"LocalGatewayRouteTableIds":{"locationName":"LocalGatewayRouteTableId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayRouteTables":{"locationName":"localGatewayRouteTableSet","type":"list","member":{"shape":"Sjv","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayVirtualInterfaceGroups":{"input":{"type":"structure","members":{"LocalGatewayVirtualInterfaceGroupIds":{"locationName":"LocalGatewayVirtualInterfaceGroupId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayVirtualInterfaceGroups":{"locationName":"localGatewayVirtualInterfaceGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"LocalGatewayVirtualInterfaceIds":{"shape":"S1hb","locationName":"localGatewayVirtualInterfaceIdSet"},"LocalGatewayId":{"locationName":"localGatewayId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGatewayVirtualInterfaces":{"input":{"type":"structure","members":{"LocalGatewayVirtualInterfaceIds":{"shape":"S1hb","locationName":"LocalGatewayVirtualInterfaceId"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGatewayVirtualInterfaces":{"locationName":"localGatewayVirtualInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayVirtualInterfaceId":{"locationName":"localGatewayVirtualInterfaceId"},"LocalGatewayId":{"locationName":"localGatewayId"},"Vlan":{"locationName":"vlan","type":"integer"},"LocalAddress":{"locationName":"localAddress"},"PeerAddress":{"locationName":"peerAddress"},"LocalBgpAsn":{"locationName":"localBgpAsn","type":"integer"},"PeerBgpAsn":{"locationName":"peerBgpAsn","type":"integer"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLocalGateways":{"input":{"type":"structure","members":{"LocalGatewayIds":{"locationName":"LocalGatewayId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LocalGateways":{"locationName":"localGatewaySet","type":"list","member":{"locationName":"item","type":"structure","members":{"LocalGatewayId":{"locationName":"localGatewayId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeLockedSnapshots":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"SnapshotIds":{"shape":"S1ho","locationName":"SnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"locationName":"item","type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"SnapshotId":{"locationName":"snapshotId"},"LockState":{"locationName":"lockState"},"LockDuration":{"locationName":"lockDuration","type":"integer"},"CoolOffPeriod":{"locationName":"coolOffPeriod","type":"integer"},"CoolOffPeriodExpiresOn":{"locationName":"coolOffPeriodExpiresOn","type":"timestamp"},"LockCreatedOn":{"locationName":"lockCreatedOn","type":"timestamp"},"LockDurationStartTime":{"locationName":"lockDurationStartTime","type":"timestamp"},"LockExpiresOn":{"locationName":"lockExpiresOn","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeMacHosts":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"HostIds":{"shape":"S17g","locationName":"HostId"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"MacHosts":{"locationName":"macHostSet","type":"list","member":{"locationName":"item","type":"structure","members":{"HostId":{"locationName":"hostId"},"MacOSLatestSupportedVersions":{"locationName":"macOSLatestSupportedVersionSet","type":"list","member":{"locationName":"item"}}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeManagedPrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"shape":"So","locationName":"PrefixListId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"shape":"Sk9","locationName":"item"}}}}},"DescribeMovingAddresses":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"PublicIps":{"shape":"So","locationName":"publicIp"}}},"output":{"type":"structure","members":{"MovingAddressStatuses":{"locationName":"movingAddressStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"MoveStatus":{"locationName":"moveStatus"},"PublicIp":{"locationName":"publicIp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNatGateways":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filter":{"shape":"S10d"},"MaxResults":{"type":"integer"},"NatGatewayIds":{"locationName":"NatGatewayId","type":"list","member":{"locationName":"item"}},"NextToken":{}}},"output":{"type":"structure","members":{"NatGateways":{"locationName":"natGatewaySet","type":"list","member":{"shape":"Ske","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkAcls":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclIds":{"locationName":"NetworkAclId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkAcls":{"locationName":"networkAclSet","type":"list","member":{"shape":"Skj","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsAccessScopeAnalyses":{"input":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisIds":{"locationName":"NetworkInsightsAccessScopeAnalysisId","type":"list","member":{"locationName":"item"}},"NetworkInsightsAccessScopeId":{},"AnalysisStartTimeBegin":{"type":"timestamp"},"AnalysisStartTimeEnd":{"type":"timestamp"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalyses":{"locationName":"networkInsightsAccessScopeAnalysisSet","type":"list","member":{"shape":"S1iq","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsAccessScopes":{"input":{"type":"structure","members":{"NetworkInsightsAccessScopeIds":{"locationName":"NetworkInsightsAccessScopeId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopes":{"locationName":"networkInsightsAccessScopeSet","type":"list","member":{"shape":"Sl4","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsAnalyses":{"input":{"type":"structure","members":{"NetworkInsightsAnalysisIds":{"locationName":"NetworkInsightsAnalysisId","type":"list","member":{"locationName":"item"}},"NetworkInsightsPathId":{},"AnalysisStartTime":{"type":"timestamp"},"AnalysisEndTime":{"type":"timestamp"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsAnalyses":{"locationName":"networkInsightsAnalysisSet","type":"list","member":{"shape":"S1j1","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInsightsPaths":{"input":{"type":"structure","members":{"NetworkInsightsPathIds":{"locationName":"NetworkInsightsPathId","type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"NetworkInsightsPaths":{"locationName":"networkInsightsPathSet","type":"list","member":{"shape":"Sll","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"Attachment":{"shape":"Slu","locationName":"attachment"},"Description":{"shape":"Sc1","locationName":"description"},"Groups":{"shape":"Sly","locationName":"groupSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"S19c","locationName":"sourceDestCheck"},"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"}}}},"DescribeNetworkInterfacePermissions":{"input":{"type":"structure","members":{"NetworkInterfacePermissionIds":{"locationName":"NetworkInterfacePermissionId","type":"list","member":{}},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfacePermissions":{"locationName":"networkInterfacePermissions","type":"list","member":{"shape":"Smb","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeNetworkInterfaces":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceIds":{"locationName":"NetworkInterfaceId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"shape":"Sls","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribePlacementGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupNames":{"locationName":"groupName","type":"list","member":{}},"GroupIds":{"locationName":"GroupId","type":"list","member":{"locationName":"GroupId"}}}},"output":{"type":"structure","members":{"PlacementGroups":{"locationName":"placementGroupSet","type":"list","member":{"shape":"Smi","locationName":"item"}}}}},"DescribePrefixLists":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"PrefixListIds":{"locationName":"PrefixListId","type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"PrefixLists":{"locationName":"prefixListSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidrs":{"shape":"So","locationName":"cidrSet"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListName":{"locationName":"prefixListName"}}}}}}},"DescribePrincipalIdFormat":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Resources":{"locationName":"Resource","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Principals":{"locationName":"principalSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"},"Statuses":{"shape":"S10u","locationName":"statusSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribePublicIpv4Pools":{"input":{"type":"structure","members":{"PoolIds":{"locationName":"PoolId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S10d","locationName":"Filter"}}},"output":{"type":"structure","members":{"PublicIpv4Pools":{"locationName":"publicIpv4PoolSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PoolId":{"locationName":"poolId"},"Description":{"locationName":"description"},"PoolAddressRanges":{"locationName":"poolAddressRangeSet","type":"list","member":{"shape":"S1l4","locationName":"item"}},"TotalAddressCount":{"locationName":"totalAddressCount","type":"integer"},"TotalAvailableAddressCount":{"locationName":"totalAvailableAddressCount","type":"integer"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRegions":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"RegionNames":{"locationName":"RegionName","type":"list","member":{"locationName":"RegionName"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"AllRegions":{"type":"boolean"}}},"output":{"type":"structure","members":{"Regions":{"locationName":"regionInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Endpoint":{"locationName":"regionEndpoint"},"RegionName":{"locationName":"regionName"},"OptInStatus":{"locationName":"optInStatus"}}}}}}},"DescribeReplaceRootVolumeTasks":{"input":{"type":"structure","members":{"ReplaceRootVolumeTaskIds":{"locationName":"ReplaceRootVolumeTaskId","type":"list","member":{"locationName":"ReplaceRootVolumeTaskId"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReplaceRootVolumeTasks":{"locationName":"replaceRootVolumeTaskSet","type":"list","member":{"shape":"Smo","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeReservedInstances":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"OfferingClass":{},"ReservedInstancesIds":{"shape":"S1lh","locationName":"ReservedInstancesId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstances":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"End":{"locationName":"end","type":"timestamp"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"Start":{"locationName":"start","type":"timestamp"},"State":{"locationName":"state"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"RecurringCharges":{"shape":"S1lp","locationName":"recurringCharges"},"Scope":{"locationName":"scope"},"Tags":{"shape":"S6","locationName":"tagSet"}}}}}}},"DescribeReservedInstancesListings":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"}}},"output":{"type":"structure","members":{"ReservedInstancesListings":{"shape":"S8k","locationName":"reservedInstancesListingsSet"}}}},"DescribeReservedInstancesModifications":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"ReservedInstancesModificationIds":{"locationName":"ReservedInstancesModificationId","type":"list","member":{"locationName":"ReservedInstancesModificationId"}},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ReservedInstancesModifications":{"locationName":"reservedInstancesModificationsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"EffectiveDate":{"locationName":"effectiveDate","type":"timestamp"},"ModificationResults":{"locationName":"modificationResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"},"TargetConfiguration":{"shape":"S1m3","locationName":"targetConfiguration"}}}},"ReservedInstancesIds":{"locationName":"reservedInstancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}}}}},"DescribeReservedInstancesOfferings":{"input":{"type":"structure","members":{"AvailabilityZone":{},"Filters":{"shape":"S10d","locationName":"Filter"},"IncludeMarketplace":{"type":"boolean"},"InstanceType":{},"MaxDuration":{"type":"long"},"MaxInstanceCount":{"type":"integer"},"MinDuration":{"type":"long"},"OfferingClass":{},"ProductDescription":{},"ReservedInstancesOfferingIds":{"locationName":"ReservedInstancesOfferingId","type":"list","member":{}},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceTenancy":{"locationName":"instanceTenancy"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"OfferingType":{"locationName":"offeringType"}}},"output":{"type":"structure","members":{"ReservedInstancesOfferings":{"locationName":"reservedInstancesOfferingsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Duration":{"locationName":"duration","type":"long"},"FixedPrice":{"locationName":"fixedPrice","type":"float"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"ReservedInstancesOfferingId":{"locationName":"reservedInstancesOfferingId"},"UsagePrice":{"locationName":"usagePrice","type":"float"},"CurrencyCode":{"locationName":"currencyCode"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Marketplace":{"locationName":"marketplace","type":"boolean"},"OfferingClass":{"locationName":"offeringClass"},"OfferingType":{"locationName":"offeringType"},"PricingDetails":{"locationName":"pricingDetailsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Count":{"locationName":"count","type":"integer"},"Price":{"locationName":"price","type":"double"}}}},"RecurringCharges":{"shape":"S1lp","locationName":"recurringCharges"},"Scope":{"locationName":"scope"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeRouteTables":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableIds":{"locationName":"RouteTableId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"RouteTables":{"locationName":"routeTableSet","type":"list","member":{"shape":"Sn4","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeScheduledInstanceAvailability":{"input":{"type":"structure","required":["FirstSlotStartTimeRange","Recurrence"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"FirstSlotStartTimeRange":{"type":"structure","required":["EarliestTime","LatestTime"],"members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"MaxResults":{"type":"integer"},"MaxSlotDurationInHours":{"type":"integer"},"MinSlotDurationInHours":{"type":"integer"},"NextToken":{},"Recurrence":{"type":"structure","members":{"Frequency":{},"Interval":{"type":"integer"},"OccurrenceDays":{"locationName":"OccurrenceDay","type":"list","member":{"locationName":"OccurenceDay","type":"integer"}},"OccurrenceRelativeToEnd":{"type":"boolean"},"OccurrenceUnit":{}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceAvailabilitySet":{"locationName":"scheduledInstanceAvailabilitySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"FirstSlotStartTime":{"locationName":"firstSlotStartTime","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceType":{"locationName":"instanceType"},"MaxTermDurationInDays":{"locationName":"maxTermDurationInDays","type":"integer"},"MinTermDurationInDays":{"locationName":"minTermDurationInDays","type":"integer"},"NetworkPlatform":{"locationName":"networkPlatform"},"Platform":{"locationName":"platform"},"PurchaseToken":{"locationName":"purchaseToken"},"Recurrence":{"shape":"S1mq","locationName":"recurrence"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}}}}}},"DescribeScheduledInstances":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"ScheduledInstanceIds":{"locationName":"ScheduledInstanceId","type":"list","member":{"locationName":"ScheduledInstanceId"}},"SlotStartTimeRange":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"S1my","locationName":"item"}}}}},"DescribeSecurityGroupReferences":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"type":"boolean"},"GroupId":{"type":"list","member":{"locationName":"item"}}}},"output":{"type":"structure","members":{"SecurityGroupReferenceSet":{"locationName":"securityGroupReferenceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"ReferencingVpcId":{"locationName":"referencingVpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"TransitGatewayId":{"locationName":"transitGatewayId"}}}}}}},"DescribeSecurityGroupRules":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"SecurityGroupRuleIds":{"shape":"S1n5","locationName":"SecurityGroupRuleId"},"DryRun":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroupRules":{"shape":"S78","locationName":"securityGroupRuleSet"},"NextToken":{"locationName":"nextToken"}}}},"DescribeSecurityGroups":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"GroupIds":{"shape":"S5v","locationName":"GroupId"},"GroupNames":{"shape":"S1n9","locationName":"GroupName"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SecurityGroups":{"locationName":"securityGroupInfo","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"groupDescription"},"GroupName":{"locationName":"groupName"},"IpPermissions":{"shape":"S6x","locationName":"ipPermissions"},"OwnerId":{"locationName":"ownerId"},"GroupId":{"locationName":"groupId"},"IpPermissionsEgress":{"shape":"S6x","locationName":"ipPermissionsEgress"},"Tags":{"shape":"S6","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"CreateVolumePermissions":{"shape":"S1nh","locationName":"createVolumePermission"},"ProductCodes":{"shape":"S16n","locationName":"productCodes"},"SnapshotId":{"locationName":"snapshotId"}}}},"DescribeSnapshotTierStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SnapshotTierStatuses":{"locationName":"snapshotTierStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"VolumeId":{"locationName":"volumeId"},"Status":{"locationName":"status"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"S6","locationName":"tagSet"},"StorageTier":{"locationName":"storageTier"},"LastTieringStartTime":{"locationName":"lastTieringStartTime","type":"timestamp"},"LastTieringProgress":{"locationName":"lastTieringProgress","type":"integer"},"LastTieringOperationStatus":{"locationName":"lastTieringOperationStatus"},"LastTieringOperationStatusDetail":{"locationName":"lastTieringOperationStatusDetail"},"ArchivalCompleteTime":{"locationName":"archivalCompleteTime","type":"timestamp"},"RestoreExpiryTime":{"locationName":"restoreExpiryTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"OwnerIds":{"shape":"S16s","locationName":"Owner"},"RestorableByUserIds":{"locationName":"RestorableBy","type":"list","member":{}},"SnapshotIds":{"shape":"S1ho","locationName":"SnapshotId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"shape":"Sng","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotDatafeedSubscription":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"SpotDatafeedSubscription":{"shape":"Snu","locationName":"spotDatafeedSubscription"}}}},"DescribeSpotFleetInstances":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"ActiveInstances":{"shape":"S15q","locationName":"activeInstanceSet"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"DescribeSpotFleetRequestHistory":{"input":{"type":"structure","required":["SpotFleetRequestId","StartTime"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"EventType":{"locationName":"eventType"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"EventInformation":{"shape":"S15n","locationName":"eventInformation"},"EventType":{"locationName":"eventType"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"LastEvaluatedTime":{"locationName":"lastEvaluatedTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"StartTime":{"locationName":"startTime","type":"timestamp"}}}},"DescribeSpotFleetRequests":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"SpotFleetRequestIds":{"shape":"S8w","locationName":"spotFleetRequestId"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotFleetRequestConfigs":{"locationName":"spotFleetRequestConfigSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ActivityStatus":{"locationName":"activityStatus"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"SpotFleetRequestConfig":{"shape":"S1o9","locationName":"spotFleetRequestConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"SpotFleetRequestState":{"locationName":"spotFleetRequestState"},"Tags":{"shape":"S6","locationName":"tagSet"}}}}}}},"DescribeSpotInstanceRequests":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotInstanceRequestIds":{"shape":"S97","locationName":"SpotInstanceRequestId"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"S1p1","locationName":"spotInstanceRequestSet"},"NextToken":{"locationName":"nextToken"}}}},"DescribeSpotPriceHistory":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"AvailabilityZone":{"locationName":"availabilityZone"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"ProductDescriptions":{"locationName":"ProductDescription","type":"list","member":{}},"StartTime":{"locationName":"startTime","type":"timestamp"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SpotPriceHistory":{"locationName":"spotPriceHistorySet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceType":{"locationName":"instanceType"},"ProductDescription":{"locationName":"productDescription"},"SpotPrice":{"locationName":"spotPrice"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}}}}},"DescribeStaleSecurityGroups":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"VpcId":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"StaleSecurityGroupSet":{"locationName":"staleSecurityGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"StaleIpPermissions":{"shape":"S1pj","locationName":"staleIpPermissions"},"StaleIpPermissionsEgress":{"shape":"S1pj","locationName":"staleIpPermissionsEgress"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeStoreImageTasks":{"input":{"type":"structure","members":{"ImageIds":{"locationName":"ImageId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"StoreImageTaskResults":{"locationName":"storeImageTaskResultSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiId":{"locationName":"amiId"},"TaskStartTime":{"locationName":"taskStartTime","type":"timestamp"},"Bucket":{"locationName":"bucket"},"S3objectKey":{"locationName":"s3objectKey"},"ProgressPercentage":{"locationName":"progressPercentage","type":"integer"},"StoreTaskState":{"locationName":"storeTaskState"},"StoreTaskFailureReason":{"locationName":"storeTaskFailureReason"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeSubnets":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"SubnetId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Subnets":{"locationName":"subnetSet","type":"list","member":{"shape":"Sbg","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTags":{"input":{"type":"structure","members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Tags":{"locationName":"tagSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"Value":{"locationName":"value"}}}}}}},"DescribeTrafficMirrorFilters":{"input":{"type":"structure","members":{"TrafficMirrorFilterIds":{"locationName":"TrafficMirrorFilterId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorFilters":{"locationName":"trafficMirrorFilterSet","type":"list","member":{"shape":"Sod","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorSessions":{"input":{"type":"structure","members":{"TrafficMirrorSessionIds":{"locationName":"TrafficMirrorSessionId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorSessions":{"locationName":"trafficMirrorSessionSet","type":"list","member":{"shape":"Sos","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrafficMirrorTargets":{"input":{"type":"structure","members":{"TrafficMirrorTargetIds":{"locationName":"TrafficMirrorTargetId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"TrafficMirrorTargets":{"locationName":"trafficMirrorTargetSet","type":"list","member":{"shape":"Sov","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1qh"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayOwnerId":{"locationName":"transitGatewayOwnerId"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"},"State":{"locationName":"state"},"Association":{"locationName":"association","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayConnectPeers":{"input":{"type":"structure","members":{"TransitGatewayConnectPeerIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnectPeers":{"locationName":"transitGatewayConnectPeerSet","type":"list","member":{"shape":"Spj","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayConnects":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1qh"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayConnects":{"locationName":"transitGatewayConnectSet","type":"list","member":{"shape":"Spd","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayMulticastDomains":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayMulticastDomains":{"locationName":"transitGatewayMulticastDomains","type":"list","member":{"shape":"Spw","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayPeeringAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1qh"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachments":{"locationName":"transitGatewayPeeringAttachments","type":"list","member":{"shape":"Sx","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayPolicyTables":{"input":{"type":"structure","members":{"TransitGatewayPolicyTableIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPolicyTables":{"locationName":"transitGatewayPolicyTables","type":"list","member":{"shape":"Sq5","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayRouteTableAnnouncements":{"input":{"type":"structure","members":{"TransitGatewayRouteTableAnnouncementIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTableAnnouncements":{"locationName":"transitGatewayRouteTableAnnouncements","type":"list","member":{"shape":"Sqq","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayRouteTables":{"input":{"type":"structure","members":{"TransitGatewayRouteTableIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTables":{"locationName":"transitGatewayRouteTables","type":"list","member":{"shape":"Sqm","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGatewayVpcAttachments":{"input":{"type":"structure","members":{"TransitGatewayAttachmentIds":{"shape":"S1qh"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachments":{"locationName":"transitGatewayVpcAttachments","type":"list","member":{"shape":"S16","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTransitGateways":{"input":{"type":"structure","members":{"TransitGatewayIds":{"type":"list","member":{"locationName":"item"}},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateways":{"locationName":"transitGatewaySet","type":"list","member":{"shape":"Sp6","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeTrunkInterfaceAssociations":{"input":{"type":"structure","members":{"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"item"}},"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InterfaceAssociations":{"locationName":"interfaceAssociationSet","type":"list","member":{"shape":"S5k","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVerifiedAccessEndpoints":{"input":{"type":"structure","members":{"VerifiedAccessEndpointIds":{"locationName":"VerifiedAccessEndpointId","type":"list","member":{"locationName":"item"}},"VerifiedAccessInstanceId":{},"VerifiedAccessGroupId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessEndpoints":{"locationName":"verifiedAccessEndpointSet","type":"list","member":{"shape":"Sra","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVerifiedAccessGroups":{"input":{"type":"structure","members":{"VerifiedAccessGroupIds":{"locationName":"VerifiedAccessGroupId","type":"list","member":{"locationName":"item"}},"VerifiedAccessInstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessGroups":{"locationName":"verifiedAccessGroupSet","type":"list","member":{"shape":"Sri","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVerifiedAccessInstanceLoggingConfigurations":{"input":{"type":"structure","members":{"VerifiedAccessInstanceIds":{"shape":"S1s0","locationName":"VerifiedAccessInstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"locationName":"loggingConfigurationSet","type":"list","member":{"shape":"S1s4","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVerifiedAccessInstances":{"input":{"type":"structure","members":{"VerifiedAccessInstanceIds":{"shape":"S1s0","locationName":"VerifiedAccessInstanceId"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessInstances":{"locationName":"verifiedAccessInstanceSet","type":"list","member":{"shape":"S6g","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVerifiedAccessTrustProviders":{"input":{"type":"structure","members":{"VerifiedAccessTrustProviderIds":{"locationName":"VerifiedAccessTrustProviderId","type":"list","member":{"locationName":"item"}},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessTrustProviders":{"locationName":"verifiedAccessTrustProviderSet","type":"list","member":{"shape":"S67","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumeAttribute":{"input":{"type":"structure","required":["Attribute","VolumeId"],"members":{"Attribute":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"AutoEnableIO":{"shape":"S19c","locationName":"autoEnableIO"},"ProductCodes":{"shape":"S16n","locationName":"productCodes"},"VolumeId":{"locationName":"volumeId"}}}},"DescribeVolumeStatus":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"VolumeIds":{"shape":"Snn","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"VolumeStatuses":{"locationName":"volumeStatusSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Actions":{"locationName":"actionsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"}}}},"AvailabilityZone":{"locationName":"availabilityZone"},"OutpostArn":{"locationName":"outpostArn"},"Events":{"locationName":"eventsSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"EventId":{"locationName":"eventId"},"EventType":{"locationName":"eventType"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"},"InstanceId":{"locationName":"instanceId"}}}},"VolumeId":{"locationName":"volumeId"},"VolumeStatus":{"locationName":"volumeStatus","type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"AttachmentStatuses":{"locationName":"attachmentStatuses","type":"list","member":{"locationName":"item","type":"structure","members":{"IoPerformance":{"locationName":"ioPerformance"},"InstanceId":{"locationName":"instanceId"}}}}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"VolumeIds":{"shape":"Snn","locationName":"VolumeId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"}}},"output":{"type":"structure","members":{"Volumes":{"locationName":"volumeSet","type":"list","member":{"shape":"Srq","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVolumesModifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VolumeIds":{"shape":"Snn","locationName":"VolumeId"},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VolumesModifications":{"locationName":"volumeModificationSet","type":"list","member":{"shape":"S1t8","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcAttribute":{"input":{"type":"structure","required":["Attribute","VpcId"],"members":{"Attribute":{},"VpcId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpcId":{"locationName":"vpcId"},"EnableDnsHostnames":{"shape":"S19c","locationName":"enableDnsHostnames"},"EnableDnsSupport":{"shape":"S19c","locationName":"enableDnsSupport"},"EnableNetworkAddressUsageMetrics":{"shape":"S19c","locationName":"enableNetworkAddressUsageMetrics"}}}},"DescribeVpcClassicLink":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcIds":{"shape":"S1te","locationName":"VpcId"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkEnabled":{"locationName":"classicLinkEnabled","type":"boolean"},"Tags":{"shape":"S6","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"MaxResults":{"locationName":"maxResults","type":"integer"},"NextToken":{"locationName":"nextToken"},"VpcIds":{"shape":"S1te"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"Vpcs":{"locationName":"vpcs","type":"list","member":{"locationName":"item","type":"structure","members":{"ClassicLinkDnsSupported":{"locationName":"classicLinkDnsSupported","type":"boolean"},"VpcId":{"locationName":"vpcId"}}}}}}},"DescribeVpcEndpointConnectionNotifications":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ConnectionNotificationSet":{"locationName":"connectionNotificationSet","type":"list","member":{"shape":"Ssg","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointConnections":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpointConnections":{"locationName":"vpcEndpointConnectionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointOwner":{"locationName":"vpcEndpointOwner"},"VpcEndpointState":{"locationName":"vpcEndpointState"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"DnsEntries":{"shape":"Ssb","locationName":"dnsEntrySet"},"NetworkLoadBalancerArns":{"shape":"So","locationName":"networkLoadBalancerArnSet"},"GatewayLoadBalancerArns":{"shape":"So","locationName":"gatewayLoadBalancerArnSet"},"IpAddressType":{"locationName":"ipAddressType"},"VpcEndpointConnectionId":{"locationName":"vpcEndpointConnectionId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServiceConfigurations":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceIds":{"shape":"Syy","locationName":"ServiceId"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceConfigurations":{"locationName":"serviceConfigurationSet","type":"list","member":{"shape":"Ssl","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AllowedPrincipals":{"locationName":"allowedPrincipals","type":"list","member":{"locationName":"item","type":"structure","members":{"PrincipalType":{"locationName":"principalType"},"Principal":{"locationName":"principal"},"ServicePermissionId":{"locationName":"servicePermissionId"},"Tags":{"shape":"S6","locationName":"tagSet"},"ServiceId":{"locationName":"serviceId"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpointServices":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ServiceNames":{"shape":"So","locationName":"ServiceName"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ServiceNames":{"shape":"So","locationName":"serviceNameSet"},"ServiceDetails":{"locationName":"serviceDetailSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceName":{"locationName":"serviceName"},"ServiceId":{"locationName":"serviceId"},"ServiceType":{"shape":"Ssm","locationName":"serviceType"},"AvailabilityZones":{"shape":"So","locationName":"availabilityZoneSet"},"Owner":{"locationName":"owner"},"BaseEndpointDnsNames":{"shape":"So","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateDnsNames":{"locationName":"privateDnsNameSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PrivateDnsName":{"locationName":"privateDnsName"}}}},"VpcEndpointPolicySupported":{"locationName":"vpcEndpointPolicySupported","type":"boolean"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"PayerResponsibility":{"locationName":"payerResponsibility"},"Tags":{"shape":"S6","locationName":"tagSet"},"PrivateDnsNameVerificationState":{"locationName":"privateDnsNameVerificationState"},"SupportedIpAddressTypes":{"shape":"Ssq","locationName":"supportedIpAddressTypeSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcEndpoints":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"VpcEndpointIds":{"shape":"S1e","locationName":"VpcEndpointId"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"VpcEndpoints":{"locationName":"vpcEndpointSet","type":"list","member":{"shape":"Ss6","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionIds":{"locationName":"VpcPeeringConnectionId","type":"list","member":{"locationName":"item"}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"locationName":"vpcPeeringConnectionSet","type":"list","member":{"shape":"S1n","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpcs":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"VpcIds":{"locationName":"VpcId","type":"list","member":{"locationName":"VpcId"}},"DryRun":{"locationName":"dryRun","type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Vpcs":{"locationName":"vpcSet","type":"list","member":{"shape":"Sbo","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"DescribeVpnConnections":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"VpnConnectionIds":{"locationName":"VpnConnectionId","type":"list","member":{"locationName":"VpnConnectionId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnections":{"locationName":"vpnConnectionSet","type":"list","member":{"shape":"Stm","locationName":"item"}}}}},"DescribeVpnGateways":{"input":{"type":"structure","members":{"Filters":{"shape":"S10d","locationName":"Filter"},"VpnGatewayIds":{"locationName":"VpnGatewayId","type":"list","member":{"locationName":"VpnGatewayId"}},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"VpnGateways":{"locationName":"vpnGatewaySet","type":"list","member":{"shape":"Suj","locationName":"item"}}}}},"DetachClassicLinkVpc":{"input":{"type":"structure","required":["InstanceId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DetachInternetGateway":{"input":{"type":"structure","required":["InternetGatewayId","VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"InternetGatewayId":{"locationName":"internetGatewayId"},"VpcId":{"locationName":"vpcId"}}}},"DetachNetworkInterface":{"input":{"type":"structure","required":["AttachmentId"],"members":{"AttachmentId":{"locationName":"attachmentId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}}},"DetachVerifiedAccessTrustProvider":{"input":{"type":"structure","required":["VerifiedAccessInstanceId","VerifiedAccessTrustProviderId"],"members":{"VerifiedAccessInstanceId":{},"VerifiedAccessTrustProviderId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessTrustProvider":{"shape":"S67","locationName":"verifiedAccessTrustProvider"},"VerifiedAccessInstance":{"shape":"S6g","locationName":"verifiedAccessInstance"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"Device":{},"Force":{"type":"boolean"},"InstanceId":{},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"shape":"S6l"}},"DetachVpnGateway":{"input":{"type":"structure","required":["VpcId","VpnGatewayId"],"members":{"VpcId":{},"VpnGatewayId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisableAddressTransfer":{"input":{"type":"structure","required":["AllocationId"],"members":{"AllocationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AddressTransfer":{"shape":"Sa","locationName":"addressTransfer"}}}},"DisableAwsNetworkPerformanceMetricSubscription":{"input":{"type":"structure","members":{"Source":{},"Destination":{},"Metric":{},"Statistic":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Output":{"locationName":"output","type":"boolean"}}}},"DisableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"DisableFastLaunch":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"Force":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"},"ResourceType":{"locationName":"resourceType"},"SnapshotConfiguration":{"shape":"S159","locationName":"snapshotConfiguration"},"LaunchTemplate":{"shape":"S15a","locationName":"launchTemplate"},"MaxParallelLaunches":{"locationName":"maxParallelLaunches","type":"integer"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"StateTransitionTime":{"locationName":"stateTransitionTime","type":"timestamp"}}}},"DisableFastSnapshotRestores":{"input":{"type":"structure","required":["AvailabilityZones","SourceSnapshotIds"],"members":{"AvailabilityZones":{"shape":"S1ve","locationName":"AvailabilityZone"},"SourceSnapshotIds":{"shape":"S1ho","locationName":"SourceSnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Successful":{"locationName":"successful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"Unsuccessful":{"locationName":"unsuccessful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"FastSnapshotRestoreStateErrors":{"locationName":"fastSnapshotRestoreStateErrorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}}}}},"DisableImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableImageBlockPublicAccess":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageBlockPublicAccessState":{"locationName":"imageBlockPublicAccessState"}}}},"DisableImageDeprecation":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableImageDeregistrationProtection":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return"}}}},"DisableIpamOrganizationAdminAccount":{"input":{"type":"structure","required":["DelegatedAdminAccountId"],"members":{"DryRun":{"type":"boolean"},"DelegatedAdminAccountId":{}}},"output":{"type":"structure","members":{"Success":{"locationName":"success","type":"boolean"}}}},"DisableSerialConsoleAccess":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SerialConsoleAccessEnabled":{"locationName":"serialConsoleAccessEnabled","type":"boolean"}}}},"DisableSnapshotBlockPublicAccess":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"DisableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"},"TransitGatewayRouteTableAnnouncementId":{}}},"output":{"type":"structure","members":{"Propagation":{"shape":"S1w5","locationName":"propagation"}}}},"DisableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{},"DryRun":{"type":"boolean"}}}},"DisableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateAddress":{"input":{"type":"structure","members":{"AssociationId":{},"PublicIp":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateClientVpnTargetNetwork":{"input":{"type":"structure","required":["ClientVpnEndpointId","AssociationId"],"members":{"ClientVpnEndpointId":{},"AssociationId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Status":{"shape":"S3m","locationName":"status"}}}},"DisassociateEnclaveCertificateIamRole":{"input":{"type":"structure","required":["CertificateArn","RoleArn"],"members":{"CertificateArn":{},"RoleArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"DisassociateIamInstanceProfile":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S3x","locationName":"iamInstanceProfileAssociation"}}}},"DisassociateInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId","AssociationTarget"],"members":{"DryRun":{"type":"boolean"},"InstanceEventWindowId":{},"AssociationTarget":{"type":"structure","members":{"InstanceIds":{"shape":"S43","locationName":"InstanceId"},"InstanceTags":{"shape":"S6","locationName":"InstanceTag"},"DedicatedHostIds":{"shape":"S44","locationName":"DedicatedHostId"}}}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S47","locationName":"instanceEventWindow"}}}},"DisassociateIpamByoasn":{"input":{"type":"structure","required":["Asn","Cidr"],"members":{"DryRun":{"type":"boolean"},"Asn":{},"Cidr":{}}},"output":{"type":"structure","members":{"AsnAssociation":{"shape":"S20","locationName":"asnAssociation"}}}},"DisassociateIpamResourceDiscovery":{"input":{"type":"structure","required":["IpamResourceDiscoveryAssociationId"],"members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryAssociationId":{}}},"output":{"type":"structure","members":{"IpamResourceDiscoveryAssociation":{"shape":"S4l","locationName":"ipamResourceDiscoveryAssociation"}}}},"DisassociateNatGatewayAddress":{"input":{"type":"structure","required":["NatGatewayId","AssociationIds"],"members":{"NatGatewayId":{},"AssociationIds":{"locationName":"AssociationId","type":"list","member":{"locationName":"item"}},"MaxDrainDurationSeconds":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"},"NatGatewayAddresses":{"shape":"S3b","locationName":"natGatewayAddressSet"}}}},"DisassociateRouteTable":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"DisassociateSubnetCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S52","locationName":"ipv6CidrBlockAssociation"},"SubnetId":{"locationName":"subnetId"}}}},"DisassociateTransitGatewayMulticastDomain":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId","TransitGatewayAttachmentId","SubnetIds"],"members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"S57"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sq","locationName":"associations"}}}},"DisassociateTransitGatewayPolicyTable":{"input":{"type":"structure","required":["TransitGatewayPolicyTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayPolicyTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S5c","locationName":"association"}}}},"DisassociateTransitGatewayRouteTable":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","TransitGatewayAttachmentId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Association":{"shape":"S5h","locationName":"association"}}}},"DisassociateTrunkInterface":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"ClientToken":{"locationName":"clientToken"}}}},"DisassociateVpcCidrBlock":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{"locationName":"associationId"}}},"output":{"type":"structure","members":{"Ipv6CidrBlockAssociation":{"shape":"S5q","locationName":"ipv6CidrBlockAssociation"},"CidrBlockAssociation":{"shape":"S5t","locationName":"cidrBlockAssociation"},"VpcId":{"locationName":"vpcId"}}}},"EnableAddressTransfer":{"input":{"type":"structure","required":["AllocationId","TransferAccountId"],"members":{"AllocationId":{},"TransferAccountId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AddressTransfer":{"shape":"Sa","locationName":"addressTransfer"}}}},"EnableAwsNetworkPerformanceMetricSubscription":{"input":{"type":"structure","members":{"Source":{},"Destination":{},"Metric":{},"Statistic":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Output":{"locationName":"output","type":"boolean"}}}},"EnableEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"}}}},"EnableFastLaunch":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"ResourceType":{},"SnapshotConfiguration":{"type":"structure","members":{"TargetResourceCount":{"type":"integer"}}},"LaunchTemplate":{"type":"structure","required":["Version"],"members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"MaxParallelLaunches":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"},"ResourceType":{"locationName":"resourceType"},"SnapshotConfiguration":{"shape":"S159","locationName":"snapshotConfiguration"},"LaunchTemplate":{"shape":"S15a","locationName":"launchTemplate"},"MaxParallelLaunches":{"locationName":"maxParallelLaunches","type":"integer"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"StateTransitionTime":{"locationName":"stateTransitionTime","type":"timestamp"}}}},"EnableFastSnapshotRestores":{"input":{"type":"structure","required":["AvailabilityZones","SourceSnapshotIds"],"members":{"AvailabilityZones":{"shape":"S1ve","locationName":"AvailabilityZone"},"SourceSnapshotIds":{"shape":"S1ho","locationName":"SourceSnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Successful":{"locationName":"successful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"StateTransitionReason":{"locationName":"stateTransitionReason"},"OwnerId":{"locationName":"ownerId"},"OwnerAlias":{"locationName":"ownerAlias"},"EnablingTime":{"locationName":"enablingTime","type":"timestamp"},"OptimizingTime":{"locationName":"optimizingTime","type":"timestamp"},"EnabledTime":{"locationName":"enabledTime","type":"timestamp"},"DisablingTime":{"locationName":"disablingTime","type":"timestamp"},"DisabledTime":{"locationName":"disabledTime","type":"timestamp"}}}},"Unsuccessful":{"locationName":"unsuccessful","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"FastSnapshotRestoreStateErrors":{"locationName":"fastSnapshotRestoreStateErrorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}}}}},"EnableImage":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableImageBlockPublicAccess":{"input":{"type":"structure","required":["ImageBlockPublicAccessState"],"members":{"ImageBlockPublicAccessState":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageBlockPublicAccessState":{"locationName":"imageBlockPublicAccessState"}}}},"EnableImageDeprecation":{"input":{"type":"structure","required":["ImageId","DeprecateAt"],"members":{"ImageId":{},"DeprecateAt":{"type":"timestamp"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableImageDeregistrationProtection":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"WithCooldown":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return"}}}},"EnableIpamOrganizationAdminAccount":{"input":{"type":"structure","required":["DelegatedAdminAccountId"],"members":{"DryRun":{"type":"boolean"},"DelegatedAdminAccountId":{}}},"output":{"type":"structure","members":{"Success":{"locationName":"success","type":"boolean"}}}},"EnableReachabilityAnalyzerOrganizationSharing":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"returnValue","type":"boolean"}}}},"EnableSerialConsoleAccess":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SerialConsoleAccessEnabled":{"locationName":"serialConsoleAccessEnabled","type":"boolean"}}}},"EnableSnapshotBlockPublicAccess":{"input":{"type":"structure","required":["State"],"members":{"State":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"EnableTransitGatewayRouteTablePropagation":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"},"TransitGatewayRouteTableAnnouncementId":{}}},"output":{"type":"structure","members":{"Propagation":{"shape":"S1w5","locationName":"propagation"}}}},"EnableVgwRoutePropagation":{"input":{"type":"structure","required":["GatewayId","RouteTableId"],"members":{"GatewayId":{},"RouteTableId":{},"DryRun":{"type":"boolean"}}}},"EnableVolumeIO":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}}},"EnableVpcClassicLink":{"input":{"type":"structure","required":["VpcId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcId":{"locationName":"vpcId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"EnableVpcClassicLinkDnsSupport":{"input":{"type":"structure","members":{"VpcId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ExportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CertificateRevocationList":{"locationName":"certificateRevocationList"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}},"ExportClientVpnClientConfiguration":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientConfiguration":{"locationName":"clientConfiguration"}}}},"ExportImage":{"input":{"type":"structure","required":["DiskImageFormat","ImageId","S3ExportLocation"],"members":{"ClientToken":{"idempotencyToken":true},"Description":{},"DiskImageFormat":{},"DryRun":{"type":"boolean"},"ImageId":{},"S3ExportLocation":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3Prefix":{}}},"RoleName":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageFormat":{"locationName":"diskImageFormat"},"ExportImageTaskId":{"locationName":"exportImageTaskId"},"ImageId":{"locationName":"imageId"},"RoleName":{"locationName":"roleName"},"Progress":{"locationName":"progress"},"S3ExportLocation":{"shape":"S14w","locationName":"s3ExportLocation"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"ExportTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","S3Bucket"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"S3Bucket":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"S3Location":{"locationName":"s3Location"}}}},"GetAssociatedEnclaveCertificateIamRoles":{"input":{"type":"structure","required":["CertificateArn"],"members":{"CertificateArn":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AssociatedRoles":{"locationName":"associatedRoleSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatedRoleArn":{"locationName":"associatedRoleArn"},"CertificateS3BucketName":{"locationName":"certificateS3BucketName"},"CertificateS3ObjectKey":{"locationName":"certificateS3ObjectKey"},"EncryptionKmsKeyId":{"locationName":"encryptionKmsKeyId"}}}}}}},"GetAssociatedIpv6PoolCidrs":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Ipv6CidrAssociations":{"locationName":"ipv6CidrAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Cidr":{"locationName":"ipv6Cidr"},"AssociatedResource":{"locationName":"associatedResource"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetAwsNetworkPerformanceData":{"input":{"type":"structure","members":{"DataQueries":{"locationName":"DataQuery","type":"list","member":{"type":"structure","members":{"Id":{},"Source":{},"Destination":{},"Metric":{},"Statistic":{},"Period":{}}}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataResponses":{"locationName":"dataResponseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Id":{"locationName":"id"},"Source":{"locationName":"source"},"Destination":{"locationName":"destination"},"Metric":{"locationName":"metric"},"Statistic":{"locationName":"statistic"},"Period":{"locationName":"period"},"MetricPoints":{"locationName":"metricPointSet","type":"list","member":{"locationName":"item","type":"structure","members":{"StartDate":{"locationName":"startDate","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"Value":{"locationName":"value","type":"float"},"Status":{"locationName":"status"}}}}}}},"NextToken":{"locationName":"nextToken"}}}},"GetCapacityReservationUsage":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservationId":{"locationName":"capacityReservationId"},"InstanceType":{"locationName":"instanceType"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"State":{"locationName":"state"},"InstanceUsages":{"locationName":"instanceUsageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AccountId":{"locationName":"accountId"},"UsedInstanceCount":{"locationName":"usedInstanceCount","type":"integer"}}}}}}},"GetCoipPoolUsage":{"input":{"type":"structure","required":["PoolId"],"members":{"PoolId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CoipPoolId":{"locationName":"coipPoolId"},"CoipAddressUsages":{"locationName":"coipAddressUsageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"CoIp":{"locationName":"coIp"}}}},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"NextToken":{"locationName":"nextToken"}}}},"GetConsoleOutput":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"Latest":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Output":{"locationName":"output"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetConsoleScreenshot":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"WakeUp":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageData":{"locationName":"imageData"},"InstanceId":{"locationName":"instanceId"}}}},"GetDefaultCreditSpecification":{"input":{"type":"structure","required":["InstanceFamily"],"members":{"DryRun":{"type":"boolean"},"InstanceFamily":{}}},"output":{"type":"structure","members":{"InstanceFamilyCreditSpecification":{"shape":"S1zp","locationName":"instanceFamilyCreditSpecification"}}}},"GetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"GetEbsEncryptionByDefault":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"EbsEncryptionByDefault":{"locationName":"ebsEncryptionByDefault","type":"boolean"},"SseType":{"locationName":"sseType"}}}},"GetFlowLogsIntegrationTemplate":{"input":{"type":"structure","required":["FlowLogId","ConfigDeliveryS3DestinationArn","IntegrateServices"],"members":{"DryRun":{"type":"boolean"},"FlowLogId":{},"ConfigDeliveryS3DestinationArn":{},"IntegrateServices":{"locationName":"IntegrateService","type":"structure","members":{"AthenaIntegrations":{"locationName":"AthenaIntegration","type":"list","member":{"locationName":"item","type":"structure","required":["IntegrationResultS3DestinationArn","PartitionLoadFrequency"],"members":{"IntegrationResultS3DestinationArn":{},"PartitionLoadFrequency":{},"PartitionStartDate":{"type":"timestamp"},"PartitionEndDate":{"type":"timestamp"}}}}}}}},"output":{"type":"structure","members":{"Result":{"locationName":"result"}}}},"GetGroupsForCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"CapacityReservationGroups":{"locationName":"capacityReservationGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupArn":{"locationName":"groupArn"},"OwnerId":{"locationName":"ownerId"}}}}}}},"GetHostReservationPurchasePreview":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"HostIdSet":{"shape":"S206"},"OfferingId":{}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S208","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"GetImageBlockPublicAccessState":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ImageBlockPublicAccessState":{"locationName":"imageBlockPublicAccessState"}}}},"GetInstanceMetadataDefaults":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"AccountLevel":{"locationName":"accountLevel","type":"structure","members":{"HttpTokens":{"locationName":"httpTokens"},"HttpPutResponseHopLimit":{"locationName":"httpPutResponseHopLimit","type":"integer"},"HttpEndpoint":{"locationName":"httpEndpoint"},"InstanceMetadataTags":{"locationName":"instanceMetadataTags"}}}}}},"GetInstanceTpmEkPub":{"input":{"type":"structure","required":["InstanceId","KeyType","KeyFormat"],"members":{"InstanceId":{},"KeyType":{},"KeyFormat":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"KeyType":{"locationName":"keyType"},"KeyFormat":{"locationName":"keyFormat"},"KeyValue":{"locationName":"keyValue","type":"string","sensitive":true}}}},"GetInstanceTypesFromInstanceRequirements":{"input":{"type":"structure","required":["ArchitectureTypes","VirtualizationTypes","InstanceRequirements"],"members":{"DryRun":{"type":"boolean"},"ArchitectureTypes":{"shape":"S20m","locationName":"ArchitectureType"},"VirtualizationTypes":{"shape":"S20n","locationName":"VirtualizationType"},"InstanceRequirements":{"shape":"Scu"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceTypes":{"locationName":"instanceTypeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetInstanceUefiData":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"UefiData":{"locationName":"uefiData"}}}},"GetIpamAddressHistory":{"input":{"type":"structure","required":["Cidr","IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"Cidr":{},"IpamScopeId":{},"VpcId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"HistoryRecords":{"locationName":"historyRecordSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"},"ResourceCidr":{"locationName":"resourceCidr"},"ResourceName":{"locationName":"resourceName"},"ResourceComplianceStatus":{"locationName":"resourceComplianceStatus"},"ResourceOverlapStatus":{"locationName":"resourceOverlapStatus"},"VpcId":{"locationName":"vpcId"},"SampledStartTime":{"locationName":"sampledStartTime","type":"timestamp"},"SampledEndTime":{"locationName":"sampledEndTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamDiscoveredAccounts":{"input":{"type":"structure","required":["IpamResourceDiscoveryId","DiscoveryRegion"],"members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryId":{},"DiscoveryRegion":{},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"IpamDiscoveredAccounts":{"locationName":"ipamDiscoveredAccountSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AccountId":{"locationName":"accountId"},"DiscoveryRegion":{"locationName":"discoveryRegion"},"FailureReason":{"locationName":"failureReason","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"LastAttemptedDiscoveryTime":{"locationName":"lastAttemptedDiscoveryTime","type":"timestamp"},"LastSuccessfulDiscoveryTime":{"locationName":"lastSuccessfulDiscoveryTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamDiscoveredPublicAddresses":{"input":{"type":"structure","required":["IpamResourceDiscoveryId","AddressRegion"],"members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryId":{},"AddressRegion":{},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"IpamDiscoveredPublicAddresses":{"locationName":"ipamDiscoveredPublicAddressSet","type":"list","member":{"locationName":"item","type":"structure","members":{"IpamResourceDiscoveryId":{"locationName":"ipamResourceDiscoveryId"},"AddressRegion":{"locationName":"addressRegion"},"Address":{"locationName":"address"},"AddressOwnerId":{"locationName":"addressOwnerId"},"AddressAllocationId":{"locationName":"addressAllocationId"},"AssociationStatus":{"locationName":"associationStatus"},"AddressType":{"locationName":"addressType"},"Service":{"locationName":"service"},"ServiceResource":{"locationName":"serviceResource"},"VpcId":{"locationName":"vpcId"},"SubnetId":{"locationName":"subnetId"},"PublicIpv4PoolId":{"locationName":"publicIpv4PoolId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkInterfaceDescription":{"locationName":"networkInterfaceDescription"},"InstanceId":{"locationName":"instanceId"},"Tags":{"locationName":"tags","type":"structure","members":{"EipTags":{"locationName":"eipTagSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}}}},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"SecurityGroups":{"locationName":"securityGroupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"GroupId":{"locationName":"groupId"}}}},"SampleTime":{"locationName":"sampleTime","type":"timestamp"}}}},"OldestSampleTime":{"locationName":"oldestSampleTime","type":"timestamp"},"NextToken":{"locationName":"nextToken"}}}},"GetIpamDiscoveredResourceCidrs":{"input":{"type":"structure","required":["IpamResourceDiscoveryId","ResourceRegion"],"members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryId":{},"ResourceRegion":{},"Filters":{"shape":"S10d","locationName":"Filter"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"IpamDiscoveredResourceCidrs":{"locationName":"ipamDiscoveredResourceCidrSet","type":"list","member":{"locationName":"item","type":"structure","members":{"IpamResourceDiscoveryId":{"locationName":"ipamResourceDiscoveryId"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceId":{"locationName":"resourceId"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceCidr":{"locationName":"resourceCidr"},"ResourceType":{"locationName":"resourceType"},"ResourceTags":{"shape":"Sg9","locationName":"resourceTagSet"},"IpUsage":{"locationName":"ipUsage","type":"double"},"VpcId":{"locationName":"vpcId"},"SampleTime":{"locationName":"sampleTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamPoolAllocations":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"IpamPoolAllocationId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IpamPoolAllocations":{"locationName":"ipamPoolAllocationSet","type":"list","member":{"shape":"S2l","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamPoolCidrs":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"IpamPoolCidrs":{"locationName":"ipamPoolCidrSet","type":"list","member":{"shape":"Szf","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"GetIpamResourceCidrs":{"input":{"type":"structure","required":["IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"IpamScopeId":{},"IpamPoolId":{},"ResourceId":{},"ResourceType":{},"ResourceTag":{"shape":"Sg0"},"ResourceOwner":{}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"IpamResourceCidrs":{"locationName":"ipamResourceCidrSet","type":"list","member":{"shape":"S21z","locationName":"item"}}}}},"GetLaunchTemplateData":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{}}},"output":{"type":"structure","members":{"LaunchTemplateData":{"shape":"Sij","locationName":"launchTemplateData"}}}},"GetManagedPrefixListAssociations":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PrefixListAssociations":{"locationName":"prefixListAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceId":{"locationName":"resourceId"},"ResourceOwner":{"locationName":"resourceOwner"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetManagedPrefixListEntries":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"TargetVersion":{"type":"long"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"Cidr":{"locationName":"cidr"},"Description":{"locationName":"description"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetNetworkInsightsAccessScopeAnalysisFindings":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeAnalysisId"],"members":{"NetworkInsightsAccessScopeAnalysisId":{},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"},"AnalysisStatus":{"locationName":"analysisStatus"},"AnalysisFindings":{"locationName":"analysisFindingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"},"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"FindingId":{"locationName":"findingId"},"FindingComponents":{"shape":"S1j3","locationName":"findingComponentSet"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetNetworkInsightsAccessScopeContent":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeId"],"members":{"NetworkInsightsAccessScopeId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeContent":{"shape":"Sl6","locationName":"networkInsightsAccessScopeContent"}}}},"GetPasswordData":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"PasswordData":{"locationName":"passwordData","type":"string","sensitive":true},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}}},"GetReservedInstancesExchangeQuote":{"input":{"type":"structure","required":["ReservedInstanceIds"],"members":{"DryRun":{"type":"boolean"},"ReservedInstanceIds":{"shape":"Se","locationName":"ReservedInstanceId"},"TargetConfigurations":{"shape":"Sg","locationName":"TargetConfiguration"}}},"output":{"type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"IsValidExchange":{"locationName":"isValidExchange","type":"boolean"},"OutputReservedInstancesWillExpireAt":{"locationName":"outputReservedInstancesWillExpireAt","type":"timestamp"},"PaymentDue":{"locationName":"paymentDue"},"ReservedInstanceValueRollup":{"shape":"S22o","locationName":"reservedInstanceValueRollup"},"ReservedInstanceValueSet":{"locationName":"reservedInstanceValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S22o","locationName":"reservationValue"},"ReservedInstanceId":{"locationName":"reservedInstanceId"}}}},"TargetConfigurationValueRollup":{"shape":"S22o","locationName":"targetConfigurationValueRollup"},"TargetConfigurationValueSet":{"locationName":"targetConfigurationValueSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ReservationValue":{"shape":"S22o","locationName":"reservationValue"},"TargetConfiguration":{"locationName":"targetConfiguration","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"OfferingId":{"locationName":"offeringId"}}}}}},"ValidationFailureReason":{"locationName":"validationFailureReason"}}}},"GetSecurityGroupsForVpc":{"input":{"type":"structure","required":["VpcId"],"members":{"VpcId":{},"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S10d","locationName":"Filter"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NextToken":{"locationName":"nextToken"},"SecurityGroupForVpcs":{"locationName":"securityGroupForVpcSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"GroupName":{"locationName":"groupName"},"OwnerId":{"locationName":"ownerId"},"GroupId":{"locationName":"groupId"},"Tags":{"shape":"S6","locationName":"tagSet"},"PrimaryVpcId":{"locationName":"primaryVpcId"}}}}}}},"GetSerialConsoleAccessStatus":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SerialConsoleAccessEnabled":{"locationName":"serialConsoleAccessEnabled","type":"boolean"}}}},"GetSnapshotBlockPublicAccessState":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"State":{"locationName":"state"}}}},"GetSpotPlacementScores":{"input":{"type":"structure","required":["TargetCapacity"],"members":{"InstanceTypes":{"locationName":"InstanceType","type":"list","member":{}},"TargetCapacity":{"type":"integer"},"TargetCapacityUnitType":{},"SingleAvailabilityZone":{"type":"boolean"},"RegionNames":{"locationName":"RegionName","type":"list","member":{}},"InstanceRequirementsWithMetadata":{"type":"structure","members":{"ArchitectureTypes":{"shape":"S20m","locationName":"ArchitectureType"},"VirtualizationTypes":{"shape":"S20n","locationName":"VirtualizationType"},"InstanceRequirements":{"shape":"Scu"}}},"DryRun":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SpotPlacementScores":{"locationName":"spotPlacementScoreSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Region":{"locationName":"region"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"Score":{"locationName":"score","type":"integer"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetSubnetCidrReservations":{"input":{"type":"structure","required":["SubnetId"],"members":{"Filters":{"shape":"S10d","locationName":"Filter"},"SubnetId":{},"DryRun":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"SubnetIpv4CidrReservations":{"shape":"S23f","locationName":"subnetIpv4CidrReservationSet"},"SubnetIpv6CidrReservations":{"shape":"S23f","locationName":"subnetIpv6CidrReservationSet"},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayAttachmentPropagations":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayAttachmentPropagations":{"locationName":"transitGatewayAttachmentPropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayMulticastDomainAssociations":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId"],"members":{"TransitGatewayMulticastDomainId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MulticastDomainAssociations":{"locationName":"multicastDomainAssociations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"Subnet":{"shape":"St","locationName":"subnet"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayPolicyTableAssociations":{"input":{"type":"structure","required":["TransitGatewayPolicyTableId"],"members":{"TransitGatewayPolicyTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"locationName":"associations","type":"list","member":{"shape":"S5c","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayPolicyTableEntries":{"input":{"type":"structure","required":["TransitGatewayPolicyTableId"],"members":{"TransitGatewayPolicyTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPolicyTableEntries":{"locationName":"transitGatewayPolicyTableEntries","type":"list","member":{"locationName":"item","type":"structure","members":{"PolicyRuleNumber":{"locationName":"policyRuleNumber"},"PolicyRule":{"locationName":"policyRule","type":"structure","members":{"SourceCidrBlock":{"locationName":"sourceCidrBlock"},"SourcePortRange":{"locationName":"sourcePortRange"},"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationPortRange":{"locationName":"destinationPortRange"},"Protocol":{"locationName":"protocol"},"MetaData":{"locationName":"metaData","type":"structure","members":{"MetaDataKey":{"locationName":"metaDataKey"},"MetaDataValue":{"locationName":"metaDataValue"}}}}},"TargetRouteTableId":{"locationName":"targetRouteTableId"}}}}}}},"GetTransitGatewayPrefixListReferences":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReferences":{"locationName":"transitGatewayPrefixListReferenceSet","type":"list","member":{"shape":"Sq9","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTableAssociations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"locationName":"associations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetTransitGatewayRouteTablePropagations":{"input":{"type":"structure","required":["TransitGatewayRouteTableId"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayRouteTablePropagations":{"locationName":"transitGatewayRouteTablePropagations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"},"TransitGatewayRouteTableAnnouncementId":{"locationName":"transitGatewayRouteTableAnnouncementId"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetVerifiedAccessEndpointPolicy":{"input":{"type":"structure","required":["VerifiedAccessEndpointId"],"members":{"VerifiedAccessEndpointId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"PolicyEnabled":{"locationName":"policyEnabled","type":"boolean"},"PolicyDocument":{"locationName":"policyDocument"}}}},"GetVerifiedAccessGroupPolicy":{"input":{"type":"structure","required":["VerifiedAccessGroupId"],"members":{"VerifiedAccessGroupId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"PolicyEnabled":{"locationName":"policyEnabled","type":"boolean"},"PolicyDocument":{"locationName":"policyDocument"}}}},"GetVpnConnectionDeviceSampleConfiguration":{"input":{"type":"structure","required":["VpnConnectionId","VpnConnectionDeviceTypeId"],"members":{"VpnConnectionId":{},"VpnConnectionDeviceTypeId":{},"InternetKeyExchangeVersion":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnectionDeviceSampleConfiguration":{"locationName":"vpnConnectionDeviceSampleConfiguration","type":"string","sensitive":true}}}},"GetVpnConnectionDeviceTypes":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnectionDeviceTypes":{"locationName":"vpnConnectionDeviceTypeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"VpnConnectionDeviceTypeId":{"locationName":"vpnConnectionDeviceTypeId"},"Vendor":{"locationName":"vendor"},"Platform":{"locationName":"platform"},"Software":{"locationName":"software"}}}},"NextToken":{"locationName":"nextToken"}}}},"GetVpnTunnelReplacementStatus":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnectionId":{"locationName":"vpnConnectionId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"VpnGatewayId":{"locationName":"vpnGatewayId"},"VpnTunnelOutsideIpAddress":{"locationName":"vpnTunnelOutsideIpAddress"},"MaintenanceDetails":{"locationName":"maintenanceDetails","type":"structure","members":{"PendingMaintenance":{"locationName":"pendingMaintenance"},"MaintenanceAutoAppliedAfter":{"locationName":"maintenanceAutoAppliedAfter","type":"timestamp"},"LastMaintenanceApplied":{"locationName":"lastMaintenanceApplied","type":"timestamp"}}}}}},"ImportClientVpnClientCertificateRevocationList":{"input":{"type":"structure","required":["ClientVpnEndpointId","CertificateRevocationList"],"members":{"ClientVpnEndpointId":{},"CertificateRevocationList":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ImportImage":{"input":{"type":"structure","members":{"Architecture":{},"ClientData":{"shape":"S24r"},"ClientToken":{},"Description":{},"DiskContainers":{"locationName":"DiskContainer","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{},"DeviceName":{},"Format":{},"SnapshotId":{},"Url":{"shape":"S18v"},"UserBucket":{"shape":"S24u"}}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Hypervisor":{},"KmsKeyId":{},"LicenseType":{},"Platform":{},"RoleName":{},"LicenseSpecifications":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"UsageOperation":{},"BootMode":{}}},"output":{"type":"structure","members":{"Architecture":{"locationName":"architecture"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"ImageId":{"locationName":"imageId"},"ImportTaskId":{"locationName":"importTaskId"},"KmsKeyId":{"locationName":"kmsKeyId"},"LicenseType":{"locationName":"licenseType"},"Platform":{"locationName":"platform"},"Progress":{"locationName":"progress"},"SnapshotDetails":{"shape":"S18t","locationName":"snapshotDetailSet"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"LicenseSpecifications":{"shape":"S18x","locationName":"licenseSpecifications"},"Tags":{"shape":"S6","locationName":"tagSet"},"UsageOperation":{"locationName":"usageOperation"}}}},"ImportInstance":{"input":{"type":"structure","required":["Platform"],"members":{"Description":{"locationName":"description"},"DiskImages":{"locationName":"diskImage","type":"list","member":{"type":"structure","members":{"Description":{},"Image":{"shape":"S251"},"Volume":{"shape":"S252"}}}},"DryRun":{"locationName":"dryRun","type":"boolean"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"AdditionalInfo":{"locationName":"additionalInfo"},"Architecture":{"locationName":"architecture"},"GroupIds":{"shape":"Sgz","locationName":"GroupId"},"GroupNames":{"shape":"Shn","locationName":"GroupName"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"locationName":"instanceType"},"Monitoring":{"locationName":"monitoring","type":"boolean"},"Placement":{"shape":"Scr","locationName":"placement"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"SubnetId":{"locationName":"subnetId"},"UserData":{"locationName":"userData","type":"structure","members":{"Data":{"locationName":"data"}},"sensitive":true}}},"Platform":{"locationName":"platform"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"S13s","locationName":"conversionTask"}}}},"ImportKeyPair":{"input":{"type":"structure","required":["KeyName","PublicKeyMaterial"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"KeyName":{"locationName":"keyName"},"PublicKeyMaterial":{"locationName":"publicKeyMaterial","type":"blob"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"KeyFingerprint":{"locationName":"keyFingerprint"},"KeyName":{"locationName":"keyName"},"KeyPairId":{"locationName":"keyPairId"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"ImportSnapshot":{"input":{"type":"structure","members":{"ClientData":{"shape":"S24r"},"ClientToken":{},"Description":{},"DiskContainer":{"type":"structure","members":{"Description":{},"Format":{},"Url":{"shape":"S18v"},"UserBucket":{"shape":"S24u"}}},"DryRun":{"type":"boolean"},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"RoleName":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"Description":{"locationName":"description"},"ImportTaskId":{"locationName":"importTaskId"},"SnapshotTaskDetail":{"shape":"S195","locationName":"snapshotTaskDetail"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"ImportVolume":{"input":{"type":"structure","required":["AvailabilityZone","Image","Volume"],"members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Image":{"shape":"S251","locationName":"image"},"Volume":{"shape":"S252","locationName":"volume"}}},"output":{"type":"structure","members":{"ConversionTask":{"shape":"S13s","locationName":"conversionTask"}}}},"ListImagesInRecycleBin":{"input":{"type":"structure","members":{"ImageIds":{"shape":"S18a","locationName":"ImageId"},"NextToken":{},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Images":{"locationName":"imageSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ImageId":{"locationName":"imageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"RecycleBinEnterTime":{"locationName":"recycleBinEnterTime","type":"timestamp"},"RecycleBinExitTime":{"locationName":"recycleBinExitTime","type":"timestamp"}}}},"NextToken":{"locationName":"nextToken"}}}},"ListSnapshotsInRecycleBin":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"SnapshotIds":{"shape":"S1ho","locationName":"SnapshotId"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Snapshots":{"locationName":"snapshotSet","type":"list","member":{"locationName":"item","type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"RecycleBinEnterTime":{"locationName":"recycleBinEnterTime","type":"timestamp"},"RecycleBinExitTime":{"locationName":"recycleBinExitTime","type":"timestamp"},"Description":{"locationName":"description"},"VolumeId":{"locationName":"volumeId"}}}},"NextToken":{"locationName":"nextToken"}}}},"LockSnapshot":{"input":{"type":"structure","required":["SnapshotId","LockMode"],"members":{"SnapshotId":{},"DryRun":{"type":"boolean"},"LockMode":{},"CoolOffPeriod":{"type":"integer"},"LockDuration":{"type":"integer"},"ExpirationDate":{"type":"timestamp"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"LockState":{"locationName":"lockState"},"LockDuration":{"locationName":"lockDuration","type":"integer"},"CoolOffPeriod":{"locationName":"coolOffPeriod","type":"integer"},"CoolOffPeriodExpiresOn":{"locationName":"coolOffPeriodExpiresOn","type":"timestamp"},"LockCreatedOn":{"locationName":"lockCreatedOn","type":"timestamp"},"LockExpiresOn":{"locationName":"lockExpiresOn","type":"timestamp"},"LockDurationStartTime":{"locationName":"lockDurationStartTime","type":"timestamp"}}}},"ModifyAddressAttribute":{"input":{"type":"structure","required":["AllocationId"],"members":{"AllocationId":{},"DomainName":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Address":{"shape":"S10q","locationName":"address"}}}},"ModifyAvailabilityZoneGroup":{"input":{"type":"structure","required":["GroupName","OptInStatus"],"members":{"GroupName":{},"OptInStatus":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyCapacityReservation":{"input":{"type":"structure","required":["CapacityReservationId"],"members":{"CapacityReservationId":{},"InstanceCount":{"type":"integer"},"EndDate":{"type":"timestamp"},"EndDateType":{},"Accept":{"type":"boolean"},"DryRun":{"type":"boolean"},"AdditionalInfo":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyCapacityReservationFleet":{"input":{"type":"structure","required":["CapacityReservationFleetId"],"members":{"CapacityReservationFleetId":{},"TotalTargetCapacity":{"type":"integer"},"EndDate":{"type":"timestamp"},"DryRun":{"type":"boolean"},"RemoveEndDate":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyClientVpnEndpoint":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ServerCertificateArn":{},"ConnectionLogOptions":{"shape":"Saq"},"DnsServers":{"type":"structure","members":{"CustomDnsServers":{"shape":"So"},"Enabled":{"type":"boolean"}}},"VpnPort":{"type":"integer"},"Description":{},"SplitTunnel":{"type":"boolean"},"DryRun":{"type":"boolean"},"SecurityGroupIds":{"shape":"S2r","locationName":"SecurityGroupId"},"VpcId":{},"SelfServicePortal":{},"ClientConnectOptions":{"shape":"Sat"},"SessionTimeoutHours":{"type":"integer"},"ClientLoginBannerOptions":{"shape":"Sau"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyDefaultCreditSpecification":{"input":{"type":"structure","required":["InstanceFamily","CpuCredits"],"members":{"DryRun":{"type":"boolean"},"InstanceFamily":{},"CpuCredits":{}}},"output":{"type":"structure","members":{"InstanceFamilyCreditSpecification":{"shape":"S1zp","locationName":"instanceFamilyCreditSpecification"}}}},"ModifyEbsDefaultKmsKeyId":{"input":{"type":"structure","required":["KmsKeyId"],"members":{"KmsKeyId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ModifyFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"DryRun":{"type":"boolean"},"ExcessCapacityTerminationPolicy":{},"LaunchTemplateConfigs":{"shape":"Sck","locationName":"LaunchTemplateConfig"},"FleetId":{},"TargetCapacitySpecification":{"shape":"Sdn"},"Context":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{},"OperationType":{},"UserIds":{"shape":"S26c","locationName":"UserId"},"UserGroups":{"shape":"S26d","locationName":"UserGroup"},"ProductCodes":{"shape":"S26e","locationName":"ProductCode"},"LoadPermission":{"type":"structure","members":{"Add":{"shape":"S26g"},"Remove":{"shape":"S26g"}}},"Description":{},"Name":{}}},"output":{"type":"structure","members":{"FpgaImageAttribute":{"shape":"S16j","locationName":"fpgaImageAttribute"}}}},"ModifyHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"AutoPlacement":{"locationName":"autoPlacement"},"HostIds":{"shape":"S17g","locationName":"hostId"},"HostRecovery":{},"InstanceType":{},"InstanceFamily":{},"HostMaintenance":{}}},"output":{"type":"structure","members":{"Successful":{"shape":"S2f","locationName":"successful"},"Unsuccessful":{"shape":"S26l","locationName":"unsuccessful"}}}},"ModifyIdFormat":{"input":{"type":"structure","required":["Resource","UseLongIds"],"members":{"Resource":{},"UseLongIds":{"type":"boolean"}}}},"ModifyIdentityIdFormat":{"input":{"type":"structure","required":["PrincipalArn","Resource","UseLongIds"],"members":{"PrincipalArn":{"locationName":"principalArn"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"ModifyImageAttribute":{"input":{"type":"structure","required":["ImageId"],"members":{"Attribute":{},"Description":{"shape":"Sc1"},"ImageId":{},"LaunchPermission":{"type":"structure","members":{"Add":{"shape":"S186"},"Remove":{"shape":"S186"}}},"OperationType":{},"ProductCodes":{"shape":"S26e","locationName":"ProductCode"},"UserGroups":{"shape":"S26d","locationName":"UserGroup"},"UserIds":{"shape":"S26c","locationName":"UserId"},"Value":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"OrganizationArns":{"locationName":"OrganizationArn","type":"list","member":{"locationName":"OrganizationArn"}},"OrganizationalUnitArns":{"locationName":"OrganizationalUnitArn","type":"list","member":{"locationName":"OrganizationalUnitArn"}},"ImdsSupport":{"shape":"Sc1"}}}},"ModifyInstanceAttribute":{"input":{"type":"structure","required":["InstanceId"],"members":{"SourceDestCheck":{"shape":"S19c"},"Attribute":{"locationName":"attribute"},"BlockDeviceMappings":{"locationName":"blockDeviceMapping","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"VolumeId":{"locationName":"volumeId"}}},"NoDevice":{"locationName":"noDevice"},"VirtualName":{"locationName":"virtualName"}}}},"DisableApiTermination":{"shape":"S19c","locationName":"disableApiTermination"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"shape":"S19c","locationName":"ebsOptimized"},"EnaSupport":{"shape":"S19c","locationName":"enaSupport"},"Groups":{"shape":"S5v","locationName":"GroupId"},"InstanceId":{"locationName":"instanceId"},"InstanceInitiatedShutdownBehavior":{"shape":"Sc1","locationName":"instanceInitiatedShutdownBehavior"},"InstanceType":{"shape":"Sc1","locationName":"instanceType"},"Kernel":{"shape":"Sc1","locationName":"kernel"},"Ramdisk":{"shape":"Sc1","locationName":"ramdisk"},"SriovNetSupport":{"shape":"Sc1","locationName":"sriovNetSupport"},"UserData":{"locationName":"userData","type":"structure","members":{"Value":{"locationName":"value","type":"blob"}}},"Value":{"locationName":"value"},"DisableApiStop":{"shape":"S19c"}}}},"ModifyInstanceCapacityReservationAttributes":{"input":{"type":"structure","required":["InstanceId","CapacityReservationSpecification"],"members":{"InstanceId":{},"CapacityReservationSpecification":{"shape":"S26y"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyInstanceCreditSpecification":{"input":{"type":"structure","required":["InstanceCreditSpecifications"],"members":{"DryRun":{"type":"boolean"},"ClientToken":{},"InstanceCreditSpecifications":{"locationName":"InstanceCreditSpecification","type":"list","member":{"locationName":"item","type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"CpuCredits":{}}}}}},"output":{"type":"structure","members":{"SuccessfulInstanceCreditSpecifications":{"locationName":"successfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"}}}},"UnsuccessfulInstanceCreditSpecifications":{"locationName":"unsuccessfulInstanceCreditSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}}}}},"ModifyInstanceEventStartTime":{"input":{"type":"structure","required":["InstanceId","InstanceEventId","NotBefore"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"InstanceEventId":{},"NotBefore":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Event":{"shape":"S19z","locationName":"event"}}}},"ModifyInstanceEventWindow":{"input":{"type":"structure","required":["InstanceEventWindowId"],"members":{"DryRun":{"type":"boolean"},"Name":{},"InstanceEventWindowId":{},"TimeRanges":{"shape":"Sf6","locationName":"TimeRange"},"CronExpression":{}}},"output":{"type":"structure","members":{"InstanceEventWindow":{"shape":"S47","locationName":"instanceEventWindow"}}}},"ModifyInstanceMaintenanceOptions":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoRecovery":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"AutoRecovery":{"locationName":"autoRecovery"}}}},"ModifyInstanceMetadataDefaults":{"input":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"InstanceMetadataTags":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyInstanceMetadataOptions":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"DryRun":{"type":"boolean"},"HttpProtocolIpv6":{},"InstanceMetadataTags":{}}},"output":{"type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceMetadataOptions":{"shape":"S1f7","locationName":"instanceMetadataOptions"}}}},"ModifyInstancePlacement":{"input":{"type":"structure","required":["InstanceId"],"members":{"Affinity":{"locationName":"affinity"},"GroupName":{},"HostId":{"locationName":"hostId"},"InstanceId":{"locationName":"instanceId"},"Tenancy":{"locationName":"tenancy"},"PartitionNumber":{"type":"integer"},"HostResourceGroupArn":{},"GroupId":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyIpam":{"input":{"type":"structure","required":["IpamId"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Description":{},"AddOperatingRegions":{"shape":"Sfn","locationName":"AddOperatingRegion"},"RemoveOperatingRegions":{"shape":"S27s","locationName":"RemoveOperatingRegion"},"Tier":{}}},"output":{"type":"structure","members":{"Ipam":{"shape":"Sfr","locationName":"ipam"}}}},"ModifyIpamPool":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Description":{},"AutoImport":{"type":"boolean"},"AllocationMinNetmaskLength":{"type":"integer"},"AllocationMaxNetmaskLength":{"type":"integer"},"AllocationDefaultNetmaskLength":{"type":"integer"},"ClearAllocationDefaultNetmaskLength":{"type":"boolean"},"AddAllocationResourceTags":{"shape":"Sfz","locationName":"AddAllocationResourceTag"},"RemoveAllocationResourceTags":{"shape":"Sfz","locationName":"RemoveAllocationResourceTag"}}},"output":{"type":"structure","members":{"IpamPool":{"shape":"Sg6","locationName":"ipamPool"}}}},"ModifyIpamResourceCidr":{"input":{"type":"structure","required":["ResourceId","ResourceCidr","ResourceRegion","CurrentIpamScopeId","Monitored"],"members":{"DryRun":{"type":"boolean"},"ResourceId":{},"ResourceCidr":{},"ResourceRegion":{},"CurrentIpamScopeId":{},"DestinationIpamScopeId":{},"Monitored":{"type":"boolean"}}},"output":{"type":"structure","members":{"IpamResourceCidr":{"shape":"S21z","locationName":"ipamResourceCidr"}}}},"ModifyIpamResourceDiscovery":{"input":{"type":"structure","required":["IpamResourceDiscoveryId"],"members":{"DryRun":{"type":"boolean"},"IpamResourceDiscoveryId":{},"Description":{},"AddOperatingRegions":{"shape":"Sfn","locationName":"AddOperatingRegion"},"RemoveOperatingRegions":{"shape":"S27s","locationName":"RemoveOperatingRegion"}}},"output":{"type":"structure","members":{"IpamResourceDiscovery":{"shape":"Sge","locationName":"ipamResourceDiscovery"}}}},"ModifyIpamScope":{"input":{"type":"structure","required":["IpamScopeId"],"members":{"DryRun":{"type":"boolean"},"IpamScopeId":{},"Description":{}}},"output":{"type":"structure","members":{"IpamScope":{"shape":"Sgi","locationName":"ipamScope"}}}},"ModifyLaunchTemplate":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"ClientToken":{},"LaunchTemplateId":{},"LaunchTemplateName":{},"DefaultVersion":{"locationName":"SetDefaultVersion"}}},"output":{"type":"structure","members":{"LaunchTemplate":{"shape":"Sic","locationName":"launchTemplate"}}}},"ModifyLocalGatewayRoute":{"input":{"type":"structure","required":["LocalGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"LocalGatewayRouteTableId":{},"LocalGatewayVirtualInterfaceGroupId":{},"NetworkInterfaceId":{},"DryRun":{"type":"boolean"},"DestinationPrefixListId":{}}},"output":{"type":"structure","members":{"Route":{"shape":"Sjo","locationName":"route"}}}},"ModifyManagedPrefixList":{"input":{"type":"structure","required":["PrefixListId"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"CurrentVersion":{"type":"long"},"PrefixListName":{},"AddEntries":{"shape":"Sk6","locationName":"AddEntry"},"RemoveEntries":{"locationName":"RemoveEntry","type":"list","member":{"type":"structure","required":["Cidr"],"members":{"Cidr":{}}}},"MaxEntries":{"type":"integer"}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sk9","locationName":"prefixList"}}}},"ModifyNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"}}},"Description":{"shape":"Sc1","locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Groups":{"shape":"Sgz","locationName":"SecurityGroupId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"shape":"S19c","locationName":"sourceDestCheck"},"EnaSrdSpecification":{"shape":"S60"},"EnablePrimaryIpv6":{"type":"boolean"},"ConnectionTrackingSpecification":{"shape":"Sha"},"AssociatePublicIpAddress":{"type":"boolean"}}}},"ModifyPrivateDnsNameOptions":{"input":{"type":"structure","required":["InstanceId"],"members":{"DryRun":{"type":"boolean"},"InstanceId":{},"PrivateDnsHostnameType":{},"EnableResourceNameDnsARecord":{"type":"boolean"},"EnableResourceNameDnsAAAARecord":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyReservedInstances":{"input":{"type":"structure","required":["ReservedInstancesIds","TargetConfigurations"],"members":{"ReservedInstancesIds":{"shape":"S1lh","locationName":"ReservedInstancesId"},"ClientToken":{"locationName":"clientToken"},"TargetConfigurations":{"locationName":"ReservedInstancesConfigurationSetItemType","type":"list","member":{"shape":"S1m3","locationName":"item"}}}},"output":{"type":"structure","members":{"ReservedInstancesModificationId":{"locationName":"reservedInstancesModificationId"}}}},"ModifySecurityGroupRules":{"input":{"type":"structure","required":["GroupId","SecurityGroupRules"],"members":{"GroupId":{},"SecurityGroupRules":{"locationName":"SecurityGroupRule","type":"list","member":{"locationName":"item","type":"structure","required":["SecurityGroupRuleId"],"members":{"SecurityGroupRuleId":{},"SecurityGroupRule":{"type":"structure","members":{"IpProtocol":{},"FromPort":{"type":"integer"},"ToPort":{"type":"integer"},"CidrIpv4":{},"CidrIpv6":{},"PrefixListId":{},"ReferencedGroupId":{},"Description":{}}}}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySnapshotAttribute":{"input":{"type":"structure","required":["SnapshotId"],"members":{"Attribute":{},"CreateVolumePermission":{"type":"structure","members":{"Add":{"shape":"S1nh"},"Remove":{"shape":"S1nh"}}},"GroupNames":{"shape":"S1n9","locationName":"UserGroup"},"OperationType":{},"SnapshotId":{},"UserIds":{"shape":"S26c","locationName":"UserId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifySnapshotTier":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"StorageTier":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"TieringStartTime":{"locationName":"tieringStartTime","type":"timestamp"}}}},"ModifySpotFleetRequest":{"input":{"type":"structure","required":["SpotFleetRequestId"],"members":{"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"LaunchTemplateConfigs":{"shape":"S1oo","locationName":"LaunchTemplateConfig"},"SpotFleetRequestId":{"locationName":"spotFleetRequestId"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"type":"integer"},"Context":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifySubnetAttribute":{"input":{"type":"structure","required":["SubnetId"],"members":{"AssignIpv6AddressOnCreation":{"shape":"S19c"},"MapPublicIpOnLaunch":{"shape":"S19c"},"SubnetId":{"locationName":"subnetId"},"MapCustomerOwnedIpOnLaunch":{"shape":"S19c"},"CustomerOwnedIpv4Pool":{},"EnableDns64":{"shape":"S19c"},"PrivateDnsHostnameTypeOnLaunch":{},"EnableResourceNameDnsARecordOnLaunch":{"shape":"S19c"},"EnableResourceNameDnsAAAARecordOnLaunch":{"shape":"S19c"},"EnableLniAtDeviceIndex":{"type":"integer"},"DisableLniAtDeviceIndex":{"shape":"S19c"}}}},"ModifyTrafficMirrorFilterNetworkServices":{"input":{"type":"structure","required":["TrafficMirrorFilterId"],"members":{"TrafficMirrorFilterId":{},"AddNetworkServices":{"shape":"Soj","locationName":"AddNetworkService"},"RemoveNetworkServices":{"shape":"Soj","locationName":"RemoveNetworkService"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilter":{"shape":"Sod","locationName":"trafficMirrorFilter"}}}},"ModifyTrafficMirrorFilterRule":{"input":{"type":"structure","required":["TrafficMirrorFilterRuleId"],"members":{"TrafficMirrorFilterRuleId":{},"TrafficDirection":{},"RuleNumber":{"type":"integer"},"RuleAction":{},"DestinationPortRange":{"shape":"Son"},"SourcePortRange":{"shape":"Son"},"Protocol":{"type":"integer"},"DestinationCidrBlock":{},"SourceCidrBlock":{},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorFilterRule":{"shape":"Sof","locationName":"trafficMirrorFilterRule"}}}},"ModifyTrafficMirrorSession":{"input":{"type":"structure","required":["TrafficMirrorSessionId"],"members":{"TrafficMirrorSessionId":{},"TrafficMirrorTargetId":{},"TrafficMirrorFilterId":{},"PacketLength":{"type":"integer"},"SessionNumber":{"type":"integer"},"VirtualNetworkId":{"type":"integer"},"Description":{},"RemoveFields":{"locationName":"RemoveField","type":"list","member":{}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TrafficMirrorSession":{"shape":"Sos","locationName":"trafficMirrorSession"}}}},"ModifyTransitGateway":{"input":{"type":"structure","required":["TransitGatewayId"],"members":{"TransitGatewayId":{},"Description":{},"Options":{"type":"structure","members":{"AddTransitGatewayCidrBlocks":{"shape":"Sp4"},"RemoveTransitGatewayCidrBlocks":{"shape":"Sp4"},"VpnEcmpSupport":{},"DnsSupport":{},"SecurityGroupReferencingSupport":{},"AutoAcceptSharedAttachments":{},"DefaultRouteTableAssociation":{},"AssociationDefaultRouteTableId":{},"DefaultRouteTablePropagation":{},"PropagationDefaultRouteTableId":{},"AmazonSideAsn":{"type":"long"}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGateway":{"shape":"Sp6","locationName":"transitGateway"}}}},"ModifyTransitGatewayPrefixListReference":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","PrefixListId"],"members":{"TransitGatewayRouteTableId":{},"PrefixListId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPrefixListReference":{"shape":"Sq9","locationName":"transitGatewayPrefixListReference"}}}},"ModifyTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"AddSubnetIds":{"shape":"S57"},"RemoveSubnetIds":{"shape":"S57"},"Options":{"type":"structure","members":{"DnsSupport":{},"SecurityGroupReferencingSupport":{},"Ipv6Support":{},"ApplianceModeSupport":{}}},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"S16","locationName":"transitGatewayVpcAttachment"}}}},"ModifyVerifiedAccessEndpoint":{"input":{"type":"structure","required":["VerifiedAccessEndpointId"],"members":{"VerifiedAccessEndpointId":{},"VerifiedAccessGroupId":{},"LoadBalancerOptions":{"type":"structure","members":{"SubnetIds":{"locationName":"SubnetId","type":"list","member":{"locationName":"item"}},"Protocol":{},"Port":{"type":"integer"}}},"NetworkInterfaceOptions":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"}}},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessEndpoint":{"shape":"Sra","locationName":"verifiedAccessEndpoint"}}}},"ModifyVerifiedAccessEndpointPolicy":{"input":{"type":"structure","required":["VerifiedAccessEndpointId"],"members":{"VerifiedAccessEndpointId":{},"PolicyEnabled":{"type":"boolean"},"PolicyDocument":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SseSpecification":{"shape":"Sr8"}}},"output":{"type":"structure","members":{"PolicyEnabled":{"locationName":"policyEnabled","type":"boolean"},"PolicyDocument":{"locationName":"policyDocument"},"SseSpecification":{"shape":"S6e","locationName":"sseSpecification"}}}},"ModifyVerifiedAccessGroup":{"input":{"type":"structure","required":["VerifiedAccessGroupId"],"members":{"VerifiedAccessGroupId":{},"VerifiedAccessInstanceId":{},"Description":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VerifiedAccessGroup":{"shape":"Sri","locationName":"verifiedAccessGroup"}}}},"ModifyVerifiedAccessGroupPolicy":{"input":{"type":"structure","required":["VerifiedAccessGroupId"],"members":{"VerifiedAccessGroupId":{},"PolicyEnabled":{"type":"boolean"},"PolicyDocument":{},"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"SseSpecification":{"shape":"Sr8"}}},"output":{"type":"structure","members":{"PolicyEnabled":{"locationName":"policyEnabled","type":"boolean"},"PolicyDocument":{"locationName":"policyDocument"},"SseSpecification":{"shape":"S6e","locationName":"sseSpecification"}}}},"ModifyVerifiedAccessInstance":{"input":{"type":"structure","required":["VerifiedAccessInstanceId"],"members":{"VerifiedAccessInstanceId":{},"Description":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"VerifiedAccessInstance":{"shape":"S6g","locationName":"verifiedAccessInstance"}}}},"ModifyVerifiedAccessInstanceLoggingConfiguration":{"input":{"type":"structure","required":["VerifiedAccessInstanceId","AccessLogs"],"members":{"VerifiedAccessInstanceId":{},"AccessLogs":{"type":"structure","members":{"S3":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"BucketName":{},"Prefix":{},"BucketOwner":{}}},"CloudWatchLogs":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"LogGroup":{}}},"KinesisDataFirehose":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"DeliveryStream":{}}},"LogVersion":{},"IncludeTrustContext":{"type":"boolean"}}},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S1s4","locationName":"loggingConfiguration"}}}},"ModifyVerifiedAccessTrustProvider":{"input":{"type":"structure","required":["VerifiedAccessTrustProviderId"],"members":{"VerifiedAccessTrustProviderId":{},"OidcOptions":{"type":"structure","members":{"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"ClientId":{},"ClientSecret":{"shape":"S6c"},"Scope":{}}},"DeviceOptions":{"type":"structure","members":{"PublicSigningKeyUrl":{}}},"Description":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"SseSpecification":{"shape":"Sr8"}}},"output":{"type":"structure","members":{"VerifiedAccessTrustProvider":{"shape":"S67","locationName":"verifiedAccessTrustProvider"}}}},"ModifyVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"DryRun":{"type":"boolean"},"VolumeId":{},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"},"Throughput":{"type":"integer"},"MultiAttachEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"VolumeModification":{"shape":"S1t8","locationName":"volumeModification"}}}},"ModifyVolumeAttribute":{"input":{"type":"structure","required":["VolumeId"],"members":{"AutoEnableIO":{"shape":"S19c"},"VolumeId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ModifyVpcAttribute":{"input":{"type":"structure","required":["VpcId"],"members":{"EnableDnsHostnames":{"shape":"S19c"},"EnableDnsSupport":{"shape":"S19c"},"VpcId":{"locationName":"vpcId"},"EnableNetworkAddressUsageMetrics":{"shape":"S19c"}}}},"ModifyVpcEndpoint":{"input":{"type":"structure","required":["VpcEndpointId"],"members":{"DryRun":{"type":"boolean"},"VpcEndpointId":{},"ResetPolicy":{"type":"boolean"},"PolicyDocument":{},"AddRouteTableIds":{"shape":"Srx","locationName":"AddRouteTableId"},"RemoveRouteTableIds":{"shape":"Srx","locationName":"RemoveRouteTableId"},"AddSubnetIds":{"shape":"Sry","locationName":"AddSubnetId"},"RemoveSubnetIds":{"shape":"Sry","locationName":"RemoveSubnetId"},"AddSecurityGroupIds":{"shape":"Srz","locationName":"AddSecurityGroupId"},"RemoveSecurityGroupIds":{"shape":"Srz","locationName":"RemoveSecurityGroupId"},"IpAddressType":{},"DnsOptions":{"shape":"Ss1"},"PrivateDnsEnabled":{"type":"boolean"},"SubnetConfigurations":{"shape":"Ss3","locationName":"SubnetConfiguration"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointConnectionNotification":{"input":{"type":"structure","required":["ConnectionNotificationId"],"members":{"DryRun":{"type":"boolean"},"ConnectionNotificationId":{},"ConnectionNotificationArn":{},"ConnectionEvents":{"shape":"So"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServiceConfiguration":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"PrivateDnsName":{},"RemovePrivateDnsName":{"type":"boolean"},"AcceptanceRequired":{"type":"boolean"},"AddNetworkLoadBalancerArns":{"shape":"So","locationName":"AddNetworkLoadBalancerArn"},"RemoveNetworkLoadBalancerArns":{"shape":"So","locationName":"RemoveNetworkLoadBalancerArn"},"AddGatewayLoadBalancerArns":{"shape":"So","locationName":"AddGatewayLoadBalancerArn"},"RemoveGatewayLoadBalancerArns":{"shape":"So","locationName":"RemoveGatewayLoadBalancerArn"},"AddSupportedIpAddressTypes":{"shape":"So","locationName":"AddSupportedIpAddressType"},"RemoveSupportedIpAddressTypes":{"shape":"So","locationName":"RemoveSupportedIpAddressType"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServicePayerResponsibility":{"input":{"type":"structure","required":["ServiceId","PayerResponsibility"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"PayerResponsibility":{}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcEndpointServicePermissions":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"AddAllowedPrincipals":{"shape":"So"},"RemoveAllowedPrincipals":{"shape":"So"}}},"output":{"type":"structure","members":{"AddedPrincipals":{"locationName":"addedPrincipalSet","type":"list","member":{"locationName":"item","type":"structure","members":{"PrincipalType":{"locationName":"principalType"},"Principal":{"locationName":"principal"},"ServicePermissionId":{"locationName":"servicePermissionId"},"ServiceId":{"locationName":"serviceId"}}}},"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpcPeeringConnectionOptions":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"AccepterPeeringConnectionOptions":{"shape":"S2ah"},"DryRun":{"type":"boolean"},"RequesterPeeringConnectionOptions":{"shape":"S2ah"},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{"AccepterPeeringConnectionOptions":{"shape":"S2aj","locationName":"accepterPeeringConnectionOptions"},"RequesterPeeringConnectionOptions":{"shape":"S2aj","locationName":"requesterPeeringConnectionOptions"}}}},"ModifyVpcTenancy":{"input":{"type":"structure","required":["VpcId","InstanceTenancy"],"members":{"VpcId":{},"InstanceTenancy":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"ModifyVpnConnection":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"TransitGatewayId":{},"CustomerGatewayId":{},"VpnGatewayId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Stm","locationName":"vpnConnection"}}}},"ModifyVpnConnectionOptions":{"input":{"type":"structure","required":["VpnConnectionId"],"members":{"VpnConnectionId":{},"LocalIpv4NetworkCidr":{},"RemoteIpv4NetworkCidr":{},"LocalIpv6NetworkCidr":{},"RemoteIpv6NetworkCidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Stm","locationName":"vpnConnection"}}}},"ModifyVpnTunnelCertificate":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Stm","locationName":"vpnConnection"}}}},"ModifyVpnTunnelOptions":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress","TunnelOptions"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"TunnelOptions":{"type":"structure","members":{"TunnelInsideCidr":{},"TunnelInsideIpv6Cidr":{},"PreSharedKey":{"shape":"St3"},"Phase1LifetimeSeconds":{"type":"integer"},"Phase2LifetimeSeconds":{"type":"integer"},"RekeyMarginTimeSeconds":{"type":"integer"},"RekeyFuzzPercentage":{"type":"integer"},"ReplayWindowSize":{"type":"integer"},"DPDTimeoutSeconds":{"type":"integer"},"DPDTimeoutAction":{},"Phase1EncryptionAlgorithms":{"shape":"St4","locationName":"Phase1EncryptionAlgorithm"},"Phase2EncryptionAlgorithms":{"shape":"St6","locationName":"Phase2EncryptionAlgorithm"},"Phase1IntegrityAlgorithms":{"shape":"St8","locationName":"Phase1IntegrityAlgorithm"},"Phase2IntegrityAlgorithms":{"shape":"Sta","locationName":"Phase2IntegrityAlgorithm"},"Phase1DHGroupNumbers":{"shape":"Stc","locationName":"Phase1DHGroupNumber"},"Phase2DHGroupNumbers":{"shape":"Ste","locationName":"Phase2DHGroupNumber"},"IKEVersions":{"shape":"Stg","locationName":"IKEVersion"},"StartupAction":{},"LogOptions":{"shape":"Sti"},"EnableTunnelLifecycleControl":{"type":"boolean"}},"sensitive":true},"DryRun":{"type":"boolean"},"SkipTunnelReplacement":{"type":"boolean"}}},"output":{"type":"structure","members":{"VpnConnection":{"shape":"Stm","locationName":"vpnConnection"}}}},"MonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S2ay","locationName":"instancesSet"}}}},"MoveAddressToVpc":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"Status":{"locationName":"status"}}}},"MoveByoipCidrToIpam":{"input":{"type":"structure","required":["Cidr","IpamPoolId","IpamPoolOwner"],"members":{"DryRun":{"type":"boolean"},"Cidr":{},"IpamPoolId":{},"IpamPoolOwner":{}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1y","locationName":"byoipCidr"}}}},"ProvisionByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"CidrAuthorizationContext":{"type":"structure","required":["Message","Signature"],"members":{"Message":{},"Signature":{}}},"PubliclyAdvertisable":{"type":"boolean"},"Description":{},"DryRun":{"type":"boolean"},"PoolTagSpecifications":{"shape":"S3","locationName":"PoolTagSpecification"},"MultiRegion":{"type":"boolean"},"NetworkBorderGroup":{}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1y","locationName":"byoipCidr"}}}},"ProvisionIpamByoasn":{"input":{"type":"structure","required":["IpamId","Asn","AsnAuthorizationContext"],"members":{"DryRun":{"type":"boolean"},"IpamId":{},"Asn":{},"AsnAuthorizationContext":{"type":"structure","required":["Message","Signature"],"members":{"Message":{},"Signature":{}}}}},"output":{"type":"structure","members":{"Byoasn":{"shape":"Szb","locationName":"byoasn"}}}},"ProvisionIpamPoolCidr":{"input":{"type":"structure","required":["IpamPoolId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{},"CidrAuthorizationContext":{"type":"structure","members":{"Message":{},"Signature":{}}},"NetmaskLength":{"type":"integer"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"IpamPoolCidr":{"shape":"Szf","locationName":"ipamPoolCidr"}}}},"ProvisionPublicIpv4PoolCidr":{"input":{"type":"structure","required":["IpamPoolId","PoolId","NetmaskLength"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"PoolId":{},"NetmaskLength":{"type":"integer"}}},"output":{"type":"structure","members":{"PoolId":{"locationName":"poolId"},"PoolAddressRange":{"shape":"S1l4","locationName":"poolAddressRange"}}}},"PurchaseCapacityBlock":{"input":{"type":"structure","required":["CapacityBlockOfferingId","InstancePlatform"],"members":{"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"CapacityBlockOfferingId":{},"InstancePlatform":{}}},"output":{"type":"structure","members":{"CapacityReservation":{"shape":"S9x","locationName":"capacityReservation"}}}},"PurchaseHostReservation":{"input":{"type":"structure","required":["HostIdSet","OfferingId"],"members":{"ClientToken":{},"CurrencyCode":{},"HostIdSet":{"shape":"S206"},"LimitPrice":{},"OfferingId":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CurrencyCode":{"locationName":"currencyCode"},"Purchase":{"shape":"S208","locationName":"purchase"},"TotalHourlyPrice":{"locationName":"totalHourlyPrice"},"TotalUpfrontPrice":{"locationName":"totalUpfrontPrice"}}}},"PurchaseReservedInstancesOffering":{"input":{"type":"structure","required":["InstanceCount","ReservedInstancesOfferingId"],"members":{"InstanceCount":{"type":"integer"},"ReservedInstancesOfferingId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"LimitPrice":{"locationName":"limitPrice","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"CurrencyCode":{"locationName":"currencyCode"}}},"PurchaseTime":{"type":"timestamp"}}},"output":{"type":"structure","members":{"ReservedInstancesId":{"locationName":"reservedInstancesId"}}}},"PurchaseScheduledInstances":{"input":{"type":"structure","required":["PurchaseRequests"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"PurchaseRequests":{"locationName":"PurchaseRequest","type":"list","member":{"locationName":"PurchaseRequest","type":"structure","required":["InstanceCount","PurchaseToken"],"members":{"InstanceCount":{"type":"integer"},"PurchaseToken":{}}}}}},"output":{"type":"structure","members":{"ScheduledInstanceSet":{"locationName":"scheduledInstanceSet","type":"list","member":{"shape":"S1my","locationName":"item"}}}}},"RebootInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RegisterImage":{"input":{"type":"structure","required":["Name"],"members":{"ImageLocation":{},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"Ser","locationName":"BlockDeviceMapping"},"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"KernelId":{"locationName":"kernelId"},"Name":{"locationName":"name"},"BillingProducts":{"locationName":"BillingProduct","type":"list","member":{"locationName":"item"}},"RamdiskId":{"locationName":"ramdiskId"},"RootDeviceName":{"locationName":"rootDeviceName"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"VirtualizationType":{"locationName":"virtualizationType"},"BootMode":{},"TpmSupport":{},"UefiData":{},"ImdsSupport":{},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"output":{"type":"structure","members":{"ImageId":{"locationName":"imageId"}}}},"RegisterInstanceEventNotificationAttributes":{"input":{"type":"structure","required":["InstanceTagAttribute"],"members":{"DryRun":{"type":"boolean"},"InstanceTagAttribute":{"type":"structure","members":{"IncludeAllTagsOfInstance":{"type":"boolean"},"InstanceTagKeys":{"shape":"Szq","locationName":"InstanceTagKey"}}}}},"output":{"type":"structure","members":{"InstanceTagAttribute":{"shape":"Szs","locationName":"instanceTagAttribute"}}}},"RegisterTransitGatewayMulticastGroupMembers":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId","NetworkInterfaceIds"],"members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Szu"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"RegisteredMulticastGroupMembers":{"locationName":"registeredMulticastGroupMembers","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"RegisteredNetworkInterfaceIds":{"shape":"So","locationName":"registeredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"RegisterTransitGatewayMulticastGroupSources":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId","NetworkInterfaceIds"],"members":{"TransitGatewayMulticastDomainId":{},"GroupIpAddress":{},"NetworkInterfaceIds":{"shape":"Szu"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"RegisteredMulticastGroupSources":{"locationName":"registeredMulticastGroupSources","type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"RegisteredNetworkInterfaceIds":{"shape":"So","locationName":"registeredNetworkInterfaceIds"},"GroupIpAddress":{"locationName":"groupIpAddress"}}}}}},"RejectTransitGatewayMulticastDomainAssociations":{"input":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{},"TransitGatewayAttachmentId":{},"SubnetIds":{"shape":"So"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Associations":{"shape":"Sq","locationName":"associations"}}}},"RejectTransitGatewayPeeringAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayPeeringAttachment":{"shape":"Sx","locationName":"transitGatewayPeeringAttachment"}}}},"RejectTransitGatewayVpcAttachment":{"input":{"type":"structure","required":["TransitGatewayAttachmentId"],"members":{"TransitGatewayAttachmentId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"TransitGatewayVpcAttachment":{"shape":"S16","locationName":"transitGatewayVpcAttachment"}}}},"RejectVpcEndpointConnections":{"input":{"type":"structure","required":["ServiceId","VpcEndpointIds"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{},"VpcEndpointIds":{"shape":"S1e","locationName":"VpcEndpointId"}}},"output":{"type":"structure","members":{"Unsuccessful":{"shape":"S1h","locationName":"unsuccessful"}}}},"RejectVpcPeeringConnection":{"input":{"type":"structure","required":["VpcPeeringConnectionId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ReleaseAddress":{"input":{"type":"structure","members":{"AllocationId":{},"PublicIp":{},"NetworkBorderGroup":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ReleaseHosts":{"input":{"type":"structure","required":["HostIds"],"members":{"HostIds":{"shape":"S17g","locationName":"hostId"}}},"output":{"type":"structure","members":{"Successful":{"shape":"S2f","locationName":"successful"},"Unsuccessful":{"shape":"S26l","locationName":"unsuccessful"}}}},"ReleaseIpamPoolAllocation":{"input":{"type":"structure","required":["IpamPoolId","Cidr","IpamPoolAllocationId"],"members":{"DryRun":{"type":"boolean"},"IpamPoolId":{},"Cidr":{},"IpamPoolAllocationId":{}}},"output":{"type":"structure","members":{"Success":{"locationName":"success","type":"boolean"}}}},"ReplaceIamInstanceProfileAssociation":{"input":{"type":"structure","required":["IamInstanceProfile","AssociationId"],"members":{"IamInstanceProfile":{"shape":"S3v"},"AssociationId":{}}},"output":{"type":"structure","members":{"IamInstanceProfileAssociation":{"shape":"S3x","locationName":"iamInstanceProfileAssociation"}}}},"ReplaceNetworkAclAssociation":{"input":{"type":"structure","required":["AssociationId","NetworkAclId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"}}}},"ReplaceNetworkAclEntry":{"input":{"type":"structure","required":["Egress","NetworkAclId","Protocol","RuleAction","RuleNumber"],"members":{"CidrBlock":{"locationName":"cidrBlock"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Sko","locationName":"Icmp"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"NetworkAclId":{"locationName":"networkAclId"},"PortRange":{"shape":"Skp","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"ReplaceRoute":{"input":{"type":"structure","required":["RouteTableId"],"members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{},"DryRun":{"locationName":"dryRun","type":"boolean"},"VpcEndpointId":{},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"LocalTarget":{"type":"boolean"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{},"LocalGatewayId":{},"CarrierGatewayId":{},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"RouteTableId":{"locationName":"routeTableId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"CoreNetworkArn":{}}}},"ReplaceRouteTableAssociation":{"input":{"type":"structure","required":["AssociationId","RouteTableId"],"members":{"AssociationId":{"locationName":"associationId"},"DryRun":{"locationName":"dryRun","type":"boolean"},"RouteTableId":{"locationName":"routeTableId"}}},"output":{"type":"structure","members":{"NewAssociationId":{"locationName":"newAssociationId"},"AssociationState":{"shape":"S4x","locationName":"associationState"}}}},"ReplaceTransitGatewayRoute":{"input":{"type":"structure","required":["DestinationCidrBlock","TransitGatewayRouteTableId"],"members":{"DestinationCidrBlock":{},"TransitGatewayRouteTableId":{},"TransitGatewayAttachmentId":{},"Blackhole":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Route":{"shape":"Sqe","locationName":"route"}}}},"ReplaceVpnTunnel":{"input":{"type":"structure","required":["VpnConnectionId","VpnTunnelOutsideIpAddress"],"members":{"VpnConnectionId":{},"VpnTunnelOutsideIpAddress":{},"ApplyPendingMaintenance":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ReportInstanceStatus":{"input":{"type":"structure","required":["Instances","ReasonCodes","Status"],"members":{"Description":{"locationName":"description"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EndTime":{"locationName":"endTime","type":"timestamp"},"Instances":{"shape":"S128","locationName":"instanceId"},"ReasonCodes":{"locationName":"reasonCode","type":"list","member":{"locationName":"item"}},"StartTime":{"locationName":"startTime","type":"timestamp"},"Status":{"locationName":"status"}}}},"RequestSpotFleet":{"input":{"type":"structure","required":["SpotFleetRequestConfig"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"SpotFleetRequestConfig":{"shape":"S1o9","locationName":"spotFleetRequestConfig"}}},"output":{"type":"structure","members":{"SpotFleetRequestId":{"locationName":"spotFleetRequestId"}}}},"RequestSpotInstances":{"input":{"type":"structure","members":{"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ClientToken":{"locationName":"clientToken"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"type":"structure","members":{"SecurityGroupIds":{"locationName":"SecurityGroupId","type":"list","member":{"locationName":"item"}},"SecurityGroups":{"locationName":"SecurityGroup","type":"list","member":{"locationName":"item"}},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"S185","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S3v","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"shape":"S1p4","locationName":"monitoring"},"NetworkInterfaces":{"shape":"S1oj","locationName":"NetworkInterface"},"Placement":{"shape":"S1ol","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"UserData":{"shape":"Sgo","locationName":"userData"}}},"SpotPrice":{"locationName":"spotPrice"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"InstanceInterruptionBehavior":{}}},"output":{"type":"structure","members":{"SpotInstanceRequests":{"shape":"S1p1","locationName":"spotInstanceRequestSet"}}}},"ResetAddressAttribute":{"input":{"type":"structure","required":["AllocationId","Attribute"],"members":{"AllocationId":{},"Attribute":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Address":{"shape":"S10q","locationName":"address"}}}},"ResetEbsDefaultKmsKeyId":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KmsKeyId":{"locationName":"kmsKeyId"}}}},"ResetFpgaImageAttribute":{"input":{"type":"structure","required":["FpgaImageId"],"members":{"DryRun":{"type":"boolean"},"FpgaImageId":{},"Attribute":{}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"ResetImageAttribute":{"input":{"type":"structure","required":["Attribute","ImageId"],"members":{"Attribute":{},"ImageId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"ResetInstanceAttribute":{"input":{"type":"structure","required":["Attribute","InstanceId"],"members":{"Attribute":{"locationName":"attribute"},"DryRun":{"locationName":"dryRun","type":"boolean"},"InstanceId":{"locationName":"instanceId"}}}},"ResetNetworkInterfaceAttribute":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"SourceDestCheck":{"locationName":"sourceDestCheck"}}}},"ResetSnapshotAttribute":{"input":{"type":"structure","required":["Attribute","SnapshotId"],"members":{"Attribute":{},"SnapshotId":{},"DryRun":{"locationName":"dryRun","type":"boolean"}}}},"RestoreAddressToClassic":{"input":{"type":"structure","required":["PublicIp"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"PublicIp":{"locationName":"publicIp"}}},"output":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"Status":{"locationName":"status"}}}},"RestoreImageFromRecycleBin":{"input":{"type":"structure","required":["ImageId"],"members":{"ImageId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"RestoreManagedPrefixListVersion":{"input":{"type":"structure","required":["PrefixListId","PreviousVersion","CurrentVersion"],"members":{"DryRun":{"type":"boolean"},"PrefixListId":{},"PreviousVersion":{"type":"long"},"CurrentVersion":{"type":"long"}}},"output":{"type":"structure","members":{"PrefixList":{"shape":"Sk9","locationName":"prefixList"}}}},"RestoreSnapshotFromRecycleBin":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"OutpostArn":{"locationName":"outpostArn"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"SseType":{"locationName":"sseType"}}}},"RestoreSnapshotTier":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"TemporaryRestoreDays":{"type":"integer"},"PermanentRestore":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"},"RestoreStartTime":{"locationName":"restoreStartTime","type":"timestamp"},"RestoreDuration":{"locationName":"restoreDuration","type":"integer"},"IsPermanentRestore":{"locationName":"isPermanentRestore","type":"boolean"}}}},"RevokeClientVpnIngress":{"input":{"type":"structure","required":["ClientVpnEndpointId","TargetNetworkCidr"],"members":{"ClientVpnEndpointId":{},"TargetNetworkCidr":{},"AccessGroupId":{},"RevokeAllGroups":{"type":"boolean"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Status":{"shape":"S6u","locationName":"status"}}}},"RevokeSecurityGroupEgress":{"input":{"type":"structure","required":["GroupId"],"members":{"DryRun":{"locationName":"dryRun","type":"boolean"},"GroupId":{"locationName":"groupId"},"IpPermissions":{"shape":"S6x","locationName":"ipPermissions"},"SecurityGroupRuleIds":{"shape":"S1n5","locationName":"SecurityGroupRuleId"},"CidrIp":{"locationName":"cidrIp"},"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"ToPort":{"locationName":"toPort","type":"integer"},"SourceSecurityGroupName":{"locationName":"sourceSecurityGroupName"},"SourceSecurityGroupOwnerId":{"locationName":"sourceSecurityGroupOwnerId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"UnknownIpPermissions":{"shape":"S6x","locationName":"unknownIpPermissionSet"}}}},"RevokeSecurityGroupIngress":{"input":{"type":"structure","members":{"CidrIp":{},"FromPort":{"type":"integer"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S6x"},"IpProtocol":{},"SourceSecurityGroupName":{},"SourceSecurityGroupOwnerId":{},"ToPort":{"type":"integer"},"DryRun":{"locationName":"dryRun","type":"boolean"},"SecurityGroupRuleIds":{"shape":"S1n5","locationName":"SecurityGroupRuleId"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"},"UnknownIpPermissions":{"shape":"S6x","locationName":"unknownIpPermissionSet"}}}},"RunInstances":{"input":{"type":"structure","required":["MaxCount","MinCount"],"members":{"BlockDeviceMappings":{"shape":"Ser","locationName":"BlockDeviceMapping"},"ImageId":{},"InstanceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"shape":"Siq","locationName":"Ipv6Address"},"KernelId":{},"KeyName":{},"MaxCount":{"type":"integer"},"MinCount":{"type":"integer"},"Monitoring":{"shape":"S1p4"},"Placement":{"shape":"Scr"},"RamdiskId":{},"SecurityGroupIds":{"shape":"Sgz","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Shn","locationName":"SecurityGroup"},"SubnetId":{},"UserData":{"type":"string","sensitive":true},"AdditionalInfo":{"locationName":"additionalInfo"},"ClientToken":{"idempotencyToken":true,"locationName":"clientToken"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S3v","locationName":"iamInstanceProfile"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"NetworkInterfaces":{"shape":"S1oj","locationName":"networkInterface"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ElasticGpuSpecification":{"type":"list","member":{"shape":"Shj","locationName":"item"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{},"Count":{"type":"integer"}}}},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"Sht"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"},"AmdSevSnp":{}}},"CapacityReservationSpecification":{"shape":"S26y"},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"MetadataOptions":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"HttpProtocolIpv6":{},"InstanceMetadataTags":{}}},"EnclaveOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"PrivateDnsNameOptions":{"type":"structure","members":{"HostnameType":{},"EnableResourceNameDnsARecord":{"type":"boolean"},"EnableResourceNameDnsAAAARecord":{"type":"boolean"}}},"MaintenanceOptions":{"type":"structure","members":{"AutoRecovery":{}}},"DisableApiStop":{"type":"boolean"},"EnablePrimaryIpv6":{"type":"boolean"}}},"output":{"shape":"S1ef"}},"RunScheduledInstances":{"input":{"type":"structure","required":["LaunchSpecification","ScheduledInstanceId"],"members":{"ClientToken":{"idempotencyToken":true},"DryRun":{"type":"boolean"},"InstanceCount":{"type":"integer"},"LaunchSpecification":{"type":"structure","required":["ImageId"],"members":{"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"Ebs":{"type":"structure","members":{"DeleteOnTermination":{"type":"boolean"},"Encrypted":{"type":"boolean"},"Iops":{"type":"integer"},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{}}},"NoDevice":{},"VirtualName":{}}}},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"ImageId":{},"InstanceType":{},"KernelId":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"S2es","locationName":"Group"},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"locationName":"Ipv6Address","type":"list","member":{"locationName":"Ipv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddressConfigs":{"locationName":"PrivateIpAddressConfig","type":"list","member":{"locationName":"PrivateIpAddressConfigSet","type":"structure","members":{"Primary":{"type":"boolean"},"PrivateIpAddress":{}}}},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{}}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"GroupName":{}}},"RamdiskId":{},"SecurityGroupIds":{"shape":"S2es","locationName":"SecurityGroupId"},"SubnetId":{},"UserData":{}},"sensitive":true},"ScheduledInstanceId":{}}},"output":{"type":"structure","members":{"InstanceIdSet":{"locationName":"instanceIdSet","type":"list","member":{"locationName":"item"}}}}},"SearchLocalGatewayRoutes":{"input":{"type":"structure","required":["LocalGatewayRouteTableId"],"members":{"LocalGatewayRouteTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routeSet","type":"list","member":{"shape":"Sjo","locationName":"item"}},"NextToken":{"locationName":"nextToken"}}}},"SearchTransitGatewayMulticastGroups":{"input":{"type":"structure","required":["TransitGatewayMulticastDomainId"],"members":{"TransitGatewayMulticastDomainId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"NextToken":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"MulticastGroups":{"locationName":"multicastGroups","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupIpAddress":{"locationName":"groupIpAddress"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"SubnetId":{"locationName":"subnetId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"GroupMember":{"locationName":"groupMember","type":"boolean"},"GroupSource":{"locationName":"groupSource","type":"boolean"},"MemberType":{"locationName":"memberType"},"SourceType":{"locationName":"sourceType"}}}},"NextToken":{"locationName":"nextToken"}}}},"SearchTransitGatewayRoutes":{"input":{"type":"structure","required":["TransitGatewayRouteTableId","Filters"],"members":{"TransitGatewayRouteTableId":{},"Filters":{"shape":"S10d","locationName":"Filter"},"MaxResults":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Routes":{"locationName":"routeSet","type":"list","member":{"shape":"Sqe","locationName":"item"}},"AdditionalRoutesAvailable":{"locationName":"additionalRoutesAvailable","type":"boolean"}}}},"SendDiagnosticInterrupt":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DryRun":{"type":"boolean"}}}},"StartInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"AdditionalInfo":{"locationName":"additionalInfo"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"StartingInstances":{"shape":"S2fg","locationName":"instancesSet"}}}},"StartNetworkInsightsAccessScopeAnalysis":{"input":{"type":"structure","required":["NetworkInsightsAccessScopeId","ClientToken"],"members":{"NetworkInsightsAccessScopeId":{},"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysis":{"shape":"S1iq","locationName":"networkInsightsAccessScopeAnalysis"}}}},"StartNetworkInsightsAnalysis":{"input":{"type":"structure","required":["NetworkInsightsPathId","ClientToken"],"members":{"NetworkInsightsPathId":{},"AdditionalAccounts":{"shape":"So","locationName":"AdditionalAccount"},"FilterInArns":{"shape":"S1j2","locationName":"FilterInArn"},"DryRun":{"type":"boolean"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"NetworkInsightsAnalysis":{"shape":"S1j1","locationName":"networkInsightsAnalysis"}}}},"StartVpcEndpointServicePrivateDnsVerification":{"input":{"type":"structure","required":["ServiceId"],"members":{"DryRun":{"type":"boolean"},"ServiceId":{}}},"output":{"type":"structure","members":{"ReturnValue":{"locationName":"return","type":"boolean"}}}},"StopInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"Hibernate":{"type":"boolean"},"DryRun":{"locationName":"dryRun","type":"boolean"},"Force":{"locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"StoppingInstances":{"shape":"S2fg","locationName":"instancesSet"}}}},"TerminateClientVpnConnections":{"input":{"type":"structure","required":["ClientVpnEndpointId"],"members":{"ClientVpnEndpointId":{},"ConnectionId":{},"Username":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ClientVpnEndpointId":{"locationName":"clientVpnEndpointId"},"Username":{"locationName":"username"},"ConnectionStatuses":{"locationName":"connectionStatuses","type":"list","member":{"locationName":"item","type":"structure","members":{"ConnectionId":{"locationName":"connectionId"},"PreviousStatus":{"shape":"S12n","locationName":"previousStatus"},"CurrentStatus":{"shape":"S12n","locationName":"currentStatus"}}}}}}},"TerminateInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"TerminatingInstances":{"shape":"S2fg","locationName":"instancesSet"}}}},"UnassignIpv6Addresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"Ipv6Addresses":{"shape":"S2v","locationName":"ipv6Addresses"},"Ipv6Prefixes":{"shape":"S2w","locationName":"Ipv6Prefix"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"}}},"output":{"type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"UnassignedIpv6Addresses":{"shape":"S2v","locationName":"unassignedIpv6Addresses"},"UnassignedIpv6Prefixes":{"shape":"S2w","locationName":"unassignedIpv6PrefixSet"}}}},"UnassignPrivateIpAddresses":{"input":{"type":"structure","required":["NetworkInterfaceId"],"members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddresses":{"shape":"S30","locationName":"privateIpAddress"},"Ipv4Prefixes":{"shape":"S2w","locationName":"Ipv4Prefix"}}}},"UnassignPrivateNatGatewayAddress":{"input":{"type":"structure","required":["NatGatewayId","PrivateIpAddresses"],"members":{"NatGatewayId":{},"PrivateIpAddresses":{"shape":"S38","locationName":"PrivateIpAddress"},"MaxDrainDurationSeconds":{"type":"integer"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"NatGatewayId":{"locationName":"natGatewayId"},"NatGatewayAddresses":{"shape":"S3b","locationName":"natGatewayAddressSet"}}}},"UnlockSnapshot":{"input":{"type":"structure","required":["SnapshotId"],"members":{"SnapshotId":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"SnapshotId":{"locationName":"snapshotId"}}}},"UnmonitorInstances":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S128","locationName":"InstanceId"},"DryRun":{"locationName":"dryRun","type":"boolean"}}},"output":{"type":"structure","members":{"InstanceMonitorings":{"shape":"S2ay","locationName":"instancesSet"}}}},"UpdateSecurityGroupRuleDescriptionsEgress":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S6x"},"SecurityGroupRuleDescriptions":{"shape":"S2g6","locationName":"SecurityGroupRuleDescription"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"UpdateSecurityGroupRuleDescriptionsIngress":{"input":{"type":"structure","members":{"DryRun":{"type":"boolean"},"GroupId":{},"GroupName":{},"IpPermissions":{"shape":"S6x"},"SecurityGroupRuleDescriptions":{"shape":"S2g6","locationName":"SecurityGroupRuleDescription"}}},"output":{"type":"structure","members":{"Return":{"locationName":"return","type":"boolean"}}}},"WithdrawByoipCidr":{"input":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"ByoipCidr":{"shape":"S1y","locationName":"byoipCidr"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"S6","locationName":"Tag"}}}},"S6":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"Sa":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"TransferAccountId":{"locationName":"transferAccountId"},"TransferOfferExpirationTimestamp":{"locationName":"transferOfferExpirationTimestamp","type":"timestamp"},"TransferOfferAcceptedTimestamp":{"locationName":"transferOfferAcceptedTimestamp","type":"timestamp"},"AddressTransferStatus":{"locationName":"addressTransferStatus"}}},"Se":{"type":"list","member":{"locationName":"ReservedInstanceId"}},"Sg":{"type":"list","member":{"locationName":"TargetConfigurationRequest","type":"structure","required":["OfferingId"],"members":{"InstanceCount":{"type":"integer"},"OfferingId":{}}}},"So":{"type":"list","member":{"locationName":"item"}},"Sq":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"Subnets":{"locationName":"subnets","type":"list","member":{"shape":"St","locationName":"item"}}}},"St":{"type":"structure","members":{"SubnetId":{"locationName":"subnetId"},"State":{"locationName":"state"}}},"Sx":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"AccepterTransitGatewayAttachmentId":{"locationName":"accepterTransitGatewayAttachmentId"},"RequesterTgwInfo":{"shape":"Sy","locationName":"requesterTgwInfo"},"AccepterTgwInfo":{"shape":"Sy","locationName":"accepterTgwInfo"},"Options":{"locationName":"options","type":"structure","members":{"DynamicRouting":{"locationName":"dynamicRouting"}}},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sy":{"type":"structure","members":{"TransitGatewayId":{"locationName":"transitGatewayId"},"CoreNetworkId":{"locationName":"coreNetworkId"},"OwnerId":{"locationName":"ownerId"},"Region":{"locationName":"region"}}},"S16":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"VpcId":{"locationName":"vpcId"},"VpcOwnerId":{"locationName":"vpcOwnerId"},"State":{"locationName":"state"},"SubnetIds":{"shape":"So","locationName":"subnetIds"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"DnsSupport":{"locationName":"dnsSupport"},"SecurityGroupReferencingSupport":{"locationName":"securityGroupReferencingSupport"},"Ipv6Support":{"locationName":"ipv6Support"},"ApplianceModeSupport":{"locationName":"applianceModeSupport"}}},"Tags":{"shape":"S6","locationName":"tagSet"}}},"S1e":{"type":"list","member":{"locationName":"item"}},"S1h":{"type":"list","member":{"shape":"S1i","locationName":"item"}},"S1i":{"type":"structure","members":{"Error":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"ResourceId":{"locationName":"resourceId"}}},"S1n":{"type":"structure","members":{"AccepterVpcInfo":{"shape":"S1o","locationName":"accepterVpcInfo"},"ExpirationTime":{"locationName":"expirationTime","type":"timestamp"},"RequesterVpcInfo":{"shape":"S1o","locationName":"requesterVpcInfo"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Tags":{"shape":"S6","locationName":"tagSet"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S1o":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Ipv6CidrBlockSet":{"locationName":"ipv6CidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"}}}},"CidrBlockSet":{"locationName":"cidrBlockSet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"}}}},"OwnerId":{"locationName":"ownerId"},"PeeringOptions":{"locationName":"peeringOptions","type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"VpcId":{"locationName":"vpcId"},"Region":{"locationName":"region"}}},"S1y":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Description":{"locationName":"description"},"AsnAssociations":{"locationName":"asnAssociationSet","type":"list","member":{"shape":"S20","locationName":"item"}},"StatusMessage":{"locationName":"statusMessage"},"State":{"locationName":"state"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"}}},"S20":{"type":"structure","members":{"Asn":{"locationName":"asn"},"Cidr":{"locationName":"cidr"},"StatusMessage":{"locationName":"statusMessage"},"State":{"locationName":"state"}}},"S2f":{"type":"list","member":{"locationName":"item"}},"S2l":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"IpamPoolAllocationId":{"locationName":"ipamPoolAllocationId"},"Description":{"locationName":"description"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceOwner":{"locationName":"resourceOwner"}}},"S2r":{"type":"list","member":{"locationName":"item"}},"S2v":{"type":"list","member":{"locationName":"item"}},"S2w":{"type":"list","member":{"locationName":"item"}},"S30":{"type":"list","member":{"locationName":"PrivateIpAddress"}},"S34":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{"locationName":"ipv4Prefix"}}}},"S38":{"type":"list","member":{"locationName":"item"}},"S3b":{"type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIp":{"locationName":"privateIp"},"PublicIp":{"locationName":"publicIp"},"AssociationId":{"locationName":"associationId"},"IsPrimary":{"locationName":"isPrimary","type":"boolean"},"FailureMessage":{"locationName":"failureMessage"},"Status":{"locationName":"status"}}}},"S3m":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S3v":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S3x":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"InstanceId":{"locationName":"instanceId"},"IamInstanceProfile":{"shape":"S3y","locationName":"iamInstanceProfile"},"State":{"locationName":"state"},"Timestamp":{"locationName":"timestamp","type":"timestamp"}}},"S3y":{"type":"structure","members":{"Arn":{"locationName":"arn"},"Id":{"locationName":"id"}}},"S43":{"type":"list","member":{"locationName":"item"}},"S44":{"type":"list","member":{"locationName":"item"}},"S47":{"type":"structure","members":{"InstanceEventWindowId":{"locationName":"instanceEventWindowId"},"TimeRanges":{"locationName":"timeRangeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"StartWeekDay":{"locationName":"startWeekDay"},"StartHour":{"locationName":"startHour","type":"integer"},"EndWeekDay":{"locationName":"endWeekDay"},"EndHour":{"locationName":"endHour","type":"integer"}}}},"Name":{"locationName":"name"},"CronExpression":{"locationName":"cronExpression"},"AssociationTarget":{"locationName":"associationTarget","type":"structure","members":{"InstanceIds":{"shape":"S43","locationName":"instanceIdSet"},"Tags":{"shape":"S6","locationName":"tagSet"},"DedicatedHostIds":{"shape":"S44","locationName":"dedicatedHostIdSet"}}},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"S4l":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamResourceDiscoveryAssociationId":{"locationName":"ipamResourceDiscoveryAssociationId"},"IpamResourceDiscoveryAssociationArn":{"locationName":"ipamResourceDiscoveryAssociationArn"},"IpamResourceDiscoveryId":{"locationName":"ipamResourceDiscoveryId"},"IpamId":{"locationName":"ipamId"},"IpamArn":{"locationName":"ipamArn"},"IpamRegion":{"locationName":"ipamRegion"},"IsDefault":{"locationName":"isDefault","type":"boolean"},"ResourceDiscoveryStatus":{"locationName":"resourceDiscoveryStatus"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"S4r":{"type":"list","member":{"locationName":"AllocationId"}},"S4x":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S52":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"locationName":"ipv6CidrBlockState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"S57":{"type":"list","member":{"locationName":"item"}},"S5c":{"type":"structure","members":{"TransitGatewayPolicyTableId":{"locationName":"transitGatewayPolicyTableId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}},"S5h":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"State":{"locationName":"state"}}},"S5k":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"BranchInterfaceId":{"locationName":"branchInterfaceId"},"TrunkInterfaceId":{"locationName":"trunkInterfaceId"},"InterfaceProtocol":{"locationName":"interfaceProtocol"},"VlanId":{"locationName":"vlanId","type":"integer"},"GreKey":{"locationName":"greKey","type":"integer"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"S5q":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"Ipv6CidrBlockState":{"shape":"S5r","locationName":"ipv6CidrBlockState"},"NetworkBorderGroup":{"locationName":"networkBorderGroup"},"Ipv6Pool":{"locationName":"ipv6Pool"}}},"S5r":{"type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}},"S5t":{"type":"structure","members":{"AssociationId":{"locationName":"associationId"},"CidrBlock":{"locationName":"cidrBlock"},"CidrBlockState":{"shape":"S5r","locationName":"cidrBlockState"}}},"S5v":{"type":"list","member":{"locationName":"groupId"}},"S60":{"type":"structure","members":{"EnaSrdEnabled":{"type":"boolean"},"EnaSrdUdpSpecification":{"type":"structure","members":{"EnaSrdUdpEnabled":{"type":"boolean"}}}}},"S67":{"type":"structure","members":{"VerifiedAccessTrustProviderId":{"locationName":"verifiedAccessTrustProviderId"},"Description":{"locationName":"description"},"TrustProviderType":{"locationName":"trustProviderType"},"UserTrustProviderType":{"locationName":"userTrustProviderType"},"DeviceTrustProviderType":{"locationName":"deviceTrustProviderType"},"OidcOptions":{"locationName":"oidcOptions","type":"structure","members":{"Issuer":{"locationName":"issuer"},"AuthorizationEndpoint":{"locationName":"authorizationEndpoint"},"TokenEndpoint":{"locationName":"tokenEndpoint"},"UserInfoEndpoint":{"locationName":"userInfoEndpoint"},"ClientId":{"locationName":"clientId"},"ClientSecret":{"shape":"S6c","locationName":"clientSecret"},"Scope":{"locationName":"scope"}}},"DeviceOptions":{"locationName":"deviceOptions","type":"structure","members":{"TenantId":{"locationName":"tenantId"},"PublicSigningKeyUrl":{"locationName":"publicSigningKeyUrl"}}},"PolicyReferenceName":{"locationName":"policyReferenceName"},"CreationTime":{"locationName":"creationTime"},"LastUpdatedTime":{"locationName":"lastUpdatedTime"},"Tags":{"shape":"S6","locationName":"tagSet"},"SseSpecification":{"shape":"S6e","locationName":"sseSpecification"}}},"S6c":{"type":"string","sensitive":true},"S6e":{"type":"structure","members":{"CustomerManagedKeyEnabled":{"locationName":"customerManagedKeyEnabled","type":"boolean"},"KmsKeyArn":{"locationName":"kmsKeyArn"}}},"S6g":{"type":"structure","members":{"VerifiedAccessInstanceId":{"locationName":"verifiedAccessInstanceId"},"Description":{"locationName":"description"},"VerifiedAccessTrustProviders":{"locationName":"verifiedAccessTrustProviderSet","type":"list","member":{"locationName":"item","type":"structure","members":{"VerifiedAccessTrustProviderId":{"locationName":"verifiedAccessTrustProviderId"},"Description":{"locationName":"description"},"TrustProviderType":{"locationName":"trustProviderType"},"UserTrustProviderType":{"locationName":"userTrustProviderType"},"DeviceTrustProviderType":{"locationName":"deviceTrustProviderType"}}}},"CreationTime":{"locationName":"creationTime"},"LastUpdatedTime":{"locationName":"lastUpdatedTime"},"Tags":{"shape":"S6","locationName":"tagSet"},"FipsEnabled":{"locationName":"fipsEnabled","type":"boolean"}}},"S6l":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"Device":{"locationName":"device"},"InstanceId":{"locationName":"instanceId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"AssociatedResource":{"locationName":"associatedResource"},"InstanceOwningService":{"locationName":"instanceOwningService"}}},"S6q":{"type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}},"S6u":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S6x":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIp":{"locationName":"cidrIp"},"Description":{"locationName":"description"}}}},"Ipv6Ranges":{"locationName":"ipv6Ranges","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrIpv6":{"locationName":"cidrIpv6"},"Description":{"locationName":"description"}}}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"PrefixListId":{"locationName":"prefixListId"}}}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S76","locationName":"item"}}}}},"S76":{"type":"structure","members":{"Description":{"locationName":"description"},"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"S78":{"type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroupRuleId":{"locationName":"securityGroupRuleId"},"GroupId":{"locationName":"groupId"},"GroupOwnerId":{"locationName":"groupOwnerId"},"IsEgress":{"locationName":"isEgress","type":"boolean"},"IpProtocol":{"locationName":"ipProtocol"},"FromPort":{"locationName":"fromPort","type":"integer"},"ToPort":{"locationName":"toPort","type":"integer"},"CidrIpv4":{"locationName":"cidrIpv4"},"CidrIpv6":{"locationName":"cidrIpv6"},"PrefixListId":{"locationName":"prefixListId"},"ReferencedGroupInfo":{"locationName":"referencedGroupInfo","type":"structure","members":{"GroupId":{"locationName":"groupId"},"PeeringStatus":{"locationName":"peeringStatus"},"UserId":{"locationName":"userId"},"VpcId":{"locationName":"vpcId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"}}},"Description":{"locationName":"description"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"S7h":{"type":"structure","members":{"S3":{"type":"structure","members":{"AWSAccessKeyId":{},"Bucket":{"locationName":"bucket"},"Prefix":{"locationName":"prefix"},"UploadPolicy":{"locationName":"uploadPolicy","type":"blob"},"UploadPolicySignature":{"locationName":"uploadPolicySignature","type":"string","sensitive":true}}}}},"S7m":{"type":"structure","members":{"BundleId":{"locationName":"bundleId"},"BundleTaskError":{"locationName":"error","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"InstanceId":{"locationName":"instanceId"},"Progress":{"locationName":"progress"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"state"},"Storage":{"shape":"S7h","locationName":"storage"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"S7w":{"type":"list","member":{"locationName":"item"}},"S8k":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ClientToken":{"locationName":"clientToken"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"InstanceCounts":{"locationName":"instanceCounts","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceCount":{"locationName":"instanceCount","type":"integer"},"State":{"locationName":"state"}}}},"PriceSchedules":{"locationName":"priceSchedules","type":"list","member":{"locationName":"item","type":"structure","members":{"Active":{"locationName":"active","type":"boolean"},"CurrencyCode":{"locationName":"currencyCode"},"Price":{"locationName":"price","type":"double"},"Term":{"locationName":"term","type":"long"}}}},"ReservedInstancesId":{"locationName":"reservedInstancesId"},"ReservedInstancesListingId":{"locationName":"reservedInstancesListingId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"S6","locationName":"tagSet"},"UpdateDate":{"locationName":"updateDate","type":"timestamp"}}}},"S8w":{"type":"list","member":{"locationName":"item"}},"S97":{"type":"list","member":{"locationName":"SpotInstanceRequestId"}},"S9x":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"OwnerId":{"locationName":"ownerId"},"CapacityReservationArn":{"locationName":"capacityReservationArn"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"InstanceType":{"locationName":"instanceType"},"InstancePlatform":{"locationName":"instancePlatform"},"AvailabilityZone":{"locationName":"availabilityZone"},"Tenancy":{"locationName":"tenancy"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"AvailableInstanceCount":{"locationName":"availableInstanceCount","type":"integer"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EphemeralStorage":{"locationName":"ephemeralStorage","type":"boolean"},"State":{"locationName":"state"},"StartDate":{"locationName":"startDate","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"EndDateType":{"locationName":"endDateType"},"InstanceMatchCriteria":{"locationName":"instanceMatchCriteria"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"},"OutpostArn":{"locationName":"outpostArn"},"CapacityReservationFleetId":{"locationName":"capacityReservationFleetId"},"PlacementGroupArn":{"locationName":"placementGroupArn"},"CapacityAllocations":{"locationName":"capacityAllocationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AllocationType":{"locationName":"allocationType"},"Count":{"locationName":"count","type":"integer"}}}},"ReservationType":{"locationName":"reservationType"}}},"Sac":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"InstanceType":{"locationName":"instanceType"},"InstancePlatform":{"locationName":"instancePlatform"},"AvailabilityZone":{"locationName":"availabilityZone"},"TotalInstanceCount":{"locationName":"totalInstanceCount","type":"integer"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"Weight":{"locationName":"weight","type":"double"},"Priority":{"locationName":"priority","type":"integer"}}}},"Sag":{"type":"structure","members":{"CarrierGatewayId":{"locationName":"carrierGatewayId"},"VpcId":{"locationName":"vpcId"},"State":{"locationName":"state"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Saq":{"type":"structure","members":{"Enabled":{"type":"boolean"},"CloudwatchLogGroup":{},"CloudwatchLogStream":{}}},"Sat":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LambdaFunctionArn":{}}},"Sau":{"type":"structure","members":{"Enabled":{"type":"boolean"},"BannerText":{}}},"Saw":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sb0":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sb5":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"CoipPoolId":{"locationName":"coipPoolId"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"}}},"Sb9":{"type":"structure","members":{"PoolId":{"locationName":"poolId"},"PoolCidrs":{"shape":"So","locationName":"poolCidrSet"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"Tags":{"shape":"S6","locationName":"tagSet"},"PoolArn":{"locationName":"poolArn"}}},"Sbd":{"type":"structure","members":{"BgpAsn":{"locationName":"bgpAsn"},"CustomerGatewayId":{"locationName":"customerGatewayId"},"IpAddress":{"locationName":"ipAddress"},"CertificateArn":{"locationName":"certificateArn"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"DeviceName":{"locationName":"deviceName"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sbg":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"AvailabilityZoneId":{"locationName":"availabilityZoneId"},"AvailableIpAddressCount":{"locationName":"availableIpAddressCount","type":"integer"},"CidrBlock":{"locationName":"cidrBlock"},"DefaultForAz":{"locationName":"defaultForAz","type":"boolean"},"EnableLniAtDeviceIndex":{"locationName":"enableLniAtDeviceIndex","type":"integer"},"MapPublicIpOnLaunch":{"locationName":"mapPublicIpOnLaunch","type":"boolean"},"MapCustomerOwnedIpOnLaunch":{"locationName":"mapCustomerOwnedIpOnLaunch","type":"boolean"},"CustomerOwnedIpv4Pool":{"locationName":"customerOwnedIpv4Pool"},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"AssignIpv6AddressOnCreation":{"locationName":"assignIpv6AddressOnCreation","type":"boolean"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S52","locationName":"item"}},"Tags":{"shape":"S6","locationName":"tagSet"},"SubnetArn":{"locationName":"subnetArn"},"OutpostArn":{"locationName":"outpostArn"},"EnableDns64":{"locationName":"enableDns64","type":"boolean"},"Ipv6Native":{"locationName":"ipv6Native","type":"boolean"},"PrivateDnsNameOptionsOnLaunch":{"locationName":"privateDnsNameOptionsOnLaunch","type":"structure","members":{"HostnameType":{"locationName":"hostnameType"},"EnableResourceNameDnsARecord":{"locationName":"enableResourceNameDnsARecord","type":"boolean"},"EnableResourceNameDnsAAAARecord":{"locationName":"enableResourceNameDnsAAAARecord","type":"boolean"}}}}},"Sbo":{"type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"InstanceTenancy":{"locationName":"instanceTenancy"},"Ipv6CidrBlockAssociationSet":{"locationName":"ipv6CidrBlockAssociationSet","type":"list","member":{"shape":"S5q","locationName":"item"}},"CidrBlockAssociationSet":{"locationName":"cidrBlockAssociationSet","type":"list","member":{"shape":"S5t","locationName":"item"}},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sbx":{"type":"structure","members":{"DhcpConfigurations":{"locationName":"dhcpConfigurationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Values":{"locationName":"valueSet","type":"list","member":{"shape":"Sc1","locationName":"item"}}}}},"DhcpOptionsId":{"locationName":"dhcpOptionsId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sc1":{"type":"structure","members":{"Value":{"locationName":"value"}}},"Sc4":{"type":"structure","members":{"Attachments":{"shape":"Sc5","locationName":"attachmentSet"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sc5":{"type":"list","member":{"locationName":"item","type":"structure","members":{"State":{"locationName":"state"},"VpcId":{"locationName":"vpcId"}}}},"Sck":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"Overrides":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{},"MaxPrice":{},"SubnetId":{},"AvailabilityZone":{},"WeightedCapacity":{"type":"double"},"Priority":{"type":"double"},"Placement":{"shape":"Scr"},"InstanceRequirements":{"shape":"Scu"},"ImageId":{}}}}}}},"Scr":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"PartitionNumber":{"locationName":"partitionNumber","type":"integer"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"},"HostResourceGroupArn":{"locationName":"hostResourceGroupArn"},"GroupId":{"locationName":"groupId"}}},"Scu":{"type":"structure","required":["VCpuCount","MemoryMiB"],"members":{"VCpuCount":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"MemoryMiB":{"type":"structure","required":["Min"],"members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"CpuManufacturers":{"shape":"Scx","locationName":"CpuManufacturer"},"MemoryGiBPerVCpu":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"ExcludedInstanceTypes":{"shape":"Sd0","locationName":"ExcludedInstanceType"},"InstanceGenerations":{"shape":"Sd2","locationName":"InstanceGeneration"},"SpotMaxPricePercentageOverLowestPrice":{"type":"integer"},"OnDemandMaxPricePercentageOverLowestPrice":{"type":"integer"},"BareMetal":{},"BurstablePerformance":{},"RequireHibernateSupport":{"type":"boolean"},"NetworkInterfaceCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"LocalStorage":{},"LocalStorageTypes":{"shape":"Sd8","locationName":"LocalStorageType"},"TotalLocalStorageGB":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"BaselineEbsBandwidthMbps":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorTypes":{"shape":"Sdc","locationName":"AcceleratorType"},"AcceleratorCount":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"AcceleratorManufacturers":{"shape":"Sdf","locationName":"AcceleratorManufacturer"},"AcceleratorNames":{"shape":"Sdh","locationName":"AcceleratorName"},"AcceleratorTotalMemoryMiB":{"type":"structure","members":{"Min":{"type":"integer"},"Max":{"type":"integer"}}},"NetworkBandwidthGbps":{"type":"structure","members":{"Min":{"type":"double"},"Max":{"type":"double"}}},"AllowedInstanceTypes":{"shape":"Sdl","locationName":"AllowedInstanceType"},"MaxSpotPriceAsPercentageOfOptimalOnDemandPrice":{"type":"integer"}}},"Scx":{"type":"list","member":{"locationName":"item"}},"Sd0":{"type":"list","member":{"locationName":"item"}},"Sd2":{"type":"list","member":{"locationName":"item"}},"Sd8":{"type":"list","member":{"locationName":"item"}},"Sdc":{"type":"list","member":{"locationName":"item"}},"Sdf":{"type":"list","member":{"locationName":"item"}},"Sdh":{"type":"list","member":{"locationName":"item"}},"Sdl":{"type":"list","member":{"locationName":"item"}},"Sdn":{"type":"structure","required":["TotalTargetCapacity"],"members":{"TotalTargetCapacity":{"type":"integer"},"OnDemandTargetCapacity":{"type":"integer"},"SpotTargetCapacity":{"type":"integer"},"DefaultTargetCapacityType":{},"TargetCapacityUnitType":{}}},"Sdv":{"type":"structure","members":{"LaunchTemplateSpecification":{"shape":"Sdw","locationName":"launchTemplateSpecification"},"Overrides":{"shape":"Sdx","locationName":"overrides"}}},"Sdw":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"Version":{"locationName":"version"}}},"Sdx":{"type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"MaxPrice":{"locationName":"maxPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"},"Placement":{"locationName":"placement","type":"structure","members":{"GroupName":{"locationName":"groupName"}}},"InstanceRequirements":{"shape":"Sdz","locationName":"instanceRequirements"},"ImageId":{"locationName":"imageId"}}},"Sdz":{"type":"structure","members":{"VCpuCount":{"locationName":"vCpuCount","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"MemoryMiB":{"locationName":"memoryMiB","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"CpuManufacturers":{"shape":"Scx","locationName":"cpuManufacturerSet"},"MemoryGiBPerVCpu":{"locationName":"memoryGiBPerVCpu","type":"structure","members":{"Min":{"locationName":"min","type":"double"},"Max":{"locationName":"max","type":"double"}}},"ExcludedInstanceTypes":{"shape":"Sd0","locationName":"excludedInstanceTypeSet"},"InstanceGenerations":{"shape":"Sd2","locationName":"instanceGenerationSet"},"SpotMaxPricePercentageOverLowestPrice":{"locationName":"spotMaxPricePercentageOverLowestPrice","type":"integer"},"OnDemandMaxPricePercentageOverLowestPrice":{"locationName":"onDemandMaxPricePercentageOverLowestPrice","type":"integer"},"BareMetal":{"locationName":"bareMetal"},"BurstablePerformance":{"locationName":"burstablePerformance"},"RequireHibernateSupport":{"locationName":"requireHibernateSupport","type":"boolean"},"NetworkInterfaceCount":{"locationName":"networkInterfaceCount","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"LocalStorage":{"locationName":"localStorage"},"LocalStorageTypes":{"shape":"Sd8","locationName":"localStorageTypeSet"},"TotalLocalStorageGB":{"locationName":"totalLocalStorageGB","type":"structure","members":{"Min":{"locationName":"min","type":"double"},"Max":{"locationName":"max","type":"double"}}},"BaselineEbsBandwidthMbps":{"locationName":"baselineEbsBandwidthMbps","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"AcceleratorTypes":{"shape":"Sdc","locationName":"acceleratorTypeSet"},"AcceleratorCount":{"locationName":"acceleratorCount","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"AcceleratorManufacturers":{"shape":"Sdf","locationName":"acceleratorManufacturerSet"},"AcceleratorNames":{"shape":"Sdh","locationName":"acceleratorNameSet"},"AcceleratorTotalMemoryMiB":{"locationName":"acceleratorTotalMemoryMiB","type":"structure","members":{"Min":{"locationName":"min","type":"integer"},"Max":{"locationName":"max","type":"integer"}}},"NetworkBandwidthGbps":{"locationName":"networkBandwidthGbps","type":"structure","members":{"Min":{"locationName":"min","type":"double"},"Max":{"locationName":"max","type":"double"}}},"AllowedInstanceTypes":{"shape":"Sdl","locationName":"allowedInstanceTypeSet"},"MaxSpotPriceAsPercentageOfOptimalOnDemandPrice":{"locationName":"maxSpotPriceAsPercentageOfOptimalOnDemandPrice","type":"integer"}}},"Sec":{"type":"list","member":{"locationName":"item"}},"Seo":{"type":"structure","members":{"Bucket":{},"Key":{}}},"Ser":{"type":"list","member":{"shape":"Ses","locationName":"BlockDeviceMapping"}},"Ses":{"type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"},"KmsKeyId":{"locationName":"kmsKeyId"},"Throughput":{"locationName":"throughput","type":"integer"},"OutpostArn":{"locationName":"outpostArn"},"Encrypted":{"locationName":"encrypted","type":"boolean"}}},"NoDevice":{"locationName":"noDevice"}}},"Sf0":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"InstanceConnectEndpointId":{"locationName":"instanceConnectEndpointId"},"InstanceConnectEndpointArn":{"locationName":"instanceConnectEndpointArn"},"State":{"locationName":"state"},"StateMessage":{"locationName":"stateMessage"},"DnsName":{"locationName":"dnsName"},"FipsDnsName":{"locationName":"fipsDnsName"},"NetworkInterfaceIds":{"locationName":"networkInterfaceIdSet","type":"list","member":{"locationName":"item"}},"VpcId":{"locationName":"vpcId"},"AvailabilityZone":{"locationName":"availabilityZone"},"CreatedAt":{"locationName":"createdAt","type":"timestamp"},"SubnetId":{"locationName":"subnetId"},"PreserveClientIp":{"locationName":"preserveClientIp","type":"boolean"},"SecurityGroupIds":{"locationName":"securityGroupIdSet","type":"list","member":{"locationName":"item"}},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sf6":{"type":"list","member":{"type":"structure","members":{"StartWeekDay":{},"StartHour":{"type":"integer"},"EndWeekDay":{},"EndHour":{"type":"integer"}}}},"Sff":{"type":"structure","members":{"Description":{"locationName":"description"},"ExportTaskId":{"locationName":"exportTaskId"},"ExportToS3Task":{"locationName":"exportToS3","type":"structure","members":{"ContainerFormat":{"locationName":"containerFormat"},"DiskImageFormat":{"locationName":"diskImageFormat"},"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"InstanceExportDetails":{"locationName":"instanceExport","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"TargetEnvironment":{"locationName":"targetEnvironment"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sfl":{"type":"structure","members":{"Attachments":{"shape":"Sc5","locationName":"attachmentSet"},"InternetGatewayId":{"locationName":"internetGatewayId"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sfn":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"Sfr":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamId":{"locationName":"ipamId"},"IpamArn":{"locationName":"ipamArn"},"IpamRegion":{"locationName":"ipamRegion"},"PublicDefaultScopeId":{"locationName":"publicDefaultScopeId"},"PrivateDefaultScopeId":{"locationName":"privateDefaultScopeId"},"ScopeCount":{"locationName":"scopeCount","type":"integer"},"Description":{"locationName":"description"},"OperatingRegions":{"shape":"Sft","locationName":"operatingRegionSet"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"},"DefaultResourceDiscoveryId":{"locationName":"defaultResourceDiscoveryId"},"DefaultResourceDiscoveryAssociationId":{"locationName":"defaultResourceDiscoveryAssociationId"},"ResourceDiscoveryAssociationCount":{"locationName":"resourceDiscoveryAssociationCount","type":"integer"},"StateMessage":{"locationName":"stateMessage"},"Tier":{"locationName":"tier"}}},"Sft":{"type":"list","member":{"locationName":"item","type":"structure","members":{"RegionName":{"locationName":"regionName"}}}},"Sfz":{"type":"list","member":{"shape":"Sg0","locationName":"item"}},"Sg0":{"type":"structure","members":{"Key":{},"Value":{}}},"Sg6":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamPoolId":{"locationName":"ipamPoolId"},"SourceIpamPoolId":{"locationName":"sourceIpamPoolId"},"IpamPoolArn":{"locationName":"ipamPoolArn"},"IpamScopeArn":{"locationName":"ipamScopeArn"},"IpamScopeType":{"locationName":"ipamScopeType"},"IpamArn":{"locationName":"ipamArn"},"IpamRegion":{"locationName":"ipamRegion"},"Locale":{"locationName":"locale"},"PoolDepth":{"locationName":"poolDepth","type":"integer"},"State":{"locationName":"state"},"StateMessage":{"locationName":"stateMessage"},"Description":{"locationName":"description"},"AutoImport":{"locationName":"autoImport","type":"boolean"},"PubliclyAdvertisable":{"locationName":"publiclyAdvertisable","type":"boolean"},"AddressFamily":{"locationName":"addressFamily"},"AllocationMinNetmaskLength":{"locationName":"allocationMinNetmaskLength","type":"integer"},"AllocationMaxNetmaskLength":{"locationName":"allocationMaxNetmaskLength","type":"integer"},"AllocationDefaultNetmaskLength":{"locationName":"allocationDefaultNetmaskLength","type":"integer"},"AllocationResourceTags":{"shape":"Sg9","locationName":"allocationResourceTagSet"},"Tags":{"shape":"S6","locationName":"tagSet"},"AwsService":{"locationName":"awsService"},"PublicIpSource":{"locationName":"publicIpSource"},"SourceResource":{"locationName":"sourceResource","type":"structure","members":{"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceOwner":{"locationName":"resourceOwner"}}}}},"Sg9":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Key":{"locationName":"key"},"Value":{"locationName":"value"}}}},"Sge":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamResourceDiscoveryId":{"locationName":"ipamResourceDiscoveryId"},"IpamResourceDiscoveryArn":{"locationName":"ipamResourceDiscoveryArn"},"IpamResourceDiscoveryRegion":{"locationName":"ipamResourceDiscoveryRegion"},"Description":{"locationName":"description"},"OperatingRegions":{"shape":"Sft","locationName":"operatingRegionSet"},"IsDefault":{"locationName":"isDefault","type":"boolean"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sgi":{"type":"structure","members":{"OwnerId":{"locationName":"ownerId"},"IpamScopeId":{"locationName":"ipamScopeId"},"IpamScopeArn":{"locationName":"ipamScopeArn"},"IpamArn":{"locationName":"ipamArn"},"IpamRegion":{"locationName":"ipamRegion"},"IpamScopeType":{"locationName":"ipamScopeType"},"IsDefault":{"locationName":"isDefault","type":"boolean"},"Description":{"locationName":"description"},"PoolCount":{"locationName":"poolCount","type":"integer"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sgo":{"type":"string","sensitive":true},"Sgr":{"type":"structure","members":{"KernelId":{},"EbsOptimized":{"type":"boolean"},"IamInstanceProfile":{"type":"structure","members":{"Arn":{},"Name":{}}},"BlockDeviceMappings":{"locationName":"BlockDeviceMapping","type":"list","member":{"locationName":"BlockDeviceMapping","type":"structure","members":{"DeviceName":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"Encrypted":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Iops":{"type":"integer"},"KmsKeyId":{},"SnapshotId":{},"VolumeSize":{"type":"integer"},"VolumeType":{},"Throughput":{"type":"integer"}}},"NoDevice":{}}}},"NetworkInterfaces":{"locationName":"NetworkInterface","type":"list","member":{"locationName":"InstanceNetworkInterfaceSpecification","type":"structure","members":{"AssociateCarrierIpAddress":{"type":"boolean"},"AssociatePublicIpAddress":{"type":"boolean"},"DeleteOnTermination":{"type":"boolean"},"Description":{},"DeviceIndex":{"type":"integer"},"Groups":{"shape":"Sgz","locationName":"SecurityGroupId"},"InterfaceType":{},"Ipv6AddressCount":{"type":"integer"},"Ipv6Addresses":{"type":"list","member":{"locationName":"InstanceIpv6Address","type":"structure","members":{"Ipv6Address":{}}}},"NetworkInterfaceId":{},"PrivateIpAddress":{},"PrivateIpAddresses":{"shape":"Sh2"},"SecondaryPrivateIpAddressCount":{"type":"integer"},"SubnetId":{},"NetworkCardIndex":{"type":"integer"},"Ipv4Prefixes":{"shape":"Sh4","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"Sh6","locationName":"Ipv6Prefix"},"Ipv6PrefixCount":{"type":"integer"},"PrimaryIpv6":{"type":"boolean"},"EnaSrdSpecification":{"shape":"Sh8"},"ConnectionTrackingSpecification":{"shape":"Sha"}}}},"ImageId":{},"InstanceType":{},"KeyName":{},"Monitoring":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"Placement":{"type":"structure","members":{"AvailabilityZone":{},"Affinity":{},"GroupName":{},"HostId":{},"Tenancy":{},"SpreadDomain":{},"HostResourceGroupArn":{},"PartitionNumber":{"type":"integer"},"GroupId":{}}},"RamDiskId":{},"DisableApiTermination":{"type":"boolean"},"InstanceInitiatedShutdownBehavior":{},"UserData":{"shape":"Sgo"},"TagSpecifications":{"locationName":"TagSpecification","type":"list","member":{"locationName":"LaunchTemplateTagSpecificationRequest","type":"structure","members":{"ResourceType":{},"Tags":{"shape":"S6","locationName":"Tag"}}}},"ElasticGpuSpecifications":{"locationName":"ElasticGpuSpecification","type":"list","member":{"shape":"Shj","locationName":"ElasticGpuSpecification"}},"ElasticInferenceAccelerators":{"locationName":"ElasticInferenceAccelerator","type":"list","member":{"locationName":"item","type":"structure","required":["Type"],"members":{"Type":{},"Count":{"type":"integer"}}}},"SecurityGroupIds":{"shape":"Sgz","locationName":"SecurityGroupId"},"SecurityGroups":{"shape":"Shn","locationName":"SecurityGroup"},"InstanceMarketOptions":{"type":"structure","members":{"MarketType":{},"SpotOptions":{"type":"structure","members":{"MaxPrice":{},"SpotInstanceType":{},"BlockDurationMinutes":{"type":"integer"},"ValidUntil":{"type":"timestamp"},"InstanceInterruptionBehavior":{}}}}},"CreditSpecification":{"shape":"Sht"},"CpuOptions":{"type":"structure","members":{"CoreCount":{"type":"integer"},"ThreadsPerCore":{"type":"integer"},"AmdSevSnp":{}}},"CapacityReservationSpecification":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"Shy"}}},"LicenseSpecifications":{"locationName":"LicenseSpecification","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{}}}},"HibernationOptions":{"type":"structure","members":{"Configured":{"type":"boolean"}}},"MetadataOptions":{"type":"structure","members":{"HttpTokens":{},"HttpPutResponseHopLimit":{"type":"integer"},"HttpEndpoint":{},"HttpProtocolIpv6":{},"InstanceMetadataTags":{}}},"EnclaveOptions":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"InstanceRequirements":{"shape":"Scu"},"PrivateDnsNameOptions":{"type":"structure","members":{"HostnameType":{},"EnableResourceNameDnsARecord":{"type":"boolean"},"EnableResourceNameDnsAAAARecord":{"type":"boolean"}}},"MaintenanceOptions":{"type":"structure","members":{"AutoRecovery":{}}},"DisableApiStop":{"type":"boolean"}}},"Sgz":{"type":"list","member":{"locationName":"SecurityGroupId"}},"Sh2":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Primary":{"locationName":"primary","type":"boolean"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"Sh4":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{}}}},"Sh6":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{}}}},"Sh8":{"type":"structure","members":{"EnaSrdEnabled":{"type":"boolean"},"EnaSrdUdpSpecification":{"type":"structure","members":{"EnaSrdUdpEnabled":{"type":"boolean"}}}}},"Sha":{"type":"structure","members":{"TcpEstablishedTimeout":{"type":"integer"},"UdpStreamTimeout":{"type":"integer"},"UdpTimeout":{"type":"integer"}}},"Shj":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Shn":{"type":"list","member":{"locationName":"SecurityGroup"}},"Sht":{"type":"structure","required":["CpuCredits"],"members":{"CpuCredits":{}}},"Shy":{"type":"structure","members":{"CapacityReservationId":{},"CapacityReservationResourceGroupArn":{}}},"Sic":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersionNumber":{"locationName":"defaultVersionNumber","type":"long"},"LatestVersionNumber":{"locationName":"latestVersionNumber","type":"long"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sid":{"type":"structure","members":{"Errors":{"locationName":"errorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}}}}},"Sii":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"VersionNumber":{"locationName":"versionNumber","type":"long"},"VersionDescription":{"locationName":"versionDescription"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"CreatedBy":{"locationName":"createdBy"},"DefaultVersion":{"locationName":"defaultVersion","type":"boolean"},"LaunchTemplateData":{"shape":"Sij","locationName":"launchTemplateData"}}},"Sij":{"type":"structure","members":{"KernelId":{"locationName":"kernelId"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"locationName":"iamInstanceProfile","type":"structure","members":{"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"BlockDeviceMappings":{"locationName":"blockDeviceMappingSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"VirtualName":{"locationName":"virtualName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"Encrypted":{"locationName":"encrypted","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Iops":{"locationName":"iops","type":"integer"},"KmsKeyId":{"locationName":"kmsKeyId"},"SnapshotId":{"locationName":"snapshotId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"VolumeType":{"locationName":"volumeType"},"Throughput":{"locationName":"throughput","type":"integer"}}},"NoDevice":{"locationName":"noDevice"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AssociateCarrierIpAddress":{"locationName":"associateCarrierIpAddress","type":"boolean"},"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"S5v","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Siq","locationName":"ipv6AddressesSet"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"Sh2","locationName":"privateIpAddressesSet"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"},"Ipv4Prefixes":{"locationName":"ipv4PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{"locationName":"ipv4Prefix"}}}},"Ipv4PrefixCount":{"locationName":"ipv4PrefixCount","type":"integer"},"Ipv6Prefixes":{"locationName":"ipv6PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{"locationName":"ipv6Prefix"}}}},"Ipv6PrefixCount":{"locationName":"ipv6PrefixCount","type":"integer"},"PrimaryIpv6":{"locationName":"primaryIpv6","type":"boolean"},"EnaSrdSpecification":{"locationName":"enaSrdSpecification","type":"structure","members":{"EnaSrdEnabled":{"locationName":"enaSrdEnabled","type":"boolean"},"EnaSrdUdpSpecification":{"locationName":"enaSrdUdpSpecification","type":"structure","members":{"EnaSrdUdpEnabled":{"locationName":"enaSrdUdpEnabled","type":"boolean"}}}}},"ConnectionTrackingSpecification":{"locationName":"connectionTrackingSpecification","type":"structure","members":{"TcpEstablishedTimeout":{"locationName":"tcpEstablishedTimeout","type":"integer"},"UdpTimeout":{"locationName":"udpTimeout","type":"integer"},"UdpStreamTimeout":{"locationName":"udpStreamTimeout","type":"integer"}}}}}},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"Placement":{"locationName":"placement","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"Affinity":{"locationName":"affinity"},"GroupName":{"locationName":"groupName"},"HostId":{"locationName":"hostId"},"Tenancy":{"locationName":"tenancy"},"SpreadDomain":{"locationName":"spreadDomain"},"HostResourceGroupArn":{"locationName":"hostResourceGroupArn"},"PartitionNumber":{"locationName":"partitionNumber","type":"integer"},"GroupId":{"locationName":"groupId"}}},"RamDiskId":{"locationName":"ramDiskId"},"DisableApiTermination":{"locationName":"disableApiTermination","type":"boolean"},"InstanceInitiatedShutdownBehavior":{"locationName":"instanceInitiatedShutdownBehavior"},"UserData":{"shape":"Sgo","locationName":"userData"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"S6","locationName":"tagSet"}}}},"ElasticGpuSpecifications":{"locationName":"elasticGpuSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"}}}},"ElasticInferenceAccelerators":{"locationName":"elasticInferenceAcceleratorSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Type":{"locationName":"type"},"Count":{"locationName":"count","type":"integer"}}}},"SecurityGroupIds":{"shape":"So","locationName":"securityGroupIdSet"},"SecurityGroups":{"shape":"So","locationName":"securityGroupSet"},"InstanceMarketOptions":{"locationName":"instanceMarketOptions","type":"structure","members":{"MarketType":{"locationName":"marketType"},"SpotOptions":{"locationName":"spotOptions","type":"structure","members":{"MaxPrice":{"locationName":"maxPrice"},"SpotInstanceType":{"locationName":"spotInstanceType"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}}},"CreditSpecification":{"locationName":"creditSpecification","type":"structure","members":{"CpuCredits":{"locationName":"cpuCredits"}}},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"},"AmdSevSnp":{"locationName":"amdSevSnp"}}},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"Sjc","locationName":"capacityReservationTarget"}}},"LicenseSpecifications":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}},"MetadataOptions":{"locationName":"metadataOptions","type":"structure","members":{"State":{"locationName":"state"},"HttpTokens":{"locationName":"httpTokens"},"HttpPutResponseHopLimit":{"locationName":"httpPutResponseHopLimit","type":"integer"},"HttpEndpoint":{"locationName":"httpEndpoint"},"HttpProtocolIpv6":{"locationName":"httpProtocolIpv6"},"InstanceMetadataTags":{"locationName":"instanceMetadataTags"}}},"EnclaveOptions":{"locationName":"enclaveOptions","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"InstanceRequirements":{"shape":"Sdz","locationName":"instanceRequirements"},"PrivateDnsNameOptions":{"locationName":"privateDnsNameOptions","type":"structure","members":{"HostnameType":{"locationName":"hostnameType"},"EnableResourceNameDnsARecord":{"locationName":"enableResourceNameDnsARecord","type":"boolean"},"EnableResourceNameDnsAAAARecord":{"locationName":"enableResourceNameDnsAAAARecord","type":"boolean"}}},"MaintenanceOptions":{"locationName":"maintenanceOptions","type":"structure","members":{"AutoRecovery":{"locationName":"autoRecovery"}}},"DisableApiStop":{"locationName":"disableApiStop","type":"boolean"}}},"Siq":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"},"IsPrimaryIpv6":{"locationName":"isPrimaryIpv6","type":"boolean"}}}},"Sjc":{"type":"structure","members":{"CapacityReservationId":{"locationName":"capacityReservationId"},"CapacityReservationResourceGroupArn":{"locationName":"capacityReservationResourceGroupArn"}}},"Sjo":{"type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"Type":{"locationName":"type"},"State":{"locationName":"state"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"OwnerId":{"locationName":"ownerId"},"SubnetId":{"locationName":"subnetId"},"CoipPoolId":{"locationName":"coipPoolId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"}}},"Sjv":{"type":"structure","members":{"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"LocalGatewayId":{"locationName":"localGatewayId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"},"Mode":{"locationName":"mode"},"StateReason":{"shape":"Sjw","locationName":"stateReason"}}},"Sjw":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Sjz":{"type":"structure","members":{"LocalGatewayRouteTableVirtualInterfaceGroupAssociationId":{"locationName":"localGatewayRouteTableVirtualInterfaceGroupAssociationId"},"LocalGatewayVirtualInterfaceGroupId":{"locationName":"localGatewayVirtualInterfaceGroupId"},"LocalGatewayId":{"locationName":"localGatewayId"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sk3":{"type":"structure","members":{"LocalGatewayRouteTableVpcAssociationId":{"locationName":"localGatewayRouteTableVpcAssociationId"},"LocalGatewayRouteTableId":{"locationName":"localGatewayRouteTableId"},"LocalGatewayRouteTableArn":{"locationName":"localGatewayRouteTableArn"},"LocalGatewayId":{"locationName":"localGatewayId"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"},"State":{"locationName":"state"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sk6":{"type":"list","member":{"type":"structure","required":["Cidr"],"members":{"Cidr":{},"Description":{}}}},"Sk9":{"type":"structure","members":{"PrefixListId":{"locationName":"prefixListId"},"AddressFamily":{"locationName":"addressFamily"},"State":{"locationName":"state"},"StateMessage":{"locationName":"stateMessage"},"PrefixListArn":{"locationName":"prefixListArn"},"PrefixListName":{"locationName":"prefixListName"},"MaxEntries":{"locationName":"maxEntries","type":"integer"},"Version":{"locationName":"version","type":"long"},"Tags":{"shape":"S6","locationName":"tagSet"},"OwnerId":{"locationName":"ownerId"}}},"Ske":{"type":"structure","members":{"CreateTime":{"locationName":"createTime","type":"timestamp"},"DeleteTime":{"locationName":"deleteTime","type":"timestamp"},"FailureCode":{"locationName":"failureCode"},"FailureMessage":{"locationName":"failureMessage"},"NatGatewayAddresses":{"shape":"S3b","locationName":"natGatewayAddressSet"},"NatGatewayId":{"locationName":"natGatewayId"},"ProvisionedBandwidth":{"locationName":"provisionedBandwidth","type":"structure","members":{"ProvisionTime":{"locationName":"provisionTime","type":"timestamp"},"Provisioned":{"locationName":"provisioned"},"RequestTime":{"locationName":"requestTime","type":"timestamp"},"Requested":{"locationName":"requested"},"Status":{"locationName":"status"}}},"State":{"locationName":"state"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Tags":{"shape":"S6","locationName":"tagSet"},"ConnectivityType":{"locationName":"connectivityType"}}},"Skj":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"NetworkAclAssociationId":{"locationName":"networkAclAssociationId"},"NetworkAclId":{"locationName":"networkAclId"},"SubnetId":{"locationName":"subnetId"}}}},"Entries":{"locationName":"entrySet","type":"list","member":{"locationName":"item","type":"structure","members":{"CidrBlock":{"locationName":"cidrBlock"},"Egress":{"locationName":"egress","type":"boolean"},"IcmpTypeCode":{"shape":"Sko","locationName":"icmpTypeCode"},"Ipv6CidrBlock":{"locationName":"ipv6CidrBlock"},"PortRange":{"shape":"Skp","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}}},"IsDefault":{"locationName":"default","type":"boolean"},"NetworkAclId":{"locationName":"networkAclId"},"Tags":{"shape":"S6","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Sko":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Type":{"locationName":"type","type":"integer"}}},"Skp":{"type":"structure","members":{"From":{"locationName":"from","type":"integer"},"To":{"locationName":"to","type":"integer"}}},"Sku":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Source":{"shape":"Skw"},"Destination":{"shape":"Skw"},"ThroughResources":{"locationName":"ThroughResource","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceStatement":{"shape":"Sl0"}}}}}}},"Skw":{"type":"structure","members":{"PacketHeaderStatement":{"type":"structure","members":{"SourceAddresses":{"shape":"So","locationName":"SourceAddress"},"DestinationAddresses":{"shape":"So","locationName":"DestinationAddress"},"SourcePorts":{"shape":"So","locationName":"SourcePort"},"DestinationPorts":{"shape":"So","locationName":"DestinationPort"},"SourcePrefixLists":{"shape":"So","locationName":"SourcePrefixList"},"DestinationPrefixLists":{"shape":"So","locationName":"DestinationPrefixList"},"Protocols":{"shape":"Sky","locationName":"Protocol"}}},"ResourceStatement":{"shape":"Sl0"}}},"Sky":{"type":"list","member":{"locationName":"item"}},"Sl0":{"type":"structure","members":{"Resources":{"shape":"So","locationName":"Resource"},"ResourceTypes":{"shape":"So","locationName":"ResourceType"}}},"Sl4":{"type":"structure","members":{"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"NetworkInsightsAccessScopeArn":{"locationName":"networkInsightsAccessScopeArn"},"CreatedDate":{"locationName":"createdDate","type":"timestamp"},"UpdatedDate":{"locationName":"updatedDate","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sl6":{"type":"structure","members":{"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"MatchPaths":{"shape":"Sl7","locationName":"matchPathSet"},"ExcludePaths":{"shape":"Sl7","locationName":"excludePathSet"}}},"Sl7":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Source":{"shape":"Sl9","locationName":"source"},"Destination":{"shape":"Sl9","locationName":"destination"},"ThroughResources":{"locationName":"throughResourceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceStatement":{"shape":"Slb","locationName":"resourceStatement"}}}}}}},"Sl9":{"type":"structure","members":{"PacketHeaderStatement":{"locationName":"packetHeaderStatement","type":"structure","members":{"SourceAddresses":{"shape":"So","locationName":"sourceAddressSet"},"DestinationAddresses":{"shape":"So","locationName":"destinationAddressSet"},"SourcePorts":{"shape":"So","locationName":"sourcePortSet"},"DestinationPorts":{"shape":"So","locationName":"destinationPortSet"},"SourcePrefixLists":{"shape":"So","locationName":"sourcePrefixListSet"},"DestinationPrefixLists":{"shape":"So","locationName":"destinationPrefixListSet"},"Protocols":{"shape":"Sky","locationName":"protocolSet"}}},"ResourceStatement":{"shape":"Slb","locationName":"resourceStatement"}}},"Slb":{"type":"structure","members":{"Resources":{"shape":"So","locationName":"resourceSet"},"ResourceTypes":{"shape":"So","locationName":"resourceTypeSet"}}},"Sli":{"type":"structure","members":{"SourceAddress":{},"SourcePortRange":{"shape":"Slj"},"DestinationAddress":{},"DestinationPortRange":{"shape":"Slj"}}},"Slj":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}},"Sll":{"type":"structure","members":{"NetworkInsightsPathId":{"locationName":"networkInsightsPathId"},"NetworkInsightsPathArn":{"locationName":"networkInsightsPathArn"},"CreatedDate":{"locationName":"createdDate","type":"timestamp"},"Source":{"locationName":"source"},"Destination":{"locationName":"destination"},"SourceArn":{"locationName":"sourceArn"},"DestinationArn":{"locationName":"destinationArn"},"SourceIp":{"locationName":"sourceIp"},"DestinationIp":{"locationName":"destinationIp"},"Protocol":{"locationName":"protocol"},"DestinationPort":{"locationName":"destinationPort","type":"integer"},"Tags":{"shape":"S6","locationName":"tagSet"},"FilterAtSource":{"shape":"Sln","locationName":"filterAtSource"},"FilterAtDestination":{"shape":"Sln","locationName":"filterAtDestination"}}},"Sln":{"type":"structure","members":{"SourceAddress":{"locationName":"sourceAddress"},"SourcePortRange":{"shape":"Slo","locationName":"sourcePortRange"},"DestinationAddress":{"locationName":"destinationAddress"},"DestinationPortRange":{"shape":"Slo","locationName":"destinationPortRange"}}},"Slo":{"type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"ToPort":{"locationName":"toPort","type":"integer"}}},"Sls":{"type":"structure","members":{"Association":{"shape":"Slt","locationName":"association"},"Attachment":{"shape":"Slu","locationName":"attachment"},"AvailabilityZone":{"locationName":"availabilityZone"},"ConnectionTrackingConfiguration":{"locationName":"connectionTrackingConfiguration","type":"structure","members":{"TcpEstablishedTimeout":{"locationName":"tcpEstablishedTimeout","type":"integer"},"UdpStreamTimeout":{"locationName":"udpStreamTimeout","type":"integer"},"UdpTimeout":{"locationName":"udpTimeout","type":"integer"}}},"Description":{"locationName":"description"},"Groups":{"shape":"Sly","locationName":"groupSet"},"InterfaceType":{"locationName":"interfaceType"},"Ipv6Addresses":{"locationName":"ipv6AddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Address":{"locationName":"ipv6Address"},"IsPrimaryIpv6":{"locationName":"isPrimaryIpv6","type":"boolean"}}}},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OutpostArn":{"locationName":"outpostArn"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"Slt","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"Ipv4Prefixes":{"shape":"S34","locationName":"ipv4PrefixSet"},"Ipv6Prefixes":{"locationName":"ipv6PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{"locationName":"ipv6Prefix"}}}},"RequesterId":{"locationName":"requesterId"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"TagSet":{"shape":"S6","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"DenyAllIgwTraffic":{"locationName":"denyAllIgwTraffic","type":"boolean"},"Ipv6Native":{"locationName":"ipv6Native","type":"boolean"},"Ipv6Address":{"locationName":"ipv6Address"}}},"Slt":{"type":"structure","members":{"AllocationId":{"locationName":"allocationId"},"AssociationId":{"locationName":"associationId"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"CarrierIp":{"locationName":"carrierIp"}}},"Slu":{"type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"Status":{"locationName":"status"},"EnaSrdSpecification":{"locationName":"enaSrdSpecification","type":"structure","members":{"EnaSrdEnabled":{"locationName":"enaSrdEnabled","type":"boolean"},"EnaSrdUdpSpecification":{"locationName":"enaSrdUdpSpecification","type":"structure","members":{"EnaSrdUdpEnabled":{"locationName":"enaSrdUdpEnabled","type":"boolean"}}}}}}},"Sly":{"type":"list","member":{"locationName":"item","type":"structure","members":{"GroupName":{"locationName":"groupName"},"GroupId":{"locationName":"groupId"}}}},"Smb":{"type":"structure","members":{"NetworkInterfacePermissionId":{"locationName":"networkInterfacePermissionId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"AwsAccountId":{"locationName":"awsAccountId"},"AwsService":{"locationName":"awsService"},"Permission":{"locationName":"permission"},"PermissionState":{"locationName":"permissionState","type":"structure","members":{"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"}}}}},"Smi":{"type":"structure","members":{"GroupName":{"locationName":"groupName"},"State":{"locationName":"state"},"Strategy":{"locationName":"strategy"},"PartitionCount":{"locationName":"partitionCount","type":"integer"},"GroupId":{"locationName":"groupId"},"Tags":{"shape":"S6","locationName":"tagSet"},"GroupArn":{"locationName":"groupArn"},"SpreadLevel":{"locationName":"spreadLevel"}}},"Smo":{"type":"structure","members":{"ReplaceRootVolumeTaskId":{"locationName":"replaceRootVolumeTaskId"},"InstanceId":{"locationName":"instanceId"},"TaskState":{"locationName":"taskState"},"StartTime":{"locationName":"startTime"},"CompleteTime":{"locationName":"completeTime"},"Tags":{"shape":"S6","locationName":"tagSet"},"ImageId":{"locationName":"imageId"},"SnapshotId":{"locationName":"snapshotId"},"DeleteReplacedRootVolume":{"locationName":"deleteReplacedRootVolume","type":"boolean"}}},"Sn4":{"type":"structure","members":{"Associations":{"locationName":"associationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Main":{"locationName":"main","type":"boolean"},"RouteTableAssociationId":{"locationName":"routeTableAssociationId"},"RouteTableId":{"locationName":"routeTableId"},"SubnetId":{"locationName":"subnetId"},"GatewayId":{"locationName":"gatewayId"},"AssociationState":{"shape":"S4x","locationName":"associationState"}}}},"PropagatingVgws":{"locationName":"propagatingVgwSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GatewayId":{"locationName":"gatewayId"}}}},"RouteTableId":{"locationName":"routeTableId"},"Routes":{"locationName":"routeSet","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"DestinationIpv6CidrBlock":{"locationName":"destinationIpv6CidrBlock"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"InstanceOwnerId":{"locationName":"instanceOwnerId"},"NatGatewayId":{"locationName":"natGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"LocalGatewayId":{"locationName":"localGatewayId"},"CarrierGatewayId":{"locationName":"carrierGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"State":{"locationName":"state"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"CoreNetworkArn":{"locationName":"coreNetworkArn"}}}},"Tags":{"shape":"S6","locationName":"tagSet"},"VpcId":{"locationName":"vpcId"},"OwnerId":{"locationName":"ownerId"}}},"Sng":{"type":"structure","members":{"DataEncryptionKeyId":{"locationName":"dataEncryptionKeyId"},"Description":{"locationName":"description"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OwnerId":{"locationName":"ownerId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"StartTime":{"locationName":"startTime","type":"timestamp"},"State":{"locationName":"status"},"StateMessage":{"locationName":"statusMessage"},"VolumeId":{"locationName":"volumeId"},"VolumeSize":{"locationName":"volumeSize","type":"integer"},"OwnerAlias":{"locationName":"ownerAlias"},"OutpostArn":{"locationName":"outpostArn"},"Tags":{"shape":"S6","locationName":"tagSet"},"StorageTier":{"locationName":"storageTier"},"RestoreExpiryTime":{"locationName":"restoreExpiryTime","type":"timestamp"},"SseType":{"locationName":"sseType"}}},"Snn":{"type":"list","member":{"locationName":"VolumeId"}},"Snu":{"type":"structure","members":{"Bucket":{"locationName":"bucket"},"Fault":{"shape":"Snv","locationName":"fault"},"OwnerId":{"locationName":"ownerId"},"Prefix":{"locationName":"prefix"},"State":{"locationName":"state"}}},"Snv":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"So6":{"type":"structure","members":{"SubnetCidrReservationId":{"locationName":"subnetCidrReservationId"},"SubnetId":{"locationName":"subnetId"},"Cidr":{"locationName":"cidr"},"ReservationType":{"locationName":"reservationType"},"OwnerId":{"locationName":"ownerId"},"Description":{"locationName":"description"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"So9":{"type":"list","member":{}},"Sod":{"type":"structure","members":{"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"IngressFilterRules":{"shape":"Soe","locationName":"ingressFilterRuleSet"},"EgressFilterRules":{"shape":"Soe","locationName":"egressFilterRuleSet"},"NetworkServices":{"shape":"Soj","locationName":"networkServiceSet"},"Description":{"locationName":"description"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Soe":{"type":"list","member":{"shape":"Sof","locationName":"item"}},"Sof":{"type":"structure","members":{"TrafficMirrorFilterRuleId":{"locationName":"trafficMirrorFilterRuleId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"TrafficDirection":{"locationName":"trafficDirection"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"},"RuleAction":{"locationName":"ruleAction"},"Protocol":{"locationName":"protocol","type":"integer"},"DestinationPortRange":{"shape":"Soi","locationName":"destinationPortRange"},"SourcePortRange":{"shape":"Soi","locationName":"sourcePortRange"},"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"SourceCidrBlock":{"locationName":"sourceCidrBlock"},"Description":{"locationName":"description"}}},"Soi":{"type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"ToPort":{"locationName":"toPort","type":"integer"}}},"Soj":{"type":"list","member":{"locationName":"item"}},"Son":{"type":"structure","members":{"FromPort":{"type":"integer"},"ToPort":{"type":"integer"}}},"Sos":{"type":"structure","members":{"TrafficMirrorSessionId":{"locationName":"trafficMirrorSessionId"},"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"TrafficMirrorFilterId":{"locationName":"trafficMirrorFilterId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PacketLength":{"locationName":"packetLength","type":"integer"},"SessionNumber":{"locationName":"sessionNumber","type":"integer"},"VirtualNetworkId":{"locationName":"virtualNetworkId","type":"integer"},"Description":{"locationName":"description"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sov":{"type":"structure","members":{"TrafficMirrorTargetId":{"locationName":"trafficMirrorTargetId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"NetworkLoadBalancerArn":{"locationName":"networkLoadBalancerArn"},"Type":{"locationName":"type"},"Description":{"locationName":"description"},"OwnerId":{"locationName":"ownerId"},"Tags":{"shape":"S6","locationName":"tagSet"},"GatewayLoadBalancerEndpointId":{"locationName":"gatewayLoadBalancerEndpointId"}}},"Sp4":{"type":"list","member":{"locationName":"item"}},"Sp6":{"type":"structure","members":{"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayArn":{"locationName":"transitGatewayArn"},"State":{"locationName":"state"},"OwnerId":{"locationName":"ownerId"},"Description":{"locationName":"description"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"TransitGatewayCidrBlocks":{"shape":"So","locationName":"transitGatewayCidrBlocks"},"AutoAcceptSharedAttachments":{"locationName":"autoAcceptSharedAttachments"},"DefaultRouteTableAssociation":{"locationName":"defaultRouteTableAssociation"},"AssociationDefaultRouteTableId":{"locationName":"associationDefaultRouteTableId"},"DefaultRouteTablePropagation":{"locationName":"defaultRouteTablePropagation"},"PropagationDefaultRouteTableId":{"locationName":"propagationDefaultRouteTableId"},"VpnEcmpSupport":{"locationName":"vpnEcmpSupport"},"DnsSupport":{"locationName":"dnsSupport"},"SecurityGroupReferencingSupport":{"locationName":"securityGroupReferencingSupport"},"MulticastSupport":{"locationName":"multicastSupport"}}},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Spd":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransportTransitGatewayAttachmentId":{"locationName":"transportTransitGatewayAttachmentId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Options":{"locationName":"options","type":"structure","members":{"Protocol":{"locationName":"protocol"}}},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sph":{"type":"list","member":{"locationName":"item"}},"Spj":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"TransitGatewayConnectPeerId":{"locationName":"transitGatewayConnectPeerId"},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"ConnectPeerConfiguration":{"locationName":"connectPeerConfiguration","type":"structure","members":{"TransitGatewayAddress":{"locationName":"transitGatewayAddress"},"PeerAddress":{"locationName":"peerAddress"},"InsideCidrBlocks":{"shape":"Sph","locationName":"insideCidrBlocks"},"Protocol":{"locationName":"protocol"},"BgpConfigurations":{"locationName":"bgpConfigurations","type":"list","member":{"locationName":"item","type":"structure","members":{"TransitGatewayAsn":{"locationName":"transitGatewayAsn","type":"long"},"PeerAsn":{"locationName":"peerAsn","type":"long"},"TransitGatewayAddress":{"locationName":"transitGatewayAddress"},"PeerAddress":{"locationName":"peerAddress"},"BgpStatus":{"locationName":"bgpStatus"}}}}}},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Spw":{"type":"structure","members":{"TransitGatewayMulticastDomainId":{"locationName":"transitGatewayMulticastDomainId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"TransitGatewayMulticastDomainArn":{"locationName":"transitGatewayMulticastDomainArn"},"OwnerId":{"locationName":"ownerId"},"Options":{"locationName":"options","type":"structure","members":{"Igmpv2Support":{"locationName":"igmpv2Support"},"StaticSourcesSupport":{"locationName":"staticSourcesSupport"},"AutoAcceptSharedAssociations":{"locationName":"autoAcceptSharedAssociations"}}},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sq5":{"type":"structure","members":{"TransitGatewayPolicyTableId":{"locationName":"transitGatewayPolicyTableId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sq9":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"PrefixListId":{"locationName":"prefixListId"},"PrefixListOwnerId":{"locationName":"prefixListOwnerId"},"State":{"locationName":"state"},"Blackhole":{"locationName":"blackhole","type":"boolean"},"TransitGatewayAttachment":{"locationName":"transitGatewayAttachment","type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceType":{"locationName":"resourceType"},"ResourceId":{"locationName":"resourceId"}}}}},"Sqe":{"type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"PrefixListId":{"locationName":"prefixListId"},"TransitGatewayRouteTableAnnouncementId":{"locationName":"transitGatewayRouteTableAnnouncementId"},"TransitGatewayAttachments":{"locationName":"transitGatewayAttachments","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceId":{"locationName":"resourceId"},"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceType":{"locationName":"resourceType"}}}},"Type":{"locationName":"type"},"State":{"locationName":"state"}}},"Sqm":{"type":"structure","members":{"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"State":{"locationName":"state"},"DefaultAssociationRouteTable":{"locationName":"defaultAssociationRouteTable","type":"boolean"},"DefaultPropagationRouteTable":{"locationName":"defaultPropagationRouteTable","type":"boolean"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sqq":{"type":"structure","members":{"TransitGatewayRouteTableAnnouncementId":{"locationName":"transitGatewayRouteTableAnnouncementId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"CoreNetworkId":{"locationName":"coreNetworkId"},"PeerTransitGatewayId":{"locationName":"peerTransitGatewayId"},"PeerCoreNetworkId":{"locationName":"peerCoreNetworkId"},"PeeringAttachmentId":{"locationName":"peeringAttachmentId"},"AnnouncementDirection":{"locationName":"announcementDirection"},"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"},"CreationTime":{"locationName":"creationTime","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sr1":{"type":"list","member":{"locationName":"item"}},"Sr8":{"type":"structure","members":{"CustomerManagedKeyEnabled":{"type":"boolean"},"KmsKeyArn":{}}},"Sra":{"type":"structure","members":{"VerifiedAccessInstanceId":{"locationName":"verifiedAccessInstanceId"},"VerifiedAccessGroupId":{"locationName":"verifiedAccessGroupId"},"VerifiedAccessEndpointId":{"locationName":"verifiedAccessEndpointId"},"ApplicationDomain":{"locationName":"applicationDomain"},"EndpointType":{"locationName":"endpointType"},"AttachmentType":{"locationName":"attachmentType"},"DomainCertificateArn":{"locationName":"domainCertificateArn"},"EndpointDomain":{"locationName":"endpointDomain"},"DeviceValidationDomain":{"locationName":"deviceValidationDomain"},"SecurityGroupIds":{"shape":"Sr1","locationName":"securityGroupIdSet"},"LoadBalancerOptions":{"locationName":"loadBalancerOptions","type":"structure","members":{"Protocol":{"locationName":"protocol"},"Port":{"locationName":"port","type":"integer"},"LoadBalancerArn":{"locationName":"loadBalancerArn"},"SubnetIds":{"locationName":"subnetIdSet","type":"list","member":{"locationName":"item"}}}},"NetworkInterfaceOptions":{"locationName":"networkInterfaceOptions","type":"structure","members":{"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Protocol":{"locationName":"protocol"},"Port":{"locationName":"port","type":"integer"}}},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"Description":{"locationName":"description"},"CreationTime":{"locationName":"creationTime"},"LastUpdatedTime":{"locationName":"lastUpdatedTime"},"DeletionTime":{"locationName":"deletionTime"},"Tags":{"shape":"S6","locationName":"tagSet"},"SseSpecification":{"shape":"S6e","locationName":"sseSpecification"}}},"Sri":{"type":"structure","members":{"VerifiedAccessGroupId":{"locationName":"verifiedAccessGroupId"},"VerifiedAccessInstanceId":{"locationName":"verifiedAccessInstanceId"},"Description":{"locationName":"description"},"Owner":{"locationName":"owner"},"VerifiedAccessGroupArn":{"locationName":"verifiedAccessGroupArn"},"CreationTime":{"locationName":"creationTime"},"LastUpdatedTime":{"locationName":"lastUpdatedTime"},"DeletionTime":{"locationName":"deletionTime"},"Tags":{"shape":"S6","locationName":"tagSet"},"SseSpecification":{"shape":"S6e","locationName":"sseSpecification"}}},"Srq":{"type":"structure","members":{"Attachments":{"locationName":"attachmentSet","type":"list","member":{"shape":"S6l","locationName":"item"}},"AvailabilityZone":{"locationName":"availabilityZone"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"KmsKeyId":{"locationName":"kmsKeyId"},"OutpostArn":{"locationName":"outpostArn"},"Size":{"locationName":"size","type":"integer"},"SnapshotId":{"locationName":"snapshotId"},"State":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"Iops":{"locationName":"iops","type":"integer"},"Tags":{"shape":"S6","locationName":"tagSet"},"VolumeType":{"locationName":"volumeType"},"FastRestored":{"locationName":"fastRestored","type":"boolean"},"MultiAttachEnabled":{"locationName":"multiAttachEnabled","type":"boolean"},"Throughput":{"locationName":"throughput","type":"integer"},"SseType":{"locationName":"sseType"}}},"Srx":{"type":"list","member":{"locationName":"item"}},"Sry":{"type":"list","member":{"locationName":"item"}},"Srz":{"type":"list","member":{"locationName":"item"}},"Ss1":{"type":"structure","members":{"DnsRecordIpType":{},"PrivateDnsOnlyForInboundResolverEndpoint":{"type":"boolean"}}},"Ss3":{"type":"list","member":{"locationName":"item","type":"structure","members":{"SubnetId":{},"Ipv4":{},"Ipv6":{}}}},"Ss6":{"type":"structure","members":{"VpcEndpointId":{"locationName":"vpcEndpointId"},"VpcEndpointType":{"locationName":"vpcEndpointType"},"VpcId":{"locationName":"vpcId"},"ServiceName":{"locationName":"serviceName"},"State":{"locationName":"state"},"PolicyDocument":{"locationName":"policyDocument"},"RouteTableIds":{"shape":"So","locationName":"routeTableIdSet"},"SubnetIds":{"shape":"So","locationName":"subnetIdSet"},"Groups":{"locationName":"groupSet","type":"list","member":{"locationName":"item","type":"structure","members":{"GroupId":{"locationName":"groupId"},"GroupName":{"locationName":"groupName"}}}},"IpAddressType":{"locationName":"ipAddressType"},"DnsOptions":{"locationName":"dnsOptions","type":"structure","members":{"DnsRecordIpType":{"locationName":"dnsRecordIpType"},"PrivateDnsOnlyForInboundResolverEndpoint":{"locationName":"privateDnsOnlyForInboundResolverEndpoint","type":"boolean"}}},"PrivateDnsEnabled":{"locationName":"privateDnsEnabled","type":"boolean"},"RequesterManaged":{"locationName":"requesterManaged","type":"boolean"},"NetworkInterfaceIds":{"shape":"So","locationName":"networkInterfaceIdSet"},"DnsEntries":{"shape":"Ssb","locationName":"dnsEntrySet"},"CreationTimestamp":{"locationName":"creationTimestamp","type":"timestamp"},"Tags":{"shape":"S6","locationName":"tagSet"},"OwnerId":{"locationName":"ownerId"},"LastError":{"locationName":"lastError","type":"structure","members":{"Message":{"locationName":"message"},"Code":{"locationName":"code"}}}}},"Ssb":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DnsName":{"locationName":"dnsName"},"HostedZoneId":{"locationName":"hostedZoneId"}}}},"Ssg":{"type":"structure","members":{"ConnectionNotificationId":{"locationName":"connectionNotificationId"},"ServiceId":{"locationName":"serviceId"},"VpcEndpointId":{"locationName":"vpcEndpointId"},"ConnectionNotificationType":{"locationName":"connectionNotificationType"},"ConnectionNotificationArn":{"locationName":"connectionNotificationArn"},"ConnectionEvents":{"shape":"So","locationName":"connectionEvents"},"ConnectionNotificationState":{"locationName":"connectionNotificationState"}}},"Ssl":{"type":"structure","members":{"ServiceType":{"shape":"Ssm","locationName":"serviceType"},"ServiceId":{"locationName":"serviceId"},"ServiceName":{"locationName":"serviceName"},"ServiceState":{"locationName":"serviceState"},"AvailabilityZones":{"shape":"So","locationName":"availabilityZoneSet"},"AcceptanceRequired":{"locationName":"acceptanceRequired","type":"boolean"},"ManagesVpcEndpoints":{"locationName":"managesVpcEndpoints","type":"boolean"},"NetworkLoadBalancerArns":{"shape":"So","locationName":"networkLoadBalancerArnSet"},"GatewayLoadBalancerArns":{"shape":"So","locationName":"gatewayLoadBalancerArnSet"},"SupportedIpAddressTypes":{"shape":"Ssq","locationName":"supportedIpAddressTypeSet"},"BaseEndpointDnsNames":{"shape":"So","locationName":"baseEndpointDnsNameSet"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateDnsNameConfiguration":{"locationName":"privateDnsNameConfiguration","type":"structure","members":{"State":{"locationName":"state"},"Type":{"locationName":"type"},"Value":{"locationName":"value"},"Name":{"locationName":"name"}}},"PayerResponsibility":{"locationName":"payerResponsibility"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Ssm":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ServiceType":{"locationName":"serviceType"}}}},"Ssq":{"type":"list","member":{"locationName":"item"}},"St3":{"type":"string","sensitive":true},"St4":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"St6":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"St8":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Sta":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Stc":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"type":"integer"}}}},"Ste":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"type":"integer"}}}},"Stg":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{}}}},"Sti":{"type":"structure","members":{"CloudWatchLogOptions":{"type":"structure","members":{"LogEnabled":{"type":"boolean"},"LogGroupArn":{},"LogOutputFormat":{}}}}},"Stm":{"type":"structure","members":{"CustomerGatewayConfiguration":{"locationName":"customerGatewayConfiguration","type":"string","sensitive":true},"CustomerGatewayId":{"locationName":"customerGatewayId"},"Category":{"locationName":"category"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpnConnectionId":{"locationName":"vpnConnectionId"},"VpnGatewayId":{"locationName":"vpnGatewayId"},"TransitGatewayId":{"locationName":"transitGatewayId"},"CoreNetworkArn":{"locationName":"coreNetworkArn"},"CoreNetworkAttachmentArn":{"locationName":"coreNetworkAttachmentArn"},"GatewayAssociationState":{"locationName":"gatewayAssociationState"},"Options":{"locationName":"options","type":"structure","members":{"EnableAcceleration":{"locationName":"enableAcceleration","type":"boolean"},"StaticRoutesOnly":{"locationName":"staticRoutesOnly","type":"boolean"},"LocalIpv4NetworkCidr":{"locationName":"localIpv4NetworkCidr"},"RemoteIpv4NetworkCidr":{"locationName":"remoteIpv4NetworkCidr"},"LocalIpv6NetworkCidr":{"locationName":"localIpv6NetworkCidr"},"RemoteIpv6NetworkCidr":{"locationName":"remoteIpv6NetworkCidr"},"OutsideIpAddressType":{"locationName":"outsideIpAddressType"},"TransportTransitGatewayAttachmentId":{"locationName":"transportTransitGatewayAttachmentId"},"TunnelInsideIpVersion":{"locationName":"tunnelInsideIpVersion"},"TunnelOptions":{"locationName":"tunnelOptionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"OutsideIpAddress":{"locationName":"outsideIpAddress"},"TunnelInsideCidr":{"locationName":"tunnelInsideCidr"},"TunnelInsideIpv6Cidr":{"locationName":"tunnelInsideIpv6Cidr"},"PreSharedKey":{"shape":"St3","locationName":"preSharedKey"},"Phase1LifetimeSeconds":{"locationName":"phase1LifetimeSeconds","type":"integer"},"Phase2LifetimeSeconds":{"locationName":"phase2LifetimeSeconds","type":"integer"},"RekeyMarginTimeSeconds":{"locationName":"rekeyMarginTimeSeconds","type":"integer"},"RekeyFuzzPercentage":{"locationName":"rekeyFuzzPercentage","type":"integer"},"ReplayWindowSize":{"locationName":"replayWindowSize","type":"integer"},"DpdTimeoutSeconds":{"locationName":"dpdTimeoutSeconds","type":"integer"},"DpdTimeoutAction":{"locationName":"dpdTimeoutAction"},"Phase1EncryptionAlgorithms":{"locationName":"phase1EncryptionAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase2EncryptionAlgorithms":{"locationName":"phase2EncryptionAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase1IntegrityAlgorithms":{"locationName":"phase1IntegrityAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase2IntegrityAlgorithms":{"locationName":"phase2IntegrityAlgorithmSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"Phase1DHGroupNumbers":{"locationName":"phase1DHGroupNumberSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value","type":"integer"}}}},"Phase2DHGroupNumbers":{"locationName":"phase2DHGroupNumberSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value","type":"integer"}}}},"IkeVersions":{"locationName":"ikeVersionSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Value":{"locationName":"value"}}}},"StartupAction":{"locationName":"startupAction"},"LogOptions":{"locationName":"logOptions","type":"structure","members":{"CloudWatchLogOptions":{"locationName":"cloudWatchLogOptions","type":"structure","members":{"LogEnabled":{"locationName":"logEnabled","type":"boolean"},"LogGroupArn":{"locationName":"logGroupArn"},"LogOutputFormat":{"locationName":"logOutputFormat"}}}}},"EnableTunnelLifecycleControl":{"locationName":"enableTunnelLifecycleControl","type":"boolean"}}}}}},"Routes":{"locationName":"routes","type":"list","member":{"locationName":"item","type":"structure","members":{"DestinationCidrBlock":{"locationName":"destinationCidrBlock"},"Source":{"locationName":"source"},"State":{"locationName":"state"}}}},"Tags":{"shape":"S6","locationName":"tagSet"},"VgwTelemetry":{"locationName":"vgwTelemetry","type":"list","member":{"locationName":"item","type":"structure","members":{"AcceptedRouteCount":{"locationName":"acceptedRouteCount","type":"integer"},"LastStatusChange":{"locationName":"lastStatusChange","type":"timestamp"},"OutsideIpAddress":{"locationName":"outsideIpAddress"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"CertificateArn":{"locationName":"certificateArn"}}}}}},"Suj":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"State":{"locationName":"state"},"Type":{"locationName":"type"},"VpcAttachments":{"locationName":"attachments","type":"list","member":{"shape":"S6q","locationName":"item"}},"VpnGatewayId":{"locationName":"vpnGatewayId"},"AmazonSideAsn":{"locationName":"amazonSideAsn","type":"long"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"Sv1":{"type":"list","member":{}},"Svb":{"type":"list","member":{"locationName":"item"}},"Sw1":{"type":"list","member":{"locationName":"item"}},"Syy":{"type":"list","member":{"locationName":"item"}},"Szb":{"type":"structure","members":{"Asn":{"locationName":"asn"},"IpamId":{"locationName":"ipamId"},"StatusMessage":{"locationName":"statusMessage"},"State":{"locationName":"state"}}},"Szf":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"State":{"locationName":"state"},"FailureReason":{"locationName":"failureReason","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"IpamPoolCidrId":{"locationName":"ipamPoolCidrId"},"NetmaskLength":{"locationName":"netmaskLength","type":"integer"}}},"Szq":{"type":"list","member":{"locationName":"item"}},"Szs":{"type":"structure","members":{"InstanceTagKeys":{"shape":"Szq","locationName":"instanceTagKeySet"},"IncludeAllTagsOfInstance":{"locationName":"includeAllTagsOfInstance","type":"boolean"}}},"Szu":{"type":"list","member":{"locationName":"item"}},"S10d":{"type":"list","member":{"locationName":"Filter","type":"structure","members":{"Name":{},"Values":{"shape":"So","locationName":"Value"}}}},"S10q":{"type":"structure","members":{"PublicIp":{"locationName":"publicIp"},"AllocationId":{"locationName":"allocationId"},"PtrRecord":{"locationName":"ptrRecord"},"PtrRecordUpdate":{"locationName":"ptrRecordUpdate","type":"structure","members":{"Value":{"locationName":"value"},"Status":{"locationName":"status"},"Reason":{"locationName":"reason"}}}}},"S10u":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Deadline":{"locationName":"deadline","type":"timestamp"},"Resource":{"locationName":"resource"},"UseLongIds":{"locationName":"useLongIds","type":"boolean"}}}},"S128":{"type":"list","member":{"locationName":"InstanceId"}},"S12n":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S13s":{"type":"structure","members":{"ConversionTaskId":{"locationName":"conversionTaskId"},"ExpirationTime":{"locationName":"expirationTime"},"ImportInstance":{"locationName":"importInstance","type":"structure","members":{"Description":{"locationName":"description"},"InstanceId":{"locationName":"instanceId"},"Platform":{"locationName":"platform"},"Volumes":{"locationName":"volumes","type":"list","member":{"locationName":"item","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"S13w","locationName":"image"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Volume":{"shape":"S13y","locationName":"volume"}}}}}},"ImportVolume":{"locationName":"importVolume","type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"BytesConverted":{"locationName":"bytesConverted","type":"long"},"Description":{"locationName":"description"},"Image":{"shape":"S13w","locationName":"image"},"Volume":{"shape":"S13y","locationName":"volume"}}},"State":{"locationName":"state"},"StatusMessage":{"locationName":"statusMessage"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"S13w":{"type":"structure","members":{"Checksum":{"locationName":"checksum"},"Format":{"locationName":"format"},"ImportManifestUrl":{"shape":"S13x","locationName":"importManifestUrl"},"Size":{"locationName":"size","type":"long"}}},"S13x":{"type":"string","sensitive":true},"S13y":{"type":"structure","members":{"Id":{"locationName":"id"},"Size":{"locationName":"size","type":"long"}}},"S14w":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Prefix":{"locationName":"s3Prefix"}}},"S159":{"type":"structure","members":{"TargetResourceCount":{"locationName":"targetResourceCount","type":"integer"}}},"S15a":{"type":"structure","members":{"LaunchTemplateId":{"locationName":"launchTemplateId"},"LaunchTemplateName":{"locationName":"launchTemplateName"},"Version":{"locationName":"version"}}},"S15n":{"type":"structure","members":{"EventDescription":{"locationName":"eventDescription"},"EventSubType":{"locationName":"eventSubType"},"InstanceId":{"locationName":"instanceId"}}},"S15q":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"InstanceHealth":{"locationName":"instanceHealth"}}}},"S16j":{"type":"structure","members":{"FpgaImageId":{"locationName":"fpgaImageId"},"Name":{"locationName":"name"},"Description":{"locationName":"description"},"LoadPermissions":{"locationName":"loadPermissions","type":"list","member":{"locationName":"item","type":"structure","members":{"UserId":{"locationName":"userId"},"Group":{"locationName":"group"}}}},"ProductCodes":{"shape":"S16n","locationName":"productCodes"}}},"S16n":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ProductCodeId":{"locationName":"productCode"},"ProductCodeType":{"locationName":"type"}}}},"S16s":{"type":"list","member":{"locationName":"Owner"}},"S17d":{"type":"list","member":{"locationName":"item"}},"S17g":{"type":"list","member":{"locationName":"item"}},"S185":{"type":"list","member":{"shape":"Ses","locationName":"item"}},"S186":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"},"OrganizationArn":{"locationName":"organizationArn"},"OrganizationalUnitArn":{"locationName":"organizationalUnitArn"}}}},"S18a":{"type":"list","member":{"locationName":"ImageId"}},"S18t":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Description":{"locationName":"description"},"DeviceName":{"locationName":"deviceName"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Format":{"locationName":"format"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"shape":"S18v","locationName":"url"},"UserBucket":{"shape":"S18w","locationName":"userBucket"}}}},"S18v":{"type":"string","sensitive":true},"S18w":{"type":"structure","members":{"S3Bucket":{"locationName":"s3Bucket"},"S3Key":{"locationName":"s3Key"}}},"S18x":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"S195":{"type":"structure","members":{"Description":{"locationName":"description"},"DiskImageSize":{"locationName":"diskImageSize","type":"double"},"Encrypted":{"locationName":"encrypted","type":"boolean"},"Format":{"locationName":"format"},"KmsKeyId":{"locationName":"kmsKeyId"},"Progress":{"locationName":"progress"},"SnapshotId":{"locationName":"snapshotId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"Url":{"shape":"S18v","locationName":"url"},"UserBucket":{"shape":"S18w","locationName":"userBucket"}}},"S199":{"type":"list","member":{"locationName":"item","type":"structure","members":{"DeviceName":{"locationName":"deviceName"},"Ebs":{"locationName":"ebs","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Status":{"locationName":"status"},"VolumeId":{"locationName":"volumeId"},"AssociatedResource":{"locationName":"associatedResource"},"VolumeOwnerId":{"locationName":"volumeOwnerId"}}}}}},"S19c":{"type":"structure","members":{"Value":{"locationName":"value","type":"boolean"}}},"S19d":{"type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"S19z":{"type":"structure","members":{"InstanceEventId":{"locationName":"instanceEventId"},"Code":{"locationName":"code"},"Description":{"locationName":"description"},"NotAfter":{"locationName":"notAfter","type":"timestamp"},"NotBefore":{"locationName":"notBefore","type":"timestamp"},"NotBeforeDeadline":{"locationName":"notBeforeDeadline","type":"timestamp"}}},"S1a2":{"type":"structure","members":{"Code":{"locationName":"code","type":"integer"},"Name":{"locationName":"name"}}},"S1a4":{"type":"structure","members":{"Details":{"locationName":"details","type":"list","member":{"locationName":"item","type":"structure","members":{"ImpairedSince":{"locationName":"impairedSince","type":"timestamp"},"Name":{"locationName":"name"},"Status":{"locationName":"status"}}}},"Status":{"locationName":"status"}}},"S1ef":{"type":"structure","members":{"Groups":{"shape":"Sly","locationName":"groupSet"},"Instances":{"locationName":"instancesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AmiLaunchIndex":{"locationName":"amiLaunchIndex","type":"integer"},"ImageId":{"locationName":"imageId"},"InstanceId":{"locationName":"instanceId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"LaunchTime":{"locationName":"launchTime","type":"timestamp"},"Monitoring":{"shape":"S1ei","locationName":"monitoring"},"Placement":{"shape":"Scr","locationName":"placement"},"Platform":{"locationName":"platform"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"ProductCodes":{"shape":"S16n","locationName":"productCodes"},"PublicDnsName":{"locationName":"dnsName"},"PublicIpAddress":{"locationName":"ipAddress"},"RamdiskId":{"locationName":"ramdiskId"},"State":{"shape":"S1a2","locationName":"instanceState"},"StateTransitionReason":{"locationName":"reason"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"Architecture":{"locationName":"architecture"},"BlockDeviceMappings":{"shape":"S199","locationName":"blockDeviceMapping"},"ClientToken":{"locationName":"clientToken"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"EnaSupport":{"locationName":"enaSupport","type":"boolean"},"Hypervisor":{"locationName":"hypervisor"},"IamInstanceProfile":{"shape":"S3y","locationName":"iamInstanceProfile"},"InstanceLifecycle":{"locationName":"instanceLifecycle"},"ElasticGpuAssociations":{"locationName":"elasticGpuAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticGpuId":{"locationName":"elasticGpuId"},"ElasticGpuAssociationId":{"locationName":"elasticGpuAssociationId"},"ElasticGpuAssociationState":{"locationName":"elasticGpuAssociationState"},"ElasticGpuAssociationTime":{"locationName":"elasticGpuAssociationTime"}}}},"ElasticInferenceAcceleratorAssociations":{"locationName":"elasticInferenceAcceleratorAssociationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ElasticInferenceAcceleratorArn":{"locationName":"elasticInferenceAcceleratorArn"},"ElasticInferenceAcceleratorAssociationId":{"locationName":"elasticInferenceAcceleratorAssociationId"},"ElasticInferenceAcceleratorAssociationState":{"locationName":"elasticInferenceAcceleratorAssociationState"},"ElasticInferenceAcceleratorAssociationTime":{"locationName":"elasticInferenceAcceleratorAssociationTime","type":"timestamp"}}}},"NetworkInterfaces":{"locationName":"networkInterfaceSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"S1er","locationName":"association"},"Attachment":{"locationName":"attachment","type":"structure","members":{"AttachTime":{"locationName":"attachTime","type":"timestamp"},"AttachmentId":{"locationName":"attachmentId"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Status":{"locationName":"status"},"NetworkCardIndex":{"locationName":"networkCardIndex","type":"integer"},"EnaSrdSpecification":{"locationName":"enaSrdSpecification","type":"structure","members":{"EnaSrdEnabled":{"locationName":"enaSrdEnabled","type":"boolean"},"EnaSrdUdpSpecification":{"locationName":"enaSrdUdpSpecification","type":"structure","members":{"EnaSrdUdpEnabled":{"locationName":"enaSrdUdpEnabled","type":"boolean"}}}}}}},"Description":{"locationName":"description"},"Groups":{"shape":"Sly","locationName":"groupSet"},"Ipv6Addresses":{"shape":"Siq","locationName":"ipv6AddressesSet"},"MacAddress":{"locationName":"macAddress"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"OwnerId":{"locationName":"ownerId"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"locationName":"privateIpAddressesSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Association":{"shape":"S1er","locationName":"association"},"Primary":{"locationName":"primary","type":"boolean"},"PrivateDnsName":{"locationName":"privateDnsName"},"PrivateIpAddress":{"locationName":"privateIpAddress"}}}},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"Status":{"locationName":"status"},"SubnetId":{"locationName":"subnetId"},"VpcId":{"locationName":"vpcId"},"InterfaceType":{"locationName":"interfaceType"},"Ipv4Prefixes":{"locationName":"ipv4PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv4Prefix":{"locationName":"ipv4Prefix"}}}},"Ipv6Prefixes":{"locationName":"ipv6PrefixSet","type":"list","member":{"locationName":"item","type":"structure","members":{"Ipv6Prefix":{"locationName":"ipv6Prefix"}}}},"ConnectionTrackingConfiguration":{"locationName":"connectionTrackingConfiguration","type":"structure","members":{"TcpEstablishedTimeout":{"locationName":"tcpEstablishedTimeout","type":"integer"},"UdpStreamTimeout":{"locationName":"udpStreamTimeout","type":"integer"},"UdpTimeout":{"locationName":"udpTimeout","type":"integer"}}}}}},"OutpostArn":{"locationName":"outpostArn"},"RootDeviceName":{"locationName":"rootDeviceName"},"RootDeviceType":{"locationName":"rootDeviceType"},"SecurityGroups":{"shape":"Sly","locationName":"groupSet"},"SourceDestCheck":{"locationName":"sourceDestCheck","type":"boolean"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SriovNetSupport":{"locationName":"sriovNetSupport"},"StateReason":{"shape":"Sjw","locationName":"stateReason"},"Tags":{"shape":"S6","locationName":"tagSet"},"VirtualizationType":{"locationName":"virtualizationType"},"CpuOptions":{"locationName":"cpuOptions","type":"structure","members":{"CoreCount":{"locationName":"coreCount","type":"integer"},"ThreadsPerCore":{"locationName":"threadsPerCore","type":"integer"},"AmdSevSnp":{"locationName":"amdSevSnp"}}},"CapacityReservationId":{"locationName":"capacityReservationId"},"CapacityReservationSpecification":{"locationName":"capacityReservationSpecification","type":"structure","members":{"CapacityReservationPreference":{"locationName":"capacityReservationPreference"},"CapacityReservationTarget":{"shape":"Sjc","locationName":"capacityReservationTarget"}}},"HibernationOptions":{"locationName":"hibernationOptions","type":"structure","members":{"Configured":{"locationName":"configured","type":"boolean"}}},"Licenses":{"locationName":"licenseSet","type":"list","member":{"locationName":"item","type":"structure","members":{"LicenseConfigurationArn":{"locationName":"licenseConfigurationArn"}}}},"MetadataOptions":{"shape":"S1f7","locationName":"metadataOptions"},"EnclaveOptions":{"shape":"S19d","locationName":"enclaveOptions"},"BootMode":{"locationName":"bootMode"},"PlatformDetails":{"locationName":"platformDetails"},"UsageOperation":{"locationName":"usageOperation"},"UsageOperationUpdateTime":{"locationName":"usageOperationUpdateTime","type":"timestamp"},"PrivateDnsNameOptions":{"locationName":"privateDnsNameOptions","type":"structure","members":{"HostnameType":{"locationName":"hostnameType"},"EnableResourceNameDnsARecord":{"locationName":"enableResourceNameDnsARecord","type":"boolean"},"EnableResourceNameDnsAAAARecord":{"locationName":"enableResourceNameDnsAAAARecord","type":"boolean"}}},"Ipv6Address":{"locationName":"ipv6Address"},"TpmSupport":{"locationName":"tpmSupport"},"MaintenanceOptions":{"locationName":"maintenanceOptions","type":"structure","members":{"AutoRecovery":{"locationName":"autoRecovery"}}},"CurrentInstanceBootMode":{"locationName":"currentInstanceBootMode"}}}},"OwnerId":{"locationName":"ownerId"},"RequesterId":{"locationName":"requesterId"},"ReservationId":{"locationName":"reservationId"}}},"S1ei":{"type":"structure","members":{"State":{"locationName":"state"}}},"S1er":{"type":"structure","members":{"CarrierIp":{"locationName":"carrierIp"},"CustomerOwnedIp":{"locationName":"customerOwnedIp"},"IpOwnerId":{"locationName":"ipOwnerId"},"PublicDnsName":{"locationName":"publicDnsName"},"PublicIp":{"locationName":"publicIp"}}},"S1f7":{"type":"structure","members":{"State":{"locationName":"state"},"HttpTokens":{"locationName":"httpTokens"},"HttpPutResponseHopLimit":{"locationName":"httpPutResponseHopLimit","type":"integer"},"HttpEndpoint":{"locationName":"httpEndpoint"},"HttpProtocolIpv6":{"locationName":"httpProtocolIpv6"},"InstanceMetadataTags":{"locationName":"instanceMetadataTags"}}},"S1hb":{"type":"list","member":{"locationName":"item"}},"S1ho":{"type":"list","member":{"locationName":"SnapshotId"}},"S1iq":{"type":"structure","members":{"NetworkInsightsAccessScopeAnalysisId":{"locationName":"networkInsightsAccessScopeAnalysisId"},"NetworkInsightsAccessScopeAnalysisArn":{"locationName":"networkInsightsAccessScopeAnalysisArn"},"NetworkInsightsAccessScopeId":{"locationName":"networkInsightsAccessScopeId"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"WarningMessage":{"locationName":"warningMessage"},"StartDate":{"locationName":"startDate","type":"timestamp"},"EndDate":{"locationName":"endDate","type":"timestamp"},"FindingsFound":{"locationName":"findingsFound"},"AnalyzedEniCount":{"locationName":"analyzedEniCount","type":"integer"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"S1j1":{"type":"structure","members":{"NetworkInsightsAnalysisId":{"locationName":"networkInsightsAnalysisId"},"NetworkInsightsAnalysisArn":{"locationName":"networkInsightsAnalysisArn"},"NetworkInsightsPathId":{"locationName":"networkInsightsPathId"},"AdditionalAccounts":{"shape":"So","locationName":"additionalAccountSet"},"FilterInArns":{"shape":"S1j2","locationName":"filterInArnSet"},"StartDate":{"locationName":"startDate","type":"timestamp"},"Status":{"locationName":"status"},"StatusMessage":{"locationName":"statusMessage"},"WarningMessage":{"locationName":"warningMessage"},"NetworkPathFound":{"locationName":"networkPathFound","type":"boolean"},"ForwardPathComponents":{"shape":"S1j3","locationName":"forwardPathComponentSet"},"ReturnPathComponents":{"shape":"S1j3","locationName":"returnPathComponentSet"},"Explanations":{"shape":"S1jn","locationName":"explanationSet"},"AlternatePathHints":{"locationName":"alternatePathHintSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ComponentId":{"locationName":"componentId"},"ComponentArn":{"locationName":"componentArn"}}}},"SuggestedAccounts":{"shape":"So","locationName":"suggestedAccountSet"},"Tags":{"shape":"S6","locationName":"tagSet"}}},"S1j2":{"type":"list","member":{"locationName":"item"}},"S1j3":{"type":"list","member":{"locationName":"item","type":"structure","members":{"SequenceNumber":{"locationName":"sequenceNumber","type":"integer"},"AclRule":{"shape":"S1j5","locationName":"aclRule"},"AttachedTo":{"shape":"S1j6","locationName":"attachedTo"},"Component":{"shape":"S1j6","locationName":"component"},"DestinationVpc":{"shape":"S1j6","locationName":"destinationVpc"},"OutboundHeader":{"shape":"S1j7","locationName":"outboundHeader"},"InboundHeader":{"shape":"S1j7","locationName":"inboundHeader"},"RouteTableRoute":{"shape":"S1ja","locationName":"routeTableRoute"},"SecurityGroupRule":{"shape":"S1jb","locationName":"securityGroupRule"},"SourceVpc":{"shape":"S1j6","locationName":"sourceVpc"},"Subnet":{"shape":"S1j6","locationName":"subnet"},"Vpc":{"shape":"S1j6","locationName":"vpc"},"AdditionalDetails":{"locationName":"additionalDetailSet","type":"list","member":{"locationName":"item","type":"structure","members":{"AdditionalDetailType":{"locationName":"additionalDetailType"},"Component":{"shape":"S1j6","locationName":"component"},"VpcEndpointService":{"shape":"S1j6","locationName":"vpcEndpointService"},"RuleOptions":{"shape":"S1je","locationName":"ruleOptionSet"},"RuleGroupTypePairs":{"locationName":"ruleGroupTypePairSet","type":"list","member":{"locationName":"item","type":"structure","members":{"RuleGroupArn":{"locationName":"ruleGroupArn"},"RuleGroupType":{"locationName":"ruleGroupType"}}}},"RuleGroupRuleOptionsPairs":{"locationName":"ruleGroupRuleOptionsPairSet","type":"list","member":{"locationName":"item","type":"structure","members":{"RuleGroupArn":{"locationName":"ruleGroupArn"},"RuleOptions":{"shape":"S1je","locationName":"ruleOptionSet"}}}},"ServiceName":{"locationName":"serviceName"},"LoadBalancers":{"shape":"S1jl","locationName":"loadBalancerSet"}}}},"TransitGateway":{"shape":"S1j6","locationName":"transitGateway"},"TransitGatewayRouteTableRoute":{"shape":"S1jm","locationName":"transitGatewayRouteTableRoute"},"Explanations":{"shape":"S1jn","locationName":"explanationSet"},"ElasticLoadBalancerListener":{"shape":"S1j6","locationName":"elasticLoadBalancerListener"},"FirewallStatelessRule":{"shape":"S1jt","locationName":"firewallStatelessRule"},"FirewallStatefulRule":{"shape":"S1jx","locationName":"firewallStatefulRule"},"ServiceName":{"locationName":"serviceName"}}}},"S1j5":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Egress":{"locationName":"egress","type":"boolean"},"PortRange":{"shape":"Skp","locationName":"portRange"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"RuleNumber":{"locationName":"ruleNumber","type":"integer"}}},"S1j6":{"type":"structure","members":{"Id":{"locationName":"id"},"Arn":{"locationName":"arn"},"Name":{"locationName":"name"}}},"S1j7":{"type":"structure","members":{"DestinationAddresses":{"shape":"S1j8","locationName":"destinationAddressSet"},"DestinationPortRanges":{"shape":"S1j9","locationName":"destinationPortRangeSet"},"Protocol":{"locationName":"protocol"},"SourceAddresses":{"shape":"S1j8","locationName":"sourceAddressSet"},"SourcePortRanges":{"shape":"S1j9","locationName":"sourcePortRangeSet"}}},"S1j8":{"type":"list","member":{"locationName":"item"}},"S1j9":{"type":"list","member":{"shape":"Skp","locationName":"item"}},"S1ja":{"type":"structure","members":{"DestinationCidr":{"locationName":"destinationCidr"},"DestinationPrefixListId":{"locationName":"destinationPrefixListId"},"EgressOnlyInternetGatewayId":{"locationName":"egressOnlyInternetGatewayId"},"GatewayId":{"locationName":"gatewayId"},"InstanceId":{"locationName":"instanceId"},"NatGatewayId":{"locationName":"natGatewayId"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"Origin":{"locationName":"origin"},"TransitGatewayId":{"locationName":"transitGatewayId"},"VpcPeeringConnectionId":{"locationName":"vpcPeeringConnectionId"},"State":{"locationName":"state"},"CarrierGatewayId":{"locationName":"carrierGatewayId"},"CoreNetworkArn":{"locationName":"coreNetworkArn"},"LocalGatewayId":{"locationName":"localGatewayId"}}},"S1jb":{"type":"structure","members":{"Cidr":{"locationName":"cidr"},"Direction":{"locationName":"direction"},"SecurityGroupId":{"locationName":"securityGroupId"},"PortRange":{"shape":"Skp","locationName":"portRange"},"PrefixListId":{"locationName":"prefixListId"},"Protocol":{"locationName":"protocol"}}},"S1je":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Keyword":{"locationName":"keyword"},"Settings":{"shape":"S1jg","locationName":"settingSet"}}}},"S1jg":{"type":"list","member":{"locationName":"item"}},"S1jl":{"type":"list","member":{"shape":"S1j6","locationName":"item"}},"S1jm":{"type":"structure","members":{"DestinationCidr":{"locationName":"destinationCidr"},"State":{"locationName":"state"},"RouteOrigin":{"locationName":"routeOrigin"},"PrefixListId":{"locationName":"prefixListId"},"AttachmentId":{"locationName":"attachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"}}},"S1jn":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Acl":{"shape":"S1j6","locationName":"acl"},"AclRule":{"shape":"S1j5","locationName":"aclRule"},"Address":{"locationName":"address"},"Addresses":{"shape":"S1j8","locationName":"addressSet"},"AttachedTo":{"shape":"S1j6","locationName":"attachedTo"},"AvailabilityZones":{"shape":"So","locationName":"availabilityZoneSet"},"Cidrs":{"shape":"So","locationName":"cidrSet"},"Component":{"shape":"S1j6","locationName":"component"},"CustomerGateway":{"shape":"S1j6","locationName":"customerGateway"},"Destination":{"shape":"S1j6","locationName":"destination"},"DestinationVpc":{"shape":"S1j6","locationName":"destinationVpc"},"Direction":{"locationName":"direction"},"ExplanationCode":{"locationName":"explanationCode"},"IngressRouteTable":{"shape":"S1j6","locationName":"ingressRouteTable"},"InternetGateway":{"shape":"S1j6","locationName":"internetGateway"},"LoadBalancerArn":{"locationName":"loadBalancerArn"},"ClassicLoadBalancerListener":{"locationName":"classicLoadBalancerListener","type":"structure","members":{"LoadBalancerPort":{"locationName":"loadBalancerPort","type":"integer"},"InstancePort":{"locationName":"instancePort","type":"integer"}}},"LoadBalancerListenerPort":{"locationName":"loadBalancerListenerPort","type":"integer"},"LoadBalancerTarget":{"locationName":"loadBalancerTarget","type":"structure","members":{"Address":{"locationName":"address"},"AvailabilityZone":{"locationName":"availabilityZone"},"Instance":{"shape":"S1j6","locationName":"instance"},"Port":{"locationName":"port","type":"integer"}}},"LoadBalancerTargetGroup":{"shape":"S1j6","locationName":"loadBalancerTargetGroup"},"LoadBalancerTargetGroups":{"shape":"S1jl","locationName":"loadBalancerTargetGroupSet"},"LoadBalancerTargetPort":{"locationName":"loadBalancerTargetPort","type":"integer"},"ElasticLoadBalancerListener":{"shape":"S1j6","locationName":"elasticLoadBalancerListener"},"MissingComponent":{"locationName":"missingComponent"},"NatGateway":{"shape":"S1j6","locationName":"natGateway"},"NetworkInterface":{"shape":"S1j6","locationName":"networkInterface"},"PacketField":{"locationName":"packetField"},"VpcPeeringConnection":{"shape":"S1j6","locationName":"vpcPeeringConnection"},"Port":{"locationName":"port","type":"integer"},"PortRanges":{"shape":"S1j9","locationName":"portRangeSet"},"PrefixList":{"shape":"S1j6","locationName":"prefixList"},"Protocols":{"shape":"S1jg","locationName":"protocolSet"},"RouteTableRoute":{"shape":"S1ja","locationName":"routeTableRoute"},"RouteTable":{"shape":"S1j6","locationName":"routeTable"},"SecurityGroup":{"shape":"S1j6","locationName":"securityGroup"},"SecurityGroupRule":{"shape":"S1jb","locationName":"securityGroupRule"},"SecurityGroups":{"shape":"S1jl","locationName":"securityGroupSet"},"SourceVpc":{"shape":"S1j6","locationName":"sourceVpc"},"State":{"locationName":"state"},"Subnet":{"shape":"S1j6","locationName":"subnet"},"SubnetRouteTable":{"shape":"S1j6","locationName":"subnetRouteTable"},"Vpc":{"shape":"S1j6","locationName":"vpc"},"VpcEndpoint":{"shape":"S1j6","locationName":"vpcEndpoint"},"VpnConnection":{"shape":"S1j6","locationName":"vpnConnection"},"VpnGateway":{"shape":"S1j6","locationName":"vpnGateway"},"TransitGateway":{"shape":"S1j6","locationName":"transitGateway"},"TransitGatewayRouteTable":{"shape":"S1j6","locationName":"transitGatewayRouteTable"},"TransitGatewayRouteTableRoute":{"shape":"S1jm","locationName":"transitGatewayRouteTableRoute"},"TransitGatewayAttachment":{"shape":"S1j6","locationName":"transitGatewayAttachment"},"ComponentAccount":{"locationName":"componentAccount"},"ComponentRegion":{"locationName":"componentRegion"},"FirewallStatelessRule":{"shape":"S1jt","locationName":"firewallStatelessRule"},"FirewallStatefulRule":{"shape":"S1jx","locationName":"firewallStatefulRule"}}}},"S1jt":{"type":"structure","members":{"RuleGroupArn":{"locationName":"ruleGroupArn"},"Sources":{"shape":"So","locationName":"sourceSet"},"Destinations":{"shape":"So","locationName":"destinationSet"},"SourcePorts":{"shape":"S1j9","locationName":"sourcePortSet"},"DestinationPorts":{"shape":"S1j9","locationName":"destinationPortSet"},"Protocols":{"locationName":"protocolSet","type":"list","member":{"locationName":"item","type":"integer"}},"RuleAction":{"locationName":"ruleAction"},"Priority":{"locationName":"priority","type":"integer"}}},"S1jx":{"type":"structure","members":{"RuleGroupArn":{"locationName":"ruleGroupArn"},"Sources":{"shape":"So","locationName":"sourceSet"},"Destinations":{"shape":"So","locationName":"destinationSet"},"SourcePorts":{"shape":"S1j9","locationName":"sourcePortSet"},"DestinationPorts":{"shape":"S1j9","locationName":"destinationPortSet"},"Protocol":{"locationName":"protocol"},"RuleAction":{"locationName":"ruleAction"},"Direction":{"locationName":"direction"}}},"S1l4":{"type":"structure","members":{"FirstAddress":{"locationName":"firstAddress"},"LastAddress":{"locationName":"lastAddress"},"AddressCount":{"locationName":"addressCount","type":"integer"},"AvailableAddressCount":{"locationName":"availableAddressCount","type":"integer"}}},"S1lh":{"type":"list","member":{"locationName":"ReservedInstancesId"}},"S1lp":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Amount":{"locationName":"amount","type":"double"},"Frequency":{"locationName":"frequency"}}}},"S1m3":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"Platform":{"locationName":"platform"},"Scope":{"locationName":"scope"}}},"S1mq":{"type":"structure","members":{"Frequency":{"locationName":"frequency"},"Interval":{"locationName":"interval","type":"integer"},"OccurrenceDaySet":{"locationName":"occurrenceDaySet","type":"list","member":{"locationName":"item","type":"integer"}},"OccurrenceRelativeToEnd":{"locationName":"occurrenceRelativeToEnd","type":"boolean"},"OccurrenceUnit":{"locationName":"occurrenceUnit"}}},"S1my":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"CreateDate":{"locationName":"createDate","type":"timestamp"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceCount":{"locationName":"instanceCount","type":"integer"},"InstanceType":{"locationName":"instanceType"},"NetworkPlatform":{"locationName":"networkPlatform"},"NextSlotStartTime":{"locationName":"nextSlotStartTime","type":"timestamp"},"Platform":{"locationName":"platform"},"PreviousSlotEndTime":{"locationName":"previousSlotEndTime","type":"timestamp"},"Recurrence":{"shape":"S1mq","locationName":"recurrence"},"ScheduledInstanceId":{"locationName":"scheduledInstanceId"},"SlotDurationInHours":{"locationName":"slotDurationInHours","type":"integer"},"TermEndDate":{"locationName":"termEndDate","type":"timestamp"},"TermStartDate":{"locationName":"termStartDate","type":"timestamp"},"TotalScheduledInstanceHours":{"locationName":"totalScheduledInstanceHours","type":"integer"}}},"S1n5":{"type":"list","member":{"locationName":"item"}},"S1n9":{"type":"list","member":{"locationName":"GroupName"}},"S1nh":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{"locationName":"group"},"UserId":{"locationName":"userId"}}}},"S1o9":{"type":"structure","required":["IamFleetRole","TargetCapacity"],"members":{"AllocationStrategy":{"locationName":"allocationStrategy"},"OnDemandAllocationStrategy":{"locationName":"onDemandAllocationStrategy"},"SpotMaintenanceStrategies":{"locationName":"spotMaintenanceStrategies","type":"structure","members":{"CapacityRebalance":{"locationName":"capacityRebalance","type":"structure","members":{"ReplacementStrategy":{"locationName":"replacementStrategy"},"TerminationDelay":{"locationName":"terminationDelay","type":"integer"}}}}},"ClientToken":{"locationName":"clientToken"},"ExcessCapacityTerminationPolicy":{"locationName":"excessCapacityTerminationPolicy"},"FulfilledCapacity":{"locationName":"fulfilledCapacity","type":"double"},"OnDemandFulfilledCapacity":{"locationName":"onDemandFulfilledCapacity","type":"double"},"IamFleetRole":{"locationName":"iamFleetRole"},"LaunchSpecifications":{"locationName":"launchSpecifications","type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroups":{"shape":"Sly","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"S185","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S3v","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"Monitoring":{"locationName":"monitoring","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"NetworkInterfaces":{"shape":"S1oj","locationName":"networkInterfaceSet"},"Placement":{"shape":"S1ol","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"UserData":{"shape":"Sgo","locationName":"userData"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"TagSpecifications":{"locationName":"tagSpecificationSet","type":"list","member":{"locationName":"item","type":"structure","members":{"ResourceType":{"locationName":"resourceType"},"Tags":{"shape":"S6","locationName":"tag"}}}},"InstanceRequirements":{"shape":"Sdz","locationName":"instanceRequirements"}}}},"LaunchTemplateConfigs":{"shape":"S1oo","locationName":"launchTemplateConfigs"},"SpotPrice":{"locationName":"spotPrice"},"TargetCapacity":{"locationName":"targetCapacity","type":"integer"},"OnDemandTargetCapacity":{"locationName":"onDemandTargetCapacity","type":"integer"},"OnDemandMaxTotalPrice":{"locationName":"onDemandMaxTotalPrice"},"SpotMaxTotalPrice":{"locationName":"spotMaxTotalPrice"},"TerminateInstancesWithExpiration":{"locationName":"terminateInstancesWithExpiration","type":"boolean"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"ReplaceUnhealthyInstances":{"locationName":"replaceUnhealthyInstances","type":"boolean"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"},"LoadBalancersConfig":{"locationName":"loadBalancersConfig","type":"structure","members":{"ClassicLoadBalancersConfig":{"locationName":"classicLoadBalancersConfig","type":"structure","members":{"ClassicLoadBalancers":{"locationName":"classicLoadBalancers","type":"list","member":{"locationName":"item","type":"structure","members":{"Name":{"locationName":"name"}}}}}},"TargetGroupsConfig":{"locationName":"targetGroupsConfig","type":"structure","members":{"TargetGroups":{"locationName":"targetGroups","type":"list","member":{"locationName":"item","type":"structure","members":{"Arn":{"locationName":"arn"}}}}}}}},"InstancePoolsToUseCount":{"locationName":"instancePoolsToUseCount","type":"integer"},"Context":{"locationName":"context"},"TargetCapacityUnitType":{"locationName":"targetCapacityUnitType"},"TagSpecifications":{"shape":"S3","locationName":"TagSpecification"}}},"S1oj":{"type":"list","member":{"locationName":"item","type":"structure","members":{"AssociatePublicIpAddress":{"locationName":"associatePublicIpAddress","type":"boolean"},"DeleteOnTermination":{"locationName":"deleteOnTermination","type":"boolean"},"Description":{"locationName":"description"},"DeviceIndex":{"locationName":"deviceIndex","type":"integer"},"Groups":{"shape":"Sgz","locationName":"SecurityGroupId"},"Ipv6AddressCount":{"locationName":"ipv6AddressCount","type":"integer"},"Ipv6Addresses":{"shape":"Siq","locationName":"ipv6AddressesSet","queryName":"Ipv6Addresses"},"NetworkInterfaceId":{"locationName":"networkInterfaceId"},"PrivateIpAddress":{"locationName":"privateIpAddress"},"PrivateIpAddresses":{"shape":"Sh2","locationName":"privateIpAddressesSet","queryName":"PrivateIpAddresses"},"SecondaryPrivateIpAddressCount":{"locationName":"secondaryPrivateIpAddressCount","type":"integer"},"SubnetId":{"locationName":"subnetId"},"AssociateCarrierIpAddress":{"type":"boolean"},"InterfaceType":{},"NetworkCardIndex":{"type":"integer"},"Ipv4Prefixes":{"shape":"Sh4","locationName":"Ipv4Prefix"},"Ipv4PrefixCount":{"type":"integer"},"Ipv6Prefixes":{"shape":"Sh6","locationName":"Ipv6Prefix"},"Ipv6PrefixCount":{"type":"integer"},"PrimaryIpv6":{"type":"boolean"},"EnaSrdSpecification":{"shape":"Sh8"},"ConnectionTrackingSpecification":{"shape":"Sha"}}}},"S1ol":{"type":"structure","members":{"AvailabilityZone":{"locationName":"availabilityZone"},"GroupName":{"locationName":"groupName"},"Tenancy":{"locationName":"tenancy"}}},"S1oo":{"type":"list","member":{"locationName":"item","type":"structure","members":{"LaunchTemplateSpecification":{"shape":"Sdw","locationName":"launchTemplateSpecification"},"Overrides":{"locationName":"overrides","type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceType":{"locationName":"instanceType"},"SpotPrice":{"locationName":"spotPrice"},"SubnetId":{"locationName":"subnetId"},"AvailabilityZone":{"locationName":"availabilityZone"},"WeightedCapacity":{"locationName":"weightedCapacity","type":"double"},"Priority":{"locationName":"priority","type":"double"},"InstanceRequirements":{"shape":"Sdz","locationName":"instanceRequirements"}}}}}}},"S1p1":{"type":"list","member":{"locationName":"item","type":"structure","members":{"ActualBlockHourlyPrice":{"locationName":"actualBlockHourlyPrice"},"AvailabilityZoneGroup":{"locationName":"availabilityZoneGroup"},"BlockDurationMinutes":{"locationName":"blockDurationMinutes","type":"integer"},"CreateTime":{"locationName":"createTime","type":"timestamp"},"Fault":{"shape":"Snv","locationName":"fault"},"InstanceId":{"locationName":"instanceId"},"LaunchGroup":{"locationName":"launchGroup"},"LaunchSpecification":{"locationName":"launchSpecification","type":"structure","members":{"UserData":{"shape":"Sgo","locationName":"userData"},"SecurityGroups":{"shape":"Sly","locationName":"groupSet"},"AddressingType":{"locationName":"addressingType"},"BlockDeviceMappings":{"shape":"S185","locationName":"blockDeviceMapping"},"EbsOptimized":{"locationName":"ebsOptimized","type":"boolean"},"IamInstanceProfile":{"shape":"S3v","locationName":"iamInstanceProfile"},"ImageId":{"locationName":"imageId"},"InstanceType":{"locationName":"instanceType"},"KernelId":{"locationName":"kernelId"},"KeyName":{"locationName":"keyName"},"NetworkInterfaces":{"shape":"S1oj","locationName":"networkInterfaceSet"},"Placement":{"shape":"S1ol","locationName":"placement"},"RamdiskId":{"locationName":"ramdiskId"},"SubnetId":{"locationName":"subnetId"},"Monitoring":{"shape":"S1p4","locationName":"monitoring"}}},"LaunchedAvailabilityZone":{"locationName":"launchedAvailabilityZone"},"ProductDescription":{"locationName":"productDescription"},"SpotInstanceRequestId":{"locationName":"spotInstanceRequestId"},"SpotPrice":{"locationName":"spotPrice"},"State":{"locationName":"state"},"Status":{"locationName":"status","type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"},"UpdateTime":{"locationName":"updateTime","type":"timestamp"}}},"Tags":{"shape":"S6","locationName":"tagSet"},"Type":{"locationName":"type"},"ValidFrom":{"locationName":"validFrom","type":"timestamp"},"ValidUntil":{"locationName":"validUntil","type":"timestamp"},"InstanceInterruptionBehavior":{"locationName":"instanceInterruptionBehavior"}}}},"S1p4":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"locationName":"enabled","type":"boolean"}}},"S1pj":{"type":"list","member":{"locationName":"item","type":"structure","members":{"FromPort":{"locationName":"fromPort","type":"integer"},"IpProtocol":{"locationName":"ipProtocol"},"IpRanges":{"locationName":"ipRanges","type":"list","member":{"locationName":"item"}},"PrefixListIds":{"locationName":"prefixListIds","type":"list","member":{"locationName":"item"}},"ToPort":{"locationName":"toPort","type":"integer"},"UserIdGroupPairs":{"locationName":"groups","type":"list","member":{"shape":"S76","locationName":"item"}}}}},"S1qh":{"type":"list","member":{}},"S1s0":{"type":"list","member":{"locationName":"item"}},"S1s4":{"type":"structure","members":{"VerifiedAccessInstanceId":{"locationName":"verifiedAccessInstanceId"},"AccessLogs":{"locationName":"accessLogs","type":"structure","members":{"S3":{"locationName":"s3","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"DeliveryStatus":{"shape":"S1s7","locationName":"deliveryStatus"},"BucketName":{"locationName":"bucketName"},"Prefix":{"locationName":"prefix"},"BucketOwner":{"locationName":"bucketOwner"}}},"CloudWatchLogs":{"locationName":"cloudWatchLogs","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"DeliveryStatus":{"shape":"S1s7","locationName":"deliveryStatus"},"LogGroup":{"locationName":"logGroup"}}},"KinesisDataFirehose":{"locationName":"kinesisDataFirehose","type":"structure","members":{"Enabled":{"locationName":"enabled","type":"boolean"},"DeliveryStatus":{"shape":"S1s7","locationName":"deliveryStatus"},"DeliveryStream":{"locationName":"deliveryStream"}}},"LogVersion":{"locationName":"logVersion"},"IncludeTrustContext":{"locationName":"includeTrustContext","type":"boolean"}}}}},"S1s7":{"type":"structure","members":{"Code":{"locationName":"code"},"Message":{"locationName":"message"}}},"S1t8":{"type":"structure","members":{"VolumeId":{"locationName":"volumeId"},"ModificationState":{"locationName":"modificationState"},"StatusMessage":{"locationName":"statusMessage"},"TargetSize":{"locationName":"targetSize","type":"integer"},"TargetIops":{"locationName":"targetIops","type":"integer"},"TargetVolumeType":{"locationName":"targetVolumeType"},"TargetThroughput":{"locationName":"targetThroughput","type":"integer"},"TargetMultiAttachEnabled":{"locationName":"targetMultiAttachEnabled","type":"boolean"},"OriginalSize":{"locationName":"originalSize","type":"integer"},"OriginalIops":{"locationName":"originalIops","type":"integer"},"OriginalVolumeType":{"locationName":"originalVolumeType"},"OriginalThroughput":{"locationName":"originalThroughput","type":"integer"},"OriginalMultiAttachEnabled":{"locationName":"originalMultiAttachEnabled","type":"boolean"},"Progress":{"locationName":"progress","type":"long"},"StartTime":{"locationName":"startTime","type":"timestamp"},"EndTime":{"locationName":"endTime","type":"timestamp"}}},"S1te":{"type":"list","member":{"locationName":"VpcId"}},"S1ve":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S1w5":{"type":"structure","members":{"TransitGatewayAttachmentId":{"locationName":"transitGatewayAttachmentId"},"ResourceId":{"locationName":"resourceId"},"ResourceType":{"locationName":"resourceType"},"TransitGatewayRouteTableId":{"locationName":"transitGatewayRouteTableId"},"State":{"locationName":"state"},"TransitGatewayRouteTableAnnouncementId":{"locationName":"transitGatewayRouteTableAnnouncementId"}}},"S1zp":{"type":"structure","members":{"InstanceFamily":{"locationName":"instanceFamily"},"CpuCredits":{"locationName":"cpuCredits"}}},"S206":{"type":"list","member":{"locationName":"item"}},"S208":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrencyCode":{"locationName":"currencyCode"},"Duration":{"locationName":"duration","type":"integer"},"HostIdSet":{"shape":"S17d","locationName":"hostIdSet"},"HostReservationId":{"locationName":"hostReservationId"},"HourlyPrice":{"locationName":"hourlyPrice"},"InstanceFamily":{"locationName":"instanceFamily"},"PaymentOption":{"locationName":"paymentOption"},"UpfrontPrice":{"locationName":"upfrontPrice"}}}},"S20m":{"type":"list","member":{"locationName":"item"}},"S20n":{"type":"list","member":{"locationName":"item"}},"S21z":{"type":"structure","members":{"IpamId":{"locationName":"ipamId"},"IpamScopeId":{"locationName":"ipamScopeId"},"IpamPoolId":{"locationName":"ipamPoolId"},"ResourceRegion":{"locationName":"resourceRegion"},"ResourceOwnerId":{"locationName":"resourceOwnerId"},"ResourceId":{"locationName":"resourceId"},"ResourceName":{"locationName":"resourceName"},"ResourceCidr":{"locationName":"resourceCidr"},"ResourceType":{"locationName":"resourceType"},"ResourceTags":{"shape":"Sg9","locationName":"resourceTagSet"},"IpUsage":{"locationName":"ipUsage","type":"double"},"ComplianceStatus":{"locationName":"complianceStatus"},"ManagementState":{"locationName":"managementState"},"OverlapStatus":{"locationName":"overlapStatus"},"VpcId":{"locationName":"vpcId"}}},"S22o":{"type":"structure","members":{"HourlyPrice":{"locationName":"hourlyPrice"},"RemainingTotalValue":{"locationName":"remainingTotalValue"},"RemainingUpfrontValue":{"locationName":"remainingUpfrontValue"}}},"S23f":{"type":"list","member":{"shape":"So6","locationName":"item"}},"S24r":{"type":"structure","members":{"Comment":{},"UploadEnd":{"type":"timestamp"},"UploadSize":{"type":"double"},"UploadStart":{"type":"timestamp"}}},"S24u":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S251":{"type":"structure","required":["Bytes","Format","ImportManifestUrl"],"members":{"Bytes":{"locationName":"bytes","type":"long"},"Format":{"locationName":"format"},"ImportManifestUrl":{"shape":"S13x","locationName":"importManifestUrl"}}},"S252":{"type":"structure","required":["Size"],"members":{"Size":{"locationName":"size","type":"long"}}},"S26c":{"type":"list","member":{"locationName":"UserId"}},"S26d":{"type":"list","member":{"locationName":"UserGroup"}},"S26e":{"type":"list","member":{"locationName":"ProductCode"}},"S26g":{"type":"list","member":{"locationName":"item","type":"structure","members":{"Group":{},"UserId":{}}}},"S26l":{"type":"list","member":{"shape":"S1i","locationName":"item"}},"S26y":{"type":"structure","members":{"CapacityReservationPreference":{},"CapacityReservationTarget":{"shape":"Shy"}}},"S27s":{"type":"list","member":{"type":"structure","members":{"RegionName":{}}}},"S2ah":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"type":"boolean"}}},"S2aj":{"type":"structure","members":{"AllowDnsResolutionFromRemoteVpc":{"locationName":"allowDnsResolutionFromRemoteVpc","type":"boolean"},"AllowEgressFromLocalClassicLinkToRemoteVpc":{"locationName":"allowEgressFromLocalClassicLinkToRemoteVpc","type":"boolean"},"AllowEgressFromLocalVpcToRemoteClassicLink":{"locationName":"allowEgressFromLocalVpcToRemoteClassicLink","type":"boolean"}}},"S2ay":{"type":"list","member":{"locationName":"item","type":"structure","members":{"InstanceId":{"locationName":"instanceId"},"Monitoring":{"shape":"S1ei","locationName":"monitoring"}}}},"S2es":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S2fg":{"type":"list","member":{"locationName":"item","type":"structure","members":{"CurrentState":{"shape":"S1a2","locationName":"currentState"},"InstanceId":{"locationName":"instanceId"},"PreviousState":{"shape":"S1a2","locationName":"previousState"}}}},"S2g6":{"type":"list","member":{"locationName":"item","type":"structure","members":{"SecurityGroupRuleId":{},"Description":{}}}}}}

/***/ }),
/* 476 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccountAttributes":{"result_key":"AccountAttributes"},"DescribeAddressTransfers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AddressTransfers"},"DescribeAddresses":{"result_key":"Addresses"},"DescribeAddressesAttribute":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Addresses"},"DescribeAvailabilityZones":{"result_key":"AvailabilityZones"},"DescribeAwsNetworkPerformanceMetricSubscriptions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Subscriptions"},"DescribeBundleTasks":{"result_key":"BundleTasks"},"DescribeByoipCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ByoipCidrs"},"DescribeCapacityBlockOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityBlockOfferings"},"DescribeCapacityReservationFleets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservationFleets"},"DescribeCapacityReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservations"},"DescribeCarrierGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CarrierGateways"},"DescribeClassicLinkInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Instances"},"DescribeClientVpnAuthorizationRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AuthorizationRules"},"DescribeClientVpnConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Connections"},"DescribeClientVpnEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnEndpoints"},"DescribeClientVpnRoutes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Routes"},"DescribeClientVpnTargetNetworks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ClientVpnTargetNetworks"},"DescribeCoipPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CoipPools"},"DescribeConversionTasks":{"result_key":"ConversionTasks"},"DescribeCustomerGateways":{"result_key":"CustomerGateways"},"DescribeDhcpOptions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DhcpOptions"},"DescribeEgressOnlyInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EgressOnlyInternetGateways"},"DescribeExportImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ExportImageTasks"},"DescribeExportTasks":{"result_key":"ExportTasks"},"DescribeFastLaunchImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FastLaunchImages"},"DescribeFastSnapshotRestores":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FastSnapshotRestores"},"DescribeFleets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fleets"},"DescribeFlowLogs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FlowLogs"},"DescribeFpgaImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"FpgaImages"},"DescribeHostReservationOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OfferingSet"},"DescribeHostReservations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HostReservationSet"},"DescribeHosts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Hosts"},"DescribeIamInstanceProfileAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IamInstanceProfileAssociations"},"DescribeImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Images"},"DescribeImportImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportImageTasks"},"DescribeImportSnapshotTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ImportSnapshotTasks"},"DescribeInstanceConnectEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceConnectEndpoints"},"DescribeInstanceCreditSpecifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceCreditSpecifications"},"DescribeInstanceEventWindows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceEventWindows"},"DescribeInstanceStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceStatuses"},"DescribeInstanceTopology":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Instances"},"DescribeInstanceTypeOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypeOfferings"},"DescribeInstanceTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypes"},"DescribeInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Reservations"},"DescribeInternetGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InternetGateways"},"DescribeIpamPools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamPools"},"DescribeIpamResourceDiscoveries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamResourceDiscoveries"},"DescribeIpamResourceDiscoveryAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamResourceDiscoveryAssociations"},"DescribeIpamScopes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamScopes"},"DescribeIpams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipams"},"DescribeIpv6Pools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipv6Pools"},"DescribeKeyPairs":{"result_key":"KeyPairs"},"DescribeLaunchTemplateVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplateVersions"},"DescribeLaunchTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LaunchTemplates"},"DescribeLocalGatewayRouteTableVirtualInterfaceGroupAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTableVirtualInterfaceGroupAssociations"},"DescribeLocalGatewayRouteTableVpcAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTableVpcAssociations"},"DescribeLocalGatewayRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayRouteTables"},"DescribeLocalGatewayVirtualInterfaceGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayVirtualInterfaceGroups"},"DescribeLocalGatewayVirtualInterfaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGatewayVirtualInterfaces"},"DescribeLocalGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LocalGateways"},"DescribeMacHosts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MacHosts"},"DescribeManagedPrefixLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixLists"},"DescribeMovingAddresses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MovingAddressStatuses"},"DescribeNatGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NatGateways"},"DescribeNetworkAcls":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkAcls"},"DescribeNetworkInsightsAccessScopeAnalyses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsAccessScopeAnalyses"},"DescribeNetworkInsightsAccessScopes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsAccessScopes"},"DescribeNetworkInsightsAnalyses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsAnalyses"},"DescribeNetworkInsightsPaths":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInsightsPaths"},"DescribeNetworkInterfacePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfacePermissions"},"DescribeNetworkInterfaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"NetworkInterfaces"},"DescribePlacementGroups":{"result_key":"PlacementGroups"},"DescribePrefixLists":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixLists"},"DescribePrincipalIdFormat":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Principals"},"DescribePublicIpv4Pools":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PublicIpv4Pools"},"DescribeRegions":{"result_key":"Regions"},"DescribeReplaceRootVolumeTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReplaceRootVolumeTasks"},"DescribeReservedInstances":{"result_key":"ReservedInstances"},"DescribeReservedInstancesListings":{"result_key":"ReservedInstancesListings"},"DescribeReservedInstancesModifications":{"input_token":"NextToken","output_token":"NextToken","result_key":"ReservedInstancesModifications"},"DescribeReservedInstancesOfferings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ReservedInstancesOfferings"},"DescribeRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"RouteTables"},"DescribeScheduledInstanceAvailability":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceAvailabilitySet"},"DescribeScheduledInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledInstanceSet"},"DescribeSecurityGroupRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityGroupRules"},"DescribeSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityGroups"},"DescribeSnapshotTierStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SnapshotTierStatuses"},"DescribeSnapshots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"DescribeSpotFleetRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotFleetRequestConfigs"},"DescribeSpotInstanceRequests":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotInstanceRequests"},"DescribeSpotPriceHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPriceHistory"},"DescribeStaleSecurityGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StaleSecurityGroupSet"},"DescribeStoreImageTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StoreImageTaskResults"},"DescribeSubnets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Subnets"},"DescribeTags":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tags"},"DescribeTrafficMirrorFilters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorFilters"},"DescribeTrafficMirrorSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorSessions"},"DescribeTrafficMirrorTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TrafficMirrorTargets"},"DescribeTransitGatewayAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachments"},"DescribeTransitGatewayConnectPeers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayConnectPeers"},"DescribeTransitGatewayConnects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayConnects"},"DescribeTransitGatewayMulticastDomains":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayMulticastDomains"},"DescribeTransitGatewayPeeringAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayPeeringAttachments"},"DescribeTransitGatewayPolicyTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayPolicyTables"},"DescribeTransitGatewayRouteTableAnnouncements":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTableAnnouncements"},"DescribeTransitGatewayRouteTables":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTables"},"DescribeTransitGatewayVpcAttachments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayVpcAttachments"},"DescribeTransitGateways":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGateways"},"DescribeTrunkInterfaceAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InterfaceAssociations"},"DescribeVerifiedAccessEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VerifiedAccessEndpoints"},"DescribeVerifiedAccessGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VerifiedAccessGroups"},"DescribeVerifiedAccessInstanceLoggingConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"LoggingConfigurations"},"DescribeVerifiedAccessInstances":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VerifiedAccessInstances"},"DescribeVerifiedAccessTrustProviders":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VerifiedAccessTrustProviders"},"DescribeVolumeStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumeStatuses"},"DescribeVolumes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Volumes"},"DescribeVolumesModifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VolumesModifications"},"DescribeVpcClassicLinkDnsSupport":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpcEndpointConnectionNotifications":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ConnectionNotificationSet"},"DescribeVpcEndpointConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpointConnections"},"DescribeVpcEndpointServiceConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServiceConfigurations"},"DescribeVpcEndpointServicePermissions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AllowedPrincipals"},"DescribeVpcEndpoints":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcEndpoints"},"DescribeVpcPeeringConnections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpcPeeringConnections"},"DescribeVpcs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Vpcs"},"DescribeVpnConnections":{"result_key":"VpnConnections"},"DescribeVpnGateways":{"result_key":"VpnGateways"},"GetAssociatedIpv6PoolCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Ipv6CidrAssociations"},"GetAwsNetworkPerformanceData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DataResponses"},"GetGroupsForCapacityReservation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CapacityReservationGroups"},"GetInstanceTypesFromInstanceRequirements":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceTypes"},"GetIpamAddressHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"HistoryRecords"},"GetIpamDiscoveredAccounts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamDiscoveredAccounts"},"GetIpamDiscoveredResourceCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamDiscoveredResourceCidrs"},"GetIpamPoolAllocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamPoolAllocations"},"GetIpamPoolCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamPoolCidrs"},"GetIpamResourceCidrs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"IpamResourceCidrs"},"GetManagedPrefixListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PrefixListAssociations"},"GetManagedPrefixListEntries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Entries"},"GetNetworkInsightsAccessScopeAnalysisFindings":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AnalysisFindings"},"GetSecurityGroupsForVpc":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SecurityGroupForVpcs"},"GetSpotPlacementScores":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"SpotPlacementScores"},"GetTransitGatewayAttachmentPropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayAttachmentPropagations"},"GetTransitGatewayMulticastDomainAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MulticastDomainAssociations"},"GetTransitGatewayPolicyTableAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"GetTransitGatewayPrefixListReferences":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayPrefixListReferences"},"GetTransitGatewayRouteTableAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"GetTransitGatewayRouteTablePropagations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"TransitGatewayRouteTablePropagations"},"GetVpnConnectionDeviceTypes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"VpnConnectionDeviceTypes"},"ListImagesInRecycleBin":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Images"},"ListSnapshotsInRecycleBin":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Snapshots"},"SearchLocalGatewayRoutes":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Routes"},"SearchTransitGatewayMulticastGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MulticastGroups"}}}

/***/ }),
/* 477 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceExists":{"delay":5,"maxAttempts":40,"operation":"DescribeInstances","acceptors":[{"matcher":"path","expected":true,"argument":"length(Reservations[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"BundleTaskComplete":{"delay":15,"operation":"DescribeBundleTasks","maxAttempts":40,"acceptors":[{"expected":"complete","matcher":"pathAll","state":"success","argument":"BundleTasks[].State"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"BundleTasks[].State"}]},"ConversionTaskCancelled":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"ConversionTaskCompleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"},{"expected":"cancelled","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"},{"expected":"cancelling","matcher":"pathAny","state":"failure","argument":"ConversionTasks[].State"}]},"ConversionTaskDeleted":{"delay":15,"operation":"DescribeConversionTasks","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"ConversionTasks[].State"}]},"CustomerGatewayAvailable":{"delay":15,"operation":"DescribeCustomerGateways","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"CustomerGateways[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"CustomerGateways[].State"}]},"ExportTaskCancelled":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"cancelled","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ExportTaskCompleted":{"delay":15,"operation":"DescribeExportTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ExportTasks[].State"}]},"ImageExists":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"matcher":"path","expected":true,"argument":"length(Images[]) > `0`","state":"success"},{"matcher":"error","expected":"InvalidAMIID.NotFound","state":"retry"}]},"ImageAvailable":{"operation":"DescribeImages","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Images[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"Images[].State","expected":"failed"}]},"InstanceRunning":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"running","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"shutting-down","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].InstanceStatus.Status","expected":"ok"},{"matcher":"error","expected":"InvalidInstanceID.NotFound","state":"retry"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Reservations[].Instances[].State.Name"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Reservations[].Instances[].State.Name"}]},"InternetGatewayExists":{"operation":"DescribeInternetGateways","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(InternetGateways[].InternetGatewayId) > `0`"},{"expected":"InvalidInternetGateway.NotFound","matcher":"error","state":"retry"}]},"KeyPairExists":{"operation":"DescribeKeyPairs","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(KeyPairs[].KeyName) > `0`"},{"expected":"InvalidKeyPair.NotFound","matcher":"error","state":"retry"}]},"NatGatewayAvailable":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"available"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"failed"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleting"},{"state":"failure","matcher":"pathAny","argument":"NatGateways[].State","expected":"deleted"},{"state":"retry","matcher":"error","expected":"NatGatewayNotFound"}]},"NatGatewayDeleted":{"operation":"DescribeNatGateways","delay":15,"maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"NatGateways[].State","expected":"deleted"},{"state":"success","matcher":"error","expected":"NatGatewayNotFound"}]},"NetworkInterfaceAvailable":{"operation":"DescribeNetworkInterfaces","delay":20,"maxAttempts":10,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"NetworkInterfaces[].Status"},{"expected":"InvalidNetworkInterfaceID.NotFound","matcher":"error","state":"failure"}]},"PasswordDataAvailable":{"operation":"GetPasswordData","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"path","argument":"length(PasswordData) > `0`","expected":true}]},"SnapshotCompleted":{"delay":15,"operation":"DescribeSnapshots","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"Snapshots[].State"},{"expected":"error","matcher":"pathAny","state":"failure","argument":"Snapshots[].State"}]},"SnapshotImported":{"delay":15,"operation":"DescribeImportSnapshotTasks","maxAttempts":40,"acceptors":[{"expected":"completed","matcher":"pathAll","state":"success","argument":"ImportSnapshotTasks[].SnapshotTaskDetail.Status"},{"expected":"error","matcher":"pathAny","state":"failure","argument":"ImportSnapshotTasks[].SnapshotTaskDetail.Status"}]},"SecurityGroupExists":{"operation":"DescribeSecurityGroups","delay":5,"maxAttempts":6,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(SecurityGroups[].GroupId) > `0`"},{"expected":"InvalidGroup.NotFound","matcher":"error","state":"retry"}]},"SpotInstanceRequestFulfilled":{"operation":"DescribeSpotInstanceRequests","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"fulfilled"},{"state":"success","matcher":"pathAll","argument":"SpotInstanceRequests[].Status.Code","expected":"request-canceled-and-instance-running"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"schedule-expired"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"canceled-before-fulfillment"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"bad-parameters"},{"state":"failure","matcher":"pathAny","argument":"SpotInstanceRequests[].Status.Code","expected":"system-error"},{"state":"retry","matcher":"error","expected":"InvalidSpotInstanceRequestID.NotFound"}]},"StoreImageTaskComplete":{"delay":5,"operation":"DescribeStoreImageTasks","maxAttempts":40,"acceptors":[{"expected":"Completed","matcher":"pathAll","state":"success","argument":"StoreImageTaskResults[].StoreTaskState"},{"expected":"Failed","matcher":"pathAny","state":"failure","argument":"StoreImageTaskResults[].StoreTaskState"},{"expected":"InProgress","matcher":"pathAny","state":"retry","argument":"StoreImageTaskResults[].StoreTaskState"}]},"SubnetAvailable":{"delay":15,"operation":"DescribeSubnets","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Subnets[].State"}]},"SystemStatusOk":{"operation":"DescribeInstanceStatus","maxAttempts":40,"delay":15,"acceptors":[{"state":"success","matcher":"pathAll","argument":"InstanceStatuses[].SystemStatus.Status","expected":"ok"}]},"VolumeAvailable":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VolumeDeleted":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"matcher":"error","expected":"InvalidVolume.NotFound","state":"success"}]},"VolumeInUse":{"delay":15,"operation":"DescribeVolumes","maxAttempts":40,"acceptors":[{"expected":"in-use","matcher":"pathAll","state":"success","argument":"Volumes[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Volumes[].State"}]},"VpcAvailable":{"delay":15,"operation":"DescribeVpcs","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Vpcs[].State"}]},"VpcExists":{"operation":"DescribeVpcs","delay":1,"maxAttempts":5,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcID.NotFound","state":"retry"}]},"VpnConnectionAvailable":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpnConnectionDeleted":{"delay":15,"operation":"DescribeVpnConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpnConnections[].State"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"VpnConnections[].State"}]},"VpcPeeringConnectionExists":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"retry"}]},"VpcPeeringConnectionDeleted":{"delay":15,"operation":"DescribeVpcPeeringConnections","maxAttempts":40,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"VpcPeeringConnections[].Status.Code"},{"matcher":"error","expected":"InvalidVpcPeeringConnectionID.NotFound","state":"success"}]}}}

/***/ }),
/* 478 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-09-21","endpointPrefix":"api.ecr","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceAbbreviation":"Amazon ECR","serviceFullName":"Amazon EC2 Container Registry","serviceId":"ECR","signatureVersion":"v4","signingName":"ecr","targetPrefix":"AmazonEC2ContainerRegistry_V20150921","uid":"ecr-2015-09-21"},"operations":{"BatchCheckLayerAvailability":{"input":{"type":"structure","required":["repositoryName","layerDigests"],"members":{"registryId":{},"repositoryName":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"layers":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"layerAvailability":{},"layerSize":{"type":"long"},"mediaType":{}}}},"failures":{"type":"list","member":{"type":"structure","members":{"layerDigest":{},"failureCode":{},"failureReason":{}}}}}}},"BatchDeleteImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"failures":{"shape":"Sn"}}}},"BatchGetImage":{"input":{"type":"structure","required":["repositoryName","imageIds"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"acceptedMediaTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"images":{"type":"list","member":{"shape":"Sv"}},"failures":{"shape":"Sn"}}}},"BatchGetRepositoryScanningConfiguration":{"input":{"type":"structure","required":["repositoryNames"],"members":{"repositoryNames":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"scanningConfigurations":{"type":"list","member":{"type":"structure","members":{"repositoryArn":{},"repositoryName":{},"scanOnPush":{"type":"boolean"},"scanFrequency":{},"appliedScanFilters":{"shape":"S15"}}}},"failures":{"type":"list","member":{"type":"structure","members":{"repositoryName":{},"failureCode":{},"failureReason":{}}}}}}},"CompleteLayerUpload":{"input":{"type":"structure","required":["repositoryName","uploadId","layerDigests"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigests":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"layerDigest":{}}}},"CreatePullThroughCacheRule":{"input":{"type":"structure","required":["ecrRepositoryPrefix","upstreamRegistryUrl"],"members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"registryId":{},"upstreamRegistry":{},"credentialArn":{}}},"output":{"type":"structure","members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"createdAt":{"type":"timestamp"},"registryId":{},"upstreamRegistry":{},"credentialArn":{}}}},"CreateRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"tags":{"shape":"S1p"},"imageTagMutability":{},"imageScanningConfiguration":{"shape":"S1u"},"encryptionConfiguration":{"shape":"S1v"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1z"}}}},"DeleteLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"DeletePullThroughCacheRule":{"input":{"type":"structure","required":["ecrRepositoryPrefix"],"members":{"ecrRepositoryPrefix":{},"registryId":{}}},"output":{"type":"structure","members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"createdAt":{"type":"timestamp"},"registryId":{},"credentialArn":{}}}},"DeleteRegistryPolicy":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"policyText":{}}}},"DeleteRepository":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"repository":{"shape":"S1z"}}}},"DeleteRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"DescribeImageReplicationStatus":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"repositoryName":{},"imageId":{"shape":"Sj"},"registryId":{}}},"output":{"type":"structure","members":{"repositoryName":{},"imageId":{"shape":"Sj"},"replicationStatuses":{"type":"list","member":{"type":"structure","members":{"region":{},"registryId":{},"status":{},"failureCode":{}}}}}}},"DescribeImageScanFindings":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageScanStatus":{"shape":"S2q"},"imageScanFindings":{"type":"structure","members":{"imageScanCompletedAt":{"type":"timestamp"},"vulnerabilitySourceUpdatedAt":{"type":"timestamp"},"findingSeverityCounts":{"shape":"S2w"},"findings":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"uri":{},"severity":{},"attributes":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}}}}},"enhancedFindings":{"type":"list","member":{"type":"structure","members":{"awsAccountId":{},"description":{},"findingArn":{},"firstObservedAt":{"type":"timestamp"},"lastObservedAt":{"type":"timestamp"},"packageVulnerabilityDetails":{"type":"structure","members":{"cvss":{"type":"list","member":{"type":"structure","members":{"baseScore":{"type":"double"},"scoringVector":{},"source":{},"version":{}}}},"referenceUrls":{"type":"list","member":{}},"relatedVulnerabilities":{"type":"list","member":{}},"source":{},"sourceUrl":{},"vendorCreatedAt":{"type":"timestamp"},"vendorSeverity":{},"vendorUpdatedAt":{"type":"timestamp"},"vulnerabilityId":{},"vulnerablePackages":{"type":"list","member":{"type":"structure","members":{"arch":{},"epoch":{"type":"integer"},"filePath":{},"name":{},"packageManager":{},"release":{},"sourceLayerHash":{},"version":{}}}}}},"remediation":{"type":"structure","members":{"recommendation":{"type":"structure","members":{"url":{},"text":{}}}}},"resources":{"type":"list","member":{"type":"structure","members":{"details":{"type":"structure","members":{"awsEcrContainerImage":{"type":"structure","members":{"architecture":{},"author":{},"imageHash":{},"imageTags":{"type":"list","member":{}},"platform":{},"pushedAt":{"type":"timestamp"},"registry":{},"repositoryName":{}}}}},"id":{},"tags":{"type":"map","key":{},"value":{}},"type":{}}}},"score":{"type":"double"},"scoreDetails":{"type":"structure","members":{"cvss":{"type":"structure","members":{"adjustments":{"type":"list","member":{"type":"structure","members":{"metric":{},"reason":{}}}},"score":{"type":"double"},"scoreSource":{},"scoringVector":{},"version":{}}}}},"severity":{},"status":{},"title":{},"type":{},"updatedAt":{"type":"timestamp"}}}}}},"nextToken":{}}}},"DescribeImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageDetails":{"type":"list","member":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageDigest":{},"imageTags":{"shape":"S4o"},"imageSizeInBytes":{"type":"long"},"imagePushedAt":{"type":"timestamp"},"imageScanStatus":{"shape":"S2q"},"imageScanFindingsSummary":{"type":"structure","members":{"imageScanCompletedAt":{"type":"timestamp"},"vulnerabilitySourceUpdatedAt":{"type":"timestamp"},"findingSeverityCounts":{"shape":"S2w"}}},"imageManifestMediaType":{},"artifactMediaType":{},"lastRecordedPullTime":{"type":"timestamp"}}}},"nextToken":{}}}},"DescribePullThroughCacheRules":{"input":{"type":"structure","members":{"registryId":{},"ecrRepositoryPrefixes":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"pullThroughCacheRules":{"type":"list","member":{"type":"structure","members":{"ecrRepositoryPrefix":{},"upstreamRegistryUrl":{},"createdAt":{"type":"timestamp"},"registryId":{},"credentialArn":{},"upstreamRegistry":{},"updatedAt":{"type":"timestamp"}}}},"nextToken":{}}}},"DescribeRegistry":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"replicationConfiguration":{"shape":"S51"}}}},"DescribeRepositories":{"input":{"type":"structure","members":{"registryId":{},"repositoryNames":{"type":"list","member":{}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"repositories":{"type":"list","member":{"shape":"S1z"}},"nextToken":{}}}},"GetAuthorizationToken":{"input":{"type":"structure","members":{"registryIds":{"deprecated":true,"deprecatedMessage":"This field is deprecated. The returned authorization token can be used to access any Amazon ECR registry that the IAM principal has access to, specifying a registry ID doesn't change the permissions scope of the authorization token.","type":"list","member":{}}}},"output":{"type":"structure","members":{"authorizationData":{"type":"list","member":{"type":"structure","members":{"authorizationToken":{},"expiresAt":{"type":"timestamp"},"proxyEndpoint":{}}}}}}},"GetDownloadUrlForLayer":{"input":{"type":"structure","required":["repositoryName","layerDigest"],"members":{"registryId":{},"repositoryName":{},"layerDigest":{}}},"output":{"type":"structure","members":{"downloadUrl":{},"layerDigest":{}}}},"GetLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"lastEvaluatedAt":{"type":"timestamp"}}}},"GetLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"imageIds":{"shape":"Si"},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{},"nextToken":{},"previewResults":{"type":"list","member":{"type":"structure","members":{"imageTags":{"shape":"S4o"},"imageDigest":{},"imagePushedAt":{"type":"timestamp"},"action":{"type":"structure","members":{"type":{}}},"appliedRulePriority":{"type":"integer"}}}},"summary":{"type":"structure","members":{"expiringImageTotalCount":{"type":"integer"}}}}}},"GetRegistryPolicy":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"policyText":{}}}},"GetRegistryScanningConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registryId":{},"scanningConfiguration":{"shape":"S66"}}}},"GetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"InitiateLayerUpload":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{}}},"output":{"type":"structure","members":{"uploadId":{},"partSize":{"type":"long"}}}},"ListImages":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"nextToken":{},"maxResults":{"type":"integer"},"filter":{"type":"structure","members":{"tagStatus":{}}}}},"output":{"type":"structure","members":{"imageIds":{"shape":"Si"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"S1p"}}}},"PutImage":{"input":{"type":"structure","required":["repositoryName","imageManifest"],"members":{"registryId":{},"repositoryName":{},"imageManifest":{},"imageManifestMediaType":{},"imageTag":{},"imageDigest":{}}},"output":{"type":"structure","members":{"image":{"shape":"Sv"}}}},"PutImageScanningConfiguration":{"input":{"type":"structure","required":["repositoryName","imageScanningConfiguration"],"members":{"registryId":{},"repositoryName":{},"imageScanningConfiguration":{"shape":"S1u"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageScanningConfiguration":{"shape":"S1u"}}}},"PutImageTagMutability":{"input":{"type":"structure","required":["repositoryName","imageTagMutability"],"members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageTagMutability":{}}}},"PutLifecyclePolicy":{"input":{"type":"structure","required":["repositoryName","lifecyclePolicyText"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}}},"PutRegistryPolicy":{"input":{"type":"structure","required":["policyText"],"members":{"policyText":{}}},"output":{"type":"structure","members":{"registryId":{},"policyText":{}}}},"PutRegistryScanningConfiguration":{"input":{"type":"structure","members":{"scanType":{},"rules":{"shape":"S68"}}},"output":{"type":"structure","members":{"registryScanningConfiguration":{"shape":"S66"}}}},"PutReplicationConfiguration":{"input":{"type":"structure","required":["replicationConfiguration"],"members":{"replicationConfiguration":{"shape":"S51"}}},"output":{"type":"structure","members":{"replicationConfiguration":{"shape":"S51"}}}},"SetRepositoryPolicy":{"input":{"type":"structure","required":["repositoryName","policyText"],"members":{"registryId":{},"repositoryName":{},"policyText":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"policyText":{}}}},"StartImageScan":{"input":{"type":"structure","required":["repositoryName","imageId"],"members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageScanStatus":{"shape":"S2q"}}}},"StartLifecyclePolicyPreview":{"input":{"type":"structure","required":["repositoryName"],"members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"lifecyclePolicyText":{},"status":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S1p"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdatePullThroughCacheRule":{"input":{"type":"structure","required":["ecrRepositoryPrefix","credentialArn"],"members":{"registryId":{},"ecrRepositoryPrefix":{},"credentialArn":{}}},"output":{"type":"structure","members":{"ecrRepositoryPrefix":{},"registryId":{},"updatedAt":{"type":"timestamp"},"credentialArn":{}}}},"UploadLayerPart":{"input":{"type":"structure","required":["repositoryName","uploadId","partFirstByte","partLastByte","layerPartBlob"],"members":{"registryId":{},"repositoryName":{},"uploadId":{},"partFirstByte":{"type":"long"},"partLastByte":{"type":"long"},"layerPartBlob":{"type":"blob"}}},"output":{"type":"structure","members":{"registryId":{},"repositoryName":{},"uploadId":{},"lastByteReceived":{"type":"long"}}}},"ValidatePullThroughCacheRule":{"input":{"type":"structure","required":["ecrRepositoryPrefix"],"members":{"ecrRepositoryPrefix":{},"registryId":{}}},"output":{"type":"structure","members":{"ecrRepositoryPrefix":{},"registryId":{},"upstreamRegistryUrl":{},"credentialArn":{},"isValid":{"type":"boolean"},"failure":{}}}}},"shapes":{"Si":{"type":"list","member":{"shape":"Sj"}},"Sj":{"type":"structure","members":{"imageDigest":{},"imageTag":{}}},"Sn":{"type":"list","member":{"type":"structure","members":{"imageId":{"shape":"Sj"},"failureCode":{},"failureReason":{}}}},"Sv":{"type":"structure","members":{"registryId":{},"repositoryName":{},"imageId":{"shape":"Sj"},"imageManifest":{},"imageManifestMediaType":{}}},"S15":{"type":"list","member":{"type":"structure","required":["filter","filterType"],"members":{"filter":{},"filterType":{}}}},"S1p":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1u":{"type":"structure","members":{"scanOnPush":{"type":"boolean"}}},"S1v":{"type":"structure","required":["encryptionType"],"members":{"encryptionType":{},"kmsKey":{}}},"S1z":{"type":"structure","members":{"repositoryArn":{},"registryId":{},"repositoryName":{},"repositoryUri":{},"createdAt":{"type":"timestamp"},"imageTagMutability":{},"imageScanningConfiguration":{"shape":"S1u"},"encryptionConfiguration":{"shape":"S1v"}}},"S2q":{"type":"structure","members":{"status":{},"description":{}}},"S2w":{"type":"map","key":{},"value":{"type":"integer"}},"S4o":{"type":"list","member":{}},"S51":{"type":"structure","required":["rules"],"members":{"rules":{"type":"list","member":{"type":"structure","required":["destinations"],"members":{"destinations":{"type":"list","member":{"type":"structure","required":["region","registryId"],"members":{"region":{},"registryId":{}}}},"repositoryFilters":{"type":"list","member":{"type":"structure","required":["filter","filterType"],"members":{"filter":{},"filterType":{}}}}}}}}},"S66":{"type":"structure","members":{"scanType":{},"rules":{"shape":"S68"}}},"S68":{"type":"list","member":{"type":"structure","required":["scanFrequency","repositoryFilters"],"members":{"scanFrequency":{},"repositoryFilters":{"shape":"S15"}}}}}}

/***/ }),
/* 479 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeImageScanFindings":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["registryId","repositoryName","imageId","imageScanStatus","imageScanFindings"],"output_token":"nextToken","result_key":["imageScanFindings.findings","imageScanFindings.enhancedFindings"]},"DescribeImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageDetails"},"DescribePullThroughCacheRules":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"pullThroughCacheRules"},"DescribeRepositories":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"repositories"},"GetLifecyclePolicyPreview":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["registryId","repositoryName","lifecyclePolicyText","status","summary"],"output_token":"nextToken","result_key":"previewResults"},"ListImages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"imageIds"}}}

/***/ }),
/* 480 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ImageScanComplete":{"description":"Wait until an image scan is complete and findings can be accessed","operation":"DescribeImageScanFindings","delay":5,"maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"imageScanStatus.status","expected":"COMPLETE"},{"state":"failure","matcher":"path","argument":"imageScanStatus.status","expected":"FAILED"}]},"LifecyclePolicyPreviewComplete":{"description":"Wait until a lifecycle policy preview request is complete and results can be accessed","operation":"GetLifecyclePolicyPreview","delay":5,"maxAttempts":20,"acceptors":[{"state":"success","matcher":"path","argument":"status","expected":"COMPLETE"},{"state":"failure","matcher":"path","argument":"status","expected":"FAILED"}]}}}

/***/ }),
/* 481 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-13","endpointPrefix":"ecs","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon ECS","serviceFullName":"Amazon EC2 Container Service","serviceId":"ECS","signatureVersion":"v4","targetPrefix":"AmazonEC2ContainerServiceV20141113","uid":"ecs-2014-11-13"},"operations":{"CreateCapacityProvider":{"input":{"type":"structure","required":["name","autoScalingGroupProvider"],"members":{"name":{},"autoScalingGroupProvider":{"shape":"S3"},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Sg"}}}},"CreateCluster":{"input":{"type":"structure","members":{"clusterName":{},"tags":{"shape":"Sb"},"settings":{"shape":"Sk"},"configuration":{"shape":"Sn"},"capacityProviders":{"shape":"Ss"},"defaultCapacityProviderStrategy":{"shape":"St"},"serviceConnectDefaults":{"shape":"Sx"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sz"}}}},"CreateService":{"input":{"type":"structure","required":["serviceName"],"members":{"cluster":{},"serviceName":{},"taskDefinition":{},"loadBalancers":{"shape":"S18"},"serviceRegistries":{"shape":"S1b"},"desiredCount":{"type":"integer"},"clientToken":{},"launchType":{},"capacityProviderStrategy":{"shape":"St"},"platformVersion":{},"role":{},"deploymentConfiguration":{"shape":"S1e"},"placementConstraints":{"shape":"S1h"},"placementStrategy":{"shape":"S1k"},"networkConfiguration":{"shape":"S1n"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"S1r"},"tags":{"shape":"Sb"},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{},"enableExecuteCommand":{"type":"boolean"},"serviceConnectConfiguration":{"shape":"S1u"},"volumeConfigurations":{"shape":"S29"}}},"output":{"type":"structure","members":{"service":{"shape":"S2n"}}}},"CreateTaskSet":{"input":{"type":"structure","required":["service","cluster","taskDefinition"],"members":{"service":{},"cluster":{},"externalId":{},"taskDefinition":{},"networkConfiguration":{"shape":"S1n"},"loadBalancers":{"shape":"S18"},"serviceRegistries":{"shape":"S1b"},"launchType":{},"capacityProviderStrategy":{"shape":"St"},"platformVersion":{},"scale":{"shape":"S2r"},"clientToken":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S2p"}}}},"DeleteAccountSetting":{"input":{"type":"structure","required":["name"],"members":{"name":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S37"}}}},"DeleteAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S3a"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S3a"}}}},"DeleteCapacityProvider":{"input":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Sg"}}}},"DeleteCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sz"}}}},"DeleteService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"service":{"shape":"S2n"}}}},"DeleteTaskDefinitions":{"input":{"type":"structure","required":["taskDefinitions"],"members":{"taskDefinitions":{"shape":"Ss"}}},"output":{"type":"structure","members":{"taskDefinitions":{"type":"list","member":{"shape":"S3n"}},"failures":{"shape":"S5o"}}}},"DeleteTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet"],"members":{"cluster":{},"service":{},"taskSet":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S2p"}}}},"DeregisterContainerInstance":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{},"force":{"type":"boolean"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S5u"}}}},"DeregisterTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S3n"}}}},"DescribeCapacityProviders":{"input":{"type":"structure","members":{"capacityProviders":{"shape":"Ss"},"include":{"type":"list","member":{}},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"capacityProviders":{"type":"list","member":{"shape":"Sg"}},"failures":{"shape":"S5o"},"nextToken":{}}}},"DescribeClusters":{"input":{"type":"structure","members":{"clusters":{"shape":"Ss"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"clusters":{"type":"list","member":{"shape":"Sz"}},"failures":{"shape":"S5o"}}}},"DescribeContainerInstances":{"input":{"type":"structure","required":["containerInstances"],"members":{"cluster":{},"containerInstances":{"shape":"Ss"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S6l"},"failures":{"shape":"S5o"}}}},"DescribeServices":{"input":{"type":"structure","required":["services"],"members":{"cluster":{},"services":{"shape":"Ss"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"services":{"type":"list","member":{"shape":"S2n"}},"failures":{"shape":"S5o"}}}},"DescribeTaskDefinition":{"input":{"type":"structure","required":["taskDefinition"],"members":{"taskDefinition":{},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S3n"},"tags":{"shape":"Sb"}}}},"DescribeTaskSets":{"input":{"type":"structure","required":["cluster","service"],"members":{"cluster":{},"service":{},"taskSets":{"shape":"Ss"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"taskSets":{"shape":"S2o"},"failures":{"shape":"S5o"}}}},"DescribeTasks":{"input":{"type":"structure","required":["tasks"],"members":{"cluster":{},"tasks":{"shape":"Ss"},"include":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"tasks":{"shape":"S73"},"failures":{"shape":"S5o"}}}},"DiscoverPollEndpoint":{"input":{"type":"structure","members":{"containerInstance":{},"cluster":{}}},"output":{"type":"structure","members":{"endpoint":{},"telemetryEndpoint":{},"serviceConnectEndpoint":{}}}},"ExecuteCommand":{"input":{"type":"structure","required":["command","interactive","task"],"members":{"cluster":{},"container":{},"command":{},"interactive":{"type":"boolean"},"task":{}}},"output":{"type":"structure","members":{"clusterArn":{},"containerArn":{},"containerName":{},"interactive":{"type":"boolean"},"session":{"type":"structure","members":{"sessionId":{},"streamUrl":{},"tokenValue":{"type":"string","sensitive":true}}},"taskArn":{}}}},"GetTaskProtection":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{},"tasks":{"shape":"Ss"}}},"output":{"type":"structure","members":{"protectedTasks":{"shape":"S7v"},"failures":{"shape":"S5o"}}}},"ListAccountSettings":{"input":{"type":"structure","members":{"name":{},"value":{},"principalArn":{},"effectiveSettings":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"settings":{"type":"list","member":{"shape":"S37"}},"nextToken":{}}}},"ListAttributes":{"input":{"type":"structure","required":["targetType"],"members":{"cluster":{},"targetType":{},"attributeName":{},"attributeValue":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S3a"},"nextToken":{}}}},"ListClusters":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"clusterArns":{"shape":"Ss"},"nextToken":{}}}},"ListContainerInstances":{"input":{"type":"structure","members":{"cluster":{},"filter":{},"nextToken":{},"maxResults":{"type":"integer"},"status":{}}},"output":{"type":"structure","members":{"containerInstanceArns":{"shape":"Ss"},"nextToken":{}}}},"ListServices":{"input":{"type":"structure","members":{"cluster":{},"nextToken":{},"maxResults":{"type":"integer"},"launchType":{},"schedulingStrategy":{}}},"output":{"type":"structure","members":{"serviceArns":{"shape":"Ss"},"nextToken":{}}}},"ListServicesByNamespace":{"input":{"type":"structure","required":["namespace"],"members":{"namespace":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"serviceArns":{"shape":"Ss"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sb"}}}},"ListTaskDefinitionFamilies":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"families":{"shape":"Ss"},"nextToken":{}}}},"ListTaskDefinitions":{"input":{"type":"structure","members":{"familyPrefix":{},"status":{},"sort":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"taskDefinitionArns":{"shape":"Ss"},"nextToken":{}}}},"ListTasks":{"input":{"type":"structure","members":{"cluster":{},"containerInstance":{},"family":{},"nextToken":{},"maxResults":{"type":"integer"},"startedBy":{},"serviceName":{},"desiredStatus":{},"launchType":{}}},"output":{"type":"structure","members":{"taskArns":{"shape":"Ss"},"nextToken":{}}}},"PutAccountSetting":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{},"principalArn":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S37"}}}},"PutAccountSettingDefault":{"input":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}},"output":{"type":"structure","members":{"setting":{"shape":"S37"}}}},"PutAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"cluster":{},"attributes":{"shape":"S3a"}}},"output":{"type":"structure","members":{"attributes":{"shape":"S3a"}}}},"PutClusterCapacityProviders":{"input":{"type":"structure","required":["cluster","capacityProviders","defaultCapacityProviderStrategy"],"members":{"cluster":{},"capacityProviders":{"shape":"Ss"},"defaultCapacityProviderStrategy":{"shape":"St"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sz"}}}},"RegisterContainerInstance":{"input":{"type":"structure","members":{"cluster":{},"instanceIdentityDocument":{},"instanceIdentityDocumentSignature":{},"totalResources":{"shape":"S5x"},"versionInfo":{"shape":"S5w"},"containerInstanceArn":{},"attributes":{"shape":"S3a"},"platformDevices":{"type":"list","member":{"type":"structure","required":["id","type"],"members":{"id":{},"type":{}}}},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S5u"}}}},"RegisterTaskDefinition":{"input":{"type":"structure","required":["family","containerDefinitions"],"members":{"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"containerDefinitions":{"shape":"S3o"},"volumes":{"shape":"S4u"},"placementConstraints":{"shape":"S58"},"requiresCompatibilities":{"shape":"S5b"},"cpu":{},"memory":{},"tags":{"shape":"Sb"},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S5k"},"inferenceAccelerators":{"shape":"S5g"},"ephemeralStorage":{"shape":"S5n"},"runtimePlatform":{"shape":"S5d"}}},"output":{"type":"structure","members":{"taskDefinition":{"shape":"S3n"},"tags":{"shape":"Sb"}}}},"RunTask":{"input":{"type":"structure","required":["taskDefinition"],"members":{"capacityProviderStrategy":{"shape":"St"},"cluster":{},"count":{"type":"integer"},"enableECSManagedTags":{"type":"boolean"},"enableExecuteCommand":{"type":"boolean"},"group":{},"launchType":{},"networkConfiguration":{"shape":"S1n"},"overrides":{"shape":"S7h"},"placementConstraints":{"shape":"S1h"},"placementStrategy":{"shape":"S1k"},"platformVersion":{},"propagateTags":{},"referenceId":{},"startedBy":{},"tags":{"shape":"Sb"},"taskDefinition":{},"clientToken":{"idempotencyToken":true},"volumeConfigurations":{"shape":"S92"}}},"output":{"type":"structure","members":{"tasks":{"shape":"S73"},"failures":{"shape":"S5o"}}}},"StartTask":{"input":{"type":"structure","required":["containerInstances","taskDefinition"],"members":{"cluster":{},"containerInstances":{"shape":"Ss"},"enableECSManagedTags":{"type":"boolean"},"enableExecuteCommand":{"type":"boolean"},"group":{},"networkConfiguration":{"shape":"S1n"},"overrides":{"shape":"S7h"},"propagateTags":{},"referenceId":{},"startedBy":{},"tags":{"shape":"Sb"},"taskDefinition":{},"volumeConfigurations":{"shape":"S92"}}},"output":{"type":"structure","members":{"tasks":{"shape":"S73"},"failures":{"shape":"S5o"}}}},"StopTask":{"input":{"type":"structure","required":["task"],"members":{"cluster":{},"task":{},"reason":{}}},"output":{"type":"structure","members":{"task":{"shape":"S74"}}}},"SubmitAttachmentStateChanges":{"input":{"type":"structure","required":["attachments"],"members":{"cluster":{},"attachments":{"shape":"S9c"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitContainerStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"containerName":{},"runtimeId":{},"status":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S78"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"SubmitTaskStateChange":{"input":{"type":"structure","members":{"cluster":{},"task":{},"status":{},"reason":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerName":{},"imageDigest":{},"runtimeId":{},"exitCode":{"type":"integer"},"networkBindings":{"shape":"S78"},"reason":{},"status":{}}}},"attachments":{"shape":"S9c"},"managedAgents":{"type":"list","member":{"type":"structure","required":["containerName","managedAgentName","status"],"members":{"containerName":{},"managedAgentName":{},"status":{},"reason":{}}}},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"executionStoppedAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{"acknowledgment":{}}}},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateCapacityProvider":{"input":{"type":"structure","required":["name","autoScalingGroupProvider"],"members":{"name":{},"autoScalingGroupProvider":{"type":"structure","members":{"managedScaling":{"shape":"S4"},"managedTerminationProtection":{},"managedDraining":{}}}}},"output":{"type":"structure","members":{"capacityProvider":{"shape":"Sg"}}}},"UpdateCluster":{"input":{"type":"structure","required":["cluster"],"members":{"cluster":{},"settings":{"shape":"Sk"},"configuration":{"shape":"Sn"},"serviceConnectDefaults":{"shape":"Sx"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sz"}}}},"UpdateClusterSettings":{"input":{"type":"structure","required":["cluster","settings"],"members":{"cluster":{},"settings":{"shape":"Sk"}}},"output":{"type":"structure","members":{"cluster":{"shape":"Sz"}}}},"UpdateContainerAgent":{"input":{"type":"structure","required":["containerInstance"],"members":{"cluster":{},"containerInstance":{}}},"output":{"type":"structure","members":{"containerInstance":{"shape":"S5u"}}}},"UpdateContainerInstancesState":{"input":{"type":"structure","required":["containerInstances","status"],"members":{"cluster":{},"containerInstances":{"shape":"Ss"},"status":{}}},"output":{"type":"structure","members":{"containerInstances":{"shape":"S6l"},"failures":{"shape":"S5o"}}}},"UpdateService":{"input":{"type":"structure","required":["service"],"members":{"cluster":{},"service":{},"desiredCount":{"type":"integer"},"taskDefinition":{},"capacityProviderStrategy":{"shape":"St"},"deploymentConfiguration":{"shape":"S1e"},"networkConfiguration":{"shape":"S1n"},"placementConstraints":{"shape":"S1h"},"placementStrategy":{"shape":"S1k"},"platformVersion":{},"forceNewDeployment":{"type":"boolean"},"healthCheckGracePeriodSeconds":{"type":"integer"},"enableExecuteCommand":{"type":"boolean"},"enableECSManagedTags":{"type":"boolean"},"loadBalancers":{"shape":"S18"},"propagateTags":{},"serviceRegistries":{"shape":"S1b"},"serviceConnectConfiguration":{"shape":"S1u"},"volumeConfigurations":{"shape":"S29"}}},"output":{"type":"structure","members":{"service":{"shape":"S2n"}}}},"UpdateServicePrimaryTaskSet":{"input":{"type":"structure","required":["cluster","service","primaryTaskSet"],"members":{"cluster":{},"service":{},"primaryTaskSet":{}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S2p"}}}},"UpdateTaskProtection":{"input":{"type":"structure","required":["cluster","tasks","protectionEnabled"],"members":{"cluster":{},"tasks":{"shape":"Ss"},"protectionEnabled":{"type":"boolean"},"expiresInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"protectedTasks":{"shape":"S7v"},"failures":{"shape":"S5o"}}}},"UpdateTaskSet":{"input":{"type":"structure","required":["cluster","service","taskSet","scale"],"members":{"cluster":{},"service":{},"taskSet":{},"scale":{"shape":"S2r"}}},"output":{"type":"structure","members":{"taskSet":{"shape":"S2p"}}}}},"shapes":{"S3":{"type":"structure","required":["autoScalingGroupArn"],"members":{"autoScalingGroupArn":{},"managedScaling":{"shape":"S4"},"managedTerminationProtection":{},"managedDraining":{}}},"S4":{"type":"structure","members":{"status":{},"targetCapacity":{"type":"integer"},"minimumScalingStepSize":{"type":"integer"},"maximumScalingStepSize":{"type":"integer"},"instanceWarmupPeriod":{"type":"integer"}}},"Sb":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"Sg":{"type":"structure","members":{"capacityProviderArn":{},"name":{},"status":{},"autoScalingGroupProvider":{"shape":"S3"},"updateStatus":{},"updateStatusReason":{},"tags":{"shape":"Sb"}}},"Sk":{"type":"list","member":{"type":"structure","members":{"name":{},"value":{}}}},"Sn":{"type":"structure","members":{"executeCommandConfiguration":{"type":"structure","members":{"kmsKeyId":{},"logging":{},"logConfiguration":{"type":"structure","members":{"cloudWatchLogGroupName":{},"cloudWatchEncryptionEnabled":{"type":"boolean"},"s3BucketName":{},"s3EncryptionEnabled":{"type":"boolean"},"s3KeyPrefix":{}}}}}}},"Ss":{"type":"list","member":{}},"St":{"type":"list","member":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{},"weight":{"type":"integer"},"base":{"type":"integer"}}}},"Sx":{"type":"structure","required":["namespace"],"members":{"namespace":{}}},"Sz":{"type":"structure","members":{"clusterArn":{},"clusterName":{},"configuration":{"shape":"Sn"},"status":{},"registeredContainerInstancesCount":{"type":"integer"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"activeServicesCount":{"type":"integer"},"statistics":{"type":"list","member":{"shape":"S12"}},"tags":{"shape":"Sb"},"settings":{"shape":"Sk"},"capacityProviders":{"shape":"Ss"},"defaultCapacityProviderStrategy":{"shape":"St"},"attachments":{"shape":"S13"},"attachmentsStatus":{},"serviceConnectDefaults":{"type":"structure","members":{"namespace":{}}}}},"S12":{"type":"structure","members":{"name":{},"value":{}}},"S13":{"type":"list","member":{"type":"structure","members":{"id":{},"type":{},"status":{},"details":{"type":"list","member":{"shape":"S12"}}}}},"S18":{"type":"list","member":{"type":"structure","members":{"targetGroupArn":{},"loadBalancerName":{},"containerName":{},"containerPort":{"type":"integer"}}}},"S1b":{"type":"list","member":{"type":"structure","members":{"registryArn":{},"port":{"type":"integer"},"containerName":{},"containerPort":{"type":"integer"}}}},"S1e":{"type":"structure","members":{"deploymentCircuitBreaker":{"type":"structure","required":["enable","rollback"],"members":{"enable":{"type":"boolean"},"rollback":{"type":"boolean"}}},"maximumPercent":{"type":"integer"},"minimumHealthyPercent":{"type":"integer"},"alarms":{"type":"structure","required":["alarmNames","enable","rollback"],"members":{"alarmNames":{"shape":"Ss"},"enable":{"type":"boolean"},"rollback":{"type":"boolean"}}}}},"S1h":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S1k":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"S1n":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["subnets"],"members":{"subnets":{"shape":"Ss"},"securityGroups":{"shape":"Ss"},"assignPublicIp":{}}}}},"S1r":{"type":"structure","required":["type"],"members":{"type":{}}},"S1u":{"type":"structure","required":["enabled"],"members":{"enabled":{"type":"boolean"},"namespace":{},"services":{"type":"list","member":{"type":"structure","required":["portName"],"members":{"portName":{},"discoveryName":{},"clientAliases":{"type":"list","member":{"type":"structure","required":["port"],"members":{"port":{"type":"integer"},"dnsName":{}}}},"ingressPortOverride":{"type":"integer"},"timeout":{"type":"structure","members":{"idleTimeoutSeconds":{"type":"integer"},"perRequestTimeoutSeconds":{"type":"integer"}}},"tls":{"type":"structure","required":["issuerCertificateAuthority"],"members":{"issuerCertificateAuthority":{"type":"structure","members":{"awsPcaAuthorityArn":{}}},"kmsKey":{},"roleArn":{}}}}}},"logConfiguration":{"shape":"S24"}}},"S24":{"type":"structure","required":["logDriver"],"members":{"logDriver":{},"options":{"type":"map","key":{},"value":{}},"secretOptions":{"shape":"S27"}}},"S27":{"type":"list","member":{"type":"structure","required":["name","valueFrom"],"members":{"name":{},"valueFrom":{}}}},"S29":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"managedEBSVolume":{"type":"structure","required":["roleArn"],"members":{"encrypted":{"type":"boolean"},"kmsKeyId":{},"volumeType":{},"sizeInGiB":{"type":"integer"},"snapshotId":{},"iops":{"type":"integer"},"throughput":{"type":"integer"},"tagSpecifications":{"shape":"S2h"},"roleArn":{},"filesystemType":{}}}}}},"S2h":{"type":"list","member":{"type":"structure","required":["resourceType"],"members":{"resourceType":{},"tags":{"shape":"Sb"},"propagateTags":{}}}},"S2n":{"type":"structure","members":{"serviceArn":{},"serviceName":{},"clusterArn":{},"loadBalancers":{"shape":"S18"},"serviceRegistries":{"shape":"S1b"},"status":{},"desiredCount":{"type":"integer"},"runningCount":{"type":"integer"},"pendingCount":{"type":"integer"},"launchType":{},"capacityProviderStrategy":{"shape":"St"},"platformVersion":{},"platformFamily":{},"taskDefinition":{},"deploymentConfiguration":{"shape":"S1e"},"taskSets":{"shape":"S2o"},"deployments":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"taskDefinition":{},"desiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"failedTasks":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"capacityProviderStrategy":{"shape":"St"},"launchType":{},"platformVersion":{},"platformFamily":{},"networkConfiguration":{"shape":"S1n"},"rolloutState":{},"rolloutStateReason":{},"serviceConnectConfiguration":{"shape":"S1u"},"serviceConnectResources":{"type":"list","member":{"type":"structure","members":{"discoveryName":{},"discoveryArn":{}}}},"volumeConfigurations":{"shape":"S29"}}}},"roleArn":{},"events":{"type":"list","member":{"type":"structure","members":{"id":{},"createdAt":{"type":"timestamp"},"message":{}}}},"createdAt":{"type":"timestamp"},"placementConstraints":{"shape":"S1h"},"placementStrategy":{"shape":"S1k"},"networkConfiguration":{"shape":"S1n"},"healthCheckGracePeriodSeconds":{"type":"integer"},"schedulingStrategy":{},"deploymentController":{"shape":"S1r"},"tags":{"shape":"Sb"},"createdBy":{},"enableECSManagedTags":{"type":"boolean"},"propagateTags":{},"enableExecuteCommand":{"type":"boolean"}}},"S2o":{"type":"list","member":{"shape":"S2p"}},"S2p":{"type":"structure","members":{"id":{},"taskSetArn":{},"serviceArn":{},"clusterArn":{},"startedBy":{},"externalId":{},"status":{},"taskDefinition":{},"computedDesiredCount":{"type":"integer"},"pendingCount":{"type":"integer"},"runningCount":{"type":"integer"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"},"launchType":{},"capacityProviderStrategy":{"shape":"St"},"platformVersion":{},"platformFamily":{},"networkConfiguration":{"shape":"S1n"},"loadBalancers":{"shape":"S18"},"serviceRegistries":{"shape":"S1b"},"scale":{"shape":"S2r"},"stabilityStatus":{},"stabilityStatusAt":{"type":"timestamp"},"tags":{"shape":"Sb"}}},"S2r":{"type":"structure","members":{"value":{"type":"double"},"unit":{}}},"S37":{"type":"structure","members":{"name":{},"value":{},"principalArn":{},"type":{}}},"S3a":{"type":"list","member":{"shape":"S3b"}},"S3b":{"type":"structure","required":["name"],"members":{"name":{},"value":{},"targetType":{},"targetId":{}}},"S3n":{"type":"structure","members":{"taskDefinitionArn":{},"containerDefinitions":{"shape":"S3o"},"family":{},"taskRoleArn":{},"executionRoleArn":{},"networkMode":{},"revision":{"type":"integer"},"volumes":{"shape":"S4u"},"status":{},"requiresAttributes":{"type":"list","member":{"shape":"S3b"}},"placementConstraints":{"shape":"S58"},"compatibilities":{"shape":"S5b"},"runtimePlatform":{"shape":"S5d"},"requiresCompatibilities":{"shape":"S5b"},"cpu":{},"memory":{},"inferenceAccelerators":{"shape":"S5g"},"pidMode":{},"ipcMode":{},"proxyConfiguration":{"shape":"S5k"},"registeredAt":{"type":"timestamp"},"deregisteredAt":{"type":"timestamp"},"registeredBy":{},"ephemeralStorage":{"shape":"S5n"}}},"S3o":{"type":"list","member":{"type":"structure","members":{"name":{},"image":{},"repositoryCredentials":{"type":"structure","required":["credentialsParameter"],"members":{"credentialsParameter":{}}},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"links":{"shape":"Ss"},"portMappings":{"type":"list","member":{"type":"structure","members":{"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{},"name":{},"appProtocol":{},"containerPortRange":{}}}},"essential":{"type":"boolean"},"entryPoint":{"shape":"Ss"},"command":{"shape":"Ss"},"environment":{"shape":"S3v"},"environmentFiles":{"shape":"S3w"},"mountPoints":{"type":"list","member":{"type":"structure","members":{"sourceVolume":{},"containerPath":{},"readOnly":{"type":"boolean"}}}},"volumesFrom":{"type":"list","member":{"type":"structure","members":{"sourceContainer":{},"readOnly":{"type":"boolean"}}}},"linuxParameters":{"type":"structure","members":{"capabilities":{"type":"structure","members":{"add":{"shape":"Ss"},"drop":{"shape":"Ss"}}},"devices":{"type":"list","member":{"type":"structure","required":["hostPath"],"members":{"hostPath":{},"containerPath":{},"permissions":{"type":"list","member":{}}}}},"initProcessEnabled":{"type":"boolean"},"sharedMemorySize":{"type":"integer"},"tmpfs":{"type":"list","member":{"type":"structure","required":["containerPath","size"],"members":{"containerPath":{},"size":{"type":"integer"},"mountOptions":{"shape":"Ss"}}}},"maxSwap":{"type":"integer"},"swappiness":{"type":"integer"}}},"secrets":{"shape":"S27"},"dependsOn":{"type":"list","member":{"type":"structure","required":["containerName","condition"],"members":{"containerName":{},"condition":{}}}},"startTimeout":{"type":"integer"},"stopTimeout":{"type":"integer"},"hostname":{},"user":{},"workingDirectory":{},"disableNetworking":{"type":"boolean"},"privileged":{"type":"boolean"},"readonlyRootFilesystem":{"type":"boolean"},"dnsServers":{"shape":"Ss"},"dnsSearchDomains":{"shape":"Ss"},"extraHosts":{"type":"list","member":{"type":"structure","required":["hostname","ipAddress"],"members":{"hostname":{},"ipAddress":{}}}},"dockerSecurityOptions":{"shape":"Ss"},"interactive":{"type":"boolean"},"pseudoTerminal":{"type":"boolean"},"dockerLabels":{"type":"map","key":{},"value":{}},"ulimits":{"type":"list","member":{"type":"structure","required":["name","softLimit","hardLimit"],"members":{"name":{},"softLimit":{"type":"integer"},"hardLimit":{"type":"integer"}}}},"logConfiguration":{"shape":"S24"},"healthCheck":{"type":"structure","required":["command"],"members":{"command":{"shape":"Ss"},"interval":{"type":"integer"},"timeout":{"type":"integer"},"retries":{"type":"integer"},"startPeriod":{"type":"integer"}}},"systemControls":{"type":"list","member":{"type":"structure","members":{"namespace":{},"value":{}}}},"resourceRequirements":{"shape":"S4n"},"firelensConfiguration":{"type":"structure","required":["type"],"members":{"type":{},"options":{"type":"map","key":{},"value":{}}}},"credentialSpecs":{"shape":"Ss"}}}},"S3v":{"type":"list","member":{"shape":"S12"}},"S3w":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S4n":{"type":"list","member":{"type":"structure","required":["value","type"],"members":{"value":{},"type":{}}}},"S4u":{"type":"list","member":{"type":"structure","members":{"name":{},"host":{"type":"structure","members":{"sourcePath":{}}},"dockerVolumeConfiguration":{"type":"structure","members":{"scope":{},"autoprovision":{"type":"boolean"},"driver":{},"driverOpts":{"shape":"S4z"},"labels":{"shape":"S4z"}}},"efsVolumeConfiguration":{"type":"structure","required":["fileSystemId"],"members":{"fileSystemId":{},"rootDirectory":{},"transitEncryption":{},"transitEncryptionPort":{"type":"integer"},"authorizationConfig":{"type":"structure","members":{"accessPointId":{},"iam":{}}}}},"fsxWindowsFileServerVolumeConfiguration":{"type":"structure","required":["fileSystemId","rootDirectory","authorizationConfig"],"members":{"fileSystemId":{},"rootDirectory":{},"authorizationConfig":{"type":"structure","required":["credentialsParameter","domain"],"members":{"credentialsParameter":{},"domain":{}}}}},"configuredAtLaunch":{"type":"boolean"}}}},"S4z":{"type":"map","key":{},"value":{}},"S58":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"S5b":{"type":"list","member":{}},"S5d":{"type":"structure","members":{"cpuArchitecture":{},"operatingSystemFamily":{}}},"S5g":{"type":"list","member":{"type":"structure","required":["deviceName","deviceType"],"members":{"deviceName":{},"deviceType":{}}}},"S5k":{"type":"structure","required":["containerName"],"members":{"type":{},"containerName":{},"properties":{"type":"list","member":{"shape":"S12"}}}},"S5n":{"type":"structure","required":["sizeInGiB"],"members":{"sizeInGiB":{"type":"integer"}}},"S5o":{"type":"list","member":{"type":"structure","members":{"arn":{},"reason":{},"detail":{}}}},"S5u":{"type":"structure","members":{"containerInstanceArn":{},"ec2InstanceId":{},"capacityProviderName":{},"version":{"type":"long"},"versionInfo":{"shape":"S5w"},"remainingResources":{"shape":"S5x"},"registeredResources":{"shape":"S5x"},"status":{},"statusReason":{},"agentConnected":{"type":"boolean"},"runningTasksCount":{"type":"integer"},"pendingTasksCount":{"type":"integer"},"agentUpdateStatus":{},"attributes":{"shape":"S3a"},"registeredAt":{"type":"timestamp"},"attachments":{"shape":"S13"},"tags":{"shape":"Sb"},"healthStatus":{"type":"structure","members":{"overallStatus":{},"details":{"type":"list","member":{"type":"structure","members":{"type":{},"status":{},"lastUpdated":{"type":"timestamp"},"lastStatusChange":{"type":"timestamp"}}}}}}}},"S5w":{"type":"structure","members":{"agentVersion":{},"agentHash":{},"dockerVersion":{}}},"S5x":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{},"doubleValue":{"type":"double"},"longValue":{"type":"long"},"integerValue":{"type":"integer"},"stringSetValue":{"shape":"Ss"}}}},"S6l":{"type":"list","member":{"shape":"S5u"}},"S73":{"type":"list","member":{"shape":"S74"}},"S74":{"type":"structure","members":{"attachments":{"shape":"S13"},"attributes":{"shape":"S3a"},"availabilityZone":{},"capacityProviderName":{},"clusterArn":{},"connectivity":{},"connectivityAt":{"type":"timestamp"},"containerInstanceArn":{},"containers":{"type":"list","member":{"type":"structure","members":{"containerArn":{},"taskArn":{},"name":{},"image":{},"imageDigest":{},"runtimeId":{},"lastStatus":{},"exitCode":{"type":"integer"},"reason":{},"networkBindings":{"shape":"S78"},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"attachmentId":{},"privateIpv4Address":{},"ipv6Address":{}}}},"healthStatus":{},"managedAgents":{"type":"list","member":{"type":"structure","members":{"lastStartedAt":{"type":"timestamp"},"name":{},"reason":{},"lastStatus":{}}}},"cpu":{},"memory":{},"memoryReservation":{},"gpuIds":{"type":"list","member":{}}}}},"cpu":{},"createdAt":{"type":"timestamp"},"desiredStatus":{},"enableExecuteCommand":{"type":"boolean"},"executionStoppedAt":{"type":"timestamp"},"group":{},"healthStatus":{},"inferenceAccelerators":{"shape":"S5g"},"lastStatus":{},"launchType":{},"memory":{},"overrides":{"shape":"S7h"},"platformVersion":{},"platformFamily":{},"pullStartedAt":{"type":"timestamp"},"pullStoppedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"startedBy":{},"stopCode":{},"stoppedAt":{"type":"timestamp"},"stoppedReason":{},"stoppingAt":{"type":"timestamp"},"tags":{"shape":"Sb"},"taskArn":{},"taskDefinitionArn":{},"version":{"type":"long"},"ephemeralStorage":{"shape":"S5n"}}},"S78":{"type":"list","member":{"type":"structure","members":{"bindIP":{},"containerPort":{"type":"integer"},"hostPort":{"type":"integer"},"protocol":{},"containerPortRange":{},"hostPortRange":{}}}},"S7h":{"type":"structure","members":{"containerOverrides":{"type":"list","member":{"type":"structure","members":{"name":{},"command":{"shape":"Ss"},"environment":{"shape":"S3v"},"environmentFiles":{"shape":"S3w"},"cpu":{"type":"integer"},"memory":{"type":"integer"},"memoryReservation":{"type":"integer"},"resourceRequirements":{"shape":"S4n"}}}},"cpu":{},"inferenceAcceleratorOverrides":{"type":"list","member":{"type":"structure","members":{"deviceName":{},"deviceType":{}}}},"executionRoleArn":{},"memory":{},"taskRoleArn":{},"ephemeralStorage":{"shape":"S5n"}}},"S7v":{"type":"list","member":{"type":"structure","members":{"taskArn":{},"protectionEnabled":{"type":"boolean"},"expirationDate":{"type":"timestamp"}}}},"S92":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"managedEBSVolume":{"type":"structure","required":["roleArn"],"members":{"encrypted":{"type":"boolean"},"kmsKeyId":{},"volumeType":{},"sizeInGiB":{"type":"integer"},"snapshotId":{},"iops":{"type":"integer"},"throughput":{"type":"integer"},"tagSpecifications":{"shape":"S2h"},"roleArn":{},"terminationPolicy":{"type":"structure","required":["deleteOnTermination"],"members":{"deleteOnTermination":{"type":"boolean"}}},"filesystemType":{}}}}}},"S9c":{"type":"list","member":{"type":"structure","required":["attachmentArn","status"],"members":{"attachmentArn":{},"status":{}}}}}}

/***/ }),
/* 482 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAccountSettings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"settings"},"ListAttributes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"attributes"},"ListClusters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"clusterArns"},"ListContainerInstances":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"containerInstanceArns"},"ListServices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serviceArns"},"ListServicesByNamespace":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"serviceArns"},"ListTaskDefinitionFamilies":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"families"},"ListTaskDefinitions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskDefinitionArns"},"ListTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskArns"}}}

/***/ }),
/* 483 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"TasksRunning":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAny","state":"failure","argument":"tasks[].lastStatus"},{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"RUNNING","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"TasksStopped":{"delay":6,"operation":"DescribeTasks","maxAttempts":100,"acceptors":[{"expected":"STOPPED","matcher":"pathAll","state":"success","argument":"tasks[].lastStatus"}]},"ServicesStable":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"DRAINING","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":"INACTIVE","matcher":"pathAny","state":"failure","argument":"services[].status"},{"expected":true,"matcher":"path","state":"success","argument":"length(services[?!(length(deployments) == `1` && runningCount == desiredCount)]) == `0`"}]},"ServicesInactive":{"delay":15,"operation":"DescribeServices","maxAttempts":40,"acceptors":[{"expected":"MISSING","matcher":"pathAny","state":"failure","argument":"failures[].reason"},{"expected":"INACTIVE","matcher":"pathAny","state":"success","argument":"services[].status"}]}}}

/***/ }),
/* 484 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-02","endpointPrefix":"elasticache","protocol":"query","serviceFullName":"Amazon ElastiCache","serviceId":"ElastiCache","signatureVersion":"v4","uid":"elasticache-2015-02-02","xmlNamespace":"http://elasticache.amazonaws.com/doc/2015-02-02/"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S3"}}},"output":{"shape":"S5","resultWrapper":"AddTagsToResourceResult"}},"AuthorizeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"BatchApplyUpdateAction":{"input":{"type":"structure","required":["ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"ServiceUpdateName":{}}},"output":{"shape":"Se","resultWrapper":"BatchApplyUpdateActionResult"}},"BatchStopUpdateAction":{"input":{"type":"structure","required":["ServiceUpdateName"],"members":{"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"ServiceUpdateName":{}}},"output":{"shape":"Se","resultWrapper":"BatchStopUpdateActionResult"}},"CompleteMigration":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"CompleteMigrationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"CopyServerlessCacheSnapshot":{"input":{"type":"structure","required":["SourceServerlessCacheSnapshotName","TargetServerlessCacheSnapshotName"],"members":{"SourceServerlessCacheSnapshotName":{},"TargetServerlessCacheSnapshotName":{},"KmsKeyId":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CopyServerlessCacheSnapshotResult","type":"structure","members":{"ServerlessCacheSnapshot":{"shape":"S1u"}}}},"CopySnapshot":{"input":{"type":"structure","required":["SourceSnapshotName","TargetSnapshotName"],"members":{"SourceSnapshotName":{},"TargetSnapshotName":{},"TargetBucket":{},"KmsKeyId":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CopySnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1y"}}}},"CreateCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"ReplicationGroupId":{},"AZMode":{},"PreferredAvailabilityZone":{},"PreferredAvailabilityZones":{"shape":"S27"},"NumCacheNodes":{"type":"integer"},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"S28"},"SecurityGroupIds":{"shape":"S29"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S2a"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{},"OutpostMode":{},"PreferredOutpostArn":{},"PreferredOutpostArns":{"shape":"S2c"},"LogDeliveryConfigurations":{"shape":"S2d"},"TransitEncryptionEnabled":{"type":"boolean"},"NetworkType":{},"IpDiscovery":{}}},"output":{"resultWrapper":"CreateCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S2g"}}}},"CreateCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","CacheParameterGroupFamily","Description"],"members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateCacheParameterGroupResult","type":"structure","members":{"CacheParameterGroup":{"shape":"S2t"}}}},"CreateCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName","Description"],"members":{"CacheSecurityGroupName":{},"Description":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateCacheSecurityGroupResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"CreateCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName","CacheSubnetGroupDescription","SubnetIds"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S2x"},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S2z"}}}},"CreateGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupIdSuffix","PrimaryReplicationGroupId"],"members":{"GlobalReplicationGroupIdSuffix":{},"GlobalReplicationGroupDescription":{},"PrimaryReplicationGroupId":{}}},"output":{"resultWrapper":"CreateGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"CreateReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId","ReplicationGroupDescription"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"GlobalReplicationGroupId":{},"PrimaryClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"MultiAZEnabled":{"type":"boolean"},"NumCacheClusters":{"type":"integer"},"PreferredCacheClusterAZs":{"shape":"S23"},"NumNodeGroups":{"type":"integer"},"ReplicasPerNodeGroup":{"type":"integer"},"NodeGroupConfiguration":{"type":"list","member":{"shape":"S21","locationName":"NodeGroupConfiguration"}},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"CacheSecurityGroupNames":{"shape":"S28"},"SecurityGroupIds":{"shape":"S29"},"Tags":{"shape":"S3"},"SnapshotArns":{"shape":"S2a"},"SnapshotName":{},"PreferredMaintenanceWindow":{},"Port":{"type":"integer"},"NotificationTopicArn":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthToken":{},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"KmsKeyId":{},"UserGroupIds":{"type":"list","member":{}},"LogDeliveryConfigurations":{"shape":"S2d"},"DataTieringEnabled":{"type":"boolean"},"NetworkType":{},"IpDiscovery":{},"TransitEncryptionMode":{},"ClusterMode":{},"ServerlessCacheSnapshotName":{}}},"output":{"resultWrapper":"CreateReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"CreateServerlessCache":{"input":{"type":"structure","required":["ServerlessCacheName","Engine"],"members":{"ServerlessCacheName":{},"Description":{},"Engine":{},"MajorEngineVersion":{},"CacheUsageLimits":{"shape":"S3h"},"KmsKeyId":{},"SecurityGroupIds":{"shape":"S29"},"SnapshotArnsToRestore":{"shape":"S2a"},"Tags":{"shape":"S3"},"UserGroupId":{},"SubnetIds":{"shape":"S3l"},"SnapshotRetentionLimit":{"type":"integer"},"DailySnapshotTime":{}}},"output":{"resultWrapper":"CreateServerlessCacheResult","type":"structure","members":{"ServerlessCache":{"shape":"S3n"}}}},"CreateServerlessCacheSnapshot":{"input":{"type":"structure","required":["ServerlessCacheSnapshotName","ServerlessCacheName"],"members":{"ServerlessCacheSnapshotName":{},"ServerlessCacheName":{},"KmsKeyId":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateServerlessCacheSnapshotResult","type":"structure","members":{"ServerlessCacheSnapshot":{"shape":"S1u"}}}},"CreateSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"KmsKeyId":{},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"CreateSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1y"}}}},"CreateUser":{"input":{"type":"structure","required":["UserId","UserName","Engine","AccessString"],"members":{"UserId":{},"UserName":{},"Engine":{},"Passwords":{"shape":"S3w"},"AccessString":{},"NoPasswordRequired":{"type":"boolean"},"Tags":{"shape":"S3"},"AuthenticationMode":{"shape":"S3y"}}},"output":{"shape":"S40","resultWrapper":"CreateUserResult"}},"CreateUserGroup":{"input":{"type":"structure","required":["UserGroupId","Engine"],"members":{"UserGroupId":{},"Engine":{},"UserIds":{"shape":"S44"},"Tags":{"shape":"S3"}}},"output":{"shape":"S45","resultWrapper":"CreateUserGroupResult"}},"DecreaseNodeGroupsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"GlobalNodeGroupsToRemove":{"shape":"S4b"},"GlobalNodeGroupsToRetain":{"shape":"S4b"},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"DecreaseNodeGroupsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"DecreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S4e"},"ReplicasToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"DecreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"DeleteCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S2g"}}}},"DeleteCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{}}}},"DeleteCacheSecurityGroup":{"input":{"type":"structure","required":["CacheSecurityGroupName"],"members":{"CacheSecurityGroupName":{}}}},"DeleteCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{}}}},"DeleteGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","RetainPrimaryReplicationGroup"],"members":{"GlobalReplicationGroupId":{},"RetainPrimaryReplicationGroup":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"DeleteReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"RetainPrimaryCluster":{"type":"boolean"},"FinalSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"DeleteServerlessCache":{"input":{"type":"structure","required":["ServerlessCacheName"],"members":{"ServerlessCacheName":{},"FinalSnapshotName":{}}},"output":{"resultWrapper":"DeleteServerlessCacheResult","type":"structure","members":{"ServerlessCache":{"shape":"S3n"}}}},"DeleteServerlessCacheSnapshot":{"input":{"type":"structure","required":["ServerlessCacheSnapshotName"],"members":{"ServerlessCacheSnapshotName":{}}},"output":{"resultWrapper":"DeleteServerlessCacheSnapshotResult","type":"structure","members":{"ServerlessCacheSnapshot":{"shape":"S1u"}}}},"DeleteSnapshot":{"input":{"type":"structure","required":["SnapshotName"],"members":{"SnapshotName":{}}},"output":{"resultWrapper":"DeleteSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S1y"}}}},"DeleteUser":{"input":{"type":"structure","required":["UserId"],"members":{"UserId":{}}},"output":{"shape":"S40","resultWrapper":"DeleteUserResult"}},"DeleteUserGroup":{"input":{"type":"structure","required":["UserGroupId"],"members":{"UserGroupId":{}}},"output":{"shape":"S45","resultWrapper":"DeleteUserGroupResult"}},"DescribeCacheClusters":{"input":{"type":"structure","members":{"CacheClusterId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowCacheNodeInfo":{"type":"boolean"},"ShowCacheClustersNotInReplicationGroups":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheClustersResult","type":"structure","members":{"Marker":{},"CacheClusters":{"type":"list","member":{"shape":"S2g","locationName":"CacheCluster"}}}}},"DescribeCacheEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeCacheEngineVersionsResult","type":"structure","members":{"Marker":{},"CacheEngineVersions":{"type":"list","member":{"locationName":"CacheEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"CacheParameterGroupFamily":{},"CacheEngineDescription":{},"CacheEngineVersionDescription":{}}}}}}},"DescribeCacheParameterGroups":{"input":{"type":"structure","members":{"CacheParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParameterGroupsResult","type":"structure","members":{"Marker":{},"CacheParameterGroups":{"type":"list","member":{"shape":"S2t","locationName":"CacheParameterGroup"}}}}},"DescribeCacheParameters":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheParametersResult","type":"structure","members":{"Marker":{},"Parameters":{"shape":"S5b"},"CacheNodeTypeSpecificParameters":{"shape":"S5e"}}}},"DescribeCacheSecurityGroups":{"input":{"type":"structure","members":{"CacheSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSecurityGroupsResult","type":"structure","members":{"Marker":{},"CacheSecurityGroups":{"type":"list","member":{"shape":"S8","locationName":"CacheSecurityGroup"}}}}},"DescribeCacheSubnetGroups":{"input":{"type":"structure","members":{"CacheSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCacheSubnetGroupsResult","type":"structure","members":{"Marker":{},"CacheSubnetGroups":{"type":"list","member":{"shape":"S2z","locationName":"CacheSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["CacheParameterGroupFamily"],"members":{"CacheParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"CacheParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S5b"},"CacheNodeTypeSpecificParameters":{"shape":"S5e"}},"wrapper":true}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"Date":{"type":"timestamp"}}}}}}},"DescribeGlobalReplicationGroups":{"input":{"type":"structure","members":{"GlobalReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{},"ShowMemberInfo":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeGlobalReplicationGroupsResult","type":"structure","members":{"Marker":{},"GlobalReplicationGroups":{"type":"list","member":{"shape":"S37","locationName":"GlobalReplicationGroup"}}}}},"DescribeReplicationGroups":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReplicationGroupsResult","type":"structure","members":{"Marker":{},"ReplicationGroups":{"type":"list","member":{"shape":"So","locationName":"ReplicationGroup"}}}}},"DescribeReservedCacheNodes":{"input":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesResult","type":"structure","members":{"Marker":{},"ReservedCacheNodes":{"type":"list","member":{"shape":"S65","locationName":"ReservedCacheNode"}}}}},"DescribeReservedCacheNodesOfferings":{"input":{"type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedCacheNodesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedCacheNodesOfferings":{"type":"list","member":{"locationName":"ReservedCacheNodesOffering","type":"structure","members":{"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"ProductDescription":{},"OfferingType":{},"RecurringCharges":{"shape":"S66"}},"wrapper":true}}}}},"DescribeServerlessCacheSnapshots":{"input":{"type":"structure","members":{"ServerlessCacheName":{},"ServerlessCacheSnapshotName":{},"SnapshotType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeServerlessCacheSnapshotsResult","type":"structure","members":{"NextToken":{},"ServerlessCacheSnapshots":{"type":"list","member":{"shape":"S1u","locationName":"ServerlessCacheSnapshot"}}}}},"DescribeServerlessCaches":{"input":{"type":"structure","members":{"ServerlessCacheName":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeServerlessCachesResult","type":"structure","members":{"NextToken":{},"ServerlessCaches":{"type":"list","member":{"shape":"S3n"}}}}},"DescribeServiceUpdates":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateStatus":{"shape":"S6j"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeServiceUpdatesResult","type":"structure","members":{"Marker":{},"ServiceUpdates":{"type":"list","member":{"locationName":"ServiceUpdate","type":"structure","members":{"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateEndDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateStatus":{},"ServiceUpdateDescription":{},"ServiceUpdateType":{},"Engine":{},"EngineVersion":{},"AutoUpdateAfterRecommendedApplyByDate":{"type":"boolean"},"EstimatedUpdateTime":{}}}}}}},"DescribeSnapshots":{"input":{"type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"SnapshotName":{},"SnapshotSource":{},"Marker":{},"MaxRecords":{"type":"integer"},"ShowNodeGroupConfig":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"S1y","locationName":"Snapshot"}}}}},"DescribeUpdateActions":{"input":{"type":"structure","members":{"ServiceUpdateName":{},"ReplicationGroupIds":{"shape":"Sc"},"CacheClusterIds":{"shape":"Sd"},"Engine":{},"ServiceUpdateStatus":{"shape":"S6j"},"ServiceUpdateTimeRange":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"UpdateActionStatus":{"type":"list","member":{}},"ShowNodeLevelUpdateStatus":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUpdateActionsResult","type":"structure","members":{"Marker":{},"UpdateActions":{"type":"list","member":{"locationName":"UpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"ServiceUpdateReleaseDate":{"type":"timestamp"},"ServiceUpdateSeverity":{},"ServiceUpdateStatus":{},"ServiceUpdateRecommendedApplyByDate":{"type":"timestamp"},"ServiceUpdateType":{},"UpdateActionAvailableDate":{"type":"timestamp"},"UpdateActionStatus":{},"NodesUpdated":{},"UpdateActionStatusModifiedDate":{"type":"timestamp"},"SlaMet":{},"NodeGroupUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupUpdateStatus","type":"structure","members":{"NodeGroupId":{},"NodeGroupMemberUpdateStatus":{"type":"list","member":{"locationName":"NodeGroupMemberUpdateStatus","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"NodeUpdateStatus":{},"NodeDeletionDate":{"type":"timestamp"},"NodeUpdateStartDate":{"type":"timestamp"},"NodeUpdateEndDate":{"type":"timestamp"},"NodeUpdateInitiatedBy":{},"NodeUpdateInitiatedDate":{"type":"timestamp"},"NodeUpdateStatusModifiedDate":{"type":"timestamp"}}}}}}},"CacheNodeUpdateStatus":{"type":"list","member":{"locationName":"CacheNodeUpdateStatus","type":"structure","members":{"CacheNodeId":{},"NodeUpdateStatus":{},"NodeDeletionDate":{"type":"timestamp"},"NodeUpdateStartDate":{"type":"timestamp"},"NodeUpdateEndDate":{"type":"timestamp"},"NodeUpdateInitiatedBy":{},"NodeUpdateInitiatedDate":{"type":"timestamp"},"NodeUpdateStatusModifiedDate":{"type":"timestamp"}}}},"EstimatedUpdateTime":{},"Engine":{}}}}}}},"DescribeUserGroups":{"input":{"type":"structure","members":{"UserGroupId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUserGroupsResult","type":"structure","members":{"UserGroups":{"type":"list","member":{"shape":"S45"}},"Marker":{}}}},"DescribeUsers":{"input":{"type":"structure","members":{"Engine":{},"UserId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeUsersResult","type":"structure","members":{"Users":{"type":"list","member":{"shape":"S40"}},"Marker":{}}}},"DisassociateGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ReplicationGroupId","ReplicationGroupRegion"],"members":{"GlobalReplicationGroupId":{},"ReplicationGroupId":{},"ReplicationGroupRegion":{}}},"output":{"resultWrapper":"DisassociateGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"ExportServerlessCacheSnapshot":{"input":{"type":"structure","required":["ServerlessCacheSnapshotName","S3BucketName"],"members":{"ServerlessCacheSnapshotName":{},"S3BucketName":{}}},"output":{"resultWrapper":"ExportServerlessCacheSnapshotResult","type":"structure","members":{"ServerlessCacheSnapshot":{"shape":"S1u"}}}},"FailoverGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","PrimaryRegion","PrimaryReplicationGroupId"],"members":{"GlobalReplicationGroupId":{},"PrimaryRegion":{},"PrimaryReplicationGroupId":{}}},"output":{"resultWrapper":"FailoverGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"IncreaseNodeGroupsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"RegionalConfigurations":{"type":"list","member":{"locationName":"RegionalConfiguration","type":"structure","required":["ReplicationGroupId","ReplicationGroupRegion","ReshardingConfiguration"],"members":{"ReplicationGroupId":{},"ReplicationGroupRegion":{},"ReshardingConfiguration":{"shape":"S7s"}}}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"IncreaseNodeGroupsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"IncreaseReplicaCount":{"input":{"type":"structure","required":["ReplicationGroupId","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NewReplicaCount":{"type":"integer"},"ReplicaConfiguration":{"shape":"S4e"},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"IncreaseReplicaCountResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ListAllowedNodeTypeModifications":{"input":{"type":"structure","members":{"CacheClusterId":{},"ReplicationGroupId":{}}},"output":{"resultWrapper":"ListAllowedNodeTypeModificationsResult","type":"structure","members":{"ScaleUpModifications":{"shape":"S7z"},"ScaleDownModifications":{"shape":"S7z"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"shape":"S5","resultWrapper":"ListTagsForResourceResult"}},"ModifyCacheCluster":{"input":{"type":"structure","required":["CacheClusterId"],"members":{"CacheClusterId":{},"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S2i"},"AZMode":{},"NewAvailabilityZones":{"shape":"S27"},"CacheSecurityGroupNames":{"shape":"S28"},"SecurityGroupIds":{"shape":"S29"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"AuthToken":{},"AuthTokenUpdateStrategy":{},"LogDeliveryConfigurations":{"shape":"S2d"},"IpDiscovery":{}}},"output":{"resultWrapper":"ModifyCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S2g"}}}},"ModifyCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName","ParameterNameValues"],"members":{"CacheParameterGroupName":{},"ParameterNameValues":{"shape":"S85"}}},"output":{"shape":"S87","resultWrapper":"ModifyCacheParameterGroupResult"}},"ModifyCacheSubnetGroup":{"input":{"type":"structure","required":["CacheSubnetGroupName"],"members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"SubnetIds":{"shape":"S2x"}}},"output":{"resultWrapper":"ModifyCacheSubnetGroupResult","type":"structure","members":{"CacheSubnetGroup":{"shape":"S2z"}}}},"ModifyGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"ApplyImmediately":{"type":"boolean"},"CacheNodeType":{},"EngineVersion":{},"CacheParameterGroupName":{},"GlobalReplicationGroupDescription":{},"AutomaticFailoverEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"ModifyReplicationGroup":{"input":{"type":"structure","required":["ReplicationGroupId"],"members":{"ReplicationGroupId":{},"ReplicationGroupDescription":{},"PrimaryClusterId":{},"SnapshottingClusterId":{},"AutomaticFailoverEnabled":{"type":"boolean"},"MultiAZEnabled":{"type":"boolean"},"NodeGroupId":{"deprecated":true},"CacheSecurityGroupNames":{"shape":"S28"},"SecurityGroupIds":{"shape":"S29"},"PreferredMaintenanceWindow":{},"NotificationTopicArn":{},"CacheParameterGroupName":{},"NotificationTopicStatus":{},"ApplyImmediately":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"CacheNodeType":{},"AuthToken":{},"AuthTokenUpdateStrategy":{},"UserGroupIdsToAdd":{"shape":"Sx"},"UserGroupIdsToRemove":{"shape":"Sx"},"RemoveUserGroups":{"type":"boolean"},"LogDeliveryConfigurations":{"shape":"S2d"},"IpDiscovery":{},"TransitEncryptionEnabled":{"type":"boolean"},"TransitEncryptionMode":{},"ClusterMode":{}}},"output":{"resultWrapper":"ModifyReplicationGroupResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ModifyReplicationGroupShardConfiguration":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupCount","ApplyImmediately"],"members":{"ReplicationGroupId":{},"NodeGroupCount":{"type":"integer"},"ApplyImmediately":{"type":"boolean"},"ReshardingConfiguration":{"shape":"S7s"},"NodeGroupsToRemove":{"type":"list","member":{"locationName":"NodeGroupToRemove"}},"NodeGroupsToRetain":{"type":"list","member":{"locationName":"NodeGroupToRetain"}}}},"output":{"resultWrapper":"ModifyReplicationGroupShardConfigurationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"ModifyServerlessCache":{"input":{"type":"structure","required":["ServerlessCacheName"],"members":{"ServerlessCacheName":{},"Description":{},"CacheUsageLimits":{"shape":"S3h"},"RemoveUserGroup":{"type":"boolean"},"UserGroupId":{},"SecurityGroupIds":{"shape":"S29"},"SnapshotRetentionLimit":{"type":"integer"},"DailySnapshotTime":{}}},"output":{"resultWrapper":"ModifyServerlessCacheResult","type":"structure","members":{"ServerlessCache":{"shape":"S3n"}}}},"ModifyUser":{"input":{"type":"structure","required":["UserId"],"members":{"UserId":{},"AccessString":{},"AppendAccessString":{},"Passwords":{"shape":"S3w"},"NoPasswordRequired":{"type":"boolean"},"AuthenticationMode":{"shape":"S3y"}}},"output":{"shape":"S40","resultWrapper":"ModifyUserResult"}},"ModifyUserGroup":{"input":{"type":"structure","required":["UserGroupId"],"members":{"UserGroupId":{},"UserIdsToAdd":{"shape":"S44"},"UserIdsToRemove":{"shape":"S44"}}},"output":{"shape":"S45","resultWrapper":"ModifyUserGroupResult"}},"PurchaseReservedCacheNodesOffering":{"input":{"type":"structure","required":["ReservedCacheNodesOfferingId"],"members":{"ReservedCacheNodesOfferingId":{},"ReservedCacheNodeId":{},"CacheNodeCount":{"type":"integer"},"Tags":{"shape":"S3"}}},"output":{"resultWrapper":"PurchaseReservedCacheNodesOfferingResult","type":"structure","members":{"ReservedCacheNode":{"shape":"S65"}}}},"RebalanceSlotsInGlobalReplicationGroup":{"input":{"type":"structure","required":["GlobalReplicationGroupId","ApplyImmediately"],"members":{"GlobalReplicationGroupId":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"RebalanceSlotsInGlobalReplicationGroupResult","type":"structure","members":{"GlobalReplicationGroup":{"shape":"S37"}}}},"RebootCacheCluster":{"input":{"type":"structure","required":["CacheClusterId","CacheNodeIdsToReboot"],"members":{"CacheClusterId":{},"CacheNodeIdsToReboot":{"shape":"S2i"}}},"output":{"resultWrapper":"RebootCacheClusterResult","type":"structure","members":{"CacheCluster":{"shape":"S2g"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"shape":"S5","resultWrapper":"RemoveTagsFromResourceResult"}},"ResetCacheParameterGroup":{"input":{"type":"structure","required":["CacheParameterGroupName"],"members":{"CacheParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"ParameterNameValues":{"shape":"S85"}}},"output":{"shape":"S87","resultWrapper":"ResetCacheParameterGroupResult"}},"RevokeCacheSecurityGroupIngress":{"input":{"type":"structure","required":["CacheSecurityGroupName","EC2SecurityGroupName","EC2SecurityGroupOwnerId"],"members":{"CacheSecurityGroupName":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeCacheSecurityGroupIngressResult","type":"structure","members":{"CacheSecurityGroup":{"shape":"S8"}}}},"StartMigration":{"input":{"type":"structure","required":["ReplicationGroupId","CustomerNodeEndpointList"],"members":{"ReplicationGroupId":{},"CustomerNodeEndpointList":{"shape":"S8y"}}},"output":{"resultWrapper":"StartMigrationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"TestFailover":{"input":{"type":"structure","required":["ReplicationGroupId","NodeGroupId"],"members":{"ReplicationGroupId":{},"NodeGroupId":{}}},"output":{"resultWrapper":"TestFailoverResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}},"TestMigration":{"input":{"type":"structure","required":["ReplicationGroupId","CustomerNodeEndpointList"],"members":{"ReplicationGroupId":{},"CustomerNodeEndpointList":{"shape":"S8y"}}},"output":{"resultWrapper":"TestMigrationResult","type":"structure","members":{"ReplicationGroup":{"shape":"So"}}}}},"shapes":{"S3":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S5":{"type":"structure","members":{"TagList":{"shape":"S3"}}},"S8":{"type":"structure","members":{"OwnerId":{},"CacheSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}}},"ARN":{}},"wrapper":true},"Sc":{"type":"list","member":{}},"Sd":{"type":"list","member":{}},"Se":{"type":"structure","members":{"ProcessedUpdateActions":{"type":"list","member":{"locationName":"ProcessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"UpdateActionStatus":{}}}},"UnprocessedUpdateActions":{"type":"list","member":{"locationName":"UnprocessedUpdateAction","type":"structure","members":{"ReplicationGroupId":{},"CacheClusterId":{},"ServiceUpdateName":{},"ErrorType":{},"ErrorMessage":{}}}}}},"So":{"type":"structure","members":{"ReplicationGroupId":{},"Description":{},"GlobalReplicationGroupInfo":{"type":"structure","members":{"GlobalReplicationGroupId":{},"GlobalReplicationGroupMemberRole":{}}},"Status":{},"PendingModifiedValues":{"type":"structure","members":{"PrimaryClusterId":{},"AutomaticFailoverStatus":{},"Resharding":{"type":"structure","members":{"SlotMigration":{"type":"structure","members":{"ProgressPercentage":{"type":"double"}}}}},"AuthTokenStatus":{},"UserGroups":{"type":"structure","members":{"UserGroupIdsToAdd":{"shape":"Sx"},"UserGroupIdsToRemove":{"shape":"Sx"}}},"LogDeliveryConfigurations":{"shape":"Sz"},"TransitEncryptionEnabled":{"type":"boolean"},"TransitEncryptionMode":{},"ClusterMode":{}}},"MemberClusters":{"type":"list","member":{"locationName":"ClusterId"}},"NodeGroups":{"type":"list","member":{"locationName":"NodeGroup","type":"structure","members":{"NodeGroupId":{},"Status":{},"PrimaryEndpoint":{"shape":"S1d"},"ReaderEndpoint":{"shape":"S1d"},"Slots":{},"NodeGroupMembers":{"type":"list","member":{"locationName":"NodeGroupMember","type":"structure","members":{"CacheClusterId":{},"CacheNodeId":{},"ReadEndpoint":{"shape":"S1d"},"PreferredAvailabilityZone":{},"PreferredOutpostArn":{},"CurrentRole":{}}}}}}},"SnapshottingClusterId":{},"AutomaticFailover":{},"MultiAZ":{},"ConfigurationEndpoint":{"shape":"S1d"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"ClusterEnabled":{"type":"boolean"},"CacheNodeType":{},"AuthTokenEnabled":{"type":"boolean"},"AuthTokenLastModifiedDate":{"type":"timestamp"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"MemberClustersOutpostArns":{"type":"list","member":{"locationName":"ReplicationGroupOutpostArn"}},"KmsKeyId":{},"ARN":{},"UserGroupIds":{"shape":"Sx"},"LogDeliveryConfigurations":{"shape":"S1m"},"ReplicationGroupCreateTime":{"type":"timestamp"},"DataTiering":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"NetworkType":{},"IpDiscovery":{},"TransitEncryptionMode":{},"ClusterMode":{}},"wrapper":true},"Sx":{"type":"list","member":{}},"Sz":{"type":"list","member":{"type":"structure","members":{"LogType":{},"DestinationType":{},"DestinationDetails":{"shape":"S13"},"LogFormat":{}}},"locationName":"PendingLogDeliveryConfiguration"},"S13":{"type":"structure","members":{"CloudWatchLogsDetails":{"type":"structure","members":{"LogGroup":{}}},"KinesisFirehoseDetails":{"type":"structure","members":{"DeliveryStream":{}}}}},"S1d":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"S1m":{"type":"list","member":{"locationName":"LogDeliveryConfiguration","type":"structure","members":{"LogType":{},"DestinationType":{},"DestinationDetails":{"shape":"S13"},"LogFormat":{},"Status":{},"Message":{}}}},"S1u":{"type":"structure","members":{"ServerlessCacheSnapshotName":{},"ARN":{},"KmsKeyId":{},"SnapshotType":{},"Status":{},"CreateTime":{"type":"timestamp"},"ExpiryTime":{"type":"timestamp"},"BytesUsedForCache":{},"ServerlessCacheConfiguration":{"type":"structure","members":{"ServerlessCacheName":{},"Engine":{},"MajorEngineVersion":{}}}}},"S1y":{"type":"structure","members":{"SnapshotName":{},"ReplicationGroupId":{},"ReplicationGroupDescription":{},"CacheClusterId":{},"SnapshotStatus":{},"SnapshotSource":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"PreferredOutpostArn":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"TopicArn":{},"Port":{"type":"integer"},"CacheParameterGroupName":{},"CacheSubnetGroupName":{},"VpcId":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"NumNodeGroups":{"type":"integer"},"AutomaticFailover":{},"NodeSnapshots":{"type":"list","member":{"locationName":"NodeSnapshot","type":"structure","members":{"CacheClusterId":{},"NodeGroupId":{},"CacheNodeId":{},"NodeGroupConfiguration":{"shape":"S21"},"CacheSize":{},"CacheNodeCreateTime":{"type":"timestamp"},"SnapshotCreateTime":{"type":"timestamp"}},"wrapper":true}},"KmsKeyId":{},"ARN":{},"DataTiering":{}},"wrapper":true},"S21":{"type":"structure","members":{"NodeGroupId":{},"Slots":{},"ReplicaCount":{"type":"integer"},"PrimaryAvailabilityZone":{},"ReplicaAvailabilityZones":{"shape":"S23"},"PrimaryOutpostArn":{},"ReplicaOutpostArns":{"type":"list","member":{"locationName":"OutpostArn"}}}},"S23":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S27":{"type":"list","member":{"locationName":"PreferredAvailabilityZone"}},"S28":{"type":"list","member":{"locationName":"CacheSecurityGroupName"}},"S29":{"type":"list","member":{"locationName":"SecurityGroupId"}},"S2a":{"type":"list","member":{"locationName":"SnapshotArn"}},"S2c":{"type":"list","member":{"locationName":"PreferredOutpostArn"}},"S2d":{"type":"list","member":{"locationName":"LogDeliveryConfigurationRequest","type":"structure","members":{"LogType":{},"DestinationType":{},"DestinationDetails":{"shape":"S13"},"LogFormat":{},"Enabled":{"type":"boolean"}}}},"S2g":{"type":"structure","members":{"CacheClusterId":{},"ConfigurationEndpoint":{"shape":"S1d"},"ClientDownloadLandingPage":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"CacheClusterStatus":{},"NumCacheNodes":{"type":"integer"},"PreferredAvailabilityZone":{},"PreferredOutpostArn":{},"CacheClusterCreateTime":{"type":"timestamp"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"NumCacheNodes":{"type":"integer"},"CacheNodeIdsToRemove":{"shape":"S2i"},"EngineVersion":{},"CacheNodeType":{},"AuthTokenStatus":{},"LogDeliveryConfigurations":{"shape":"Sz"},"TransitEncryptionEnabled":{"type":"boolean"},"TransitEncryptionMode":{}}},"NotificationConfiguration":{"type":"structure","members":{"TopicArn":{},"TopicStatus":{}}},"CacheSecurityGroups":{"type":"list","member":{"locationName":"CacheSecurityGroup","type":"structure","members":{"CacheSecurityGroupName":{},"Status":{}}}},"CacheParameterGroup":{"type":"structure","members":{"CacheParameterGroupName":{},"ParameterApplyStatus":{},"CacheNodeIdsToReboot":{"shape":"S2i"}}},"CacheSubnetGroupName":{},"CacheNodes":{"type":"list","member":{"locationName":"CacheNode","type":"structure","members":{"CacheNodeId":{},"CacheNodeStatus":{},"CacheNodeCreateTime":{"type":"timestamp"},"Endpoint":{"shape":"S1d"},"ParameterGroupStatus":{},"SourceCacheNodeId":{},"CustomerAvailabilityZone":{},"CustomerOutpostArn":{}}}},"AutoMinorVersionUpgrade":{"type":"boolean"},"SecurityGroups":{"type":"list","member":{"type":"structure","members":{"SecurityGroupId":{},"Status":{}}}},"ReplicationGroupId":{},"SnapshotRetentionLimit":{"type":"integer"},"SnapshotWindow":{},"AuthTokenEnabled":{"type":"boolean"},"AuthTokenLastModifiedDate":{"type":"timestamp"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"ARN":{},"ReplicationGroupLogDeliveryEnabled":{"type":"boolean"},"LogDeliveryConfigurations":{"shape":"S1m"},"NetworkType":{},"IpDiscovery":{},"TransitEncryptionMode":{}},"wrapper":true},"S2i":{"type":"list","member":{"locationName":"CacheNodeId"}},"S2t":{"type":"structure","members":{"CacheParameterGroupName":{},"CacheParameterGroupFamily":{},"Description":{},"IsGlobal":{"type":"boolean"},"ARN":{}},"wrapper":true},"S2x":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2z":{"type":"structure","members":{"CacheSubnetGroupName":{},"CacheSubnetGroupDescription":{},"VpcId":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"type":"structure","members":{"Name":{}},"wrapper":true},"SubnetOutpost":{"type":"structure","members":{"SubnetOutpostArn":{}}},"SupportedNetworkTypes":{"shape":"S34"}}}},"ARN":{},"SupportedNetworkTypes":{"shape":"S34"}},"wrapper":true},"S34":{"type":"list","member":{}},"S37":{"type":"structure","members":{"GlobalReplicationGroupId":{},"GlobalReplicationGroupDescription":{},"Status":{},"CacheNodeType":{},"Engine":{},"EngineVersion":{},"Members":{"type":"list","member":{"locationName":"GlobalReplicationGroupMember","type":"structure","members":{"ReplicationGroupId":{},"ReplicationGroupRegion":{},"Role":{},"AutomaticFailover":{},"Status":{}},"wrapper":true}},"ClusterEnabled":{"type":"boolean"},"GlobalNodeGroups":{"type":"list","member":{"locationName":"GlobalNodeGroup","type":"structure","members":{"GlobalNodeGroupId":{},"Slots":{}}}},"AuthTokenEnabled":{"type":"boolean"},"TransitEncryptionEnabled":{"type":"boolean"},"AtRestEncryptionEnabled":{"type":"boolean"},"ARN":{}},"wrapper":true},"S3h":{"type":"structure","members":{"DataStorage":{"type":"structure","required":["Unit"],"members":{"Maximum":{"type":"integer"},"Minimum":{"type":"integer"},"Unit":{}}},"ECPUPerSecond":{"type":"structure","members":{"Maximum":{"type":"integer"},"Minimum":{"type":"integer"}}}}},"S3l":{"type":"list","member":{"locationName":"SubnetId"}},"S3n":{"type":"structure","members":{"ServerlessCacheName":{},"Description":{},"CreateTime":{"type":"timestamp"},"Status":{},"Engine":{},"MajorEngineVersion":{},"FullEngineVersion":{},"CacheUsageLimits":{"shape":"S3h"},"KmsKeyId":{},"SecurityGroupIds":{"shape":"S29"},"Endpoint":{"shape":"S1d"},"ReaderEndpoint":{"shape":"S1d"},"ARN":{},"UserGroupId":{},"SubnetIds":{"shape":"S3l"},"SnapshotRetentionLimit":{"type":"integer"},"DailySnapshotTime":{}}},"S3w":{"type":"list","member":{}},"S3y":{"type":"structure","members":{"Type":{},"Passwords":{"shape":"S3w"}}},"S40":{"type":"structure","members":{"UserId":{},"UserName":{},"Status":{},"Engine":{},"MinimumEngineVersion":{},"AccessString":{},"UserGroupIds":{"shape":"Sx"},"Authentication":{"type":"structure","members":{"Type":{},"PasswordCount":{"type":"integer"}}},"ARN":{}}},"S44":{"type":"list","member":{}},"S45":{"type":"structure","members":{"UserGroupId":{},"Status":{},"Engine":{},"UserIds":{"shape":"S46"},"MinimumEngineVersion":{},"PendingChanges":{"type":"structure","members":{"UserIdsToRemove":{"shape":"S46"},"UserIdsToAdd":{"shape":"S46"}}},"ReplicationGroups":{"type":"list","member":{}},"ServerlessCaches":{"type":"list","member":{}},"ARN":{}}},"S46":{"type":"list","member":{}},"S4b":{"type":"list","member":{"locationName":"GlobalNodeGroupId"}},"S4e":{"type":"list","member":{"locationName":"ConfigureShard","type":"structure","required":["NodeGroupId","NewReplicaCount"],"members":{"NodeGroupId":{},"NewReplicaCount":{"type":"integer"},"PreferredAvailabilityZones":{"shape":"S27"},"PreferredOutpostArns":{"shape":"S2c"}}}},"S5b":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ChangeType":{}}}},"S5e":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificParameter","type":"structure","members":{"ParameterName":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"CacheNodeTypeSpecificValues":{"type":"list","member":{"locationName":"CacheNodeTypeSpecificValue","type":"structure","members":{"CacheNodeType":{},"Value":{}}}},"ChangeType":{}}}},"S65":{"type":"structure","members":{"ReservedCacheNodeId":{},"ReservedCacheNodesOfferingId":{},"CacheNodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CacheNodeCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"State":{},"RecurringCharges":{"shape":"S66"},"ReservationARN":{}},"wrapper":true},"S66":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S6j":{"type":"list","member":{}},"S7s":{"type":"list","member":{"locationName":"ReshardingConfiguration","type":"structure","members":{"NodeGroupId":{},"PreferredAvailabilityZones":{"shape":"S23"}}}},"S7z":{"type":"list","member":{}},"S85":{"type":"list","member":{"locationName":"ParameterNameValue","type":"structure","members":{"ParameterName":{},"ParameterValue":{}}}},"S87":{"type":"structure","members":{"CacheParameterGroupName":{}}},"S8y":{"type":"list","member":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}}}}}

/***/ }),
/* 485 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCacheClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheClusters"},"DescribeCacheEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheEngineVersions"},"DescribeCacheParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheParameterGroups"},"DescribeCacheParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeCacheSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSecurityGroups"},"DescribeCacheSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"CacheSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeGlobalReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalReplicationGroups"},"DescribeReplicationGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReplicationGroups"},"DescribeReservedCacheNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodes"},"DescribeReservedCacheNodesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedCacheNodesOfferings"},"DescribeServerlessCacheSnapshots":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServerlessCacheSnapshots"},"DescribeServerlessCaches":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ServerlessCaches"},"DescribeServiceUpdates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ServiceUpdates"},"DescribeSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeUpdateActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UpdateActions"},"DescribeUserGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UserGroups"},"DescribeUsers":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Users"}}}

/***/ }),
/* 486 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"CacheClusterAvailable":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAll","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleting","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is available.","maxAttempts":40,"operation":"DescribeCacheClusters"},"CacheClusterDeleted":{"acceptors":[{"argument":"CacheClusters[].CacheClusterStatus","expected":"deleted","matcher":"pathAll","state":"success"},{"expected":"CacheClusterNotFound","matcher":"error","state":"success"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"available","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"creating","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"incompatible-network","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"modifying","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"restore-failed","matcher":"pathAny","state":"failure"},{"argument":"CacheClusters[].CacheClusterStatus","expected":"snapshotting","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache cluster is deleted.","maxAttempts":40,"operation":"DescribeCacheClusters"},"ReplicationGroupAvailable":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAny","state":"failure"}],"delay":15,"description":"Wait until ElastiCache replication group is available.","maxAttempts":40,"operation":"DescribeReplicationGroups"},"ReplicationGroupDeleted":{"acceptors":[{"argument":"ReplicationGroups[].Status","expected":"deleted","matcher":"pathAll","state":"success"},{"argument":"ReplicationGroups[].Status","expected":"available","matcher":"pathAny","state":"failure"},{"expected":"ReplicationGroupNotFoundFault","matcher":"error","state":"success"}],"delay":15,"description":"Wait until ElastiCache replication group is deleted.","maxAttempts":40,"operation":"DescribeReplicationGroups"}}}

/***/ }),
/* 487 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"elasticbeanstalk","protocol":"query","serviceAbbreviation":"Elastic Beanstalk","serviceFullName":"AWS Elastic Beanstalk","serviceId":"Elastic Beanstalk","signatureVersion":"v4","uid":"elasticbeanstalk-2010-12-01","xmlNamespace":"http://elasticbeanstalk.amazonaws.com/docs/2010-12-01/"},"operations":{"AbortEnvironmentUpdate":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"ApplyEnvironmentManagedAction":{"input":{"type":"structure","required":["ActionId"],"members":{"EnvironmentName":{},"EnvironmentId":{},"ActionId":{}}},"output":{"resultWrapper":"ApplyEnvironmentManagedActionResult","type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{}}}},"AssociateEnvironmentOperationsRole":{"input":{"type":"structure","required":["EnvironmentName","OperationsRole"],"members":{"EnvironmentName":{},"OperationsRole":{}}}},"CheckDNSAvailability":{"input":{"type":"structure","required":["CNAMEPrefix"],"members":{"CNAMEPrefix":{}}},"output":{"resultWrapper":"CheckDNSAvailabilityResult","type":"structure","members":{"Available":{"type":"boolean"},"FullyQualifiedCNAME":{}}}},"ComposeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"GroupName":{},"VersionLabels":{"type":"list","member":{}}}},"output":{"shape":"Sk","resultWrapper":"ComposeEnvironmentsResult"}},"CreateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{},"ResourceLifecycleConfig":{"shape":"S19"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S1j","resultWrapper":"CreateApplicationResult"}},"CreateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{},"SourceBuildInformation":{"shape":"S1p"},"SourceBundle":{"shape":"S1t"},"BuildConfiguration":{"type":"structure","required":["CodeBuildServiceRole","Image"],"members":{"ArtifactName":{},"CodeBuildServiceRole":{},"ComputeType":{},"Image":{},"TimeoutInMinutes":{"type":"integer"}}},"AutoCreateApplication":{"type":"boolean"},"Process":{"type":"boolean"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S21","resultWrapper":"CreateApplicationVersionResult"}},"CreateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"SourceConfiguration":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{}}},"EnvironmentId":{},"Description":{},"OptionSettings":{"shape":"S27"},"Tags":{"shape":"S1f"}}},"output":{"shape":"S2d","resultWrapper":"CreateConfigurationTemplateResult"}},"CreateEnvironment":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"EnvironmentName":{},"GroupName":{},"Description":{},"CNAMEPrefix":{},"Tier":{"shape":"S13"},"Tags":{"shape":"S1f"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"},"OperationsRole":{}}},"output":{"shape":"Sm","resultWrapper":"CreateEnvironmentResult"}},"CreatePlatformVersion":{"input":{"type":"structure","required":["PlatformName","PlatformVersion","PlatformDefinitionBundle"],"members":{"PlatformName":{},"PlatformVersion":{},"PlatformDefinitionBundle":{"shape":"S1t"},"EnvironmentName":{},"OptionSettings":{"shape":"S27"},"Tags":{"shape":"S1f"}}},"output":{"resultWrapper":"CreatePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2m"},"Builder":{"type":"structure","members":{"ARN":{}}}}}},"CreateStorageLocation":{"output":{"resultWrapper":"CreateStorageLocationResult","type":"structure","members":{"S3Bucket":{}}}},"DeleteApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TerminateEnvByForce":{"type":"boolean"}}}},"DeleteApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"DeleteSourceBundle":{"type":"boolean"}}}},"DeleteConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{}}}},"DeleteEnvironmentConfiguration":{"input":{"type":"structure","required":["ApplicationName","EnvironmentName"],"members":{"ApplicationName":{},"EnvironmentName":{}}}},"DeletePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DeletePlatformVersionResult","type":"structure","members":{"PlatformSummary":{"shape":"S2m"}}}},"DescribeAccountAttributes":{"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"ResourceQuotas":{"type":"structure","members":{"ApplicationQuota":{"shape":"S3c"},"ApplicationVersionQuota":{"shape":"S3c"},"EnvironmentQuota":{"shape":"S3c"},"ConfigurationTemplateQuota":{"shape":"S3c"},"CustomPlatformQuota":{"shape":"S3c"}}}}}},"DescribeApplicationVersions":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabels":{"shape":"S1m"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeApplicationVersionsResult","type":"structure","members":{"ApplicationVersions":{"type":"list","member":{"shape":"S22"}},"NextToken":{}}}},"DescribeApplications":{"input":{"type":"structure","members":{"ApplicationNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeApplicationsResult","type":"structure","members":{"Applications":{"type":"list","member":{"shape":"S1k"}}}}},"DescribeConfigurationOptions":{"input":{"type":"structure","members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"SolutionStackName":{},"PlatformArn":{},"Options":{"shape":"S2g"}}},"output":{"resultWrapper":"DescribeConfigurationOptionsResult","type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"Options":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"Name":{},"DefaultValue":{},"ChangeSeverity":{},"UserDefined":{"type":"boolean"},"ValueType":{},"ValueOptions":{"type":"list","member":{}},"MinValue":{"type":"integer"},"MaxValue":{"type":"integer"},"MaxLength":{"type":"integer"},"Regex":{"type":"structure","members":{"Pattern":{},"Label":{}}}}}}}}},"DescribeConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeConfigurationSettingsResult","type":"structure","members":{"ConfigurationSettings":{"type":"list","member":{"shape":"S2d"}}}}},"DescribeEnvironmentHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeEnvironmentHealthResult","type":"structure","members":{"EnvironmentName":{},"HealthStatus":{},"Status":{},"Color":{},"Causes":{"shape":"S48"},"ApplicationMetrics":{"shape":"S4a"},"InstancesHealth":{"type":"structure","members":{"NoData":{"type":"integer"},"Unknown":{"type":"integer"},"Pending":{"type":"integer"},"Ok":{"type":"integer"},"Info":{"type":"integer"},"Warning":{"type":"integer"},"Degraded":{"type":"integer"},"Severe":{"type":"integer"}}},"RefreshedAt":{"type":"timestamp"}}}},"DescribeEnvironmentManagedActionHistory":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionHistoryResult","type":"structure","members":{"ManagedActionHistoryItems":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionType":{},"ActionDescription":{},"FailureType":{},"Status":{},"FailureDescription":{},"ExecutedTime":{"type":"timestamp"},"FinishedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEnvironmentManagedActions":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"Status":{}}},"output":{"resultWrapper":"DescribeEnvironmentManagedActionsResult","type":"structure","members":{"ManagedActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionDescription":{},"ActionType":{},"Status":{},"WindowStartTime":{"type":"timestamp"}}}}}}},"DescribeEnvironmentResources":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}},"output":{"resultWrapper":"DescribeEnvironmentResourcesResult","type":"structure","members":{"EnvironmentResources":{"type":"structure","members":{"EnvironmentName":{},"AutoScalingGroups":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LaunchConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"LaunchTemplates":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"LoadBalancers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Triggers":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Queues":{"type":"list","member":{"type":"structure","members":{"Name":{},"URL":{}}}}}}}}},"DescribeEnvironments":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"EnvironmentIds":{"type":"list","member":{}},"EnvironmentNames":{"type":"list","member":{}},"IncludeDeleted":{"type":"boolean"},"IncludedDeletedBackTo":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"shape":"Sk","resultWrapper":"DescribeEnvironmentsResult"}},"DescribeEvents":{"input":{"type":"structure","members":{"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentId":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventDate":{"type":"timestamp"},"Message":{},"ApplicationName":{},"VersionLabel":{},"TemplateName":{},"EnvironmentName":{},"PlatformArn":{},"RequestId":{},"Severity":{}}}},"NextToken":{}}}},"DescribeInstancesHealth":{"input":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"AttributeNames":{"type":"list","member":{}},"NextToken":{}}},"output":{"resultWrapper":"DescribeInstancesHealthResult","type":"structure","members":{"InstanceHealthList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"HealthStatus":{},"Color":{},"Causes":{"shape":"S48"},"LaunchedAt":{"type":"timestamp"},"ApplicationMetrics":{"shape":"S4a"},"System":{"type":"structure","members":{"CPUUtilization":{"type":"structure","members":{"User":{"type":"double"},"Nice":{"type":"double"},"System":{"type":"double"},"Idle":{"type":"double"},"IOWait":{"type":"double"},"IRQ":{"type":"double"},"SoftIRQ":{"type":"double"},"Privileged":{"type":"double"}}},"LoadAverage":{"type":"list","member":{"type":"double"}}}},"Deployment":{"type":"structure","members":{"VersionLabel":{},"DeploymentId":{"type":"long"},"Status":{},"DeploymentTime":{"type":"timestamp"}}},"AvailabilityZone":{},"InstanceType":{}}}},"RefreshedAt":{"type":"timestamp"},"NextToken":{}}}},"DescribePlatformVersion":{"input":{"type":"structure","members":{"PlatformArn":{}}},"output":{"resultWrapper":"DescribePlatformVersionResult","type":"structure","members":{"PlatformDescription":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformName":{},"PlatformVersion":{},"SolutionStackName":{},"PlatformStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"PlatformCategory":{},"Description":{},"Maintainer":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"ProgrammingLanguages":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"Frameworks":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"CustomAmiList":{"type":"list","member":{"type":"structure","members":{"VirtualizationType":{},"ImageId":{}}}},"SupportedTierList":{"shape":"S2s"},"SupportedAddonList":{"shape":"S2u"},"PlatformLifecycleState":{},"PlatformBranchName":{},"PlatformBranchLifecycleState":{}}}}}},"DisassociateEnvironmentOperationsRole":{"input":{"type":"structure","required":["EnvironmentName"],"members":{"EnvironmentName":{}}}},"ListAvailableSolutionStacks":{"output":{"resultWrapper":"ListAvailableSolutionStacksResult","type":"structure","members":{"SolutionStacks":{"type":"list","member":{}},"SolutionStackDetails":{"type":"list","member":{"type":"structure","members":{"SolutionStackName":{},"PermittedFileTypes":{"type":"list","member":{}}}}}}}},"ListPlatformBranches":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Attribute":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformBranchesResult","type":"structure","members":{"PlatformBranchSummaryList":{"type":"list","member":{"type":"structure","members":{"PlatformName":{},"BranchName":{},"LifecycleState":{},"BranchOrder":{"type":"integer"},"SupportedTierList":{"shape":"S2s"}}}},"NextToken":{}}}},"ListPlatformVersions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Type":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"ListPlatformVersionsResult","type":"structure","members":{"PlatformSummaryList":{"type":"list","member":{"shape":"S2m"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"ResourceArn":{},"ResourceTags":{"shape":"S7g"}}}},"RebuildEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RequestEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}}},"RestartAppServer":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{}}}},"RetrieveEnvironmentInfo":{"input":{"type":"structure","required":["InfoType"],"members":{"EnvironmentId":{},"EnvironmentName":{},"InfoType":{}}},"output":{"resultWrapper":"RetrieveEnvironmentInfoResult","type":"structure","members":{"EnvironmentInfo":{"type":"list","member":{"type":"structure","members":{"InfoType":{},"Ec2InstanceId":{},"SampleTimestamp":{"type":"timestamp"},"Message":{}}}}}}},"SwapEnvironmentCNAMEs":{"input":{"type":"structure","members":{"SourceEnvironmentId":{},"SourceEnvironmentName":{},"DestinationEnvironmentId":{},"DestinationEnvironmentName":{}}}},"TerminateEnvironment":{"input":{"type":"structure","members":{"EnvironmentId":{},"EnvironmentName":{},"TerminateResources":{"type":"boolean"},"ForceTerminate":{"type":"boolean"}}},"output":{"shape":"Sm","resultWrapper":"TerminateEnvironmentResult"}},"UpdateApplication":{"input":{"type":"structure","required":["ApplicationName"],"members":{"ApplicationName":{},"Description":{}}},"output":{"shape":"S1j","resultWrapper":"UpdateApplicationResult"}},"UpdateApplicationResourceLifecycle":{"input":{"type":"structure","required":["ApplicationName","ResourceLifecycleConfig"],"members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S19"}}},"output":{"resultWrapper":"UpdateApplicationResourceLifecycleResult","type":"structure","members":{"ApplicationName":{},"ResourceLifecycleConfig":{"shape":"S19"}}}},"UpdateApplicationVersion":{"input":{"type":"structure","required":["ApplicationName","VersionLabel"],"members":{"ApplicationName":{},"VersionLabel":{},"Description":{}}},"output":{"shape":"S21","resultWrapper":"UpdateApplicationVersionResult"}},"UpdateConfigurationTemplate":{"input":{"type":"structure","required":["ApplicationName","TemplateName"],"members":{"ApplicationName":{},"TemplateName":{},"Description":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"}}},"output":{"shape":"S2d","resultWrapper":"UpdateConfigurationTemplateResult"}},"UpdateEnvironment":{"input":{"type":"structure","members":{"ApplicationName":{},"EnvironmentId":{},"EnvironmentName":{},"GroupName":{},"Description":{},"Tier":{"shape":"S13"},"VersionLabel":{},"TemplateName":{},"SolutionStackName":{},"PlatformArn":{},"OptionSettings":{"shape":"S27"},"OptionsToRemove":{"shape":"S2g"}}},"output":{"shape":"Sm","resultWrapper":"UpdateEnvironmentResult"}},"UpdateTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"TagsToAdd":{"shape":"S7g"},"TagsToRemove":{"type":"list","member":{}}}}},"ValidateConfigurationSettings":{"input":{"type":"structure","required":["ApplicationName","OptionSettings"],"members":{"ApplicationName":{},"TemplateName":{},"EnvironmentName":{},"OptionSettings":{"shape":"S27"}}},"output":{"resultWrapper":"ValidateConfigurationSettingsResult","type":"structure","members":{"Messages":{"type":"list","member":{"type":"structure","members":{"Message":{},"Severity":{},"Namespace":{},"OptionName":{}}}}}}}},"shapes":{"Sk":{"type":"structure","members":{"Environments":{"type":"list","member":{"shape":"Sm"}},"NextToken":{}}},"Sm":{"type":"structure","members":{"EnvironmentName":{},"EnvironmentId":{},"ApplicationName":{},"VersionLabel":{},"SolutionStackName":{},"PlatformArn":{},"TemplateName":{},"Description":{},"EndpointURL":{},"CNAME":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{},"AbortableOperationInProgress":{"type":"boolean"},"Health":{},"HealthStatus":{},"Resources":{"type":"structure","members":{"LoadBalancer":{"type":"structure","members":{"LoadBalancerName":{},"Domain":{},"Listeners":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"Port":{"type":"integer"}}}}}}}},"Tier":{"shape":"S13"},"EnvironmentLinks":{"type":"list","member":{"type":"structure","members":{"LinkName":{},"EnvironmentName":{}}}},"EnvironmentArn":{},"OperationsRole":{}}},"S13":{"type":"structure","members":{"Name":{},"Type":{},"Version":{}}},"S19":{"type":"structure","members":{"ServiceRole":{},"VersionLifecycleConfig":{"type":"structure","members":{"MaxCountRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxCount":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}},"MaxAgeRule":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"MaxAgeInDays":{"type":"integer"},"DeleteSourceFromS3":{"type":"boolean"}}}}}}},"S1f":{"type":"list","member":{"shape":"S1g"}},"S1g":{"type":"structure","members":{"Key":{},"Value":{}}},"S1j":{"type":"structure","members":{"Application":{"shape":"S1k"}}},"S1k":{"type":"structure","members":{"ApplicationArn":{},"ApplicationName":{},"Description":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Versions":{"shape":"S1m"},"ConfigurationTemplates":{"type":"list","member":{}},"ResourceLifecycleConfig":{"shape":"S19"}}},"S1m":{"type":"list","member":{}},"S1p":{"type":"structure","required":["SourceType","SourceRepository","SourceLocation"],"members":{"SourceType":{},"SourceRepository":{},"SourceLocation":{}}},"S1t":{"type":"structure","members":{"S3Bucket":{},"S3Key":{}}},"S21":{"type":"structure","members":{"ApplicationVersion":{"shape":"S22"}}},"S22":{"type":"structure","members":{"ApplicationVersionArn":{},"ApplicationName":{},"Description":{},"VersionLabel":{},"SourceBuildInformation":{"shape":"S1p"},"BuildArn":{},"SourceBundle":{"shape":"S1t"},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"Status":{}}},"S27":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{},"Value":{}}}},"S2d":{"type":"structure","members":{"SolutionStackName":{},"PlatformArn":{},"ApplicationName":{},"TemplateName":{},"Description":{},"EnvironmentName":{},"DeploymentStatus":{},"DateCreated":{"type":"timestamp"},"DateUpdated":{"type":"timestamp"},"OptionSettings":{"shape":"S27"}}},"S2g":{"type":"list","member":{"type":"structure","members":{"ResourceName":{},"Namespace":{},"OptionName":{}}}},"S2m":{"type":"structure","members":{"PlatformArn":{},"PlatformOwner":{},"PlatformStatus":{},"PlatformCategory":{},"OperatingSystemName":{},"OperatingSystemVersion":{},"SupportedTierList":{"shape":"S2s"},"SupportedAddonList":{"shape":"S2u"},"PlatformLifecycleState":{},"PlatformVersion":{},"PlatformBranchName":{},"PlatformBranchLifecycleState":{}}},"S2s":{"type":"list","member":{}},"S2u":{"type":"list","member":{}},"S3c":{"type":"structure","members":{"Maximum":{"type":"integer"}}},"S48":{"type":"list","member":{}},"S4a":{"type":"structure","members":{"Duration":{"type":"integer"},"RequestCount":{"type":"integer"},"StatusCodes":{"type":"structure","members":{"Status2xx":{"type":"integer"},"Status3xx":{"type":"integer"},"Status4xx":{"type":"integer"},"Status5xx":{"type":"integer"}}},"Latency":{"type":"structure","members":{"P999":{"type":"double"},"P99":{"type":"double"},"P95":{"type":"double"},"P90":{"type":"double"},"P85":{"type":"double"},"P75":{"type":"double"},"P50":{"type":"double"},"P10":{"type":"double"}}}}},"S7g":{"type":"list","member":{"shape":"S1g"}}}}

/***/ }),
/* 488 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApplicationVersions":{"result_key":"ApplicationVersions"},"DescribeApplications":{"result_key":"Applications"},"DescribeConfigurationOptions":{"result_key":"Options"},"DescribeEnvironmentManagedActionHistory":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"ManagedActionHistoryItems"},"DescribeEnvironments":{"result_key":"Environments"},"DescribeEvents":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"Events"},"ListAvailableSolutionStacks":{"result_key":"SolutionStacks"},"ListPlatformBranches":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken"},"ListPlatformVersions":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"PlatformSummaryList"}}}

/***/ }),
/* 489 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"EnvironmentExists":{"delay":20,"maxAttempts":20,"operation":"DescribeEnvironments","acceptors":[{"state":"success","matcher":"pathAll","argument":"Environments[].Status","expected":"Ready"},{"state":"retry","matcher":"pathAll","argument":"Environments[].Status","expected":"Launching"}]},"EnvironmentUpdated":{"delay":20,"maxAttempts":20,"operation":"DescribeEnvironments","acceptors":[{"state":"success","matcher":"pathAll","argument":"Environments[].Status","expected":"Ready"},{"state":"retry","matcher":"pathAll","argument":"Environments[].Status","expected":"Updating"}]},"EnvironmentTerminated":{"delay":20,"maxAttempts":20,"operation":"DescribeEnvironments","acceptors":[{"state":"success","matcher":"pathAll","argument":"Environments[].Status","expected":"Terminated"},{"state":"retry","matcher":"pathAll","argument":"Environments[].Status","expected":"Terminating"}]}}}

/***/ }),
/* 490 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-02-01","endpointPrefix":"elasticfilesystem","protocol":"rest-json","serviceAbbreviation":"EFS","serviceFullName":"Amazon Elastic File System","serviceId":"EFS","signatureVersion":"v4","uid":"elasticfilesystem-2015-02-01"},"operations":{"CreateAccessPoint":{"http":{"requestUri":"/2015-02-01/access-points","responseCode":200},"input":{"type":"structure","required":["ClientToken","FileSystemId"],"members":{"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S3"},"FileSystemId":{},"PosixUser":{"shape":"S8"},"RootDirectory":{"shape":"Sc"}}},"output":{"shape":"Si"}},"CreateFileSystem":{"http":{"requestUri":"/2015-02-01/file-systems","responseCode":201},"input":{"type":"structure","required":["CreationToken"],"members":{"CreationToken":{"idempotencyToken":true},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"AvailabilityZoneName":{},"Backup":{"type":"boolean"},"Tags":{"shape":"S3"}}},"output":{"shape":"Sx"}},"CreateMountTarget":{"http":{"requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","required":["FileSystemId","SubnetId"],"members":{"FileSystemId":{},"SubnetId":{},"IpAddress":{},"SecurityGroups":{"shape":"S1a"}}},"output":{"shape":"S1c"}},"CreateReplicationConfiguration":{"http":{"requestUri":"/2015-02-01/file-systems/{SourceFileSystemId}/replication-configuration","responseCode":200},"input":{"type":"structure","required":["SourceFileSystemId","Destinations"],"members":{"SourceFileSystemId":{"location":"uri","locationName":"SourceFileSystemId"},"Destinations":{"type":"list","member":{"type":"structure","members":{"Region":{},"AvailabilityZoneName":{},"KmsKeyId":{},"FileSystemId":{}}}}}},"output":{"shape":"S1k"}},"CreateTags":{"http":{"requestUri":"/2015-02-01/create-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","Tags"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Tags":{"shape":"S3"}}},"deprecated":true,"deprecatedMessage":"Use TagResource."},"DeleteAccessPoint":{"http":{"method":"DELETE","requestUri":"/2015-02-01/access-points/{AccessPointId}","responseCode":204},"input":{"type":"structure","required":["AccessPointId"],"members":{"AccessPointId":{"location":"uri","locationName":"AccessPointId"}}}},"DeleteFileSystem":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteFileSystemPolicy":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}}},"DeleteMountTarget":{"http":{"method":"DELETE","requestUri":"/2015-02-01/mount-targets/{MountTargetId}","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}}},"DeleteReplicationConfiguration":{"http":{"method":"DELETE","requestUri":"/2015-02-01/file-systems/{SourceFileSystemId}/replication-configuration","responseCode":204},"input":{"type":"structure","required":["SourceFileSystemId"],"members":{"SourceFileSystemId":{"location":"uri","locationName":"SourceFileSystemId"}}}},"DeleteTags":{"http":{"requestUri":"/2015-02-01/delete-tags/{FileSystemId}","responseCode":204},"input":{"type":"structure","required":["FileSystemId","TagKeys"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"TagKeys":{"shape":"S1v"}}},"deprecated":true,"deprecatedMessage":"Use UntagResource."},"DescribeAccessPoints":{"http":{"method":"GET","requestUri":"/2015-02-01/access-points","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"AccessPointId":{"location":"querystring","locationName":"AccessPointId"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"AccessPoints":{"type":"list","member":{"shape":"Si"}},"NextToken":{}}}},"DescribeAccountPreferences":{"http":{"method":"GET","requestUri":"/2015-02-01/account-preferences","responseCode":200},"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceIdPreference":{"shape":"S23"},"NextToken":{}}}},"DescribeBackupPolicy":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/backup-policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S28"}},"DescribeFileSystemPolicy":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S2c"}},"DescribeFileSystems":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"CreationToken":{"location":"querystring","locationName":"CreationToken"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"}}},"output":{"type":"structure","members":{"Marker":{},"FileSystems":{"type":"list","member":{"shape":"Sx"}},"NextMarker":{}}}},"DescribeLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"shape":"S2k"}},"DescribeMountTargetSecurityGroups":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":200},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"}}},"output":{"type":"structure","required":["SecurityGroups"],"members":{"SecurityGroups":{"shape":"S1a"}}}},"DescribeMountTargets":{"http":{"method":"GET","requestUri":"/2015-02-01/mount-targets","responseCode":200},"input":{"type":"structure","members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"MountTargetId":{"location":"querystring","locationName":"MountTargetId"},"AccessPointId":{"location":"querystring","locationName":"AccessPointId"}}},"output":{"type":"structure","members":{"Marker":{},"MountTargets":{"type":"list","member":{"shape":"S1c"}},"NextMarker":{}}}},"DescribeReplicationConfigurations":{"http":{"method":"GET","requestUri":"/2015-02-01/file-systems/replication-configurations","responseCode":200},"input":{"type":"structure","members":{"FileSystemId":{"location":"querystring","locationName":"FileSystemId"},"NextToken":{"location":"querystring","locationName":"NextToken"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"}}},"output":{"type":"structure","members":{"Replications":{"type":"list","member":{"shape":"S1k"}},"NextToken":{}}}},"DescribeTags":{"http":{"method":"GET","requestUri":"/2015-02-01/tags/{FileSystemId}/","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"Marker":{"location":"querystring","locationName":"Marker"},"FileSystemId":{"location":"uri","locationName":"FileSystemId"}}},"output":{"type":"structure","required":["Tags"],"members":{"Marker":{},"Tags":{"shape":"S3"},"NextMarker":{}}},"deprecated":true,"deprecatedMessage":"Use ListTagsForResource."},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S3"},"NextToken":{}}}},"ModifyMountTargetSecurityGroups":{"http":{"method":"PUT","requestUri":"/2015-02-01/mount-targets/{MountTargetId}/security-groups","responseCode":204},"input":{"type":"structure","required":["MountTargetId"],"members":{"MountTargetId":{"location":"uri","locationName":"MountTargetId"},"SecurityGroups":{"shape":"S1a"}}}},"PutAccountPreferences":{"http":{"method":"PUT","requestUri":"/2015-02-01/account-preferences","responseCode":200},"input":{"type":"structure","required":["ResourceIdType"],"members":{"ResourceIdType":{}}},"output":{"type":"structure","members":{"ResourceIdPreference":{"shape":"S23"}}}},"PutBackupPolicy":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/backup-policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId","BackupPolicy"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"BackupPolicy":{"shape":"S29"}}},"output":{"shape":"S28"}},"PutFileSystemPolicy":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/policy","responseCode":200},"input":{"type":"structure","required":["FileSystemId","Policy"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}},"output":{"shape":"S2c"}},"PutLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/lifecycle-configuration","responseCode":200},"input":{"type":"structure","required":["FileSystemId","LifecyclePolicies"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"LifecyclePolicies":{"shape":"S2l"}}},"output":{"shape":"S2k"}},"TagResource":{"http":{"requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Tags":{"shape":"S3"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2015-02-01/resource-tags/{ResourceId}","responseCode":200},"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"TagKeys":{"shape":"S1v","location":"querystring","locationName":"tagKeys"}}}},"UpdateFileSystem":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}","responseCode":202},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"}}},"output":{"shape":"Sx"}},"UpdateFileSystemProtection":{"http":{"method":"PUT","requestUri":"/2015-02-01/file-systems/{FileSystemId}/protection","responseCode":200},"input":{"type":"structure","required":["FileSystemId"],"members":{"FileSystemId":{"location":"uri","locationName":"FileSystemId"},"ReplicationOverwriteProtection":{}}},"output":{"shape":"S15"},"idempotent":true}},"shapes":{"S3":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S8":{"type":"structure","required":["Uid","Gid"],"members":{"Uid":{"type":"long"},"Gid":{"type":"long"},"SecondaryGids":{"type":"list","member":{"type":"long"}}}},"Sc":{"type":"structure","members":{"Path":{},"CreationInfo":{"type":"structure","required":["OwnerUid","OwnerGid","Permissions"],"members":{"OwnerUid":{"type":"long"},"OwnerGid":{"type":"long"},"Permissions":{}}}}},"Si":{"type":"structure","members":{"ClientToken":{},"Name":{},"Tags":{"shape":"S3"},"AccessPointId":{},"AccessPointArn":{},"FileSystemId":{},"PosixUser":{"shape":"S8"},"RootDirectory":{"shape":"Sc"},"OwnerId":{},"LifeCycleState":{}}},"Sx":{"type":"structure","required":["OwnerId","CreationToken","FileSystemId","CreationTime","LifeCycleState","NumberOfMountTargets","SizeInBytes","PerformanceMode","Tags"],"members":{"OwnerId":{},"CreationToken":{},"FileSystemId":{},"FileSystemArn":{},"CreationTime":{"type":"timestamp"},"LifeCycleState":{},"Name":{},"NumberOfMountTargets":{"type":"integer"},"SizeInBytes":{"type":"structure","required":["Value"],"members":{"Value":{"type":"long"},"Timestamp":{"type":"timestamp"},"ValueInIA":{"type":"long"},"ValueInStandard":{"type":"long"},"ValueInArchive":{"type":"long"}}},"PerformanceMode":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"ThroughputMode":{},"ProvisionedThroughputInMibps":{"type":"double"},"AvailabilityZoneName":{},"AvailabilityZoneId":{},"Tags":{"shape":"S3"},"FileSystemProtection":{"shape":"S15"}}},"S15":{"type":"structure","members":{"ReplicationOverwriteProtection":{}}},"S1a":{"type":"list","member":{}},"S1c":{"type":"structure","required":["MountTargetId","FileSystemId","SubnetId","LifeCycleState"],"members":{"OwnerId":{},"MountTargetId":{},"FileSystemId":{},"SubnetId":{},"LifeCycleState":{},"IpAddress":{},"NetworkInterfaceId":{},"AvailabilityZoneId":{},"AvailabilityZoneName":{},"VpcId":{}}},"S1k":{"type":"structure","required":["SourceFileSystemId","SourceFileSystemRegion","SourceFileSystemArn","OriginalSourceFileSystemArn","CreationTime","Destinations"],"members":{"SourceFileSystemId":{},"SourceFileSystemRegion":{},"SourceFileSystemArn":{},"OriginalSourceFileSystemArn":{},"CreationTime":{"type":"timestamp"},"Destinations":{"type":"list","member":{"type":"structure","required":["Status","FileSystemId","Region"],"members":{"Status":{},"FileSystemId":{},"Region":{},"LastReplicatedTimestamp":{"type":"timestamp"}}}}}},"S1v":{"type":"list","member":{}},"S23":{"type":"structure","members":{"ResourceIdType":{},"Resources":{"type":"list","member":{}}}},"S28":{"type":"structure","members":{"BackupPolicy":{"shape":"S29"}}},"S29":{"type":"structure","required":["Status"],"members":{"Status":{}}},"S2c":{"type":"structure","members":{"FileSystemId":{},"Policy":{}}},"S2k":{"type":"structure","members":{"LifecyclePolicies":{"shape":"S2l"}}},"S2l":{"type":"list","member":{"type":"structure","members":{"TransitionToIA":{},"TransitionToPrimaryStorageClass":{},"TransitionToArchive":{}}}}}}

/***/ }),
/* 491 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAccessPoints":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AccessPoints"},"DescribeFileSystems":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"FileSystems"},"DescribeMountTargets":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"MountTargets"},"DescribeReplicationConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Replications"},"DescribeTags":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Tags"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 492 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-06-01","endpointPrefix":"elasticloadbalancing","protocol":"query","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing","signatureVersion":"v4","uid":"elasticloadbalancing-2012-06-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2012-06-01/"},"operations":{"AddTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"ApplySecurityGroupsToLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","SecurityGroups"],"members":{"LoadBalancerName":{},"SecurityGroups":{"shape":"Sa"}}},"output":{"resultWrapper":"ApplySecurityGroupsToLoadBalancerResult","type":"structure","members":{"SecurityGroups":{"shape":"Sa"}}}},"AttachLoadBalancerToSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"AttachLoadBalancerToSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"ConfigureHealthCheck":{"input":{"type":"structure","required":["LoadBalancerName","HealthCheck"],"members":{"LoadBalancerName":{},"HealthCheck":{"shape":"Si"}}},"output":{"resultWrapper":"ConfigureHealthCheckResult","type":"structure","members":{"HealthCheck":{"shape":"Si"}}}},"CreateAppCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","CookieName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieName":{}}},"output":{"resultWrapper":"CreateAppCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLBCookieStickinessPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}},"output":{"resultWrapper":"CreateLBCookieStickinessPolicyResult","type":"structure","members":{}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"SecurityGroups":{"shape":"Sa"},"Scheme":{},"Tags":{"shape":"S4"}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"DNSName":{}}}},"CreateLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","Listeners"],"members":{"LoadBalancerName":{},"Listeners":{"shape":"Sx"}}},"output":{"resultWrapper":"CreateLoadBalancerListenersResult","type":"structure","members":{}}},"CreateLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName","PolicyTypeName"],"members":{"LoadBalancerName":{},"PolicyName":{},"PolicyTypeName":{},"PolicyAttributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}},"output":{"resultWrapper":"CreateLoadBalancerPolicyResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteLoadBalancerListeners":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPorts"],"members":{"LoadBalancerName":{},"LoadBalancerPorts":{"type":"list","member":{"type":"integer"}}}},"output":{"resultWrapper":"DeleteLoadBalancerListenersResult","type":"structure","members":{}}},"DeleteLoadBalancerPolicy":{"input":{"type":"structure","required":["LoadBalancerName","PolicyName"],"members":{"LoadBalancerName":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteLoadBalancerPolicyResult","type":"structure","members":{}}},"DeregisterInstancesFromLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DeregisterInstancesFromLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeInstanceHealth":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"DescribeInstanceHealthResult","type":"structure","members":{"InstanceStates":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"State":{},"ReasonCode":{},"Description":{}}}}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName"],"members":{"LoadBalancerName":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerAttributes":{"shape":"S2a"}}}},"DescribeLoadBalancerPolicies":{"input":{"type":"structure","members":{"LoadBalancerName":{},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"DescribeLoadBalancerPoliciesResult","type":"structure","members":{"PolicyDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyTypeName":{},"PolicyAttributeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeValue":{}}}}}}}}}},"DescribeLoadBalancerPolicyTypes":{"input":{"type":"structure","members":{"PolicyTypeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeLoadBalancerPolicyTypesResult","type":"structure","members":{"PolicyTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"PolicyTypeName":{},"Description":{},"PolicyAttributeTypeDescriptions":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{},"Description":{},"DefaultValue":{},"Cardinality":{}}}}}}}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerNames":{"shape":"S2"},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancerDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"DNSName":{},"CanonicalHostedZoneName":{},"CanonicalHostedZoneNameID":{},"ListenerDescriptions":{"type":"list","member":{"type":"structure","members":{"Listener":{"shape":"Sy"},"PolicyNames":{"shape":"S2s"}}}},"Policies":{"type":"structure","members":{"AppCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieName":{}}}},"LBCookieStickinessPolicies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"CookieExpirationPeriod":{"type":"long"}}}},"OtherPolicies":{"shape":"S2s"}}},"BackendServerDescriptions":{"type":"list","member":{"type":"structure","members":{"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}}},"AvailabilityZones":{"shape":"S13"},"Subnets":{"shape":"Se"},"VPCId":{},"Instances":{"shape":"S1p"},"HealthCheck":{"shape":"Si"},"SourceSecurityGroup":{"type":"structure","members":{"OwnerAlias":{},"GroupName":{}}},"SecurityGroups":{"shape":"Sa"},"CreatedTime":{"type":"timestamp"},"Scheme":{}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["LoadBalancerNames"],"members":{"LoadBalancerNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"LoadBalancerName":{},"Tags":{"shape":"S4"}}}}}}},"DetachLoadBalancerFromSubnets":{"input":{"type":"structure","required":["LoadBalancerName","Subnets"],"members":{"LoadBalancerName":{},"Subnets":{"shape":"Se"}}},"output":{"resultWrapper":"DetachLoadBalancerFromSubnetsResult","type":"structure","members":{"Subnets":{"shape":"Se"}}}},"DisableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"DisableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"EnableAvailabilityZonesForLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","AvailabilityZones"],"members":{"LoadBalancerName":{},"AvailabilityZones":{"shape":"S13"}}},"output":{"resultWrapper":"EnableAvailabilityZonesForLoadBalancerResult","type":"structure","members":{"AvailabilityZones":{"shape":"S13"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerAttributes"],"members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"LoadBalancerName":{},"LoadBalancerAttributes":{"shape":"S2a"}}}},"RegisterInstancesWithLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerName","Instances"],"members":{"LoadBalancerName":{},"Instances":{"shape":"S1p"}}},"output":{"resultWrapper":"RegisterInstancesWithLoadBalancerResult","type":"structure","members":{"Instances":{"shape":"S1p"}}}},"RemoveTags":{"input":{"type":"structure","required":["LoadBalancerNames","Tags"],"members":{"LoadBalancerNames":{"shape":"S2"},"Tags":{"type":"list","member":{"type":"structure","members":{"Key":{}}}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"SetLoadBalancerListenerSSLCertificate":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","SSLCertificateId"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"SSLCertificateId":{}}},"output":{"resultWrapper":"SetLoadBalancerListenerSSLCertificateResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesForBackendServer":{"input":{"type":"structure","required":["LoadBalancerName","InstancePort","PolicyNames"],"members":{"LoadBalancerName":{},"InstancePort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesForBackendServerResult","type":"structure","members":{}}},"SetLoadBalancerPoliciesOfListener":{"input":{"type":"structure","required":["LoadBalancerName","LoadBalancerPort","PolicyNames"],"members":{"LoadBalancerName":{},"LoadBalancerPort":{"type":"integer"},"PolicyNames":{"shape":"S2s"}}},"output":{"resultWrapper":"SetLoadBalancerPoliciesOfListenerResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sa":{"type":"list","member":{}},"Se":{"type":"list","member":{}},"Si":{"type":"structure","required":["Target","Interval","Timeout","UnhealthyThreshold","HealthyThreshold"],"members":{"Target":{},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"UnhealthyThreshold":{"type":"integer"},"HealthyThreshold":{"type":"integer"}}},"Sx":{"type":"list","member":{"shape":"Sy"}},"Sy":{"type":"structure","required":["Protocol","LoadBalancerPort","InstancePort"],"members":{"Protocol":{},"LoadBalancerPort":{"type":"integer"},"InstanceProtocol":{},"InstancePort":{"type":"integer"},"SSLCertificateId":{}}},"S13":{"type":"list","member":{}},"S1p":{"type":"list","member":{"type":"structure","members":{"InstanceId":{}}}},"S2a":{"type":"structure","members":{"CrossZoneLoadBalancing":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"}}},"AccessLog":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"S3BucketName":{},"EmitInterval":{"type":"integer"},"S3BucketPrefix":{}}},"ConnectionDraining":{"type":"structure","required":["Enabled"],"members":{"Enabled":{"type":"boolean"},"Timeout":{"type":"integer"}}},"ConnectionSettings":{"type":"structure","required":["IdleTimeout"],"members":{"IdleTimeout":{"type":"integer"}}},"AdditionalAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"S2s":{"type":"list","member":{}}}}

/***/ }),
/* 493 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeInstanceHealth":{"result_key":"InstanceStates"},"DescribeLoadBalancerPolicies":{"result_key":"PolicyDescriptions"},"DescribeLoadBalancerPolicyTypes":{"result_key":"PolicyTypeDescriptions"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancerDescriptions"}}}

/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceDeregistered":{"delay":15,"operation":"DescribeInstanceHealth","maxAttempts":40,"acceptors":[{"expected":"OutOfService","matcher":"pathAll","state":"success","argument":"InstanceStates[].State"},{"matcher":"error","expected":"InvalidInstance","state":"success"}]},"AnyInstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAny","state":"success"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"},"InstanceInService":{"acceptors":[{"argument":"InstanceStates[].State","expected":"InService","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}],"delay":15,"maxAttempts":40,"operation":"DescribeInstanceHealth"}}}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-01","endpointPrefix":"elasticloadbalancing","protocol":"query","protocols":["query"],"serviceAbbreviation":"Elastic Load Balancing v2","serviceFullName":"Elastic Load Balancing","serviceId":"Elastic Load Balancing v2","signatureVersion":"v4","uid":"elasticloadbalancingv2-2015-12-01","xmlNamespace":"http://elasticloadbalancing.amazonaws.com/doc/2015-12-01/"},"operations":{"AddListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"AddListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceArns","Tags"],"members":{"ResourceArns":{"shape":"S9"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"AddTagsResult","type":"structure","members":{}}},"AddTrustStoreRevocations":{"input":{"type":"structure","required":["TrustStoreArn"],"members":{"TrustStoreArn":{},"RevocationContents":{"type":"list","member":{"type":"structure","members":{"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"RevocationType":{}}}}}},"output":{"resultWrapper":"AddTrustStoreRevocationsResult","type":"structure","members":{"TrustStoreRevocations":{"type":"list","member":{"type":"structure","members":{"TrustStoreArn":{},"RevocationId":{"type":"long"},"RevocationType":{},"NumberOfRevokedEntries":{"type":"long"}}}}}}},"CreateListener":{"input":{"type":"structure","required":["LoadBalancerArn","DefaultActions"],"members":{"LoadBalancerArn":{},"Protocol":{},"Port":{"type":"integer"},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sy"},"AlpnPolicy":{"shape":"S2b"},"Tags":{"shape":"Sb"},"MutualAuthentication":{"shape":"S2d"}}},"output":{"resultWrapper":"CreateListenerResult","type":"structure","members":{"Listeners":{"shape":"S2h"}}}},"CreateLoadBalancer":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Subnets":{"shape":"S2l"},"SubnetMappings":{"shape":"S2n"},"SecurityGroups":{"shape":"S2s"},"Scheme":{},"Tags":{"shape":"Sb"},"Type":{},"IpAddressType":{},"CustomerOwnedIpv4Pool":{}}},"output":{"resultWrapper":"CreateLoadBalancerResult","type":"structure","members":{"LoadBalancers":{"shape":"S2z"}}}},"CreateRule":{"input":{"type":"structure","required":["ListenerArn","Conditions","Priority","Actions"],"members":{"ListenerArn":{},"Conditions":{"shape":"S3h"},"Priority":{"type":"integer"},"Actions":{"shape":"Sy"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateRuleResult","type":"structure","members":{"Rules":{"shape":"S3x"}}}},"CreateTargetGroup":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Protocol":{},"ProtocolVersion":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckPath":{},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S4b"},"TargetType":{},"Tags":{"shape":"Sb"},"IpAddressType":{}}},"output":{"resultWrapper":"CreateTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S4h"}}}},"CreateTrustStore":{"input":{"type":"structure","required":["Name","CaCertificatesBundleS3Bucket","CaCertificatesBundleS3Key"],"members":{"Name":{},"CaCertificatesBundleS3Bucket":{},"CaCertificatesBundleS3Key":{},"CaCertificatesBundleS3ObjectVersion":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateTrustStoreResult","type":"structure","members":{"TrustStores":{"shape":"S4n"}}}},"DeleteListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{}}},"output":{"resultWrapper":"DeleteListenerResult","type":"structure","members":{}}},"DeleteLoadBalancer":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DeleteLoadBalancerResult","type":"structure","members":{}}},"DeleteRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{}}},"output":{"resultWrapper":"DeleteRuleResult","type":"structure","members":{}}},"DeleteTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DeleteTargetGroupResult","type":"structure","members":{}}},"DeleteTrustStore":{"input":{"type":"structure","required":["TrustStoreArn"],"members":{"TrustStoreArn":{}}},"output":{"resultWrapper":"DeleteTrustStoreResult","type":"structure","members":{}}},"DeregisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S53"}}},"output":{"resultWrapper":"DeregisterTargetsResult","type":"structure","members":{}}},"DescribeAccountLimits":{"input":{"type":"structure","members":{"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeAccountLimitsResult","type":"structure","members":{"Limits":{"type":"list","member":{"type":"structure","members":{"Name":{},"Max":{}}}},"NextMarker":{}}}},"DescribeListenerCertificates":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenerCertificatesResult","type":"structure","members":{"Certificates":{"shape":"S3"},"NextMarker":{}}}},"DescribeListeners":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"ListenerArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeListenersResult","type":"structure","members":{"Listeners":{"shape":"S2h"},"NextMarker":{}}}},"DescribeLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{}}},"output":{"resultWrapper":"DescribeLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S5m"}}}},"DescribeLoadBalancers":{"input":{"type":"structure","members":{"LoadBalancerArns":{"shape":"S4j"},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeLoadBalancersResult","type":"structure","members":{"LoadBalancers":{"shape":"S2z"},"NextMarker":{}}}},"DescribeRules":{"input":{"type":"structure","members":{"ListenerArn":{},"RuleArns":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeRulesResult","type":"structure","members":{"Rules":{"shape":"S3x"},"NextMarker":{}}}},"DescribeSSLPolicies":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"},"LoadBalancerType":{}}},"output":{"resultWrapper":"DescribeSSLPoliciesResult","type":"structure","members":{"SslPolicies":{"type":"list","member":{"type":"structure","members":{"SslProtocols":{"type":"list","member":{}},"Ciphers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Priority":{"type":"integer"}}}},"Name":{},"SupportedLoadBalancerTypes":{"shape":"S3k"}}}},"NextMarker":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceArns"],"members":{"ResourceArns":{"shape":"S9"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TagDescriptions":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"Sb"}}}}}}},"DescribeTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{}}},"output":{"resultWrapper":"DescribeTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S6d"}}}},"DescribeTargetGroups":{"input":{"type":"structure","members":{"LoadBalancerArn":{},"TargetGroupArns":{"type":"list","member":{}},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTargetGroupsResult","type":"structure","members":{"TargetGroups":{"shape":"S4h"},"NextMarker":{}}}},"DescribeTargetHealth":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S53"},"Include":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeTargetHealthResult","type":"structure","members":{"TargetHealthDescriptions":{"type":"list","member":{"type":"structure","members":{"Target":{"shape":"S54"},"HealthCheckPort":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}},"AnomalyDetection":{"type":"structure","members":{"Result":{},"MitigationInEffect":{}}}}}}}}},"DescribeTrustStoreAssociations":{"input":{"type":"structure","required":["TrustStoreArn"],"members":{"TrustStoreArn":{},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTrustStoreAssociationsResult","type":"structure","members":{"TrustStoreAssociations":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{}}}},"NextMarker":{}}}},"DescribeTrustStoreRevocations":{"input":{"type":"structure","required":["TrustStoreArn"],"members":{"TrustStoreArn":{},"RevocationIds":{"shape":"S74"},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTrustStoreRevocationsResult","type":"structure","members":{"TrustStoreRevocations":{"type":"list","member":{"type":"structure","members":{"TrustStoreArn":{},"RevocationId":{"type":"long"},"RevocationType":{},"NumberOfRevokedEntries":{"type":"long"}}}},"NextMarker":{}}}},"DescribeTrustStores":{"input":{"type":"structure","members":{"TrustStoreArns":{"type":"list","member":{}},"Names":{"type":"list","member":{}},"Marker":{},"PageSize":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTrustStoresResult","type":"structure","members":{"TrustStores":{"shape":"S4n"},"NextMarker":{}}}},"GetTrustStoreCaCertificatesBundle":{"input":{"type":"structure","required":["TrustStoreArn"],"members":{"TrustStoreArn":{}}},"output":{"resultWrapper":"GetTrustStoreCaCertificatesBundleResult","type":"structure","members":{"Location":{}}}},"GetTrustStoreRevocationContent":{"input":{"type":"structure","required":["TrustStoreArn","RevocationId"],"members":{"TrustStoreArn":{},"RevocationId":{"type":"long"}}},"output":{"resultWrapper":"GetTrustStoreRevocationContentResult","type":"structure","members":{"Location":{}}}},"ModifyListener":{"input":{"type":"structure","required":["ListenerArn"],"members":{"ListenerArn":{},"Port":{"type":"integer"},"Protocol":{},"SslPolicy":{},"Certificates":{"shape":"S3"},"DefaultActions":{"shape":"Sy"},"AlpnPolicy":{"shape":"S2b"},"MutualAuthentication":{"shape":"S2d"}}},"output":{"resultWrapper":"ModifyListenerResult","type":"structure","members":{"Listeners":{"shape":"S2h"}}}},"ModifyLoadBalancerAttributes":{"input":{"type":"structure","required":["LoadBalancerArn","Attributes"],"members":{"LoadBalancerArn":{},"Attributes":{"shape":"S5m"}}},"output":{"resultWrapper":"ModifyLoadBalancerAttributesResult","type":"structure","members":{"Attributes":{"shape":"S5m"}}}},"ModifyRule":{"input":{"type":"structure","required":["RuleArn"],"members":{"RuleArn":{},"Conditions":{"shape":"S3h"},"Actions":{"shape":"Sy"}}},"output":{"resultWrapper":"ModifyRuleResult","type":"structure","members":{"Rules":{"shape":"S3x"}}}},"ModifyTargetGroup":{"input":{"type":"structure","required":["TargetGroupArn"],"members":{"TargetGroupArn":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckPath":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"Matcher":{"shape":"S4b"}}},"output":{"resultWrapper":"ModifyTargetGroupResult","type":"structure","members":{"TargetGroups":{"shape":"S4h"}}}},"ModifyTargetGroupAttributes":{"input":{"type":"structure","required":["TargetGroupArn","Attributes"],"members":{"TargetGroupArn":{},"Attributes":{"shape":"S6d"}}},"output":{"resultWrapper":"ModifyTargetGroupAttributesResult","type":"structure","members":{"Attributes":{"shape":"S6d"}}}},"ModifyTrustStore":{"input":{"type":"structure","required":["TrustStoreArn","CaCertificatesBundleS3Bucket","CaCertificatesBundleS3Key"],"members":{"TrustStoreArn":{},"CaCertificatesBundleS3Bucket":{},"CaCertificatesBundleS3Key":{},"CaCertificatesBundleS3ObjectVersion":{}}},"output":{"resultWrapper":"ModifyTrustStoreResult","type":"structure","members":{"TrustStores":{"shape":"S4n"}}}},"RegisterTargets":{"input":{"type":"structure","required":["TargetGroupArn","Targets"],"members":{"TargetGroupArn":{},"Targets":{"shape":"S53"}}},"output":{"resultWrapper":"RegisterTargetsResult","type":"structure","members":{}}},"RemoveListenerCertificates":{"input":{"type":"structure","required":["ListenerArn","Certificates"],"members":{"ListenerArn":{},"Certificates":{"shape":"S3"}}},"output":{"resultWrapper":"RemoveListenerCertificatesResult","type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceArns","TagKeys"],"members":{"ResourceArns":{"shape":"S9"},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"RemoveTagsResult","type":"structure","members":{}}},"RemoveTrustStoreRevocations":{"input":{"type":"structure","required":["TrustStoreArn","RevocationIds"],"members":{"TrustStoreArn":{},"RevocationIds":{"shape":"S74"}}},"output":{"resultWrapper":"RemoveTrustStoreRevocationsResult","type":"structure","members":{}}},"SetIpAddressType":{"input":{"type":"structure","required":["LoadBalancerArn","IpAddressType"],"members":{"LoadBalancerArn":{},"IpAddressType":{}}},"output":{"resultWrapper":"SetIpAddressTypeResult","type":"structure","members":{"IpAddressType":{}}}},"SetRulePriorities":{"input":{"type":"structure","required":["RulePriorities"],"members":{"RulePriorities":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{"type":"integer"}}}}}},"output":{"resultWrapper":"SetRulePrioritiesResult","type":"structure","members":{"Rules":{"shape":"S3x"}}}},"SetSecurityGroups":{"input":{"type":"structure","required":["LoadBalancerArn","SecurityGroups"],"members":{"LoadBalancerArn":{},"SecurityGroups":{"shape":"S2s"},"EnforceSecurityGroupInboundRulesOnPrivateLinkTraffic":{}}},"output":{"resultWrapper":"SetSecurityGroupsResult","type":"structure","members":{"SecurityGroupIds":{"shape":"S2s"},"EnforceSecurityGroupInboundRulesOnPrivateLinkTraffic":{}}}},"SetSubnets":{"input":{"type":"structure","required":["LoadBalancerArn"],"members":{"LoadBalancerArn":{},"Subnets":{"shape":"S2l"},"SubnetMappings":{"shape":"S2n"},"IpAddressType":{}}},"output":{"resultWrapper":"SetSubnetsResult","type":"structure","members":{"AvailabilityZones":{"shape":"S38"},"IpAddressType":{}}}}},"shapes":{"S3":{"type":"list","member":{"type":"structure","members":{"CertificateArn":{},"IsDefault":{"type":"boolean"}}}},"S9":{"type":"list","member":{}},"Sb":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"Sy":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"TargetGroupArn":{},"AuthenticateOidcConfig":{"type":"structure","required":["Issuer","AuthorizationEndpoint","TokenEndpoint","UserInfoEndpoint","ClientId"],"members":{"Issuer":{},"AuthorizationEndpoint":{},"TokenEndpoint":{},"UserInfoEndpoint":{},"ClientId":{},"ClientSecret":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{},"UseExistingClientSecret":{"type":"boolean"}}},"AuthenticateCognitoConfig":{"type":"structure","required":["UserPoolArn","UserPoolClientId","UserPoolDomain"],"members":{"UserPoolArn":{},"UserPoolClientId":{},"UserPoolDomain":{},"SessionCookieName":{},"Scope":{},"SessionTimeout":{"type":"long"},"AuthenticationRequestExtraParams":{"type":"map","key":{},"value":{}},"OnUnauthenticatedRequest":{}}},"Order":{"type":"integer"},"RedirectConfig":{"type":"structure","required":["StatusCode"],"members":{"Protocol":{},"Port":{},"Host":{},"Path":{},"Query":{},"StatusCode":{}}},"FixedResponseConfig":{"type":"structure","required":["StatusCode"],"members":{"MessageBody":{},"StatusCode":{},"ContentType":{}}},"ForwardConfig":{"type":"structure","members":{"TargetGroups":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"Weight":{"type":"integer"}}}},"TargetGroupStickinessConfig":{"type":"structure","members":{"Enabled":{"type":"boolean"},"DurationSeconds":{"type":"integer"}}}}}}}},"S2b":{"type":"list","member":{}},"S2d":{"type":"structure","members":{"Mode":{},"TrustStoreArn":{},"IgnoreClientCertificateExpiry":{"type":"boolean"}}},"S2h":{"type":"list","member":{"type":"structure","members":{"ListenerArn":{},"LoadBalancerArn":{},"Port":{"type":"integer"},"Protocol":{},"Certificates":{"shape":"S3"},"SslPolicy":{},"DefaultActions":{"shape":"Sy"},"AlpnPolicy":{"shape":"S2b"},"MutualAuthentication":{"shape":"S2d"}}}},"S2l":{"type":"list","member":{}},"S2n":{"type":"list","member":{"type":"structure","members":{"SubnetId":{},"AllocationId":{},"PrivateIPv4Address":{},"IPv6Address":{}}}},"S2s":{"type":"list","member":{}},"S2z":{"type":"list","member":{"type":"structure","members":{"LoadBalancerArn":{},"DNSName":{},"CanonicalHostedZoneId":{},"CreatedTime":{"type":"timestamp"},"LoadBalancerName":{},"Scheme":{},"VpcId":{},"State":{"type":"structure","members":{"Code":{},"Reason":{}}},"Type":{},"AvailabilityZones":{"shape":"S38"},"SecurityGroups":{"shape":"S2s"},"IpAddressType":{},"CustomerOwnedIpv4Pool":{},"EnforceSecurityGroupInboundRulesOnPrivateLinkTraffic":{}}}},"S38":{"type":"list","member":{"type":"structure","members":{"ZoneName":{},"SubnetId":{},"OutpostId":{},"LoadBalancerAddresses":{"type":"list","member":{"type":"structure","members":{"IpAddress":{},"AllocationId":{},"PrivateIPv4Address":{},"IPv6Address":{}}}}}}},"S3h":{"type":"list","member":{"type":"structure","members":{"Field":{},"Values":{"shape":"S3k"},"HostHeaderConfig":{"type":"structure","members":{"Values":{"shape":"S3k"}}},"PathPatternConfig":{"type":"structure","members":{"Values":{"shape":"S3k"}}},"HttpHeaderConfig":{"type":"structure","members":{"HttpHeaderName":{},"Values":{"shape":"S3k"}}},"QueryStringConfig":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}},"HttpRequestMethodConfig":{"type":"structure","members":{"Values":{"shape":"S3k"}}},"SourceIpConfig":{"type":"structure","members":{"Values":{"shape":"S3k"}}}}}},"S3k":{"type":"list","member":{}},"S3x":{"type":"list","member":{"type":"structure","members":{"RuleArn":{},"Priority":{},"Conditions":{"shape":"S3h"},"Actions":{"shape":"Sy"},"IsDefault":{"type":"boolean"}}}},"S4b":{"type":"structure","members":{"HttpCode":{},"GrpcCode":{}}},"S4h":{"type":"list","member":{"type":"structure","members":{"TargetGroupArn":{},"TargetGroupName":{},"Protocol":{},"Port":{"type":"integer"},"VpcId":{},"HealthCheckProtocol":{},"HealthCheckPort":{},"HealthCheckEnabled":{"type":"boolean"},"HealthCheckIntervalSeconds":{"type":"integer"},"HealthCheckTimeoutSeconds":{"type":"integer"},"HealthyThresholdCount":{"type":"integer"},"UnhealthyThresholdCount":{"type":"integer"},"HealthCheckPath":{},"Matcher":{"shape":"S4b"},"LoadBalancerArns":{"shape":"S4j"},"TargetType":{},"ProtocolVersion":{},"IpAddressType":{}}}},"S4j":{"type":"list","member":{}},"S4n":{"type":"list","member":{"type":"structure","members":{"Name":{},"TrustStoreArn":{},"Status":{},"NumberOfCaCertificates":{"type":"integer"},"TotalRevokedEntries":{"type":"long"}}}},"S53":{"type":"list","member":{"shape":"S54"}},"S54":{"type":"structure","required":["Id"],"members":{"Id":{},"Port":{"type":"integer"},"AvailabilityZone":{}}},"S5m":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S6d":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S74":{"type":"list","member":{"type":"long"}}}}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeListeners":{"input_token":"Marker","output_token":"NextMarker","result_key":"Listeners"},"DescribeLoadBalancers":{"input_token":"Marker","output_token":"NextMarker","result_key":"LoadBalancers"},"DescribeTargetGroups":{"input_token":"Marker","output_token":"NextMarker","result_key":"TargetGroups"},"DescribeTrustStoreAssociations":{"input_token":"Marker","limit_key":"PageSize","output_token":"NextMarker"},"DescribeTrustStoreRevocations":{"input_token":"Marker","limit_key":"PageSize","output_token":"NextMarker"},"DescribeTrustStores":{"input_token":"Marker","limit_key":"PageSize","output_token":"NextMarker"}}}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"LoadBalancerExists":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"matcher":"status","expected":200,"state":"success"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"retry"}]},"LoadBalancerAvailable":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"success","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"state":"retry","matcher":"pathAny","argument":"LoadBalancers[].State.Code","expected":"provisioning"},{"state":"retry","matcher":"error","expected":"LoadBalancerNotFound"}]},"LoadBalancersDeleted":{"delay":15,"operation":"DescribeLoadBalancers","maxAttempts":40,"acceptors":[{"state":"retry","matcher":"pathAll","argument":"LoadBalancers[].State.Code","expected":"active"},{"matcher":"error","expected":"LoadBalancerNotFound","state":"success"}]},"TargetInService":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"healthy","matcher":"pathAll","state":"success"},{"matcher":"error","expected":"InvalidInstance","state":"retry"}]},"TargetDeregistered":{"delay":15,"maxAttempts":40,"operation":"DescribeTargetHealth","acceptors":[{"matcher":"error","expected":"InvalidTarget","state":"success"},{"argument":"TargetHealthDescriptions[].TargetHealth.State","expected":"unused","matcher":"pathAll","state":"success"}]}}}

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2009-03-31","endpointPrefix":"elasticmapreduce","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon EMR","serviceFullName":"Amazon EMR","serviceId":"EMR","signatureVersion":"v4","targetPrefix":"ElasticMapReduce","uid":"elasticmapreduce-2009-03-31"},"operations":{"AddInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"shape":"S3"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceFleetId":{},"ClusterArn":{}}}},"AddInstanceGroups":{"input":{"type":"structure","required":["InstanceGroups","JobFlowId"],"members":{"InstanceGroups":{"shape":"S11"},"JobFlowId":{}}},"output":{"type":"structure","members":{"JobFlowId":{},"InstanceGroupIds":{"type":"list","member":{}},"ClusterArn":{}}}},"AddJobFlowSteps":{"input":{"type":"structure","required":["JobFlowId","Steps"],"members":{"JobFlowId":{},"Steps":{"shape":"S1m"},"ExecutionRoleArn":{}}},"output":{"type":"structure","members":{"StepIds":{"shape":"S1v"}}}},"AddTags":{"input":{"type":"structure","required":["ResourceId","Tags"],"members":{"ResourceId":{},"Tags":{"shape":"S1y"}}},"output":{"type":"structure","members":{}}},"CancelSteps":{"input":{"type":"structure","required":["ClusterId","StepIds"],"members":{"ClusterId":{},"StepIds":{"shape":"S1v"},"StepCancellationOption":{}}},"output":{"type":"structure","members":{"CancelStepsInfoList":{"type":"list","member":{"type":"structure","members":{"StepId":{},"Status":{},"Reason":{}}}}}}},"CreateSecurityConfiguration":{"input":{"type":"structure","required":["Name","SecurityConfiguration"],"members":{"Name":{},"SecurityConfiguration":{}}},"output":{"type":"structure","required":["Name","CreationDateTime"],"members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"CreateStudio":{"input":{"type":"structure","required":["Name","AuthMode","VpcId","SubnetIds","ServiceRole","WorkspaceSecurityGroupId","EngineSecurityGroupId","DefaultS3Location"],"members":{"Name":{},"Description":{},"AuthMode":{},"VpcId":{},"SubnetIds":{"shape":"S2d"},"ServiceRole":{},"UserRole":{},"WorkspaceSecurityGroupId":{},"EngineSecurityGroupId":{},"DefaultS3Location":{},"IdpAuthUrl":{},"IdpRelayStateParameterName":{},"Tags":{"shape":"S1y"},"TrustedIdentityPropagationEnabled":{"type":"boolean"},"IdcUserAssignment":{},"IdcInstanceArn":{},"EncryptionKeyArn":{}}},"output":{"type":"structure","members":{"StudioId":{},"Url":{}}}},"CreateStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType","SessionPolicyArn"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{}}}},"DeleteSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteStudio":{"input":{"type":"structure","required":["StudioId"],"members":{"StudioId":{}}}},"DeleteStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{}}}},"DescribeCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"Cluster":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S2q"},"Ec2InstanceAttributes":{"type":"structure","members":{"Ec2KeyName":{},"Ec2SubnetId":{},"RequestedEc2SubnetIds":{"shape":"S2z"},"Ec2AvailabilityZone":{},"RequestedEc2AvailabilityZones":{"shape":"S2z"},"IamInstanceProfile":{},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S30"},"AdditionalSlaveSecurityGroups":{"shape":"S30"}}},"InstanceCollectionType":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"RequestedAmiVersion":{},"RunningAmiVersion":{},"ReleaseLabel":{},"AutoTerminate":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"UnhealthyNodeReplacement":{"type":"boolean"},"VisibleToAllUsers":{"type":"boolean"},"Applications":{"shape":"S33"},"Tags":{"shape":"S1y"},"ServiceRole":{},"NormalizedInstanceHours":{"type":"integer"},"MasterPublicDnsName":{},"Configurations":{"shape":"Si"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S37"},"ClusterArn":{},"OutpostArn":{},"StepConcurrencyLevel":{"type":"integer"},"PlacementGroups":{"shape":"S39"},"OSReleaseLabel":{},"EbsRootVolumeIops":{"type":"integer"},"EbsRootVolumeThroughput":{"type":"integer"}}}}}},"DescribeJobFlows":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"JobFlowIds":{"shape":"S1t"},"JobFlowStates":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobFlows":{"type":"list","member":{"type":"structure","required":["JobFlowId","Name","ExecutionStatusDetail","Instances"],"members":{"JobFlowId":{},"Name":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"AmiVersion":{},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}},"Instances":{"type":"structure","required":["MasterInstanceType","SlaveInstanceType","InstanceCount"],"members":{"MasterInstanceType":{},"MasterPublicDnsName":{},"MasterInstanceId":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["Market","InstanceRole","InstanceType","InstanceRequestCount","InstanceRunningCount","State","CreationDateTime"],"members":{"InstanceGroupId":{},"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceRequestCount":{"type":"integer"},"InstanceRunningCount":{"type":"integer"},"State":{},"LastStateChangeReason":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"CustomAmiId":{}}}},"NormalizedInstanceHours":{"type":"integer"},"Ec2KeyName":{},"Ec2SubnetId":{},"Placement":{"shape":"S3n"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"UnhealthyNodeReplacement":{"type":"boolean"},"HadoopVersion":{}}},"Steps":{"type":"list","member":{"type":"structure","required":["StepConfig","ExecutionStatusDetail"],"members":{"StepConfig":{"shape":"S1n"},"ExecutionStatusDetail":{"type":"structure","required":["State","CreationDateTime"],"members":{"State":{},"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"},"LastStateChangeReason":{}}}}}},"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"BootstrapActionConfig":{"shape":"S3u"}}}},"SupportedProducts":{"shape":"S3w"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"AutoScalingRole":{},"ScaleDownBehavior":{}}}}}},"deprecated":true},"DescribeNotebookExecution":{"input":{"type":"structure","required":["NotebookExecutionId"],"members":{"NotebookExecutionId":{}}},"output":{"type":"structure","members":{"NotebookExecution":{"type":"structure","members":{"NotebookExecutionId":{},"EditorId":{},"ExecutionEngine":{"shape":"S40"},"NotebookExecutionName":{},"NotebookParams":{},"Status":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Arn":{},"OutputNotebookURI":{},"LastStateChangeReason":{},"NotebookInstanceSecurityGroupId":{},"Tags":{"shape":"S1y"},"NotebookS3Location":{"shape":"S44"},"OutputNotebookS3Location":{"type":"structure","members":{"Bucket":{},"Key":{}}},"OutputNotebookFormat":{},"EnvironmentVariables":{"shape":"S48"}}}}}},"DescribeReleaseLabel":{"input":{"type":"structure","members":{"ReleaseLabel":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ReleaseLabel":{},"Applications":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"NextToken":{},"AvailableOSReleases":{"type":"list","member":{"type":"structure","members":{"Label":{}}}}}}},"DescribeSecurityConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"SecurityConfiguration":{},"CreationDateTime":{"type":"timestamp"}}}},"DescribeStep":{"input":{"type":"structure","required":["ClusterId","StepId"],"members":{"ClusterId":{},"StepId":{}}},"output":{"type":"structure","members":{"Step":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S4l"},"ActionOnFailure":{},"Status":{"shape":"S4m"},"ExecutionRoleArn":{}}}}}},"DescribeStudio":{"input":{"type":"structure","required":["StudioId"],"members":{"StudioId":{}}},"output":{"type":"structure","members":{"Studio":{"type":"structure","members":{"StudioId":{},"StudioArn":{},"Name":{},"Description":{},"AuthMode":{},"VpcId":{},"SubnetIds":{"shape":"S2d"},"ServiceRole":{},"UserRole":{},"WorkspaceSecurityGroupId":{},"EngineSecurityGroupId":{},"Url":{},"CreationTime":{"type":"timestamp"},"DefaultS3Location":{},"IdpAuthUrl":{},"IdpRelayStateParameterName":{},"Tags":{"shape":"S1y"},"IdcInstanceArn":{},"TrustedIdentityPropagationEnabled":{"type":"boolean"},"IdcUserAssignment":{},"EncryptionKeyArn":{}}}}}},"GetAutoTerminationPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"AutoTerminationPolicy":{"shape":"S4x"}}}},"GetBlockPublicAccessConfiguration":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["BlockPublicAccessConfiguration","BlockPublicAccessConfigurationMetadata"],"members":{"BlockPublicAccessConfiguration":{"shape":"S51"},"BlockPublicAccessConfigurationMetadata":{"type":"structure","required":["CreationDateTime","CreatedByArn"],"members":{"CreationDateTime":{"type":"timestamp"},"CreatedByArn":{}}}}}},"GetClusterSessionCredentials":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"ExecutionRoleArn":{}}},"output":{"type":"structure","members":{"Credentials":{"type":"structure","members":{"UsernamePassword":{"type":"structure","members":{"Username":{},"Password":{}},"sensitive":true}},"union":true},"ExpiresAt":{"type":"timestamp"}}}},"GetManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{"ManagedScalingPolicy":{"shape":"S5c"}}}},"GetStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{}}},"output":{"type":"structure","members":{"SessionMapping":{"type":"structure","members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}}}},"ListBootstrapActions":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"BootstrapActions":{"type":"list","member":{"type":"structure","members":{"Name":{},"ScriptPath":{},"Args":{"shape":"S30"}}}},"Marker":{}}}},"ListClusters":{"input":{"type":"structure","members":{"CreatedAfter":{"type":"timestamp"},"CreatedBefore":{"type":"timestamp"},"ClusterStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Clusters":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"shape":"S2q"},"NormalizedInstanceHours":{"type":"integer"},"ClusterArn":{},"OutpostArn":{}}}},"Marker":{}}}},"ListInstanceFleets":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceFleets":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"ProvisionedOnDemandCapacity":{"type":"integer"},"ProvisionedSpotCapacity":{"type":"integer"},"InstanceTypeSpecifications":{"type":"list","member":{"type":"structure","members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"Configurations":{"shape":"Si"},"EbsBlockDevices":{"shape":"S63"},"EbsOptimized":{"type":"boolean"},"CustomAmiId":{}}}},"LaunchSpecifications":{"shape":"Sl"},"ResizeSpecifications":{"shape":"Su"}}}},"Marker":{}}}},"ListInstanceGroups":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"Marker":{}}},"output":{"type":"structure","members":{"InstanceGroups":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Market":{},"InstanceGroupType":{},"BidPrice":{},"InstanceType":{},"RequestedInstanceCount":{"type":"integer"},"RunningInstanceCount":{"type":"integer"},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"Configurations":{"shape":"Si"},"ConfigurationsVersion":{"type":"long"},"LastSuccessfullyAppliedConfigurations":{"shape":"Si"},"LastSuccessfullyAppliedConfigurationsVersion":{"type":"long"},"EbsBlockDevices":{"shape":"S63"},"EbsOptimized":{"type":"boolean"},"ShrinkPolicy":{"shape":"S6f"},"AutoScalingPolicy":{"shape":"S6j"},"CustomAmiId":{}}}},"Marker":{}}}},"ListInstances":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"InstanceGroupId":{},"InstanceGroupTypes":{"type":"list","member":{}},"InstanceFleetId":{},"InstanceFleetType":{},"InstanceStates":{"type":"list","member":{}},"Marker":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"Id":{},"Ec2InstanceId":{},"PublicDnsName":{},"PublicIpAddress":{},"PrivateDnsName":{},"PrivateIpAddress":{},"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"InstanceGroupId":{},"InstanceFleetId":{},"Market":{},"InstanceType":{},"EbsVolumes":{"type":"list","member":{"type":"structure","members":{"Device":{},"VolumeId":{}}}}}}},"Marker":{}}}},"ListNotebookExecutions":{"input":{"type":"structure","members":{"EditorId":{},"Status":{},"From":{"type":"timestamp"},"To":{"type":"timestamp"},"Marker":{},"ExecutionEngineId":{}}},"output":{"type":"structure","members":{"NotebookExecutions":{"type":"list","member":{"type":"structure","members":{"NotebookExecutionId":{},"EditorId":{},"NotebookExecutionName":{},"Status":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NotebookS3Location":{"shape":"S44"},"ExecutionEngineId":{}}}},"Marker":{}}}},"ListReleaseLabels":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Prefix":{},"Application":{}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ReleaseLabels":{"shape":"S30"},"NextToken":{}}}},"ListSecurityConfigurations":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"SecurityConfigurations":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreationDateTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListSteps":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepStates":{"type":"list","member":{}},"StepIds":{"shape":"S1t"},"Marker":{}}},"output":{"type":"structure","members":{"Steps":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Config":{"shape":"S4l"},"ActionOnFailure":{},"Status":{"shape":"S4m"}}}},"Marker":{}}}},"ListStudioSessionMappings":{"input":{"type":"structure","members":{"StudioId":{},"IdentityType":{},"Marker":{}}},"output":{"type":"structure","members":{"SessionMappings":{"type":"list","member":{"type":"structure","members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{},"CreationTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListStudios":{"input":{"type":"structure","members":{"Marker":{}}},"output":{"type":"structure","members":{"Studios":{"type":"list","member":{"type":"structure","members":{"StudioId":{},"Name":{},"VpcId":{},"Description":{},"Url":{},"AuthMode":{},"CreationTime":{"type":"timestamp"}}}},"Marker":{}}}},"ListSupportedInstanceTypes":{"input":{"type":"structure","required":["ReleaseLabel"],"members":{"ReleaseLabel":{},"Marker":{}}},"output":{"type":"structure","members":{"SupportedInstanceTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"MemoryGB":{"type":"float"},"StorageGB":{"type":"integer"},"VCPU":{"type":"integer"},"Is64BitsOnly":{"type":"boolean"},"InstanceFamilyId":{},"EbsOptimizedAvailable":{"type":"boolean"},"EbsOptimizedByDefault":{"type":"boolean"},"NumberOfDisks":{"type":"integer"},"EbsStorageOnly":{"type":"boolean"},"Architecture":{}}}},"Marker":{}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"StepConcurrencyLevel":{"type":"integer"}}},"output":{"type":"structure","members":{"StepConcurrencyLevel":{"type":"integer"}}}},"ModifyInstanceFleet":{"input":{"type":"structure","required":["ClusterId","InstanceFleet"],"members":{"ClusterId":{},"InstanceFleet":{"type":"structure","required":["InstanceFleetId"],"members":{"InstanceFleetId":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"ResizeSpecifications":{"shape":"Su"}}}}}},"ModifyInstanceGroups":{"input":{"type":"structure","members":{"ClusterId":{},"InstanceGroups":{"type":"list","member":{"type":"structure","required":["InstanceGroupId"],"members":{"InstanceGroupId":{},"InstanceCount":{"type":"integer"},"EC2InstanceIdsToTerminate":{"type":"list","member":{}},"ShrinkPolicy":{"shape":"S6f"},"ReconfigurationType":{},"Configurations":{"shape":"Si"}}}}}}},"PutAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId","AutoScalingPolicy"],"members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S15"}}},"output":{"type":"structure","members":{"ClusterId":{},"InstanceGroupId":{},"AutoScalingPolicy":{"shape":"S6j"},"ClusterArn":{}}}},"PutAutoTerminationPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{},"AutoTerminationPolicy":{"shape":"S4x"}}},"output":{"type":"structure","members":{}}},"PutBlockPublicAccessConfiguration":{"input":{"type":"structure","required":["BlockPublicAccessConfiguration"],"members":{"BlockPublicAccessConfiguration":{"shape":"S51"}}},"output":{"type":"structure","members":{}}},"PutManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId","ManagedScalingPolicy"],"members":{"ClusterId":{},"ManagedScalingPolicy":{"shape":"S5c"}}},"output":{"type":"structure","members":{}}},"RemoveAutoScalingPolicy":{"input":{"type":"structure","required":["ClusterId","InstanceGroupId"],"members":{"ClusterId":{},"InstanceGroupId":{}}},"output":{"type":"structure","members":{}}},"RemoveAutoTerminationPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{}}},"RemoveManagedScalingPolicy":{"input":{"type":"structure","required":["ClusterId"],"members":{"ClusterId":{}}},"output":{"type":"structure","members":{}}},"RemoveTags":{"input":{"type":"structure","required":["ResourceId","TagKeys"],"members":{"ResourceId":{},"TagKeys":{"shape":"S30"}}},"output":{"type":"structure","members":{}}},"RunJobFlow":{"input":{"type":"structure","required":["Name","Instances"],"members":{"Name":{},"LogUri":{},"LogEncryptionKmsKeyId":{},"AdditionalInfo":{},"AmiVersion":{},"ReleaseLabel":{},"Instances":{"type":"structure","members":{"MasterInstanceType":{},"SlaveInstanceType":{},"InstanceCount":{"type":"integer"},"InstanceGroups":{"shape":"S11"},"InstanceFleets":{"type":"list","member":{"shape":"S3"}},"Ec2KeyName":{},"Placement":{"shape":"S3n"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"},"TerminationProtected":{"type":"boolean"},"UnhealthyNodeReplacement":{"type":"boolean"},"HadoopVersion":{},"Ec2SubnetId":{},"Ec2SubnetIds":{"shape":"S2z"},"EmrManagedMasterSecurityGroup":{},"EmrManagedSlaveSecurityGroup":{},"ServiceAccessSecurityGroup":{},"AdditionalMasterSecurityGroups":{"shape":"S8m"},"AdditionalSlaveSecurityGroups":{"shape":"S8m"}}},"Steps":{"shape":"S1m"},"BootstrapActions":{"type":"list","member":{"shape":"S3u"}},"SupportedProducts":{"shape":"S3w"},"NewSupportedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Args":{"shape":"S1t"}}}},"Applications":{"shape":"S33"},"Configurations":{"shape":"Si"},"VisibleToAllUsers":{"type":"boolean"},"JobFlowRole":{},"ServiceRole":{},"Tags":{"shape":"S1y"},"SecurityConfiguration":{},"AutoScalingRole":{},"ScaleDownBehavior":{},"CustomAmiId":{},"EbsRootVolumeSize":{"type":"integer"},"RepoUpgradeOnBoot":{},"KerberosAttributes":{"shape":"S37"},"StepConcurrencyLevel":{"type":"integer"},"ManagedScalingPolicy":{"shape":"S5c"},"PlacementGroupConfigs":{"shape":"S39"},"AutoTerminationPolicy":{"shape":"S4x"},"OSReleaseLabel":{},"EbsRootVolumeIops":{"type":"integer"},"EbsRootVolumeThroughput":{"type":"integer"}}},"output":{"type":"structure","members":{"JobFlowId":{},"ClusterArn":{}}}},"SetKeepJobFlowAliveWhenNoSteps":{"input":{"type":"structure","required":["JobFlowIds","KeepJobFlowAliveWhenNoSteps"],"members":{"JobFlowIds":{"shape":"S1t"},"KeepJobFlowAliveWhenNoSteps":{"type":"boolean"}}}},"SetTerminationProtection":{"input":{"type":"structure","required":["JobFlowIds","TerminationProtected"],"members":{"JobFlowIds":{"shape":"S1t"},"TerminationProtected":{"type":"boolean"}}}},"SetUnhealthyNodeReplacement":{"input":{"type":"structure","required":["JobFlowIds","UnhealthyNodeReplacement"],"members":{"JobFlowIds":{"shape":"S1t"},"UnhealthyNodeReplacement":{"type":"boolean"}}}},"SetVisibleToAllUsers":{"input":{"type":"structure","required":["JobFlowIds","VisibleToAllUsers"],"members":{"JobFlowIds":{"shape":"S1t"},"VisibleToAllUsers":{"type":"boolean"}}}},"StartNotebookExecution":{"input":{"type":"structure","required":["ExecutionEngine","ServiceRole"],"members":{"EditorId":{},"RelativePath":{},"NotebookExecutionName":{},"NotebookParams":{},"ExecutionEngine":{"shape":"S40"},"ServiceRole":{},"NotebookInstanceSecurityGroupId":{},"Tags":{"shape":"S1y"},"NotebookS3Location":{"type":"structure","members":{"Bucket":{},"Key":{}}},"OutputNotebookS3Location":{"type":"structure","members":{"Bucket":{},"Key":{}}},"OutputNotebookFormat":{},"EnvironmentVariables":{"shape":"S48"}}},"output":{"type":"structure","members":{"NotebookExecutionId":{}}}},"StopNotebookExecution":{"input":{"type":"structure","required":["NotebookExecutionId"],"members":{"NotebookExecutionId":{}}}},"TerminateJobFlows":{"input":{"type":"structure","required":["JobFlowIds"],"members":{"JobFlowIds":{"shape":"S1t"}}}},"UpdateStudio":{"input":{"type":"structure","required":["StudioId"],"members":{"StudioId":{},"Name":{},"Description":{},"SubnetIds":{"shape":"S2d"},"DefaultS3Location":{},"EncryptionKeyArn":{}}}},"UpdateStudioSessionMapping":{"input":{"type":"structure","required":["StudioId","IdentityType","SessionPolicyArn"],"members":{"StudioId":{},"IdentityId":{},"IdentityName":{},"IdentityType":{},"SessionPolicyArn":{}}}}},"shapes":{"S3":{"type":"structure","required":["InstanceFleetType"],"members":{"Name":{},"InstanceFleetType":{},"TargetOnDemandCapacity":{"type":"integer"},"TargetSpotCapacity":{"type":"integer"},"InstanceTypeConfigs":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{"type":"integer"},"BidPrice":{},"BidPriceAsPercentageOfOnDemandPrice":{"type":"double"},"EbsConfiguration":{"shape":"Sa"},"Configurations":{"shape":"Si"},"CustomAmiId":{}}}},"LaunchSpecifications":{"shape":"Sl"},"ResizeSpecifications":{"shape":"Su"}}},"Sa":{"type":"structure","members":{"EbsBlockDeviceConfigs":{"type":"list","member":{"type":"structure","required":["VolumeSpecification"],"members":{"VolumeSpecification":{"shape":"Sd"},"VolumesPerInstance":{"type":"integer"}}}},"EbsOptimized":{"type":"boolean"}}},"Sd":{"type":"structure","required":["VolumeType","SizeInGB"],"members":{"VolumeType":{},"Iops":{"type":"integer"},"SizeInGB":{"type":"integer"},"Throughput":{"type":"integer"}}},"Si":{"type":"list","member":{"type":"structure","members":{"Classification":{},"Configurations":{"shape":"Si"},"Properties":{"shape":"Sk"}}}},"Sk":{"type":"map","key":{},"value":{}},"Sl":{"type":"structure","members":{"SpotSpecification":{"type":"structure","required":["TimeoutDurationMinutes","TimeoutAction"],"members":{"TimeoutDurationMinutes":{"type":"integer"},"TimeoutAction":{},"BlockDurationMinutes":{"type":"integer"},"AllocationStrategy":{}}},"OnDemandSpecification":{"type":"structure","required":["AllocationStrategy"],"members":{"AllocationStrategy":{},"CapacityReservationOptions":{"type":"structure","members":{"UsageStrategy":{},"CapacityReservationPreference":{},"CapacityReservationResourceGroupArn":{}}}}}}},"Su":{"type":"structure","members":{"SpotResizeSpecification":{"type":"structure","required":["TimeoutDurationMinutes"],"members":{"TimeoutDurationMinutes":{"type":"integer"}}},"OnDemandResizeSpecification":{"type":"structure","required":["TimeoutDurationMinutes"],"members":{"TimeoutDurationMinutes":{"type":"integer"}}}}},"S11":{"type":"list","member":{"type":"structure","required":["InstanceRole","InstanceType","InstanceCount"],"members":{"Name":{},"Market":{},"InstanceRole":{},"BidPrice":{},"InstanceType":{},"InstanceCount":{"type":"integer"},"Configurations":{"shape":"Si"},"EbsConfiguration":{"shape":"Sa"},"AutoScalingPolicy":{"shape":"S15"},"CustomAmiId":{}}}},"S15":{"type":"structure","required":["Constraints","Rules"],"members":{"Constraints":{"shape":"S16"},"Rules":{"shape":"S17"}}},"S16":{"type":"structure","required":["MinCapacity","MaxCapacity"],"members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"}}},"S17":{"type":"list","member":{"type":"structure","required":["Name","Action","Trigger"],"members":{"Name":{},"Description":{},"Action":{"type":"structure","required":["SimpleScalingPolicyConfiguration"],"members":{"Market":{},"SimpleScalingPolicyConfiguration":{"type":"structure","required":["ScalingAdjustment"],"members":{"AdjustmentType":{},"ScalingAdjustment":{"type":"integer"},"CoolDown":{"type":"integer"}}}}},"Trigger":{"type":"structure","required":["CloudWatchAlarmDefinition"],"members":{"CloudWatchAlarmDefinition":{"type":"structure","required":["ComparisonOperator","MetricName","Period","Threshold"],"members":{"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"Namespace":{},"Period":{"type":"integer"},"Statistic":{},"Threshold":{"type":"double"},"Unit":{},"Dimensions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}}}}}},"S1m":{"type":"list","member":{"shape":"S1n"}},"S1n":{"type":"structure","required":["Name","HadoopJarStep"],"members":{"Name":{},"ActionOnFailure":{},"HadoopJarStep":{"type":"structure","required":["Jar"],"members":{"Properties":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Jar":{},"MainClass":{},"Args":{"shape":"S1t"}}}}},"S1t":{"type":"list","member":{}},"S1v":{"type":"list","member":{}},"S1y":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S2d":{"type":"list","member":{}},"S2q":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"ReadyDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}},"ErrorDetails":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorData":{"type":"list","member":{"shape":"Sk"}},"ErrorMessage":{}}}}}},"S2z":{"type":"list","member":{}},"S30":{"type":"list","member":{}},"S33":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{},"Args":{"shape":"S30"},"AdditionalInfo":{"shape":"Sk"}}}},"S37":{"type":"structure","required":["Realm","KdcAdminPassword"],"members":{"Realm":{},"KdcAdminPassword":{},"CrossRealmTrustPrincipalPassword":{},"ADDomainJoinUser":{},"ADDomainJoinPassword":{}}},"S39":{"type":"list","member":{"type":"structure","required":["InstanceRole"],"members":{"InstanceRole":{},"PlacementStrategy":{}}}},"S3n":{"type":"structure","members":{"AvailabilityZone":{},"AvailabilityZones":{"shape":"S2z"}}},"S3u":{"type":"structure","required":["Name","ScriptBootstrapAction"],"members":{"Name":{},"ScriptBootstrapAction":{"type":"structure","required":["Path"],"members":{"Path":{},"Args":{"shape":"S1t"}}}}},"S3w":{"type":"list","member":{}},"S40":{"type":"structure","required":["Id"],"members":{"Id":{},"Type":{},"MasterInstanceSecurityGroupId":{},"ExecutionRoleArn":{}}},"S44":{"type":"structure","members":{"Bucket":{},"Key":{}}},"S48":{"type":"map","key":{},"value":{}},"S4l":{"type":"structure","members":{"Jar":{},"Properties":{"shape":"Sk"},"MainClass":{},"Args":{"shape":"S30"}}},"S4m":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}},"FailureDetails":{"type":"structure","members":{"Reason":{},"Message":{},"LogFile":{}}},"Timeline":{"type":"structure","members":{"CreationDateTime":{"type":"timestamp"},"StartDateTime":{"type":"timestamp"},"EndDateTime":{"type":"timestamp"}}}}},"S4x":{"type":"structure","members":{"IdleTimeout":{"type":"long"}}},"S51":{"type":"structure","required":["BlockPublicSecurityGroupRules"],"members":{"BlockPublicSecurityGroupRules":{"type":"boolean"},"PermittedPublicSecurityGroupRuleRanges":{"type":"list","member":{"type":"structure","required":["MinRange"],"members":{"MinRange":{"type":"integer"},"MaxRange":{"type":"integer"}}}}}},"S5c":{"type":"structure","members":{"ComputeLimits":{"type":"structure","required":["UnitType","MinimumCapacityUnits","MaximumCapacityUnits"],"members":{"UnitType":{},"MinimumCapacityUnits":{"type":"integer"},"MaximumCapacityUnits":{"type":"integer"},"MaximumOnDemandCapacityUnits":{"type":"integer"},"MaximumCoreCapacityUnits":{"type":"integer"}}}}},"S63":{"type":"list","member":{"type":"structure","members":{"VolumeSpecification":{"shape":"Sd"},"Device":{}}}},"S6f":{"type":"structure","members":{"DecommissionTimeout":{"type":"integer"},"InstanceResizePolicy":{"type":"structure","members":{"InstancesToTerminate":{"shape":"S6h"},"InstancesToProtect":{"shape":"S6h"},"InstanceTerminationTimeout":{"type":"integer"}}}}},"S6h":{"type":"list","member":{}},"S6j":{"type":"structure","members":{"Status":{"type":"structure","members":{"State":{},"StateChangeReason":{"type":"structure","members":{"Code":{},"Message":{}}}}},"Constraints":{"shape":"S16"},"Rules":{"shape":"S17"}}},"S8m":{"type":"list","member":{}}}}

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeJobFlows":{"result_key":"JobFlows"},"ListBootstrapActions":{"input_token":"Marker","output_token":"Marker","result_key":"BootstrapActions"},"ListClusters":{"input_token":"Marker","output_token":"Marker","result_key":"Clusters"},"ListInstanceFleets":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceFleets"},"ListInstanceGroups":{"input_token":"Marker","output_token":"Marker","result_key":"InstanceGroups"},"ListInstances":{"input_token":"Marker","output_token":"Marker","result_key":"Instances"},"ListNotebookExecutions":{"input_token":"Marker","output_token":"Marker","result_key":"NotebookExecutions"},"ListReleaseLabels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListSecurityConfigurations":{"input_token":"Marker","output_token":"Marker","result_key":"SecurityConfigurations"},"ListSteps":{"input_token":"Marker","output_token":"Marker","result_key":"Steps"},"ListStudioSessionMappings":{"input_token":"Marker","output_token":"Marker","result_key":"SessionMappings"},"ListStudios":{"input_token":"Marker","output_token":"Marker","result_key":"Studios"},"ListSupportedInstanceTypes":{"input_token":"Marker","output_token":"Marker"}}}

/***/ }),
/* 500 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterRunning":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"RUNNING"},{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"WAITING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATING"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]},"StepComplete":{"delay":30,"operation":"DescribeStep","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Step.Status.State","expected":"COMPLETED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"FAILED"},{"state":"failure","matcher":"path","argument":"Step.Status.State","expected":"CANCELLED"}]},"ClusterTerminated":{"delay":30,"operation":"DescribeCluster","maxAttempts":60,"acceptors":[{"state":"success","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED"},{"state":"failure","matcher":"path","argument":"Cluster.Status.State","expected":"TERMINATED_WITH_ERRORS"}]}}}

/***/ }),
/* 501 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-09-25","endpointPrefix":"elastictranscoder","protocol":"rest-json","serviceFullName":"Amazon Elastic Transcoder","serviceId":"Elastic Transcoder","signatureVersion":"v4","uid":"elastictranscoder-2012-09-25"},"operations":{"CancelJob":{"http":{"method":"DELETE","requestUri":"/2012-09-25/jobs/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"CreateJob":{"http":{"requestUri":"/2012-09-25/jobs","responseCode":201},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"Su"},"Outputs":{"type":"list","member":{"shape":"Su"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"}}}},"UserMetadata":{"shape":"S1v"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"CreatePipeline":{"http":{"requestUri":"/2012-09-25/pipelines","responseCode":201},"input":{"type":"structure","required":["Name","InputBucket","Role"],"members":{"Name":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"CreatePreset":{"http":{"requestUri":"/2012-09-25/presets","responseCode":201},"input":{"type":"structure","required":["Name","Container"],"members":{"Name":{},"Description":{},"Container":{},"Video":{"shape":"S2r"},"Audio":{"shape":"S37"},"Thumbnails":{"shape":"S3i"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"},"Warning":{}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeletePreset":{"http":{"method":"DELETE","requestUri":"/2012-09-25/presets/{Id}","responseCode":202},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"ListJobsByPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByPipeline/{PipelineId}"},"input":{"type":"structure","required":["PipelineId"],"members":{"PipelineId":{"location":"uri","locationName":"PipelineId"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListJobsByStatus":{"http":{"method":"GET","requestUri":"/2012-09-25/jobsByStatus/{Status}"},"input":{"type":"structure","required":["Status"],"members":{"Status":{"location":"uri","locationName":"Status"},"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Jobs":{"shape":"S3v"},"NextPageToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Pipelines":{"type":"list","member":{"shape":"S2l"}},"NextPageToken":{}}}},"ListPresets":{"http":{"method":"GET","requestUri":"/2012-09-25/presets"},"input":{"type":"structure","members":{"Ascending":{"location":"querystring","locationName":"Ascending"},"PageToken":{"location":"querystring","locationName":"PageToken"}}},"output":{"type":"structure","members":{"Presets":{"type":"list","member":{"shape":"S3m"}},"NextPageToken":{}}}},"ReadJob":{"http":{"method":"GET","requestUri":"/2012-09-25/jobs/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Job":{"shape":"S1y"}}}},"ReadPipeline":{"http":{"method":"GET","requestUri":"/2012-09-25/pipelines/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"ReadPreset":{"http":{"method":"GET","requestUri":"/2012-09-25/presets/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{"Preset":{"shape":"S3m"}}}},"TestRole":{"http":{"requestUri":"/2012-09-25/roleTests","responseCode":200},"input":{"type":"structure","required":["Role","InputBucket","OutputBucket","Topics"],"members":{"Role":{},"InputBucket":{},"OutputBucket":{},"Topics":{"type":"list","member":{}}},"deprecated":true},"output":{"type":"structure","members":{"Success":{},"Messages":{"type":"list","member":{}}},"deprecated":true},"deprecated":true},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/2012-09-25/pipelines/{Id}","responseCode":200},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Name":{},"InputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"},"Warnings":{"shape":"S2n"}}}},"UpdatePipelineNotifications":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/notifications"},"input":{"type":"structure","required":["Id","Notifications"],"members":{"Id":{"location":"uri","locationName":"Id"},"Notifications":{"shape":"S2a"}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}},"UpdatePipelineStatus":{"http":{"requestUri":"/2012-09-25/pipelines/{Id}/status"},"input":{"type":"structure","required":["Id","Status"],"members":{"Id":{"location":"uri","locationName":"Id"},"Status":{}}},"output":{"type":"structure","members":{"Pipeline":{"shape":"S2l"}}}}},"shapes":{"S5":{"type":"structure","members":{"Key":{},"FrameRate":{},"Resolution":{},"AspectRatio":{},"Interlaced":{},"Container":{},"Encryption":{"shape":"Sc"},"TimeSpan":{"shape":"Sg"},"InputCaptions":{"type":"structure","members":{"MergePolicy":{},"CaptionSources":{"shape":"Sk"}}},"DetectedProperties":{"type":"structure","members":{"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"}}}}},"Sc":{"type":"structure","members":{"Mode":{},"Key":{},"KeyMd5":{},"InitializationVector":{}}},"Sg":{"type":"structure","members":{"StartTime":{},"Duration":{}}},"Sk":{"type":"list","member":{"type":"structure","members":{"Key":{},"Language":{},"TimeOffset":{},"Label":{},"Encryption":{"shape":"Sc"}}}},"St":{"type":"list","member":{"shape":"S5"}},"Su":{"type":"structure","members":{"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"}}},"Sx":{"type":"list","member":{"type":"structure","members":{"PresetWatermarkId":{},"InputKey":{},"Encryption":{"shape":"Sc"}}}},"S11":{"type":"structure","members":{"MergePolicy":{},"Artwork":{"type":"list","member":{"type":"structure","members":{"InputKey":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{},"AlbumArtFormat":{},"Encryption":{"shape":"Sc"}}}}}},"S19":{"type":"list","member":{"type":"structure","members":{"TimeSpan":{"shape":"Sg"}},"deprecated":true},"deprecated":true},"S1b":{"type":"structure","members":{"MergePolicy":{"deprecated":true},"CaptionSources":{"shape":"Sk","deprecated":true},"CaptionFormats":{"type":"list","member":{"type":"structure","members":{"Format":{},"Pattern":{},"Encryption":{"shape":"Sc"}}}}}},"S1l":{"type":"list","member":{}},"S1m":{"type":"structure","members":{"Method":{},"Key":{},"KeyMd5":{},"InitializationVector":{},"LicenseAcquisitionUrl":{},"KeyStoragePolicy":{}}},"S1q":{"type":"structure","members":{"Format":{},"Key":{},"KeyMd5":{},"KeyId":{},"InitializationVector":{},"LicenseAcquisitionUrl":{}}},"S1v":{"type":"map","key":{},"value":{}},"S1y":{"type":"structure","members":{"Id":{},"Arn":{},"PipelineId":{},"Input":{"shape":"S5"},"Inputs":{"shape":"St"},"Output":{"shape":"S1z"},"Outputs":{"type":"list","member":{"shape":"S1z"}},"OutputKeyPrefix":{},"Playlists":{"type":"list","member":{"type":"structure","members":{"Name":{},"Format":{},"OutputKeys":{"shape":"S1l"},"HlsContentProtection":{"shape":"S1m"},"PlayReadyDrm":{"shape":"S1q"},"Status":{},"StatusDetail":{}}}},"Status":{},"UserMetadata":{"shape":"S1v"},"Timing":{"type":"structure","members":{"SubmitTimeMillis":{"type":"long"},"StartTimeMillis":{"type":"long"},"FinishTimeMillis":{"type":"long"}}}}},"S1z":{"type":"structure","members":{"Id":{},"Key":{},"ThumbnailPattern":{},"ThumbnailEncryption":{"shape":"Sc"},"Rotate":{},"PresetId":{},"SegmentDuration":{},"Status":{},"StatusDetail":{},"Duration":{"type":"long"},"Width":{"type":"integer"},"Height":{"type":"integer"},"FrameRate":{},"FileSize":{"type":"long"},"DurationMillis":{"type":"long"},"Watermarks":{"shape":"Sx"},"AlbumArt":{"shape":"S11"},"Composition":{"shape":"S19","deprecated":true},"Captions":{"shape":"S1b"},"Encryption":{"shape":"Sc"},"AppliedColorSpaceConversion":{}}},"S2a":{"type":"structure","members":{"Progressing":{},"Completed":{},"Warning":{},"Error":{}}},"S2c":{"type":"structure","members":{"Bucket":{},"StorageClass":{},"Permissions":{"type":"list","member":{"type":"structure","members":{"GranteeType":{},"Grantee":{},"Access":{"type":"list","member":{}}}}}}},"S2l":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Status":{},"InputBucket":{},"OutputBucket":{},"Role":{},"AwsKmsKeyArn":{},"Notifications":{"shape":"S2a"},"ContentConfig":{"shape":"S2c"},"ThumbnailConfig":{"shape":"S2c"}}},"S2n":{"type":"list","member":{"type":"structure","members":{"Code":{},"Message":{}}}},"S2r":{"type":"structure","members":{"Codec":{},"CodecOptions":{"type":"map","key":{},"value":{}},"KeyframesMaxDist":{},"FixedGOP":{},"BitRate":{},"FrameRate":{},"MaxFrameRate":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"DisplayAspectRatio":{},"SizingPolicy":{},"PaddingPolicy":{},"Watermarks":{"type":"list","member":{"type":"structure","members":{"Id":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"HorizontalAlign":{},"HorizontalOffset":{},"VerticalAlign":{},"VerticalOffset":{},"Opacity":{},"Target":{}}}}}},"S37":{"type":"structure","members":{"Codec":{},"SampleRate":{},"BitRate":{},"Channels":{},"AudioPackingMode":{},"CodecOptions":{"type":"structure","members":{"Profile":{},"BitDepth":{},"BitOrder":{},"Signed":{}}}}},"S3i":{"type":"structure","members":{"Format":{},"Interval":{},"Resolution":{},"AspectRatio":{},"MaxWidth":{},"MaxHeight":{},"SizingPolicy":{},"PaddingPolicy":{}}},"S3m":{"type":"structure","members":{"Id":{},"Arn":{},"Name":{},"Description":{},"Container":{},"Audio":{"shape":"S37"},"Video":{"shape":"S2r"},"Thumbnails":{"shape":"S3i"},"Type":{}}},"S3v":{"type":"list","member":{"shape":"S1y"}}}}

/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListJobsByPipeline":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListJobsByStatus":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Jobs"},"ListPipelines":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Pipelines"},"ListPresets":{"input_token":"PageToken","output_token":"NextPageToken","result_key":"Presets"}}}

/***/ }),
/* 503 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"JobComplete":{"delay":30,"operation":"ReadJob","maxAttempts":120,"acceptors":[{"expected":"Complete","matcher":"path","state":"success","argument":"Job.Status"},{"expected":"Canceled","matcher":"path","state":"failure","argument":"Job.Status"},{"expected":"Error","matcher":"path","state":"failure","argument":"Job.Status"}]}}}

/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-12-01","endpointPrefix":"email","protocol":"query","serviceAbbreviation":"Amazon SES","serviceFullName":"Amazon Simple Email Service","serviceId":"SES","signatureVersion":"v4","signingName":"ses","uid":"email-2010-12-01","xmlNamespace":"http://ses.amazonaws.com/doc/2010-12-01/"},"operations":{"CloneReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","OriginalRuleSetName"],"members":{"RuleSetName":{},"OriginalRuleSetName":{}}},"output":{"resultWrapper":"CloneReceiptRuleSetResult","type":"structure","members":{}}},"CreateConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSet"],"members":{"ConfigurationSet":{"shape":"S5"}}},"output":{"resultWrapper":"CreateConfigurationSetResult","type":"structure","members":{}}},"CreateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"CreateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"CreateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"CreateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"CreateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName","FromEmailAddress","TemplateSubject","TemplateContent","SuccessRedirectionURL","FailureRedirectionURL"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"CreateReceiptFilter":{"input":{"type":"structure","required":["Filter"],"members":{"Filter":{"shape":"S10"}}},"output":{"resultWrapper":"CreateReceiptFilterResult","type":"structure","members":{}}},"CreateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"After":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"CreateReceiptRuleResult","type":"structure","members":{}}},"CreateReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"CreateReceiptRuleSetResult","type":"structure","members":{}}},"CreateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"CreateTemplateResult","type":"structure","members":{}}},"DeleteConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetResult","type":"structure","members":{}}},"DeleteConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestinationName"],"members":{"ConfigurationSetName":{},"EventDestinationName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetEventDestinationResult","type":"structure","members":{}}},"DeleteConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{}}},"output":{"resultWrapper":"DeleteConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"DeleteCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}}},"DeleteIdentity":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"DeleteIdentityResult","type":"structure","members":{}}},"DeleteIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName"],"members":{"Identity":{},"PolicyName":{}}},"output":{"resultWrapper":"DeleteIdentityPolicyResult","type":"structure","members":{}}},"DeleteReceiptFilter":{"input":{"type":"structure","required":["FilterName"],"members":{"FilterName":{}}},"output":{"resultWrapper":"DeleteReceiptFilterResult","type":"structure","members":{}}},"DeleteReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleResult","type":"structure","members":{}}},"DeleteReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DeleteReceiptRuleSetResult","type":"structure","members":{}}},"DeleteTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"DeleteTemplateResult","type":"structure","members":{}}},"DeleteVerifiedEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"DescribeActiveReceiptRuleSet":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeActiveReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"DescribeConfigurationSet":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"ConfigurationSetAttributeNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeConfigurationSetResult","type":"structure","members":{"ConfigurationSet":{"shape":"S5"},"EventDestinations":{"type":"list","member":{"shape":"S9"}},"TrackingOptions":{"shape":"Sp"},"DeliveryOptions":{"shape":"S31"},"ReputationOptions":{"type":"structure","members":{"SendingEnabled":{"type":"boolean"},"ReputationMetricsEnabled":{"type":"boolean"},"LastFreshStart":{"type":"timestamp"}}}}}},"DescribeReceiptRule":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleResult","type":"structure","members":{"Rule":{"shape":"S18"}}}},"DescribeReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName"],"members":{"RuleSetName":{}}},"output":{"resultWrapper":"DescribeReceiptRuleSetResult","type":"structure","members":{"Metadata":{"shape":"S2t"},"Rules":{"shape":"S2v"}}}},"GetAccountSendingEnabled":{"output":{"resultWrapper":"GetAccountSendingEnabledResult","type":"structure","members":{"Enabled":{"type":"boolean"}}}},"GetCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetCustomVerificationEmailTemplateResult","type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"GetIdentityDkimAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityDkimAttributesResult","type":"structure","required":["DkimAttributes"],"members":{"DkimAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["DkimEnabled","DkimVerificationStatus"],"members":{"DkimEnabled":{"type":"boolean"},"DkimVerificationStatus":{},"DkimTokens":{"shape":"S3h"}}}}}}},"GetIdentityMailFromDomainAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityMailFromDomainAttributesResult","type":"structure","required":["MailFromDomainAttributes"],"members":{"MailFromDomainAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["MailFromDomain","MailFromDomainStatus","BehaviorOnMXFailure"],"members":{"MailFromDomain":{},"MailFromDomainStatus":{},"BehaviorOnMXFailure":{}}}}}}},"GetIdentityNotificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityNotificationAttributesResult","type":"structure","required":["NotificationAttributes"],"members":{"NotificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["BounceTopic","ComplaintTopic","DeliveryTopic","ForwardingEnabled"],"members":{"BounceTopic":{},"ComplaintTopic":{},"DeliveryTopic":{},"ForwardingEnabled":{"type":"boolean"},"HeadersInBounceNotificationsEnabled":{"type":"boolean"},"HeadersInComplaintNotificationsEnabled":{"type":"boolean"},"HeadersInDeliveryNotificationsEnabled":{"type":"boolean"}}}}}}},"GetIdentityPolicies":{"input":{"type":"structure","required":["Identity","PolicyNames"],"members":{"Identity":{},"PolicyNames":{"shape":"S3w"}}},"output":{"resultWrapper":"GetIdentityPoliciesResult","type":"structure","required":["Policies"],"members":{"Policies":{"type":"map","key":{},"value":{}}}}},"GetIdentityVerificationAttributes":{"input":{"type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"}}},"output":{"resultWrapper":"GetIdentityVerificationAttributesResult","type":"structure","required":["VerificationAttributes"],"members":{"VerificationAttributes":{"type":"map","key":{},"value":{"type":"structure","required":["VerificationStatus"],"members":{"VerificationStatus":{},"VerificationToken":{}}}}}}},"GetSendQuota":{"output":{"resultWrapper":"GetSendQuotaResult","type":"structure","members":{"Max24HourSend":{"type":"double"},"MaxSendRate":{"type":"double"},"SentLast24Hours":{"type":"double"}}}},"GetSendStatistics":{"output":{"resultWrapper":"GetSendStatisticsResult","type":"structure","members":{"SendDataPoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"DeliveryAttempts":{"type":"long"},"Bounces":{"type":"long"},"Complaints":{"type":"long"},"Rejects":{"type":"long"}}}}}}},"GetTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{}}},"output":{"resultWrapper":"GetTemplateResult","type":"structure","members":{"Template":{"shape":"S20"}}}},"ListConfigurationSets":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListConfigurationSetsResult","type":"structure","members":{"ConfigurationSets":{"type":"list","member":{"shape":"S5"}},"NextToken":{}}}},"ListCustomVerificationEmailTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListCustomVerificationEmailTemplatesResult","type":"structure","members":{"CustomVerificationEmailTemplates":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"NextToken":{}}}},"ListIdentities":{"input":{"type":"structure","members":{"IdentityType":{},"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListIdentitiesResult","type":"structure","required":["Identities"],"members":{"Identities":{"shape":"S3c"},"NextToken":{}}}},"ListIdentityPolicies":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{}}},"output":{"resultWrapper":"ListIdentityPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S3w"}}}},"ListReceiptFilters":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListReceiptFiltersResult","type":"structure","members":{"Filters":{"type":"list","member":{"shape":"S10"}}}}},"ListReceiptRuleSets":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListReceiptRuleSetsResult","type":"structure","members":{"RuleSets":{"type":"list","member":{"shape":"S2t"}},"NextToken":{}}}},"ListTemplates":{"input":{"type":"structure","members":{"NextToken":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListTemplatesResult","type":"structure","members":{"TemplatesMetadata":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListVerifiedEmailAddresses":{"output":{"resultWrapper":"ListVerifiedEmailAddressesResult","type":"structure","members":{"VerifiedEmailAddresses":{"shape":"S54"}}}},"PutConfigurationSetDeliveryOptions":{"input":{"type":"structure","required":["ConfigurationSetName"],"members":{"ConfigurationSetName":{},"DeliveryOptions":{"shape":"S31"}}},"output":{"resultWrapper":"PutConfigurationSetDeliveryOptionsResult","type":"structure","members":{}}},"PutIdentityPolicy":{"input":{"type":"structure","required":["Identity","PolicyName","Policy"],"members":{"Identity":{},"PolicyName":{},"Policy":{}}},"output":{"resultWrapper":"PutIdentityPolicyResult","type":"structure","members":{}}},"ReorderReceiptRuleSet":{"input":{"type":"structure","required":["RuleSetName","RuleNames"],"members":{"RuleSetName":{},"RuleNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"ReorderReceiptRuleSetResult","type":"structure","members":{}}},"SendBounce":{"input":{"type":"structure","required":["OriginalMessageId","BounceSender","BouncedRecipientInfoList"],"members":{"OriginalMessageId":{},"BounceSender":{},"Explanation":{},"MessageDsn":{"type":"structure","required":["ReportingMta"],"members":{"ReportingMta":{},"ArrivalDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}},"BouncedRecipientInfoList":{"type":"list","member":{"type":"structure","required":["Recipient"],"members":{"Recipient":{},"RecipientArn":{},"BounceType":{},"RecipientDsnFields":{"type":"structure","required":["Action","Status"],"members":{"FinalRecipient":{},"Action":{},"RemoteMta":{},"Status":{},"DiagnosticCode":{},"LastAttemptDate":{"type":"timestamp"},"ExtensionFields":{"shape":"S5i"}}}}}},"BounceSenderArn":{}}},"output":{"resultWrapper":"SendBounceResult","type":"structure","members":{"MessageId":{}}}},"SendBulkTemplatedEmail":{"input":{"type":"structure","required":["Source","Template","Destinations"],"members":{"Source":{},"SourceArn":{},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"ReturnPathArn":{},"ConfigurationSetName":{},"DefaultTags":{"shape":"S5x"},"Template":{},"TemplateArn":{},"DefaultTemplateData":{},"Destinations":{"type":"list","member":{"type":"structure","required":["Destination"],"members":{"Destination":{"shape":"S64"},"ReplacementTags":{"shape":"S5x"},"ReplacementTemplateData":{}}}}}},"output":{"resultWrapper":"SendBulkTemplatedEmailResult","type":"structure","required":["Status"],"members":{"Status":{"type":"list","member":{"type":"structure","members":{"Status":{},"Error":{},"MessageId":{}}}}}}},"SendCustomVerificationEmail":{"input":{"type":"structure","required":["EmailAddress","TemplateName"],"members":{"EmailAddress":{},"TemplateName":{},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendCustomVerificationEmailResult","type":"structure","members":{"MessageId":{}}}},"SendEmail":{"input":{"type":"structure","required":["Source","Destination","Message"],"members":{"Source":{},"Destination":{"shape":"S64"},"Message":{"type":"structure","required":["Subject","Body"],"members":{"Subject":{"shape":"S6e"},"Body":{"type":"structure","members":{"Text":{"shape":"S6e"},"Html":{"shape":"S6e"}}}}},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendRawEmail":{"input":{"type":"structure","required":["RawMessage"],"members":{"Source":{},"Destinations":{"shape":"S54"},"RawMessage":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"FromArn":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{}}},"output":{"resultWrapper":"SendRawEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SendTemplatedEmail":{"input":{"type":"structure","required":["Source","Destination","Template","TemplateData"],"members":{"Source":{},"Destination":{"shape":"S64"},"ReplyToAddresses":{"shape":"S54"},"ReturnPath":{},"SourceArn":{},"ReturnPathArn":{},"Tags":{"shape":"S5x"},"ConfigurationSetName":{},"Template":{},"TemplateArn":{},"TemplateData":{}}},"output":{"resultWrapper":"SendTemplatedEmailResult","type":"structure","required":["MessageId"],"members":{"MessageId":{}}}},"SetActiveReceiptRuleSet":{"input":{"type":"structure","members":{"RuleSetName":{}}},"output":{"resultWrapper":"SetActiveReceiptRuleSetResult","type":"structure","members":{}}},"SetIdentityDkimEnabled":{"input":{"type":"structure","required":["Identity","DkimEnabled"],"members":{"Identity":{},"DkimEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityDkimEnabledResult","type":"structure","members":{}}},"SetIdentityFeedbackForwardingEnabled":{"input":{"type":"structure","required":["Identity","ForwardingEnabled"],"members":{"Identity":{},"ForwardingEnabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityFeedbackForwardingEnabledResult","type":"structure","members":{}}},"SetIdentityHeadersInNotificationsEnabled":{"input":{"type":"structure","required":["Identity","NotificationType","Enabled"],"members":{"Identity":{},"NotificationType":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"SetIdentityHeadersInNotificationsEnabledResult","type":"structure","members":{}}},"SetIdentityMailFromDomain":{"input":{"type":"structure","required":["Identity"],"members":{"Identity":{},"MailFromDomain":{},"BehaviorOnMXFailure":{}}},"output":{"resultWrapper":"SetIdentityMailFromDomainResult","type":"structure","members":{}}},"SetIdentityNotificationTopic":{"input":{"type":"structure","required":["Identity","NotificationType"],"members":{"Identity":{},"NotificationType":{},"SnsTopic":{}}},"output":{"resultWrapper":"SetIdentityNotificationTopicResult","type":"structure","members":{}}},"SetReceiptRulePosition":{"input":{"type":"structure","required":["RuleSetName","RuleName"],"members":{"RuleSetName":{},"RuleName":{},"After":{}}},"output":{"resultWrapper":"SetReceiptRulePositionResult","type":"structure","members":{}}},"TestRenderTemplate":{"input":{"type":"structure","required":["TemplateName","TemplateData"],"members":{"TemplateName":{},"TemplateData":{}}},"output":{"resultWrapper":"TestRenderTemplateResult","type":"structure","members":{"RenderedTemplate":{}}}},"UpdateAccountSendingEnabled":{"input":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetEventDestination":{"input":{"type":"structure","required":["ConfigurationSetName","EventDestination"],"members":{"ConfigurationSetName":{},"EventDestination":{"shape":"S9"}}},"output":{"resultWrapper":"UpdateConfigurationSetEventDestinationResult","type":"structure","members":{}}},"UpdateConfigurationSetReputationMetricsEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetSendingEnabled":{"input":{"type":"structure","required":["ConfigurationSetName","Enabled"],"members":{"ConfigurationSetName":{},"Enabled":{"type":"boolean"}}}},"UpdateConfigurationSetTrackingOptions":{"input":{"type":"structure","required":["ConfigurationSetName","TrackingOptions"],"members":{"ConfigurationSetName":{},"TrackingOptions":{"shape":"Sp"}}},"output":{"resultWrapper":"UpdateConfigurationSetTrackingOptionsResult","type":"structure","members":{}}},"UpdateCustomVerificationEmailTemplate":{"input":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"FromEmailAddress":{},"TemplateSubject":{},"TemplateContent":{},"SuccessRedirectionURL":{},"FailureRedirectionURL":{}}}},"UpdateReceiptRule":{"input":{"type":"structure","required":["RuleSetName","Rule"],"members":{"RuleSetName":{},"Rule":{"shape":"S18"}}},"output":{"resultWrapper":"UpdateReceiptRuleResult","type":"structure","members":{}}},"UpdateTemplate":{"input":{"type":"structure","required":["Template"],"members":{"Template":{"shape":"S20"}}},"output":{"resultWrapper":"UpdateTemplateResult","type":"structure","members":{}}},"VerifyDomainDkim":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainDkimResult","type":"structure","required":["DkimTokens"],"members":{"DkimTokens":{"shape":"S3h"}}}},"VerifyDomainIdentity":{"input":{"type":"structure","required":["Domain"],"members":{"Domain":{}}},"output":{"resultWrapper":"VerifyDomainIdentityResult","type":"structure","required":["VerificationToken"],"members":{"VerificationToken":{}}}},"VerifyEmailAddress":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}}},"VerifyEmailIdentity":{"input":{"type":"structure","required":["EmailAddress"],"members":{"EmailAddress":{}}},"output":{"resultWrapper":"VerifyEmailIdentityResult","type":"structure","members":{}}}},"shapes":{"S5":{"type":"structure","required":["Name"],"members":{"Name":{}}},"S9":{"type":"structure","required":["Name","MatchingEventTypes"],"members":{"Name":{},"Enabled":{"type":"boolean"},"MatchingEventTypes":{"type":"list","member":{}},"KinesisFirehoseDestination":{"type":"structure","required":["IAMRoleARN","DeliveryStreamARN"],"members":{"IAMRoleARN":{},"DeliveryStreamARN":{}}},"CloudWatchDestination":{"type":"structure","required":["DimensionConfigurations"],"members":{"DimensionConfigurations":{"type":"list","member":{"type":"structure","required":["DimensionName","DimensionValueSource","DefaultDimensionValue"],"members":{"DimensionName":{},"DimensionValueSource":{},"DefaultDimensionValue":{}}}}}},"SNSDestination":{"type":"structure","required":["TopicARN"],"members":{"TopicARN":{}}}}},"Sp":{"type":"structure","members":{"CustomRedirectDomain":{}}},"S10":{"type":"structure","required":["Name","IpFilter"],"members":{"Name":{},"IpFilter":{"type":"structure","required":["Policy","Cidr"],"members":{"Policy":{},"Cidr":{}}}}},"S18":{"type":"structure","required":["Name"],"members":{"Name":{},"Enabled":{"type":"boolean"},"TlsPolicy":{},"Recipients":{"type":"list","member":{}},"Actions":{"type":"list","member":{"type":"structure","members":{"S3Action":{"type":"structure","required":["BucketName"],"members":{"TopicArn":{},"BucketName":{},"ObjectKeyPrefix":{},"KmsKeyArn":{}}},"BounceAction":{"type":"structure","required":["SmtpReplyCode","Message","Sender"],"members":{"TopicArn":{},"SmtpReplyCode":{},"StatusCode":{},"Message":{},"Sender":{}}},"WorkmailAction":{"type":"structure","required":["OrganizationArn"],"members":{"TopicArn":{},"OrganizationArn":{}}},"LambdaAction":{"type":"structure","required":["FunctionArn"],"members":{"TopicArn":{},"FunctionArn":{},"InvocationType":{}}},"StopAction":{"type":"structure","required":["Scope"],"members":{"Scope":{},"TopicArn":{}}},"AddHeaderAction":{"type":"structure","required":["HeaderName","HeaderValue"],"members":{"HeaderName":{},"HeaderValue":{}}},"SNSAction":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"Encoding":{}}}}}},"ScanEnabled":{"type":"boolean"}}},"S20":{"type":"structure","required":["TemplateName"],"members":{"TemplateName":{},"SubjectPart":{},"TextPart":{},"HtmlPart":{}}},"S2t":{"type":"structure","members":{"Name":{},"CreatedTimestamp":{"type":"timestamp"}}},"S2v":{"type":"list","member":{"shape":"S18"}},"S31":{"type":"structure","members":{"TlsPolicy":{}}},"S3c":{"type":"list","member":{}},"S3h":{"type":"list","member":{}},"S3w":{"type":"list","member":{}},"S54":{"type":"list","member":{}},"S5i":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S5x":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S64":{"type":"structure","members":{"ToAddresses":{"shape":"S54"},"CcAddresses":{"shape":"S54"},"BccAddresses":{"shape":"S54"}}},"S6e":{"type":"structure","required":["Data"],"members":{"Data":{},"Charset":{}}}}}

/***/ }),
/* 505 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCustomVerificationEmailTemplates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListIdentities":{"input_token":"NextToken","limit_key":"MaxItems","output_token":"NextToken","result_key":"Identities"},"ListVerifiedEmailAddresses":{"result_key":"VerifiedEmailAddresses"}}}

/***/ }),
/* 506 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"IdentityExists":{"delay":3,"operation":"GetIdentityVerificationAttributes","maxAttempts":20,"acceptors":[{"expected":"Success","matcher":"pathAll","state":"success","argument":"VerificationAttributes.*.VerificationStatus"}]}}}

/***/ }),
/* 507 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-07","endpointPrefix":"events","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Events","serviceId":"CloudWatch Events","signatureVersion":"v4","targetPrefix":"AWSEvents","uid":"events-2015-10-07"},"operations":{"ActivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"CancelReplay":{"input":{"type":"structure","required":["ReplayName"],"members":{"ReplayName":{}}},"output":{"type":"structure","members":{"ReplayArn":{},"State":{},"StateReason":{}}}},"CreateApiDestination":{"input":{"type":"structure","required":["Name","ConnectionArn","InvocationEndpoint","HttpMethod"],"members":{"Name":{},"Description":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"ApiDestinationState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"CreateArchive":{"input":{"type":"structure","required":["ArchiveName","EventSourceArn"],"members":{"ArchiveName":{},"EventSourceArn":{},"Description":{},"EventPattern":{},"RetentionDays":{"type":"integer"}}},"output":{"type":"structure","members":{"ArchiveArn":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"}}}},"CreateConnection":{"input":{"type":"structure","required":["Name","AuthorizationType","AuthParameters"],"members":{"Name":{},"Description":{},"AuthorizationType":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{"shape":"S11"}}},"OAuthParameters":{"type":"structure","required":["ClientParameters","AuthorizationEndpoint","HttpMethod"],"members":{"ClientParameters":{"type":"structure","required":["ClientID","ClientSecret"],"members":{"ClientID":{},"ClientSecret":{"shape":"S11"}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S15"}}},"ApiKeyAuthParameters":{"type":"structure","required":["ApiKeyName","ApiKeyValue"],"members":{"ApiKeyName":{},"ApiKeyValue":{"shape":"S11"}}},"InvocationHttpParameters":{"shape":"S15"}}}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"CreateEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventSourceName":{},"Tags":{"shape":"S1o"}}},"output":{"type":"structure","members":{"EventBusArn":{}}}},"CreatePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}},"output":{"type":"structure","members":{"EventSourceArn":{}}}},"DeactivateEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeauthorizeConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DeleteApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{}}},"output":{"type":"structure","members":{}}},"DeleteConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DeleteEventBus":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeletePartnerEventSource":{"input":{"type":"structure","required":["Name","Account"],"members":{"Name":{},"Account":{}}}},"DeleteRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{},"Force":{"type":"boolean"}}}},"DescribeApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"Name":{},"Description":{},"ApiDestinationState":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"DescribeArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{}}},"output":{"type":"structure","members":{"ArchiveArn":{},"ArchiveName":{},"EventSourceArn":{},"Description":{},"EventPattern":{},"State":{},"StateReason":{},"RetentionDays":{"type":"integer"},"SizeBytes":{"type":"long"},"EventCount":{"type":"long"},"CreationTime":{"type":"timestamp"}}}},"DescribeConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ConnectionArn":{},"Name":{},"Description":{},"ConnectionState":{},"StateReason":{},"AuthorizationType":{},"SecretArn":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","members":{"Username":{}}},"OAuthParameters":{"type":"structure","members":{"ClientParameters":{"type":"structure","members":{"ClientID":{}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S15"}}},"ApiKeyAuthParameters":{"type":"structure","members":{"ApiKeyName":{}}},"InvocationHttpParameters":{"shape":"S15"}}},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"DescribeEventBus":{"input":{"type":"structure","members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"DescribeEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"DescribePartnerEventSource":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Arn":{},"Name":{}}}},"DescribeReplay":{"input":{"type":"structure","required":["ReplayName"],"members":{"ReplayName":{}}},"output":{"type":"structure","members":{"ReplayName":{},"ReplayArn":{},"Description":{},"State":{},"StateReason":{},"EventSourceArn":{},"Destination":{"shape":"S2y"},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"EventLastReplayedTime":{"type":"timestamp"},"ReplayStartTime":{"type":"timestamp"},"ReplayEndTime":{"type":"timestamp"}}}},"DescribeRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}},"output":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"ScheduleExpression":{},"State":{},"Description":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{},"CreatedBy":{}}}},"DisableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"EnableRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"EventBusName":{}}}},"ListApiDestinations":{"input":{"type":"structure","members":{"NamePrefix":{},"ConnectionArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinations":{"type":"list","member":{"type":"structure","members":{"ApiDestinationArn":{},"Name":{},"ApiDestinationState":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListArchives":{"input":{"type":"structure","members":{"NamePrefix":{},"EventSourceArn":{},"State":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Archives":{"type":"list","member":{"type":"structure","members":{"ArchiveName":{},"EventSourceArn":{},"State":{},"StateReason":{},"RetentionDays":{"type":"integer"},"SizeBytes":{"type":"long"},"EventCount":{"type":"long"},"CreationTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListConnections":{"input":{"type":"structure","members":{"NamePrefix":{},"ConnectionState":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Connections":{"type":"list","member":{"type":"structure","members":{"ConnectionArn":{},"Name":{},"ConnectionState":{},"StateReason":{},"AuthorizationType":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListEventBuses":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventBuses":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Policy":{}}}},"NextToken":{}}}},"ListEventSources":{"input":{"type":"structure","members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"EventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreatedBy":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"Name":{},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSourceAccounts":{"input":{"type":"structure","required":["EventSourceName"],"members":{"EventSourceName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSourceAccounts":{"type":"list","member":{"type":"structure","members":{"Account":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"},"State":{}}}},"NextToken":{}}}},"ListPartnerEventSources":{"input":{"type":"structure","required":["NamePrefix"],"members":{"NamePrefix":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PartnerEventSources":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Name":{}}}},"NextToken":{}}}},"ListReplays":{"input":{"type":"structure","members":{"NamePrefix":{},"State":{},"EventSourceArn":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Replays":{"type":"list","member":{"type":"structure","members":{"ReplayName":{},"EventSourceArn":{},"State":{},"StateReason":{},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"EventLastReplayedTime":{"type":"timestamp"},"ReplayStartTime":{"type":"timestamp"},"ReplayEndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"ListRuleNamesByTarget":{"input":{"type":"structure","required":["TargetArn"],"members":{"TargetArn":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"RuleNames":{"type":"list","member":{}},"NextToken":{}}}},"ListRules":{"input":{"type":"structure","members":{"NamePrefix":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Rules":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"EventPattern":{},"State":{},"Description":{},"ScheduleExpression":{},"RoleArn":{},"ManagedBy":{},"EventBusName":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1o"}}}},"ListTargetsByRule":{"input":{"type":"structure","required":["Rule"],"members":{"Rule":{},"EventBusName":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Targets":{"shape":"S4n"},"NextToken":{}}}},"PutEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S6n"},"DetailType":{},"Detail":{},"EventBusName":{},"TraceHeader":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPartnerEvents":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","members":{"Time":{"type":"timestamp"},"Source":{},"Resources":{"shape":"S6n"},"DetailType":{},"Detail":{}}}}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"Entries":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"PutPermission":{"input":{"type":"structure","members":{"EventBusName":{},"Action":{},"Principal":{},"StatementId":{},"Condition":{"type":"structure","required":["Type","Key","Value"],"members":{"Type":{},"Key":{},"Value":{}}},"Policy":{}}}},"PutRule":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ScheduleExpression":{},"EventPattern":{},"State":{},"Description":{},"RoleArn":{},"Tags":{"shape":"S1o"},"EventBusName":{}}},"output":{"type":"structure","members":{"RuleArn":{}}}},"PutTargets":{"input":{"type":"structure","required":["Rule","Targets"],"members":{"Rule":{},"EventBusName":{},"Targets":{"shape":"S4n"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"RemovePermission":{"input":{"type":"structure","members":{"StatementId":{},"RemoveAllPermissions":{"type":"boolean"},"EventBusName":{}}}},"RemoveTargets":{"input":{"type":"structure","required":["Rule","Ids"],"members":{"Rule":{},"EventBusName":{},"Ids":{"type":"list","member":{}},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{"FailedEntryCount":{"type":"integer"},"FailedEntries":{"type":"list","member":{"type":"structure","members":{"TargetId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"StartReplay":{"input":{"type":"structure","required":["ReplayName","EventSourceArn","EventStartTime","EventEndTime","Destination"],"members":{"ReplayName":{},"Description":{},"EventSourceArn":{},"EventStartTime":{"type":"timestamp"},"EventEndTime":{"type":"timestamp"},"Destination":{"shape":"S2y"}}},"output":{"type":"structure","members":{"ReplayArn":{},"State":{},"StateReason":{},"ReplayStartTime":{"type":"timestamp"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S1o"}}},"output":{"type":"structure","members":{}}},"TestEventPattern":{"input":{"type":"structure","required":["EventPattern","Event"],"members":{"EventPattern":{},"Event":{}}},"output":{"type":"structure","members":{"Result":{"type":"boolean"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateApiDestination":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"ConnectionArn":{},"InvocationEndpoint":{},"HttpMethod":{},"InvocationRateLimitPerSecond":{"type":"integer"}}},"output":{"type":"structure","members":{"ApiDestinationArn":{},"ApiDestinationState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"}}}},"UpdateArchive":{"input":{"type":"structure","required":["ArchiveName"],"members":{"ArchiveName":{},"Description":{},"EventPattern":{},"RetentionDays":{"type":"integer"}}},"output":{"type":"structure","members":{"ArchiveArn":{},"State":{},"StateReason":{},"CreationTime":{"type":"timestamp"}}}},"UpdateConnection":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"AuthorizationType":{},"AuthParameters":{"type":"structure","members":{"BasicAuthParameters":{"type":"structure","members":{"Username":{},"Password":{"shape":"S11"}}},"OAuthParameters":{"type":"structure","members":{"ClientParameters":{"type":"structure","members":{"ClientID":{},"ClientSecret":{"shape":"S11"}}},"AuthorizationEndpoint":{},"HttpMethod":{},"OAuthHttpParameters":{"shape":"S15"}}},"ApiKeyAuthParameters":{"type":"structure","members":{"ApiKeyName":{},"ApiKeyValue":{"shape":"S11"}}},"InvocationHttpParameters":{"shape":"S15"}}}}},"output":{"type":"structure","members":{"ConnectionArn":{},"ConnectionState":{},"CreationTime":{"type":"timestamp"},"LastModifiedTime":{"type":"timestamp"},"LastAuthorizedTime":{"type":"timestamp"}}}}},"shapes":{"S11":{"type":"string","sensitive":true},"S15":{"type":"structure","members":{"HeaderParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{"type":"string","sensitive":true},"IsValueSecret":{"type":"boolean"}}}},"QueryStringParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{"type":"string","sensitive":true},"IsValueSecret":{"type":"boolean"}}}},"BodyParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{"type":"string","sensitive":true},"IsValueSecret":{"type":"boolean"}}}}}},"S1o":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S2y":{"type":"structure","required":["Arn"],"members":{"Arn":{},"FilterArns":{"type":"list","member":{}}}},"S4n":{"type":"list","member":{"type":"structure","required":["Id","Arn"],"members":{"Id":{},"Arn":{},"RoleArn":{},"Input":{},"InputPath":{},"InputTransformer":{"type":"structure","required":["InputTemplate"],"members":{"InputPathsMap":{"type":"map","key":{},"value":{}},"InputTemplate":{}}},"KinesisParameters":{"type":"structure","required":["PartitionKeyPath"],"members":{"PartitionKeyPath":{}}},"RunCommandParameters":{"type":"structure","required":["RunCommandTargets"],"members":{"RunCommandTargets":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"EcsParameters":{"type":"structure","required":["TaskDefinitionArn"],"members":{"TaskDefinitionArn":{},"TaskCount":{"type":"integer"},"LaunchType":{},"NetworkConfiguration":{"type":"structure","members":{"awsvpcConfiguration":{"type":"structure","required":["Subnets"],"members":{"Subnets":{"shape":"S59"},"SecurityGroups":{"shape":"S59"},"AssignPublicIp":{}}}}},"PlatformVersion":{},"Group":{},"CapacityProviderStrategy":{"type":"list","member":{"type":"structure","required":["capacityProvider"],"members":{"capacityProvider":{},"weight":{"type":"integer"},"base":{"type":"integer"}}}},"EnableECSManagedTags":{"type":"boolean"},"EnableExecuteCommand":{"type":"boolean"},"PlacementConstraints":{"type":"list","member":{"type":"structure","members":{"type":{},"expression":{}}}},"PlacementStrategy":{"type":"list","member":{"type":"structure","members":{"type":{},"field":{}}}},"PropagateTags":{},"ReferenceId":{},"Tags":{"shape":"S1o"}}},"BatchParameters":{"type":"structure","required":["JobDefinition","JobName"],"members":{"JobDefinition":{},"JobName":{},"ArrayProperties":{"type":"structure","members":{"Size":{"type":"integer"}}},"RetryStrategy":{"type":"structure","members":{"Attempts":{"type":"integer"}}}}},"SqsParameters":{"type":"structure","members":{"MessageGroupId":{}}},"HttpParameters":{"type":"structure","members":{"PathParameterValues":{"type":"list","member":{}},"HeaderParameters":{"type":"map","key":{},"value":{}},"QueryStringParameters":{"type":"map","key":{},"value":{}}}},"RedshiftDataParameters":{"type":"structure","required":["Database","Sql"],"members":{"SecretManagerArn":{},"Database":{},"DbUser":{},"Sql":{},"StatementName":{},"WithEvent":{"type":"boolean"}}},"SageMakerPipelineParameters":{"type":"structure","members":{"PipelineParameterList":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"DeadLetterConfig":{"type":"structure","members":{"Arn":{}}},"RetryPolicy":{"type":"structure","members":{"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"}}}}}},"S59":{"type":"list","member":{}},"S6n":{"type":"list","member":{}}}}

/***/ }),
/* 508 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 509 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-04","endpointPrefix":"firehose","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Firehose","serviceFullName":"Amazon Kinesis Firehose","serviceId":"Firehose","signatureVersion":"v4","targetPrefix":"Firehose_20150804","uid":"firehose-2015-08-04"},"operations":{"CreateDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamType":{},"KinesisStreamSourceConfiguration":{"type":"structure","required":["KinesisStreamARN","RoleARN"],"members":{"KinesisStreamARN":{},"RoleARN":{}}},"DeliveryStreamEncryptionConfigurationInput":{"shape":"S7"},"S3DestinationConfiguration":{"shape":"Sa","deprecated":true},"ExtendedS3DestinationConfiguration":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"Sa"},"DataFormatConversionConfiguration":{"shape":"Sz"},"DynamicPartitioningConfiguration":{"shape":"S1o"},"FileExtension":{},"CustomTimeZone":{}}},"RedshiftDestinationConfiguration":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","Password","S3Configuration"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1v"},"Username":{"shape":"S1z"},"Password":{"shape":"S20"},"RetryOptions":{"shape":"S21"},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupConfiguration":{"shape":"Sa"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationConfiguration":{"type":"structure","required":["RoleARN","IndexName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2a"},"RetryOptions":{"shape":"S2d"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfiguration":{"shape":"S2g"},"DocumentIdOptions":{"shape":"S2j"}}},"AmazonopensearchserviceDestinationConfiguration":{"type":"structure","required":["RoleARN","IndexName","S3Configuration"],"members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2r"},"RetryOptions":{"shape":"S2u"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfiguration":{"shape":"S2g"},"DocumentIdOptions":{"shape":"S2j"}}},"SplunkDestinationConfiguration":{"type":"structure","required":["HECEndpoint","HECEndpointType","HECToken","S3Configuration"],"members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S32"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"BufferingHints":{"shape":"S35"}}},"HttpEndpointDestinationConfiguration":{"type":"structure","required":["EndpointConfiguration","S3Configuration"],"members":{"EndpointConfiguration":{"shape":"S39"},"BufferingHints":{"shape":"S3d"},"CloudWatchLoggingOptions":{"shape":"Sl"},"RequestConfiguration":{"shape":"S3g"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S3m"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"}}},"Tags":{"shape":"S3p"},"AmazonOpenSearchServerlessDestinationConfiguration":{"type":"structure","required":["RoleARN","IndexName","S3Configuration"],"members":{"RoleARN":{},"CollectionEndpoint":{},"IndexName":{},"BufferingHints":{"shape":"S3w"},"RetryOptions":{"shape":"S3z"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfiguration":{"shape":"S2g"}}},"MSKSourceConfiguration":{"type":"structure","required":["MSKClusterARN","TopicName","AuthenticationConfiguration"],"members":{"MSKClusterARN":{},"TopicName":{},"AuthenticationConfiguration":{"shape":"S45"}}},"SnowflakeDestinationConfiguration":{"type":"structure","required":["AccountUrl","PrivateKey","User","Database","Schema","Table","RoleARN","S3Configuration"],"members":{"AccountUrl":{"shape":"S48"},"PrivateKey":{"shape":"S49"},"KeyPassphrase":{"shape":"S4a"},"User":{"shape":"S4b"},"Database":{"shape":"S4c"},"Schema":{"shape":"S4d"},"Table":{"shape":"S4e"},"SnowflakeRoleConfiguration":{"shape":"S4f"},"DataLoadingOption":{},"MetaDataColumnName":{"shape":"S4i"},"ContentColumnName":{"shape":"S4j"},"SnowflakeVpcConfiguration":{"shape":"S4k"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S4m"},"S3BackupMode":{},"S3Configuration":{"shape":"Sa"}}}}},"output":{"type":"structure","members":{"DeliveryStreamARN":{}}}},"DeleteDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"AllowForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"Limit":{"type":"integer"},"ExclusiveStartDestinationId":{}}},"output":{"type":"structure","required":["DeliveryStreamDescription"],"members":{"DeliveryStreamDescription":{"type":"structure","required":["DeliveryStreamName","DeliveryStreamARN","DeliveryStreamStatus","DeliveryStreamType","VersionId","Destinations","HasMoreDestinations"],"members":{"DeliveryStreamName":{},"DeliveryStreamARN":{},"DeliveryStreamStatus":{},"FailureDescription":{"shape":"S4z"},"DeliveryStreamEncryptionConfiguration":{"type":"structure","members":{"KeyARN":{},"KeyType":{},"Status":{},"FailureDescription":{"shape":"S4z"}}},"DeliveryStreamType":{},"VersionId":{},"CreateTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Source":{"type":"structure","members":{"KinesisStreamSourceDescription":{"type":"structure","members":{"KinesisStreamARN":{},"RoleARN":{},"DeliveryStartTimestamp":{"type":"timestamp"}}},"MSKSourceDescription":{"type":"structure","members":{"MSKClusterARN":{},"TopicName":{},"AuthenticationConfiguration":{"shape":"S45"},"DeliveryStartTimestamp":{"type":"timestamp"}}}}},"Destinations":{"type":"list","member":{"type":"structure","required":["DestinationId"],"members":{"DestinationId":{},"S3DestinationDescription":{"shape":"S5b"},"ExtendedS3DestinationDescription":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S5b"},"DataFormatConversionConfiguration":{"shape":"Sz"},"DynamicPartitioningConfiguration":{"shape":"S1o"},"FileExtension":{},"CustomTimeZone":{}}},"RedshiftDestinationDescription":{"type":"structure","required":["RoleARN","ClusterJDBCURL","CopyCommand","Username","S3DestinationDescription"],"members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1v"},"Username":{"shape":"S1z"},"RetryOptions":{"shape":"S21"},"S3DestinationDescription":{"shape":"S5b"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupDescription":{"shape":"S5b"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2a"},"RetryOptions":{"shape":"S2d"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S5b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfigurationDescription":{"shape":"S5f"},"DocumentIdOptions":{"shape":"S2j"}}},"AmazonopensearchserviceDestinationDescription":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2r"},"RetryOptions":{"shape":"S2u"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S5b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfigurationDescription":{"shape":"S5f"},"DocumentIdOptions":{"shape":"S2j"}}},"SplunkDestinationDescription":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S32"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S5b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"BufferingHints":{"shape":"S35"}}},"HttpEndpointDestinationDescription":{"type":"structure","members":{"EndpointConfiguration":{"type":"structure","members":{"Url":{"shape":"S3a"},"Name":{}}},"BufferingHints":{"shape":"S3d"},"CloudWatchLoggingOptions":{"shape":"Sl"},"RequestConfiguration":{"shape":"S3g"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S3m"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S5b"}}},"SnowflakeDestinationDescription":{"type":"structure","members":{"AccountUrl":{"shape":"S48"},"User":{"shape":"S4b"},"Database":{"shape":"S4c"},"Schema":{"shape":"S4d"},"Table":{"shape":"S4e"},"SnowflakeRoleConfiguration":{"shape":"S4f"},"DataLoadingOption":{},"MetaDataColumnName":{"shape":"S4i"},"ContentColumnName":{"shape":"S4j"},"SnowflakeVpcConfiguration":{"shape":"S4k"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S4m"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S5b"}}},"AmazonOpenSearchServerlessDestinationDescription":{"type":"structure","members":{"RoleARN":{},"CollectionEndpoint":{},"IndexName":{},"BufferingHints":{"shape":"S3w"},"RetryOptions":{"shape":"S3z"},"S3BackupMode":{},"S3DestinationDescription":{"shape":"S5b"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"VpcConfigurationDescription":{"shape":"S5f"}}}}}},"HasMoreDestinations":{"type":"boolean"}}}}}},"ListDeliveryStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"DeliveryStreamType":{},"ExclusiveStartDeliveryStreamName":{}}},"output":{"type":"structure","required":["DeliveryStreamNames","HasMoreDeliveryStreams"],"members":{"DeliveryStreamNames":{"type":"list","member":{}},"HasMoreDeliveryStreams":{"type":"boolean"}}}},"ListTagsForDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"shape":"S3q"}},"HasMoreTags":{"type":"boolean"}}}},"PutRecord":{"input":{"type":"structure","required":["DeliveryStreamName","Record"],"members":{"DeliveryStreamName":{},"Record":{"shape":"S5v"}}},"output":{"type":"structure","required":["RecordId"],"members":{"RecordId":{},"Encrypted":{"type":"boolean"}}}},"PutRecordBatch":{"input":{"type":"structure","required":["DeliveryStreamName","Records"],"members":{"DeliveryStreamName":{},"Records":{"type":"list","member":{"shape":"S5v"}}}},"output":{"type":"structure","required":["FailedPutCount","RequestResponses"],"members":{"FailedPutCount":{"type":"integer"},"Encrypted":{"type":"boolean"},"RequestResponses":{"type":"list","member":{"type":"structure","members":{"RecordId":{},"ErrorCode":{},"ErrorMessage":{}}}}}}},"StartDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{},"DeliveryStreamEncryptionConfigurationInput":{"shape":"S7"}}},"output":{"type":"structure","members":{}}},"StopDeliveryStreamEncryption":{"input":{"type":"structure","required":["DeliveryStreamName"],"members":{"DeliveryStreamName":{}}},"output":{"type":"structure","members":{}}},"TagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","Tags"],"members":{"DeliveryStreamName":{},"Tags":{"shape":"S3p"}}},"output":{"type":"structure","members":{}}},"UntagDeliveryStream":{"input":{"type":"structure","required":["DeliveryStreamName","TagKeys"],"members":{"DeliveryStreamName":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDestination":{"input":{"type":"structure","required":["DeliveryStreamName","CurrentDeliveryStreamVersionId","DestinationId"],"members":{"DeliveryStreamName":{},"CurrentDeliveryStreamVersionId":{},"DestinationId":{},"S3DestinationUpdate":{"shape":"S6g","deprecated":true},"ExtendedS3DestinationUpdate":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S6g"},"DataFormatConversionConfiguration":{"shape":"Sz"},"DynamicPartitioningConfiguration":{"shape":"S1o"},"FileExtension":{},"CustomTimeZone":{}}},"RedshiftDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"ClusterJDBCURL":{},"CopyCommand":{"shape":"S1v"},"Username":{"shape":"S1z"},"Password":{"shape":"S20"},"RetryOptions":{"shape":"S21"},"S3Update":{"shape":"S6g"},"ProcessingConfiguration":{"shape":"Sq"},"S3BackupMode":{},"S3BackupUpdate":{"shape":"S6g"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"ElasticsearchDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2a"},"RetryOptions":{"shape":"S2d"},"S3Update":{"shape":"S6g"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"DocumentIdOptions":{"shape":"S2j"}}},"AmazonopensearchserviceDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"DomainARN":{},"ClusterEndpoint":{},"IndexName":{},"TypeName":{},"IndexRotationPeriod":{},"BufferingHints":{"shape":"S2r"},"RetryOptions":{"shape":"S2u"},"S3Update":{"shape":"S6g"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"DocumentIdOptions":{"shape":"S2j"}}},"SplunkDestinationUpdate":{"type":"structure","members":{"HECEndpoint":{},"HECEndpointType":{},"HECToken":{},"HECAcknowledgmentTimeoutInSeconds":{"type":"integer"},"RetryOptions":{"shape":"S32"},"S3BackupMode":{},"S3Update":{"shape":"S6g"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"},"BufferingHints":{"shape":"S35"}}},"HttpEndpointDestinationUpdate":{"type":"structure","members":{"EndpointConfiguration":{"shape":"S39"},"BufferingHints":{"shape":"S3d"},"CloudWatchLoggingOptions":{"shape":"Sl"},"RequestConfiguration":{"shape":"S3g"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S3m"},"S3BackupMode":{},"S3Update":{"shape":"S6g"}}},"AmazonOpenSearchServerlessDestinationUpdate":{"type":"structure","members":{"RoleARN":{},"CollectionEndpoint":{},"IndexName":{},"BufferingHints":{"shape":"S3w"},"RetryOptions":{"shape":"S3z"},"S3Update":{"shape":"S6g"},"ProcessingConfiguration":{"shape":"Sq"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"SnowflakeDestinationUpdate":{"type":"structure","members":{"AccountUrl":{"shape":"S48"},"PrivateKey":{"shape":"S49"},"KeyPassphrase":{"shape":"S4a"},"User":{"shape":"S4b"},"Database":{"shape":"S4c"},"Schema":{"shape":"S4d"},"Table":{"shape":"S4e"},"SnowflakeRoleConfiguration":{"shape":"S4f"},"DataLoadingOption":{},"MetaDataColumnName":{"shape":"S4i"},"ContentColumnName":{"shape":"S4j"},"CloudWatchLoggingOptions":{"shape":"Sl"},"ProcessingConfiguration":{"shape":"Sq"},"RoleARN":{},"RetryOptions":{"shape":"S4m"},"S3BackupMode":{},"S3Update":{"shape":"S6g"}}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S7":{"type":"structure","required":["KeyType"],"members":{"KeyARN":{},"KeyType":{}}},"Sa":{"type":"structure","required":["RoleARN","BucketARN"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"Se":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"Si":{"type":"structure","members":{"NoEncryptionConfig":{},"KMSEncryptionConfig":{"type":"structure","required":["AWSKMSKeyARN"],"members":{"AWSKMSKeyARN":{}}}}},"Sl":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogGroupName":{},"LogStreamName":{}}},"Sq":{"type":"structure","members":{"Enabled":{"type":"boolean"},"Processors":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["ParameterName","ParameterValue"],"members":{"ParameterName":{},"ParameterValue":{}}}}}}}}},"Sz":{"type":"structure","members":{"SchemaConfiguration":{"type":"structure","members":{"RoleARN":{},"CatalogId":{},"DatabaseName":{},"TableName":{},"Region":{},"VersionId":{}}},"InputFormatConfiguration":{"type":"structure","members":{"Deserializer":{"type":"structure","members":{"OpenXJsonSerDe":{"type":"structure","members":{"ConvertDotsInJsonKeysToUnderscores":{"type":"boolean"},"CaseInsensitive":{"type":"boolean"},"ColumnToJsonKeyMappings":{"type":"map","key":{},"value":{}}}},"HiveJsonSerDe":{"type":"structure","members":{"TimestampFormats":{"type":"list","member":{}}}}}}}},"OutputFormatConfiguration":{"type":"structure","members":{"Serializer":{"type":"structure","members":{"ParquetSerDe":{"type":"structure","members":{"BlockSizeBytes":{"type":"integer"},"PageSizeBytes":{"type":"integer"},"Compression":{},"EnableDictionaryCompression":{"type":"boolean"},"MaxPaddingBytes":{"type":"integer"},"WriterVersion":{}}},"OrcSerDe":{"type":"structure","members":{"StripeSizeBytes":{"type":"integer"},"BlockSizeBytes":{"type":"integer"},"RowIndexStride":{"type":"integer"},"EnablePadding":{"type":"boolean"},"PaddingTolerance":{"type":"double"},"Compression":{},"BloomFilterColumns":{"type":"list","member":{}},"BloomFilterFalsePositiveProbability":{"type":"double"},"DictionaryKeyThreshold":{"type":"double"},"FormatVersion":{}}}}}}},"Enabled":{"type":"boolean"}}},"S1o":{"type":"structure","members":{"RetryOptions":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"Enabled":{"type":"boolean"}}},"S1v":{"type":"structure","required":["DataTableName"],"members":{"DataTableName":{},"DataTableColumns":{},"CopyOptions":{}}},"S1z":{"type":"string","sensitive":true},"S20":{"type":"string","sensitive":true},"S21":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2a":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S2d":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S2g":{"type":"structure","required":["SubnetIds","RoleARN","SecurityGroupIds"],"members":{"SubnetIds":{"shape":"S2h"},"RoleARN":{},"SecurityGroupIds":{"shape":"S2i"}}},"S2h":{"type":"list","member":{}},"S2i":{"type":"list","member":{}},"S2j":{"type":"structure","required":["DefaultDocumentIdFormat"],"members":{"DefaultDocumentIdFormat":{}}},"S2r":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S2u":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S32":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S35":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S39":{"type":"structure","required":["Url"],"members":{"Url":{"shape":"S3a"},"Name":{},"AccessKey":{"type":"string","sensitive":true}}},"S3a":{"type":"string","sensitive":true},"S3d":{"type":"structure","members":{"SizeInMBs":{"type":"integer"},"IntervalInSeconds":{"type":"integer"}}},"S3g":{"type":"structure","members":{"ContentEncoding":{},"CommonAttributes":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeValue"],"members":{"AttributeName":{"type":"string","sensitive":true},"AttributeValue":{"type":"string","sensitive":true}}}}}},"S3m":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S3p":{"type":"list","member":{"shape":"S3q"}},"S3q":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}},"S3w":{"type":"structure","members":{"IntervalInSeconds":{"type":"integer"},"SizeInMBs":{"type":"integer"}}},"S3z":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S45":{"type":"structure","required":["RoleARN","Connectivity"],"members":{"RoleARN":{},"Connectivity":{}}},"S48":{"type":"string","sensitive":true},"S49":{"type":"string","sensitive":true},"S4a":{"type":"string","sensitive":true},"S4b":{"type":"string","sensitive":true},"S4c":{"type":"string","sensitive":true},"S4d":{"type":"string","sensitive":true},"S4e":{"type":"string","sensitive":true},"S4f":{"type":"structure","members":{"Enabled":{"type":"boolean"},"SnowflakeRole":{"type":"string","sensitive":true}}},"S4i":{"type":"string","sensitive":true},"S4j":{"type":"string","sensitive":true},"S4k":{"type":"structure","required":["PrivateLinkVpceId"],"members":{"PrivateLinkVpceId":{"type":"string","sensitive":true}}},"S4m":{"type":"structure","members":{"DurationInSeconds":{"type":"integer"}}},"S4z":{"type":"structure","required":["Type","Details"],"members":{"Type":{},"Details":{}}},"S5b":{"type":"structure","required":["RoleARN","BucketARN","BufferingHints","CompressionFormat","EncryptionConfiguration"],"members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}},"S5f":{"type":"structure","required":["SubnetIds","RoleARN","SecurityGroupIds","VpcId"],"members":{"SubnetIds":{"shape":"S2h"},"RoleARN":{},"SecurityGroupIds":{"shape":"S2i"},"VpcId":{}}},"S5v":{"type":"structure","required":["Data"],"members":{"Data":{"type":"blob"}}},"S6g":{"type":"structure","members":{"RoleARN":{},"BucketARN":{},"Prefix":{},"ErrorOutputPrefix":{},"BufferingHints":{"shape":"Se"},"CompressionFormat":{},"EncryptionConfiguration":{"shape":"Si"},"CloudWatchLoggingOptions":{"shape":"Sl"}}}}}

/***/ }),
/* 510 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 511 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecast","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Service","serviceId":"forecast","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecast","uid":"forecast-2018-06-26"},"operations":{"CreateAutoPredictor":{"input":{"type":"structure","required":["PredictorName"],"members":{"PredictorName":{},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"ForecastDimensions":{"shape":"S6"},"ForecastFrequency":{},"DataConfig":{"shape":"S8"},"EncryptionConfig":{"shape":"Si"},"ReferencePredictorArn":{},"OptimizationMetric":{},"ExplainPredictor":{"type":"boolean"},"Tags":{"shape":"Sm"},"MonitorConfig":{"type":"structure","required":["MonitorName"],"members":{"MonitorName":{}}},"TimeAlignmentBoundary":{"shape":"Sr"}}},"output":{"type":"structure","members":{"PredictorArn":{}}}},"CreateDataset":{"input":{"type":"structure","required":["DatasetName","Domain","DatasetType","Schema"],"members":{"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"S10"},"EncryptionConfig":{"shape":"Si"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"DatasetArn":{}}}},"CreateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupName","Domain"],"members":{"DatasetGroupName":{},"Domain":{},"DatasetArns":{"shape":"S16"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"DatasetGroupArn":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobName","DatasetArn","DataSource"],"members":{"DatasetImportJobName":{},"DatasetArn":{},"DataSource":{"shape":"S19"},"TimestampFormat":{},"TimeZone":{},"UseGeolocationForTimeZone":{"type":"boolean"},"GeolocationFormat":{},"Tags":{"shape":"Sm"},"Format":{},"ImportMode":{}}},"output":{"type":"structure","members":{"DatasetImportJobArn":{}}}},"CreateExplainability":{"input":{"type":"structure","required":["ExplainabilityName","ResourceArn","ExplainabilityConfig"],"members":{"ExplainabilityName":{},"ResourceArn":{},"ExplainabilityConfig":{"shape":"S1k"},"DataSource":{"shape":"S19"},"Schema":{"shape":"S10"},"EnableVisualization":{"type":"boolean"},"StartDateTime":{},"EndDateTime":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"ExplainabilityArn":{}}}},"CreateExplainabilityExport":{"input":{"type":"structure","required":["ExplainabilityExportName","ExplainabilityArn","Destination"],"members":{"ExplainabilityExportName":{},"ExplainabilityArn":{},"Destination":{"shape":"S1q"},"Tags":{"shape":"Sm"},"Format":{}}},"output":{"type":"structure","members":{"ExplainabilityExportArn":{}}}},"CreateForecast":{"input":{"type":"structure","required":["ForecastName","PredictorArn"],"members":{"ForecastName":{},"PredictorArn":{},"ForecastTypes":{"shape":"S4"},"Tags":{"shape":"Sm"},"TimeSeriesSelector":{"shape":"S1t"}}},"output":{"type":"structure","members":{"ForecastArn":{}}}},"CreateForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobName","ForecastArn","Destination"],"members":{"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"S1q"},"Tags":{"shape":"Sm"},"Format":{}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{}}}},"CreateMonitor":{"input":{"type":"structure","required":["MonitorName","ResourceArn"],"members":{"MonitorName":{},"ResourceArn":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"MonitorArn":{}}}},"CreatePredictor":{"input":{"type":"structure","required":["PredictorName","ForecastHorizon","InputDataConfig","FeaturizationConfig"],"members":{"PredictorName":{},"AlgorithmArn":{},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"PerformAutoML":{"type":"boolean"},"AutoMLOverrideStrategy":{},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"S22"},"EvaluationParameters":{"shape":"S25"},"HPOConfig":{"shape":"S26"},"InputDataConfig":{"shape":"S2g"},"FeaturizationConfig":{"shape":"S2j"},"EncryptionConfig":{"shape":"Si"},"Tags":{"shape":"Sm"},"OptimizationMetric":{}}},"output":{"type":"structure","members":{"PredictorArn":{}}}},"CreatePredictorBacktestExportJob":{"input":{"type":"structure","required":["PredictorBacktestExportJobName","PredictorArn","Destination"],"members":{"PredictorBacktestExportJobName":{},"PredictorArn":{},"Destination":{"shape":"S1q"},"Tags":{"shape":"Sm"},"Format":{}}},"output":{"type":"structure","members":{"PredictorBacktestExportJobArn":{}}}},"CreateWhatIfAnalysis":{"input":{"type":"structure","required":["WhatIfAnalysisName","ForecastArn"],"members":{"WhatIfAnalysisName":{},"ForecastArn":{},"TimeSeriesSelector":{"shape":"S1t"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"WhatIfAnalysisArn":{}}}},"CreateWhatIfForecast":{"input":{"type":"structure","required":["WhatIfForecastName","WhatIfAnalysisArn"],"members":{"WhatIfForecastName":{},"WhatIfAnalysisArn":{},"TimeSeriesTransformations":{"shape":"S2w"},"TimeSeriesReplacementsDataSource":{"shape":"S34"},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"WhatIfForecastArn":{}}}},"CreateWhatIfForecastExport":{"input":{"type":"structure","required":["WhatIfForecastExportName","WhatIfForecastArns","Destination"],"members":{"WhatIfForecastExportName":{},"WhatIfForecastArns":{"shape":"S38"},"Destination":{"shape":"S1q"},"Tags":{"shape":"Sm"},"Format":{}}},"output":{"type":"structure","members":{"WhatIfForecastExportArn":{}}}},"DeleteDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"idempotent":true},"DeleteDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"idempotent":true},"DeleteExplainability":{"input":{"type":"structure","required":["ExplainabilityArn"],"members":{"ExplainabilityArn":{}}},"idempotent":true},"DeleteExplainabilityExport":{"input":{"type":"structure","required":["ExplainabilityExportArn"],"members":{"ExplainabilityExportArn":{}}},"idempotent":true},"DeleteForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"idempotent":true},"DeleteForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"idempotent":true},"DeleteMonitor":{"input":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}},"idempotent":true},"DeletePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"idempotent":true},"DeletePredictorBacktestExportJob":{"input":{"type":"structure","required":["PredictorBacktestExportJobArn"],"members":{"PredictorBacktestExportJobArn":{}}},"idempotent":true},"DeleteResourceTree":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"idempotent":true},"DeleteWhatIfAnalysis":{"input":{"type":"structure","required":["WhatIfAnalysisArn"],"members":{"WhatIfAnalysisArn":{}}},"idempotent":true},"DeleteWhatIfForecast":{"input":{"type":"structure","required":["WhatIfForecastArn"],"members":{"WhatIfForecastArn":{}}},"idempotent":true},"DeleteWhatIfForecastExport":{"input":{"type":"structure","required":["WhatIfForecastExportArn"],"members":{"WhatIfForecastExportArn":{}}},"idempotent":true},"DescribeAutoPredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"ForecastFrequency":{},"ForecastDimensions":{"shape":"S6"},"DatasetImportJobArns":{"shape":"S16"},"DataConfig":{"shape":"S8"},"EncryptionConfig":{"shape":"Si"},"ReferencePredictorSummary":{"shape":"S3q"},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"OptimizationMetric":{},"ExplainabilityInfo":{"type":"structure","members":{"ExplainabilityArn":{},"Status":{}}},"MonitorInfo":{"type":"structure","members":{"MonitorArn":{},"Status":{}}},"TimeAlignmentBoundary":{"shape":"Sr"}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"Domain":{},"DatasetType":{},"DataFrequency":{},"Schema":{"shape":"S10"},"EncryptionConfig":{"shape":"Si"},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{}}},"output":{"type":"structure","members":{"DatasetGroupName":{},"DatasetGroupArn":{},"DatasetArns":{"shape":"S16"},"Domain":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["DatasetImportJobArn"],"members":{"DatasetImportJobArn":{}}},"output":{"type":"structure","members":{"DatasetImportJobName":{},"DatasetImportJobArn":{},"DatasetArn":{},"TimestampFormat":{},"TimeZone":{},"UseGeolocationForTimeZone":{"type":"boolean"},"GeolocationFormat":{},"DataSource":{"shape":"S19"},"EstimatedTimeRemainingInMinutes":{"type":"long"},"FieldStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"Count":{"type":"integer"},"CountDistinct":{"type":"integer"},"CountNull":{"type":"integer"},"CountNan":{"type":"integer"},"Min":{},"Max":{},"Avg":{"type":"double"},"Stddev":{"type":"double"},"CountLong":{"type":"long"},"CountDistinctLong":{"type":"long"},"CountNullLong":{"type":"long"},"CountNanLong":{"type":"long"}}}},"DataSize":{"type":"double"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Format":{},"ImportMode":{}}},"idempotent":true},"DescribeExplainability":{"input":{"type":"structure","required":["ExplainabilityArn"],"members":{"ExplainabilityArn":{}}},"output":{"type":"structure","members":{"ExplainabilityArn":{},"ExplainabilityName":{},"ResourceArn":{},"ExplainabilityConfig":{"shape":"S1k"},"EnableVisualization":{"type":"boolean"},"DataSource":{"shape":"S19"},"Schema":{"shape":"S10"},"StartDateTime":{},"EndDateTime":{},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}},"idempotent":true},"DescribeExplainabilityExport":{"input":{"type":"structure","required":["ExplainabilityExportArn"],"members":{"ExplainabilityExportArn":{}}},"output":{"type":"structure","members":{"ExplainabilityExportArn":{},"ExplainabilityExportName":{},"ExplainabilityArn":{},"Destination":{"shape":"S1q"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Format":{}}},"idempotent":true},"DescribeForecast":{"input":{"type":"structure","required":["ForecastArn"],"members":{"ForecastArn":{}}},"output":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"ForecastTypes":{"shape":"S4"},"PredictorArn":{},"DatasetGroupArn":{},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"TimeSeriesSelector":{"shape":"S1t"}}},"idempotent":true},"DescribeForecastExportJob":{"input":{"type":"structure","required":["ForecastExportJobArn"],"members":{"ForecastExportJobArn":{}}},"output":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"ForecastArn":{},"Destination":{"shape":"S1q"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Format":{}}},"idempotent":true},"DescribeMonitor":{"input":{"type":"structure","required":["MonitorArn"],"members":{"MonitorArn":{}}},"output":{"type":"structure","members":{"MonitorName":{},"MonitorArn":{},"ResourceArn":{},"Status":{},"LastEvaluationTime":{"type":"timestamp"},"LastEvaluationState":{},"Baseline":{"type":"structure","members":{"PredictorBaseline":{"type":"structure","members":{"BaselineMetrics":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{"type":"double"}}}}}}}},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"EstimatedEvaluationTimeRemainingInMinutes":{"type":"long"}}},"idempotent":true},"DescribePredictor":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"AlgorithmArn":{},"AutoMLAlgorithmArns":{"shape":"S16"},"ForecastHorizon":{"type":"integer"},"ForecastTypes":{"shape":"S4"},"PerformAutoML":{"type":"boolean"},"AutoMLOverrideStrategy":{},"PerformHPO":{"type":"boolean"},"TrainingParameters":{"shape":"S22"},"EvaluationParameters":{"shape":"S25"},"HPOConfig":{"shape":"S26"},"InputDataConfig":{"shape":"S2g"},"FeaturizationConfig":{"shape":"S2j"},"EncryptionConfig":{"shape":"Si"},"PredictorExecutionDetails":{"type":"structure","members":{"PredictorExecutions":{"type":"list","member":{"type":"structure","members":{"AlgorithmArn":{},"TestWindows":{"type":"list","member":{"type":"structure","members":{"TestWindowStart":{"type":"timestamp"},"TestWindowEnd":{"type":"timestamp"},"Status":{},"Message":{}}}}}}}}},"EstimatedTimeRemainingInMinutes":{"type":"long"},"IsAutoPredictor":{"type":"boolean"},"DatasetImportJobArns":{"shape":"S16"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"OptimizationMetric":{}}},"idempotent":true},"DescribePredictorBacktestExportJob":{"input":{"type":"structure","required":["PredictorBacktestExportJobArn"],"members":{"PredictorBacktestExportJobArn":{}}},"output":{"type":"structure","members":{"PredictorBacktestExportJobArn":{},"PredictorBacktestExportJobName":{},"PredictorArn":{},"Destination":{"shape":"S1q"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"Format":{}}},"idempotent":true},"DescribeWhatIfAnalysis":{"input":{"type":"structure","required":["WhatIfAnalysisArn"],"members":{"WhatIfAnalysisArn":{}}},"output":{"type":"structure","members":{"WhatIfAnalysisName":{},"WhatIfAnalysisArn":{},"ForecastArn":{},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"TimeSeriesSelector":{"shape":"S1t"}}},"idempotent":true},"DescribeWhatIfForecast":{"input":{"type":"structure","required":["WhatIfForecastArn"],"members":{"WhatIfForecastArn":{}}},"output":{"type":"structure","members":{"WhatIfForecastName":{},"WhatIfForecastArn":{},"WhatIfAnalysisArn":{},"EstimatedTimeRemainingInMinutes":{"type":"long"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"TimeSeriesTransformations":{"shape":"S2w"},"TimeSeriesReplacementsDataSource":{"shape":"S34"},"ForecastTypes":{"shape":"S4"}}},"idempotent":true},"DescribeWhatIfForecastExport":{"input":{"type":"structure","required":["WhatIfForecastExportArn"],"members":{"WhatIfForecastExportArn":{}}},"output":{"type":"structure","members":{"WhatIfForecastExportArn":{},"WhatIfForecastExportName":{},"WhatIfForecastArns":{"type":"list","member":{}},"Destination":{"shape":"S1q"},"Message":{},"Status":{},"CreationTime":{"type":"timestamp"},"EstimatedTimeRemainingInMinutes":{"type":"long"},"LastModificationTime":{"type":"timestamp"},"Format":{}}},"idempotent":true},"GetAccuracyMetrics":{"input":{"type":"structure","required":["PredictorArn"],"members":{"PredictorArn":{}}},"output":{"type":"structure","members":{"PredictorEvaluationResults":{"type":"list","member":{"type":"structure","members":{"AlgorithmArn":{},"TestWindows":{"type":"list","member":{"type":"structure","members":{"TestWindowStart":{"type":"timestamp"},"TestWindowEnd":{"type":"timestamp"},"ItemCount":{"type":"integer"},"EvaluationType":{},"Metrics":{"type":"structure","members":{"RMSE":{"deprecated":true,"deprecatedMessage":"This property is deprecated, please refer to ErrorMetrics for both RMSE and WAPE","type":"double"},"WeightedQuantileLosses":{"type":"list","member":{"type":"structure","members":{"Quantile":{"type":"double"},"LossValue":{"type":"double"}}}},"ErrorMetrics":{"type":"list","member":{"type":"structure","members":{"ForecastType":{},"WAPE":{"type":"double"},"RMSE":{"type":"double"},"MASE":{"type":"double"},"MAPE":{"type":"double"}}}},"AverageWeightedQuantileLoss":{"type":"double"}}}}}}}}},"IsAutoPredictor":{"type":"boolean"},"AutoMLOverrideStrategy":{},"OptimizationMetric":{}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetGroups":{"type":"list","member":{"type":"structure","members":{"DatasetGroupArn":{},"DatasetGroupName":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"DatasetImportJobs":{"type":"list","member":{"type":"structure","members":{"DatasetImportJobArn":{},"DatasetImportJobName":{},"DataSource":{"shape":"S19"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"},"ImportMode":{}}}},"NextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Datasets":{"type":"list","member":{"type":"structure","members":{"DatasetArn":{},"DatasetName":{},"DatasetType":{},"Domain":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListExplainabilities":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"Explainabilities":{"type":"list","member":{"type":"structure","members":{"ExplainabilityArn":{},"ExplainabilityName":{},"ResourceArn":{},"ExplainabilityConfig":{"shape":"S1k"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListExplainabilityExports":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"ExplainabilityExports":{"type":"list","member":{"type":"structure","members":{"ExplainabilityExportArn":{},"ExplainabilityExportName":{},"Destination":{"shape":"S1q"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecastExportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"ForecastExportJobs":{"type":"list","member":{"type":"structure","members":{"ForecastExportJobArn":{},"ForecastExportJobName":{},"Destination":{"shape":"S1q"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListForecasts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"Forecasts":{"type":"list","member":{"type":"structure","members":{"ForecastArn":{},"ForecastName":{},"PredictorArn":{},"CreatedUsingAutoPredictor":{"type":"boolean"},"DatasetGroupArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListMonitorEvaluations":{"input":{"type":"structure","required":["MonitorArn"],"members":{"NextToken":{},"MaxResults":{"type":"integer"},"MonitorArn":{},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"NextToken":{},"PredictorMonitorEvaluations":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"MonitorArn":{},"EvaluationTime":{"type":"timestamp"},"EvaluationState":{},"WindowStartDatetime":{"type":"timestamp"},"WindowEndDatetime":{"type":"timestamp"},"PredictorEvent":{"type":"structure","members":{"Detail":{},"Datetime":{"type":"timestamp"}}},"MonitorDataSource":{"type":"structure","members":{"DatasetImportJobArn":{},"ForecastArn":{},"PredictorArn":{}}},"MetricResults":{"type":"list","member":{"type":"structure","members":{"MetricName":{},"MetricValue":{"type":"double"}}}},"NumItemsEvaluated":{"type":"long"},"Message":{}}}}}},"idempotent":true},"ListMonitors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"Monitors":{"type":"list","member":{"type":"structure","members":{"MonitorArn":{},"MonitorName":{},"ResourceArn":{},"Status":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListPredictorBacktestExportJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"PredictorBacktestExportJobs":{"type":"list","member":{"type":"structure","members":{"PredictorBacktestExportJobArn":{},"PredictorBacktestExportJobName":{},"Destination":{"shape":"S1q"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListPredictors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"Predictors":{"type":"list","member":{"type":"structure","members":{"PredictorArn":{},"PredictorName":{},"DatasetGroupArn":{},"IsAutoPredictor":{"type":"boolean"},"ReferencePredictorSummary":{"shape":"S3q"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sm"}}}},"ListWhatIfAnalyses":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"WhatIfAnalyses":{"type":"list","member":{"type":"structure","members":{"WhatIfAnalysisArn":{},"WhatIfAnalysisName":{},"ForecastArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListWhatIfForecastExports":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"WhatIfForecastExports":{"type":"list","member":{"type":"structure","members":{"WhatIfForecastExportArn":{},"WhatIfForecastArns":{"shape":"S38"},"WhatIfForecastExportName":{},"Destination":{"shape":"S1q"},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ListWhatIfForecasts":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Filters":{"shape":"S5m"}}},"output":{"type":"structure","members":{"WhatIfForecasts":{"type":"list","member":{"type":"structure","members":{"WhatIfForecastArn":{},"WhatIfForecastName":{},"WhatIfAnalysisArn":{},"Status":{},"Message":{},"CreationTime":{"type":"timestamp"},"LastModificationTime":{"type":"timestamp"}}}},"NextToken":{}}},"idempotent":true},"ResumeResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"idempotent":true},"StopResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{"shape":"So"}}}},"output":{"type":"structure","members":{}}},"UpdateDatasetGroup":{"input":{"type":"structure","required":["DatasetGroupArn","DatasetArns"],"members":{"DatasetGroupArn":{},"DatasetArns":{"shape":"S16"}}},"output":{"type":"structure","members":{}},"idempotent":true}},"shapes":{"S4":{"type":"list","member":{}},"S6":{"type":"list","member":{}},"S8":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{},"AttributeConfigs":{"type":"list","member":{"type":"structure","required":["AttributeName","Transformations"],"members":{"AttributeName":{},"Transformations":{"type":"map","key":{},"value":{}}}}},"AdditionalDatasets":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Configuration":{"type":"map","key":{},"value":{"shape":"Sh"}}}}}}},"Sh":{"type":"list","member":{}},"Si":{"type":"structure","required":["RoleArn","KMSKeyArn"],"members":{"RoleArn":{},"KMSKeyArn":{}}},"Sm":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{"shape":"So"},"Value":{"type":"string","sensitive":true}}}},"So":{"type":"string","sensitive":true},"Sr":{"type":"structure","members":{"Month":{},"DayOfMonth":{"type":"integer"},"DayOfWeek":{},"Hour":{"type":"integer"}}},"S10":{"type":"structure","members":{"Attributes":{"type":"list","member":{"type":"structure","members":{"AttributeName":{},"AttributeType":{}}}}}},"S16":{"type":"list","member":{}},"S19":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"S1a"}}},"S1a":{"type":"structure","required":["Path","RoleArn"],"members":{"Path":{},"RoleArn":{},"KMSKeyArn":{}}},"S1k":{"type":"structure","required":["TimeSeriesGranularity","TimePointGranularity"],"members":{"TimeSeriesGranularity":{},"TimePointGranularity":{}}},"S1q":{"type":"structure","required":["S3Config"],"members":{"S3Config":{"shape":"S1a"}}},"S1t":{"type":"structure","members":{"TimeSeriesIdentifiers":{"type":"structure","members":{"DataSource":{"shape":"S19"},"Schema":{"shape":"S10"},"Format":{}}}}},"S22":{"type":"map","key":{},"value":{}},"S25":{"type":"structure","members":{"NumberOfBacktestWindows":{"type":"integer"},"BackTestWindowOffset":{"type":"integer"}}},"S26":{"type":"structure","members":{"ParameterRanges":{"type":"structure","members":{"CategoricalParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"Sh"}}}},"ContinuousParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"double"},"MinValue":{"type":"double"},"ScalingType":{}}}},"IntegerParameterRanges":{"type":"list","member":{"type":"structure","required":["Name","MaxValue","MinValue"],"members":{"Name":{},"MaxValue":{"type":"integer"},"MinValue":{"type":"integer"},"ScalingType":{}}}}}}}},"S2g":{"type":"structure","required":["DatasetGroupArn"],"members":{"DatasetGroupArn":{},"SupplementaryFeatures":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}},"S2j":{"type":"structure","required":["ForecastFrequency"],"members":{"ForecastFrequency":{},"ForecastDimensions":{"shape":"S6"},"Featurizations":{"type":"list","member":{"type":"structure","required":["AttributeName"],"members":{"AttributeName":{},"FeaturizationPipeline":{"type":"list","member":{"type":"structure","required":["FeaturizationMethodName"],"members":{"FeaturizationMethodName":{},"FeaturizationMethodParameters":{"type":"map","key":{},"value":{}}}}}}}}}},"S2w":{"type":"list","member":{"type":"structure","members":{"Action":{"type":"structure","required":["AttributeName","Operation","Value"],"members":{"AttributeName":{},"Operation":{},"Value":{"type":"double"}}},"TimeSeriesConditions":{"type":"list","member":{"type":"structure","required":["AttributeName","AttributeValue","Condition"],"members":{"AttributeName":{},"AttributeValue":{},"Condition":{}}}}}}},"S34":{"type":"structure","required":["S3Config","Schema"],"members":{"S3Config":{"shape":"S1a"},"Schema":{"shape":"S10"},"Format":{},"TimestampFormat":{}}},"S38":{"type":"list","member":{}},"S3q":{"type":"structure","members":{"Arn":{},"State":{}}},"S5m":{"type":"list","member":{"type":"structure","required":["Key","Value","Condition"],"members":{"Key":{},"Value":{},"Condition":{}}}}}}

/***/ }),
/* 512 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDatasetGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetGroups"},"ListDatasetImportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetImportJobs"},"ListDatasets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Datasets"},"ListExplainabilities":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Explainabilities"},"ListExplainabilityExports":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ExplainabilityExports"},"ListForecastExportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ForecastExportJobs"},"ListForecasts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Forecasts"},"ListMonitorEvaluations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PredictorMonitorEvaluations"},"ListMonitors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Monitors"},"ListPredictorBacktestExportJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PredictorBacktestExportJobs"},"ListPredictors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Predictors"},"ListWhatIfAnalyses":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WhatIfAnalyses"},"ListWhatIfForecastExports":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WhatIfForecastExports"},"ListWhatIfForecasts":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WhatIfForecasts"}}}

/***/ }),
/* 513 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-06-26","endpointPrefix":"forecastquery","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Forecast Query Service","serviceId":"forecastquery","signatureVersion":"v4","signingName":"forecast","targetPrefix":"AmazonForecastRuntime","uid":"forecastquery-2018-06-26"},"operations":{"QueryForecast":{"input":{"type":"structure","required":["ForecastArn","Filters"],"members":{"ForecastArn":{},"StartDate":{},"EndDate":{},"Filters":{"shape":"S4"},"NextToken":{}}},"output":{"type":"structure","members":{"Forecast":{"shape":"S9"}}}},"QueryWhatIfForecast":{"input":{"type":"structure","required":["WhatIfForecastArn","Filters"],"members":{"WhatIfForecastArn":{},"StartDate":{},"EndDate":{},"Filters":{"shape":"S4"},"NextToken":{}}},"output":{"type":"structure","members":{"Forecast":{"shape":"S9"}}}}},"shapes":{"S4":{"type":"map","key":{},"value":{}},"S9":{"type":"structure","members":{"Predictions":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Timestamp":{},"Value":{"type":"double"}}}}}}}}}

/***/ }),
/* 514 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-10-01","endpointPrefix":"gamelift","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon GameLift","serviceId":"GameLift","signatureVersion":"v4","targetPrefix":"GameLift","uid":"gamelift-2015-10-01"},"operations":{"AcceptMatch":{"input":{"type":"structure","required":["TicketId","PlayerIds","AcceptanceType"],"members":{"TicketId":{},"PlayerIds":{"type":"list","member":{"shape":"S4"},"sensitive":true},"AcceptanceType":{}}},"output":{"type":"structure","members":{}}},"ClaimGameServer":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"GameServerId":{},"GameServerData":{},"FilterOption":{"type":"structure","members":{"InstanceStatuses":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sf"}}}},"CreateAlias":{"input":{"type":"structure","required":["Name","RoutingStrategy"],"members":{"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sq"},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sz"}}}},"CreateBuild":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"S13"},"OperatingSystem":{},"Tags":{"shape":"Su"},"ServerSdkVersion":{}}},"output":{"type":"structure","members":{"Build":{"shape":"S18"},"UploadCredentials":{"shape":"S1d"},"StorageLocation":{"shape":"S13"}}}},"CreateContainerGroupDefinition":{"input":{"type":"structure","required":["Name","TotalMemoryLimit","TotalCpuLimit","ContainerDefinitions","OperatingSystem"],"members":{"Name":{},"SchedulingStrategy":{},"TotalMemoryLimit":{"type":"integer"},"TotalCpuLimit":{"type":"integer"},"ContainerDefinitions":{"type":"list","member":{"type":"structure","required":["ContainerName","ImageUri"],"members":{"ContainerName":{},"ImageUri":{},"MemoryLimits":{"shape":"S1n"},"PortConfiguration":{"shape":"S1p"},"Cpu":{"type":"integer"},"HealthCheck":{"shape":"S1v"},"Command":{"shape":"S1w"},"Essential":{"type":"boolean"},"EntryPoint":{"shape":"S23"},"WorkingDirectory":{},"Environment":{"shape":"S24"},"DependsOn":{"shape":"S26"}}}},"OperatingSystem":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"ContainerGroupDefinition":{"shape":"S2b"}}}},"CreateFleet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"BuildId":{},"ScriptId":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S2m"},"EC2InstanceType":{},"EC2InboundPermissions":{"shape":"S2o"},"NewGameSessionProtectionPolicy":{},"RuntimeConfiguration":{"shape":"S2s"},"ResourceCreationLimitPolicy":{"shape":"S2y"},"MetricGroups":{"shape":"S30"},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"FleetType":{},"InstanceRoleArn":{},"CertificateConfiguration":{"shape":"S33"},"Locations":{"shape":"S35"},"Tags":{"shape":"Su"},"ComputeType":{},"AnywhereConfiguration":{"shape":"S39"},"InstanceRoleCredentialsProvider":{},"ContainerGroupsConfiguration":{"type":"structure","required":["ContainerGroupDefinitionNames","ConnectionPortRange"],"members":{"ContainerGroupDefinitionNames":{"type":"list","member":{}},"ConnectionPortRange":{"shape":"S3f"},"DesiredReplicaContainerGroupsPerInstance":{"type":"integer"}}}}},"output":{"type":"structure","members":{"FleetAttributes":{"shape":"S3i"},"LocationStates":{"shape":"S3t"}}}},"CreateFleetLocations":{"input":{"type":"structure","required":["FleetId","Locations"],"members":{"FleetId":{},"Locations":{"shape":"S35"}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"LocationStates":{"shape":"S3t"}}}},"CreateGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","RoleArn","MinSize","MaxSize","LaunchTemplate","InstanceDefinitions"],"members":{"GameServerGroupName":{},"RoleArn":{},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"LaunchTemplate":{"type":"structure","members":{"LaunchTemplateId":{},"LaunchTemplateName":{},"Version":{}}},"InstanceDefinitions":{"shape":"S44"},"AutoScalingPolicy":{"type":"structure","required":["TargetTrackingConfiguration"],"members":{"EstimatedInstanceWarmup":{"type":"integer"},"TargetTrackingConfiguration":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"}}}}},"BalancingStrategy":{},"GameServerProtectionPolicy":{},"VpcSubnets":{"type":"list","member":{}},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S4g"}}}},"CreateGameSession":{"input":{"type":"structure","required":["MaximumPlayerSessionCount"],"members":{"FleetId":{},"AliasId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"GameProperties":{"shape":"S4n"},"CreatorId":{},"GameSessionId":{},"IdempotencyToken":{},"GameSessionData":{},"Location":{}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S4u"}}}},"CreateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S53"},"Destinations":{"shape":"S55"},"FilterConfiguration":{"shape":"S58"},"PriorityConfiguration":{"shape":"S5a"},"CustomEventData":{},"NotificationTarget":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S5g"}}}},"CreateLocation":{"input":{"type":"structure","required":["LocationName"],"members":{"LocationName":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"Location":{"shape":"S5l"}}}},"CreateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name","RequestTimeoutSeconds","AcceptanceRequired","RuleSetName"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S5o"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S4n"},"GameSessionData":{},"BackfillMode":{},"FlexMatchMode":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S5y"}}}},"CreateMatchmakingRuleSet":{"input":{"type":"structure","required":["Name","RuleSetBody"],"members":{"Name":{},"RuleSetBody":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","required":["RuleSet"],"members":{"RuleSet":{"shape":"S64"}}}},"CreatePlayerSession":{"input":{"type":"structure","required":["GameSessionId","PlayerId"],"members":{"GameSessionId":{},"PlayerId":{"shape":"S4"},"PlayerData":{}}},"output":{"type":"structure","members":{"PlayerSession":{"shape":"S68"}}}},"CreatePlayerSessions":{"input":{"type":"structure","required":["GameSessionId","PlayerIds"],"members":{"GameSessionId":{},"PlayerIds":{"type":"list","member":{"shape":"S4"},"sensitive":true},"PlayerDataMap":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S6f"}}}},"CreateScript":{"input":{"type":"structure","members":{"Name":{},"Version":{},"StorageLocation":{"shape":"S13"},"ZipFile":{"type":"blob"},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{"Script":{"shape":"S6j"}}}},"CreateVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{"VpcPeeringAuthorization":{"shape":"S6m"}}}},"CreateVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","PeerVpcAwsAccountId","PeerVpcId"],"members":{"FleetId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}}},"DeleteBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}}},"DeleteContainerGroupDefinition":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DeleteFleet":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}}},"DeleteFleetLocations":{"input":{"type":"structure","required":["FleetId","Locations"],"members":{"FleetId":{},"Locations":{"shape":"S59"}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"LocationStates":{"shape":"S3t"}}}},"DeleteGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"DeleteOption":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S4g"}}}},"DeleteGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteLocation":{"input":{"type":"structure","required":["LocationName"],"members":{"LocationName":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteMatchmakingRuleSet":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId"],"members":{"Name":{},"FleetId":{}}}},"DeleteScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}}},"DeleteVpcPeeringAuthorization":{"input":{"type":"structure","required":["GameLiftAwsAccountId","PeerVpcId"],"members":{"GameLiftAwsAccountId":{},"PeerVpcId":{}}},"output":{"type":"structure","members":{}}},"DeleteVpcPeeringConnection":{"input":{"type":"structure","required":["FleetId","VpcPeeringConnectionId"],"members":{"FleetId":{},"VpcPeeringConnectionId":{}}},"output":{"type":"structure","members":{}}},"DeregisterCompute":{"input":{"type":"structure","required":["FleetId","ComputeName"],"members":{"FleetId":{},"ComputeName":{}}},"output":{"type":"structure","members":{}}},"DeregisterGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{}}}},"DescribeAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sz"}}}},"DescribeBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"Build":{"shape":"S18"}}}},"DescribeCompute":{"input":{"type":"structure","required":["FleetId","ComputeName"],"members":{"FleetId":{},"ComputeName":{}}},"output":{"type":"structure","members":{"Compute":{"shape":"S7p"}}}},"DescribeContainerGroupDefinition":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ContainerGroupDefinition":{"shape":"S2b"}}}},"DescribeEC2InstanceLimits":{"input":{"type":"structure","members":{"EC2InstanceType":{},"Location":{}}},"output":{"type":"structure","members":{"EC2InstanceLimits":{"type":"list","member":{"type":"structure","members":{"EC2InstanceType":{},"CurrentInstances":{"type":"integer"},"InstanceLimit":{"type":"integer"},"Location":{}}}}}}},"DescribeFleetAttributes":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S86"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetAttributes":{"type":"list","member":{"shape":"S3i"}},"NextToken":{}}}},"DescribeFleetCapacity":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S86"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"type":"list","member":{"shape":"S8c"}},"NextToken":{}}}},"DescribeFleetEvents":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Events":{"type":"list","member":{"type":"structure","members":{"EventId":{},"ResourceId":{},"EventCode":{},"Message":{},"EventTime":{"type":"timestamp"},"PreSignedLogUrl":{},"Count":{"type":"long"}}}},"NextToken":{}}}},"DescribeFleetLocationAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Locations":{"shape":"S59"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"LocationAttributes":{"type":"list","member":{"type":"structure","members":{"LocationState":{"shape":"S3u"},"StoppedActions":{"shape":"S3n"},"UpdateStatus":{}}}},"NextToken":{}}}},"DescribeFleetLocationCapacity":{"input":{"type":"structure","required":["FleetId","Location"],"members":{"FleetId":{},"Location":{}}},"output":{"type":"structure","members":{"FleetCapacity":{"shape":"S8c"}}}},"DescribeFleetLocationUtilization":{"input":{"type":"structure","required":["FleetId","Location"],"members":{"FleetId":{},"Location":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"shape":"S8u"}}}},"DescribeFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"InboundPermissions":{"shape":"S2o"},"UpdateStatus":{},"Location":{}}}},"DescribeFleetUtilization":{"input":{"type":"structure","members":{"FleetIds":{"shape":"S86"},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetUtilization":{"type":"list","member":{"shape":"S8u"}},"NextToken":{}}}},"DescribeGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sf"}}}},"DescribeGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S4g"}}}},"DescribeGameServerInstances":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"InstanceIds":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServerInstances":{"type":"list","member":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"InstanceId":{},"InstanceStatus":{}}}},"NextToken":{}}}},"DescribeGameSessionDetails":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"Location":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionDetails":{"type":"list","member":{"type":"structure","members":{"GameSession":{"shape":"S4u"},"ProtectionPolicy":{}}}},"NextToken":{}}}},"DescribeGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S9g"}}}},"DescribeGameSessionQueues":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessionQueues":{"type":"list","member":{"shape":"S5g"}},"NextToken":{}}}},"DescribeGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"GameSessionId":{},"AliasId":{},"Location":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S9t"},"NextToken":{}}}},"DescribeInstances":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InstanceId":{},"Limit":{"type":"integer"},"NextToken":{},"Location":{}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"InstanceId":{},"IpAddress":{"shape":"S4x"},"DnsName":{},"OperatingSystem":{},"Type":{},"Status":{},"CreationTime":{"type":"timestamp"},"Location":{}}}},"NextToken":{}}}},"DescribeMatchmaking":{"input":{"type":"structure","required":["TicketIds"],"members":{"TicketIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"TicketList":{"type":"list","member":{"shape":"Sa3"}}}}},"DescribeMatchmakingConfigurations":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"RuleSetName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Configurations":{"type":"list","member":{"shape":"S5y"}},"NextToken":{}}}},"DescribeMatchmakingRuleSets":{"input":{"type":"structure","members":{"Names":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["RuleSets"],"members":{"RuleSets":{"type":"list","member":{"shape":"S64"}},"NextToken":{}}}},"DescribePlayerSessions":{"input":{"type":"structure","members":{"GameSessionId":{},"PlayerId":{"shape":"S4"},"PlayerSessionId":{},"PlayerSessionStatusFilter":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"PlayerSessions":{"shape":"S6f"},"NextToken":{}}}},"DescribeRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S2s"}}}},"DescribeScalingPolicies":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"StatusFilter":{},"Limit":{"type":"integer"},"NextToken":{},"Location":{}}},"output":{"type":"structure","members":{"ScalingPolicies":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"Name":{},"Status":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"ComparisonOperator":{},"Threshold":{"type":"double"},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"Sb6"},"UpdateStatus":{},"Location":{}}}},"NextToken":{}}}},"DescribeScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{}}},"output":{"type":"structure","members":{"Script":{"shape":"S6j"}}}},"DescribeVpcPeeringAuthorizations":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"VpcPeeringAuthorizations":{"type":"list","member":{"shape":"S6m"}}}}},"DescribeVpcPeeringConnections":{"input":{"type":"structure","members":{"FleetId":{}}},"output":{"type":"structure","members":{"VpcPeeringConnections":{"type":"list","member":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"IpV4CidrBlock":{},"VpcPeeringConnectionId":{},"Status":{"type":"structure","members":{"Code":{},"Message":{}}},"PeerVpcId":{},"GameLiftVpcId":{}}}}}}},"GetComputeAccess":{"input":{"type":"structure","required":["FleetId","ComputeName"],"members":{"FleetId":{},"ComputeName":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"ComputeName":{},"ComputeArn":{},"Credentials":{"shape":"S1d"},"Target":{}}}},"GetComputeAuthToken":{"input":{"type":"structure","required":["FleetId","ComputeName"],"members":{"FleetId":{},"ComputeName":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"ComputeName":{},"ComputeArn":{},"AuthToken":{},"ExpirationTimestamp":{"type":"timestamp"}}}},"GetGameSessionLogUrl":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{}}},"output":{"type":"structure","members":{"PreSignedUrl":{}}}},"GetInstanceAccess":{"input":{"type":"structure","required":["FleetId","InstanceId"],"members":{"FleetId":{},"InstanceId":{}}},"output":{"type":"structure","members":{"InstanceAccess":{"type":"structure","members":{"FleetId":{},"InstanceId":{},"IpAddress":{"shape":"S4x"},"OperatingSystem":{},"Credentials":{"type":"structure","members":{"UserName":{},"Secret":{}},"sensitive":true}}}}}},"ListAliases":{"input":{"type":"structure","members":{"RoutingStrategyType":{},"Name":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"shape":"Sz"}},"NextToken":{}}}},"ListBuilds":{"input":{"type":"structure","members":{"Status":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Builds":{"type":"list","member":{"shape":"S18"}},"NextToken":{}}}},"ListCompute":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Location":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ComputeList":{"type":"list","member":{"shape":"S7p"}},"NextToken":{}}}},"ListContainerGroupDefinitions":{"input":{"type":"structure","members":{"SchedulingStrategy":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ContainerGroupDefinitions":{"type":"list","member":{"shape":"S2b"}},"NextToken":{}}}},"ListFleets":{"input":{"type":"structure","members":{"BuildId":{},"ScriptId":{},"ContainerGroupDefinitionName":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"FleetIds":{"type":"list","member":{}},"NextToken":{}}}},"ListGameServerGroups":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServerGroups":{"type":"list","member":{"shape":"S4g"}},"NextToken":{}}}},"ListGameServers":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"SortOrder":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameServers":{"type":"list","member":{"shape":"Sf"}},"NextToken":{}}}},"ListLocations":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{}},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Locations":{"type":"list","member":{"shape":"S5l"}},"NextToken":{}}}},"ListScripts":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Scripts":{"type":"list","member":{"shape":"S6j"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Su"}}}},"PutScalingPolicy":{"input":{"type":"structure","required":["Name","FleetId","MetricName"],"members":{"Name":{},"FleetId":{},"ScalingAdjustment":{"type":"integer"},"ScalingAdjustmentType":{},"Threshold":{"type":"double"},"ComparisonOperator":{},"EvaluationPeriods":{"type":"integer"},"MetricName":{},"PolicyType":{},"TargetConfiguration":{"shape":"Sb6"}}},"output":{"type":"structure","members":{"Name":{}}}},"RegisterCompute":{"input":{"type":"structure","required":["FleetId","ComputeName"],"members":{"FleetId":{},"ComputeName":{},"CertificatePath":{},"DnsName":{},"IpAddress":{"shape":"S4x"},"Location":{}}},"output":{"type":"structure","members":{"Compute":{"shape":"S7p"}}}},"RegisterGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId","InstanceId"],"members":{"GameServerGroupName":{},"GameServerId":{},"InstanceId":{},"ConnectionInfo":{},"GameServerData":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sf"}}}},"RequestUploadCredentials":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{}}},"output":{"type":"structure","members":{"UploadCredentials":{"shape":"S1d"},"StorageLocation":{"shape":"S13"}}}},"ResolveAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"ResumeGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","ResumeActions"],"members":{"GameServerGroupName":{},"ResumeActions":{"shape":"S4j"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S4g"}}}},"SearchGameSessions":{"input":{"type":"structure","members":{"FleetId":{},"AliasId":{},"Location":{},"FilterExpression":{},"SortExpression":{},"Limit":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"GameSessions":{"shape":"S9t"},"NextToken":{}}}},"StartFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S3n"},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"StartGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId","GameSessionQueueName","MaximumPlayerSessionCount"],"members":{"PlacementId":{},"GameSessionQueueName":{},"GameProperties":{"shape":"S4n"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"PlayerLatencies":{"shape":"S9i"},"DesiredPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{"shape":"S4"},"PlayerData":{}}}},"GameSessionData":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S9g"}}}},"StartMatchBackfill":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"GameSessionArn":{},"Players":{"shape":"Sa6"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"Sa3"}}}},"StartMatchmaking":{"input":{"type":"structure","required":["ConfigurationName","Players"],"members":{"TicketId":{},"ConfigurationName":{},"Players":{"shape":"Sa6"}}},"output":{"type":"structure","members":{"MatchmakingTicket":{"shape":"Sa3"}}}},"StopFleetActions":{"input":{"type":"structure","required":["FleetId","Actions"],"members":{"FleetId":{},"Actions":{"shape":"S3n"},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"StopGameSessionPlacement":{"input":{"type":"structure","required":["PlacementId"],"members":{"PlacementId":{}}},"output":{"type":"structure","members":{"GameSessionPlacement":{"shape":"S9g"}}}},"StopMatchmaking":{"input":{"type":"structure","required":["TicketId"],"members":{"TicketId":{}}},"output":{"type":"structure","members":{}}},"SuspendGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName","SuspendActions"],"members":{"GameServerGroupName":{},"SuspendActions":{"shape":"S4j"}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S4g"}}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Su"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasId"],"members":{"AliasId":{},"Name":{},"Description":{},"RoutingStrategy":{"shape":"Sq"}}},"output":{"type":"structure","members":{"Alias":{"shape":"Sz"}}}},"UpdateBuild":{"input":{"type":"structure","required":["BuildId"],"members":{"BuildId":{},"Name":{},"Version":{}}},"output":{"type":"structure","members":{"Build":{"shape":"S18"}}}},"UpdateFleetAttributes":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"Name":{},"Description":{},"NewGameSessionProtectionPolicy":{},"ResourceCreationLimitPolicy":{"shape":"S2y"},"MetricGroups":{"shape":"S30"},"AnywhereConfiguration":{"shape":"S39"}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"UpdateFleetCapacity":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"DesiredInstances":{"type":"integer"},"MinSize":{"type":"integer"},"MaxSize":{"type":"integer"},"Location":{}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"Location":{}}}},"UpdateFleetPortSettings":{"input":{"type":"structure","required":["FleetId"],"members":{"FleetId":{},"InboundPermissionAuthorizations":{"shape":"S2o"},"InboundPermissionRevocations":{"shape":"S2o"}}},"output":{"type":"structure","members":{"FleetId":{},"FleetArn":{}}}},"UpdateGameServer":{"input":{"type":"structure","required":["GameServerGroupName","GameServerId"],"members":{"GameServerGroupName":{},"GameServerId":{},"GameServerData":{},"UtilizationStatus":{},"HealthCheck":{}}},"output":{"type":"structure","members":{"GameServer":{"shape":"Sf"}}}},"UpdateGameServerGroup":{"input":{"type":"structure","required":["GameServerGroupName"],"members":{"GameServerGroupName":{},"RoleArn":{},"InstanceDefinitions":{"shape":"S44"},"GameServerProtectionPolicy":{},"BalancingStrategy":{}}},"output":{"type":"structure","members":{"GameServerGroup":{"shape":"S4g"}}}},"UpdateGameSession":{"input":{"type":"structure","required":["GameSessionId"],"members":{"GameSessionId":{},"MaximumPlayerSessionCount":{"type":"integer"},"Name":{},"PlayerSessionCreationPolicy":{},"ProtectionPolicy":{},"GameProperties":{"shape":"S4n"}}},"output":{"type":"structure","members":{"GameSession":{"shape":"S4u"}}}},"UpdateGameSessionQueue":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S53"},"Destinations":{"shape":"S55"},"FilterConfiguration":{"shape":"S58"},"PriorityConfiguration":{"shape":"S5a"},"CustomEventData":{},"NotificationTarget":{}}},"output":{"type":"structure","members":{"GameSessionQueue":{"shape":"S5g"}}}},"UpdateMatchmakingConfiguration":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"GameSessionQueueArns":{"shape":"S5o"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"GameProperties":{"shape":"S4n"},"GameSessionData":{},"BackfillMode":{},"FlexMatchMode":{}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S5y"}}}},"UpdateRuntimeConfiguration":{"input":{"type":"structure","required":["FleetId","RuntimeConfiguration"],"members":{"FleetId":{},"RuntimeConfiguration":{"shape":"S2s"}}},"output":{"type":"structure","members":{"RuntimeConfiguration":{"shape":"S2s"}}}},"UpdateScript":{"input":{"type":"structure","required":["ScriptId"],"members":{"ScriptId":{},"Name":{},"Version":{},"StorageLocation":{"shape":"S13"},"ZipFile":{"type":"blob"}}},"output":{"type":"structure","members":{"Script":{"shape":"S6j"}}}},"ValidateMatchmakingRuleSet":{"input":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetBody":{}}},"output":{"type":"structure","members":{"Valid":{"type":"boolean"}}}}},"shapes":{"S4":{"type":"string","sensitive":true},"Sf":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"GameServerId":{},"InstanceId":{},"ConnectionInfo":{},"GameServerData":{},"ClaimStatus":{},"UtilizationStatus":{},"RegistrationTime":{"type":"timestamp"},"LastClaimTime":{"type":"timestamp"},"LastHealthCheckTime":{"type":"timestamp"}}},"Sq":{"type":"structure","members":{"Type":{},"FleetId":{},"Message":{}}},"Su":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sz":{"type":"structure","members":{"AliasId":{},"Name":{},"AliasArn":{},"Description":{},"RoutingStrategy":{"shape":"Sq"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"S13":{"type":"structure","members":{"Bucket":{},"Key":{},"RoleArn":{},"ObjectVersion":{}}},"S18":{"type":"structure","members":{"BuildId":{},"BuildArn":{},"Name":{},"Version":{},"Status":{},"SizeOnDisk":{"type":"long"},"OperatingSystem":{},"CreationTime":{"type":"timestamp"},"ServerSdkVersion":{}}},"S1d":{"type":"structure","members":{"AccessKeyId":{},"SecretAccessKey":{},"SessionToken":{}},"sensitive":true},"S1n":{"type":"structure","members":{"SoftLimit":{"type":"integer"},"HardLimit":{"type":"integer"}}},"S1p":{"type":"structure","required":["ContainerPortRanges"],"members":{"ContainerPortRanges":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","Protocol"],"members":{"FromPort":{"shape":"S1s"},"ToPort":{"shape":"S1s"},"Protocol":{}}}}}},"S1s":{"type":"integer","sensitive":true},"S1v":{"type":"structure","required":["Command"],"members":{"Command":{"shape":"S1w"},"Interval":{"type":"integer"},"Timeout":{"type":"integer"},"Retries":{"type":"integer"},"StartPeriod":{"type":"integer"}}},"S1w":{"type":"list","member":{}},"S23":{"type":"list","member":{}},"S24":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"S26":{"type":"list","member":{"type":"structure","required":["ContainerName","Condition"],"members":{"ContainerName":{},"Condition":{}}}},"S2b":{"type":"structure","members":{"ContainerGroupDefinitionArn":{},"CreationTime":{"type":"timestamp"},"OperatingSystem":{},"Name":{},"SchedulingStrategy":{},"TotalMemoryLimit":{"type":"integer"},"TotalCpuLimit":{"type":"integer"},"ContainerDefinitions":{"type":"list","member":{"type":"structure","required":["ContainerName","ImageUri"],"members":{"ContainerName":{},"ImageUri":{},"ResolvedImageDigest":{},"MemoryLimits":{"shape":"S1n"},"PortConfiguration":{"shape":"S1p"},"Cpu":{"type":"integer"},"HealthCheck":{"shape":"S1v"},"Command":{"shape":"S1w"},"Essential":{"type":"boolean"},"EntryPoint":{"shape":"S23"},"WorkingDirectory":{},"Environment":{"shape":"S24"},"DependsOn":{"shape":"S26"}}}},"Status":{},"StatusReason":{}}},"S2m":{"type":"list","member":{}},"S2o":{"type":"list","member":{"type":"structure","required":["FromPort","ToPort","IpRange","Protocol"],"members":{"FromPort":{"shape":"S1s"},"ToPort":{"shape":"S1s"},"IpRange":{"type":"string","sensitive":true},"Protocol":{}}}},"S2s":{"type":"structure","members":{"ServerProcesses":{"type":"list","member":{"type":"structure","required":["LaunchPath","ConcurrentExecutions"],"members":{"LaunchPath":{},"Parameters":{},"ConcurrentExecutions":{"type":"integer"}}}},"MaxConcurrentGameSessionActivations":{"type":"integer"},"GameSessionActivationTimeoutSeconds":{"type":"integer"}}},"S2y":{"type":"structure","members":{"NewGameSessionsPerCreator":{"type":"integer"},"PolicyPeriodInMinutes":{"type":"integer"}}},"S30":{"type":"list","member":{}},"S33":{"type":"structure","required":["CertificateType"],"members":{"CertificateType":{}}},"S35":{"type":"list","member":{"type":"structure","required":["Location"],"members":{"Location":{}}}},"S39":{"type":"structure","required":["Cost"],"members":{"Cost":{}}},"S3f":{"type":"structure","required":["FromPort","ToPort"],"members":{"FromPort":{"shape":"S1s"},"ToPort":{"shape":"S1s"}}},"S3i":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"FleetType":{},"InstanceType":{},"Description":{},"Name":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"BuildId":{},"BuildArn":{},"ScriptId":{},"ScriptArn":{},"ServerLaunchPath":{},"ServerLaunchParameters":{},"LogPaths":{"shape":"S2m"},"NewGameSessionProtectionPolicy":{},"OperatingSystem":{},"ResourceCreationLimitPolicy":{"shape":"S2y"},"MetricGroups":{"shape":"S30"},"StoppedActions":{"shape":"S3n"},"InstanceRoleArn":{},"CertificateConfiguration":{"shape":"S33"},"ComputeType":{},"AnywhereConfiguration":{"shape":"S39"},"InstanceRoleCredentialsProvider":{},"ContainerGroupsAttributes":{"type":"structure","members":{"ContainerGroupDefinitionProperties":{"type":"list","member":{"type":"structure","members":{"SchedulingStrategy":{},"ContainerGroupDefinitionName":{}}}},"ConnectionPortRange":{"shape":"S3f"},"ContainerGroupsPerInstance":{"type":"structure","members":{"DesiredReplicaContainerGroupsPerInstance":{"type":"integer"},"MaxReplicaContainerGroupsPerInstance":{"type":"integer"}}}}}}},"S3n":{"type":"list","member":{}},"S3t":{"type":"list","member":{"shape":"S3u"}},"S3u":{"type":"structure","members":{"Location":{},"Status":{}}},"S44":{"type":"list","member":{"type":"structure","required":["InstanceType"],"members":{"InstanceType":{},"WeightedCapacity":{}}}},"S4g":{"type":"structure","members":{"GameServerGroupName":{},"GameServerGroupArn":{},"RoleArn":{},"InstanceDefinitions":{"shape":"S44"},"BalancingStrategy":{},"GameServerProtectionPolicy":{},"AutoScalingGroupArn":{},"Status":{},"StatusReason":{},"SuspendedActions":{"shape":"S4j"},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"}}},"S4j":{"type":"list","member":{}},"S4n":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S4u":{"type":"structure","members":{"GameSessionId":{},"Name":{},"FleetId":{},"FleetArn":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Status":{},"StatusReason":{},"GameProperties":{"shape":"S4n"},"IpAddress":{"shape":"S4x"},"DnsName":{},"Port":{"shape":"S1s"},"PlayerSessionCreationPolicy":{},"CreatorId":{},"GameSessionData":{},"MatchmakerData":{},"Location":{}}},"S4x":{"type":"string","sensitive":true},"S53":{"type":"list","member":{"type":"structure","members":{"MaximumIndividualPlayerLatencyMilliseconds":{"type":"integer"},"PolicyDurationSeconds":{"type":"integer"}}}},"S55":{"type":"list","member":{"type":"structure","members":{"DestinationArn":{}}}},"S58":{"type":"structure","members":{"AllowedLocations":{"shape":"S59"}}},"S59":{"type":"list","member":{}},"S5a":{"type":"structure","members":{"PriorityOrder":{"type":"list","member":{}},"LocationOrder":{"shape":"S59"}}},"S5g":{"type":"structure","members":{"Name":{},"GameSessionQueueArn":{},"TimeoutInSeconds":{"type":"integer"},"PlayerLatencyPolicies":{"shape":"S53"},"Destinations":{"shape":"S55"},"FilterConfiguration":{"shape":"S58"},"PriorityConfiguration":{"shape":"S5a"},"CustomEventData":{},"NotificationTarget":{}}},"S5l":{"type":"structure","members":{"LocationName":{},"LocationArn":{}}},"S5o":{"type":"list","member":{}},"S5y":{"type":"structure","members":{"Name":{},"ConfigurationArn":{},"Description":{},"GameSessionQueueArns":{"shape":"S5o"},"RequestTimeoutSeconds":{"type":"integer"},"AcceptanceTimeoutSeconds":{"type":"integer"},"AcceptanceRequired":{"type":"boolean"},"RuleSetName":{},"RuleSetArn":{},"NotificationTarget":{},"AdditionalPlayerCount":{"type":"integer"},"CustomEventData":{},"CreationTime":{"type":"timestamp"},"GameProperties":{"shape":"S4n"},"GameSessionData":{},"BackfillMode":{},"FlexMatchMode":{}}},"S64":{"type":"structure","required":["RuleSetBody"],"members":{"RuleSetName":{},"RuleSetArn":{},"RuleSetBody":{},"CreationTime":{"type":"timestamp"}}},"S68":{"type":"structure","members":{"PlayerSessionId":{},"PlayerId":{"shape":"S4"},"GameSessionId":{},"FleetId":{},"FleetArn":{},"CreationTime":{"type":"timestamp"},"TerminationTime":{"type":"timestamp"},"Status":{},"IpAddress":{"shape":"S4x"},"DnsName":{},"Port":{"shape":"S1s"},"PlayerData":{}}},"S6f":{"type":"list","member":{"shape":"S68"}},"S6j":{"type":"structure","members":{"ScriptId":{},"ScriptArn":{},"Name":{},"Version":{},"SizeOnDisk":{"type":"long"},"CreationTime":{"type":"timestamp"},"StorageLocation":{"shape":"S13"}}},"S6m":{"type":"structure","members":{"GameLiftAwsAccountId":{},"PeerVpcAwsAccountId":{},"PeerVpcId":{},"CreationTime":{"type":"timestamp"},"ExpirationTime":{"type":"timestamp"}}},"S7p":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"ComputeName":{},"ComputeArn":{},"IpAddress":{"shape":"S4x"},"DnsName":{},"ComputeStatus":{},"Location":{},"CreationTime":{"type":"timestamp"},"OperatingSystem":{},"Type":{},"GameLiftServiceSdkEndpoint":{},"GameLiftAgentEndpoint":{},"InstanceId":{},"ContainerAttributes":{"type":"structure","members":{"ContainerPortMappings":{"type":"list","member":{"type":"structure","members":{"ContainerPort":{"shape":"S1s"},"ConnectionPort":{"shape":"S1s"},"Protocol":{}}}}}}}},"S86":{"type":"list","member":{}},"S8c":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"InstanceType":{},"InstanceCounts":{"type":"structure","members":{"DESIRED":{"type":"integer"},"MINIMUM":{"type":"integer"},"MAXIMUM":{"type":"integer"},"PENDING":{"type":"integer"},"ACTIVE":{"type":"integer"},"IDLE":{"type":"integer"},"TERMINATING":{"type":"integer"}}},"Location":{},"ReplicaContainerGroupCounts":{"type":"structure","members":{"PENDING":{"type":"integer"},"ACTIVE":{"type":"integer"},"IDLE":{"type":"integer"},"TERMINATING":{"type":"integer"}}}}},"S8u":{"type":"structure","members":{"FleetId":{},"FleetArn":{},"ActiveServerProcessCount":{"type":"integer"},"ActiveGameSessionCount":{"type":"integer"},"CurrentPlayerSessionCount":{"type":"integer"},"MaximumPlayerSessionCount":{"type":"integer"},"Location":{}}},"S9g":{"type":"structure","members":{"PlacementId":{},"GameSessionQueueName":{},"Status":{},"GameProperties":{"shape":"S4n"},"MaximumPlayerSessionCount":{"type":"integer"},"GameSessionName":{},"GameSessionId":{},"GameSessionArn":{},"GameSessionRegion":{},"PlayerLatencies":{"shape":"S9i"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"IpAddress":{"shape":"S4x"},"DnsName":{},"Port":{"shape":"S1s"},"PlacedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{"shape":"S4"},"PlayerSessionId":{}}}},"GameSessionData":{},"MatchmakerData":{}}},"S9i":{"type":"list","member":{"type":"structure","members":{"PlayerId":{"shape":"S4"},"RegionIdentifier":{},"LatencyInMilliseconds":{"type":"float"}}}},"S9t":{"type":"list","member":{"shape":"S4u"}},"Sa3":{"type":"structure","members":{"TicketId":{},"ConfigurationName":{},"ConfigurationArn":{},"Status":{},"StatusReason":{},"StatusMessage":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Players":{"shape":"Sa6"},"GameSessionConnectionInfo":{"type":"structure","members":{"GameSessionArn":{},"IpAddress":{"shape":"S4x"},"DnsName":{},"Port":{"type":"integer"},"MatchedPlayerSessions":{"type":"list","member":{"type":"structure","members":{"PlayerId":{"shape":"S4"},"PlayerSessionId":{}}}}}},"EstimatedWaitTime":{"type":"integer"}}},"Sa6":{"type":"list","member":{"type":"structure","members":{"PlayerId":{"shape":"S4"},"PlayerAttributes":{"type":"map","key":{},"value":{"type":"structure","members":{"S":{},"N":{"type":"double"},"SL":{"type":"list","member":{}},"SDM":{"type":"map","key":{},"value":{"type":"double"}}}}},"Team":{},"LatencyInMs":{"type":"map","key":{},"value":{"type":"integer"}}}}},"Sb6":{"type":"structure","required":["TargetValue"],"members":{"TargetValue":{"type":"double"}}}}}

/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeFleetAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetAttributes"},"DescribeFleetCapacity":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetCapacity"},"DescribeFleetEvents":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Events"},"DescribeFleetLocationAttributes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit"},"DescribeFleetUtilization":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetUtilization"},"DescribeGameServerInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameServerInstances"},"DescribeGameSessionDetails":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessionDetails"},"DescribeGameSessionQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessionQueues"},"DescribeGameSessions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessions"},"DescribeInstances":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Instances"},"DescribeMatchmakingConfigurations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Configurations"},"DescribeMatchmakingRuleSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"RuleSets"},"DescribePlayerSessions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"PlayerSessions"},"DescribeScalingPolicies":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"ScalingPolicies"},"ListAliases":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Aliases"},"ListBuilds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Builds"},"ListCompute":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"ComputeList"},"ListContainerGroupDefinitions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"ContainerGroupDefinitions"},"ListFleets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"FleetIds"},"ListGameServerGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameServerGroups"},"ListGameServers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameServers"},"ListLocations":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Locations"},"ListScripts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"Scripts"},"SearchGameSessions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"Limit","result_key":"GameSessions"}}}

/***/ }),
/* 517 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-05-08","endpointPrefix":"iam","globalEndpoint":"iam.amazonaws.com","protocol":"query","serviceAbbreviation":"IAM","serviceFullName":"AWS Identity and Access Management","serviceId":"IAM","signatureVersion":"v4","uid":"iam-2010-05-08","xmlNamespace":"https://iam.amazonaws.com/doc/2010-05-08/"},"operations":{"AddClientIDToOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"AddRoleToInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"AddUserToGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"AttachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"AttachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"AttachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"ChangePassword":{"input":{"type":"structure","required":["OldPassword","NewPassword"],"members":{"OldPassword":{"shape":"Sf"},"NewPassword":{"shape":"Sf"}}}},"CreateAccessKey":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"CreateAccessKeyResult","type":"structure","required":["AccessKey"],"members":{"AccessKey":{"type":"structure","required":["UserName","AccessKeyId","Status","SecretAccessKey"],"members":{"UserName":{},"AccessKeyId":{},"Status":{},"SecretAccessKey":{"type":"string","sensitive":true},"CreateDate":{"type":"timestamp"}}}}}},"CreateAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"CreateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"Path":{},"GroupName":{}}},"output":{"resultWrapper":"CreateGroupResult","type":"structure","required":["Group"],"members":{"Group":{"shape":"Ss"}}}},"CreateInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{},"Path":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"S10"}}}},"CreateLoginProfile":{"input":{"type":"structure","required":["UserName","Password"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}},"output":{"resultWrapper":"CreateLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1d"}}}},"CreateOpenIDConnectProvider":{"input":{"type":"structure","required":["Url"],"members":{"Url":{},"ClientIDList":{"shape":"S1g"},"ThumbprintList":{"shape":"S1h"},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateOpenIDConnectProviderResult","type":"structure","members":{"OpenIDConnectProviderArn":{},"Tags":{"shape":"Sv"}}}},"CreatePolicy":{"input":{"type":"structure","required":["PolicyName","PolicyDocument"],"members":{"PolicyName":{},"Path":{},"PolicyDocument":{},"Description":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreatePolicyResult","type":"structure","members":{"Policy":{"shape":"S1p"}}}},"CreatePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","PolicyDocument"],"members":{"PolicyArn":{},"PolicyDocument":{},"SetAsDefault":{"type":"boolean"}}},"output":{"resultWrapper":"CreatePolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1u"}}}},"CreateRole":{"input":{"type":"structure","required":["RoleName","AssumeRolePolicyDocument"],"members":{"Path":{},"RoleName":{},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"S12"}}}},"CreateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","Name"],"members":{"SAMLMetadataDocument":{},"Name":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{},"Tags":{"shape":"Sv"}}}},"CreateServiceLinkedRole":{"input":{"type":"structure","required":["AWSServiceName"],"members":{"AWSServiceName":{},"Description":{},"CustomSuffix":{}}},"output":{"resultWrapper":"CreateServiceLinkedRoleResult","type":"structure","members":{"Role":{"shape":"S12"}}}},"CreateServiceSpecificCredential":{"input":{"type":"structure","required":["UserName","ServiceName"],"members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"CreateServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S27"}}}},"CreateUser":{"input":{"type":"structure","required":["UserName"],"members":{"Path":{},"UserName":{},"PermissionsBoundary":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateUserResult","type":"structure","members":{"User":{"shape":"S2d"}}}},"CreateVirtualMFADevice":{"input":{"type":"structure","required":["VirtualMFADeviceName"],"members":{"Path":{},"VirtualMFADeviceName":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"CreateVirtualMFADeviceResult","type":"structure","required":["VirtualMFADevice"],"members":{"VirtualMFADevice":{"shape":"S2h"}}}},"DeactivateMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber"],"members":{"UserName":{},"SerialNumber":{}}}},"DeleteAccessKey":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"UserName":{},"AccessKeyId":{}}}},"DeleteAccountAlias":{"input":{"type":"structure","required":["AccountAlias"],"members":{"AccountAlias":{}}}},"DeleteAccountPasswordPolicy":{},"DeleteGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{}}}},"DeleteGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}}},"DeleteInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}}},"DeleteLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}}},"DeletePolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}}},"DeletePolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"DeleteRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}}},"DeleteRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}}},"DeleteSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}}},"DeleteSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId"],"members":{"UserName":{},"SSHPublicKeyId":{}}}},"DeleteServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}}},"DeleteServiceLinkedRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"DeleteServiceLinkedRoleResult","type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}}},"DeleteServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}}},"DeleteSigningCertificate":{"input":{"type":"structure","required":["CertificateId"],"members":{"UserName":{},"CertificateId":{}}}},"DeleteUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}}},"DeleteUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}}},"DeleteVirtualMFADevice":{"input":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{}}}},"DetachGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyArn"],"members":{"GroupName":{},"PolicyArn":{}}}},"DetachRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyArn"],"members":{"RoleName":{},"PolicyArn":{}}}},"DetachUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyArn"],"members":{"UserName":{},"PolicyArn":{}}}},"EnableMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"GenerateCredentialReport":{"output":{"resultWrapper":"GenerateCredentialReportResult","type":"structure","members":{"State":{},"Description":{}}}},"GenerateOrganizationsAccessReport":{"input":{"type":"structure","required":["EntityPath"],"members":{"EntityPath":{},"OrganizationsPolicyId":{}}},"output":{"resultWrapper":"GenerateOrganizationsAccessReportResult","type":"structure","members":{"JobId":{}}}},"GenerateServiceLastAccessedDetails":{"input":{"type":"structure","required":["Arn"],"members":{"Arn":{},"Granularity":{}}},"output":{"resultWrapper":"GenerateServiceLastAccessedDetailsResult","type":"structure","members":{"JobId":{}}}},"GetAccessKeyLastUsed":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyLastUsedResult","type":"structure","members":{"UserName":{},"AccessKeyLastUsed":{"type":"structure","required":["LastUsedDate","ServiceName","Region"],"members":{"LastUsedDate":{"type":"timestamp"},"ServiceName":{},"Region":{}}}}}},"GetAccountAuthorizationDetails":{"input":{"type":"structure","members":{"Filter":{"type":"list","member":{}},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetAccountAuthorizationDetailsResult","type":"structure","members":{"UserDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"UserPolicyList":{"shape":"S43"},"GroupList":{"type":"list","member":{}},"AttachedManagedPolicies":{"shape":"S46"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"}}}},"GroupDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"GroupPolicyList":{"shape":"S43"},"AttachedManagedPolicies":{"shape":"S46"}}}},"RoleDetailList":{"type":"list","member":{"type":"structure","members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"InstanceProfileList":{"shape":"S4c"},"RolePolicyList":{"shape":"S43"},"AttachedManagedPolicies":{"shape":"S46"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"},"RoleLastUsed":{"shape":"S18"}}}},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"PolicyVersionList":{"shape":"S4f"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetAccountPasswordPolicy":{"output":{"resultWrapper":"GetAccountPasswordPolicyResult","type":"structure","required":["PasswordPolicy"],"members":{"PasswordPolicy":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"ExpirePasswords":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}}}},"GetAccountSummary":{"output":{"resultWrapper":"GetAccountSummaryResult","type":"structure","members":{"SummaryMap":{"type":"map","key":{},"value":{"type":"integer"}}}}},"GetContextKeysForCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList"],"members":{"PolicyInputList":{"shape":"S4s"}}},"output":{"shape":"S4t","resultWrapper":"GetContextKeysForCustomPolicyResult"}},"GetContextKeysForPrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4s"}}},"output":{"shape":"S4t","resultWrapper":"GetContextKeysForPrincipalPolicyResult"}},"GetCredentialReport":{"output":{"resultWrapper":"GetCredentialReportResult","type":"structure","members":{"Content":{"type":"blob"},"ReportFormat":{},"GeneratedTime":{"type":"timestamp"}}}},"GetGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"GetGroupResult","type":"structure","required":["Group","Users"],"members":{"Group":{"shape":"Ss"},"Users":{"shape":"S52"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"GetGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName"],"members":{"GroupName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetGroupPolicyResult","type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{}}},"output":{"resultWrapper":"GetInstanceProfileResult","type":"structure","required":["InstanceProfile"],"members":{"InstanceProfile":{"shape":"S10"}}}},"GetLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{}}},"output":{"resultWrapper":"GetLoginProfileResult","type":"structure","required":["LoginProfile"],"members":{"LoginProfile":{"shape":"S1d"}}}},"GetMFADevice":{"input":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{},"UserName":{}}},"output":{"resultWrapper":"GetMFADeviceResult","type":"structure","required":["SerialNumber"],"members":{"UserName":{},"SerialNumber":{},"EnableDate":{"type":"timestamp"},"Certifications":{"type":"map","key":{},"value":{}}}}},"GetOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{}}},"output":{"resultWrapper":"GetOpenIDConnectProviderResult","type":"structure","members":{"Url":{},"ClientIDList":{"shape":"S1g"},"ThumbprintList":{"shape":"S1h"},"CreateDate":{"type":"timestamp"},"Tags":{"shape":"Sv"}}}},"GetOrganizationsAccessReport":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{},"SortKey":{}}},"output":{"resultWrapper":"GetOrganizationsAccessReportResult","type":"structure","required":["JobStatus","JobCreationDate"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"NumberOfServicesAccessible":{"type":"integer"},"NumberOfServicesNotAccessed":{"type":"integer"},"AccessDetails":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"ServiceNamespace":{},"Region":{},"EntityPath":{},"LastAuthenticatedTime":{"type":"timestamp"},"TotalAuthenticatedEntities":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"ErrorDetails":{"shape":"S5p"}}}},"GetPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{}}},"output":{"resultWrapper":"GetPolicyResult","type":"structure","members":{"Policy":{"shape":"S1p"}}}},"GetPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}},"output":{"resultWrapper":"GetPolicyVersionResult","type":"structure","members":{"PolicyVersion":{"shape":"S1u"}}}},"GetRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{}}},"output":{"resultWrapper":"GetRoleResult","type":"structure","required":["Role"],"members":{"Role":{"shape":"S12"}}}},"GetRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName"],"members":{"RoleName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetRolePolicyResult","type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"GetSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{}}},"output":{"resultWrapper":"GetSAMLProviderResult","type":"structure","members":{"SAMLMetadataDocument":{},"CreateDate":{"type":"timestamp"},"ValidUntil":{"type":"timestamp"},"Tags":{"shape":"Sv"}}}},"GetSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Encoding"],"members":{"UserName":{},"SSHPublicKeyId":{},"Encoding":{}}},"output":{"resultWrapper":"GetSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S63"}}}},"GetServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{}}},"output":{"resultWrapper":"GetServerCertificateResult","type":"structure","required":["ServerCertificate"],"members":{"ServerCertificate":{"type":"structure","required":["ServerCertificateMetadata","CertificateBody"],"members":{"ServerCertificateMetadata":{"shape":"S69"},"CertificateBody":{},"CertificateChain":{},"Tags":{"shape":"Sv"}}}}}},"GetServiceLastAccessedDetails":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsResult","type":"structure","required":["JobStatus","JobCreationDate","ServicesLastAccessed","JobCompletionDate"],"members":{"JobStatus":{},"JobType":{},"JobCreationDate":{"type":"timestamp"},"ServicesLastAccessed":{"type":"list","member":{"type":"structure","required":["ServiceName","ServiceNamespace"],"members":{"ServiceName":{},"LastAuthenticated":{"type":"timestamp"},"ServiceNamespace":{},"LastAuthenticatedEntity":{},"LastAuthenticatedRegion":{},"TotalAuthenticatedEntities":{"type":"integer"},"TrackedActionsLastAccessed":{"type":"list","member":{"type":"structure","members":{"ActionName":{},"LastAccessedEntity":{},"LastAccessedTime":{"type":"timestamp"},"LastAccessedRegion":{}}}}}}},"JobCompletionDate":{"type":"timestamp"},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5p"}}}},"GetServiceLastAccessedDetailsWithEntities":{"input":{"type":"structure","required":["JobId","ServiceNamespace"],"members":{"JobId":{},"ServiceNamespace":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetServiceLastAccessedDetailsWithEntitiesResult","type":"structure","required":["JobStatus","JobCreationDate","JobCompletionDate","EntityDetailsList"],"members":{"JobStatus":{},"JobCreationDate":{"type":"timestamp"},"JobCompletionDate":{"type":"timestamp"},"EntityDetailsList":{"type":"list","member":{"type":"structure","required":["EntityInfo"],"members":{"EntityInfo":{"type":"structure","required":["Arn","Name","Type","Id"],"members":{"Arn":{},"Name":{},"Type":{},"Id":{},"Path":{}}},"LastAuthenticated":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{},"Error":{"shape":"S5p"}}}},"GetServiceLinkedRoleDeletionStatus":{"input":{"type":"structure","required":["DeletionTaskId"],"members":{"DeletionTaskId":{}}},"output":{"resultWrapper":"GetServiceLinkedRoleDeletionStatusResult","type":"structure","required":["Status"],"members":{"Status":{},"Reason":{"type":"structure","members":{"Reason":{},"RoleUsageList":{"type":"list","member":{"type":"structure","members":{"Region":{},"Resources":{"type":"list","member":{}}}}}}}}}},"GetUser":{"input":{"type":"structure","members":{"UserName":{}}},"output":{"resultWrapper":"GetUserResult","type":"structure","required":["User"],"members":{"User":{"shape":"S2d"}}}},"GetUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName"],"members":{"UserName":{},"PolicyName":{}}},"output":{"resultWrapper":"GetUserPolicyResult","type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"ListAccessKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccessKeysResult","type":"structure","required":["AccessKeyMetadata"],"members":{"AccessKeyMetadata":{"type":"list","member":{"type":"structure","members":{"UserName":{},"AccessKeyId":{},"Status":{},"CreateDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAccountAliases":{"input":{"type":"structure","members":{"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAccountAliasesResult","type":"structure","required":["AccountAliases"],"members":{"AccountAliases":{"type":"list","member":{}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedGroupPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedRolePoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListAttachedUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListAttachedUserPoliciesResult","type":"structure","members":{"AttachedPolicies":{"shape":"S46"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListEntitiesForPolicy":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"EntityFilter":{},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListEntitiesForPolicyResult","type":"structure","members":{"PolicyGroups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupId":{}}}},"PolicyUsers":{"type":"list","member":{"type":"structure","members":{"UserName":{},"UserId":{}}}},"PolicyRoles":{"type":"list","member":{"type":"structure","members":{"RoleName":{},"RoleId":{}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupPolicies":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7p"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroups":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7t"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListGroupsForUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListGroupsForUserResult","type":"structure","required":["Groups"],"members":{"Groups":{"shape":"S7t"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfileTags":{"input":{"type":"structure","required":["InstanceProfileName"],"members":{"InstanceProfileName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfileTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfiles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4c"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListInstanceProfilesForRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListInstanceProfilesForRoleResult","type":"structure","required":["InstanceProfiles"],"members":{"InstanceProfiles":{"shape":"S4c"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListMFADeviceTags":{"input":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListMFADeviceTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListMFADevices":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListMFADevicesResult","type":"structure","required":["MFADevices"],"members":{"MFADevices":{"type":"list","member":{"type":"structure","required":["UserName","SerialNumber","EnableDate"],"members":{"UserName":{},"SerialNumber":{},"EnableDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListOpenIDConnectProviderTags":{"input":{"type":"structure","required":["OpenIDConnectProviderArn"],"members":{"OpenIDConnectProviderArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListOpenIDConnectProviderTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListOpenIDConnectProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListOpenIDConnectProvidersResult","type":"structure","members":{"OpenIDConnectProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}}}}},"ListPolicies":{"input":{"type":"structure","members":{"Scope":{},"OnlyAttached":{"type":"boolean"},"PathPrefix":{},"PolicyUsageFilter":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPoliciesResult","type":"structure","members":{"Policies":{"type":"list","member":{"shape":"S1p"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPoliciesGrantingServiceAccess":{"input":{"type":"structure","required":["Arn","ServiceNamespaces"],"members":{"Marker":{},"Arn":{},"ServiceNamespaces":{"type":"list","member":{}}}},"output":{"resultWrapper":"ListPoliciesGrantingServiceAccessResult","type":"structure","required":["PoliciesGrantingServiceAccess"],"members":{"PoliciesGrantingServiceAccess":{"type":"list","member":{"type":"structure","members":{"ServiceNamespace":{},"Policies":{"type":"list","member":{"type":"structure","required":["PolicyName","PolicyType"],"members":{"PolicyName":{},"PolicyType":{},"PolicyArn":{},"EntityType":{},"EntityName":{}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPolicyTags":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPolicyTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListPolicyVersions":{"input":{"type":"structure","required":["PolicyArn"],"members":{"PolicyArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListPolicyVersionsResult","type":"structure","members":{"Versions":{"shape":"S4f"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRolePolicies":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolePoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7p"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoleTags":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRoleTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListRoles":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListRolesResult","type":"structure","required":["Roles"],"members":{"Roles":{"shape":"S11"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListSAMLProviderTags":{"input":{"type":"structure","required":["SAMLProviderArn"],"members":{"SAMLProviderArn":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSAMLProviderTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListSAMLProviders":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"ListSAMLProvidersResult","type":"structure","members":{"SAMLProviderList":{"type":"list","member":{"type":"structure","members":{"Arn":{},"ValidUntil":{"type":"timestamp"},"CreateDate":{"type":"timestamp"}}}}}}},"ListSSHPublicKeys":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSSHPublicKeysResult","type":"structure","members":{"SSHPublicKeys":{"type":"list","member":{"type":"structure","required":["UserName","SSHPublicKeyId","Status","UploadDate"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{},"UploadDate":{"type":"timestamp"}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServerCertificateTags":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListServerCertificateTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServerCertificates":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListServerCertificatesResult","type":"structure","required":["ServerCertificateMetadataList"],"members":{"ServerCertificateMetadataList":{"type":"list","member":{"shape":"S69"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListServiceSpecificCredentials":{"input":{"type":"structure","members":{"UserName":{},"ServiceName":{}}},"output":{"resultWrapper":"ListServiceSpecificCredentialsResult","type":"structure","members":{"ServiceSpecificCredentials":{"type":"list","member":{"type":"structure","required":["UserName","Status","ServiceUserName","CreateDate","ServiceSpecificCredentialId","ServiceName"],"members":{"UserName":{},"Status":{},"ServiceUserName":{},"CreateDate":{"type":"timestamp"},"ServiceSpecificCredentialId":{},"ServiceName":{}}}}}}},"ListSigningCertificates":{"input":{"type":"structure","members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListSigningCertificatesResult","type":"structure","required":["Certificates"],"members":{"Certificates":{"type":"list","member":{"shape":"S9n"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserPolicies":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserPoliciesResult","type":"structure","required":["PolicyNames"],"members":{"PolicyNames":{"shape":"S7p"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUserTags":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUserTagsResult","type":"structure","required":["Tags"],"members":{"Tags":{"shape":"Sv"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListUsers":{"input":{"type":"structure","members":{"PathPrefix":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListUsersResult","type":"structure","required":["Users"],"members":{"Users":{"shape":"S52"},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"ListVirtualMFADevices":{"input":{"type":"structure","members":{"AssignmentStatus":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"resultWrapper":"ListVirtualMFADevicesResult","type":"structure","required":["VirtualMFADevices"],"members":{"VirtualMFADevices":{"type":"list","member":{"shape":"S2h"}},"IsTruncated":{"type":"boolean"},"Marker":{}}}},"PutGroupPolicy":{"input":{"type":"structure","required":["GroupName","PolicyName","PolicyDocument"],"members":{"GroupName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutRolePermissionsBoundary":{"input":{"type":"structure","required":["RoleName","PermissionsBoundary"],"members":{"RoleName":{},"PermissionsBoundary":{}}}},"PutRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyName","PolicyDocument"],"members":{"RoleName":{},"PolicyName":{},"PolicyDocument":{}}}},"PutUserPermissionsBoundary":{"input":{"type":"structure","required":["UserName","PermissionsBoundary"],"members":{"UserName":{},"PermissionsBoundary":{}}}},"PutUserPolicy":{"input":{"type":"structure","required":["UserName","PolicyName","PolicyDocument"],"members":{"UserName":{},"PolicyName":{},"PolicyDocument":{}}}},"RemoveClientIDFromOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ClientID"],"members":{"OpenIDConnectProviderArn":{},"ClientID":{}}}},"RemoveRoleFromInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","RoleName"],"members":{"InstanceProfileName":{},"RoleName":{}}}},"RemoveUserFromGroup":{"input":{"type":"structure","required":["GroupName","UserName"],"members":{"GroupName":{},"UserName":{}}}},"ResetServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId"],"members":{"UserName":{},"ServiceSpecificCredentialId":{}}},"output":{"resultWrapper":"ResetServiceSpecificCredentialResult","type":"structure","members":{"ServiceSpecificCredential":{"shape":"S27"}}}},"ResyncMFADevice":{"input":{"type":"structure","required":["UserName","SerialNumber","AuthenticationCode1","AuthenticationCode2"],"members":{"UserName":{},"SerialNumber":{},"AuthenticationCode1":{},"AuthenticationCode2":{}}}},"SetDefaultPolicyVersion":{"input":{"type":"structure","required":["PolicyArn","VersionId"],"members":{"PolicyArn":{},"VersionId":{}}}},"SetSecurityTokenServicePreferences":{"input":{"type":"structure","required":["GlobalEndpointTokenVersion"],"members":{"GlobalEndpointTokenVersion":{}}}},"SimulateCustomPolicy":{"input":{"type":"structure","required":["PolicyInputList","ActionNames"],"members":{"PolicyInputList":{"shape":"S4s"},"PermissionsBoundaryPolicyInputList":{"shape":"S4s"},"ActionNames":{"shape":"Sad"},"ResourceArns":{"shape":"Saf"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"Sah"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"San","resultWrapper":"SimulateCustomPolicyResult"}},"SimulatePrincipalPolicy":{"input":{"type":"structure","required":["PolicySourceArn","ActionNames"],"members":{"PolicySourceArn":{},"PolicyInputList":{"shape":"S4s"},"PermissionsBoundaryPolicyInputList":{"shape":"S4s"},"ActionNames":{"shape":"Sad"},"ResourceArns":{"shape":"Saf"},"ResourcePolicy":{},"ResourceOwner":{},"CallerArn":{},"ContextEntries":{"shape":"Sah"},"ResourceHandlingOption":{},"MaxItems":{"type":"integer"},"Marker":{}}},"output":{"shape":"San","resultWrapper":"SimulatePrincipalPolicyResult"}},"TagInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","Tags"],"members":{"InstanceProfileName":{},"Tags":{"shape":"Sv"}}}},"TagMFADevice":{"input":{"type":"structure","required":["SerialNumber","Tags"],"members":{"SerialNumber":{},"Tags":{"shape":"Sv"}}}},"TagOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","Tags"],"members":{"OpenIDConnectProviderArn":{},"Tags":{"shape":"Sv"}}}},"TagPolicy":{"input":{"type":"structure","required":["PolicyArn","Tags"],"members":{"PolicyArn":{},"Tags":{"shape":"Sv"}}}},"TagRole":{"input":{"type":"structure","required":["RoleName","Tags"],"members":{"RoleName":{},"Tags":{"shape":"Sv"}}}},"TagSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn","Tags"],"members":{"SAMLProviderArn":{},"Tags":{"shape":"Sv"}}}},"TagServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","Tags"],"members":{"ServerCertificateName":{},"Tags":{"shape":"Sv"}}}},"TagUser":{"input":{"type":"structure","required":["UserName","Tags"],"members":{"UserName":{},"Tags":{"shape":"Sv"}}}},"UntagInstanceProfile":{"input":{"type":"structure","required":["InstanceProfileName","TagKeys"],"members":{"InstanceProfileName":{},"TagKeys":{"shape":"Sbe"}}}},"UntagMFADevice":{"input":{"type":"structure","required":["SerialNumber","TagKeys"],"members":{"SerialNumber":{},"TagKeys":{"shape":"Sbe"}}}},"UntagOpenIDConnectProvider":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","TagKeys"],"members":{"OpenIDConnectProviderArn":{},"TagKeys":{"shape":"Sbe"}}}},"UntagPolicy":{"input":{"type":"structure","required":["PolicyArn","TagKeys"],"members":{"PolicyArn":{},"TagKeys":{"shape":"Sbe"}}}},"UntagRole":{"input":{"type":"structure","required":["RoleName","TagKeys"],"members":{"RoleName":{},"TagKeys":{"shape":"Sbe"}}}},"UntagSAMLProvider":{"input":{"type":"structure","required":["SAMLProviderArn","TagKeys"],"members":{"SAMLProviderArn":{},"TagKeys":{"shape":"Sbe"}}}},"UntagServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","TagKeys"],"members":{"ServerCertificateName":{},"TagKeys":{"shape":"Sbe"}}}},"UntagUser":{"input":{"type":"structure","required":["UserName","TagKeys"],"members":{"UserName":{},"TagKeys":{"shape":"Sbe"}}}},"UpdateAccessKey":{"input":{"type":"structure","required":["AccessKeyId","Status"],"members":{"UserName":{},"AccessKeyId":{},"Status":{}}}},"UpdateAccountPasswordPolicy":{"input":{"type":"structure","members":{"MinimumPasswordLength":{"type":"integer"},"RequireSymbols":{"type":"boolean"},"RequireNumbers":{"type":"boolean"},"RequireUppercaseCharacters":{"type":"boolean"},"RequireLowercaseCharacters":{"type":"boolean"},"AllowUsersToChangePassword":{"type":"boolean"},"MaxPasswordAge":{"type":"integer"},"PasswordReusePrevention":{"type":"integer"},"HardExpiry":{"type":"boolean"}}}},"UpdateAssumeRolePolicy":{"input":{"type":"structure","required":["RoleName","PolicyDocument"],"members":{"RoleName":{},"PolicyDocument":{}}}},"UpdateGroup":{"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"NewPath":{},"NewGroupName":{}}}},"UpdateLoginProfile":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"Password":{"shape":"Sf"},"PasswordResetRequired":{"type":"boolean"}}}},"UpdateOpenIDConnectProviderThumbprint":{"input":{"type":"structure","required":["OpenIDConnectProviderArn","ThumbprintList"],"members":{"OpenIDConnectProviderArn":{},"ThumbprintList":{"shape":"S1h"}}}},"UpdateRole":{"input":{"type":"structure","required":["RoleName"],"members":{"RoleName":{},"Description":{},"MaxSessionDuration":{"type":"integer"}}},"output":{"resultWrapper":"UpdateRoleResult","type":"structure","members":{}}},"UpdateRoleDescription":{"input":{"type":"structure","required":["RoleName","Description"],"members":{"RoleName":{},"Description":{}}},"output":{"resultWrapper":"UpdateRoleDescriptionResult","type":"structure","members":{"Role":{"shape":"S12"}}}},"UpdateSAMLProvider":{"input":{"type":"structure","required":["SAMLMetadataDocument","SAMLProviderArn"],"members":{"SAMLMetadataDocument":{},"SAMLProviderArn":{}}},"output":{"resultWrapper":"UpdateSAMLProviderResult","type":"structure","members":{"SAMLProviderArn":{}}}},"UpdateSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyId","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Status":{}}}},"UpdateServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName"],"members":{"ServerCertificateName":{},"NewPath":{},"NewServerCertificateName":{}}}},"UpdateServiceSpecificCredential":{"input":{"type":"structure","required":["ServiceSpecificCredentialId","Status"],"members":{"UserName":{},"ServiceSpecificCredentialId":{},"Status":{}}}},"UpdateSigningCertificate":{"input":{"type":"structure","required":["CertificateId","Status"],"members":{"UserName":{},"CertificateId":{},"Status":{}}}},"UpdateUser":{"input":{"type":"structure","required":["UserName"],"members":{"UserName":{},"NewPath":{},"NewUserName":{}}}},"UploadSSHPublicKey":{"input":{"type":"structure","required":["UserName","SSHPublicKeyBody"],"members":{"UserName":{},"SSHPublicKeyBody":{}}},"output":{"resultWrapper":"UploadSSHPublicKeyResult","type":"structure","members":{"SSHPublicKey":{"shape":"S63"}}}},"UploadServerCertificate":{"input":{"type":"structure","required":["ServerCertificateName","CertificateBody","PrivateKey"],"members":{"Path":{},"ServerCertificateName":{},"CertificateBody":{},"PrivateKey":{"type":"string","sensitive":true},"CertificateChain":{},"Tags":{"shape":"Sv"}}},"output":{"resultWrapper":"UploadServerCertificateResult","type":"structure","members":{"ServerCertificateMetadata":{"shape":"S69"},"Tags":{"shape":"Sv"}}}},"UploadSigningCertificate":{"input":{"type":"structure","required":["CertificateBody"],"members":{"UserName":{},"CertificateBody":{}}},"output":{"resultWrapper":"UploadSigningCertificateResult","type":"structure","required":["Certificate"],"members":{"Certificate":{"shape":"S9n"}}}}},"shapes":{"Sf":{"type":"string","sensitive":true},"Ss":{"type":"structure","required":["Path","GroupName","GroupId","Arn","CreateDate"],"members":{"Path":{},"GroupName":{},"GroupId":{},"Arn":{},"CreateDate":{"type":"timestamp"}}},"Sv":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S10":{"type":"structure","required":["Path","InstanceProfileName","InstanceProfileId","Arn","CreateDate","Roles"],"members":{"Path":{},"InstanceProfileName":{},"InstanceProfileId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"Roles":{"shape":"S11"},"Tags":{"shape":"Sv"}}},"S11":{"type":"list","member":{"shape":"S12"}},"S12":{"type":"structure","required":["Path","RoleName","RoleId","Arn","CreateDate"],"members":{"Path":{},"RoleName":{},"RoleId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"AssumeRolePolicyDocument":{},"Description":{},"MaxSessionDuration":{"type":"integer"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"},"RoleLastUsed":{"shape":"S18"}}},"S16":{"type":"structure","members":{"PermissionsBoundaryType":{},"PermissionsBoundaryArn":{}}},"S18":{"type":"structure","members":{"LastUsedDate":{"type":"timestamp"},"Region":{}}},"S1d":{"type":"structure","required":["UserName","CreateDate"],"members":{"UserName":{},"CreateDate":{"type":"timestamp"},"PasswordResetRequired":{"type":"boolean"}}},"S1g":{"type":"list","member":{}},"S1h":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"PolicyName":{},"PolicyId":{},"Arn":{},"Path":{},"DefaultVersionId":{},"AttachmentCount":{"type":"integer"},"PermissionsBoundaryUsageCount":{"type":"integer"},"IsAttachable":{"type":"boolean"},"Description":{},"CreateDate":{"type":"timestamp"},"UpdateDate":{"type":"timestamp"},"Tags":{"shape":"Sv"}}},"S1u":{"type":"structure","members":{"Document":{},"VersionId":{},"IsDefaultVersion":{"type":"boolean"},"CreateDate":{"type":"timestamp"}}},"S27":{"type":"structure","required":["CreateDate","ServiceName","ServiceUserName","ServicePassword","ServiceSpecificCredentialId","UserName","Status"],"members":{"CreateDate":{"type":"timestamp"},"ServiceName":{},"ServiceUserName":{},"ServicePassword":{"type":"string","sensitive":true},"ServiceSpecificCredentialId":{},"UserName":{},"Status":{}}},"S2d":{"type":"structure","required":["Path","UserName","UserId","Arn","CreateDate"],"members":{"Path":{},"UserName":{},"UserId":{},"Arn":{},"CreateDate":{"type":"timestamp"},"PasswordLastUsed":{"type":"timestamp"},"PermissionsBoundary":{"shape":"S16"},"Tags":{"shape":"Sv"}}},"S2h":{"type":"structure","required":["SerialNumber"],"members":{"SerialNumber":{},"Base32StringSeed":{"shape":"S2j"},"QRCodePNG":{"shape":"S2j"},"User":{"shape":"S2d"},"EnableDate":{"type":"timestamp"},"Tags":{"shape":"Sv"}}},"S2j":{"type":"blob","sensitive":true},"S43":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyDocument":{}}}},"S46":{"type":"list","member":{"type":"structure","members":{"PolicyName":{},"PolicyArn":{}}}},"S4c":{"type":"list","member":{"shape":"S10"}},"S4f":{"type":"list","member":{"shape":"S1u"}},"S4s":{"type":"list","member":{}},"S4t":{"type":"structure","members":{"ContextKeyNames":{"shape":"S4u"}}},"S4u":{"type":"list","member":{}},"S52":{"type":"list","member":{"shape":"S2d"}},"S5p":{"type":"structure","required":["Message","Code"],"members":{"Message":{},"Code":{}}},"S63":{"type":"structure","required":["UserName","SSHPublicKeyId","Fingerprint","SSHPublicKeyBody","Status"],"members":{"UserName":{},"SSHPublicKeyId":{},"Fingerprint":{},"SSHPublicKeyBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"S69":{"type":"structure","required":["Path","ServerCertificateName","ServerCertificateId","Arn"],"members":{"Path":{},"ServerCertificateName":{},"ServerCertificateId":{},"Arn":{},"UploadDate":{"type":"timestamp"},"Expiration":{"type":"timestamp"}}},"S7p":{"type":"list","member":{}},"S7t":{"type":"list","member":{"shape":"Ss"}},"S9n":{"type":"structure","required":["UserName","CertificateId","CertificateBody","Status"],"members":{"UserName":{},"CertificateId":{},"CertificateBody":{},"Status":{},"UploadDate":{"type":"timestamp"}}},"Sad":{"type":"list","member":{}},"Saf":{"type":"list","member":{}},"Sah":{"type":"list","member":{"type":"structure","members":{"ContextKeyName":{},"ContextKeyValues":{"type":"list","member":{}},"ContextKeyType":{}}}},"San":{"type":"structure","members":{"EvaluationResults":{"type":"list","member":{"type":"structure","required":["EvalActionName","EvalDecision"],"members":{"EvalActionName":{},"EvalResourceName":{},"EvalDecision":{},"MatchedStatements":{"shape":"Sar"},"MissingContextValues":{"shape":"S4u"},"OrganizationsDecisionDetail":{"type":"structure","members":{"AllowedByOrganizations":{"type":"boolean"}}},"PermissionsBoundaryDecisionDetail":{"shape":"Saz"},"EvalDecisionDetails":{"shape":"Sb0"},"ResourceSpecificResults":{"type":"list","member":{"type":"structure","required":["EvalResourceName","EvalResourceDecision"],"members":{"EvalResourceName":{},"EvalResourceDecision":{},"MatchedStatements":{"shape":"Sar"},"MissingContextValues":{"shape":"S4u"},"EvalDecisionDetails":{"shape":"Sb0"},"PermissionsBoundaryDecisionDetail":{"shape":"Saz"}}}}}}},"IsTruncated":{"type":"boolean"},"Marker":{}}},"Sar":{"type":"list","member":{"type":"structure","members":{"SourcePolicyId":{},"SourcePolicyType":{},"StartPosition":{"shape":"Sav"},"EndPosition":{"shape":"Sav"}}}},"Sav":{"type":"structure","members":{"Line":{"type":"integer"},"Column":{"type":"integer"}}},"Saz":{"type":"structure","members":{"AllowedByPermissionsBoundary":{"type":"boolean"}}},"Sb0":{"type":"map","key":{},"value":{}},"Sbe":{"type":"list","member":{}}}}

/***/ }),
/* 518 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetAccountAuthorizationDetails":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["UserDetailList","GroupDetailList","RoleDetailList","Policies"]},"GetGroup":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListAccessKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccessKeyMetadata"},"ListAccountAliases":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AccountAliases"},"ListAttachedGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListAttachedUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"AttachedPolicies"},"ListEntitiesForPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":["PolicyGroups","PolicyUsers","PolicyRoles"]},"ListGroupPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListGroups":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListGroupsForUser":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Groups"},"ListInstanceProfileTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListInstanceProfiles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListInstanceProfilesForRole":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"InstanceProfiles"},"ListMFADeviceTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"MFADevices"},"ListOpenIDConnectProviderTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Policies"},"ListPolicyTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListPolicyVersions":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Versions"},"ListRolePolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListRoleTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListRoles":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Roles"},"ListSAMLProviderTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListSAMLProviders":{"result_key":"SAMLProviderList"},"ListSSHPublicKeys":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"SSHPublicKeys"},"ListServerCertificateTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListServerCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"ServerCertificateMetadataList"},"ListSigningCertificates":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Certificates"},"ListUserPolicies":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"PolicyNames"},"ListUserTags":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Tags"},"ListUsers":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"Users"},"ListVirtualMFADevices":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"VirtualMFADevices"},"SimulateCustomPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"},"SimulatePrincipalPolicy":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"Marker","result_key":"EvaluationResults"}}}

/***/ }),
/* 519 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"InstanceProfileExists":{"delay":1,"operation":"GetInstanceProfile","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"state":"retry","matcher":"status","expected":404}]},"UserExists":{"delay":1,"operation":"GetUser","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"RoleExists":{"delay":1,"operation":"GetRole","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]},"PolicyExists":{"delay":1,"operation":"GetPolicy","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"NoSuchEntity"}]}}}

/***/ }),
/* 520 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-02-16","endpointPrefix":"inspector","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Inspector","serviceId":"Inspector","signatureVersion":"v4","targetPrefix":"InspectorService","uid":"inspector-2016-02-16"},"operations":{"AddAttributesToFindings":{"input":{"type":"structure","required":["findingArns","attributes"],"members":{"findingArns":{"shape":"S2"},"attributes":{"shape":"S4"}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"CreateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetName"],"members":{"assessmentTargetName":{},"resourceGroupArn":{}}},"output":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"CreateAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTemplateName","durationInSeconds","rulesPackageArns"],"members":{"assessmentTargetArn":{},"assessmentTemplateName":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"}}},"output":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"CreateExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}},"output":{"type":"structure","required":["previewToken"],"members":{"previewToken":{}}}},"CreateResourceGroup":{"input":{"type":"structure","required":["resourceGroupTags"],"members":{"resourceGroupTags":{"shape":"Sp"}}},"output":{"type":"structure","required":["resourceGroupArn"],"members":{"resourceGroupArn":{}}}},"DeleteAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"DeleteAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn"],"members":{"assessmentTargetArn":{}}}},"DeleteAssessmentTemplate":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{}}}},"DescribeAssessmentRuns":{"input":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentRuns","failedItems"],"members":{"assessmentRuns":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTemplateArn","state","durationInSeconds","rulesPackageArns","userAttributesForFindings","createdAt","stateChangedAt","dataCollected","stateChanges","notifications","findingCounts"],"members":{"arn":{},"name":{},"assessmentTemplateArn":{},"state":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"type":"list","member":{}},"userAttributesForFindings":{"shape":"S4"},"createdAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"stateChangedAt":{"type":"timestamp"},"dataCollected":{"type":"boolean"},"stateChanges":{"type":"list","member":{"type":"structure","required":["stateChangedAt","state"],"members":{"stateChangedAt":{"type":"timestamp"},"state":{}}}},"notifications":{"type":"list","member":{"type":"structure","required":["date","event","error"],"members":{"date":{"type":"timestamp"},"event":{},"message":{},"error":{"type":"boolean"},"snsTopicArn":{},"snsPublishStatusCode":{}}}},"findingCounts":{"type":"map","key":{},"value":{"type":"integer"}}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTargets":{"input":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTargets","failedItems"],"members":{"assessmentTargets":{"type":"list","member":{"type":"structure","required":["arn","name","createdAt","updatedAt"],"members":{"arn":{},"name":{},"resourceGroupArn":{},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeAssessmentTemplates":{"input":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["assessmentTemplates","failedItems"],"members":{"assessmentTemplates":{"type":"list","member":{"type":"structure","required":["arn","name","assessmentTargetArn","durationInSeconds","rulesPackageArns","userAttributesForFindings","assessmentRunCount","createdAt"],"members":{"arn":{},"name":{},"assessmentTargetArn":{},"durationInSeconds":{"type":"integer"},"rulesPackageArns":{"shape":"Sj"},"userAttributesForFindings":{"shape":"S4"},"lastAssessmentRunArn":{},"assessmentRunCount":{"type":"integer"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeCrossAccountAccessRole":{"output":{"type":"structure","required":["roleArn","valid","registeredAt"],"members":{"roleArn":{},"valid":{"type":"boolean"},"registeredAt":{"type":"timestamp"}}}},"DescribeExclusions":{"input":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"type":"list","member":{}},"locale":{}}},"output":{"type":"structure","required":["exclusions","failedItems"],"members":{"exclusions":{"type":"map","key":{},"value":{"type":"structure","required":["arn","title","description","recommendation","scopes"],"members":{"arn":{},"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"failedItems":{"shape":"S9"}}}},"DescribeFindings":{"input":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["findings","failedItems"],"members":{"findings":{"type":"list","member":{"type":"structure","required":["arn","attributes","userAttributes","createdAt","updatedAt"],"members":{"arn":{},"schemaVersion":{"type":"integer"},"service":{},"serviceAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"assessmentRunArn":{},"rulesPackageArn":{}}},"assetType":{},"assetAttributes":{"type":"structure","required":["schemaVersion"],"members":{"schemaVersion":{"type":"integer"},"agentId":{},"autoScalingGroup":{},"amiId":{},"hostname":{},"ipv4Addresses":{"type":"list","member":{}},"tags":{"type":"list","member":{"shape":"S2i"}},"networkInterfaces":{"type":"list","member":{"type":"structure","members":{"networkInterfaceId":{},"subnetId":{},"vpcId":{},"privateDnsName":{},"privateIpAddress":{},"privateIpAddresses":{"type":"list","member":{"type":"structure","members":{"privateDnsName":{},"privateIpAddress":{}}}},"publicDnsName":{},"publicIp":{},"ipv6Addresses":{"type":"list","member":{}},"securityGroups":{"type":"list","member":{"type":"structure","members":{"groupName":{},"groupId":{}}}}}}}}},"id":{},"title":{},"description":{},"recommendation":{},"severity":{},"numericSeverity":{"type":"double"},"confidence":{"type":"integer"},"indicatorOfCompromise":{"type":"boolean"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S4"},"createdAt":{"type":"timestamp"},"updatedAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeResourceGroups":{"input":{"type":"structure","required":["resourceGroupArns"],"members":{"resourceGroupArns":{"shape":"Sy"}}},"output":{"type":"structure","required":["resourceGroups","failedItems"],"members":{"resourceGroups":{"type":"list","member":{"type":"structure","required":["arn","tags","createdAt"],"members":{"arn":{},"tags":{"shape":"Sp"},"createdAt":{"type":"timestamp"}}}},"failedItems":{"shape":"S9"}}}},"DescribeRulesPackages":{"input":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"Sy"},"locale":{}}},"output":{"type":"structure","required":["rulesPackages","failedItems"],"members":{"rulesPackages":{"type":"list","member":{"type":"structure","required":["arn","name","version","provider"],"members":{"arn":{},"name":{},"version":{},"provider":{},"description":{}}}},"failedItems":{"shape":"S9"}}}},"GetAssessmentReport":{"input":{"type":"structure","required":["assessmentRunArn","reportFileFormat","reportType"],"members":{"assessmentRunArn":{},"reportFileFormat":{},"reportType":{}}},"output":{"type":"structure","required":["status"],"members":{"status":{},"url":{}}}},"GetExclusionsPreview":{"input":{"type":"structure","required":["assessmentTemplateArn","previewToken"],"members":{"assessmentTemplateArn":{},"previewToken":{},"nextToken":{},"maxResults":{"type":"integer"},"locale":{}}},"output":{"type":"structure","required":["previewStatus"],"members":{"previewStatus":{},"exclusionPreviews":{"type":"list","member":{"type":"structure","required":["title","description","recommendation","scopes"],"members":{"title":{},"description":{},"recommendation":{},"scopes":{"shape":"S1x"},"attributes":{"shape":"S21"}}}},"nextToken":{}}}},"GetTelemetryMetadata":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}},"output":{"type":"structure","required":["telemetryMetadata"],"members":{"telemetryMetadata":{"shape":"S3j"}}}},"ListAssessmentRunAgents":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"filter":{"type":"structure","required":["agentHealths","agentHealthCodes"],"members":{"agentHealths":{"type":"list","member":{}},"agentHealthCodes":{"type":"list","member":{}}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunAgents"],"members":{"assessmentRunAgents":{"type":"list","member":{"type":"structure","required":["agentId","assessmentRunArn","agentHealth","agentHealthCode","telemetryMetadata"],"members":{"agentId":{},"assessmentRunArn":{},"agentHealth":{},"agentHealthCode":{},"agentHealthDetails":{},"autoScalingGroup":{},"telemetryMetadata":{"shape":"S3j"}}}},"nextToken":{}}}},"ListAssessmentRuns":{"input":{"type":"structure","members":{"assessmentTemplateArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"states":{"type":"list","member":{}},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"},"startTimeRange":{"shape":"S43"},"completionTimeRange":{"shape":"S43"},"stateChangeTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentRunArns"],"members":{"assessmentRunArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTargets":{"input":{"type":"structure","members":{"filter":{"type":"structure","members":{"assessmentTargetNamePattern":{}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTargetArns"],"members":{"assessmentTargetArns":{"shape":"S45"},"nextToken":{}}}},"ListAssessmentTemplates":{"input":{"type":"structure","members":{"assessmentTargetArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"namePattern":{},"durationRange":{"shape":"S41"},"rulesPackageArns":{"shape":"S42"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["assessmentTemplateArns"],"members":{"assessmentTemplateArns":{"shape":"S45"},"nextToken":{}}}},"ListEventSubscriptions":{"input":{"type":"structure","members":{"resourceArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["subscriptions"],"members":{"subscriptions":{"type":"list","member":{"type":"structure","required":["resourceArn","topicArn","eventSubscriptions"],"members":{"resourceArn":{},"topicArn":{},"eventSubscriptions":{"type":"list","member":{"type":"structure","required":["event","subscribedAt"],"members":{"event":{},"subscribedAt":{"type":"timestamp"}}}}}}},"nextToken":{}}}},"ListExclusions":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["exclusionArns"],"members":{"exclusionArns":{"shape":"S45"},"nextToken":{}}}},"ListFindings":{"input":{"type":"structure","members":{"assessmentRunArns":{"shape":"S3x"},"filter":{"type":"structure","members":{"agentIds":{"type":"list","member":{}},"autoScalingGroups":{"type":"list","member":{}},"ruleNames":{"type":"list","member":{}},"severities":{"type":"list","member":{}},"rulesPackageArns":{"shape":"S42"},"attributes":{"shape":"S21"},"userAttributes":{"shape":"S21"},"creationTimeRange":{"shape":"S43"}}},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["findingArns"],"members":{"findingArns":{"shape":"S45"},"nextToken":{}}}},"ListRulesPackages":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["rulesPackageArns"],"members":{"rulesPackageArns":{"shape":"S45"},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","required":["tags"],"members":{"tags":{"shape":"S4x"}}}},"PreviewAgents":{"input":{"type":"structure","required":["previewAgentsArn"],"members":{"previewAgentsArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","required":["agentPreviews"],"members":{"agentPreviews":{"type":"list","member":{"type":"structure","required":["agentId"],"members":{"hostname":{},"agentId":{},"autoScalingGroup":{},"agentHealth":{},"agentVersion":{},"operatingSystem":{},"kernelVersion":{},"ipv4Address":{}}}},"nextToken":{}}}},"RegisterCrossAccountAccessRole":{"input":{"type":"structure","required":["roleArn"],"members":{"roleArn":{}}}},"RemoveAttributesFromFindings":{"input":{"type":"structure","required":["findingArns","attributeKeys"],"members":{"findingArns":{"shape":"S2"},"attributeKeys":{"type":"list","member":{}}}},"output":{"type":"structure","required":["failedItems"],"members":{"failedItems":{"shape":"S9"}}}},"SetTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{},"tags":{"shape":"S4x"}}}},"StartAssessmentRun":{"input":{"type":"structure","required":["assessmentTemplateArn"],"members":{"assessmentTemplateArn":{},"assessmentRunName":{}}},"output":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{}}}},"StopAssessmentRun":{"input":{"type":"structure","required":["assessmentRunArn"],"members":{"assessmentRunArn":{},"stopAction":{}}}},"SubscribeToEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UnsubscribeFromEvent":{"input":{"type":"structure","required":["resourceArn","event","topicArn"],"members":{"resourceArn":{},"event":{},"topicArn":{}}}},"UpdateAssessmentTarget":{"input":{"type":"structure","required":["assessmentTargetArn","assessmentTargetName"],"members":{"assessmentTargetArn":{},"assessmentTargetName":{},"resourceGroupArn":{}}}}},"shapes":{"S2":{"type":"list","member":{}},"S4":{"type":"list","member":{"shape":"S5"}},"S5":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S9":{"type":"map","key":{},"value":{"type":"structure","required":["failureCode","retryable"],"members":{"failureCode":{},"retryable":{"type":"boolean"}}}},"Sj":{"type":"list","member":{}},"Sp":{"type":"list","member":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{}},"S1x":{"type":"list","member":{"type":"structure","members":{"key":{},"value":{}}}},"S21":{"type":"list","member":{"shape":"S5"}},"S2i":{"type":"structure","required":["key"],"members":{"key":{},"value":{}}},"S3j":{"type":"list","member":{"type":"structure","required":["messageType","count"],"members":{"messageType":{},"count":{"type":"long"},"dataSize":{"type":"long"}}}},"S3x":{"type":"list","member":{}},"S41":{"type":"structure","members":{"minSeconds":{"type":"integer"},"maxSeconds":{"type":"integer"}}},"S42":{"type":"list","member":{}},"S43":{"type":"structure","members":{"beginDate":{"type":"timestamp"},"endDate":{"type":"timestamp"}}},"S45":{"type":"list","member":{}},"S4x":{"type":"list","member":{"shape":"S2i"}}}}

/***/ }),
/* 521 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetExclusionsPreview":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRunAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentRuns":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTargets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListAssessmentTemplates":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListEventSubscriptions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListExclusions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListFindings":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListRulesPackages":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"PreviewAgents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 522 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"iot","protocol":"rest-json","serviceFullName":"AWS IoT","serviceId":"IoT","signatureVersion":"v4","signingName":"iot","uid":"iot-2015-05-28"},"operations":{"AcceptCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/accept-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}}},"AddThingToBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/addThingToBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"AddThingToThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/addThingToThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"AssociateTargetsWithJob":{"http":{"requestUri":"/jobs/{jobId}/targets"},"input":{"type":"structure","required":["targets","jobId"],"members":{"targets":{"shape":"Sg"},"jobId":{"location":"uri","locationName":"jobId"},"comment":{},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"AttachPolicy":{"http":{"method":"PUT","requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"AttachPrincipalPolicy":{"http":{"method":"PUT","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"AttachSecurityProfile":{"http":{"method":"PUT","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"AttachThingPrincipal":{"http":{"method":"PUT","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"CancelAuditMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/audit/mitigationactions/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelAuditTask":{"http":{"method":"PUT","requestUri":"/audit/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/cancel-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}}},"CancelDetectMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/detect/mitigationactions/tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"CancelJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"reasonCode":{},"comment":{},"force":{"location":"querystring","locationName":"force","type":"boolean"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CancelJobExecution":{"http":{"method":"PUT","requestUri":"/things/{thingName}/jobs/{jobId}/cancel"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"expectedVersion":{"type":"long"},"statusDetails":{"shape":"S1e"}}}},"ClearDefaultAuthorizer":{"http":{"method":"DELETE","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ConfirmTopicRuleDestination":{"http":{"method":"GET","requestUri":"/confirmdestination/{confirmationToken+}"},"input":{"type":"structure","required":["confirmationToken"],"members":{"confirmationToken":{"location":"uri","locationName":"confirmationToken"}}},"output":{"type":"structure","members":{}}},"CreateAuditSuppression":{"http":{"requestUri":"/audit/suppressions/create"},"input":{"type":"structure","required":["checkName","resourceIdentifier","clientRequestToken"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"CreateAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName","authorizerFunctionArn"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S2a"},"status":{},"tags":{"shape":"S2e"},"signingDisabled":{"type":"boolean"},"enableCachingForHttp":{"type":"boolean"}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"CreateBillingGroup":{"http":{"requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S2n"},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"billingGroupId":{}}}},"CreateCertificateFromCsr":{"http":{"requestUri":"/certificates"},"input":{"type":"structure","required":["certificateSigningRequest"],"members":{"certificateSigningRequest":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{}}}},"CreateCertificateProvider":{"http":{"requestUri":"/certificate-providers/{certificateProviderName}"},"input":{"type":"structure","required":["certificateProviderName","lambdaFunctionArn","accountDefaultForOperations"],"members":{"certificateProviderName":{"location":"uri","locationName":"certificateProviderName"},"lambdaFunctionArn":{},"accountDefaultForOperations":{"shape":"S2y"},"clientToken":{"idempotencyToken":true},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"certificateProviderName":{},"certificateProviderArn":{}}}},"CreateCustomMetric":{"http":{"requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName","metricType","clientRequestToken"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"displayName":{},"metricType":{},"tags":{"shape":"S2e"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{}}}},"CreateDimension":{"http":{"requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name","type","stringValues","clientRequestToken"],"members":{"name":{"location":"uri","locationName":"name"},"type":{},"stringValues":{"shape":"S3c"},"tags":{"shape":"S2e"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"name":{},"arn":{}}}},"CreateDomainConfiguration":{"http":{"requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"},"domainName":{},"serverCertificateArns":{"type":"list","member":{}},"validationCertificateArn":{},"authorizerConfig":{"shape":"S3l"},"serviceType":{},"tags":{"shape":"S2e"},"tlsConfig":{"shape":"S3o"},"serverCertificateConfig":{"shape":"S3q"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{}}}},"CreateDynamicThingGroup":{"http":{"requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","queryString"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S3v"},"indexName":{},"queryString":{},"queryVersion":{},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{},"indexName":{},"queryString":{},"queryVersion":{}}}},"CreateFleetMetric":{"http":{"method":"PUT","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName","queryString","aggregationType","period","aggregationField"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"queryString":{},"aggregationType":{"shape":"S49"},"period":{"type":"integer"},"aggregationField":{},"description":{},"queryVersion":{},"indexName":{},"unit":{},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{}}}},"CreateJob":{"http":{"method":"PUT","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","targets"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"targets":{"shape":"Sg"},"documentSource":{},"document":{},"description":{},"presignedUrlConfig":{"shape":"S4m"},"targetSelection":{},"jobExecutionsRolloutConfig":{"shape":"S4p"},"abortConfig":{"shape":"S4w"},"timeoutConfig":{"shape":"S53"},"tags":{"shape":"S2e"},"namespaceId":{},"jobTemplateArn":{},"jobExecutionsRetryConfig":{"shape":"S56"},"documentParameters":{"shape":"S5b"},"schedulingConfig":{"shape":"S5e"},"destinationPackageVersions":{"shape":"S5l"}}},"output":{"type":"structure","members":{"jobArn":{},"jobId":{},"description":{}}}},"CreateJobTemplate":{"http":{"method":"PUT","requestUri":"/job-templates/{jobTemplateId}"},"input":{"type":"structure","required":["jobTemplateId","description"],"members":{"jobTemplateId":{"location":"uri","locationName":"jobTemplateId"},"jobArn":{},"documentSource":{},"document":{},"description":{},"presignedUrlConfig":{"shape":"S4m"},"jobExecutionsRolloutConfig":{"shape":"S4p"},"abortConfig":{"shape":"S4w"},"timeoutConfig":{"shape":"S53"},"tags":{"shape":"S2e"},"jobExecutionsRetryConfig":{"shape":"S56"},"maintenanceWindows":{"shape":"S5h"},"destinationPackageVersions":{"shape":"S5l"}}},"output":{"type":"structure","members":{"jobTemplateArn":{},"jobTemplateId":{}}}},"CreateKeysAndCertificate":{"http":{"requestUri":"/keys-and-certificate"},"input":{"type":"structure","members":{"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"certificatePem":{},"keyPair":{"shape":"S5t"}}}},"CreateMitigationAction":{"http":{"requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName","roleArn","actionParams"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S5y"},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"CreateOTAUpdate":{"http":{"requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId","targets","files","roleArn"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"description":{},"targets":{"shape":"S6i"},"protocols":{"shape":"S6k"},"targetSelection":{},"awsJobExecutionsRolloutConfig":{"shape":"S6m"},"awsJobPresignedUrlConfig":{"shape":"S6t"},"awsJobAbortConfig":{"type":"structure","required":["abortCriteriaList"],"members":{"abortCriteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"awsJobTimeoutConfig":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}},"files":{"shape":"S74"},"roleArn":{},"additionalParameters":{"shape":"S82"},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"otaUpdateId":{},"awsIotJobId":{},"otaUpdateArn":{},"awsIotJobArn":{},"otaUpdateStatus":{}}}},"CreatePackage":{"http":{"method":"PUT","requestUri":"/packages/{packageName}","responseCode":200},"input":{"type":"structure","required":["packageName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"description":{"shape":"S8a"},"tags":{"shape":"S8b"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{"packageName":{},"packageArn":{},"description":{"shape":"S8a"}}},"idempotent":true},"CreatePackageVersion":{"http":{"method":"PUT","requestUri":"/packages/{packageName}/versions/{versionName}","responseCode":200},"input":{"type":"structure","required":["packageName","versionName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"versionName":{"location":"uri","locationName":"versionName"},"description":{"shape":"S8a"},"attributes":{"shape":"S8g"},"tags":{"shape":"S8b"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{"packageVersionArn":{},"packageName":{},"versionName":{},"description":{"shape":"S8a"},"attributes":{"shape":"S8g"},"status":{},"errorReason":{}}},"idempotent":true},"CreatePolicy":{"http":{"requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"policyVersionId":{}}}},"CreatePolicyVersion":{"http":{"requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName","policyDocument"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyDocument":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"policyArn":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"}}}},"CreateProvisioningClaim":{"http":{"requestUri":"/provisioning-templates/{templateName}/provisioning-claim"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{"certificateId":{},"certificatePem":{},"keyPair":{"shape":"S5t"},"expiration":{"type":"timestamp"}}}},"CreateProvisioningTemplate":{"http":{"requestUri":"/provisioning-templates"},"input":{"type":"structure","required":["templateName","templateBody","provisioningRoleArn"],"members":{"templateName":{},"description":{},"templateBody":{},"enabled":{"type":"boolean"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S92"},"tags":{"shape":"S2e"},"type":{}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"defaultVersionId":{"type":"integer"}}}},"CreateProvisioningTemplateVersion":{"http":{"requestUri":"/provisioning-templates/{templateName}/versions"},"input":{"type":"structure","required":["templateName","templateBody"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"templateBody":{},"setAsDefault":{"location":"querystring","locationName":"setAsDefault","type":"boolean"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"versionId":{"type":"integer"},"isDefaultVersion":{"type":"boolean"}}}},"CreateRoleAlias":{"http":{"requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias","roleArn"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"CreateScheduledAudit":{"http":{"requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["frequency","targetCheckNames","scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S9i"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"CreateSecurityProfile":{"http":{"requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S9o"},"alertTargets":{"shape":"Saf"},"additionalMetricsToRetain":{"shape":"Saj","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"Sak"},"tags":{"shape":"S2e"},"metricsExportConfig":{"shape":"Sam"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{}}}},"CreateStream":{"http":{"requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId","files","roleArn"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"Sas"},"roleArn":{},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"CreateThing":{"http":{"requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S3x"},"billingGroupName":{}}},"output":{"type":"structure","members":{"thingName":{},"thingArn":{},"thingId":{}}}},"CreateThingGroup":{"http":{"requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"parentGroupName":{},"thingGroupProperties":{"shape":"S3v"},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingGroupId":{}}}},"CreateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"thingTypeProperties":{"shape":"Sb4"},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeId":{}}}},"CreateTopicRule":{"http":{"requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"Sbc"},"tags":{"location":"header","locationName":"x-amz-tagging"}},"payload":"topicRulePayload"}},"CreateTopicRuleDestination":{"http":{"requestUri":"/destinations"},"input":{"type":"structure","required":["destinationConfiguration"],"members":{"destinationConfiguration":{"type":"structure","members":{"httpUrlConfiguration":{"type":"structure","required":["confirmationUrl"],"members":{"confirmationUrl":{}}},"vpcConfiguration":{"type":"structure","required":["subnetIds","vpcId","roleArn"],"members":{"subnetIds":{"shape":"Set"},"securityGroups":{"shape":"Sev"},"vpcId":{},"roleArn":{}}}}}}},"output":{"type":"structure","members":{"topicRuleDestination":{"shape":"Sez"}}}},"DeleteAccountAuditConfiguration":{"http":{"method":"DELETE","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"deleteScheduledAudits":{"location":"querystring","locationName":"deleteScheduledAudits","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteAuditSuppression":{"http":{"requestUri":"/audit/suppressions/delete"},"input":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"}}},"output":{"type":"structure","members":{}}},"DeleteAuthorizer":{"http":{"method":"DELETE","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{}}},"DeleteBillingGroup":{"http":{"method":"DELETE","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteCACertificate":{"http":{"method":"DELETE","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{}}},"DeleteCertificate":{"http":{"method":"DELETE","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"forceDelete":{"location":"querystring","locationName":"forceDelete","type":"boolean"}}}},"DeleteCertificateProvider":{"http":{"method":"DELETE","requestUri":"/certificate-providers/{certificateProviderName}"},"input":{"type":"structure","required":["certificateProviderName"],"members":{"certificateProviderName":{"location":"uri","locationName":"certificateProviderName"}}},"output":{"type":"structure","members":{}}},"DeleteCustomMetric":{"http":{"method":"DELETE","requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"}}},"output":{"type":"structure","members":{}}},"DeleteDimension":{"http":{"method":"DELETE","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{}}},"DeleteDomainConfiguration":{"http":{"method":"DELETE","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"}}},"output":{"type":"structure","members":{}}},"DeleteDynamicThingGroup":{"http":{"method":"DELETE","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteFleetMetric":{"http":{"method":"DELETE","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}}},"DeleteJob":{"http":{"method":"DELETE","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}}},"DeleteJobExecution":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/jobs/{jobId}/executionNumber/{executionNumber}"},"input":{"type":"structure","required":["jobId","thingName","executionNumber"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"uri","locationName":"executionNumber","type":"long"},"force":{"location":"querystring","locationName":"force","type":"boolean"},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}}},"DeleteJobTemplate":{"http":{"method":"DELETE","requestUri":"/job-templates/{jobTemplateId}"},"input":{"type":"structure","required":["jobTemplateId"],"members":{"jobTemplateId":{"location":"uri","locationName":"jobTemplateId"}}}},"DeleteMitigationAction":{"http":{"method":"DELETE","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{}}},"DeleteOTAUpdate":{"http":{"method":"DELETE","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"},"deleteStream":{"location":"querystring","locationName":"deleteStream","type":"boolean"},"forceDeleteAWSJob":{"location":"querystring","locationName":"forceDeleteAWSJob","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeletePackage":{"http":{"method":"DELETE","requestUri":"/packages/{packageName}","responseCode":200},"input":{"type":"structure","required":["packageName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeletePackageVersion":{"http":{"method":"DELETE","requestUri":"/packages/{packageName}/versions/{versionName}","responseCode":200},"input":{"type":"structure","required":["packageName","versionName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"versionName":{"location":"uri","locationName":"versionName"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeletePolicy":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}}},"DeletePolicyVersion":{"http":{"method":"DELETE","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"DeleteProvisioningTemplate":{"http":{"method":"DELETE","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningTemplateVersion":{"http":{"method":"DELETE","requestUri":"/provisioning-templates/{templateName}/versions/{versionId}"},"input":{"type":"structure","required":["templateName","versionId"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"versionId":{"location":"uri","locationName":"versionId","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteRegistrationCode":{"http":{"method":"DELETE","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DeleteRoleAlias":{"http":{"method":"DELETE","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{}}},"DeleteScheduledAudit":{"http":{"method":"DELETE","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{}}},"DeleteSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"method":"DELETE","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{}}},"DeleteThing":{"http":{"method":"DELETE","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingGroup":{"http":{"method":"DELETE","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"}}},"output":{"type":"structure","members":{}}},"DeleteThingType":{"http":{"method":"DELETE","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{}}},"DeleteTopicRule":{"http":{"method":"DELETE","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"DeleteTopicRuleDestination":{"http":{"method":"DELETE","requestUri":"/destinations/{arn+}"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","members":{}}},"DeleteV2LoggingLevel":{"http":{"method":"DELETE","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["targetType","targetName"],"members":{"targetType":{"location":"querystring","locationName":"targetType"},"targetName":{"location":"querystring","locationName":"targetName"}}}},"DeprecateThingType":{"http":{"requestUri":"/thing-types/{thingTypeName}/deprecate"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"},"undoDeprecate":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DescribeAccountAuditConfiguration":{"http":{"method":"GET","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sh5"},"auditCheckConfigurations":{"shape":"Sh8"}}}},"DescribeAuditFinding":{"http":{"method":"GET","requestUri":"/audit/findings/{findingId}"},"input":{"type":"structure","required":["findingId"],"members":{"findingId":{"location":"uri","locationName":"findingId"}}},"output":{"type":"structure","members":{"finding":{"shape":"Shd"}}}},"DescribeAuditMitigationActionsTask":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"taskStatistics":{"type":"map","key":{},"value":{"type":"structure","members":{"totalFindingsCount":{"type":"long"},"failedFindingsCount":{"type":"long"},"succeededFindingsCount":{"type":"long"},"skippedFindingsCount":{"type":"long"},"canceledFindingsCount":{"type":"long"}}}},"target":{"shape":"Shx"},"auditCheckToActionsMapping":{"shape":"Si1"},"actionsDefinition":{"shape":"Si3"}}}},"DescribeAuditSuppression":{"http":{"requestUri":"/audit/suppressions/describe"},"input":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"}}},"output":{"type":"structure","members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{}}}},"DescribeAuditTask":{"http":{"method":"GET","requestUri":"/audit/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskStatus":{},"taskType":{},"taskStartTime":{"type":"timestamp"},"taskStatistics":{"type":"structure","members":{"totalChecks":{"type":"integer"},"inProgressChecks":{"type":"integer"},"waitingForDataCollectionChecks":{"type":"integer"},"compliantChecks":{"type":"integer"},"nonCompliantChecks":{"type":"integer"},"failedChecks":{"type":"integer"},"canceledChecks":{"type":"integer"}}},"scheduledAuditName":{},"auditDetails":{"type":"map","key":{},"value":{"type":"structure","members":{"checkRunStatus":{},"checkCompliant":{"type":"boolean"},"totalResourcesCount":{"type":"long"},"nonCompliantResourcesCount":{"type":"long"},"suppressedNonCompliantResourcesCount":{"type":"long"},"errorCode":{},"message":{}}}}}}},"DescribeAuthorizer":{"http":{"method":"GET","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"}}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Siu"}}}},"DescribeBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"}}},"output":{"type":"structure","members":{"billingGroupName":{},"billingGroupId":{},"billingGroupArn":{},"version":{"type":"long"},"billingGroupProperties":{"shape":"S2n"},"billingGroupMetadata":{"type":"structure","members":{"creationDate":{"type":"timestamp"}}}}}},"DescribeCACertificate":{"http":{"method":"GET","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"creationDate":{"type":"timestamp"},"autoRegistrationStatus":{},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"generationId":{},"validity":{"shape":"Sj7"},"certificateMode":{}}},"registrationConfig":{"shape":"Sj9"}}}},"DescribeCertificate":{"http":{"method":"GET","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"}}},"output":{"type":"structure","members":{"certificateDescription":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"caCertificateId":{},"status":{},"certificatePem":{},"ownedBy":{},"previousOwnedBy":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"customerVersion":{"type":"integer"},"transferData":{"type":"structure","members":{"transferMessage":{},"rejectReason":{},"transferDate":{"type":"timestamp"},"acceptDate":{"type":"timestamp"},"rejectDate":{"type":"timestamp"}}},"generationId":{},"validity":{"shape":"Sj7"},"certificateMode":{}}}}}},"DescribeCertificateProvider":{"http":{"method":"GET","requestUri":"/certificate-providers/{certificateProviderName}"},"input":{"type":"structure","required":["certificateProviderName"],"members":{"certificateProviderName":{"location":"uri","locationName":"certificateProviderName"}}},"output":{"type":"structure","members":{"certificateProviderName":{},"certificateProviderArn":{},"lambdaFunctionArn":{},"accountDefaultForOperations":{"shape":"S2y"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeCustomMetric":{"http":{"method":"GET","requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{},"metricType":{},"displayName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeDefaultAuthorizer":{"http":{"method":"GET","requestUri":"/default-authorizer"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"authorizerDescription":{"shape":"Siu"}}}},"DescribeDetectMitigationActionsTask":{"http":{"method":"GET","requestUri":"/detect/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskSummary":{"shape":"Sjo"}}}},"DescribeDimension":{"http":{"method":"GET","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}},"output":{"type":"structure","members":{"name":{},"arn":{},"type":{},"stringValues":{"shape":"S3c"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeDomainConfiguration":{"http":{"method":"GET","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{},"domainName":{},"serverCertificates":{"type":"list","member":{"type":"structure","members":{"serverCertificateArn":{},"serverCertificateStatus":{},"serverCertificateStatusDetail":{}}}},"authorizerConfig":{"shape":"S3l"},"domainConfigurationStatus":{},"serviceType":{},"domainType":{},"lastStatusChangeDate":{"type":"timestamp"},"tlsConfig":{"shape":"S3o"},"serverCertificateConfig":{"shape":"S3q"}}}},"DescribeEndpoint":{"http":{"method":"GET","requestUri":"/endpoint"},"input":{"type":"structure","members":{"endpointType":{"location":"querystring","locationName":"endpointType"}}},"output":{"type":"structure","members":{"endpointAddress":{}}}},"DescribeEventConfigurations":{"http":{"method":"GET","requestUri":"/event-configurations"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"eventConfigurations":{"shape":"Ske"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeFleetMetric":{"http":{"method":"GET","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName"],"members":{"metricName":{"location":"uri","locationName":"metricName"}}},"output":{"type":"structure","members":{"metricName":{},"queryString":{},"aggregationType":{"shape":"S49"},"period":{"type":"integer"},"aggregationField":{},"description":{},"queryVersion":{},"indexName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"unit":{},"version":{"type":"long"},"metricArn":{}}}},"DescribeIndex":{"http":{"method":"GET","requestUri":"/indices/{indexName}"},"input":{"type":"structure","required":["indexName"],"members":{"indexName":{"location":"uri","locationName":"indexName"}}},"output":{"type":"structure","members":{"indexName":{},"indexStatus":{},"schema":{}}}},"DescribeJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"documentSource":{},"job":{"type":"structure","members":{"jobArn":{},"jobId":{},"targetSelection":{},"status":{},"forceCanceled":{"type":"boolean"},"reasonCode":{},"comment":{},"targets":{"shape":"Sg"},"description":{},"presignedUrlConfig":{"shape":"S4m"},"jobExecutionsRolloutConfig":{"shape":"S4p"},"abortConfig":{"shape":"S4w"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"jobProcessDetails":{"type":"structure","members":{"processingTargets":{"type":"list","member":{}},"numberOfCanceledThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"},"numberOfFailedThings":{"type":"integer"},"numberOfRejectedThings":{"type":"integer"},"numberOfQueuedThings":{"type":"integer"},"numberOfInProgressThings":{"type":"integer"},"numberOfRemovedThings":{"type":"integer"},"numberOfTimedOutThings":{"type":"integer"}}},"timeoutConfig":{"shape":"S53"},"namespaceId":{},"jobTemplateArn":{},"jobExecutionsRetryConfig":{"shape":"S56"},"documentParameters":{"shape":"S5b"},"isConcurrent":{"type":"boolean"},"schedulingConfig":{"shape":"S5e"},"scheduledJobRollouts":{"type":"list","member":{"type":"structure","members":{"startTime":{}}}},"destinationPackageVersions":{"shape":"S5l"}}}}}},"DescribeJobExecution":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs/{jobId}"},"input":{"type":"structure","required":["jobId","thingName"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"thingName":{"location":"uri","locationName":"thingName"},"executionNumber":{"location":"querystring","locationName":"executionNumber","type":"long"}}},"output":{"type":"structure","members":{"execution":{"type":"structure","members":{"jobId":{},"status":{},"forceCanceled":{"type":"boolean"},"statusDetails":{"type":"structure","members":{"detailsMap":{"shape":"S1e"}}},"thingArn":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"},"versionNumber":{"type":"long"},"approximateSecondsBeforeTimedOut":{"type":"long"}}}}}},"DescribeJobTemplate":{"http":{"method":"GET","requestUri":"/job-templates/{jobTemplateId}"},"input":{"type":"structure","required":["jobTemplateId"],"members":{"jobTemplateId":{"location":"uri","locationName":"jobTemplateId"}}},"output":{"type":"structure","members":{"jobTemplateArn":{},"jobTemplateId":{},"description":{},"documentSource":{},"document":{},"createdAt":{"type":"timestamp"},"presignedUrlConfig":{"shape":"S4m"},"jobExecutionsRolloutConfig":{"shape":"S4p"},"abortConfig":{"shape":"S4w"},"timeoutConfig":{"shape":"S53"},"jobExecutionsRetryConfig":{"shape":"S56"},"maintenanceWindows":{"shape":"S5h"},"destinationPackageVersions":{"shape":"S5l"}}}},"DescribeManagedJobTemplate":{"http":{"method":"GET","requestUri":"/managed-job-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"templateVersion":{"location":"querystring","locationName":"templateVersion"}}},"output":{"type":"structure","members":{"templateName":{},"templateArn":{},"description":{},"templateVersion":{},"environments":{"shape":"Slk"},"documentParameters":{"type":"list","member":{"type":"structure","members":{"key":{},"description":{},"regex":{},"example":{},"optional":{"type":"boolean"}}}},"document":{}}}},"DescribeMitigationAction":{"http":{"method":"GET","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"}}},"output":{"type":"structure","members":{"actionName":{},"actionType":{},"actionArn":{},"actionId":{},"roleArn":{},"actionParams":{"shape":"S5y"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"DescribeProvisioningTemplate":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"}}},"output":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"defaultVersionId":{"type":"integer"},"templateBody":{},"enabled":{"type":"boolean"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S92"},"type":{}}}},"DescribeProvisioningTemplateVersion":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}/versions/{versionId}"},"input":{"type":"structure","required":["templateName","versionId"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"versionId":{"location":"uri","locationName":"versionId","type":"integer"}}},"output":{"type":"structure","members":{"versionId":{"type":"integer"},"creationDate":{"type":"timestamp"},"templateBody":{},"isDefaultVersion":{"type":"boolean"}}}},"DescribeRoleAlias":{"http":{"method":"GET","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"}}},"output":{"type":"structure","members":{"roleAliasDescription":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{},"roleArn":{},"owner":{},"credentialDurationSeconds":{"type":"integer"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}}}},"DescribeScheduledAudit":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S9i"},"scheduledAuditName":{},"scheduledAuditArn":{}}}},"DescribeSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S9o"},"alertTargets":{"shape":"Saf"},"additionalMetricsToRetain":{"shape":"Saj","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"Sak"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"metricsExportConfig":{"shape":"Sam"}}}},"DescribeStream":{"http":{"method":"GET","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"}}},"output":{"type":"structure","members":{"streamInfo":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{},"files":{"shape":"Sas"},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"roleArn":{}}}}}},"DescribeThing":{"http":{"method":"GET","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"defaultClientId":{},"thingName":{},"thingId":{},"thingArn":{},"thingTypeName":{},"attributes":{"shape":"S3y"},"version":{"type":"long"},"billingGroupName":{}}}},"DescribeThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"}}},"output":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupArn":{},"version":{"type":"long"},"thingGroupProperties":{"shape":"S3v"},"thingGroupMetadata":{"type":"structure","members":{"parentGroupName":{},"rootToParentThingGroups":{"shape":"Smd"},"creationDate":{"type":"timestamp"}}},"indexName":{},"queryString":{},"queryVersion":{},"status":{}}}},"DescribeThingRegistrationTask":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{"taskId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{},"status":{},"message":{},"successCount":{"type":"integer"},"failureCount":{"type":"integer"},"percentageProgress":{"type":"integer"}}}},"DescribeThingType":{"http":{"method":"GET","requestUri":"/thing-types/{thingTypeName}"},"input":{"type":"structure","required":["thingTypeName"],"members":{"thingTypeName":{"location":"uri","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypeName":{},"thingTypeId":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"Sb4"},"thingTypeMetadata":{"shape":"Smq"}}}},"DetachPolicy":{"http":{"requestUri":"/target-policies/{policyName}"},"input":{"type":"structure","required":["policyName","target"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"target":{}}}},"DetachPrincipalPolicy":{"http":{"method":"DELETE","requestUri":"/principal-policies/{policyName}"},"input":{"type":"structure","required":["policyName","principal"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"principal":{"location":"header","locationName":"x-amzn-iot-principal"}}},"deprecated":true},"DetachSecurityProfile":{"http":{"method":"DELETE","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName","securityProfileTargetArn"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{}}},"DetachThingPrincipal":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName","principal"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{}}},"DisableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/disable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"EnableTopicRule":{"http":{"requestUri":"/rules/{ruleName}/enable"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}}},"GetBehaviorModelTrainingSummaries":{"http":{"method":"GET","requestUri":"/behavior-model-training/summaries"},"input":{"type":"structure","members":{"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"summaries":{"type":"list","member":{"type":"structure","members":{"securityProfileName":{},"behaviorName":{},"trainingDataCollectionStartDate":{"type":"timestamp"},"modelStatus":{},"datapointsCollectionPercentage":{"type":"double"},"lastModelRefreshDate":{"type":"timestamp"}}}},"nextToken":{}}}},"GetBucketsAggregation":{"http":{"requestUri":"/indices/buckets"},"input":{"type":"structure","required":["queryString","aggregationField","bucketsAggregationType"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{},"bucketsAggregationType":{"type":"structure","members":{"termsAggregation":{"type":"structure","members":{"maxBuckets":{"type":"integer"}}}}}}},"output":{"type":"structure","members":{"totalCount":{"type":"integer"},"buckets":{"type":"list","member":{"type":"structure","members":{"keyValue":{},"count":{"type":"integer"}}}}}}},"GetCardinality":{"http":{"requestUri":"/indices/cardinality"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{}}},"output":{"type":"structure","members":{"cardinality":{"type":"integer"}}}},"GetEffectivePolicies":{"http":{"requestUri":"/effective-policies"},"input":{"type":"structure","members":{"principal":{},"cognitoIdentityPoolId":{},"thingName":{"location":"querystring","locationName":"thingName"}}},"output":{"type":"structure","members":{"effectivePolicies":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{}}}}}}},"GetIndexingConfiguration":{"http":{"method":"GET","requestUri":"/indexing/config"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Snp"},"thingGroupIndexingConfiguration":{"shape":"So5"}}}},"GetJobDocument":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/job-document"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"}}},"output":{"type":"structure","members":{"document":{}}}},"GetLoggingOptions":{"http":{"method":"GET","requestUri":"/loggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"logLevel":{}}}},"GetOTAUpdate":{"http":{"method":"GET","requestUri":"/otaUpdates/{otaUpdateId}"},"input":{"type":"structure","required":["otaUpdateId"],"members":{"otaUpdateId":{"location":"uri","locationName":"otaUpdateId"}}},"output":{"type":"structure","members":{"otaUpdateInfo":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"description":{},"targets":{"shape":"S6i"},"protocols":{"shape":"S6k"},"awsJobExecutionsRolloutConfig":{"shape":"S6m"},"awsJobPresignedUrlConfig":{"shape":"S6t"},"targetSelection":{},"otaUpdateFiles":{"shape":"S74"},"otaUpdateStatus":{},"awsIotJobId":{},"awsIotJobArn":{},"errorInfo":{"type":"structure","members":{"code":{},"message":{}}},"additionalParameters":{"shape":"S82"}}}}}},"GetPackage":{"http":{"method":"GET","requestUri":"/packages/{packageName}","responseCode":200},"input":{"type":"structure","required":["packageName"],"members":{"packageName":{"location":"uri","locationName":"packageName"}}},"output":{"type":"structure","members":{"packageName":{},"packageArn":{},"description":{"shape":"S8a"},"defaultVersionName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"GetPackageConfiguration":{"http":{"method":"GET","requestUri":"/package-configuration","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"versionUpdateByJobsConfig":{"shape":"Sol"}}}},"GetPackageVersion":{"http":{"method":"GET","requestUri":"/packages/{packageName}/versions/{versionName}","responseCode":200},"input":{"type":"structure","required":["packageName","versionName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"versionName":{"location":"uri","locationName":"versionName"}}},"output":{"type":"structure","members":{"packageVersionArn":{},"packageName":{},"versionName":{},"description":{"shape":"S8a"},"attributes":{"shape":"S8g"},"status":{},"errorReason":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"GetPercentiles":{"http":{"requestUri":"/indices/percentiles"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{},"percents":{"type":"list","member":{"type":"double"}}}},"output":{"type":"structure","members":{"percentiles":{"type":"list","member":{"type":"structure","members":{"percent":{"type":"double"},"value":{"type":"double"}}}}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/policies/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyName":{},"policyArn":{},"policyDocument":{},"defaultVersionId":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetPolicyVersion":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}},"output":{"type":"structure","members":{"policyArn":{},"policyName":{},"policyDocument":{},"policyVersionId":{},"isDefaultVersion":{"type":"boolean"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"generationId":{}}}},"GetRegistrationCode":{"http":{"method":"GET","requestUri":"/registrationcode"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"registrationCode":{}}}},"GetStatistics":{"http":{"requestUri":"/indices/statistics"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"aggregationField":{},"queryVersion":{}}},"output":{"type":"structure","members":{"statistics":{"type":"structure","members":{"count":{"type":"integer"},"average":{"type":"double"},"sum":{"type":"double"},"minimum":{"type":"double"},"maximum":{"type":"double"},"sumOfSquares":{"type":"double"},"variance":{"type":"double"},"stdDeviation":{"type":"double"}}}}}},"GetTopicRule":{"http":{"method":"GET","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"}}},"output":{"type":"structure","members":{"ruleArn":{},"rule":{"type":"structure","members":{"ruleName":{},"sql":{},"description":{},"createdAt":{"type":"timestamp"},"actions":{"shape":"Sbf"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"Sbg"}}}}}},"GetTopicRuleDestination":{"http":{"method":"GET","requestUri":"/destinations/{arn+}"},"input":{"type":"structure","required":["arn"],"members":{"arn":{"location":"uri","locationName":"arn"}}},"output":{"type":"structure","members":{"topicRuleDestination":{"shape":"Sez"}}}},"GetV2LoggingOptions":{"http":{"method":"GET","requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"ListActiveViolations":{"http":{"method":"GET","requestUri":"/active-violations"},"input":{"type":"structure","members":{"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"behaviorCriteriaType":{"location":"querystring","locationName":"behaviorCriteriaType"},"listSuppressedAlerts":{"location":"querystring","locationName":"listSuppressedAlerts","type":"boolean"},"verificationState":{"location":"querystring","locationName":"verificationState"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"activeViolations":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S9p"},"lastViolationValue":{"shape":"S9w"},"violationEventAdditionalInfo":{"shape":"Spv"},"verificationState":{},"verificationStateDescription":{},"lastViolationTime":{"type":"timestamp"},"violationStartTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListAttachedPolicies":{"http":{"requestUri":"/attached-policies/{target}"},"input":{"type":"structure","required":["target"],"members":{"target":{"location":"uri","locationName":"target"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sq2"},"nextMarker":{}}}},"ListAuditFindings":{"http":{"requestUri":"/audit/findings"},"input":{"type":"structure","members":{"taskId":{},"checkName":{},"resourceIdentifier":{"shape":"S1o"},"maxResults":{"type":"integer"},"nextToken":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"listSuppressedFindings":{"type":"boolean"}}},"output":{"type":"structure","members":{"findings":{"type":"list","member":{"shape":"Shd"}},"nextToken":{}}}},"ListAuditMitigationActionsExecutions":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/executions"},"input":{"type":"structure","required":["taskId","findingId"],"members":{"taskId":{"location":"querystring","locationName":"taskId"},"actionStatus":{"location":"querystring","locationName":"actionStatus"},"findingId":{"location":"querystring","locationName":"findingId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionsExecutions":{"type":"list","member":{"type":"structure","members":{"taskId":{},"findingId":{},"actionName":{},"actionId":{},"status":{},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"errorCode":{},"message":{}}}},"nextToken":{}}}},"ListAuditMitigationActionsTasks":{"http":{"method":"GET","requestUri":"/audit/mitigationactions/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"auditTaskId":{"location":"querystring","locationName":"auditTaskId"},"findingId":{"location":"querystring","locationName":"findingId"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"startTime":{"type":"timestamp"},"taskStatus":{}}}},"nextToken":{}}}},"ListAuditSuppressions":{"http":{"requestUri":"/audit/suppressions/list"},"input":{"type":"structure","members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"ascendingOrder":{"type":"boolean"},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"suppressions":{"type":"list","member":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{}}}},"nextToken":{}}}},"ListAuditTasks":{"http":{"method":"GET","requestUri":"/audit/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"taskType":{"location":"querystring","locationName":"taskType"},"taskStatus":{"location":"querystring","locationName":"taskStatus"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskStatus":{},"taskType":{}}}},"nextToken":{}}}},"ListAuthorizers":{"http":{"method":"GET","requestUri":"/authorizers/"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"authorizers":{"type":"list","member":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"nextMarker":{}}}},"ListBillingGroups":{"http":{"method":"GET","requestUri":"/billing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"}}},"output":{"type":"structure","members":{"billingGroups":{"type":"list","member":{"shape":"Sme"}},"nextToken":{}}}},"ListCACertificates":{"http":{"method":"GET","requestUri":"/cacertificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"},"templateName":{"location":"querystring","locationName":"templateName"}}},"output":{"type":"structure","members":{"certificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListCertificateProviders":{"http":{"method":"GET","requestUri":"/certificate-providers/"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificateProviders":{"type":"list","member":{"type":"structure","members":{"certificateProviderName":{},"certificateProviderArn":{}}}},"nextToken":{}}}},"ListCertificates":{"http":{"method":"GET","requestUri":"/certificates"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sr8"},"nextMarker":{}}}},"ListCertificatesByCA":{"http":{"method":"GET","requestUri":"/certificates-by-ca/{caCertificateId}"},"input":{"type":"structure","required":["caCertificateId"],"members":{"caCertificateId":{"location":"uri","locationName":"caCertificateId"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"certificates":{"shape":"Sr8"},"nextMarker":{}}}},"ListCustomMetrics":{"http":{"method":"GET","requestUri":"/custom-metrics"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"metricNames":{"type":"list","member":{}},"nextToken":{}}}},"ListDetectMitigationActionsExecutions":{"http":{"method":"GET","requestUri":"/detect/mitigationactions/executions"},"input":{"type":"structure","members":{"taskId":{"location":"querystring","locationName":"taskId"},"violationId":{"location":"querystring","locationName":"violationId"},"thingName":{"location":"querystring","locationName":"thingName"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionsExecutions":{"type":"list","member":{"type":"structure","members":{"taskId":{},"violationId":{},"actionName":{},"thingName":{},"executionStartDate":{"type":"timestamp"},"executionEndDate":{"type":"timestamp"},"status":{},"errorCode":{},"message":{}}}},"nextToken":{}}}},"ListDetectMitigationActionsTasks":{"http":{"method":"GET","requestUri":"/detect/mitigationactions/tasks"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"tasks":{"type":"list","member":{"shape":"Sjo"}},"nextToken":{}}}},"ListDimensions":{"http":{"method":"GET","requestUri":"/dimensions"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"dimensionNames":{"type":"list","member":{}},"nextToken":{}}}},"ListDomainConfigurations":{"http":{"method":"GET","requestUri":"/domainConfigurations"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"serviceType":{"location":"querystring","locationName":"serviceType"}}},"output":{"type":"structure","members":{"domainConfigurations":{"type":"list","member":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{},"serviceType":{}}}},"nextMarker":{}}}},"ListFleetMetrics":{"http":{"method":"GET","requestUri":"/fleet-metrics"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"fleetMetrics":{"type":"list","member":{"type":"structure","members":{"metricName":{},"metricArn":{}}}},"nextToken":{}}}},"ListIndices":{"http":{"method":"GET","requestUri":"/indices"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"indexNames":{"type":"list","member":{}},"nextToken":{}}}},"ListJobExecutionsForJob":{"http":{"method":"GET","requestUri":"/jobs/{jobId}/things"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"thingArn":{},"jobExecutionSummary":{"shape":"Ss8"}}}},"nextToken":{}}}},"ListJobExecutionsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/jobs"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"status":{"location":"querystring","locationName":"status"},"namespaceId":{"location":"querystring","locationName":"namespaceId"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"jobId":{"location":"querystring","locationName":"jobId"}}},"output":{"type":"structure","members":{"executionSummaries":{"type":"list","member":{"type":"structure","members":{"jobId":{},"jobExecutionSummary":{"shape":"Ss8"}}}},"nextToken":{}}}},"ListJobTemplates":{"http":{"method":"GET","requestUri":"/job-templates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"jobTemplates":{"type":"list","member":{"type":"structure","members":{"jobTemplateArn":{},"jobTemplateId":{},"description":{},"createdAt":{"type":"timestamp"}}}},"nextToken":{}}}},"ListJobs":{"http":{"method":"GET","requestUri":"/jobs"},"input":{"type":"structure","members":{"status":{"location":"querystring","locationName":"status"},"targetSelection":{"location":"querystring","locationName":"targetSelection"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"thingGroupName":{"location":"querystring","locationName":"thingGroupName"},"thingGroupId":{"location":"querystring","locationName":"thingGroupId"},"namespaceId":{"location":"querystring","locationName":"namespaceId"}}},"output":{"type":"structure","members":{"jobs":{"type":"list","member":{"type":"structure","members":{"jobArn":{},"jobId":{},"thingGroupId":{},"targetSelection":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"completedAt":{"type":"timestamp"},"isConcurrent":{"type":"boolean"}}}},"nextToken":{}}}},"ListManagedJobTemplates":{"http":{"method":"GET","requestUri":"/managed-job-templates"},"input":{"type":"structure","members":{"templateName":{"location":"querystring","locationName":"templateName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"managedJobTemplates":{"type":"list","member":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"environments":{"shape":"Slk"},"templateVersion":{}}}},"nextToken":{}}}},"ListMetricValues":{"http":{"method":"GET","requestUri":"/metric-values"},"input":{"type":"structure","required":["thingName","metricName","startTime","endTime"],"members":{"thingName":{"location":"querystring","locationName":"thingName"},"metricName":{"location":"querystring","locationName":"metricName"},"dimensionName":{"location":"querystring","locationName":"dimensionName"},"dimensionValueOperator":{"location":"querystring","locationName":"dimensionValueOperator"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"metricDatumList":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"timestamp"},"value":{"shape":"S9w"}}}},"nextToken":{}}}},"ListMitigationActions":{"http":{"method":"GET","requestUri":"/mitigationactions/actions"},"input":{"type":"structure","members":{"actionType":{"location":"querystring","locationName":"actionType"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"actionIdentifiers":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOTAUpdates":{"http":{"method":"GET","requestUri":"/otaUpdates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"otaUpdateStatus":{"location":"querystring","locationName":"otaUpdateStatus"}}},"output":{"type":"structure","members":{"otaUpdates":{"type":"list","member":{"type":"structure","members":{"otaUpdateId":{},"otaUpdateArn":{},"creationDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListOutgoingCertificates":{"http":{"method":"GET","requestUri":"/certificates-out-going"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"outgoingCertificates":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"transferredTo":{},"transferDate":{"type":"timestamp"},"transferMessage":{},"creationDate":{"type":"timestamp"}}}},"nextMarker":{}}}},"ListPackageVersions":{"http":{"method":"GET","requestUri":"/packages/{packageName}/versions","responseCode":200},"input":{"type":"structure","required":["packageName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"status":{"location":"querystring","locationName":"status"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"packageVersionSummaries":{"type":"list","member":{"type":"structure","members":{"packageName":{},"versionName":{},"status":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListPackages":{"http":{"method":"GET","requestUri":"/packages","responseCode":200},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"packageSummaries":{"type":"list","member":{"type":"structure","members":{"packageName":{},"defaultVersionName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"nextToken":{}}}},"ListPolicies":{"http":{"method":"GET","requestUri":"/policies"},"input":{"type":"structure","members":{"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sq2"},"nextMarker":{}}}},"ListPolicyPrincipals":{"http":{"method":"GET","requestUri":"/policy-principals"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"header","locationName":"x-amzn-iot-policy"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"principals":{"shape":"Stj"},"nextMarker":{}}},"deprecated":true},"ListPolicyVersions":{"http":{"method":"GET","requestUri":"/policies/{policyName}/version"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"}}},"output":{"type":"structure","members":{"policyVersions":{"type":"list","member":{"type":"structure","members":{"versionId":{},"isDefaultVersion":{"type":"boolean"},"createDate":{"type":"timestamp"}}}}}}},"ListPrincipalPolicies":{"http":{"method":"GET","requestUri":"/principal-policies"},"input":{"type":"structure","required":["principal"],"members":{"principal":{"location":"header","locationName":"x-amzn-iot-principal"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"policies":{"shape":"Sq2"},"nextMarker":{}}},"deprecated":true},"ListPrincipalThings":{"http":{"method":"GET","requestUri":"/principals/things"},"input":{"type":"structure","required":["principal"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"principal":{"location":"header","locationName":"x-amzn-principal"}}},"output":{"type":"structure","members":{"things":{"shape":"Stt"},"nextToken":{}}}},"ListProvisioningTemplateVersions":{"http":{"method":"GET","requestUri":"/provisioning-templates/{templateName}/versions"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"versions":{"type":"list","member":{"type":"structure","members":{"versionId":{"type":"integer"},"creationDate":{"type":"timestamp"},"isDefaultVersion":{"type":"boolean"}}}},"nextToken":{}}}},"ListProvisioningTemplates":{"http":{"method":"GET","requestUri":"/provisioning-templates"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"templates":{"type":"list","member":{"type":"structure","members":{"templateArn":{},"templateName":{},"description":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"enabled":{"type":"boolean"},"type":{}}}},"nextToken":{}}}},"ListRelatedResourcesForAuditFinding":{"http":{"method":"GET","requestUri":"/audit/relatedResources"},"input":{"type":"structure","required":["findingId"],"members":{"findingId":{"location":"querystring","locationName":"findingId"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"relatedResources":{"shape":"Shi"},"nextToken":{}}}},"ListRoleAliases":{"http":{"method":"GET","requestUri":"/role-aliases"},"input":{"type":"structure","members":{"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"},"marker":{"location":"querystring","locationName":"marker"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"roleAliases":{"type":"list","member":{}},"nextMarker":{}}}},"ListScheduledAudits":{"http":{"method":"GET","requestUri":"/audit/scheduledaudits"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"scheduledAudits":{"type":"list","member":{"type":"structure","members":{"scheduledAuditName":{},"scheduledAuditArn":{},"frequency":{},"dayOfMonth":{},"dayOfWeek":{}}}},"nextToken":{}}}},"ListSecurityProfiles":{"http":{"method":"GET","requestUri":"/security-profiles"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"dimensionName":{"location":"querystring","locationName":"dimensionName"},"metricName":{"location":"querystring","locationName":"metricName"}}},"output":{"type":"structure","members":{"securityProfileIdentifiers":{"type":"list","member":{"shape":"Sue"}},"nextToken":{}}}},"ListSecurityProfilesForTarget":{"http":{"method":"GET","requestUri":"/security-profiles-for-target"},"input":{"type":"structure","required":["securityProfileTargetArn"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"securityProfileTargetArn":{"location":"querystring","locationName":"securityProfileTargetArn"}}},"output":{"type":"structure","members":{"securityProfileTargetMappings":{"type":"list","member":{"type":"structure","members":{"securityProfileIdentifier":{"shape":"Sue"},"target":{"shape":"Suj"}}}},"nextToken":{}}}},"ListStreams":{"http":{"method":"GET","requestUri":"/streams"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ascendingOrder":{"location":"querystring","locationName":"isAscendingOrder","type":"boolean"}}},"output":{"type":"structure","members":{"streams":{"type":"list","member":{"type":"structure","members":{"streamId":{},"streamArn":{},"streamVersion":{"type":"integer"},"description":{}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"tags":{"shape":"S2e"},"nextToken":{}}}},"ListTargetsForPolicy":{"http":{"requestUri":"/policy-targets/{policyName}"},"input":{"type":"structure","required":["policyName"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"marker":{"location":"querystring","locationName":"marker"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"targets":{"type":"list","member":{}},"nextMarker":{}}}},"ListTargetsForSecurityProfile":{"http":{"method":"GET","requestUri":"/security-profiles/{securityProfileName}/targets"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"securityProfileTargets":{"type":"list","member":{"shape":"Suj"}},"nextToken":{}}}},"ListThingGroups":{"http":{"method":"GET","requestUri":"/thing-groups"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"parentGroup":{"location":"querystring","locationName":"parentGroup"},"namePrefixFilter":{"location":"querystring","locationName":"namePrefixFilter"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Smd"},"nextToken":{}}}},"ListThingGroupsForThing":{"http":{"method":"GET","requestUri":"/things/{thingName}/thing-groups"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"thingGroups":{"shape":"Smd"},"nextToken":{}}}},"ListThingPrincipals":{"http":{"method":"GET","requestUri":"/things/{thingName}/principals"},"input":{"type":"structure","required":["thingName"],"members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingName":{"location":"uri","locationName":"thingName"}}},"output":{"type":"structure","members":{"principals":{"shape":"Stj"},"nextToken":{}}}},"ListThingRegistrationTaskReports":{"http":{"method":"GET","requestUri":"/thing-registration-tasks/{taskId}/reports"},"input":{"type":"structure","required":["taskId","reportType"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"reportType":{"location":"querystring","locationName":"reportType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"resourceLinks":{"type":"list","member":{}},"reportType":{},"nextToken":{}}}},"ListThingRegistrationTasks":{"http":{"method":"GET","requestUri":"/thing-registration-tasks"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"status":{"location":"querystring","locationName":"status"}}},"output":{"type":"structure","members":{"taskIds":{"type":"list","member":{}},"nextToken":{}}}},"ListThingTypes":{"http":{"method":"GET","requestUri":"/thing-types"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"}}},"output":{"type":"structure","members":{"thingTypes":{"type":"list","member":{"type":"structure","members":{"thingTypeName":{},"thingTypeArn":{},"thingTypeProperties":{"shape":"Sb4"},"thingTypeMetadata":{"shape":"Smq"}}}},"nextToken":{}}}},"ListThings":{"http":{"method":"GET","requestUri":"/things"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"attributeName":{"location":"querystring","locationName":"attributeName"},"attributeValue":{"location":"querystring","locationName":"attributeValue"},"thingTypeName":{"location":"querystring","locationName":"thingTypeName"},"usePrefixAttributeValue":{"location":"querystring","locationName":"usePrefixAttributeValue","type":"boolean"}}},"output":{"type":"structure","members":{"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingTypeName":{},"thingArn":{},"attributes":{"shape":"S3y"},"version":{"type":"long"}}}},"nextToken":{}}}},"ListThingsInBillingGroup":{"http":{"method":"GET","requestUri":"/billing-groups/{billingGroupName}/things"},"input":{"type":"structure","required":["billingGroupName"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Stt"},"nextToken":{}}}},"ListThingsInThingGroup":{"http":{"method":"GET","requestUri":"/thing-groups/{thingGroupName}/things"},"input":{"type":"structure","required":["thingGroupName"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"recursive":{"location":"querystring","locationName":"recursive","type":"boolean"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"things":{"shape":"Stt"},"nextToken":{}}}},"ListTopicRuleDestinations":{"http":{"method":"GET","requestUri":"/destinations"},"input":{"type":"structure","members":{"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"destinationSummaries":{"type":"list","member":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"statusReason":{},"httpUrlSummary":{"type":"structure","members":{"confirmationUrl":{}}},"vpcDestinationSummary":{"type":"structure","members":{"subnetIds":{"shape":"Set"},"securityGroups":{"shape":"Sev"},"vpcId":{},"roleArn":{}}}}}},"nextToken":{}}}},"ListTopicRules":{"http":{"method":"GET","requestUri":"/rules"},"input":{"type":"structure","members":{"topic":{"location":"querystring","locationName":"topic"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"},"ruleDisabled":{"location":"querystring","locationName":"ruleDisabled","type":"boolean"}}},"output":{"type":"structure","members":{"rules":{"type":"list","member":{"type":"structure","members":{"ruleArn":{},"ruleName":{},"topicPattern":{},"createdAt":{"type":"timestamp"},"ruleDisabled":{"type":"boolean"}}}},"nextToken":{}}}},"ListV2LoggingLevels":{"http":{"method":"GET","requestUri":"/v2LoggingLevel"},"input":{"type":"structure","members":{"targetType":{"location":"querystring","locationName":"targetType"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"logTargetConfigurations":{"type":"list","member":{"type":"structure","members":{"logTarget":{"shape":"Sw7"},"logLevel":{}}}},"nextToken":{}}}},"ListViolationEvents":{"http":{"method":"GET","requestUri":"/violation-events"},"input":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"thingName":{"location":"querystring","locationName":"thingName"},"securityProfileName":{"location":"querystring","locationName":"securityProfileName"},"behaviorCriteriaType":{"location":"querystring","locationName":"behaviorCriteriaType"},"listSuppressedAlerts":{"location":"querystring","locationName":"listSuppressedAlerts","type":"boolean"},"verificationState":{"location":"querystring","locationName":"verificationState"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"violationEvents":{"type":"list","member":{"type":"structure","members":{"violationId":{},"thingName":{},"securityProfileName":{},"behavior":{"shape":"S9p"},"metricValue":{"shape":"S9w"},"violationEventAdditionalInfo":{"shape":"Spv"},"violationEventType":{},"verificationState":{},"verificationStateDescription":{},"violationEventTime":{"type":"timestamp"}}}},"nextToken":{}}}},"PutVerificationStateOnViolation":{"http":{"requestUri":"/violations/verification-state/{violationId}"},"input":{"type":"structure","required":["violationId","verificationState"],"members":{"violationId":{"location":"uri","locationName":"violationId"},"verificationState":{},"verificationStateDescription":{}}},"output":{"type":"structure","members":{}}},"RegisterCACertificate":{"http":{"requestUri":"/cacertificate"},"input":{"type":"structure","required":["caCertificate"],"members":{"caCertificate":{},"verificationCertificate":{},"setAsActive":{"location":"querystring","locationName":"setAsActive","type":"boolean"},"allowAutoRegistration":{"location":"querystring","locationName":"allowAutoRegistration","type":"boolean"},"registrationConfig":{"shape":"Sj9"},"tags":{"shape":"S2e"},"certificateMode":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificate":{"http":{"requestUri":"/certificate/register"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"caCertificatePem":{},"setAsActive":{"deprecated":true,"location":"querystring","locationName":"setAsActive","type":"boolean"},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterCertificateWithoutCA":{"http":{"requestUri":"/certificate/register-no-ca"},"input":{"type":"structure","required":["certificatePem"],"members":{"certificatePem":{},"status":{}}},"output":{"type":"structure","members":{"certificateArn":{},"certificateId":{}}}},"RegisterThing":{"http":{"requestUri":"/things"},"input":{"type":"structure","required":["templateBody"],"members":{"templateBody":{},"parameters":{"type":"map","key":{},"value":{}}}},"output":{"type":"structure","members":{"certificatePem":{},"resourceArns":{"type":"map","key":{},"value":{}}}}},"RejectCertificateTransfer":{"http":{"method":"PATCH","requestUri":"/reject-certificate-transfer/{certificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"rejectReason":{}}}},"RemoveThingFromBillingGroup":{"http":{"method":"PUT","requestUri":"/billing-groups/removeThingFromBillingGroup"},"input":{"type":"structure","members":{"billingGroupName":{},"billingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"RemoveThingFromThingGroup":{"http":{"method":"PUT","requestUri":"/thing-groups/removeThingFromThingGroup"},"input":{"type":"structure","members":{"thingGroupName":{},"thingGroupArn":{},"thingName":{},"thingArn":{}}},"output":{"type":"structure","members":{}}},"ReplaceTopicRule":{"http":{"method":"PATCH","requestUri":"/rules/{ruleName}"},"input":{"type":"structure","required":["ruleName","topicRulePayload"],"members":{"ruleName":{"location":"uri","locationName":"ruleName"},"topicRulePayload":{"shape":"Sbc"}},"payload":"topicRulePayload"}},"SearchIndex":{"http":{"requestUri":"/indices/search"},"input":{"type":"structure","required":["queryString"],"members":{"indexName":{},"queryString":{},"nextToken":{},"maxResults":{"type":"integer"},"queryVersion":{}}},"output":{"type":"structure","members":{"nextToken":{},"things":{"type":"list","member":{"type":"structure","members":{"thingName":{},"thingId":{},"thingTypeName":{},"thingGroupNames":{"shape":"Sx4"},"attributes":{"shape":"S3y"},"shadow":{},"deviceDefender":{},"connectivity":{"type":"structure","members":{"connected":{"type":"boolean"},"timestamp":{"type":"long"},"disconnectReason":{}}}}}},"thingGroups":{"type":"list","member":{"type":"structure","members":{"thingGroupName":{},"thingGroupId":{},"thingGroupDescription":{},"attributes":{"shape":"S3y"},"parentGroupNames":{"shape":"Sx4"}}}}}}},"SetDefaultAuthorizer":{"http":{"requestUri":"/default-authorizer"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"SetDefaultPolicyVersion":{"http":{"method":"PATCH","requestUri":"/policies/{policyName}/version/{policyVersionId}"},"input":{"type":"structure","required":["policyName","policyVersionId"],"members":{"policyName":{"location":"uri","locationName":"policyName"},"policyVersionId":{"location":"uri","locationName":"policyVersionId"}}}},"SetLoggingOptions":{"http":{"requestUri":"/loggingOptions"},"input":{"type":"structure","required":["loggingOptionsPayload"],"members":{"loggingOptionsPayload":{"type":"structure","required":["roleArn"],"members":{"roleArn":{},"logLevel":{}}}},"payload":"loggingOptionsPayload"}},"SetV2LoggingLevel":{"http":{"requestUri":"/v2LoggingLevel"},"input":{"type":"structure","required":["logTarget","logLevel"],"members":{"logTarget":{"shape":"Sw7"},"logLevel":{}}}},"SetV2LoggingOptions":{"http":{"requestUri":"/v2LoggingOptions"},"input":{"type":"structure","members":{"roleArn":{},"defaultLogLevel":{},"disableAllLogs":{"type":"boolean"}}}},"StartAuditMitigationActionsTask":{"http":{"requestUri":"/audit/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId","target","auditCheckToActionsMapping","clientRequestToken"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"target":{"shape":"Shx"},"auditCheckToActionsMapping":{"shape":"Si1"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartDetectMitigationActionsTask":{"http":{"method":"PUT","requestUri":"/detect/mitigationactions/tasks/{taskId}"},"input":{"type":"structure","required":["taskId","target","actions","clientRequestToken"],"members":{"taskId":{"location":"uri","locationName":"taskId"},"target":{"shape":"Sjq"},"actions":{"type":"list","member":{}},"violationEventOccurrenceRange":{"shape":"Sjt"},"includeOnlyActiveViolations":{"type":"boolean"},"includeSuppressedAlerts":{"type":"boolean"},"clientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartOnDemandAuditTask":{"http":{"requestUri":"/audit/tasks"},"input":{"type":"structure","required":["targetCheckNames"],"members":{"targetCheckNames":{"shape":"S9i"}}},"output":{"type":"structure","members":{"taskId":{}}}},"StartThingRegistrationTask":{"http":{"requestUri":"/thing-registration-tasks"},"input":{"type":"structure","required":["templateBody","inputFileBucket","inputFileKey","roleArn"],"members":{"templateBody":{},"inputFileBucket":{},"inputFileKey":{},"roleArn":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"StopThingRegistrationTask":{"http":{"method":"PUT","requestUri":"/thing-registration-tasks/{taskId}/cancel"},"input":{"type":"structure","required":["taskId"],"members":{"taskId":{"location":"uri","locationName":"taskId"}}},"output":{"type":"structure","members":{}}},"TagResource":{"http":{"requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"S2e"}}},"output":{"type":"structure","members":{}}},"TestAuthorization":{"http":{"requestUri":"/test-authorization"},"input":{"type":"structure","required":["authInfos"],"members":{"principal":{},"cognitoIdentityPoolId":{},"authInfos":{"type":"list","member":{"shape":"Sxx"}},"clientId":{"location":"querystring","locationName":"clientId"},"policyNamesToAdd":{"shape":"Sy1"},"policyNamesToSkip":{"shape":"Sy1"}}},"output":{"type":"structure","members":{"authResults":{"type":"list","member":{"type":"structure","members":{"authInfo":{"shape":"Sxx"},"allowed":{"type":"structure","members":{"policies":{"shape":"Sq2"}}},"denied":{"type":"structure","members":{"implicitDeny":{"type":"structure","members":{"policies":{"shape":"Sq2"}}},"explicitDeny":{"type":"structure","members":{"policies":{"shape":"Sq2"}}}}},"authDecision":{},"missingContextValues":{"type":"list","member":{}}}}}}}},"TestInvokeAuthorizer":{"http":{"requestUri":"/authorizer/{authorizerName}/test"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"token":{},"tokenSignature":{},"httpContext":{"type":"structure","members":{"headers":{"type":"map","key":{},"value":{}},"queryString":{}}},"mqttContext":{"type":"structure","members":{"username":{},"password":{"type":"blob"},"clientId":{}}},"tlsContext":{"type":"structure","members":{"serverName":{}}}}},"output":{"type":"structure","members":{"isAuthenticated":{"type":"boolean"},"principalId":{},"policyDocuments":{"type":"list","member":{}},"refreshAfterInSeconds":{"type":"integer"},"disconnectAfterInSeconds":{"type":"integer"}}}},"TransferCertificate":{"http":{"method":"PATCH","requestUri":"/transfer-certificate/{certificateId}"},"input":{"type":"structure","required":["certificateId","targetAwsAccount"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"targetAwsAccount":{"location":"querystring","locationName":"targetAwsAccount"},"transferMessage":{}}},"output":{"type":"structure","members":{"transferredCertificateArn":{}}}},"UntagResource":{"http":{"requestUri":"/untag"},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateAccountAuditConfiguration":{"http":{"method":"PATCH","requestUri":"/audit/configuration"},"input":{"type":"structure","members":{"roleArn":{},"auditNotificationTargetConfigurations":{"shape":"Sh5"},"auditCheckConfigurations":{"shape":"Sh8"}}},"output":{"type":"structure","members":{}}},"UpdateAuditSuppression":{"http":{"method":"PATCH","requestUri":"/audit/suppressions/update"},"input":{"type":"structure","required":["checkName","resourceIdentifier"],"members":{"checkName":{},"resourceIdentifier":{"shape":"S1o"},"expirationDate":{"type":"timestamp"},"suppressIndefinitely":{"type":"boolean"},"description":{}}},"output":{"type":"structure","members":{}}},"UpdateAuthorizer":{"http":{"method":"PUT","requestUri":"/authorizer/{authorizerName}"},"input":{"type":"structure","required":["authorizerName"],"members":{"authorizerName":{"location":"uri","locationName":"authorizerName"},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S2a"},"status":{},"enableCachingForHttp":{"type":"boolean"}}},"output":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{}}}},"UpdateBillingGroup":{"http":{"method":"PATCH","requestUri":"/billing-groups/{billingGroupName}"},"input":{"type":"structure","required":["billingGroupName","billingGroupProperties"],"members":{"billingGroupName":{"location":"uri","locationName":"billingGroupName"},"billingGroupProperties":{"shape":"S2n"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateCACertificate":{"http":{"method":"PUT","requestUri":"/cacertificate/{caCertificateId}"},"input":{"type":"structure","required":["certificateId"],"members":{"certificateId":{"location":"uri","locationName":"caCertificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"},"newAutoRegistrationStatus":{"location":"querystring","locationName":"newAutoRegistrationStatus"},"registrationConfig":{"shape":"Sj9"},"removeAutoRegistration":{"type":"boolean"}}}},"UpdateCertificate":{"http":{"method":"PUT","requestUri":"/certificates/{certificateId}"},"input":{"type":"structure","required":["certificateId","newStatus"],"members":{"certificateId":{"location":"uri","locationName":"certificateId"},"newStatus":{"location":"querystring","locationName":"newStatus"}}}},"UpdateCertificateProvider":{"http":{"method":"PUT","requestUri":"/certificate-providers/{certificateProviderName}"},"input":{"type":"structure","required":["certificateProviderName"],"members":{"certificateProviderName":{"location":"uri","locationName":"certificateProviderName"},"lambdaFunctionArn":{},"accountDefaultForOperations":{"shape":"S2y"}}},"output":{"type":"structure","members":{"certificateProviderName":{},"certificateProviderArn":{}}}},"UpdateCustomMetric":{"http":{"method":"PATCH","requestUri":"/custom-metric/{metricName}"},"input":{"type":"structure","required":["metricName","displayName"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"displayName":{}}},"output":{"type":"structure","members":{"metricName":{},"metricArn":{},"metricType":{},"displayName":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateDimension":{"http":{"method":"PATCH","requestUri":"/dimensions/{name}"},"input":{"type":"structure","required":["name","stringValues"],"members":{"name":{"location":"uri","locationName":"name"},"stringValues":{"shape":"S3c"}}},"output":{"type":"structure","members":{"name":{},"arn":{},"type":{},"stringValues":{"shape":"S3c"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"}}}},"UpdateDomainConfiguration":{"http":{"method":"PUT","requestUri":"/domainConfigurations/{domainConfigurationName}"},"input":{"type":"structure","required":["domainConfigurationName"],"members":{"domainConfigurationName":{"location":"uri","locationName":"domainConfigurationName"},"authorizerConfig":{"shape":"S3l"},"domainConfigurationStatus":{},"removeAuthorizerConfig":{"type":"boolean"},"tlsConfig":{"shape":"S3o"},"serverCertificateConfig":{"shape":"S3q"}}},"output":{"type":"structure","members":{"domainConfigurationName":{},"domainConfigurationArn":{}}}},"UpdateDynamicThingGroup":{"http":{"method":"PATCH","requestUri":"/dynamic-thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S3v"},"expectedVersion":{"type":"long"},"indexName":{},"queryString":{},"queryVersion":{}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateEventConfigurations":{"http":{"method":"PATCH","requestUri":"/event-configurations"},"input":{"type":"structure","members":{"eventConfigurations":{"shape":"Ske"}}},"output":{"type":"structure","members":{}}},"UpdateFleetMetric":{"http":{"method":"PATCH","requestUri":"/fleet-metric/{metricName}"},"input":{"type":"structure","required":["metricName","indexName"],"members":{"metricName":{"location":"uri","locationName":"metricName"},"queryString":{},"aggregationType":{"shape":"S49"},"period":{"type":"integer"},"aggregationField":{},"description":{},"queryVersion":{},"indexName":{},"unit":{},"expectedVersion":{"type":"long"}}}},"UpdateIndexingConfiguration":{"http":{"requestUri":"/indexing/config"},"input":{"type":"structure","members":{"thingIndexingConfiguration":{"shape":"Snp"},"thingGroupIndexingConfiguration":{"shape":"So5"}}},"output":{"type":"structure","members":{}}},"UpdateJob":{"http":{"method":"PATCH","requestUri":"/jobs/{jobId}"},"input":{"type":"structure","required":["jobId"],"members":{"jobId":{"location":"uri","locationName":"jobId"},"description":{},"presignedUrlConfig":{"shape":"S4m"},"jobExecutionsRolloutConfig":{"shape":"S4p"},"abortConfig":{"shape":"S4w"},"timeoutConfig":{"shape":"S53"},"namespaceId":{"location":"querystring","locationName":"namespaceId"},"jobExecutionsRetryConfig":{"shape":"S56"}}}},"UpdateMitigationAction":{"http":{"method":"PATCH","requestUri":"/mitigationactions/actions/{actionName}"},"input":{"type":"structure","required":["actionName"],"members":{"actionName":{"location":"uri","locationName":"actionName"},"roleArn":{},"actionParams":{"shape":"S5y"}}},"output":{"type":"structure","members":{"actionArn":{},"actionId":{}}}},"UpdatePackage":{"http":{"method":"PATCH","requestUri":"/packages/{packageName}","responseCode":200},"input":{"type":"structure","required":["packageName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"description":{"shape":"S8a"},"defaultVersionName":{},"unsetDefaultVersion":{"type":"boolean"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdatePackageConfiguration":{"http":{"method":"PATCH","requestUri":"/package-configuration","responseCode":200},"input":{"type":"structure","members":{"versionUpdateByJobsConfig":{"shape":"Sol"},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdatePackageVersion":{"http":{"method":"PATCH","requestUri":"/packages/{packageName}/versions/{versionName}","responseCode":200},"input":{"type":"structure","required":["packageName","versionName"],"members":{"packageName":{"location":"uri","locationName":"packageName"},"versionName":{"location":"uri","locationName":"versionName"},"description":{"shape":"S8a"},"attributes":{"shape":"S8g"},"action":{},"clientToken":{"idempotencyToken":true,"location":"querystring","locationName":"clientToken"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateProvisioningTemplate":{"http":{"method":"PATCH","requestUri":"/provisioning-templates/{templateName}"},"input":{"type":"structure","required":["templateName"],"members":{"templateName":{"location":"uri","locationName":"templateName"},"description":{},"enabled":{"type":"boolean"},"defaultVersionId":{"type":"integer"},"provisioningRoleArn":{},"preProvisioningHook":{"shape":"S92"},"removePreProvisioningHook":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateRoleAlias":{"http":{"method":"PUT","requestUri":"/role-aliases/{roleAlias}"},"input":{"type":"structure","required":["roleAlias"],"members":{"roleAlias":{"location":"uri","locationName":"roleAlias"},"roleArn":{},"credentialDurationSeconds":{"type":"integer"}}},"output":{"type":"structure","members":{"roleAlias":{},"roleAliasArn":{}}}},"UpdateScheduledAudit":{"http":{"method":"PATCH","requestUri":"/audit/scheduledaudits/{scheduledAuditName}"},"input":{"type":"structure","required":["scheduledAuditName"],"members":{"frequency":{},"dayOfMonth":{},"dayOfWeek":{},"targetCheckNames":{"shape":"S9i"},"scheduledAuditName":{"location":"uri","locationName":"scheduledAuditName"}}},"output":{"type":"structure","members":{"scheduledAuditArn":{}}}},"UpdateSecurityProfile":{"http":{"method":"PATCH","requestUri":"/security-profiles/{securityProfileName}"},"input":{"type":"structure","required":["securityProfileName"],"members":{"securityProfileName":{"location":"uri","locationName":"securityProfileName"},"securityProfileDescription":{},"behaviors":{"shape":"S9o"},"alertTargets":{"shape":"Saf"},"additionalMetricsToRetain":{"shape":"Saj","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"Sak"},"deleteBehaviors":{"type":"boolean"},"deleteAlertTargets":{"type":"boolean"},"deleteAdditionalMetricsToRetain":{"type":"boolean"},"expectedVersion":{"location":"querystring","locationName":"expectedVersion","type":"long"},"metricsExportConfig":{"shape":"Sam"},"deleteMetricsExportConfig":{"type":"boolean"}}},"output":{"type":"structure","members":{"securityProfileName":{},"securityProfileArn":{},"securityProfileDescription":{},"behaviors":{"shape":"S9o"},"alertTargets":{"shape":"Saf"},"additionalMetricsToRetain":{"shape":"Saj","deprecated":true,"deprecatedMessage":"Use additionalMetricsToRetainV2."},"additionalMetricsToRetainV2":{"shape":"Sak"},"version":{"type":"long"},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"metricsExportConfig":{"shape":"Sam"}}}},"UpdateStream":{"http":{"method":"PUT","requestUri":"/streams/{streamId}"},"input":{"type":"structure","required":["streamId"],"members":{"streamId":{"location":"uri","locationName":"streamId"},"description":{},"files":{"shape":"Sas"},"roleArn":{}}},"output":{"type":"structure","members":{"streamId":{},"streamArn":{},"description":{},"streamVersion":{"type":"integer"}}}},"UpdateThing":{"http":{"method":"PATCH","requestUri":"/things/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"thingTypeName":{},"attributePayload":{"shape":"S3x"},"expectedVersion":{"type":"long"},"removeThingType":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateThingGroup":{"http":{"method":"PATCH","requestUri":"/thing-groups/{thingGroupName}"},"input":{"type":"structure","required":["thingGroupName","thingGroupProperties"],"members":{"thingGroupName":{"location":"uri","locationName":"thingGroupName"},"thingGroupProperties":{"shape":"S3v"},"expectedVersion":{"type":"long"}}},"output":{"type":"structure","members":{"version":{"type":"long"}}}},"UpdateThingGroupsForThing":{"http":{"method":"PUT","requestUri":"/thing-groups/updateThingGroupsForThing"},"input":{"type":"structure","members":{"thingName":{},"thingGroupsToAdd":{"shape":"S10n"},"thingGroupsToRemove":{"shape":"S10n"},"overrideDynamicGroups":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"UpdateTopicRuleDestination":{"http":{"method":"PATCH","requestUri":"/destinations"},"input":{"type":"structure","required":["arn","status"],"members":{"arn":{},"status":{}}},"output":{"type":"structure","members":{}}},"ValidateSecurityProfileBehaviors":{"http":{"requestUri":"/security-profile-behaviors/validate"},"input":{"type":"structure","required":["behaviors"],"members":{"behaviors":{"shape":"S9o"}}},"output":{"type":"structure","members":{"valid":{"type":"boolean"},"validationErrors":{"type":"list","member":{"type":"structure","members":{"errorMessage":{}}}}}}}},"shapes":{"Sg":{"type":"list","member":{}},"S1e":{"type":"map","key":{},"value":{}},"S1o":{"type":"structure","members":{"deviceCertificateId":{},"caCertificateId":{},"cognitoIdentityPoolId":{},"clientId":{},"policyVersionIdentifier":{"type":"structure","members":{"policyName":{},"policyVersionId":{}}},"account":{},"iamRoleArn":{},"roleAliasArn":{},"issuerCertificateIdentifier":{"type":"structure","members":{"issuerCertificateSubject":{},"issuerId":{},"issuerCertificateSerialNumber":{}}},"deviceCertificateArn":{}}},"S2a":{"type":"map","key":{},"value":{}},"S2e":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"S2n":{"type":"structure","members":{"billingGroupDescription":{}}},"S2y":{"type":"list","member":{}},"S3c":{"type":"list","member":{}},"S3l":{"type":"structure","members":{"defaultAuthorizerName":{},"allowAuthorizerOverride":{"type":"boolean"}}},"S3o":{"type":"structure","members":{"securityPolicy":{}}},"S3q":{"type":"structure","members":{"enableOCSPCheck":{"type":"boolean"}}},"S3v":{"type":"structure","members":{"thingGroupDescription":{},"attributePayload":{"shape":"S3x"}}},"S3x":{"type":"structure","members":{"attributes":{"shape":"S3y"},"merge":{"type":"boolean"}}},"S3y":{"type":"map","key":{},"value":{}},"S49":{"type":"structure","required":["name"],"members":{"name":{},"values":{"type":"list","member":{}}}},"S4m":{"type":"structure","members":{"roleArn":{},"expiresInSec":{"type":"long"}}},"S4p":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"},"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}}}},"S4w":{"type":"structure","required":["criteriaList"],"members":{"criteriaList":{"type":"list","member":{"type":"structure","required":["failureType","action","thresholdPercentage","minNumberOfExecutedThings"],"members":{"failureType":{},"action":{},"thresholdPercentage":{"type":"double"},"minNumberOfExecutedThings":{"type":"integer"}}}}}},"S53":{"type":"structure","members":{"inProgressTimeoutInMinutes":{"type":"long"}}},"S56":{"type":"structure","required":["criteriaList"],"members":{"criteriaList":{"type":"list","member":{"type":"structure","required":["failureType","numberOfRetries"],"members":{"failureType":{},"numberOfRetries":{"type":"integer"}}}}}},"S5b":{"type":"map","key":{},"value":{}},"S5e":{"type":"structure","members":{"startTime":{},"endTime":{},"endBehavior":{},"maintenanceWindows":{"shape":"S5h"}}},"S5h":{"type":"list","member":{"type":"structure","required":["startTime","durationInMinutes"],"members":{"startTime":{},"durationInMinutes":{"type":"integer"}}}},"S5l":{"type":"list","member":{}},"S5t":{"type":"structure","members":{"PublicKey":{},"PrivateKey":{"type":"string","sensitive":true}}},"S5y":{"type":"structure","members":{"updateDeviceCertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"updateCACertificateParams":{"type":"structure","required":["action"],"members":{"action":{}}},"addThingsToThingGroupParams":{"type":"structure","required":["thingGroupNames"],"members":{"thingGroupNames":{"type":"list","member":{}},"overrideDynamicGroups":{"type":"boolean"}}},"replaceDefaultPolicyVersionParams":{"type":"structure","required":["templateName"],"members":{"templateName":{}}},"enableIoTLoggingParams":{"type":"structure","required":["roleArnForLogging","logLevel"],"members":{"roleArnForLogging":{},"logLevel":{}}},"publishFindingToSnsParams":{"type":"structure","required":["topicArn"],"members":{"topicArn":{}}}}},"S6i":{"type":"list","member":{}},"S6k":{"type":"list","member":{}},"S6m":{"type":"structure","members":{"maximumPerMinute":{"type":"integer"},"exponentialRate":{"type":"structure","required":["baseRatePerMinute","incrementFactor","rateIncreaseCriteria"],"members":{"baseRatePerMinute":{"type":"integer"},"incrementFactor":{"type":"double"},"rateIncreaseCriteria":{"type":"structure","members":{"numberOfNotifiedThings":{"type":"integer"},"numberOfSucceededThings":{"type":"integer"}}}}}}},"S6t":{"type":"structure","members":{"expiresInSec":{"type":"long"}}},"S74":{"type":"list","member":{"type":"structure","members":{"fileName":{},"fileType":{"type":"integer"},"fileVersion":{},"fileLocation":{"type":"structure","members":{"stream":{"type":"structure","members":{"streamId":{},"fileId":{"type":"integer"}}},"s3Location":{"shape":"S7d"}}},"codeSigning":{"type":"structure","members":{"awsSignerJobId":{},"startSigningJobParameter":{"type":"structure","members":{"signingProfileParameter":{"type":"structure","members":{"certificateArn":{},"platform":{},"certificatePathOnDevice":{}}},"signingProfileName":{},"destination":{"type":"structure","members":{"s3Destination":{"type":"structure","members":{"bucket":{},"prefix":{}}}}}}},"customCodeSigning":{"type":"structure","members":{"signature":{"type":"structure","members":{"inlineDocument":{"type":"blob"}}},"certificateChain":{"type":"structure","members":{"certificateName":{},"inlineDocument":{}}},"hashAlgorithm":{},"signatureAlgorithm":{}}}}},"attributes":{"type":"map","key":{},"value":{}}}}},"S7d":{"type":"structure","members":{"bucket":{},"key":{},"version":{}}},"S82":{"type":"map","key":{},"value":{}},"S8a":{"type":"string","sensitive":true},"S8b":{"type":"map","key":{},"value":{}},"S8g":{"type":"map","key":{},"value":{},"sensitive":true},"S92":{"type":"structure","required":["targetArn"],"members":{"payloadVersion":{},"targetArn":{}}},"S9i":{"type":"list","member":{}},"S9o":{"type":"list","member":{"shape":"S9p"}},"S9p":{"type":"structure","required":["name"],"members":{"name":{},"metric":{},"metricDimension":{"shape":"S9s"},"criteria":{"type":"structure","members":{"comparisonOperator":{},"value":{"shape":"S9w"},"durationSeconds":{"type":"integer"},"consecutiveDatapointsToAlarm":{"type":"integer"},"consecutiveDatapointsToClear":{"type":"integer"},"statisticalThreshold":{"type":"structure","members":{"statistic":{}}},"mlDetectionConfig":{"type":"structure","required":["confidenceLevel"],"members":{"confidenceLevel":{}}}}},"suppressAlerts":{"type":"boolean"},"exportMetric":{"type":"boolean"}}},"S9s":{"type":"structure","required":["dimensionName"],"members":{"dimensionName":{},"operator":{}}},"S9w":{"type":"structure","members":{"count":{"type":"long"},"cidrs":{"type":"list","member":{}},"ports":{"type":"list","member":{"type":"integer"}},"number":{"type":"double"},"numbers":{"type":"list","member":{"type":"double"}},"strings":{"type":"list","member":{}}}},"Saf":{"type":"map","key":{},"value":{"type":"structure","required":["alertTargetArn","roleArn"],"members":{"alertTargetArn":{},"roleArn":{}}}},"Saj":{"type":"list","member":{}},"Sak":{"type":"list","member":{"type":"structure","required":["metric"],"members":{"metric":{},"metricDimension":{"shape":"S9s"},"exportMetric":{"type":"boolean"}}}},"Sam":{"type":"structure","required":["mqttTopic","roleArn"],"members":{"mqttTopic":{},"roleArn":{}}},"Sas":{"type":"list","member":{"type":"structure","members":{"fileId":{"type":"integer"},"s3Location":{"shape":"S7d"}}}},"Sb4":{"type":"structure","members":{"thingTypeDescription":{},"searchableAttributes":{"type":"list","member":{}}}},"Sbc":{"type":"structure","required":["sql","actions"],"members":{"sql":{},"description":{},"actions":{"shape":"Sbf"},"ruleDisabled":{"type":"boolean"},"awsIotSqlVersion":{},"errorAction":{"shape":"Sbg"}}},"Sbf":{"type":"list","member":{"shape":"Sbg"}},"Sbg":{"type":"structure","members":{"dynamoDB":{"type":"structure","required":["tableName","roleArn","hashKeyField","hashKeyValue"],"members":{"tableName":{},"roleArn":{},"operation":{},"hashKeyField":{},"hashKeyValue":{},"hashKeyType":{},"rangeKeyField":{},"rangeKeyValue":{},"rangeKeyType":{},"payloadField":{}}},"dynamoDBv2":{"type":"structure","required":["roleArn","putItem"],"members":{"roleArn":{},"putItem":{"type":"structure","required":["tableName"],"members":{"tableName":{}}}}},"lambda":{"type":"structure","required":["functionArn"],"members":{"functionArn":{}}},"sns":{"type":"structure","required":["targetArn","roleArn"],"members":{"targetArn":{},"roleArn":{},"messageFormat":{}}},"sqs":{"type":"structure","required":["roleArn","queueUrl"],"members":{"roleArn":{},"queueUrl":{},"useBase64":{"type":"boolean"}}},"kinesis":{"type":"structure","required":["roleArn","streamName"],"members":{"roleArn":{},"streamName":{},"partitionKey":{}}},"republish":{"type":"structure","required":["roleArn","topic"],"members":{"roleArn":{},"topic":{},"qos":{"type":"integer"},"headers":{"type":"structure","members":{"payloadFormatIndicator":{},"contentType":{},"responseTopic":{},"correlationData":{},"messageExpiry":{},"userProperties":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}}}},"s3":{"type":"structure","required":["roleArn","bucketName","key"],"members":{"roleArn":{},"bucketName":{},"key":{},"cannedAcl":{}}},"firehose":{"type":"structure","required":["roleArn","deliveryStreamName"],"members":{"roleArn":{},"deliveryStreamName":{},"separator":{},"batchMode":{"type":"boolean"}}},"cloudwatchMetric":{"type":"structure","required":["roleArn","metricNamespace","metricName","metricValue","metricUnit"],"members":{"roleArn":{},"metricNamespace":{},"metricName":{},"metricValue":{},"metricUnit":{},"metricTimestamp":{}}},"cloudwatchAlarm":{"type":"structure","required":["roleArn","alarmName","stateReason","stateValue"],"members":{"roleArn":{},"alarmName":{},"stateReason":{},"stateValue":{}}},"cloudwatchLogs":{"type":"structure","required":["roleArn","logGroupName"],"members":{"roleArn":{},"logGroupName":{},"batchMode":{"type":"boolean"}}},"elasticsearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}},"salesforce":{"type":"structure","required":["token","url"],"members":{"token":{},"url":{}}},"iotAnalytics":{"type":"structure","members":{"channelArn":{},"channelName":{},"batchMode":{"type":"boolean"},"roleArn":{}}},"iotEvents":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"messageId":{},"batchMode":{"type":"boolean"},"roleArn":{}}},"iotSiteWise":{"type":"structure","required":["putAssetPropertyValueEntries","roleArn"],"members":{"putAssetPropertyValueEntries":{"type":"list","member":{"type":"structure","required":["propertyValues"],"members":{"entryId":{},"assetId":{},"propertyId":{},"propertyAlias":{},"propertyValues":{"type":"list","member":{"type":"structure","required":["value","timestamp"],"members":{"value":{"type":"structure","members":{"stringValue":{},"integerValue":{},"doubleValue":{},"booleanValue":{}}},"timestamp":{"type":"structure","required":["timeInSeconds"],"members":{"timeInSeconds":{},"offsetInNanos":{}}},"quality":{}}}}}}},"roleArn":{}}},"stepFunctions":{"type":"structure","required":["stateMachineName","roleArn"],"members":{"executionNamePrefix":{},"stateMachineName":{},"roleArn":{}}},"timestream":{"type":"structure","required":["roleArn","databaseName","tableName","dimensions"],"members":{"roleArn":{},"databaseName":{},"tableName":{},"dimensions":{"type":"list","member":{"type":"structure","required":["name","value"],"members":{"name":{},"value":{}}}},"timestamp":{"type":"structure","required":["value","unit"],"members":{"value":{},"unit":{}}}}},"http":{"type":"structure","required":["url"],"members":{"url":{},"confirmationUrl":{},"headers":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"auth":{"type":"structure","members":{"sigv4":{"type":"structure","required":["signingRegion","serviceName","roleArn"],"members":{"signingRegion":{},"serviceName":{},"roleArn":{}}}}}}},"kafka":{"type":"structure","required":["destinationArn","topic","clientProperties"],"members":{"destinationArn":{},"topic":{},"key":{},"partition":{},"clientProperties":{"type":"map","key":{},"value":{}},"headers":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}},"openSearch":{"type":"structure","required":["roleArn","endpoint","index","type","id"],"members":{"roleArn":{},"endpoint":{},"index":{},"type":{},"id":{}}},"location":{"type":"structure","required":["roleArn","trackerName","deviceId","latitude","longitude"],"members":{"roleArn":{},"trackerName":{},"deviceId":{},"timestamp":{"type":"structure","required":["value"],"members":{"value":{},"unit":{}}},"latitude":{},"longitude":{}}}}},"Set":{"type":"list","member":{}},"Sev":{"type":"list","member":{}},"Sez":{"type":"structure","members":{"arn":{},"status":{},"createdAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"statusReason":{},"httpUrlProperties":{"type":"structure","members":{"confirmationUrl":{}}},"vpcProperties":{"type":"structure","members":{"subnetIds":{"shape":"Set"},"securityGroups":{"shape":"Sev"},"vpcId":{},"roleArn":{}}}}},"Sh5":{"type":"map","key":{},"value":{"type":"structure","members":{"targetArn":{},"roleArn":{},"enabled":{"type":"boolean"}}}},"Sh8":{"type":"map","key":{},"value":{"type":"structure","members":{"enabled":{"type":"boolean"}}}},"Shd":{"type":"structure","members":{"findingId":{},"taskId":{},"checkName":{},"taskStartTime":{"type":"timestamp"},"findingTime":{"type":"timestamp"},"severity":{},"nonCompliantResource":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"S1o"},"additionalInfo":{"shape":"Shh"}}},"relatedResources":{"shape":"Shi"},"reasonForNonCompliance":{},"reasonForNonComplianceCode":{},"isSuppressed":{"type":"boolean"}}},"Shh":{"type":"map","key":{},"value":{}},"Shi":{"type":"list","member":{"type":"structure","members":{"resourceType":{},"resourceIdentifier":{"shape":"S1o"},"additionalInfo":{"shape":"Shh"}}}},"Shx":{"type":"structure","members":{"auditTaskId":{},"findingIds":{"type":"list","member":{}},"auditCheckToReasonCodeFilter":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"Si1":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Si3":{"type":"list","member":{"type":"structure","members":{"name":{},"id":{},"roleArn":{},"actionParams":{"shape":"S5y"}}}},"Siu":{"type":"structure","members":{"authorizerName":{},"authorizerArn":{},"authorizerFunctionArn":{},"tokenKeyName":{},"tokenSigningPublicKeys":{"shape":"S2a"},"status":{},"creationDate":{"type":"timestamp"},"lastModifiedDate":{"type":"timestamp"},"signingDisabled":{"type":"boolean"},"enableCachingForHttp":{"type":"boolean"}}},"Sj7":{"type":"structure","members":{"notBefore":{"type":"timestamp"},"notAfter":{"type":"timestamp"}}},"Sj9":{"type":"structure","members":{"templateBody":{},"roleArn":{},"templateName":{}}},"Sjo":{"type":"structure","members":{"taskId":{},"taskStatus":{},"taskStartTime":{"type":"timestamp"},"taskEndTime":{"type":"timestamp"},"target":{"shape":"Sjq"},"violationEventOccurrenceRange":{"shape":"Sjt"},"onlyActiveViolationsIncluded":{"type":"boolean"},"suppressedAlertsIncluded":{"type":"boolean"},"actionsDefinition":{"shape":"Si3"},"taskStatistics":{"type":"structure","members":{"actionsExecuted":{"type":"long"},"actionsSkipped":{"type":"long"},"actionsFailed":{"type":"long"}}}}},"Sjq":{"type":"structure","members":{"violationIds":{"type":"list","member":{}},"securityProfileName":{},"behaviorName":{}}},"Sjt":{"type":"structure","required":["startTime","endTime"],"members":{"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"}}},"Ske":{"type":"map","key":{},"value":{"type":"structure","members":{"Enabled":{"type":"boolean"}}}},"Slk":{"type":"list","member":{}},"Smd":{"type":"list","member":{"shape":"Sme"}},"Sme":{"type":"structure","members":{"groupName":{},"groupArn":{}}},"Smq":{"type":"structure","members":{"deprecated":{"type":"boolean"},"deprecationDate":{"type":"timestamp"},"creationDate":{"type":"timestamp"}}},"Snp":{"type":"structure","required":["thingIndexingMode"],"members":{"thingIndexingMode":{},"thingConnectivityIndexingMode":{},"deviceDefenderIndexingMode":{},"namedShadowIndexingMode":{},"managedFields":{"shape":"Snu"},"customFields":{"shape":"Snu"},"filter":{"type":"structure","members":{"namedShadowNames":{"type":"list","member":{}},"geoLocations":{"type":"list","member":{"type":"structure","members":{"name":{},"order":{}}}}}}}},"Snu":{"type":"list","member":{"type":"structure","members":{"name":{},"type":{}}}},"So5":{"type":"structure","required":["thingGroupIndexingMode"],"members":{"thingGroupIndexingMode":{},"managedFields":{"shape":"Snu"},"customFields":{"shape":"Snu"}}},"Sol":{"type":"structure","members":{"enabled":{"type":"boolean"},"roleArn":{}}},"Spv":{"type":"structure","members":{"confidenceLevel":{}}},"Sq2":{"type":"list","member":{"type":"structure","members":{"policyName":{},"policyArn":{}}}},"Sr8":{"type":"list","member":{"type":"structure","members":{"certificateArn":{},"certificateId":{},"status":{},"certificateMode":{},"creationDate":{"type":"timestamp"}}}},"Ss8":{"type":"structure","members":{"status":{},"queuedAt":{"type":"timestamp"},"startedAt":{"type":"timestamp"},"lastUpdatedAt":{"type":"timestamp"},"executionNumber":{"type":"long"},"retryAttempt":{"type":"integer"}}},"Stj":{"type":"list","member":{}},"Stt":{"type":"list","member":{}},"Sue":{"type":"structure","required":["name","arn"],"members":{"name":{},"arn":{}}},"Suj":{"type":"structure","required":["arn"],"members":{"arn":{}}},"Sw7":{"type":"structure","required":["targetType"],"members":{"targetType":{},"targetName":{}}},"Sx4":{"type":"list","member":{}},"Sxx":{"type":"structure","required":["resources"],"members":{"actionType":{},"resources":{"type":"list","member":{}}}},"Sy1":{"type":"list","member":{}},"S10n":{"type":"list","member":{}}}}

/***/ }),
/* 523 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetBehaviorModelTrainingSummaries":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"summaries"},"ListActiveViolations":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"activeViolations"},"ListAttachedPolicies":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"policies"},"ListAuditFindings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"findings"},"ListAuditMitigationActionsExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"actionsExecutions"},"ListAuditMitigationActionsTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tasks"},"ListAuditSuppressions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"suppressions"},"ListAuditTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tasks"},"ListAuthorizers":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"authorizers"},"ListBillingGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"billingGroups"},"ListCACertificates":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"certificates"},"ListCertificates":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"certificates"},"ListCertificatesByCA":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"certificates"},"ListCustomMetrics":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"metricNames"},"ListDetectMitigationActionsExecutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"actionsExecutions"},"ListDetectMitigationActionsTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"tasks"},"ListDimensions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"dimensionNames"},"ListDomainConfigurations":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"domainConfigurations"},"ListFleetMetrics":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"fleetMetrics"},"ListIndices":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"indexNames"},"ListJobExecutionsForJob":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"executionSummaries"},"ListJobExecutionsForThing":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"executionSummaries"},"ListJobTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"jobTemplates"},"ListJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"jobs"},"ListManagedJobTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"managedJobTemplates"},"ListMetricValues":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"metricDatumList"},"ListMitigationActions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"actionIdentifiers"},"ListOTAUpdates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"otaUpdates"},"ListOutgoingCertificates":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"outgoingCertificates"},"ListPackageVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"packageVersionSummaries"},"ListPackages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"packageSummaries"},"ListPolicies":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"policies"},"ListPolicyPrincipals":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"principals"},"ListPrincipalPolicies":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"policies"},"ListPrincipalThings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListProvisioningTemplateVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"versions"},"ListProvisioningTemplates":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"templates"},"ListRelatedResourcesForAuditFinding":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"relatedResources"},"ListRoleAliases":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"roleAliases"},"ListScheduledAudits":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"scheduledAudits"},"ListSecurityProfiles":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"securityProfileIdentifiers"},"ListSecurityProfilesForTarget":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"securityProfileTargetMappings"},"ListStreams":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"streams"},"ListTagsForResource":{"input_token":"nextToken","output_token":"nextToken","result_key":"tags"},"ListTargetsForPolicy":{"input_token":"marker","limit_key":"pageSize","output_token":"nextMarker","result_key":"targets"},"ListTargetsForSecurityProfile":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"securityProfileTargets"},"ListThingGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"thingGroups"},"ListThingGroupsForThing":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"thingGroups"},"ListThingPrincipals":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"principals"},"ListThingRegistrationTaskReports":{"input_token":"nextToken","limit_key":"maxResults","non_aggregate_keys":["reportType"],"output_token":"nextToken","result_key":"resourceLinks"},"ListThingRegistrationTasks":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"taskIds"},"ListThingTypes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"thingTypes"},"ListThings":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListThingsInBillingGroup":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListThingsInThingGroup":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"things"},"ListTopicRuleDestinations":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"destinationSummaries"},"ListTopicRules":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"rules"},"ListV2LoggingLevels":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"logTargetConfigurations"},"ListViolationEvents":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"violationEvents"}}}

/***/ }),
/* 524 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-05-28","endpointPrefix":"data-ats.iot","protocol":"rest-json","serviceFullName":"AWS IoT Data Plane","serviceId":"IoT Data Plane","signatureVersion":"v4","signingName":"iotdata","uid":"iot-data-2015-05-28"},"operations":{"DeleteThingShadow":{"http":{"method":"DELETE","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","required":["payload"],"members":{"payload":{"type":"blob"}},"payload":"payload"}},"GetRetainedMessage":{"http":{"method":"GET","requestUri":"/retainedMessage/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"}}},"output":{"type":"structure","members":{"topic":{},"payload":{"type":"blob"},"qos":{"type":"integer"},"lastModifiedTime":{"type":"long"},"userProperties":{"type":"blob"}}}},"GetThingShadow":{"http":{"method":"GET","requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"}}},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}},"ListNamedShadowsForThing":{"http":{"method":"GET","requestUri":"/api/things/shadow/ListNamedShadowsForThing/{thingName}"},"input":{"type":"structure","required":["thingName"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"pageSize":{"location":"querystring","locationName":"pageSize","type":"integer"}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{}},"nextToken":{},"timestamp":{"type":"long"}}}},"ListRetainedMessages":{"http":{"method":"GET","requestUri":"/retainedMessage"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"retainedTopics":{"type":"list","member":{"type":"structure","members":{"topic":{},"payloadSize":{"type":"long"},"qos":{"type":"integer"},"lastModifiedTime":{"type":"long"}}}},"nextToken":{}}}},"Publish":{"http":{"requestUri":"/topics/{topic}"},"input":{"type":"structure","required":["topic"],"members":{"topic":{"location":"uri","locationName":"topic"},"qos":{"location":"querystring","locationName":"qos","type":"integer"},"retain":{"location":"querystring","locationName":"retain","type":"boolean"},"payload":{"type":"blob"},"userProperties":{"jsonvalue":true,"location":"header","locationName":"x-amz-mqtt5-user-properties"},"payloadFormatIndicator":{"location":"header","locationName":"x-amz-mqtt5-payload-format-indicator"},"contentType":{"location":"querystring","locationName":"contentType"},"responseTopic":{"location":"querystring","locationName":"responseTopic"},"correlationData":{"location":"header","locationName":"x-amz-mqtt5-correlation-data"},"messageExpiry":{"location":"querystring","locationName":"messageExpiry","type":"long"}},"payload":"payload"}},"UpdateThingShadow":{"http":{"requestUri":"/things/{thingName}/shadow"},"input":{"type":"structure","required":["thingName","payload"],"members":{"thingName":{"location":"uri","locationName":"thingName"},"shadowName":{"location":"querystring","locationName":"name"},"payload":{"type":"blob"}},"payload":"payload"},"output":{"type":"structure","members":{"payload":{"type":"blob"}},"payload":"payload"}}},"shapes":{}}

/***/ }),
/* 525 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListRetainedMessages":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"retainedTopics"}}}

/***/ }),
/* 526 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"iotanalytics","protocol":"rest-json","serviceFullName":"AWS IoT Analytics","serviceId":"IoTAnalytics","signatureVersion":"v4","signingName":"iotanalytics","uid":"iotanalytics-2017-11-27"},"operations":{"BatchPutMessage":{"http":{"requestUri":"/messages/batch","responseCode":200},"input":{"type":"structure","required":["channelName","messages"],"members":{"channelName":{},"messages":{"type":"list","member":{"type":"structure","required":["messageId","payload"],"members":{"messageId":{},"payload":{"type":"blob"}}}}}},"output":{"type":"structure","members":{"batchPutMessageErrorEntries":{"type":"list","member":{"type":"structure","members":{"messageId":{},"errorCode":{},"errorMessage":{}}}}}}},"CancelPipelineReprocessing":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}/reprocessing/{reprocessingId}"},"input":{"type":"structure","required":["pipelineName","reprocessingId"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"reprocessingId":{"location":"uri","locationName":"reprocessingId"}}},"output":{"type":"structure","members":{}}},"CreateChannel":{"http":{"requestUri":"/channels","responseCode":201},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"channelName":{},"channelArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDataset":{"http":{"requestUri":"/datasets","responseCode":201},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"tags":{"shape":"Sq"},"lateDataRules":{"shape":"S24"}}},"output":{"type":"structure","members":{"datasetName":{},"datasetArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreateDatasetContent":{"http":{"requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{}}},"output":{"type":"structure","members":{"versionId":{}}}},"CreateDatastore":{"http":{"requestUri":"/datastores","responseCode":201},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{},"datastoreStorage":{"shape":"S2h"},"retentionPeriod":{"shape":"Sn"},"tags":{"shape":"Sq"},"fileFormatConfiguration":{"shape":"S2m"},"datastorePartitions":{"shape":"S2u"}}},"output":{"type":"structure","members":{"datastoreName":{},"datastoreArn":{},"retentionPeriod":{"shape":"Sn"}}}},"CreatePipeline":{"http":{"requestUri":"/pipelines","responseCode":201},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{},"pipelineActivities":{"shape":"S34"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{"pipelineName":{},"pipelineArn":{}}}},"DeleteChannel":{"http":{"method":"DELETE","requestUri":"/channels/{channelName}","responseCode":204},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"}}}},"DeleteDataset":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}}},"DeleteDatasetContent":{"http":{"method":"DELETE","requestUri":"/datasets/{datasetName}/content","responseCode":204},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}}},"DeleteDatastore":{"http":{"method":"DELETE","requestUri":"/datastores/{datastoreName}","responseCode":204},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"}}}},"DeletePipeline":{"http":{"method":"DELETE","requestUri":"/pipelines/{pipelineName}","responseCode":204},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}}},"DescribeChannel":{"http":{"method":"GET","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"channel":{"type":"structure","members":{"name":{},"storage":{"shape":"Sh"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S42"}}}}}},"DescribeDataset":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"arn":{},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"lateDataRules":{"shape":"S24"}}}}}},"DescribeDatastore":{"http":{"method":"GET","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"includeStatistics":{"location":"querystring","locationName":"includeStatistics","type":"boolean"}}},"output":{"type":"structure","members":{"datastore":{"type":"structure","members":{"name":{},"storage":{"shape":"S2h"},"arn":{},"status":{},"retentionPeriod":{"shape":"Sn"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"},"fileFormatConfiguration":{"shape":"S2m"},"datastorePartitions":{"shape":"S2u"}}},"statistics":{"type":"structure","members":{"size":{"shape":"S42"}}}}}},"DescribeLoggingOptions":{"http":{"method":"GET","requestUri":"/logging"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"loggingOptions":{"shape":"S4f"}}}},"DescribePipeline":{"http":{"method":"GET","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"}}},"output":{"type":"structure","members":{"pipeline":{"type":"structure","members":{"name":{},"arn":{},"activities":{"shape":"S34"},"reprocessingSummaries":{"shape":"S4l"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}}}},"GetDatasetContent":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/content"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"versionId":{"location":"querystring","locationName":"versionId"}}},"output":{"type":"structure","members":{"entries":{"type":"list","member":{"type":"structure","members":{"entryName":{},"dataURI":{}}}},"timestamp":{"type":"timestamp"},"status":{"shape":"S4t"}}}},"ListChannels":{"http":{"method":"GET","requestUri":"/channels"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"channelSummaries":{"type":"list","member":{"type":"structure","members":{"channelName":{},"channelStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasetContents":{"http":{"method":"GET","requestUri":"/datasets/{datasetName}/contents"},"input":{"type":"structure","required":["datasetName"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"scheduledOnOrAfter":{"location":"querystring","locationName":"scheduledOnOrAfter","type":"timestamp"},"scheduledBefore":{"location":"querystring","locationName":"scheduledBefore","type":"timestamp"}}},"output":{"type":"structure","members":{"datasetContentSummaries":{"type":"list","member":{"type":"structure","members":{"version":{},"status":{"shape":"S4t"},"creationTime":{"type":"timestamp"},"scheduleTime":{"type":"timestamp"},"completionTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListDatasets":{"http":{"method":"GET","requestUri":"/datasets"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datasetSummaries":{"type":"list","member":{"type":"structure","members":{"datasetName":{},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"triggers":{"shape":"S1l"},"actions":{"type":"list","member":{"type":"structure","members":{"actionName":{},"actionType":{}}}}}}},"nextToken":{}}}},"ListDatastores":{"http":{"method":"GET","requestUri":"/datastores"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"datastoreSummaries":{"type":"list","member":{"type":"structure","members":{"datastoreName":{},"datastoreStorage":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","members":{"bucket":{},"keyPrefix":{},"roleArn":{}}},"iotSiteWiseMultiLayerStorage":{"type":"structure","members":{"customerManagedS3Storage":{"type":"structure","members":{"bucket":{},"keyPrefix":{}}}}}}},"status":{},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"},"lastMessageArrivalTime":{"type":"timestamp"},"fileFormatType":{},"datastorePartitions":{"shape":"S2u"}}}},"nextToken":{}}}},"ListPipelines":{"http":{"method":"GET","requestUri":"/pipelines"},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"pipelineSummaries":{"type":"list","member":{"type":"structure","members":{"pipelineName":{},"reprocessingSummaries":{"shape":"S4l"},"creationTime":{"type":"timestamp"},"lastUpdateTime":{"type":"timestamp"}}}},"nextToken":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags"},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"Sq"}}}},"PutLoggingOptions":{"http":{"method":"PUT","requestUri":"/logging"},"input":{"type":"structure","required":["loggingOptions"],"members":{"loggingOptions":{"shape":"S4f"}}}},"RunPipelineActivity":{"http":{"requestUri":"/pipelineactivities/run"},"input":{"type":"structure","required":["pipelineActivity","payloads"],"members":{"pipelineActivity":{"shape":"S35"},"payloads":{"shape":"S5z"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S5z"},"logResult":{}}}},"SampleChannelData":{"http":{"method":"GET","requestUri":"/channels/{channelName}/sample"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"maxMessages":{"location":"querystring","locationName":"maxMessages","type":"integer"},"startTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"endTime":{"location":"querystring","locationName":"endTime","type":"timestamp"}}},"output":{"type":"structure","members":{"payloads":{"shape":"S5z"}}}},"StartPipelineReprocessing":{"http":{"requestUri":"/pipelines/{pipelineName}/reprocessing"},"input":{"type":"structure","required":["pipelineName"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"startTime":{"type":"timestamp"},"endTime":{"type":"timestamp"},"channelMessages":{"type":"structure","members":{"s3Paths":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"reprocessingId":{}}}},"TagResource":{"http":{"requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tags":{"shape":"Sq"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"querystring","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateChannel":{"http":{"method":"PUT","requestUri":"/channels/{channelName}"},"input":{"type":"structure","required":["channelName"],"members":{"channelName":{"location":"uri","locationName":"channelName"},"channelStorage":{"shape":"Sh"},"retentionPeriod":{"shape":"Sn"}}}},"UpdateDataset":{"http":{"method":"PUT","requestUri":"/datasets/{datasetName}"},"input":{"type":"structure","required":["datasetName","actions"],"members":{"datasetName":{"location":"uri","locationName":"datasetName"},"actions":{"shape":"Sy"},"triggers":{"shape":"S1l"},"contentDeliveryRules":{"shape":"S1q"},"retentionPeriod":{"shape":"Sn"},"versioningConfiguration":{"shape":"S21"},"lateDataRules":{"shape":"S24"}}}},"UpdateDatastore":{"http":{"method":"PUT","requestUri":"/datastores/{datastoreName}"},"input":{"type":"structure","required":["datastoreName"],"members":{"datastoreName":{"location":"uri","locationName":"datastoreName"},"retentionPeriod":{"shape":"Sn"},"datastoreStorage":{"shape":"S2h"},"fileFormatConfiguration":{"shape":"S2m"}}}},"UpdatePipeline":{"http":{"method":"PUT","requestUri":"/pipelines/{pipelineName}"},"input":{"type":"structure","required":["pipelineName","pipelineActivities"],"members":{"pipelineName":{"location":"uri","locationName":"pipelineName"},"pipelineActivities":{"shape":"S34"}}}}},"shapes":{"Sh":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}}}},"Sn":{"type":"structure","members":{"unlimited":{"type":"boolean"},"numberOfDays":{"type":"integer"}}},"Sq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Sy":{"type":"list","member":{"type":"structure","members":{"actionName":{},"queryAction":{"type":"structure","required":["sqlQuery"],"members":{"sqlQuery":{},"filters":{"type":"list","member":{"type":"structure","members":{"deltaTime":{"type":"structure","required":["offsetSeconds","timeExpression"],"members":{"offsetSeconds":{"type":"integer"},"timeExpression":{}}}}}}}},"containerAction":{"type":"structure","required":["image","executionRoleArn","resourceConfiguration"],"members":{"image":{},"executionRoleArn":{},"resourceConfiguration":{"type":"structure","required":["computeType","volumeSizeInGB"],"members":{"computeType":{},"volumeSizeInGB":{"type":"integer"}}},"variables":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{},"stringValue":{},"doubleValue":{"type":"double"},"datasetContentVersionValue":{"type":"structure","required":["datasetName"],"members":{"datasetName":{}}},"outputFileUriValue":{"type":"structure","required":["fileName"],"members":{"fileName":{}}}}}}}}}}},"S1l":{"type":"list","member":{"type":"structure","members":{"schedule":{"type":"structure","members":{"expression":{}}},"dataset":{"type":"structure","required":["name"],"members":{"name":{}}}}}},"S1q":{"type":"list","member":{"type":"structure","required":["destination"],"members":{"entryName":{},"destination":{"type":"structure","members":{"iotEventsDestinationConfiguration":{"type":"structure","required":["inputName","roleArn"],"members":{"inputName":{},"roleArn":{}}},"s3DestinationConfiguration":{"type":"structure","required":["bucket","key","roleArn"],"members":{"bucket":{},"key":{},"glueConfiguration":{"type":"structure","required":["tableName","databaseName"],"members":{"tableName":{},"databaseName":{}}},"roleArn":{}}}}}}}},"S21":{"type":"structure","members":{"unlimited":{"type":"boolean"},"maxVersions":{"type":"integer"}}},"S24":{"type":"list","member":{"type":"structure","required":["ruleConfiguration"],"members":{"ruleName":{},"ruleConfiguration":{"type":"structure","members":{"deltaTimeSessionWindowConfiguration":{"type":"structure","required":["timeoutInMinutes"],"members":{"timeoutInMinutes":{"type":"integer"}}}}}}}},"S2h":{"type":"structure","members":{"serviceManagedS3":{"type":"structure","members":{}},"customerManagedS3":{"type":"structure","required":["bucket","roleArn"],"members":{"bucket":{},"keyPrefix":{},"roleArn":{}}},"iotSiteWiseMultiLayerStorage":{"type":"structure","required":["customerManagedS3Storage"],"members":{"customerManagedS3Storage":{"type":"structure","required":["bucket"],"members":{"bucket":{},"keyPrefix":{}}}}}}},"S2m":{"type":"structure","members":{"jsonConfiguration":{"type":"structure","members":{}},"parquetConfiguration":{"type":"structure","members":{"schemaDefinition":{"type":"structure","members":{"columns":{"type":"list","member":{"type":"structure","required":["name","type"],"members":{"name":{},"type":{}}}}}}}}}},"S2u":{"type":"structure","members":{"partitions":{"type":"list","member":{"type":"structure","members":{"attributePartition":{"type":"structure","required":["attributeName"],"members":{"attributeName":{}}},"timestampPartition":{"type":"structure","required":["attributeName"],"members":{"attributeName":{},"timestampFormat":{}}}}}}}},"S34":{"type":"list","member":{"shape":"S35"}},"S35":{"type":"structure","members":{"channel":{"type":"structure","required":["name","channelName"],"members":{"name":{},"channelName":{},"next":{}}},"lambda":{"type":"structure","required":["name","lambdaName","batchSize"],"members":{"name":{},"lambdaName":{},"batchSize":{"type":"integer"},"next":{}}},"datastore":{"type":"structure","required":["name","datastoreName"],"members":{"name":{},"datastoreName":{}}},"addAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"type":"map","key":{},"value":{}},"next":{}}},"removeAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S3g"},"next":{}}},"selectAttributes":{"type":"structure","required":["name","attributes"],"members":{"name":{},"attributes":{"shape":"S3g"},"next":{}}},"filter":{"type":"structure","required":["name","filter"],"members":{"name":{},"filter":{},"next":{}}},"math":{"type":"structure","required":["name","attribute","math"],"members":{"name":{},"attribute":{},"math":{},"next":{}}},"deviceRegistryEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}},"deviceShadowEnrich":{"type":"structure","required":["name","attribute","thingName","roleArn"],"members":{"name":{},"attribute":{},"thingName":{},"roleArn":{},"next":{}}}}},"S3g":{"type":"list","member":{}},"S42":{"type":"structure","members":{"estimatedSizeInBytes":{"type":"double"},"estimatedOn":{"type":"timestamp"}}},"S4f":{"type":"structure","required":["roleArn","level","enabled"],"members":{"roleArn":{},"level":{},"enabled":{"type":"boolean"}}},"S4l":{"type":"list","member":{"type":"structure","members":{"id":{},"status":{},"creationTime":{"type":"timestamp"}}}},"S4t":{"type":"structure","members":{"state":{},"reason":{}}},"S5z":{"type":"list","member":{"type":"blob"}}}}

/***/ }),
/* 527 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListChannels":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasetContents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatasets":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListDatastores":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"ListPipelines":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 528 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-12-02","endpointPrefix":"kinesis","jsonVersion":"1.1","protocol":"json","protocolSettings":{"h2":"eventstream"},"serviceAbbreviation":"Kinesis","serviceFullName":"Amazon Kinesis","serviceId":"Kinesis","signatureVersion":"v4","targetPrefix":"Kinesis_20131202","uid":"kinesis-2013-12-02"},"operations":{"AddTagsToStream":{"input":{"type":"structure","required":["Tags"],"members":{"StreamName":{},"Tags":{"type":"map","key":{},"value":{}},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"CreateStream":{"input":{"type":"structure","required":["StreamName"],"members":{"StreamName":{},"ShardCount":{"type":"integer"},"StreamModeDetails":{"shape":"S9"}}}},"DecreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{"contextParam":{"name":"ResourceARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"DeleteStream":{"input":{"type":"structure","members":{"StreamName":{},"EnforceConsumerDeletion":{"type":"boolean"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"DeregisterStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{"contextParam":{"name":"StreamARN"}},"ConsumerName":{},"ConsumerARN":{"contextParam":{"name":"ConsumerARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"DescribeLimits":{"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["ShardLimit","OpenShardCount","OnDemandStreamCount","OnDemandStreamCountLimit"],"members":{"ShardLimit":{"type":"integer"},"OpenShardCount":{"type":"integer"},"OnDemandStreamCount":{"type":"integer"},"OnDemandStreamCountLimit":{"type":"integer"}}}},"DescribeStream":{"input":{"type":"structure","members":{"StreamName":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","required":["StreamDescription"],"members":{"StreamDescription":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","Shards","HasMoreShards","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"StreamModeDetails":{"shape":"S9"},"Shards":{"shape":"Sv"},"HasMoreShards":{"type":"boolean"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"S12"},"EncryptionType":{},"KeyId":{}}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"DescribeStreamConsumer":{"input":{"type":"structure","members":{"StreamARN":{"contextParam":{"name":"StreamARN"}},"ConsumerName":{},"ConsumerARN":{"contextParam":{"name":"ConsumerARN"}}}},"output":{"type":"structure","required":["ConsumerDescription"],"members":{"ConsumerDescription":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp","StreamARN"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"},"StreamARN":{}}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"DescribeStreamSummary":{"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","required":["StreamDescriptionSummary"],"members":{"StreamDescriptionSummary":{"type":"structure","required":["StreamName","StreamARN","StreamStatus","RetentionPeriodHours","StreamCreationTimestamp","EnhancedMonitoring","OpenShardCount"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"StreamModeDetails":{"shape":"S9"},"RetentionPeriodHours":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"EnhancedMonitoring":{"shape":"S12"},"EncryptionType":{},"KeyId":{},"OpenShardCount":{"type":"integer"},"ConsumerCount":{"type":"integer"}}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"DisableEnhancedMonitoring":{"input":{"type":"structure","required":["ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"S14"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"shape":"S1h"},"staticContextParams":{"OperationType":{"value":"control"}}},"EnableEnhancedMonitoring":{"input":{"type":"structure","required":["ShardLevelMetrics"],"members":{"StreamName":{},"ShardLevelMetrics":{"shape":"S14"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"shape":"S1h"},"staticContextParams":{"OperationType":{"value":"control"}}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","required":["Records"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["SequenceNumber","Data","PartitionKey"],"members":{"SequenceNumber":{},"ApproximateArrivalTimestamp":{"type":"timestamp"},"Data":{"type":"blob"},"PartitionKey":{},"EncryptionType":{}}}},"NextShardIterator":{},"MillisBehindLatest":{"type":"long"},"ChildShards":{"type":"list","member":{"type":"structure","required":["ShardId","ParentShards","HashKeyRange"],"members":{"ShardId":{},"ParentShards":{"type":"list","member":{}},"HashKeyRange":{"shape":"Sx"}}}}}},"staticContextParams":{"OperationType":{"value":"data"}}},"GetResourcePolicy":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{"contextParam":{"name":"ResourceARN"}}}},"output":{"type":"structure","required":["Policy"],"members":{"Policy":{}}},"staticContextParams":{"OperationType":{"value":"control"}}},"GetShardIterator":{"input":{"type":"structure","required":["ShardId","ShardIteratorType"],"members":{"StreamName":{},"ShardId":{},"ShardIteratorType":{},"StartingSequenceNumber":{},"Timestamp":{"type":"timestamp"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","members":{"ShardIterator":{}}},"staticContextParams":{"OperationType":{"value":"data"}}},"IncreaseStreamRetentionPeriod":{"input":{"type":"structure","required":["RetentionPeriodHours"],"members":{"StreamName":{},"RetentionPeriodHours":{"type":"integer"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"ListShards":{"input":{"type":"structure","members":{"StreamName":{},"NextToken":{},"ExclusiveStartShardId":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"},"ShardFilter":{"type":"structure","required":["Type"],"members":{"Type":{},"ShardId":{},"Timestamp":{"type":"timestamp"}}},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","members":{"Shards":{"shape":"Sv"},"NextToken":{}}},"staticContextParams":{"OperationType":{"value":"control"}}},"ListStreamConsumers":{"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{"contextParam":{"name":"StreamARN"}},"NextToken":{},"MaxResults":{"type":"integer"},"StreamCreationTimestamp":{"type":"timestamp"}}},"output":{"type":"structure","members":{"Consumers":{"type":"list","member":{"shape":"S2c"}},"NextToken":{}}},"staticContextParams":{"OperationType":{"value":"control"}}},"ListStreams":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"ExclusiveStartStreamName":{},"NextToken":{}}},"output":{"type":"structure","required":["StreamNames","HasMoreStreams"],"members":{"StreamNames":{"type":"list","member":{}},"HasMoreStreams":{"type":"boolean"},"NextToken":{},"StreamSummaries":{"type":"list","member":{"type":"structure","required":["StreamName","StreamARN","StreamStatus"],"members":{"StreamName":{},"StreamARN":{},"StreamStatus":{},"StreamModeDetails":{"shape":"S9"},"StreamCreationTimestamp":{"type":"timestamp"}}}}}}},"ListTagsForStream":{"input":{"type":"structure","members":{"StreamName":{},"ExclusiveStartTagKey":{},"Limit":{"type":"integer"},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","required":["Tags","HasMoreTags"],"members":{"Tags":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Value":{}}}},"HasMoreTags":{"type":"boolean"}}},"staticContextParams":{"OperationType":{"value":"control"}}},"MergeShards":{"input":{"type":"structure","required":["ShardToMerge","AdjacentShardToMerge"],"members":{"StreamName":{},"ShardToMerge":{},"AdjacentShardToMerge":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"PutRecord":{"input":{"type":"structure","required":["Data","PartitionKey"],"members":{"StreamName":{},"Data":{"type":"blob"},"PartitionKey":{},"ExplicitHashKey":{},"SequenceNumberForOrdering":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","required":["ShardId","SequenceNumber"],"members":{"ShardId":{},"SequenceNumber":{},"EncryptionType":{}}},"staticContextParams":{"OperationType":{"value":"data"}}},"PutRecords":{"input":{"type":"structure","required":["Records"],"members":{"Records":{"type":"list","member":{"type":"structure","required":["Data","PartitionKey"],"members":{"Data":{"type":"blob"},"ExplicitHashKey":{},"PartitionKey":{}}}},"StreamName":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","required":["Records"],"members":{"FailedRecordCount":{"type":"integer"},"Records":{"type":"list","member":{"type":"structure","members":{"SequenceNumber":{},"ShardId":{},"ErrorCode":{},"ErrorMessage":{}}}},"EncryptionType":{}}},"staticContextParams":{"OperationType":{"value":"data"}}},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceARN","Policy"],"members":{"ResourceARN":{"contextParam":{"name":"ResourceARN"}},"Policy":{}}},"staticContextParams":{"OperationType":{"value":"control"}}},"RegisterStreamConsumer":{"input":{"type":"structure","required":["StreamARN","ConsumerName"],"members":{"StreamARN":{"contextParam":{"name":"StreamARN"}},"ConsumerName":{}}},"output":{"type":"structure","required":["Consumer"],"members":{"Consumer":{"shape":"S2c"}}},"staticContextParams":{"OperationType":{"value":"control"}}},"RemoveTagsFromStream":{"input":{"type":"structure","required":["TagKeys"],"members":{"StreamName":{},"TagKeys":{"type":"list","member":{}},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"SplitShard":{"input":{"type":"structure","required":["ShardToSplit","NewStartingHashKey"],"members":{"StreamName":{},"ShardToSplit":{},"NewStartingHashKey":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"StartStreamEncryption":{"input":{"type":"structure","required":["EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"StopStreamEncryption":{"input":{"type":"structure","required":["EncryptionType","KeyId"],"members":{"StreamName":{},"EncryptionType":{},"KeyId":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"staticContextParams":{"OperationType":{"value":"control"}}},"UpdateShardCount":{"input":{"type":"structure","required":["TargetShardCount","ScalingType"],"members":{"StreamName":{},"TargetShardCount":{"type":"integer"},"ScalingType":{},"StreamARN":{"contextParam":{"name":"StreamARN"}}}},"output":{"type":"structure","members":{"StreamName":{},"CurrentShardCount":{"type":"integer"},"TargetShardCount":{"type":"integer"},"StreamARN":{}}},"staticContextParams":{"OperationType":{"value":"control"}}},"UpdateStreamMode":{"input":{"type":"structure","required":["StreamARN","StreamModeDetails"],"members":{"StreamARN":{"contextParam":{"name":"StreamARN"}},"StreamModeDetails":{"shape":"S9"}}},"staticContextParams":{"OperationType":{"value":"control"}}}},"shapes":{"S9":{"type":"structure","required":["StreamMode"],"members":{"StreamMode":{}}},"Sv":{"type":"list","member":{"type":"structure","required":["ShardId","HashKeyRange","SequenceNumberRange"],"members":{"ShardId":{},"ParentShardId":{},"AdjacentParentShardId":{},"HashKeyRange":{"shape":"Sx"},"SequenceNumberRange":{"type":"structure","required":["StartingSequenceNumber"],"members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}}}}},"Sx":{"type":"structure","required":["StartingHashKey","EndingHashKey"],"members":{"StartingHashKey":{},"EndingHashKey":{}}},"S12":{"type":"list","member":{"type":"structure","members":{"ShardLevelMetrics":{"shape":"S14"}}}},"S14":{"type":"list","member":{}},"S1h":{"type":"structure","members":{"StreamName":{},"CurrentShardLevelMetrics":{"shape":"S14"},"DesiredShardLevelMetrics":{"shape":"S14"},"StreamARN":{}}},"S2c":{"type":"structure","required":["ConsumerName","ConsumerARN","ConsumerStatus","ConsumerCreationTimestamp"],"members":{"ConsumerName":{},"ConsumerARN":{},"ConsumerStatus":{},"ConsumerCreationTimestamp":{"type":"timestamp"}}}}}

/***/ }),
/* 529 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeStream":{"input_token":"ExclusiveStartShardId","limit_key":"Limit","more_results":"StreamDescription.HasMoreShards","output_token":"StreamDescription.Shards[-1].ShardId","result_key":"StreamDescription.Shards"},"ListStreamConsumers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListStreams":{"input_token":"NextToken","limit_key":"Limit","more_results":"HasMoreStreams","output_token":"NextToken","result_key":["StreamNames","StreamSummaries"]}}}

/***/ }),
/* 530 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"StreamExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ACTIVE","matcher":"path","state":"success","argument":"StreamDescription.StreamStatus"}]},"StreamNotExists":{"delay":10,"operation":"DescribeStream","maxAttempts":18,"acceptors":[{"expected":"ResourceNotFoundException","matcher":"error","state":"success"}]}}}

/***/ }),
/* 531 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Archived Media","serviceFullName":"Amazon Kinesis Video Streams Archived Media","serviceId":"Kinesis Video Archived Media","signatureVersion":"v4","uid":"kinesis-video-archived-media-2017-09-30"},"operations":{"GetClip":{"http":{"requestUri":"/getClip"},"input":{"type":"structure","required":["ClipFragmentSelector"],"members":{"StreamName":{},"StreamARN":{},"ClipFragmentSelector":{"type":"structure","required":["FragmentSelectorType","TimestampRange"],"members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","required":["StartTimestamp","EndTimestamp"],"members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"shape":"Sa"}},"payload":"Payload"}},"GetDASHStreamingSessionURL":{"http":{"requestUri":"/getDASHStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"DisplayFragmentTimestamp":{},"DisplayFragmentNumber":{},"DASHFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"Expires":{"type":"integer"},"MaxManifestFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"DASHStreamingSessionURL":{}}}},"GetHLSStreamingSessionURL":{"http":{"requestUri":"/getHLSStreamingSessionURL"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"PlaybackMode":{},"HLSFragmentSelector":{"type":"structure","members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}},"ContainerFormat":{},"DiscontinuityMode":{},"DisplayFragmentTimestamp":{},"Expires":{"type":"integer"},"MaxMediaPlaylistFragmentResults":{"type":"long"}}},"output":{"type":"structure","members":{"HLSStreamingSessionURL":{}}}},"GetImages":{"http":{"requestUri":"/getImages"},"input":{"type":"structure","required":["ImageSelectorType","StartTimestamp","EndTimestamp","Format"],"members":{"StreamName":{},"StreamARN":{},"ImageSelectorType":{},"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"},"SamplingInterval":{"type":"integer"},"Format":{},"FormatConfig":{"type":"map","key":{},"value":{}},"WidthPixels":{"type":"integer"},"HeightPixels":{"type":"integer"},"MaxResults":{"type":"long"},"NextToken":{}}},"output":{"type":"structure","members":{"Images":{"type":"list","member":{"type":"structure","members":{"TimeStamp":{"type":"timestamp"},"Error":{},"ImageContent":{}}}},"NextToken":{}}}},"GetMediaForFragmentList":{"http":{"requestUri":"/getMediaForFragmentList"},"input":{"type":"structure","required":["Fragments"],"members":{"StreamName":{},"StreamARN":{},"Fragments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"shape":"Sa"}},"payload":"Payload"}},"ListFragments":{"http":{"requestUri":"/listFragments"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"MaxResults":{"type":"long"},"NextToken":{},"FragmentSelector":{"type":"structure","required":["FragmentSelectorType","TimestampRange"],"members":{"FragmentSelectorType":{},"TimestampRange":{"type":"structure","required":["StartTimestamp","EndTimestamp"],"members":{"StartTimestamp":{"type":"timestamp"},"EndTimestamp":{"type":"timestamp"}}}}}}},"output":{"type":"structure","members":{"Fragments":{"type":"list","member":{"type":"structure","members":{"FragmentNumber":{},"FragmentSizeInBytes":{"type":"long"},"ProducerTimestamp":{"type":"timestamp"},"ServerTimestamp":{"type":"timestamp"},"FragmentLengthInMilliseconds":{"type":"long"}}}},"NextToken":{}}}}},"shapes":{"Sa":{"type":"blob","streaming":true}}}

/***/ }),
/* 532 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetImages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Images"},"ListFragments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Fragments"}}}

/***/ }),
/* 533 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video Media","serviceFullName":"Amazon Kinesis Video Streams Media","serviceId":"Kinesis Video Media","signatureVersion":"v4","uid":"kinesis-video-media-2017-09-30"},"operations":{"GetMedia":{"http":{"requestUri":"/getMedia"},"input":{"type":"structure","required":["StartSelector"],"members":{"StreamName":{},"StreamARN":{},"StartSelector":{"type":"structure","required":["StartSelectorType"],"members":{"StartSelectorType":{},"AfterFragmentNumber":{},"StartTimestamp":{"type":"timestamp"},"ContinuationToken":{}}}}},"output":{"type":"structure","members":{"ContentType":{"location":"header","locationName":"Content-Type"},"Payload":{"type":"blob","streaming":true}},"payload":"Payload"}}},"shapes":{}}

/***/ }),
/* 534 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 535 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2019-12-04","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Amazon Kinesis Video Signaling Channels","serviceFullName":"Amazon Kinesis Video Signaling Channels","serviceId":"Kinesis Video Signaling","signatureVersion":"v4","uid":"kinesis-video-signaling-2019-12-04"},"operations":{"GetIceServerConfig":{"http":{"requestUri":"/v1/get-ice-server-config"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"ClientId":{},"Service":{},"Username":{}}},"output":{"type":"structure","members":{"IceServerList":{"type":"list","member":{"type":"structure","members":{"Uris":{"type":"list","member":{}},"Username":{},"Password":{},"Ttl":{"type":"integer"}}}}}}},"SendAlexaOfferToMaster":{"http":{"requestUri":"/v1/send-alexa-offer-to-master"},"input":{"type":"structure","required":["ChannelARN","SenderClientId","MessagePayload"],"members":{"ChannelARN":{},"SenderClientId":{},"MessagePayload":{}}},"output":{"type":"structure","members":{"Answer":{}}}}},"shapes":{}}

/***/ }),
/* 536 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 537 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-30","endpointPrefix":"kinesisvideo","protocol":"rest-json","serviceAbbreviation":"Kinesis Video","serviceFullName":"Amazon Kinesis Video Streams","serviceId":"Kinesis Video","signatureVersion":"v4","uid":"kinesisvideo-2017-09-30"},"operations":{"CreateSignalingChannel":{"http":{"requestUri":"/createSignalingChannel"},"input":{"type":"structure","required":["ChannelName"],"members":{"ChannelName":{},"ChannelType":{},"SingleMasterConfiguration":{"shape":"S4"},"Tags":{"type":"list","member":{"shape":"S7"}}}},"output":{"type":"structure","members":{"ChannelARN":{}}}},"CreateStream":{"http":{"requestUri":"/createStream"},"input":{"type":"structure","required":["StreamName"],"members":{"DeviceName":{},"StreamName":{},"MediaType":{},"KmsKeyId":{},"DataRetentionInHours":{"type":"integer"},"Tags":{"shape":"Si"}}},"output":{"type":"structure","members":{"StreamARN":{}}}},"DeleteEdgeConfiguration":{"http":{"requestUri":"/deleteEdgeConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{}}},"DeleteSignalingChannel":{"http":{"requestUri":"/deleteSignalingChannel"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"CurrentVersion":{}}},"output":{"type":"structure","members":{}}},"DeleteStream":{"http":{"requestUri":"/deleteStream"},"input":{"type":"structure","required":["StreamARN"],"members":{"StreamARN":{},"CurrentVersion":{}}},"output":{"type":"structure","members":{}}},"DescribeEdgeConfiguration":{"http":{"requestUri":"/describeEdgeConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"SyncStatus":{},"FailedStatusDetails":{},"EdgeConfig":{"shape":"Sw"},"EdgeAgentStatus":{"type":"structure","members":{"LastRecorderStatus":{"type":"structure","members":{"JobStatusDetails":{},"LastCollectedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"RecorderStatus":{}}},"LastUploaderStatus":{"type":"structure","members":{"JobStatusDetails":{},"LastCollectedTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"UploaderStatus":{}}}}}}}},"DescribeImageGenerationConfiguration":{"http":{"requestUri":"/describeImageGenerationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"ImageGenerationConfiguration":{"shape":"S1k"}}}},"DescribeMappedResourceConfiguration":{"http":{"requestUri":"/describeMappedResourceConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"MappedResourceConfigurationList":{"type":"list","member":{"type":"structure","members":{"Type":{},"ARN":{}}}},"NextToken":{}}}},"DescribeMediaStorageConfiguration":{"http":{"requestUri":"/describeMediaStorageConfiguration"},"input":{"type":"structure","members":{"ChannelName":{},"ChannelARN":{}}},"output":{"type":"structure","members":{"MediaStorageConfiguration":{"shape":"S26"}}}},"DescribeNotificationConfiguration":{"http":{"requestUri":"/describeNotificationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"NotificationConfiguration":{"shape":"S2a"}}}},"DescribeSignalingChannel":{"http":{"requestUri":"/describeSignalingChannel"},"input":{"type":"structure","members":{"ChannelName":{},"ChannelARN":{}}},"output":{"type":"structure","members":{"ChannelInfo":{"shape":"S2e"}}}},"DescribeStream":{"http":{"requestUri":"/describeStream"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{}}},"output":{"type":"structure","members":{"StreamInfo":{"shape":"S2i"}}}},"GetDataEndpoint":{"http":{"requestUri":"/getDataEndpoint"},"input":{"type":"structure","required":["APIName"],"members":{"StreamName":{},"StreamARN":{},"APIName":{}}},"output":{"type":"structure","members":{"DataEndpoint":{}}}},"GetSignalingChannelEndpoint":{"http":{"requestUri":"/getSignalingChannelEndpoint"},"input":{"type":"structure","required":["ChannelARN"],"members":{"ChannelARN":{},"SingleMasterChannelEndpointConfiguration":{"type":"structure","members":{"Protocols":{"type":"list","member":{}},"Role":{}}}}},"output":{"type":"structure","members":{"ResourceEndpointList":{"type":"list","member":{"type":"structure","members":{"Protocol":{},"ResourceEndpoint":{}}}}}}},"ListEdgeAgentConfigurations":{"http":{"requestUri":"/listEdgeAgentConfigurations"},"input":{"type":"structure","required":["HubDeviceArn"],"members":{"HubDeviceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EdgeConfigs":{"type":"list","member":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"SyncStatus":{},"FailedStatusDetails":{},"EdgeConfig":{"shape":"Sw"}}}},"NextToken":{}}}},"ListSignalingChannels":{"http":{"requestUri":"/listSignalingChannels"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"ChannelNameCondition":{"type":"structure","members":{"ComparisonOperator":{},"ComparisonValue":{}}}}},"output":{"type":"structure","members":{"ChannelInfoList":{"type":"list","member":{"shape":"S2e"}},"NextToken":{}}}},"ListStreams":{"http":{"requestUri":"/listStreams"},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{},"StreamNameCondition":{"type":"structure","members":{"ComparisonOperator":{},"ComparisonValue":{}}}}},"output":{"type":"structure","members":{"StreamInfoList":{"type":"list","member":{"shape":"S2i"}},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/ListTagsForResource"},"input":{"type":"structure","required":["ResourceARN"],"members":{"NextToken":{},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Si"}}}},"ListTagsForStream":{"http":{"requestUri":"/listTagsForStream"},"input":{"type":"structure","members":{"NextToken":{},"StreamARN":{},"StreamName":{}}},"output":{"type":"structure","members":{"NextToken":{},"Tags":{"shape":"Si"}}}},"StartEdgeConfigurationUpdate":{"http":{"requestUri":"/startEdgeConfigurationUpdate"},"input":{"type":"structure","required":["EdgeConfig"],"members":{"StreamName":{},"StreamARN":{},"EdgeConfig":{"shape":"Sw"}}},"output":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"CreationTime":{"type":"timestamp"},"LastUpdatedTime":{"type":"timestamp"},"SyncStatus":{},"FailedStatusDetails":{},"EdgeConfig":{"shape":"Sw"}}}},"TagResource":{"http":{"requestUri":"/TagResource"},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"type":"list","member":{"shape":"S7"}}}},"output":{"type":"structure","members":{}}},"TagStream":{"http":{"requestUri":"/tagStream"},"input":{"type":"structure","required":["Tags"],"members":{"StreamARN":{},"StreamName":{},"Tags":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/UntagResource"},"input":{"type":"structure","required":["ResourceARN","TagKeyList"],"members":{"ResourceARN":{},"TagKeyList":{"shape":"S3n"}}},"output":{"type":"structure","members":{}}},"UntagStream":{"http":{"requestUri":"/untagStream"},"input":{"type":"structure","required":["TagKeyList"],"members":{"StreamARN":{},"StreamName":{},"TagKeyList":{"shape":"S3n"}}},"output":{"type":"structure","members":{}}},"UpdateDataRetention":{"http":{"requestUri":"/updateDataRetention"},"input":{"type":"structure","required":["CurrentVersion","Operation","DataRetentionChangeInHours"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"Operation":{},"DataRetentionChangeInHours":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"UpdateImageGenerationConfiguration":{"http":{"requestUri":"/updateImageGenerationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"ImageGenerationConfiguration":{"shape":"S1k"}}},"output":{"type":"structure","members":{}}},"UpdateMediaStorageConfiguration":{"http":{"requestUri":"/updateMediaStorageConfiguration"},"input":{"type":"structure","required":["ChannelARN","MediaStorageConfiguration"],"members":{"ChannelARN":{},"MediaStorageConfiguration":{"shape":"S26"}}},"output":{"type":"structure","members":{}}},"UpdateNotificationConfiguration":{"http":{"requestUri":"/updateNotificationConfiguration"},"input":{"type":"structure","members":{"StreamName":{},"StreamARN":{},"NotificationConfiguration":{"shape":"S2a"}}},"output":{"type":"structure","members":{}}},"UpdateSignalingChannel":{"http":{"requestUri":"/updateSignalingChannel"},"input":{"type":"structure","required":["ChannelARN","CurrentVersion"],"members":{"ChannelARN":{},"CurrentVersion":{},"SingleMasterConfiguration":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"UpdateStream":{"http":{"requestUri":"/updateStream"},"input":{"type":"structure","required":["CurrentVersion"],"members":{"StreamName":{},"StreamARN":{},"CurrentVersion":{},"DeviceName":{},"MediaType":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"structure","members":{"MessageTtlSeconds":{"type":"integer"}}},"S7":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"Si":{"type":"map","key":{},"value":{}},"Sw":{"type":"structure","required":["HubDeviceArn","RecorderConfig"],"members":{"HubDeviceArn":{},"RecorderConfig":{"type":"structure","required":["MediaSourceConfig"],"members":{"MediaSourceConfig":{"type":"structure","required":["MediaUriSecretArn","MediaUriType"],"members":{"MediaUriSecretArn":{"type":"string","sensitive":true},"MediaUriType":{}}},"ScheduleConfig":{"shape":"S12"}}},"UploaderConfig":{"type":"structure","required":["ScheduleConfig"],"members":{"ScheduleConfig":{"shape":"S12"}}},"DeletionConfig":{"type":"structure","members":{"EdgeRetentionInHours":{"type":"integer"},"LocalSizeConfig":{"type":"structure","members":{"MaxLocalMediaSizeInMB":{"type":"integer"},"StrategyOnFullSize":{}}},"DeleteAfterUpload":{"type":"boolean"}}}}},"S12":{"type":"structure","required":["ScheduleExpression","DurationInSeconds"],"members":{"ScheduleExpression":{},"DurationInSeconds":{"type":"integer"}}},"S1k":{"type":"structure","required":["Status","ImageSelectorType","DestinationConfig","SamplingInterval","Format"],"members":{"Status":{},"ImageSelectorType":{},"DestinationConfig":{"type":"structure","required":["Uri","DestinationRegion"],"members":{"Uri":{},"DestinationRegion":{}}},"SamplingInterval":{"type":"integer"},"Format":{},"FormatConfig":{"type":"map","key":{},"value":{}},"WidthPixels":{"type":"integer"},"HeightPixels":{"type":"integer"}}},"S26":{"type":"structure","required":["Status"],"members":{"StreamARN":{},"Status":{}}},"S2a":{"type":"structure","required":["Status","DestinationConfig"],"members":{"Status":{},"DestinationConfig":{"type":"structure","required":["Uri"],"members":{"Uri":{}}}}},"S2e":{"type":"structure","members":{"ChannelName":{},"ChannelARN":{},"ChannelType":{},"ChannelStatus":{},"CreationTime":{"type":"timestamp"},"SingleMasterConfiguration":{"shape":"S4"},"Version":{}}},"S2i":{"type":"structure","members":{"DeviceName":{},"StreamName":{},"StreamARN":{},"MediaType":{},"KmsKeyId":{},"Version":{},"Status":{},"CreationTime":{"type":"timestamp"},"DataRetentionInHours":{"type":"integer"}}},"S3n":{"type":"list","member":{}}}}

/***/ }),
/* 538 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeMappedResourceConfiguration":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"MappedResourceConfigurationList"},"ListEdgeAgentConfigurations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EdgeConfigs"},"ListSignalingChannels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ChannelInfoList"},"ListStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StreamInfoList"}}}

/***/ }),
/* 539 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-01","endpointPrefix":"kms","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"KMS","serviceFullName":"AWS Key Management Service","serviceId":"KMS","signatureVersion":"v4","targetPrefix":"TrentService","uid":"kms-2014-11-01"},"operations":{"CancelKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyId":{}}}},"ConnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"CreateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"CreateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreName"],"members":{"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"KeyStorePassword":{"shape":"Sd"},"CustomKeyStoreType":{},"XksProxyUriEndpoint":{},"XksProxyUriPath":{},"XksProxyVpcEndpointServiceName":{},"XksProxyAuthenticationCredential":{"shape":"Si"},"XksProxyConnectivity":{}}},"output":{"type":"structure","members":{"CustomKeyStoreId":{}}}},"CreateGrant":{"input":{"type":"structure","required":["KeyId","GranteePrincipal","Operations"],"members":{"KeyId":{},"GranteePrincipal":{},"RetiringPrincipal":{},"Operations":{"shape":"Sp"},"Constraints":{"shape":"Sr"},"GrantTokens":{"shape":"Sv"},"Name":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"GrantToken":{},"GrantId":{}}}},"CreateKey":{"input":{"type":"structure","members":{"Policy":{},"Description":{},"KeyUsage":{},"CustomerMasterKeySpec":{"shape":"S15","deprecated":true,"deprecatedMessage":"This parameter has been deprecated. Instead, use the KeySpec parameter."},"KeySpec":{},"Origin":{},"CustomKeyStoreId":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Tags":{"shape":"S19"},"MultiRegion":{"type":"boolean"},"XksKeyId":{}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S1f"}}}},"Decrypt":{"input":{"type":"structure","required":["CiphertextBlob"],"members":{"CiphertextBlob":{"type":"blob"},"EncryptionContext":{"shape":"Ss"},"GrantTokens":{"shape":"Sv"},"KeyId":{},"EncryptionAlgorithm":{},"Recipient":{"shape":"S21"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KeyId":{},"Plaintext":{"shape":"S25"},"EncryptionAlgorithm":{},"CiphertextForRecipient":{"type":"blob"}}}},"DeleteAlias":{"input":{"type":"structure","required":["AliasName"],"members":{"AliasName":{}}}},"DeleteCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"DeleteImportedKeyMaterial":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DescribeCustomKeyStores":{"input":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"CustomKeyStores":{"type":"list","member":{"type":"structure","members":{"CustomKeyStoreId":{},"CustomKeyStoreName":{},"CloudHsmClusterId":{},"TrustAnchorCertificate":{},"ConnectionState":{},"ConnectionErrorCode":{},"CreationDate":{"type":"timestamp"},"CustomKeyStoreType":{},"XksProxyConfiguration":{"type":"structure","members":{"Connectivity":{},"AccessKeyId":{"shape":"Sj"},"UriEndpoint":{},"UriPath":{},"VpcEndpointServiceName":{}}}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"DescribeKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Sv"}}},"output":{"type":"structure","members":{"KeyMetadata":{"shape":"S1f"}}}},"DisableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"DisconnectCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{}}},"output":{"type":"structure","members":{}}},"EnableKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}}},"EnableKeyRotation":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"RotationPeriodInDays":{"type":"integer"}}}},"Encrypt":{"input":{"type":"structure","required":["KeyId","Plaintext"],"members":{"KeyId":{},"Plaintext":{"shape":"S25"},"EncryptionContext":{"shape":"Ss"},"GrantTokens":{"shape":"Sv"},"EncryptionAlgorithm":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{},"EncryptionAlgorithm":{}}}},"GenerateDataKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Ss"},"NumberOfBytes":{"type":"integer"},"KeySpec":{},"GrantTokens":{"shape":"Sv"},"Recipient":{"shape":"S21"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"Plaintext":{"shape":"S25"},"KeyId":{},"CiphertextForRecipient":{"type":"blob"}}}},"GenerateDataKeyPair":{"input":{"type":"structure","required":["KeyId","KeyPairSpec"],"members":{"EncryptionContext":{"shape":"Ss"},"KeyId":{},"KeyPairSpec":{},"GrantTokens":{"shape":"Sv"},"Recipient":{"shape":"S21"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"PrivateKeyCiphertextBlob":{"type":"blob"},"PrivateKeyPlaintext":{"shape":"S25"},"PublicKey":{"type":"blob"},"KeyId":{},"KeyPairSpec":{},"CiphertextForRecipient":{"type":"blob"}}}},"GenerateDataKeyPairWithoutPlaintext":{"input":{"type":"structure","required":["KeyId","KeyPairSpec"],"members":{"EncryptionContext":{"shape":"Ss"},"KeyId":{},"KeyPairSpec":{},"GrantTokens":{"shape":"Sv"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"PrivateKeyCiphertextBlob":{"type":"blob"},"PublicKey":{"type":"blob"},"KeyId":{},"KeyPairSpec":{}}}},"GenerateDataKeyWithoutPlaintext":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"EncryptionContext":{"shape":"Ss"},"KeySpec":{},"NumberOfBytes":{"type":"integer"},"GrantTokens":{"shape":"Sv"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"KeyId":{}}}},"GenerateMac":{"input":{"type":"structure","required":["Message","KeyId","MacAlgorithm"],"members":{"Message":{"shape":"S25"},"KeyId":{},"MacAlgorithm":{},"GrantTokens":{"shape":"Sv"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"Mac":{"type":"blob"},"MacAlgorithm":{},"KeyId":{}}}},"GenerateRandom":{"input":{"type":"structure","members":{"NumberOfBytes":{"type":"integer"},"CustomKeyStoreId":{},"Recipient":{"shape":"S21"}}},"output":{"type":"structure","members":{"Plaintext":{"shape":"S25"},"CiphertextForRecipient":{"type":"blob"}}}},"GetKeyPolicy":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"PolicyName":{}}},"output":{"type":"structure","members":{"Policy":{},"PolicyName":{}}}},"GetKeyRotationStatus":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyRotationEnabled":{"type":"boolean"},"KeyId":{},"RotationPeriodInDays":{"type":"integer"},"NextRotationDate":{"type":"timestamp"},"OnDemandRotationStartDate":{"type":"timestamp"}}}},"GetParametersForImport":{"input":{"type":"structure","required":["KeyId","WrappingAlgorithm","WrappingKeySpec"],"members":{"KeyId":{},"WrappingAlgorithm":{},"WrappingKeySpec":{}}},"output":{"type":"structure","members":{"KeyId":{},"ImportToken":{"type":"blob"},"PublicKey":{"shape":"S25"},"ParametersValidTo":{"type":"timestamp"}}}},"GetPublicKey":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"GrantTokens":{"shape":"Sv"}}},"output":{"type":"structure","members":{"KeyId":{},"PublicKey":{"type":"blob"},"CustomerMasterKeySpec":{"shape":"S15","deprecated":true,"deprecatedMessage":"This field has been deprecated. Instead, use the KeySpec field."},"KeySpec":{},"KeyUsage":{},"EncryptionAlgorithms":{"shape":"S1m"},"SigningAlgorithms":{"shape":"S1o"}}}},"ImportKeyMaterial":{"input":{"type":"structure","required":["KeyId","ImportToken","EncryptedKeyMaterial"],"members":{"KeyId":{},"ImportToken":{"type":"blob"},"EncryptedKeyMaterial":{"type":"blob"},"ValidTo":{"type":"timestamp"},"ExpirationModel":{}}},"output":{"type":"structure","members":{}}},"ListAliases":{"input":{"type":"structure","members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Aliases":{"type":"list","member":{"type":"structure","members":{"AliasName":{},"AliasArn":{},"TargetKeyId":{},"CreationDate":{"type":"timestamp"},"LastUpdatedDate":{"type":"timestamp"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListGrants":{"input":{"type":"structure","required":["KeyId"],"members":{"Limit":{"type":"integer"},"Marker":{},"KeyId":{},"GrantId":{},"GranteePrincipal":{}}},"output":{"shape":"S3s"}},"ListKeyPolicies":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"PolicyNames":{"type":"list","member":{}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListKeyRotations":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Rotations":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"RotationDate":{"type":"timestamp"},"RotationType":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListKeys":{"input":{"type":"structure","members":{"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Keys":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"KeyArn":{}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListResourceTags":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S19"},"NextMarker":{},"Truncated":{"type":"boolean"}}}},"ListRetirableGrants":{"input":{"type":"structure","required":["RetiringPrincipal"],"members":{"Limit":{"type":"integer"},"Marker":{},"RetiringPrincipal":{}}},"output":{"shape":"S3s"}},"PutKeyPolicy":{"input":{"type":"structure","required":["KeyId","Policy"],"members":{"KeyId":{},"PolicyName":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"}}}},"ReEncrypt":{"input":{"type":"structure","required":["CiphertextBlob","DestinationKeyId"],"members":{"CiphertextBlob":{"type":"blob"},"SourceEncryptionContext":{"shape":"Ss"},"SourceKeyId":{},"DestinationKeyId":{},"DestinationEncryptionContext":{"shape":"Ss"},"SourceEncryptionAlgorithm":{},"DestinationEncryptionAlgorithm":{},"GrantTokens":{"shape":"Sv"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"CiphertextBlob":{"type":"blob"},"SourceKeyId":{},"KeyId":{},"SourceEncryptionAlgorithm":{},"DestinationEncryptionAlgorithm":{}}}},"ReplicateKey":{"input":{"type":"structure","required":["KeyId","ReplicaRegion"],"members":{"KeyId":{},"ReplicaRegion":{},"Policy":{},"BypassPolicyLockoutSafetyCheck":{"type":"boolean"},"Description":{},"Tags":{"shape":"S19"}}},"output":{"type":"structure","members":{"ReplicaKeyMetadata":{"shape":"S1f"},"ReplicaPolicy":{},"ReplicaTags":{"shape":"S19"}}}},"RetireGrant":{"input":{"type":"structure","members":{"GrantToken":{},"KeyId":{},"GrantId":{},"DryRun":{"type":"boolean"}}}},"RevokeGrant":{"input":{"type":"structure","required":["KeyId","GrantId"],"members":{"KeyId":{},"GrantId":{},"DryRun":{"type":"boolean"}}}},"RotateKeyOnDemand":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{}}},"output":{"type":"structure","members":{"KeyId":{}}}},"ScheduleKeyDeletion":{"input":{"type":"structure","required":["KeyId"],"members":{"KeyId":{},"PendingWindowInDays":{"type":"integer"}}},"output":{"type":"structure","members":{"KeyId":{},"DeletionDate":{"type":"timestamp"},"KeyState":{},"PendingWindowInDays":{"type":"integer"}}}},"Sign":{"input":{"type":"structure","required":["KeyId","Message","SigningAlgorithm"],"members":{"KeyId":{},"Message":{"shape":"S25"},"MessageType":{},"GrantTokens":{"shape":"Sv"},"SigningAlgorithm":{},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KeyId":{},"Signature":{"type":"blob"},"SigningAlgorithm":{}}}},"TagResource":{"input":{"type":"structure","required":["KeyId","Tags"],"members":{"KeyId":{},"Tags":{"shape":"S19"}}}},"UntagResource":{"input":{"type":"structure","required":["KeyId","TagKeys"],"members":{"KeyId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateAlias":{"input":{"type":"structure","required":["AliasName","TargetKeyId"],"members":{"AliasName":{},"TargetKeyId":{}}}},"UpdateCustomKeyStore":{"input":{"type":"structure","required":["CustomKeyStoreId"],"members":{"CustomKeyStoreId":{},"NewCustomKeyStoreName":{},"KeyStorePassword":{"shape":"Sd"},"CloudHsmClusterId":{},"XksProxyUriEndpoint":{},"XksProxyUriPath":{},"XksProxyVpcEndpointServiceName":{},"XksProxyAuthenticationCredential":{"shape":"Si"},"XksProxyConnectivity":{}}},"output":{"type":"structure","members":{}}},"UpdateKeyDescription":{"input":{"type":"structure","required":["KeyId","Description"],"members":{"KeyId":{},"Description":{}}}},"UpdatePrimaryRegion":{"input":{"type":"structure","required":["KeyId","PrimaryRegion"],"members":{"KeyId":{},"PrimaryRegion":{}}}},"Verify":{"input":{"type":"structure","required":["KeyId","Message","Signature","SigningAlgorithm"],"members":{"KeyId":{},"Message":{"shape":"S25"},"MessageType":{},"Signature":{"type":"blob"},"SigningAlgorithm":{},"GrantTokens":{"shape":"Sv"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KeyId":{},"SignatureValid":{"type":"boolean"},"SigningAlgorithm":{}}}},"VerifyMac":{"input":{"type":"structure","required":["Message","KeyId","MacAlgorithm","Mac"],"members":{"Message":{"shape":"S25"},"KeyId":{},"MacAlgorithm":{},"Mac":{"type":"blob"},"GrantTokens":{"shape":"Sv"},"DryRun":{"type":"boolean"}}},"output":{"type":"structure","members":{"KeyId":{},"MacValid":{"type":"boolean"},"MacAlgorithm":{}}}}},"shapes":{"Sd":{"type":"string","sensitive":true},"Si":{"type":"structure","required":["AccessKeyId","RawSecretAccessKey"],"members":{"AccessKeyId":{"shape":"Sj"},"RawSecretAccessKey":{"type":"string","sensitive":true}}},"Sj":{"type":"string","sensitive":true},"Sp":{"type":"list","member":{}},"Sr":{"type":"structure","members":{"EncryptionContextSubset":{"shape":"Ss"},"EncryptionContextEquals":{"shape":"Ss"}}},"Ss":{"type":"map","key":{},"value":{}},"Sv":{"type":"list","member":{}},"S15":{"type":"string","deprecated":true,"deprecatedMessage":"This enum has been deprecated. Instead, use the KeySpec enum."},"S19":{"type":"list","member":{"type":"structure","required":["TagKey","TagValue"],"members":{"TagKey":{},"TagValue":{}}}},"S1f":{"type":"structure","required":["KeyId"],"members":{"AWSAccountId":{},"KeyId":{},"Arn":{},"CreationDate":{"type":"timestamp"},"Enabled":{"type":"boolean"},"Description":{},"KeyUsage":{},"KeyState":{},"DeletionDate":{"type":"timestamp"},"ValidTo":{"type":"timestamp"},"Origin":{},"CustomKeyStoreId":{},"CloudHsmClusterId":{},"ExpirationModel":{},"KeyManager":{},"CustomerMasterKeySpec":{"shape":"S15","deprecated":true,"deprecatedMessage":"This field has been deprecated. Instead, use the KeySpec field."},"KeySpec":{},"EncryptionAlgorithms":{"shape":"S1m"},"SigningAlgorithms":{"shape":"S1o"},"MultiRegion":{"type":"boolean"},"MultiRegionConfiguration":{"type":"structure","members":{"MultiRegionKeyType":{},"PrimaryKey":{"shape":"S1s"},"ReplicaKeys":{"type":"list","member":{"shape":"S1s"}}}},"PendingDeletionWindowInDays":{"type":"integer"},"MacAlgorithms":{"type":"list","member":{}},"XksKeyConfiguration":{"type":"structure","members":{"Id":{}}}}},"S1m":{"type":"list","member":{}},"S1o":{"type":"list","member":{}},"S1s":{"type":"structure","members":{"Arn":{},"Region":{}}},"S21":{"type":"structure","members":{"KeyEncryptionAlgorithm":{},"AttestationDocument":{"type":"blob"}}},"S25":{"type":"blob","sensitive":true},"S3s":{"type":"structure","members":{"Grants":{"type":"list","member":{"type":"structure","members":{"KeyId":{},"GrantId":{},"Name":{},"CreationDate":{"type":"timestamp"},"GranteePrincipal":{},"RetiringPrincipal":{},"IssuingAccount":{},"Operations":{"shape":"Sp"},"Constraints":{"shape":"Sr"}}}},"NextMarker":{},"Truncated":{"type":"boolean"}}}}}

/***/ }),
/* 540 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCustomKeyStores":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"CustomKeyStores"},"ListAliases":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Aliases"},"ListGrants":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Grants"},"ListKeyPolicies":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"PolicyNames"},"ListKeyRotations":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Rotations"},"ListKeys":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Keys"},"ListResourceTags":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Tags"},"ListRetirableGrants":{"input_token":"Marker","limit_key":"Limit","more_results":"Truncated","output_token":"NextMarker","result_key":"Grants"}}}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = {"metadata":{"apiVersion":"2014-11-11","endpointPrefix":"lambda","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","protocol":"rest-json"},"operations":{"AddEventSource":{"http":{"requestUri":"/2014-11-13/event-source-mappings/"},"input":{"type":"structure","required":["EventSource","FunctionName","Role"],"members":{"EventSource":{},"FunctionName":{},"Role":{},"BatchSize":{"type":"integer"},"Parameters":{"shape":"S6"}}},"output":{"shape":"S7"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"GetEventSource":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S7"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"Se"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{}}}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"shape":"Se"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"shape":"Sq"}},"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}}}},"ListEventSources":{"http":{"method":"GET","requestUri":"/2014-11-13/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSource"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSources":{"type":"list","member":{"shape":"S7"}}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2014-11-13/functions/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"type":"list","member":{"shape":"Se"}}}}},"RemoveEventSource":{"http":{"method":"DELETE","requestUri":"/2014-11-13/event-source-mappings/{UUID}","responseCode":204},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}}},"output":{"shape":"Se"}},"UploadFunction":{"http":{"method":"PUT","requestUri":"/2014-11-13/functions/{FunctionName}","responseCode":201},"input":{"type":"structure","required":["FunctionName","FunctionZip","Runtime","Role","Handler","Mode"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionZip":{"shape":"Sq"},"Runtime":{"location":"querystring","locationName":"Runtime"},"Role":{"location":"querystring","locationName":"Role"},"Handler":{"location":"querystring","locationName":"Handler"},"Mode":{"location":"querystring","locationName":"Mode"},"Description":{"location":"querystring","locationName":"Description"},"Timeout":{"location":"querystring","locationName":"Timeout","type":"integer"},"MemorySize":{"location":"querystring","locationName":"MemorySize","type":"integer"}},"payload":"FunctionZip"},"output":{"shape":"Se"}}},"shapes":{"S6":{"type":"map","key":{},"value":{}},"S7":{"type":"structure","members":{"UUID":{},"BatchSize":{"type":"integer"},"EventSource":{},"FunctionName":{},"Parameters":{"shape":"S6"},"Role":{},"LastModified":{"type":"timestamp"},"IsActive":{"type":"boolean"},"Status":{}}},"Se":{"type":"structure","members":{"FunctionName":{},"FunctionARN":{},"ConfigurationId":{},"Runtime":{},"Role":{},"Handler":{},"Mode":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{"type":"timestamp"}}},"Sq":{"type":"blob","streaming":true}}}

/***/ }),
/* 542 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEventSources":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"EventSources"},"ListFunctions":{"input_token":"Marker","output_token":"NextMarker","limit_key":"MaxItems","result_key":"Functions"}}}

/***/ }),
/* 543 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-03-31","endpointPrefix":"lambda","protocol":"rest-json","serviceFullName":"AWS Lambda","serviceId":"Lambda","signatureVersion":"v4","uid":"lambda-2015-03-31"},"operations":{"AddLayerVersionPermission":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":201},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId","Action","Principal"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{},"Action":{},"Principal":{},"OrganizationId":{},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}},"output":{"type":"structure","members":{"Statement":{},"RevisionId":{}}}},"AddPermission":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":201},"input":{"type":"structure","required":["FunctionName","StatementId","Action","Principal"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{},"Action":{},"Principal":{},"SourceArn":{},"SourceAccount":{},"EventSourceToken":{},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{},"PrincipalOrgID":{},"FunctionUrlAuthType":{}}},"output":{"type":"structure","members":{"Statement":{}}}},"CreateAlias":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":201},"input":{"type":"structure","required":["FunctionName","Name","FunctionVersion"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sp"}}},"output":{"shape":"St"}},"CreateCodeSigningConfig":{"http":{"requestUri":"/2020-04-22/code-signing-configs/","responseCode":201},"input":{"type":"structure","required":["AllowedPublishers"],"members":{"Description":{},"AllowedPublishers":{"shape":"Sw"},"CodeSigningPolicies":{"shape":"Sy"}}},"output":{"type":"structure","required":["CodeSigningConfig"],"members":{"CodeSigningConfig":{"shape":"S11"}}}},"CreateEventSourceMapping":{"http":{"requestUri":"/2015-03-31/event-source-mappings/","responseCode":202},"input":{"type":"structure","required":["FunctionName"],"members":{"EventSourceArn":{},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"FilterCriteria":{"shape":"S18"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"},"DestinationConfig":{"shape":"S1g"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"},"TumblingWindowInSeconds":{"type":"integer"},"Topics":{"shape":"S1o"},"Queues":{"shape":"S1q"},"SourceAccessConfigurations":{"shape":"S1s"},"SelfManagedEventSource":{"shape":"S1w"},"FunctionResponseTypes":{"shape":"S21"},"AmazonManagedKafkaEventSourceConfig":{"shape":"S23"},"SelfManagedKafkaEventSourceConfig":{"shape":"S24"},"ScalingConfig":{"shape":"S25"},"DocumentDBEventSourceConfig":{"shape":"S27"}}},"output":{"shape":"S2b"}},"CreateFunction":{"http":{"requestUri":"/2015-03-31/functions","responseCode":201},"input":{"type":"structure","required":["FunctionName","Role","Code"],"members":{"FunctionName":{},"Runtime":{},"Role":{},"Handler":{},"Code":{"type":"structure","members":{"ZipFile":{"shape":"S2h"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ImageUri":{}}},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"Publish":{"type":"boolean"},"VpcConfig":{"shape":"S2o"},"PackageType":{},"DeadLetterConfig":{"shape":"S2v"},"Environment":{"shape":"S2x"},"KMSKeyArn":{},"TracingConfig":{"shape":"S32"},"Tags":{"shape":"S34"},"Layers":{"shape":"S37"},"FileSystemConfigs":{"shape":"S39"},"ImageConfig":{"shape":"S3d"},"CodeSigningConfigArn":{},"Architectures":{"shape":"S3g"},"EphemeralStorage":{"shape":"S3i"},"SnapStart":{"shape":"S3k"},"LoggingConfig":{"shape":"S3m"}}},"output":{"shape":"S3r"}},"CreateFunctionUrlConfig":{"http":{"requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":201},"input":{"type":"structure","required":["FunctionName","AuthType"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"AuthType":{},"Cors":{"shape":"S4i"},"InvokeMode":{}}},"output":{"type":"structure","required":["FunctionUrl","FunctionArn","AuthType","CreationTime"],"members":{"FunctionUrl":{},"FunctionArn":{},"AuthType":{},"Cors":{"shape":"S4i"},"CreationTime":{},"InvokeMode":{}}}},"DeleteAlias":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":204},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}}},"DeleteCodeSigningConfig":{"http":{"method":"DELETE","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}","responseCode":204},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"}}},"output":{"type":"structure","members":{}}},"DeleteEventSourceMapping":{"http":{"method":"DELETE","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S2b"}},"DeleteFunction":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteFunctionCodeSigningConfig":{"http":{"method":"DELETE","requestUri":"/2020-06-30/functions/{FunctionName}/code-signing-config","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"DeleteFunctionConcurrency":{"http":{"method":"DELETE","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}}},"DeleteFunctionEventInvokeConfig":{"http":{"method":"DELETE","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteFunctionUrlConfig":{"http":{"method":"DELETE","requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":204},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"DeleteLayerVersion":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}}},"DeleteProvisionedConcurrencyConfig":{"http":{"method":"DELETE","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":204},"input":{"type":"structure","required":["FunctionName","Qualifier"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}}},"GetAccountSettings":{"http":{"method":"GET","requestUri":"/2016-08-19/account-settings/","responseCode":200},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccountLimit":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"CodeSizeUnzipped":{"type":"long"},"CodeSizeZipped":{"type":"long"},"ConcurrentExecutions":{"type":"integer"},"UnreservedConcurrentExecutions":{"type":"integer"}}},"AccountUsage":{"type":"structure","members":{"TotalCodeSize":{"type":"long"},"FunctionCount":{"type":"long"}}}}}},"GetAlias":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"shape":"St"}},"GetCodeSigningConfig":{"http":{"method":"GET","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"}}},"output":{"type":"structure","required":["CodeSigningConfig"],"members":{"CodeSigningConfig":{"shape":"S11"}}}},"GetEventSourceMapping":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":200},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"}}},"output":{"shape":"S2b"}},"GetFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Configuration":{"shape":"S3r"},"Code":{"type":"structure","members":{"RepositoryType":{},"Location":{},"ImageUri":{},"ResolvedImageUri":{}}},"Tags":{"shape":"S34"},"Concurrency":{"shape":"S5i"}}}},"GetFunctionCodeSigningConfig":{"http":{"method":"GET","requestUri":"/2020-06-30/functions/{FunctionName}/code-signing-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","required":["CodeSigningConfigArn","FunctionName"],"members":{"CodeSigningConfigArn":{},"FunctionName":{}}}},"GetFunctionConcurrency":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}}},"GetFunctionConfiguration":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S3r"}},"GetFunctionEventInvokeConfig":{"http":{"method":"GET","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"shape":"S5q"}},"GetFunctionUrlConfig":{"http":{"method":"GET","requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","required":["FunctionUrl","FunctionArn","AuthType","CreationTime","LastModifiedTime"],"members":{"FunctionUrl":{},"FunctionArn":{},"AuthType":{},"Cors":{"shape":"S4i"},"CreationTime":{},"LastModifiedTime":{},"InvokeMode":{}}}},"GetLayerVersion":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"shape":"S5w"}},"GetLayerVersionByArn":{"http":{"method":"GET","requestUri":"/2018-10-31/layers?find=LayerVersion","responseCode":200},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"querystring","locationName":"Arn"}}},"output":{"shape":"S5w"}},"GetLayerVersionPolicy":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy","responseCode":200},"input":{"type":"structure","required":["LayerName","VersionNumber"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"GetPolicy":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/policy","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"Policy":{},"RevisionId":{}}}},"GetProvisionedConcurrencyConfig":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","Qualifier"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"GetRuntimeManagementConfig":{"http":{"method":"GET","requestUri":"/2021-07-20/functions/{FunctionName}/runtime-management-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}}},"output":{"type":"structure","members":{"UpdateRuntimeOn":{},"RuntimeVersionArn":{},"FunctionArn":{}}}},"Invoke":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/invocations"},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvocationType":{"location":"header","locationName":"X-Amz-Invocation-Type"},"LogType":{"location":"header","locationName":"X-Amz-Log-Type"},"ClientContext":{"location":"header","locationName":"X-Amz-Client-Context"},"Payload":{"shape":"S2h"},"Qualifier":{"location":"querystring","locationName":"Qualifier"}},"payload":"Payload"},"output":{"type":"structure","members":{"StatusCode":{"location":"statusCode","type":"integer"},"FunctionError":{"location":"header","locationName":"X-Amz-Function-Error"},"LogResult":{"location":"header","locationName":"X-Amz-Log-Result"},"Payload":{"shape":"S2h"},"ExecutedVersion":{"location":"header","locationName":"X-Amz-Executed-Version"}},"payload":"Payload"}},"InvokeAsync":{"http":{"requestUri":"/2014-11-13/functions/{FunctionName}/invoke-async/","responseCode":202},"input":{"type":"structure","required":["FunctionName","InvokeArgs"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvokeArgs":{"type":"blob","streaming":true}},"deprecated":true,"payload":"InvokeArgs"},"output":{"type":"structure","members":{"Status":{"location":"statusCode","type":"integer"}},"deprecated":true},"deprecated":true},"InvokeWithResponseStream":{"http":{"requestUri":"/2021-11-15/functions/{FunctionName}/response-streaming-invocations"},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"InvocationType":{"location":"header","locationName":"X-Amz-Invocation-Type"},"LogType":{"location":"header","locationName":"X-Amz-Log-Type"},"ClientContext":{"location":"header","locationName":"X-Amz-Client-Context"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"Payload":{"shape":"S2h"}},"payload":"Payload"},"output":{"type":"structure","members":{"StatusCode":{"location":"statusCode","type":"integer"},"ExecutedVersion":{"location":"header","locationName":"X-Amz-Executed-Version"},"EventStream":{"type":"structure","members":{"PayloadChunk":{"type":"structure","members":{"Payload":{"shape":"S2h","eventpayload":true}},"event":true},"InvokeComplete":{"type":"structure","members":{"ErrorCode":{},"ErrorDetails":{},"LogResult":{}},"event":true}},"eventstream":true},"ResponseStreamContentType":{"location":"header","locationName":"Content-Type"}},"payload":"EventStream"}},"ListAliases":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/aliases","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Aliases":{"type":"list","member":{"shape":"St"}}}}},"ListCodeSigningConfigs":{"http":{"method":"GET","requestUri":"/2020-04-22/code-signing-configs/","responseCode":200},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"CodeSigningConfigs":{"type":"list","member":{"shape":"S11"}}}}},"ListEventSourceMappings":{"http":{"method":"GET","requestUri":"/2015-03-31/event-source-mappings/","responseCode":200},"input":{"type":"structure","members":{"EventSourceArn":{"location":"querystring","locationName":"EventSourceArn"},"FunctionName":{"location":"querystring","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"EventSourceMappings":{"type":"list","member":{"shape":"S2b"}}}}},"ListFunctionEventInvokeConfigs":{"http":{"method":"GET","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config/list","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"FunctionEventInvokeConfigs":{"type":"list","member":{"shape":"S5q"}},"NextMarker":{}}}},"ListFunctionUrlConfigs":{"http":{"method":"GET","requestUri":"/2021-10-31/functions/{FunctionName}/urls","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","required":["FunctionUrlConfigs"],"members":{"FunctionUrlConfigs":{"type":"list","member":{"type":"structure","required":["FunctionUrl","FunctionArn","CreationTime","LastModifiedTime","AuthType"],"members":{"FunctionUrl":{},"FunctionArn":{},"CreationTime":{},"LastModifiedTime":{},"Cors":{"shape":"S4i"},"AuthType":{},"InvokeMode":{}}}},"NextMarker":{}}}},"ListFunctions":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/","responseCode":200},"input":{"type":"structure","members":{"MasterRegion":{"location":"querystring","locationName":"MasterRegion"},"FunctionVersion":{"location":"querystring","locationName":"FunctionVersion"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Functions":{"shape":"S7g"}}}},"ListFunctionsByCodeSigningConfig":{"http":{"method":"GET","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}/functions","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"FunctionArns":{"type":"list","member":{}}}}},"ListLayerVersions":{"http":{"method":"GET","requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":200},"input":{"type":"structure","required":["LayerName"],"members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"LayerName":{"location":"uri","locationName":"LayerName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"CompatibleArchitecture":{"location":"querystring","locationName":"CompatibleArchitecture"}}},"output":{"type":"structure","members":{"NextMarker":{},"LayerVersions":{"type":"list","member":{"shape":"S7o"}}}}},"ListLayers":{"http":{"method":"GET","requestUri":"/2018-10-31/layers","responseCode":200},"input":{"type":"structure","members":{"CompatibleRuntime":{"location":"querystring","locationName":"CompatibleRuntime"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"},"CompatibleArchitecture":{"location":"querystring","locationName":"CompatibleArchitecture"}}},"output":{"type":"structure","members":{"NextMarker":{},"Layers":{"type":"list","member":{"type":"structure","members":{"LayerName":{},"LayerArn":{},"LatestMatchingVersion":{"shape":"S7o"}}}}}}},"ListProvisionedConcurrencyConfigs":{"http":{"method":"GET","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency?List=ALL","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"ProvisionedConcurrencyConfigs":{"type":"list","member":{"type":"structure","members":{"FunctionArn":{},"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"NextMarker":{}}}},"ListTags":{"http":{"method":"GET","requestUri":"/2017-03-31/tags/{ARN}"},"input":{"type":"structure","required":["Resource"],"members":{"Resource":{"location":"uri","locationName":"ARN"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S34"}}}},"ListVersionsByFunction":{"http":{"method":"GET","requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Marker":{"location":"querystring","locationName":"Marker"},"MaxItems":{"location":"querystring","locationName":"MaxItems","type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Versions":{"shape":"S7g"}}}},"PublishLayerVersion":{"http":{"requestUri":"/2018-10-31/layers/{LayerName}/versions","responseCode":201},"input":{"type":"structure","required":["LayerName","Content"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"Description":{},"Content":{"type":"structure","members":{"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ZipFile":{"shape":"S2h"}}},"CompatibleRuntimes":{"shape":"S5z"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S61"}}},"output":{"type":"structure","members":{"Content":{"shape":"S5x"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S5z"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S61"}}}},"PublishVersion":{"http":{"requestUri":"/2015-03-31/functions/{FunctionName}/versions","responseCode":201},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"CodeSha256":{},"Description":{},"RevisionId":{}}},"output":{"shape":"S3r"}},"PutFunctionCodeSigningConfig":{"http":{"method":"PUT","requestUri":"/2020-06-30/functions/{FunctionName}/code-signing-config","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn","FunctionName"],"members":{"CodeSigningConfigArn":{},"FunctionName":{"location":"uri","locationName":"FunctionName"}}},"output":{"type":"structure","required":["CodeSigningConfigArn","FunctionName"],"members":{"CodeSigningConfigArn":{},"FunctionName":{}}}},"PutFunctionConcurrency":{"http":{"method":"PUT","requestUri":"/2017-10-31/functions/{FunctionName}/concurrency","responseCode":200},"input":{"type":"structure","required":["FunctionName","ReservedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ReservedConcurrentExecutions":{"type":"integer"}}},"output":{"shape":"S5i"}},"PutFunctionEventInvokeConfig":{"http":{"method":"PUT","requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"}}},"output":{"shape":"S5q"}},"PutProvisionedConcurrencyConfig":{"http":{"method":"PUT","requestUri":"/2019-09-30/functions/{FunctionName}/provisioned-concurrency","responseCode":202},"input":{"type":"structure","required":["FunctionName","Qualifier","ProvisionedConcurrentExecutions"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"ProvisionedConcurrentExecutions":{"type":"integer"}}},"output":{"type":"structure","members":{"RequestedProvisionedConcurrentExecutions":{"type":"integer"},"AvailableProvisionedConcurrentExecutions":{"type":"integer"},"AllocatedProvisionedConcurrentExecutions":{"type":"integer"},"Status":{},"StatusReason":{},"LastModified":{}}}},"PutRuntimeManagementConfig":{"http":{"method":"PUT","requestUri":"/2021-07-20/functions/{FunctionName}/runtime-management-config","responseCode":200},"input":{"type":"structure","required":["FunctionName","UpdateRuntimeOn"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"UpdateRuntimeOn":{},"RuntimeVersionArn":{}}},"output":{"type":"structure","required":["UpdateRuntimeOn","FunctionArn"],"members":{"UpdateRuntimeOn":{},"FunctionArn":{},"RuntimeVersionArn":{}}}},"RemoveLayerVersionPermission":{"http":{"method":"DELETE","requestUri":"/2018-10-31/layers/{LayerName}/versions/{VersionNumber}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["LayerName","VersionNumber","StatementId"],"members":{"LayerName":{"location":"uri","locationName":"LayerName"},"VersionNumber":{"location":"uri","locationName":"VersionNumber","type":"long"},"StatementId":{"location":"uri","locationName":"StatementId"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"RemovePermission":{"http":{"method":"DELETE","requestUri":"/2015-03-31/functions/{FunctionName}/policy/{StatementId}","responseCode":204},"input":{"type":"structure","required":["FunctionName","StatementId"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"StatementId":{"location":"uri","locationName":"StatementId"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"RevisionId":{"location":"querystring","locationName":"RevisionId"}}}},"TagResource":{"http":{"requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","Tags"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"Tags":{"shape":"S34"}}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/2017-03-31/tags/{ARN}","responseCode":204},"input":{"type":"structure","required":["Resource","TagKeys"],"members":{"Resource":{"location":"uri","locationName":"ARN"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}}},"UpdateAlias":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/aliases/{Name}","responseCode":200},"input":{"type":"structure","required":["FunctionName","Name"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Name":{"location":"uri","locationName":"Name"},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sp"},"RevisionId":{}}},"output":{"shape":"St"}},"UpdateCodeSigningConfig":{"http":{"method":"PUT","requestUri":"/2020-04-22/code-signing-configs/{CodeSigningConfigArn}","responseCode":200},"input":{"type":"structure","required":["CodeSigningConfigArn"],"members":{"CodeSigningConfigArn":{"location":"uri","locationName":"CodeSigningConfigArn"},"Description":{},"AllowedPublishers":{"shape":"Sw"},"CodeSigningPolicies":{"shape":"Sy"}}},"output":{"type":"structure","required":["CodeSigningConfig"],"members":{"CodeSigningConfig":{"shape":"S11"}}}},"UpdateEventSourceMapping":{"http":{"method":"PUT","requestUri":"/2015-03-31/event-source-mappings/{UUID}","responseCode":202},"input":{"type":"structure","required":["UUID"],"members":{"UUID":{"location":"uri","locationName":"UUID"},"FunctionName":{},"Enabled":{"type":"boolean"},"BatchSize":{"type":"integer"},"FilterCriteria":{"shape":"S18"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"SourceAccessConfigurations":{"shape":"S1s"},"TumblingWindowInSeconds":{"type":"integer"},"FunctionResponseTypes":{"shape":"S21"},"ScalingConfig":{"shape":"S25"},"DocumentDBEventSourceConfig":{"shape":"S27"}}},"output":{"shape":"S2b"}},"UpdateFunctionCode":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/code","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"ZipFile":{"shape":"S2h"},"S3Bucket":{},"S3Key":{},"S3ObjectVersion":{},"ImageUri":{},"Publish":{"type":"boolean"},"DryRun":{"type":"boolean"},"RevisionId":{},"Architectures":{"shape":"S3g"}}},"output":{"shape":"S3r"}},"UpdateFunctionConfiguration":{"http":{"method":"PUT","requestUri":"/2015-03-31/functions/{FunctionName}/configuration","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Role":{},"Handler":{},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"VpcConfig":{"shape":"S2o"},"Environment":{"shape":"S2x"},"Runtime":{},"DeadLetterConfig":{"shape":"S2v"},"KMSKeyArn":{},"TracingConfig":{"shape":"S32"},"RevisionId":{},"Layers":{"shape":"S37"},"FileSystemConfigs":{"shape":"S39"},"ImageConfig":{"shape":"S3d"},"EphemeralStorage":{"shape":"S3i"},"SnapStart":{"shape":"S3k"},"LoggingConfig":{"shape":"S3m"}}},"output":{"shape":"S3r"}},"UpdateFunctionEventInvokeConfig":{"http":{"requestUri":"/2019-09-25/functions/{FunctionName}/event-invoke-config","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"}}},"output":{"shape":"S5q"}},"UpdateFunctionUrlConfig":{"http":{"method":"PUT","requestUri":"/2021-10-31/functions/{FunctionName}/url","responseCode":200},"input":{"type":"structure","required":["FunctionName"],"members":{"FunctionName":{"location":"uri","locationName":"FunctionName"},"Qualifier":{"location":"querystring","locationName":"Qualifier"},"AuthType":{},"Cors":{"shape":"S4i"},"InvokeMode":{}}},"output":{"type":"structure","required":["FunctionUrl","FunctionArn","AuthType","CreationTime","LastModifiedTime"],"members":{"FunctionUrl":{},"FunctionArn":{},"AuthType":{},"Cors":{"shape":"S4i"},"CreationTime":{},"LastModifiedTime":{},"InvokeMode":{}}}}},"shapes":{"Sp":{"type":"structure","members":{"AdditionalVersionWeights":{"type":"map","key":{},"value":{"type":"double"}}}},"St":{"type":"structure","members":{"AliasArn":{},"Name":{},"FunctionVersion":{},"Description":{},"RoutingConfig":{"shape":"Sp"},"RevisionId":{}}},"Sw":{"type":"structure","required":["SigningProfileVersionArns"],"members":{"SigningProfileVersionArns":{"type":"list","member":{}}}},"Sy":{"type":"structure","members":{"UntrustedArtifactOnDeployment":{}}},"S11":{"type":"structure","required":["CodeSigningConfigId","CodeSigningConfigArn","AllowedPublishers","CodeSigningPolicies","LastModified"],"members":{"CodeSigningConfigId":{},"CodeSigningConfigArn":{},"Description":{},"AllowedPublishers":{"shape":"Sw"},"CodeSigningPolicies":{"shape":"Sy"},"LastModified":{}}},"S18":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"Pattern":{}}}}}},"S1g":{"type":"structure","members":{"OnSuccess":{"type":"structure","members":{"Destination":{}}},"OnFailure":{"type":"structure","members":{"Destination":{}}}}},"S1o":{"type":"list","member":{}},"S1q":{"type":"list","member":{}},"S1s":{"type":"list","member":{"type":"structure","members":{"Type":{},"URI":{}}}},"S1w":{"type":"structure","members":{"Endpoints":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"S21":{"type":"list","member":{}},"S23":{"type":"structure","members":{"ConsumerGroupId":{}}},"S24":{"type":"structure","members":{"ConsumerGroupId":{}}},"S25":{"type":"structure","members":{"MaximumConcurrency":{"type":"integer"}}},"S27":{"type":"structure","members":{"DatabaseName":{},"CollectionName":{},"FullDocument":{}}},"S2b":{"type":"structure","members":{"UUID":{},"StartingPosition":{},"StartingPositionTimestamp":{"type":"timestamp"},"BatchSize":{"type":"integer"},"MaximumBatchingWindowInSeconds":{"type":"integer"},"ParallelizationFactor":{"type":"integer"},"EventSourceArn":{},"FilterCriteria":{"shape":"S18"},"FunctionArn":{},"LastModified":{"type":"timestamp"},"LastProcessingResult":{},"State":{},"StateTransitionReason":{},"DestinationConfig":{"shape":"S1g"},"Topics":{"shape":"S1o"},"Queues":{"shape":"S1q"},"SourceAccessConfigurations":{"shape":"S1s"},"SelfManagedEventSource":{"shape":"S1w"},"MaximumRecordAgeInSeconds":{"type":"integer"},"BisectBatchOnFunctionError":{"type":"boolean"},"MaximumRetryAttempts":{"type":"integer"},"TumblingWindowInSeconds":{"type":"integer"},"FunctionResponseTypes":{"shape":"S21"},"AmazonManagedKafkaEventSourceConfig":{"shape":"S23"},"SelfManagedKafkaEventSourceConfig":{"shape":"S24"},"ScalingConfig":{"shape":"S25"},"DocumentDBEventSourceConfig":{"shape":"S27"}}},"S2h":{"type":"blob","sensitive":true},"S2o":{"type":"structure","members":{"SubnetIds":{"shape":"S2p"},"SecurityGroupIds":{"shape":"S2r"},"Ipv6AllowedForDualStack":{"type":"boolean"}}},"S2p":{"type":"list","member":{}},"S2r":{"type":"list","member":{}},"S2v":{"type":"structure","members":{"TargetArn":{}}},"S2x":{"type":"structure","members":{"Variables":{"shape":"S2y"}}},"S2y":{"type":"map","key":{"type":"string","sensitive":true},"value":{"type":"string","sensitive":true},"sensitive":true},"S32":{"type":"structure","members":{"Mode":{}}},"S34":{"type":"map","key":{},"value":{}},"S37":{"type":"list","member":{}},"S39":{"type":"list","member":{"type":"structure","required":["Arn","LocalMountPath"],"members":{"Arn":{},"LocalMountPath":{}}}},"S3d":{"type":"structure","members":{"EntryPoint":{"shape":"S3e"},"Command":{"shape":"S3e"},"WorkingDirectory":{}}},"S3e":{"type":"list","member":{}},"S3g":{"type":"list","member":{}},"S3i":{"type":"structure","required":["Size"],"members":{"Size":{"type":"integer"}}},"S3k":{"type":"structure","members":{"ApplyOn":{}}},"S3m":{"type":"structure","members":{"LogFormat":{},"ApplicationLogLevel":{},"SystemLogLevel":{},"LogGroup":{}}},"S3r":{"type":"structure","members":{"FunctionName":{},"FunctionArn":{},"Runtime":{},"Role":{},"Handler":{},"CodeSize":{"type":"long"},"Description":{},"Timeout":{"type":"integer"},"MemorySize":{"type":"integer"},"LastModified":{},"CodeSha256":{},"Version":{},"VpcConfig":{"type":"structure","members":{"SubnetIds":{"shape":"S2p"},"SecurityGroupIds":{"shape":"S2r"},"VpcId":{},"Ipv6AllowedForDualStack":{"type":"boolean"}}},"DeadLetterConfig":{"shape":"S2v"},"Environment":{"type":"structure","members":{"Variables":{"shape":"S2y"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"shape":"S3z"}}}}},"KMSKeyArn":{},"TracingConfig":{"type":"structure","members":{"Mode":{}}},"MasterArn":{},"RevisionId":{},"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CodeSize":{"type":"long"},"SigningProfileVersionArn":{},"SigningJobArn":{}}}},"State":{},"StateReason":{},"StateReasonCode":{},"LastUpdateStatus":{},"LastUpdateStatusReason":{},"LastUpdateStatusReasonCode":{},"FileSystemConfigs":{"shape":"S39"},"PackageType":{},"ImageConfigResponse":{"type":"structure","members":{"ImageConfig":{"shape":"S3d"},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"shape":"S3z"}}}}},"SigningProfileVersionArn":{},"SigningJobArn":{},"Architectures":{"shape":"S3g"},"EphemeralStorage":{"shape":"S3i"},"SnapStart":{"type":"structure","members":{"ApplyOn":{},"OptimizationStatus":{}}},"RuntimeVersionConfig":{"type":"structure","members":{"RuntimeVersionArn":{},"Error":{"type":"structure","members":{"ErrorCode":{},"Message":{"shape":"S3z"}}}}},"LoggingConfig":{"shape":"S3m"}}},"S3z":{"type":"string","sensitive":true},"S4i":{"type":"structure","members":{"AllowCredentials":{"type":"boolean"},"AllowHeaders":{"shape":"S4k"},"AllowMethods":{"type":"list","member":{}},"AllowOrigins":{"type":"list","member":{}},"ExposeHeaders":{"shape":"S4k"},"MaxAge":{"type":"integer"}}},"S4k":{"type":"list","member":{}},"S5i":{"type":"structure","members":{"ReservedConcurrentExecutions":{"type":"integer"}}},"S5q":{"type":"structure","members":{"LastModified":{"type":"timestamp"},"FunctionArn":{},"MaximumRetryAttempts":{"type":"integer"},"MaximumEventAgeInSeconds":{"type":"integer"},"DestinationConfig":{"shape":"S1g"}}},"S5w":{"type":"structure","members":{"Content":{"shape":"S5x"},"LayerArn":{},"LayerVersionArn":{},"Description":{},"CreatedDate":{},"Version":{"type":"long"},"CompatibleRuntimes":{"shape":"S5z"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S61"}}},"S5x":{"type":"structure","members":{"Location":{},"CodeSha256":{},"CodeSize":{"type":"long"},"SigningProfileVersionArn":{},"SigningJobArn":{}}},"S5z":{"type":"list","member":{}},"S61":{"type":"list","member":{}},"S7g":{"type":"list","member":{"shape":"S3r"}},"S7o":{"type":"structure","members":{"LayerVersionArn":{},"Version":{"type":"long"},"Description":{},"CreatedDate":{},"CompatibleRuntimes":{"shape":"S5z"},"LicenseInfo":{},"CompatibleArchitectures":{"shape":"S61"}}}}}

/***/ }),
/* 544 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAliases":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Aliases"},"ListCodeSigningConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"CodeSigningConfigs"},"ListEventSourceMappings":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"EventSourceMappings"},"ListFunctionEventInvokeConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"FunctionEventInvokeConfigs"},"ListFunctionUrlConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"FunctionUrlConfigs"},"ListFunctions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Functions"},"ListFunctionsByCodeSigningConfig":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"FunctionArns"},"ListLayerVersions":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"LayerVersions"},"ListLayers":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Layers"},"ListProvisionedConcurrencyConfigs":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"ProvisionedConcurrencyConfigs"},"ListVersionsByFunction":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextMarker","result_key":"Versions"}}}

/***/ }),
/* 545 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"FunctionExists":{"delay":1,"operation":"GetFunction","maxAttempts":20,"acceptors":[{"state":"success","matcher":"status","expected":200},{"state":"retry","matcher":"error","expected":"ResourceNotFoundException"}]},"FunctionActive":{"delay":5,"maxAttempts":60,"operation":"GetFunctionConfiguration","description":"Waits for the function's State to be Active. This waiter uses GetFunctionConfiguration API. This should be used after new function creation.","acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"Active"},{"state":"failure","matcher":"path","argument":"State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"State","expected":"Pending"}]},"FunctionUpdated":{"delay":5,"maxAttempts":60,"operation":"GetFunctionConfiguration","description":"Waits for the function's LastUpdateStatus to be Successful. This waiter uses GetFunctionConfiguration API. This should be used after function updates.","acceptors":[{"state":"success","matcher":"path","argument":"LastUpdateStatus","expected":"Successful"},{"state":"failure","matcher":"path","argument":"LastUpdateStatus","expected":"Failed"},{"state":"retry","matcher":"path","argument":"LastUpdateStatus","expected":"InProgress"}]},"FunctionActiveV2":{"delay":1,"maxAttempts":300,"operation":"GetFunction","description":"Waits for the function's State to be Active. This waiter uses GetFunction API. This should be used after new function creation.","acceptors":[{"state":"success","matcher":"path","argument":"Configuration.State","expected":"Active"},{"state":"failure","matcher":"path","argument":"Configuration.State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"Configuration.State","expected":"Pending"}]},"FunctionUpdatedV2":{"delay":1,"maxAttempts":300,"operation":"GetFunction","description":"Waits for the function's LastUpdateStatus to be Successful. This waiter uses GetFunction API. This should be used after function updates.","acceptors":[{"state":"success","matcher":"path","argument":"Configuration.LastUpdateStatus","expected":"Successful"},{"state":"failure","matcher":"path","argument":"Configuration.LastUpdateStatus","expected":"Failed"},{"state":"retry","matcher":"path","argument":"Configuration.LastUpdateStatus","expected":"InProgress"}]},"PublishedVersionActive":{"delay":5,"maxAttempts":312,"operation":"GetFunctionConfiguration","description":"Waits for the published version's State to be Active. This waiter uses GetFunctionConfiguration API. This should be used after new version is published.","acceptors":[{"state":"success","matcher":"path","argument":"State","expected":"Active"},{"state":"failure","matcher":"path","argument":"State","expected":"Failed"},{"state":"retry","matcher":"path","argument":"State","expected":"Pending"}]}}}

/***/ }),
/* 546 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-04-19","endpointPrefix":"models.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Model Building Service","serviceId":"Lex Model Building Service","signatureVersion":"v4","signingName":"lex","uid":"lex-models-2017-04-19"},"operations":{"CreateBotVersion":{"http":{"requestUri":"/bots/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"enableModelImprovements":{"type":"boolean"},"detectSentiment":{"type":"boolean"}}}},"CreateIntentVersion":{"http":{"requestUri":"/intents/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}}},"CreateSlotTypeVersion":{"http":{"requestUri":"/slottypes/{name}/versions","responseCode":201},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"checksum":{}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1q"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}}},"DeleteBot":{"http":{"method":"DELETE","requestUri":"/bots/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteBotAlias":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}}},"DeleteBotChannelAssociation":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":204},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}}},"DeleteBotVersion":{"http":{"method":"DELETE","requestUri":"/bots/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteIntent":{"http":{"method":"DELETE","requestUri":"/intents/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteIntentVersion":{"http":{"method":"DELETE","requestUri":"/intents/{name}/versions/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteSlotType":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}","responseCode":204},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"}}}},"DeleteSlotTypeVersion":{"http":{"method":"DELETE","requestUri":"/slottypes/{name}/version/{version}","responseCode":204},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}}},"DeleteUtterances":{"http":{"method":"DELETE","requestUri":"/bots/{botName}/utterances/{userId}","responseCode":204},"input":{"type":"structure","required":["botName","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"userId":{"location":"uri","locationName":"userId"}}}},"GetBot":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/{versionoralias}","responseCode":200},"input":{"type":"structure","required":["name","versionOrAlias"],"members":{"name":{"location":"uri","locationName":"name"},"versionOrAlias":{"location":"uri","locationName":"versionoralias"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"enableModelImprovements":{"type":"boolean"},"nluIntentConfidenceThreshold":{"type":"double"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"detectSentiment":{"type":"boolean"}}}},"GetBotAlias":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S2h"}}}},"GetBotAliases":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/","responseCode":200},"input":{"type":"structure","required":["botName"],"members":{"botName":{"location":"uri","locationName":"botName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"BotAliases":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S2h"}}}},"nextToken":{}}}},"GetBotChannelAssociation":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/{name}","responseCode":200},"input":{"type":"structure","required":["name","botName","botAlias"],"members":{"name":{"location":"uri","locationName":"name"},"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S2z"},"status":{},"failureReason":{}}}},"GetBotChannelAssociations":{"http":{"method":"GET","requestUri":"/bots/{botName}/aliases/{aliasName}/channels/","responseCode":200},"input":{"type":"structure","required":["botName","botAlias"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"aliasName"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"botChannelAssociations":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"botAlias":{},"botName":{},"createdDate":{"type":"timestamp"},"type":{},"botConfiguration":{"shape":"S2z"},"status":{},"failureReason":{}}}},"nextToken":{}}}},"GetBotVersions":{"http":{"method":"GET","requestUri":"/bots/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"bots":{"shape":"S38"},"nextToken":{}}}},"GetBots":{"http":{"method":"GET","requestUri":"/bots/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"bots":{"shape":"S38"},"nextToken":{}}}},"GetBuiltinIntent":{"http":{"method":"GET","requestUri":"/builtins/intents/{signature}","responseCode":200},"input":{"type":"structure","required":["signature"],"members":{"signature":{"location":"uri","locationName":"signature"}}},"output":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S3e"},"slots":{"type":"list","member":{"type":"structure","members":{"name":{}}}}}}},"GetBuiltinIntents":{"http":{"method":"GET","requestUri":"/builtins/intents/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S3e"}}}},"nextToken":{}}}},"GetBuiltinSlotTypes":{"http":{"method":"GET","requestUri":"/builtins/slottypes/","responseCode":200},"input":{"type":"structure","members":{"locale":{"location":"querystring","locationName":"locale"},"signatureContains":{"location":"querystring","locationName":"signatureContains"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"type":"list","member":{"type":"structure","members":{"signature":{},"supportedLocales":{"shape":"S3e"}}}},"nextToken":{}}}},"GetExport":{"http":{"method":"GET","requestUri":"/exports/","responseCode":200},"input":{"type":"structure","required":["name","version","resourceType","exportType"],"members":{"name":{"location":"querystring","locationName":"name"},"version":{"location":"querystring","locationName":"version"},"resourceType":{"location":"querystring","locationName":"resourceType"},"exportType":{"location":"querystring","locationName":"exportType"}}},"output":{"type":"structure","members":{"name":{},"version":{},"resourceType":{},"exportType":{},"exportStatus":{},"failureReason":{},"url":{}}}},"GetImport":{"http":{"method":"GET","requestUri":"/imports/{importId}","responseCode":200},"input":{"type":"structure","required":["importId"],"members":{"importId":{"location":"uri","locationName":"importId"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"failureReason":{"type":"list","member":{}},"createdDate":{"type":"timestamp"}}}},"GetIntent":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}}},"GetIntentVersions":{"http":{"method":"GET","requestUri":"/intents/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"intents":{"shape":"S45"},"nextToken":{}}}},"GetIntents":{"http":{"method":"GET","requestUri":"/intents/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"intents":{"shape":"S45"},"nextToken":{}}}},"GetMigration":{"http":{"method":"GET","requestUri":"/migrations/{migrationId}","responseCode":200},"input":{"type":"structure","required":["migrationId"],"members":{"migrationId":{"location":"uri","locationName":"migrationId"}}},"output":{"type":"structure","members":{"migrationId":{},"v1BotName":{},"v1BotVersion":{},"v1BotLocale":{},"v2BotId":{},"v2BotRole":{},"migrationStatus":{},"migrationStrategy":{},"migrationTimestamp":{"type":"timestamp"},"alerts":{"type":"list","member":{"type":"structure","members":{"type":{},"message":{},"details":{"type":"list","member":{}},"referenceURLs":{"type":"list","member":{}}}}}}}},"GetMigrations":{"http":{"method":"GET","requestUri":"/migrations","responseCode":200},"input":{"type":"structure","members":{"sortByAttribute":{"location":"querystring","locationName":"sortByAttribute"},"sortByOrder":{"location":"querystring","locationName":"sortByOrder"},"v1BotNameContains":{"location":"querystring","locationName":"v1BotNameContains"},"migrationStatusEquals":{"location":"querystring","locationName":"migrationStatusEquals"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"migrationSummaries":{"type":"list","member":{"type":"structure","members":{"migrationId":{},"v1BotName":{},"v1BotVersion":{},"v1BotLocale":{},"v2BotId":{},"v2BotRole":{},"migrationStatus":{},"migrationStrategy":{},"migrationTimestamp":{"type":"timestamp"}}}},"nextToken":{}}}},"GetSlotType":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/{version}","responseCode":200},"input":{"type":"structure","required":["name","version"],"members":{"name":{"location":"uri","locationName":"name"},"version":{"location":"uri","locationName":"version"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1q"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}}},"GetSlotTypeVersions":{"http":{"method":"GET","requestUri":"/slottypes/{name}/versions/","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S4x"},"nextToken":{}}}},"GetSlotTypes":{"http":{"method":"GET","requestUri":"/slottypes/","responseCode":200},"input":{"type":"structure","members":{"nextToken":{"location":"querystring","locationName":"nextToken"},"maxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"nameContains":{"location":"querystring","locationName":"nameContains"}}},"output":{"type":"structure","members":{"slotTypes":{"shape":"S4x"},"nextToken":{}}}},"GetUtterancesView":{"http":{"method":"GET","requestUri":"/bots/{botname}/utterances?view=aggregation","responseCode":200},"input":{"type":"structure","required":["botName","botVersions","statusType"],"members":{"botName":{"location":"uri","locationName":"botname"},"botVersions":{"location":"querystring","locationName":"bot_versions","type":"list","member":{}},"statusType":{"location":"querystring","locationName":"status_type"}}},"output":{"type":"structure","members":{"botName":{},"utterances":{"type":"list","member":{"type":"structure","members":{"botVersion":{},"utterances":{"type":"list","member":{"type":"structure","members":{"utteranceString":{},"count":{"type":"integer"},"distinctUsers":{"type":"integer"},"firstUtteredDate":{"type":"timestamp"},"lastUtteredDate":{"type":"timestamp"}}}}}}}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{resourceArn}","responseCode":200},"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"tags":{"shape":"S5e"}}}},"PutBot":{"http":{"method":"PUT","requestUri":"/bots/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name","locale","childDirected"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"intents":{"shape":"S6"},"enableModelImprovements":{"type":"boolean"},"nluIntentConfidenceThreshold":{"type":"double"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"processBehavior":{},"locale":{},"childDirected":{"type":"boolean"},"detectSentiment":{"type":"boolean"},"createVersion":{"type":"boolean"},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{"name":{},"description":{},"intents":{"shape":"S6"},"enableModelImprovements":{"type":"boolean"},"nluIntentConfidenceThreshold":{"type":"double"},"clarificationPrompt":{"shape":"Sa"},"abortStatement":{"shape":"Si"},"status":{},"failureReason":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"idleSessionTTLInSeconds":{"type":"integer"},"voiceId":{},"checksum":{},"version":{},"locale":{},"childDirected":{"type":"boolean"},"createVersion":{"type":"boolean"},"detectSentiment":{"type":"boolean"},"tags":{"shape":"S5e"}}}},"PutBotAlias":{"http":{"method":"PUT","requestUri":"/bots/{botName}/aliases/{name}","responseCode":200},"input":{"type":"structure","required":["name","botVersion","botName"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"botVersion":{},"botName":{"location":"uri","locationName":"botName"},"checksum":{},"conversationLogs":{"type":"structure","required":["logSettings","iamRoleArn"],"members":{"logSettings":{"type":"list","member":{"type":"structure","required":["logType","destination","resourceArn"],"members":{"logType":{},"destination":{},"kmsKeyArn":{},"resourceArn":{}}}},"iamRoleArn":{}}},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{"name":{},"description":{},"botVersion":{},"botName":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"checksum":{},"conversationLogs":{"shape":"S2h"},"tags":{"shape":"S5e"}}}},"PutIntent":{"http":{"method":"PUT","requestUri":"/intents/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"checksum":{},"createVersion":{"type":"boolean"},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}},"output":{"type":"structure","members":{"name":{},"description":{},"slots":{"shape":"Sq"},"sampleUtterances":{"shape":"S13"},"confirmationPrompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"},"followUpPrompt":{"shape":"S14"},"conclusionStatement":{"shape":"Si"},"dialogCodeHook":{"shape":"S15"},"fulfillmentActivity":{"shape":"S18"},"parentIntentSignature":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"createVersion":{"type":"boolean"},"kendraConfiguration":{"shape":"S1b"},"inputContexts":{"shape":"S1f"},"outputContexts":{"shape":"S1i"}}}},"PutSlotType":{"http":{"method":"PUT","requestUri":"/slottypes/{name}/versions/$LATEST","responseCode":200},"input":{"type":"structure","required":["name"],"members":{"name":{"location":"uri","locationName":"name"},"description":{},"enumerationValues":{"shape":"S1q"},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}},"output":{"type":"structure","members":{"name":{},"description":{},"enumerationValues":{"shape":"S1q"},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{},"checksum":{},"valueSelectionStrategy":{},"createVersion":{"type":"boolean"},"parentSlotTypeSignature":{},"slotTypeConfigurations":{"shape":"S1v"}}}},"StartImport":{"http":{"requestUri":"/imports/","responseCode":201},"input":{"type":"structure","required":["payload","resourceType","mergeStrategy"],"members":{"payload":{"type":"blob"},"resourceType":{},"mergeStrategy":{},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{"name":{},"resourceType":{},"mergeStrategy":{},"importId":{},"importStatus":{},"tags":{"shape":"S5e"},"createdDate":{"type":"timestamp"}}}},"StartMigration":{"http":{"requestUri":"/migrations","responseCode":202},"input":{"type":"structure","required":["v1BotName","v1BotVersion","v2BotName","v2BotRole","migrationStrategy"],"members":{"v1BotName":{},"v1BotVersion":{},"v2BotName":{},"v2BotRole":{},"migrationStrategy":{}}},"output":{"type":"structure","members":{"v1BotName":{},"v1BotVersion":{},"v1BotLocale":{},"v2BotId":{},"v2BotRole":{},"migrationId":{},"migrationStrategy":{},"migrationTimestamp":{"type":"timestamp"}}}},"TagResource":{"http":{"requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tags":{"shape":"S5e"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{resourceArn}","responseCode":204},"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{"location":"uri","locationName":"resourceArn"},"tagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S6":{"type":"list","member":{"type":"structure","required":["intentName","intentVersion"],"members":{"intentName":{},"intentVersion":{}}}},"Sa":{"type":"structure","required":["messages","maxAttempts"],"members":{"messages":{"shape":"Sb"},"maxAttempts":{"type":"integer"},"responseCard":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["contentType","content"],"members":{"contentType":{},"content":{},"groupNumber":{"type":"integer"}}}},"Si":{"type":"structure","required":["messages"],"members":{"messages":{"shape":"Sb"},"responseCard":{}}},"Sq":{"type":"list","member":{"type":"structure","required":["name","slotConstraint"],"members":{"name":{},"description":{},"slotConstraint":{},"slotType":{},"slotTypeVersion":{},"valueElicitationPrompt":{"shape":"Sa"},"priority":{"type":"integer"},"sampleUtterances":{"type":"list","member":{}},"responseCard":{},"obfuscationSetting":{},"defaultValueSpec":{"type":"structure","required":["defaultValueList"],"members":{"defaultValueList":{"type":"list","member":{"type":"structure","required":["defaultValue"],"members":{"defaultValue":{}}}}}}}}},"S13":{"type":"list","member":{}},"S14":{"type":"structure","required":["prompt","rejectionStatement"],"members":{"prompt":{"shape":"Sa"},"rejectionStatement":{"shape":"Si"}}},"S15":{"type":"structure","required":["uri","messageVersion"],"members":{"uri":{},"messageVersion":{}}},"S18":{"type":"structure","required":["type"],"members":{"type":{},"codeHook":{"shape":"S15"}}},"S1b":{"type":"structure","required":["kendraIndex","role"],"members":{"kendraIndex":{},"queryFilterString":{},"role":{}}},"S1f":{"type":"list","member":{"type":"structure","required":["name"],"members":{"name":{}}}},"S1i":{"type":"list","member":{"type":"structure","required":["name","timeToLiveInSeconds","turnsToLive"],"members":{"name":{},"timeToLiveInSeconds":{"type":"integer"},"turnsToLive":{"type":"integer"}}}},"S1q":{"type":"list","member":{"type":"structure","required":["value"],"members":{"value":{},"synonyms":{"type":"list","member":{}}}}},"S1v":{"type":"list","member":{"type":"structure","members":{"regexConfiguration":{"type":"structure","required":["pattern"],"members":{"pattern":{}}}}}},"S2h":{"type":"structure","members":{"logSettings":{"type":"list","member":{"type":"structure","members":{"logType":{},"destination":{},"kmsKeyArn":{},"resourceArn":{},"resourcePrefix":{}}}},"iamRoleArn":{}}},"S2z":{"type":"map","key":{},"value":{},"sensitive":true},"S38":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"status":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S3e":{"type":"list","member":{}},"S45":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S4x":{"type":"list","member":{"type":"structure","members":{"name":{},"description":{},"lastUpdatedDate":{"type":"timestamp"},"createdDate":{"type":"timestamp"},"version":{}}}},"S5e":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}}

/***/ }),
/* 547 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetBotAliases":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotChannelAssociations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBotVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBots":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetBuiltinSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntentVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetIntents":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetMigrations":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypeVersions":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"},"GetSlotTypes":{"input_token":"nextToken","output_token":"nextToken","limit_key":"maxResults"}}}

/***/ }),
/* 548 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-11-19","endpointPrefix":"geo","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Location Service","serviceId":"Location","signatureVersion":"v4","signingName":"geo","uid":"location-2020-11-19"},"operations":{"AssociateTrackerConsumer":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/consumers","responseCode":200},"input":{"type":"structure","required":["ConsumerArn","TrackerName"],"members":{"ConsumerArn":{},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.tracking."}},"BatchDeleteDevicePositionHistory":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/delete-positions","responseCode":200},"input":{"type":"structure","required":["DeviceIds","TrackerName"],"members":{"DeviceIds":{"type":"list","member":{}},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error"],"members":{"DeviceId":{},"Error":{"shape":"Sb"}}}}}},"endpoint":{"hostPrefix":"tracking."}},"BatchDeleteGeofence":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/delete-geofences","responseCode":200},"input":{"type":"structure","required":["CollectionName","GeofenceIds"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"GeofenceIds":{"type":"list","member":{}}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["Error","GeofenceId"],"members":{"Error":{"shape":"Sb"},"GeofenceId":{}}}}}},"endpoint":{"hostPrefix":"geofencing."}},"BatchEvaluateGeofences":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/positions","responseCode":200},"input":{"type":"structure","required":["CollectionName","DevicePositionUpdates"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"DevicePositionUpdates":{"type":"list","member":{"shape":"Sl"}}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error","SampleTime"],"members":{"DeviceId":{},"Error":{"shape":"Sb"},"SampleTime":{"shape":"St"}}}}}},"endpoint":{"hostPrefix":"geofencing."}},"BatchGetDevicePosition":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/get-positions","responseCode":200},"input":{"type":"structure","required":["DeviceIds","TrackerName"],"members":{"DeviceIds":{"type":"list","member":{}},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["DevicePositions","Errors"],"members":{"DevicePositions":{"shape":"S11"},"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error"],"members":{"DeviceId":{},"Error":{"shape":"Sb"}}}}}},"endpoint":{"hostPrefix":"tracking."}},"BatchPutGeofence":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/put-geofences","responseCode":200},"input":{"type":"structure","required":["CollectionName","Entries"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"Entries":{"type":"list","member":{"type":"structure","required":["GeofenceId","Geometry"],"members":{"GeofenceId":{},"GeofenceProperties":{"shape":"Sq"},"Geometry":{"shape":"S18"}}}}}},"output":{"type":"structure","required":["Errors","Successes"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["Error","GeofenceId"],"members":{"Error":{"shape":"Sb"},"GeofenceId":{}}}},"Successes":{"type":"list","member":{"type":"structure","required":["CreateTime","GeofenceId","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"UpdateTime":{"shape":"St"}}}}}},"endpoint":{"hostPrefix":"geofencing."}},"BatchUpdateDevicePosition":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/positions","responseCode":200},"input":{"type":"structure","required":["TrackerName","Updates"],"members":{"TrackerName":{"location":"uri","locationName":"TrackerName"},"Updates":{"type":"list","member":{"shape":"Sl"}}}},"output":{"type":"structure","required":["Errors"],"members":{"Errors":{"type":"list","member":{"type":"structure","required":["DeviceId","Error","SampleTime"],"members":{"DeviceId":{},"Error":{"shape":"Sb"},"SampleTime":{"shape":"St"}}}}}},"endpoint":{"hostPrefix":"tracking."}},"CalculateRoute":{"http":{"requestUri":"/routes/v0/calculators/{CalculatorName}/calculate/route","responseCode":200},"input":{"type":"structure","required":["CalculatorName","DeparturePosition","DestinationPosition"],"members":{"ArrivalTime":{"shape":"St"},"CalculatorName":{"location":"uri","locationName":"CalculatorName"},"CarModeOptions":{"shape":"S1n"},"DepartNow":{"type":"boolean"},"DeparturePosition":{"shape":"So"},"DepartureTime":{"shape":"St"},"DestinationPosition":{"shape":"So"},"DistanceUnit":{},"IncludeLegGeometry":{"type":"boolean"},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"OptimizeFor":{},"TravelMode":{},"TruckModeOptions":{"shape":"S1t"},"WaypointPositions":{"type":"list","member":{"shape":"So"}}}},"output":{"type":"structure","required":["Legs","Summary"],"members":{"Legs":{"type":"list","member":{"type":"structure","required":["Distance","DurationSeconds","EndPosition","StartPosition","Steps"],"members":{"Distance":{"type":"double"},"DurationSeconds":{"type":"double"},"EndPosition":{"shape":"So"},"Geometry":{"type":"structure","members":{"LineString":{"type":"list","member":{"shape":"So"}}}},"StartPosition":{"shape":"So"},"Steps":{"type":"list","member":{"type":"structure","required":["Distance","DurationSeconds","EndPosition","StartPosition"],"members":{"Distance":{"type":"double"},"DurationSeconds":{"type":"double"},"EndPosition":{"shape":"So"},"GeometryOffset":{"type":"integer"},"StartPosition":{"shape":"So"}}}}}}},"Summary":{"type":"structure","required":["DataSource","Distance","DistanceUnit","DurationSeconds","RouteBBox"],"members":{"DataSource":{},"Distance":{"type":"double"},"DistanceUnit":{},"DurationSeconds":{"type":"double"},"RouteBBox":{"shape":"S2i"}}}}},"endpoint":{"hostPrefix":"routes."}},"CalculateRouteMatrix":{"http":{"requestUri":"/routes/v0/calculators/{CalculatorName}/calculate/route-matrix","responseCode":200},"input":{"type":"structure","required":["CalculatorName","DeparturePositions","DestinationPositions"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"},"CarModeOptions":{"shape":"S1n"},"DepartNow":{"type":"boolean"},"DeparturePositions":{"type":"list","member":{"shape":"So"}},"DepartureTime":{"shape":"St"},"DestinationPositions":{"type":"list","member":{"shape":"So"}},"DistanceUnit":{},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"TravelMode":{},"TruckModeOptions":{"shape":"S1t"}}},"output":{"type":"structure","required":["RouteMatrix","Summary"],"members":{"RouteMatrix":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"Distance":{"type":"double"},"DurationSeconds":{"type":"double"},"Error":{"type":"structure","required":["Code"],"members":{"Code":{},"Message":{}}}}}}},"SnappedDeparturePositions":{"type":"list","member":{"shape":"So"}},"SnappedDestinationPositions":{"type":"list","member":{"shape":"So"}},"Summary":{"type":"structure","required":["DataSource","DistanceUnit","ErrorCount","RouteCount"],"members":{"DataSource":{},"DistanceUnit":{},"ErrorCount":{"type":"integer"},"RouteCount":{"type":"integer"}}}}},"endpoint":{"hostPrefix":"routes."}},"CreateGeofenceCollection":{"http":{"requestUri":"/geofencing/v0/collections","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{},"Description":{},"KmsKeyId":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."},"Tags":{"shape":"S33"}}},"output":{"type":"structure","required":["CollectionArn","CollectionName","CreateTime"],"members":{"CollectionArn":{},"CollectionName":{},"CreateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.geofencing."},"idempotent":true},"CreateKey":{"http":{"requestUri":"/metadata/v0/keys","responseCode":200},"input":{"type":"structure","required":["KeyName","Restrictions"],"members":{"Description":{},"ExpireTime":{"shape":"St"},"KeyName":{},"NoExpiry":{"type":"boolean"},"Restrictions":{"shape":"S38"},"Tags":{"shape":"S33"}}},"output":{"type":"structure","required":["CreateTime","Key","KeyArn","KeyName"],"members":{"CreateTime":{"shape":"St"},"Key":{"shape":"S1q"},"KeyArn":{},"KeyName":{}}},"endpoint":{"hostPrefix":"cp.metadata."},"idempotent":true},"CreateMap":{"http":{"requestUri":"/maps/v0/maps","responseCode":200},"input":{"type":"structure","required":["Configuration","MapName"],"members":{"Configuration":{"shape":"S3h"},"Description":{},"MapName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"Tags":{"shape":"S33"}}},"output":{"type":"structure","required":["CreateTime","MapArn","MapName"],"members":{"CreateTime":{"shape":"St"},"MapArn":{},"MapName":{}}},"endpoint":{"hostPrefix":"cp.maps."},"idempotent":true},"CreatePlaceIndex":{"http":{"requestUri":"/places/v0/indexes","responseCode":200},"input":{"type":"structure","required":["DataSource","IndexName"],"members":{"DataSource":{},"DataSourceConfiguration":{"shape":"S3o"},"Description":{},"IndexName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"Tags":{"shape":"S33"}}},"output":{"type":"structure","required":["CreateTime","IndexArn","IndexName"],"members":{"CreateTime":{"shape":"St"},"IndexArn":{},"IndexName":{}}},"endpoint":{"hostPrefix":"cp.places."},"idempotent":true},"CreateRouteCalculator":{"http":{"requestUri":"/routes/v0/calculators","responseCode":200},"input":{"type":"structure","required":["CalculatorName","DataSource"],"members":{"CalculatorName":{},"DataSource":{},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"Tags":{"shape":"S33"}}},"output":{"type":"structure","required":["CalculatorArn","CalculatorName","CreateTime"],"members":{"CalculatorArn":{},"CalculatorName":{},"CreateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.routes."},"idempotent":true},"CreateTracker":{"http":{"requestUri":"/tracking/v0/trackers","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"Description":{},"EventBridgeEnabled":{"type":"boolean"},"KmsKeyEnableGeospatialQueries":{"type":"boolean"},"KmsKeyId":{},"PositionFiltering":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."},"Tags":{"shape":"S33"},"TrackerName":{}}},"output":{"type":"structure","required":["CreateTime","TrackerArn","TrackerName"],"members":{"CreateTime":{"shape":"St"},"TrackerArn":{},"TrackerName":{}}},"endpoint":{"hostPrefix":"cp.tracking."},"idempotent":true},"DeleteGeofenceCollection":{"http":{"method":"DELETE","requestUri":"/geofencing/v0/collections/{CollectionName}","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.geofencing."},"idempotent":true},"DeleteKey":{"http":{"method":"DELETE","requestUri":"/metadata/v0/keys/{KeyName}","responseCode":200},"input":{"type":"structure","required":["KeyName"],"members":{"ForceDelete":{"location":"querystring","locationName":"forceDelete","type":"boolean"},"KeyName":{"location":"uri","locationName":"KeyName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.metadata."},"idempotent":true},"DeleteMap":{"http":{"method":"DELETE","requestUri":"/maps/v0/maps/{MapName}","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.maps."},"idempotent":true},"DeletePlaceIndex":{"http":{"method":"DELETE","requestUri":"/places/v0/indexes/{IndexName}","responseCode":200},"input":{"type":"structure","required":["IndexName"],"members":{"IndexName":{"location":"uri","locationName":"IndexName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.places."},"idempotent":true},"DeleteRouteCalculator":{"http":{"method":"DELETE","requestUri":"/routes/v0/calculators/{CalculatorName}","responseCode":200},"input":{"type":"structure","required":["CalculatorName"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.routes."},"idempotent":true},"DeleteTracker":{"http":{"method":"DELETE","requestUri":"/tracking/v0/trackers/{TrackerName}","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.tracking."},"idempotent":true},"DescribeGeofenceCollection":{"http":{"method":"GET","requestUri":"/geofencing/v0/collections/{CollectionName}","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"}}},"output":{"type":"structure","required":["CollectionArn","CollectionName","CreateTime","Description","UpdateTime"],"members":{"CollectionArn":{},"CollectionName":{},"CreateTime":{"shape":"St"},"Description":{},"GeofenceCount":{"type":"integer"},"KmsKeyId":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"Tags":{"shape":"S33"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.geofencing."}},"DescribeKey":{"http":{"method":"GET","requestUri":"/metadata/v0/keys/{KeyName}","responseCode":200},"input":{"type":"structure","required":["KeyName"],"members":{"KeyName":{"location":"uri","locationName":"KeyName"}}},"output":{"type":"structure","required":["CreateTime","ExpireTime","Key","KeyArn","KeyName","Restrictions","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"Description":{},"ExpireTime":{"shape":"St"},"Key":{"shape":"S1q"},"KeyArn":{},"KeyName":{},"Restrictions":{"shape":"S38"},"Tags":{"shape":"S33"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.metadata."}},"DescribeMap":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","required":["Configuration","CreateTime","DataSource","Description","MapArn","MapName","UpdateTime"],"members":{"Configuration":{"shape":"S3h"},"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"MapArn":{},"MapName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"Tags":{"shape":"S33"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.maps."}},"DescribePlaceIndex":{"http":{"method":"GET","requestUri":"/places/v0/indexes/{IndexName}","responseCode":200},"input":{"type":"structure","required":["IndexName"],"members":{"IndexName":{"location":"uri","locationName":"IndexName"}}},"output":{"type":"structure","required":["CreateTime","DataSource","DataSourceConfiguration","Description","IndexArn","IndexName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"DataSource":{},"DataSourceConfiguration":{"shape":"S3o"},"Description":{},"IndexArn":{},"IndexName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"Tags":{"shape":"S33"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.places."}},"DescribeRouteCalculator":{"http":{"method":"GET","requestUri":"/routes/v0/calculators/{CalculatorName}","responseCode":200},"input":{"type":"structure","required":["CalculatorName"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"}}},"output":{"type":"structure","required":["CalculatorArn","CalculatorName","CreateTime","DataSource","Description","UpdateTime"],"members":{"CalculatorArn":{},"CalculatorName":{},"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"Tags":{"shape":"S33"},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.routes."}},"DescribeTracker":{"http":{"method":"GET","requestUri":"/tracking/v0/trackers/{TrackerName}","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["CreateTime","Description","TrackerArn","TrackerName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"Description":{},"EventBridgeEnabled":{"type":"boolean"},"KmsKeyEnableGeospatialQueries":{"type":"boolean"},"KmsKeyId":{},"PositionFiltering":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"Tags":{"shape":"S33"},"TrackerArn":{},"TrackerName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.tracking."}},"DisassociateTrackerConsumer":{"http":{"method":"DELETE","requestUri":"/tracking/v0/trackers/{TrackerName}/consumers/{ConsumerArn}","responseCode":200},"input":{"type":"structure","required":["ConsumerArn","TrackerName"],"members":{"ConsumerArn":{"location":"uri","locationName":"ConsumerArn"},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.tracking."}},"GetDevicePosition":{"http":{"method":"GET","requestUri":"/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/positions/latest","responseCode":200},"input":{"type":"structure","required":["DeviceId","TrackerName"],"members":{"DeviceId":{"location":"uri","locationName":"DeviceId"},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["Position","ReceivedTime","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"ReceivedTime":{"shape":"St"},"SampleTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"tracking."}},"GetDevicePositionHistory":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/devices/{DeviceId}/list-positions","responseCode":200},"input":{"type":"structure","required":["DeviceId","TrackerName"],"members":{"DeviceId":{"location":"uri","locationName":"DeviceId"},"EndTimeExclusive":{"shape":"St"},"MaxResults":{"type":"integer"},"NextToken":{},"StartTimeInclusive":{"shape":"St"},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["DevicePositions"],"members":{"DevicePositions":{"shape":"S11"},"NextToken":{}}},"endpoint":{"hostPrefix":"tracking."}},"GetGeofence":{"http":{"method":"GET","requestUri":"/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}","responseCode":200},"input":{"type":"structure","required":["CollectionName","GeofenceId"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"GeofenceId":{"location":"uri","locationName":"GeofenceId"}}},"output":{"type":"structure","required":["CreateTime","GeofenceId","Geometry","Status","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"GeofenceProperties":{"shape":"Sq"},"Geometry":{"shape":"S18"},"Status":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"geofencing."}},"GetMapGlyphs":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/glyphs/{FontStack}/{FontUnicodeRange}","responseCode":200},"input":{"type":"structure","required":["FontStack","FontUnicodeRange","MapName"],"members":{"FontStack":{"location":"uri","locationName":"FontStack"},"FontUnicodeRange":{"location":"uri","locationName":"FontUnicodeRange"},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"GetMapSprites":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/sprites/{FileName}","responseCode":200},"input":{"type":"structure","required":["FileName","MapName"],"members":{"FileName":{"location":"uri","locationName":"FileName"},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"GetMapStyleDescriptor":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/style-descriptor","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"MapName":{"location":"uri","locationName":"MapName"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"GetMapTile":{"http":{"method":"GET","requestUri":"/maps/v0/maps/{MapName}/tiles/{Z}/{X}/{Y}","responseCode":200},"input":{"type":"structure","required":["MapName","X","Y","Z"],"members":{"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"MapName":{"location":"uri","locationName":"MapName"},"X":{"location":"uri","locationName":"X"},"Y":{"location":"uri","locationName":"Y"},"Z":{"location":"uri","locationName":"Z"}}},"output":{"type":"structure","members":{"Blob":{"type":"blob"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentType":{"location":"header","locationName":"Content-Type"}},"payload":"Blob"},"endpoint":{"hostPrefix":"maps."}},"GetPlace":{"http":{"method":"GET","requestUri":"/places/v0/indexes/{IndexName}/places/{PlaceId}","responseCode":200},"input":{"type":"structure","required":["IndexName","PlaceId"],"members":{"IndexName":{"location":"uri","locationName":"IndexName"},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"Language":{"location":"querystring","locationName":"language"},"PlaceId":{"location":"uri","locationName":"PlaceId"}}},"output":{"type":"structure","required":["Place"],"members":{"Place":{"shape":"S5d"}}},"endpoint":{"hostPrefix":"places."}},"ListDevicePositions":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/list-positions","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"FilterGeometry":{"type":"structure","members":{"Polygon":{"shape":"S1a"}}},"MaxResults":{"type":"integer"},"NextToken":{},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["DeviceId","Position","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"SampleTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"tracking."}},"ListGeofenceCollections":{"http":{"requestUri":"/geofencing/v0/list-collections","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CollectionName","CreateTime","Description","UpdateTime"],"members":{"CollectionName":{},"CreateTime":{"shape":"St"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"cp.geofencing."}},"ListGeofences":{"http":{"requestUri":"/geofencing/v0/collections/{CollectionName}/list-geofences","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","GeofenceId","Geometry","Status","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"GeofenceProperties":{"shape":"Sq"},"Geometry":{"shape":"S18"},"Status":{},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"geofencing."}},"ListKeys":{"http":{"requestUri":"/metadata/v0/list-keys","responseCode":200},"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"KeyStatus":{}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","ExpireTime","KeyName","Restrictions","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"Description":{},"ExpireTime":{"shape":"St"},"KeyName":{},"Restrictions":{"shape":"S38"},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"cp.metadata."}},"ListMaps":{"http":{"requestUri":"/maps/v0/list-maps","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","DataSource","Description","MapName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"MapName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"cp.maps."}},"ListPlaceIndexes":{"http":{"requestUri":"/places/v0/list-indexes","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","DataSource","Description","IndexName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"IndexName":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"cp.places."}},"ListRouteCalculators":{"http":{"requestUri":"/routes/v0/list-calculators","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CalculatorName","CreateTime","DataSource","Description","UpdateTime"],"members":{"CalculatorName":{},"CreateTime":{"shape":"St"},"DataSource":{},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"cp.routes."}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"}}},"output":{"type":"structure","members":{"Tags":{"shape":"S33"}}},"endpoint":{"hostPrefix":"cp.metadata."}},"ListTrackerConsumers":{"http":{"requestUri":"/tracking/v0/trackers/{TrackerName}/list-consumers","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"MaxResults":{"type":"integer"},"NextToken":{},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["ConsumerArns"],"members":{"ConsumerArns":{"type":"list","member":{}},"NextToken":{}}},"endpoint":{"hostPrefix":"cp.tracking."}},"ListTrackers":{"http":{"requestUri":"/tracking/v0/list-trackers","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"type":"structure","required":["CreateTime","Description","TrackerName","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. Always returns RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. Unused."},"TrackerName":{},"UpdateTime":{"shape":"St"}}}},"NextToken":{}}},"endpoint":{"hostPrefix":"cp.tracking."}},"PutGeofence":{"http":{"method":"PUT","requestUri":"/geofencing/v0/collections/{CollectionName}/geofences/{GeofenceId}","responseCode":200},"input":{"type":"structure","required":["CollectionName","GeofenceId","Geometry"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"GeofenceId":{"location":"uri","locationName":"GeofenceId"},"GeofenceProperties":{"shape":"Sq"},"Geometry":{"shape":"S18"}}},"output":{"type":"structure","required":["CreateTime","GeofenceId","UpdateTime"],"members":{"CreateTime":{"shape":"St"},"GeofenceId":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"geofencing."}},"SearchPlaceIndexForPosition":{"http":{"requestUri":"/places/v0/indexes/{IndexName}/search/position","responseCode":200},"input":{"type":"structure","required":["IndexName","Position"],"members":{"IndexName":{"location":"uri","locationName":"IndexName"},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"Language":{},"MaxResults":{"type":"integer"},"Position":{"shape":"So"}}},"output":{"type":"structure","required":["Results","Summary"],"members":{"Results":{"type":"list","member":{"type":"structure","required":["Distance","Place"],"members":{"Distance":{"type":"double"},"Place":{"shape":"S5d"},"PlaceId":{}}}},"Summary":{"type":"structure","required":["DataSource","Position"],"members":{"DataSource":{},"Language":{},"MaxResults":{"type":"integer"},"Position":{"shape":"So"}}}}},"endpoint":{"hostPrefix":"places."}},"SearchPlaceIndexForSuggestions":{"http":{"requestUri":"/places/v0/indexes/{IndexName}/search/suggestions","responseCode":200},"input":{"type":"structure","required":["IndexName","Text"],"members":{"BiasPosition":{"shape":"So"},"FilterBBox":{"shape":"S2i"},"FilterCategories":{"shape":"S78"},"FilterCountries":{"shape":"S79"},"IndexName":{"location":"uri","locationName":"IndexName"},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"Language":{},"MaxResults":{"type":"integer"},"Text":{"type":"string","sensitive":true}}},"output":{"type":"structure","required":["Results","Summary"],"members":{"Results":{"type":"list","member":{"type":"structure","required":["Text"],"members":{"Categories":{"shape":"S5e"},"PlaceId":{},"SupplementalCategories":{"shape":"S5h"},"Text":{}}}},"Summary":{"type":"structure","required":["DataSource","Text"],"members":{"BiasPosition":{"shape":"So"},"DataSource":{},"FilterBBox":{"shape":"S2i"},"FilterCategories":{"shape":"S78"},"FilterCountries":{"shape":"S79"},"Language":{},"MaxResults":{"type":"integer"},"Text":{"shape":"S7h"}}}}},"endpoint":{"hostPrefix":"places."}},"SearchPlaceIndexForText":{"http":{"requestUri":"/places/v0/indexes/{IndexName}/search/text","responseCode":200},"input":{"type":"structure","required":["IndexName","Text"],"members":{"BiasPosition":{"shape":"So"},"FilterBBox":{"shape":"S2i"},"FilterCategories":{"shape":"S78"},"FilterCountries":{"shape":"S79"},"IndexName":{"location":"uri","locationName":"IndexName"},"Key":{"shape":"S1q","location":"querystring","locationName":"key"},"Language":{},"MaxResults":{"type":"integer"},"Text":{"type":"string","sensitive":true}}},"output":{"type":"structure","required":["Results","Summary"],"members":{"Results":{"type":"list","member":{"type":"structure","required":["Place"],"members":{"Distance":{"type":"double"},"Place":{"shape":"S5d"},"PlaceId":{},"Relevance":{"type":"double"}}}},"Summary":{"type":"structure","required":["DataSource","Text"],"members":{"BiasPosition":{"shape":"So"},"DataSource":{},"FilterBBox":{"shape":"S2i"},"FilterCategories":{"shape":"S78"},"FilterCountries":{"shape":"S79"},"Language":{},"MaxResults":{"type":"integer"},"ResultBBox":{"shape":"S2i"},"Text":{"shape":"S7h"}}}}},"endpoint":{"hostPrefix":"places."}},"TagResource":{"http":{"requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"Tags":{"shape":"S33"}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.metadata."}},"UntagResource":{"http":{"method":"DELETE","requestUri":"/tags/{ResourceArn}","responseCode":200},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{"location":"uri","locationName":"ResourceArn"},"TagKeys":{"location":"querystring","locationName":"tagKeys","type":"list","member":{}}}},"output":{"type":"structure","members":{}},"endpoint":{"hostPrefix":"cp.metadata."},"idempotent":true},"UpdateGeofenceCollection":{"http":{"method":"PATCH","requestUri":"/geofencing/v0/collections/{CollectionName}","responseCode":200},"input":{"type":"structure","required":["CollectionName"],"members":{"CollectionName":{"location":"uri","locationName":"CollectionName"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."}}},"output":{"type":"structure","required":["CollectionArn","CollectionName","UpdateTime"],"members":{"CollectionArn":{},"CollectionName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.geofencing."},"idempotent":true},"UpdateKey":{"http":{"method":"PATCH","requestUri":"/metadata/v0/keys/{KeyName}","responseCode":200},"input":{"type":"structure","required":["KeyName"],"members":{"Description":{},"ExpireTime":{"shape":"St"},"ForceUpdate":{"type":"boolean"},"KeyName":{"location":"uri","locationName":"KeyName"},"NoExpiry":{"type":"boolean"},"Restrictions":{"shape":"S38"}}},"output":{"type":"structure","required":["KeyArn","KeyName","UpdateTime"],"members":{"KeyArn":{},"KeyName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.metadata."},"idempotent":true},"UpdateMap":{"http":{"method":"PATCH","requestUri":"/maps/v0/maps/{MapName}","responseCode":200},"input":{"type":"structure","required":["MapName"],"members":{"ConfigurationUpdate":{"type":"structure","members":{"CustomLayers":{"shape":"S3i"},"PoliticalView":{}}},"Description":{},"MapName":{"location":"uri","locationName":"MapName"},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."}}},"output":{"type":"structure","required":["MapArn","MapName","UpdateTime"],"members":{"MapArn":{},"MapName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.maps."},"idempotent":true},"UpdatePlaceIndex":{"http":{"method":"PATCH","requestUri":"/places/v0/indexes/{IndexName}","responseCode":200},"input":{"type":"structure","required":["IndexName"],"members":{"DataSourceConfiguration":{"shape":"S3o"},"Description":{},"IndexName":{"location":"uri","locationName":"IndexName"},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."}}},"output":{"type":"structure","required":["IndexArn","IndexName","UpdateTime"],"members":{"IndexArn":{},"IndexName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.places."},"idempotent":true},"UpdateRouteCalculator":{"http":{"method":"PATCH","requestUri":"/routes/v0/calculators/{CalculatorName}","responseCode":200},"input":{"type":"structure","required":["CalculatorName"],"members":{"CalculatorName":{"location":"uri","locationName":"CalculatorName"},"Description":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."}}},"output":{"type":"structure","required":["CalculatorArn","CalculatorName","UpdateTime"],"members":{"CalculatorArn":{},"CalculatorName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.routes."},"idempotent":true},"UpdateTracker":{"http":{"method":"PATCH","requestUri":"/tracking/v0/trackers/{TrackerName}","responseCode":200},"input":{"type":"structure","required":["TrackerName"],"members":{"Description":{},"EventBridgeEnabled":{"type":"boolean"},"KmsKeyEnableGeospatialQueries":{"type":"boolean"},"PositionFiltering":{},"PricingPlan":{"deprecated":true,"deprecatedMessage":"Deprecated. If included, the only allowed value is RequestBasedUsage."},"PricingPlanDataSource":{"deprecated":true,"deprecatedMessage":"Deprecated. No longer allowed."},"TrackerName":{"location":"uri","locationName":"TrackerName"}}},"output":{"type":"structure","required":["TrackerArn","TrackerName","UpdateTime"],"members":{"TrackerArn":{},"TrackerName":{},"UpdateTime":{"shape":"St"}}},"endpoint":{"hostPrefix":"cp.tracking."},"idempotent":true}},"shapes":{"Sb":{"type":"structure","members":{"Code":{},"Message":{}}},"Sl":{"type":"structure","required":["DeviceId","Position","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"SampleTime":{"shape":"St"}}},"Sm":{"type":"structure","required":["Horizontal"],"members":{"Horizontal":{"type":"double"}}},"So":{"type":"list","member":{"type":"double"},"sensitive":true},"Sq":{"type":"map","key":{},"value":{},"sensitive":true},"St":{"type":"timestamp","timestampFormat":"iso8601"},"S11":{"type":"list","member":{"type":"structure","required":["Position","ReceivedTime","SampleTime"],"members":{"Accuracy":{"shape":"Sm"},"DeviceId":{},"Position":{"shape":"So"},"PositionProperties":{"shape":"Sq"},"ReceivedTime":{"shape":"St"},"SampleTime":{"shape":"St"}}}},"S18":{"type":"structure","members":{"Circle":{"type":"structure","required":["Center","Radius"],"members":{"Center":{"shape":"So"},"Radius":{"type":"double"}},"sensitive":true},"Polygon":{"shape":"S1a"}}},"S1a":{"type":"list","member":{"type":"list","member":{"shape":"So"}}},"S1n":{"type":"structure","members":{"AvoidFerries":{"type":"boolean"},"AvoidTolls":{"type":"boolean"}}},"S1q":{"type":"string","sensitive":true},"S1t":{"type":"structure","members":{"AvoidFerries":{"type":"boolean"},"AvoidTolls":{"type":"boolean"},"Dimensions":{"type":"structure","members":{"Height":{"type":"double"},"Length":{"type":"double"},"Unit":{},"Width":{"type":"double"}}},"Weight":{"type":"structure","members":{"Total":{"type":"double"},"Unit":{}}}}},"S2i":{"type":"list","member":{"type":"double"},"sensitive":true},"S33":{"type":"map","key":{},"value":{}},"S38":{"type":"structure","required":["AllowActions","AllowResources"],"members":{"AllowActions":{"type":"list","member":{}},"AllowReferers":{"type":"list","member":{}},"AllowResources":{"type":"list","member":{}}}},"S3h":{"type":"structure","required":["Style"],"members":{"CustomLayers":{"shape":"S3i"},"PoliticalView":{},"Style":{}}},"S3i":{"type":"list","member":{}},"S3o":{"type":"structure","members":{"IntendedUse":{}}},"S5d":{"type":"structure","required":["Geometry"],"members":{"AddressNumber":{},"Categories":{"shape":"S5e"},"Country":{},"Geometry":{"type":"structure","members":{"Point":{"shape":"So"}}},"Interpolated":{"type":"boolean"},"Label":{},"Municipality":{},"Neighborhood":{},"PostalCode":{},"Region":{},"Street":{},"SubMunicipality":{},"SubRegion":{},"SupplementalCategories":{"shape":"S5h"},"TimeZone":{"type":"structure","required":["Name"],"members":{"Name":{},"Offset":{"type":"integer"}}},"UnitNumber":{},"UnitType":{}}},"S5e":{"type":"list","member":{}},"S5h":{"type":"list","member":{}},"S78":{"type":"list","member":{}},"S79":{"type":"list","member":{}},"S7h":{"type":"string","sensitive":true}}}

/***/ }),
/* 549 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"GetDevicePositionHistory":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"DevicePositions"},"ListDevicePositions":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListGeofenceCollections":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListGeofences":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListKeys":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListMaps":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListPlaceIndexes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListRouteCalculators":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"},"ListTrackerConsumers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ConsumerArns"},"ListTrackers":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Entries"}}}

/***/ }),
/* 550 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-03-28","endpointPrefix":"logs","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon CloudWatch Logs","serviceId":"CloudWatch Logs","signatureVersion":"v4","targetPrefix":"Logs_20140328","uid":"logs-2014-03-28"},"operations":{"AssociateKmsKey":{"input":{"type":"structure","required":["kmsKeyId"],"members":{"logGroupName":{},"kmsKeyId":{},"resourceIdentifier":{}}}},"CancelExportTask":{"input":{"type":"structure","required":["taskId"],"members":{"taskId":{}}}},"CreateDelivery":{"input":{"type":"structure","required":["deliverySourceName","deliveryDestinationArn"],"members":{"deliverySourceName":{},"deliveryDestinationArn":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"delivery":{"shape":"Se"}}}},"CreateExportTask":{"input":{"type":"structure","required":["logGroupName","from","to","destination"],"members":{"taskName":{},"logGroupName":{},"logStreamNamePrefix":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{}}},"output":{"type":"structure","members":{"taskId":{}}}},"CreateLogAnomalyDetector":{"input":{"type":"structure","required":["logGroupArnList"],"members":{"logGroupArnList":{"shape":"Sp"},"detectorName":{},"evaluationFrequency":{},"filterPattern":{},"kmsKeyId":{},"anomalyVisibilityTime":{"type":"long"},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"anomalyDetectorArn":{}}}},"CreateLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"kmsKeyId":{},"tags":{"shape":"Sa"},"logGroupClass":{}}}},"CreateLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteAccountPolicy":{"input":{"type":"structure","required":["policyName","policyType"],"members":{"policyName":{},"policyType":{}}}},"DeleteDataProtectionPolicy":{"input":{"type":"structure","required":["logGroupIdentifier"],"members":{"logGroupIdentifier":{}}}},"DeleteDelivery":{"input":{"type":"structure","required":["id"],"members":{"id":{}}}},"DeleteDeliveryDestination":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeleteDeliveryDestinationPolicy":{"input":{"type":"structure","required":["deliveryDestinationName"],"members":{"deliveryDestinationName":{}}}},"DeleteDeliverySource":{"input":{"type":"structure","required":["name"],"members":{"name":{}}}},"DeleteDestination":{"input":{"type":"structure","required":["destinationName"],"members":{"destinationName":{}}}},"DeleteLogAnomalyDetector":{"input":{"type":"structure","required":["anomalyDetectorArn"],"members":{"anomalyDetectorArn":{}}}},"DeleteLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteLogStream":{"input":{"type":"structure","required":["logGroupName","logStreamName"],"members":{"logGroupName":{},"logStreamName":{}}}},"DeleteMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DeleteQueryDefinition":{"input":{"type":"structure","required":["queryDefinitionId"],"members":{"queryDefinitionId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"DeleteResourcePolicy":{"input":{"type":"structure","members":{"policyName":{}}}},"DeleteRetentionPolicy":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}}}},"DeleteSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName"],"members":{"logGroupName":{},"filterName":{}}}},"DescribeAccountPolicies":{"input":{"type":"structure","required":["policyType"],"members":{"policyType":{},"policyName":{},"accountIdentifiers":{"shape":"S1p"}}},"output":{"type":"structure","members":{"accountPolicies":{"type":"list","member":{"shape":"S1t"}}}}},"DescribeDeliveries":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"deliveries":{"type":"list","member":{"shape":"Se"}},"nextToken":{}}}},"DescribeDeliveryDestinations":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"deliveryDestinations":{"type":"list","member":{"shape":"S25"}},"nextToken":{}}}},"DescribeDeliverySources":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"deliverySources":{"type":"list","member":{"shape":"S2b"}},"nextToken":{}}}},"DescribeDestinations":{"input":{"type":"structure","members":{"DestinationNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"destinations":{"type":"list","member":{"shape":"S2i"}},"nextToken":{}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"taskId":{},"statusCode":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"exportTasks":{"type":"list","member":{"type":"structure","members":{"taskId":{},"taskName":{},"logGroupName":{},"from":{"type":"long"},"to":{"type":"long"},"destination":{},"destinationPrefix":{},"status":{"type":"structure","members":{"code":{},"message":{}}},"executionInfo":{"type":"structure","members":{"creationTime":{"type":"long"},"completionTime":{"type":"long"}}}}}},"nextToken":{}}}},"DescribeLogGroups":{"input":{"type":"structure","members":{"accountIdentifiers":{"shape":"S1p"},"logGroupNamePrefix":{},"logGroupNamePattern":{},"nextToken":{},"limit":{"type":"integer"},"includeLinkedAccounts":{"type":"boolean"},"logGroupClass":{}}},"output":{"type":"structure","members":{"logGroups":{"type":"list","member":{"type":"structure","members":{"logGroupName":{},"creationTime":{"type":"long"},"retentionInDays":{"type":"integer"},"metricFilterCount":{"type":"integer"},"arn":{},"storedBytes":{"type":"long"},"kmsKeyId":{},"dataProtectionStatus":{},"inheritedProperties":{"type":"list","member":{}},"logGroupClass":{},"logGroupArn":{}}}},"nextToken":{}}}},"DescribeLogStreams":{"input":{"type":"structure","members":{"logGroupName":{},"logGroupIdentifier":{},"logStreamNamePrefix":{},"orderBy":{},"descending":{"type":"boolean"},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"logStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"creationTime":{"type":"long"},"firstEventTimestamp":{"type":"long"},"lastEventTimestamp":{"type":"long"},"lastIngestionTime":{"type":"long"},"uploadSequenceToken":{},"arn":{},"storedBytes":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be deprecated for log streams, and will be reported as zero. This change applies only to log streams. The storedBytes parameter for log groups is not affected.","type":"long"}}}},"nextToken":{}}}},"DescribeMetricFilters":{"input":{"type":"structure","members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"},"metricName":{},"metricNamespace":{}}},"output":{"type":"structure","members":{"metricFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S3j"},"creationTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueries":{"input":{"type":"structure","members":{"logGroupName":{},"status":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queries":{"type":"list","member":{"type":"structure","members":{"queryId":{},"queryString":{},"status":{},"createTime":{"type":"long"},"logGroupName":{}}}},"nextToken":{}}}},"DescribeQueryDefinitions":{"input":{"type":"structure","members":{"queryDefinitionNamePrefix":{},"maxResults":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"queryDefinitions":{"type":"list","member":{"type":"structure","members":{"queryDefinitionId":{},"name":{},"queryString":{},"lastModified":{"type":"long"},"logGroupNames":{"shape":"S45"}}}},"nextToken":{}}}},"DescribeResourcePolicies":{"input":{"type":"structure","members":{"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"resourcePolicies":{"type":"list","member":{"shape":"S49"}},"nextToken":{}}}},"DescribeSubscriptionFilters":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{},"filterNamePrefix":{},"nextToken":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"subscriptionFilters":{"type":"list","member":{"type":"structure","members":{"filterName":{},"logGroupName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{},"creationTime":{"type":"long"}}}},"nextToken":{}}}},"DisassociateKmsKey":{"input":{"type":"structure","members":{"logGroupName":{},"resourceIdentifier":{}}}},"FilterLogEvents":{"input":{"type":"structure","members":{"logGroupName":{},"logGroupIdentifier":{},"logStreamNames":{"shape":"S4j"},"logStreamNamePrefix":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"filterPattern":{},"nextToken":{},"limit":{"type":"integer"},"interleaved":{"deprecated":true,"deprecatedMessage":"Starting on June 17, 2019, this parameter will be ignored and the value will be assumed to be true. The response from this operation will always interleave events from multiple log streams within a log group.","type":"boolean"},"unmask":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"},"eventId":{}}}},"searchedLogStreams":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"searchedCompletely":{"type":"boolean"}}}},"nextToken":{}}}},"GetDataProtectionPolicy":{"input":{"type":"structure","required":["logGroupIdentifier"],"members":{"logGroupIdentifier":{}}},"output":{"type":"structure","members":{"logGroupIdentifier":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}},"GetDelivery":{"input":{"type":"structure","required":["id"],"members":{"id":{}}},"output":{"type":"structure","members":{"delivery":{"shape":"Se"}}}},"GetDeliveryDestination":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"deliveryDestination":{"shape":"S25"}}}},"GetDeliveryDestinationPolicy":{"input":{"type":"structure","required":["deliveryDestinationName"],"members":{"deliveryDestinationName":{}}},"output":{"type":"structure","members":{"policy":{"shape":"S54"}}}},"GetDeliverySource":{"input":{"type":"structure","required":["name"],"members":{"name":{}}},"output":{"type":"structure","members":{"deliverySource":{"shape":"S2b"}}}},"GetLogAnomalyDetector":{"input":{"type":"structure","required":["anomalyDetectorArn"],"members":{"anomalyDetectorArn":{}}},"output":{"type":"structure","members":{"detectorName":{},"logGroupArnList":{"shape":"Sp"},"evaluationFrequency":{},"filterPattern":{},"anomalyDetectorStatus":{},"kmsKeyId":{},"creationTimeStamp":{"type":"long"},"lastModifiedTimeStamp":{"type":"long"},"anomalyVisibilityTime":{"type":"long"}}}},"GetLogEvents":{"input":{"type":"structure","required":["logStreamName"],"members":{"logGroupName":{},"logGroupIdentifier":{},"logStreamName":{},"startTime":{"type":"long"},"endTime":{"type":"long"},"nextToken":{},"limit":{"type":"integer"},"startFromHead":{"type":"boolean"},"unmask":{"type":"boolean"}}},"output":{"type":"structure","members":{"events":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{},"ingestionTime":{"type":"long"}}}},"nextForwardToken":{},"nextBackwardToken":{}}}},"GetLogGroupFields":{"input":{"type":"structure","members":{"logGroupName":{},"time":{"type":"long"},"logGroupIdentifier":{}}},"output":{"type":"structure","members":{"logGroupFields":{"type":"list","member":{"type":"structure","members":{"name":{},"percent":{"type":"integer"}}}}}}},"GetLogRecord":{"input":{"type":"structure","required":["logRecordPointer"],"members":{"logRecordPointer":{},"unmask":{"type":"boolean"}}},"output":{"type":"structure","members":{"logRecord":{"type":"map","key":{},"value":{}}}}},"GetQueryResults":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"results":{"type":"list","member":{"type":"list","member":{"type":"structure","members":{"field":{},"value":{}}}}},"statistics":{"type":"structure","members":{"recordsMatched":{"type":"double"},"recordsScanned":{"type":"double"},"bytesScanned":{"type":"double"}}},"status":{},"encryptionKey":{}}}},"ListAnomalies":{"input":{"type":"structure","members":{"anomalyDetectorArn":{},"suppressionState":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"anomalies":{"type":"list","member":{"type":"structure","required":["anomalyId","patternId","anomalyDetectorArn","patternString","firstSeen","lastSeen","description","active","state","histogram","logSamples","patternTokens","logGroupArnList"],"members":{"anomalyId":{},"patternId":{},"anomalyDetectorArn":{},"patternString":{},"patternRegex":{},"priority":{},"firstSeen":{"type":"long"},"lastSeen":{"type":"long"},"description":{},"active":{"type":"boolean"},"state":{},"histogram":{"type":"map","key":{},"value":{"type":"long"}},"logSamples":{"type":"list","member":{"type":"structure","members":{"timestamp":{"type":"long"},"message":{}}}},"patternTokens":{"type":"list","member":{"type":"structure","members":{"dynamicTokenPosition":{"type":"integer"},"isDynamic":{"type":"boolean"},"tokenString":{},"enumerations":{"type":"map","key":{},"value":{"type":"long"}}}}},"logGroupArnList":{"shape":"Sp"},"suppressed":{"type":"boolean"},"suppressedDate":{"type":"long"},"suppressedUntil":{"type":"long"},"isPatternLevelSuppression":{"type":"boolean"}}}},"nextToken":{}}}},"ListLogAnomalyDetectors":{"input":{"type":"structure","members":{"filterLogGroupArn":{},"limit":{"type":"integer"},"nextToken":{}}},"output":{"type":"structure","members":{"anomalyDetectors":{"type":"list","member":{"type":"structure","members":{"anomalyDetectorArn":{},"detectorName":{},"logGroupArnList":{"shape":"Sp"},"evaluationFrequency":{},"filterPattern":{},"anomalyDetectorStatus":{},"kmsKeyId":{},"creationTimeStamp":{"type":"long"},"lastModifiedTimeStamp":{"type":"long"},"anomalyVisibilityTime":{"type":"long"}}}},"nextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sa"}}}},"ListTagsLogGroup":{"input":{"type":"structure","required":["logGroupName"],"members":{"logGroupName":{}},"deprecated":true,"deprecatedMessage":"Please use the generic tagging API model ListTagsForResourceRequest and ListTagsForResourceResponse"},"output":{"type":"structure","members":{"tags":{"shape":"Sa"}},"deprecated":true,"deprecatedMessage":"Please use the generic tagging API model ListTagsForResourceRequest and ListTagsForResourceResponse"},"deprecated":true,"deprecatedMessage":"Please use the generic tagging API ListTagsForResource"},"PutAccountPolicy":{"input":{"type":"structure","required":["policyName","policyDocument","policyType"],"members":{"policyName":{},"policyDocument":{},"policyType":{},"scope":{},"selectionCriteria":{}}},"output":{"type":"structure","members":{"accountPolicy":{"shape":"S1t"}}}},"PutDataProtectionPolicy":{"input":{"type":"structure","required":["logGroupIdentifier","policyDocument"],"members":{"logGroupIdentifier":{},"policyDocument":{}}},"output":{"type":"structure","members":{"logGroupIdentifier":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}}},"PutDeliveryDestination":{"input":{"type":"structure","required":["name","deliveryDestinationConfiguration"],"members":{"name":{},"outputFormat":{},"deliveryDestinationConfiguration":{"shape":"S27"},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"deliveryDestination":{"shape":"S25"}}}},"PutDeliveryDestinationPolicy":{"input":{"type":"structure","required":["deliveryDestinationName","deliveryDestinationPolicy"],"members":{"deliveryDestinationName":{},"deliveryDestinationPolicy":{}}},"output":{"type":"structure","members":{"policy":{"shape":"S54"}}}},"PutDeliverySource":{"input":{"type":"structure","required":["name","resourceArn","logType"],"members":{"name":{},"resourceArn":{},"logType":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"deliverySource":{"shape":"S2b"}}}},"PutDestination":{"input":{"type":"structure","required":["destinationName","targetArn","roleArn"],"members":{"destinationName":{},"targetArn":{},"roleArn":{},"tags":{"shape":"Sa"}}},"output":{"type":"structure","members":{"destination":{"shape":"S2i"}}}},"PutDestinationPolicy":{"input":{"type":"structure","required":["destinationName","accessPolicy"],"members":{"destinationName":{},"accessPolicy":{},"forceUpdate":{"type":"boolean"}}}},"PutLogEvents":{"input":{"type":"structure","required":["logGroupName","logStreamName","logEvents"],"members":{"logGroupName":{},"logStreamName":{},"logEvents":{"type":"list","member":{"type":"structure","required":["timestamp","message"],"members":{"timestamp":{"type":"long"},"message":{}}}},"sequenceToken":{}}},"output":{"type":"structure","members":{"nextSequenceToken":{},"rejectedLogEventsInfo":{"type":"structure","members":{"tooNewLogEventStartIndex":{"type":"integer"},"tooOldLogEventEndIndex":{"type":"integer"},"expiredLogEventEndIndex":{"type":"integer"}}}}}},"PutMetricFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","metricTransformations"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"metricTransformations":{"shape":"S3j"}}}},"PutQueryDefinition":{"input":{"type":"structure","required":["name","queryString"],"members":{"name":{},"queryDefinitionId":{},"logGroupNames":{"shape":"S45"},"queryString":{},"clientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"queryDefinitionId":{}}}},"PutResourcePolicy":{"input":{"type":"structure","members":{"policyName":{},"policyDocument":{}}},"output":{"type":"structure","members":{"resourcePolicy":{"shape":"S49"}}}},"PutRetentionPolicy":{"input":{"type":"structure","required":["logGroupName","retentionInDays"],"members":{"logGroupName":{},"retentionInDays":{"type":"integer"}}}},"PutSubscriptionFilter":{"input":{"type":"structure","required":["logGroupName","filterName","filterPattern","destinationArn"],"members":{"logGroupName":{},"filterName":{},"filterPattern":{},"destinationArn":{},"roleArn":{},"distribution":{}}}},"StartLiveTail":{"input":{"type":"structure","required":["logGroupIdentifiers"],"members":{"logGroupIdentifiers":{"shape":"S7s"},"logStreamNames":{"shape":"S4j"},"logStreamNamePrefixes":{"shape":"S4j"},"logEventFilterPattern":{}}},"output":{"type":"structure","members":{"responseStream":{"type":"structure","members":{"sessionStart":{"type":"structure","members":{"requestId":{},"sessionId":{},"logGroupIdentifiers":{"shape":"S7s"},"logStreamNames":{"shape":"S4j"},"logStreamNamePrefixes":{"shape":"S4j"},"logEventFilterPattern":{}},"event":true},"sessionUpdate":{"type":"structure","members":{"sessionMetadata":{"type":"structure","members":{"sampled":{"type":"boolean"}}},"sessionResults":{"type":"list","member":{"type":"structure","members":{"logStreamName":{},"logGroupIdentifier":{},"message":{},"timestamp":{"type":"long"},"ingestionTime":{"type":"long"}}}}},"event":true},"SessionTimeoutException":{"type":"structure","members":{"message":{}},"exception":true},"SessionStreamingException":{"type":"structure","members":{"message":{}},"exception":true}},"eventstream":true}}},"endpoint":{"hostPrefix":"streaming-"}},"StartQuery":{"input":{"type":"structure","required":["startTime","endTime","queryString"],"members":{"logGroupName":{},"logGroupNames":{"shape":"S45"},"logGroupIdentifiers":{"type":"list","member":{}},"startTime":{"type":"long"},"endTime":{"type":"long"},"queryString":{},"limit":{"type":"integer"}}},"output":{"type":"structure","members":{"queryId":{}}}},"StopQuery":{"input":{"type":"structure","required":["queryId"],"members":{"queryId":{}}},"output":{"type":"structure","members":{"success":{"type":"boolean"}}}},"TagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"shape":"Sa"}},"deprecated":true,"deprecatedMessage":"Please use the generic tagging API model TagResourceRequest"},"deprecated":true,"deprecatedMessage":"Please use the generic tagging API TagResource"},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sa"}}}},"TestMetricFilter":{"input":{"type":"structure","required":["filterPattern","logEventMessages"],"members":{"filterPattern":{},"logEventMessages":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"matches":{"type":"list","member":{"type":"structure","members":{"eventNumber":{"type":"long"},"eventMessage":{},"extractedValues":{"type":"map","key":{},"value":{}}}}}}}},"UntagLogGroup":{"input":{"type":"structure","required":["logGroupName","tags"],"members":{"logGroupName":{},"tags":{"type":"list","member":{}}},"deprecated":true,"deprecatedMessage":"Please use the generic tagging API model UntagResourceRequest"},"deprecated":true,"deprecatedMessage":"Please use the generic tagging API UntagResource"},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}}},"UpdateAnomaly":{"input":{"type":"structure","required":["anomalyDetectorArn"],"members":{"anomalyId":{},"patternId":{},"anomalyDetectorArn":{},"suppressionType":{},"suppressionPeriod":{"type":"structure","members":{"value":{"type":"integer"},"suppressionUnit":{}}}}}},"UpdateLogAnomalyDetector":{"input":{"type":"structure","required":["anomalyDetectorArn","enabled"],"members":{"anomalyDetectorArn":{},"evaluationFrequency":{},"filterPattern":{},"anomalyVisibilityTime":{"type":"long"},"enabled":{"type":"boolean"}}}}},"shapes":{"Sa":{"type":"map","key":{},"value":{}},"Se":{"type":"structure","members":{"id":{},"arn":{},"deliverySourceName":{},"deliveryDestinationArn":{},"deliveryDestinationType":{},"tags":{"shape":"Sa"}}},"Sp":{"type":"list","member":{}},"S1p":{"type":"list","member":{}},"S1t":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"},"policyType":{},"scope":{},"selectionCriteria":{},"accountId":{}}},"S25":{"type":"structure","members":{"name":{},"arn":{},"deliveryDestinationType":{},"outputFormat":{},"deliveryDestinationConfiguration":{"shape":"S27"},"tags":{"shape":"Sa"}}},"S27":{"type":"structure","required":["destinationResourceArn"],"members":{"destinationResourceArn":{}}},"S2b":{"type":"structure","members":{"name":{},"arn":{},"resourceArns":{"type":"list","member":{}},"service":{},"logType":{},"tags":{"shape":"Sa"}}},"S2i":{"type":"structure","members":{"destinationName":{},"targetArn":{},"roleArn":{},"accessPolicy":{},"arn":{},"creationTime":{"type":"long"}}},"S3j":{"type":"list","member":{"type":"structure","required":["metricName","metricNamespace","metricValue"],"members":{"metricName":{},"metricNamespace":{},"metricValue":{},"defaultValue":{"type":"double"},"dimensions":{"type":"map","key":{},"value":{}},"unit":{}}}},"S45":{"type":"list","member":{}},"S49":{"type":"structure","members":{"policyName":{},"policyDocument":{},"lastUpdatedTime":{"type":"long"}}},"S4j":{"type":"list","member":{}},"S54":{"type":"structure","members":{"deliveryDestinationPolicy":{}}},"S7s":{"type":"list","member":{}}}}

/***/ }),
/* 551 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDeliveries":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"deliveries"},"DescribeDeliveryDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"deliveryDestinations"},"DescribeDeliverySources":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"deliverySources"},"DescribeDestinations":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"destinations"},"DescribeLogGroups":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logGroups"},"DescribeLogStreams":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"logStreams"},"DescribeMetricFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"metricFilters"},"DescribeSubscriptionFilters":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"subscriptionFilters"},"FilterLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":["events","searchedLogStreams"]},"GetLogEvents":{"input_token":"nextToken","limit_key":"limit","output_token":"nextForwardToken","result_key":"events"},"ListAnomalies":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"anomalies"},"ListLogAnomalyDetectors":{"input_token":"nextToken","limit_key":"limit","output_token":"nextToken","result_key":"anomalyDetectors"}}}

/***/ }),
/* 552 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-12-12","endpointPrefix":"machinelearning","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Machine Learning","serviceId":"Machine Learning","signatureVersion":"v4","targetPrefix":"AmazonML_20141212","uid":"machinelearning-2014-12-12"},"operations":{"AddTags":{"input":{"type":"structure","required":["Tags","ResourceId","ResourceType"],"members":{"Tags":{"shape":"S2"},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"CreateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","MLModelId","BatchPredictionDataSourceId","OutputUri"],"members":{"BatchPredictionId":{},"BatchPredictionName":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"OutputUri":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"CreateDataSourceFromRDS":{"input":{"type":"structure","required":["DataSourceId","RDSData","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"RDSData":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation","ResourceRole","ServiceRole","SubnetId","SecurityGroupIds"],"members":{"DatabaseInformation":{"shape":"Sf"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{"type":"string","sensitive":true}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{},"ResourceRole":{},"ServiceRole":{},"SubnetId":{},"SecurityGroupIds":{"type":"list","member":{}}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromRedshift":{"input":{"type":"structure","required":["DataSourceId","DataSpec","RoleARN"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DatabaseInformation","SelectSqlQuery","DatabaseCredentials","S3StagingLocation"],"members":{"DatabaseInformation":{"shape":"Sy"},"SelectSqlQuery":{},"DatabaseCredentials":{"type":"structure","required":["Username","Password"],"members":{"Username":{},"Password":{"type":"string","sensitive":true}}},"S3StagingLocation":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaUri":{}}},"RoleARN":{},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateDataSourceFromS3":{"input":{"type":"structure","required":["DataSourceId","DataSpec"],"members":{"DataSourceId":{},"DataSourceName":{},"DataSpec":{"type":"structure","required":["DataLocationS3"],"members":{"DataLocationS3":{},"DataRearrangement":{},"DataSchema":{},"DataSchemaLocationS3":{}}},"ComputeStatistics":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"CreateEvaluation":{"input":{"type":"structure","required":["EvaluationId","MLModelId","EvaluationDataSourceId"],"members":{"EvaluationId":{},"EvaluationName":{},"MLModelId":{},"EvaluationDataSourceId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"CreateMLModel":{"input":{"type":"structure","required":["MLModelId","MLModelType","TrainingDataSourceId"],"members":{"MLModelId":{},"MLModelName":{},"MLModelType":{},"Parameters":{"shape":"S1d"},"TrainingDataSourceId":{},"Recipe":{},"RecipeUri":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"CreateRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"DeleteDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"DeleteEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"DeleteMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{}}}},"DeleteRealtimeEndpoint":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{}}},"output":{"type":"structure","members":{"MLModelId":{},"RealtimeEndpointInfo":{"shape":"S1j"}}}},"DeleteTags":{"input":{"type":"structure","required":["TagKeys","ResourceId","ResourceType"],"members":{"TagKeys":{"type":"list","member":{}},"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{}}}},"DescribeBatchPredictions":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"NextToken":{}}}},"DescribeDataSources":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeEvaluations":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMLModels":{"input":{"type":"structure","members":{"FilterVariable":{},"EQ":{},"GT":{},"LT":{},"GE":{},"LE":{},"NE":{},"Prefix":{},"SortOrder":{},"NextToken":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"type":"list","member":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"Algorithm":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeTags":{"input":{"type":"structure","required":["ResourceId","ResourceType"],"members":{"ResourceId":{},"ResourceType":{}}},"output":{"type":"structure","members":{"ResourceId":{},"ResourceType":{},"Tags":{"shape":"S2"}}}},"GetBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId"],"members":{"BatchPredictionId":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{},"MLModelId":{},"BatchPredictionDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"OutputUri":{},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"TotalRecordCount":{"type":"long"},"InvalidRecordCount":{"type":"long"}}}},"GetDataSource":{"input":{"type":"structure","required":["DataSourceId"],"members":{"DataSourceId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"DataSourceId":{},"DataLocationS3":{},"DataRearrangement":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"DataSizeInBytes":{"type":"long"},"NumberOfFiles":{"type":"long"},"Name":{},"Status":{},"LogUri":{},"Message":{},"RedshiftMetadata":{"shape":"S2i"},"RDSMetadata":{"shape":"S2j"},"RoleARN":{},"ComputeStatistics":{"type":"boolean"},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"DataSourceSchema":{}}}},"GetEvaluation":{"input":{"type":"structure","required":["EvaluationId"],"members":{"EvaluationId":{}}},"output":{"type":"structure","members":{"EvaluationId":{},"MLModelId":{},"EvaluationDataSourceId":{},"InputDataLocationS3":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"PerformanceMetrics":{"shape":"S2q"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"}}}},"GetMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"Verbose":{"type":"boolean"}}},"output":{"type":"structure","members":{"MLModelId":{},"TrainingDataSourceId":{},"CreatedByIamUser":{},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Name":{},"Status":{},"SizeInBytes":{"type":"long"},"EndpointInfo":{"shape":"S1j"},"TrainingParameters":{"shape":"S1d"},"InputDataLocationS3":{},"MLModelType":{},"ScoreThreshold":{"type":"float"},"ScoreThresholdLastUpdatedAt":{"type":"timestamp"},"LogUri":{},"Message":{},"ComputeTime":{"type":"long"},"FinishedAt":{"type":"timestamp"},"StartedAt":{"type":"timestamp"},"Recipe":{},"Schema":{}}}},"Predict":{"input":{"type":"structure","required":["MLModelId","Record","PredictEndpoint"],"members":{"MLModelId":{},"Record":{"type":"map","key":{},"value":{}},"PredictEndpoint":{}}},"output":{"type":"structure","members":{"Prediction":{"type":"structure","members":{"predictedLabel":{},"predictedValue":{"type":"float"},"predictedScores":{"type":"map","key":{},"value":{"type":"float"}},"details":{"type":"map","key":{},"value":{}}}}}}},"UpdateBatchPrediction":{"input":{"type":"structure","required":["BatchPredictionId","BatchPredictionName"],"members":{"BatchPredictionId":{},"BatchPredictionName":{}}},"output":{"type":"structure","members":{"BatchPredictionId":{}}}},"UpdateDataSource":{"input":{"type":"structure","required":["DataSourceId","DataSourceName"],"members":{"DataSourceId":{},"DataSourceName":{}}},"output":{"type":"structure","members":{"DataSourceId":{}}}},"UpdateEvaluation":{"input":{"type":"structure","required":["EvaluationId","EvaluationName"],"members":{"EvaluationId":{},"EvaluationName":{}}},"output":{"type":"structure","members":{"EvaluationId":{}}}},"UpdateMLModel":{"input":{"type":"structure","required":["MLModelId"],"members":{"MLModelId":{},"MLModelName":{},"ScoreThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"MLModelId":{}}}}},"shapes":{"S2":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","required":["InstanceIdentifier","DatabaseName"],"members":{"InstanceIdentifier":{},"DatabaseName":{}}},"Sy":{"type":"structure","required":["DatabaseName","ClusterIdentifier"],"members":{"DatabaseName":{},"ClusterIdentifier":{}}},"S1d":{"type":"map","key":{},"value":{}},"S1j":{"type":"structure","members":{"PeakRequestsPerSecond":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"EndpointUrl":{},"EndpointStatus":{}}},"S2i":{"type":"structure","members":{"RedshiftDatabase":{"shape":"Sy"},"DatabaseUserName":{},"SelectSqlQuery":{}}},"S2j":{"type":"structure","members":{"Database":{"shape":"Sf"},"DatabaseUserName":{},"SelectSqlQuery":{},"ResourceRole":{},"ServiceRole":{},"DataPipelineId":{}}},"S2q":{"type":"structure","members":{"Properties":{"type":"map","key":{},"value":{}}}}}}

/***/ }),
/* 553 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeBatchPredictions":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeDataSources":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeEvaluations":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"},"DescribeMLModels":{"input_token":"NextToken","limit_key":"Limit","output_token":"NextToken","result_key":"Results"}}}

/***/ }),
/* 554 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DataSourceAvailable":{"delay":30,"operation":"DescribeDataSources","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"MLModelAvailable":{"delay":30,"operation":"DescribeMLModels","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"EvaluationAvailable":{"delay":30,"operation":"DescribeEvaluations","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]},"BatchPredictionAvailable":{"delay":30,"operation":"DescribeBatchPredictions","maxAttempts":60,"acceptors":[{"expected":"COMPLETED","matcher":"pathAll","state":"success","argument":"Results[].Status"},{"expected":"FAILED","matcher":"pathAny","state":"failure","argument":"Results[].Status"}]}}}

/***/ }),
/* 555 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-09-17","endpointPrefix":"catalog.marketplace","jsonVersion":"1.1","protocol":"rest-json","serviceAbbreviation":"AWS Marketplace Catalog","serviceFullName":"AWS Marketplace Catalog Service","serviceId":"Marketplace Catalog","signatureVersion":"v4","signingName":"aws-marketplace","uid":"marketplace-catalog-2018-09-17"},"operations":{"BatchDescribeEntities":{"http":{"requestUri":"/BatchDescribeEntities"},"input":{"type":"structure","required":["EntityRequestList"],"members":{"EntityRequestList":{"type":"list","member":{"type":"structure","required":["Catalog","EntityId"],"members":{"Catalog":{},"EntityId":{}}}}}},"output":{"type":"structure","members":{"EntityDetails":{"type":"map","key":{},"value":{"type":"structure","members":{"EntityType":{},"EntityArn":{},"EntityIdentifier":{},"LastModifiedDate":{},"DetailsDocument":{"shape":"Sd"}}}},"Errors":{"type":"map","key":{},"value":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}}}}},"CancelChangeSet":{"http":{"method":"PATCH","requestUri":"/CancelChangeSet"},"input":{"type":"structure","required":["Catalog","ChangeSetId"],"members":{"Catalog":{"location":"querystring","locationName":"catalog"},"ChangeSetId":{"location":"querystring","locationName":"changeSetId"}}},"output":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{}}}},"DeleteResourcePolicy":{"http":{"method":"DELETE","requestUri":"/DeleteResourcePolicy"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{}}},"DescribeChangeSet":{"http":{"method":"GET","requestUri":"/DescribeChangeSet"},"input":{"type":"structure","required":["Catalog","ChangeSetId"],"members":{"Catalog":{"location":"querystring","locationName":"catalog"},"ChangeSetId":{"location":"querystring","locationName":"changeSetId"}}},"output":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{},"ChangeSetName":{},"Intent":{},"StartTime":{},"EndTime":{},"Status":{},"FailureCode":{},"FailureDescription":{},"ChangeSet":{"type":"list","member":{"type":"structure","members":{"ChangeType":{},"Entity":{"shape":"Sy"},"Details":{},"DetailsDocument":{"shape":"Sd"},"ErrorDetailList":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"ErrorMessage":{}}}},"ChangeName":{}}}}}}},"DescribeEntity":{"http":{"method":"GET","requestUri":"/DescribeEntity"},"input":{"type":"structure","required":["Catalog","EntityId"],"members":{"Catalog":{"location":"querystring","locationName":"catalog"},"EntityId":{"location":"querystring","locationName":"entityId"}}},"output":{"type":"structure","members":{"EntityType":{},"EntityIdentifier":{},"EntityArn":{},"LastModifiedDate":{},"Details":{},"DetailsDocument":{"shape":"Sd"}}}},"GetResourcePolicy":{"http":{"method":"GET","requestUri":"/GetResourcePolicy"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{"location":"querystring","locationName":"resourceArn"}}},"output":{"type":"structure","members":{"Policy":{}}}},"ListChangeSets":{"http":{"requestUri":"/ListChangeSets"},"input":{"type":"structure","required":["Catalog"],"members":{"Catalog":{},"FilterList":{"shape":"S1a"},"Sort":{"shape":"S1f"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ChangeSetSummaryList":{"type":"list","member":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{},"ChangeSetName":{},"StartTime":{},"EndTime":{},"Status":{},"EntityIdList":{"type":"list","member":{}},"FailureCode":{}}}},"NextToken":{}}}},"ListEntities":{"http":{"requestUri":"/ListEntities"},"input":{"type":"structure","required":["Catalog","EntityType"],"members":{"Catalog":{},"EntityType":{},"FilterList":{"shape":"S1a"},"Sort":{"shape":"S1f"},"NextToken":{},"MaxResults":{"type":"integer"},"OwnershipType":{},"EntityTypeFilters":{"type":"structure","members":{"DataProductFilters":{"type":"structure","members":{"EntityId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"ProductTitle":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"Visibility":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"LastModifiedDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}}}},"SaaSProductFilters":{"type":"structure","members":{"EntityId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"ProductTitle":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"Visibility":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"LastModifiedDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}}}},"AmiProductFilters":{"type":"structure","members":{"EntityId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"LastModifiedDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}},"ProductTitle":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"Visibility":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}}}},"OfferFilters":{"type":"structure","members":{"EntityId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"Name":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"ProductId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"ResaleAuthorizationId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"ReleaseDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}},"AvailabilityEndDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}},"BuyerAccounts":{"type":"structure","members":{"WildCardValue":{}}},"State":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"Targeting":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"LastModifiedDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}}}},"ContainerProductFilters":{"type":"structure","members":{"EntityId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"LastModifiedDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}},"ProductTitle":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"Visibility":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}}}},"ResaleAuthorizationFilters":{"type":"structure","members":{"EntityId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"Name":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"ProductId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"CreatedDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}},"ValueList":{"type":"list","member":{}}}},"AvailabilityEndDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}},"ValueList":{"type":"list","member":{}}}},"ManufacturerAccountId":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"ProductName":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"ManufacturerLegalName":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"ResellerAccountID":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"ResellerLegalName":{"type":"structure","members":{"ValueList":{"type":"list","member":{}},"WildCardValue":{}}},"Status":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"OfferExtendedStatus":{"type":"structure","members":{"ValueList":{"type":"list","member":{}}}},"LastModifiedDate":{"type":"structure","members":{"DateRange":{"type":"structure","members":{"AfterValue":{},"BeforeValue":{}}}}}}}},"union":true},"EntityTypeSort":{"type":"structure","members":{"DataProductSort":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}},"SaaSProductSort":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}},"AmiProductSort":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}},"OfferSort":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}},"ContainerProductSort":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}},"ResaleAuthorizationSort":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}}},"union":true}}},"output":{"type":"structure","members":{"EntitySummaryList":{"type":"list","member":{"type":"structure","members":{"Name":{},"EntityType":{},"EntityId":{},"EntityArn":{},"LastModifiedDate":{},"Visibility":{},"AmiProductSummary":{"type":"structure","members":{"ProductTitle":{},"Visibility":{}}},"ContainerProductSummary":{"type":"structure","members":{"ProductTitle":{},"Visibility":{}}},"DataProductSummary":{"type":"structure","members":{"ProductTitle":{},"Visibility":{}}},"SaaSProductSummary":{"type":"structure","members":{"ProductTitle":{},"Visibility":{}}},"OfferSummary":{"type":"structure","members":{"Name":{},"ProductId":{},"ResaleAuthorizationId":{},"ReleaseDate":{},"AvailabilityEndDate":{},"BuyerAccounts":{"type":"list","member":{}},"State":{},"Targeting":{"type":"list","member":{}}}},"ResaleAuthorizationSummary":{"type":"structure","members":{"Name":{},"ProductId":{},"ProductName":{},"ManufacturerAccountId":{},"ManufacturerLegalName":{},"ResellerAccountID":{},"ResellerLegalName":{},"Status":{},"OfferExtendedStatus":{},"CreatedDate":{},"AvailabilityEndDate":{}}}}}},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/ListTagsForResource"},"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"ResourceArn":{},"Tags":{"shape":"S5y"}}}},"PutResourcePolicy":{"http":{"requestUri":"/PutResourcePolicy"},"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"StartChangeSet":{"http":{"requestUri":"/StartChangeSet"},"input":{"type":"structure","required":["Catalog","ChangeSet"],"members":{"Catalog":{},"ChangeSet":{"type":"list","member":{"type":"structure","required":["ChangeType","Entity"],"members":{"ChangeType":{},"Entity":{"shape":"Sy"},"EntityTags":{"shape":"S5y"},"Details":{},"DetailsDocument":{"shape":"Sd"},"ChangeName":{}}}},"ChangeSetName":{},"ClientRequestToken":{"idempotencyToken":true},"ChangeSetTags":{"shape":"S5y"},"Intent":{}}},"output":{"type":"structure","members":{"ChangeSetId":{},"ChangeSetArn":{}}}},"TagResource":{"http":{"requestUri":"/TagResource"},"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S5y"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/UntagResource"},"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"Sd":{"type":"structure","members":{},"document":true},"Sy":{"type":"structure","required":["Type"],"members":{"Type":{},"Identifier":{}}},"S1a":{"type":"list","member":{"type":"structure","members":{"Name":{},"ValueList":{"type":"list","member":{}}}}},"S1f":{"type":"structure","members":{"SortBy":{},"SortOrder":{}}},"S5y":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 556 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListChangeSets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ChangeSetSummaryList"},"ListEntities":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"EntitySummaryList"}}}

/***/ }),
/* 557 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-07-01","endpointPrefix":"marketplacecommerceanalytics","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Marketplace Commerce Analytics","serviceId":"Marketplace Commerce Analytics","signatureVersion":"v4","signingName":"marketplacecommerceanalytics","targetPrefix":"MarketplaceCommerceAnalytics20150701","uid":"marketplacecommerceanalytics-2015-07-01"},"operations":{"GenerateDataSet":{"input":{"type":"structure","required":["dataSetType","dataSetPublicationDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"dataSetPublicationDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}}},"output":{"type":"structure","members":{"dataSetRequestId":{}}}},"StartSupportDataExport":{"input":{"type":"structure","required":["dataSetType","fromDate","roleNameArn","destinationS3BucketName","snsTopicArn"],"members":{"dataSetType":{},"fromDate":{"type":"timestamp"},"roleNameArn":{},"destinationS3BucketName":{},"destinationS3Prefix":{},"snsTopicArn":{},"customerDefinedValues":{"shape":"S8"}},"deprecated":true,"deprecatedMessage":"This target has been deprecated. As of December 2022 Product Support Connection is no longer supported."},"output":{"type":"structure","members":{"dataSetRequestId":{}},"deprecated":true,"deprecatedMessage":"This target has been deprecated. As of December 2022 Product Support Connection is no longer supported."},"deprecated":true,"deprecatedMessage":"This target has been deprecated. As of December 2022 Product Support Connection is no longer supported."}},"shapes":{"S8":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 558 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 559 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-09-01","endpointPrefix":"data.mediastore","protocol":"rest-json","serviceAbbreviation":"MediaStore Data","serviceFullName":"AWS Elemental MediaStore Data Plane","serviceId":"MediaStore Data","signatureVersion":"v4","signingName":"mediastore","uid":"mediastore-data-2017-09-01"},"operations":{"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{}}},"DescribeObject":{"http":{"method":"HEAD","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"}}},"output":{"type":"structure","members":{"ETag":{"location":"header","locationName":"ETag"},"ContentType":{"location":"header","locationName":"Content-Type"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"}}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Path"],"members":{"Path":{"location":"uri","locationName":"Path"},"Range":{"location":"header","locationName":"Range"}}},"output":{"type":"structure","required":["StatusCode"],"members":{"Body":{"shape":"Se"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentType":{"location":"header","locationName":"Content-Type"},"ETag":{"location":"header","locationName":"ETag"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"StatusCode":{"location":"statusCode","type":"integer"}},"payload":"Body"}},"ListItems":{"http":{"method":"GET"},"input":{"type":"structure","members":{"Path":{"location":"querystring","locationName":"Path"},"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"ETag":{},"LastModified":{"type":"timestamp"},"ContentType":{},"ContentLength":{"type":"long"}}}},"NextToken":{}}}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Path+}"},"input":{"type":"structure","required":["Body","Path"],"members":{"Body":{"shape":"Se"},"Path":{"location":"uri","locationName":"Path"},"ContentType":{"location":"header","locationName":"Content-Type"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"UploadAvailability":{"location":"header","locationName":"x-amz-upload-availability"}},"payload":"Body"},"output":{"type":"structure","members":{"ContentSHA256":{},"ETag":{},"StorageClass":{}}},"authtype":"v4-unsigned-body"}},"shapes":{"Se":{"type":"blob","streaming":true}}}

/***/ }),
/* 560 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListItems":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-06-05","endpointPrefix":"mobileanalytics","serviceFullName":"Amazon Mobile Analytics","serviceId":"Mobile Analytics","signatureVersion":"v4","protocol":"rest-json"},"operations":{"PutEvents":{"http":{"requestUri":"/2014-06-05/events","responseCode":202},"input":{"type":"structure","required":["events","clientContext"],"members":{"events":{"type":"list","member":{"type":"structure","required":["eventType","timestamp"],"members":{"eventType":{},"timestamp":{},"session":{"type":"structure","members":{"id":{},"duration":{"type":"long"},"startTimestamp":{},"stopTimestamp":{}}},"version":{},"attributes":{"type":"map","key":{},"value":{}},"metrics":{"type":"map","key":{},"value":{"type":"double"}}}}},"clientContext":{"location":"header","locationName":"x-amz-Client-Context"},"clientContextEncoding":{"location":"header","locationName":"x-amz-Client-Context-Encoding"}}}}},"shapes":{}}

/***/ }),
/* 562 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-08-01","endpointPrefix":"monitoring","protocol":"query","serviceAbbreviation":"CloudWatch","serviceFullName":"Amazon CloudWatch","serviceId":"CloudWatch","signatureVersion":"v4","uid":"monitoring-2010-08-01","xmlNamespace":"http://monitoring.amazonaws.com/doc/2010-08-01/"},"operations":{"DeleteAlarms":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DeleteAnomalyDetector":{"input":{"type":"structure","members":{"Namespace":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"MetricName":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Dimensions":{"shape":"S7","deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Stat":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"SingleMetricAnomalyDetector":{"shape":"Sc"},"MetricMathAnomalyDetector":{"shape":"Se"}}},"output":{"resultWrapper":"DeleteAnomalyDetectorResult","type":"structure","members":{}}},"DeleteDashboards":{"input":{"type":"structure","required":["DashboardNames"],"members":{"DashboardNames":{"type":"list","member":{}}}},"output":{"resultWrapper":"DeleteDashboardsResult","type":"structure","members":{}}},"DeleteInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Sw"}}},"output":{"resultWrapper":"DeleteInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sz"}}}},"DeleteMetricStream":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"resultWrapper":"DeleteMetricStreamResult","type":"structure","members":{}}},"DescribeAlarmHistory":{"input":{"type":"structure","members":{"AlarmName":{},"AlarmTypes":{"shape":"S19"},"HistoryItemType":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"NextToken":{},"ScanBy":{}}},"output":{"resultWrapper":"DescribeAlarmHistoryResult","type":"structure","members":{"AlarmHistoryItems":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmType":{},"Timestamp":{"type":"timestamp"},"HistoryItemType":{},"HistorySummary":{},"HistoryData":{}}}},"NextToken":{}}}},"DescribeAlarms":{"input":{"type":"structure","members":{"AlarmNames":{"shape":"S2"},"AlarmNamePrefix":{},"AlarmTypes":{"shape":"S19"},"ChildrenOfAlarmName":{},"ParentsOfAlarmName":{},"StateValue":{},"ActionPrefix":{},"MaxRecords":{"type":"integer"},"NextToken":{}}},"output":{"resultWrapper":"DescribeAlarmsResult","type":"structure","members":{"CompositeAlarms":{"type":"list","member":{"type":"structure","members":{"ActionsEnabled":{"type":"boolean"},"AlarmActions":{"shape":"S1t"},"AlarmArn":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"AlarmDescription":{},"AlarmName":{},"AlarmRule":{},"InsufficientDataActions":{"shape":"S1t"},"OKActions":{"shape":"S1t"},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"StateValue":{},"StateTransitionedTimestamp":{"type":"timestamp"},"ActionsSuppressedBy":{},"ActionsSuppressedReason":{},"ActionsSuppressor":{},"ActionsSuppressorWaitPeriod":{"type":"integer"},"ActionsSuppressorExtensionPeriod":{"type":"integer"}},"xmlOrder":["ActionsEnabled","AlarmActions","AlarmArn","AlarmConfigurationUpdatedTimestamp","AlarmDescription","AlarmName","AlarmRule","InsufficientDataActions","OKActions","StateReason","StateReasonData","StateUpdatedTimestamp","StateValue","StateTransitionedTimestamp","ActionsSuppressedBy","ActionsSuppressedReason","ActionsSuppressor","ActionsSuppressorWaitPeriod","ActionsSuppressorExtensionPeriod"]}},"MetricAlarms":{"shape":"S23"},"NextToken":{}}}},"DescribeAlarmsForMetric":{"input":{"type":"structure","required":["MetricName","Namespace"],"members":{"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{}}},"output":{"resultWrapper":"DescribeAlarmsForMetricResult","type":"structure","members":{"MetricAlarms":{"shape":"S23"}}}},"DescribeAnomalyDetectors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"AnomalyDetectorTypes":{"type":"list","member":{}}}},"output":{"resultWrapper":"DescribeAnomalyDetectorsResult","type":"structure","members":{"AnomalyDetectors":{"type":"list","member":{"type":"structure","members":{"Namespace":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.Namespace property."},"MetricName":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.MetricName property."},"Dimensions":{"shape":"S7","deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.Dimensions property."},"Stat":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector.Stat property."},"Configuration":{"shape":"S2n"},"StateValue":{},"MetricCharacteristics":{"shape":"S2s"},"SingleMetricAnomalyDetector":{"shape":"Sc"},"MetricMathAnomalyDetector":{"shape":"Se"}}}},"NextToken":{}}}},"DescribeInsightRules":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"DescribeInsightRulesResult","type":"structure","members":{"NextToken":{},"InsightRules":{"type":"list","member":{"type":"structure","required":["Name","State","Schema","Definition"],"members":{"Name":{},"State":{},"Schema":{},"Definition":{},"ManagedRule":{"type":"boolean"}}}}}}},"DisableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"DisableInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Sw"}}},"output":{"resultWrapper":"DisableInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sz"}}}},"EnableAlarmActions":{"input":{"type":"structure","required":["AlarmNames"],"members":{"AlarmNames":{"shape":"S2"}}}},"EnableInsightRules":{"input":{"type":"structure","required":["RuleNames"],"members":{"RuleNames":{"shape":"Sw"}}},"output":{"resultWrapper":"EnableInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sz"}}}},"GetDashboard":{"input":{"type":"structure","required":["DashboardName"],"members":{"DashboardName":{}}},"output":{"resultWrapper":"GetDashboardResult","type":"structure","members":{"DashboardArn":{},"DashboardBody":{},"DashboardName":{}}}},"GetInsightRuleReport":{"input":{"type":"structure","required":["RuleName","StartTime","EndTime","Period"],"members":{"RuleName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"MaxContributorCount":{"type":"integer"},"Metrics":{"type":"list","member":{}},"OrderBy":{}}},"output":{"resultWrapper":"GetInsightRuleReportResult","type":"structure","members":{"KeyLabels":{"type":"list","member":{}},"AggregationStatistic":{},"AggregateValue":{"type":"double"},"ApproximateUniqueCount":{"type":"long"},"Contributors":{"type":"list","member":{"type":"structure","required":["Keys","ApproximateAggregateValue","Datapoints"],"members":{"Keys":{"type":"list","member":{}},"ApproximateAggregateValue":{"type":"double"},"Datapoints":{"type":"list","member":{"type":"structure","required":["Timestamp","ApproximateValue"],"members":{"Timestamp":{"type":"timestamp"},"ApproximateValue":{"type":"double"}}}}}}},"MetricDatapoints":{"type":"list","member":{"type":"structure","required":["Timestamp"],"members":{"Timestamp":{"type":"timestamp"},"UniqueContributors":{"type":"double"},"MaxContributorValue":{"type":"double"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}}}}}},"GetMetricData":{"input":{"type":"structure","required":["MetricDataQueries","StartTime","EndTime"],"members":{"MetricDataQueries":{"shape":"Sf"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{},"ScanBy":{},"MaxDatapoints":{"type":"integer"},"LabelOptions":{"type":"structure","members":{"Timezone":{}}}}},"output":{"resultWrapper":"GetMetricDataResult","type":"structure","members":{"MetricDataResults":{"type":"list","member":{"type":"structure","members":{"Id":{},"Label":{},"Timestamps":{"type":"list","member":{"type":"timestamp"}},"Values":{"type":"list","member":{"type":"double"}},"StatusCode":{},"Messages":{"shape":"S47"}}}},"NextToken":{},"Messages":{"shape":"S47"}}}},"GetMetricStatistics":{"input":{"type":"structure","required":["Namespace","MetricName","StartTime","EndTime","Period"],"members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Period":{"type":"integer"},"Statistics":{"type":"list","member":{}},"ExtendedStatistics":{"type":"list","member":{}},"Unit":{}}},"output":{"resultWrapper":"GetMetricStatisticsResult","type":"structure","members":{"Label":{},"Datapoints":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"SampleCount":{"type":"double"},"Average":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"},"Unit":{},"ExtendedStatistics":{"type":"map","key":{},"value":{"type":"double"}}},"xmlOrder":["Timestamp","SampleCount","Average","Sum","Minimum","Maximum","Unit","ExtendedStatistics"]}}}}},"GetMetricStream":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"resultWrapper":"GetMetricStreamResult","type":"structure","members":{"Arn":{},"Name":{},"IncludeFilters":{"shape":"S4l"},"ExcludeFilters":{"shape":"S4l"},"FirehoseArn":{},"RoleArn":{},"State":{},"CreationDate":{"type":"timestamp"},"LastUpdateDate":{"type":"timestamp"},"OutputFormat":{},"StatisticsConfigurations":{"shape":"S4q"},"IncludeLinkedAccountsMetrics":{"type":"boolean"}}}},"GetMetricWidgetImage":{"input":{"type":"structure","required":["MetricWidget"],"members":{"MetricWidget":{},"OutputFormat":{}}},"output":{"resultWrapper":"GetMetricWidgetImageResult","type":"structure","members":{"MetricWidgetImage":{"type":"blob"}}}},"ListDashboards":{"input":{"type":"structure","members":{"DashboardNamePrefix":{},"NextToken":{}}},"output":{"resultWrapper":"ListDashboardsResult","type":"structure","members":{"DashboardEntries":{"type":"list","member":{"type":"structure","members":{"DashboardName":{},"DashboardArn":{},"LastModified":{"type":"timestamp"},"Size":{"type":"long"}}}},"NextToken":{}}}},"ListManagedInsightRules":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListManagedInsightRulesResult","type":"structure","members":{"ManagedRules":{"type":"list","member":{"type":"structure","members":{"TemplateName":{},"ResourceARN":{},"RuleState":{"type":"structure","required":["RuleName","State"],"members":{"RuleName":{},"State":{}}}}}},"NextToken":{}}}},"ListMetricStreams":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListMetricStreamsResult","type":"structure","members":{"NextToken":{},"Entries":{"type":"list","member":{"type":"structure","members":{"Arn":{},"CreationDate":{"type":"timestamp"},"LastUpdateDate":{"type":"timestamp"},"Name":{},"FirehoseArn":{},"State":{},"OutputFormat":{}}}}}}},"ListMetrics":{"input":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Value":{}}}},"NextToken":{},"RecentlyActive":{},"IncludeLinkedAccounts":{"type":"boolean"},"OwningAccount":{}}},"output":{"resultWrapper":"ListMetricsResult","type":"structure","members":{"Metrics":{"type":"list","member":{"shape":"Sj"}},"NextToken":{},"OwningAccounts":{"type":"list","member":{}}},"xmlOrder":["Metrics","NextToken","OwningAccounts"]}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"S5u"}}}},"PutAnomalyDetector":{"input":{"type":"structure","members":{"Namespace":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"MetricName":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Dimensions":{"shape":"S7","deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Stat":{"deprecated":true,"deprecatedMessage":"Use SingleMetricAnomalyDetector."},"Configuration":{"shape":"S2n"},"MetricCharacteristics":{"shape":"S2s"},"SingleMetricAnomalyDetector":{"shape":"Sc"},"MetricMathAnomalyDetector":{"shape":"Se"}}},"output":{"resultWrapper":"PutAnomalyDetectorResult","type":"structure","members":{}}},"PutCompositeAlarm":{"input":{"type":"structure","required":["AlarmName","AlarmRule"],"members":{"ActionsEnabled":{"type":"boolean"},"AlarmActions":{"shape":"S1t"},"AlarmDescription":{},"AlarmName":{},"AlarmRule":{},"InsufficientDataActions":{"shape":"S1t"},"OKActions":{"shape":"S1t"},"Tags":{"shape":"S5u"},"ActionsSuppressor":{},"ActionsSuppressorWaitPeriod":{"type":"integer"},"ActionsSuppressorExtensionPeriod":{"type":"integer"}}}},"PutDashboard":{"input":{"type":"structure","required":["DashboardName","DashboardBody"],"members":{"DashboardName":{},"DashboardBody":{}}},"output":{"resultWrapper":"PutDashboardResult","type":"structure","members":{"DashboardValidationMessages":{"type":"list","member":{"type":"structure","members":{"DataPath":{},"Message":{}}}}}}},"PutInsightRule":{"input":{"type":"structure","required":["RuleName","RuleDefinition"],"members":{"RuleName":{},"RuleState":{},"RuleDefinition":{},"Tags":{"shape":"S5u"}}},"output":{"resultWrapper":"PutInsightRuleResult","type":"structure","members":{}}},"PutManagedInsightRules":{"input":{"type":"structure","required":["ManagedRules"],"members":{"ManagedRules":{"type":"list","member":{"type":"structure","required":["TemplateName","ResourceARN"],"members":{"TemplateName":{},"ResourceARN":{},"Tags":{"shape":"S5u"}}}}}},"output":{"resultWrapper":"PutManagedInsightRulesResult","type":"structure","members":{"Failures":{"shape":"Sz"}}}},"PutMetricAlarm":{"input":{"type":"structure","required":["AlarmName","EvaluationPeriods","ComparisonOperator"],"members":{"AlarmName":{},"AlarmDescription":{},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S1t"},"AlarmActions":{"shape":"S1t"},"InsufficientDataActions":{"shape":"S1t"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"Sf"},"Tags":{"shape":"S5u"},"ThresholdMetricId":{}}}},"PutMetricData":{"input":{"type":"structure","required":["Namespace","MetricData"],"members":{"Namespace":{},"MetricData":{"type":"list","member":{"type":"structure","required":["MetricName"],"members":{"MetricName":{},"Dimensions":{"shape":"S7"},"Timestamp":{"type":"timestamp"},"Value":{"type":"double"},"StatisticValues":{"type":"structure","required":["SampleCount","Sum","Minimum","Maximum"],"members":{"SampleCount":{"type":"double"},"Sum":{"type":"double"},"Minimum":{"type":"double"},"Maximum":{"type":"double"}}},"Values":{"type":"list","member":{"type":"double"}},"Counts":{"type":"list","member":{"type":"double"}},"Unit":{},"StorageResolution":{"type":"integer"}}}}}},"requestcompression":{"encodings":["gzip"]}},"PutMetricStream":{"input":{"type":"structure","required":["Name","FirehoseArn","RoleArn","OutputFormat"],"members":{"Name":{},"IncludeFilters":{"shape":"S4l"},"ExcludeFilters":{"shape":"S4l"},"FirehoseArn":{},"RoleArn":{},"OutputFormat":{},"Tags":{"shape":"S5u"},"StatisticsConfigurations":{"shape":"S4q"},"IncludeLinkedAccountsMetrics":{"type":"boolean"}}},"output":{"resultWrapper":"PutMetricStreamResult","type":"structure","members":{"Arn":{}}}},"SetAlarmState":{"input":{"type":"structure","required":["AlarmName","StateValue","StateReason"],"members":{"AlarmName":{},"StateValue":{},"StateReason":{},"StateReasonData":{}}}},"StartMetricStreams":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S6p"}}},"output":{"resultWrapper":"StartMetricStreamsResult","type":"structure","members":{}}},"StopMetricStreams":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S6p"}}},"output":{"resultWrapper":"StopMetricStreamsResult","type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S5u"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}}},"shapes":{"S2":{"type":"list","member":{}},"S7":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}},"xmlOrder":["Name","Value"]}},"Sc":{"type":"structure","members":{"AccountId":{},"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"},"Stat":{}}},"Se":{"type":"structure","members":{"MetricDataQueries":{"shape":"Sf"}}},"Sf":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"MetricStat":{"type":"structure","required":["Metric","Period","Stat"],"members":{"Metric":{"shape":"Sj"},"Period":{"type":"integer"},"Stat":{},"Unit":{}}},"Expression":{},"Label":{},"ReturnData":{"type":"boolean"},"Period":{"type":"integer"},"AccountId":{}}}},"Sj":{"type":"structure","members":{"Namespace":{},"MetricName":{},"Dimensions":{"shape":"S7"}},"xmlOrder":["Namespace","MetricName","Dimensions"]},"Sw":{"type":"list","member":{}},"Sz":{"type":"list","member":{"type":"structure","members":{"FailureResource":{},"ExceptionType":{},"FailureCode":{},"FailureDescription":{}}}},"S19":{"type":"list","member":{}},"S1t":{"type":"list","member":{}},"S23":{"type":"list","member":{"type":"structure","members":{"AlarmName":{},"AlarmArn":{},"AlarmDescription":{},"AlarmConfigurationUpdatedTimestamp":{"type":"timestamp"},"ActionsEnabled":{"type":"boolean"},"OKActions":{"shape":"S1t"},"AlarmActions":{"shape":"S1t"},"InsufficientDataActions":{"shape":"S1t"},"StateValue":{},"StateReason":{},"StateReasonData":{},"StateUpdatedTimestamp":{"type":"timestamp"},"MetricName":{},"Namespace":{},"Statistic":{},"ExtendedStatistic":{},"Dimensions":{"shape":"S7"},"Period":{"type":"integer"},"Unit":{},"EvaluationPeriods":{"type":"integer"},"DatapointsToAlarm":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"TreatMissingData":{},"EvaluateLowSampleCountPercentile":{},"Metrics":{"shape":"Sf"},"ThresholdMetricId":{},"EvaluationState":{},"StateTransitionedTimestamp":{"type":"timestamp"}},"xmlOrder":["AlarmName","AlarmArn","AlarmDescription","AlarmConfigurationUpdatedTimestamp","ActionsEnabled","OKActions","AlarmActions","InsufficientDataActions","StateValue","StateReason","StateReasonData","StateUpdatedTimestamp","MetricName","Namespace","Statistic","Dimensions","Period","Unit","EvaluationPeriods","Threshold","ComparisonOperator","ExtendedStatistic","TreatMissingData","EvaluateLowSampleCountPercentile","DatapointsToAlarm","Metrics","ThresholdMetricId","EvaluationState","StateTransitionedTimestamp"]}},"S2n":{"type":"structure","members":{"ExcludedTimeRanges":{"type":"list","member":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}},"xmlOrder":["StartTime","EndTime"]}},"MetricTimezone":{}}},"S2s":{"type":"structure","members":{"PeriodicSpikes":{"type":"boolean"}}},"S47":{"type":"list","member":{"type":"structure","members":{"Code":{},"Value":{}}}},"S4l":{"type":"list","member":{"type":"structure","members":{"Namespace":{},"MetricNames":{"type":"list","member":{}}}}},"S4q":{"type":"list","member":{"type":"structure","required":["IncludeMetrics","AdditionalStatistics"],"members":{"IncludeMetrics":{"type":"list","member":{"type":"structure","required":["Namespace","MetricName"],"members":{"Namespace":{},"MetricName":{}}}},"AdditionalStatistics":{"type":"list","member":{}}}}},"S5u":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S6p":{"type":"list","member":{}}}}

/***/ }),
/* 563 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeAlarmHistory":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":"AlarmHistoryItems"},"DescribeAlarms":{"input_token":"NextToken","limit_key":"MaxRecords","output_token":"NextToken","result_key":["MetricAlarms","CompositeAlarms"]},"DescribeAlarmsForMetric":{"result_key":"MetricAlarms"},"DescribeAnomalyDetectors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AnomalyDetectors"},"DescribeInsightRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetMetricData":{"input_token":"NextToken","limit_key":"MaxDatapoints","output_token":"NextToken","result_key":["MetricDataResults","Messages"]},"ListDashboards":{"input_token":"NextToken","output_token":"NextToken","result_key":"DashboardEntries"},"ListManagedInsightRules":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListMetricStreams":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListMetrics":{"input_token":"NextToken","output_token":"NextToken","result_key":["Metrics","OwningAccounts"]}}}

/***/ }),
/* 564 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(MetricAlarms[]) > `0`","state":"success"}]},"CompositeAlarmExists":{"delay":5,"maxAttempts":40,"operation":"DescribeAlarms","acceptors":[{"matcher":"path","expected":true,"argument":"length(CompositeAlarms[]) > `0`","state":"success"}]}}}

/***/ }),
/* 565 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-01-17","endpointPrefix":"mturk-requester","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"Amazon MTurk","serviceFullName":"Amazon Mechanical Turk","serviceId":"MTurk","signatureVersion":"v4","targetPrefix":"MTurkRequesterServiceV20170117","uid":"mturk-requester-2017-01-17"},"operations":{"AcceptQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"IntegerValue":{"type":"integer"}}},"output":{"type":"structure","members":{}}},"ApproveAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{},"RequesterFeedback":{},"OverrideRejection":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"AssociateQualificationWithWorker":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{},"IntegerValue":{"type":"integer"},"SendNotification":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"CreateAdditionalAssignmentsForHIT":{"input":{"type":"structure","required":["HITId","NumberOfAdditionalAssignments"],"members":{"HITId":{},"NumberOfAdditionalAssignments":{"type":"integer"},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"CreateHIT":{"input":{"type":"structure","required":["LifetimeInSeconds","AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"MaxAssignments":{"type":"integer"},"AutoApprovalDelayInSeconds":{"type":"long"},"LifetimeInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"Question":{},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateHITType":{"input":{"type":"structure","required":["AssignmentDurationInSeconds","Reward","Title","Description"],"members":{"AutoApprovalDelayInSeconds":{"type":"long"},"AssignmentDurationInSeconds":{"type":"long"},"Reward":{},"Title":{},"Keywords":{},"Description":{},"QualificationRequirements":{"shape":"Si"}}},"output":{"type":"structure","members":{"HITTypeId":{}}},"idempotent":true},"CreateHITWithHITType":{"input":{"type":"structure","required":["HITTypeId","LifetimeInSeconds"],"members":{"HITTypeId":{},"MaxAssignments":{"type":"integer"},"LifetimeInSeconds":{"type":"long"},"Question":{},"RequesterAnnotation":{},"UniqueRequestToken":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"HITLayoutId":{},"HITLayoutParameters":{"shape":"Sw"}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}}},"CreateQualificationType":{"input":{"type":"structure","required":["Name","Description","QualificationTypeStatus"],"members":{"Name":{},"Keywords":{},"Description":{},"QualificationTypeStatus":{},"RetryDelayInSeconds":{"type":"long"},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}},"CreateWorkerBlock":{"input":{"type":"structure","required":["WorkerId","Reason"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"DeleteHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DeleteWorkerBlock":{"input":{"type":"structure","required":["WorkerId"],"members":{"WorkerId":{},"Reason":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"DisassociateQualificationFromWorker":{"input":{"type":"structure","required":["WorkerId","QualificationTypeId"],"members":{"WorkerId":{},"QualificationTypeId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"GetAccountBalance":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AvailableBalance":{},"OnHoldBalance":{}}},"idempotent":true},"GetAssignment":{"input":{"type":"structure","required":["AssignmentId"],"members":{"AssignmentId":{}}},"output":{"type":"structure","members":{"Assignment":{"shape":"S1p"},"HIT":{"shape":"Sz"}}},"idempotent":true},"GetFileUploadURL":{"input":{"type":"structure","required":["AssignmentId","QuestionIdentifier"],"members":{"AssignmentId":{},"QuestionIdentifier":{}}},"output":{"type":"structure","members":{"FileUploadURL":{}}},"idempotent":true},"GetHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{}}},"output":{"type":"structure","members":{"HIT":{"shape":"Sz"}}},"idempotent":true},"GetQualificationScore":{"input":{"type":"structure","required":["QualificationTypeId","WorkerId"],"members":{"QualificationTypeId":{},"WorkerId":{}}},"output":{"type":"structure","members":{"Qualification":{"shape":"S1x"}}},"idempotent":true},"GetQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}},"idempotent":true},"ListAssignmentsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"NextToken":{},"MaxResults":{"type":"integer"},"AssignmentStatuses":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Assignments":{"type":"list","member":{"shape":"S1p"}}}},"idempotent":true},"ListBonusPayments":{"input":{"type":"structure","members":{"HITId":{},"AssignmentId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"BonusPayments":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"GrantTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListHITs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListHITsForQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListQualificationRequests":{"input":{"type":"structure","members":{"QualificationTypeId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationRequests":{"type":"list","member":{"type":"structure","members":{"QualificationRequestId":{},"QualificationTypeId":{},"WorkerId":{},"Test":{},"Answer":{},"SubmitTime":{"type":"timestamp"}}}}}},"idempotent":true},"ListQualificationTypes":{"input":{"type":"structure","required":["MustBeRequestable"],"members":{"Query":{},"MustBeRequestable":{"type":"boolean"},"MustBeOwnedByCaller":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NumResults":{"type":"integer"},"NextToken":{},"QualificationTypes":{"type":"list","member":{"shape":"S1a"}}}},"idempotent":true},"ListReviewPolicyResultsForHIT":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"PolicyLevels":{"type":"list","member":{}},"RetrieveActions":{"type":"boolean"},"RetrieveResults":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"HITId":{},"AssignmentReviewPolicy":{"shape":"Sq"},"HITReviewPolicy":{"shape":"Sq"},"AssignmentReviewReport":{"shape":"S2r"},"HITReviewReport":{"shape":"S2r"},"NextToken":{}}},"idempotent":true},"ListReviewableHITs":{"input":{"type":"structure","members":{"HITTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"HITs":{"shape":"S2d"}}},"idempotent":true},"ListWorkerBlocks":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"WorkerBlocks":{"type":"list","member":{"type":"structure","members":{"WorkerId":{},"Reason":{}}}}}},"idempotent":true},"ListWorkersWithQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Status":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"NumResults":{"type":"integer"},"Qualifications":{"type":"list","member":{"shape":"S1x"}}}},"idempotent":true},"NotifyWorkers":{"input":{"type":"structure","required":["Subject","MessageText","WorkerIds"],"members":{"Subject":{},"MessageText":{},"WorkerIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"NotifyWorkersFailureStatuses":{"type":"list","member":{"type":"structure","members":{"NotifyWorkersFailureCode":{},"NotifyWorkersFailureMessage":{},"WorkerId":{}}}}}}},"RejectAssignment":{"input":{"type":"structure","required":["AssignmentId","RequesterFeedback"],"members":{"AssignmentId":{},"RequesterFeedback":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"RejectQualificationRequest":{"input":{"type":"structure","required":["QualificationRequestId"],"members":{"QualificationRequestId":{},"Reason":{}}},"output":{"type":"structure","members":{}}},"SendBonus":{"input":{"type":"structure","required":["WorkerId","BonusAmount","AssignmentId","Reason"],"members":{"WorkerId":{},"BonusAmount":{},"AssignmentId":{},"Reason":{},"UniqueRequestToken":{}}},"output":{"type":"structure","members":{}}},"SendTestEventNotification":{"input":{"type":"structure","required":["Notification","TestEventType"],"members":{"Notification":{"shape":"S3k"},"TestEventType":{}}},"output":{"type":"structure","members":{}}},"UpdateExpirationForHIT":{"input":{"type":"structure","required":["HITId","ExpireAt"],"members":{"HITId":{},"ExpireAt":{"type":"timestamp"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITReviewStatus":{"input":{"type":"structure","required":["HITId"],"members":{"HITId":{},"Revert":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateHITTypeOfHIT":{"input":{"type":"structure","required":["HITId","HITTypeId"],"members":{"HITId":{},"HITTypeId":{}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateNotificationSettings":{"input":{"type":"structure","required":["HITTypeId"],"members":{"HITTypeId":{},"Notification":{"shape":"S3k"},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{}},"idempotent":true},"UpdateQualificationType":{"input":{"type":"structure","required":["QualificationTypeId"],"members":{"QualificationTypeId":{},"Description":{},"QualificationTypeStatus":{},"Test":{},"AnswerKey":{},"TestDurationInSeconds":{"type":"long"},"RetryDelayInSeconds":{"type":"long"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"output":{"type":"structure","members":{"QualificationType":{"shape":"S1a"}}}}},"shapes":{"Si":{"type":"list","member":{"type":"structure","required":["QualificationTypeId","Comparator"],"members":{"QualificationTypeId":{},"Comparator":{},"IntegerValues":{"type":"list","member":{"type":"integer"}},"LocaleValues":{"type":"list","member":{"shape":"Sn"}},"RequiredToPreview":{"deprecated":true,"type":"boolean"},"ActionsGuarded":{}}}},"Sn":{"type":"structure","required":["Country"],"members":{"Country":{},"Subdivision":{}}},"Sq":{"type":"structure","required":["PolicyName"],"members":{"PolicyName":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"},"MapEntries":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"shape":"St"}}}}}}}}},"St":{"type":"list","member":{}},"Sw":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}},"Sz":{"type":"structure","members":{"HITId":{},"HITTypeId":{},"HITGroupId":{},"HITLayoutId":{},"CreationTime":{"type":"timestamp"},"Title":{},"Description":{},"Question":{},"Keywords":{},"HITStatus":{},"MaxAssignments":{"type":"integer"},"Reward":{},"AutoApprovalDelayInSeconds":{"type":"long"},"Expiration":{"type":"timestamp"},"AssignmentDurationInSeconds":{"type":"long"},"RequesterAnnotation":{},"QualificationRequirements":{"shape":"Si"},"HITReviewStatus":{},"NumberOfAssignmentsPending":{"type":"integer"},"NumberOfAssignmentsAvailable":{"type":"integer"},"NumberOfAssignmentsCompleted":{"type":"integer"}}},"S1a":{"type":"structure","members":{"QualificationTypeId":{},"CreationTime":{"type":"timestamp"},"Name":{},"Description":{},"Keywords":{},"QualificationTypeStatus":{},"Test":{},"TestDurationInSeconds":{"type":"long"},"AnswerKey":{},"RetryDelayInSeconds":{"type":"long"},"IsRequestable":{"type":"boolean"},"AutoGranted":{"type":"boolean"},"AutoGrantedValue":{"type":"integer"}}},"S1p":{"type":"structure","members":{"AssignmentId":{},"WorkerId":{},"HITId":{},"AssignmentStatus":{},"AutoApprovalTime":{"type":"timestamp"},"AcceptTime":{"type":"timestamp"},"SubmitTime":{"type":"timestamp"},"ApprovalTime":{"type":"timestamp"},"RejectionTime":{"type":"timestamp"},"Deadline":{"type":"timestamp"},"Answer":{},"RequesterFeedback":{}}},"S1x":{"type":"structure","members":{"QualificationTypeId":{},"WorkerId":{},"GrantTime":{"type":"timestamp"},"IntegerValue":{"type":"integer"},"LocaleValue":{"shape":"Sn"},"Status":{}}},"S2d":{"type":"list","member":{"shape":"Sz"}},"S2r":{"type":"structure","members":{"ReviewResults":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"SubjectId":{},"SubjectType":{},"QuestionId":{},"Key":{},"Value":{}}}},"ReviewActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"ActionName":{},"TargetId":{},"TargetType":{},"Status":{},"CompleteTime":{"type":"timestamp"},"Result":{},"ErrorCode":{}}}}}},"S3k":{"type":"structure","required":["Destination","Transport","Version","EventTypes"],"members":{"Destination":{},"Transport":{},"Version":{},"EventTypes":{"type":"list","member":{}}}}}}

/***/ }),
/* 566 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListAssignmentsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListBonusPayments":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListHITsForQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationRequests":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListQualificationTypes":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewPolicyResultsForHIT":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListReviewableHITs":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkerBlocks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListWorkersWithQualificationType":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 567 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-18","endpointPrefix":"opsworks","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS OpsWorks","serviceId":"OpsWorks","signatureVersion":"v4","targetPrefix":"OpsWorks_20130218","uid":"opsworks-2013-02-18"},"operations":{"AssignInstance":{"input":{"type":"structure","required":["InstanceId","LayerIds"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"}}}},"AssignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"InstanceId":{}}}},"AssociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"InstanceId":{}}}},"AttachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"CloneStack":{"input":{"type":"structure","required":["SourceStackId","ServiceRoleArn"],"members":{"SourceStackId":{},"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"ClonePermissions":{"type":"boolean"},"CloneAppIds":{"shape":"S3"},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateApp":{"input":{"type":"structure","required":["StackId","Name","Type"],"members":{"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}},"output":{"type":"structure","members":{"AppId":{}}}},"CreateDeployment":{"input":{"type":"structure","required":["StackId","Command"],"members":{"StackId":{},"AppId":{},"InstanceIds":{"shape":"S3"},"LayerIds":{"shape":"S3"},"Command":{"shape":"Ss"},"Comment":{},"CustomJson":{}}},"output":{"type":"structure","members":{"DeploymentId":{}}}},"CreateInstance":{"input":{"type":"structure","required":["StackId","LayerIds","InstanceType"],"members":{"StackId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"AvailabilityZone":{},"VirtualizationType":{},"SubnetId":{},"Architecture":{},"RootDeviceType":{},"BlockDeviceMappings":{"shape":"Sz"},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{},"Tenancy":{}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"CreateLayer":{"input":{"type":"structure","required":["StackId","Type","Name","Shortname"],"members":{"StackId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}},"output":{"type":"structure","members":{"LayerId":{}}}},"CreateStack":{"input":{"type":"structure","required":["Name","Region","ServiceRoleArn","DefaultInstanceProfileArn"],"members":{"Name":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"AgentVersion":{}}},"output":{"type":"structure","members":{"StackId":{}}}},"CreateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}},"output":{"type":"structure","members":{"IamUserArn":{}}}},"DeleteApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{}}}},"DeleteInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"DeleteElasticIp":{"type":"boolean"},"DeleteVolumes":{"type":"boolean"}}}},"DeleteLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}}},"DeleteStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"DeleteUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{}}}},"DeregisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn"],"members":{"EcsClusterArn":{}}}},"DeregisterElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"DeregisterInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"DeregisterRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{}}}},"DeregisterVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"DescribeAgentVersions":{"input":{"type":"structure","members":{"StackId":{},"ConfigurationManager":{"shape":"Sa"}}},"output":{"type":"structure","members":{"AgentVersions":{"type":"list","member":{"type":"structure","members":{"Version":{},"ConfigurationManager":{"shape":"Sa"}}}}}}},"DescribeApps":{"input":{"type":"structure","members":{"StackId":{},"AppIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Apps":{"type":"list","member":{"type":"structure","members":{"AppId":{},"StackId":{},"Shortname":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"CreatedAt":{},"Environment":{"shape":"So"}}}}}}},"DescribeCommands":{"input":{"type":"structure","members":{"DeploymentId":{},"InstanceId":{},"CommandIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"DeploymentId":{},"CreatedAt":{},"AcknowledgedAt":{},"CompletedAt":{},"Status":{},"ExitCode":{"type":"integer"},"LogUrl":{},"Type":{}}}}}}},"DescribeDeployments":{"input":{"type":"structure","members":{"StackId":{},"AppId":{},"DeploymentIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Deployments":{"type":"list","member":{"type":"structure","members":{"DeploymentId":{},"StackId":{},"AppId":{},"CreatedAt":{},"CompletedAt":{},"Duration":{"type":"integer"},"IamUserArn":{},"Comment":{},"Command":{"shape":"Ss"},"Status":{},"CustomJson":{},"InstanceIds":{"shape":"S3"}}}}}}},"DescribeEcsClusters":{"input":{"type":"structure","members":{"EcsClusterArns":{"shape":"S3"},"StackId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"EcsClusters":{"type":"list","member":{"type":"structure","members":{"EcsClusterArn":{},"EcsClusterName":{},"StackId":{},"RegisteredAt":{}}}},"NextToken":{}}}},"DescribeElasticIps":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"Ips":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticIps":{"type":"list","member":{"type":"structure","members":{"Ip":{},"Name":{},"Domain":{},"Region":{},"InstanceId":{}}}}}}},"DescribeElasticLoadBalancers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ElasticLoadBalancers":{"type":"list","member":{"type":"structure","members":{"ElasticLoadBalancerName":{},"Region":{},"DnsName":{},"StackId":{},"LayerId":{},"VpcId":{},"AvailabilityZones":{"shape":"S3"},"SubnetIds":{"shape":"S3"},"Ec2InstanceIds":{"shape":"S3"}}}}}}},"DescribeInstances":{"input":{"type":"structure","members":{"StackId":{},"LayerId":{},"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Instances":{"type":"list","member":{"type":"structure","members":{"AgentVersion":{},"AmiId":{},"Architecture":{},"Arn":{},"AutoScalingType":{},"AvailabilityZone":{},"BlockDeviceMappings":{"shape":"Sz"},"CreatedAt":{},"EbsOptimized":{"type":"boolean"},"Ec2InstanceId":{},"EcsClusterArn":{},"EcsContainerInstanceArn":{},"ElasticIp":{},"Hostname":{},"InfrastructureClass":{},"InstallUpdatesOnBoot":{"type":"boolean"},"InstanceId":{},"InstanceProfileArn":{},"InstanceType":{},"LastServiceErrorId":{},"LayerIds":{"shape":"S3"},"Os":{},"Platform":{},"PrivateDns":{},"PrivateIp":{},"PublicDns":{},"PublicIp":{},"RegisteredBy":{},"ReportedAgentVersion":{},"ReportedOs":{"type":"structure","members":{"Family":{},"Name":{},"Version":{}}},"RootDeviceType":{},"RootDeviceVolumeId":{},"SecurityGroupIds":{"shape":"S3"},"SshHostDsaKeyFingerprint":{},"SshHostRsaKeyFingerprint":{},"SshKeyName":{},"StackId":{},"Status":{},"SubnetId":{},"Tenancy":{},"VirtualizationType":{}}}}}}},"DescribeLayers":{"input":{"type":"structure","members":{"StackId":{},"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Layers":{"type":"list","member":{"type":"structure","members":{"Arn":{},"StackId":{},"LayerId":{},"Type":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"DefaultSecurityGroupNames":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"DefaultRecipes":{"shape":"S1h"},"CustomRecipes":{"shape":"S1h"},"CreatedAt":{},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}}}}},"DescribeLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerIds"],"members":{"LayerIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"LoadBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}}}}},"DescribeMyUserProfile":{"output":{"type":"structure","members":{"UserProfile":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{}}}}}},"DescribeOperatingSystems":{"output":{"type":"structure","members":{"OperatingSystems":{"type":"list","member":{"type":"structure","members":{"Name":{},"Id":{},"Type":{},"ConfigurationManagers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Version":{}}}},"ReportedName":{},"ReportedVersion":{},"Supported":{"type":"boolean"}}}}}}},"DescribePermissions":{"input":{"type":"structure","members":{"IamUserArn":{},"StackId":{}}},"output":{"type":"structure","members":{"Permissions":{"type":"list","member":{"type":"structure","members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}}}}},"DescribeRaidArrays":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"RaidArrays":{"type":"list","member":{"type":"structure","members":{"RaidArrayId":{},"InstanceId":{},"Name":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"AvailabilityZone":{},"CreatedAt":{},"StackId":{},"VolumeType":{},"Iops":{"type":"integer"}}}}}}},"DescribeRdsDbInstances":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"RdsDbInstanceArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"RdsDbInstances":{"type":"list","member":{"type":"structure","members":{"RdsDbInstanceArn":{},"DbInstanceIdentifier":{},"DbUser":{},"DbPassword":{},"Region":{},"Address":{},"Engine":{},"StackId":{},"MissingOnRds":{"type":"boolean"}}}}}}},"DescribeServiceErrors":{"input":{"type":"structure","members":{"StackId":{},"InstanceId":{},"ServiceErrorIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"ServiceErrors":{"type":"list","member":{"type":"structure","members":{"ServiceErrorId":{},"StackId":{},"InstanceId":{},"Type":{},"Message":{},"CreatedAt":{}}}}}}},"DescribeStackProvisioningParameters":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"AgentInstallerUrl":{},"Parameters":{"type":"map","key":{},"value":{}}}}},"DescribeStackSummary":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}},"output":{"type":"structure","members":{"StackSummary":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"LayersCount":{"type":"integer"},"AppsCount":{"type":"integer"},"InstancesCount":{"type":"structure","members":{"Assigning":{"type":"integer"},"Booting":{"type":"integer"},"ConnectionLost":{"type":"integer"},"Deregistering":{"type":"integer"},"Online":{"type":"integer"},"Pending":{"type":"integer"},"Rebooting":{"type":"integer"},"Registered":{"type":"integer"},"Registering":{"type":"integer"},"Requested":{"type":"integer"},"RunningSetup":{"type":"integer"},"SetupFailed":{"type":"integer"},"ShuttingDown":{"type":"integer"},"StartFailed":{"type":"integer"},"StopFailed":{"type":"integer"},"Stopped":{"type":"integer"},"Stopping":{"type":"integer"},"Terminated":{"type":"integer"},"Terminating":{"type":"integer"},"Unassigning":{"type":"integer"}}}}}}}},"DescribeStacks":{"input":{"type":"structure","members":{"StackIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Stacks":{"type":"list","member":{"type":"structure","members":{"StackId":{},"Name":{},"Arn":{},"Region":{},"VpcId":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"UseOpsworksSecurityGroups":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"CreatedAt":{},"DefaultRootDeviceType":{},"AgentVersion":{}}}}}}},"DescribeTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"TimeBasedAutoScalingConfigurations":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}}}}},"DescribeUserProfiles":{"input":{"type":"structure","members":{"IamUserArns":{"shape":"S3"}}},"output":{"type":"structure","members":{"UserProfiles":{"type":"list","member":{"type":"structure","members":{"IamUserArn":{},"Name":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}}}}},"DescribeVolumes":{"input":{"type":"structure","members":{"InstanceId":{},"StackId":{},"RaidArrayId":{},"VolumeIds":{"shape":"S3"}}},"output":{"type":"structure","members":{"Volumes":{"type":"list","member":{"type":"structure","members":{"VolumeId":{},"Ec2VolumeId":{},"Name":{},"RaidArrayId":{},"InstanceId":{},"Status":{},"Size":{"type":"integer"},"Device":{},"MountPoint":{},"Region":{},"AvailabilityZone":{},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}}}}},"DetachElasticLoadBalancer":{"input":{"type":"structure","required":["ElasticLoadBalancerName","LayerId"],"members":{"ElasticLoadBalancerName":{},"LayerId":{}}}},"DisassociateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{}}}},"GetHostnameSuggestion":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{}}},"output":{"type":"structure","members":{"LayerId":{},"Hostname":{}}}},"GrantAccess":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"ValidForInMinutes":{"type":"integer"}}},"output":{"type":"structure","members":{"TemporaryCredential":{"type":"structure","members":{"Username":{},"Password":{},"ValidForInMinutes":{"type":"integer"},"InstanceId":{}}}}}},"ListTags":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S50"},"NextToken":{}}}},"RebootInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"RegisterEcsCluster":{"input":{"type":"structure","required":["EcsClusterArn","StackId"],"members":{"EcsClusterArn":{},"StackId":{}}},"output":{"type":"structure","members":{"EcsClusterArn":{}}}},"RegisterElasticIp":{"input":{"type":"structure","required":["ElasticIp","StackId"],"members":{"ElasticIp":{},"StackId":{}}},"output":{"type":"structure","members":{"ElasticIp":{}}}},"RegisterInstance":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Hostname":{},"PublicIp":{},"PrivateIp":{},"RsaPublicKey":{},"RsaPublicKeyFingerprint":{},"InstanceIdentity":{"type":"structure","members":{"Document":{},"Signature":{}}}}},"output":{"type":"structure","members":{"InstanceId":{}}}},"RegisterRdsDbInstance":{"input":{"type":"structure","required":["StackId","RdsDbInstanceArn","DbUser","DbPassword"],"members":{"StackId":{},"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"RegisterVolume":{"input":{"type":"structure","required":["StackId"],"members":{"Ec2VolumeId":{},"StackId":{}}},"output":{"type":"structure","members":{"VolumeId":{}}}},"SetLoadBasedAutoScaling":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Enable":{"type":"boolean"},"UpScaling":{"shape":"S36"},"DownScaling":{"shape":"S36"}}}},"SetPermission":{"input":{"type":"structure","required":["StackId","IamUserArn"],"members":{"StackId":{},"IamUserArn":{},"AllowSsh":{"type":"boolean"},"AllowSudo":{"type":"boolean"},"Level":{}}}},"SetTimeBasedAutoScaling":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"AutoScalingSchedule":{"shape":"S4b"}}}},"StartInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"StartStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"StopInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Force":{"type":"boolean"}}}},"StopStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S50"}}}},"UnassignInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}}},"UnassignVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateApp":{"input":{"type":"structure","required":["AppId"],"members":{"AppId":{},"Name":{},"Description":{},"DataSources":{"shape":"Si"},"Type":{},"AppSource":{"shape":"Sd"},"Domains":{"shape":"S3"},"EnableSsl":{"type":"boolean"},"SslConfiguration":{"shape":"Sl"},"Attributes":{"shape":"Sm"},"Environment":{"shape":"So"}}}},"UpdateElasticIp":{"input":{"type":"structure","required":["ElasticIp"],"members":{"ElasticIp":{},"Name":{}}}},"UpdateInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"LayerIds":{"shape":"S3"},"InstanceType":{},"AutoScalingType":{},"Hostname":{},"Os":{},"AmiId":{},"SshKeyName":{},"Architecture":{},"InstallUpdatesOnBoot":{"type":"boolean"},"EbsOptimized":{"type":"boolean"},"AgentVersion":{}}}},"UpdateLayer":{"input":{"type":"structure","required":["LayerId"],"members":{"LayerId":{},"Name":{},"Shortname":{},"Attributes":{"shape":"S17"},"CloudWatchLogsConfiguration":{"shape":"S19"},"CustomInstanceProfileArn":{},"CustomJson":{},"CustomSecurityGroupIds":{"shape":"S3"},"Packages":{"shape":"S3"},"VolumeConfigurations":{"shape":"S1f"},"EnableAutoHealing":{"type":"boolean"},"AutoAssignElasticIps":{"type":"boolean"},"AutoAssignPublicIps":{"type":"boolean"},"CustomRecipes":{"shape":"S1h"},"InstallUpdatesOnBoot":{"type":"boolean"},"UseEbsOptimizedInstances":{"type":"boolean"},"LifecycleEventConfiguration":{"shape":"S1i"}}}},"UpdateMyUserProfile":{"input":{"type":"structure","members":{"SshPublicKey":{}}}},"UpdateRdsDbInstance":{"input":{"type":"structure","required":["RdsDbInstanceArn"],"members":{"RdsDbInstanceArn":{},"DbUser":{},"DbPassword":{}}}},"UpdateStack":{"input":{"type":"structure","required":["StackId"],"members":{"StackId":{},"Name":{},"Attributes":{"shape":"S8"},"ServiceRoleArn":{},"DefaultInstanceProfileArn":{},"DefaultOs":{},"HostnameTheme":{},"DefaultAvailabilityZone":{},"DefaultSubnetId":{},"CustomJson":{},"ConfigurationManager":{"shape":"Sa"},"ChefConfiguration":{"shape":"Sb"},"UseCustomCookbooks":{"type":"boolean"},"CustomCookbooksSource":{"shape":"Sd"},"DefaultSshKeyName":{},"DefaultRootDeviceType":{},"UseOpsworksSecurityGroups":{"type":"boolean"},"AgentVersion":{}}}},"UpdateUserProfile":{"input":{"type":"structure","required":["IamUserArn"],"members":{"IamUserArn":{},"SshUsername":{},"SshPublicKey":{},"AllowSelfManagement":{"type":"boolean"}}}},"UpdateVolume":{"input":{"type":"structure","required":["VolumeId"],"members":{"VolumeId":{},"Name":{},"MountPoint":{}}}}},"shapes":{"S3":{"type":"list","member":{}},"S8":{"type":"map","key":{},"value":{}},"Sa":{"type":"structure","members":{"Name":{},"Version":{}}},"Sb":{"type":"structure","members":{"ManageBerkshelf":{"type":"boolean"},"BerkshelfVersion":{}}},"Sd":{"type":"structure","members":{"Type":{},"Url":{},"Username":{},"Password":{},"SshKey":{},"Revision":{}}},"Si":{"type":"list","member":{"type":"structure","members":{"Type":{},"Arn":{},"DatabaseName":{}}}},"Sl":{"type":"structure","required":["Certificate","PrivateKey"],"members":{"Certificate":{},"PrivateKey":{},"Chain":{}}},"Sm":{"type":"map","key":{},"value":{}},"So":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{},"Secure":{"type":"boolean"}}}},"Ss":{"type":"structure","required":["Name"],"members":{"Name":{},"Args":{"type":"map","key":{},"value":{"shape":"S3"}}}},"Sz":{"type":"list","member":{"type":"structure","members":{"DeviceName":{},"NoDevice":{},"VirtualName":{},"Ebs":{"type":"structure","members":{"SnapshotId":{},"Iops":{"type":"integer"},"VolumeSize":{"type":"integer"},"VolumeType":{},"DeleteOnTermination":{"type":"boolean"}}}}}},"S17":{"type":"map","key":{},"value":{}},"S19":{"type":"structure","members":{"Enabled":{"type":"boolean"},"LogStreams":{"type":"list","member":{"type":"structure","members":{"LogGroupName":{},"DatetimeFormat":{},"TimeZone":{},"File":{},"FileFingerprintLines":{},"MultiLineStartPattern":{},"InitialPosition":{},"Encoding":{},"BufferDuration":{"type":"integer"},"BatchCount":{"type":"integer"},"BatchSize":{"type":"integer"}}}}}},"S1f":{"type":"list","member":{"type":"structure","required":["MountPoint","NumberOfDisks","Size"],"members":{"MountPoint":{},"RaidLevel":{"type":"integer"},"NumberOfDisks":{"type":"integer"},"Size":{"type":"integer"},"VolumeType":{},"Iops":{"type":"integer"},"Encrypted":{"type":"boolean"}}}},"S1h":{"type":"structure","members":{"Setup":{"shape":"S3"},"Configure":{"shape":"S3"},"Deploy":{"shape":"S3"},"Undeploy":{"shape":"S3"},"Shutdown":{"shape":"S3"}}},"S1i":{"type":"structure","members":{"Shutdown":{"type":"structure","members":{"ExecutionTimeout":{"type":"integer"},"DelayUntilElbConnectionsDrained":{"type":"boolean"}}}}},"S36":{"type":"structure","members":{"InstanceCount":{"type":"integer"},"ThresholdsWaitTime":{"type":"integer"},"IgnoreMetricsTime":{"type":"integer"},"CpuThreshold":{"type":"double"},"MemoryThreshold":{"type":"double"},"LoadThreshold":{"type":"double"},"Alarms":{"shape":"S3"}}},"S4b":{"type":"structure","members":{"Monday":{"shape":"S4c"},"Tuesday":{"shape":"S4c"},"Wednesday":{"shape":"S4c"},"Thursday":{"shape":"S4c"},"Friday":{"shape":"S4c"},"Saturday":{"shape":"S4c"},"Sunday":{"shape":"S4c"}}},"S4c":{"type":"map","key":{},"value":{}},"S50":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 568 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeApps":{"result_key":"Apps"},"DescribeCommands":{"result_key":"Commands"},"DescribeDeployments":{"result_key":"Deployments"},"DescribeEcsClusters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EcsClusters"},"DescribeElasticIps":{"result_key":"ElasticIps"},"DescribeElasticLoadBalancers":{"result_key":"ElasticLoadBalancers"},"DescribeInstances":{"result_key":"Instances"},"DescribeLayers":{"result_key":"Layers"},"DescribeLoadBasedAutoScaling":{"result_key":"LoadBasedAutoScalingConfigurations"},"DescribePermissions":{"result_key":"Permissions"},"DescribeRaidArrays":{"result_key":"RaidArrays"},"DescribeServiceErrors":{"result_key":"ServiceErrors"},"DescribeStacks":{"result_key":"Stacks"},"DescribeTimeBasedAutoScaling":{"result_key":"TimeBasedAutoScalingConfigurations"},"DescribeUserProfiles":{"result_key":"UserProfiles"},"DescribeVolumes":{"result_key":"Volumes"}}}

/***/ }),
/* 569 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"AppExists":{"delay":1,"operation":"DescribeApps","maxAttempts":40,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"matcher":"status","expected":400,"state":"failure"}]},"DeploymentSuccessful":{"delay":15,"operation":"DescribeDeployments","maxAttempts":40,"description":"Wait until a deployment has completed successfully.","acceptors":[{"expected":"successful","matcher":"pathAll","state":"success","argument":"Deployments[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Deployments[].Status"}]},"InstanceOnline":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is online.","acceptors":[{"expected":"online","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceRegistered":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is registered.","acceptors":[{"expected":"registered","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"shutting_down","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopped","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stopping","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminating","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"terminated","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceStopped":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is stopped.","acceptors":[{"expected":"stopped","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"stop_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]},"InstanceTerminated":{"delay":15,"operation":"DescribeInstances","maxAttempts":40,"description":"Wait until OpsWorks instance is terminated.","acceptors":[{"expected":"terminated","matcher":"pathAll","state":"success","argument":"Instances[].Status"},{"expected":"ResourceNotFoundException","matcher":"error","state":"success"},{"expected":"booting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"online","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"pending","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"requested","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"running_setup","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"setup_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"},{"expected":"start_failed","matcher":"pathAny","state":"failure","argument":"Instances[].Status"}]}}}

/***/ }),
/* 570 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceFullName":"Amazon Personalize","serviceId":"Personalize","signatureVersion":"v4","signingName":"personalize","targetPrefix":"AmazonPersonalize","uid":"personalize-2018-05-22"},"operations":{"CreateBatchInferenceJob":{"input":{"type":"structure","required":["jobName","solutionVersionArn","jobInput","jobOutput","roleArn"],"members":{"jobName":{},"solutionVersionArn":{},"filterArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"S5"},"jobOutput":{"shape":"S9"},"roleArn":{},"batchInferenceJobConfig":{"shape":"Sb"},"tags":{"shape":"Sf"},"batchInferenceJobMode":{},"themeGenerationConfig":{"shape":"Sk"}}},"output":{"type":"structure","members":{"batchInferenceJobArn":{}}}},"CreateBatchSegmentJob":{"input":{"type":"structure","required":["jobName","solutionVersionArn","jobInput","jobOutput","roleArn"],"members":{"jobName":{},"solutionVersionArn":{},"filterArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"Sp"},"jobOutput":{"shape":"Sq"},"roleArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"batchSegmentJobArn":{}}}},"CreateCampaign":{"input":{"type":"structure","required":["name","solutionVersionArn"],"members":{"name":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Su"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true},"CreateDataDeletionJob":{"input":{"type":"structure","required":["jobName","datasetGroupArn","dataSource","roleArn"],"members":{"jobName":{},"datasetGroupArn":{},"dataSource":{"shape":"Sy"},"roleArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"dataDeletionJobArn":{}}}},"CreateDataset":{"input":{"type":"structure","required":["name","schemaArn","datasetGroupArn","datasetType"],"members":{"name":{},"schemaArn":{},"datasetGroupArn":{},"datasetType":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"datasetArn":{}}},"idempotent":true},"CreateDatasetExportJob":{"input":{"type":"structure","required":["jobName","datasetArn","roleArn","jobOutput"],"members":{"jobName":{},"datasetArn":{},"ingestionMode":{},"roleArn":{},"jobOutput":{"shape":"S15"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"datasetExportJobArn":{}}},"idempotent":true},"CreateDatasetGroup":{"input":{"type":"structure","required":["name"],"members":{"name":{},"roleArn":{},"kmsKeyArn":{},"domain":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"datasetGroupArn":{},"domain":{}}}},"CreateDatasetImportJob":{"input":{"type":"structure","required":["jobName","datasetArn","dataSource","roleArn"],"members":{"jobName":{},"datasetArn":{},"dataSource":{"shape":"Sy"},"roleArn":{},"tags":{"shape":"Sf"},"importMode":{},"publishAttributionMetricsToS3":{"type":"boolean"}}},"output":{"type":"structure","members":{"datasetImportJobArn":{}}}},"CreateEventTracker":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"datasetGroupArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"eventTrackerArn":{},"trackingId":{}}},"idempotent":true},"CreateFilter":{"input":{"type":"structure","required":["name","datasetGroupArn","filterExpression"],"members":{"name":{},"datasetGroupArn":{},"filterExpression":{"shape":"S1h"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"filterArn":{}}}},"CreateMetricAttribution":{"input":{"type":"structure","required":["name","datasetGroupArn","metrics","metricsOutputConfig"],"members":{"name":{},"datasetGroupArn":{},"metrics":{"shape":"S1k"},"metricsOutputConfig":{"shape":"S1p"}}},"output":{"type":"structure","members":{"metricAttributionArn":{}}}},"CreateRecommender":{"input":{"type":"structure","required":["name","datasetGroupArn","recipeArn"],"members":{"name":{},"datasetGroupArn":{},"recipeArn":{},"recommenderConfig":{"shape":"S1s"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true},"CreateSchema":{"input":{"type":"structure","required":["name","schema"],"members":{"name":{},"schema":{},"domain":{}}},"output":{"type":"structure","members":{"schemaArn":{}}},"idempotent":true},"CreateSolution":{"input":{"type":"structure","required":["name","datasetGroupArn"],"members":{"name":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"performAutoTraining":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"S23"},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"solutionArn":{}}}},"CreateSolutionVersion":{"input":{"type":"structure","required":["solutionArn"],"members":{"name":{},"solutionArn":{},"trainingMode":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{"solutionVersionArn":{}}}},"DeleteCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"idempotent":true},"DeleteDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"idempotent":true},"DeleteDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"idempotent":true},"DeleteEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"idempotent":true},"DeleteFilter":{"input":{"type":"structure","required":["filterArn"],"members":{"filterArn":{}}}},"DeleteMetricAttribution":{"input":{"type":"structure","required":["metricAttributionArn"],"members":{"metricAttributionArn":{}}},"idempotent":true},"DeleteRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"idempotent":true},"DeleteSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"idempotent":true},"DeleteSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"idempotent":true},"DescribeAlgorithm":{"input":{"type":"structure","required":["algorithmArn"],"members":{"algorithmArn":{}}},"output":{"type":"structure","members":{"algorithm":{"type":"structure","members":{"name":{},"algorithmArn":{},"algorithmImage":{"type":"structure","required":["dockerURI"],"members":{"name":{},"dockerURI":{}}},"defaultHyperParameters":{"shape":"Sc"},"defaultHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"},"isTunable":{"type":"boolean"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"},"isTunable":{"type":"boolean"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S2m"},"isTunable":{"type":"boolean"}}}}}},"defaultResourceConfig":{"type":"map","key":{},"value":{}},"trainingInputMode":{},"roleArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeBatchInferenceJob":{"input":{"type":"structure","required":["batchInferenceJobArn"],"members":{"batchInferenceJobArn":{}}},"output":{"type":"structure","members":{"batchInferenceJob":{"type":"structure","members":{"jobName":{},"batchInferenceJobArn":{},"filterArn":{},"failureReason":{},"solutionVersionArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"S5"},"jobOutput":{"shape":"S9"},"batchInferenceJobConfig":{"shape":"Sb"},"roleArn":{},"batchInferenceJobMode":{},"themeGenerationConfig":{"shape":"Sk"},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeBatchSegmentJob":{"input":{"type":"structure","required":["batchSegmentJobArn"],"members":{"batchSegmentJobArn":{}}},"output":{"type":"structure","members":{"batchSegmentJob":{"type":"structure","members":{"jobName":{},"batchSegmentJobArn":{},"filterArn":{},"failureReason":{},"solutionVersionArn":{},"numResults":{"type":"integer"},"jobInput":{"shape":"Sp"},"jobOutput":{"shape":"Sq"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{}}},"output":{"type":"structure","members":{"campaign":{"type":"structure","members":{"name":{},"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Su"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestCampaignUpdate":{"type":"structure","members":{"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Su"},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}}}},"idempotent":true},"DescribeDataDeletionJob":{"input":{"type":"structure","required":["dataDeletionJobArn"],"members":{"dataDeletionJobArn":{}}},"output":{"type":"structure","members":{"dataDeletionJob":{"type":"structure","members":{"jobName":{},"dataDeletionJobArn":{},"datasetGroupArn":{},"dataSource":{"shape":"Sy"},"roleArn":{},"status":{},"numDeleted":{"type":"integer"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeDataset":{"input":{"type":"structure","required":["datasetArn"],"members":{"datasetArn":{}}},"output":{"type":"structure","members":{"dataset":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetGroupArn":{},"datasetType":{},"schemaArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestDatasetUpdate":{"type":"structure","members":{"schemaArn":{},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}},"trackingId":{}}}}},"idempotent":true},"DescribeDatasetExportJob":{"input":{"type":"structure","required":["datasetExportJobArn"],"members":{"datasetExportJobArn":{}}},"output":{"type":"structure","members":{"datasetExportJob":{"type":"structure","members":{"jobName":{},"datasetExportJobArn":{},"datasetArn":{},"ingestionMode":{},"roleArn":{},"status":{},"jobOutput":{"shape":"S15"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}},"idempotent":true},"DescribeDatasetGroup":{"input":{"type":"structure","required":["datasetGroupArn"],"members":{"datasetGroupArn":{}}},"output":{"type":"structure","members":{"datasetGroup":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"roleArn":{},"kmsKeyArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"domain":{}}}}},"idempotent":true},"DescribeDatasetImportJob":{"input":{"type":"structure","required":["datasetImportJobArn"],"members":{"datasetImportJobArn":{}}},"output":{"type":"structure","members":{"datasetImportJob":{"type":"structure","members":{"jobName":{},"datasetImportJobArn":{},"datasetArn":{},"dataSource":{"shape":"Sy"},"roleArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"importMode":{},"publishAttributionMetricsToS3":{"type":"boolean"}}}}},"idempotent":true},"DescribeEventTracker":{"input":{"type":"structure","required":["eventTrackerArn"],"members":{"eventTrackerArn":{}}},"output":{"type":"structure","members":{"eventTracker":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"accountId":{},"trackingId":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeFeatureTransformation":{"input":{"type":"structure","required":["featureTransformationArn"],"members":{"featureTransformationArn":{}}},"output":{"type":"structure","members":{"featureTransformation":{"type":"structure","members":{"name":{},"featureTransformationArn":{},"defaultParameters":{"type":"map","key":{},"value":{}},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{}}}}},"idempotent":true},"DescribeFilter":{"input":{"type":"structure","required":["filterArn"],"members":{"filterArn":{}}},"output":{"type":"structure","members":{"filter":{"type":"structure","members":{"name":{},"filterArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"datasetGroupArn":{},"failureReason":{},"filterExpression":{"shape":"S1h"},"status":{}}}}},"idempotent":true},"DescribeMetricAttribution":{"input":{"type":"structure","required":["metricAttributionArn"],"members":{"metricAttributionArn":{}}},"output":{"type":"structure","members":{"metricAttribution":{"type":"structure","members":{"name":{},"metricAttributionArn":{},"datasetGroupArn":{},"metricsOutputConfig":{"shape":"S1p"},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}}},"DescribeRecipe":{"input":{"type":"structure","required":["recipeArn"],"members":{"recipeArn":{}}},"output":{"type":"structure","members":{"recipe":{"type":"structure","members":{"name":{},"recipeArn":{},"algorithmArn":{},"featureTransformationArn":{},"status":{},"description":{},"creationDateTime":{"type":"timestamp"},"recipeType":{},"lastUpdatedDateTime":{"type":"timestamp"}}}}},"idempotent":true},"DescribeRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"output":{"type":"structure","members":{"recommender":{"type":"structure","members":{"recommenderArn":{},"datasetGroupArn":{},"name":{},"recipeArn":{},"recommenderConfig":{"shape":"S1s"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{},"failureReason":{},"latestRecommenderUpdate":{"type":"structure","members":{"recommenderConfig":{"shape":"S1s"},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"status":{},"failureReason":{}}},"modelMetrics":{"shape":"S55"}}}}},"idempotent":true},"DescribeSchema":{"input":{"type":"structure","required":["schemaArn"],"members":{"schemaArn":{}}},"output":{"type":"structure","members":{"schema":{"type":"structure","members":{"name":{},"schemaArn":{},"schema":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"domain":{}}}}},"idempotent":true},"DescribeSolution":{"input":{"type":"structure","required":["solutionArn"],"members":{"solutionArn":{}}},"output":{"type":"structure","members":{"solution":{"type":"structure","members":{"name":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"performAutoTraining":{"type":"boolean"},"recipeArn":{},"datasetGroupArn":{},"eventType":{},"solutionConfig":{"shape":"S23"},"autoMLResult":{"type":"structure","members":{"bestRecipeArn":{}}},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"latestSolutionVersion":{"shape":"S5f"}}}}},"idempotent":true},"DescribeSolutionVersion":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersion":{"type":"structure","members":{"name":{},"solutionVersionArn":{},"solutionArn":{},"performHPO":{"type":"boolean"},"performAutoML":{"type":"boolean"},"recipeArn":{},"eventType":{},"datasetGroupArn":{},"solutionConfig":{"shape":"S23"},"trainingHours":{"type":"double"},"trainingMode":{},"tunedHPOParams":{"type":"structure","members":{"algorithmHyperParameters":{"shape":"Sc"}}},"status":{},"failureReason":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"trainingType":{}}}}},"idempotent":true},"GetSolutionMetrics":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"output":{"type":"structure","members":{"solutionVersionArn":{},"metrics":{"shape":"S55"}}}},"ListBatchInferenceJobs":{"input":{"type":"structure","members":{"solutionVersionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"batchInferenceJobs":{"type":"list","member":{"type":"structure","members":{"batchInferenceJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"solutionVersionArn":{},"batchInferenceJobMode":{}}}},"nextToken":{}}},"idempotent":true},"ListBatchSegmentJobs":{"input":{"type":"structure","members":{"solutionVersionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"batchSegmentJobs":{"type":"list","member":{"type":"structure","members":{"batchSegmentJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"solutionVersionArn":{}}}},"nextToken":{}}},"idempotent":true},"ListCampaigns":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"campaigns":{"type":"list","member":{"type":"structure","members":{"name":{},"campaignArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDataDeletionJobs":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"dataDeletionJobs":{"type":"list","member":{"type":"structure","members":{"dataDeletionJobArn":{},"datasetGroupArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetExportJobs":{"input":{"type":"structure","members":{"datasetArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetExportJobs":{"type":"list","member":{"type":"structure","members":{"datasetExportJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetGroups":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetGroups":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetGroupArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"domain":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasetImportJobs":{"input":{"type":"structure","members":{"datasetArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasetImportJobs":{"type":"list","member":{"type":"structure","members":{"datasetImportJobArn":{},"jobName":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{},"importMode":{}}}},"nextToken":{}}},"idempotent":true},"ListDatasets":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"datasets":{"type":"list","member":{"type":"structure","members":{"name":{},"datasetArn":{},"datasetType":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListEventTrackers":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"eventTrackers":{"type":"list","member":{"type":"structure","members":{"name":{},"eventTrackerArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListFilters":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"name":{},"filterArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"datasetGroupArn":{},"failureReason":{},"status":{}}}},"nextToken":{}}},"idempotent":true},"ListMetricAttributionMetrics":{"input":{"type":"structure","members":{"metricAttributionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"metrics":{"shape":"S1k"},"nextToken":{}}},"idempotent":true},"ListMetricAttributions":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"metricAttributions":{"type":"list","member":{"type":"structure","members":{"name":{},"metricAttributionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}},"nextToken":{}}},"idempotent":true},"ListRecipes":{"input":{"type":"structure","members":{"recipeProvider":{},"nextToken":{},"maxResults":{"type":"integer"},"domain":{}}},"output":{"type":"structure","members":{"recipes":{"type":"list","member":{"type":"structure","members":{"name":{},"recipeArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"domain":{}}}},"nextToken":{}}},"idempotent":true},"ListRecommenders":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"recommenders":{"type":"list","member":{"type":"structure","members":{"name":{},"recommenderArn":{},"datasetGroupArn":{},"recipeArn":{},"recommenderConfig":{"shape":"S1s"},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"}}}},"nextToken":{}}},"idempotent":true},"ListSchemas":{"input":{"type":"structure","members":{"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"schemas":{"type":"list","member":{"type":"structure","members":{"name":{},"schemaArn":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"domain":{}}}},"nextToken":{}}},"idempotent":true},"ListSolutionVersions":{"input":{"type":"structure","members":{"solutionArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutionVersions":{"type":"list","member":{"shape":"S5f"}},"nextToken":{}}},"idempotent":true},"ListSolutions":{"input":{"type":"structure","members":{"datasetGroupArn":{},"nextToken":{},"maxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"solutions":{"type":"list","member":{"type":"structure","members":{"name":{},"solutionArn":{},"status":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"recipeArn":{}}}},"nextToken":{}}},"idempotent":true},"ListTagsForResource":{"input":{"type":"structure","required":["resourceArn"],"members":{"resourceArn":{}}},"output":{"type":"structure","members":{"tags":{"shape":"Sf"}}}},"StartRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true},"StopRecommender":{"input":{"type":"structure","required":["recommenderArn"],"members":{"recommenderArn":{}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true},"StopSolutionVersionCreation":{"input":{"type":"structure","required":["solutionVersionArn"],"members":{"solutionVersionArn":{}}},"idempotent":true},"TagResource":{"input":{"type":"structure","required":["resourceArn","tags"],"members":{"resourceArn":{},"tags":{"shape":"Sf"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["resourceArn","tagKeys"],"members":{"resourceArn":{},"tagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateCampaign":{"input":{"type":"structure","required":["campaignArn"],"members":{"campaignArn":{},"solutionVersionArn":{},"minProvisionedTPS":{"type":"integer"},"campaignConfig":{"shape":"Su"}}},"output":{"type":"structure","members":{"campaignArn":{}}},"idempotent":true},"UpdateDataset":{"input":{"type":"structure","required":["datasetArn","schemaArn"],"members":{"datasetArn":{},"schemaArn":{}}},"output":{"type":"structure","members":{"datasetArn":{}}},"idempotent":true},"UpdateMetricAttribution":{"input":{"type":"structure","members":{"addMetrics":{"shape":"S1k"},"removeMetrics":{"type":"list","member":{}},"metricsOutputConfig":{"shape":"S1p"},"metricAttributionArn":{}}},"output":{"type":"structure","members":{"metricAttributionArn":{}}}},"UpdateRecommender":{"input":{"type":"structure","required":["recommenderArn","recommenderConfig"],"members":{"recommenderArn":{},"recommenderConfig":{"shape":"S1s"}}},"output":{"type":"structure","members":{"recommenderArn":{}}},"idempotent":true}},"shapes":{"S5":{"type":"structure","required":["s3DataSource"],"members":{"s3DataSource":{"shape":"S6"}}},"S6":{"type":"structure","required":["path"],"members":{"path":{},"kmsKeyArn":{}}},"S9":{"type":"structure","required":["s3DataDestination"],"members":{"s3DataDestination":{"shape":"S6"}}},"Sb":{"type":"structure","members":{"itemExplorationConfig":{"shape":"Sc"}}},"Sc":{"type":"map","key":{},"value":{}},"Sf":{"type":"list","member":{"type":"structure","required":["tagKey","tagValue"],"members":{"tagKey":{},"tagValue":{}}}},"Sk":{"type":"structure","required":["fieldsForThemeGeneration"],"members":{"fieldsForThemeGeneration":{"type":"structure","required":["itemName"],"members":{"itemName":{}}}}},"Sp":{"type":"structure","required":["s3DataSource"],"members":{"s3DataSource":{"shape":"S6"}}},"Sq":{"type":"structure","required":["s3DataDestination"],"members":{"s3DataDestination":{"shape":"S6"}}},"Su":{"type":"structure","members":{"itemExplorationConfig":{"shape":"Sc"},"enableMetadataWithRecommendations":{"type":"boolean"},"syncWithLatestSolutionVersion":{"type":"boolean"}}},"Sy":{"type":"structure","members":{"dataLocation":{}}},"S15":{"type":"structure","required":["s3DataDestination"],"members":{"s3DataDestination":{"shape":"S6"}}},"S1h":{"type":"string","sensitive":true},"S1k":{"type":"list","member":{"type":"structure","required":["eventType","metricName","expression"],"members":{"eventType":{},"metricName":{},"expression":{}}}},"S1p":{"type":"structure","required":["roleArn"],"members":{"s3DataDestination":{"shape":"S6"},"roleArn":{}}},"S1s":{"type":"structure","members":{"itemExplorationConfig":{"shape":"Sc"},"minRecommendationRequestsPerSecond":{"type":"integer"},"trainingDataConfig":{"shape":"S1t"},"enableMetadataWithRecommendations":{"type":"boolean"}}},"S1t":{"type":"structure","members":{"excludedDatasetColumns":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"S23":{"type":"structure","members":{"eventValueThreshold":{},"hpoConfig":{"type":"structure","members":{"hpoObjective":{"type":"structure","members":{"type":{},"metricName":{},"metricRegex":{}}},"hpoResourceConfig":{"type":"structure","members":{"maxNumberOfTrainingJobs":{},"maxParallelTrainingJobs":{}}},"algorithmHyperParameterRanges":{"type":"structure","members":{"integerHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"integer"},"maxValue":{"type":"integer"}}}},"continuousHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"minValue":{"type":"double"},"maxValue":{"type":"double"}}}},"categoricalHyperParameterRanges":{"type":"list","member":{"type":"structure","members":{"name":{},"values":{"shape":"S2m"}}}}}}}},"algorithmHyperParameters":{"shape":"Sc"},"featureTransformationParameters":{"type":"map","key":{},"value":{}},"autoMLConfig":{"type":"structure","members":{"metricName":{},"recipeList":{"type":"list","member":{}}}},"optimizationObjective":{"type":"structure","members":{"itemAttribute":{},"objectiveSensitivity":{}}},"trainingDataConfig":{"shape":"S1t"},"autoTrainingConfig":{"type":"structure","members":{"schedulingExpression":{}}}}},"S2m":{"type":"list","member":{}},"S55":{"type":"map","key":{},"value":{"type":"double"}},"S5f":{"type":"structure","members":{"solutionVersionArn":{},"status":{},"trainingMode":{},"trainingType":{},"creationDateTime":{"type":"timestamp"},"lastUpdatedDateTime":{"type":"timestamp"},"failureReason":{}}}}}

/***/ }),
/* 571 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListBatchInferenceJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"batchInferenceJobs"},"ListBatchSegmentJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"batchSegmentJobs"},"ListCampaigns":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"campaigns"},"ListDatasetExportJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetExportJobs"},"ListDatasetGroups":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetGroups"},"ListDatasetImportJobs":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasetImportJobs"},"ListDatasets":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"datasets"},"ListEventTrackers":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"eventTrackers"},"ListFilters":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"Filters"},"ListMetricAttributionMetrics":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"metrics"},"ListMetricAttributions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"metricAttributions"},"ListRecipes":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"recipes"},"ListRecommenders":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"recommenders"},"ListSchemas":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"schemas"},"ListSolutionVersions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutionVersions"},"ListSolutions":{"input_token":"nextToken","limit_key":"maxResults","output_token":"nextToken","result_key":"solutions"}}}

/***/ }),
/* 572 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-03-22","endpointPrefix":"personalize-events","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Personalize Events","serviceId":"Personalize Events","signatureVersion":"v4","signingName":"personalize","uid":"personalize-events-2018-03-22"},"operations":{"PutActionInteractions":{"http":{"requestUri":"/action-interactions"},"input":{"type":"structure","required":["trackingId","actionInteractions"],"members":{"trackingId":{},"actionInteractions":{"type":"list","member":{"type":"structure","required":["actionId","sessionId","timestamp","eventType"],"members":{"actionId":{"shape":"S5"},"userId":{"shape":"S6"},"sessionId":{},"timestamp":{"type":"timestamp"},"eventType":{},"eventId":{},"recommendationId":{},"impression":{"type":"list","member":{"shape":"S5"}},"properties":{"jsonvalue":true,"type":"string","sensitive":true}}}}}}},"PutActions":{"http":{"requestUri":"/actions"},"input":{"type":"structure","required":["datasetArn","actions"],"members":{"datasetArn":{},"actions":{"type":"list","member":{"type":"structure","required":["actionId"],"members":{"actionId":{},"properties":{"jsonvalue":true,"type":"string","sensitive":true}}}}}}},"PutEvents":{"http":{"requestUri":"/events"},"input":{"type":"structure","required":["trackingId","sessionId","eventList"],"members":{"trackingId":{},"userId":{"shape":"S6"},"sessionId":{},"eventList":{"type":"list","member":{"type":"structure","required":["eventType","sentAt"],"members":{"eventId":{},"eventType":{},"eventValue":{"type":"float"},"itemId":{"shape":"Sk"},"properties":{"jsonvalue":true,"type":"string","sensitive":true},"sentAt":{"type":"timestamp"},"recommendationId":{},"impression":{"type":"list","member":{"shape":"Sk"}},"metricAttribution":{"type":"structure","required":["eventAttributionSource"],"members":{"eventAttributionSource":{}}}},"sensitive":true}}}}},"PutItems":{"http":{"requestUri":"/items"},"input":{"type":"structure","required":["datasetArn","items"],"members":{"datasetArn":{},"items":{"type":"list","member":{"type":"structure","required":["itemId"],"members":{"itemId":{},"properties":{"jsonvalue":true,"type":"string","sensitive":true}}}}}}},"PutUsers":{"http":{"requestUri":"/users"},"input":{"type":"structure","required":["datasetArn","users"],"members":{"datasetArn":{},"users":{"type":"list","member":{"type":"structure","required":["userId"],"members":{"userId":{},"properties":{"jsonvalue":true,"type":"string","sensitive":true}}}}}}}},"shapes":{"S5":{"type":"string","sensitive":true},"S6":{"type":"string","sensitive":true},"Sk":{"type":"string","sensitive":true}}}

/***/ }),
/* 573 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 574 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2018-05-22","endpointPrefix":"personalize-runtime","jsonVersion":"1.1","protocol":"rest-json","protocols":["rest-json"],"serviceFullName":"Amazon Personalize Runtime","serviceId":"Personalize Runtime","signatureVersion":"v4","signingName":"personalize","uid":"personalize-runtime-2018-05-22"},"operations":{"GetActionRecommendations":{"http":{"requestUri":"/action-recommendations"},"input":{"type":"structure","members":{"campaignArn":{},"userId":{},"numResults":{"type":"integer"},"filterArn":{},"filterValues":{"shape":"S5"}}},"output":{"type":"structure","members":{"actionList":{"type":"list","member":{"type":"structure","members":{"actionId":{},"score":{"type":"double"}}}},"recommendationId":{}}},"idempotent":true},"GetPersonalizedRanking":{"http":{"requestUri":"/personalize-ranking"},"input":{"type":"structure","required":["campaignArn","inputList","userId"],"members":{"campaignArn":{},"inputList":{"type":"list","member":{}},"userId":{},"context":{"shape":"Sh"},"filterArn":{},"filterValues":{"shape":"S5"},"metadataColumns":{"shape":"Sk"}}},"output":{"type":"structure","members":{"personalizedRanking":{"shape":"Sp"},"recommendationId":{}}},"idempotent":true},"GetRecommendations":{"http":{"requestUri":"/recommendations"},"input":{"type":"structure","members":{"campaignArn":{},"itemId":{},"userId":{},"numResults":{"type":"integer"},"context":{"shape":"Sh"},"filterArn":{},"filterValues":{"shape":"S5"},"recommenderArn":{},"promotions":{"type":"list","member":{"type":"structure","members":{"name":{},"percentPromotedItems":{"type":"integer"},"filterArn":{},"filterValues":{"shape":"S5"}}}},"metadataColumns":{"shape":"Sk"}}},"output":{"type":"structure","members":{"itemList":{"shape":"Sp"},"recommendationId":{}}},"idempotent":true}},"shapes":{"S5":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"Sh":{"type":"map","key":{},"value":{"type":"string","sensitive":true}},"Sk":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sp":{"type":"list","member":{"type":"structure","members":{"itemId":{},"score":{"type":"double"},"promotionName":{},"metadata":{"type":"map","key":{},"value":{},"sensitive":true},"reason":{"type":"list","member":{}}}}}}}

/***/ }),
/* 575 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 576 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-10","endpointPrefix":"polly","protocol":"rest-json","serviceFullName":"Amazon Polly","serviceId":"Polly","signatureVersion":"v4","uid":"polly-2016-06-10"},"operations":{"DeleteLexicon":{"http":{"method":"DELETE","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{}}},"DescribeVoices":{"http":{"method":"GET","requestUri":"/v1/voices","responseCode":200},"input":{"type":"structure","members":{"Engine":{"location":"querystring","locationName":"Engine"},"LanguageCode":{"location":"querystring","locationName":"LanguageCode"},"IncludeAdditionalLanguageCodes":{"location":"querystring","locationName":"IncludeAdditionalLanguageCodes","type":"boolean"},"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Voices":{"type":"list","member":{"type":"structure","members":{"Gender":{},"Id":{},"LanguageCode":{},"LanguageName":{},"Name":{},"AdditionalLanguageCodes":{"type":"list","member":{}},"SupportedEngines":{"type":"list","member":{}}}}},"NextToken":{}}}},"GetLexicon":{"http":{"method":"GET","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name"],"members":{"Name":{"location":"uri","locationName":"LexiconName"}}},"output":{"type":"structure","members":{"Lexicon":{"type":"structure","members":{"Content":{"shape":"Sl"},"Name":{}}},"LexiconAttributes":{"shape":"Sm"}}}},"GetSpeechSynthesisTask":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks/{TaskId}","responseCode":200},"input":{"type":"structure","required":["TaskId"],"members":{"TaskId":{"location":"uri","locationName":"TaskId"}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"ListLexicons":{"http":{"method":"GET","requestUri":"/v1/lexicons","responseCode":200},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"NextToken"}}},"output":{"type":"structure","members":{"Lexicons":{"type":"list","member":{"type":"structure","members":{"Name":{},"Attributes":{"shape":"Sm"}}}},"NextToken":{}}}},"ListSpeechSynthesisTasks":{"http":{"method":"GET","requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","members":{"MaxResults":{"location":"querystring","locationName":"MaxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"NextToken"},"Status":{"location":"querystring","locationName":"Status"}}},"output":{"type":"structure","members":{"NextToken":{},"SynthesisTasks":{"type":"list","member":{"shape":"Sv"}}}}},"PutLexicon":{"http":{"method":"PUT","requestUri":"/v1/lexicons/{LexiconName}","responseCode":200},"input":{"type":"structure","required":["Name","Content"],"members":{"Name":{"location":"uri","locationName":"LexiconName"},"Content":{"shape":"Sl"}}},"output":{"type":"structure","members":{}}},"StartSpeechSynthesisTask":{"http":{"requestUri":"/v1/synthesisTasks","responseCode":200},"input":{"type":"structure","required":["OutputFormat","OutputS3BucketName","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"SampleRate":{},"SnsTopicArn":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"SynthesisTask":{"shape":"Sv"}}}},"SynthesizeSpeech":{"http":{"requestUri":"/v1/speech","responseCode":200},"input":{"type":"structure","required":["OutputFormat","Text","VoiceId"],"members":{"Engine":{},"LanguageCode":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"Text":{},"TextType":{},"VoiceId":{}}},"output":{"type":"structure","members":{"AudioStream":{"type":"blob","streaming":true},"ContentType":{"location":"header","locationName":"Content-Type"},"RequestCharacters":{"location":"header","locationName":"x-amzn-RequestCharacters","type":"integer"}},"payload":"AudioStream"}}},"shapes":{"Sl":{"type":"string","sensitive":true},"Sm":{"type":"structure","members":{"Alphabet":{},"LanguageCode":{},"LastModified":{"type":"timestamp"},"LexiconArn":{},"LexemesCount":{"type":"integer"},"Size":{"type":"integer"}}},"Sv":{"type":"structure","members":{"Engine":{},"TaskId":{},"TaskStatus":{},"TaskStatusReason":{},"OutputUri":{},"CreationTime":{"type":"timestamp"},"RequestCharacters":{"type":"integer"},"SnsTopicArn":{},"LexiconNames":{"shape":"S12"},"OutputFormat":{},"SampleRate":{},"SpeechMarkTypes":{"shape":"S15"},"TextType":{},"VoiceId":{},"LanguageCode":{}}},"S12":{"type":"list","member":{}},"S15":{"type":"list","member":{}}}}

/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListSpeechSynthesisTasks":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-15","endpointPrefix":"api.pricing","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"AWS Pricing","serviceFullName":"AWS Price List Service","serviceId":"Pricing","signatureVersion":"v4","signingName":"pricing","targetPrefix":"AWSPriceListService","uid":"pricing-2017-10-15"},"operations":{"DescribeServices":{"input":{"type":"structure","members":{"ServiceCode":{},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","required":["ServiceCode"],"members":{"ServiceCode":{},"AttributeNames":{"type":"list","member":{}}}}},"FormatVersion":{},"NextToken":{}}}},"GetAttributeValues":{"input":{"type":"structure","required":["ServiceCode","AttributeName"],"members":{"ServiceCode":{},"AttributeName":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"AttributeValues":{"type":"list","member":{"type":"structure","members":{"Value":{}}}},"NextToken":{}}}},"GetPriceListFileUrl":{"input":{"type":"structure","required":["PriceListArn","FileFormat"],"members":{"PriceListArn":{},"FileFormat":{}}},"output":{"type":"structure","members":{"Url":{}}}},"GetProducts":{"input":{"type":"structure","required":["ServiceCode"],"members":{"ServiceCode":{},"Filters":{"type":"list","member":{"type":"structure","required":["Type","Field","Value"],"members":{"Type":{},"Field":{},"Value":{}}}},"FormatVersion":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"FormatVersion":{},"PriceList":{"type":"list","member":{"jsonvalue":true}},"NextToken":{}}}},"ListPriceLists":{"input":{"type":"structure","required":["ServiceCode","EffectiveDate","CurrencyCode"],"members":{"ServiceCode":{},"EffectiveDate":{"type":"timestamp"},"RegionCode":{},"CurrencyCode":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"PriceLists":{"type":"list","member":{"type":"structure","members":{"PriceListArn":{},"RegionCode":{},"CurrencyCode":{},"FileFormats":{"type":"list","member":{}}}}},"NextToken":{}}}}},"shapes":{}}

/***/ }),
/* 579 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeServices":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"Services"},"GetAttributeValues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"AttributeValues"},"GetProducts":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PriceList"},"ListPriceLists":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"PriceLists"}}}

/***/ }),
/* 580 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{}}

/***/ }),
/* 581 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-01-10","endpointPrefix":"rds","protocol":"query","protocols":["query"],"serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-01-10","xmlNamespace":"http://rds.amazonaws.com/doc/2013-01-10/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1c"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S25"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S25","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1c","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2f"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2f"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1o","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3m","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3o"}},"wrapper":true}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1i"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1o"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3m"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2f"}}},"output":{"shape":"S3z","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"Id":{},"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMembership":{"type":"structure","members":{"OptionGroupName":{},"Status":{}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1c":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1i":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1o":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S25":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2f":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3m":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3o"}},"wrapper":true},"S3o":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S3z":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 582 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 583 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-02-12","endpointPrefix":"rds","protocol":"query","protocols":["query"],"serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-02-12","xmlNamespace":"http://rds.amazonaws.com/doc/2013-02-12/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1d"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S28"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S28","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1d","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2n"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2n"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1p","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S3w","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S3y"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1j"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1p"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S3w"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2n"}}},"output":{"shape":"S4b","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1d":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1j":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1p":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1t","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1t":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S28":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2n":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S3w":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S3y"}},"wrapper":true},"S3y":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4b":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 584 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 585 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-09-09","endpointPrefix":"rds","protocol":"query","protocols":["query"],"serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2013-09-09","xmlNamespace":"http://rds.amazonaws.com/doc/2013-09-09/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S1f"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sk"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2d"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2d","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"St","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S1f","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2s"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sk","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S11","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2s"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S27"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1r","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S14","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S41","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S27"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S43"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S27"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"Sp"},"VpcSecurityGroupIds":{"shape":"Sq"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1l"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S11"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"Sp"},"VpcSecurityGroupMemberships":{"shape":"Sq"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1r"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S41"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2s"}}},"output":{"shape":"S4g","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"St"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{}},"wrapper":true},"Sp":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"Sq":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"St":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sv"},"VpcSecurityGroups":{"shape":"Sx"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S11"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}}},"wrapper":true},"Sv":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"Sx":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S11":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S14"},"SubnetStatus":{}}}}},"wrapper":true},"S14":{"type":"structure","members":{"Name":{},"ProvisionedIopsCapable":{"type":"boolean"}},"wrapper":true},"S1f":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"S1l":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S1r":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"S1v","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sv"},"VpcSecurityGroupMemberships":{"shape":"Sx"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"S1v":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S27":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2d":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2s":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S41":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S43"}},"wrapper":true},"S43":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4g":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 586 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 587 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"deleted","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]}}}

/***/ }),
/* 588 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-09-01","endpointPrefix":"rds","protocol":"query","protocols":["query"],"serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-09-01","xmlNamespace":"http://rds.amazonaws.com/doc/2014-09-01/"},"operations":{"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"S9"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","AllocatedStorage","DBInstanceClass","Engine","MasterUsername","MasterUserPassword"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier","SourceDBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"S9"},"DBSubnetGroupName":{},"StorageType":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"Sk"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"SourceIds":{"shape":"S5"},"Enabled":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"Sn"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"locationName":"DBEngineVersion","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2h"},"SupportedCharacterSets":{"type":"list","member":{"shape":"S2h","locationName":"CharacterSet"}}}}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S17","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"Sk","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S2w"},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sd","locationName":"DBSecurityGroup"}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"Sn","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S1b","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S2w"}},"wrapper":true}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S6"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S4","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S6"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S6"},"Date":{"type":"timestamp"}}}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"}}}}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S2b"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"St","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZones":{"type":"list","member":{"shape":"S1e","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"S45","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S2b"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"S47"}},"wrapper":true}}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S2b"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"S9"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSecurityGroups":{"shape":"S13"},"VpcSecurityGroupIds":{"shape":"S14"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S1u"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S1b"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S6"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"DBSecurityGroupMemberships":{"shape":"S13"},"VpcSecurityGroupMemberships":{"shape":"S14"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"St"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"S45"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S4"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S2w"}}},"output":{"shape":"S4k","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBSnapshotIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["SourceDBInstanceIdentifier","TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"S9"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S17"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sd"}}}}},"shapes":{"S4":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S5"},"EventCategoriesList":{"shape":"S6"},"Enabled":{"type":"boolean"}},"wrapper":true},"S5":{"type":"list","member":{"locationName":"SourceId"}},"S6":{"type":"list","member":{"locationName":"EventCategory"}},"S9":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sd":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}}},"wrapper":true},"Sk":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{}},"wrapper":true},"Sn":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"St":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionSettings":{"type":"list","member":{"shape":"Sx","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"Sy"},"VpcSecurityGroupMemberships":{"shape":"S10"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{}},"wrapper":true},"Sx":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"Sy":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S10":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S13":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S14":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S17":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"}}},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"Sy"},"VpcSecurityGroups":{"shape":"S10"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S1b"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S1e"},"SubnetStatus":{}}}}},"wrapper":true},"S1e":{"type":"structure","members":{"Name":{}},"wrapper":true},"S1u":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S2b":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S2h":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2w":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{}}}},"S45":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"S47"}},"wrapper":true},"S47":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"S4k":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 589 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 590 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-10-31","endpointPrefix":"rds","protocol":"query","protocols":["query"],"serviceAbbreviation":"Amazon RDS","serviceFullName":"Amazon Relational Database Service","serviceId":"RDS","signatureVersion":"v4","uid":"rds-2014-10-31","xmlNamespace":"http://rds.amazonaws.com/doc/2014-10-31/"},"operations":{"AddRoleToDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddRoleToDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"AddSourceIdentifierToSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"AddSourceIdentifierToSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"Sb"}}}},"ApplyPendingMaintenanceAction":{"input":{"type":"structure","required":["ResourceIdentifier","ApplyAction","OptInType"],"members":{"ResourceIdentifier":{},"ApplyAction":{},"OptInType":{}}},"output":{"resultWrapper":"ApplyPendingMaintenanceActionResult","type":"structure","members":{"ResourcePendingMaintenanceActions":{"shape":"Sf"}}}},"AuthorizeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"BacktrackDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","BacktrackTo"],"members":{"DBClusterIdentifier":{},"BacktrackTo":{"type":"timestamp"},"Force":{"type":"boolean"},"UseEarliestTimeOnPointInTimeUnavailable":{"type":"boolean"}}},"output":{"shape":"Ss","resultWrapper":"BacktrackDBClusterResult"}},"CancelExportTask":{"input":{"type":"structure","required":["ExportTaskIdentifier"],"members":{"ExportTaskIdentifier":{}}},"output":{"shape":"Su","resultWrapper":"CancelExportTaskResult"}},"CopyDBClusterParameterGroup":{"input":{"type":"structure","required":["SourceDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupIdentifier","TargetDBClusterParameterGroupDescription"],"members":{"SourceDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupIdentifier":{},"TargetDBClusterParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"S10"}}}},"CopyDBClusterSnapshot":{"input":{"type":"structure","required":["SourceDBClusterSnapshotIdentifier","TargetDBClusterSnapshotIdentifier"],"members":{"SourceDBClusterSnapshotIdentifier":{},"TargetDBClusterSnapshotIdentifier":{},"KmsKeyId":{},"PreSignedUrl":{},"CopyTags":{"type":"boolean"},"Tags":{"shape":"Sb"},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S13"}}}},"CopyDBParameterGroup":{"input":{"type":"structure","required":["SourceDBParameterGroupIdentifier","TargetDBParameterGroupIdentifier","TargetDBParameterGroupDescription"],"members":{"SourceDBParameterGroupIdentifier":{},"TargetDBParameterGroupIdentifier":{},"TargetDBParameterGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S18"}}}},"CopyDBSnapshot":{"input":{"type":"structure","required":["SourceDBSnapshotIdentifier","TargetDBSnapshotIdentifier"],"members":{"SourceDBSnapshotIdentifier":{},"TargetDBSnapshotIdentifier":{},"KmsKeyId":{},"Tags":{"shape":"Sb"},"CopyTags":{"type":"boolean"},"PreSignedUrl":{},"OptionGroupName":{},"TargetCustomAvailabilityZone":{},"CopyOptionGroup":{"type":"boolean"},"SourceRegion":{}}},"output":{"resultWrapper":"CopyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S1b"}}}},"CopyOptionGroup":{"input":{"type":"structure","required":["SourceOptionGroupIdentifier","TargetOptionGroupIdentifier","TargetOptionGroupDescription"],"members":{"SourceOptionGroupIdentifier":{},"TargetOptionGroupIdentifier":{},"TargetOptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CopyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1g"}}}},"CreateBlueGreenDeployment":{"input":{"type":"structure","required":["BlueGreenDeploymentName","Source"],"members":{"BlueGreenDeploymentName":{},"Source":{},"TargetEngineVersion":{},"TargetDBParameterGroupName":{},"TargetDBClusterParameterGroupName":{},"Tags":{"shape":"Sb"},"TargetDBInstanceClass":{},"UpgradeTargetStorageConfig":{"type":"boolean"}}},"output":{"resultWrapper":"CreateBlueGreenDeploymentResult","type":"structure","members":{"BlueGreenDeployment":{"shape":"S1x"}}}},"CreateCustomDBEngineVersion":{"input":{"type":"structure","required":["Engine","EngineVersion"],"members":{"Engine":{},"EngineVersion":{},"DatabaseInstallationFilesS3BucketName":{},"DatabaseInstallationFilesS3Prefix":{},"ImageId":{},"KMSKeyId":{},"Description":{},"Manifest":{},"Tags":{"shape":"Sb"},"SourceCustomDbEngineVersionIdentifier":{},"UseAwsProvidedLatestImage":{"type":"boolean"}}},"output":{"shape":"S2g","resultWrapper":"CreateCustomDBEngineVersionResult"}},"CreateDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"S14"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S2t"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"EngineMode":{},"ScalingConfiguration":{"shape":"S2v"},"RdsCustomClusterConfiguration":{"shape":"S2w"},"DeletionProtection":{"type":"boolean"},"GlobalClusterIdentifier":{},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"EnableGlobalWriteForwarding":{"type":"boolean"},"DBClusterInstanceClass":{},"AllocatedStorage":{"type":"integer"},"StorageType":{},"Iops":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableLimitlessDatabase":{"type":"boolean"},"ServerlessV2ScalingConfiguration":{"shape":"S2y"},"NetworkType":{},"DBSystemId":{},"ManageMasterUserPassword":{"type":"boolean"},"MasterUserSecretKmsKeyId":{},"EnableLocalWriteForwarding":{"type":"boolean"},"CACertificateIdentifier":{},"EngineLifecycleSupport":{},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"CreateDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterIdentifier","DBClusterEndpointIdentifier","EndpointType"],"members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"},"Tags":{"shape":"Sb"}}},"output":{"shape":"S3q","resultWrapper":"CreateDBClusterEndpointResult"}},"CreateDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterParameterGroupResult","type":"structure","members":{"DBClusterParameterGroup":{"shape":"S10"}}}},"CreateDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","DBClusterIdentifier"],"members":{"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S13"}}}},"CreateDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S3w"},"VpcSecurityGroupIds":{"shape":"S2t"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CharacterSetName":{},"NcharCharacterSetName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBClusterIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"Domain":{},"DomainFqdn":{},"DomainOu":{},"DomainAuthSecretArn":{},"DomainDnsIps":{"shape":"Sv"},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"PromotionTier":{"type":"integer"},"Timezone":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"ProcessorFeatures":{"shape":"S1c"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"},"EnableCustomerOwnedIp":{"type":"boolean"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{},"StorageThroughput":{"type":"integer"},"ManageMasterUserPassword":{"type":"boolean"},"MasterUserSecretKmsKeyId":{},"CACertificateIdentifier":{},"DBSystemId":{},"DedicatedLogVolume":{"type":"boolean"},"MultiTenant":{"type":"boolean"},"EngineLifecycleSupport":{}}},"output":{"resultWrapper":"CreateDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"CreateDBInstanceReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SourceDBInstanceIdentifier":{},"DBInstanceClass":{},"AvailabilityZone":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"Iops":{"type":"integer"},"OptionGroupName":{},"DBParameterGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"DBSubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"S2t"},"StorageType":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"KmsKeyId":{},"PreSignedUrl":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"ProcessorFeatures":{"shape":"S1c"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"DomainFqdn":{},"DomainOu":{},"DomainAuthSecretArn":{},"DomainDnsIps":{"shape":"Sv"},"ReplicaMode":{},"MaxAllocatedStorage":{"type":"integer"},"CustomIamInstanceProfile":{},"NetworkType":{},"StorageThroughput":{"type":"integer"},"EnableCustomerOwnedIp":{"type":"boolean"},"AllocatedStorage":{"type":"integer"},"SourceDBClusterIdentifier":{},"DedicatedLogVolume":{"type":"boolean"},"UpgradeStorageConfig":{"type":"boolean"},"CACertificateIdentifier":{},"SourceRegion":{}}},"output":{"resultWrapper":"CreateDBInstanceReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"CreateDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","DBParameterGroupFamily","Description"],"members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBParameterGroupResult","type":"structure","members":{"DBParameterGroup":{"shape":"S18"}}}},"CreateDBProxy":{"input":{"type":"structure","required":["DBProxyName","EngineFamily","Auth","RoleArn","VpcSubnetIds"],"members":{"DBProxyName":{},"EngineFamily":{},"Auth":{"shape":"S4q"},"RoleArn":{},"VpcSubnetIds":{"shape":"Sv"},"VpcSecurityGroupIds":{"shape":"Sv"},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S4w"}}}},"CreateDBProxyEndpoint":{"input":{"type":"structure","required":["DBProxyName","DBProxyEndpointName","VpcSubnetIds"],"members":{"DBProxyName":{},"DBProxyEndpointName":{},"VpcSubnetIds":{"shape":"Sv"},"VpcSecurityGroupIds":{"shape":"Sv"},"TargetRole":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBProxyEndpointResult","type":"structure","members":{"DBProxyEndpoint":{"shape":"S55"}}}},"CreateDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName","DBSecurityGroupDescription"],"members":{"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSecurityGroupResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"CreateDBShardGroup":{"input":{"type":"structure","required":["DBShardGroupIdentifier","DBClusterIdentifier","MaxACU"],"members":{"DBShardGroupIdentifier":{},"DBClusterIdentifier":{},"ComputeRedundancy":{"type":"integer"},"MaxACU":{"type":"double"},"PubliclyAccessible":{"type":"boolean"}}},"output":{"shape":"S5a","resultWrapper":"CreateDBShardGroupResult"}},"CreateDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier","DBInstanceIdentifier"],"members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S1b"}}}},"CreateDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","DBSubnetGroupDescription","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S5f"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S42"}}}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"SourceIds":{"shape":"S7"},"Enabled":{"type":"boolean"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"CreateGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"SourceDBClusterIdentifier":{},"Engine":{},"EngineVersion":{},"EngineLifecycleSupport":{},"DeletionProtection":{"type":"boolean"},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"}}},"output":{"resultWrapper":"CreateGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S5l"}}}},"CreateIntegration":{"input":{"type":"structure","required":["SourceArn","TargetArn","IntegrationName"],"members":{"SourceArn":{},"TargetArn":{},"IntegrationName":{},"KMSKeyId":{},"AdditionalEncryptionContext":{"shape":"S5w"},"Tags":{"shape":"Sb"},"DataFilter":{},"Description":{}}},"output":{"shape":"S5z","resultWrapper":"CreateIntegrationResult"}},"CreateOptionGroup":{"input":{"type":"structure","required":["OptionGroupName","EngineName","MajorEngineVersion","OptionGroupDescription"],"members":{"OptionGroupName":{},"EngineName":{},"MajorEngineVersion":{},"OptionGroupDescription":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1g"}}}},"CreateTenantDatabase":{"input":{"type":"structure","required":["DBInstanceIdentifier","TenantDBName","MasterUsername","MasterUserPassword"],"members":{"DBInstanceIdentifier":{},"TenantDBName":{},"MasterUsername":{},"MasterUserPassword":{"shape":"S67"},"CharacterSetName":{},"NcharCharacterSetName":{},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"CreateTenantDatabaseResult","type":"structure","members":{"TenantDatabase":{"shape":"S69"}}}},"DeleteBlueGreenDeployment":{"input":{"type":"structure","required":["BlueGreenDeploymentIdentifier"],"members":{"BlueGreenDeploymentIdentifier":{},"DeleteTarget":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteBlueGreenDeploymentResult","type":"structure","members":{"BlueGreenDeployment":{"shape":"S1x"}}}},"DeleteCustomDBEngineVersion":{"input":{"type":"structure","required":["Engine","EngineVersion"],"members":{"Engine":{},"EngineVersion":{}}},"output":{"shape":"S2g","resultWrapper":"DeleteCustomDBEngineVersionResult"}},"DeleteDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{},"DeleteAutomatedBackups":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"DeleteDBClusterAutomatedBackup":{"input":{"type":"structure","required":["DbClusterResourceId"],"members":{"DbClusterResourceId":{}}},"output":{"resultWrapper":"DeleteDBClusterAutomatedBackupResult","type":"structure","members":{"DBClusterAutomatedBackup":{"shape":"S6i"}}}},"DeleteDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{}}},"output":{"shape":"S3q","resultWrapper":"DeleteDBClusterEndpointResult"}},"DeleteDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{}}}},"DeleteDBClusterSnapshot":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBClusterSnapshotResult","type":"structure","members":{"DBClusterSnapshot":{"shape":"S13"}}}},"DeleteDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{},"DeleteAutomatedBackups":{"type":"boolean"}}},"output":{"resultWrapper":"DeleteDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"DeleteDBInstanceAutomatedBackup":{"input":{"type":"structure","members":{"DbiResourceId":{},"DBInstanceAutomatedBackupsArn":{}}},"output":{"resultWrapper":"DeleteDBInstanceAutomatedBackupResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S6s"}}}},"DeleteDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{}}}},"DeleteDBProxy":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{}}},"output":{"resultWrapper":"DeleteDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S4w"}}}},"DeleteDBProxyEndpoint":{"input":{"type":"structure","required":["DBProxyEndpointName"],"members":{"DBProxyEndpointName":{}}},"output":{"resultWrapper":"DeleteDBProxyEndpointResult","type":"structure","members":{"DBProxyEndpoint":{"shape":"S55"}}}},"DeleteDBSecurityGroup":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{}}}},"DeleteDBShardGroup":{"input":{"type":"structure","required":["DBShardGroupIdentifier"],"members":{"DBShardGroupIdentifier":{}}},"output":{"shape":"S5a","resultWrapper":"DeleteDBShardGroupResult"}},"DeleteDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S1b"}}}},"DeleteDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName"],"members":{"DBSubnetGroupName":{}}}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}},"output":{"resultWrapper":"DeleteEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"DeleteGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier"],"members":{"GlobalClusterIdentifier":{}}},"output":{"resultWrapper":"DeleteGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S5l"}}}},"DeleteIntegration":{"input":{"type":"structure","required":["IntegrationIdentifier"],"members":{"IntegrationIdentifier":{}}},"output":{"shape":"S5z","resultWrapper":"DeleteIntegrationResult"}},"DeleteOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{}}}},"DeleteTenantDatabase":{"input":{"type":"structure","required":["DBInstanceIdentifier","TenantDBName"],"members":{"DBInstanceIdentifier":{},"TenantDBName":{},"SkipFinalSnapshot":{"type":"boolean"},"FinalDBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DeleteTenantDatabaseResult","type":"structure","members":{"TenantDatabase":{"shape":"S69"}}}},"DeregisterDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"DBInstanceIdentifiers":{"shape":"Sv"},"DBClusterIdentifiers":{"shape":"Sv"}}},"output":{"resultWrapper":"DeregisterDBProxyTargetsResult","type":"structure","members":{}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountQuotas":{"type":"list","member":{"locationName":"AccountQuota","type":"structure","members":{"AccountQuotaName":{},"Used":{"type":"long"},"Max":{"type":"long"}},"wrapper":true}}}}},"DescribeBlueGreenDeployments":{"input":{"type":"structure","members":{"BlueGreenDeploymentIdentifier":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeBlueGreenDeploymentsResult","type":"structure","members":{"BlueGreenDeployments":{"type":"list","member":{"shape":"S1x"}},"Marker":{}}}},"DescribeCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCertificatesResult","type":"structure","members":{"DefaultCertificateForNewLaunches":{},"Certificates":{"type":"list","member":{"shape":"S7t","locationName":"Certificate"}},"Marker":{}}}},"DescribeDBClusterAutomatedBackups":{"input":{"type":"structure","members":{"DbClusterResourceId":{},"DBClusterIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterAutomatedBackupsResult","type":"structure","members":{"Marker":{},"DBClusterAutomatedBackups":{"type":"list","member":{"shape":"S6i","locationName":"DBClusterAutomatedBackup"}}}}},"DescribeDBClusterBacktracks":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterBacktracksResult","type":"structure","members":{"Marker":{},"DBClusterBacktracks":{"type":"list","member":{"shape":"Ss","locationName":"DBClusterBacktrack"}}}}},"DescribeDBClusterEndpoints":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterEndpointIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterEndpointsResult","type":"structure","members":{"Marker":{},"DBClusterEndpoints":{"type":"list","member":{"shape":"S3q","locationName":"DBClusterEndpointList"}}}}},"DescribeDBClusterParameterGroups":{"input":{"type":"structure","members":{"DBClusterParameterGroupName":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"DBClusterParameterGroups":{"type":"list","member":{"shape":"S10","locationName":"DBClusterParameterGroup"}}}}},"DescribeDBClusterParameters":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"Source":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S88"},"Marker":{}}}},"DescribeDBClusterSnapshotAttributes":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier"],"members":{"DBClusterSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotAttributesResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S8d"}}}},"DescribeDBClusterSnapshots":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"DBClusterSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"},"DbClusterResourceId":{}}},"output":{"resultWrapper":"DescribeDBClusterSnapshotsResult","type":"structure","members":{"Marker":{},"DBClusterSnapshots":{"type":"list","member":{"shape":"S13","locationName":"DBClusterSnapshot"}}}}},"DescribeDBClusters":{"input":{"type":"structure","members":{"DBClusterIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBClustersResult","type":"structure","members":{"Marker":{},"DBClusters":{"type":"list","member":{"shape":"S31","locationName":"DBCluster"}}}}},"DescribeDBEngineVersions":{"input":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{},"DefaultOnly":{"type":"boolean"},"ListSupportedCharacterSets":{"type":"boolean"},"ListSupportedTimezones":{"type":"boolean"},"IncludeAll":{"type":"boolean"}}},"output":{"resultWrapper":"DescribeDBEngineVersionsResult","type":"structure","members":{"Marker":{},"DBEngineVersions":{"type":"list","member":{"shape":"S2g","locationName":"DBEngineVersion"}}}}},"DescribeDBInstanceAutomatedBackups":{"input":{"type":"structure","members":{"DbiResourceId":{},"DBInstanceIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{},"DBInstanceAutomatedBackupsArn":{}}},"output":{"resultWrapper":"DescribeDBInstanceAutomatedBackupsResult","type":"structure","members":{"Marker":{},"DBInstanceAutomatedBackups":{"type":"list","member":{"shape":"S6s","locationName":"DBInstanceAutomatedBackup"}}}}},"DescribeDBInstances":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBInstancesResult","type":"structure","members":{"Marker":{},"DBInstances":{"type":"list","member":{"shape":"S3y","locationName":"DBInstance"}}}}},"DescribeDBLogFiles":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"FilenameContains":{},"FileLastWritten":{"type":"long"},"FileSize":{"type":"long"},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBLogFilesResult","type":"structure","members":{"DescribeDBLogFiles":{"type":"list","member":{"locationName":"DescribeDBLogFilesDetails","type":"structure","members":{"LogFileName":{},"LastWritten":{"type":"long"},"Size":{"type":"long"}}}},"Marker":{}}}},"DescribeDBParameterGroups":{"input":{"type":"structure","members":{"DBParameterGroupName":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParameterGroupsResult","type":"structure","members":{"Marker":{},"DBParameterGroups":{"type":"list","member":{"shape":"S18","locationName":"DBParameterGroup"}}}}},"DescribeDBParameters":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"Source":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBParametersResult","type":"structure","members":{"Parameters":{"shape":"S88"},"Marker":{}}}},"DescribeDBProxies":{"input":{"type":"structure","members":{"DBProxyName":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxiesResult","type":"structure","members":{"DBProxies":{"type":"list","member":{"shape":"S4w"}},"Marker":{}}}},"DescribeDBProxyEndpoints":{"input":{"type":"structure","members":{"DBProxyName":{},"DBProxyEndpointName":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyEndpointsResult","type":"structure","members":{"DBProxyEndpoints":{"type":"list","member":{"shape":"S55"}},"Marker":{}}}},"DescribeDBProxyTargetGroups":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyTargetGroupsResult","type":"structure","members":{"TargetGroups":{"type":"list","member":{"shape":"S9e"}},"Marker":{}}}},"DescribeDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBProxyTargetsResult","type":"structure","members":{"Targets":{"shape":"S9i"},"Marker":{}}}},"DescribeDBRecommendations":{"input":{"type":"structure","members":{"LastUpdatedAfter":{"type":"timestamp"},"LastUpdatedBefore":{"type":"timestamp"},"Locale":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBRecommendationsResult","type":"structure","members":{"DBRecommendations":{"type":"list","member":{"shape":"S9s"}},"Marker":{}}}},"DescribeDBSecurityGroups":{"input":{"type":"structure","members":{"DBSecurityGroupName":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSecurityGroupsResult","type":"structure","members":{"Marker":{},"DBSecurityGroups":{"type":"list","member":{"shape":"Sl","locationName":"DBSecurityGroup"}}}}},"DescribeDBShardGroups":{"input":{"type":"structure","members":{"DBShardGroupIdentifier":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeDBShardGroupsResult","type":"structure","members":{"DBShardGroups":{"type":"list","member":{"shape":"S5a","locationName":"DBShardGroup"}},"Marker":{}}}},"DescribeDBSnapshotAttributes":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"DescribeDBSnapshotAttributesResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"Sal"}}}},"DescribeDBSnapshotTenantDatabases":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{},"DbiResourceId":{}}},"output":{"resultWrapper":"DescribeDBSnapshotTenantDatabasesResult","type":"structure","members":{"Marker":{},"DBSnapshotTenantDatabases":{"type":"list","member":{"locationName":"DBSnapshotTenantDatabase","type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"DbiResourceId":{},"EngineName":{},"SnapshotType":{},"TenantDatabaseCreateTime":{"type":"timestamp"},"TenantDBName":{},"MasterUsername":{},"TenantDatabaseResourceId":{},"CharacterSetName":{},"DBSnapshotTenantDatabaseARN":{},"NcharCharacterSetName":{},"TagList":{"shape":"Sb"}},"wrapper":true}}}}},"DescribeDBSnapshots":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"SnapshotType":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{},"IncludeShared":{"type":"boolean"},"IncludePublic":{"type":"boolean"},"DbiResourceId":{}}},"output":{"resultWrapper":"DescribeDBSnapshotsResult","type":"structure","members":{"Marker":{},"DBSnapshots":{"type":"list","member":{"shape":"S1b","locationName":"DBSnapshot"}}}}},"DescribeDBSubnetGroups":{"input":{"type":"structure","members":{"DBSubnetGroupName":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDBSubnetGroupsResult","type":"structure","members":{"Marker":{},"DBSubnetGroups":{"type":"list","member":{"shape":"S42","locationName":"DBSubnetGroup"}}}}},"DescribeEngineDefaultClusterParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultClusterParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"Sb0"}}}},"DescribeEngineDefaultParameters":{"input":{"type":"structure","required":["DBParameterGroupFamily"],"members":{"DBParameterGroupFamily":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEngineDefaultParametersResult","type":"structure","members":{"EngineDefaults":{"shape":"Sb0"}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{},"Filters":{"shape":"S7k"}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"EventCategories":{"shape":"S8"}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S6","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"EventCategories":{"shape":"S8"},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S8"},"Date":{"type":"timestamp"},"SourceArn":{}}}}}}},"DescribeExportTasks":{"input":{"type":"structure","members":{"ExportTaskIdentifier":{},"SourceArn":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"},"SourceType":{}}},"output":{"resultWrapper":"DescribeExportTasksResult","type":"structure","members":{"Marker":{},"ExportTasks":{"type":"list","member":{"shape":"Su","locationName":"ExportTask"}}}}},"DescribeGlobalClusters":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeGlobalClustersResult","type":"structure","members":{"Marker":{},"GlobalClusters":{"type":"list","member":{"shape":"S5l","locationName":"GlobalClusterMember"}}}}},"DescribeIntegrations":{"input":{"type":"structure","members":{"IntegrationIdentifier":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeIntegrationsResult","type":"structure","members":{"Marker":{},"Integrations":{"type":"list","member":{"shape":"S5z","locationName":"Integration"}}}}},"DescribeOptionGroupOptions":{"input":{"type":"structure","required":["EngineName"],"members":{"EngineName":{},"MajorEngineVersion":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOptionGroupOptionsResult","type":"structure","members":{"OptionGroupOptions":{"type":"list","member":{"locationName":"OptionGroupOption","type":"structure","members":{"Name":{},"Description":{},"EngineName":{},"MajorEngineVersion":{},"MinimumRequiredMinorEngineVersion":{},"PortRequired":{"type":"boolean"},"DefaultPort":{"type":"integer"},"OptionsDependedOn":{"type":"list","member":{"locationName":"OptionName"}},"OptionsConflictsWith":{"type":"list","member":{"locationName":"OptionConflictName"}},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"RequiresAutoMinorEngineVersionUpgrade":{"type":"boolean"},"VpcOnly":{"type":"boolean"},"SupportsOptionVersionDowngrade":{"type":"boolean"},"OptionGroupOptionSettings":{"type":"list","member":{"locationName":"OptionGroupOptionSetting","type":"structure","members":{"SettingName":{},"SettingDescription":{},"DefaultValue":{},"ApplyType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsRequired":{"type":"boolean"},"MinimumEngineVersionPerAllowedValue":{"type":"list","member":{"locationName":"MinimumEngineVersionPerAllowedValue","type":"structure","members":{"AllowedValue":{},"MinimumEngineVersion":{}}}}}}},"OptionGroupOptionVersions":{"type":"list","member":{"locationName":"OptionVersion","type":"structure","members":{"Version":{},"IsDefault":{"type":"boolean"}}}},"CopyableCrossAccount":{"type":"boolean"}}}},"Marker":{}}}},"DescribeOptionGroups":{"input":{"type":"structure","members":{"OptionGroupName":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"},"EngineName":{},"MajorEngineVersion":{}}},"output":{"resultWrapper":"DescribeOptionGroupsResult","type":"structure","members":{"OptionGroupsList":{"type":"list","member":{"shape":"S1g","locationName":"OptionGroup"}},"Marker":{}}}},"DescribeOrderableDBInstanceOptions":{"input":{"type":"structure","required":["Engine"],"members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZoneGroup":{},"Vpc":{"type":"boolean"},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableDBInstanceOptionsResult","type":"structure","members":{"OrderableDBInstanceOptions":{"type":"list","member":{"locationName":"OrderableDBInstanceOption","type":"structure","members":{"Engine":{},"EngineVersion":{},"DBInstanceClass":{},"LicenseModel":{},"AvailabilityZoneGroup":{},"AvailabilityZones":{"type":"list","member":{"shape":"S45","locationName":"AvailabilityZone"}},"MultiAZCapable":{"type":"boolean"},"ReadReplicaCapable":{"type":"boolean"},"Vpc":{"type":"boolean"},"SupportsStorageEncryption":{"type":"boolean"},"StorageType":{},"SupportsIops":{"type":"boolean"},"SupportsEnhancedMonitoring":{"type":"boolean"},"SupportsIAMDatabaseAuthentication":{"type":"boolean"},"SupportsPerformanceInsights":{"type":"boolean"},"MinStorageSize":{"type":"integer"},"MaxStorageSize":{"type":"integer"},"MinIopsPerDbInstance":{"type":"integer"},"MaxIopsPerDbInstance":{"type":"integer"},"MinIopsPerGib":{"type":"double"},"MaxIopsPerGib":{"type":"double"},"AvailableProcessorFeatures":{"shape":"Sc9"},"SupportedEngineModes":{"shape":"S2m"},"SupportsStorageAutoscaling":{"type":"boolean"},"SupportsKerberosAuthentication":{"type":"boolean"},"OutpostCapable":{"type":"boolean"},"SupportedActivityStreamModes":{"type":"list","member":{}},"SupportsGlobalDatabases":{"type":"boolean"},"SupportsClusters":{"type":"boolean"},"SupportedNetworkTypes":{"shape":"Sv"},"SupportsStorageThroughput":{"type":"boolean"},"MinStorageThroughputPerDbInstance":{"type":"integer"},"MaxStorageThroughputPerDbInstance":{"type":"integer"},"MinStorageThroughputPerIops":{"type":"double"},"MaxStorageThroughputPerIops":{"type":"double"},"SupportsDedicatedLogVolume":{"type":"boolean"}},"wrapper":true}},"Marker":{}}}},"DescribePendingMaintenanceActions":{"input":{"type":"structure","members":{"ResourceIdentifier":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribePendingMaintenanceActionsResult","type":"structure","members":{"PendingMaintenanceActions":{"type":"list","member":{"shape":"Sf","locationName":"ResourcePendingMaintenanceActions"}},"Marker":{}}}},"DescribeReservedDBInstances":{"input":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"LeaseId":{},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesResult","type":"structure","members":{"Marker":{},"ReservedDBInstances":{"type":"list","member":{"shape":"Sci","locationName":"ReservedDBInstance"}}}}},"DescribeReservedDBInstancesOfferings":{"input":{"type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"Filters":{"shape":"S7k"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedDBInstancesOfferingsResult","type":"structure","members":{"Marker":{},"ReservedDBInstancesOfferings":{"type":"list","member":{"locationName":"ReservedDBInstancesOffering","type":"structure","members":{"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"RecurringCharges":{"shape":"Scj"}},"wrapper":true}}}}},"DescribeSourceRegions":{"input":{"type":"structure","members":{"RegionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"Filters":{"shape":"S7k"}}},"output":{"resultWrapper":"DescribeSourceRegionsResult","type":"structure","members":{"Marker":{},"SourceRegions":{"type":"list","member":{"locationName":"SourceRegion","type":"structure","members":{"RegionName":{},"Endpoint":{},"Status":{},"SupportsDBInstanceAutomatedBackupsReplication":{"type":"boolean"}}}}}}},"DescribeTenantDatabases":{"input":{"type":"structure","members":{"DBInstanceIdentifier":{},"TenantDBName":{},"Filters":{"shape":"S7k"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeTenantDatabasesResult","type":"structure","members":{"Marker":{},"TenantDatabases":{"type":"list","member":{"shape":"S69","locationName":"TenantDatabase"}}}}},"DescribeValidDBInstanceModifications":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"DescribeValidDBInstanceModificationsResult","type":"structure","members":{"ValidDBInstanceModificationsMessage":{"type":"structure","members":{"Storage":{"type":"list","member":{"locationName":"ValidStorageOptions","type":"structure","members":{"StorageType":{},"StorageSize":{"shape":"Sd1"},"ProvisionedIops":{"shape":"Sd1"},"IopsToStorageRatio":{"shape":"Sd3"},"SupportsStorageAutoscaling":{"type":"boolean"},"ProvisionedStorageThroughput":{"shape":"Sd1"},"StorageThroughputToIopsRatio":{"shape":"Sd3"}}}},"ValidProcessorFeatures":{"shape":"Sc9"},"SupportsDedicatedLogVolume":{"type":"boolean"}},"wrapper":true}}}},"DisableHttpEndpoint":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"DisableHttpEndpointResult","type":"structure","members":{"ResourceArn":{},"HttpEndpointEnabled":{"type":"boolean"}}}},"DownloadDBLogFilePortion":{"input":{"type":"structure","required":["DBInstanceIdentifier","LogFileName"],"members":{"DBInstanceIdentifier":{},"LogFileName":{},"Marker":{},"NumberOfLines":{"type":"integer"}}},"output":{"resultWrapper":"DownloadDBLogFilePortionResult","type":"structure","members":{"LogFileData":{},"Marker":{},"AdditionalDataPending":{"type":"boolean"}}}},"EnableHttpEndpoint":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"EnableHttpEndpointResult","type":"structure","members":{"ResourceArn":{},"HttpEndpointEnabled":{"type":"boolean"}}}},"FailoverDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"TargetDBInstanceIdentifier":{}}},"output":{"resultWrapper":"FailoverDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"FailoverGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier","TargetDbClusterIdentifier"],"members":{"GlobalClusterIdentifier":{},"TargetDbClusterIdentifier":{},"AllowDataLoss":{"type":"boolean"},"Switchover":{"type":"boolean"}}},"output":{"resultWrapper":"FailoverGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S5l"}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceName"],"members":{"ResourceName":{},"Filters":{"shape":"S7k"}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"TagList":{"shape":"Sb"}}}},"ModifyActivityStream":{"input":{"type":"structure","members":{"ResourceArn":{},"AuditPolicyState":{}}},"output":{"resultWrapper":"ModifyActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{},"Mode":{},"EngineNativeAuditFieldsIncluded":{"type":"boolean"},"PolicyStatus":{}}}},"ModifyCertificates":{"input":{"type":"structure","members":{"CertificateIdentifier":{},"RemoveCustomerOverride":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyCertificatesResult","type":"structure","members":{"Certificate":{"shape":"S7t"}}}},"ModifyCurrentDBClusterCapacity":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"Capacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}},"output":{"resultWrapper":"ModifyCurrentDBClusterCapacityResult","type":"structure","members":{"DBClusterIdentifier":{},"PendingCapacity":{"type":"integer"},"CurrentCapacity":{"type":"integer"},"SecondsBeforeTimeout":{"type":"integer"},"TimeoutAction":{}}}},"ModifyCustomDBEngineVersion":{"input":{"type":"structure","required":["Engine","EngineVersion"],"members":{"Engine":{},"EngineVersion":{},"Description":{},"Status":{}}},"output":{"shape":"S2g","resultWrapper":"ModifyCustomDBEngineVersionResult"}},"ModifyDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"NewDBClusterIdentifier":{},"ApplyImmediately":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S2t"},"Port":{"type":"integer"},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"CloudwatchLogsExportConfiguration":{"shape":"Sdt"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"DBInstanceParameterGroupName":{},"Domain":{},"DomainIAMRoleName":{},"ScalingConfiguration":{"shape":"S2v"},"DeletionProtection":{"type":"boolean"},"EnableHttpEndpoint":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"EnableGlobalWriteForwarding":{"type":"boolean"},"DBClusterInstanceClass":{},"AllocatedStorage":{"type":"integer"},"StorageType":{},"Iops":{"type":"integer"},"AutoMinorVersionUpgrade":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"ServerlessV2ScalingConfiguration":{"shape":"S2y"},"NetworkType":{},"ManageMasterUserPassword":{"type":"boolean"},"RotateMasterUserPassword":{"type":"boolean"},"MasterUserSecretKmsKeyId":{},"EngineMode":{},"AllowEngineModeChange":{"type":"boolean"},"EnableLocalWriteForwarding":{"type":"boolean"},"AwsBackupRecoveryPointArn":{},"EnableLimitlessDatabase":{"type":"boolean"},"CACertificateIdentifier":{}}},"output":{"resultWrapper":"ModifyDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"ModifyDBClusterEndpoint":{"input":{"type":"structure","required":["DBClusterEndpointIdentifier"],"members":{"DBClusterEndpointIdentifier":{},"EndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"}}},"output":{"shape":"S3q","resultWrapper":"ModifyDBClusterEndpointResult"}},"ModifyDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName","Parameters"],"members":{"DBClusterParameterGroupName":{},"Parameters":{"shape":"S88"}}},"output":{"shape":"Sdy","resultWrapper":"ModifyDBClusterParameterGroupResult"}},"ModifyDBClusterSnapshotAttribute":{"input":{"type":"structure","required":["DBClusterSnapshotIdentifier","AttributeName"],"members":{"DBClusterSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S8g"},"ValuesToRemove":{"shape":"S8g"}}},"output":{"resultWrapper":"ModifyDBClusterSnapshotAttributeResult","type":"structure","members":{"DBClusterSnapshotAttributesResult":{"shape":"S8d"}}}},"ModifyDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"DBSubnetGroupName":{},"DBSecurityGroups":{"shape":"S3w"},"VpcSecurityGroupIds":{"shape":"S2t"},"ApplyImmediately":{"type":"boolean"},"MasterUserPassword":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"NewDBInstanceIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"CACertificateIdentifier":{},"Domain":{},"DomainFqdn":{},"DomainOu":{},"DomainAuthSecretArn":{},"DomainDnsIps":{"shape":"Sv"},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"DBPortNumber":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"MonitoringRoleArn":{},"DomainIAMRoleName":{},"DisableDomain":{"type":"boolean"},"PromotionTier":{"type":"integer"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"CloudwatchLogsExportConfiguration":{"shape":"Sdt"},"ProcessorFeatures":{"shape":"S1c"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"},"CertificateRotationRestart":{"type":"boolean"},"ReplicaMode":{},"EnableCustomerOwnedIp":{"type":"boolean"},"AwsBackupRecoveryPointArn":{},"AutomationMode":{},"ResumeFullAutomationModeMinutes":{"type":"integer"},"NetworkType":{},"StorageThroughput":{"type":"integer"},"ManageMasterUserPassword":{"type":"boolean"},"RotateMasterUserPassword":{"type":"boolean"},"MasterUserSecretKmsKeyId":{},"Engine":{},"DedicatedLogVolume":{"type":"boolean"},"MultiTenant":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"ModifyDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName","Parameters"],"members":{"DBParameterGroupName":{},"Parameters":{"shape":"S88"}}},"output":{"shape":"Se4","resultWrapper":"ModifyDBParameterGroupResult"}},"ModifyDBProxy":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"NewDBProxyName":{},"Auth":{"shape":"S4q"},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"RoleArn":{},"SecurityGroups":{"shape":"Sv"}}},"output":{"resultWrapper":"ModifyDBProxyResult","type":"structure","members":{"DBProxy":{"shape":"S4w"}}}},"ModifyDBProxyEndpoint":{"input":{"type":"structure","required":["DBProxyEndpointName"],"members":{"DBProxyEndpointName":{},"NewDBProxyEndpointName":{},"VpcSecurityGroupIds":{"shape":"Sv"}}},"output":{"resultWrapper":"ModifyDBProxyEndpointResult","type":"structure","members":{"DBProxyEndpoint":{"shape":"S55"}}}},"ModifyDBProxyTargetGroup":{"input":{"type":"structure","required":["TargetGroupName","DBProxyName"],"members":{"TargetGroupName":{},"DBProxyName":{},"ConnectionPoolConfig":{"type":"structure","members":{"MaxConnectionsPercent":{"type":"integer"},"MaxIdleConnectionsPercent":{"type":"integer"},"ConnectionBorrowTimeout":{"type":"integer"},"SessionPinningFilters":{"shape":"Sv"},"InitQuery":{}}},"NewName":{}}},"output":{"resultWrapper":"ModifyDBProxyTargetGroupResult","type":"structure","members":{"DBProxyTargetGroup":{"shape":"S9e"}}}},"ModifyDBRecommendation":{"input":{"type":"structure","required":["RecommendationId"],"members":{"RecommendationId":{},"Locale":{},"Status":{},"RecommendedActionUpdates":{"type":"list","member":{"type":"structure","required":["ActionId","Status"],"members":{"ActionId":{},"Status":{}}}}}},"output":{"resultWrapper":"ModifyDBRecommendationResult","type":"structure","members":{"DBRecommendation":{"shape":"S9s"}}}},"ModifyDBShardGroup":{"input":{"type":"structure","required":["DBShardGroupIdentifier"],"members":{"DBShardGroupIdentifier":{},"MaxACU":{"type":"double"}}},"output":{"shape":"S5a","resultWrapper":"ModifyDBShardGroupResult"}},"ModifyDBSnapshot":{"input":{"type":"structure","required":["DBSnapshotIdentifier"],"members":{"DBSnapshotIdentifier":{},"EngineVersion":{},"OptionGroupName":{}}},"output":{"resultWrapper":"ModifyDBSnapshotResult","type":"structure","members":{"DBSnapshot":{"shape":"S1b"}}}},"ModifyDBSnapshotAttribute":{"input":{"type":"structure","required":["DBSnapshotIdentifier","AttributeName"],"members":{"DBSnapshotIdentifier":{},"AttributeName":{},"ValuesToAdd":{"shape":"S8g"},"ValuesToRemove":{"shape":"S8g"}}},"output":{"resultWrapper":"ModifyDBSnapshotAttributeResult","type":"structure","members":{"DBSnapshotAttributesResult":{"shape":"Sal"}}}},"ModifyDBSubnetGroup":{"input":{"type":"structure","required":["DBSubnetGroupName","SubnetIds"],"members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"SubnetIds":{"shape":"S5f"}}},"output":{"resultWrapper":"ModifyDBSubnetGroupResult","type":"structure","members":{"DBSubnetGroup":{"shape":"S42"}}}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"EventCategories":{"shape":"S8"},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"ModifyGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"NewGlobalClusterIdentifier":{},"DeletionProtection":{"type":"boolean"},"EngineVersion":{},"AllowMajorVersionUpgrade":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S5l"}}}},"ModifyIntegration":{"input":{"type":"structure","required":["IntegrationIdentifier"],"members":{"IntegrationIdentifier":{},"IntegrationName":{},"DataFilter":{},"Description":{}}},"output":{"shape":"S5z","resultWrapper":"ModifyIntegrationResult"}},"ModifyOptionGroup":{"input":{"type":"structure","required":["OptionGroupName"],"members":{"OptionGroupName":{},"OptionsToInclude":{"type":"list","member":{"locationName":"OptionConfiguration","type":"structure","required":["OptionName"],"members":{"OptionName":{},"Port":{"type":"integer"},"OptionVersion":{},"DBSecurityGroupMemberships":{"shape":"S3w"},"VpcSecurityGroupMemberships":{"shape":"S2t"},"OptionSettings":{"type":"list","member":{"shape":"S1k","locationName":"OptionSetting"}}}}},"OptionsToRemove":{"type":"list","member":{}},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyOptionGroupResult","type":"structure","members":{"OptionGroup":{"shape":"S1g"}}}},"ModifyTenantDatabase":{"input":{"type":"structure","required":["DBInstanceIdentifier","TenantDBName"],"members":{"DBInstanceIdentifier":{},"TenantDBName":{},"MasterUserPassword":{"shape":"S67"},"NewTenantDBName":{}}},"output":{"resultWrapper":"ModifyTenantDatabaseResult","type":"structure","members":{"TenantDatabase":{"shape":"S69"}}}},"PromoteReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{}}},"output":{"resultWrapper":"PromoteReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"PromoteReadReplicaDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"PromoteReadReplicaDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"PurchaseReservedDBInstancesOffering":{"input":{"type":"structure","required":["ReservedDBInstancesOfferingId"],"members":{"ReservedDBInstancesOfferingId":{},"ReservedDBInstanceId":{},"DBInstanceCount":{"type":"integer"},"Tags":{"shape":"Sb"}}},"output":{"resultWrapper":"PurchaseReservedDBInstancesOfferingResult","type":"structure","members":{"ReservedDBInstance":{"shape":"Sci"}}}},"RebootDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"RebootDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"RebootDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"ForceFailover":{"type":"boolean"}}},"output":{"resultWrapper":"RebootDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"RebootDBShardGroup":{"input":{"type":"structure","required":["DBShardGroupIdentifier"],"members":{"DBShardGroupIdentifier":{}}},"output":{"shape":"S5a","resultWrapper":"RebootDBShardGroupResult"}},"RegisterDBProxyTargets":{"input":{"type":"structure","required":["DBProxyName"],"members":{"DBProxyName":{},"TargetGroupName":{},"DBInstanceIdentifiers":{"shape":"Sv"},"DBClusterIdentifiers":{"shape":"Sv"}}},"output":{"resultWrapper":"RegisterDBProxyTargetsResult","type":"structure","members":{"DBProxyTargets":{"shape":"S9i"}}}},"RemoveFromGlobalCluster":{"input":{"type":"structure","members":{"GlobalClusterIdentifier":{},"DbClusterIdentifier":{}}},"output":{"resultWrapper":"RemoveFromGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S5l"}}}},"RemoveRoleFromDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier","RoleArn"],"members":{"DBClusterIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveRoleFromDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier","RoleArn","FeatureName"],"members":{"DBInstanceIdentifier":{},"RoleArn":{},"FeatureName":{}}}},"RemoveSourceIdentifierFromSubscription":{"input":{"type":"structure","required":["SubscriptionName","SourceIdentifier"],"members":{"SubscriptionName":{},"SourceIdentifier":{}}},"output":{"resultWrapper":"RemoveSourceIdentifierFromSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S6"}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"type":"list","member":{}}}}},"ResetDBClusterParameterGroup":{"input":{"type":"structure","required":["DBClusterParameterGroupName"],"members":{"DBClusterParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S88"}}},"output":{"shape":"Sdy","resultWrapper":"ResetDBClusterParameterGroupResult"}},"ResetDBParameterGroup":{"input":{"type":"structure","required":["DBParameterGroupName"],"members":{"DBParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S88"}}},"output":{"shape":"Se4","resultWrapper":"ResetDBParameterGroupResult"}},"RestoreDBClusterFromS3":{"input":{"type":"structure","required":["DBClusterIdentifier","Engine","MasterUsername","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"AvailabilityZones":{"shape":"S14"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroupName":{},"VpcSecurityGroupIds":{"shape":"S2t"},"DBSubnetGroupName":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"MasterUsername":{},"MasterUserPassword":{},"OptionGroupName":{},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"Tags":{"shape":"Sb"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"ServerlessV2ScalingConfiguration":{"shape":"S2y"},"NetworkType":{},"ManageMasterUserPassword":{"type":"boolean"},"MasterUserSecretKmsKeyId":{},"StorageType":{},"EngineLifecycleSupport":{}}},"output":{"resultWrapper":"RestoreDBClusterFromS3Result","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"RestoreDBClusterFromSnapshot":{"input":{"type":"structure","required":["DBClusterIdentifier","SnapshotIdentifier","Engine"],"members":{"AvailabilityZones":{"shape":"S14"},"DBClusterIdentifier":{},"SnapshotIdentifier":{},"Engine":{},"EngineVersion":{},"Port":{"type":"integer"},"DBSubnetGroupName":{},"DatabaseName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S2t"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"EngineMode":{},"ScalingConfiguration":{"shape":"S2v"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"DBClusterInstanceClass":{},"StorageType":{},"Iops":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"ServerlessV2ScalingConfiguration":{"shape":"S2y"},"NetworkType":{},"RdsCustomClusterConfiguration":{"shape":"S2w"},"EngineLifecycleSupport":{}}},"output":{"resultWrapper":"RestoreDBClusterFromSnapshotResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"RestoreDBClusterToPointInTime":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{},"RestoreType":{},"SourceDBClusterIdentifier":{},"RestoreToTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"Port":{"type":"integer"},"DBSubnetGroupName":{},"OptionGroupName":{},"VpcSecurityGroupIds":{"shape":"S2t"},"Tags":{"shape":"Sb"},"KmsKeyId":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"BacktrackWindow":{"type":"long"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"DBClusterParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"CopyTagsToSnapshot":{"type":"boolean"},"Domain":{},"DomainIAMRoleName":{},"ScalingConfiguration":{"shape":"S2v"},"EngineMode":{},"DBClusterInstanceClass":{},"StorageType":{},"PubliclyAccessible":{"type":"boolean"},"Iops":{"type":"integer"},"ServerlessV2ScalingConfiguration":{"shape":"S2y"},"NetworkType":{},"SourceDbClusterResourceId":{},"RdsCustomClusterConfiguration":{"shape":"S2w"},"EngineLifecycleSupport":{}}},"output":{"resultWrapper":"RestoreDBClusterToPointInTimeResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"RestoreDBInstanceFromDBSnapshot":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S2t"},"Domain":{},"DomainFqdn":{},"DomainOu":{},"DomainAuthSecretArn":{},"DomainDnsIps":{"shape":"Sv"},"CopyTagsToSnapshot":{"type":"boolean"},"DomainIAMRoleName":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"ProcessorFeatures":{"shape":"S1c"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"EnableCustomerOwnedIp":{"type":"boolean"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{},"StorageThroughput":{"type":"integer"},"DBClusterSnapshotIdentifier":{},"AllocatedStorage":{"type":"integer"},"DedicatedLogVolume":{"type":"boolean"},"CACertificateIdentifier":{},"EngineLifecycleSupport":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromDBSnapshotResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"RestoreDBInstanceFromS3":{"input":{"type":"structure","required":["DBInstanceIdentifier","DBInstanceClass","Engine","SourceEngine","SourceEngineVersion","S3BucketName","S3IngestionRoleArn"],"members":{"DBName":{},"DBInstanceIdentifier":{},"AllocatedStorage":{"type":"integer"},"DBInstanceClass":{},"Engine":{},"MasterUsername":{},"MasterUserPassword":{},"DBSecurityGroups":{"shape":"S3w"},"VpcSecurityGroupIds":{"shape":"S2t"},"AvailabilityZone":{},"DBSubnetGroupName":{},"PreferredMaintenanceWindow":{},"DBParameterGroupName":{},"BackupRetentionPeriod":{"type":"integer"},"PreferredBackupWindow":{},"Port":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PubliclyAccessible":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"SourceEngine":{},"SourceEngineVersion":{},"S3BucketName":{},"S3Prefix":{},"S3IngestionRoleArn":{},"EnablePerformanceInsights":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"ProcessorFeatures":{"shape":"S1c"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"MaxAllocatedStorage":{"type":"integer"},"NetworkType":{},"StorageThroughput":{"type":"integer"},"ManageMasterUserPassword":{"type":"boolean"},"MasterUserSecretKmsKeyId":{},"DedicatedLogVolume":{"type":"boolean"},"CACertificateIdentifier":{},"EngineLifecycleSupport":{}}},"output":{"resultWrapper":"RestoreDBInstanceFromS3Result","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"RestoreDBInstanceToPointInTime":{"input":{"type":"structure","required":["TargetDBInstanceIdentifier"],"members":{"SourceDBInstanceIdentifier":{},"TargetDBInstanceIdentifier":{},"RestoreTime":{"type":"timestamp"},"UseLatestRestorableTime":{"type":"boolean"},"DBInstanceClass":{},"Port":{"type":"integer"},"AvailabilityZone":{},"DBSubnetGroupName":{},"MultiAZ":{"type":"boolean"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"LicenseModel":{},"DBName":{},"Engine":{},"Iops":{"type":"integer"},"OptionGroupName":{},"CopyTagsToSnapshot":{"type":"boolean"},"Tags":{"shape":"Sb"},"StorageType":{},"TdeCredentialArn":{},"TdeCredentialPassword":{},"VpcSecurityGroupIds":{"shape":"S2t"},"Domain":{},"DomainIAMRoleName":{},"DomainFqdn":{},"DomainOu":{},"DomainAuthSecretArn":{},"DomainDnsIps":{"shape":"Sv"},"EnableIAMDatabaseAuthentication":{"type":"boolean"},"EnableCloudwatchLogsExports":{"shape":"S2p"},"ProcessorFeatures":{"shape":"S1c"},"UseDefaultProcessorFeatures":{"type":"boolean"},"DBParameterGroupName":{},"DeletionProtection":{"type":"boolean"},"SourceDbiResourceId":{},"MaxAllocatedStorage":{"type":"integer"},"SourceDBInstanceAutomatedBackupsArn":{},"EnableCustomerOwnedIp":{"type":"boolean"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{},"StorageThroughput":{"type":"integer"},"AllocatedStorage":{"type":"integer"},"DedicatedLogVolume":{"type":"boolean"},"CACertificateIdentifier":{},"EngineLifecycleSupport":{}}},"output":{"resultWrapper":"RestoreDBInstanceToPointInTimeResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"RevokeDBSecurityGroupIngress":{"input":{"type":"structure","required":["DBSecurityGroupName"],"members":{"DBSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeDBSecurityGroupIngressResult","type":"structure","members":{"DBSecurityGroup":{"shape":"Sl"}}}},"StartActivityStream":{"input":{"type":"structure","required":["ResourceArn","Mode","KmsKeyId"],"members":{"ResourceArn":{},"Mode":{},"KmsKeyId":{},"ApplyImmediately":{"type":"boolean"},"EngineNativeAuditFieldsIncluded":{"type":"boolean"}}},"output":{"resultWrapper":"StartActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{},"Mode":{},"ApplyImmediately":{"type":"boolean"},"EngineNativeAuditFieldsIncluded":{"type":"boolean"}}}},"StartDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StartDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"StartDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"StartDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"StartDBInstanceAutomatedBackupsReplication":{"input":{"type":"structure","required":["SourceDBInstanceArn"],"members":{"SourceDBInstanceArn":{},"BackupRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"PreSignedUrl":{}}},"output":{"resultWrapper":"StartDBInstanceAutomatedBackupsReplicationResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S6s"}}}},"StartExportTask":{"input":{"type":"structure","required":["ExportTaskIdentifier","SourceArn","S3BucketName","IamRoleArn","KmsKeyId"],"members":{"ExportTaskIdentifier":{},"SourceArn":{},"S3BucketName":{},"IamRoleArn":{},"KmsKeyId":{},"S3Prefix":{},"ExportOnly":{"shape":"Sv"}}},"output":{"shape":"Su","resultWrapper":"StartExportTaskResult"}},"StopActivityStream":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"ApplyImmediately":{"type":"boolean"}}},"output":{"resultWrapper":"StopActivityStreamResult","type":"structure","members":{"KmsKeyId":{},"KinesisStreamName":{},"Status":{}}}},"StopDBCluster":{"input":{"type":"structure","required":["DBClusterIdentifier"],"members":{"DBClusterIdentifier":{}}},"output":{"resultWrapper":"StopDBClusterResult","type":"structure","members":{"DBCluster":{"shape":"S31"}}}},"StopDBInstance":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{},"DBSnapshotIdentifier":{}}},"output":{"resultWrapper":"StopDBInstanceResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}},"StopDBInstanceAutomatedBackupsReplication":{"input":{"type":"structure","required":["SourceDBInstanceArn"],"members":{"SourceDBInstanceArn":{}}},"output":{"resultWrapper":"StopDBInstanceAutomatedBackupsReplicationResult","type":"structure","members":{"DBInstanceAutomatedBackup":{"shape":"S6s"}}}},"SwitchoverBlueGreenDeployment":{"input":{"type":"structure","required":["BlueGreenDeploymentIdentifier"],"members":{"BlueGreenDeploymentIdentifier":{},"SwitchoverTimeout":{"type":"integer"}}},"output":{"resultWrapper":"SwitchoverBlueGreenDeploymentResult","type":"structure","members":{"BlueGreenDeployment":{"shape":"S1x"}}}},"SwitchoverGlobalCluster":{"input":{"type":"structure","required":["GlobalClusterIdentifier","TargetDbClusterIdentifier"],"members":{"GlobalClusterIdentifier":{},"TargetDbClusterIdentifier":{}}},"output":{"resultWrapper":"SwitchoverGlobalClusterResult","type":"structure","members":{"GlobalCluster":{"shape":"S5l"}}}},"SwitchoverReadReplica":{"input":{"type":"structure","required":["DBInstanceIdentifier"],"members":{"DBInstanceIdentifier":{}}},"output":{"resultWrapper":"SwitchoverReadReplicaResult","type":"structure","members":{"DBInstance":{"shape":"S3y"}}}}},"shapes":{"S6":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{},"SourceType":{},"SourceIdsList":{"shape":"S7"},"EventCategoriesList":{"shape":"S8"},"Enabled":{"type":"boolean"},"EventSubscriptionArn":{}},"wrapper":true},"S7":{"type":"list","member":{"locationName":"SourceId"}},"S8":{"type":"list","member":{"locationName":"EventCategory"}},"Sb":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"Sf":{"type":"structure","members":{"ResourceIdentifier":{},"PendingMaintenanceActionDetails":{"type":"list","member":{"locationName":"PendingMaintenanceAction","type":"structure","members":{"Action":{},"AutoAppliedAfterDate":{"type":"timestamp"},"ForcedApplyDate":{"type":"timestamp"},"OptInStatus":{},"CurrentApplyDate":{"type":"timestamp"},"Description":{}}}}},"wrapper":true},"Sl":{"type":"structure","members":{"OwnerId":{},"DBSecurityGroupName":{},"DBSecurityGroupDescription":{},"VpcId":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupId":{},"EC2SecurityGroupOwnerId":{}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{}}}},"DBSecurityGroupArn":{}},"wrapper":true},"Ss":{"type":"structure","members":{"DBClusterIdentifier":{},"BacktrackIdentifier":{},"BacktrackTo":{"type":"timestamp"},"BacktrackedFrom":{"type":"timestamp"},"BacktrackRequestCreationTime":{"type":"timestamp"},"Status":{}}},"Su":{"type":"structure","members":{"ExportTaskIdentifier":{},"SourceArn":{},"ExportOnly":{"shape":"Sv"},"SnapshotTime":{"type":"timestamp"},"TaskStartTime":{"type":"timestamp"},"TaskEndTime":{"type":"timestamp"},"S3Bucket":{},"S3Prefix":{},"IamRoleArn":{},"KmsKeyId":{},"Status":{},"PercentProgress":{"type":"integer"},"TotalExtractedDataInGB":{"type":"integer"},"FailureCause":{},"WarningMessage":{},"SourceType":{}}},"Sv":{"type":"list","member":{}},"S10":{"type":"structure","members":{"DBClusterParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBClusterParameterGroupArn":{}},"wrapper":true},"S13":{"type":"structure","members":{"AvailabilityZones":{"shape":"S14"},"DBClusterSnapshotIdentifier":{},"DBClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"EngineMode":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"VpcId":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"PercentProgress":{"type":"integer"},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DBClusterSnapshotArn":{},"SourceDBClusterSnapshotArn":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"TagList":{"shape":"Sb"},"DBSystemId":{},"StorageType":{},"DbClusterResourceId":{},"StorageThroughput":{"type":"integer"}},"wrapper":true},"S14":{"type":"list","member":{"locationName":"AvailabilityZone"}},"S18":{"type":"structure","members":{"DBParameterGroupName":{},"DBParameterGroupFamily":{},"Description":{},"DBParameterGroupArn":{}},"wrapper":true},"S1b":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBInstanceIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Engine":{},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"EngineVersion":{},"LicenseModel":{},"SnapshotType":{},"Iops":{"type":"integer"},"OptionGroupName":{},"PercentProgress":{"type":"integer"},"SourceRegion":{},"SourceDBSnapshotIdentifier":{},"StorageType":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"DBSnapshotArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"ProcessorFeatures":{"shape":"S1c"},"DbiResourceId":{},"TagList":{"shape":"Sb"},"OriginalSnapshotCreateTime":{"type":"timestamp"},"SnapshotDatabaseTime":{"type":"timestamp"},"SnapshotTarget":{},"StorageThroughput":{"type":"integer"},"DBSystemId":{},"DedicatedLogVolume":{"type":"boolean"},"MultiTenant":{"type":"boolean"}},"wrapper":true},"S1c":{"type":"list","member":{"locationName":"ProcessorFeature","type":"structure","members":{"Name":{},"Value":{}}}},"S1g":{"type":"structure","members":{"OptionGroupName":{},"OptionGroupDescription":{},"EngineName":{},"MajorEngineVersion":{},"Options":{"type":"list","member":{"locationName":"Option","type":"structure","members":{"OptionName":{},"OptionDescription":{},"Persistent":{"type":"boolean"},"Permanent":{"type":"boolean"},"Port":{"type":"integer"},"OptionVersion":{},"OptionSettings":{"type":"list","member":{"shape":"S1k","locationName":"OptionSetting"}},"DBSecurityGroupMemberships":{"shape":"S1l"},"VpcSecurityGroupMemberships":{"shape":"S1n"}}}},"AllowsVpcAndNonVpcInstanceMemberships":{"type":"boolean"},"VpcId":{},"OptionGroupArn":{},"SourceOptionGroup":{},"SourceAccountId":{},"CopyTimestamp":{"type":"timestamp"}},"wrapper":true},"S1k":{"type":"structure","members":{"Name":{},"Value":{},"DefaultValue":{},"Description":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"IsCollection":{"type":"boolean"}}},"S1l":{"type":"list","member":{"locationName":"DBSecurityGroup","type":"structure","members":{"DBSecurityGroupName":{},"Status":{}}}},"S1n":{"type":"list","member":{"locationName":"VpcSecurityGroupMembership","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S1x":{"type":"structure","members":{"BlueGreenDeploymentIdentifier":{},"BlueGreenDeploymentName":{},"Source":{},"Target":{},"SwitchoverDetails":{"type":"list","member":{"type":"structure","members":{"SourceMember":{},"TargetMember":{},"Status":{}}}},"Tasks":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{}}}},"Status":{},"StatusDetails":{},"CreateTime":{"type":"timestamp"},"DeleteTime":{"type":"timestamp"},"TagList":{"shape":"Sb"}}},"S2g":{"type":"structure","members":{"Engine":{},"EngineVersion":{},"DBParameterGroupFamily":{},"DBEngineDescription":{},"DBEngineVersionDescription":{},"DefaultCharacterSet":{"shape":"S2h"},"Image":{"type":"structure","members":{"ImageId":{},"Status":{}}},"DBEngineMediaType":{},"SupportedCharacterSets":{"shape":"S2j"},"SupportedNcharCharacterSets":{"shape":"S2j"},"ValidUpgradeTarget":{"type":"list","member":{"locationName":"UpgradeTarget","type":"structure","members":{"Engine":{},"EngineVersion":{},"Description":{},"AutoUpgrade":{"type":"boolean"},"IsMajorVersionUpgrade":{"type":"boolean"},"SupportedEngineModes":{"shape":"S2m"},"SupportsParallelQuery":{"type":"boolean"},"SupportsGlobalDatabases":{"type":"boolean"},"SupportsBabelfish":{"type":"boolean"},"SupportsLimitlessDatabase":{"type":"boolean"},"SupportsLocalWriteForwarding":{"type":"boolean"},"SupportsIntegrations":{"type":"boolean"}}}},"SupportedTimezones":{"type":"list","member":{"locationName":"Timezone","type":"structure","members":{"TimezoneName":{}}}},"ExportableLogTypes":{"shape":"S2p"},"SupportsLogExportsToCloudwatchLogs":{"type":"boolean"},"SupportsReadReplica":{"type":"boolean"},"SupportedEngineModes":{"shape":"S2m"},"SupportedFeatureNames":{"type":"list","member":{}},"Status":{},"SupportsParallelQuery":{"type":"boolean"},"SupportsGlobalDatabases":{"type":"boolean"},"MajorEngineVersion":{},"DatabaseInstallationFilesS3BucketName":{},"DatabaseInstallationFilesS3Prefix":{},"DBEngineVersionArn":{},"KMSKeyId":{},"CreateTime":{"type":"timestamp"},"TagList":{"shape":"Sb"},"SupportsBabelfish":{"type":"boolean"},"CustomDBEngineVersionManifest":{},"SupportsLimitlessDatabase":{"type":"boolean"},"SupportsCertificateRotationWithoutRestart":{"type":"boolean"},"SupportedCACertificateIdentifiers":{"type":"list","member":{}},"SupportsLocalWriteForwarding":{"type":"boolean"},"SupportsIntegrations":{"type":"boolean"}}},"S2h":{"type":"structure","members":{"CharacterSetName":{},"CharacterSetDescription":{}}},"S2j":{"type":"list","member":{"shape":"S2h","locationName":"CharacterSet"}},"S2m":{"type":"list","member":{}},"S2p":{"type":"list","member":{}},"S2t":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S2v":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{},"SecondsBeforeTimeout":{"type":"integer"}}},"S2w":{"type":"structure","members":{"InterconnectSubnetId":{},"TransitGatewayMulticastDomainId":{},"ReplicaMode":{}}},"S2y":{"type":"structure","members":{"MinCapacity":{"type":"double"},"MaxCapacity":{"type":"double"}}},"S31":{"type":"structure","members":{"AllocatedStorage":{"type":"integer"},"AvailabilityZones":{"shape":"S14"},"BackupRetentionPeriod":{"type":"integer"},"CharacterSetName":{},"DatabaseName":{},"DBClusterIdentifier":{},"DBClusterParameterGroup":{},"DBSubnetGroup":{},"Status":{},"AutomaticRestartTime":{"type":"timestamp"},"PercentProgress":{},"EarliestRestorableTime":{"type":"timestamp"},"Endpoint":{},"ReaderEndpoint":{},"CustomEndpoints":{"shape":"Sv"},"MultiAZ":{"type":"boolean"},"Engine":{},"EngineVersion":{},"LatestRestorableTime":{"type":"timestamp"},"Port":{"type":"integer"},"MasterUsername":{},"DBClusterOptionGroupMemberships":{"type":"list","member":{"locationName":"DBClusterOptionGroup","type":"structure","members":{"DBClusterOptionGroupName":{},"Status":{}}}},"PreferredBackupWindow":{},"PreferredMaintenanceWindow":{},"ReplicationSourceIdentifier":{},"ReadReplicaIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaIdentifier"}},"StatusInfos":{"type":"list","member":{"locationName":"DBClusterStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"DBClusterMembers":{"type":"list","member":{"locationName":"DBClusterMember","type":"structure","members":{"DBInstanceIdentifier":{},"IsClusterWriter":{"type":"boolean"},"DBClusterParameterGroupStatus":{},"PromotionTier":{"type":"integer"}},"wrapper":true}},"VpcSecurityGroups":{"shape":"S1n"},"HostedZoneId":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbClusterResourceId":{},"DBClusterArn":{},"AssociatedRoles":{"type":"list","member":{"locationName":"DBClusterRole","type":"structure","members":{"RoleArn":{},"Status":{},"FeatureName":{}}}},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"CloneGroupId":{},"ClusterCreateTime":{"type":"timestamp"},"EarliestBacktrackTime":{"type":"timestamp"},"BacktrackWindow":{"type":"long"},"BacktrackConsumedChangeRecords":{"type":"long"},"EnabledCloudwatchLogsExports":{"shape":"S2p"},"Capacity":{"type":"integer"},"EngineMode":{},"ScalingConfigurationInfo":{"type":"structure","members":{"MinCapacity":{"type":"integer"},"MaxCapacity":{"type":"integer"},"AutoPause":{"type":"boolean"},"SecondsUntilAutoPause":{"type":"integer"},"TimeoutAction":{},"SecondsBeforeTimeout":{"type":"integer"}}},"RdsCustomClusterConfiguration":{"shape":"S2w"},"DeletionProtection":{"type":"boolean"},"HttpEndpointEnabled":{"type":"boolean"},"ActivityStreamMode":{},"ActivityStreamStatus":{},"ActivityStreamKmsKeyId":{},"ActivityStreamKinesisStreamName":{},"CopyTagsToSnapshot":{"type":"boolean"},"CrossAccountClone":{"type":"boolean"},"DomainMemberships":{"shape":"S3e"},"TagList":{"shape":"Sb"},"GlobalWriteForwardingStatus":{},"GlobalWriteForwardingRequested":{"type":"boolean"},"PendingModifiedValues":{"type":"structure","members":{"PendingCloudwatchLogsExports":{"shape":"S3i"},"DBClusterIdentifier":{},"MasterUserPassword":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"EngineVersion":{},"BackupRetentionPeriod":{"type":"integer"},"AllocatedStorage":{"type":"integer"},"RdsCustomClusterConfiguration":{"shape":"S2w"},"Iops":{"type":"integer"},"StorageType":{},"CertificateDetails":{"shape":"S3j"}}},"DBClusterInstanceClass":{},"StorageType":{},"Iops":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"AutoMinorVersionUpgrade":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"MonitoringRoleArn":{},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"ServerlessV2ScalingConfiguration":{"type":"structure","members":{"MinCapacity":{"type":"double"},"MaxCapacity":{"type":"double"}}},"NetworkType":{},"DBSystemId":{},"MasterUserSecret":{"shape":"S3l"},"IOOptimizedNextAllowedModificationTime":{"type":"timestamp"},"LocalWriteForwardingStatus":{},"AwsBackupRecoveryPointArn":{},"LimitlessDatabase":{"type":"structure","members":{"Status":{},"MinRequiredACU":{"type":"double"}}},"StorageThroughput":{"type":"integer"},"CertificateDetails":{"shape":"S3j"},"EngineLifecycleSupport":{}},"wrapper":true},"S3e":{"type":"list","member":{"locationName":"DomainMembership","type":"structure","members":{"Domain":{},"Status":{},"FQDN":{},"IAMRoleName":{},"OU":{},"AuthSecretArn":{},"DnsIps":{"shape":"Sv"}}}},"S3i":{"type":"structure","members":{"LogTypesToEnable":{"shape":"S2p"},"LogTypesToDisable":{"shape":"S2p"}}},"S3j":{"type":"structure","members":{"CAIdentifier":{},"ValidTill":{"type":"timestamp"}}},"S3l":{"type":"structure","members":{"SecretArn":{},"SecretStatus":{},"KmsKeyId":{}}},"S3q":{"type":"structure","members":{"DBClusterEndpointIdentifier":{},"DBClusterIdentifier":{},"DBClusterEndpointResourceIdentifier":{},"Endpoint":{},"Status":{},"EndpointType":{},"CustomEndpointType":{},"StaticMembers":{"shape":"Sv"},"ExcludedMembers":{"shape":"Sv"},"DBClusterEndpointArn":{}}},"S3w":{"type":"list","member":{"locationName":"DBSecurityGroupName"}},"S3y":{"type":"structure","members":{"DBInstanceIdentifier":{},"DBInstanceClass":{},"Engine":{},"DBInstanceStatus":{},"AutomaticRestartTime":{"type":"timestamp"},"MasterUsername":{},"DBName":{},"Endpoint":{"shape":"S3z"},"AllocatedStorage":{"type":"integer"},"InstanceCreateTime":{"type":"timestamp"},"PreferredBackupWindow":{},"BackupRetentionPeriod":{"type":"integer"},"DBSecurityGroups":{"shape":"S1l"},"VpcSecurityGroups":{"shape":"S1n"},"DBParameterGroups":{"type":"list","member":{"locationName":"DBParameterGroup","type":"structure","members":{"DBParameterGroupName":{},"ParameterApplyStatus":{}}}},"AvailabilityZone":{},"DBSubnetGroup":{"shape":"S42"},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"DBInstanceClass":{},"AllocatedStorage":{"type":"integer"},"MasterUserPassword":{},"Port":{"type":"integer"},"BackupRetentionPeriod":{"type":"integer"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"DBInstanceIdentifier":{},"StorageType":{},"CACertificateIdentifier":{},"DBSubnetGroupName":{},"PendingCloudwatchLogsExports":{"shape":"S3i"},"ProcessorFeatures":{"shape":"S1c"},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"AutomationMode":{},"ResumeFullAutomationModeTime":{"type":"timestamp"},"StorageThroughput":{"type":"integer"},"Engine":{},"DedicatedLogVolume":{"type":"boolean"},"MultiTenant":{"type":"boolean"}}},"LatestRestorableTime":{"type":"timestamp"},"MultiAZ":{"type":"boolean"},"EngineVersion":{},"AutoMinorVersionUpgrade":{"type":"boolean"},"ReadReplicaSourceDBInstanceIdentifier":{},"ReadReplicaDBInstanceIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBInstanceIdentifier"}},"ReadReplicaDBClusterIdentifiers":{"type":"list","member":{"locationName":"ReadReplicaDBClusterIdentifier"}},"ReplicaMode":{},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupMemberships":{"type":"list","member":{"locationName":"OptionGroupMembership","type":"structure","members":{"OptionGroupName":{},"Status":{}}}},"CharacterSetName":{},"NcharCharacterSetName":{},"SecondaryAvailabilityZone":{},"PubliclyAccessible":{"type":"boolean"},"StatusInfos":{"type":"list","member":{"locationName":"DBInstanceStatusInfo","type":"structure","members":{"StatusType":{},"Normal":{"type":"boolean"},"Status":{},"Message":{}}}},"StorageType":{},"TdeCredentialArn":{},"DbInstancePort":{"type":"integer"},"DBClusterIdentifier":{},"StorageEncrypted":{"type":"boolean"},"KmsKeyId":{},"DbiResourceId":{},"CACertificateIdentifier":{},"DomainMemberships":{"shape":"S3e"},"CopyTagsToSnapshot":{"type":"boolean"},"MonitoringInterval":{"type":"integer"},"EnhancedMonitoringResourceArn":{},"MonitoringRoleArn":{},"PromotionTier":{"type":"integer"},"DBInstanceArn":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"PerformanceInsightsEnabled":{"type":"boolean"},"PerformanceInsightsKMSKeyId":{},"PerformanceInsightsRetentionPeriod":{"type":"integer"},"EnabledCloudwatchLogsExports":{"shape":"S2p"},"ProcessorFeatures":{"shape":"S1c"},"DeletionProtection":{"type":"boolean"},"AssociatedRoles":{"type":"list","member":{"locationName":"DBInstanceRole","type":"structure","members":{"RoleArn":{},"FeatureName":{},"Status":{}}}},"ListenerEndpoint":{"shape":"S3z"},"MaxAllocatedStorage":{"type":"integer"},"TagList":{"shape":"Sb"},"DBInstanceAutomatedBackupsReplications":{"shape":"S4h"},"CustomerOwnedIpEnabled":{"type":"boolean"},"AwsBackupRecoveryPointArn":{},"ActivityStreamStatus":{},"ActivityStreamKmsKeyId":{},"ActivityStreamKinesisStreamName":{},"ActivityStreamMode":{},"ActivityStreamEngineNativeAuditFieldsIncluded":{"type":"boolean"},"AutomationMode":{},"ResumeFullAutomationModeTime":{"type":"timestamp"},"CustomIamInstanceProfile":{},"BackupTarget":{},"NetworkType":{},"ActivityStreamPolicyStatus":{},"StorageThroughput":{"type":"integer"},"DBSystemId":{},"MasterUserSecret":{"shape":"S3l"},"CertificateDetails":{"shape":"S3j"},"ReadReplicaSourceDBClusterIdentifier":{},"PercentProgress":{},"DedicatedLogVolume":{"type":"boolean"},"IsStorageConfigUpgradeAvailable":{"type":"boolean"},"MultiTenant":{"type":"boolean"},"EngineLifecycleSupport":{}},"wrapper":true},"S3z":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"HostedZoneId":{}}},"S42":{"type":"structure","members":{"DBSubnetGroupName":{},"DBSubnetGroupDescription":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S45"},"SubnetOutpost":{"type":"structure","members":{"Arn":{}}},"SubnetStatus":{}}}},"DBSubnetGroupArn":{},"SupportedNetworkTypes":{"shape":"Sv"}},"wrapper":true},"S45":{"type":"structure","members":{"Name":{}},"wrapper":true},"S4h":{"type":"list","member":{"locationName":"DBInstanceAutomatedBackupsReplication","type":"structure","members":{"DBInstanceAutomatedBackupsArn":{}}}},"S4q":{"type":"list","member":{"type":"structure","members":{"Description":{},"UserName":{},"AuthScheme":{},"SecretArn":{},"IAMAuth":{},"ClientPasswordAuthType":{}}}},"S4w":{"type":"structure","members":{"DBProxyName":{},"DBProxyArn":{},"Status":{},"EngineFamily":{},"VpcId":{},"VpcSecurityGroupIds":{"shape":"Sv"},"VpcSubnetIds":{"shape":"Sv"},"Auth":{"type":"list","member":{"type":"structure","members":{"Description":{},"UserName":{},"AuthScheme":{},"SecretArn":{},"IAMAuth":{},"ClientPasswordAuthType":{}}}},"RoleArn":{},"Endpoint":{},"RequireTLS":{"type":"boolean"},"IdleClientTimeout":{"type":"integer"},"DebugLogging":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"}}},"S55":{"type":"structure","members":{"DBProxyEndpointName":{},"DBProxyEndpointArn":{},"DBProxyName":{},"Status":{},"VpcId":{},"VpcSecurityGroupIds":{"shape":"Sv"},"VpcSubnetIds":{"shape":"Sv"},"Endpoint":{},"CreatedDate":{"type":"timestamp"},"TargetRole":{},"IsDefault":{"type":"boolean"}}},"S5a":{"type":"structure","members":{"DBShardGroupResourceId":{},"DBShardGroupIdentifier":{},"DBClusterIdentifier":{},"MaxACU":{"type":"double"},"ComputeRedundancy":{"type":"integer"},"Status":{},"PubliclyAccessible":{"type":"boolean"},"Endpoint":{}}},"S5f":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S5l":{"type":"structure","members":{"GlobalClusterIdentifier":{},"GlobalClusterResourceId":{},"GlobalClusterArn":{},"Status":{},"Engine":{},"EngineVersion":{},"EngineLifecycleSupport":{},"DatabaseName":{},"StorageEncrypted":{"type":"boolean"},"DeletionProtection":{"type":"boolean"},"GlobalClusterMembers":{"type":"list","member":{"locationName":"GlobalClusterMember","type":"structure","members":{"DBClusterArn":{},"Readers":{"type":"list","member":{}},"IsWriter":{"type":"boolean"},"GlobalWriteForwardingStatus":{},"SynchronizationStatus":{}},"wrapper":true}},"FailoverState":{"type":"structure","members":{"Status":{},"FromDbClusterArn":{},"ToDbClusterArn":{},"IsDataLossAllowed":{"type":"boolean"}},"wrapper":true}},"wrapper":true},"S5w":{"type":"map","key":{},"value":{}},"S5z":{"type":"structure","members":{"SourceArn":{},"TargetArn":{},"IntegrationName":{},"IntegrationArn":{},"KMSKeyId":{},"AdditionalEncryptionContext":{"shape":"S5w"},"Status":{},"Tags":{"shape":"Sb"},"CreateTime":{"type":"timestamp"},"Errors":{"type":"list","member":{"locationName":"IntegrationError","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{},"ErrorMessage":{}}}},"DataFilter":{},"Description":{}}},"S67":{"type":"string","sensitive":true},"S69":{"type":"structure","members":{"TenantDatabaseCreateTime":{"type":"timestamp"},"DBInstanceIdentifier":{},"TenantDBName":{},"Status":{},"MasterUsername":{},"DbiResourceId":{},"TenantDatabaseResourceId":{},"TenantDatabaseARN":{},"CharacterSetName":{},"NcharCharacterSetName":{},"DeletionProtection":{"type":"boolean"},"PendingModifiedValues":{"type":"structure","members":{"MasterUserPassword":{"shape":"S67"},"TenantDBName":{}}},"TagList":{"shape":"Sb"}},"wrapper":true},"S6i":{"type":"structure","members":{"Engine":{},"VpcId":{},"DBClusterAutomatedBackupsArn":{},"DBClusterIdentifier":{},"RestoreWindow":{"shape":"S6j"},"MasterUsername":{},"DbClusterResourceId":{},"Region":{},"LicenseModel":{},"Status":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"ClusterCreateTime":{"type":"timestamp"},"StorageEncrypted":{"type":"boolean"},"AllocatedStorage":{"type":"integer"},"EngineVersion":{},"DBClusterArn":{},"BackupRetentionPeriod":{"type":"integer"},"EngineMode":{},"AvailabilityZones":{"shape":"S14"},"Port":{"type":"integer"},"KmsKeyId":{},"StorageType":{},"Iops":{"type":"integer"},"AwsBackupRecoveryPointArn":{},"StorageThroughput":{"type":"integer"}},"wrapper":true},"S6j":{"type":"structure","members":{"EarliestTime":{"type":"timestamp"},"LatestTime":{"type":"timestamp"}}},"S6s":{"type":"structure","members":{"DBInstanceArn":{},"DbiResourceId":{},"Region":{},"DBInstanceIdentifier":{},"RestoreWindow":{"shape":"S6j"},"AllocatedStorage":{"type":"integer"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"VpcId":{},"InstanceCreateTime":{"type":"timestamp"},"MasterUsername":{},"Engine":{},"EngineVersion":{},"LicenseModel":{},"Iops":{"type":"integer"},"OptionGroupName":{},"TdeCredentialArn":{},"Encrypted":{"type":"boolean"},"StorageType":{},"KmsKeyId":{},"Timezone":{},"IAMDatabaseAuthenticationEnabled":{"type":"boolean"},"BackupRetentionPeriod":{"type":"integer"},"DBInstanceAutomatedBackupsArn":{},"DBInstanceAutomatedBackupsReplications":{"shape":"S4h"},"BackupTarget":{},"StorageThroughput":{"type":"integer"},"AwsBackupRecoveryPointArn":{},"DedicatedLogVolume":{"type":"boolean"},"MultiTenant":{"type":"boolean"}},"wrapper":true},"S7k":{"type":"list","member":{"locationName":"Filter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{"locationName":"Value"}}}}},"S7t":{"type":"structure","members":{"CertificateIdentifier":{},"CertificateType":{},"Thumbprint":{},"ValidFrom":{"type":"timestamp"},"ValidTill":{"type":"timestamp"},"CertificateArn":{},"CustomerOverride":{"type":"boolean"},"CustomerOverrideValidTill":{"type":"timestamp"}},"wrapper":true},"S88":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"ApplyType":{},"DataType":{},"AllowedValues":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{},"ApplyMethod":{},"SupportedEngineModes":{"shape":"S2m"}}}},"S8d":{"type":"structure","members":{"DBClusterSnapshotIdentifier":{},"DBClusterSnapshotAttributes":{"type":"list","member":{"locationName":"DBClusterSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S8g"}}}}},"wrapper":true},"S8g":{"type":"list","member":{"locationName":"AttributeValue"}},"S9e":{"type":"structure","members":{"DBProxyName":{},"TargetGroupName":{},"TargetGroupArn":{},"IsDefault":{"type":"boolean"},"Status":{},"ConnectionPoolConfig":{"type":"structure","members":{"MaxConnectionsPercent":{"type":"integer"},"MaxIdleConnectionsPercent":{"type":"integer"},"ConnectionBorrowTimeout":{"type":"integer"},"SessionPinningFilters":{"shape":"Sv"},"InitQuery":{}}},"CreatedDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"}}},"S9i":{"type":"list","member":{"type":"structure","members":{"TargetArn":{},"Endpoint":{},"TrackedClusterId":{},"RdsResourceId":{},"Port":{"type":"integer"},"Type":{},"Role":{},"TargetHealth":{"type":"structure","members":{"State":{},"Reason":{},"Description":{}}}}}},"S9s":{"type":"structure","members":{"RecommendationId":{},"TypeId":{},"Severity":{},"ResourceArn":{},"Status":{},"CreatedTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"Detection":{},"Recommendation":{},"Description":{},"Reason":{},"RecommendedActions":{"type":"list","member":{"type":"structure","members":{"ActionId":{},"Title":{},"Description":{},"Operation":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"ApplyModes":{"shape":"Sv"},"Status":{},"IssueDetails":{"shape":"S9x"},"ContextAttributes":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}},"Category":{},"Source":{},"TypeDetection":{},"TypeRecommendation":{},"Impact":{},"AdditionalInfo":{},"Links":{"type":"list","member":{"type":"structure","members":{"Text":{},"Url":{}}}},"IssueDetails":{"shape":"S9x"}}},"S9x":{"type":"structure","members":{"PerformanceIssueDetails":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Metrics":{"type":"list","member":{"type":"structure","members":{"Name":{},"References":{"type":"list","member":{"type":"structure","members":{"Name":{},"ReferenceDetails":{"type":"structure","members":{"ScalarReferenceDetails":{"type":"structure","members":{"Value":{"type":"double"}}}}}}}},"StatisticsDetails":{},"MetricQuery":{"type":"structure","members":{"PerformanceInsightsMetricQuery":{"type":"structure","members":{"GroupBy":{"type":"structure","members":{"Dimensions":{"shape":"Sv"},"Group":{},"Limit":{"type":"integer"}}},"Metric":{}}}}}}}},"Analysis":{}}}}},"Sal":{"type":"structure","members":{"DBSnapshotIdentifier":{},"DBSnapshotAttributes":{"type":"list","member":{"locationName":"DBSnapshotAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"shape":"S8g"}},"wrapper":true}}},"wrapper":true},"Sb0":{"type":"structure","members":{"DBParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S88"}},"wrapper":true},"Sc9":{"type":"list","member":{"locationName":"AvailableProcessorFeature","type":"structure","members":{"Name":{},"DefaultValue":{},"AllowedValues":{}}}},"Sci":{"type":"structure","members":{"ReservedDBInstanceId":{},"ReservedDBInstancesOfferingId":{},"DBInstanceClass":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"DBInstanceCount":{"type":"integer"},"ProductDescription":{},"OfferingType":{},"MultiAZ":{"type":"boolean"},"State":{},"RecurringCharges":{"shape":"Scj"},"ReservedDBInstanceArn":{},"LeaseId":{}},"wrapper":true},"Scj":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"Sd1":{"type":"list","member":{"locationName":"Range","type":"structure","members":{"From":{"type":"integer"},"To":{"type":"integer"},"Step":{"type":"integer"}}}},"Sd3":{"type":"list","member":{"locationName":"DoubleRange","type":"structure","members":{"From":{"type":"double"},"To":{"type":"double"}}}},"Sdt":{"type":"structure","members":{"EnableLogTypes":{"shape":"S2p"},"DisableLogTypes":{"shape":"S2p"}}},"Sdy":{"type":"structure","members":{"DBClusterParameterGroupName":{}}},"Se4":{"type":"structure","members":{"DBParameterGroupName":{}}}}}

/***/ }),
/* 591 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeBlueGreenDeployments":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"BlueGreenDeployments"},"DescribeCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Certificates"},"DescribeDBClusterAutomatedBackups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterAutomatedBackups"},"DescribeDBClusterBacktracks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterBacktracks"},"DescribeDBClusterEndpoints":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterEndpoints"},"DescribeDBClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterParameterGroups"},"DescribeDBClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusterSnapshots"},"DescribeDBClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBClusters"},"DescribeDBEngineVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBEngineVersions"},"DescribeDBInstanceAutomatedBackups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstanceAutomatedBackups"},"DescribeDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBInstances"},"DescribeDBLogFiles":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DescribeDBLogFiles"},"DescribeDBParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBParameterGroups"},"DescribeDBParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeDBProxies":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBProxies"},"DescribeDBProxyEndpoints":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBProxyEndpoints"},"DescribeDBProxyTargetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TargetGroups"},"DescribeDBProxyTargets":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Targets"},"DescribeDBRecommendations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBRecommendations"},"DescribeDBSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSecurityGroups"},"DescribeDBSnapshotTenantDatabases":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshotTenantDatabases"},"DescribeDBSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSnapshots"},"DescribeDBSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DBSubnetGroups"},"DescribeEngineDefaultParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"EngineDefaults.Marker","result_key":"EngineDefaults.Parameters"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeExportTasks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ExportTasks"},"DescribeGlobalClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"GlobalClusters"},"DescribeIntegrations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Integrations"},"DescribeOptionGroupOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupOptions"},"DescribeOptionGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OptionGroupsList"},"DescribeOrderableDBInstanceOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableDBInstanceOptions"},"DescribePendingMaintenanceActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"PendingMaintenanceActions"},"DescribeReservedDBInstances":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstances"},"DescribeReservedDBInstancesOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedDBInstancesOfferings"},"DescribeSourceRegions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"SourceRegions"},"DescribeTenantDatabases":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TenantDatabases"},"DownloadDBLogFilePortion":{"input_token":"Marker","limit_key":"NumberOfLines","more_results":"AdditionalDataPending","output_token":"Marker","result_key":"LogFileData"},"ListTagsForResource":{"result_key":"TagList"}}}

/***/ }),
/* 592 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"DBInstanceAvailable":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBInstanceDeleted":{"delay":30,"operation":"DescribeDBInstances","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBInstances) == `0`"},{"expected":"DBInstanceNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBInstances[].DBInstanceStatus"}]},"DBSnapshotAvailable":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBSnapshotDeleted":{"delay":30,"operation":"DescribeDBSnapshots","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBSnapshots) == `0`"},{"expected":"DBSnapshotNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBSnapshots[].Status"}]},"DBClusterSnapshotAvailable":{"delay":30,"operation":"DescribeDBClusterSnapshots","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBClusterSnapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"}]},"DBClusterSnapshotDeleted":{"delay":30,"operation":"DescribeDBClusterSnapshots","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBClusterSnapshots) == `0`"},{"expected":"DBClusterSnapshotNotFoundFault","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBClusterSnapshots[].Status"}]},"DBClusterAvailable":{"delay":30,"operation":"DescribeDBClusters","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"DBClusters[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"}]},"DBClusterDeleted":{"delay":30,"operation":"DescribeDBClusters","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(DBClusters) == `0`"},{"expected":"DBClusterNotFoundFault","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"},{"expected":"rebooting","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"},{"expected":"resetting-master-credentials","matcher":"pathAny","state":"failure","argument":"DBClusters[].Status"}]},"TenantDatabaseAvailable":{"delay":30,"operation":"DescribeTenantDatabases","maxAttempts":60,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"TenantDatabases[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"TenantDatabases[].Status"},{"expected":"incompatible-parameters","matcher":"pathAny","state":"failure","argument":"TenantDatabases[].Status"},{"expected":"incompatible-restore","matcher":"pathAny","state":"failure","argument":"TenantDatabases[].Status"}]},"TenantDatabaseDeleted":{"delay":30,"operation":"DescribeTenantDatabases","maxAttempts":60,"acceptors":[{"expected":true,"matcher":"path","state":"success","argument":"length(TenantDatabases) == `0`"},{"expected":"DBInstanceNotFoundFault","matcher":"error","state":"success"}]}}}

/***/ }),
/* 593 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-12-01","endpointPrefix":"redshift","protocol":"query","serviceFullName":"Amazon Redshift","serviceId":"Redshift","signatureVersion":"v4","uid":"redshift-2012-12-01","xmlNamespace":"http://redshift.amazonaws.com/doc/2012-12-01/"},"operations":{"AcceptReservedNodeExchange":{"input":{"type":"structure","required":["ReservedNodeId","TargetReservedNodeOfferingId"],"members":{"ReservedNodeId":{},"TargetReservedNodeOfferingId":{}}},"output":{"resultWrapper":"AcceptReservedNodeExchangeResult","type":"structure","members":{"ExchangedReservedNode":{"shape":"S4"}}}},"AddPartner":{"input":{"shape":"Sb"},"output":{"shape":"Sg","resultWrapper":"AddPartnerResult"}},"AssociateDataShareConsumer":{"input":{"type":"structure","required":["DataShareArn"],"members":{"DataShareArn":{},"AssociateEntireAccount":{"type":"boolean"},"ConsumerArn":{},"ConsumerRegion":{},"AllowWrites":{"type":"boolean"}}},"output":{"shape":"Sj","resultWrapper":"AssociateDataShareConsumerResult"}},"AuthorizeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"AuthorizeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sq"}}}},"AuthorizeDataShare":{"input":{"type":"structure","required":["DataShareArn","ConsumerIdentifier"],"members":{"DataShareArn":{},"ConsumerIdentifier":{},"AllowWrites":{"type":"boolean"}}},"output":{"shape":"Sj","resultWrapper":"AuthorizeDataShareResult"}},"AuthorizeEndpointAccess":{"input":{"type":"structure","required":["Account"],"members":{"ClusterIdentifier":{},"Account":{},"VpcIds":{"shape":"Sz"}}},"output":{"shape":"S10","resultWrapper":"AuthorizeEndpointAccessResult"}},"AuthorizeSnapshotAccess":{"input":{"type":"structure","required":["AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotArn":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"AuthorizeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"BatchDeleteClusterSnapshots":{"input":{"type":"structure","required":["Identifiers"],"members":{"Identifiers":{"type":"list","member":{"shape":"S1c","locationName":"DeleteClusterSnapshotMessage"}}}},"output":{"resultWrapper":"BatchDeleteClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"S1e"},"Errors":{"type":"list","member":{"shape":"S1g","locationName":"SnapshotErrorMessage"}}}}},"BatchModifyClusterSnapshots":{"input":{"type":"structure","required":["SnapshotIdentifierList"],"members":{"SnapshotIdentifierList":{"shape":"S1e"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"BatchModifyClusterSnapshotsResult","type":"structure","members":{"Resources":{"shape":"S1e"},"Errors":{"type":"list","member":{"shape":"S1g","locationName":"SnapshotErrorMessage"}}}}},"CancelResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S1l","resultWrapper":"CancelResizeResult"}},"CopyClusterSnapshot":{"input":{"type":"structure","required":["SourceSnapshotIdentifier","TargetSnapshotIdentifier"],"members":{"SourceSnapshotIdentifier":{},"SourceSnapshotClusterIdentifier":{},"TargetSnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"CopyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"CreateAuthenticationProfile":{"input":{"type":"structure","required":["AuthenticationProfileName","AuthenticationProfileContent"],"members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}},"output":{"resultWrapper":"CreateAuthenticationProfileResult","type":"structure","members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}}},"CreateCluster":{"input":{"type":"structure","required":["ClusterIdentifier","NodeType","MasterUsername"],"members":{"DBName":{},"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"MasterUsername":{},"MasterUserPassword":{"shape":"S1x"},"ClusterSecurityGroups":{"shape":"S1y"},"VpcSecurityGroupIds":{"shape":"S1z"},"ClusterSubnetGroupName":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Port":{"type":"integer"},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"Tags":{"shape":"St"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S20"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{},"AvailabilityZoneRelocation":{"type":"boolean"},"AquaConfigurationStatus":{},"DefaultIamRoleArn":{},"LoadSampleData":{},"ManageMasterPassword":{"type":"boolean"},"MasterPasswordSecretKmsKeyId":{},"IpAddressType":{},"MultiAZ":{"type":"boolean"},"RedshiftIdcApplicationArn":{}}},"output":{"resultWrapper":"CreateClusterResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"CreateClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","ParameterGroupFamily","Description"],"members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterParameterGroupResult","type":"structure","members":{"ClusterParameterGroup":{"shape":"S33"}}}},"CreateClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName","Description"],"members":{"ClusterSecurityGroupName":{},"Description":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterSecurityGroupResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sq"}}}},"CreateClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier","ClusterIdentifier"],"members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"CreateClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","Description","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S39"},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S3b"}}}},"CreateCustomDomainAssociation":{"input":{"type":"structure","required":["CustomDomainName","CustomDomainCertificateArn","ClusterIdentifier"],"members":{"CustomDomainName":{},"CustomDomainCertificateArn":{},"ClusterIdentifier":{}}},"output":{"resultWrapper":"CreateCustomDomainAssociationResult","type":"structure","members":{"CustomDomainName":{},"CustomDomainCertificateArn":{},"ClusterIdentifier":{},"CustomDomainCertExpiryTime":{}}}},"CreateEndpointAccess":{"input":{"type":"structure","required":["EndpointName","SubnetGroupName"],"members":{"ClusterIdentifier":{},"ResourceOwner":{},"EndpointName":{},"SubnetGroupName":{},"VpcSecurityGroupIds":{"shape":"S1z"}}},"output":{"shape":"S3n","resultWrapper":"CreateEndpointAccessResult"}},"CreateEventSubscription":{"input":{"type":"structure","required":["SubscriptionName","SnsTopicArn"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S3p"},"EventCategories":{"shape":"S3q"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S3s"}}}},"CreateHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateHsmClientCertificateResult","type":"structure","members":{"HsmClientCertificate":{"shape":"S3v"}}}},"CreateHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier","Description","HsmIpAddress","HsmPartitionName","HsmPartitionPassword","HsmServerPublicCertificate"],"members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"HsmPartitionPassword":{},"HsmServerPublicCertificate":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateHsmConfigurationResult","type":"structure","members":{"HsmConfiguration":{"shape":"S3y"}}}},"CreateRedshiftIdcApplication":{"input":{"type":"structure","required":["IdcInstanceArn","RedshiftIdcApplicationName","IdcDisplayName","IamRoleArn"],"members":{"IdcInstanceArn":{},"RedshiftIdcApplicationName":{},"IdentityNamespace":{},"IdcDisplayName":{},"IamRoleArn":{},"AuthorizedTokenIssuerList":{"shape":"S43"},"ServiceIntegrations":{"shape":"S46"}}},"output":{"resultWrapper":"CreateRedshiftIdcApplicationResult","type":"structure","members":{"RedshiftIdcApplication":{"shape":"S4d"}}}},"CreateScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName","TargetAction","Schedule","IamRole"],"members":{"ScheduledActionName":{},"TargetAction":{"shape":"S4f"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Enable":{"type":"boolean"}}},"output":{"shape":"S4j","resultWrapper":"CreateScheduledActionResult"}},"CreateSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"St"}}},"output":{"resultWrapper":"CreateSnapshotCopyGrantResult","type":"structure","members":{"SnapshotCopyGrant":{"shape":"S4o"}}}},"CreateSnapshotSchedule":{"input":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S4q"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"St"},"DryRun":{"type":"boolean"},"NextInvocations":{"type":"integer"}}},"output":{"shape":"S4r","resultWrapper":"CreateSnapshotScheduleResult"}},"CreateTags":{"input":{"type":"structure","required":["ResourceName","Tags"],"members":{"ResourceName":{},"Tags":{"shape":"St"}}}},"CreateUsageLimit":{"input":{"type":"structure","required":["ClusterIdentifier","FeatureType","LimitType","Amount"],"members":{"ClusterIdentifier":{},"FeatureType":{},"LimitType":{},"Amount":{"type":"long"},"Period":{},"BreachAction":{},"Tags":{"shape":"St"}}},"output":{"shape":"S51","resultWrapper":"CreateUsageLimitResult"}},"DeauthorizeDataShare":{"input":{"type":"structure","required":["DataShareArn","ConsumerIdentifier"],"members":{"DataShareArn":{},"ConsumerIdentifier":{}}},"output":{"shape":"Sj","resultWrapper":"DeauthorizeDataShareResult"}},"DeleteAuthenticationProfile":{"input":{"type":"structure","required":["AuthenticationProfileName"],"members":{"AuthenticationProfileName":{}}},"output":{"resultWrapper":"DeleteAuthenticationProfileResult","type":"structure","members":{"AuthenticationProfileName":{}}}},"DeleteCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"SkipFinalClusterSnapshot":{"type":"boolean"},"FinalClusterSnapshotIdentifier":{},"FinalClusterSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"DeleteClusterResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"DeleteClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{}}}},"DeleteClusterSecurityGroup":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{}}}},"DeleteClusterSnapshot":{"input":{"shape":"S1c"},"output":{"resultWrapper":"DeleteClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"DeleteClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName"],"members":{"ClusterSubnetGroupName":{}}}},"DeleteCustomDomainAssociation":{"input":{"type":"structure","required":["ClusterIdentifier","CustomDomainName"],"members":{"ClusterIdentifier":{},"CustomDomainName":{}}}},"DeleteEndpointAccess":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{}}},"output":{"shape":"S3n","resultWrapper":"DeleteEndpointAccessResult"}},"DeleteEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{}}}},"DeleteHsmClientCertificate":{"input":{"type":"structure","required":["HsmClientCertificateIdentifier"],"members":{"HsmClientCertificateIdentifier":{}}}},"DeleteHsmConfiguration":{"input":{"type":"structure","required":["HsmConfigurationIdentifier"],"members":{"HsmConfigurationIdentifier":{}}}},"DeletePartner":{"input":{"shape":"Sb"},"output":{"shape":"Sg","resultWrapper":"DeletePartnerResult"}},"DeleteRedshiftIdcApplication":{"input":{"type":"structure","required":["RedshiftIdcApplicationArn"],"members":{"RedshiftIdcApplicationArn":{}}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}}},"DeleteScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{}}}},"DeleteSnapshotCopyGrant":{"input":{"type":"structure","required":["SnapshotCopyGrantName"],"members":{"SnapshotCopyGrantName":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier"],"members":{"ScheduleIdentifier":{}}}},"DeleteTags":{"input":{"type":"structure","required":["ResourceName","TagKeys"],"members":{"ResourceName":{},"TagKeys":{"shape":"S5m"}}}},"DeleteUsageLimit":{"input":{"type":"structure","required":["UsageLimitId"],"members":{"UsageLimitId":{}}}},"DescribeAccountAttributes":{"input":{"type":"structure","members":{"AttributeNames":{"type":"list","member":{"locationName":"AttributeName"}}}},"output":{"resultWrapper":"DescribeAccountAttributesResult","type":"structure","members":{"AccountAttributes":{"type":"list","member":{"locationName":"AccountAttribute","type":"structure","members":{"AttributeName":{},"AttributeValues":{"type":"list","member":{"locationName":"AttributeValueTarget","type":"structure","members":{"AttributeValue":{}}}}}}}}}},"DescribeAuthenticationProfiles":{"input":{"type":"structure","members":{"AuthenticationProfileName":{}}},"output":{"resultWrapper":"DescribeAuthenticationProfilesResult","type":"structure","members":{"AuthenticationProfiles":{"type":"list","member":{"type":"structure","members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}}}}}},"DescribeClusterDbRevisions":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterDbRevisionsResult","type":"structure","members":{"Marker":{},"ClusterDbRevisions":{"type":"list","member":{"locationName":"ClusterDbRevision","type":"structure","members":{"ClusterIdentifier":{},"CurrentDatabaseRevision":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"},"RevisionTargets":{"type":"list","member":{"locationName":"RevisionTarget","type":"structure","members":{"DatabaseRevision":{},"Description":{},"DatabaseRevisionReleaseDate":{"type":"timestamp"}}}}}}}}}},"DescribeClusterParameterGroups":{"input":{"type":"structure","members":{"ParameterGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeClusterParameterGroupsResult","type":"structure","members":{"Marker":{},"ParameterGroups":{"type":"list","member":{"shape":"S33","locationName":"ClusterParameterGroup"}}}}},"DescribeClusterParameters":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"Source":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterParametersResult","type":"structure","members":{"Parameters":{"shape":"S6b"},"Marker":{}}}},"DescribeClusterSecurityGroups":{"input":{"type":"structure","members":{"ClusterSecurityGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeClusterSecurityGroupsResult","type":"structure","members":{"Marker":{},"ClusterSecurityGroups":{"type":"list","member":{"shape":"Sq","locationName":"ClusterSecurityGroup"}}}}},"DescribeClusterSnapshots":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotArn":{},"SnapshotType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxRecords":{"type":"integer"},"Marker":{},"OwnerAccount":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"},"ClusterExists":{"type":"boolean"},"SortingEntities":{"type":"list","member":{"locationName":"SnapshotSortingEntity","type":"structure","required":["Attribute"],"members":{"Attribute":{},"SortOrder":{}}}}}},"output":{"resultWrapper":"DescribeClusterSnapshotsResult","type":"structure","members":{"Marker":{},"Snapshots":{"type":"list","member":{"shape":"S14","locationName":"Snapshot"}}}}},"DescribeClusterSubnetGroups":{"input":{"type":"structure","members":{"ClusterSubnetGroupName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeClusterSubnetGroupsResult","type":"structure","members":{"Marker":{},"ClusterSubnetGroups":{"type":"list","member":{"shape":"S3b","locationName":"ClusterSubnetGroup"}}}}},"DescribeClusterTracks":{"input":{"type":"structure","members":{"MaintenanceTrackName":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterTracksResult","type":"structure","members":{"MaintenanceTracks":{"type":"list","member":{"locationName":"MaintenanceTrack","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"UpdateTargets":{"type":"list","member":{"locationName":"UpdateTarget","type":"structure","members":{"MaintenanceTrackName":{},"DatabaseVersion":{},"SupportedOperations":{"type":"list","member":{"locationName":"SupportedOperation","type":"structure","members":{"OperationName":{}}}}}}}}}},"Marker":{}}}},"DescribeClusterVersions":{"input":{"type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeClusterVersionsResult","type":"structure","members":{"Marker":{},"ClusterVersions":{"type":"list","member":{"locationName":"ClusterVersion","type":"structure","members":{"ClusterVersion":{},"ClusterParameterGroupFamily":{},"Description":{}}}}}}},"DescribeClusters":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeClustersResult","type":"structure","members":{"Marker":{},"Clusters":{"type":"list","member":{"shape":"S23","locationName":"Cluster"}}}}},"DescribeCustomDomainAssociations":{"input":{"type":"structure","members":{"CustomDomainName":{},"CustomDomainCertificateArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeCustomDomainAssociationsResult","type":"structure","members":{"Marker":{},"Associations":{"type":"list","member":{"locationName":"Association","type":"structure","members":{"CustomDomainCertificateArn":{},"CustomDomainCertificateExpiryDate":{"type":"timestamp"},"CertificateAssociations":{"type":"list","member":{"locationName":"CertificateAssociation","type":"structure","members":{"CustomDomainName":{},"ClusterIdentifier":{}}}}},"wrapper":true}}}}},"DescribeDataShares":{"input":{"type":"structure","members":{"DataShareArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDataSharesResult","type":"structure","members":{"DataShares":{"shape":"S7e"},"Marker":{}}}},"DescribeDataSharesForConsumer":{"input":{"type":"structure","members":{"ConsumerArn":{},"Status":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDataSharesForConsumerResult","type":"structure","members":{"DataShares":{"shape":"S7e"},"Marker":{}}}},"DescribeDataSharesForProducer":{"input":{"type":"structure","members":{"ProducerArn":{},"Status":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDataSharesForProducerResult","type":"structure","members":{"DataShares":{"shape":"S7e"},"Marker":{}}}},"DescribeDefaultClusterParameters":{"input":{"type":"structure","required":["ParameterGroupFamily"],"members":{"ParameterGroupFamily":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeDefaultClusterParametersResult","type":"structure","members":{"DefaultClusterParameters":{"type":"structure","members":{"ParameterGroupFamily":{},"Marker":{},"Parameters":{"shape":"S6b"}},"wrapper":true}}}},"DescribeEndpointAccess":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"ResourceOwner":{},"EndpointName":{},"VpcId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEndpointAccessResult","type":"structure","members":{"EndpointAccessList":{"type":"list","member":{"shape":"S3n"}},"Marker":{}}}},"DescribeEndpointAuthorization":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"Account":{},"Grantee":{"type":"boolean"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEndpointAuthorizationResult","type":"structure","members":{"EndpointAuthorizationList":{"type":"list","member":{"shape":"S10"}},"Marker":{}}}},"DescribeEventCategories":{"input":{"type":"structure","members":{"SourceType":{}}},"output":{"resultWrapper":"DescribeEventCategoriesResult","type":"structure","members":{"EventCategoriesMapList":{"type":"list","member":{"locationName":"EventCategoriesMap","type":"structure","members":{"SourceType":{},"Events":{"type":"list","member":{"locationName":"EventInfoMap","type":"structure","members":{"EventId":{},"EventCategories":{"shape":"S3q"},"EventDescription":{},"Severity":{}},"wrapper":true}}},"wrapper":true}}}}},"DescribeEventSubscriptions":{"input":{"type":"structure","members":{"SubscriptionName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeEventSubscriptionsResult","type":"structure","members":{"Marker":{},"EventSubscriptionsList":{"type":"list","member":{"shape":"S3s","locationName":"EventSubscription"}}}}},"DescribeEvents":{"input":{"type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Duration":{"type":"integer"},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeEventsResult","type":"structure","members":{"Marker":{},"Events":{"type":"list","member":{"locationName":"Event","type":"structure","members":{"SourceIdentifier":{},"SourceType":{},"Message":{},"EventCategories":{"shape":"S3q"},"Severity":{},"Date":{"type":"timestamp"},"EventId":{}}}}}}},"DescribeHsmClientCertificates":{"input":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeHsmClientCertificatesResult","type":"structure","members":{"Marker":{},"HsmClientCertificates":{"type":"list","member":{"shape":"S3v","locationName":"HsmClientCertificate"}}}}},"DescribeHsmConfigurations":{"input":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeHsmConfigurationsResult","type":"structure","members":{"Marker":{},"HsmConfigurations":{"type":"list","member":{"shape":"S3y","locationName":"HsmConfiguration"}}}}},"DescribeInboundIntegrations":{"input":{"type":"structure","members":{"IntegrationArn":{},"TargetArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeInboundIntegrationsResult","type":"structure","members":{"Marker":{},"InboundIntegrations":{"type":"list","member":{"locationName":"InboundIntegration","type":"structure","members":{"IntegrationArn":{},"SourceArn":{},"TargetArn":{},"Status":{},"Errors":{"type":"list","member":{"locationName":"IntegrationError","type":"structure","required":["ErrorCode"],"members":{"ErrorCode":{},"ErrorMessage":{}}}},"CreateTime":{"type":"timestamp"}}}}}}},"DescribeLoggingStatus":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S8m","resultWrapper":"DescribeLoggingStatusResult"}},"DescribeNodeConfigurationOptions":{"input":{"type":"structure","required":["ActionType"],"members":{"ActionType":{},"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotArn":{},"OwnerAccount":{},"Filters":{"locationName":"Filter","type":"list","member":{"locationName":"NodeConfigurationOptionsFilter","type":"structure","members":{"Name":{},"Operator":{},"Values":{"shape":"S3h","locationName":"Value"}}}},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeNodeConfigurationOptionsResult","type":"structure","members":{"NodeConfigurationOptionList":{"type":"list","member":{"locationName":"NodeConfigurationOption","type":"structure","members":{"NodeType":{},"NumberOfNodes":{"type":"integer"},"EstimatedDiskUtilizationPercent":{"type":"double"},"Mode":{}}}},"Marker":{}}}},"DescribeOrderableClusterOptions":{"input":{"type":"structure","members":{"ClusterVersion":{},"NodeType":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeOrderableClusterOptionsResult","type":"structure","members":{"OrderableClusterOptions":{"type":"list","member":{"locationName":"OrderableClusterOption","type":"structure","members":{"ClusterVersion":{},"ClusterType":{},"NodeType":{},"AvailabilityZones":{"type":"list","member":{"shape":"S3e","locationName":"AvailabilityZone"}}},"wrapper":true}},"Marker":{}}}},"DescribePartners":{"input":{"type":"structure","required":["AccountId","ClusterIdentifier"],"members":{"AccountId":{},"ClusterIdentifier":{},"DatabaseName":{},"PartnerName":{}}},"output":{"resultWrapper":"DescribePartnersResult","type":"structure","members":{"PartnerIntegrationInfoList":{"type":"list","member":{"locationName":"PartnerIntegrationInfo","type":"structure","members":{"DatabaseName":{},"PartnerName":{},"Status":{},"StatusMessage":{},"CreatedAt":{"type":"timestamp"},"UpdatedAt":{"type":"timestamp"}}}}}}},"DescribeRedshiftIdcApplications":{"input":{"type":"structure","members":{"RedshiftIdcApplicationArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeRedshiftIdcApplicationsResult","type":"structure","members":{"RedshiftIdcApplications":{"type":"list","member":{"shape":"S4d"}},"Marker":{}}}},"DescribeReservedNodeExchangeStatus":{"input":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeExchangeRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeExchangeStatusResult","type":"structure","members":{"ReservedNodeExchangeStatusDetails":{"type":"list","member":{"shape":"S2y","locationName":"ReservedNodeExchangeStatus"}},"Marker":{}}}},"DescribeReservedNodeOfferings":{"input":{"type":"structure","members":{"ReservedNodeOfferingId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S9i"}}}},"DescribeReservedNodes":{"input":{"type":"structure","members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeReservedNodesResult","type":"structure","members":{"Marker":{},"ReservedNodes":{"type":"list","member":{"shape":"S4","locationName":"ReservedNode"}}}}},"DescribeResize":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S1l","resultWrapper":"DescribeResizeResult"}},"DescribeScheduledActions":{"input":{"type":"structure","members":{"ScheduledActionName":{},"TargetActionType":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Active":{"type":"boolean"},"Filters":{"type":"list","member":{"locationName":"ScheduledActionFilter","type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"shape":"S3h"}}}},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeScheduledActionsResult","type":"structure","members":{"Marker":{},"ScheduledActions":{"type":"list","member":{"shape":"S4j","locationName":"ScheduledAction"}}}}},"DescribeSnapshotCopyGrants":{"input":{"type":"structure","members":{"SnapshotCopyGrantName":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeSnapshotCopyGrantsResult","type":"structure","members":{"Marker":{},"SnapshotCopyGrants":{"type":"list","member":{"shape":"S4o","locationName":"SnapshotCopyGrant"}}}}},"DescribeSnapshotSchedules":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"},"Marker":{},"MaxRecords":{"type":"integer"}}},"output":{"resultWrapper":"DescribeSnapshotSchedulesResult","type":"structure","members":{"SnapshotSchedules":{"type":"list","member":{"shape":"S4r","locationName":"SnapshotSchedule"}},"Marker":{}}}},"DescribeStorage":{"output":{"resultWrapper":"DescribeStorageResult","type":"structure","members":{"TotalBackupSizeInMegaBytes":{"type":"double"},"TotalProvisionedStorageInMegaBytes":{"type":"double"}}}},"DescribeTableRestoreStatus":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"TableRestoreRequestId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"DescribeTableRestoreStatusResult","type":"structure","members":{"TableRestoreStatusDetails":{"type":"list","member":{"shape":"Sa5","locationName":"TableRestoreStatus"}},"Marker":{}}}},"DescribeTags":{"input":{"type":"structure","members":{"ResourceName":{},"ResourceType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeTagsResult","type":"structure","members":{"TaggedResources":{"type":"list","member":{"locationName":"TaggedResource","type":"structure","members":{"Tag":{"shape":"Su"},"ResourceName":{},"ResourceType":{}}}},"Marker":{}}}},"DescribeUsageLimits":{"input":{"type":"structure","members":{"UsageLimitId":{},"ClusterIdentifier":{},"FeatureType":{},"MaxRecords":{"type":"integer"},"Marker":{},"TagKeys":{"shape":"S5m"},"TagValues":{"shape":"S66"}}},"output":{"resultWrapper":"DescribeUsageLimitsResult","type":"structure","members":{"UsageLimits":{"type":"list","member":{"shape":"S51"}},"Marker":{}}}},"DisableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"shape":"S8m","resultWrapper":"DisableLoggingResult"}},"DisableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"DisableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"DisassociateDataShareConsumer":{"input":{"type":"structure","required":["DataShareArn"],"members":{"DataShareArn":{},"DisassociateEntireAccount":{"type":"boolean"},"ConsumerArn":{},"ConsumerRegion":{}}},"output":{"shape":"Sj","resultWrapper":"DisassociateDataShareConsumerResult"}},"EnableLogging":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"BucketName":{},"S3KeyPrefix":{},"LogDestinationType":{},"LogExports":{"shape":"S8o"}}},"output":{"shape":"S8m","resultWrapper":"EnableLoggingResult"}},"EnableSnapshotCopy":{"input":{"type":"structure","required":["ClusterIdentifier","DestinationRegion"],"members":{"ClusterIdentifier":{},"DestinationRegion":{},"RetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"}}},"output":{"resultWrapper":"EnableSnapshotCopyResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"FailoverPrimaryCompute":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"FailoverPrimaryComputeResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"GetClusterCredentials":{"input":{"type":"structure","required":["DbUser"],"members":{"DbUser":{},"DbName":{},"ClusterIdentifier":{},"DurationSeconds":{"type":"integer"},"AutoCreate":{"type":"boolean"},"DbGroups":{"type":"list","member":{"locationName":"DbGroup"}},"CustomDomainName":{}}},"output":{"resultWrapper":"GetClusterCredentialsResult","type":"structure","members":{"DbUser":{},"DbPassword":{"shape":"S1x"},"Expiration":{"type":"timestamp"}}}},"GetClusterCredentialsWithIAM":{"input":{"type":"structure","members":{"DbName":{},"ClusterIdentifier":{},"DurationSeconds":{"type":"integer"},"CustomDomainName":{}}},"output":{"resultWrapper":"GetClusterCredentialsWithIAMResult","type":"structure","members":{"DbUser":{},"DbPassword":{"shape":"S1x"},"Expiration":{"type":"timestamp"},"NextRefreshTime":{"type":"timestamp"}}}},"GetReservedNodeExchangeConfigurationOptions":{"input":{"type":"structure","required":["ActionType"],"members":{"ActionType":{},"ClusterIdentifier":{},"SnapshotIdentifier":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetReservedNodeExchangeConfigurationOptionsResult","type":"structure","members":{"Marker":{},"ReservedNodeConfigurationOptionList":{"type":"list","member":{"locationName":"ReservedNodeConfigurationOption","type":"structure","members":{"SourceReservedNode":{"shape":"S4"},"TargetReservedNodeCount":{"type":"integer"},"TargetReservedNodeOffering":{"shape":"S9j"}},"wrapper":true}}}}},"GetReservedNodeExchangeOfferings":{"input":{"type":"structure","required":["ReservedNodeId"],"members":{"ReservedNodeId":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"GetReservedNodeExchangeOfferingsResult","type":"structure","members":{"Marker":{},"ReservedNodeOfferings":{"shape":"S9i"}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"GetResourcePolicyResult","type":"structure","members":{"ResourcePolicy":{"shape":"Sb1"}}}},"ListRecommendations":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"NamespaceArn":{},"MaxRecords":{"type":"integer"},"Marker":{}}},"output":{"resultWrapper":"ListRecommendationsResult","type":"structure","members":{"Recommendations":{"type":"list","member":{"locationName":"Recommendation","type":"structure","members":{"Id":{},"ClusterIdentifier":{},"NamespaceArn":{},"CreatedAt":{"type":"timestamp"},"RecommendationType":{},"Title":{},"Description":{},"Observation":{},"ImpactRanking":{},"RecommendationText":{},"RecommendedActions":{"type":"list","member":{"locationName":"RecommendedAction","type":"structure","members":{"Text":{},"Database":{},"Command":{},"Type":{}}}},"ReferenceLinks":{"type":"list","member":{"locationName":"ReferenceLink","type":"structure","members":{"Text":{},"Link":{}}}}}}},"Marker":{}}}},"ModifyAquaConfiguration":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AquaConfigurationStatus":{}}},"output":{"resultWrapper":"ModifyAquaConfigurationResult","type":"structure","members":{"AquaConfiguration":{"shape":"S2w"}}}},"ModifyAuthenticationProfile":{"input":{"type":"structure","required":["AuthenticationProfileName","AuthenticationProfileContent"],"members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}},"output":{"resultWrapper":"ModifyAuthenticationProfileResult","type":"structure","members":{"AuthenticationProfileName":{},"AuthenticationProfileContent":{}}}},"ModifyCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterSecurityGroups":{"shape":"S1y"},"VpcSecurityGroupIds":{"shape":"S1z"},"MasterUserPassword":{"shape":"S1x"},"ClusterParameterGroupName":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"PreferredMaintenanceWindow":{},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"NewClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"ElasticIp":{},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"AvailabilityZoneRelocation":{"type":"boolean"},"AvailabilityZone":{},"Port":{"type":"integer"},"ManageMasterPassword":{"type":"boolean"},"MasterPasswordSecretKmsKeyId":{},"IpAddressType":{},"MultiAZ":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyClusterResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"ModifyClusterDbRevision":{"input":{"type":"structure","required":["ClusterIdentifier","RevisionTarget"],"members":{"ClusterIdentifier":{},"RevisionTarget":{}}},"output":{"resultWrapper":"ModifyClusterDbRevisionResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"ModifyClusterIamRoles":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"AddIamRoles":{"shape":"S20"},"RemoveIamRoles":{"shape":"S20"},"DefaultIamRoleArn":{}}},"output":{"resultWrapper":"ModifyClusterIamRolesResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"ModifyClusterMaintenance":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"DeferMaintenance":{"type":"boolean"},"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"},"DeferMaintenanceDuration":{"type":"integer"}}},"output":{"resultWrapper":"ModifyClusterMaintenanceResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"ModifyClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName","Parameters"],"members":{"ParameterGroupName":{},"Parameters":{"shape":"S6b"}}},"output":{"shape":"Sbp","resultWrapper":"ModifyClusterParameterGroupResult"}},"ModifyClusterSnapshot":{"input":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"Force":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyClusterSnapshotResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"ModifyClusterSnapshotSchedule":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ScheduleIdentifier":{},"DisassociateSchedule":{"type":"boolean"}}}},"ModifyClusterSubnetGroup":{"input":{"type":"structure","required":["ClusterSubnetGroupName","SubnetIds"],"members":{"ClusterSubnetGroupName":{},"Description":{},"SubnetIds":{"shape":"S39"}}},"output":{"resultWrapper":"ModifyClusterSubnetGroupResult","type":"structure","members":{"ClusterSubnetGroup":{"shape":"S3b"}}}},"ModifyCustomDomainAssociation":{"input":{"type":"structure","required":["CustomDomainName","CustomDomainCertificateArn","ClusterIdentifier"],"members":{"CustomDomainName":{},"CustomDomainCertificateArn":{},"ClusterIdentifier":{}}},"output":{"resultWrapper":"ModifyCustomDomainAssociationResult","type":"structure","members":{"CustomDomainName":{},"CustomDomainCertificateArn":{},"ClusterIdentifier":{},"CustomDomainCertExpiryTime":{}}}},"ModifyEndpointAccess":{"input":{"type":"structure","required":["EndpointName"],"members":{"EndpointName":{},"VpcSecurityGroupIds":{"shape":"S1z"}}},"output":{"shape":"S3n","resultWrapper":"ModifyEndpointAccessResult"}},"ModifyEventSubscription":{"input":{"type":"structure","required":["SubscriptionName"],"members":{"SubscriptionName":{},"SnsTopicArn":{},"SourceType":{},"SourceIds":{"shape":"S3p"},"EventCategories":{"shape":"S3q"},"Severity":{},"Enabled":{"type":"boolean"}}},"output":{"resultWrapper":"ModifyEventSubscriptionResult","type":"structure","members":{"EventSubscription":{"shape":"S3s"}}}},"ModifyRedshiftIdcApplication":{"input":{"type":"structure","required":["RedshiftIdcApplicationArn"],"members":{"RedshiftIdcApplicationArn":{},"IdentityNamespace":{},"IamRoleArn":{},"IdcDisplayName":{},"AuthorizedTokenIssuerList":{"shape":"S43"},"ServiceIntegrations":{"shape":"S46"}}},"output":{"resultWrapper":"ModifyRedshiftIdcApplicationResult","type":"structure","members":{"RedshiftIdcApplication":{"shape":"S4d"}}}},"ModifyScheduledAction":{"input":{"type":"structure","required":["ScheduledActionName"],"members":{"ScheduledActionName":{},"TargetAction":{"shape":"S4f"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Enable":{"type":"boolean"}}},"output":{"shape":"S4j","resultWrapper":"ModifyScheduledActionResult"}},"ModifySnapshotCopyRetentionPeriod":{"input":{"type":"structure","required":["ClusterIdentifier","RetentionPeriod"],"members":{"ClusterIdentifier":{},"RetentionPeriod":{"type":"integer"},"Manual":{"type":"boolean"}}},"output":{"resultWrapper":"ModifySnapshotCopyRetentionPeriodResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"ModifySnapshotSchedule":{"input":{"type":"structure","required":["ScheduleIdentifier","ScheduleDefinitions"],"members":{"ScheduleIdentifier":{},"ScheduleDefinitions":{"shape":"S4q"}}},"output":{"shape":"S4r","resultWrapper":"ModifySnapshotScheduleResult"}},"ModifyUsageLimit":{"input":{"type":"structure","required":["UsageLimitId"],"members":{"UsageLimitId":{},"Amount":{"type":"long"},"BreachAction":{}}},"output":{"shape":"S51","resultWrapper":"ModifyUsageLimitResult"}},"PauseCluster":{"input":{"shape":"S4h"},"output":{"resultWrapper":"PauseClusterResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"PurchaseReservedNodeOffering":{"input":{"type":"structure","required":["ReservedNodeOfferingId"],"members":{"ReservedNodeOfferingId":{},"NodeCount":{"type":"integer"}}},"output":{"resultWrapper":"PurchaseReservedNodeOfferingResult","type":"structure","members":{"ReservedNode":{"shape":"S4"}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"resultWrapper":"PutResourcePolicyResult","type":"structure","members":{"ResourcePolicy":{"shape":"Sb1"}}}},"RebootCluster":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RebootClusterResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"RejectDataShare":{"input":{"type":"structure","required":["DataShareArn"],"members":{"DataShareArn":{}}},"output":{"shape":"Sj","resultWrapper":"RejectDataShareResult"}},"ResetClusterParameterGroup":{"input":{"type":"structure","required":["ParameterGroupName"],"members":{"ParameterGroupName":{},"ResetAllParameters":{"type":"boolean"},"Parameters":{"shape":"S6b"}}},"output":{"shape":"Sbp","resultWrapper":"ResetClusterParameterGroupResult"}},"ResizeCluster":{"input":{"shape":"S4g"},"output":{"resultWrapper":"ResizeClusterResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"RestoreFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SnapshotArn":{},"SnapshotClusterIdentifier":{},"Port":{"type":"integer"},"AvailabilityZone":{},"AllowVersionUpgrade":{"type":"boolean"},"ClusterSubnetGroupName":{},"PubliclyAccessible":{"type":"boolean"},"OwnerAccount":{},"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"ElasticIp":{},"ClusterParameterGroupName":{},"ClusterSecurityGroups":{"shape":"S1y"},"VpcSecurityGroupIds":{"shape":"S1z"},"PreferredMaintenanceWindow":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"KmsKeyId":{},"NodeType":{},"EnhancedVpcRouting":{"type":"boolean"},"AdditionalInfo":{},"IamRoles":{"shape":"S20"},"MaintenanceTrackName":{},"SnapshotScheduleIdentifier":{},"NumberOfNodes":{"type":"integer"},"AvailabilityZoneRelocation":{"type":"boolean"},"AquaConfigurationStatus":{},"DefaultIamRoleArn":{},"ReservedNodeId":{},"TargetReservedNodeOfferingId":{},"Encrypted":{"type":"boolean"},"ManageMasterPassword":{"type":"boolean"},"MasterPasswordSecretKmsKeyId":{},"IpAddressType":{},"MultiAZ":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreFromClusterSnapshotResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"RestoreTableFromClusterSnapshot":{"input":{"type":"structure","required":["ClusterIdentifier","SnapshotIdentifier","SourceDatabaseName","SourceTableName","NewTableName"],"members":{"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{},"EnableCaseSensitiveIdentifier":{"type":"boolean"}}},"output":{"resultWrapper":"RestoreTableFromClusterSnapshotResult","type":"structure","members":{"TableRestoreStatus":{"shape":"Sa5"}}}},"ResumeCluster":{"input":{"shape":"S4i"},"output":{"resultWrapper":"ResumeClusterResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"RevokeClusterSecurityGroupIngress":{"input":{"type":"structure","required":["ClusterSecurityGroupName"],"members":{"ClusterSecurityGroupName":{},"CIDRIP":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{}}},"output":{"resultWrapper":"RevokeClusterSecurityGroupIngressResult","type":"structure","members":{"ClusterSecurityGroup":{"shape":"Sq"}}}},"RevokeEndpointAccess":{"input":{"type":"structure","members":{"ClusterIdentifier":{},"Account":{},"VpcIds":{"shape":"Sz"},"Force":{"type":"boolean"}}},"output":{"shape":"S10","resultWrapper":"RevokeEndpointAccessResult"}},"RevokeSnapshotAccess":{"input":{"type":"structure","required":["AccountWithRestoreAccess"],"members":{"SnapshotIdentifier":{},"SnapshotArn":{},"SnapshotClusterIdentifier":{},"AccountWithRestoreAccess":{}}},"output":{"resultWrapper":"RevokeSnapshotAccessResult","type":"structure","members":{"Snapshot":{"shape":"S14"}}}},"RotateEncryptionKey":{"input":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"output":{"resultWrapper":"RotateEncryptionKeyResult","type":"structure","members":{"Cluster":{"shape":"S23"}}}},"UpdatePartnerStatus":{"input":{"type":"structure","required":["AccountId","ClusterIdentifier","DatabaseName","PartnerName","Status"],"members":{"AccountId":{},"ClusterIdentifier":{},"DatabaseName":{},"PartnerName":{},"Status":{},"StatusMessage":{}}},"output":{"shape":"Sg","resultWrapper":"UpdatePartnerStatusResult"}}},"shapes":{"S4":{"type":"structure","members":{"ReservedNodeId":{},"ReservedNodeOfferingId":{},"NodeType":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"NodeCount":{"type":"integer"},"State":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true},"S8":{"type":"list","member":{"locationName":"RecurringCharge","type":"structure","members":{"RecurringChargeAmount":{"type":"double"},"RecurringChargeFrequency":{}},"wrapper":true}},"Sb":{"type":"structure","required":["AccountId","ClusterIdentifier","DatabaseName","PartnerName"],"members":{"AccountId":{},"ClusterIdentifier":{},"DatabaseName":{},"PartnerName":{}}},"Sg":{"type":"structure","members":{"DatabaseName":{},"PartnerName":{}}},"Sj":{"type":"structure","members":{"DataShareArn":{},"ProducerArn":{},"AllowPubliclyAccessibleConsumers":{"type":"boolean"},"DataShareAssociations":{"type":"list","member":{"type":"structure","members":{"ConsumerIdentifier":{},"Status":{},"ConsumerRegion":{},"CreatedDate":{"type":"timestamp"},"StatusChangeDate":{"type":"timestamp"},"ProducerAllowedWrites":{"type":"boolean"},"ConsumerAcceptedWrites":{"type":"boolean"}}}},"ManagedBy":{}}},"Sq":{"type":"structure","members":{"ClusterSecurityGroupName":{},"Description":{},"EC2SecurityGroups":{"type":"list","member":{"locationName":"EC2SecurityGroup","type":"structure","members":{"Status":{},"EC2SecurityGroupName":{},"EC2SecurityGroupOwnerId":{},"Tags":{"shape":"St"}}}},"IPRanges":{"type":"list","member":{"locationName":"IPRange","type":"structure","members":{"Status":{},"CIDRIP":{},"Tags":{"shape":"St"}}}},"Tags":{"shape":"St"}},"wrapper":true},"St":{"type":"list","member":{"shape":"Su","locationName":"Tag"}},"Su":{"type":"structure","members":{"Key":{},"Value":{}}},"Sz":{"type":"list","member":{"locationName":"VpcIdentifier"}},"S10":{"type":"structure","members":{"Grantor":{},"Grantee":{},"ClusterIdentifier":{},"AuthorizeTime":{"type":"timestamp"},"ClusterStatus":{},"Status":{},"AllowedAllVPCs":{"type":"boolean"},"AllowedVPCs":{"shape":"Sz"},"EndpointCount":{"type":"integer"}}},"S14":{"type":"structure","members":{"SnapshotIdentifier":{},"ClusterIdentifier":{},"SnapshotCreateTime":{"type":"timestamp"},"Status":{},"Port":{"type":"integer"},"AvailabilityZone":{},"ClusterCreateTime":{"type":"timestamp"},"MasterUsername":{},"ClusterVersion":{},"EngineFullVersion":{},"SnapshotType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"DBName":{},"VpcId":{},"Encrypted":{"type":"boolean"},"KmsKeyId":{},"EncryptedWithHSM":{"type":"boolean"},"AccountsWithRestoreAccess":{"type":"list","member":{"locationName":"AccountWithRestoreAccess","type":"structure","members":{"AccountId":{},"AccountAlias":{}}}},"OwnerAccount":{},"TotalBackupSizeInMegaBytes":{"type":"double"},"ActualIncrementalBackupSizeInMegaBytes":{"type":"double"},"BackupProgressInMegaBytes":{"type":"double"},"CurrentBackupRateInMegaBytesPerSecond":{"type":"double"},"EstimatedSecondsToCompletion":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"SourceRegion":{},"Tags":{"shape":"St"},"RestorableNodeTypes":{"type":"list","member":{"locationName":"NodeType"}},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRemainingDays":{"type":"integer"},"SnapshotRetentionStartTime":{"type":"timestamp"},"MasterPasswordSecretArn":{},"MasterPasswordSecretKmsKeyId":{},"SnapshotArn":{}},"wrapper":true},"S1c":{"type":"structure","required":["SnapshotIdentifier"],"members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{}}},"S1e":{"type":"list","member":{"locationName":"String"}},"S1g":{"type":"structure","members":{"SnapshotIdentifier":{},"SnapshotClusterIdentifier":{},"FailureCode":{},"FailureReason":{}}},"S1l":{"type":"structure","members":{"TargetNodeType":{},"TargetNumberOfNodes":{"type":"integer"},"TargetClusterType":{},"Status":{},"ImportTablesCompleted":{"type":"list","member":{}},"ImportTablesInProgress":{"type":"list","member":{}},"ImportTablesNotStarted":{"type":"list","member":{}},"AvgResizeRateInMegaBytesPerSecond":{"type":"double"},"TotalResizeDataInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ResizeType":{},"Message":{},"TargetEncryptionType":{},"DataTransferProgressPercent":{"type":"double"}}},"S1x":{"type":"string","sensitive":true},"S1y":{"type":"list","member":{"locationName":"ClusterSecurityGroupName"}},"S1z":{"type":"list","member":{"locationName":"VpcSecurityGroupId"}},"S20":{"type":"list","member":{"locationName":"IamRoleArn"}},"S23":{"type":"structure","members":{"ClusterIdentifier":{},"NodeType":{},"ClusterStatus":{},"ClusterAvailabilityStatus":{},"ModifyStatus":{},"MasterUsername":{},"DBName":{},"Endpoint":{"type":"structure","members":{"Address":{},"Port":{"type":"integer"},"VpcEndpoints":{"type":"list","member":{"shape":"S26","locationName":"VpcEndpoint"}}}},"ClusterCreateTime":{"type":"timestamp"},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"ClusterSecurityGroups":{"type":"list","member":{"locationName":"ClusterSecurityGroup","type":"structure","members":{"ClusterSecurityGroupName":{},"Status":{}}}},"VpcSecurityGroups":{"shape":"S2b"},"ClusterParameterGroups":{"type":"list","member":{"locationName":"ClusterParameterGroup","type":"structure","members":{"ParameterGroupName":{},"ParameterApplyStatus":{},"ClusterParameterStatusList":{"type":"list","member":{"type":"structure","members":{"ParameterName":{},"ParameterApplyStatus":{},"ParameterApplyErrorDescription":{}}}}}}},"ClusterSubnetGroupName":{},"VpcId":{},"AvailabilityZone":{},"PreferredMaintenanceWindow":{},"PendingModifiedValues":{"type":"structure","members":{"MasterUserPassword":{"shape":"S1x"},"NodeType":{},"NumberOfNodes":{"type":"integer"},"ClusterType":{},"ClusterVersion":{},"AutomatedSnapshotRetentionPeriod":{"type":"integer"},"ClusterIdentifier":{},"PubliclyAccessible":{"type":"boolean"},"EnhancedVpcRouting":{"type":"boolean"},"MaintenanceTrackName":{},"EncryptionType":{}}},"ClusterVersion":{},"AllowVersionUpgrade":{"type":"boolean"},"NumberOfNodes":{"type":"integer"},"PubliclyAccessible":{"type":"boolean"},"Encrypted":{"type":"boolean"},"RestoreStatus":{"type":"structure","members":{"Status":{},"CurrentRestoreRateInMegaBytesPerSecond":{"type":"double"},"SnapshotSizeInMegaBytes":{"type":"long"},"ProgressInMegaBytes":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"}}},"DataTransferProgress":{"type":"structure","members":{"Status":{},"CurrentRateInMegaBytesPerSecond":{"type":"double"},"TotalDataInMegaBytes":{"type":"long"},"DataTransferredInMegaBytes":{"type":"long"},"EstimatedTimeToCompletionInSeconds":{"type":"long"},"ElapsedTimeInSeconds":{"type":"long"}}},"HsmStatus":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmConfigurationIdentifier":{},"Status":{}}},"ClusterSnapshotCopyStatus":{"type":"structure","members":{"DestinationRegion":{},"RetentionPeriod":{"type":"long"},"ManualSnapshotRetentionPeriod":{"type":"integer"},"SnapshotCopyGrantName":{}}},"ClusterPublicKey":{},"ClusterNodes":{"shape":"S2m"},"ElasticIpStatus":{"type":"structure","members":{"ElasticIp":{},"Status":{}}},"ClusterRevisionNumber":{},"Tags":{"shape":"St"},"KmsKeyId":{},"EnhancedVpcRouting":{"type":"boolean"},"IamRoles":{"type":"list","member":{"locationName":"ClusterIamRole","type":"structure","members":{"IamRoleArn":{},"ApplyStatus":{}}}},"PendingActions":{"type":"list","member":{}},"MaintenanceTrackName":{},"ElasticResizeNumberOfNodeOptions":{},"DeferredMaintenanceWindows":{"type":"list","member":{"locationName":"DeferredMaintenanceWindow","type":"structure","members":{"DeferMaintenanceIdentifier":{},"DeferMaintenanceStartTime":{"type":"timestamp"},"DeferMaintenanceEndTime":{"type":"timestamp"}}}},"SnapshotScheduleIdentifier":{},"SnapshotScheduleState":{},"ExpectedNextSnapshotScheduleTime":{"type":"timestamp"},"ExpectedNextSnapshotScheduleTimeStatus":{},"NextMaintenanceWindowStartTime":{"type":"timestamp"},"ResizeInfo":{"type":"structure","members":{"ResizeType":{},"AllowCancelResize":{"type":"boolean"}}},"AvailabilityZoneRelocationStatus":{},"ClusterNamespaceArn":{},"TotalStorageCapacityInMegaBytes":{"type":"long"},"AquaConfiguration":{"shape":"S2w"},"DefaultIamRoleArn":{},"ReservedNodeExchangeStatus":{"shape":"S2y"},"CustomDomainName":{},"CustomDomainCertificateArn":{},"CustomDomainCertificateExpiryDate":{"type":"timestamp"},"MasterPasswordSecretArn":{},"MasterPasswordSecretKmsKeyId":{},"IpAddressType":{},"MultiAZ":{},"MultiAZSecondary":{"type":"structure","members":{"AvailabilityZone":{},"ClusterNodes":{"shape":"S2m"}}}},"wrapper":true},"S26":{"type":"structure","members":{"VpcEndpointId":{},"VpcId":{},"NetworkInterfaces":{"type":"list","member":{"locationName":"NetworkInterface","type":"structure","members":{"NetworkInterfaceId":{},"SubnetId":{},"PrivateIpAddress":{},"AvailabilityZone":{},"Ipv6Address":{}}}}}},"S2b":{"type":"list","member":{"locationName":"VpcSecurityGroup","type":"structure","members":{"VpcSecurityGroupId":{},"Status":{}}}},"S2m":{"type":"list","member":{"type":"structure","members":{"NodeRole":{},"PrivateIPAddress":{},"PublicIPAddress":{}}}},"S2w":{"type":"structure","members":{"AquaStatus":{},"AquaConfigurationStatus":{}}},"S2y":{"type":"structure","members":{"ReservedNodeExchangeRequestId":{},"Status":{},"RequestTime":{"type":"timestamp"},"SourceReservedNodeId":{},"SourceReservedNodeType":{},"SourceReservedNodeCount":{"type":"integer"},"TargetReservedNodeOfferingId":{},"TargetReservedNodeType":{},"TargetReservedNodeCount":{"type":"integer"}},"wrapper":true},"S33":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupFamily":{},"Description":{},"Tags":{"shape":"St"}},"wrapper":true},"S39":{"type":"list","member":{"locationName":"SubnetIdentifier"}},"S3b":{"type":"structure","members":{"ClusterSubnetGroupName":{},"Description":{},"VpcId":{},"SubnetGroupStatus":{},"Subnets":{"type":"list","member":{"locationName":"Subnet","type":"structure","members":{"SubnetIdentifier":{},"SubnetAvailabilityZone":{"shape":"S3e"},"SubnetStatus":{}}}},"Tags":{"shape":"St"},"SupportedClusterIpAddressTypes":{"shape":"S3h"}},"wrapper":true},"S3e":{"type":"structure","members":{"Name":{},"SupportedPlatforms":{"type":"list","member":{"locationName":"SupportedPlatform","type":"structure","members":{"Name":{}},"wrapper":true}}},"wrapper":true},"S3h":{"type":"list","member":{"locationName":"item"}},"S3n":{"type":"structure","members":{"ClusterIdentifier":{},"ResourceOwner":{},"SubnetGroupName":{},"EndpointStatus":{},"EndpointName":{},"EndpointCreateTime":{"type":"timestamp"},"Port":{"type":"integer"},"Address":{},"VpcSecurityGroups":{"shape":"S2b"},"VpcEndpoint":{"shape":"S26"}}},"S3p":{"type":"list","member":{"locationName":"SourceId"}},"S3q":{"type":"list","member":{"locationName":"EventCategory"}},"S3s":{"type":"structure","members":{"CustomerAwsId":{},"CustSubscriptionId":{},"SnsTopicArn":{},"Status":{},"SubscriptionCreationTime":{"type":"timestamp"},"SourceType":{},"SourceIdsList":{"shape":"S3p"},"EventCategoriesList":{"shape":"S3q"},"Severity":{},"Enabled":{"type":"boolean"},"Tags":{"shape":"St"}},"wrapper":true},"S3v":{"type":"structure","members":{"HsmClientCertificateIdentifier":{},"HsmClientCertificatePublicKey":{},"Tags":{"shape":"St"}},"wrapper":true},"S3y":{"type":"structure","members":{"HsmConfigurationIdentifier":{},"Description":{},"HsmIpAddress":{},"HsmPartitionName":{},"Tags":{"shape":"St"}},"wrapper":true},"S43":{"type":"list","member":{"type":"structure","members":{"TrustedTokenIssuerArn":{},"AuthorizedAudiencesList":{"type":"list","member":{}}}}},"S46":{"type":"list","member":{"type":"structure","members":{"LakeFormation":{"type":"list","member":{"type":"structure","members":{"LakeFormationQuery":{"type":"structure","required":["Authorization"],"members":{"Authorization":{}}}},"union":true}}},"union":true}},"S4d":{"type":"structure","members":{"IdcInstanceArn":{},"RedshiftIdcApplicationName":{},"RedshiftIdcApplicationArn":{},"IdentityNamespace":{},"IdcDisplayName":{},"IamRoleArn":{},"IdcManagedApplicationArn":{},"IdcOnboardStatus":{},"AuthorizedTokenIssuerList":{"shape":"S43"},"ServiceIntegrations":{"shape":"S46"}},"wrapper":true},"S4f":{"type":"structure","members":{"ResizeCluster":{"shape":"S4g"},"PauseCluster":{"shape":"S4h"},"ResumeCluster":{"shape":"S4i"}}},"S4g":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{},"ClusterType":{},"NodeType":{},"NumberOfNodes":{"type":"integer"},"Classic":{"type":"boolean"},"ReservedNodeId":{},"TargetReservedNodeOfferingId":{}}},"S4h":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"S4i":{"type":"structure","required":["ClusterIdentifier"],"members":{"ClusterIdentifier":{}}},"S4j":{"type":"structure","members":{"ScheduledActionName":{},"TargetAction":{"shape":"S4f"},"Schedule":{},"IamRole":{},"ScheduledActionDescription":{},"State":{},"NextInvocations":{"type":"list","member":{"locationName":"ScheduledActionTime","type":"timestamp"}},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S4o":{"type":"structure","members":{"SnapshotCopyGrantName":{},"KmsKeyId":{},"Tags":{"shape":"St"}},"wrapper":true},"S4q":{"type":"list","member":{"locationName":"ScheduleDefinition"}},"S4r":{"type":"structure","members":{"ScheduleDefinitions":{"shape":"S4q"},"ScheduleIdentifier":{},"ScheduleDescription":{},"Tags":{"shape":"St"},"NextInvocations":{"type":"list","member":{"locationName":"SnapshotTime","type":"timestamp"}},"AssociatedClusterCount":{"type":"integer"},"AssociatedClusters":{"type":"list","member":{"locationName":"ClusterAssociatedToSchedule","type":"structure","members":{"ClusterIdentifier":{},"ScheduleAssociationState":{}}}}}},"S51":{"type":"structure","members":{"UsageLimitId":{},"ClusterIdentifier":{},"FeatureType":{},"LimitType":{},"Amount":{"type":"long"},"Period":{},"BreachAction":{},"Tags":{"shape":"St"}}},"S5m":{"type":"list","member":{"locationName":"TagKey"}},"S66":{"type":"list","member":{"locationName":"TagValue"}},"S6b":{"type":"list","member":{"locationName":"Parameter","type":"structure","members":{"ParameterName":{},"ParameterValue":{},"Description":{},"Source":{},"DataType":{},"AllowedValues":{},"ApplyType":{},"IsModifiable":{"type":"boolean"},"MinimumEngineVersion":{}}}},"S7e":{"type":"list","member":{"shape":"Sj"}},"S8m":{"type":"structure","members":{"LoggingEnabled":{"type":"boolean"},"BucketName":{},"S3KeyPrefix":{},"LastSuccessfulDeliveryTime":{"type":"timestamp"},"LastFailureTime":{"type":"timestamp"},"LastFailureMessage":{},"LogDestinationType":{},"LogExports":{"shape":"S8o"}}},"S8o":{"type":"list","member":{}},"S9i":{"type":"list","member":{"shape":"S9j","locationName":"ReservedNodeOffering"}},"S9j":{"type":"structure","members":{"ReservedNodeOfferingId":{},"NodeType":{},"Duration":{"type":"integer"},"FixedPrice":{"type":"double"},"UsagePrice":{"type":"double"},"CurrencyCode":{},"OfferingType":{},"RecurringCharges":{"shape":"S8"},"ReservedNodeOfferingType":{}},"wrapper":true},"Sa5":{"type":"structure","members":{"TableRestoreRequestId":{},"Status":{},"Message":{},"RequestTime":{"type":"timestamp"},"ProgressInMegaBytes":{"type":"long"},"TotalDataInMegaBytes":{"type":"long"},"ClusterIdentifier":{},"SnapshotIdentifier":{},"SourceDatabaseName":{},"SourceSchemaName":{},"SourceTableName":{},"TargetDatabaseName":{},"TargetSchemaName":{},"NewTableName":{}},"wrapper":true},"Sb1":{"type":"structure","members":{"ResourceArn":{},"Policy":{}}},"Sbp":{"type":"structure","members":{"ParameterGroupName":{},"ParameterGroupStatus":{}}}}}

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeClusterDbRevisions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterDbRevisions"},"DescribeClusterParameterGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ParameterGroups"},"DescribeClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Parameters"},"DescribeClusterSecurityGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSecurityGroups"},"DescribeClusterSnapshots":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Snapshots"},"DescribeClusterSubnetGroups":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterSubnetGroups"},"DescribeClusterTracks":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"MaintenanceTracks"},"DescribeClusterVersions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ClusterVersions"},"DescribeClusters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Clusters"},"DescribeCustomDomainAssociations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Associations"},"DescribeDataShares":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DataShares"},"DescribeDataSharesForConsumer":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DataShares"},"DescribeDataSharesForProducer":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"DataShares"},"DescribeDefaultClusterParameters":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"DefaultClusterParameters.Marker","result_key":"DefaultClusterParameters.Parameters"},"DescribeEndpointAccess":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EndpointAccessList"},"DescribeEndpointAuthorization":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EndpointAuthorizationList"},"DescribeEventSubscriptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"EventSubscriptionsList"},"DescribeEvents":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Events"},"DescribeHsmClientCertificates":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmClientCertificates"},"DescribeHsmConfigurations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"HsmConfigurations"},"DescribeInboundIntegrations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"InboundIntegrations"},"DescribeNodeConfigurationOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"NodeConfigurationOptionList"},"DescribeOrderableClusterOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"OrderableClusterOptions"},"DescribeRedshiftIdcApplications":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"RedshiftIdcApplications"},"DescribeReservedNodeExchangeStatus":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeExchangeStatusDetails"},"DescribeReservedNodeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"},"DescribeReservedNodes":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodes"},"DescribeScheduledActions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ScheduledActions"},"DescribeSnapshotCopyGrants":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"SnapshotCopyGrants"},"DescribeSnapshotSchedules":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"SnapshotSchedules"},"DescribeTableRestoreStatus":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TableRestoreStatusDetails"},"DescribeTags":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"TaggedResources"},"DescribeUsageLimits":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"UsageLimits"},"GetReservedNodeExchangeConfigurationOptions":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeConfigurationOptionList"},"GetReservedNodeExchangeOfferings":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"ReservedNodeOfferings"},"ListRecommendations":{"input_token":"Marker","limit_key":"MaxRecords","output_token":"Marker","result_key":"Recommendations"}}}

/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ClusterAvailable":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Clusters[].ClusterStatus"},{"expected":"deleting","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"ClusterNotFound","matcher":"error","state":"retry"}]},"ClusterDeleted":{"delay":60,"operation":"DescribeClusters","maxAttempts":30,"acceptors":[{"expected":"ClusterNotFound","matcher":"error","state":"success"},{"expected":"creating","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"},{"expected":"modifying","matcher":"pathAny","state":"failure","argument":"Clusters[].ClusterStatus"}]},"ClusterRestored":{"operation":"DescribeClusters","maxAttempts":30,"delay":60,"acceptors":[{"state":"success","matcher":"pathAll","argument":"Clusters[].RestoreStatus.Status","expected":"completed"},{"state":"failure","matcher":"pathAny","argument":"Clusters[].ClusterStatus","expected":"deleting"}]},"SnapshotAvailable":{"delay":15,"operation":"DescribeClusterSnapshots","maxAttempts":20,"acceptors":[{"expected":"available","matcher":"pathAll","state":"success","argument":"Snapshots[].Status"},{"expected":"failed","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"},{"expected":"deleted","matcher":"pathAny","state":"failure","argument":"Snapshots[].Status"}]}}}

/***/ }),
/* 596 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-06-27","endpointPrefix":"rekognition","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Rekognition","serviceId":"Rekognition","signatureVersion":"v4","targetPrefix":"RekognitionService","uid":"rekognition-2016-06-27"},"operations":{"AssociateFaces":{"input":{"type":"structure","required":["CollectionId","UserId","FaceIds"],"members":{"CollectionId":{},"UserId":{},"FaceIds":{"shape":"S4"},"UserMatchThreshold":{"type":"float"},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"AssociatedFaces":{"type":"list","member":{"type":"structure","members":{"FaceId":{}}}},"UnsuccessfulFaceAssociations":{"type":"list","member":{"type":"structure","members":{"FaceId":{},"UserId":{},"Confidence":{"type":"float"},"Reasons":{"type":"list","member":{}}}}},"UserStatus":{}}}},"CompareFaces":{"input":{"type":"structure","required":["SourceImage","TargetImage"],"members":{"SourceImage":{"shape":"Sh"},"TargetImage":{"shape":"Sh"},"SimilarityThreshold":{"type":"float"},"QualityFilter":{}}},"output":{"type":"structure","members":{"SourceImageFace":{"type":"structure","members":{"BoundingBox":{"shape":"Sq"},"Confidence":{"type":"float"}}},"FaceMatches":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"Su"}}}},"UnmatchedFaces":{"type":"list","member":{"shape":"Su"}},"SourceImageOrientationCorrection":{},"TargetImageOrientationCorrection":{}}}},"CopyProjectVersion":{"input":{"type":"structure","required":["SourceProjectArn","SourceProjectVersionArn","DestinationProjectArn","VersionName","OutputConfig"],"members":{"SourceProjectArn":{},"SourceProjectVersionArn":{},"DestinationProjectArn":{},"VersionName":{},"OutputConfig":{"shape":"S1c"},"Tags":{"shape":"S1e"},"KmsKeyId":{}}},"output":{"type":"structure","members":{"ProjectVersionArn":{}}}},"CreateCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"Tags":{"shape":"S1e"}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"},"CollectionArn":{},"FaceModelVersion":{}}}},"CreateDataset":{"input":{"type":"structure","required":["DatasetType","ProjectArn"],"members":{"DatasetSource":{"type":"structure","members":{"GroundTruthManifest":{"shape":"S1p"},"DatasetArn":{}}},"DatasetType":{},"ProjectArn":{}}},"output":{"type":"structure","members":{"DatasetArn":{}}}},"CreateFaceLivenessSession":{"input":{"type":"structure","members":{"KmsKeyId":{},"Settings":{"type":"structure","members":{"OutputConfig":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3KeyPrefix":{}}},"AuditImagesLimit":{"type":"integer"}}},"ClientRequestToken":{}}},"output":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"idempotent":true},"CreateProject":{"input":{"type":"structure","required":["ProjectName"],"members":{"ProjectName":{},"Feature":{},"AutoUpdate":{}}},"output":{"type":"structure","members":{"ProjectArn":{}}}},"CreateProjectVersion":{"input":{"type":"structure","required":["ProjectArn","VersionName","OutputConfig"],"members":{"ProjectArn":{},"VersionName":{},"OutputConfig":{"shape":"S1c"},"TrainingData":{"shape":"S26"},"TestingData":{"shape":"S29"},"Tags":{"shape":"S1e"},"KmsKeyId":{},"VersionDescription":{},"FeatureConfig":{"shape":"S2b"}}},"output":{"type":"structure","members":{"ProjectVersionArn":{}}}},"CreateStreamProcessor":{"input":{"type":"structure","required":["Input","Output","Name","Settings","RoleArn"],"members":{"Input":{"shape":"S2f"},"Output":{"shape":"S2i"},"Name":{},"Settings":{"shape":"S2n"},"RoleArn":{},"Tags":{"shape":"S1e"},"NotificationChannel":{"shape":"S2t"},"KmsKeyId":{},"RegionsOfInterest":{"shape":"S2v"},"DataSharingPreference":{"shape":"S2z"}}},"output":{"type":"structure","members":{"StreamProcessorArn":{}}}},"CreateUser":{"input":{"type":"structure","required":["CollectionId","UserId"],"members":{"CollectionId":{},"UserId":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"DeleteCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"StatusCode":{"type":"integer"}}}},"DeleteDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{}}},"DeleteFaces":{"input":{"type":"structure","required":["CollectionId","FaceIds"],"members":{"CollectionId":{},"FaceIds":{"shape":"S39"}}},"output":{"type":"structure","members":{"DeletedFaces":{"shape":"S39"},"UnsuccessfulFaceDeletions":{"type":"list","member":{"type":"structure","members":{"FaceId":{},"UserId":{},"Reasons":{"type":"list","member":{}}}}}}}},"DeleteProject":{"input":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"DeleteProjectPolicy":{"input":{"type":"structure","required":["ProjectArn","PolicyName"],"members":{"ProjectArn":{},"PolicyName":{},"PolicyRevisionId":{}}},"output":{"type":"structure","members":{}}},"DeleteProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn"],"members":{"ProjectVersionArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"DeleteStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteUser":{"input":{"type":"structure","required":["CollectionId","UserId"],"members":{"CollectionId":{},"UserId":{},"ClientRequestToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"DescribeCollection":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{}}},"output":{"type":"structure","members":{"FaceCount":{"type":"long"},"FaceModelVersion":{},"CollectionARN":{},"CreationTimestamp":{"type":"timestamp"},"UserCount":{"type":"long"}}}},"DescribeDataset":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{}}},"output":{"type":"structure","members":{"DatasetDescription":{"type":"structure","members":{"CreationTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"},"Status":{},"StatusMessage":{},"StatusMessageCode":{},"DatasetStats":{"type":"structure","members":{"LabeledEntries":{"type":"integer"},"TotalEntries":{"type":"integer"},"TotalLabels":{"type":"integer"},"ErrorEntries":{"type":"integer"}}}}}}}},"DescribeProjectVersions":{"input":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{},"VersionNames":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProjectVersionDescriptions":{"type":"list","member":{"type":"structure","members":{"ProjectVersionArn":{},"CreationTimestamp":{"type":"timestamp"},"MinInferenceUnits":{"type":"integer"},"Status":{},"StatusMessage":{},"BillableTrainingTimeInSeconds":{"type":"long"},"TrainingEndTimestamp":{"type":"timestamp"},"OutputConfig":{"shape":"S1c"},"TrainingDataResult":{"type":"structure","members":{"Input":{"shape":"S26"},"Output":{"shape":"S26"},"Validation":{"shape":"S4d"}}},"TestingDataResult":{"type":"structure","members":{"Input":{"shape":"S29"},"Output":{"shape":"S29"},"Validation":{"shape":"S4d"}}},"EvaluationResult":{"type":"structure","members":{"F1Score":{"type":"float"},"Summary":{"type":"structure","members":{"S3Object":{"shape":"Sj"}}}}},"ManifestSummary":{"shape":"S1p"},"KmsKeyId":{},"MaxInferenceUnits":{"type":"integer"},"SourceProjectVersionArn":{},"VersionDescription":{},"Feature":{},"BaseModelVersion":{},"FeatureConfig":{"shape":"S2b"}}}},"NextToken":{}}}},"DescribeProjects":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"},"ProjectNames":{"type":"list","member":{}},"Features":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ProjectDescriptions":{"type":"list","member":{"type":"structure","members":{"ProjectArn":{},"CreationTimestamp":{"type":"timestamp"},"Status":{},"Datasets":{"type":"list","member":{"type":"structure","members":{"CreationTimestamp":{"type":"timestamp"},"DatasetType":{},"DatasetArn":{},"Status":{},"StatusMessage":{},"StatusMessageCode":{}}}},"Feature":{},"AutoUpdate":{}}}},"NextToken":{}}}},"DescribeStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"StreamProcessorArn":{},"Status":{},"StatusMessage":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdateTimestamp":{"type":"timestamp"},"Input":{"shape":"S2f"},"Output":{"shape":"S2i"},"RoleArn":{},"Settings":{"shape":"S2n"},"NotificationChannel":{"shape":"S2t"},"KmsKeyId":{},"RegionsOfInterest":{"shape":"S2v"},"DataSharingPreference":{"shape":"S2z"}}}},"DetectCustomLabels":{"input":{"type":"structure","required":["ProjectVersionArn","Image"],"members":{"ProjectVersionArn":{},"Image":{"shape":"Sh"},"MaxResults":{"type":"integer"},"MinConfidence":{"type":"float"}}},"output":{"type":"structure","members":{"CustomLabels":{"type":"list","member":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"Geometry":{"shape":"S4x"}}}}}}},"DetectFaces":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"Sh"},"Attributes":{"shape":"S4z"}}},"output":{"type":"structure","members":{"FaceDetails":{"type":"list","member":{"shape":"S53"}},"OrientationCorrection":{}}}},"DetectLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"Sh"},"MaxLabels":{"type":"integer"},"MinConfidence":{"type":"float"},"Features":{"type":"list","member":{}},"Settings":{"type":"structure","members":{"GeneralLabels":{"shape":"S5j"},"ImageProperties":{"type":"structure","members":{"MaxDominantColors":{"type":"integer"}}}}}}},"output":{"type":"structure","members":{"Labels":{"type":"list","member":{"shape":"S5q"}},"OrientationCorrection":{},"LabelModelVersion":{},"ImageProperties":{"type":"structure","members":{"Quality":{"shape":"S62"},"DominantColors":{"shape":"S5t"},"Foreground":{"type":"structure","members":{"Quality":{"shape":"S62"},"DominantColors":{"shape":"S5t"}}},"Background":{"type":"structure","members":{"Quality":{"shape":"S62"},"DominantColors":{"shape":"S5t"}}}}}}}},"DetectModerationLabels":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"Sh"},"MinConfidence":{"type":"float"},"HumanLoopConfig":{"type":"structure","required":["HumanLoopName","FlowDefinitionArn"],"members":{"HumanLoopName":{},"FlowDefinitionArn":{},"DataAttributes":{"type":"structure","members":{"ContentClassifiers":{"type":"list","member":{}}}}}},"ProjectVersion":{}}},"output":{"type":"structure","members":{"ModerationLabels":{"type":"list","member":{"shape":"S6f"}},"ModerationModelVersion":{},"HumanLoopActivationOutput":{"type":"structure","members":{"HumanLoopArn":{},"HumanLoopActivationReasons":{"type":"list","member":{}},"HumanLoopActivationConditionsEvaluationResults":{"jsonvalue":true}}},"ProjectVersion":{},"ContentTypes":{"shape":"S6l"}}}},"DetectProtectiveEquipment":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"Sh"},"SummarizationAttributes":{"type":"structure","required":["MinConfidence","RequiredEquipmentTypes"],"members":{"MinConfidence":{"type":"float"},"RequiredEquipmentTypes":{"type":"list","member":{}}}}}},"output":{"type":"structure","members":{"ProtectiveEquipmentModelVersion":{},"Persons":{"type":"list","member":{"type":"structure","members":{"BodyParts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"EquipmentDetections":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sq"},"Confidence":{"type":"float"},"Type":{},"CoversBodyPart":{"type":"structure","members":{"Confidence":{"type":"float"},"Value":{"type":"boolean"}}}}}}}}},"BoundingBox":{"shape":"Sq"},"Confidence":{"type":"float"},"Id":{"type":"integer"}}}},"Summary":{"type":"structure","members":{"PersonsWithRequiredEquipment":{"shape":"S71"},"PersonsWithoutRequiredEquipment":{"shape":"S71"},"PersonsIndeterminate":{"shape":"S71"}}}}}},"DetectText":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"Sh"},"Filters":{"type":"structure","members":{"WordFilter":{"shape":"S74"},"RegionsOfInterest":{"shape":"S2v"}}}}},"output":{"type":"structure","members":{"TextDetections":{"type":"list","member":{"shape":"S79"}},"TextModelVersion":{}}}},"DisassociateFaces":{"input":{"type":"structure","required":["CollectionId","UserId","FaceIds"],"members":{"CollectionId":{},"UserId":{},"ClientRequestToken":{"idempotencyToken":true},"FaceIds":{"shape":"S4"}}},"output":{"type":"structure","members":{"DisassociatedFaces":{"type":"list","member":{"type":"structure","members":{"FaceId":{}}}},"UnsuccessfulFaceDisassociations":{"type":"list","member":{"type":"structure","members":{"FaceId":{},"UserId":{},"Reasons":{"type":"list","member":{}}}}},"UserStatus":{}}}},"DistributeDatasetEntries":{"input":{"type":"structure","required":["Datasets"],"members":{"Datasets":{"type":"list","member":{"type":"structure","required":["Arn"],"members":{"Arn":{}}}}}},"output":{"type":"structure","members":{}}},"GetCelebrityInfo":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"Urls":{"shape":"S7q"},"Name":{},"KnownGender":{"shape":"S7s"}}}},"GetCelebrityRecognition":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S81"},"NextToken":{},"Celebrities":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Celebrity":{"type":"structure","members":{"Urls":{"shape":"S7q"},"Name":{},"Id":{},"Confidence":{"type":"float"},"BoundingBox":{"shape":"Sq"},"Face":{"shape":"S53"},"KnownGender":{"shape":"S7s"}}}}}},"JobId":{},"Video":{"shape":"S87"},"JobTag":{}}}},"GetContentModeration":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{},"AggregateBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S81"},"ModerationLabels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"ModerationLabel":{"shape":"S6f"},"StartTimestampMillis":{"type":"long"},"EndTimestampMillis":{"type":"long"},"DurationMillis":{"type":"long"},"ContentTypes":{"shape":"S6l"}}}},"NextToken":{},"ModerationModelVersion":{},"JobId":{},"Video":{"shape":"S87"},"JobTag":{},"GetRequestMetadata":{"type":"structure","members":{"SortBy":{},"AggregateBy":{}}}}}},"GetFaceDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S81"},"NextToken":{},"Faces":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Face":{"shape":"S53"}}}},"JobId":{},"Video":{"shape":"S87"},"JobTag":{}}}},"GetFaceLivenessSessionResults":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","required":["SessionId","Status"],"members":{"SessionId":{},"Status":{},"Confidence":{"type":"float"},"ReferenceImage":{"shape":"S8n"},"AuditImages":{"type":"list","member":{"shape":"S8n"}}}}},"GetFaceSearch":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"NextToken":{},"VideoMetadata":{"shape":"S81"},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S8v"},"FaceMatches":{"shape":"S8x"}}}},"JobId":{},"Video":{"shape":"S87"},"JobTag":{}}}},"GetLabelDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{},"AggregateBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S81"},"NextToken":{},"Labels":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Label":{"shape":"S5q"},"StartTimestampMillis":{"type":"long"},"EndTimestampMillis":{"type":"long"},"DurationMillis":{"type":"long"}}}},"LabelModelVersion":{},"JobId":{},"Video":{"shape":"S87"},"JobTag":{},"GetRequestMetadata":{"type":"structure","members":{"SortBy":{},"AggregateBy":{}}}}}},"GetMediaAnalysisJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","required":["JobId","OperationsConfig","Status","CreationTimestamp","Input","OutputConfig"],"members":{"JobId":{},"JobName":{},"OperationsConfig":{"shape":"S9e"},"Status":{},"FailureDetails":{"shape":"S9h"},"CreationTimestamp":{"type":"timestamp"},"CompletionTimestamp":{"type":"timestamp"},"Input":{"shape":"S9j"},"OutputConfig":{"shape":"S9k"},"KmsKeyId":{},"Results":{"shape":"S9m"},"ManifestSummary":{"shape":"S9o"}}}},"GetPersonTracking":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{},"SortBy":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S81"},"NextToken":{},"Persons":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"Person":{"shape":"S8v"}}}},"JobId":{},"Video":{"shape":"S87"},"JobTag":{}}}},"GetSegmentDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"type":"list","member":{"shape":"S81"}},"AudioMetadata":{"type":"list","member":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"SampleRate":{"type":"long"},"NumberOfChannels":{"type":"long"}}}},"NextToken":{},"Segments":{"type":"list","member":{"type":"structure","members":{"Type":{},"StartTimestampMillis":{"type":"long"},"EndTimestampMillis":{"type":"long"},"DurationMillis":{"type":"long"},"StartTimecodeSMPTE":{},"EndTimecodeSMPTE":{},"DurationSMPTE":{},"TechnicalCueSegment":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}},"ShotSegment":{"type":"structure","members":{"Index":{"type":"long"},"Confidence":{"type":"float"}}},"StartFrameNumber":{"type":"long"},"EndFrameNumber":{"type":"long"},"DurationFrames":{"type":"long"}}}},"SelectedSegmentTypes":{"type":"list","member":{"type":"structure","members":{"Type":{},"ModelVersion":{}}}},"JobId":{},"Video":{"shape":"S87"},"JobTag":{}}}},"GetTextDetection":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"JobStatus":{},"StatusMessage":{},"VideoMetadata":{"shape":"S81"},"TextDetections":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"long"},"TextDetection":{"shape":"S79"}}}},"NextToken":{},"TextModelVersion":{},"JobId":{},"Video":{"shape":"S87"},"JobTag":{}}}},"IndexFaces":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"Sh"},"ExternalImageId":{},"DetectionAttributes":{"shape":"S4z"},"MaxFaces":{"type":"integer"},"QualityFilter":{}}},"output":{"type":"structure","members":{"FaceRecords":{"type":"list","member":{"type":"structure","members":{"Face":{"shape":"S8z"},"FaceDetail":{"shape":"S53"}}}},"OrientationCorrection":{},"FaceModelVersion":{},"UnindexedFaces":{"type":"list","member":{"type":"structure","members":{"Reasons":{"type":"list","member":{}},"FaceDetail":{"shape":"S53"}}}}}}},"ListCollections":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"CollectionIds":{"type":"list","member":{}},"NextToken":{},"FaceModelVersions":{"type":"list","member":{}}}}},"ListDatasetEntries":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{},"ContainsLabels":{"type":"list","member":{}},"Labeled":{"type":"boolean"},"SourceRefContains":{},"HasErrors":{"type":"boolean"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetEntries":{"type":"list","member":{}},"NextToken":{}}}},"ListDatasetLabels":{"input":{"type":"structure","required":["DatasetArn"],"members":{"DatasetArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"DatasetLabelDescriptions":{"type":"list","member":{"type":"structure","members":{"LabelName":{},"LabelStats":{"type":"structure","members":{"EntryCount":{"type":"integer"},"BoundingBoxCount":{"type":"integer"}}}}}},"NextToken":{}}}},"ListFaces":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"NextToken":{},"MaxResults":{"type":"integer"},"UserId":{},"FaceIds":{"shape":"S39"}}},"output":{"type":"structure","members":{"Faces":{"type":"list","member":{"shape":"S8z"}},"NextToken":{},"FaceModelVersion":{}}}},"ListMediaAnalysisJobs":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["MediaAnalysisJobs"],"members":{"NextToken":{},"MediaAnalysisJobs":{"type":"list","member":{"type":"structure","required":["JobId","OperationsConfig","Status","CreationTimestamp","Input","OutputConfig"],"members":{"JobId":{},"JobName":{},"OperationsConfig":{"shape":"S9e"},"Status":{},"FailureDetails":{"shape":"S9h"},"CreationTimestamp":{"type":"timestamp"},"CompletionTimestamp":{"type":"timestamp"},"Input":{"shape":"S9j"},"OutputConfig":{"shape":"S9k"},"KmsKeyId":{},"Results":{"shape":"S9m"},"ManifestSummary":{"shape":"S9o"}}}}}}},"ListProjectPolicies":{"input":{"type":"structure","required":["ProjectArn"],"members":{"ProjectArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ProjectPolicies":{"type":"list","member":{"type":"structure","members":{"ProjectArn":{},"PolicyName":{},"PolicyRevisionId":{},"PolicyDocument":{},"CreationTimestamp":{"type":"timestamp"},"LastUpdatedTimestamp":{"type":"timestamp"}}}},"NextToken":{}}}},"ListStreamProcessors":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"StreamProcessors":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"S1e"}}}},"ListUsers":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"type":"structure","members":{"UserId":{},"UserStatus":{}}}},"NextToken":{}}}},"PutProjectPolicy":{"input":{"type":"structure","required":["ProjectArn","PolicyName","PolicyDocument"],"members":{"ProjectArn":{},"PolicyName":{},"PolicyRevisionId":{},"PolicyDocument":{}}},"output":{"type":"structure","members":{"PolicyRevisionId":{}}}},"RecognizeCelebrities":{"input":{"type":"structure","required":["Image"],"members":{"Image":{"shape":"Sh"}}},"output":{"type":"structure","members":{"CelebrityFaces":{"type":"list","member":{"type":"structure","members":{"Urls":{"shape":"S7q"},"Name":{},"Id":{},"Face":{"shape":"Su"},"MatchConfidence":{"type":"float"},"KnownGender":{"shape":"S7s"}}}},"UnrecognizedFaces":{"type":"list","member":{"shape":"Su"}},"OrientationCorrection":{}}}},"SearchFaces":{"input":{"type":"structure","required":["CollectionId","FaceId"],"members":{"CollectionId":{},"FaceId":{},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"}}},"output":{"type":"structure","members":{"SearchedFaceId":{},"FaceMatches":{"shape":"S8x"},"FaceModelVersion":{}}}},"SearchFacesByImage":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"Sh"},"MaxFaces":{"type":"integer"},"FaceMatchThreshold":{"type":"float"},"QualityFilter":{}}},"output":{"type":"structure","members":{"SearchedFaceBoundingBox":{"shape":"Sq"},"SearchedFaceConfidence":{"type":"float"},"FaceMatches":{"shape":"S8x"},"FaceModelVersion":{}}}},"SearchUsers":{"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{},"UserId":{},"FaceId":{},"UserMatchThreshold":{"type":"float"},"MaxUsers":{"type":"integer"}}},"output":{"type":"structure","members":{"UserMatches":{"shape":"Scb"},"FaceModelVersion":{},"SearchedFace":{"type":"structure","members":{"FaceId":{}}},"SearchedUser":{"type":"structure","members":{"UserId":{}}}}}},"SearchUsersByImage":{"input":{"type":"structure","required":["CollectionId","Image"],"members":{"CollectionId":{},"Image":{"shape":"Sh"},"UserMatchThreshold":{"type":"float"},"MaxUsers":{"type":"integer"},"QualityFilter":{}}},"output":{"type":"structure","members":{"UserMatches":{"shape":"Scb"},"FaceModelVersion":{},"SearchedFace":{"type":"structure","members":{"FaceDetail":{"shape":"S53"}}},"UnsearchedFaces":{"type":"list","member":{"type":"structure","members":{"FaceDetails":{"shape":"S53"},"Reasons":{"type":"list","member":{}}}}}}}},"StartCelebrityRecognition":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S87"},"ClientRequestToken":{},"NotificationChannel":{"shape":"Sco"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartContentModeration":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S87"},"MinConfidence":{"type":"float"},"ClientRequestToken":{},"NotificationChannel":{"shape":"Sco"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S87"},"ClientRequestToken":{},"NotificationChannel":{"shape":"Sco"},"FaceAttributes":{},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartFaceSearch":{"input":{"type":"structure","required":["Video","CollectionId"],"members":{"Video":{"shape":"S87"},"ClientRequestToken":{},"FaceMatchThreshold":{"type":"float"},"CollectionId":{},"NotificationChannel":{"shape":"Sco"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartLabelDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S87"},"ClientRequestToken":{},"MinConfidence":{"type":"float"},"NotificationChannel":{"shape":"Sco"},"JobTag":{},"Features":{"type":"list","member":{}},"Settings":{"type":"structure","members":{"GeneralLabels":{"shape":"S5j"}}}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartMediaAnalysisJob":{"input":{"type":"structure","required":["OperationsConfig","Input","OutputConfig"],"members":{"ClientRequestToken":{"idempotencyToken":true},"JobName":{},"OperationsConfig":{"shape":"S9e"},"Input":{"shape":"S9j"},"OutputConfig":{"shape":"S9k"},"KmsKeyId":{}}},"output":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"idempotent":true},"StartPersonTracking":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S87"},"ClientRequestToken":{},"NotificationChannel":{"shape":"Sco"},"JobTag":{}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn","MinInferenceUnits"],"members":{"ProjectVersionArn":{},"MinInferenceUnits":{"type":"integer"},"MaxInferenceUnits":{"type":"integer"}}},"output":{"type":"structure","members":{"Status":{}}}},"StartSegmentDetection":{"input":{"type":"structure","required":["Video","SegmentTypes"],"members":{"Video":{"shape":"S87"},"ClientRequestToken":{},"NotificationChannel":{"shape":"Sco"},"JobTag":{},"Filters":{"type":"structure","members":{"TechnicalCueFilter":{"type":"structure","members":{"MinSegmentConfidence":{"type":"float"},"BlackFrame":{"type":"structure","members":{"MaxPixelThreshold":{"type":"float"},"MinCoveragePercentage":{"type":"float"}}}}},"ShotFilter":{"type":"structure","members":{"MinSegmentConfidence":{"type":"float"}}}}},"SegmentTypes":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StartStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"StartSelector":{"type":"structure","members":{"KVSStreamStartSelector":{"type":"structure","members":{"ProducerTimestamp":{"type":"long"},"FragmentNumber":{}}}}},"StopSelector":{"type":"structure","members":{"MaxDurationInSeconds":{"type":"long"}}}}},"output":{"type":"structure","members":{"SessionId":{}}}},"StartTextDetection":{"input":{"type":"structure","required":["Video"],"members":{"Video":{"shape":"S87"},"ClientRequestToken":{},"NotificationChannel":{"shape":"Sco"},"JobTag":{},"Filters":{"type":"structure","members":{"WordFilter":{"shape":"S74"},"RegionsOfInterest":{"shape":"S2v"}}}}},"output":{"type":"structure","members":{"JobId":{}}},"idempotent":true},"StopProjectVersion":{"input":{"type":"structure","required":["ProjectVersionArn"],"members":{"ProjectVersionArn":{}}},"output":{"type":"structure","members":{"Status":{}}}},"StopStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"S1e"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateDatasetEntries":{"input":{"type":"structure","required":["DatasetArn","Changes"],"members":{"DatasetArn":{},"Changes":{"type":"structure","required":["GroundTruth"],"members":{"GroundTruth":{"type":"blob"}}}}},"output":{"type":"structure","members":{}}},"UpdateStreamProcessor":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"SettingsForUpdate":{"type":"structure","members":{"ConnectedHomeForUpdate":{"type":"structure","members":{"Labels":{"shape":"S2q"},"MinConfidence":{"type":"float"}}}}},"RegionsOfInterestForUpdate":{"shape":"S2v"},"DataSharingPreferenceForUpdate":{"shape":"S2z"},"ParametersToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{}},"Sh":{"type":"structure","members":{"Bytes":{"type":"blob"},"S3Object":{"shape":"Sj"}}},"Sj":{"type":"structure","members":{"Bucket":{},"Name":{},"Version":{}}},"Sq":{"type":"structure","members":{"Width":{"type":"float"},"Height":{"type":"float"},"Left":{"type":"float"},"Top":{"type":"float"}}},"Su":{"type":"structure","members":{"BoundingBox":{"shape":"Sq"},"Confidence":{"type":"float"},"Landmarks":{"shape":"Sv"},"Pose":{"shape":"Sy"},"Quality":{"shape":"S10"},"Emotions":{"shape":"S11"},"Smile":{"shape":"S14"}}},"Sv":{"type":"list","member":{"type":"structure","members":{"Type":{},"X":{"type":"float"},"Y":{"type":"float"}}}},"Sy":{"type":"structure","members":{"Roll":{"type":"float"},"Yaw":{"type":"float"},"Pitch":{"type":"float"}}},"S10":{"type":"structure","members":{"Brightness":{"type":"float"},"Sharpness":{"type":"float"}}},"S11":{"type":"list","member":{"type":"structure","members":{"Type":{},"Confidence":{"type":"float"}}}},"S14":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"S1c":{"type":"structure","members":{"S3Bucket":{},"S3KeyPrefix":{}}},"S1e":{"type":"map","key":{},"value":{}},"S1p":{"type":"structure","members":{"S3Object":{"shape":"Sj"}}},"S26":{"type":"structure","members":{"Assets":{"shape":"S27"}}},"S27":{"type":"list","member":{"type":"structure","members":{"GroundTruthManifest":{"shape":"S1p"}}}},"S29":{"type":"structure","members":{"Assets":{"shape":"S27"},"AutoCreate":{"type":"boolean"}}},"S2b":{"type":"structure","members":{"ContentModeration":{"type":"structure","members":{"ConfidenceThreshold":{"type":"float"}}}}},"S2f":{"type":"structure","members":{"KinesisVideoStream":{"type":"structure","members":{"Arn":{}}}}},"S2i":{"type":"structure","members":{"KinesisDataStream":{"type":"structure","members":{"Arn":{}}},"S3Destination":{"type":"structure","members":{"Bucket":{},"KeyPrefix":{}}}}},"S2n":{"type":"structure","members":{"FaceSearch":{"type":"structure","members":{"CollectionId":{},"FaceMatchThreshold":{"type":"float"}}},"ConnectedHome":{"type":"structure","required":["Labels"],"members":{"Labels":{"shape":"S2q"},"MinConfidence":{"type":"float"}}}}},"S2q":{"type":"list","member":{}},"S2t":{"type":"structure","required":["SNSTopicArn"],"members":{"SNSTopicArn":{}}},"S2v":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sq"},"Polygon":{"shape":"S2x"}}}},"S2x":{"type":"list","member":{"type":"structure","members":{"X":{"type":"float"},"Y":{"type":"float"}}}},"S2z":{"type":"structure","required":["OptIn"],"members":{"OptIn":{"type":"boolean"}}},"S39":{"type":"list","member":{}},"S4d":{"type":"structure","members":{"Assets":{"shape":"S27"}}},"S4x":{"type":"structure","members":{"BoundingBox":{"shape":"Sq"},"Polygon":{"shape":"S2x"}}},"S4z":{"type":"list","member":{}},"S53":{"type":"structure","members":{"BoundingBox":{"shape":"Sq"},"AgeRange":{"type":"structure","members":{"Low":{"type":"integer"},"High":{"type":"integer"}}},"Smile":{"shape":"S14"},"Eyeglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Sunglasses":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Gender":{"type":"structure","members":{"Value":{},"Confidence":{"type":"float"}}},"Beard":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Mustache":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"EyesOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"MouthOpen":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"Emotions":{"shape":"S11"},"Landmarks":{"shape":"Sv"},"Pose":{"shape":"Sy"},"Quality":{"shape":"S10"},"Confidence":{"type":"float"},"FaceOccluded":{"type":"structure","members":{"Value":{"type":"boolean"},"Confidence":{"type":"float"}}},"EyeDirection":{"type":"structure","members":{"Yaw":{"type":"float"},"Pitch":{"type":"float"},"Confidence":{"type":"float"}}}}},"S5j":{"type":"structure","members":{"LabelInclusionFilters":{"shape":"S5k"},"LabelExclusionFilters":{"shape":"S5k"},"LabelCategoryInclusionFilters":{"shape":"S5k"},"LabelCategoryExclusionFilters":{"shape":"S5k"}}},"S5k":{"type":"list","member":{}},"S5q":{"type":"structure","members":{"Name":{},"Confidence":{"type":"float"},"Instances":{"type":"list","member":{"type":"structure","members":{"BoundingBox":{"shape":"Sq"},"Confidence":{"type":"float"},"DominantColors":{"shape":"S5t"}}}},"Parents":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Aliases":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Categories":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}},"S5t":{"type":"list","member":{"type":"structure","members":{"Red":{"type":"integer"},"Blue":{"type":"integer"},"Green":{"type":"integer"},"HexCode":{},"CSSColor":{},"SimplifiedColor":{},"PixelPercent":{"type":"float"}}}},"S62":{"type":"structure","members":{"Brightness":{"type":"float"},"Sharpness":{"type":"float"},"Contrast":{"type":"float"}}},"S6f":{"type":"structure","members":{"Confidence":{"type":"float"},"Name":{},"ParentName":{},"TaxonomyLevel":{"type":"integer"}}},"S6l":{"type":"list","member":{"type":"structure","members":{"Confidence":{"type":"float"},"Name":{}}}},"S71":{"type":"list","member":{"type":"integer"}},"S74":{"type":"structure","members":{"MinConfidence":{"type":"float"},"MinBoundingBoxHeight":{"type":"float"},"MinBoundingBoxWidth":{"type":"float"}}},"S79":{"type":"structure","members":{"DetectedText":{},"Type":{},"Id":{"type":"integer"},"ParentId":{"type":"integer"},"Confidence":{"type":"float"},"Geometry":{"shape":"S4x"}}},"S7q":{"type":"list","member":{}},"S7s":{"type":"structure","members":{"Type":{}}},"S81":{"type":"structure","members":{"Codec":{},"DurationMillis":{"type":"long"},"Format":{},"FrameRate":{"type":"float"},"FrameHeight":{"type":"long"},"FrameWidth":{"type":"long"},"ColorRange":{}}},"S87":{"type":"structure","members":{"S3Object":{"shape":"Sj"}}},"S8n":{"type":"structure","members":{"Bytes":{"type":"blob","sensitive":true},"S3Object":{"shape":"Sj"},"BoundingBox":{"shape":"Sq"}}},"S8v":{"type":"structure","members":{"Index":{"type":"long"},"BoundingBox":{"shape":"Sq"},"Face":{"shape":"S53"}}},"S8x":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"Face":{"shape":"S8z"}}}},"S8z":{"type":"structure","members":{"FaceId":{},"BoundingBox":{"shape":"Sq"},"ImageId":{},"ExternalImageId":{},"Confidence":{"type":"float"},"IndexFacesModelVersion":{},"UserId":{}}},"S9e":{"type":"structure","members":{"DetectModerationLabels":{"type":"structure","members":{"MinConfidence":{"type":"float"},"ProjectVersion":{}}}}},"S9h":{"type":"structure","members":{"Code":{},"Message":{}}},"S9j":{"type":"structure","required":["S3Object"],"members":{"S3Object":{"shape":"Sj"}}},"S9k":{"type":"structure","required":["S3Bucket"],"members":{"S3Bucket":{},"S3KeyPrefix":{}}},"S9m":{"type":"structure","members":{"S3Object":{"shape":"Sj"},"ModelVersions":{"type":"structure","members":{"Moderation":{}}}}},"S9o":{"type":"structure","members":{"S3Object":{"shape":"Sj"}}},"Scb":{"type":"list","member":{"type":"structure","members":{"Similarity":{"type":"float"},"User":{"type":"structure","members":{"UserId":{},"UserStatus":{}}}}}},"Sco":{"type":"structure","required":["SNSTopicArn","RoleArn"],"members":{"SNSTopicArn":{},"RoleArn":{}}}}}

/***/ }),
/* 597 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeProjectVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProjectVersionDescriptions"},"DescribeProjects":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProjectDescriptions"},"GetCelebrityRecognition":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetContentModeration":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetFaceSearch":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetLabelDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetPersonTracking":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetSegmentDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetTextDetection":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListCollections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CollectionIds"},"ListDatasetEntries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetEntries"},"ListDatasetLabels":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DatasetLabelDescriptions"},"ListFaces":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Faces"},"ListMediaAnalysisJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListProjectPolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ProjectPolicies"},"ListStreamProcessors":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListUsers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Users"}}}

/***/ }),
/* 598 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ProjectVersionTrainingCompleted":{"description":"Wait until the ProjectVersion training completes.","operation":"DescribeProjectVersions","delay":120,"maxAttempts":360,"acceptors":[{"state":"success","matcher":"pathAll","argument":"ProjectVersionDescriptions[].Status","expected":"TRAINING_COMPLETED"},{"state":"failure","matcher":"pathAny","argument":"ProjectVersionDescriptions[].Status","expected":"TRAINING_FAILED"}]},"ProjectVersionRunning":{"description":"Wait until the ProjectVersion is running.","delay":30,"maxAttempts":40,"operation":"DescribeProjectVersions","acceptors":[{"state":"success","matcher":"pathAll","argument":"ProjectVersionDescriptions[].Status","expected":"RUNNING"},{"state":"failure","matcher":"pathAny","argument":"ProjectVersionDescriptions[].Status","expected":"FAILED"}]}}}

/***/ }),
/* 599 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-11-27","endpointPrefix":"resource-groups","protocol":"rest-json","serviceAbbreviation":"Resource Groups","serviceFullName":"AWS Resource Groups","serviceId":"Resource Groups","signatureVersion":"v4","signingName":"resource-groups","uid":"resource-groups-2017-11-27"},"operations":{"CreateGroup":{"http":{"requestUri":"/groups"},"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Description":{},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"},"Configuration":{"shape":"Sa"}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"},"ResourceQuery":{"shape":"S4"},"Tags":{"shape":"S7"},"GroupConfiguration":{"shape":"Sl"}}}},"DeleteGroup":{"http":{"requestUri":"/delete-group"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"}}}},"GetAccountSettings":{"http":{"requestUri":"/get-account-settings"},"output":{"type":"structure","members":{"AccountSettings":{"shape":"Ss"}}}},"GetGroup":{"http":{"requestUri":"/get-group"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"}}}},"GetGroupConfiguration":{"http":{"requestUri":"/get-group-configuration"},"input":{"type":"structure","members":{"Group":{}}},"output":{"type":"structure","members":{"GroupConfiguration":{"shape":"Sl"}}}},"GetGroupQuery":{"http":{"requestUri":"/get-group-query"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"S12"}}}},"GetTags":{"http":{"method":"GET","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn"],"members":{"Arn":{"location":"uri","locationName":"Arn"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"GroupResources":{"http":{"requestUri":"/group-resources"},"input":{"type":"structure","required":["Group","ResourceArns"],"members":{"Group":{},"ResourceArns":{"shape":"S16"}}},"output":{"type":"structure","members":{"Succeeded":{"shape":"S16"},"Failed":{"shape":"S19"},"Pending":{"shape":"S1d"}}}},"ListGroupResources":{"http":{"requestUri":"/list-group-resources"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{},"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Resources":{"type":"list","member":{"type":"structure","members":{"Identifier":{"shape":"S1q"},"Status":{"type":"structure","members":{"Name":{}}}}}},"ResourceIdentifiers":{"shape":"S1u","deprecated":true,"deprecatedMessage":"This field is deprecated, use Resources instead."},"NextToken":{},"QueryErrors":{"shape":"S1v"}}}},"ListGroups":{"http":{"requestUri":"/groups-list"},"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Name","Values"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"location":"querystring","locationName":"maxResults","type":"integer"},"NextToken":{"location":"querystring","locationName":"nextToken"}}},"output":{"type":"structure","members":{"GroupIdentifiers":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupArn":{}}}},"Groups":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use GroupIdentifiers instead.","type":"list","member":{"shape":"Sj"}},"NextToken":{}}}},"PutGroupConfiguration":{"http":{"requestUri":"/put-group-configuration","responseCode":202},"input":{"type":"structure","members":{"Group":{},"Configuration":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"SearchResources":{"http":{"requestUri":"/resources/search"},"input":{"type":"structure","required":["ResourceQuery"],"members":{"ResourceQuery":{"shape":"S4"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceIdentifiers":{"shape":"S1u"},"NextToken":{},"QueryErrors":{"shape":"S1v"}}}},"Tag":{"http":{"method":"PUT","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Tags"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Tags":{"shape":"S7"}}},"output":{"type":"structure","members":{"Arn":{},"Tags":{"shape":"S7"}}}},"UngroupResources":{"http":{"requestUri":"/ungroup-resources"},"input":{"type":"structure","required":["Group","ResourceArns"],"members":{"Group":{},"ResourceArns":{"shape":"S16"}}},"output":{"type":"structure","members":{"Succeeded":{"shape":"S16"},"Failed":{"shape":"S19"},"Pending":{"shape":"S1d"}}}},"Untag":{"http":{"method":"PATCH","requestUri":"/resources/{Arn}/tags"},"input":{"type":"structure","required":["Arn","Keys"],"members":{"Arn":{"location":"uri","locationName":"Arn"},"Keys":{"shape":"S2i"}}},"output":{"type":"structure","members":{"Arn":{},"Keys":{"shape":"S2i"}}}},"UpdateAccountSettings":{"http":{"requestUri":"/update-account-settings"},"input":{"type":"structure","members":{"GroupLifecycleEventsDesiredStatus":{}}},"output":{"type":"structure","members":{"AccountSettings":{"shape":"Ss"}}}},"UpdateGroup":{"http":{"requestUri":"/update-group"},"input":{"type":"structure","members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{},"Description":{}}},"output":{"type":"structure","members":{"Group":{"shape":"Sj"}}}},"UpdateGroupQuery":{"http":{"requestUri":"/update-group-query"},"input":{"type":"structure","required":["ResourceQuery"],"members":{"GroupName":{"deprecated":true,"deprecatedMessage":"This field is deprecated, use Group instead."},"Group":{},"ResourceQuery":{"shape":"S4"}}},"output":{"type":"structure","members":{"GroupQuery":{"shape":"S12"}}}}},"shapes":{"S4":{"type":"structure","required":["Type","Query"],"members":{"Type":{},"Query":{}}},"S7":{"type":"map","key":{},"value":{}},"Sa":{"type":"list","member":{"type":"structure","required":["Type"],"members":{"Type":{},"Parameters":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Values":{"type":"list","member":{}}}}}}}},"Sj":{"type":"structure","required":["GroupArn","Name"],"members":{"GroupArn":{},"Name":{},"Description":{}}},"Sl":{"type":"structure","members":{"Configuration":{"shape":"Sa"},"ProposedConfiguration":{"shape":"Sa"},"Status":{},"FailureReason":{}}},"Ss":{"type":"structure","members":{"GroupLifecycleEventsDesiredStatus":{},"GroupLifecycleEventsStatus":{},"GroupLifecycleEventsStatusMessage":{}}},"S12":{"type":"structure","required":["GroupName","ResourceQuery"],"members":{"GroupName":{},"ResourceQuery":{"shape":"S4"}}},"S16":{"type":"list","member":{}},"S19":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{},"ErrorMessage":{},"ErrorCode":{}}}},"S1d":{"type":"list","member":{"type":"structure","members":{"ResourceArn":{}}}},"S1q":{"type":"structure","members":{"ResourceArn":{},"ResourceType":{}}},"S1u":{"type":"list","member":{"shape":"S1q"}},"S1v":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{},"Message":{}}}},"S2i":{"type":"list","member":{}}}}

/***/ }),
/* 600 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListGroupResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":["ResourceIdentifiers","Resources"]},"ListGroups":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"GroupIdentifiers"},"SearchResources":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"ResourceIdentifiers"}}}

/***/ }),
/* 601 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-04-01","endpointPrefix":"route53","globalEndpoint":"route53.amazonaws.com","protocol":"rest-xml","serviceAbbreviation":"Route 53","serviceFullName":"Amazon Route 53","serviceId":"Route 53","signatureVersion":"v4","uid":"route53-2013-04-01"},"operations":{"ActivateKeySigningKey":{"http":{"requestUri":"/2013-04-01/keysigningkey/{HostedZoneId}/{Name}/activate"},"input":{"type":"structure","required":["HostedZoneId","Name"],"members":{"HostedZoneId":{"location":"uri","locationName":"HostedZoneId"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"AssociateVPCWithHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/associatevpc"},"input":{"locationName":"AssociateVPCWithHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"ChangeCidrCollection":{"http":{"requestUri":"/2013-04-01/cidrcollection/{CidrCollectionId}"},"input":{"locationName":"ChangeCidrCollectionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Changes"],"members":{"Id":{"location":"uri","locationName":"CidrCollectionId"},"CollectionVersion":{"type":"long"},"Changes":{"type":"list","member":{"type":"structure","required":["LocationName","Action","CidrList"],"members":{"LocationName":{},"Action":{},"CidrList":{"type":"list","member":{"locationName":"Cidr"}}}}}}},"output":{"type":"structure","required":["Id"],"members":{"Id":{}}}},"ChangeResourceRecordSets":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/rrset/"},"input":{"locationName":"ChangeResourceRecordSetsRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","ChangeBatch"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"ChangeBatch":{"type":"structure","required":["Changes"],"members":{"Comment":{},"Changes":{"type":"list","member":{"locationName":"Change","type":"structure","required":["Action","ResourceRecordSet"],"members":{"Action":{},"ResourceRecordSet":{"shape":"Sv"}}}}}}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"ChangeTagsForResource":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"locationName":"ChangeTagsForResourceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"AddTags":{"shape":"S1s"},"RemoveTagKeys":{"type":"list","member":{"locationName":"Key"}}}},"output":{"type":"structure","members":{}}},"CreateCidrCollection":{"http":{"requestUri":"/2013-04-01/cidrcollection","responseCode":201},"input":{"locationName":"CreateCidrCollectionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","CallerReference"],"members":{"Name":{},"CallerReference":{}}},"output":{"type":"structure","members":{"Collection":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Version":{"type":"long"}}},"Location":{"location":"header","locationName":"Location"}}}},"CreateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck","responseCode":201},"input":{"locationName":"CreateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HealthCheckConfig"],"members":{"CallerReference":{},"HealthCheckConfig":{"shape":"S27"}}},"output":{"type":"structure","required":["HealthCheck","Location"],"members":{"HealthCheck":{"shape":"S2u"},"Location":{"location":"header","locationName":"Location"}}}},"CreateHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone","responseCode":201},"input":{"locationName":"CreateHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","CallerReference"],"members":{"Name":{},"VPC":{"shape":"Sa"},"CallerReference":{},"HostedZoneConfig":{"shape":"S3b"},"DelegationSetId":{}}},"output":{"type":"structure","required":["HostedZone","ChangeInfo","DelegationSet","Location"],"members":{"HostedZone":{"shape":"S3e"},"ChangeInfo":{"shape":"S5"},"DelegationSet":{"shape":"S3g"},"VPC":{"shape":"Sa"},"Location":{"location":"header","locationName":"Location"}}}},"CreateKeySigningKey":{"http":{"requestUri":"/2013-04-01/keysigningkey","responseCode":201},"input":{"locationName":"CreateKeySigningKeyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference","HostedZoneId","KeyManagementServiceArn","Name","Status"],"members":{"CallerReference":{},"HostedZoneId":{},"KeyManagementServiceArn":{},"Name":{},"Status":{}}},"output":{"type":"structure","required":["ChangeInfo","KeySigningKey","Location"],"members":{"ChangeInfo":{"shape":"S5"},"KeySigningKey":{"shape":"S3m"},"Location":{"location":"header","locationName":"Location"}}}},"CreateQueryLoggingConfig":{"http":{"requestUri":"/2013-04-01/queryloggingconfig","responseCode":201},"input":{"locationName":"CreateQueryLoggingConfigRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"output":{"type":"structure","required":["QueryLoggingConfig","Location"],"members":{"QueryLoggingConfig":{"shape":"S3t"},"Location":{"location":"header","locationName":"Location"}}}},"CreateReusableDelegationSet":{"http":{"requestUri":"/2013-04-01/delegationset","responseCode":201},"input":{"locationName":"CreateReusableDelegationSetRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["CallerReference"],"members":{"CallerReference":{},"HostedZoneId":{}}},"output":{"type":"structure","required":["DelegationSet","Location"],"members":{"DelegationSet":{"shape":"S3g"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicy":{"http":{"requestUri":"/2013-04-01/trafficpolicy","responseCode":201},"input":{"locationName":"CreateTrafficPolicyRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Name","Document"],"members":{"Name":{},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S42"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance","responseCode":201},"input":{"locationName":"CreateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","Name","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance","Location"],"members":{"TrafficPolicyInstance":{"shape":"S47"},"Location":{"location":"header","locationName":"Location"}}}},"CreateTrafficPolicyVersion":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}","responseCode":201},"input":{"locationName":"CreateTrafficPolicyVersionRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Document"],"members":{"Id":{"location":"uri","locationName":"Id"},"Document":{},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy","Location"],"members":{"TrafficPolicy":{"shape":"S42"},"Location":{"location":"header","locationName":"Location"}}}},"CreateVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"locationName":"CreateVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"}}},"output":{"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{},"VPC":{"shape":"Sa"}}}},"DeactivateKeySigningKey":{"http":{"requestUri":"/2013-04-01/keysigningkey/{HostedZoneId}/{Name}/deactivate"},"input":{"type":"structure","required":["HostedZoneId","Name"],"members":{"HostedZoneId":{"location":"uri","locationName":"HostedZoneId"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DeleteCidrCollection":{"http":{"method":"DELETE","requestUri":"/2013-04-01/cidrcollection/{CidrCollectionId}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"CidrCollectionId"}}},"output":{"type":"structure","members":{}}},"DeleteHealthCheck":{"http":{"method":"DELETE","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","members":{}}},"DeleteHostedZone":{"http":{"method":"DELETE","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DeleteKeySigningKey":{"http":{"method":"DELETE","requestUri":"/2013-04-01/keysigningkey/{HostedZoneId}/{Name}"},"input":{"type":"structure","required":["HostedZoneId","Name"],"members":{"HostedZoneId":{"location":"uri","locationName":"HostedZoneId"},"Name":{"location":"uri","locationName":"Name"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DeleteQueryLoggingConfig":{"http":{"method":"DELETE","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteReusableDelegationSet":{"http":{"method":"DELETE","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicy":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","members":{}}},"DeleteTrafficPolicyInstance":{"http":{"method":"DELETE","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","members":{}}},"DeleteVPCAssociationAuthorization":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/deauthorizevpcassociation"},"input":{"locationName":"DeleteVPCAssociationAuthorizationRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"}}},"output":{"type":"structure","members":{}}},"DisableHostedZoneDNSSEC":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disable-dnssec"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"DisassociateVPCFromHostedZone":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/disassociatevpc"},"input":{"locationName":"DisassociateVPCFromHostedZoneRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HostedZoneId","VPC"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"VPC":{"shape":"Sa"},"Comment":{}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"EnableHostedZoneDNSSEC":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}/enable-dnssec"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"GetAccountLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/accountlimit/{Type}"},"input":{"type":"structure","required":["Type"],"members":{"Type":{"location":"uri","locationName":"Type"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetChange":{"http":{"method":"GET","requestUri":"/2013-04-01/change/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["ChangeInfo"],"members":{"ChangeInfo":{"shape":"S5"}}}},"GetCheckerIpRanges":{"http":{"method":"GET","requestUri":"/2013-04-01/checkeripranges"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["CheckerIpRanges"],"members":{"CheckerIpRanges":{"type":"list","member":{}}}}},"GetDNSSEC":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/dnssec"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Status","KeySigningKeys"],"members":{"Status":{"type":"structure","members":{"ServeSignature":{},"StatusMessage":{}}},"KeySigningKeys":{"type":"list","member":{"shape":"S3m"}}}}},"GetGeoLocation":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocation"},"input":{"type":"structure","members":{"ContinentCode":{"location":"querystring","locationName":"continentcode"},"CountryCode":{"location":"querystring","locationName":"countrycode"},"SubdivisionCode":{"location":"querystring","locationName":"subdivisioncode"}}},"output":{"type":"structure","required":["GeoLocationDetails"],"members":{"GeoLocationDetails":{"shape":"S5o"}}}},"GetHealthCheck":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S2u"}}}},"GetHealthCheckCount":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheckcount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HealthCheckCount"],"members":{"HealthCheckCount":{"type":"long"}}}},"GetHealthCheckLastFailureReason":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/lastfailurereason"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S5z"}}}},"GetHealthCheckStatus":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck/{HealthCheckId}/status"},"input":{"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"}}},"output":{"type":"structure","required":["HealthCheckObservations"],"members":{"HealthCheckObservations":{"shape":"S5z"}}}},"GetHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S3e"},"DelegationSet":{"shape":"S3g"},"VPCs":{"shape":"S67"}}}},"GetHostedZoneCount":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["HostedZoneCount"],"members":{"HostedZoneCount":{"type":"long"}}}},"GetHostedZoneLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonelimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","HostedZoneId"],"members":{"Type":{"location":"uri","locationName":"Type"},"HostedZoneId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetQueryLoggingConfig":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["QueryLoggingConfig"],"members":{"QueryLoggingConfig":{"shape":"S3t"}}}},"GetReusableDelegationSet":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["DelegationSet"],"members":{"DelegationSet":{"shape":"S3g"}}}},"GetReusableDelegationSetLimit":{"http":{"method":"GET","requestUri":"/2013-04-01/reusabledelegationsetlimit/{Id}/{Type}"},"input":{"type":"structure","required":["Type","DelegationSetId"],"members":{"Type":{"location":"uri","locationName":"Type"},"DelegationSetId":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["Limit","Count"],"members":{"Limit":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{"type":"long"}}},"Count":{"type":"long"}}}},"GetTrafficPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"type":"structure","required":["Id","Version"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S42"}}}},"GetTrafficPolicyInstance":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S47"}}}},"GetTrafficPolicyInstanceCount":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstancecount"},"input":{"type":"structure","members":{}},"output":{"type":"structure","required":["TrafficPolicyInstanceCount"],"members":{"TrafficPolicyInstanceCount":{"type":"integer"}}}},"ListCidrBlocks":{"http":{"method":"GET","requestUri":"/2013-04-01/cidrcollection/{CidrCollectionId}/cidrblocks"},"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{"location":"uri","locationName":"CidrCollectionId"},"LocationName":{"location":"querystring","locationName":"location"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","members":{"NextToken":{},"CidrBlocks":{"type":"list","member":{"type":"structure","members":{"CidrBlock":{},"LocationName":{}}}}}}},"ListCidrCollections":{"http":{"method":"GET","requestUri":"/2013-04-01/cidrcollection"},"input":{"type":"structure","members":{"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","members":{"NextToken":{},"CidrCollections":{"type":"list","member":{"type":"structure","members":{"Arn":{},"Id":{},"Name":{},"Version":{"type":"long"}}}}}}},"ListCidrLocations":{"http":{"method":"GET","requestUri":"/2013-04-01/cidrcollection/{CidrCollectionId}"},"input":{"type":"structure","required":["CollectionId"],"members":{"CollectionId":{"location":"uri","locationName":"CidrCollectionId"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","members":{"NextToken":{},"CidrLocations":{"type":"list","member":{"type":"structure","members":{"LocationName":{}}}}}}},"ListGeoLocations":{"http":{"method":"GET","requestUri":"/2013-04-01/geolocations"},"input":{"type":"structure","members":{"StartContinentCode":{"location":"querystring","locationName":"startcontinentcode"},"StartCountryCode":{"location":"querystring","locationName":"startcountrycode"},"StartSubdivisionCode":{"location":"querystring","locationName":"startsubdivisioncode"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["GeoLocationDetailsList","IsTruncated","MaxItems"],"members":{"GeoLocationDetailsList":{"type":"list","member":{"shape":"S5o","locationName":"GeoLocationDetails"}},"IsTruncated":{"type":"boolean"},"NextContinentCode":{},"NextCountryCode":{},"NextSubdivisionCode":{},"MaxItems":{}}}},"ListHealthChecks":{"http":{"method":"GET","requestUri":"/2013-04-01/healthcheck"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HealthChecks","Marker","IsTruncated","MaxItems"],"members":{"HealthChecks":{"type":"list","member":{"shape":"S2u","locationName":"HealthCheck"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZones":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"DelegationSetId":{"location":"querystring","locationName":"delegationsetid"},"HostedZoneType":{"location":"querystring","locationName":"hostedzonetype"}}},"output":{"type":"structure","required":["HostedZones","Marker","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S7k"},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListHostedZonesByName":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyname"},"input":{"type":"structure","members":{"DNSName":{"location":"querystring","locationName":"dnsname"},"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["HostedZones","IsTruncated","MaxItems"],"members":{"HostedZones":{"shape":"S7k"},"DNSName":{},"HostedZoneId":{},"IsTruncated":{"type":"boolean"},"NextDNSName":{},"NextHostedZoneId":{},"MaxItems":{}}}},"ListHostedZonesByVPC":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzonesbyvpc"},"input":{"type":"structure","required":["VPCId","VPCRegion"],"members":{"VPCId":{"location":"querystring","locationName":"vpcid"},"VPCRegion":{"location":"querystring","locationName":"vpcregion"},"MaxItems":{"location":"querystring","locationName":"maxitems"},"NextToken":{"location":"querystring","locationName":"nexttoken"}}},"output":{"type":"structure","required":["HostedZoneSummaries","MaxItems"],"members":{"HostedZoneSummaries":{"type":"list","member":{"locationName":"HostedZoneSummary","type":"structure","required":["HostedZoneId","Name","Owner"],"members":{"HostedZoneId":{},"Name":{},"Owner":{"type":"structure","members":{"OwningAccount":{},"OwningService":{}}}}}},"MaxItems":{},"NextToken":{}}}},"ListQueryLoggingConfigs":{"http":{"method":"GET","requestUri":"/2013-04-01/queryloggingconfig"},"input":{"type":"structure","members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["QueryLoggingConfigs"],"members":{"QueryLoggingConfigs":{"type":"list","member":{"shape":"S3t","locationName":"QueryLoggingConfig"}},"NextToken":{}}}},"ListResourceRecordSets":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/rrset"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"StartRecordName":{"location":"querystring","locationName":"name"},"StartRecordType":{"location":"querystring","locationName":"type"},"StartRecordIdentifier":{"location":"querystring","locationName":"identifier"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["ResourceRecordSets","IsTruncated","MaxItems"],"members":{"ResourceRecordSets":{"type":"list","member":{"shape":"Sv","locationName":"ResourceRecordSet"}},"IsTruncated":{"type":"boolean"},"NextRecordName":{},"NextRecordType":{},"NextRecordIdentifier":{},"MaxItems":{}}}},"ListReusableDelegationSets":{"http":{"method":"GET","requestUri":"/2013-04-01/delegationset"},"input":{"type":"structure","members":{"Marker":{"location":"querystring","locationName":"marker"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["DelegationSets","Marker","IsTruncated","MaxItems"],"members":{"DelegationSets":{"type":"list","member":{"shape":"S3g","locationName":"DelegationSet"}},"Marker":{},"IsTruncated":{"type":"boolean"},"NextMarker":{},"MaxItems":{}}}},"ListTagsForResource":{"http":{"method":"GET","requestUri":"/2013-04-01/tags/{ResourceType}/{ResourceId}"},"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}},"output":{"type":"structure","required":["ResourceTagSet"],"members":{"ResourceTagSet":{"shape":"S85"}}}},"ListTagsForResources":{"http":{"requestUri":"/2013-04-01/tags/{ResourceType}"},"input":{"locationName":"ListTagsForResourcesRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["ResourceType","ResourceIds"],"members":{"ResourceType":{"location":"uri","locationName":"ResourceType"},"ResourceIds":{"type":"list","member":{"locationName":"ResourceId"}}}},"output":{"type":"structure","required":["ResourceTagSets"],"members":{"ResourceTagSets":{"type":"list","member":{"shape":"S85","locationName":"ResourceTagSet"}}}}},"ListTrafficPolicies":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies"},"input":{"type":"structure","members":{"TrafficPolicyIdMarker":{"location":"querystring","locationName":"trafficpolicyid"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicySummaries","IsTruncated","TrafficPolicyIdMarker","MaxItems"],"members":{"TrafficPolicySummaries":{"type":"list","member":{"locationName":"TrafficPolicySummary","type":"structure","required":["Id","Name","Type","LatestVersion","TrafficPolicyCount"],"members":{"Id":{},"Name":{},"Type":{},"LatestVersion":{"type":"integer"},"TrafficPolicyCount":{"type":"integer"}}}},"IsTruncated":{"type":"boolean"},"TrafficPolicyIdMarker":{},"MaxItems":{}}}},"ListTrafficPolicyInstances":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances"},"input":{"type":"structure","members":{"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S8g"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByHostedZone":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/hostedzone"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"querystring","locationName":"id"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S8g"},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyInstancesByPolicy":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicyinstances/trafficpolicy"},"input":{"type":"structure","required":["TrafficPolicyId","TrafficPolicyVersion"],"members":{"TrafficPolicyId":{"location":"querystring","locationName":"id"},"TrafficPolicyVersion":{"location":"querystring","locationName":"version","type":"integer"},"HostedZoneIdMarker":{"location":"querystring","locationName":"hostedzoneid"},"TrafficPolicyInstanceNameMarker":{"location":"querystring","locationName":"trafficpolicyinstancename"},"TrafficPolicyInstanceTypeMarker":{"location":"querystring","locationName":"trafficpolicyinstancetype"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicyInstances","IsTruncated","MaxItems"],"members":{"TrafficPolicyInstances":{"shape":"S8g"},"HostedZoneIdMarker":{},"TrafficPolicyInstanceNameMarker":{},"TrafficPolicyInstanceTypeMarker":{},"IsTruncated":{"type":"boolean"},"MaxItems":{}}}},"ListTrafficPolicyVersions":{"http":{"method":"GET","requestUri":"/2013-04-01/trafficpolicies/{Id}/versions"},"input":{"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"TrafficPolicyVersionMarker":{"location":"querystring","locationName":"trafficpolicyversion"},"MaxItems":{"location":"querystring","locationName":"maxitems"}}},"output":{"type":"structure","required":["TrafficPolicies","IsTruncated","TrafficPolicyVersionMarker","MaxItems"],"members":{"TrafficPolicies":{"type":"list","member":{"shape":"S42","locationName":"TrafficPolicy"}},"IsTruncated":{"type":"boolean"},"TrafficPolicyVersionMarker":{},"MaxItems":{}}}},"ListVPCAssociationAuthorizations":{"http":{"method":"GET","requestUri":"/2013-04-01/hostedzone/{Id}/authorizevpcassociation"},"input":{"type":"structure","required":["HostedZoneId"],"members":{"HostedZoneId":{"location":"uri","locationName":"Id"},"NextToken":{"location":"querystring","locationName":"nexttoken"},"MaxResults":{"location":"querystring","locationName":"maxresults"}}},"output":{"type":"structure","required":["HostedZoneId","VPCs"],"members":{"HostedZoneId":{},"NextToken":{},"VPCs":{"shape":"S67"}}}},"TestDNSAnswer":{"http":{"method":"GET","requestUri":"/2013-04-01/testdnsanswer"},"input":{"type":"structure","required":["HostedZoneId","RecordName","RecordType"],"members":{"HostedZoneId":{"location":"querystring","locationName":"hostedzoneid"},"RecordName":{"location":"querystring","locationName":"recordname"},"RecordType":{"location":"querystring","locationName":"recordtype"},"ResolverIP":{"location":"querystring","locationName":"resolverip"},"EDNS0ClientSubnetIP":{"location":"querystring","locationName":"edns0clientsubnetip"},"EDNS0ClientSubnetMask":{"location":"querystring","locationName":"edns0clientsubnetmask"}}},"output":{"type":"structure","required":["Nameserver","RecordName","RecordType","RecordData","ResponseCode","Protocol"],"members":{"Nameserver":{},"RecordName":{},"RecordType":{},"RecordData":{"type":"list","member":{"locationName":"RecordDataEntry"}},"ResponseCode":{},"Protocol":{}}}},"UpdateHealthCheck":{"http":{"requestUri":"/2013-04-01/healthcheck/{HealthCheckId}"},"input":{"locationName":"UpdateHealthCheckRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["HealthCheckId"],"members":{"HealthCheckId":{"location":"uri","locationName":"HealthCheckId"},"HealthCheckVersion":{"type":"long"},"IPAddress":{},"Port":{"type":"integer"},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"FailureThreshold":{"type":"integer"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S2k"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S2m"},"AlarmIdentifier":{"shape":"S2o"},"InsufficientDataHealthStatus":{},"ResetElements":{"type":"list","member":{"locationName":"ResettableElementName"}}}},"output":{"type":"structure","required":["HealthCheck"],"members":{"HealthCheck":{"shape":"S2u"}}}},"UpdateHostedZoneComment":{"http":{"requestUri":"/2013-04-01/hostedzone/{Id}"},"input":{"locationName":"UpdateHostedZoneCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id"],"members":{"Id":{"location":"uri","locationName":"Id"},"Comment":{}}},"output":{"type":"structure","required":["HostedZone"],"members":{"HostedZone":{"shape":"S3e"}}}},"UpdateTrafficPolicyComment":{"http":{"requestUri":"/2013-04-01/trafficpolicy/{Id}/{Version}"},"input":{"locationName":"UpdateTrafficPolicyCommentRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","Version","Comment"],"members":{"Id":{"location":"uri","locationName":"Id"},"Version":{"location":"uri","locationName":"Version","type":"integer"},"Comment":{}}},"output":{"type":"structure","required":["TrafficPolicy"],"members":{"TrafficPolicy":{"shape":"S42"}}}},"UpdateTrafficPolicyInstance":{"http":{"requestUri":"/2013-04-01/trafficpolicyinstance/{Id}"},"input":{"locationName":"UpdateTrafficPolicyInstanceRequest","xmlNamespace":{"uri":"https://route53.amazonaws.com/doc/2013-04-01/"},"type":"structure","required":["Id","TTL","TrafficPolicyId","TrafficPolicyVersion"],"members":{"Id":{"location":"uri","locationName":"Id"},"TTL":{"type":"long"},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"}}},"output":{"type":"structure","required":["TrafficPolicyInstance"],"members":{"TrafficPolicyInstance":{"shape":"S47"}}}}},"shapes":{"S5":{"type":"structure","required":["Id","Status","SubmittedAt"],"members":{"Id":{},"Status":{},"SubmittedAt":{"type":"timestamp"},"Comment":{}}},"Sa":{"type":"structure","members":{"VPCRegion":{},"VPCId":{}}},"Sv":{"type":"structure","required":["Name","Type"],"members":{"Name":{},"Type":{},"SetIdentifier":{},"Weight":{"type":"long"},"Region":{},"GeoLocation":{"type":"structure","members":{"ContinentCode":{},"CountryCode":{},"SubdivisionCode":{}}},"Failover":{},"MultiValueAnswer":{"type":"boolean"},"TTL":{"type":"long"},"ResourceRecords":{"type":"list","member":{"locationName":"ResourceRecord","type":"structure","required":["Value"],"members":{"Value":{}}}},"AliasTarget":{"type":"structure","required":["HostedZoneId","DNSName","EvaluateTargetHealth"],"members":{"HostedZoneId":{},"DNSName":{},"EvaluateTargetHealth":{"type":"boolean"}}},"HealthCheckId":{},"TrafficPolicyInstanceId":{},"CidrRoutingConfig":{"type":"structure","required":["CollectionId","LocationName"],"members":{"CollectionId":{},"LocationName":{}}},"GeoProximityLocation":{"type":"structure","members":{"AWSRegion":{},"LocalZoneGroup":{},"Coordinates":{"type":"structure","required":["Latitude","Longitude"],"members":{"Latitude":{},"Longitude":{}}},"Bias":{"type":"integer"}}}}},"S1s":{"type":"list","member":{"locationName":"Tag","type":"structure","members":{"Key":{},"Value":{}}}},"S27":{"type":"structure","required":["Type"],"members":{"IPAddress":{},"Port":{"type":"integer"},"Type":{},"ResourcePath":{},"FullyQualifiedDomainName":{},"SearchString":{},"RequestInterval":{"type":"integer"},"FailureThreshold":{"type":"integer"},"MeasureLatency":{"type":"boolean"},"Inverted":{"type":"boolean"},"Disabled":{"type":"boolean"},"HealthThreshold":{"type":"integer"},"ChildHealthChecks":{"shape":"S2k"},"EnableSNI":{"type":"boolean"},"Regions":{"shape":"S2m"},"AlarmIdentifier":{"shape":"S2o"},"InsufficientDataHealthStatus":{},"RoutingControlArn":{}}},"S2k":{"type":"list","member":{"locationName":"ChildHealthCheck"}},"S2m":{"type":"list","member":{"locationName":"Region"}},"S2o":{"type":"structure","required":["Region","Name"],"members":{"Region":{},"Name":{}}},"S2u":{"type":"structure","required":["Id","CallerReference","HealthCheckConfig","HealthCheckVersion"],"members":{"Id":{},"CallerReference":{},"LinkedService":{"shape":"S2v"},"HealthCheckConfig":{"shape":"S27"},"HealthCheckVersion":{"type":"long"},"CloudWatchAlarmConfiguration":{"type":"structure","required":["EvaluationPeriods","Threshold","ComparisonOperator","Period","MetricName","Namespace","Statistic"],"members":{"EvaluationPeriods":{"type":"integer"},"Threshold":{"type":"double"},"ComparisonOperator":{},"Period":{"type":"integer"},"MetricName":{},"Namespace":{},"Statistic":{},"Dimensions":{"type":"list","member":{"locationName":"Dimension","type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{}}}}}}}},"S2v":{"type":"structure","members":{"ServicePrincipal":{},"Description":{}}},"S3b":{"type":"structure","members":{"Comment":{},"PrivateZone":{"type":"boolean"}}},"S3e":{"type":"structure","required":["Id","Name","CallerReference"],"members":{"Id":{},"Name":{},"CallerReference":{},"Config":{"shape":"S3b"},"ResourceRecordSetCount":{"type":"long"},"LinkedService":{"shape":"S2v"}}},"S3g":{"type":"structure","required":["NameServers"],"members":{"Id":{},"CallerReference":{},"NameServers":{"type":"list","member":{"locationName":"NameServer"}}}},"S3m":{"type":"structure","members":{"Name":{},"KmsArn":{},"Flag":{"type":"integer"},"SigningAlgorithmMnemonic":{},"SigningAlgorithmType":{"type":"integer"},"DigestAlgorithmMnemonic":{},"DigestAlgorithmType":{"type":"integer"},"KeyTag":{"type":"integer"},"DigestValue":{},"PublicKey":{},"DSRecord":{},"DNSKEYRecord":{},"Status":{},"StatusMessage":{},"CreatedDate":{"type":"timestamp"},"LastModifiedDate":{"type":"timestamp"}}},"S3t":{"type":"structure","required":["Id","HostedZoneId","CloudWatchLogsLogGroupArn"],"members":{"Id":{},"HostedZoneId":{},"CloudWatchLogsLogGroupArn":{}}},"S42":{"type":"structure","required":["Id","Version","Name","Type","Document"],"members":{"Id":{},"Version":{"type":"integer"},"Name":{},"Type":{},"Document":{},"Comment":{}}},"S47":{"type":"structure","required":["Id","HostedZoneId","Name","TTL","State","Message","TrafficPolicyId","TrafficPolicyVersion","TrafficPolicyType"],"members":{"Id":{},"HostedZoneId":{},"Name":{},"TTL":{"type":"long"},"State":{},"Message":{},"TrafficPolicyId":{},"TrafficPolicyVersion":{"type":"integer"},"TrafficPolicyType":{}}},"S5o":{"type":"structure","members":{"ContinentCode":{},"ContinentName":{},"CountryCode":{},"CountryName":{},"SubdivisionCode":{},"SubdivisionName":{}}},"S5z":{"type":"list","member":{"locationName":"HealthCheckObservation","type":"structure","members":{"Region":{},"IPAddress":{},"StatusReport":{"type":"structure","members":{"Status":{},"CheckedTime":{"type":"timestamp"}}}}}},"S67":{"type":"list","member":{"shape":"Sa","locationName":"VPC"}},"S7k":{"type":"list","member":{"shape":"S3e","locationName":"HostedZone"}},"S85":{"type":"structure","members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S1s"}}},"S8g":{"type":"list","member":{"shape":"S47","locationName":"TrafficPolicyInstance"}}}}

/***/ }),
/* 602 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListCidrBlocks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CidrBlocks"},"ListCidrCollections":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CidrCollections"},"ListCidrLocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CidrLocations"},"ListHealthChecks":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HealthChecks"},"ListHostedZones":{"input_token":"Marker","limit_key":"MaxItems","more_results":"IsTruncated","output_token":"NextMarker","result_key":"HostedZones"},"ListQueryLoggingConfigs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"QueryLoggingConfigs"},"ListResourceRecordSets":{"input_token":["StartRecordName","StartRecordType","StartRecordIdentifier"],"limit_key":"MaxItems","more_results":"IsTruncated","output_token":["NextRecordName","NextRecordType","NextRecordIdentifier"],"result_key":"ResourceRecordSets"}}}

/***/ }),
/* 603 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"ResourceRecordSetsChanged":{"delay":30,"maxAttempts":60,"operation":"GetChange","acceptors":[{"matcher":"path","expected":"INSYNC","argument":"ChangeInfo.Status","state":"success"}]}}}

/***/ }),
/* 604 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-05-15","endpointPrefix":"route53domains","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Route 53 Domains","serviceId":"Route 53 Domains","signatureVersion":"v4","targetPrefix":"Route53Domains_v20140515","uid":"route53domains-2014-05-15"},"operations":{"AcceptDomainTransferFromAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName","Password"],"members":{"DomainName":{},"Password":{"shape":"S3"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"AssociateDelegationSignerToDomain":{"input":{"type":"structure","required":["DomainName","SigningAttributes"],"members":{"DomainName":{},"SigningAttributes":{"type":"structure","members":{"Algorithm":{"type":"integer"},"Flags":{"type":"integer"},"PublicKey":{}}}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CancelDomainTransferToAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"CheckDomainAvailability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"IdnLangCode":{}}},"output":{"type":"structure","members":{"Availability":{}}}},"CheckDomainTransferability":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AuthCode":{"shape":"Si"}}},"output":{"type":"structure","members":{"Transferability":{"type":"structure","members":{"Transferable":{}}},"Message":{}}}},"DeleteDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"DeleteTagsForDomain":{"input":{"type":"structure","required":["DomainName","TagsToDelete"],"members":{"DomainName":{},"TagsToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"DisableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"DisableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"DisassociateDelegationSignerFromDomain":{"input":{"type":"structure","required":["DomainName","Id"],"members":{"DomainName":{},"Id":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"EnableDomainAutoRenew":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{}}},"EnableDomainTransferLock":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"GetContactReachabilityStatus":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"status":{}}}},"GetDomainDetail":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"DomainName":{},"Nameservers":{"shape":"S19"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S1f"},"RegistrantContact":{"shape":"S1f"},"TechContact":{"shape":"S1f"},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"},"RegistrarName":{},"WhoIsServer":{},"RegistrarUrl":{},"AbuseContactEmail":{"shape":"S1o"},"AbuseContactPhone":{"shape":"S1n"},"RegistryDomainId":{},"CreationDate":{"type":"timestamp"},"UpdatedDate":{"type":"timestamp"},"ExpirationDate":{"type":"timestamp"},"Reseller":{},"DnsSec":{},"StatusList":{"type":"list","member":{}},"DnssecKeys":{"type":"list","member":{"type":"structure","members":{"Algorithm":{"type":"integer"},"Flags":{"type":"integer"},"PublicKey":{},"DigestType":{"type":"integer"},"Digest":{},"KeyTag":{"type":"integer"},"Id":{}}}},"BillingContact":{"shape":"S1f"},"BillingPrivacy":{"type":"boolean"}}}},"GetDomainSuggestions":{"input":{"type":"structure","required":["DomainName","SuggestionCount","OnlyAvailable"],"members":{"DomainName":{},"SuggestionCount":{"type":"integer"},"OnlyAvailable":{"type":"boolean"}}},"output":{"type":"structure","members":{"SuggestionsList":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Availability":{}}}}}}},"GetOperationDetail":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Status":{},"Message":{},"DomainName":{},"Type":{},"SubmittedDate":{"type":"timestamp"},"LastUpdatedDate":{"type":"timestamp"},"StatusFlag":{}}}},"ListDomains":{"input":{"type":"structure","members":{"FilterConditions":{"type":"list","member":{"type":"structure","required":["Name","Operator","Values"],"members":{"Name":{},"Operator":{},"Values":{"type":"list","member":{}}}}},"SortCondition":{"type":"structure","required":["Name","SortOrder"],"members":{"Name":{},"SortOrder":{}}},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"Domains":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"AutoRenew":{"type":"boolean"},"TransferLock":{"type":"boolean"},"Expiry":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListOperations":{"input":{"type":"structure","members":{"SubmittedSince":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"},"Status":{"type":"list","member":{}},"Type":{"type":"list","member":{}},"SortBy":{},"SortOrder":{}}},"output":{"type":"structure","members":{"Operations":{"type":"list","member":{"type":"structure","members":{"OperationId":{},"Status":{},"Type":{},"SubmittedDate":{"type":"timestamp"},"DomainName":{},"Message":{},"StatusFlag":{},"LastUpdatedDate":{"type":"timestamp"}}}},"NextPageMarker":{}}}},"ListPrices":{"input":{"type":"structure","members":{"Tld":{},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"Prices":{"type":"list","member":{"type":"structure","members":{"Name":{},"RegistrationPrice":{"shape":"S37"},"TransferPrice":{"shape":"S37"},"RenewalPrice":{"shape":"S37"},"ChangeOwnershipPrice":{"shape":"S37"},"RestorationPrice":{"shape":"S37"}}}},"NextPageMarker":{}}}},"ListTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S3c"}}}},"PushDomain":{"input":{"type":"structure","required":["DomainName","Target"],"members":{"DomainName":{},"Target":{}}}},"RegisterDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S1f"},"RegistrantContact":{"shape":"S1f"},"TechContact":{"shape":"S1f"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"},"BillingContact":{"shape":"S1f"},"PrivacyProtectBillingContact":{"type":"boolean"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"RejectDomainTransferFromAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"OperationId":{}}}},"RenewDomain":{"input":{"type":"structure","required":["DomainName","CurrentExpiryYear"],"members":{"DomainName":{},"DurationInYears":{"type":"integer"},"CurrentExpiryYear":{"type":"integer"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"ResendContactReachabilityEmail":{"input":{"type":"structure","members":{"domainName":{}}},"output":{"type":"structure","members":{"domainName":{},"emailAddress":{"shape":"S1o"},"isAlreadyVerified":{"type":"boolean"}}}},"ResendOperationAuthorization":{"input":{"type":"structure","required":["OperationId"],"members":{"OperationId":{}}}},"RetrieveDomainAuthCode":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{}}},"output":{"type":"structure","members":{"AuthCode":{"shape":"Si"}}}},"TransferDomain":{"input":{"type":"structure","required":["DomainName","DurationInYears","AdminContact","RegistrantContact","TechContact"],"members":{"DomainName":{},"IdnLangCode":{},"DurationInYears":{"type":"integer"},"Nameservers":{"shape":"S19"},"AuthCode":{"shape":"Si"},"AutoRenew":{"type":"boolean"},"AdminContact":{"shape":"S1f"},"RegistrantContact":{"shape":"S1f"},"TechContact":{"shape":"S1f"},"PrivacyProtectAdminContact":{"type":"boolean"},"PrivacyProtectRegistrantContact":{"type":"boolean"},"PrivacyProtectTechContact":{"type":"boolean"},"BillingContact":{"shape":"S1f"},"PrivacyProtectBillingContact":{"type":"boolean"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"TransferDomainToAnotherAwsAccount":{"input":{"type":"structure","required":["DomainName","AccountId"],"members":{"DomainName":{},"AccountId":{}}},"output":{"type":"structure","members":{"OperationId":{},"Password":{"shape":"S3"}}}},"UpdateDomainContact":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminContact":{"shape":"S1f"},"RegistrantContact":{"shape":"S1f"},"TechContact":{"shape":"S1f"},"Consent":{"type":"structure","required":["MaxPrice","Currency"],"members":{"MaxPrice":{"type":"double"},"Currency":{}}},"BillingContact":{"shape":"S1f"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"UpdateDomainContactPrivacy":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"AdminPrivacy":{"type":"boolean"},"RegistrantPrivacy":{"type":"boolean"},"TechPrivacy":{"type":"boolean"},"BillingPrivacy":{"type":"boolean"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"UpdateDomainNameservers":{"input":{"type":"structure","required":["DomainName","Nameservers"],"members":{"DomainName":{},"FIAuthKey":{"deprecated":true,"type":"string","sensitive":true},"Nameservers":{"shape":"S19"}}},"output":{"type":"structure","members":{"OperationId":{}}}},"UpdateTagsForDomain":{"input":{"type":"structure","required":["DomainName"],"members":{"DomainName":{},"TagsToUpdate":{"shape":"S3c"}}},"output":{"type":"structure","members":{}}},"ViewBilling":{"input":{"type":"structure","members":{"Start":{"type":"timestamp"},"End":{"type":"timestamp"},"Marker":{},"MaxItems":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageMarker":{},"BillingRecords":{"type":"list","member":{"type":"structure","members":{"DomainName":{},"Operation":{},"InvoiceId":{},"BillDate":{"type":"timestamp"},"Price":{"type":"double"}}}}}}}},"shapes":{"S3":{"type":"string","sensitive":true},"Si":{"type":"string","sensitive":true},"S19":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"GlueIps":{"type":"list","member":{}}}}},"S1f":{"type":"structure","members":{"FirstName":{"shape":"S1g"},"LastName":{"shape":"S1g"},"ContactType":{},"OrganizationName":{"shape":"S1g"},"AddressLine1":{"shape":"S1i"},"AddressLine2":{"shape":"S1i"},"City":{"type":"string","sensitive":true},"State":{"type":"string","sensitive":true},"CountryCode":{"type":"string","sensitive":true},"ZipCode":{"type":"string","sensitive":true},"PhoneNumber":{"shape":"S1n"},"Email":{"shape":"S1o"},"Fax":{"shape":"S1n"},"ExtraParams":{"type":"list","member":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Value":{"type":"string","sensitive":true}}}}},"sensitive":true},"S1g":{"type":"string","sensitive":true},"S1i":{"type":"string","sensitive":true},"S1n":{"type":"string","sensitive":true},"S1o":{"type":"string","sensitive":true},"S37":{"type":"structure","required":["Price","Currency"],"members":{"Price":{"type":"double"},"Currency":{}}},"S3c":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}}}}

/***/ }),
/* 605 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDomains":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Domains"},"ListOperations":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Operations"},"ListPrices":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"Prices"},"ViewBilling":{"input_token":"Marker","limit_key":"MaxItems","output_token":"NextPageMarker","result_key":"BillingRecords"}}}

/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-11-28","endpointPrefix":"runtime.lex","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon Lex Runtime Service","serviceId":"Lex Runtime Service","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex-2016-11-28"},"operations":{"DeleteSession":{"http":{"method":"DELETE","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"}}},"output":{"type":"structure","members":{"botName":{},"botAlias":{},"userId":{},"sessionId":{}}}},"GetSession":{"http":{"method":"GET","requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session/"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"checkpointLabelFilter":{"location":"querystring","locationName":"checkpointLabelFilter"}}},"output":{"type":"structure","members":{"recentIntentSummaryView":{"shape":"Sa"},"sessionAttributes":{"shape":"Sd"},"sessionId":{},"dialogAction":{"shape":"Sh"},"activeContexts":{"shape":"Sk"}}}},"PostContent":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/content"},"input":{"type":"structure","required":["botName","botAlias","userId","contentType","inputStream"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"St","jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"requestAttributes":{"shape":"St","jsonvalue":true,"location":"header","locationName":"x-amz-lex-request-attributes"},"contentType":{"location":"header","locationName":"Content-Type"},"accept":{"location":"header","locationName":"Accept"},"inputStream":{"shape":"Sw"},"activeContexts":{"shape":"Sx","jsonvalue":true,"location":"header","locationName":"x-amz-lex-active-contexts"}},"payload":"inputStream"},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"nluIntentConfidence":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-nlu-intent-confidence"},"alternativeIntents":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-alternative-intents"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"sentimentResponse":{"location":"header","locationName":"x-amz-lex-sentiment"},"message":{"shape":"Si","deprecated":true,"deprecatedMessage":"The message field is deprecated, use the encodedMessage field instead. The message field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.","location":"header","locationName":"x-amz-lex-message"},"encodedMessage":{"shape":"Sz","location":"header","locationName":"x-amz-lex-encoded-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"inputTranscript":{"deprecated":true,"deprecatedMessage":"The inputTranscript field is deprecated, use the encodedInputTranscript field instead. The inputTranscript field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.","location":"header","locationName":"x-amz-lex-input-transcript"},"encodedInputTranscript":{"location":"header","locationName":"x-amz-lex-encoded-input-transcript","type":"string","sensitive":true},"audioStream":{"shape":"Sw"},"botVersion":{"location":"header","locationName":"x-amz-lex-bot-version"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"activeContexts":{"shape":"Sx","jsonvalue":true,"location":"header","locationName":"x-amz-lex-active-contexts"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"},"PostText":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/text"},"input":{"type":"structure","required":["botName","botAlias","userId","inputText"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sd"},"requestAttributes":{"shape":"Sd"},"inputText":{"shape":"Si"},"activeContexts":{"shape":"Sk"}}},"output":{"type":"structure","members":{"intentName":{},"nluIntentConfidence":{"shape":"S15"},"alternativeIntents":{"type":"list","member":{"type":"structure","members":{"intentName":{},"nluIntentConfidence":{"shape":"S15"},"slots":{"shape":"Sd"}}}},"slots":{"shape":"Sd"},"sessionAttributes":{"shape":"Sd"},"message":{"shape":"Si"},"sentimentResponse":{"type":"structure","members":{"sentimentLabel":{},"sentimentScore":{}}},"messageFormat":{},"dialogState":{},"slotToElicit":{},"responseCard":{"type":"structure","members":{"version":{},"contentType":{},"genericAttachments":{"type":"list","member":{"type":"structure","members":{"title":{},"subTitle":{},"attachmentLinkUrl":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}},"sessionId":{},"botVersion":{},"activeContexts":{"shape":"Sk"}}}},"PutSession":{"http":{"requestUri":"/bot/{botName}/alias/{botAlias}/user/{userId}/session"},"input":{"type":"structure","required":["botName","botAlias","userId"],"members":{"botName":{"location":"uri","locationName":"botName"},"botAlias":{"location":"uri","locationName":"botAlias"},"userId":{"location":"uri","locationName":"userId"},"sessionAttributes":{"shape":"Sd"},"dialogAction":{"shape":"Sh"},"recentIntentSummaryView":{"shape":"Sa"},"accept":{"location":"header","locationName":"Accept"},"activeContexts":{"shape":"Sk"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"intentName":{"location":"header","locationName":"x-amz-lex-intent-name"},"slots":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-slots"},"sessionAttributes":{"jsonvalue":true,"location":"header","locationName":"x-amz-lex-session-attributes"},"message":{"shape":"Si","deprecated":true,"deprecatedMessage":"The message field is deprecated, use the encodedMessage field instead. The message field is available only in the de-DE, en-AU, en-GB, en-US, es-419, es-ES, es-US, fr-CA, fr-FR and it-IT locales.","location":"header","locationName":"x-amz-lex-message"},"encodedMessage":{"shape":"Sz","location":"header","locationName":"x-amz-lex-encoded-message"},"messageFormat":{"location":"header","locationName":"x-amz-lex-message-format"},"dialogState":{"location":"header","locationName":"x-amz-lex-dialog-state"},"slotToElicit":{"location":"header","locationName":"x-amz-lex-slot-to-elicit"},"audioStream":{"shape":"Sw"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"activeContexts":{"shape":"Sx","jsonvalue":true,"location":"header","locationName":"x-amz-lex-active-contexts"}},"payload":"audioStream"}}},"shapes":{"Sa":{"type":"list","member":{"type":"structure","required":["dialogActionType"],"members":{"intentName":{},"checkpointLabel":{},"slots":{"shape":"Sd"},"confirmationStatus":{},"dialogActionType":{},"fulfillmentState":{},"slotToElicit":{}}}},"Sd":{"type":"map","key":{},"value":{},"sensitive":true},"Sh":{"type":"structure","required":["type"],"members":{"type":{},"intentName":{},"slots":{"shape":"Sd"},"slotToElicit":{},"fulfillmentState":{},"message":{"shape":"Si"},"messageFormat":{}}},"Si":{"type":"string","sensitive":true},"Sk":{"type":"list","member":{"type":"structure","required":["name","timeToLive","parameters"],"members":{"name":{},"timeToLive":{"type":"structure","members":{"timeToLiveInSeconds":{"type":"integer"},"turnsToLive":{"type":"integer"}}},"parameters":{"type":"map","key":{},"value":{"shape":"Si"}}}},"sensitive":true},"St":{"type":"string","sensitive":true},"Sw":{"type":"blob","streaming":true},"Sx":{"type":"string","sensitive":true},"Sz":{"type":"string","sensitive":true},"S15":{"type":"structure","members":{"score":{"type":"double"}}}}}

/***/ }),
/* 607 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 608 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2020-08-07","endpointPrefix":"runtime-v2-lex","jsonVersion":"1.1","protocol":"rest-json","protocolSettings":{"h2":"eventstream"},"serviceAbbreviation":"Lex Runtime V2","serviceFullName":"Amazon Lex Runtime V2","serviceId":"Lex Runtime V2","signatureVersion":"v4","signingName":"lex","uid":"runtime.lex.v2-2020-08-07"},"operations":{"DeleteSession":{"http":{"method":"DELETE","requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"},"input":{"type":"structure","required":["botId","botAliasId","sessionId","localeId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"}}},"output":{"type":"structure","members":{"botId":{},"botAliasId":{},"localeId":{},"sessionId":{}}}},"GetSession":{"http":{"method":"GET","requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"},"input":{"type":"structure","required":["botId","botAliasId","localeId","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"}}},"output":{"type":"structure","members":{"sessionId":{},"messages":{"shape":"Sa"},"interpretations":{"shape":"Sl"},"sessionState":{"shape":"S12"}}}},"PutSession":{"http":{"requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}"},"input":{"type":"structure","required":["botId","botAliasId","localeId","sessionState","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"},"messages":{"shape":"Sa"},"sessionState":{"shape":"S12"},"requestAttributes":{"shape":"S1f"},"responseContentType":{"location":"header","locationName":"ResponseContentType"}}},"output":{"type":"structure","members":{"contentType":{"location":"header","locationName":"Content-Type"},"messages":{"location":"header","locationName":"x-amz-lex-messages"},"sessionState":{"location":"header","locationName":"x-amz-lex-session-state"},"requestAttributes":{"location":"header","locationName":"x-amz-lex-request-attributes"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"audioStream":{"shape":"S1r"}},"payload":"audioStream"}},"RecognizeText":{"http":{"requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/text"},"input":{"type":"structure","required":["botId","botAliasId","localeId","text","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"},"text":{"shape":"Sc"},"sessionState":{"shape":"S12"},"requestAttributes":{"shape":"S1f"}}},"output":{"type":"structure","members":{"messages":{"shape":"Sa"},"sessionState":{"shape":"S12"},"interpretations":{"shape":"Sl"},"requestAttributes":{"shape":"S1f"},"sessionId":{},"recognizedBotMember":{"type":"structure","required":["botId"],"members":{"botId":{},"botName":{}}}}}},"RecognizeUtterance":{"http":{"requestUri":"/bots/{botId}/botAliases/{botAliasId}/botLocales/{localeId}/sessions/{sessionId}/utterance"},"input":{"type":"structure","required":["botId","botAliasId","localeId","requestContentType","sessionId"],"members":{"botId":{"location":"uri","locationName":"botId"},"botAliasId":{"location":"uri","locationName":"botAliasId"},"localeId":{"location":"uri","locationName":"localeId"},"sessionId":{"location":"uri","locationName":"sessionId"},"sessionState":{"shape":"S1w","location":"header","locationName":"x-amz-lex-session-state"},"requestAttributes":{"shape":"S1w","location":"header","locationName":"x-amz-lex-request-attributes"},"requestContentType":{"location":"header","locationName":"Content-Type"},"responseContentType":{"location":"header","locationName":"Response-Content-Type"},"inputStream":{"shape":"S1r"}},"payload":"inputStream"},"output":{"type":"structure","members":{"inputMode":{"location":"header","locationName":"x-amz-lex-input-mode"},"contentType":{"location":"header","locationName":"Content-Type"},"messages":{"location":"header","locationName":"x-amz-lex-messages"},"interpretations":{"location":"header","locationName":"x-amz-lex-interpretations"},"sessionState":{"location":"header","locationName":"x-amz-lex-session-state"},"requestAttributes":{"location":"header","locationName":"x-amz-lex-request-attributes"},"sessionId":{"location":"header","locationName":"x-amz-lex-session-id"},"inputTranscript":{"location":"header","locationName":"x-amz-lex-input-transcript"},"audioStream":{"shape":"S1r"},"recognizedBotMember":{"location":"header","locationName":"x-amz-lex-recognized-bot-member"}},"payload":"audioStream"},"authtype":"v4-unsigned-body"}},"shapes":{"Sa":{"type":"list","member":{"type":"structure","required":["contentType"],"members":{"content":{"shape":"Sc"},"contentType":{},"imageResponseCard":{"type":"structure","required":["title"],"members":{"title":{},"subtitle":{},"imageUrl":{},"buttons":{"type":"list","member":{"type":"structure","required":["text","value"],"members":{"text":{},"value":{}}}}}}}}},"Sc":{"type":"string","sensitive":true},"Sl":{"type":"list","member":{"type":"structure","members":{"nluConfidence":{"type":"structure","members":{"score":{"type":"double"}}},"sentimentResponse":{"type":"structure","members":{"sentiment":{},"sentimentScore":{"type":"structure","members":{"positive":{"type":"double"},"negative":{"type":"double"},"neutral":{"type":"double"},"mixed":{"type":"double"}}}}},"intent":{"shape":"Ss"},"interpretationSource":{}}}},"Ss":{"type":"structure","required":["name"],"members":{"name":{},"slots":{"shape":"St"},"state":{},"confirmationState":{}}},"St":{"type":"map","key":{},"value":{"shape":"Su"}},"Su":{"type":"structure","members":{"value":{"type":"structure","required":["interpretedValue"],"members":{"originalValue":{},"interpretedValue":{},"resolvedValues":{"type":"list","member":{}}}},"shape":{},"values":{"type":"list","member":{"shape":"Su"}},"subSlots":{"shape":"St"}}},"S12":{"type":"structure","members":{"dialogAction":{"type":"structure","required":["type"],"members":{"type":{},"slotToElicit":{},"slotElicitationStyle":{},"subSlotToElicit":{"shape":"S16"}}},"intent":{"shape":"Ss"},"activeContexts":{"type":"list","member":{"type":"structure","required":["name","timeToLive","contextAttributes"],"members":{"name":{},"timeToLive":{"type":"structure","required":["timeToLiveInSeconds","turnsToLive"],"members":{"timeToLiveInSeconds":{"type":"integer"},"turnsToLive":{"type":"integer"}}},"contextAttributes":{"type":"map","key":{},"value":{"shape":"Sc"}}}}},"sessionAttributes":{"shape":"S1f"},"originatingRequestId":{},"runtimeHints":{"type":"structure","members":{"slotHints":{"type":"map","key":{},"value":{"shape":"S1k"}}}}}},"S16":{"type":"structure","required":["name"],"members":{"name":{},"subSlotToElicit":{"shape":"S16"}}},"S1f":{"type":"map","key":{},"value":{}},"S1k":{"type":"map","key":{},"value":{"type":"structure","members":{"runtimeHintValues":{"type":"list","member":{"type":"structure","required":["phrase"],"members":{"phrase":{}}}},"subSlotHints":{"shape":"S1k"}}}},"S1r":{"type":"blob","streaming":true},"S1w":{"type":"string","sensitive":true}}}

/***/ }),
/* 609 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 610 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2006-03-01","checksumFormat":"md5","endpointPrefix":"s3","globalEndpoint":"s3.amazonaws.com","protocol":"rest-xml","protocols":["rest-xml"],"serviceAbbreviation":"Amazon S3","serviceFullName":"Amazon Simple Storage Service","serviceId":"S3","signatureVersion":"s3","uid":"s3-2006-03-01"},"operations":{"AbortMultipartUpload":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CompleteMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"MultipartUpload":{"locationName":"CompleteMultipartUpload","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"ETag":{},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{},"PartNumber":{"type":"integer"}}},"flattened":true}}},"UploadId":{"location":"querystring","locationName":"uploadId"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"}},"payload":"MultipartUpload"},"output":{"type":"structure","members":{"Location":{},"Bucket":{},"Key":{},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"CopyObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-checksum-algorithm"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"location":"uri","locationName":"Key"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"MetadataDirective":{"location":"header","locationName":"x-amz-metadata-directive"},"TaggingDirective":{"location":"header","locationName":"x-amz-tagging-directive"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1k","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ExpectedSourceBucketOwner":{"location":"header","locationName":"x-amz-source-expected-bucket-owner"}}},"output":{"type":"structure","members":{"CopyObjectResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyObjectResult"},"alias":"PutObjectCopy","staticContextParams":{"DisableS3ExpressSessionAuth":{"value":true}}},"CreateBucket":{"http":{"method":"PUT","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"CreateBucketConfiguration":{"locationName":"CreateBucketConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LocationConstraint":{},"Location":{"type":"structure","members":{"Type":{},"Name":{}}},"Bucket":{"type":"structure","members":{"DataRedundancy":{},"Type":{}}}}},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"ObjectLockEnabledForBucket":{"location":"header","locationName":"x-amz-bucket-object-lock-enabled","type":"boolean"},"ObjectOwnership":{"location":"header","locationName":"x-amz-object-ownership"}},"payload":"CreateBucketConfiguration"},"output":{"type":"structure","members":{"Location":{"location":"header","locationName":"Location"}}},"alias":"PutBucket","staticContextParams":{"DisableAccessPoints":{"value":true},"UseS3ExpressControlEndpoint":{"value":true}}},"CreateMultipartUpload":{"http":{"requestUri":"/{Bucket}/{Key+}?uploads"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-checksum-algorithm"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{"locationName":"Bucket"},"Key":{},"UploadId":{},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-checksum-algorithm"}}},"alias":"InitiateMultipartUpload"},"CreateSession":{"http":{"method":"GET","requestUri":"/{Bucket}?session"},"input":{"type":"structure","required":["Bucket"],"members":{"SessionMode":{"location":"header","locationName":"x-amz-create-session-mode"},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"}}},"output":{"type":"structure","required":["Credentials"],"members":{"Credentials":{"locationName":"Credentials","type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{"locationName":"AccessKeyId"},"SecretAccessKey":{"shape":"S2h","locationName":"SecretAccessKey"},"SessionToken":{"shape":"S2h","locationName":"SessionToken"},"Expiration":{"locationName":"Expiration","type":"timestamp"}}}}},"staticContextParams":{"DisableS3ExpressSessionAuth":{"value":true}}},"DeleteBucket":{"http":{"method":"DELETE","requestUri":"/{Bucket}","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketAnalyticsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?analytics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketCors":{"http":{"method":"DELETE","requestUri":"/{Bucket}?cors","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketEncryption":{"http":{"method":"DELETE","requestUri":"/{Bucket}?encryption","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketIntelligentTieringConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?intelligent-tiering","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketInventoryConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?inventory","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketLifecycle":{"http":{"method":"DELETE","requestUri":"/{Bucket}?lifecycle","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketMetricsConfiguration":{"http":{"method":"DELETE","requestUri":"/{Bucket}?metrics","responseCode":204},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketOwnershipControls":{"http":{"method":"DELETE","requestUri":"/{Bucket}?ownershipControls","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketPolicy":{"http":{"method":"DELETE","requestUri":"/{Bucket}?policy","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketReplication":{"http":{"method":"DELETE","requestUri":"/{Bucket}?replication","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteBucketWebsite":{"http":{"method":"DELETE","requestUri":"/{Bucket}?website","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"DeleteObject":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"DeleteObjectTagging":{"http":{"method":"DELETE","requestUri":"/{Bucket}/{Key+}?tagging","responseCode":204},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}}},"DeleteObjects":{"http":{"requestUri":"/{Bucket}?delete"},"input":{"type":"structure","required":["Bucket","Delete"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Delete":{"locationName":"Delete","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Objects"],"members":{"Objects":{"locationName":"Object","type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"VersionId":{}}},"flattened":true},"Quiet":{"type":"boolean"}}},"MFA":{"location":"header","locationName":"x-amz-mfa"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"}},"payload":"Delete"},"output":{"type":"structure","members":{"Deleted":{"type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"DeleteMarker":{"type":"boolean"},"DeleteMarkerVersionId":{}}},"flattened":true},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"Errors":{"locationName":"Error","type":"list","member":{"type":"structure","members":{"Key":{},"VersionId":{},"Code":{},"Message":{}}},"flattened":true}}},"alias":"DeleteMultipleObjects","httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"DeletePublicAccessBlock":{"http":{"method":"DELETE","requestUri":"/{Bucket}?publicAccessBlock","responseCode":204},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketAccelerateConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Status":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketAcl":{"http":{"method":"GET","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S3q"},"Grants":{"shape":"S3t","locationName":"AccessControlList"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketAnalyticsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"AnalyticsConfiguration":{"shape":"S42"}},"payload":"AnalyticsConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketCors":{"http":{"method":"GET","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"CORSRules":{"shape":"S4h","locationName":"CORSRule"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketEncryption":{"http":{"method":"GET","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ServerSideEncryptionConfiguration":{"shape":"S4u"}},"payload":"ServerSideEncryptionConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketIntelligentTieringConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?intelligent-tiering"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"}}},"output":{"type":"structure","members":{"IntelligentTieringConfiguration":{"shape":"S50"}},"payload":"IntelligentTieringConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketInventoryConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"InventoryConfiguration":{"shape":"S5a"}},"payload":"InventoryConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketLifecycle":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S5q","locationName":"Rule"}}},"deprecated":true,"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketLifecycleConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Rules":{"shape":"S66","locationName":"Rule"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketLocation":{"http":{"method":"GET","requestUri":"/{Bucket}?location"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"LocationConstraint":{}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketLogging":{"http":{"method":"GET","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"LoggingEnabled":{"shape":"S6i"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketMetricsConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"MetricsConfiguration":{"shape":"S6u"}},"payload":"MetricsConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketNotification":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S6y"},"output":{"shape":"S6z"},"deprecated":true,"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketNotificationConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?notification"},"input":{"shape":"S6y"},"output":{"shape":"S7a"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketOwnershipControls":{"http":{"method":"GET","requestUri":"/{Bucket}?ownershipControls"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"OwnershipControls":{"shape":"S7r"}},"payload":"OwnershipControls"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketPolicy":{"http":{"method":"GET","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Policy":{}},"payload":"Policy"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketPolicyStatus":{"http":{"method":"GET","requestUri":"/{Bucket}?policyStatus"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"PolicyStatus":{"type":"structure","members":{"IsPublic":{"locationName":"IsPublic","type":"boolean"}}}},"payload":"PolicyStatus"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketReplication":{"http":{"method":"GET","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ReplicationConfiguration":{"shape":"S83"}},"payload":"ReplicationConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketRequestPayment":{"http":{"method":"GET","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Payer":{}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketTagging":{"http":{"method":"GET","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S48"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketVersioning":{"http":{"method":"GET","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Status":{},"MFADelete":{"locationName":"MfaDelete"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetBucketWebsite":{"http":{"method":"GET","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"RedirectAllRequestsTo":{"shape":"S96"},"IndexDocument":{"shape":"S99"},"ErrorDocument":{"shape":"S9b"},"RoutingRules":{"shape":"S9c"}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"GetObject":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"ResponseCacheControl":{"location":"querystring","locationName":"response-cache-control"},"ResponseContentDisposition":{"location":"querystring","locationName":"response-content-disposition"},"ResponseContentEncoding":{"location":"querystring","locationName":"response-content-encoding"},"ResponseContentLanguage":{"location":"querystring","locationName":"response-content-language"},"ResponseContentType":{"location":"querystring","locationName":"response-content-type"},"ResponseExpires":{"location":"querystring","locationName":"response-expires","type":"timestamp","timestampFormat":"rfc822"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumMode":{"location":"header","locationName":"x-amz-checksum-mode"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ETag":{"location":"header","locationName":"ETag"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentRange":{"location":"header","locationName":"Content-Range"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","deprecated":true,"type":"timestamp"},"ExpiresString":{"location":"header","locationName":"ExpiresString"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"TagCount":{"location":"header","locationName":"x-amz-tagging-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}},"payload":"Body"},"httpChecksum":{"requestValidationModeMember":"ChecksumMode","responseAlgorithms":["CRC32","CRC32C","SHA256","SHA1"]}},"GetObjectAcl":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Owner":{"shape":"S3q"},"Grants":{"shape":"S3t","locationName":"AccessControlList"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"GetObjectAttributes":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?attributes"},"input":{"type":"structure","required":["Bucket","Key","ObjectAttributes"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"MaxParts":{"location":"header","locationName":"x-amz-max-parts","type":"integer"},"PartNumberMarker":{"location":"header","locationName":"x-amz-part-number-marker","type":"integer"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ObjectAttributes":{"location":"header","locationName":"x-amz-object-attributes","type":"list","member":{}}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ETag":{},"Checksum":{"type":"structure","members":{"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"ObjectParts":{"type":"structure","members":{"TotalPartsCount":{"locationName":"PartsCount","type":"integer"},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"Size":{"type":"long"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"flattened":true}}},"StorageClass":{},"ObjectSize":{"type":"long"}}}},"GetObjectLegalHold":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"LegalHold":{"shape":"Sar","locationName":"LegalHold"}},"payload":"LegalHold"}},"GetObjectLockConfiguration":{"http":{"method":"GET","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ObjectLockConfiguration":{"shape":"Sau"}},"payload":"ObjectLockConfiguration"}},"GetObjectRetention":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Retention":{"shape":"Sb2","locationName":"Retention"}},"payload":"Retention"}},"GetObjectTagging":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","required":["TagSet"],"members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"},"TagSet":{"shape":"S48"}}}},"GetObjectTorrent":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}?torrent"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Body":{"streaming":true,"type":"blob"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"Body"}},"GetPublicAccessBlock":{"http":{"method":"GET","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"PublicAccessBlockConfiguration":{"shape":"Sb9"}},"payload":"PublicAccessBlockConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"HeadBucket":{"http":{"method":"HEAD","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"BucketLocationType":{"location":"header","locationName":"x-amz-bucket-location-type"},"BucketLocationName":{"location":"header","locationName":"x-amz-bucket-location-name"},"BucketRegion":{"location":"header","locationName":"x-amz-bucket-region"},"AccessPointAlias":{"location":"header","locationName":"x-amz-access-point-alias","type":"boolean"}}}},"HeadObject":{"http":{"method":"HEAD","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"IfMatch":{"location":"header","locationName":"If-Match"},"IfModifiedSince":{"location":"header","locationName":"If-Modified-Since","type":"timestamp"},"IfNoneMatch":{"location":"header","locationName":"If-None-Match"},"IfUnmodifiedSince":{"location":"header","locationName":"If-Unmodified-Since","type":"timestamp"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"Range":{"location":"header","locationName":"Range"},"VersionId":{"location":"querystring","locationName":"versionId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumMode":{"location":"header","locationName":"x-amz-checksum-mode"}}},"output":{"type":"structure","members":{"DeleteMarker":{"location":"header","locationName":"x-amz-delete-marker","type":"boolean"},"AcceptRanges":{"location":"header","locationName":"accept-ranges"},"Expiration":{"location":"header","locationName":"x-amz-expiration"},"Restore":{"location":"header","locationName":"x-amz-restore"},"ArchiveStatus":{"location":"header","locationName":"x-amz-archive-status"},"LastModified":{"location":"header","locationName":"Last-Modified","type":"timestamp"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"ETag":{"location":"header","locationName":"ETag"},"MissingMeta":{"location":"header","locationName":"x-amz-missing-meta","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentType":{"location":"header","locationName":"Content-Type"},"Expires":{"location":"header","locationName":"Expires","deprecated":true,"type":"timestamp"},"ExpiresString":{"location":"header","locationName":"ExpiresString"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ReplicationStatus":{"location":"header","locationName":"x-amz-replication-status"},"PartsCount":{"location":"header","locationName":"x-amz-mp-parts-count","type":"integer"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"}}}},"ListBucketAnalyticsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"AnalyticsConfigurationList":{"locationName":"AnalyticsConfiguration","type":"list","member":{"shape":"S42"},"flattened":true}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"ListBucketIntelligentTieringConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?intelligent-tiering"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"IntelligentTieringConfigurationList":{"locationName":"IntelligentTieringConfiguration","type":"list","member":{"shape":"S50"},"flattened":true}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"ListBucketInventoryConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"ContinuationToken":{},"InventoryConfigurationList":{"locationName":"InventoryConfiguration","type":"list","member":{"shape":"S5a"},"flattened":true},"IsTruncated":{"type":"boolean"},"NextContinuationToken":{}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"ListBucketMetricsConfigurations":{"http":{"method":"GET","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"ContinuationToken":{},"NextContinuationToken":{},"MetricsConfigurationList":{"locationName":"MetricsConfiguration","type":"list","member":{"shape":"S6u"},"flattened":true}}}},"ListBuckets":{"http":{"method":"GET"},"output":{"type":"structure","members":{"Buckets":{"shape":"Sby"},"Owner":{"shape":"S3q"}}},"alias":"GetService"},"ListDirectoryBuckets":{"http":{"method":"GET"},"input":{"type":"structure","members":{"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"MaxDirectoryBuckets":{"location":"querystring","locationName":"max-directory-buckets","type":"integer"}}},"output":{"type":"structure","members":{"Buckets":{"shape":"Sby"},"ContinuationToken":{}}},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"ListMultipartUploads":{"http":{"method":"GET","requestUri":"/{Bucket}?uploads"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxUploads":{"location":"querystring","locationName":"max-uploads","type":"integer"},"Prefix":{"contextParam":{"name":"Prefix"},"location":"querystring","locationName":"prefix"},"UploadIdMarker":{"location":"querystring","locationName":"upload-id-marker"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}}},"output":{"type":"structure","members":{"Bucket":{},"KeyMarker":{},"UploadIdMarker":{},"NextKeyMarker":{},"Prefix":{},"Delimiter":{},"NextUploadIdMarker":{},"MaxUploads":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Uploads":{"locationName":"Upload","type":"list","member":{"type":"structure","members":{"UploadId":{},"Key":{},"Initiated":{"type":"timestamp"},"StorageClass":{},"Owner":{"shape":"S3q"},"Initiator":{"shape":"Sch"},"ChecksumAlgorithm":{}}},"flattened":true},"CommonPrefixes":{"shape":"Sci"},"EncodingType":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"ListObjectVersions":{"http":{"method":"GET","requestUri":"/{Bucket}?versions"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"KeyMarker":{"location":"querystring","locationName":"key-marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"contextParam":{"name":"Prefix"},"location":"querystring","locationName":"prefix"},"VersionIdMarker":{"location":"querystring","locationName":"version-id-marker"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"OptionalObjectAttributes":{"shape":"Scn","location":"header","locationName":"x-amz-optional-object-attributes"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"KeyMarker":{},"VersionIdMarker":{},"NextKeyMarker":{},"NextVersionIdMarker":{},"Versions":{"locationName":"Version","type":"list","member":{"type":"structure","members":{"ETag":{},"ChecksumAlgorithm":{"shape":"Sct"},"Size":{"type":"long"},"StorageClass":{},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"},"Owner":{"shape":"S3q"},"RestoreStatus":{"shape":"Scw"}}},"flattened":true},"DeleteMarkers":{"locationName":"DeleteMarker","type":"list","member":{"type":"structure","members":{"Owner":{"shape":"S3q"},"Key":{},"VersionId":{},"IsLatest":{"type":"boolean"},"LastModified":{"type":"timestamp"}}},"flattened":true},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sci"},"EncodingType":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"alias":"GetBucketObjectVersions"},"ListObjects":{"http":{"method":"GET","requestUri":"/{Bucket}"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"Marker":{"location":"querystring","locationName":"marker"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"contextParam":{"name":"Prefix"},"location":"querystring","locationName":"prefix"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"OptionalObjectAttributes":{"shape":"Scn","location":"header","locationName":"x-amz-optional-object-attributes"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Marker":{},"NextMarker":{},"Contents":{"shape":"Sd5"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sci"},"EncodingType":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"alias":"GetBucket"},"ListObjectsV2":{"http":{"method":"GET","requestUri":"/{Bucket}?list-type=2"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Delimiter":{"location":"querystring","locationName":"delimiter"},"EncodingType":{"location":"querystring","locationName":"encoding-type"},"MaxKeys":{"location":"querystring","locationName":"max-keys","type":"integer"},"Prefix":{"contextParam":{"name":"Prefix"},"location":"querystring","locationName":"prefix"},"ContinuationToken":{"location":"querystring","locationName":"continuation-token"},"FetchOwner":{"location":"querystring","locationName":"fetch-owner","type":"boolean"},"StartAfter":{"location":"querystring","locationName":"start-after"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"OptionalObjectAttributes":{"shape":"Scn","location":"header","locationName":"x-amz-optional-object-attributes"}}},"output":{"type":"structure","members":{"IsTruncated":{"type":"boolean"},"Contents":{"shape":"Sd5"},"Name":{},"Prefix":{},"Delimiter":{},"MaxKeys":{"type":"integer"},"CommonPrefixes":{"shape":"Sci"},"EncodingType":{},"KeyCount":{"type":"integer"},"ContinuationToken":{},"NextContinuationToken":{},"StartAfter":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}}},"ListParts":{"http":{"method":"GET","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","UploadId"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"MaxParts":{"location":"querystring","locationName":"max-parts","type":"integer"},"PartNumberMarker":{"location":"querystring","locationName":"part-number-marker","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"}}},"output":{"type":"structure","members":{"AbortDate":{"location":"header","locationName":"x-amz-abort-date","type":"timestamp"},"AbortRuleId":{"location":"header","locationName":"x-amz-abort-rule-id"},"Bucket":{},"Key":{},"UploadId":{},"PartNumberMarker":{"type":"integer"},"NextPartNumberMarker":{"type":"integer"},"MaxParts":{"type":"integer"},"IsTruncated":{"type":"boolean"},"Parts":{"locationName":"Part","type":"list","member":{"type":"structure","members":{"PartNumber":{"type":"integer"},"LastModified":{"type":"timestamp"},"ETag":{},"Size":{"type":"long"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"flattened":true},"Initiator":{"shape":"Sch"},"Owner":{"shape":"S3q"},"StorageClass":{},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"ChecksumAlgorithm":{}}}},"PutBucketAccelerateConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?accelerate"},"input":{"type":"structure","required":["Bucket","AccelerateConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"AccelerateConfiguration":{"locationName":"AccelerateConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Status":{}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"}},"payload":"AccelerateConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}?acl"},"input":{"type":"structure","required":["Bucket"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sdk","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"AccessControlPolicy"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketAnalyticsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?analytics"},"input":{"type":"structure","required":["Bucket","Id","AnalyticsConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"AnalyticsConfiguration":{"shape":"S42","locationName":"AnalyticsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"AnalyticsConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketCors":{"http":{"method":"PUT","requestUri":"/{Bucket}?cors"},"input":{"type":"structure","required":["Bucket","CORSConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"CORSConfiguration":{"locationName":"CORSConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["CORSRules"],"members":{"CORSRules":{"shape":"S4h","locationName":"CORSRule"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"CORSConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketEncryption":{"http":{"method":"PUT","requestUri":"/{Bucket}?encryption"},"input":{"type":"structure","required":["Bucket","ServerSideEncryptionConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ServerSideEncryptionConfiguration":{"shape":"S4u","locationName":"ServerSideEncryptionConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"ServerSideEncryptionConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketIntelligentTieringConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?intelligent-tiering"},"input":{"type":"structure","required":["Bucket","Id","IntelligentTieringConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"IntelligentTieringConfiguration":{"shape":"S50","locationName":"IntelligentTieringConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"IntelligentTieringConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketInventoryConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?inventory"},"input":{"type":"structure","required":["Bucket","Id","InventoryConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"InventoryConfiguration":{"shape":"S5a","locationName":"InventoryConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"InventoryConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketLifecycle":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S5q","locationName":"Rule"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"LifecycleConfiguration"},"deprecated":true,"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketLifecycleConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?lifecycle"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"LifecycleConfiguration":{"locationName":"LifecycleConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Rules"],"members":{"Rules":{"shape":"S66","locationName":"Rule"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"LifecycleConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketLogging":{"http":{"method":"PUT","requestUri":"/{Bucket}?logging"},"input":{"type":"structure","required":["Bucket","BucketLoggingStatus"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"BucketLoggingStatus":{"locationName":"BucketLoggingStatus","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"LoggingEnabled":{"shape":"S6i"}}},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"BucketLoggingStatus"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketMetricsConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?metrics"},"input":{"type":"structure","required":["Bucket","Id","MetricsConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Id":{"location":"querystring","locationName":"id"},"MetricsConfiguration":{"shape":"S6u","locationName":"MetricsConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"MetricsConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketNotification":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"NotificationConfiguration":{"shape":"S6z","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"NotificationConfiguration"},"deprecated":true,"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketNotificationConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?notification"},"input":{"type":"structure","required":["Bucket","NotificationConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"NotificationConfiguration":{"shape":"S7a","locationName":"NotificationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"SkipDestinationValidation":{"location":"header","locationName":"x-amz-skip-destination-validation","type":"boolean"}},"payload":"NotificationConfiguration"},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketOwnershipControls":{"http":{"method":"PUT","requestUri":"/{Bucket}?ownershipControls"},"input":{"type":"structure","required":["Bucket","OwnershipControls"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"OwnershipControls":{"shape":"S7r","locationName":"OwnershipControls","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}}},"payload":"OwnershipControls"},"httpChecksum":{"requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketPolicy":{"http":{"method":"PUT","requestUri":"/{Bucket}?policy"},"input":{"type":"structure","required":["Bucket","Policy"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ConfirmRemoveSelfBucketAccess":{"location":"header","locationName":"x-amz-confirm-remove-self-bucket-access","type":"boolean"},"Policy":{},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Policy"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketReplication":{"http":{"method":"PUT","requestUri":"/{Bucket}?replication"},"input":{"type":"structure","required":["Bucket","ReplicationConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ReplicationConfiguration":{"shape":"S83","locationName":"ReplicationConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"ReplicationConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketRequestPayment":{"http":{"method":"PUT","requestUri":"/{Bucket}?requestPayment"},"input":{"type":"structure","required":["Bucket","RequestPaymentConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"RequestPaymentConfiguration":{"locationName":"RequestPaymentConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Payer"],"members":{"Payer":{}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"RequestPaymentConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}?tagging"},"input":{"type":"structure","required":["Bucket","Tagging"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"Tagging":{"shape":"Sea","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Tagging"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketVersioning":{"http":{"method":"PUT","requestUri":"/{Bucket}?versioning"},"input":{"type":"structure","required":["Bucket","VersioningConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"MFA":{"location":"header","locationName":"x-amz-mfa"},"VersioningConfiguration":{"locationName":"VersioningConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"MFADelete":{"locationName":"MfaDelete"},"Status":{}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"VersioningConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutBucketWebsite":{"http":{"method":"PUT","requestUri":"/{Bucket}?website"},"input":{"type":"structure","required":["Bucket","WebsiteConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"WebsiteConfiguration":{"locationName":"WebsiteConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"ErrorDocument":{"shape":"S9b"},"IndexDocument":{"shape":"S99"},"RedirectAllRequestsTo":{"shape":"S96"},"RoutingRules":{"shape":"S9c"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"WebsiteConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"PutObject":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"Body":{"streaming":true,"type":"blob"},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"CacheControl":{"location":"header","locationName":"Cache-Control"},"ContentDisposition":{"location":"header","locationName":"Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ContentType":{"location":"header","locationName":"Content-Type"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"Expires":{"location":"header","locationName":"Expires","type":"timestamp"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"StorageClass":{"location":"header","locationName":"x-amz-storage-class"},"WebsiteRedirectLocation":{"location":"header","locationName":"x-amz-website-redirect-location"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Tagging":{"location":"header","locationName":"x-amz-tagging"},"ObjectLockMode":{"location":"header","locationName":"x-amz-object-lock-mode"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-object-lock-retain-until-date"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-object-lock-legal-hold"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Body"},"output":{"type":"structure","members":{"Expiration":{"location":"header","locationName":"x-amz-expiration"},"ETag":{"location":"header","locationName":"ETag"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"VersionId":{"location":"header","locationName":"x-amz-version-id"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"SSEKMSEncryptionContext":{"shape":"S1i","location":"header","locationName":"x-amz-server-side-encryption-context"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false}},"PutObjectAcl":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?acl"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"ACL":{"location":"header","locationName":"x-amz-acl"},"AccessControlPolicy":{"shape":"Sdk","locationName":"AccessControlPolicy","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"GrantFullControl":{"location":"header","locationName":"x-amz-grant-full-control"},"GrantRead":{"location":"header","locationName":"x-amz-grant-read"},"GrantReadACP":{"location":"header","locationName":"x-amz-grant-read-acp"},"GrantWrite":{"location":"header","locationName":"x-amz-grant-write"},"GrantWriteACP":{"location":"header","locationName":"x-amz-grant-write-acp"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"AccessControlPolicy"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectLegalHold":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?legal-hold"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"LegalHold":{"shape":"Sar","locationName":"LegalHold","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"LegalHold"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectLockConfiguration":{"http":{"method":"PUT","requestUri":"/{Bucket}?object-lock"},"input":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ObjectLockConfiguration":{"shape":"Sau","locationName":"ObjectLockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"Token":{"location":"header","locationName":"x-amz-bucket-object-lock-token"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"ObjectLockConfiguration"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectRetention":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?retention"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"Retention":{"shape":"Sb2","locationName":"Retention","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"VersionId":{"location":"querystring","locationName":"versionId"},"BypassGovernanceRetention":{"location":"header","locationName":"x-amz-bypass-governance-retention","type":"boolean"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Retention"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutObjectTagging":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}?tagging"},"input":{"type":"structure","required":["Bucket","Key","Tagging"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"Tagging":{"shape":"Sea","locationName":"Tagging","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"}},"payload":"Tagging"},"output":{"type":"structure","members":{"VersionId":{"location":"header","locationName":"x-amz-version-id"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true}},"PutPublicAccessBlock":{"http":{"method":"PUT","requestUri":"/{Bucket}?publicAccessBlock"},"input":{"type":"structure","required":["Bucket","PublicAccessBlockConfiguration"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"PublicAccessBlockConfiguration":{"shape":"Sb9","locationName":"PublicAccessBlockConfiguration","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"PublicAccessBlockConfiguration"},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":true},"staticContextParams":{"UseS3ExpressControlEndpoint":{"value":true}}},"RestoreObject":{"http":{"requestUri":"/{Bucket}/{Key+}?restore"},"input":{"type":"structure","required":["Bucket","Key"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"VersionId":{"location":"querystring","locationName":"versionId"},"RestoreRequest":{"locationName":"RestoreRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","members":{"Days":{"type":"integer"},"GlacierJobParameters":{"type":"structure","required":["Tier"],"members":{"Tier":{}}},"Type":{},"Tier":{},"Description":{},"SelectParameters":{"type":"structure","required":["InputSerialization","ExpressionType","Expression","OutputSerialization"],"members":{"InputSerialization":{"shape":"Sf0"},"ExpressionType":{},"Expression":{},"OutputSerialization":{"shape":"Sff"}}},"OutputLocation":{"type":"structure","members":{"S3":{"type":"structure","required":["BucketName","Prefix"],"members":{"BucketName":{},"Prefix":{},"Encryption":{"type":"structure","required":["EncryptionType"],"members":{"EncryptionType":{},"KMSKeyId":{"shape":"Sr"},"KMSContext":{}}},"CannedACL":{},"AccessControlList":{"shape":"S3t"},"Tagging":{"shape":"Sea"},"UserMetadata":{"type":"list","member":{"locationName":"MetadataEntry","type":"structure","members":{"Name":{},"Value":{}}}},"StorageClass":{}}}}}}},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"RestoreRequest"},"output":{"type":"structure","members":{"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"},"RestoreOutputPath":{"location":"header","locationName":"x-amz-restore-output-path"}}},"alias":"PostObjectRestore","httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false}},"SelectObjectContent":{"http":{"requestUri":"/{Bucket}/{Key+}?select&select-type=2"},"input":{"locationName":"SelectObjectContentRequest","xmlNamespace":{"uri":"http://s3.amazonaws.com/doc/2006-03-01/"},"type":"structure","required":["Bucket","Key","Expression","ExpressionType","InputSerialization","OutputSerialization"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"Key":{"location":"uri","locationName":"Key"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"Expression":{},"ExpressionType":{},"RequestProgress":{"type":"structure","members":{"Enabled":{"type":"boolean"}}},"InputSerialization":{"shape":"Sf0"},"OutputSerialization":{"shape":"Sff"},"ScanRange":{"type":"structure","members":{"Start":{"type":"long"},"End":{"type":"long"}}},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"output":{"type":"structure","members":{"Payload":{"type":"structure","members":{"Records":{"type":"structure","members":{"Payload":{"eventpayload":true,"type":"blob"}},"event":true},"Stats":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Progress":{"type":"structure","members":{"Details":{"eventpayload":true,"type":"structure","members":{"BytesScanned":{"type":"long"},"BytesProcessed":{"type":"long"},"BytesReturned":{"type":"long"}}}},"event":true},"Cont":{"type":"structure","members":{},"event":true},"End":{"type":"structure","members":{},"event":true}},"eventstream":true}},"payload":"Payload"}},"UploadPart":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","Key","PartNumber","UploadId"],"members":{"Body":{"streaming":true,"type":"blob"},"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentMD5":{"location":"header","locationName":"Content-MD5"},"ChecksumAlgorithm":{"location":"header","locationName":"x-amz-sdk-checksum-algorithm"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"Key":{"contextParam":{"name":"Key"},"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}},"payload":"Body"},"output":{"type":"structure","members":{"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"ETag":{"location":"header","locationName":"ETag"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-checksum-sha256"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}}},"httpChecksum":{"requestAlgorithmMember":"ChecksumAlgorithm","requestChecksumRequired":false}},"UploadPartCopy":{"http":{"method":"PUT","requestUri":"/{Bucket}/{Key+}"},"input":{"type":"structure","required":["Bucket","CopySource","Key","PartNumber","UploadId"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"CopySource":{"location":"header","locationName":"x-amz-copy-source"},"CopySourceIfMatch":{"location":"header","locationName":"x-amz-copy-source-if-match"},"CopySourceIfModifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-modified-since","type":"timestamp"},"CopySourceIfNoneMatch":{"location":"header","locationName":"x-amz-copy-source-if-none-match"},"CopySourceIfUnmodifiedSince":{"location":"header","locationName":"x-amz-copy-source-if-unmodified-since","type":"timestamp"},"CopySourceRange":{"location":"header","locationName":"x-amz-copy-source-range"},"Key":{"location":"uri","locationName":"Key"},"PartNumber":{"location":"querystring","locationName":"partNumber","type":"integer"},"UploadId":{"location":"querystring","locationName":"uploadId"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKey":{"shape":"Sk","location":"header","locationName":"x-amz-server-side-encryption-customer-key"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"CopySourceSSECustomerAlgorithm":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-algorithm"},"CopySourceSSECustomerKey":{"shape":"S1k","location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key"},"CopySourceSSECustomerKeyMD5":{"location":"header","locationName":"x-amz-copy-source-server-side-encryption-customer-key-MD5"},"RequestPayer":{"location":"header","locationName":"x-amz-request-payer"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"},"ExpectedSourceBucketOwner":{"location":"header","locationName":"x-amz-source-expected-bucket-owner"}}},"output":{"type":"structure","members":{"CopySourceVersionId":{"location":"header","locationName":"x-amz-copy-source-version-id"},"CopyPartResult":{"type":"structure","members":{"ETag":{},"LastModified":{"type":"timestamp"},"ChecksumCRC32":{},"ChecksumCRC32C":{},"ChecksumSHA1":{},"ChecksumSHA256":{}}},"ServerSideEncryption":{"location":"header","locationName":"x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-server-side-encryption-customer-algorithm"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-server-side-encryption-customer-key-MD5"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-server-side-encryption-aws-kms-key-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"},"RequestCharged":{"location":"header","locationName":"x-amz-request-charged"}},"payload":"CopyPartResult"},"staticContextParams":{"DisableS3ExpressSessionAuth":{"value":true}}},"WriteGetObjectResponse":{"http":{"requestUri":"/WriteGetObjectResponse"},"input":{"type":"structure","required":["RequestRoute","RequestToken"],"members":{"RequestRoute":{"hostLabel":true,"location":"header","locationName":"x-amz-request-route"},"RequestToken":{"location":"header","locationName":"x-amz-request-token"},"Body":{"streaming":true,"type":"blob"},"StatusCode":{"location":"header","locationName":"x-amz-fwd-status","type":"integer"},"ErrorCode":{"location":"header","locationName":"x-amz-fwd-error-code"},"ErrorMessage":{"location":"header","locationName":"x-amz-fwd-error-message"},"AcceptRanges":{"location":"header","locationName":"x-amz-fwd-header-accept-ranges"},"CacheControl":{"location":"header","locationName":"x-amz-fwd-header-Cache-Control"},"ContentDisposition":{"location":"header","locationName":"x-amz-fwd-header-Content-Disposition"},"ContentEncoding":{"location":"header","locationName":"x-amz-fwd-header-Content-Encoding"},"ContentLanguage":{"location":"header","locationName":"x-amz-fwd-header-Content-Language"},"ContentLength":{"location":"header","locationName":"Content-Length","type":"long"},"ContentRange":{"location":"header","locationName":"x-amz-fwd-header-Content-Range"},"ContentType":{"location":"header","locationName":"x-amz-fwd-header-Content-Type"},"ChecksumCRC32":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-crc32"},"ChecksumCRC32C":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-crc32c"},"ChecksumSHA1":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-sha1"},"ChecksumSHA256":{"location":"header","locationName":"x-amz-fwd-header-x-amz-checksum-sha256"},"DeleteMarker":{"location":"header","locationName":"x-amz-fwd-header-x-amz-delete-marker","type":"boolean"},"ETag":{"location":"header","locationName":"x-amz-fwd-header-ETag"},"Expires":{"location":"header","locationName":"x-amz-fwd-header-Expires","type":"timestamp"},"Expiration":{"location":"header","locationName":"x-amz-fwd-header-x-amz-expiration"},"LastModified":{"location":"header","locationName":"x-amz-fwd-header-Last-Modified","type":"timestamp"},"MissingMeta":{"location":"header","locationName":"x-amz-fwd-header-x-amz-missing-meta","type":"integer"},"Metadata":{"shape":"S1b","location":"headers","locationName":"x-amz-meta-"},"ObjectLockMode":{"location":"header","locationName":"x-amz-fwd-header-x-amz-object-lock-mode"},"ObjectLockLegalHoldStatus":{"location":"header","locationName":"x-amz-fwd-header-x-amz-object-lock-legal-hold"},"ObjectLockRetainUntilDate":{"shape":"S1o","location":"header","locationName":"x-amz-fwd-header-x-amz-object-lock-retain-until-date"},"PartsCount":{"location":"header","locationName":"x-amz-fwd-header-x-amz-mp-parts-count","type":"integer"},"ReplicationStatus":{"location":"header","locationName":"x-amz-fwd-header-x-amz-replication-status"},"RequestCharged":{"location":"header","locationName":"x-amz-fwd-header-x-amz-request-charged"},"Restore":{"location":"header","locationName":"x-amz-fwd-header-x-amz-restore"},"ServerSideEncryption":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption"},"SSECustomerAlgorithm":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-customer-algorithm"},"SSEKMSKeyId":{"shape":"Sr","location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-aws-kms-key-id"},"SSECustomerKeyMD5":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-customer-key-MD5"},"StorageClass":{"location":"header","locationName":"x-amz-fwd-header-x-amz-storage-class"},"TagCount":{"location":"header","locationName":"x-amz-fwd-header-x-amz-tagging-count","type":"integer"},"VersionId":{"location":"header","locationName":"x-amz-fwd-header-x-amz-version-id"},"BucketKeyEnabled":{"location":"header","locationName":"x-amz-fwd-header-x-amz-server-side-encryption-bucket-key-enabled","type":"boolean"}},"payload":"Body"},"authtype":"v4-unsigned-body","endpoint":{"hostPrefix":"{RequestRoute}."},"staticContextParams":{"UseObjectLambdaEndpoint":{"value":true}}}},"shapes":{"Sk":{"type":"blob","sensitive":true},"Sr":{"type":"string","sensitive":true},"S1b":{"type":"map","key":{},"value":{}},"S1i":{"type":"string","sensitive":true},"S1k":{"type":"blob","sensitive":true},"S1o":{"type":"timestamp","timestampFormat":"iso8601"},"S2h":{"type":"string","sensitive":true},"S3q":{"type":"structure","members":{"DisplayName":{},"ID":{}}},"S3t":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S3v"},"Permission":{}}}},"S3v":{"type":"structure","required":["Type"],"members":{"DisplayName":{},"EmailAddress":{},"ID":{},"Type":{"locationName":"xsi:type","xmlAttribute":true},"URI":{}},"xmlNamespace":{"prefix":"xsi","uri":"http://www.w3.org/2001/XMLSchema-instance"}},"S42":{"type":"structure","required":["Id","StorageClassAnalysis"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S45"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S48","flattened":true,"locationName":"Tag"}}}}},"StorageClassAnalysis":{"type":"structure","members":{"DataExport":{"type":"structure","required":["OutputSchemaVersion","Destination"],"members":{"OutputSchemaVersion":{},"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Format","Bucket"],"members":{"Format":{},"BucketAccountId":{},"Bucket":{},"Prefix":{}}}}}}}}}}},"S45":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S48":{"type":"list","member":{"shape":"S45","locationName":"Tag"}},"S4h":{"type":"list","member":{"type":"structure","required":["AllowedMethods","AllowedOrigins"],"members":{"ID":{},"AllowedHeaders":{"locationName":"AllowedHeader","type":"list","member":{},"flattened":true},"AllowedMethods":{"locationName":"AllowedMethod","type":"list","member":{},"flattened":true},"AllowedOrigins":{"locationName":"AllowedOrigin","type":"list","member":{},"flattened":true},"ExposeHeaders":{"locationName":"ExposeHeader","type":"list","member":{},"flattened":true},"MaxAgeSeconds":{"type":"integer"}}},"flattened":true},"S4u":{"type":"structure","required":["Rules"],"members":{"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","members":{"ApplyServerSideEncryptionByDefault":{"type":"structure","required":["SSEAlgorithm"],"members":{"SSEAlgorithm":{},"KMSMasterKeyID":{"shape":"Sr"}}},"BucketKeyEnabled":{"type":"boolean"}}},"flattened":true}}},"S50":{"type":"structure","required":["Id","Status","Tierings"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S45"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S48","flattened":true,"locationName":"Tag"}}}}},"Status":{},"Tierings":{"locationName":"Tiering","type":"list","member":{"type":"structure","required":["Days","AccessTier"],"members":{"Days":{"type":"integer"},"AccessTier":{}}},"flattened":true}}},"S5a":{"type":"structure","required":["Destination","IsEnabled","Id","IncludedObjectVersions","Schedule"],"members":{"Destination":{"type":"structure","required":["S3BucketDestination"],"members":{"S3BucketDestination":{"type":"structure","required":["Bucket","Format"],"members":{"AccountId":{},"Bucket":{},"Format":{},"Prefix":{},"Encryption":{"type":"structure","members":{"SSES3":{"locationName":"SSE-S3","type":"structure","members":{}},"SSEKMS":{"locationName":"SSE-KMS","type":"structure","required":["KeyId"],"members":{"KeyId":{"shape":"Sr"}}}}}}}}},"IsEnabled":{"type":"boolean"},"Filter":{"type":"structure","required":["Prefix"],"members":{"Prefix":{}}},"Id":{},"IncludedObjectVersions":{},"OptionalFields":{"type":"list","member":{"locationName":"Field"}},"Schedule":{"type":"structure","required":["Frequency"],"members":{"Frequency":{}}}}},"S5q":{"type":"list","member":{"type":"structure","required":["Prefix","Status"],"members":{"Expiration":{"shape":"S5s"},"ID":{},"Prefix":{},"Status":{},"Transition":{"shape":"S5x"},"NoncurrentVersionTransition":{"shape":"S5z"},"NoncurrentVersionExpiration":{"shape":"S61"},"AbortIncompleteMultipartUpload":{"shape":"S62"}}},"flattened":true},"S5s":{"type":"structure","members":{"Date":{"shape":"S5t"},"Days":{"type":"integer"},"ExpiredObjectDeleteMarker":{"type":"boolean"}}},"S5t":{"type":"timestamp","timestampFormat":"iso8601"},"S5x":{"type":"structure","members":{"Date":{"shape":"S5t"},"Days":{"type":"integer"},"StorageClass":{}}},"S5z":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"StorageClass":{},"NewerNoncurrentVersions":{"type":"integer"}}},"S61":{"type":"structure","members":{"NoncurrentDays":{"type":"integer"},"NewerNoncurrentVersions":{"type":"integer"}}},"S62":{"type":"structure","members":{"DaysAfterInitiation":{"type":"integer"}}},"S66":{"type":"list","member":{"type":"structure","required":["Status"],"members":{"Expiration":{"shape":"S5s"},"ID":{},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S45"},"ObjectSizeGreaterThan":{"type":"long"},"ObjectSizeLessThan":{"type":"long"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S48","flattened":true,"locationName":"Tag"},"ObjectSizeGreaterThan":{"type":"long"},"ObjectSizeLessThan":{"type":"long"}}}}},"Status":{},"Transitions":{"locationName":"Transition","type":"list","member":{"shape":"S5x"},"flattened":true},"NoncurrentVersionTransitions":{"locationName":"NoncurrentVersionTransition","type":"list","member":{"shape":"S5z"},"flattened":true},"NoncurrentVersionExpiration":{"shape":"S61"},"AbortIncompleteMultipartUpload":{"shape":"S62"}}},"flattened":true},"S6i":{"type":"structure","required":["TargetBucket","TargetPrefix"],"members":{"TargetBucket":{},"TargetGrants":{"type":"list","member":{"locationName":"Grant","type":"structure","members":{"Grantee":{"shape":"S3v"},"Permission":{}}}},"TargetPrefix":{},"TargetObjectKeyFormat":{"type":"structure","members":{"SimplePrefix":{"locationName":"SimplePrefix","type":"structure","members":{}},"PartitionedPrefix":{"locationName":"PartitionedPrefix","type":"structure","members":{"PartitionDateSource":{}}}}}}},"S6u":{"type":"structure","required":["Id"],"members":{"Id":{},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S45"},"AccessPointArn":{},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S48","flattened":true,"locationName":"Tag"},"AccessPointArn":{}}}}}}},"S6y":{"type":"structure","required":["Bucket"],"members":{"Bucket":{"contextParam":{"name":"Bucket"},"location":"uri","locationName":"Bucket"},"ExpectedBucketOwner":{"location":"header","locationName":"x-amz-expected-bucket-owner"}}},"S6z":{"type":"structure","members":{"TopicConfiguration":{"type":"structure","members":{"Id":{},"Events":{"shape":"S72","locationName":"Event"},"Event":{"deprecated":true},"Topic":{}}},"QueueConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S72","locationName":"Event"},"Queue":{}}},"CloudFunctionConfiguration":{"type":"structure","members":{"Id":{},"Event":{"deprecated":true},"Events":{"shape":"S72","locationName":"Event"},"CloudFunction":{},"InvocationRole":{}}}}},"S72":{"type":"list","member":{},"flattened":true},"S7a":{"type":"structure","members":{"TopicConfigurations":{"locationName":"TopicConfiguration","type":"list","member":{"type":"structure","required":["TopicArn","Events"],"members":{"Id":{},"TopicArn":{"locationName":"Topic"},"Events":{"shape":"S72","locationName":"Event"},"Filter":{"shape":"S7d"}}},"flattened":true},"QueueConfigurations":{"locationName":"QueueConfiguration","type":"list","member":{"type":"structure","required":["QueueArn","Events"],"members":{"Id":{},"QueueArn":{"locationName":"Queue"},"Events":{"shape":"S72","locationName":"Event"},"Filter":{"shape":"S7d"}}},"flattened":true},"LambdaFunctionConfigurations":{"locationName":"CloudFunctionConfiguration","type":"list","member":{"type":"structure","required":["LambdaFunctionArn","Events"],"members":{"Id":{},"LambdaFunctionArn":{"locationName":"CloudFunction"},"Events":{"shape":"S72","locationName":"Event"},"Filter":{"shape":"S7d"}}},"flattened":true},"EventBridgeConfiguration":{"type":"structure","members":{}}}},"S7d":{"type":"structure","members":{"Key":{"locationName":"S3Key","type":"structure","members":{"FilterRules":{"locationName":"FilterRule","type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}},"flattened":true}}}}},"S7r":{"type":"structure","required":["Rules"],"members":{"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["ObjectOwnership"],"members":{"ObjectOwnership":{}}},"flattened":true}}},"S83":{"type":"structure","required":["Role","Rules"],"members":{"Role":{},"Rules":{"locationName":"Rule","type":"list","member":{"type":"structure","required":["Status","Destination"],"members":{"ID":{},"Priority":{"type":"integer"},"Prefix":{"deprecated":true},"Filter":{"type":"structure","members":{"Prefix":{},"Tag":{"shape":"S45"},"And":{"type":"structure","members":{"Prefix":{},"Tags":{"shape":"S48","flattened":true,"locationName":"Tag"}}}}},"Status":{},"SourceSelectionCriteria":{"type":"structure","members":{"SseKmsEncryptedObjects":{"type":"structure","required":["Status"],"members":{"Status":{}}},"ReplicaModifications":{"type":"structure","required":["Status"],"members":{"Status":{}}}}},"ExistingObjectReplication":{"type":"structure","required":["Status"],"members":{"Status":{}}},"Destination":{"type":"structure","required":["Bucket"],"members":{"Bucket":{},"Account":{},"StorageClass":{},"AccessControlTranslation":{"type":"structure","required":["Owner"],"members":{"Owner":{}}},"EncryptionConfiguration":{"type":"structure","members":{"ReplicaKmsKeyID":{}}},"ReplicationTime":{"type":"structure","required":["Status","Time"],"members":{"Status":{},"Time":{"shape":"S8p"}}},"Metrics":{"type":"structure","required":["Status"],"members":{"Status":{},"EventThreshold":{"shape":"S8p"}}}}},"DeleteMarkerReplication":{"type":"structure","members":{"Status":{}}}}},"flattened":true}}},"S8p":{"type":"structure","members":{"Minutes":{"type":"integer"}}},"S96":{"type":"structure","required":["HostName"],"members":{"HostName":{},"Protocol":{}}},"S99":{"type":"structure","required":["Suffix"],"members":{"Suffix":{}}},"S9b":{"type":"structure","required":["Key"],"members":{"Key":{}}},"S9c":{"type":"list","member":{"locationName":"RoutingRule","type":"structure","required":["Redirect"],"members":{"Condition":{"type":"structure","members":{"HttpErrorCodeReturnedEquals":{},"KeyPrefixEquals":{}}},"Redirect":{"type":"structure","members":{"HostName":{},"HttpRedirectCode":{},"Protocol":{},"ReplaceKeyPrefixWith":{},"ReplaceKeyWith":{}}}}}},"Sar":{"type":"structure","members":{"Status":{}}},"Sau":{"type":"structure","members":{"ObjectLockEnabled":{},"Rule":{"type":"structure","members":{"DefaultRetention":{"type":"structure","members":{"Mode":{},"Days":{"type":"integer"},"Years":{"type":"integer"}}}}}}},"Sb2":{"type":"structure","members":{"Mode":{},"RetainUntilDate":{"shape":"S5t"}}},"Sb9":{"type":"structure","members":{"BlockPublicAcls":{"locationName":"BlockPublicAcls","type":"boolean"},"IgnorePublicAcls":{"locationName":"IgnorePublicAcls","type":"boolean"},"BlockPublicPolicy":{"locationName":"BlockPublicPolicy","type":"boolean"},"RestrictPublicBuckets":{"locationName":"RestrictPublicBuckets","type":"boolean"}}},"Sby":{"type":"list","member":{"locationName":"Bucket","type":"structure","members":{"Name":{},"CreationDate":{"type":"timestamp"}}}},"Sch":{"type":"structure","members":{"ID":{},"DisplayName":{}}},"Sci":{"type":"list","member":{"type":"structure","members":{"Prefix":{}}},"flattened":true},"Scn":{"type":"list","member":{}},"Sct":{"type":"list","member":{},"flattened":true},"Scw":{"type":"structure","members":{"IsRestoreInProgress":{"type":"boolean"},"RestoreExpiryDate":{"type":"timestamp"}}},"Sd5":{"type":"list","member":{"type":"structure","members":{"Key":{},"LastModified":{"type":"timestamp"},"ETag":{},"ChecksumAlgorithm":{"shape":"Sct"},"Size":{"type":"long"},"StorageClass":{},"Owner":{"shape":"S3q"},"RestoreStatus":{"shape":"Scw"}}},"flattened":true},"Sdk":{"type":"structure","members":{"Grants":{"shape":"S3t","locationName":"AccessControlList"},"Owner":{"shape":"S3q"}}},"Sea":{"type":"structure","required":["TagSet"],"members":{"TagSet":{"shape":"S48"}}},"Sf0":{"type":"structure","members":{"CSV":{"type":"structure","members":{"FileHeaderInfo":{},"Comments":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{},"AllowQuotedRecordDelimiter":{"type":"boolean"}}},"CompressionType":{},"JSON":{"type":"structure","members":{"Type":{}}},"Parquet":{"type":"structure","members":{}}}},"Sff":{"type":"structure","members":{"CSV":{"type":"structure","members":{"QuoteFields":{},"QuoteEscapeCharacter":{},"RecordDelimiter":{},"FieldDelimiter":{},"QuoteCharacter":{}}},"JSON":{"type":"structure","members":{"RecordDelimiter":{}}}}}},"clientContextParams":{"Accelerate":{"documentation":"Enables this client to use S3 Transfer Acceleration endpoints.","type":"boolean"},"DisableMultiRegionAccessPoints":{"documentation":"Disables this client's usage of Multi-Region Access Points.","type":"boolean"},"DisableS3ExpressSessionAuth":{"documentation":"Disables this client's usage of Session Auth for S3Express\n      buckets and reverts to using conventional SigV4 for those.","type":"boolean"},"ForcePathStyle":{"documentation":"Forces this client to use path-style addressing for buckets.","type":"boolean"},"UseArnRegion":{"documentation":"Enables this client to use an ARN's region when constructing an endpoint instead of the client's configured region.","type":"boolean"}}}

/***/ }),
/* 611 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListBuckets":{"result_key":"Buckets"},"ListDirectoryBuckets":{"input_token":"ContinuationToken","limit_key":"MaxDirectoryBuckets","output_token":"ContinuationToken","result_key":"Buckets"},"ListMultipartUploads":{"input_token":["KeyMarker","UploadIdMarker"],"limit_key":"MaxUploads","more_results":"IsTruncated","output_token":["NextKeyMarker","NextUploadIdMarker"],"result_key":["Uploads","CommonPrefixes"]},"ListObjectVersions":{"input_token":["KeyMarker","VersionIdMarker"],"limit_key":"MaxKeys","more_results":"IsTruncated","output_token":["NextKeyMarker","NextVersionIdMarker"],"result_key":["Versions","DeleteMarkers","CommonPrefixes"]},"ListObjects":{"input_token":"Marker","limit_key":"MaxKeys","more_results":"IsTruncated","output_token":"NextMarker || Contents[-1].Key","result_key":["Contents","CommonPrefixes"]},"ListObjectsV2":{"input_token":"ContinuationToken","limit_key":"MaxKeys","output_token":"NextContinuationToken","result_key":["Contents","CommonPrefixes"]},"ListParts":{"input_token":"PartNumberMarker","limit_key":"MaxParts","more_results":"IsTruncated","output_token":"NextPartNumberMarker","result_key":"Parts"}}}

/***/ }),
/* 612 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"BucketExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":301,"matcher":"status","state":"success"},{"expected":403,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"BucketNotExists":{"delay":5,"operation":"HeadBucket","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]},"ObjectExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":200,"matcher":"status","state":"success"},{"expected":404,"matcher":"status","state":"retry"}]},"ObjectNotExists":{"delay":5,"operation":"HeadObject","maxAttempts":20,"acceptors":[{"expected":404,"matcher":"status","state":"success"}]}}}

/***/ }),
/* 613 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-10-17","endpointPrefix":"secretsmanager","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceFullName":"AWS Secrets Manager","serviceId":"Secrets Manager","signatureVersion":"v4","signingName":"secretsmanager","targetPrefix":"secretsmanager","uid":"secretsmanager-2017-10-17"},"operations":{"BatchGetSecretValue":{"input":{"type":"structure","members":{"SecretIdList":{"type":"list","member":{}},"Filters":{"shape":"S4"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"SecretValues":{"type":"list","member":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"SecretBinary":{"shape":"Sh"},"SecretString":{"shape":"Si"},"VersionStages":{"shape":"Sj"},"CreatedDate":{"type":"timestamp"}}}},"NextToken":{},"Errors":{"type":"list","member":{"type":"structure","members":{"SecretId":{},"ErrorCode":{},"Message":{}}}}}}},"CancelRotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"CreateSecret":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sh"},"SecretString":{"shape":"Si"},"Tags":{"shape":"Sx"},"AddReplicaRegions":{"shape":"S11"},"ForceOverwriteReplicaSecret":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"ReplicationStatus":{"shape":"S16"}}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"DeleteSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"RecoveryWindowInDays":{"type":"long"},"ForceDeleteWithoutRecovery":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"DeletionDate":{"type":"timestamp"}}}},"DescribeSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"S1l"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"NextRotationDate":{"type":"timestamp"},"Tags":{"shape":"Sx"},"VersionIdsToStages":{"shape":"S1t"},"OwningService":{},"CreatedDate":{"type":"timestamp"},"PrimaryRegion":{},"ReplicationStatus":{"shape":"S16"}}}},"GetRandomPassword":{"input":{"type":"structure","members":{"PasswordLength":{"type":"long"},"ExcludeCharacters":{},"ExcludeNumbers":{"type":"boolean"},"ExcludePunctuation":{"type":"boolean"},"ExcludeUppercase":{"type":"boolean"},"ExcludeLowercase":{"type":"boolean"},"IncludeSpace":{"type":"boolean"},"RequireEachIncludedType":{"type":"boolean"}}},"output":{"type":"structure","members":{"RandomPassword":{"type":"string","sensitive":true}}}},"GetResourcePolicy":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"ResourcePolicy":{}}}},"GetSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"VersionId":{},"VersionStage":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"SecretBinary":{"shape":"Sh"},"SecretString":{"shape":"Si"},"VersionStages":{"shape":"Sj"},"CreatedDate":{"type":"timestamp"}}}},"ListSecretVersionIds":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"MaxResults":{"type":"integer"},"NextToken":{},"IncludeDeprecated":{"type":"boolean"}}},"output":{"type":"structure","members":{"Versions":{"type":"list","member":{"type":"structure","members":{"VersionId":{},"VersionStages":{"shape":"Sj"},"LastAccessedDate":{"type":"timestamp"},"CreatedDate":{"type":"timestamp"},"KmsKeyIds":{"type":"list","member":{}}}}},"NextToken":{},"ARN":{},"Name":{}}}},"ListSecrets":{"input":{"type":"structure","members":{"IncludePlannedDeletion":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"S4"},"SortOrder":{}}},"output":{"type":"structure","members":{"SecretList":{"type":"list","member":{"type":"structure","members":{"ARN":{},"Name":{},"Description":{},"KmsKeyId":{},"RotationEnabled":{"type":"boolean"},"RotationLambdaARN":{},"RotationRules":{"shape":"S1l"},"LastRotatedDate":{"type":"timestamp"},"LastChangedDate":{"type":"timestamp"},"LastAccessedDate":{"type":"timestamp"},"DeletedDate":{"type":"timestamp"},"NextRotationDate":{"type":"timestamp"},"Tags":{"shape":"Sx"},"SecretVersionsToStages":{"shape":"S1t"},"OwningService":{},"CreatedDate":{"type":"timestamp"},"PrimaryRegion":{}}}},"NextToken":{}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["SecretId","ResourcePolicy"],"members":{"SecretId":{},"ResourcePolicy":{},"BlockPublicPolicy":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"PutSecretValue":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"SecretBinary":{"shape":"Sh"},"SecretString":{"shape":"Si"},"VersionStages":{"shape":"Sj"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{},"VersionStages":{"shape":"Sj"}}}},"RemoveRegionsFromReplication":{"input":{"type":"structure","required":["SecretId","RemoveReplicaRegions"],"members":{"SecretId":{},"RemoveReplicaRegions":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ARN":{},"ReplicationStatus":{"shape":"S16"}}}},"ReplicateSecretToRegions":{"input":{"type":"structure","required":["SecretId","AddReplicaRegions"],"members":{"SecretId":{},"AddReplicaRegions":{"shape":"S11"},"ForceOverwriteReplicaSecret":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"ReplicationStatus":{"shape":"S16"}}}},"RestoreSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"RotateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"RotationLambdaARN":{},"RotationRules":{"shape":"S1l"},"RotateImmediately":{"type":"boolean"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"StopReplicationToReplica":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{}}},"output":{"type":"structure","members":{"ARN":{}}}},"TagResource":{"input":{"type":"structure","required":["SecretId","Tags"],"members":{"SecretId":{},"Tags":{"shape":"Sx"}}}},"UntagResource":{"input":{"type":"structure","required":["SecretId","TagKeys"],"members":{"SecretId":{},"TagKeys":{"type":"list","member":{}}}}},"UpdateSecret":{"input":{"type":"structure","required":["SecretId"],"members":{"SecretId":{},"ClientRequestToken":{"idempotencyToken":true},"Description":{},"KmsKeyId":{},"SecretBinary":{"shape":"Sh"},"SecretString":{"shape":"Si"}}},"output":{"type":"structure","members":{"ARN":{},"Name":{},"VersionId":{}}}},"UpdateSecretVersionStage":{"input":{"type":"structure","required":["SecretId","VersionStage"],"members":{"SecretId":{},"VersionStage":{},"RemoveFromVersionId":{},"MoveToVersionId":{}}},"output":{"type":"structure","members":{"ARN":{},"Name":{}}}},"ValidateResourcePolicy":{"input":{"type":"structure","required":["ResourcePolicy"],"members":{"SecretId":{},"ResourcePolicy":{}}},"output":{"type":"structure","members":{"PolicyValidationPassed":{"type":"boolean"},"ValidationErrors":{"type":"list","member":{"type":"structure","members":{"CheckName":{},"ErrorMessage":{}}}}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"Sh":{"type":"blob","sensitive":true},"Si":{"type":"string","sensitive":true},"Sj":{"type":"list","member":{}},"Sx":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"S11":{"type":"list","member":{"type":"structure","members":{"Region":{},"KmsKeyId":{}}}},"S16":{"type":"list","member":{"type":"structure","members":{"Region":{},"KmsKeyId":{},"Status":{},"StatusMessage":{},"LastAccessedDate":{"type":"timestamp"}}}},"S1l":{"type":"structure","members":{"AutomaticallyAfterDays":{"type":"long"},"Duration":{},"ScheduleExpression":{}}},"S1t":{"type":"map","key":{},"value":{"shape":"Sj"}}}}

/***/ }),
/* 614 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetSecretValue":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSecretVersionIds":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"},"ListSecrets":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults"}}}

/***/ }),
/* 615 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-12-10","endpointPrefix":"servicecatalog","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Service Catalog","serviceId":"Service Catalog","signatureVersion":"v4","targetPrefix":"AWS242ServiceCatalogService","uid":"servicecatalog-2015-12-10"},"operations":{"AcceptPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"AssociateBudgetWithResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"AssociatePrincipalWithPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN","PrincipalType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{},"PrincipalType":{}}},"output":{"type":"structure","members":{}}},"AssociateProductWithPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{}}},"AssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"AssociateTagOptionWithResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"BatchAssociateServiceActionWithProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sn"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sq"}}}},"BatchDisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ServiceActionAssociations"],"members":{"ServiceActionAssociations":{"shape":"Sn"},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"FailedServiceActionAssociations":{"shape":"Sq"}}}},"CopyProduct":{"input":{"type":"structure","required":["SourceProductArn","IdempotencyToken"],"members":{"AcceptLanguage":{},"SourceProductArn":{},"TargetProductId":{},"TargetProductName":{},"SourceProvisioningArtifactIdentifiers":{"type":"list","member":{"type":"map","key":{},"value":{}}},"CopyOptions":{"type":"list","member":{}},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"CopyProductToken":{}}}},"CreateConstraint":{"input":{"type":"structure","required":["PortfolioId","ProductId","Parameters","Type","IdempotencyToken"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"Parameters":{},"Type":{},"Description":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"CreatePortfolio":{"input":{"type":"structure","required":["DisplayName","ProviderName","IdempotencyToken"],"members":{"AcceptLanguage":{},"DisplayName":{},"Description":{},"ProviderName":{},"Tags":{"shape":"S1i"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"CreatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"},"ShareTagOptions":{"type":"boolean"},"SharePrincipals":{"type":"boolean"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"CreateProduct":{"input":{"type":"structure","required":["Name","Owner","ProductType","IdempotencyToken"],"members":{"AcceptLanguage":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"ProductType":{},"Tags":{"shape":"S1i"},"ProvisioningArtifactParameters":{"shape":"S24"},"IdempotencyToken":{"idempotencyToken":true},"SourceConnection":{"shape":"S2c"}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2l"},"ProvisioningArtifactDetail":{"shape":"S2w"},"Tags":{"shape":"S1q"}}}},"CreateProvisionedProductPlan":{"input":{"type":"structure","required":["PlanName","PlanType","ProductId","ProvisionedProductName","ProvisioningArtifactId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanName":{},"PlanType":{},"NotificationArns":{"shape":"S33"},"PathId":{},"ProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{},"ProvisioningParameters":{"shape":"S36"},"IdempotencyToken":{"idempotencyToken":true},"Tags":{"shape":"S1q"}}},"output":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionedProductName":{},"ProvisioningArtifactId":{}}}},"CreateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","Parameters","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"Parameters":{"shape":"S24"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2w"},"Info":{"shape":"S27"},"Status":{}}}},"CreateServiceAction":{"input":{"type":"structure","required":["Name","DefinitionType","Definition","IdempotencyToken"],"members":{"Name":{},"DefinitionType":{},"Definition":{"shape":"S3h"},"Description":{},"AcceptLanguage":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S3m"}}}},"CreateTagOption":{"input":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3s"}}}},"DeleteConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeletePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{}}}},"DeleteProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{}}},"DeleteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"IgnoreErrors":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{}}},"output":{"type":"structure","members":{}}},"DeleteServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"DeleteTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{}}},"DescribeConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"DescribeCopyProductStatus":{"input":{"type":"structure","required":["CopyProductToken"],"members":{"AcceptLanguage":{},"CopyProductToken":{}}},"output":{"type":"structure","members":{"CopyProductStatus":{},"TargetProductId":{},"StatusDetail":{}}}},"DescribePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S4k"},"Budgets":{"shape":"S4l"}}}},"DescribePortfolioShareStatus":{"input":{"type":"structure","required":["PortfolioShareToken"],"members":{"PortfolioShareToken":{}}},"output":{"type":"structure","members":{"PortfolioShareToken":{},"PortfolioId":{},"OrganizationNodeValue":{},"Status":{},"ShareDetails":{"type":"structure","members":{"SuccessfulShares":{"type":"list","member":{}},"ShareErrors":{"type":"list","member":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Message":{},"Error":{}}}}}}}}},"DescribePortfolioShares":{"input":{"type":"structure","required":["PortfolioId","Type"],"members":{"PortfolioId":{},"Type":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"NextPageToken":{},"PortfolioShareDetails":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"Type":{},"Accepted":{"type":"boolean"},"ShareTagOptions":{"type":"boolean"},"SharePrincipals":{"type":"boolean"}}}}}}},"DescribeProduct":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2m"},"ProvisioningArtifacts":{"shape":"S56"},"Budgets":{"shape":"S4l"},"LaunchPaths":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}}}}},"DescribeProductAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{},"SourcePortfolioId":{}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2l"},"ProvisioningArtifactSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProvisioningArtifactMetadata":{"shape":"S27"}}}},"Tags":{"shape":"S1q"},"TagOptions":{"shape":"S4k"},"Budgets":{"shape":"S4l"}}}},"DescribeProductView":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{}}},"output":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2m"},"ProvisioningArtifacts":{"shape":"S56"}}}},"DescribeProvisionedProduct":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Id":{},"Name":{}}},"output":{"type":"structure","members":{"ProvisionedProductDetail":{"shape":"S5k"},"CloudWatchDashboards":{"type":"list","member":{"type":"structure","members":{"Name":{}}}}}}},"DescribeProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId"],"members":{"AcceptLanguage":{},"PlanId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProductPlanDetails":{"type":"structure","members":{"CreatedTime":{"type":"timestamp"},"PathId":{},"ProductId":{},"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{},"Status":{},"UpdatedTime":{"type":"timestamp"},"NotificationArns":{"shape":"S33"},"ProvisioningParameters":{"shape":"S36"},"Tags":{"shape":"S1q"},"StatusMessage":{}}},"ResourceChanges":{"type":"list","member":{"type":"structure","members":{"Action":{},"LogicalResourceId":{},"PhysicalResourceId":{},"ResourceType":{},"Replacement":{},"Scope":{"type":"list","member":{}},"Details":{"type":"list","member":{"type":"structure","members":{"Target":{"type":"structure","members":{"Attribute":{},"Name":{},"RequiresRecreation":{}}},"Evaluation":{},"CausingEntity":{}}}}}}},"NextPageToken":{}}}},"DescribeProvisioningArtifact":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisioningArtifactId":{},"ProductId":{},"ProvisioningArtifactName":{},"ProductName":{},"Verbose":{"type":"boolean"},"IncludeProvisioningArtifactParameters":{"type":"boolean"}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2w"},"Info":{"shape":"S27"},"Status":{},"ProvisioningArtifactParameters":{"shape":"S6l"}}}},"DescribeProvisioningParameters":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"PathId":{},"PathName":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactParameters":{"shape":"S6l"},"ConstraintSummaries":{"shape":"S6w"},"UsageInstructions":{"type":"list","member":{"type":"structure","members":{"Type":{},"Value":{}}}},"TagOptions":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ProvisioningArtifactPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S76"},"StackSetRegions":{"shape":"S77"}}},"ProvisioningArtifactOutputs":{"shape":"S79","deprecated":true,"deprecatedMessage":"This property is deprecated and returns the Id and Description of the Provisioning Artifact. Use ProvisioningArtifactOutputKeys instead to get the Keys and Descriptions of the outputs."},"ProvisioningArtifactOutputKeys":{"shape":"S79"}}}},"DescribeRecord":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S7f"},"RecordOutputs":{"shape":"S7q"},"NextPageToken":{}}}},"DescribeServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S3m"}}}},"DescribeServiceActionExecutionParameters":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionParameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"DefaultValues":{"shape":"S82"}}}}}}},"DescribeTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3s"}}}},"DisableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"DisassociateBudgetFromResource":{"input":{"type":"structure","required":["BudgetName","ResourceId"],"members":{"BudgetName":{},"ResourceId":{}}},"output":{"type":"structure","members":{}}},"DisassociatePrincipalFromPortfolio":{"input":{"type":"structure","required":["PortfolioId","PrincipalARN"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PrincipalARN":{},"PrincipalType":{}}},"output":{"type":"structure","members":{}}},"DisassociateProductFromPortfolio":{"input":{"type":"structure","required":["ProductId","PortfolioId"],"members":{"AcceptLanguage":{},"ProductId":{},"PortfolioId":{}}},"output":{"type":"structure","members":{}}},"DisassociateServiceActionFromProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ServiceActionId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"ServiceActionId":{},"AcceptLanguage":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"DisassociateTagOptionFromResource":{"input":{"type":"structure","required":["ResourceId","TagOptionId"],"members":{"ResourceId":{},"TagOptionId":{}}},"output":{"type":"structure","members":{}}},"EnableAWSOrganizationsAccess":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{}}},"ExecuteProvisionedProductPlan":{"input":{"type":"structure","required":["PlanId","IdempotencyToken"],"members":{"AcceptLanguage":{},"PlanId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S7f"}}}},"ExecuteProvisionedProductServiceAction":{"input":{"type":"structure","required":["ProvisionedProductId","ServiceActionId","ExecuteToken"],"members":{"ProvisionedProductId":{},"ServiceActionId":{},"ExecuteToken":{"idempotencyToken":true},"AcceptLanguage":{},"Parameters":{"type":"map","key":{},"value":{"shape":"S82"}}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S7f"}}}},"GetAWSOrganizationsAccessStatus":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"AccessStatus":{}}}},"GetProvisionedProductOutputs":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisionedProductId":{},"ProvisionedProductName":{},"OutputKeys":{"type":"list","member":{}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Outputs":{"shape":"S7q"},"NextPageToken":{}}}},"ImportAsProvisionedProduct":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId","ProvisionedProductName","PhysicalId","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"ProvisionedProductName":{},"PhysicalId":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S7f"}}}},"ListAcceptedPortfolioShares":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"},"PortfolioShareType":{}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S90"},"NextPageToken":{}}}},"ListBudgetsForResource":{"input":{"type":"structure","required":["ResourceId"],"members":{"AcceptLanguage":{},"ResourceId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Budgets":{"shape":"S4l"},"NextPageToken":{}}}},"ListConstraintsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ConstraintDetails":{"type":"list","member":{"shape":"S1b"}},"NextPageToken":{}}}},"ListLaunchPaths":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"LaunchPathSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"ConstraintSummaries":{"shape":"S6w"},"Tags":{"shape":"S1q"},"Name":{}}}},"NextPageToken":{}}}},"ListOrganizationPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId","OrganizationNodeType"],"members":{"AcceptLanguage":{},"PortfolioId":{},"OrganizationNodeType":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"OrganizationNodes":{"type":"list","member":{"shape":"S1s"}},"NextPageToken":{}}}},"ListPortfolioAccess":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"OrganizationParentId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"AccountIds":{"type":"list","member":{}},"NextPageToken":{}}}},"ListPortfolios":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S90"},"NextPageToken":{}}}},"ListPortfoliosForProduct":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"PortfolioDetails":{"shape":"S90"},"NextPageToken":{}}}},"ListPrincipalsForPortfolio":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"PrincipalARN":{},"PrincipalType":{}}}},"NextPageToken":{}}}},"ListProvisionedProductPlans":{"input":{"type":"structure","members":{"AcceptLanguage":{},"ProvisionProductId":{},"PageSize":{"type":"integer"},"PageToken":{},"AccessLevelFilter":{"shape":"S9p"}}},"output":{"type":"structure","members":{"ProvisionedProductPlans":{"type":"list","member":{"type":"structure","members":{"PlanName":{},"PlanId":{},"ProvisionProductId":{},"ProvisionProductName":{},"PlanType":{},"ProvisioningArtifactId":{}}}},"NextPageToken":{}}}},"ListProvisioningArtifacts":{"input":{"type":"structure","required":["ProductId"],"members":{"AcceptLanguage":{},"ProductId":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetails":{"type":"list","member":{"shape":"S2w"}},"NextPageToken":{}}}},"ListProvisioningArtifactsForServiceAction":{"input":{"type":"structure","required":["ServiceActionId"],"members":{"ServiceActionId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactViews":{"type":"list","member":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2m"},"ProvisioningArtifact":{"shape":"S57"}}}},"NextPageToken":{}}}},"ListRecordHistory":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S9p"},"SearchFilter":{"type":"structure","members":{"Key":{},"Value":{}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"RecordDetails":{"type":"list","member":{"shape":"S7f"}},"NextPageToken":{}}}},"ListResourcesForTagOption":{"input":{"type":"structure","required":["TagOptionId"],"members":{"TagOptionId":{},"ResourceType":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ResourceDetails":{"type":"list","member":{"type":"structure","members":{"Id":{},"ARN":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"}}}},"PageToken":{}}}},"ListServiceActions":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"Sak"},"NextPageToken":{}}}},"ListServiceActionsForProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"ProductId":{},"ProvisioningArtifactId":{},"PageSize":{"type":"integer"},"PageToken":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionSummaries":{"shape":"Sak"},"NextPageToken":{}}}},"ListStackInstancesForProvisionedProduct":{"input":{"type":"structure","required":["ProvisionedProductId"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"PageToken":{},"PageSize":{"type":"integer"}}},"output":{"type":"structure","members":{"StackInstances":{"type":"list","member":{"type":"structure","members":{"Account":{},"Region":{},"StackInstanceStatus":{}}}},"NextPageToken":{}}}},"ListTagOptions":{"input":{"type":"structure","members":{"Filters":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"}}},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"TagOptionDetails":{"shape":"S4k"},"PageToken":{}}}},"NotifyProvisionProductEngineWorkflowResult":{"input":{"type":"structure","required":["WorkflowToken","RecordId","Status","IdempotencyToken"],"members":{"WorkflowToken":{},"RecordId":{},"Status":{},"FailureReason":{},"ResourceIdentifier":{"type":"structure","members":{"UniqueTag":{"type":"structure","members":{"Key":{},"Value":{}}}}},"Outputs":{"shape":"S7q"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"NotifyTerminateProvisionedProductEngineWorkflowResult":{"input":{"type":"structure","required":["WorkflowToken","RecordId","Status","IdempotencyToken"],"members":{"WorkflowToken":{},"RecordId":{},"Status":{},"FailureReason":{},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"NotifyUpdateProvisionedProductEngineWorkflowResult":{"input":{"type":"structure","required":["WorkflowToken","RecordId","Status","IdempotencyToken"],"members":{"WorkflowToken":{},"RecordId":{},"Status":{},"FailureReason":{},"Outputs":{"shape":"S7q"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{}}},"ProvisionProduct":{"input":{"type":"structure","required":["ProvisionedProductName","ProvisionToken"],"members":{"AcceptLanguage":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"PathId":{},"PathName":{},"ProvisionedProductName":{},"ProvisioningParameters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S76"},"StackSetRegions":{"shape":"S77"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"}}},"Tags":{"shape":"S1q"},"NotificationArns":{"shape":"S33"},"ProvisionToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S7f"}}}},"RejectPortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"PortfolioShareType":{}}},"output":{"type":"structure","members":{}}},"ScanProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S9p"},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"shape":"S5k"}},"NextPageToken":{}}}},"SearchProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"Filters":{"shape":"Sbn"},"PageSize":{"type":"integer"},"SortBy":{},"SortOrder":{},"PageToken":{}}},"output":{"type":"structure","members":{"ProductViewSummaries":{"type":"list","member":{"shape":"S2m"}},"ProductViewAggregations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"Value":{},"ApproximateCount":{"type":"integer"}}}}},"NextPageToken":{}}}},"SearchProductsAsAdmin":{"input":{"type":"structure","members":{"AcceptLanguage":{},"PortfolioId":{},"Filters":{"shape":"Sbn"},"SortBy":{},"SortOrder":{},"PageToken":{},"PageSize":{"type":"integer"},"ProductSource":{}}},"output":{"type":"structure","members":{"ProductViewDetails":{"type":"list","member":{"shape":"S2l"}},"NextPageToken":{}}}},"SearchProvisionedProducts":{"input":{"type":"structure","members":{"AcceptLanguage":{},"AccessLevelFilter":{"shape":"S9p"},"Filters":{"type":"map","key":{},"value":{"type":"list","member":{}}},"SortBy":{},"SortOrder":{},"PageSize":{"type":"integer"},"PageToken":{}}},"output":{"type":"structure","members":{"ProvisionedProducts":{"type":"list","member":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"LastProvisioningRecordId":{},"LastSuccessfulProvisioningRecordId":{},"Tags":{"shape":"S1q"},"PhysicalId":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"UserArn":{},"UserArnSession":{}}}},"TotalResultsCount":{"type":"integer"},"NextPageToken":{}}}},"TerminateProvisionedProduct":{"input":{"type":"structure","required":["TerminateToken"],"members":{"ProvisionedProductName":{},"ProvisionedProductId":{},"TerminateToken":{"idempotencyToken":true},"IgnoreErrors":{"type":"boolean"},"AcceptLanguage":{},"RetainPhysicalResources":{"type":"boolean"}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S7f"}}}},"UpdateConstraint":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Description":{},"Parameters":{}}},"output":{"type":"structure","members":{"ConstraintDetail":{"shape":"S1b"},"ConstraintParameters":{},"Status":{}}}},"UpdatePortfolio":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"DisplayName":{},"Description":{},"ProviderName":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sco"}}},"output":{"type":"structure","members":{"PortfolioDetail":{"shape":"S1n"},"Tags":{"shape":"S1q"}}}},"UpdatePortfolioShare":{"input":{"type":"structure","required":["PortfolioId"],"members":{"AcceptLanguage":{},"PortfolioId":{},"AccountId":{},"OrganizationNode":{"shape":"S1s"},"ShareTagOptions":{"type":"boolean"},"SharePrincipals":{"type":"boolean"}}},"output":{"type":"structure","members":{"PortfolioShareToken":{},"Status":{}}}},"UpdateProduct":{"input":{"type":"structure","required":["Id"],"members":{"AcceptLanguage":{},"Id":{},"Name":{},"Owner":{},"Description":{},"Distributor":{},"SupportDescription":{},"SupportEmail":{},"SupportUrl":{},"AddTags":{"shape":"S1i"},"RemoveTags":{"shape":"Sco"},"SourceConnection":{"shape":"S2c"}}},"output":{"type":"structure","members":{"ProductViewDetail":{"shape":"S2l"},"Tags":{"shape":"S1q"}}}},"UpdateProvisionedProduct":{"input":{"type":"structure","required":["UpdateToken"],"members":{"AcceptLanguage":{},"ProvisionedProductName":{},"ProvisionedProductId":{},"ProductId":{},"ProductName":{},"ProvisioningArtifactId":{},"ProvisioningArtifactName":{},"PathId":{},"PathName":{},"ProvisioningParameters":{"shape":"S36"},"ProvisioningPreferences":{"type":"structure","members":{"StackSetAccounts":{"shape":"S76"},"StackSetRegions":{"shape":"S77"},"StackSetFailureToleranceCount":{"type":"integer"},"StackSetFailureTolerancePercentage":{"type":"integer"},"StackSetMaxConcurrencyCount":{"type":"integer"},"StackSetMaxConcurrencyPercentage":{"type":"integer"},"StackSetOperationType":{}}},"Tags":{"shape":"S1q"},"UpdateToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"RecordDetail":{"shape":"S7f"}}}},"UpdateProvisionedProductProperties":{"input":{"type":"structure","required":["ProvisionedProductId","ProvisionedProductProperties","IdempotencyToken"],"members":{"AcceptLanguage":{},"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sd0"},"IdempotencyToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"ProvisionedProductId":{},"ProvisionedProductProperties":{"shape":"Sd0"},"RecordId":{},"Status":{}}}},"UpdateProvisioningArtifact":{"input":{"type":"structure","required":["ProductId","ProvisioningArtifactId"],"members":{"AcceptLanguage":{},"ProductId":{},"ProvisioningArtifactId":{},"Name":{},"Description":{},"Active":{"type":"boolean"},"Guidance":{}}},"output":{"type":"structure","members":{"ProvisioningArtifactDetail":{"shape":"S2w"},"Info":{"shape":"S27"},"Status":{}}}},"UpdateServiceAction":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Name":{},"Definition":{"shape":"S3h"},"Description":{},"AcceptLanguage":{}}},"output":{"type":"structure","members":{"ServiceActionDetail":{"shape":"S3m"}}}},"UpdateTagOption":{"input":{"type":"structure","required":["Id"],"members":{"Id":{},"Value":{},"Active":{"type":"boolean"}}},"output":{"type":"structure","members":{"TagOptionDetail":{"shape":"S3s"}}}}},"shapes":{"Sn":{"type":"list","member":{"type":"structure","required":["ServiceActionId","ProductId","ProvisioningArtifactId"],"members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{}}}},"Sq":{"type":"list","member":{"type":"structure","members":{"ServiceActionId":{},"ProductId":{},"ProvisioningArtifactId":{},"ErrorCode":{},"ErrorMessage":{}}}},"S1b":{"type":"structure","members":{"ConstraintId":{},"Type":{},"Description":{},"Owner":{},"ProductId":{},"PortfolioId":{}}},"S1i":{"type":"list","member":{"shape":"S1j"}},"S1j":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}},"S1n":{"type":"structure","members":{"Id":{},"ARN":{},"DisplayName":{},"Description":{},"CreatedTime":{"type":"timestamp"},"ProviderName":{}}},"S1q":{"type":"list","member":{"shape":"S1j"}},"S1s":{"type":"structure","members":{"Type":{},"Value":{}}},"S24":{"type":"structure","members":{"Name":{},"Description":{},"Info":{"shape":"S27"},"Type":{},"DisableTemplateValidation":{"type":"boolean"}}},"S27":{"type":"map","key":{},"value":{}},"S2c":{"type":"structure","required":["ConnectionParameters"],"members":{"Type":{},"ConnectionParameters":{"shape":"S2e"}}},"S2e":{"type":"structure","members":{"CodeStar":{"type":"structure","required":["ConnectionArn","Repository","Branch","ArtifactPath"],"members":{"ConnectionArn":{},"Repository":{},"Branch":{},"ArtifactPath":{}}}}},"S2l":{"type":"structure","members":{"ProductViewSummary":{"shape":"S2m"},"Status":{},"ProductARN":{},"CreatedTime":{"type":"timestamp"},"SourceConnection":{"type":"structure","members":{"Type":{},"ConnectionParameters":{"shape":"S2e"},"LastSync":{"type":"structure","members":{"LastSyncTime":{"type":"timestamp"},"LastSyncStatus":{},"LastSyncStatusMessage":{},"LastSuccessfulSyncTime":{"type":"timestamp"},"LastSuccessfulSyncProvisioningArtifactId":{}}}}}}},"S2m":{"type":"structure","members":{"Id":{},"ProductId":{},"Name":{},"Owner":{},"ShortDescription":{},"Type":{},"Distributor":{},"HasDefaultPath":{"type":"boolean"},"SupportEmail":{},"SupportDescription":{},"SupportUrl":{}}},"S2w":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"Type":{},"CreatedTime":{"type":"timestamp"},"Active":{"type":"boolean"},"Guidance":{},"SourceRevision":{}}},"S33":{"type":"list","member":{}},"S36":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{},"UsePreviousValue":{"type":"boolean"}}}},"S3h":{"type":"map","key":{},"value":{}},"S3m":{"type":"structure","members":{"ServiceActionSummary":{"shape":"S3n"},"Definition":{"shape":"S3h"}}},"S3n":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"DefinitionType":{}}},"S3s":{"type":"structure","members":{"Key":{},"Value":{},"Active":{"type":"boolean"},"Id":{},"Owner":{}}},"S4k":{"type":"list","member":{"shape":"S3s"}},"S4l":{"type":"list","member":{"type":"structure","members":{"BudgetName":{}}}},"S56":{"type":"list","member":{"shape":"S57"}},"S57":{"type":"structure","members":{"Id":{},"Name":{},"Description":{},"CreatedTime":{"type":"timestamp"},"Guidance":{}}},"S5k":{"type":"structure","members":{"Name":{},"Arn":{},"Type":{},"Id":{},"Status":{},"StatusMessage":{},"CreatedTime":{"type":"timestamp"},"IdempotencyToken":{},"LastRecordId":{},"LastProvisioningRecordId":{},"LastSuccessfulProvisioningRecordId":{},"ProductId":{},"ProvisioningArtifactId":{},"LaunchRoleArn":{}}},"S6l":{"type":"list","member":{"type":"structure","members":{"ParameterKey":{},"DefaultValue":{},"ParameterType":{},"IsNoEcho":{"type":"boolean"},"Description":{},"ParameterConstraints":{"type":"structure","members":{"AllowedValues":{"type":"list","member":{}},"AllowedPattern":{},"ConstraintDescription":{},"MaxLength":{},"MinLength":{},"MaxValue":{},"MinValue":{}}}}}},"S6w":{"type":"list","member":{"type":"structure","members":{"Type":{},"Description":{}}}},"S76":{"type":"list","member":{}},"S77":{"type":"list","member":{}},"S79":{"type":"list","member":{"type":"structure","members":{"Key":{},"Description":{}}}},"S7f":{"type":"structure","members":{"RecordId":{},"ProvisionedProductName":{},"Status":{},"CreatedTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ProvisionedProductType":{},"RecordType":{},"ProvisionedProductId":{},"ProductId":{},"ProvisioningArtifactId":{},"PathId":{},"RecordErrors":{"type":"list","member":{"type":"structure","members":{"Code":{},"Description":{}}}},"RecordTags":{"type":"list","member":{"type":"structure","members":{"Key":{},"Value":{}}}},"LaunchRoleArn":{}}},"S7q":{"type":"list","member":{"type":"structure","members":{"OutputKey":{},"OutputValue":{},"Description":{}}}},"S82":{"type":"list","member":{}},"S90":{"type":"list","member":{"shape":"S1n"}},"S9p":{"type":"structure","members":{"Key":{},"Value":{}}},"Sak":{"type":"list","member":{"shape":"S3n"}},"Sbn":{"type":"map","key":{},"value":{"type":"list","member":{}}},"Sco":{"type":"list","member":{}},"Sd0":{"type":"map","key":{},"value":{}}}}

/***/ }),
/* 616 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribePortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"GetProvisionedProductOutputs":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListAcceptedPortfolioShares":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListBudgetsForResource":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListConstraintsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListLaunchPaths":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListOrganizationPortfolioAccess":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolioAccess":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfolios":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPortfoliosForProduct":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListPrincipalsForPortfolio":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListProvisioningArtifactsForServiceAction":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListResourcesForTagOption":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"ListServiceActions":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListServiceActionsForProvisioningArtifact":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"ListTagOptions":{"input_token":"PageToken","output_token":"PageToken","limit_key":"PageSize"},"SearchProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProductsAsAdmin":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"},"SearchProvisionedProducts":{"input_token":"PageToken","output_token":"NextPageToken","limit_key":"PageSize"}}}

/***/ }),
/* 617 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2010-03-31","endpointPrefix":"sns","protocol":"query","serviceAbbreviation":"Amazon SNS","serviceFullName":"Amazon Simple Notification Service","serviceId":"SNS","signatureVersion":"v4","uid":"sns-2010-03-31","xmlNamespace":"http://sns.amazonaws.com/doc/2010-03-31/"},"operations":{"AddPermission":{"input":{"type":"structure","required":["TopicArn","Label","AWSAccountId","ActionName"],"members":{"TopicArn":{},"Label":{},"AWSAccountId":{"type":"list","member":{}},"ActionName":{"type":"list","member":{}}}}},"CheckIfPhoneNumberIsOptedOut":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{"shape":"S9"}}},"output":{"resultWrapper":"CheckIfPhoneNumberIsOptedOutResult","type":"structure","members":{"isOptedOut":{"type":"boolean"}}}},"ConfirmSubscription":{"input":{"type":"structure","required":["TopicArn","Token"],"members":{"TopicArn":{},"Token":{},"AuthenticateOnUnsubscribe":{}}},"output":{"resultWrapper":"ConfirmSubscriptionResult","type":"structure","members":{"SubscriptionArn":{}}}},"CreatePlatformApplication":{"input":{"type":"structure","required":["Name","Platform","Attributes"],"members":{"Name":{},"Platform":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformApplicationResult","type":"structure","members":{"PlatformApplicationArn":{}}}},"CreatePlatformEndpoint":{"input":{"type":"structure","required":["PlatformApplicationArn","Token"],"members":{"PlatformApplicationArn":{},"Token":{},"CustomUserData":{},"Attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"CreatePlatformEndpointResult","type":"structure","members":{"EndpointArn":{}}}},"CreateSMSSandboxPhoneNumber":{"input":{"type":"structure","required":["PhoneNumber"],"members":{"PhoneNumber":{"shape":"So"},"LanguageCode":{}}},"output":{"resultWrapper":"CreateSMSSandboxPhoneNumberResult","type":"structure","members":{}}},"CreateTopic":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Attributes":{"shape":"St"},"Tags":{"shape":"Sw"},"DataProtectionPolicy":{}}},"output":{"resultWrapper":"CreateTopicResult","type":"structure","members":{"TopicArn":{}}}},"DeleteEndpoint":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}}},"DeletePlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}}},"DeleteSMSSandboxPhoneNumber":{"input":{"type":"structure","required":["PhoneNumber"],"members":{"PhoneNumber":{"shape":"So"}}},"output":{"resultWrapper":"DeleteSMSSandboxPhoneNumberResult","type":"structure","members":{}}},"DeleteTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}}},"GetDataProtectionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"GetDataProtectionPolicyResult","type":"structure","members":{"DataProtectionPolicy":{}}}},"GetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn"],"members":{"EndpointArn":{}}},"output":{"resultWrapper":"GetEndpointAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{}}},"output":{"resultWrapper":"GetPlatformApplicationAttributesResult","type":"structure","members":{"Attributes":{"shape":"Sj"}}}},"GetSMSAttributes":{"input":{"type":"structure","members":{"attributes":{"type":"list","member":{}}}},"output":{"resultWrapper":"GetSMSAttributesResult","type":"structure","members":{"attributes":{"shape":"Sj"}}}},"GetSMSSandboxAccountStatus":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetSMSSandboxAccountStatusResult","type":"structure","required":["IsInSandbox"],"members":{"IsInSandbox":{"type":"boolean"}}}},"GetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}},"output":{"resultWrapper":"GetSubscriptionAttributesResult","type":"structure","members":{"Attributes":{"shape":"S1j"}}}},"GetTopicAttributes":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{}}},"output":{"resultWrapper":"GetTopicAttributesResult","type":"structure","members":{"Attributes":{"shape":"St"}}}},"ListEndpointsByPlatformApplication":{"input":{"type":"structure","required":["PlatformApplicationArn"],"members":{"PlatformApplicationArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListEndpointsByPlatformApplicationResult","type":"structure","members":{"Endpoints":{"type":"list","member":{"type":"structure","members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListOriginationNumbers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListOriginationNumbersResult","type":"structure","members":{"NextToken":{},"PhoneNumbers":{"type":"list","member":{"type":"structure","members":{"CreatedAt":{"type":"timestamp"},"PhoneNumber":{"shape":"S9"},"Status":{},"Iso2CountryCode":{},"RouteType":{},"NumberCapabilities":{"type":"list","member":{}}}}}}}},"ListPhoneNumbersOptedOut":{"input":{"type":"structure","members":{"nextToken":{}}},"output":{"resultWrapper":"ListPhoneNumbersOptedOutResult","type":"structure","members":{"phoneNumbers":{"type":"list","member":{"shape":"S9"}},"nextToken":{}}}},"ListPlatformApplications":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListPlatformApplicationsResult","type":"structure","members":{"PlatformApplications":{"type":"list","member":{"type":"structure","members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"NextToken":{}}}},"ListSMSSandboxPhoneNumbers":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"resultWrapper":"ListSMSSandboxPhoneNumbersResult","type":"structure","required":["PhoneNumbers"],"members":{"PhoneNumbers":{"type":"list","member":{"type":"structure","members":{"PhoneNumber":{"shape":"So"},"Status":{}}}},"NextToken":{}}}},"ListSubscriptions":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsResult","type":"structure","members":{"Subscriptions":{"shape":"S2h"},"NextToken":{}}}},"ListSubscriptionsByTopic":{"input":{"type":"structure","required":["TopicArn"],"members":{"TopicArn":{},"NextToken":{}}},"output":{"resultWrapper":"ListSubscriptionsByTopicResult","type":"structure","members":{"Subscriptions":{"shape":"S2h"},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"resultWrapper":"ListTagsForResourceResult","type":"structure","members":{"Tags":{"shape":"Sw"}}}},"ListTopics":{"input":{"type":"structure","members":{"NextToken":{}}},"output":{"resultWrapper":"ListTopicsResult","type":"structure","members":{"Topics":{"type":"list","member":{"type":"structure","members":{"TopicArn":{}}}},"NextToken":{}}}},"OptInPhoneNumber":{"input":{"type":"structure","required":["phoneNumber"],"members":{"phoneNumber":{"shape":"S9"}}},"output":{"resultWrapper":"OptInPhoneNumberResult","type":"structure","members":{}}},"Publish":{"input":{"type":"structure","required":["Message"],"members":{"TopicArn":{},"TargetArn":{},"PhoneNumber":{"shape":"S9"},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"shape":"S31"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"resultWrapper":"PublishResult","type":"structure","members":{"MessageId":{},"SequenceNumber":{}}}},"PublishBatch":{"input":{"type":"structure","required":["TopicArn","PublishBatchRequestEntries"],"members":{"TopicArn":{},"PublishBatchRequestEntries":{"type":"list","member":{"type":"structure","required":["Id","Message"],"members":{"Id":{},"Message":{},"Subject":{},"MessageStructure":{},"MessageAttributes":{"shape":"S31"},"MessageDeduplicationId":{},"MessageGroupId":{}}}}}},"output":{"resultWrapper":"PublishBatchResult","type":"structure","members":{"Successful":{"type":"list","member":{"type":"structure","members":{"Id":{},"MessageId":{},"SequenceNumber":{}}}},"Failed":{"type":"list","member":{"type":"structure","required":["Id","Code","SenderFault"],"members":{"Id":{},"Code":{},"Message":{},"SenderFault":{"type":"boolean"}}}}}}},"PutDataProtectionPolicy":{"input":{"type":"structure","required":["ResourceArn","DataProtectionPolicy"],"members":{"ResourceArn":{},"DataProtectionPolicy":{}}}},"RemovePermission":{"input":{"type":"structure","required":["TopicArn","Label"],"members":{"TopicArn":{},"Label":{}}}},"SetEndpointAttributes":{"input":{"type":"structure","required":["EndpointArn","Attributes"],"members":{"EndpointArn":{},"Attributes":{"shape":"Sj"}}}},"SetPlatformApplicationAttributes":{"input":{"type":"structure","required":["PlatformApplicationArn","Attributes"],"members":{"PlatformApplicationArn":{},"Attributes":{"shape":"Sj"}}}},"SetSMSAttributes":{"input":{"type":"structure","required":["attributes"],"members":{"attributes":{"shape":"Sj"}}},"output":{"resultWrapper":"SetSMSAttributesResult","type":"structure","members":{}}},"SetSubscriptionAttributes":{"input":{"type":"structure","required":["SubscriptionArn","AttributeName"],"members":{"SubscriptionArn":{},"AttributeName":{},"AttributeValue":{}}}},"SetTopicAttributes":{"input":{"type":"structure","required":["TopicArn","AttributeName"],"members":{"TopicArn":{},"AttributeName":{},"AttributeValue":{}}}},"Subscribe":{"input":{"type":"structure","required":["TopicArn","Protocol"],"members":{"TopicArn":{},"Protocol":{},"Endpoint":{},"Attributes":{"shape":"S1j"},"ReturnSubscriptionArn":{"type":"boolean"}}},"output":{"resultWrapper":"SubscribeResult","type":"structure","members":{"SubscriptionArn":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sw"}}},"output":{"resultWrapper":"TagResourceResult","type":"structure","members":{}}},"Unsubscribe":{"input":{"type":"structure","required":["SubscriptionArn"],"members":{"SubscriptionArn":{}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"resultWrapper":"UntagResourceResult","type":"structure","members":{}}},"VerifySMSSandboxPhoneNumber":{"input":{"type":"structure","required":["PhoneNumber","OneTimePassword"],"members":{"PhoneNumber":{"shape":"So"},"OneTimePassword":{}}},"output":{"resultWrapper":"VerifySMSSandboxPhoneNumberResult","type":"structure","members":{}}}},"shapes":{"S9":{"type":"string","sensitive":true},"Sj":{"type":"map","key":{},"value":{}},"So":{"type":"string","sensitive":true},"St":{"type":"map","key":{},"value":{}},"Sw":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S1j":{"type":"map","key":{},"value":{}},"S2h":{"type":"list","member":{"type":"structure","members":{"SubscriptionArn":{},"Owner":{},"Protocol":{},"Endpoint":{},"TopicArn":{}}}},"S31":{"type":"map","key":{"locationName":"Name"},"value":{"locationName":"Value","type":"structure","required":["DataType"],"members":{"DataType":{},"StringValue":{},"BinaryValue":{"type":"blob"}}}}}}

/***/ }),
/* 618 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListEndpointsByPlatformApplication":{"input_token":"NextToken","output_token":"NextToken","result_key":"Endpoints"},"ListOriginationNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PhoneNumbers"},"ListPhoneNumbersOptedOut":{"input_token":"nextToken","output_token":"nextToken","result_key":"phoneNumbers"},"ListPlatformApplications":{"input_token":"NextToken","output_token":"NextToken","result_key":"PlatformApplications"},"ListSMSSandboxPhoneNumbers":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"PhoneNumbers"},"ListSubscriptions":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListSubscriptionsByTopic":{"input_token":"NextToken","output_token":"NextToken","result_key":"Subscriptions"},"ListTopics":{"input_token":"NextToken","output_token":"NextToken","result_key":"Topics"}}}

/***/ }),
/* 619 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-11-05","awsQueryCompatible":{},"endpointPrefix":"sqs","jsonVersion":"1.0","protocol":"json","serviceAbbreviation":"Amazon SQS","serviceFullName":"Amazon Simple Queue Service","serviceId":"SQS","signatureVersion":"v4","targetPrefix":"AmazonSQS","uid":"sqs-2012-11-05"},"operations":{"AddPermission":{"input":{"type":"structure","required":["QueueUrl","Label","AWSAccountIds","Actions"],"members":{"QueueUrl":{},"Label":{},"AWSAccountIds":{"type":"list","member":{},"flattened":true},"Actions":{"type":"list","member":{},"flattened":true}}}},"CancelMessageMoveTask":{"input":{"type":"structure","required":["TaskHandle"],"members":{"TaskHandle":{}}},"output":{"type":"structure","members":{"ApproximateNumberOfMessagesMoved":{"type":"long"}}}},"ChangeMessageVisibility":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle","VisibilityTimeout"],"members":{"QueueUrl":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}}},"ChangeMessageVisibilityBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{},"VisibilityTimeout":{"type":"integer"}}},"flattened":true}}},"output":{"type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sg"}}}},"CreateQueue":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"Attributes":{"shape":"Sk"},"tags":{"shape":"Sm"}}},"output":{"type":"structure","members":{"QueueUrl":{}}}},"DeleteMessage":{"input":{"type":"structure","required":["QueueUrl","ReceiptHandle"],"members":{"QueueUrl":{},"ReceiptHandle":{}}}},"DeleteMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"type":"structure","required":["Id","ReceiptHandle"],"members":{"Id":{},"ReceiptHandle":{}}},"flattened":true}}},"output":{"type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{}}},"flattened":true},"Failed":{"shape":"Sg"}}}},"DeleteQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"GetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sz"}}},"output":{"type":"structure","members":{"Attributes":{"shape":"Sk"}}}},"GetQueueUrl":{"input":{"type":"structure","required":["QueueName"],"members":{"QueueName":{},"QueueOwnerAWSAccountId":{}}},"output":{"type":"structure","members":{"QueueUrl":{}}}},"ListDeadLetterSourceQueues":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","required":["queueUrls"],"members":{"queueUrls":{"shape":"S17"},"NextToken":{}}}},"ListMessageMoveTasks":{"input":{"type":"structure","required":["SourceArn"],"members":{"SourceArn":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Results":{"flattened":true,"type":"list","member":{"type":"structure","members":{"TaskHandle":{},"Status":{},"SourceArn":{},"DestinationArn":{},"MaxNumberOfMessagesPerSecond":{"type":"integer"},"ApproximateNumberOfMessagesMoved":{"type":"long"},"ApproximateNumberOfMessagesToMove":{"type":"long"},"FailureReason":{},"StartedTimestamp":{"type":"long"}}}}}}},"ListQueueTags":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sm"}}}},"ListQueues":{"input":{"type":"structure","members":{"QueueNamePrefix":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"QueueUrls":{"shape":"S17"},"NextToken":{}}}},"PurgeQueue":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{}}}},"ReceiveMessage":{"input":{"type":"structure","required":["QueueUrl"],"members":{"QueueUrl":{},"AttributeNames":{"shape":"Sz","deprecated":true,"deprecatedMessage":"AttributeNames has been replaced by MessageSystemAttributeNames"},"MessageSystemAttributeNames":{"type":"list","member":{},"flattened":true},"MessageAttributeNames":{"type":"list","member":{},"flattened":true},"MaxNumberOfMessages":{"type":"integer"},"VisibilityTimeout":{"type":"integer"},"WaitTimeSeconds":{"type":"integer"},"ReceiveRequestAttemptId":{}}},"output":{"type":"structure","members":{"Messages":{"type":"list","member":{"type":"structure","members":{"MessageId":{},"ReceiptHandle":{},"MD5OfBody":{},"Body":{},"Attributes":{"type":"map","key":{},"value":{},"flattened":true},"MD5OfMessageAttributes":{},"MessageAttributes":{"shape":"S1r"}}},"flattened":true}}}},"RemovePermission":{"input":{"type":"structure","required":["QueueUrl","Label"],"members":{"QueueUrl":{},"Label":{}}}},"SendMessage":{"input":{"type":"structure","required":["QueueUrl","MessageBody"],"members":{"QueueUrl":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1r"},"MessageSystemAttributes":{"shape":"S1y"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"output":{"type":"structure","members":{"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MD5OfMessageSystemAttributes":{},"MessageId":{},"SequenceNumber":{}}}},"SendMessageBatch":{"input":{"type":"structure","required":["QueueUrl","Entries"],"members":{"QueueUrl":{},"Entries":{"type":"list","member":{"type":"structure","required":["Id","MessageBody"],"members":{"Id":{},"MessageBody":{},"DelaySeconds":{"type":"integer"},"MessageAttributes":{"shape":"S1r"},"MessageSystemAttributes":{"shape":"S1y"},"MessageDeduplicationId":{},"MessageGroupId":{}}},"flattened":true}}},"output":{"type":"structure","required":["Successful","Failed"],"members":{"Successful":{"type":"list","member":{"type":"structure","required":["Id","MessageId","MD5OfMessageBody"],"members":{"Id":{},"MessageId":{},"MD5OfMessageBody":{},"MD5OfMessageAttributes":{},"MD5OfMessageSystemAttributes":{},"SequenceNumber":{}}},"flattened":true},"Failed":{"shape":"Sg"}}}},"SetQueueAttributes":{"input":{"type":"structure","required":["QueueUrl","Attributes"],"members":{"QueueUrl":{},"Attributes":{"shape":"Sk"}}}},"StartMessageMoveTask":{"input":{"type":"structure","required":["SourceArn"],"members":{"SourceArn":{},"DestinationArn":{},"MaxNumberOfMessagesPerSecond":{"type":"integer"}}},"output":{"type":"structure","members":{"TaskHandle":{}}}},"TagQueue":{"input":{"type":"structure","required":["QueueUrl","Tags"],"members":{"QueueUrl":{},"Tags":{"shape":"Sm"}}}},"UntagQueue":{"input":{"type":"structure","required":["QueueUrl","TagKeys"],"members":{"QueueUrl":{},"TagKeys":{"type":"list","member":{},"flattened":true}}}}},"shapes":{"Sg":{"type":"list","member":{"type":"structure","required":["Id","SenderFault","Code"],"members":{"Id":{},"SenderFault":{"type":"boolean"},"Code":{},"Message":{}}},"flattened":true},"Sk":{"type":"map","key":{},"value":{},"flattened":true},"Sm":{"type":"map","key":{},"value":{},"flattened":true},"Sz":{"type":"list","member":{},"flattened":true},"S17":{"type":"list","member":{},"flattened":true},"S1r":{"type":"map","key":{},"value":{"type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"shape":"S1u","flattened":true},"BinaryListValues":{"shape":"S1v","flattened":true},"DataType":{}}},"flattened":true},"S1u":{"type":"list","member":{}},"S1v":{"type":"list","member":{"type":"blob"}},"S1y":{"type":"map","key":{},"value":{"type":"structure","required":["DataType"],"members":{"StringValue":{},"BinaryValue":{"type":"blob"},"StringListValues":{"shape":"S1u","flattened":true},"BinaryListValues":{"shape":"S1v","flattened":true},"DataType":{}}},"flattened":true}}}

/***/ }),
/* 620 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListDeadLetterSourceQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"queueUrls"},"ListQueues":{"input_token":"NextToken","output_token":"NextToken","limit_key":"MaxResults","result_key":"QueueUrls"}}}

/***/ }),
/* 621 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2014-11-06","endpointPrefix":"ssm","jsonVersion":"1.1","protocol":"json","protocols":["json"],"serviceAbbreviation":"Amazon SSM","serviceFullName":"Amazon Simple Systems Manager (SSM)","serviceId":"SSM","signatureVersion":"v4","targetPrefix":"AmazonSSM","uid":"ssm-2014-11-06"},"operations":{"AddTagsToResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","Tags"],"members":{"ResourceType":{},"ResourceId":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{}}},"AssociateOpsItemRelatedItem":{"input":{"type":"structure","required":["OpsItemId","AssociationType","ResourceType","ResourceUri"],"members":{"OpsItemId":{},"AssociationType":{},"ResourceType":{},"ResourceUri":{}}},"output":{"type":"structure","members":{"AssociationId":{}}}},"CancelCommand":{"input":{"type":"structure","required":["CommandId"],"members":{"CommandId":{},"InstanceIds":{"shape":"Si"}}},"output":{"type":"structure","members":{}}},"CancelMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{}}}},"CreateActivation":{"input":{"type":"structure","required":["IamRole"],"members":{"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Tags":{"shape":"S4"},"RegistrationMetadata":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}}}},"output":{"type":"structure","members":{"ActivationId":{},"ActivationCode":{}}}},"CreateAssociation":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"InstanceId":{},"Parameters":{"shape":"S14"},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"AssociationName":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"TargetMaps":{"shape":"S26"},"Tags":{"shape":"S4"},"AlarmConfiguration":{"shape":"S1z"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S2c"}}}},"CreateAssociationBatch":{"input":{"type":"structure","required":["Entries"],"members":{"Entries":{"type":"list","member":{"shape":"S2t"}}}},"output":{"type":"structure","members":{"Successful":{"type":"list","member":{"shape":"S2c"}},"Failed":{"type":"list","member":{"type":"structure","members":{"Entry":{"shape":"S2t"},"Message":{},"Fault":{}}}}}}},"CreateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Requires":{"shape":"S32"},"Attachments":{"shape":"S36"},"Name":{},"DisplayName":{},"VersionName":{},"DocumentType":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S3i"}}}},"CreateMaintenanceWindow":{"input":{"type":"structure","required":["Name","Schedule","Duration","Cutoff","AllowUnassociatedTargets"],"members":{"Name":{},"Description":{"shape":"S4c"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"WindowId":{}}}},"CreateOpsItem":{"input":{"type":"structure","required":["Description","Source","Title"],"members":{"Description":{},"OpsItemType":{},"OperationalData":{"shape":"S4q"},"Notifications":{"shape":"S4v"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S4z"},"Source":{},"Title":{},"Tags":{"shape":"S4"},"Category":{},"Severity":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"},"AccountId":{}}},"output":{"type":"structure","members":{"OpsItemId":{},"OpsItemArn":{}}}},"CreateOpsMetadata":{"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{},"Metadata":{"shape":"S5a"},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"OpsMetadataArn":{}}}},"CreatePatchBaseline":{"input":{"type":"structure","required":["Name"],"members":{"OperatingSystem":{},"Name":{},"GlobalFilters":{"shape":"S5j"},"ApprovalRules":{"shape":"S5p"},"ApprovedPatches":{"shape":"S5v"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5v"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S5z"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"S4"}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"CreateResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{},"S3Destination":{"shape":"S69"},"SyncType":{},"SyncSource":{"shape":"S6i"}}},"output":{"type":"structure","members":{}}},"DeleteActivation":{"input":{"type":"structure","required":["ActivationId"],"members":{"ActivationId":{}}},"output":{"type":"structure","members":{}}},"DeleteAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{},"Force":{"type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteInventory":{"input":{"type":"structure","required":["TypeName"],"members":{"TypeName":{},"SchemaDeleteOption":{},"DryRun":{"type":"boolean"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionSummary":{"shape":"S76"}}}},"DeleteMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{}}}},"DeleteOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}},"output":{"type":"structure","members":{}}},"DeleteOpsMetadata":{"input":{"type":"structure","required":["OpsMetadataArn"],"members":{"OpsMetadataArn":{}}},"output":{"type":"structure","members":{}}},"DeleteParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{}}},"DeleteParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S7n"}}},"output":{"type":"structure","members":{"DeletedParameters":{"shape":"S7n"},"InvalidParameters":{"shape":"S7n"}}}},"DeletePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"DeleteResourceDataSync":{"input":{"type":"structure","required":["SyncName"],"members":{"SyncName":{},"SyncType":{}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","PolicyId","PolicyHash"],"members":{"ResourceArn":{},"PolicyId":{},"PolicyHash":{}}},"output":{"type":"structure","members":{}}},"DeregisterManagedInstance":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{}}},"output":{"type":"structure","members":{}}},"DeregisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"DeregisterTargetFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Safe":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{}}}},"DeregisterTaskFromMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{}}}},"DescribeActivations":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","members":{"FilterKey":{},"FilterValues":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ActivationList":{"type":"list","member":{"type":"structure","members":{"ActivationId":{},"Description":{},"DefaultInstanceName":{},"IamRole":{},"RegistrationLimit":{"type":"integer"},"RegistrationsCount":{"type":"integer"},"ExpirationDate":{"type":"timestamp"},"Expired":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"Tags":{"shape":"S4"}}}},"NextToken":{}}}},"DescribeAssociation":{"input":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S2c"}}}},"DescribeAssociationExecutionTargets":{"input":{"type":"structure","required":["AssociationId","ExecutionId"],"members":{"AssociationId":{},"ExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutionTargets":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"ResourceId":{},"ResourceType":{},"Status":{},"DetailedStatus":{},"LastExecutionDate":{"type":"timestamp"},"OutputSource":{"type":"structure","members":{"OutputSourceId":{},"OutputSourceType":{}}}}}},"NextToken":{}}}},"DescribeAssociationExecutions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Value","Type"],"members":{"Key":{},"Value":{},"Type":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationExecutions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"ExecutionId":{},"Status":{},"DetailedStatus":{},"CreatedTime":{"type":"timestamp"},"LastExecutionDate":{"type":"timestamp"},"ResourceCountByStatus":{},"AlarmConfiguration":{"shape":"S1z"},"TriggeredAlarms":{"shape":"S2o"}}}},"NextToken":{}}}},"DescribeAutomationExecutions":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AutomationExecutionMetadataList":{"type":"list","member":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"AutomationExecutionStatus":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"ExecutedBy":{},"LogFile":{},"Outputs":{"shape":"S9n"},"Mode":{},"ParentAutomationExecutionId":{},"CurrentStepName":{},"CurrentAction":{},"FailureMessage":{},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S26"},"ResolvedTargets":{"shape":"S9s"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"AutomationType":{},"AlarmConfiguration":{"shape":"S1z"},"TriggeredAlarms":{"shape":"S2o"},"AutomationSubtype":{},"ScheduledTime":{"type":"timestamp"},"Runbooks":{"shape":"S9w"},"OpsItemId":{},"AssociationId":{},"ChangeRequestName":{}}}},"NextToken":{}}}},"DescribeAutomationStepExecutions":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"NextToken":{},"MaxResults":{"type":"integer"},"ReverseOrder":{"type":"boolean"}}},"output":{"type":"structure","members":{"StepExecutions":{"shape":"Sa6"},"NextToken":{}}}},"DescribeAvailablePatches":{"input":{"type":"structure","members":{"Filters":{"shape":"Sah"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"shape":"Sap"}},"NextToken":{}}}},"DescribeDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"DocumentVersion":{},"VersionName":{}}},"output":{"type":"structure","members":{"Document":{"shape":"S3i"}}}},"DescribeDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AccountIds":{"shape":"Sbk"},"AccountSharingInfoList":{"type":"list","member":{"type":"structure","members":{"AccountId":{},"SharedDocumentVersion":{}}}},"NextToken":{}}}},"DescribeEffectiveInstanceAssociations":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"InstanceId":{},"Content":{},"AssociationVersion":{}}}},"NextToken":{}}}},"DescribeEffectivePatchesForPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"EffectivePatches":{"type":"list","member":{"type":"structure","members":{"Patch":{"shape":"Sap"},"PatchStatus":{"type":"structure","members":{"DeploymentStatus":{},"ComplianceLevel":{},"ApprovalDate":{"type":"timestamp"}}}}}},"NextToken":{}}}},"DescribeInstanceAssociationsStatus":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceAssociationStatusInfos":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"Name":{},"DocumentVersion":{},"AssociationVersion":{},"InstanceId":{},"ExecutionDate":{"type":"timestamp"},"Status":{},"DetailedStatus":{},"ExecutionSummary":{},"ErrorCode":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{"type":"structure","members":{"OutputUrl":{}}}}},"AssociationName":{}}}},"NextToken":{}}}},"DescribeInstanceInformation":{"input":{"type":"structure","members":{"InstanceInformationFilterList":{"type":"list","member":{"type":"structure","required":["key","valueSet"],"members":{"key":{},"valueSet":{"shape":"Scd"}}}},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"shape":"Scd"}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceInformationList":{"type":"list","member":{"type":"structure","members":{"InstanceId":{},"PingStatus":{},"LastPingDateTime":{"type":"timestamp"},"AgentVersion":{},"IsLatestVersion":{"type":"boolean"},"PlatformType":{},"PlatformName":{},"PlatformVersion":{},"ActivationId":{},"IamRole":{},"RegistrationDate":{"type":"timestamp"},"ResourceType":{},"Name":{},"IPAddress":{},"ComputerName":{},"AssociationStatus":{},"LastAssociationExecutionDate":{"type":"timestamp"},"LastSuccessfulAssociationExecutionDate":{"type":"timestamp"},"AssociationOverview":{"shape":"Scr"},"SourceId":{},"SourceType":{}}}},"NextToken":{}}}},"DescribeInstancePatchStates":{"input":{"type":"structure","required":["InstanceIds"],"members":{"InstanceIds":{"shape":"Si"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Scz"}},"NextToken":{}}}},"DescribeInstancePatchStatesForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Type"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InstancePatchStates":{"type":"list","member":{"shape":"Scz"}},"NextToken":{}}}},"DescribeInstancePatches":{"input":{"type":"structure","required":["InstanceId"],"members":{"InstanceId":{},"Filters":{"shape":"Sah"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Patches":{"type":"list","member":{"type":"structure","required":["Title","KBId","Classification","Severity","State","InstalledTime"],"members":{"Title":{},"KBId":{},"Classification":{},"Severity":{},"State":{},"InstalledTime":{"type":"timestamp"},"CVEIds":{}}}},"NextToken":{}}}},"DescribeInstanceProperties":{"input":{"type":"structure","members":{"InstancePropertyFilterList":{"type":"list","member":{"type":"structure","required":["key","valueSet"],"members":{"key":{},"valueSet":{"shape":"Sdz"}}}},"FiltersWithOperator":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"shape":"Sdz"},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InstanceProperties":{"type":"list","member":{"type":"structure","members":{"Name":{},"InstanceId":{},"InstanceType":{},"InstanceRole":{},"KeyName":{},"InstanceState":{},"Architecture":{},"IPAddress":{},"LaunchTime":{"type":"timestamp"},"PingStatus":{},"LastPingDateTime":{"type":"timestamp"},"AgentVersion":{},"PlatformType":{},"PlatformName":{},"PlatformVersion":{},"ActivationId":{},"IamRole":{},"RegistrationDate":{"type":"timestamp"},"ResourceType":{},"ComputerName":{},"AssociationStatus":{},"LastAssociationExecutionDate":{"type":"timestamp"},"LastSuccessfulAssociationExecutionDate":{"type":"timestamp"},"AssociationOverview":{"shape":"Scr"},"SourceId":{},"SourceType":{}}}},"NextToken":{}}}},"DescribeInventoryDeletions":{"input":{"type":"structure","members":{"DeletionId":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"InventoryDeletions":{"type":"list","member":{"type":"structure","members":{"DeletionId":{},"TypeName":{},"DeletionStartTime":{"type":"timestamp"},"LastStatus":{},"LastStatusMessage":{},"DeletionSummary":{"shape":"S76"},"LastStatusUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{},"Filters":{"shape":"Ser"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskInvocationIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Sf3"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Sd2"},"WindowTargetId":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutionTasks":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{},"Filters":{"shape":"Ser"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutionTaskIdentities":{"type":"list","member":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TaskArn":{},"TaskType":{},"AlarmConfiguration":{"shape":"S1z"},"TriggeredAlarms":{"shape":"S2o"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowExecutions":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Ser"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowExecutionId":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowSchedule":{"input":{"type":"structure","members":{"WindowId":{},"Targets":{"shape":"S18"},"ResourceType":{},"Filters":{"shape":"Sah"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ScheduledWindowExecutions":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"ExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTargets":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Ser"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Targets":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"ResourceType":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Sd2"},"Name":{},"Description":{"shape":"S4c"}}}},"NextToken":{}}}},"DescribeMaintenanceWindowTasks":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Filters":{"shape":"Ser"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Tasks":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"TaskArn":{},"Type":{},"Targets":{"shape":"S18"},"TaskParameters":{"shape":"Sfu"},"Priority":{"type":"integer"},"LoggingInfo":{"shape":"Sg0"},"ServiceRoleArn":{},"MaxConcurrency":{},"MaxErrors":{},"Name":{},"Description":{"shape":"S4c"},"CutoffBehavior":{},"AlarmConfiguration":{"shape":"S1z"}}}},"NextToken":{}}}},"DescribeMaintenanceWindows":{"input":{"type":"structure","members":{"Filters":{"shape":"Ser"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S4c"},"Enabled":{"type":"boolean"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"EndDate":{},"StartDate":{},"NextExecutionTime":{}}}},"NextToken":{}}}},"DescribeMaintenanceWindowsForTarget":{"input":{"type":"structure","required":["Targets","ResourceType"],"members":{"Targets":{"shape":"S18"},"ResourceType":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"WindowIdentities":{"type":"list","member":{"type":"structure","members":{"WindowId":{},"Name":{}}}},"NextToken":{}}}},"DescribeOpsItems":{"input":{"type":"structure","members":{"OpsItemFilters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"OpsItemSummaries":{"type":"list","member":{"type":"structure","members":{"CreatedBy":{},"CreatedTime":{"type":"timestamp"},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Priority":{"type":"integer"},"Source":{},"Status":{},"OpsItemId":{},"Title":{},"OperationalData":{"shape":"S4q"},"Category":{},"Severity":{},"OpsItemType":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"}}}}}}},"DescribeParameters":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"ParameterFilters":{"shape":"Sgu"},"MaxResults":{"type":"integer"},"NextToken":{},"Shared":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"ARN":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"AllowedPattern":{},"Version":{"type":"long"},"Tier":{},"Policies":{"shape":"Sh9"},"DataType":{}}}},"NextToken":{}}}},"DescribePatchBaselines":{"input":{"type":"structure","members":{"Filters":{"shape":"Sah"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"BaselineIdentities":{"type":"list","member":{"shape":"Shf"}},"NextToken":{}}}},"DescribePatchGroupState":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{}}},"output":{"type":"structure","members":{"Instances":{"type":"integer"},"InstancesWithInstalledPatches":{"type":"integer"},"InstancesWithInstalledOtherPatches":{"type":"integer"},"InstancesWithInstalledPendingRebootPatches":{"type":"integer"},"InstancesWithInstalledRejectedPatches":{"type":"integer"},"InstancesWithMissingPatches":{"type":"integer"},"InstancesWithFailedPatches":{"type":"integer"},"InstancesWithNotApplicablePatches":{"type":"integer"},"InstancesWithUnreportedNotApplicablePatches":{"type":"integer"},"InstancesWithCriticalNonCompliantPatches":{"type":"integer"},"InstancesWithSecurityNonCompliantPatches":{"type":"integer"},"InstancesWithOtherNonCompliantPatches":{"type":"integer"}}}},"DescribePatchGroups":{"input":{"type":"structure","members":{"MaxResults":{"type":"integer"},"Filters":{"shape":"Sah"},"NextToken":{}}},"output":{"type":"structure","members":{"Mappings":{"type":"list","member":{"type":"structure","members":{"PatchGroup":{},"BaselineIdentity":{"shape":"Shf"}}}},"NextToken":{}}}},"DescribePatchProperties":{"input":{"type":"structure","required":["OperatingSystem","Property"],"members":{"OperatingSystem":{},"Property":{},"PatchSet":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Properties":{"type":"list","member":{"type":"map","key":{},"value":{}}},"NextToken":{}}}},"DescribeSessions":{"input":{"type":"structure","required":["State"],"members":{"State":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}}}},"output":{"type":"structure","members":{"Sessions":{"type":"list","member":{"type":"structure","members":{"SessionId":{},"Target":{},"Status":{},"StartDate":{"type":"timestamp"},"EndDate":{"type":"timestamp"},"DocumentName":{},"Owner":{},"Reason":{},"Details":{},"OutputUrl":{"type":"structure","members":{"S3OutputUrl":{},"CloudWatchOutputUrl":{}}},"MaxSessionDuration":{}}}},"NextToken":{}}}},"DisassociateOpsItemRelatedItem":{"input":{"type":"structure","required":["OpsItemId","AssociationId"],"members":{"OpsItemId":{},"AssociationId":{}}},"output":{"type":"structure","members":{}}},"GetAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{}}},"output":{"type":"structure","members":{"AutomationExecution":{"type":"structure","members":{"AutomationExecutionId":{},"DocumentName":{},"DocumentVersion":{},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"AutomationExecutionStatus":{},"StepExecutions":{"shape":"Sa6"},"StepExecutionsTruncated":{"type":"boolean"},"Parameters":{"shape":"S9n"},"Outputs":{"shape":"S9n"},"FailureMessage":{},"Mode":{},"ParentAutomationExecutionId":{},"ExecutedBy":{},"CurrentStepName":{},"CurrentAction":{},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S26"},"ResolvedTargets":{"shape":"S9s"},"MaxConcurrency":{},"MaxErrors":{},"Target":{},"TargetLocations":{"shape":"S1s"},"ProgressCounters":{"type":"structure","members":{"TotalSteps":{"type":"integer"},"SuccessSteps":{"type":"integer"},"FailedSteps":{"type":"integer"},"CancelledSteps":{"type":"integer"},"TimedOutSteps":{"type":"integer"}}},"AlarmConfiguration":{"shape":"S1z"},"TriggeredAlarms":{"shape":"S2o"},"AutomationSubtype":{},"ScheduledTime":{"type":"timestamp"},"Runbooks":{"shape":"S9w"},"OpsItemId":{},"AssociationId":{},"ChangeRequestName":{},"Variables":{"shape":"S9n"}}}}}},"GetCalendarState":{"input":{"type":"structure","required":["CalendarNames"],"members":{"CalendarNames":{"shape":"S1q"},"AtTime":{}}},"output":{"type":"structure","members":{"State":{},"AtTime":{},"NextTransitionTime":{}}}},"GetCommandInvocation":{"input":{"type":"structure","required":["CommandId","InstanceId"],"members":{"CommandId":{},"InstanceId":{},"PluginName":{}}},"output":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"PluginName":{},"ResponseCode":{"type":"integer"},"ExecutionStartDateTime":{},"ExecutionElapsedTime":{},"ExecutionEndDateTime":{},"Status":{},"StatusDetails":{},"StandardOutputContent":{},"StandardOutputUrl":{},"StandardErrorContent":{},"StandardErrorUrl":{},"CloudWatchOutputConfig":{"shape":"Sj0"}}}},"GetConnectionStatus":{"input":{"type":"structure","required":["Target"],"members":{"Target":{}}},"output":{"type":"structure","members":{"Target":{},"Status":{}}}},"GetDefaultPatchBaseline":{"input":{"type":"structure","members":{"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"OperatingSystem":{}}}},"GetDeployablePatchSnapshotForInstance":{"input":{"type":"structure","required":["InstanceId","SnapshotId"],"members":{"InstanceId":{},"SnapshotId":{},"BaselineOverride":{"type":"structure","members":{"OperatingSystem":{},"GlobalFilters":{"shape":"S5j"},"ApprovalRules":{"shape":"S5p"},"ApprovedPatches":{"shape":"S5v"},"ApprovedPatchesComplianceLevel":{},"RejectedPatches":{"shape":"S5v"},"RejectedPatchesAction":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"Sources":{"shape":"S5z"}}}}},"output":{"type":"structure","members":{"InstanceId":{},"SnapshotId":{},"SnapshotDownloadUrl":{},"Product":{}}}},"GetDocument":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{}}},"output":{"type":"structure","members":{"Name":{},"CreatedDate":{"type":"timestamp"},"DisplayName":{},"VersionName":{},"DocumentVersion":{},"Status":{},"StatusInformation":{},"Content":{},"DocumentType":{},"DocumentFormat":{},"Requires":{"shape":"S32"},"AttachmentsContent":{"type":"list","member":{"type":"structure","members":{"Name":{},"Size":{"type":"long"},"Hash":{},"HashType":{},"Url":{}}}},"ReviewStatus":{}}}},"GetInventory":{"input":{"type":"structure","members":{"Filters":{"shape":"Sjm"},"Aggregators":{"shape":"Sjs"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","required":["TypeName","SchemaVersion","Content"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sk9"}}}}}}},"NextToken":{}}}},"GetInventorySchema":{"input":{"type":"structure","members":{"TypeName":{},"NextToken":{},"MaxResults":{"type":"integer"},"Aggregator":{"type":"boolean"},"SubType":{"type":"boolean"}}},"output":{"type":"structure","members":{"Schemas":{"type":"list","member":{"type":"structure","required":["TypeName","Attributes"],"members":{"TypeName":{},"Version":{},"Attributes":{"type":"list","member":{"type":"structure","required":["Name","DataType"],"members":{"Name":{},"DataType":{}}}},"DisplayName":{}}}},"NextToken":{}}}},"GetMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S4c"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"NextExecutionTime":{},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"}}}},"GetMaintenanceWindowExecution":{"input":{"type":"structure","required":["WindowExecutionId"],"members":{"WindowExecutionId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskIds":{"type":"list","member":{}},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}}},"GetMaintenanceWindowExecutionTask":{"input":{"type":"structure","required":["WindowExecutionId","TaskId"],"members":{"WindowExecutionId":{},"TaskId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"TaskArn":{},"ServiceRole":{},"Type":{},"TaskParameters":{"type":"list","member":{"shape":"Sfu"},"sensitive":true},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"AlarmConfiguration":{"shape":"S1z"},"TriggeredAlarms":{"shape":"S2o"}}}},"GetMaintenanceWindowExecutionTaskInvocation":{"input":{"type":"structure","required":["WindowExecutionId","TaskId","InvocationId"],"members":{"WindowExecutionId":{},"TaskId":{},"InvocationId":{}}},"output":{"type":"structure","members":{"WindowExecutionId":{},"TaskExecutionId":{},"InvocationId":{},"ExecutionId":{},"TaskType":{},"Parameters":{"shape":"Sf3"},"Status":{},"StatusDetails":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"OwnerInformation":{"shape":"Sd2"},"WindowTargetId":{}}}},"GetMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Sfu"},"TaskInvocationParameters":{"shape":"Sl0"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sg0"},"Name":{},"Description":{"shape":"S4c"},"CutoffBehavior":{},"AlarmConfiguration":{"shape":"S1z"}}}},"GetOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{},"OpsItemArn":{}}},"output":{"type":"structure","members":{"OpsItem":{"type":"structure","members":{"CreatedBy":{},"OpsItemType":{},"CreatedTime":{"type":"timestamp"},"Description":{},"LastModifiedBy":{},"LastModifiedTime":{"type":"timestamp"},"Notifications":{"shape":"S4v"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S4z"},"Status":{},"OpsItemId":{},"Version":{},"Title":{},"Source":{},"OperationalData":{"shape":"S4q"},"Category":{},"Severity":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"},"OpsItemArn":{}}}}}},"GetOpsMetadata":{"input":{"type":"structure","required":["OpsMetadataArn"],"members":{"OpsMetadataArn":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"ResourceId":{},"Metadata":{"shape":"S5a"},"NextToken":{}}}},"GetOpsSummary":{"input":{"type":"structure","members":{"SyncName":{},"Filters":{"shape":"Sln"},"Aggregators":{"shape":"Slt"},"ResultAttributes":{"type":"list","member":{"type":"structure","required":["TypeName"],"members":{"TypeName":{}}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Entities":{"type":"list","member":{"type":"structure","members":{"Id":{},"Data":{"type":"map","key":{},"value":{"type":"structure","members":{"CaptureTime":{},"Content":{"type":"list","member":{"type":"map","key":{},"value":{}}}}}}}}},"NextToken":{}}}},"GetParameter":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameter":{"shape":"Smf"}}}},"GetParameterHistory":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"KeyId":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"Description":{},"Value":{"shape":"Smg"},"AllowedPattern":{},"Version":{"type":"long"},"Labels":{"shape":"Smm"},"Tier":{},"Policies":{"shape":"Sh9"},"DataType":{}}}},"NextToken":{}}}},"GetParameters":{"input":{"type":"structure","required":["Names"],"members":{"Names":{"shape":"S7n"},"WithDecryption":{"type":"boolean"}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Smq"},"InvalidParameters":{"shape":"S7n"}}}},"GetParametersByPath":{"input":{"type":"structure","required":["Path"],"members":{"Path":{},"Recursive":{"type":"boolean"},"ParameterFilters":{"shape":"Sgu"},"WithDecryption":{"type":"boolean"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Parameters":{"shape":"Smq"},"NextToken":{}}}},"GetPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S5j"},"ApprovalRules":{"shape":"S5p"},"ApprovedPatches":{"shape":"S5v"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5v"},"RejectedPatchesAction":{},"PatchGroups":{"type":"list","member":{}},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S5z"}}}},"GetPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["PatchGroup"],"members":{"PatchGroup":{},"OperatingSystem":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{},"OperatingSystem":{}}}},"GetResourcePolicies":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"NextToken":{},"Policies":{"type":"list","member":{"type":"structure","members":{"PolicyId":{},"PolicyHash":{},"Policy":{}}}}}}},"GetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Sn8"}}}},"LabelParameterVersion":{"input":{"type":"structure","required":["Name","Labels"],"members":{"Name":{},"ParameterVersion":{"type":"long"},"Labels":{"shape":"Smm"}}},"output":{"type":"structure","members":{"InvalidLabels":{"shape":"Smm"},"ParameterVersion":{"type":"long"}}}},"ListAssociationVersions":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"AssociationVersions":{"type":"list","member":{"type":"structure","members":{"AssociationId":{},"AssociationVersion":{},"CreatedDate":{"type":"timestamp"},"Name":{},"DocumentVersion":{},"Parameters":{"shape":"S14"},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"TargetMaps":{"shape":"S26"}}}},"NextToken":{}}}},"ListAssociations":{"input":{"type":"structure","members":{"AssociationFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"Associations":{"type":"list","member":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationId":{},"AssociationVersion":{},"DocumentVersion":{},"Targets":{"shape":"S18"},"LastExecutionDate":{"type":"timestamp"},"Overview":{"shape":"S2j"},"ScheduleExpression":{},"AssociationName":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"TargetMaps":{"shape":"S26"}}}},"NextToken":{}}}},"ListCommandInvocations":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Snq"},"Details":{"type":"boolean"}}},"output":{"type":"structure","members":{"CommandInvocations":{"type":"list","member":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"InstanceName":{},"Comment":{},"DocumentName":{},"DocumentVersion":{},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"TraceOutput":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"CommandPlugins":{"type":"list","member":{"type":"structure","members":{"Name":{},"Status":{},"StatusDetails":{},"ResponseCode":{"type":"integer"},"ResponseStartDateTime":{"type":"timestamp"},"ResponseFinishDateTime":{"type":"timestamp"},"Output":{},"StandardOutputUrl":{},"StandardErrorUrl":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}},"ServiceRole":{},"NotificationConfig":{"shape":"Sl2"},"CloudWatchOutputConfig":{"shape":"Sj0"}}}},"NextToken":{}}}},"ListCommands":{"input":{"type":"structure","members":{"CommandId":{},"InstanceId":{},"MaxResults":{"type":"integer"},"NextToken":{},"Filters":{"shape":"Snq"}}},"output":{"type":"structure","members":{"Commands":{"type":"list","member":{"shape":"So6"}},"NextToken":{}}}},"ListComplianceItems":{"input":{"type":"structure","members":{"Filters":{"shape":"Sod"},"ResourceIds":{"type":"list","member":{}},"ResourceTypes":{"type":"list","member":{}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Id":{},"Title":{},"Status":{},"Severity":{},"ExecutionSummary":{"shape":"Sov"},"Details":{"shape":"Soy"}}}},"NextToken":{}}}},"ListComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sod"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"CompliantSummary":{"shape":"Sp3"},"NonCompliantSummary":{"shape":"Sp6"}}}},"NextToken":{}}}},"ListDocumentMetadataHistory":{"input":{"type":"structure","required":["Name","Metadata"],"members":{"Name":{},"DocumentVersion":{},"Metadata":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Name":{},"DocumentVersion":{},"Author":{},"Metadata":{"type":"structure","members":{"ReviewerResponse":{"type":"list","member":{"type":"structure","members":{"CreateTime":{"type":"timestamp"},"UpdatedTime":{"type":"timestamp"},"ReviewStatus":{},"Comment":{"shape":"Spd"},"Reviewer":{}}}}}},"NextToken":{}}}},"ListDocumentVersions":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"type":"structure","members":{"Name":{},"DisplayName":{},"DocumentVersion":{},"VersionName":{},"CreatedDate":{"type":"timestamp"},"IsDefaultVersion":{"type":"boolean"},"DocumentFormat":{},"Status":{},"StatusInformation":{},"ReviewStatus":{}}}},"NextToken":{}}}},"ListDocuments":{"input":{"type":"structure","members":{"DocumentFilterList":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"Filters":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"DocumentIdentifiers":{"type":"list","member":{"type":"structure","members":{"Name":{},"CreatedDate":{"type":"timestamp"},"DisplayName":{},"Owner":{},"VersionName":{},"PlatformTypes":{"shape":"S3w"},"DocumentVersion":{},"DocumentType":{},"SchemaVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"},"Requires":{"shape":"S32"},"ReviewStatus":{},"Author":{}}}},"NextToken":{}}}},"ListInventoryEntries":{"input":{"type":"structure","required":["InstanceId","TypeName"],"members":{"InstanceId":{},"TypeName":{},"Filters":{"shape":"Sjm"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TypeName":{},"InstanceId":{},"SchemaVersion":{},"CaptureTime":{},"Entries":{"shape":"Sk9"},"NextToken":{}}}},"ListOpsItemEvents":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Summaries":{"type":"list","member":{"type":"structure","members":{"OpsItemId":{},"EventId":{},"Source":{},"DetailType":{},"Detail":{},"CreatedBy":{"shape":"Sqb"},"CreatedTime":{"type":"timestamp"}}}}}}},"ListOpsItemRelatedItems":{"input":{"type":"structure","members":{"OpsItemId":{},"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values","Operator"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Operator":{}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"NextToken":{},"Summaries":{"type":"list","member":{"type":"structure","members":{"OpsItemId":{},"AssociationId":{},"ResourceType":{},"AssociationType":{},"ResourceUri":{},"CreatedBy":{"shape":"Sqb"},"CreatedTime":{"type":"timestamp"},"LastModifiedBy":{"shape":"Sqb"},"LastModifiedTime":{"type":"timestamp"}}}}}}},"ListOpsMetadata":{"input":{"type":"structure","members":{"Filters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"OpsMetadataList":{"type":"list","member":{"type":"structure","members":{"ResourceId":{},"OpsMetadataArn":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"CreationDate":{"type":"timestamp"}}}},"NextToken":{}}}},"ListResourceComplianceSummaries":{"input":{"type":"structure","members":{"Filters":{"shape":"Sod"},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceComplianceSummaryItems":{"type":"list","member":{"type":"structure","members":{"ComplianceType":{},"ResourceType":{},"ResourceId":{},"Status":{},"OverallSeverity":{},"ExecutionSummary":{"shape":"Sov"},"CompliantSummary":{"shape":"Sp3"},"NonCompliantSummary":{"shape":"Sp6"}}}},"NextToken":{}}}},"ListResourceDataSync":{"input":{"type":"structure","members":{"SyncType":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceDataSyncItems":{"type":"list","member":{"type":"structure","members":{"SyncName":{},"SyncType":{},"SyncSource":{"type":"structure","members":{"SourceType":{},"AwsOrganizationsSource":{"shape":"S6k"},"SourceRegions":{"shape":"S6p"},"IncludeFutureRegions":{"type":"boolean"},"State":{},"EnableAllOpsDataSources":{"type":"boolean"}}},"S3Destination":{"shape":"S69"},"LastSyncTime":{"type":"timestamp"},"LastSuccessfulSyncTime":{"type":"timestamp"},"SyncLastModifiedTime":{"type":"timestamp"},"LastStatus":{},"SyncCreatedTime":{"type":"timestamp"},"LastSyncStatusMessage":{}}}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceType","ResourceId"],"members":{"ResourceType":{},"ResourceId":{}}},"output":{"type":"structure","members":{"TagList":{"shape":"S4"}}}},"ModifyDocumentPermission":{"input":{"type":"structure","required":["Name","PermissionType"],"members":{"Name":{},"PermissionType":{},"AccountIdsToAdd":{"shape":"Sbk"},"AccountIdsToRemove":{"shape":"Sbk"},"SharedDocumentVersion":{}}},"output":{"type":"structure","members":{}}},"PutComplianceItems":{"input":{"type":"structure","required":["ResourceId","ResourceType","ComplianceType","ExecutionSummary","Items"],"members":{"ResourceId":{},"ResourceType":{},"ComplianceType":{},"ExecutionSummary":{"shape":"Sov"},"Items":{"type":"list","member":{"type":"structure","required":["Severity","Status"],"members":{"Id":{},"Title":{},"Severity":{},"Status":{},"Details":{"shape":"Soy"}}}},"ItemContentHash":{},"UploadType":{}}},"output":{"type":"structure","members":{}}},"PutInventory":{"input":{"type":"structure","required":["InstanceId","Items"],"members":{"InstanceId":{},"Items":{"type":"list","member":{"type":"structure","required":["TypeName","SchemaVersion","CaptureTime"],"members":{"TypeName":{},"SchemaVersion":{},"CaptureTime":{},"ContentHash":{},"Content":{"shape":"Sk9"},"Context":{"type":"map","key":{},"value":{}}}}}}},"output":{"type":"structure","members":{"Message":{}}}},"PutParameter":{"input":{"type":"structure","required":["Name","Value"],"members":{"Name":{},"Description":{},"Value":{"shape":"Smg"},"Type":{},"KeyId":{},"Overwrite":{"type":"boolean"},"AllowedPattern":{},"Tags":{"shape":"S4"},"Tier":{},"Policies":{},"DataType":{}}},"output":{"type":"structure","members":{"Version":{"type":"long"},"Tier":{}}}},"PutResourcePolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{},"PolicyId":{},"PolicyHash":{}}},"output":{"type":"structure","members":{"PolicyId":{},"PolicyHash":{}}}},"RegisterDefaultPatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{}}},"output":{"type":"structure","members":{"BaselineId":{}}}},"RegisterPatchBaselineForPatchGroup":{"input":{"type":"structure","required":["BaselineId","PatchGroup"],"members":{"BaselineId":{},"PatchGroup":{}}},"output":{"type":"structure","members":{"BaselineId":{},"PatchGroup":{}}}},"RegisterTargetWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","ResourceType","Targets"],"members":{"WindowId":{},"ResourceType":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Sd2"},"Name":{},"Description":{"shape":"S4c"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"WindowTargetId":{}}}},"RegisterTaskWithMaintenanceWindow":{"input":{"type":"structure","required":["WindowId","TaskArn","TaskType"],"members":{"WindowId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskType":{},"TaskParameters":{"shape":"Sfu"},"TaskInvocationParameters":{"shape":"Sl0"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sg0"},"Name":{},"Description":{"shape":"S4c"},"ClientToken":{"idempotencyToken":true},"CutoffBehavior":{},"AlarmConfiguration":{"shape":"S1z"}}},"output":{"type":"structure","members":{"WindowTaskId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceType","ResourceId","TagKeys"],"members":{"ResourceType":{},"ResourceId":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"ResetServiceSetting":{"input":{"type":"structure","required":["SettingId"],"members":{"SettingId":{}}},"output":{"type":"structure","members":{"ServiceSetting":{"shape":"Sn8"}}}},"ResumeSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"SendAutomationSignal":{"input":{"type":"structure","required":["AutomationExecutionId","SignalType"],"members":{"AutomationExecutionId":{},"SignalType":{},"Payload":{"shape":"S9n"}}},"output":{"type":"structure","members":{}}},"SendCommand":{"input":{"type":"structure","required":["DocumentName"],"members":{"InstanceIds":{"shape":"Si"},"Targets":{"shape":"S18"},"DocumentName":{},"DocumentVersion":{},"DocumentHash":{},"DocumentHashType":{},"TimeoutSeconds":{"type":"integer"},"Comment":{},"Parameters":{"shape":"S14"},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"ServiceRoleArn":{},"NotificationConfig":{"shape":"Sl2"},"CloudWatchOutputConfig":{"shape":"Sj0"},"AlarmConfiguration":{"shape":"S1z"}}},"output":{"type":"structure","members":{"Command":{"shape":"So6"}}}},"StartAssociationsOnce":{"input":{"type":"structure","required":["AssociationIds"],"members":{"AssociationIds":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"StartAutomationExecution":{"input":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S9n"},"ClientToken":{},"Mode":{},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S26"},"MaxConcurrency":{},"MaxErrors":{},"TargetLocations":{"shape":"S1s"},"Tags":{"shape":"S4"},"AlarmConfiguration":{"shape":"S1z"}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StartChangeRequestExecution":{"input":{"type":"structure","required":["DocumentName","Runbooks"],"members":{"ScheduledTime":{"type":"timestamp"},"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S9n"},"ChangeRequestName":{},"ClientToken":{},"AutoApprove":{"type":"boolean"},"Runbooks":{"shape":"S9w"},"Tags":{"shape":"S4"},"ScheduledEndTime":{"type":"timestamp"},"ChangeDetails":{}}},"output":{"type":"structure","members":{"AutomationExecutionId":{}}}},"StartSession":{"input":{"type":"structure","required":["Target"],"members":{"Target":{},"DocumentName":{},"Reason":{},"Parameters":{"type":"map","key":{},"value":{"type":"list","member":{}}}}},"output":{"type":"structure","members":{"SessionId":{},"TokenValue":{},"StreamUrl":{}}}},"StopAutomationExecution":{"input":{"type":"structure","required":["AutomationExecutionId"],"members":{"AutomationExecutionId":{},"Type":{}}},"output":{"type":"structure","members":{}}},"TerminateSession":{"input":{"type":"structure","required":["SessionId"],"members":{"SessionId":{}}},"output":{"type":"structure","members":{"SessionId":{}}}},"UnlabelParameterVersion":{"input":{"type":"structure","required":["Name","ParameterVersion","Labels"],"members":{"Name":{},"ParameterVersion":{"type":"long"},"Labels":{"shape":"Smm"}}},"output":{"type":"structure","members":{"RemovedLabels":{"shape":"Smm"},"InvalidLabels":{"shape":"Smm"}}}},"UpdateAssociation":{"input":{"type":"structure","required":["AssociationId"],"members":{"AssociationId":{},"Parameters":{"shape":"S14"},"DocumentVersion":{},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"Name":{},"Targets":{"shape":"S18"},"AssociationName":{},"AssociationVersion":{},"AutomationTargetParameterName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"TargetMaps":{"shape":"S26"},"AlarmConfiguration":{"shape":"S1z"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S2c"}}}},"UpdateAssociationStatus":{"input":{"type":"structure","required":["Name","InstanceId","AssociationStatus"],"members":{"Name":{},"InstanceId":{},"AssociationStatus":{"shape":"S2f"}}},"output":{"type":"structure","members":{"AssociationDescription":{"shape":"S2c"}}}},"UpdateDocument":{"input":{"type":"structure","required":["Content","Name"],"members":{"Content":{},"Attachments":{"shape":"S36"},"Name":{},"DisplayName":{},"VersionName":{},"DocumentVersion":{},"DocumentFormat":{},"TargetType":{}}},"output":{"type":"structure","members":{"DocumentDescription":{"shape":"S3i"}}}},"UpdateDocumentDefaultVersion":{"input":{"type":"structure","required":["Name","DocumentVersion"],"members":{"Name":{},"DocumentVersion":{}}},"output":{"type":"structure","members":{"Description":{"type":"structure","members":{"Name":{},"DefaultVersion":{},"DefaultVersionName":{}}}}}},"UpdateDocumentMetadata":{"input":{"type":"structure","required":["Name","DocumentReviews"],"members":{"Name":{},"DocumentVersion":{},"DocumentReviews":{"type":"structure","required":["Action"],"members":{"Action":{},"Comment":{"shape":"Spd"}}}}},"output":{"type":"structure","members":{}}},"UpdateMaintenanceWindow":{"input":{"type":"structure","required":["WindowId"],"members":{"WindowId":{},"Name":{},"Description":{"shape":"S4c"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"Name":{},"Description":{"shape":"S4c"},"StartDate":{},"EndDate":{},"Schedule":{},"ScheduleTimezone":{},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"Cutoff":{"type":"integer"},"AllowUnassociatedTargets":{"type":"boolean"},"Enabled":{"type":"boolean"}}}},"UpdateMaintenanceWindowTarget":{"input":{"type":"structure","required":["WindowId","WindowTargetId"],"members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Sd2"},"Name":{},"Description":{"shape":"S4c"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTargetId":{},"Targets":{"shape":"S18"},"OwnerInformation":{"shape":"Sd2"},"Name":{},"Description":{"shape":"S4c"}}}},"UpdateMaintenanceWindowTask":{"input":{"type":"structure","required":["WindowId","WindowTaskId"],"members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Sfu"},"TaskInvocationParameters":{"shape":"Sl0"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sg0"},"Name":{},"Description":{"shape":"S4c"},"Replace":{"type":"boolean"},"CutoffBehavior":{},"AlarmConfiguration":{"shape":"S1z"}}},"output":{"type":"structure","members":{"WindowId":{},"WindowTaskId":{},"Targets":{"shape":"S18"},"TaskArn":{},"ServiceRoleArn":{},"TaskParameters":{"shape":"Sfu"},"TaskInvocationParameters":{"shape":"Sl0"},"Priority":{"type":"integer"},"MaxConcurrency":{},"MaxErrors":{},"LoggingInfo":{"shape":"Sg0"},"Name":{},"Description":{"shape":"S4c"},"CutoffBehavior":{},"AlarmConfiguration":{"shape":"S1z"}}}},"UpdateManagedInstanceRole":{"input":{"type":"structure","required":["InstanceId","IamRole"],"members":{"InstanceId":{},"IamRole":{}}},"output":{"type":"structure","members":{}}},"UpdateOpsItem":{"input":{"type":"structure","required":["OpsItemId"],"members":{"Description":{},"OperationalData":{"shape":"S4q"},"OperationalDataToDelete":{"type":"list","member":{}},"Notifications":{"shape":"S4v"},"Priority":{"type":"integer"},"RelatedOpsItems":{"shape":"S4z"},"Status":{},"OpsItemId":{},"Title":{},"Category":{},"Severity":{},"ActualStartTime":{"type":"timestamp"},"ActualEndTime":{"type":"timestamp"},"PlannedStartTime":{"type":"timestamp"},"PlannedEndTime":{"type":"timestamp"},"OpsItemArn":{}}},"output":{"type":"structure","members":{}}},"UpdateOpsMetadata":{"input":{"type":"structure","required":["OpsMetadataArn"],"members":{"OpsMetadataArn":{},"MetadataToUpdate":{"shape":"S5a"},"KeysToDelete":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"OpsMetadataArn":{}}}},"UpdatePatchBaseline":{"input":{"type":"structure","required":["BaselineId"],"members":{"BaselineId":{},"Name":{},"GlobalFilters":{"shape":"S5j"},"ApprovalRules":{"shape":"S5p"},"ApprovedPatches":{"shape":"S5v"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5v"},"RejectedPatchesAction":{},"Description":{},"Sources":{"shape":"S5z"},"Replace":{"type":"boolean"}}},"output":{"type":"structure","members":{"BaselineId":{},"Name":{},"OperatingSystem":{},"GlobalFilters":{"shape":"S5j"},"ApprovalRules":{"shape":"S5p"},"ApprovedPatches":{"shape":"S5v"},"ApprovedPatchesComplianceLevel":{},"ApprovedPatchesEnableNonSecurity":{"type":"boolean"},"RejectedPatches":{"shape":"S5v"},"RejectedPatchesAction":{},"CreatedDate":{"type":"timestamp"},"ModifiedDate":{"type":"timestamp"},"Description":{},"Sources":{"shape":"S5z"}}}},"UpdateResourceDataSync":{"input":{"type":"structure","required":["SyncName","SyncType","SyncSource"],"members":{"SyncName":{},"SyncType":{},"SyncSource":{"shape":"S6i"}}},"output":{"type":"structure","members":{}}},"UpdateServiceSetting":{"input":{"type":"structure","required":["SettingId","SettingValue"],"members":{"SettingId":{},"SettingValue":{}}},"output":{"type":"structure","members":{}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Si":{"type":"list","member":{}},"S14":{"type":"map","key":{},"value":{"type":"list","member":{}},"sensitive":true},"S18":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"S1e":{"type":"structure","members":{"S3Location":{"type":"structure","members":{"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{}}}}},"S1q":{"type":"list","member":{}},"S1s":{"type":"list","member":{"shape":"S1t"}},"S1t":{"type":"structure","members":{"Accounts":{"type":"list","member":{}},"Regions":{"type":"list","member":{}},"TargetLocationMaxConcurrency":{},"TargetLocationMaxErrors":{},"ExecutionRoleName":{},"TargetLocationAlarmConfiguration":{"shape":"S1z"}}},"S1z":{"type":"structure","required":["Alarms"],"members":{"IgnorePollAlarmFailure":{"type":"boolean"},"Alarms":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{}}}}}},"S26":{"type":"list","member":{"type":"map","key":{},"value":{"type":"list","member":{}}}},"S2c":{"type":"structure","members":{"Name":{},"InstanceId":{},"AssociationVersion":{},"Date":{"type":"timestamp"},"LastUpdateAssociationDate":{"type":"timestamp"},"Status":{"shape":"S2f"},"Overview":{"shape":"S2j"},"DocumentVersion":{},"AutomationTargetParameterName":{},"Parameters":{"shape":"S14"},"AssociationId":{},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"LastExecutionDate":{"type":"timestamp"},"LastSuccessfulExecutionDate":{"type":"timestamp"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"TargetMaps":{"shape":"S26"},"AlarmConfiguration":{"shape":"S1z"},"TriggeredAlarms":{"shape":"S2o"}}},"S2f":{"type":"structure","required":["Date","Name","Message"],"members":{"Date":{"type":"timestamp"},"Name":{},"Message":{},"AdditionalInfo":{}}},"S2j":{"type":"structure","members":{"Status":{},"DetailedStatus":{},"AssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"S2o":{"type":"list","member":{"type":"structure","required":["Name","State"],"members":{"Name":{},"State":{}}}},"S2t":{"type":"structure","required":["Name"],"members":{"Name":{},"InstanceId":{},"Parameters":{"shape":"S14"},"AutomationTargetParameterName":{},"DocumentVersion":{},"Targets":{"shape":"S18"},"ScheduleExpression":{},"OutputLocation":{"shape":"S1e"},"AssociationName":{},"MaxErrors":{},"MaxConcurrency":{},"ComplianceSeverity":{},"SyncCompliance":{},"ApplyOnlyAtCronInterval":{"type":"boolean"},"CalendarNames":{"shape":"S1q"},"TargetLocations":{"shape":"S1s"},"ScheduleOffset":{"type":"integer"},"Duration":{"type":"integer"},"TargetMaps":{"shape":"S26"},"AlarmConfiguration":{"shape":"S1z"}}},"S32":{"type":"list","member":{"type":"structure","required":["Name"],"members":{"Name":{},"Version":{},"RequireType":{},"VersionName":{}}}},"S36":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Name":{}}}},"S3i":{"type":"structure","members":{"Sha1":{},"Hash":{},"HashType":{},"Name":{},"DisplayName":{},"VersionName":{},"Owner":{},"CreatedDate":{"type":"timestamp"},"Status":{},"StatusInformation":{},"DocumentVersion":{},"Description":{},"Parameters":{"type":"list","member":{"type":"structure","members":{"Name":{},"Type":{},"Description":{},"DefaultValue":{}}}},"PlatformTypes":{"shape":"S3w"},"DocumentType":{},"SchemaVersion":{},"LatestVersion":{},"DefaultVersion":{},"DocumentFormat":{},"TargetType":{},"Tags":{"shape":"S4"},"AttachmentsInformation":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"Requires":{"shape":"S32"},"Author":{},"ReviewInformation":{"type":"list","member":{"type":"structure","members":{"ReviewedTime":{"type":"timestamp"},"Status":{},"Reviewer":{}}}},"ApprovedVersion":{},"PendingReviewVersion":{},"ReviewStatus":{},"Category":{"type":"list","member":{}},"CategoryEnum":{"type":"list","member":{}}}},"S3w":{"type":"list","member":{}},"S4c":{"type":"string","sensitive":true},"S4q":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{},"Type":{}}}},"S4v":{"type":"list","member":{"type":"structure","members":{"Arn":{}}}},"S4z":{"type":"list","member":{"type":"structure","required":["OpsItemId"],"members":{"OpsItemId":{}}}},"S5a":{"type":"map","key":{},"value":{"type":"structure","members":{"Value":{}}}},"S5j":{"type":"structure","required":["PatchFilters"],"members":{"PatchFilters":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}}}}}}},"S5p":{"type":"structure","required":["PatchRules"],"members":{"PatchRules":{"type":"list","member":{"type":"structure","required":["PatchFilterGroup"],"members":{"PatchFilterGroup":{"shape":"S5j"},"ComplianceLevel":{},"ApproveAfterDays":{"type":"integer"},"ApproveUntilDate":{},"EnableNonSecurity":{"type":"boolean"}}}}}},"S5v":{"type":"list","member":{}},"S5z":{"type":"list","member":{"type":"structure","required":["Name","Products","Configuration"],"members":{"Name":{},"Products":{"type":"list","member":{}},"Configuration":{"type":"string","sensitive":true}}}},"S69":{"type":"structure","required":["BucketName","SyncFormat","Region"],"members":{"BucketName":{},"Prefix":{},"SyncFormat":{},"Region":{},"AWSKMSKeyARN":{},"DestinationDataSharing":{"type":"structure","members":{"DestinationDataSharingType":{}}}}},"S6i":{"type":"structure","required":["SourceType","SourceRegions"],"members":{"SourceType":{},"AwsOrganizationsSource":{"shape":"S6k"},"SourceRegions":{"shape":"S6p"},"IncludeFutureRegions":{"type":"boolean"},"EnableAllOpsDataSources":{"type":"boolean"}}},"S6k":{"type":"structure","required":["OrganizationSourceType"],"members":{"OrganizationSourceType":{},"OrganizationalUnits":{"type":"list","member":{"type":"structure","members":{"OrganizationalUnitId":{}}}}}},"S6p":{"type":"list","member":{}},"S76":{"type":"structure","members":{"TotalCount":{"type":"integer"},"RemainingCount":{"type":"integer"},"SummaryItems":{"type":"list","member":{"type":"structure","members":{"Version":{},"Count":{"type":"integer"},"RemainingCount":{"type":"integer"}}}}}},"S7n":{"type":"list","member":{}},"S9n":{"type":"map","key":{},"value":{"type":"list","member":{}}},"S9s":{"type":"structure","members":{"ParameterValues":{"type":"list","member":{}},"Truncated":{"type":"boolean"}}},"S9w":{"type":"list","member":{"type":"structure","required":["DocumentName"],"members":{"DocumentName":{},"DocumentVersion":{},"Parameters":{"shape":"S9n"},"TargetParameterName":{},"Targets":{"shape":"S18"},"TargetMaps":{"shape":"S26"},"MaxConcurrency":{},"MaxErrors":{},"TargetLocations":{"shape":"S1s"}}}},"Sa6":{"type":"list","member":{"type":"structure","members":{"StepName":{},"Action":{},"TimeoutSeconds":{"type":"long"},"OnFailure":{},"MaxAttempts":{"type":"integer"},"ExecutionStartTime":{"type":"timestamp"},"ExecutionEndTime":{"type":"timestamp"},"StepStatus":{},"ResponseCode":{},"Inputs":{"type":"map","key":{},"value":{}},"Outputs":{"shape":"S9n"},"Response":{},"FailureMessage":{},"FailureDetails":{"type":"structure","members":{"FailureStage":{},"FailureType":{},"Details":{"shape":"S9n"}}},"StepExecutionId":{},"OverriddenParameters":{"shape":"S9n"},"IsEnd":{"type":"boolean"},"NextStep":{},"IsCritical":{"type":"boolean"},"ValidNextSteps":{"type":"list","member":{}},"Targets":{"shape":"S18"},"TargetLocation":{"shape":"S1t"},"TriggeredAlarms":{"shape":"S2o"},"ParentStepDetails":{"type":"structure","members":{"StepExecutionId":{},"StepName":{},"Action":{},"Iteration":{"type":"integer"},"IteratorValue":{}}}}}},"Sah":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"Sap":{"type":"structure","members":{"Id":{},"ReleaseDate":{"type":"timestamp"},"Title":{},"Description":{},"ContentUrl":{},"Vendor":{},"ProductFamily":{},"Product":{},"Classification":{},"MsrcSeverity":{},"KbNumber":{},"MsrcNumber":{},"Language":{},"AdvisoryIds":{"type":"list","member":{}},"BugzillaIds":{"type":"list","member":{}},"CVEIds":{"type":"list","member":{}},"Name":{},"Epoch":{"type":"integer"},"Version":{},"Release":{},"Arch":{},"Severity":{},"Repository":{}}},"Sbk":{"type":"list","member":{}},"Scd":{"type":"list","member":{}},"Scr":{"type":"structure","members":{"DetailedStatus":{},"InstanceAssociationStatusAggregatedCount":{"type":"map","key":{},"value":{"type":"integer"}}}},"Scz":{"type":"structure","required":["InstanceId","PatchGroup","BaselineId","OperationStartTime","OperationEndTime","Operation"],"members":{"InstanceId":{},"PatchGroup":{},"BaselineId":{},"SnapshotId":{},"InstallOverrideList":{},"OwnerInformation":{"shape":"Sd2"},"InstalledCount":{"type":"integer"},"InstalledOtherCount":{"type":"integer"},"InstalledPendingRebootCount":{"type":"integer"},"InstalledRejectedCount":{"type":"integer"},"MissingCount":{"type":"integer"},"FailedCount":{"type":"integer"},"UnreportedNotApplicableCount":{"type":"integer"},"NotApplicableCount":{"type":"integer"},"OperationStartTime":{"type":"timestamp"},"OperationEndTime":{"type":"timestamp"},"Operation":{},"LastNoRebootInstallOperationTime":{"type":"timestamp"},"RebootOption":{},"CriticalNonCompliantCount":{"type":"integer"},"SecurityNonCompliantCount":{"type":"integer"},"OtherNonCompliantCount":{"type":"integer"}}},"Sd2":{"type":"string","sensitive":true},"Sdz":{"type":"list","member":{}},"Ser":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}}}}},"Sf3":{"type":"string","sensitive":true},"Sfu":{"type":"map","key":{},"value":{"type":"structure","members":{"Values":{"type":"list","member":{"type":"string","sensitive":true},"sensitive":true}},"sensitive":true},"sensitive":true},"Sg0":{"type":"structure","required":["S3BucketName","S3Region"],"members":{"S3BucketName":{},"S3KeyPrefix":{},"S3Region":{}}},"Sgu":{"type":"list","member":{"type":"structure","required":["Key"],"members":{"Key":{},"Option":{},"Values":{"type":"list","member":{}}}}},"Sh9":{"type":"list","member":{"type":"structure","members":{"PolicyText":{},"PolicyType":{},"PolicyStatus":{}}}},"Shf":{"type":"structure","members":{"BaselineId":{},"BaselineName":{},"OperatingSystem":{},"BaselineDescription":{},"DefaultBaseline":{"type":"boolean"}}},"Sj0":{"type":"structure","members":{"CloudWatchLogGroupName":{},"CloudWatchOutputEnabled":{"type":"boolean"}}},"Sjm":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sjs":{"type":"list","member":{"type":"structure","members":{"Expression":{},"Aggregators":{"shape":"Sjs"},"Groups":{"type":"list","member":{"type":"structure","required":["Name","Filters"],"members":{"Name":{},"Filters":{"shape":"Sjm"}}}}}}},"Sk9":{"type":"list","member":{"type":"map","key":{},"value":{}}},"Sl0":{"type":"structure","members":{"RunCommand":{"type":"structure","members":{"Comment":{},"CloudWatchOutputConfig":{"shape":"Sj0"},"DocumentHash":{},"DocumentHashType":{},"DocumentVersion":{},"NotificationConfig":{"shape":"Sl2"},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"Parameters":{"shape":"S14"},"ServiceRoleArn":{},"TimeoutSeconds":{"type":"integer"}}},"Automation":{"type":"structure","members":{"DocumentVersion":{},"Parameters":{"shape":"S9n"}}},"StepFunctions":{"type":"structure","members":{"Input":{"type":"string","sensitive":true},"Name":{}}},"Lambda":{"type":"structure","members":{"ClientContext":{},"Qualifier":{},"Payload":{"type":"blob","sensitive":true}}}}},"Sl2":{"type":"structure","members":{"NotificationArn":{},"NotificationEvents":{"type":"list","member":{}},"NotificationType":{}}},"Sln":{"type":"list","member":{"type":"structure","required":["Key","Values"],"members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Slt":{"type":"list","member":{"type":"structure","members":{"AggregatorType":{},"TypeName":{},"AttributeName":{},"Values":{"type":"map","key":{},"value":{}},"Filters":{"shape":"Sln"},"Aggregators":{"shape":"Slt"}}}},"Smf":{"type":"structure","members":{"Name":{},"Type":{},"Value":{"shape":"Smg"},"Version":{"type":"long"},"Selector":{},"SourceResult":{},"LastModifiedDate":{"type":"timestamp"},"ARN":{},"DataType":{}}},"Smg":{"type":"string","sensitive":true},"Smm":{"type":"list","member":{}},"Smq":{"type":"list","member":{"shape":"Smf"}},"Sn8":{"type":"structure","members":{"SettingId":{},"SettingValue":{},"LastModifiedDate":{"type":"timestamp"},"LastModifiedUser":{},"ARN":{},"Status":{}}},"Snq":{"type":"list","member":{"type":"structure","required":["key","value"],"members":{"key":{},"value":{}}}},"So6":{"type":"structure","members":{"CommandId":{},"DocumentName":{},"DocumentVersion":{},"Comment":{},"ExpiresAfter":{"type":"timestamp"},"Parameters":{"shape":"S14"},"InstanceIds":{"shape":"Si"},"Targets":{"shape":"S18"},"RequestedDateTime":{"type":"timestamp"},"Status":{},"StatusDetails":{},"OutputS3Region":{},"OutputS3BucketName":{},"OutputS3KeyPrefix":{},"MaxConcurrency":{},"MaxErrors":{},"TargetCount":{"type":"integer"},"CompletedCount":{"type":"integer"},"ErrorCount":{"type":"integer"},"DeliveryTimedOutCount":{"type":"integer"},"ServiceRole":{},"NotificationConfig":{"shape":"Sl2"},"CloudWatchOutputConfig":{"shape":"Sj0"},"TimeoutSeconds":{"type":"integer"},"AlarmConfiguration":{"shape":"S1z"},"TriggeredAlarms":{"shape":"S2o"}}},"Sod":{"type":"list","member":{"type":"structure","members":{"Key":{},"Values":{"type":"list","member":{}},"Type":{}}}},"Sov":{"type":"structure","required":["ExecutionTime"],"members":{"ExecutionTime":{"type":"timestamp"},"ExecutionId":{},"ExecutionType":{}}},"Soy":{"type":"map","key":{},"value":{}},"Sp3":{"type":"structure","members":{"CompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sp5"}}},"Sp5":{"type":"structure","members":{"CriticalCount":{"type":"integer"},"HighCount":{"type":"integer"},"MediumCount":{"type":"integer"},"LowCount":{"type":"integer"},"InformationalCount":{"type":"integer"},"UnspecifiedCount":{"type":"integer"}}},"Sp6":{"type":"structure","members":{"NonCompliantCount":{"type":"integer"},"SeveritySummary":{"shape":"Sp5"}}},"Spd":{"type":"list","member":{"type":"structure","members":{"Type":{},"Content":{}}}},"Sqb":{"type":"structure","members":{"Arn":{}}}}}

/***/ }),
/* 622 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeActivations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ActivationList"},"DescribeAssociationExecutionTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AssociationExecutionTargets"},"DescribeAssociationExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AssociationExecutions"},"DescribeAutomationExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AutomationExecutionMetadataList"},"DescribeAutomationStepExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"StepExecutions"},"DescribeAvailablePatches":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Patches"},"DescribeEffectiveInstanceAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"DescribeEffectivePatchesForPatchBaseline":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"EffectivePatches"},"DescribeInstanceAssociationsStatus":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceAssociationStatusInfos"},"DescribeInstanceInformation":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceInformationList"},"DescribeInstancePatchStates":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstancePatchStates"},"DescribeInstancePatchStatesForPatchGroup":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstancePatchStates"},"DescribeInstancePatches":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Patches"},"DescribeInstanceProperties":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InstanceProperties"},"DescribeInventoryDeletions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"InventoryDeletions"},"DescribeMaintenanceWindowExecutionTaskInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowExecutionTaskInvocationIdentities"},"DescribeMaintenanceWindowExecutionTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowExecutionTaskIdentities"},"DescribeMaintenanceWindowExecutions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowExecutions"},"DescribeMaintenanceWindowSchedule":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ScheduledWindowExecutions"},"DescribeMaintenanceWindowTargets":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Targets"},"DescribeMaintenanceWindowTasks":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Tasks"},"DescribeMaintenanceWindows":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowIdentities"},"DescribeMaintenanceWindowsForTarget":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"WindowIdentities"},"DescribeOpsItems":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OpsItemSummaries"},"DescribeParameters":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"DescribePatchBaselines":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"BaselineIdentities"},"DescribePatchGroups":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Mappings"},"DescribePatchProperties":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Properties"},"DescribeSessions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Sessions"},"GetInventory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Entities"},"GetInventorySchema":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Schemas"},"GetOpsSummary":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Entities"},"GetParameterHistory":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetParametersByPath":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetResourcePolicies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Policies"},"ListAssociationVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"AssociationVersions"},"ListAssociations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Associations"},"ListCommandInvocations":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"CommandInvocations"},"ListCommands":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Commands"},"ListComplianceItems":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ComplianceItems"},"ListComplianceSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ComplianceSummaryItems"},"ListDocumentVersions":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentVersions"},"ListDocuments":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"DocumentIdentifiers"},"ListOpsItemEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListOpsItemRelatedItems":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"Summaries"},"ListOpsMetadata":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"OpsMetadataList"},"ListResourceComplianceSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceComplianceSummaryItems"},"ListResourceDataSync":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken","result_key":"ResourceDataSyncItems"}}}

/***/ }),
/* 623 */
/***/ (function(module, exports) {

module.exports = {"version":2,"waiters":{"CommandExecuted":{"delay":5,"operation":"GetCommandInvocation","maxAttempts":20,"acceptors":[{"expected":"Pending","matcher":"path","state":"retry","argument":"Status"},{"expected":"InProgress","matcher":"path","state":"retry","argument":"Status"},{"expected":"Delayed","matcher":"path","state":"retry","argument":"Status"},{"expected":"Success","matcher":"path","state":"success","argument":"Status"},{"expected":"Cancelled","matcher":"path","state":"failure","argument":"Status"},{"expected":"TimedOut","matcher":"path","state":"failure","argument":"Status"},{"expected":"Failed","matcher":"path","state":"failure","argument":"Status"},{"expected":"Cancelling","matcher":"path","state":"failure","argument":"Status"},{"state":"retry","matcher":"error","expected":"InvocationDoesNotExist"}]}}}

/***/ }),
/* 624 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2013-06-30","endpointPrefix":"storagegateway","jsonVersion":"1.1","protocol":"json","serviceFullName":"AWS Storage Gateway","serviceId":"Storage Gateway","signatureVersion":"v4","targetPrefix":"StorageGateway_20130630","uid":"storagegateway-2013-06-30"},"operations":{"ActivateGateway":{"input":{"type":"structure","required":["ActivationKey","GatewayName","GatewayTimezone","GatewayRegion"],"members":{"ActivationKey":{},"GatewayName":{},"GatewayTimezone":{},"GatewayRegion":{},"GatewayType":{},"TapeDriveType":{},"MediumChangerType":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddCache":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddTagsToResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"AddUploadBuffer":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AddWorkingStorage":{"input":{"type":"structure","required":["GatewayARN","DiskIds"],"members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"AssignTapePool":{"input":{"type":"structure","required":["TapeARN","PoolId"],"members":{"TapeARN":{},"PoolId":{},"BypassGovernanceRetention":{"type":"boolean"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"AssociateFileSystem":{"input":{"type":"structure","required":["UserName","Password","ClientToken","GatewayARN","LocationARN"],"members":{"UserName":{},"Password":{"shape":"Sx"},"ClientToken":{},"GatewayARN":{},"LocationARN":{},"Tags":{"shape":"S9"},"AuditDestinationARN":{},"CacheAttributes":{"shape":"S11"},"EndpointNetworkConfiguration":{"shape":"S13"}}},"output":{"type":"structure","members":{"FileSystemAssociationARN":{}}}},"AttachVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeARN","NetworkInterfaceId"],"members":{"GatewayARN":{},"TargetName":{},"VolumeARN":{},"NetworkInterfaceId":{},"DiskId":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CancelArchival":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CancelRetrieval":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateCachediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","VolumeSizeInBytes","TargetName","NetworkInterfaceId","ClientToken"],"members":{"GatewayARN":{},"VolumeSizeInBytes":{"type":"long"},"SnapshotId":{},"TargetName":{},"SourceVolumeARN":{},"NetworkInterfaceId":{},"ClientToken":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"TargetARN":{}}}},"CreateNFSFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"NFSFileShareDefaults":{"shape":"S1p"},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1w"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"AuditDestinationARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSMBFileShare":{"input":{"type":"structure","required":["ClientToken","GatewayARN","Role","LocationARN"],"members":{"ClientToken":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AccessBasedEnumeration":{"type":"boolean"},"AdminUserList":{"shape":"S25"},"ValidUserList":{"shape":"S25"},"InvalidUserList":{"shape":"S25"},"AuditDestinationARN":{},"Authentication":{},"CaseSensitivity":{},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"OplocksEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"CreateSnapshot":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"SnapshotId":{}}}},"CreateSnapshotFromVolumeRecoveryPoint":{"input":{"type":"structure","required":["VolumeARN","SnapshotDescription"],"members":{"VolumeARN":{},"SnapshotDescription":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"SnapshotId":{},"VolumeARN":{},"VolumeRecoveryPointTime":{}}}},"CreateStorediSCSIVolume":{"input":{"type":"structure","required":["GatewayARN","DiskId","PreserveExistingData","TargetName","NetworkInterfaceId"],"members":{"GatewayARN":{},"DiskId":{},"SnapshotId":{},"PreserveExistingData":{"type":"boolean"},"TargetName":{},"NetworkInterfaceId":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"TargetARN":{}}}},"CreateTapePool":{"input":{"type":"structure","required":["PoolName","StorageClass"],"members":{"PoolName":{},"StorageClass":{},"RetentionLockType":{},"RetentionLockTimeInDays":{"type":"integer"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"PoolARN":{}}}},"CreateTapeWithBarcode":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","TapeBarcode"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"TapeBarcode":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"CreateTapes":{"input":{"type":"structure","required":["GatewayARN","TapeSizeInBytes","ClientToken","NumTapesToCreate","TapeBarcodePrefix"],"members":{"GatewayARN":{},"TapeSizeInBytes":{"type":"long"},"ClientToken":{},"NumTapesToCreate":{"type":"integer"},"TapeBarcodePrefix":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"TapeARNs":{"shape":"S2x"}}}},"DeleteAutomaticTapeCreationPolicy":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN","BandwidthType"],"members":{"GatewayARN":{},"BandwidthType":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteChapCredentials":{"input":{"type":"structure","required":["TargetARN","InitiatorName"],"members":{"TargetARN":{},"InitiatorName":{}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"DeleteFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"DeleteGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DeleteSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DeleteTape":{"input":{"type":"structure","required":["GatewayARN","TapeARN"],"members":{"GatewayARN":{},"TapeARN":{},"BypassGovernanceRetention":{"type":"boolean"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapeArchive":{"input":{"type":"structure","required":["TapeARN"],"members":{"TapeARN":{},"BypassGovernanceRetention":{"type":"boolean"}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"DeleteTapePool":{"input":{"type":"structure","required":["PoolARN"],"members":{"PoolARN":{}}},"output":{"type":"structure","members":{"PoolARN":{}}}},"DeleteVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DescribeAvailabilityMonitorTest":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Status":{},"StartTime":{"type":"timestamp"}}}},"DescribeBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"DescribeBandwidthRateLimitSchedule":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"BandwidthRateLimitIntervals":{"shape":"S3u"}}}},"DescribeCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"CacheAllocatedInBytes":{"type":"long"},"CacheUsedPercentage":{"type":"double"},"CacheDirtyPercentage":{"type":"double"},"CacheHitPercentage":{"type":"double"},"CacheMissPercentage":{"type":"double"}}}},"DescribeCachediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S44"}}},"output":{"type":"structure","members":{"CachediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"SourceSnapshotId":{},"VolumeiSCSIAttributes":{"shape":"S4d"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeChapCredentials":{"input":{"type":"structure","required":["TargetARN"],"members":{"TargetARN":{}}},"output":{"type":"structure","members":{"ChapCredentials":{"type":"list","member":{"type":"structure","members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S4m"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S4m"}}}}}}},"DescribeFileSystemAssociations":{"input":{"type":"structure","required":["FileSystemAssociationARNList"],"members":{"FileSystemAssociationARNList":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"FileSystemAssociationInfoList":{"type":"list","member":{"type":"structure","members":{"FileSystemAssociationARN":{},"LocationARN":{},"FileSystemAssociationStatus":{},"AuditDestinationARN":{},"GatewayARN":{},"Tags":{"shape":"S9"},"CacheAttributes":{"shape":"S11"},"EndpointNetworkConfiguration":{"shape":"S13"},"FileSystemAssociationStatusDetails":{"type":"list","member":{"type":"structure","members":{"ErrorCode":{}}}}}}}}}},"DescribeGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayId":{},"GatewayName":{},"GatewayTimezone":{},"GatewayState":{},"GatewayNetworkInterfaces":{"type":"list","member":{"type":"structure","members":{"Ipv4Address":{},"MacAddress":{},"Ipv6Address":{}},"sensitive":true}},"GatewayType":{},"NextUpdateAvailabilityDate":{},"LastSoftwareUpdate":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{},"Tags":{"shape":"S9"},"VPCEndpoint":{},"CloudWatchLogGroupARN":{},"HostEnvironment":{},"EndpointType":{},"SoftwareUpdatesEndDate":{},"DeprecationDate":{},"GatewayCapacity":{},"SupportedGatewayCapacities":{"type":"list","member":{}},"HostEnvironmentId":{},"SoftwareVersion":{}}}},"DescribeMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"},"Timezone":{}}}},"DescribeNFSFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S5j"}}},"output":{"type":"structure","members":{"NFSFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"NFSFileShareDefaults":{"shape":"S1p"},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1w"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"AuditDestinationARN":{}}}}}}},"DescribeSMBFileShares":{"input":{"type":"structure","required":["FileShareARNList"],"members":{"FileShareARNList":{"shape":"S5j"}}},"output":{"type":"structure","members":{"SMBFileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"Path":{},"Role":{},"LocationARN":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AccessBasedEnumeration":{"type":"boolean"},"AdminUserList":{"shape":"S25"},"ValidUserList":{"shape":"S25"},"InvalidUserList":{"shape":"S25"},"AuditDestinationARN":{},"Authentication":{},"CaseSensitivity":{},"Tags":{"shape":"S9"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"VPCEndpointDNSName":{},"BucketRegion":{},"OplocksEnabled":{"type":"boolean"}}}}}}},"DescribeSMBSettings":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DomainName":{},"ActiveDirectoryStatus":{},"SMBGuestPasswordSet":{"type":"boolean"},"SMBSecurityStrategy":{},"FileSharesVisible":{"type":"boolean"},"SMBLocalGroups":{"shape":"S5z"}}}},"DescribeSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Timezone":{},"Tags":{"shape":"S9"}}}},"DescribeStorediSCSIVolumes":{"input":{"type":"structure","required":["VolumeARNs"],"members":{"VolumeARNs":{"shape":"S44"}}},"output":{"type":"structure","members":{"StorediSCSIVolumes":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"VolumeType":{},"VolumeStatus":{},"VolumeAttachmentStatus":{},"VolumeSizeInBytes":{"type":"long"},"VolumeProgress":{"type":"double"},"VolumeDiskId":{},"SourceSnapshotId":{},"PreservedExistingData":{"type":"boolean"},"VolumeiSCSIAttributes":{"shape":"S4d"},"CreatedDate":{"type":"timestamp"},"VolumeUsedInBytes":{"type":"long"},"KMSKey":{},"TargetName":{}}}}}}},"DescribeTapeArchives":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2x"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeArchives":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"CompletionTime":{"type":"timestamp"},"RetrievedTo":{},"TapeStatus":{},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"RetentionStartDate":{"type":"timestamp"},"PoolEntryDate":{"type":"timestamp"}}}},"Marker":{}}}},"DescribeTapeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"TapeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeRecoveryPointTime":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{}}}},"Marker":{}}}},"DescribeTapes":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"TapeARNs":{"shape":"S2x"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Tapes":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeCreatedDate":{"type":"timestamp"},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"VTLDevice":{},"Progress":{"type":"double"},"TapeUsedInBytes":{"type":"long"},"KMSKey":{},"PoolId":{},"Worm":{"type":"boolean"},"RetentionStartDate":{"type":"timestamp"},"PoolEntryDate":{"type":"timestamp"}}}},"Marker":{}}}},"DescribeUploadBuffer":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"UploadBufferUsedInBytes":{"type":"long"},"UploadBufferAllocatedInBytes":{"type":"long"}}}},"DescribeVTLDevices":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"VTLDeviceARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"VTLDevices":{"type":"list","member":{"type":"structure","members":{"VTLDeviceARN":{},"VTLDeviceType":{},"VTLDeviceVendor":{},"VTLDeviceProductIdentifier":{},"DeviceiSCSIAttributes":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}}}}},"Marker":{}}}},"DescribeWorkingStorage":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"DiskIds":{"shape":"Sg"},"WorkingStorageUsedInBytes":{"type":"long"},"WorkingStorageAllocatedInBytes":{"type":"long"}}}},"DetachVolume":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{},"ForceDetach":{"type":"boolean"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"DisableGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"DisassociateFileSystem":{"input":{"type":"structure","required":["FileSystemAssociationARN"],"members":{"FileSystemAssociationARN":{},"ForceDelete":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileSystemAssociationARN":{}}}},"JoinDomain":{"input":{"type":"structure","required":["GatewayARN","DomainName","UserName","Password"],"members":{"GatewayARN":{},"DomainName":{},"OrganizationalUnit":{},"DomainControllers":{"type":"list","member":{}},"TimeoutInSeconds":{"type":"integer"},"UserName":{},"Password":{"shape":"Sx"}}},"output":{"type":"structure","members":{"GatewayARN":{},"ActiveDirectoryStatus":{}}}},"ListAutomaticTapeCreationPolicies":{"input":{"type":"structure","members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"AutomaticTapeCreationPolicyInfos":{"type":"list","member":{"type":"structure","members":{"AutomaticTapeCreationRules":{"shape":"S7j"},"GatewayARN":{}}}}}}},"ListFileShares":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileShareInfoList":{"type":"list","member":{"type":"structure","members":{"FileShareType":{},"FileShareARN":{},"FileShareId":{},"FileShareStatus":{},"GatewayARN":{}}}}}}},"ListFileSystemAssociations":{"input":{"type":"structure","members":{"GatewayARN":{},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Marker":{},"NextMarker":{},"FileSystemAssociationSummaryList":{"type":"list","member":{"type":"structure","members":{"FileSystemAssociationId":{},"FileSystemAssociationARN":{},"FileSystemAssociationStatus":{},"GatewayARN":{}}}}}}},"ListGateways":{"input":{"type":"structure","members":{"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Gateways":{"type":"list","member":{"type":"structure","members":{"GatewayId":{},"GatewayARN":{},"GatewayType":{},"GatewayOperationalState":{},"GatewayName":{},"Ec2InstanceId":{},"Ec2InstanceRegion":{},"HostEnvironment":{},"HostEnvironmentId":{},"DeprecationDate":{},"SoftwareVersion":{}}}},"Marker":{}}}},"ListLocalDisks":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"Disks":{"type":"list","member":{"type":"structure","members":{"DiskId":{},"DiskPath":{},"DiskNode":{},"DiskStatus":{},"DiskSizeInBytes":{"type":"long"},"DiskAllocationType":{},"DiskAllocationResource":{},"DiskAttributeList":{"type":"list","member":{}}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"ResourceARN":{},"Marker":{},"Tags":{"shape":"S9"}}}},"ListTapePools":{"input":{"type":"structure","members":{"PoolARNs":{"type":"list","member":{}},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"PoolInfos":{"type":"list","member":{"type":"structure","members":{"PoolARN":{},"PoolName":{},"StorageClass":{},"RetentionLockType":{},"RetentionLockTimeInDays":{"type":"integer"},"PoolStatus":{}}}},"Marker":{}}}},"ListTapes":{"input":{"type":"structure","members":{"TapeARNs":{"shape":"S2x"},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"TapeInfos":{"type":"list","member":{"type":"structure","members":{"TapeARN":{},"TapeBarcode":{},"TapeSizeInBytes":{"type":"long"},"TapeStatus":{},"GatewayARN":{},"PoolId":{},"RetentionStartDate":{"type":"timestamp"},"PoolEntryDate":{"type":"timestamp"}}}},"Marker":{}}}},"ListVolumeInitiators":{"input":{"type":"structure","required":["VolumeARN"],"members":{"VolumeARN":{}}},"output":{"type":"structure","members":{"Initiators":{"type":"list","member":{}}}}},"ListVolumeRecoveryPoints":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"VolumeRecoveryPointInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeSizeInBytes":{"type":"long"},"VolumeUsageInBytes":{"type":"long"},"VolumeRecoveryPointTime":{}}}}}}},"ListVolumes":{"input":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{},"Marker":{},"VolumeInfos":{"type":"list","member":{"type":"structure","members":{"VolumeARN":{},"VolumeId":{},"GatewayARN":{},"GatewayId":{},"VolumeType":{},"VolumeSizeInBytes":{"type":"long"},"VolumeAttachmentStatus":{}}}}}}},"NotifyWhenUploaded":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RefreshCache":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"FolderList":{"type":"list","member":{}},"Recursive":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{},"NotificationId":{}}}},"RemoveTagsFromResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"ResourceARN":{}}}},"ResetCache":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"RetrieveTapeArchive":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"RetrieveTapeRecoveryPoint":{"input":{"type":"structure","required":["TapeARN","GatewayARN"],"members":{"TapeARN":{},"GatewayARN":{}}},"output":{"type":"structure","members":{"TapeARN":{}}}},"SetLocalConsolePassword":{"input":{"type":"structure","required":["GatewayARN","LocalConsolePassword"],"members":{"GatewayARN":{},"LocalConsolePassword":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"SetSMBGuestPassword":{"input":{"type":"structure","required":["GatewayARN","Password"],"members":{"GatewayARN":{},"Password":{"type":"string","sensitive":true}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"ShutdownGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartAvailabilityMonitorTest":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"StartGateway":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateAutomaticTapeCreationPolicy":{"input":{"type":"structure","required":["AutomaticTapeCreationRules","GatewayARN"],"members":{"AutomaticTapeCreationRules":{"shape":"S7j"},"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimit":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateBandwidthRateLimitSchedule":{"input":{"type":"structure","required":["GatewayARN","BandwidthRateLimitIntervals"],"members":{"GatewayARN":{},"BandwidthRateLimitIntervals":{"shape":"S3u"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateChapCredentials":{"input":{"type":"structure","required":["TargetARN","SecretToAuthenticateInitiator","InitiatorName"],"members":{"TargetARN":{},"SecretToAuthenticateInitiator":{"shape":"S4m"},"InitiatorName":{},"SecretToAuthenticateTarget":{"shape":"S4m"}}},"output":{"type":"structure","members":{"TargetARN":{},"InitiatorName":{}}}},"UpdateFileSystemAssociation":{"input":{"type":"structure","required":["FileSystemAssociationARN"],"members":{"FileSystemAssociationARN":{},"UserName":{},"Password":{"shape":"Sx"},"AuditDestinationARN":{},"CacheAttributes":{"shape":"S11"}}},"output":{"type":"structure","members":{"FileSystemAssociationARN":{}}}},"UpdateGatewayInformation":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{},"GatewayName":{},"GatewayTimezone":{},"CloudWatchLogGroupARN":{},"GatewayCapacity":{}}},"output":{"type":"structure","members":{"GatewayARN":{},"GatewayName":{}}}},"UpdateGatewaySoftwareNow":{"input":{"type":"structure","required":["GatewayARN"],"members":{"GatewayARN":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateMaintenanceStartTime":{"input":{"type":"structure","required":["GatewayARN","HourOfDay","MinuteOfHour"],"members":{"GatewayARN":{},"HourOfDay":{"type":"integer"},"MinuteOfHour":{"type":"integer"},"DayOfWeek":{"type":"integer"},"DayOfMonth":{"type":"integer"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateNFSFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"NFSFileShareDefaults":{"shape":"S1p"},"DefaultStorageClass":{},"ObjectACL":{},"ClientList":{"shape":"S1w"},"Squash":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"AuditDestinationARN":{}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBFileShare":{"input":{"type":"structure","required":["FileShareARN"],"members":{"FileShareARN":{},"KMSEncrypted":{"type":"boolean"},"KMSKey":{},"DefaultStorageClass":{},"ObjectACL":{},"ReadOnly":{"type":"boolean"},"GuessMIMETypeEnabled":{"type":"boolean"},"RequesterPays":{"type":"boolean"},"SMBACLEnabled":{"type":"boolean"},"AccessBasedEnumeration":{"type":"boolean"},"AdminUserList":{"shape":"S25"},"ValidUserList":{"shape":"S25"},"InvalidUserList":{"shape":"S25"},"AuditDestinationARN":{},"CaseSensitivity":{},"FileShareName":{},"CacheAttributes":{"shape":"S11"},"NotificationPolicy":{},"OplocksEnabled":{"type":"boolean"}}},"output":{"type":"structure","members":{"FileShareARN":{}}}},"UpdateSMBFileShareVisibility":{"input":{"type":"structure","required":["GatewayARN","FileSharesVisible"],"members":{"GatewayARN":{},"FileSharesVisible":{"type":"boolean"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSMBLocalGroups":{"input":{"type":"structure","required":["GatewayARN","SMBLocalGroups"],"members":{"GatewayARN":{},"SMBLocalGroups":{"shape":"S5z"}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSMBSecurityStrategy":{"input":{"type":"structure","required":["GatewayARN","SMBSecurityStrategy"],"members":{"GatewayARN":{},"SMBSecurityStrategy":{}}},"output":{"type":"structure","members":{"GatewayARN":{}}}},"UpdateSnapshotSchedule":{"input":{"type":"structure","required":["VolumeARN","StartAt","RecurrenceInHours"],"members":{"VolumeARN":{},"StartAt":{"type":"integer"},"RecurrenceInHours":{"type":"integer"},"Description":{},"Tags":{"shape":"S9"}}},"output":{"type":"structure","members":{"VolumeARN":{}}}},"UpdateVTLDeviceType":{"input":{"type":"structure","required":["VTLDeviceARN","DeviceType"],"members":{"VTLDeviceARN":{},"DeviceType":{}}},"output":{"type":"structure","members":{"VTLDeviceARN":{}}}}},"shapes":{"S9":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sg":{"type":"list","member":{}},"Sx":{"type":"string","sensitive":true},"S11":{"type":"structure","members":{"CacheStaleTimeoutInSeconds":{"type":"integer"}}},"S13":{"type":"structure","members":{"IpAddresses":{"type":"list","member":{}}}},"S1p":{"type":"structure","members":{"FileMode":{},"DirectoryMode":{},"GroupId":{"type":"long"},"OwnerId":{"type":"long"}}},"S1w":{"type":"list","member":{}},"S25":{"type":"list","member":{}},"S2x":{"type":"list","member":{}},"S3u":{"type":"list","member":{"type":"structure","required":["StartHourOfDay","StartMinuteOfHour","EndHourOfDay","EndMinuteOfHour","DaysOfWeek"],"members":{"StartHourOfDay":{"type":"integer"},"StartMinuteOfHour":{"type":"integer"},"EndHourOfDay":{"type":"integer"},"EndMinuteOfHour":{"type":"integer"},"DaysOfWeek":{"type":"list","member":{"type":"integer"}},"AverageUploadRateLimitInBitsPerSec":{"type":"long"},"AverageDownloadRateLimitInBitsPerSec":{"type":"long"}}}},"S44":{"type":"list","member":{}},"S4d":{"type":"structure","members":{"TargetARN":{},"NetworkInterfaceId":{},"NetworkInterfacePort":{"type":"integer"},"LunNumber":{"type":"integer"},"ChapEnabled":{"type":"boolean"}}},"S4m":{"type":"string","sensitive":true},"S5j":{"type":"list","member":{}},"S5z":{"type":"structure","members":{"GatewayAdmins":{"shape":"S25"}}},"S7j":{"type":"list","member":{"type":"structure","required":["TapeBarcodePrefix","PoolId","TapeSizeInBytes","MinimumNumTapes"],"members":{"TapeBarcodePrefix":{},"PoolId":{},"TapeSizeInBytes":{"type":"long"},"MinimumNumTapes":{"type":"integer"},"Worm":{"type":"boolean"}}}}}}

/***/ }),
/* 625 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeCachediSCSIVolumes":{"result_key":"CachediSCSIVolumes"},"DescribeStorediSCSIVolumes":{"result_key":"StorediSCSIVolumes"},"DescribeTapeArchives":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeArchives"},"DescribeTapeRecoveryPoints":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeRecoveryPointInfos"},"DescribeTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Tapes"},"DescribeVTLDevices":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VTLDevices"},"ListFileShares":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["Marker"],"output_token":"NextMarker","result_key":"FileShareInfoList"},"ListFileSystemAssociations":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["Marker"],"output_token":"NextMarker","result_key":"FileSystemAssociationSummaryList"},"ListGateways":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Gateways"},"ListLocalDisks":{"result_key":"Disks"},"ListTagsForResource":{"input_token":"Marker","limit_key":"Limit","non_aggregate_keys":["ResourceARN"],"output_token":"Marker","result_key":"Tags"},"ListTapePools":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"PoolInfos"},"ListTapes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"TapeInfos"},"ListVolumeRecoveryPoints":{"result_key":"VolumeRecoveryPointInfos"},"ListVolumes":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"VolumeInfos"}}}

/***/ }),
/* 626 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2012-08-10","endpointPrefix":"streams.dynamodb","jsonVersion":"1.0","protocol":"json","serviceFullName":"Amazon DynamoDB Streams","serviceId":"DynamoDB Streams","signatureVersion":"v4","signingName":"dynamodb","targetPrefix":"DynamoDBStreams_20120810","uid":"streams-dynamodb-2012-08-10"},"operations":{"DescribeStream":{"input":{"type":"structure","required":["StreamArn"],"members":{"StreamArn":{},"Limit":{"type":"integer"},"ExclusiveStartShardId":{}}},"output":{"type":"structure","members":{"StreamDescription":{"type":"structure","members":{"StreamArn":{},"StreamLabel":{},"StreamStatus":{},"StreamViewType":{},"CreationRequestDateTime":{"type":"timestamp"},"TableName":{},"KeySchema":{"type":"list","member":{"type":"structure","required":["AttributeName","KeyType"],"members":{"AttributeName":{},"KeyType":{}}}},"Shards":{"type":"list","member":{"type":"structure","members":{"ShardId":{},"SequenceNumberRange":{"type":"structure","members":{"StartingSequenceNumber":{},"EndingSequenceNumber":{}}},"ParentShardId":{}}}},"LastEvaluatedShardId":{}}}}}},"GetRecords":{"input":{"type":"structure","required":["ShardIterator"],"members":{"ShardIterator":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"Records":{"type":"list","member":{"type":"structure","members":{"eventID":{},"eventName":{},"eventVersion":{},"eventSource":{},"awsRegion":{},"dynamodb":{"type":"structure","members":{"ApproximateCreationDateTime":{"type":"timestamp"},"Keys":{"shape":"Sr"},"NewImage":{"shape":"Sr"},"OldImage":{"shape":"Sr"},"SequenceNumber":{},"SizeBytes":{"type":"long"},"StreamViewType":{}}},"userIdentity":{"type":"structure","members":{"PrincipalId":{},"Type":{}}}}}},"NextShardIterator":{}}}},"GetShardIterator":{"input":{"type":"structure","required":["StreamArn","ShardId","ShardIteratorType"],"members":{"StreamArn":{},"ShardId":{},"ShardIteratorType":{},"SequenceNumber":{}}},"output":{"type":"structure","members":{"ShardIterator":{}}}},"ListStreams":{"input":{"type":"structure","members":{"TableName":{},"Limit":{"type":"integer"},"ExclusiveStartStreamArn":{}}},"output":{"type":"structure","members":{"Streams":{"type":"list","member":{"type":"structure","members":{"StreamArn":{},"TableName":{},"StreamLabel":{}}}},"LastEvaluatedStreamArn":{}}}}},"shapes":{"Sr":{"type":"map","key":{},"value":{"shape":"St"}},"St":{"type":"structure","members":{"S":{},"N":{},"B":{"type":"blob"},"SS":{"type":"list","member":{}},"NS":{"type":"list","member":{}},"BS":{"type":"list","member":{"type":"blob"}},"M":{"type":"map","key":{},"value":{"shape":"St"}},"L":{"type":"list","member":{"shape":"St"}},"NULL":{"type":"boolean"},"BOOL":{"type":"boolean"}}}}}

/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 628 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2011-06-15","endpointPrefix":"sts","globalEndpoint":"sts.amazonaws.com","protocol":"query","serviceAbbreviation":"AWS STS","serviceFullName":"AWS Security Token Service","serviceId":"STS","signatureVersion":"v4","uid":"sts-2011-06-15","xmlNamespace":"https://sts.amazonaws.com/doc/2011-06-15/"},"operations":{"AssumeRole":{"input":{"type":"structure","required":["RoleArn","RoleSessionName"],"members":{"RoleArn":{},"RoleSessionName":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"},"TransitiveTagKeys":{"type":"list","member":{}},"ExternalId":{},"SerialNumber":{},"TokenCode":{},"SourceIdentity":{},"ProvidedContexts":{"type":"list","member":{"type":"structure","members":{"ProviderArn":{},"ContextAssertion":{}}}}}},"output":{"resultWrapper":"AssumeRoleResult","type":"structure","members":{"Credentials":{"shape":"Sl"},"AssumedRoleUser":{"shape":"Sq"},"PackedPolicySize":{"type":"integer"},"SourceIdentity":{}}}},"AssumeRoleWithSAML":{"input":{"type":"structure","required":["RoleArn","PrincipalArn","SAMLAssertion"],"members":{"RoleArn":{},"PrincipalArn":{},"SAMLAssertion":{"type":"string","sensitive":true},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithSAMLResult","type":"structure","members":{"Credentials":{"shape":"Sl"},"AssumedRoleUser":{"shape":"Sq"},"PackedPolicySize":{"type":"integer"},"Subject":{},"SubjectType":{},"Issuer":{},"Audience":{},"NameQualifier":{},"SourceIdentity":{}}}},"AssumeRoleWithWebIdentity":{"input":{"type":"structure","required":["RoleArn","RoleSessionName","WebIdentityToken"],"members":{"RoleArn":{},"RoleSessionName":{},"WebIdentityToken":{"type":"string","sensitive":true},"ProviderId":{},"PolicyArns":{"shape":"S4"},"Policy":{},"DurationSeconds":{"type":"integer"}}},"output":{"resultWrapper":"AssumeRoleWithWebIdentityResult","type":"structure","members":{"Credentials":{"shape":"Sl"},"SubjectFromWebIdentityToken":{},"AssumedRoleUser":{"shape":"Sq"},"PackedPolicySize":{"type":"integer"},"Provider":{},"Audience":{},"SourceIdentity":{}}}},"DecodeAuthorizationMessage":{"input":{"type":"structure","required":["EncodedMessage"],"members":{"EncodedMessage":{}}},"output":{"resultWrapper":"DecodeAuthorizationMessageResult","type":"structure","members":{"DecodedMessage":{}}}},"GetAccessKeyInfo":{"input":{"type":"structure","required":["AccessKeyId"],"members":{"AccessKeyId":{}}},"output":{"resultWrapper":"GetAccessKeyInfoResult","type":"structure","members":{"Account":{}}}},"GetCallerIdentity":{"input":{"type":"structure","members":{}},"output":{"resultWrapper":"GetCallerIdentityResult","type":"structure","members":{"UserId":{},"Account":{},"Arn":{}}}},"GetFederationToken":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"Policy":{},"PolicyArns":{"shape":"S4"},"DurationSeconds":{"type":"integer"},"Tags":{"shape":"S8"}}},"output":{"resultWrapper":"GetFederationTokenResult","type":"structure","members":{"Credentials":{"shape":"Sl"},"FederatedUser":{"type":"structure","required":["FederatedUserId","Arn"],"members":{"FederatedUserId":{},"Arn":{}}},"PackedPolicySize":{"type":"integer"}}}},"GetSessionToken":{"input":{"type":"structure","members":{"DurationSeconds":{"type":"integer"},"SerialNumber":{},"TokenCode":{}}},"output":{"resultWrapper":"GetSessionTokenResult","type":"structure","members":{"Credentials":{"shape":"Sl"}}}}},"shapes":{"S4":{"type":"list","member":{"type":"structure","members":{"arn":{}}}},"S8":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sl":{"type":"structure","required":["AccessKeyId","SecretAccessKey","SessionToken","Expiration"],"members":{"AccessKeyId":{},"SecretAccessKey":{"type":"string","sensitive":true},"SessionToken":{},"Expiration":{"type":"timestamp"}}},"Sq":{"type":"structure","required":["AssumedRoleId","Arn"],"members":{"AssumedRoleId":{},"Arn":{}}}}}

/***/ }),
/* 629 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 630 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2017-07-01","endpointPrefix":"translate","jsonVersion":"1.1","protocol":"json","serviceFullName":"Amazon Translate","serviceId":"Translate","signatureVersion":"v4","signingName":"translate","targetPrefix":"AWSShineFrontendService_20170701","uid":"translate-2017-07-01"},"operations":{"CreateParallelData":{"input":{"type":"structure","required":["Name","ParallelDataConfig","ClientToken"],"members":{"Name":{},"Description":{},"ParallelDataConfig":{"shape":"S4"},"EncryptionKey":{"shape":"S7"},"ClientToken":{"idempotencyToken":true},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"Name":{},"Status":{}}}},"DeleteParallelData":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"Name":{},"Status":{}}}},"DeleteTerminology":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}}},"DescribeTextTranslationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"TextTranslationJobProperties":{"shape":"Sn"}}}},"GetParallelData":{"input":{"type":"structure","required":["Name"],"members":{"Name":{}}},"output":{"type":"structure","members":{"ParallelDataProperties":{"shape":"S17"},"DataLocation":{"shape":"S1b"},"AuxiliaryDataLocation":{"shape":"S1b"},"LatestUpdateAttemptAuxiliaryDataLocation":{"shape":"S1b"}}}},"GetTerminology":{"input":{"type":"structure","required":["Name"],"members":{"Name":{},"TerminologyDataFormat":{}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"S1g"},"TerminologyDataLocation":{"shape":"S1j"},"AuxiliaryDataLocation":{"shape":"S1j"}}}},"ImportTerminology":{"input":{"type":"structure","required":["Name","MergeStrategy","TerminologyData"],"members":{"Name":{},"MergeStrategy":{},"Description":{},"TerminologyData":{"type":"structure","required":["File","Format"],"members":{"File":{"type":"blob","sensitive":true},"Format":{},"Directionality":{}}},"EncryptionKey":{"shape":"S7"},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{"TerminologyProperties":{"shape":"S1g"},"AuxiliaryDataLocation":{"shape":"S1j"}}}},"ListLanguages":{"input":{"type":"structure","members":{"DisplayLanguageCode":{},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"Languages":{"type":"list","member":{"type":"structure","required":["LanguageName","LanguageCode"],"members":{"LanguageName":{},"LanguageCode":{}}}},"DisplayLanguageCode":{},"NextToken":{}}}},"ListParallelData":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"ParallelDataPropertiesList":{"type":"list","member":{"shape":"S17"}},"NextToken":{}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sb"}}}},"ListTerminologies":{"input":{"type":"structure","members":{"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TerminologyPropertiesList":{"type":"list","member":{"shape":"S1g"}},"NextToken":{}}}},"ListTextTranslationJobs":{"input":{"type":"structure","members":{"Filter":{"type":"structure","members":{"JobName":{},"JobStatus":{},"SubmittedBeforeTime":{"type":"timestamp"},"SubmittedAfterTime":{"type":"timestamp"}}},"NextToken":{},"MaxResults":{"type":"integer"}}},"output":{"type":"structure","members":{"TextTranslationJobPropertiesList":{"type":"list","member":{"shape":"Sn"}},"NextToken":{}}}},"StartTextTranslationJob":{"input":{"type":"structure","required":["InputDataConfig","OutputDataConfig","DataAccessRoleArn","SourceLanguageCode","TargetLanguageCodes","ClientToken"],"members":{"JobName":{},"InputDataConfig":{"shape":"Sx"},"OutputDataConfig":{"shape":"Sz"},"DataAccessRoleArn":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"St"},"TerminologyNames":{"shape":"Su"},"ParallelDataNames":{"shape":"Su"},"ClientToken":{"idempotencyToken":true},"Settings":{"shape":"S11"}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"StopTextTranslationJob":{"input":{"type":"structure","required":["JobId"],"members":{"JobId":{}}},"output":{"type":"structure","members":{"JobId":{},"JobStatus":{}}}},"TagResource":{"input":{"type":"structure","required":["ResourceArn","Tags"],"members":{"ResourceArn":{},"Tags":{"shape":"Sb"}}},"output":{"type":"structure","members":{}}},"TranslateDocument":{"input":{"type":"structure","required":["Document","SourceLanguageCode","TargetLanguageCode"],"members":{"Document":{"type":"structure","required":["Content","ContentType"],"members":{"Content":{"type":"blob","sensitive":true},"ContentType":{}}},"TerminologyNames":{"shape":"Su"},"SourceLanguageCode":{},"TargetLanguageCode":{},"Settings":{"shape":"S11"}}},"output":{"type":"structure","required":["TranslatedDocument","SourceLanguageCode","TargetLanguageCode"],"members":{"TranslatedDocument":{"type":"structure","required":["Content"],"members":{"Content":{"type":"blob","sensitive":true}}},"SourceLanguageCode":{},"TargetLanguageCode":{},"AppliedTerminologies":{"shape":"S2m"},"AppliedSettings":{"shape":"S11"}}}},"TranslateText":{"input":{"type":"structure","required":["Text","SourceLanguageCode","TargetLanguageCode"],"members":{"Text":{},"TerminologyNames":{"shape":"Su"},"SourceLanguageCode":{},"TargetLanguageCode":{},"Settings":{"shape":"S11"}}},"output":{"type":"structure","required":["TranslatedText","SourceLanguageCode","TargetLanguageCode"],"members":{"TranslatedText":{},"SourceLanguageCode":{},"TargetLanguageCode":{},"AppliedTerminologies":{"shape":"S2m"},"AppliedSettings":{"shape":"S11"}}}},"UntagResource":{"input":{"type":"structure","required":["ResourceArn","TagKeys"],"members":{"ResourceArn":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateParallelData":{"input":{"type":"structure","required":["Name","ParallelDataConfig","ClientToken"],"members":{"Name":{},"Description":{},"ParallelDataConfig":{"shape":"S4"},"ClientToken":{"idempotencyToken":true}}},"output":{"type":"structure","members":{"Name":{},"Status":{},"LatestUpdateAttemptStatus":{},"LatestUpdateAttemptAt":{"type":"timestamp"}}}}},"shapes":{"S4":{"type":"structure","members":{"S3Uri":{},"Format":{}}},"S7":{"type":"structure","required":["Type","Id"],"members":{"Type":{},"Id":{}}},"Sb":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"Sn":{"type":"structure","members":{"JobId":{},"JobName":{},"JobStatus":{},"JobDetails":{"type":"structure","members":{"TranslatedDocumentsCount":{"type":"integer"},"DocumentsWithErrorsCount":{"type":"integer"},"InputDocumentsCount":{"type":"integer"}}},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"St"},"TerminologyNames":{"shape":"Su"},"ParallelDataNames":{"shape":"Su"},"Message":{},"SubmittedTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"InputDataConfig":{"shape":"Sx"},"OutputDataConfig":{"shape":"Sz"},"DataAccessRoleArn":{},"Settings":{"shape":"S11"}}},"St":{"type":"list","member":{}},"Su":{"type":"list","member":{}},"Sx":{"type":"structure","required":["S3Uri","ContentType"],"members":{"S3Uri":{},"ContentType":{}}},"Sz":{"type":"structure","required":["S3Uri"],"members":{"S3Uri":{},"EncryptionKey":{"shape":"S7"}}},"S11":{"type":"structure","members":{"Formality":{},"Profanity":{},"Brevity":{}}},"S17":{"type":"structure","members":{"Name":{},"Arn":{},"Description":{},"Status":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"S19"},"ParallelDataConfig":{"shape":"S4"},"Message":{},"ImportedDataSize":{"type":"long"},"ImportedRecordCount":{"type":"long"},"FailedRecordCount":{"type":"long"},"SkippedRecordCount":{"type":"long"},"EncryptionKey":{"shape":"S7"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"LatestUpdateAttemptStatus":{},"LatestUpdateAttemptAt":{"type":"timestamp"}}},"S19":{"type":"list","member":{}},"S1b":{"type":"structure","required":["RepositoryType","Location"],"members":{"RepositoryType":{},"Location":{}}},"S1g":{"type":"structure","members":{"Name":{},"Description":{},"Arn":{},"SourceLanguageCode":{},"TargetLanguageCodes":{"shape":"S19"},"EncryptionKey":{"shape":"S7"},"SizeBytes":{"type":"integer"},"TermCount":{"type":"integer"},"CreatedAt":{"type":"timestamp"},"LastUpdatedAt":{"type":"timestamp"},"Directionality":{},"Message":{},"SkippedTermCount":{"type":"integer"},"Format":{}}},"S1j":{"type":"structure","required":["RepositoryType","Location"],"members":{"RepositoryType":{},"Location":{}}},"S2m":{"type":"list","member":{"type":"structure","members":{"Name":{},"Terms":{"type":"list","member":{"type":"structure","members":{"SourceText":{},"TargetText":{}}}}}}}}}

/***/ }),
/* 631 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"ListLanguages":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListParallelData":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTerminologies":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"ListTextTranslationJobs":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"}}}

/***/ }),
/* 632 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2015-08-24","endpointPrefix":"waf","jsonVersion":"1.1","protocol":"json","serviceAbbreviation":"WAF","serviceFullName":"AWS WAF","serviceId":"WAF","signatureVersion":"v4","targetPrefix":"AWSWAF_20150824","uid":"waf-2015-08-24"},"operations":{"CreateByteMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"},"ChangeToken":{}}}},"CreateGeoMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"},"ChangeToken":{}}}},"CreateIPSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"},"ChangeToken":{}}}},"CreateRateBasedRule":{"input":{"type":"structure","required":["Name","MetricName","RateKey","RateLimit","ChangeToken"],"members":{"Name":{},"MetricName":{},"RateKey":{},"RateLimit":{"type":"long"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"},"ChangeToken":{}}}},"CreateRegexMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"},"ChangeToken":{}}}},"CreateRegexPatternSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"},"ChangeToken":{}}}},"CreateRule":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"},"ChangeToken":{}}}},"CreateRuleGroup":{"input":{"type":"structure","required":["Name","MetricName","ChangeToken"],"members":{"Name":{},"MetricName":{},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"},"ChangeToken":{}}}},"CreateSizeConstraintSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"},"ChangeToken":{}}}},"CreateSqlInjectionMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"},"ChangeToken":{}}}},"CreateWebACL":{"input":{"type":"structure","required":["Name","MetricName","DefaultAction","ChangeToken"],"members":{"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"ChangeToken":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"},"ChangeToken":{}}}},"CreateWebACLMigrationStack":{"input":{"type":"structure","required":["WebACLId","S3BucketName","IgnoreUnsupportedType"],"members":{"WebACLId":{},"S3BucketName":{},"IgnoreUnsupportedType":{"type":"boolean"}}},"output":{"type":"structure","required":["S3ObjectUrl"],"members":{"S3ObjectUrl":{}}}},"CreateXssMatchSet":{"input":{"type":"structure","required":["Name","ChangeToken"],"members":{"Name":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2k"},"ChangeToken":{}}}},"DeleteByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken"],"members":{"ByteMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken"],"members":{"GeoMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken"],"members":{"IPSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeletePermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{}}},"DeleteRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","ChangeToken"],"members":{"RegexMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","ChangeToken"],"members":{"RegexPatternSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRule":{"input":{"type":"structure","required":["RuleId","ChangeToken"],"members":{"RuleId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","ChangeToken"],"members":{"RuleGroupId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken"],"members":{"SizeConstraintSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"DeleteXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken"],"members":{"XssMatchSetId":{},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId"],"members":{"ByteMatchSetId":{}}},"output":{"type":"structure","members":{"ByteMatchSet":{"shape":"S5"}}}},"GetChangeToken":{"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"GetChangeTokenStatus":{"input":{"type":"structure","required":["ChangeToken"],"members":{"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeTokenStatus":{}}}},"GetGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId"],"members":{"GeoMatchSetId":{}}},"output":{"type":"structure","members":{"GeoMatchSet":{"shape":"Sh"}}}},"GetIPSet":{"input":{"type":"structure","required":["IPSetId"],"members":{"IPSetId":{}}},"output":{"type":"structure","members":{"IPSet":{"shape":"So"}}}},"GetLoggingConfiguration":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3s"}}}},"GetPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn"],"members":{"ResourceArn":{}}},"output":{"type":"structure","members":{"Policy":{}}}},"GetRateBasedRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S12"}}}},"GetRateBasedRuleManagedKeys":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{},"NextMarker":{}}},"output":{"type":"structure","members":{"ManagedKeys":{"type":"list","member":{}},"NextMarker":{}}}},"GetRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId"],"members":{"RegexMatchSetId":{}}},"output":{"type":"structure","members":{"RegexMatchSet":{"shape":"S19"}}}},"GetRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId"],"members":{"RegexPatternSetId":{}}},"output":{"type":"structure","members":{"RegexPatternSet":{"shape":"S1e"}}}},"GetRule":{"input":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}},"output":{"type":"structure","members":{"Rule":{"shape":"S1j"}}}},"GetRuleGroup":{"input":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{}}},"output":{"type":"structure","members":{"RuleGroup":{"shape":"S1m"}}}},"GetSampledRequests":{"input":{"type":"structure","required":["WebAclId","RuleId","TimeWindow","MaxItems"],"members":{"WebAclId":{},"RuleId":{},"TimeWindow":{"shape":"S4e"},"MaxItems":{"type":"long"}}},"output":{"type":"structure","members":{"SampledRequests":{"type":"list","member":{"type":"structure","required":["Request","Weight"],"members":{"Request":{"type":"structure","members":{"ClientIP":{},"Country":{},"URI":{},"Method":{},"HTTPVersion":{},"Headers":{"type":"list","member":{"type":"structure","members":{"Name":{},"Value":{}}}}}},"Weight":{"type":"long"},"Timestamp":{"type":"timestamp"},"Action":{},"RuleWithinRuleGroup":{}}}},"PopulationSize":{"type":"long"},"TimeWindow":{"shape":"S4e"}}}},"GetSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId"],"members":{"SizeConstraintSetId":{}}},"output":{"type":"structure","members":{"SizeConstraintSet":{"shape":"S1p"}}}},"GetSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId"],"members":{"SqlInjectionMatchSetId":{}}},"output":{"type":"structure","members":{"SqlInjectionMatchSet":{"shape":"S1w"}}}},"GetWebACL":{"input":{"type":"structure","required":["WebACLId"],"members":{"WebACLId":{}}},"output":{"type":"structure","members":{"WebACL":{"shape":"S23"}}}},"GetXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId"],"members":{"XssMatchSetId":{}}},"output":{"type":"structure","members":{"XssMatchSet":{"shape":"S2k"}}}},"ListActivatedRulesInRuleGroup":{"input":{"type":"structure","members":{"RuleGroupId":{},"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ActivatedRules":{"shape":"S24"}}}},"ListByteMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"ByteMatchSets":{"type":"list","member":{"type":"structure","required":["ByteMatchSetId","Name"],"members":{"ByteMatchSetId":{},"Name":{}}}}}}},"ListGeoMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"GeoMatchSets":{"type":"list","member":{"type":"structure","required":["GeoMatchSetId","Name"],"members":{"GeoMatchSetId":{},"Name":{}}}}}}},"ListIPSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"IPSets":{"type":"list","member":{"type":"structure","required":["IPSetId","Name"],"members":{"IPSetId":{},"Name":{}}}}}}},"ListLoggingConfigurations":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"LoggingConfigurations":{"type":"list","member":{"shape":"S3s"}},"NextMarker":{}}}},"ListRateBasedRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5p"}}}},"ListRegexMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexMatchSets":{"type":"list","member":{"type":"structure","required":["RegexMatchSetId","Name"],"members":{"RegexMatchSetId":{},"Name":{}}}}}}},"ListRegexPatternSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RegexPatternSets":{"type":"list","member":{"type":"structure","required":["RegexPatternSetId","Name"],"members":{"RegexPatternSetId":{},"Name":{}}}}}}},"ListRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name"],"members":{"RuleGroupId":{},"Name":{}}}}}}},"ListRules":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"Rules":{"shape":"S5p"}}}},"ListSizeConstraintSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SizeConstraintSets":{"type":"list","member":{"type":"structure","required":["SizeConstraintSetId","Name"],"members":{"SizeConstraintSetId":{},"Name":{}}}}}}},"ListSqlInjectionMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"SqlInjectionMatchSets":{"type":"list","member":{"type":"structure","required":["SqlInjectionMatchSetId","Name"],"members":{"SqlInjectionMatchSetId":{},"Name":{}}}}}}},"ListSubscribedRuleGroups":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"RuleGroups":{"type":"list","member":{"type":"structure","required":["RuleGroupId","Name","MetricName"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}}}}}},"ListTagsForResource":{"input":{"type":"structure","required":["ResourceARN"],"members":{"NextMarker":{},"Limit":{"type":"integer"},"ResourceARN":{}}},"output":{"type":"structure","members":{"NextMarker":{},"TagInfoForResource":{"type":"structure","members":{"ResourceARN":{},"TagList":{"shape":"Sx"}}}}}},"ListWebACLs":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"WebACLs":{"type":"list","member":{"type":"structure","required":["WebACLId","Name"],"members":{"WebACLId":{},"Name":{}}}}}}},"ListXssMatchSets":{"input":{"type":"structure","members":{"NextMarker":{},"Limit":{"type":"integer"}}},"output":{"type":"structure","members":{"NextMarker":{},"XssMatchSets":{"type":"list","member":{"type":"structure","required":["XssMatchSetId","Name"],"members":{"XssMatchSetId":{},"Name":{}}}}}}},"PutLoggingConfiguration":{"input":{"type":"structure","required":["LoggingConfiguration"],"members":{"LoggingConfiguration":{"shape":"S3s"}}},"output":{"type":"structure","members":{"LoggingConfiguration":{"shape":"S3s"}}}},"PutPermissionPolicy":{"input":{"type":"structure","required":["ResourceArn","Policy"],"members":{"ResourceArn":{},"Policy":{}}},"output":{"type":"structure","members":{}}},"TagResource":{"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sx"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateByteMatchSet":{"input":{"type":"structure","required":["ByteMatchSetId","ChangeToken","Updates"],"members":{"ByteMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ByteMatchTuple"],"members":{"Action":{},"ByteMatchTuple":{"shape":"S8"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateGeoMatchSet":{"input":{"type":"structure","required":["GeoMatchSetId","ChangeToken","Updates"],"members":{"GeoMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","GeoMatchConstraint"],"members":{"Action":{},"GeoMatchConstraint":{"shape":"Sj"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateIPSet":{"input":{"type":"structure","required":["IPSetId","ChangeToken","Updates"],"members":{"IPSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","IPSetDescriptor"],"members":{"Action":{},"IPSetDescriptor":{"shape":"Sq"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRateBasedRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates","RateLimit"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7f"},"RateLimit":{"type":"long"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexMatchSet":{"input":{"type":"structure","required":["RegexMatchSetId","Updates","ChangeToken"],"members":{"RegexMatchSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexMatchTuple"],"members":{"Action":{},"RegexMatchTuple":{"shape":"S1b"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRegexPatternSet":{"input":{"type":"structure","required":["RegexPatternSetId","Updates","ChangeToken"],"members":{"RegexPatternSetId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","RegexPatternString"],"members":{"Action":{},"RegexPatternString":{}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRule":{"input":{"type":"structure","required":["RuleId","ChangeToken","Updates"],"members":{"RuleId":{},"ChangeToken":{},"Updates":{"shape":"S7f"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateRuleGroup":{"input":{"type":"structure","required":["RuleGroupId","Updates","ChangeToken"],"members":{"RuleGroupId":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"ChangeToken":{}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSizeConstraintSet":{"input":{"type":"structure","required":["SizeConstraintSetId","ChangeToken","Updates"],"members":{"SizeConstraintSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SizeConstraint"],"members":{"Action":{},"SizeConstraint":{"shape":"S1r"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateSqlInjectionMatchSet":{"input":{"type":"structure","required":["SqlInjectionMatchSetId","ChangeToken","Updates"],"members":{"SqlInjectionMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","SqlInjectionMatchTuple"],"members":{"Action":{},"SqlInjectionMatchTuple":{"shape":"S1y"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateWebACL":{"input":{"type":"structure","required":["WebACLId","ChangeToken"],"members":{"WebACLId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","ActivatedRule"],"members":{"Action":{},"ActivatedRule":{"shape":"S25"}}}},"DefaultAction":{"shape":"S20"}}},"output":{"type":"structure","members":{"ChangeToken":{}}}},"UpdateXssMatchSet":{"input":{"type":"structure","required":["XssMatchSetId","ChangeToken","Updates"],"members":{"XssMatchSetId":{},"ChangeToken":{},"Updates":{"type":"list","member":{"type":"structure","required":["Action","XssMatchTuple"],"members":{"Action":{},"XssMatchTuple":{"shape":"S2m"}}}}}},"output":{"type":"structure","members":{"ChangeToken":{}}}}},"shapes":{"S5":{"type":"structure","required":["ByteMatchSetId","ByteMatchTuples"],"members":{"ByteMatchSetId":{},"Name":{},"ByteMatchTuples":{"type":"list","member":{"shape":"S8"}}}},"S8":{"type":"structure","required":["FieldToMatch","TargetString","TextTransformation","PositionalConstraint"],"members":{"FieldToMatch":{"shape":"S9"},"TargetString":{"type":"blob"},"TextTransformation":{},"PositionalConstraint":{}}},"S9":{"type":"structure","required":["Type"],"members":{"Type":{},"Data":{}}},"Sh":{"type":"structure","required":["GeoMatchSetId","GeoMatchConstraints"],"members":{"GeoMatchSetId":{},"Name":{},"GeoMatchConstraints":{"type":"list","member":{"shape":"Sj"}}}},"Sj":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"So":{"type":"structure","required":["IPSetId","IPSetDescriptors"],"members":{"IPSetId":{},"Name":{},"IPSetDescriptors":{"type":"list","member":{"shape":"Sq"}}}},"Sq":{"type":"structure","required":["Type","Value"],"members":{"Type":{},"Value":{}}},"Sx":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"S12":{"type":"structure","required":["RuleId","MatchPredicates","RateKey","RateLimit"],"members":{"RuleId":{},"Name":{},"MetricName":{},"MatchPredicates":{"shape":"S13"},"RateKey":{},"RateLimit":{"type":"long"}}},"S13":{"type":"list","member":{"shape":"S14"}},"S14":{"type":"structure","required":["Negated","Type","DataId"],"members":{"Negated":{"type":"boolean"},"Type":{},"DataId":{}}},"S19":{"type":"structure","members":{"RegexMatchSetId":{},"Name":{},"RegexMatchTuples":{"type":"list","member":{"shape":"S1b"}}}},"S1b":{"type":"structure","required":["FieldToMatch","TextTransformation","RegexPatternSetId"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"RegexPatternSetId":{}}},"S1e":{"type":"structure","required":["RegexPatternSetId","RegexPatternStrings"],"members":{"RegexPatternSetId":{},"Name":{},"RegexPatternStrings":{"type":"list","member":{}}}},"S1j":{"type":"structure","required":["RuleId","Predicates"],"members":{"RuleId":{},"Name":{},"MetricName":{},"Predicates":{"shape":"S13"}}},"S1m":{"type":"structure","required":["RuleGroupId"],"members":{"RuleGroupId":{},"Name":{},"MetricName":{}}},"S1p":{"type":"structure","required":["SizeConstraintSetId","SizeConstraints"],"members":{"SizeConstraintSetId":{},"Name":{},"SizeConstraints":{"type":"list","member":{"shape":"S1r"}}}},"S1r":{"type":"structure","required":["FieldToMatch","TextTransformation","ComparisonOperator","Size"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{},"ComparisonOperator":{},"Size":{"type":"long"}}},"S1w":{"type":"structure","required":["SqlInjectionMatchSetId","SqlInjectionMatchTuples"],"members":{"SqlInjectionMatchSetId":{},"Name":{},"SqlInjectionMatchTuples":{"type":"list","member":{"shape":"S1y"}}}},"S1y":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S20":{"type":"structure","required":["Type"],"members":{"Type":{}}},"S23":{"type":"structure","required":["WebACLId","DefaultAction","Rules"],"members":{"WebACLId":{},"Name":{},"MetricName":{},"DefaultAction":{"shape":"S20"},"Rules":{"shape":"S24"},"WebACLArn":{}}},"S24":{"type":"list","member":{"shape":"S25"}},"S25":{"type":"structure","required":["Priority","RuleId"],"members":{"Priority":{"type":"integer"},"RuleId":{},"Action":{"shape":"S20"},"OverrideAction":{"type":"structure","required":["Type"],"members":{"Type":{}}},"Type":{},"ExcludedRules":{"type":"list","member":{"type":"structure","required":["RuleId"],"members":{"RuleId":{}}}}}},"S2k":{"type":"structure","required":["XssMatchSetId","XssMatchTuples"],"members":{"XssMatchSetId":{},"Name":{},"XssMatchTuples":{"type":"list","member":{"shape":"S2m"}}}},"S2m":{"type":"structure","required":["FieldToMatch","TextTransformation"],"members":{"FieldToMatch":{"shape":"S9"},"TextTransformation":{}}},"S3s":{"type":"structure","required":["ResourceArn","LogDestinationConfigs"],"members":{"ResourceArn":{},"LogDestinationConfigs":{"type":"list","member":{}},"RedactedFields":{"type":"list","member":{"shape":"S9"}}}},"S4e":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"}}},"S5p":{"type":"list","member":{"type":"structure","required":["RuleId","Name"],"members":{"RuleId":{},"Name":{}}}},"S7f":{"type":"list","member":{"type":"structure","required":["Action","Predicate"],"members":{"Action":{},"Predicate":{"shape":"S14"}}}}}}

/***/ }),
/* 633 */
/***/ (function(module, exports) {

module.exports = {"pagination":{}}

/***/ }),
/* 634 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-05-01","endpointPrefix":"workdocs","jsonVersion":"1.1","protocol":"rest-json","serviceFullName":"Amazon WorkDocs","serviceId":"WorkDocs","signatureVersion":"v4","uid":"workdocs-2016-05-01"},"operations":{"AbortDocumentVersionUpload":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"}}}},"ActivateUser":{"http":{"requestUri":"/api/v1/users/{UserId}/activation","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"AddResourcePermissions":{"http":{"requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":201},"input":{"type":"structure","required":["ResourceId","Principals"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"Principals":{"type":"list","member":{"type":"structure","required":["Id","Type","Role"],"members":{"Id":{},"Type":{},"Role":{}}}},"NotificationOptions":{"type":"structure","members":{"SendEmail":{"type":"boolean"},"EmailMessage":{"shape":"St"}}}}},"output":{"type":"structure","members":{"ShareResults":{"type":"list","member":{"type":"structure","members":{"PrincipalId":{},"InviteePrincipalId":{},"Role":{},"Status":{},"ShareId":{},"StatusMessage":{"shape":"St"}}}}}}},"CreateComment":{"http":{"requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment","responseCode":201},"input":{"type":"structure","required":["DocumentId","VersionId","Text"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Visibility":{},"NotifyCollaborators":{"type":"boolean"}}},"output":{"type":"structure","members":{"Comment":{"shape":"S13"}}}},"CreateCustomMetadata":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId","CustomMetadata"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionid"},"CustomMetadata":{"shape":"S16"}}},"output":{"type":"structure","members":{}}},"CreateFolder":{"http":{"requestUri":"/api/v1/folders","responseCode":201},"input":{"type":"structure","required":["ParentFolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Name":{"shape":"S1b"},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"}}}},"CreateLabels":{"http":{"method":"PUT","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId","Labels"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"Labels":{"shape":"S1g"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{}}},"CreateNotificationSubscription":{"http":{"requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId","Endpoint","Protocol","SubscriptionType"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Endpoint":{},"Protocol":{},"SubscriptionType":{}}},"output":{"type":"structure","members":{"Subscription":{"shape":"S1p"}}}},"CreateUser":{"http":{"requestUri":"/api/v1/users","responseCode":201},"input":{"type":"structure","required":["Username","GivenName","Surname","Password"],"members":{"OrganizationId":{},"Username":{"shape":"S9"},"EmailAddress":{"shape":"Sa"},"GivenName":{"shape":"Sb"},"Surname":{"shape":"Sb"},"Password":{"type":"string","sensitive":true},"TimeZoneId":{},"StorageRule":{"shape":"Sj"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"DeactivateUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}/activation","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"UserId":{"location":"uri","locationName":"UserId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}}},"DeleteComment":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comment/{CommentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId","CommentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"CommentId":{"location":"uri","locationName":"CommentId"}}}},"DeleteCustomMetadata":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/customMetadata","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"VersionId":{"location":"querystring","locationName":"versionId"},"Keys":{"location":"querystring","locationName":"keys","type":"list","member":{}},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteDocument":{"http":{"method":"DELETE","requestUri":"/api/v1/documents/{DocumentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"}}}},"DeleteDocumentVersion":{"http":{"method":"DELETE","requestUri":"/api/v1/documentVersions/{DocumentId}/versions/{VersionId}","responseCode":204},"input":{"type":"structure","required":["DocumentId","VersionId","DeletePriorVersions"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"DeletePriorVersions":{"location":"querystring","locationName":"deletePriorVersions","type":"boolean"}}}},"DeleteFolder":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteFolderContents":{"http":{"method":"DELETE","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":204},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"}}}},"DeleteLabels":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/labels","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"ResourceId":{"location":"uri","locationName":"ResourceId"},"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Labels":{"shape":"S1g","location":"querystring","locationName":"labels"},"DeleteAll":{"location":"querystring","locationName":"deleteAll","type":"boolean"}}},"output":{"type":"structure","members":{}}},"DeleteNotificationSubscription":{"http":{"method":"DELETE","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions/{SubscriptionId}","responseCode":200},"input":{"type":"structure","required":["SubscriptionId","OrganizationId"],"members":{"SubscriptionId":{"location":"uri","locationName":"SubscriptionId"},"OrganizationId":{"location":"uri","locationName":"OrganizationId"}}}},"DeleteUser":{"http":{"method":"DELETE","requestUri":"/api/v1/users/{UserId}","responseCode":204},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"}}}},"DescribeActivities":{"http":{"method":"GET","requestUri":"/api/v1/activities","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"StartTime":{"location":"querystring","locationName":"startTime","type":"timestamp"},"EndTime":{"location":"querystring","locationName":"endTime","type":"timestamp"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"ActivityTypes":{"location":"querystring","locationName":"activityTypes"},"ResourceId":{"location":"querystring","locationName":"resourceId"},"UserId":{"location":"querystring","locationName":"userId"},"IncludeIndirectActivities":{"location":"querystring","locationName":"includeIndirectActivities","type":"boolean"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"UserActivities":{"type":"list","member":{"type":"structure","members":{"Type":{},"TimeStamp":{"type":"timestamp"},"IsIndirectActivity":{"type":"boolean"},"OrganizationId":{},"Initiator":{"shape":"S2e"},"Participants":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S2e"}},"Groups":{"shape":"S2h"}}},"ResourceMetadata":{"shape":"S2k"},"OriginalParent":{"shape":"S2k"},"CommentMetadata":{"shape":"S2m"}}}},"Marker":{}}}},"DescribeComments":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}/comments","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Comments":{"type":"list","member":{"shape":"S13"}},"Marker":{}}}},"DescribeDocumentVersions":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Include":{"location":"querystring","locationName":"include"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"DocumentVersions":{"type":"list","member":{"shape":"S2w"}},"Marker":{}}}},"DescribeFolderContents":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/contents","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Sort":{"location":"querystring","locationName":"sort"},"Order":{"location":"querystring","locationName":"order"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"},"Type":{"location":"querystring","locationName":"type"},"Include":{"location":"querystring","locationName":"include"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S39"},"Documents":{"shape":"S3a"},"Marker":{}}}},"DescribeGroups":{"http":{"method":"GET","requestUri":"/api/v1/groups","responseCode":200},"input":{"type":"structure","required":["SearchQuery"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"SearchQuery":{"shape":"S3d","location":"querystring","locationName":"searchQuery"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Groups":{"shape":"S2h"},"Marker":{}}}},"DescribeNotificationSubscriptions":{"http":{"method":"GET","requestUri":"/api/v1/organizations/{OrganizationId}/subscriptions","responseCode":200},"input":{"type":"structure","required":["OrganizationId"],"members":{"OrganizationId":{"location":"uri","locationName":"OrganizationId"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"}}},"output":{"type":"structure","members":{"Subscriptions":{"type":"list","member":{"shape":"S1p"}},"Marker":{}}}},"DescribeResourcePermissions":{"http":{"method":"GET","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":200},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"querystring","locationName":"principalId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Principals":{"type":"list","member":{"type":"structure","members":{"Id":{},"Type":{},"Roles":{"type":"list","member":{"type":"structure","members":{"Role":{},"Type":{}}}}}}},"Marker":{}}}},"DescribeRootFolders":{"http":{"method":"GET","requestUri":"/api/v1/me/root","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S39"},"Marker":{}}}},"DescribeUsers":{"http":{"method":"GET","requestUri":"/api/v1/users","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"OrganizationId":{"location":"querystring","locationName":"organizationId"},"UserIds":{"location":"querystring","locationName":"userIds"},"Query":{"shape":"S3d","location":"querystring","locationName":"query"},"Include":{"location":"querystring","locationName":"include"},"Order":{"location":"querystring","locationName":"order"},"Sort":{"location":"querystring","locationName":"sort"},"Marker":{"location":"querystring","locationName":"marker"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"}}},"output":{"type":"structure","members":{"Users":{"type":"list","member":{"shape":"S8"}},"TotalNumberOfUsers":{"deprecated":true,"type":"long"},"Marker":{}}}},"GetCurrentUser":{"http":{"method":"GET","requestUri":"/api/v1/me","responseCode":200},"input":{"type":"structure","required":["AuthenticationToken"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}},"GetDocument":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S3b"},"CustomMetadata":{"shape":"S16"}}}},"GetDocumentPath":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/path","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S44"}}}},"GetDocumentVersion":{"http":{"method":"GET","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"Fields":{"location":"querystring","locationName":"fields"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S2w"},"CustomMetadata":{"shape":"S16"}}}},"GetFolder":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"IncludeCustomMetadata":{"location":"querystring","locationName":"includeCustomMetadata","type":"boolean"}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S1d"},"CustomMetadata":{"shape":"S16"}}}},"GetFolderPath":{"http":{"method":"GET","requestUri":"/api/v1/folders/{FolderId}/path","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Fields":{"location":"querystring","locationName":"fields"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Path":{"shape":"S44"}}}},"GetResources":{"http":{"method":"GET","requestUri":"/api/v1/resources","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"querystring","locationName":"userId"},"CollectionType":{"location":"querystring","locationName":"collectionType"},"Limit":{"location":"querystring","locationName":"limit","type":"integer"},"Marker":{"location":"querystring","locationName":"marker"}}},"output":{"type":"structure","members":{"Folders":{"shape":"S39"},"Documents":{"shape":"S3a"},"Marker":{}}}},"InitiateDocumentVersionUpload":{"http":{"requestUri":"/api/v1/documents","responseCode":201},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"Id":{},"Name":{"shape":"S1b"},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"ContentType":{},"DocumentSizeInBytes":{"type":"long"},"ParentFolderId":{}}},"output":{"type":"structure","members":{"Metadata":{"shape":"S3b"},"UploadMetadata":{"type":"structure","members":{"UploadUrl":{"shape":"S31"},"SignedHeaders":{"type":"map","key":{},"value":{}}}}}}},"RemoveAllResourcePermissions":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions","responseCode":204},"input":{"type":"structure","required":["ResourceId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"}}}},"RemoveResourcePermission":{"http":{"method":"DELETE","requestUri":"/api/v1/resources/{ResourceId}/permissions/{PrincipalId}","responseCode":204},"input":{"type":"structure","required":["ResourceId","PrincipalId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"ResourceId":{"location":"uri","locationName":"ResourceId"},"PrincipalId":{"location":"uri","locationName":"PrincipalId"},"PrincipalType":{"location":"querystring","locationName":"type"}}}},"RestoreDocumentVersions":{"http":{"requestUri":"/api/v1/documentVersions/restore/{DocumentId}","responseCode":204},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"}}}},"SearchResources":{"http":{"requestUri":"/api/v1/search","responseCode":200},"input":{"type":"structure","members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"QueryText":{"shape":"S3d"},"QueryScopes":{"type":"list","member":{}},"OrganizationId":{},"AdditionalResponseFields":{"type":"list","member":{}},"Filters":{"type":"structure","members":{"TextLocales":{"type":"list","member":{}},"ContentCategories":{"type":"list","member":{}},"ResourceTypes":{"type":"list","member":{}},"Labels":{"type":"list","member":{}},"Principals":{"type":"list","member":{"type":"structure","required":["Id"],"members":{"Id":{},"Roles":{"type":"list","member":{}}}}},"AncestorIds":{"type":"list","member":{}},"SearchCollectionTypes":{"type":"list","member":{}},"SizeRange":{"type":"structure","members":{"StartValue":{"type":"long"},"EndValue":{"type":"long"}}},"CreatedRange":{"shape":"S5d"},"ModifiedRange":{"shape":"S5d"}}},"OrderBy":{"type":"list","member":{"type":"structure","members":{"Field":{},"Order":{}}}},"Limit":{"type":"integer"},"Marker":{}}},"output":{"type":"structure","members":{"Items":{"type":"list","member":{"type":"structure","members":{"ResourceType":{},"WebUrl":{"type":"string","sensitive":true},"DocumentMetadata":{"shape":"S3b"},"FolderMetadata":{"shape":"S1d"},"CommentMetadata":{"shape":"S2m"},"DocumentVersionMetadata":{"shape":"S2w"}}}},"Marker":{}}}},"UpdateDocument":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}","responseCode":200},"input":{"type":"structure","required":["DocumentId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"Name":{"shape":"S1b"},"ParentFolderId":{},"ResourceState":{}}}},"UpdateDocumentVersion":{"http":{"method":"PATCH","requestUri":"/api/v1/documents/{DocumentId}/versions/{VersionId}","responseCode":200},"input":{"type":"structure","required":["DocumentId","VersionId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"DocumentId":{"location":"uri","locationName":"DocumentId"},"VersionId":{"location":"uri","locationName":"VersionId"},"VersionStatus":{}}}},"UpdateFolder":{"http":{"method":"PATCH","requestUri":"/api/v1/folders/{FolderId}","responseCode":200},"input":{"type":"structure","required":["FolderId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"FolderId":{"location":"uri","locationName":"FolderId"},"Name":{"shape":"S1b"},"ParentFolderId":{},"ResourceState":{}}}},"UpdateUser":{"http":{"method":"PATCH","requestUri":"/api/v1/users/{UserId}","responseCode":200},"input":{"type":"structure","required":["UserId"],"members":{"AuthenticationToken":{"shape":"S2","location":"header","locationName":"Authentication"},"UserId":{"location":"uri","locationName":"UserId"},"GivenName":{"shape":"Sb"},"Surname":{"shape":"Sb"},"Type":{},"StorageRule":{"shape":"Sj"},"TimeZoneId":{},"Locale":{},"GrantPoweruserPrivileges":{}}},"output":{"type":"structure","members":{"User":{"shape":"S8"}}}}},"shapes":{"S2":{"type":"string","sensitive":true},"S8":{"type":"structure","members":{"Id":{},"Username":{"shape":"S9"},"EmailAddress":{"shape":"Sa"},"GivenName":{"shape":"Sb"},"Surname":{"shape":"Sb"},"OrganizationId":{},"RootFolderId":{},"RecycleBinFolderId":{},"Status":{},"Type":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"TimeZoneId":{},"Locale":{},"Storage":{"type":"structure","members":{"StorageUtilizedInBytes":{"type":"long"},"StorageRule":{"shape":"Sj"}}}}},"S9":{"type":"string","sensitive":true},"Sa":{"type":"string","sensitive":true},"Sb":{"type":"string","sensitive":true},"Sj":{"type":"structure","members":{"StorageAllocatedInBytes":{"type":"long"},"StorageType":{}}},"St":{"type":"string","sensitive":true},"S10":{"type":"string","sensitive":true},"S13":{"type":"structure","required":["CommentId"],"members":{"CommentId":{},"ParentId":{},"ThreadId":{},"Text":{"shape":"S10"},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"Status":{},"Visibility":{},"RecipientId":{}}},"S16":{"type":"map","key":{},"value":{}},"S1b":{"type":"string","sensitive":true},"S1d":{"type":"structure","members":{"Id":{},"Name":{"shape":"S1b"},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ResourceState":{},"Signature":{},"Labels":{"shape":"S1g"},"Size":{"type":"long"},"LatestVersionSize":{"type":"long"}}},"S1g":{"type":"list","member":{}},"S1p":{"type":"structure","members":{"SubscriptionId":{},"EndPoint":{},"Protocol":{}}},"S2e":{"type":"structure","members":{"Id":{},"Username":{"shape":"S9"},"GivenName":{"shape":"Sb"},"Surname":{"shape":"Sb"},"EmailAddress":{"shape":"Sa"}}},"S2h":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{}}}},"S2k":{"type":"structure","members":{"Type":{},"Name":{"shape":"S1b"},"OriginalName":{"shape":"S1b"},"Id":{},"VersionId":{},"Owner":{"shape":"S2e"},"ParentId":{}}},"S2m":{"type":"structure","members":{"CommentId":{},"Contributor":{"shape":"S8"},"CreatedTimestamp":{"type":"timestamp"},"CommentStatus":{},"RecipientId":{},"ContributorId":{}}},"S2w":{"type":"structure","members":{"Id":{},"Name":{"shape":"S1b"},"ContentType":{},"Size":{"type":"long"},"Signature":{},"Status":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"ContentCreatedTimestamp":{"type":"timestamp"},"ContentModifiedTimestamp":{"type":"timestamp"},"CreatorId":{},"Thumbnail":{"type":"map","key":{},"value":{"shape":"S31"}},"Source":{"type":"map","key":{},"value":{"shape":"S31"}}}},"S31":{"type":"string","sensitive":true},"S39":{"type":"list","member":{"shape":"S1d"}},"S3a":{"type":"list","member":{"shape":"S3b"}},"S3b":{"type":"structure","members":{"Id":{},"CreatorId":{},"ParentFolderId":{},"CreatedTimestamp":{"type":"timestamp"},"ModifiedTimestamp":{"type":"timestamp"},"LatestVersionMetadata":{"shape":"S2w"},"ResourceState":{},"Labels":{"shape":"S1g"}}},"S3d":{"type":"string","sensitive":true},"S44":{"type":"structure","members":{"Components":{"type":"list","member":{"type":"structure","members":{"Id":{},"Name":{"shape":"S1b"}}}}}},"S5d":{"type":"structure","members":{"StartValue":{"type":"timestamp"},"EndValue":{"type":"timestamp"}}}}}

/***/ }),
/* 635 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"DescribeActivities":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"UserActivities"},"DescribeComments":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Comments"},"DescribeDocumentVersions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"DocumentVersions"},"DescribeFolderContents":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":["Folders","Documents"]},"DescribeGroups":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Groups"},"DescribeNotificationSubscriptions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Subscriptions"},"DescribeResourcePermissions":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Principals"},"DescribeRootFolders":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Folders"},"DescribeUsers":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Users"},"SearchResources":{"input_token":"Marker","limit_key":"Limit","output_token":"Marker","result_key":"Items"}}}

/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = {"version":"2.0","metadata":{"apiVersion":"2016-04-12","endpointPrefix":"xray","protocol":"rest-json","serviceFullName":"AWS X-Ray","serviceId":"XRay","signatureVersion":"v4","uid":"xray-2016-04-12"},"operations":{"BatchGetTraces":{"http":{"requestUri":"/Traces"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Traces":{"type":"list","member":{"type":"structure","members":{"Id":{},"Duration":{"type":"double"},"LimitExceeded":{"type":"boolean"},"Segments":{"type":"list","member":{"type":"structure","members":{"Id":{},"Document":{}}}}}}},"UnprocessedTraceIds":{"type":"list","member":{}},"NextToken":{}}}},"CreateGroup":{"http":{"requestUri":"/CreateGroup"},"input":{"type":"structure","required":["GroupName"],"members":{"GroupName":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"Group":{"shape":"So"}}}},"CreateSamplingRule":{"http":{"requestUri":"/CreateSamplingRule"},"input":{"type":"structure","required":["SamplingRule"],"members":{"SamplingRule":{"shape":"Sq"},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S16"}}}},"DeleteGroup":{"http":{"requestUri":"/DeleteGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{}}},"DeleteResourcePolicy":{"http":{"requestUri":"/DeleteResourcePolicy"},"input":{"type":"structure","required":["PolicyName"],"members":{"PolicyName":{},"PolicyRevisionId":{}}},"output":{"type":"structure","members":{}}},"DeleteSamplingRule":{"http":{"requestUri":"/DeleteSamplingRule"},"input":{"type":"structure","members":{"RuleName":{},"RuleARN":{}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S16"}}}},"GetEncryptionConfig":{"http":{"requestUri":"/EncryptionConfig"},"input":{"type":"structure","members":{}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S1j"}}}},"GetGroup":{"http":{"requestUri":"/GetGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{}}},"output":{"type":"structure","members":{"Group":{"shape":"So"}}}},"GetGroups":{"http":{"requestUri":"/Groups"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"Groups":{"type":"list","member":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"}}}},"NextToken":{}}}},"GetInsight":{"http":{"requestUri":"/Insight"},"input":{"type":"structure","required":["InsightId"],"members":{"InsightId":{}}},"output":{"type":"structure","members":{"Insight":{"type":"structure","members":{"InsightId":{},"GroupARN":{},"GroupName":{},"RootCauseServiceId":{"shape":"S1x"},"Categories":{"shape":"S1z"},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Summary":{},"ClientRequestImpactStatistics":{"shape":"S23"},"RootCauseServiceRequestImpactStatistics":{"shape":"S23"},"TopAnomalousServices":{"shape":"S25"}}}}}},"GetInsightEvents":{"http":{"requestUri":"/InsightEvents"},"input":{"type":"structure","required":["InsightId"],"members":{"InsightId":{},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InsightEvents":{"type":"list","member":{"type":"structure","members":{"Summary":{},"EventTime":{"type":"timestamp"},"ClientRequestImpactStatistics":{"shape":"S23"},"RootCauseServiceRequestImpactStatistics":{"shape":"S23"},"TopAnomalousServices":{"shape":"S25"}}}},"NextToken":{}}}},"GetInsightImpactGraph":{"http":{"requestUri":"/InsightImpactGraph"},"input":{"type":"structure","required":["InsightId","StartTime","EndTime"],"members":{"InsightId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"NextToken":{}}},"output":{"type":"structure","members":{"InsightId":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"ServiceGraphStartTime":{"type":"timestamp"},"ServiceGraphEndTime":{"type":"timestamp"},"Services":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"Type":{},"Name":{},"Names":{"shape":"S1y"},"AccountId":{},"Edges":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"}}}}}}},"NextToken":{}}}},"GetInsightSummaries":{"http":{"requestUri":"/InsightSummaries"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"States":{"type":"list","member":{}},"GroupARN":{},"GroupName":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"MaxResults":{"type":"integer"},"NextToken":{}}},"output":{"type":"structure","members":{"InsightSummaries":{"type":"list","member":{"type":"structure","members":{"InsightId":{},"GroupARN":{},"GroupName":{},"RootCauseServiceId":{"shape":"S1x"},"Categories":{"shape":"S1z"},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Summary":{},"ClientRequestImpactStatistics":{"shape":"S23"},"RootCauseServiceRequestImpactStatistics":{"shape":"S23"},"TopAnomalousServices":{"shape":"S25"},"LastUpdateTime":{"type":"timestamp"}}}},"NextToken":{}}}},"GetSamplingRules":{"http":{"requestUri":"/GetSamplingRules"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingRuleRecords":{"type":"list","member":{"shape":"S16"}},"NextToken":{}}}},"GetSamplingStatisticSummaries":{"http":{"requestUri":"/SamplingStatisticSummaries"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"SamplingStatisticSummaries":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"BorrowCount":{"type":"integer"},"SampledCount":{"type":"integer"}}}},"NextToken":{}}}},"GetSamplingTargets":{"http":{"requestUri":"/SamplingTargets"},"input":{"type":"structure","required":["SamplingStatisticsDocuments"],"members":{"SamplingStatisticsDocuments":{"type":"list","member":{"type":"structure","required":["RuleName","ClientID","Timestamp","RequestCount","SampledCount"],"members":{"RuleName":{},"ClientID":{},"Timestamp":{"type":"timestamp"},"RequestCount":{"type":"integer"},"SampledCount":{"type":"integer"},"BorrowCount":{"type":"integer"}}}}}},"output":{"type":"structure","members":{"SamplingTargetDocuments":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"FixedRate":{"type":"double"},"ReservoirQuota":{"type":"integer"},"ReservoirQuotaTTL":{"type":"timestamp"},"Interval":{"type":"integer"}}}},"LastRuleModification":{"type":"timestamp"},"UnprocessedStatistics":{"type":"list","member":{"type":"structure","members":{"RuleName":{},"ErrorCode":{},"Message":{}}}}}}},"GetServiceGraph":{"http":{"requestUri":"/ServiceGraph"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"NextToken":{}}},"output":{"type":"structure","members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Services":{"shape":"S3e"},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTimeSeriesServiceStatistics":{"http":{"requestUri":"/TimeSeriesServiceStatistics"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"GroupName":{},"GroupARN":{},"EntitySelectorExpression":{},"Period":{"type":"integer"},"ForecastStatistics":{"type":"boolean"},"NextToken":{}}},"output":{"type":"structure","members":{"TimeSeriesServiceStatistics":{"type":"list","member":{"type":"structure","members":{"Timestamp":{"type":"timestamp"},"EdgeSummaryStatistics":{"shape":"S3i"},"ServiceSummaryStatistics":{"shape":"S3q"},"ServiceForecastStatistics":{"type":"structure","members":{"FaultCountHigh":{"type":"long"},"FaultCountLow":{"type":"long"}}},"ResponseTimeHistogram":{"shape":"S3l"}}}},"ContainsOldGroupVersions":{"type":"boolean"},"NextToken":{}}}},"GetTraceGraph":{"http":{"requestUri":"/TraceGraph"},"input":{"type":"structure","required":["TraceIds"],"members":{"TraceIds":{"shape":"S2"},"NextToken":{}}},"output":{"type":"structure","members":{"Services":{"shape":"S3e"},"NextToken":{}}}},"GetTraceSummaries":{"http":{"requestUri":"/TraceSummaries"},"input":{"type":"structure","required":["StartTime","EndTime"],"members":{"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"TimeRangeType":{},"Sampling":{"type":"boolean"},"SamplingStrategy":{"type":"structure","members":{"Name":{},"Value":{"type":"double"}}},"FilterExpression":{},"NextToken":{}}},"output":{"type":"structure","members":{"TraceSummaries":{"type":"list","member":{"type":"structure","members":{"Id":{},"StartTime":{"type":"timestamp"},"Duration":{"type":"double"},"ResponseTime":{"type":"double"},"HasFault":{"type":"boolean"},"HasError":{"type":"boolean"},"HasThrottle":{"type":"boolean"},"IsPartial":{"type":"boolean"},"Http":{"type":"structure","members":{"HttpURL":{},"HttpStatus":{"type":"integer"},"HttpMethod":{},"UserAgent":{},"ClientIp":{}}},"Annotations":{"type":"map","key":{},"value":{"type":"list","member":{"type":"structure","members":{"AnnotationValue":{"type":"structure","members":{"NumberValue":{"type":"double"},"BooleanValue":{"type":"boolean"},"StringValue":{}}},"ServiceIds":{"shape":"S4d"}}}}},"Users":{"type":"list","member":{"type":"structure","members":{"UserName":{},"ServiceIds":{"shape":"S4d"}}}},"ServiceIds":{"shape":"S4d"},"ResourceARNs":{"type":"list","member":{"type":"structure","members":{"ARN":{}}}},"InstanceIds":{"type":"list","member":{"type":"structure","members":{"Id":{}}}},"AvailabilityZones":{"type":"list","member":{"type":"structure","members":{"Name":{}}}},"EntryPoint":{"shape":"S1x"},"FaultRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1y"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S4s"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"ErrorRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1y"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Exceptions":{"shape":"S4s"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"ResponseTimeRootCauses":{"type":"list","member":{"type":"structure","members":{"Services":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1y"},"Type":{},"AccountId":{},"EntityPath":{"type":"list","member":{"type":"structure","members":{"Name":{},"Coverage":{"type":"double"},"Remote":{"type":"boolean"}}}},"Inferred":{"type":"boolean"}}}},"ClientImpacting":{"type":"boolean"}}}},"Revision":{"type":"integer"},"MatchedEventTime":{"type":"timestamp"}}}},"ApproximateTime":{"type":"timestamp"},"TracesProcessedCount":{"type":"long"},"NextToken":{}}}},"ListResourcePolicies":{"http":{"requestUri":"/ListResourcePolicies"},"input":{"type":"structure","members":{"NextToken":{}}},"output":{"type":"structure","members":{"ResourcePolicies":{"type":"list","member":{"shape":"S5a"}},"NextToken":{}}}},"ListTagsForResource":{"http":{"requestUri":"/ListTagsForResource"},"input":{"type":"structure","required":["ResourceARN"],"members":{"ResourceARN":{},"NextToken":{}}},"output":{"type":"structure","members":{"Tags":{"shape":"Sj"},"NextToken":{}}}},"PutEncryptionConfig":{"http":{"requestUri":"/PutEncryptionConfig"},"input":{"type":"structure","required":["Type"],"members":{"KeyId":{},"Type":{}}},"output":{"type":"structure","members":{"EncryptionConfig":{"shape":"S1j"}}}},"PutResourcePolicy":{"http":{"requestUri":"/PutResourcePolicy"},"input":{"type":"structure","required":["PolicyName","PolicyDocument"],"members":{"PolicyName":{},"PolicyDocument":{},"PolicyRevisionId":{},"BypassPolicyLockoutCheck":{"type":"boolean"}}},"output":{"type":"structure","members":{"ResourcePolicy":{"shape":"S5a"}}}},"PutTelemetryRecords":{"http":{"requestUri":"/TelemetryRecords"},"input":{"type":"structure","required":["TelemetryRecords"],"members":{"TelemetryRecords":{"type":"list","member":{"type":"structure","required":["Timestamp"],"members":{"Timestamp":{"type":"timestamp"},"SegmentsReceivedCount":{"type":"integer"},"SegmentsSentCount":{"type":"integer"},"SegmentsSpilloverCount":{"type":"integer"},"SegmentsRejectedCount":{"type":"integer"},"BackendConnectionErrors":{"type":"structure","members":{"TimeoutCount":{"type":"integer"},"ConnectionRefusedCount":{"type":"integer"},"HTTPCode4XXCount":{"type":"integer"},"HTTPCode5XXCount":{"type":"integer"},"UnknownHostCount":{"type":"integer"},"OtherCount":{"type":"integer"}}}}}},"EC2InstanceId":{},"Hostname":{},"ResourceARN":{}}},"output":{"type":"structure","members":{}}},"PutTraceSegments":{"http":{"requestUri":"/TraceSegments"},"input":{"type":"structure","required":["TraceSegmentDocuments"],"members":{"TraceSegmentDocuments":{"type":"list","member":{}}}},"output":{"type":"structure","members":{"UnprocessedTraceSegments":{"type":"list","member":{"type":"structure","members":{"Id":{},"ErrorCode":{},"Message":{}}}}}}},"TagResource":{"http":{"requestUri":"/TagResource"},"input":{"type":"structure","required":["ResourceARN","Tags"],"members":{"ResourceARN":{},"Tags":{"shape":"Sj"}}},"output":{"type":"structure","members":{}}},"UntagResource":{"http":{"requestUri":"/UntagResource"},"input":{"type":"structure","required":["ResourceARN","TagKeys"],"members":{"ResourceARN":{},"TagKeys":{"type":"list","member":{}}}},"output":{"type":"structure","members":{}}},"UpdateGroup":{"http":{"requestUri":"/UpdateGroup"},"input":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"}}},"output":{"type":"structure","members":{"Group":{"shape":"So"}}}},"UpdateSamplingRule":{"http":{"requestUri":"/UpdateSamplingRule"},"input":{"type":"structure","required":["SamplingRuleUpdate"],"members":{"SamplingRuleUpdate":{"type":"structure","members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"Host":{},"ServiceName":{},"ServiceType":{},"HTTPMethod":{},"URLPath":{},"Attributes":{"shape":"S12"}}}}},"output":{"type":"structure","members":{"SamplingRuleRecord":{"shape":"S16"}}}}},"shapes":{"S2":{"type":"list","member":{}},"Si":{"type":"structure","members":{"InsightsEnabled":{"type":"boolean"},"NotificationsEnabled":{"type":"boolean"}}},"Sj":{"type":"list","member":{"type":"structure","required":["Key","Value"],"members":{"Key":{},"Value":{}}}},"So":{"type":"structure","members":{"GroupName":{},"GroupARN":{},"FilterExpression":{},"InsightsConfiguration":{"shape":"Si"}}},"Sq":{"type":"structure","required":["ResourceARN","Priority","FixedRate","ReservoirSize","ServiceName","ServiceType","Host","HTTPMethod","URLPath","Version"],"members":{"RuleName":{},"RuleARN":{},"ResourceARN":{},"Priority":{"type":"integer"},"FixedRate":{"type":"double"},"ReservoirSize":{"type":"integer"},"ServiceName":{},"ServiceType":{},"Host":{},"HTTPMethod":{},"URLPath":{},"Version":{"type":"integer"},"Attributes":{"shape":"S12"}}},"S12":{"type":"map","key":{},"value":{}},"S16":{"type":"structure","members":{"SamplingRule":{"shape":"Sq"},"CreatedAt":{"type":"timestamp"},"ModifiedAt":{"type":"timestamp"}}},"S1j":{"type":"structure","members":{"KeyId":{},"Status":{},"Type":{}}},"S1x":{"type":"structure","members":{"Name":{},"Names":{"shape":"S1y"},"AccountId":{},"Type":{}}},"S1y":{"type":"list","member":{}},"S1z":{"type":"list","member":{}},"S23":{"type":"structure","members":{"FaultCount":{"type":"long"},"OkCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S25":{"type":"list","member":{"type":"structure","members":{"ServiceId":{"shape":"S1x"}}}},"S3e":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"Name":{},"Names":{"shape":"S1y"},"Root":{"type":"boolean"},"AccountId":{},"Type":{},"State":{},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"Edges":{"type":"list","member":{"type":"structure","members":{"ReferenceId":{"type":"integer"},"StartTime":{"type":"timestamp"},"EndTime":{"type":"timestamp"},"SummaryStatistics":{"shape":"S3i"},"ResponseTimeHistogram":{"shape":"S3l"},"Aliases":{"type":"list","member":{"type":"structure","members":{"Name":{},"Names":{"type":"list","member":{}},"Type":{}}}},"EdgeType":{},"ReceivedEventAgeHistogram":{"shape":"S3l"}}}},"SummaryStatistics":{"shape":"S3q"},"DurationHistogram":{"shape":"S3l"},"ResponseTimeHistogram":{"shape":"S3l"}}}},"S3i":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S3j"},"FaultStatistics":{"shape":"S3k"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S3j":{"type":"structure","members":{"ThrottleCount":{"type":"long"},"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S3k":{"type":"structure","members":{"OtherCount":{"type":"long"},"TotalCount":{"type":"long"}}},"S3l":{"type":"list","member":{"type":"structure","members":{"Value":{"type":"double"},"Count":{"type":"integer"}}}},"S3q":{"type":"structure","members":{"OkCount":{"type":"long"},"ErrorStatistics":{"shape":"S3j"},"FaultStatistics":{"shape":"S3k"},"TotalCount":{"type":"long"},"TotalResponseTime":{"type":"double"}}},"S4d":{"type":"list","member":{"shape":"S1x"}},"S4s":{"type":"list","member":{"type":"structure","members":{"Name":{},"Message":{}}}},"S5a":{"type":"structure","members":{"PolicyName":{},"PolicyDocument":{},"PolicyRevisionId":{},"LastUpdatedTime":{"type":"timestamp"}}}}}

/***/ }),
/* 637 */
/***/ (function(module, exports) {

module.exports = {"pagination":{"BatchGetTraces":{"input_token":"NextToken","non_aggregate_keys":["UnprocessedTraceIds"],"output_token":"NextToken","result_key":"Traces"},"GetGroups":{"input_token":"NextToken","output_token":"NextToken","result_key":"Groups"},"GetInsightEvents":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetInsightSummaries":{"input_token":"NextToken","limit_key":"MaxResults","output_token":"NextToken"},"GetSamplingRules":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingRuleRecords"},"GetSamplingStatisticSummaries":{"input_token":"NextToken","output_token":"NextToken","result_key":"SamplingStatisticSummaries"},"GetServiceGraph":{"input_token":"NextToken","non_aggregate_keys":["StartTime","EndTime","ContainsOldGroupVersions"],"output_token":"NextToken","result_key":"Services"},"GetTimeSeriesServiceStatistics":{"input_token":"NextToken","non_aggregate_keys":["ContainsOldGroupVersions"],"output_token":"NextToken","result_key":"TimeSeriesServiceStatistics"},"GetTraceGraph":{"input_token":"NextToken","output_token":"NextToken","result_key":"Services"},"GetTraceSummaries":{"input_token":"NextToken","non_aggregate_keys":["TracesProcessedCount","ApproximateTime"],"output_token":"NextToken","result_key":"TraceSummaries"},"ListResourcePolicies":{"input_token":"NextToken","output_token":"NextToken","result_key":"ResourcePolicies"},"ListTagsForResource":{"input_token":"NextToken","output_token":"NextToken","result_key":"Tags"}}}

/***/ }),
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */
/***/ (function(module, exports) {

module.exports = {"rules":{"*/*":{"endpoint":"{service}.{region}.amazonaws.com"},"cn-*/*":{"endpoint":"{service}.{region}.amazonaws.com.cn"},"eu-isoe-*/*":"euIsoe","us-iso-*/*":"usIso","us-isob-*/*":"usIsob","us-isof-*/*":"usIsof","*/budgets":"globalSSL","*/cloudfront":"globalSSL","*/sts":"globalSSL","*/importexport":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2","globalEndpoint":true},"*/route53":"globalSSL","cn-*/route53":{"endpoint":"{service}.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-northwest-1"},"us-gov-*/route53":"globalGovCloud","us-iso-*/route53":{"endpoint":"{service}.c2s.ic.gov","globalEndpoint":true,"signingRegion":"us-iso-east-1"},"us-isob-*/route53":{"endpoint":"{service}.sc2s.sgov.gov","globalEndpoint":true,"signingRegion":"us-isob-east-1"},"*/waf":"globalSSL","*/iam":"globalSSL","cn-*/iam":{"endpoint":"{service}.cn-north-1.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-north-1"},"us-iso-*/iam":{"endpoint":"{service}.us-iso-east-1.c2s.ic.gov","globalEndpoint":true,"signingRegion":"us-iso-east-1"},"us-gov-*/iam":"globalGovCloud","*/ce":{"endpoint":"{service}.us-east-1.amazonaws.com","globalEndpoint":true,"signingRegion":"us-east-1"},"cn-*/ce":{"endpoint":"{service}.cn-northwest-1.amazonaws.com.cn","globalEndpoint":true,"signingRegion":"cn-northwest-1"},"us-gov-*/sts":{"endpoint":"{service}.{region}.amazonaws.com"},"us-gov-west-1/s3":"s3signature","us-west-1/s3":"s3signature","us-west-2/s3":"s3signature","eu-west-1/s3":"s3signature","ap-southeast-1/s3":"s3signature","ap-southeast-2/s3":"s3signature","ap-northeast-1/s3":"s3signature","sa-east-1/s3":"s3signature","us-east-1/s3":{"endpoint":"{service}.amazonaws.com","signatureVersion":"s3"},"us-east-1/sdb":{"endpoint":"{service}.amazonaws.com","signatureVersion":"v2"},"*/sdb":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"v2"},"*/resource-explorer-2":"dualstackByDefault","*/kendra-ranking":"dualstackByDefault","*/internetmonitor":"dualstackByDefault","*/codecatalyst":"globalDualstackByDefault"},"fipsRules":{"*/*":"fipsStandard","us-gov-*/*":"fipsStandard","us-iso-*/*":{"endpoint":"{service}-fips.{region}.c2s.ic.gov"},"us-iso-*/dms":"usIso","us-isob-*/*":{"endpoint":"{service}-fips.{region}.sc2s.sgov.gov"},"us-isob-*/dms":"usIsob","cn-*/*":{"endpoint":"{service}-fips.{region}.amazonaws.com.cn"},"*/api.ecr":"fips.api.ecr","*/api.sagemaker":"fips.api.sagemaker","*/batch":"fipsDotPrefix","*/eks":"fipsDotPrefix","*/models.lex":"fips.models.lex","*/runtime.lex":"fips.runtime.lex","*/runtime.sagemaker":{"endpoint":"runtime-fips.sagemaker.{region}.amazonaws.com"},"*/iam":"fipsWithoutRegion","*/route53":"fipsWithoutRegion","*/transcribe":"fipsDotPrefix","*/waf":"fipsWithoutRegion","us-gov-*/transcribe":"fipsDotPrefix","us-gov-*/api.ecr":"fips.api.ecr","us-gov-*/models.lex":"fips.models.lex","us-gov-*/runtime.lex":"fips.runtime.lex","us-gov-*/access-analyzer":"fipsWithServiceOnly","us-gov-*/acm":"fipsWithServiceOnly","us-gov-*/acm-pca":"fipsWithServiceOnly","us-gov-*/api.sagemaker":"fipsWithServiceOnly","us-gov-*/appconfig":"fipsWithServiceOnly","us-gov-*/application-autoscaling":"fipsWithServiceOnly","us-gov-*/autoscaling":"fipsWithServiceOnly","us-gov-*/autoscaling-plans":"fipsWithServiceOnly","us-gov-*/batch":"fipsWithServiceOnly","us-gov-*/cassandra":"fipsWithServiceOnly","us-gov-*/clouddirectory":"fipsWithServiceOnly","us-gov-*/cloudformation":"fipsWithServiceOnly","us-gov-*/cloudshell":"fipsWithServiceOnly","us-gov-*/cloudtrail":"fipsWithServiceOnly","us-gov-*/config":"fipsWithServiceOnly","us-gov-*/connect":"fipsWithServiceOnly","us-gov-*/databrew":"fipsWithServiceOnly","us-gov-*/dlm":"fipsWithServiceOnly","us-gov-*/dms":"fipsWithServiceOnly","us-gov-*/dynamodb":"fipsWithServiceOnly","us-gov-*/ec2":"fipsWithServiceOnly","us-gov-*/eks":"fipsWithServiceOnly","us-gov-*/elasticache":"fipsWithServiceOnly","us-gov-*/elasticbeanstalk":"fipsWithServiceOnly","us-gov-*/elasticloadbalancing":"fipsWithServiceOnly","us-gov-*/elasticmapreduce":"fipsWithServiceOnly","us-gov-*/events":"fipsWithServiceOnly","us-gov-*/fis":"fipsWithServiceOnly","us-gov-*/glacier":"fipsWithServiceOnly","us-gov-*/greengrass":"fipsWithServiceOnly","us-gov-*/guardduty":"fipsWithServiceOnly","us-gov-*/identitystore":"fipsWithServiceOnly","us-gov-*/imagebuilder":"fipsWithServiceOnly","us-gov-*/kafka":"fipsWithServiceOnly","us-gov-*/kinesis":"fipsWithServiceOnly","us-gov-*/logs":"fipsWithServiceOnly","us-gov-*/mediaconvert":"fipsWithServiceOnly","us-gov-*/monitoring":"fipsWithServiceOnly","us-gov-*/networkmanager":"fipsWithServiceOnly","us-gov-*/organizations":"fipsWithServiceOnly","us-gov-*/outposts":"fipsWithServiceOnly","us-gov-*/participant.connect":"fipsWithServiceOnly","us-gov-*/ram":"fipsWithServiceOnly","us-gov-*/rds":"fipsWithServiceOnly","us-gov-*/redshift":"fipsWithServiceOnly","us-gov-*/resource-groups":"fipsWithServiceOnly","us-gov-*/runtime.sagemaker":"fipsWithServiceOnly","us-gov-*/serverlessrepo":"fipsWithServiceOnly","us-gov-*/servicecatalog-appregistry":"fipsWithServiceOnly","us-gov-*/servicequotas":"fipsWithServiceOnly","us-gov-*/sns":"fipsWithServiceOnly","us-gov-*/sqs":"fipsWithServiceOnly","us-gov-*/ssm":"fipsWithServiceOnly","us-gov-*/streams.dynamodb":"fipsWithServiceOnly","us-gov-*/sts":"fipsWithServiceOnly","us-gov-*/support":"fipsWithServiceOnly","us-gov-*/swf":"fipsWithServiceOnly","us-gov-west-1/states":"fipsWithServiceOnly","us-iso-east-1/elasticfilesystem":{"endpoint":"elasticfilesystem-fips.{region}.c2s.ic.gov"},"us-gov-west-1/organizations":"fipsWithServiceOnly","us-gov-west-1/route53":{"endpoint":"route53.us-gov.amazonaws.com"},"*/resource-explorer-2":"fipsDualstackByDefault","*/kendra-ranking":"dualstackByDefault","*/internetmonitor":"dualstackByDefault","*/codecatalyst":"fipsGlobalDualstackByDefault"},"dualstackRules":{"*/*":{"endpoint":"{service}.{region}.api.aws"},"cn-*/*":{"endpoint":"{service}.{region}.api.amazonwebservices.com.cn"},"*/s3":"dualstackLegacy","cn-*/s3":"dualstackLegacyCn","*/s3-control":"dualstackLegacy","cn-*/s3-control":"dualstackLegacyCn","ap-south-1/ec2":"dualstackLegacyEc2","eu-west-1/ec2":"dualstackLegacyEc2","sa-east-1/ec2":"dualstackLegacyEc2","us-east-1/ec2":"dualstackLegacyEc2","us-east-2/ec2":"dualstackLegacyEc2","us-west-2/ec2":"dualstackLegacyEc2"},"dualstackFipsRules":{"*/*":{"endpoint":"{service}-fips.{region}.api.aws"},"cn-*/*":{"endpoint":"{service}-fips.{region}.api.amazonwebservices.com.cn"},"*/s3":"dualstackFipsLegacy","cn-*/s3":"dualstackFipsLegacyCn","*/s3-control":"dualstackFipsLegacy","cn-*/s3-control":"dualstackFipsLegacyCn"},"patterns":{"globalSSL":{"endpoint":"https://{service}.amazonaws.com","globalEndpoint":true,"signingRegion":"us-east-1"},"globalGovCloud":{"endpoint":"{service}.us-gov.amazonaws.com","globalEndpoint":true,"signingRegion":"us-gov-west-1"},"s3signature":{"endpoint":"{service}.{region}.amazonaws.com","signatureVersion":"s3"},"euIsoe":{"endpoint":"{service}.{region}.cloud.adc-e.uk"},"usIso":{"endpoint":"{service}.{region}.c2s.ic.gov"},"usIsob":{"endpoint":"{service}.{region}.sc2s.sgov.gov"},"usIsof":{"endpoint":"{service}.{region}.csp.hci.ic.gov"},"fipsStandard":{"endpoint":"{service}-fips.{region}.amazonaws.com"},"fipsDotPrefix":{"endpoint":"fips.{service}.{region}.amazonaws.com"},"fipsWithoutRegion":{"endpoint":"{service}-fips.amazonaws.com"},"fips.api.ecr":{"endpoint":"ecr-fips.{region}.amazonaws.com"},"fips.api.sagemaker":{"endpoint":"api-fips.sagemaker.{region}.amazonaws.com"},"fips.models.lex":{"endpoint":"models-fips.lex.{region}.amazonaws.com"},"fips.runtime.lex":{"endpoint":"runtime-fips.lex.{region}.amazonaws.com"},"fipsWithServiceOnly":{"endpoint":"{service}.{region}.amazonaws.com"},"dualstackLegacy":{"endpoint":"{service}.dualstack.{region}.amazonaws.com"},"dualstackLegacyCn":{"endpoint":"{service}.dualstack.{region}.amazonaws.com.cn"},"dualstackFipsLegacy":{"endpoint":"{service}-fips.dualstack.{region}.amazonaws.com"},"dualstackFipsLegacyCn":{"endpoint":"{service}-fips.dualstack.{region}.amazonaws.com.cn"},"dualstackLegacyEc2":{"endpoint":"api.ec2.{region}.aws"},"dualstackByDefault":{"endpoint":"{service}.{region}.api.aws"},"fipsDualstackByDefault":{"endpoint":"{service}-fips.{region}.api.aws"},"globalDualstackByDefault":{"endpoint":"{service}.global.api.aws"},"fipsGlobalDualstackByDefault":{"endpoint":"{service}-fips.global.api.aws"}}}

/***/ }),
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Header__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_Header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_Header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Sidebar__ = __webpack_require__(1211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_layout_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_layout_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Footer__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_layout_Footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_layout_Footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_Login__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_auth_js__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'app-header': __WEBPACK_IMPORTED_MODULE_2__components_layout_Header___default.a,
    'app-sidebar': __WEBPACK_IMPORTED_MODULE_3__components_layout_Sidebar___default.a,
    'app-footer': __WEBPACK_IMPORTED_MODULE_4__components_layout_Footer___default.a,
    'app-login': __WEBPACK_IMPORTED_MODULE_5__components_auth_Login___default.a
  },
  watch: {
    '$store.state.auth.loggedIn': function $storeStateAuthLoggedIn(loggedIn) {
      if (!loggedIn) {
        this.$router.push('/login');
      }
    }
  },
  methods: {
    switchColor: function switchColor() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                setTimeout(function () {
                  document.querySelector('body').style.background = 'white';
                  document.querySelector('.nav-header').style.display = 'none';
                  document.querySelector('.sidebar').style.background = 'white';
                  document.querySelector('.sidebar').style.border = '1px solid lightgray';
                  document.querySelector('.content').style.background = 'white';
                  document.querySelector('.footer').style.background = 'white';
                  document.querySelector('.panel-inverse>.panel-heading').style.background = '#10AA85';
                  document.querySelector('.panel-inverse>.panel-heading').style.color = 'white';
                  document.querySelector('.sidebar-minify-btn').style.background = 'gray';
                }, 1000);
                _this.$forceUpdate();
                _context.next = 4;
                return _this.$nextTick();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    var context = this;
    this.$ls.on('logged_in', function (loggedIn) {
      if (!loggedIn) {
        context.$store.commit('auth_destroyed');
      }
    });

    if (!this.$ls.get('logged_in')) {
      this.$router.push('/login');
    } else {
      var token = this.$ls.get('token');
      __WEBPACK_IMPORTED_MODULE_6__services_auth_js__["a" /* default */].doValidateToken(token, function (validateTokenResult) {
        context.$store.commit('auth_authenticated', validateTokenResult.scopes);
      });
    }
    if (sessionStorage.getItem('theme') === 'new') {
      this.switchColor();
    }
  }
});

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "affiliate-nav"
});

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "form-iklan",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      filterStart: null,
      filterEnd: null,
      isLoading: false,
      listAffiliator: [],
      dataDash: {
        total_expanse: 0,
        total_accumulate_coin: 0,
        total_coin: 0,
        total_income: 0,
        total_member: 0,
        total_active_member: 0
      },
      filter: {
        start_date: null,
        end_date: null
      },
      filter_affiliator: {
        page: 1,
        page_size: 10,
        search: null,
        sort_by: null,
        sort_mode: null
      },
      logo: __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default.a
    };
  },
  filters: {
    convertDate: function convertDate(v) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(v).format("DD MMMM YYYY");
    },
    currency: function currency(value) {
      var val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  methods: {
    submitFilter: function submitFilter(field, val) {
      // if(field !== 'page') this.filter.page = 1
      // this.filter[field] = val
      // this.getList() 
      this.getDataDashboard();
    },
    submitFilterAffiliator: function submitFilterAffiliator(field, val) {
      if (field !== 'page') this.filter_affiliator.page = 1;
      this.filter_affiliator[field] = val;
      this.getDataListAffiliator();
    },
    sort: function sort(field) {
      if (this.filter_affiliator.sort_mode === 'ASC') this.filter_affiliator.sort_mode = 'DESC';else this.filter_affiliator.sort_mode = 'ASC';
      this.filter_affiliator.sort_by = field;
      this.getDataListAffiliator();
    },
    clearFilter: function clearFilter() {
      this.filter.start_date = null;
      this.filter.end_date = null;
      this.getDataDashboard();
    },
    getDataDashboard: function getDataDashboard() {
      var context = this;
      context.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].getDataDashboardAffiliate(context.filter, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.dataDash = result.data;
        }
      });
    },
    getDataListAffiliator: function getDataListAffiliator() {
      var context = this;
      context.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].getListAffiliator(context.filter_affiliator, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.listAffiliator = result.data;
        }
      });
    }
  },
  mounted: function mounted() {
    var context = this;
    DatepickerPlugin.init("#filterStart", function (value) {
      context.filter.start_date = value;
    });
    DatepickerPlugin.init("#filterEnd", function (value) {
      context.filter.end_date = value;
    });
    this.filter.start_date = '01/01/' + __WEBPACK_IMPORTED_MODULE_3_moment___default()().year();
    this.filter.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(new Date()).format('DD/MM/YYYY');
    this.getDataDashboard();
    this.getDataListAffiliator();
  }
});

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import AffiliateSetting from "../setting/AffiliateSetting.vue";
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "form-redeem-list",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      // filterStart: null,
      // filterEnd: null,
      redeemList: [],
      logo: __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default.a,
      varstate: null,
      redeemDetail: {
        id: null,
        coin: 0,
        rupiah: 0,
        note: "",
        type: "",
        status: "",
        walletType: "",
        walletAccount: "",
        walletNumber: "",
        memberId: 0,
        memberName: "",
        memberEmail: "",
        memberCode: "",
        productId: null,
        productType: null,
        productTitle: null,
        productPrice: null,
        productCommission: null,
        createdAt: null,
        updatedAt: null,
        isActive: true
      },
      isLoading: false,
      listWallet: [],
      listStatus: [],
      form: {
        note: "",
        status: ""
      },
      filter: {
        search: '',
        start_date: null,
        end_date: null,
        wallet_type: '',
        status: '',
        page: 1,
        sort_mode: 'DESC',
        page_size: 10
      }
    };
  },
  filters: {
    convertDate: function convertDate(v) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default.a.unix(v).format("DD MMMM YYYY");
    },
    currency: function currency(value) {
      var val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  // watch: {
  //   filter:  {
  //     // This will let Vue know to look inside the array
  //     deep: true,
  //     // We have to move our method to a handler field
  //     handler: function (val, oldVal) {
  //       var context = this;
  //       context.getList();
  //       // context.showSave = true;
  //     },
  //   },
  // },
  methods: {
    showDetail: function showDetail(val) {
      this.redeemDetail = val;
      this.form.status = val.status;
      this.form.note = val.note;
      this.varstate = val.status;
      $("#redeemModal").modal("show");
    },
    resetFilter: function resetFilter() {
      this.filter = {
        search: '',
        start_date: null,
        end_date: null,
        wallet_type: '',
        status: '',
        page: 1,
        sort_mode: 'DESC',
        page_size: 10
      };
      this.getList();
    },
    hideDetail: function hideDetail() {
      $("#redeemModal").modal("hide");
    },
    saveChanges: function saveChanges(id) {
      var context = this;

      if (context.form.status === 'FAILED' && (context.form.note === '' || context.form.note === null)) {
        alert('Status gagal note wajib diisi');
      } else {
        context.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].updateStatusRedeem([id, context.form], function (result) {
          context.isLoading = false;
          if (result.success) {
            alert("data berhasil diubah");
            context.hideDetail();
            context.getList();
          } else {
            alert('gagal ubah data');
          }
        });
      }
    },
    getWallet: function getWallet(id) {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].getRedeemWallets(function (result) {
        if (result.success) {
          context.listWallet = result.data;
        }
      });
    },
    getStatus: function getStatus(id) {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].getRedeemStatus(function (result) {
        if (result.success) {
          context.listStatus = result.data;
        }
      });
    },
    submitFilter: function submitFilter(field, val) {
      if (field !== 'page') this.filter.page = 1;
      this.filter[field] = val;
      this.getList();
    },
    applyFilter: function applyFilter() {
      this.filter.page = 1;
      this.getList();
    },
    getList: function getList() {
      var context = this;
      context.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].getRedeemList(context.filter, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.redeemList = result.data.data;
        }
      });
    }
  },
  mounted: function mounted() {
    this.getList();
    this.getWallet();
    this.getStatus();
    var context = this;
    DatepickerPlugin.init("#filterStart", function (value) {
      context.filter.start_date = value;
    });
    DatepickerPlugin.init("#filterEnd", function (value) {
      context.filter.end_date = value;
    });
  }
});

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_sales_js__ = __webpack_require__(20);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: "form-config-affiliate",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      logo: __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default.a,
      grade: "",
      state: '',
      isLoading: false,
      formConfig: {
        "hide_product_for_android": false,
        "coin_to_rupiah": 0,
        "admin_coin_fee": 0,
        "minimum_coin_withdraw": 0,
        "multiple_coin_withdraw": 0,
        "affiliate_message": ""
      },
      searchText: '',
      listProduk: [],
      pagination: {
        perPage: 5,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'asc'
      },
      search: {
        query: "",
        by: ""
      }
    };
  },
  mounted: function mounted() {
    this.getConfig();
    this.getProduct();
  },

  filters: {
    currency: function currency(value) {
      var val = (value / 1).toFixed(0).replace(".", ",");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
  },
  methods: {
    getConfig: function getConfig() {
      var context = this;
      context.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].getConfigAffiliate(function (result) {
        context.isLoading = false;
        // if (result.success) {
        result.data.minimum_coin_withdraw /= result.data.coin_to_rupiah;
        result.data.admin_coin_fee /= result.data.coin_to_rupiah;
        result.data.multiple_coin_withdraw /= result.data.coin_to_rupiah;
        context.formConfig = result.data;
        console.log(context.formConfig);
        // }
      });
    },
    changeClass: function changeClass() {
      var context = this;
      context.pagination.currentPage = 1;
      if (context.grade != '') {
        context.search.query = context.grade;
        context.search.by = 'grade';
      }
      context.searchText = '';
      context.state = '';
      context.getProduct();
    },
    changeState: function changeState() {
      var context = this;
      context.pagination.currentPage = 1;
      context.searchText = '';
      context.grade = '';
      if (context.state === 'SUBSCRIPTION' || context.state === 'TICKET') {
        context.search.query = context.state;
        context.search.by = 'type';
      } else if (context.state === 'PUBLISHED' || context.state === 'UNPUBLISHED') {
        context.search.query = context.state;
        context.search.by = 'status';
      }
      context.getProduct();
    },
    previous: function previous() {
      this.pagination.currentPage -= 1;
      this.getProduct();
    },
    next: function next() {
      this.pagination.currentPage += 1;
      this.getProduct();
    },
    searchfunction: function searchfunction() {
      var context = this;
      if (context.searchText !== '') {
        context.search.query = context.searchText;
        context.search.by = 'title';
      }
      context.pagination.currentPage = 1;
      context.grade = '';
      context.state = '';
      context.getProduct();
    },
    getProduct: function getProduct() {
      var context = this;
      context.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_3__services_sales_js__["a" /* default */].getProdukList(context.pagination, context.search, function (result) {
        context.isLoading = false;
        if (result.data.length > 0) {

          for (var index = 0; index < result.data.length; index++) {
            result.data[index].edit = false;
          }
          context.listProduk = result.data;
          console.log(context.listProduk);
        } else {
          alert('data tidak ditemukan');
        }
      });
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    saveData: function saveData() {
      var context = this;
      var bd = this.formConfig;
      if (bd.coin_to_rupiah < 1 || bd.admin_coin_fee < 1 || bd.minimum_coin_withdraw < 1 || bd.multiple_coin_withdraw < 1 || bd.coin_to_rupiah === '' || bd.admin_coin_fee === '' || bd.minimum_coin_withdraw === '' || bd.multiple_coin_withdraw === '' || bd.affiliate_message === '') {
        alert('input tidak valid');
        return false;
      }
      var body = bd;
      body.minimum_coin_withdraw = bd.minimum_coin_withdraw * bd.coin_to_rupiah;
      body.multiple_coin_withdraw = bd.multiple_coin_withdraw * bd.coin_to_rupiah;
      body.admin_coin_fee = bd.admin_coin_fee * bd.coin_to_rupiah;

      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].saveConfig(body, function (result) {
        if (result.success) {
          alert("Data config affiliate berhasil di simpan");
          context.getConfig();
        }
      });
    },
    updateProduct: function updateProduct(item) {
      var context = this;
      // if(item.short_description === '') item.short_description = null
      __WEBPACK_IMPORTED_MODULE_2__services_affiliate_js__["a" /* default */].updateProduct(item, function (result) {
        if (result.success) {
          alert("Data persentase komisi produk berhasil di perbaharui");
          context.getProduct();
        } else {
          alert("Data persentase komisi produk gagal di perbaharui");
        }
      });
    }
  }
});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Alert__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_launcher_png__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_img_launcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_img_launcher_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Login',
  components: {
    'app-alert': __WEBPACK_IMPORTED_MODULE_0__components_layout_Alert___default.a
  },
  data: function data() {
    return {
      typpss: 'password',
      th: sessionStorage.getItem('theme') ? sessionStorage.getItem('theme') : 'old',
      logo: __WEBPACK_IMPORTED_MODULE_2__assets_img_launcher_png___default.a,
      errors: [],
      email: '',
      password: '',
      hasError: false,
      errorMessage: '',
      errorTitle: '' };
  },
  methods: {
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.password) this.errors.push('password');
      if (!this.email) this.errors.push('email');

      if (this.errors.length == 0) return true;

      this.hasError = true;
      this.errorMessage = this.errors.join(' dan ') + ' harus diisi';

      return false;
    },
    handleLogin: function handleLogin() {
      if (this.validateForm()) {
        var context = this;
        __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].doLogin(context.email, context.password, function (result) {
          var userData = result.data;
          if (result.success) {
            __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].doValidateToken(userData.token, function (validateTokenResult) {
              var appScopes = validateTokenResult.scopes;
              context.$ls.set('logged_in', true);
              context.$ls.set('token', userData.token);
              context.$ls.set('refresh_token', userData.refreshToken);
              context.$ls.set('profiles', {
                name: userData.name,
                firstName: userData.firstName,
                lastName: userData.lastName,
                email: userData.email,
                phone: userData.phoneNumber,
                picture: userData.picture
              });

              context.$store.commit('auth_authenticated', appScopes);
              if (context.th === 'new') location.reload();
            });
          } else {
            context.hasError = true;
            context.errorMessage = result.message;
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.$store.state.auth.loggedIn) {
      this.$router.push('/');
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bimbel-nav'
});

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapelChooser__ = __webpack_require__(1162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapelChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__MapelChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_bimbel_js__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryoutgroup-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal___default.a,
    'app-mapelchooser': __WEBPACK_IMPORTED_MODULE_0__MapelChooser___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      errors: [],
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      kurikulumList: JSON.parse(localStorage.getItem('kurikulum')),
      jenjang: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null,
      listMapelPackage: []
      // selectedMapel: []  
    };
  },
  created: function created() {},

  watch: {},
  computed: {
    kelas: {
      get: function get() {
        return this.$store.state.bimbel.bimbel_kelas;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_bimbel_kelas', value);
      }
    },
    name: {
      get: function get() {
        return this.$store.state.bimbel.bimbel_name;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_bimbel_name', value);
      }
    },
    kurikulum: {
      get: function get() {
        return this.$store.state.bimbel.bimbel_kurikulum;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_bimbel_kurikulum', value);
      }
    },
    selectedMapel: {
      get: function get() {
        return this.$store.state.bimbel.bimbel_mapel;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_bimbel_mapel', value);
      }
    },
    start_date: {
      get: function get() {
        return this.$store.state.bimbel.bimbel_start;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_bimbel_start', value);
      }
    },
    description: {
      get: function get() {
        return this.$store.state.bimbel.bimbel_description;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_bimbel_description', value);
      }
    },
    picture_url: {
      get: function get() {
        return this.$store.state.bimbel.picture_url;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_picture_url', value);
      }
    },
    end_date: {
      get: function get() {
        return this.$store.state.bimbel.bimbel_end;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_bimbel_end', value);
      }
    }
  },
  methods: {
    resetKelas: function resetKelas() {
      this.kelas = [];
    },
    openMapel: function openMapel() {
      this.$refs.mapelChooser.openGroupModal();
    },
    getPaketMapel: function getPaketMapel() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_5__services_bimbel_js__["a" /* default */].getListPackage(function (response) {
        if (response.success) {
          context.listMapelPackage = response.data;
        } else {
          return;
        }
      });
    },
    mapelSelected: function mapelSelected(item) {
      var found = this.selectedMapel.find(function (element) {
        return element.id == item.id;
      });
      if (!found) this.selectedMapel.push(item);
    },
    deleteMapel: function deleteMapel(index) {
      this.selectedMapel.splice(index, 1);
    },

    validateForm: function validateForm() {
      this.errors = [];
      if (this.name == '') this.errors.push('Nama wajib diisi');
      if (this.selectedMapel.length < 1) this.errors.push('Mapel wajib diisi');
      if (this.kurikulum == '') this.errors.push('Kurikulum Pelajaran wajib diisi');
      if (this.jenjang == null) this.errors.push('Jenjang wajib diisi');
      if (this.kelas == '') this.errors.push('Kelas wajib diisi');
      if (this.description == '') this.errors.push('Deskripsi wajib diisi');
      if (this.start_date == null) this.errors.push('Start Date wajib diisi');
      if (this.end_date == null) this.errors.push('End Date wajib diisi');
      if (this.start_time == null) this.errors.push('Start Time wajib diisi');
      if (this.end_time == null) this.errors.push('End Time wajib diisi');
      return this.errors.length == 0;
    },
    saveData: function saveData() {
      if (!this.validateForm()) {
        return;
      }
      var mapelid = [];
      for (var i = 0; i < this.selectedMapel.length; i++) {
        mapelid.push(this.selectedMapel[i].id);
      }
      this.isLoading = true;
      var context = this;
      var body = {
        name: this.name,
        description: this.description,
        grade: this.kelas,
        jenjang: this.jenjang,
        start_date: this.start_date + ' ' + this.start_time,
        end_date: this.end_date + ' ' + this.end_time,
        curriculum_id: this.kurikulum,
        block_packages: mapelid,
        picture: this.picture_url
      };
      __WEBPACK_IMPORTED_MODULE_5__services_bimbel_js__["a" /* default */].addBimbel(body, function (result) {
        context.isLoading = false;
        context.$store.commit('bimbel_reset', result.data);
        context.$router.push({ path: '/paket-bimbel' });
      });
    },
    editData: function editData() {
      if (!this.validateForm()) {
        return;
      }
      var mapelid = [];
      for (var i = 0; i < this.selectedMapel.length; i++) {
        mapelid.push(this.selectedMapel[i].id);
      }
      this.isLoading = true;
      var context = this;
      var body = {
        name: this.name,
        description: this.description,
        grade: this.kelas,
        jenjang: this.jenjang,
        start_date: this.start_date + ' ' + this.start_time,
        end_date: this.end_date + ' ' + this.end_time,
        curriculum_id: this.kurikulum,
        block_packages: mapelid,
        picture: this.picture_url
      };
      __WEBPACK_IMPORTED_MODULE_5__services_bimbel_js__["a" /* default */].editBimbel([body, this.$route.params.id], function (result) {
        context.isLoading = false;
        context.$store.commit('bimbel_reset', result.data);
        context.$router.push({ path: '/paket-bimbel' });
      });
    }
  },
  mounted: function mounted() {
    var context = this;
    DatepickerPlugin.init("#startDate", function (value) {
      context.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    DatepickerPlugin.init("#endDate", function (value) {
      context.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    ClockpickerPlugin.init("#startTime", function (value) {
      context.start_time = value + ":00";
    });

    ClockpickerPlugin.init("#endTime", function (value) {
      context.end_time = value + ":00";
    });
    if (this.$route.params.id) {
      var context = this;
      //  this.changeUrl = false
      __WEBPACK_IMPORTED_MODULE_5__services_bimbel_js__["a" /* default */].getbimbelDetailById(this.$route.params.id, function (result) {
        var gradeWrap = [];
        context.name = result.data.name;
        context.description = result.data.description;
        context.jenjang = result.data.grade < 7 ? 'SD' : result.data.grade < 10 ? 'SMP' : result.data.grade > 9 ? 'SMA' : 'SMA';
        context.kelas = result.data.grade;
        context.kurikulum = result.data.curriculum.id;
        context.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(result.data.start_date).format("YYYY-MM-DD"); //parse string
        context.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(result.data.end_date).format("YYYY-MM-DD"); //parse string
        context.start_time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(result.data.start_date).format("HH:mm:ss"); //parse string
        context.end_time = __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(result.data.end_date).format("HH:mm:ss"); //parse string
        context.selectedMapel = [];
        context.picture_url = result.data.picture;
        var block = result.data.block_packages;

        for (var i = 0; i < block.length; i++) {
          var wrapper = {
            id: block[i].id,
            data: [block[i].mapel_name, block[i].name, block[i].semester]
          };
          context.selectedMapel.push(wrapper);
        }
      });
    } else {
      this.$store.commit('bimbel_reset', '');
    }
  }
});

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'paket-bimbel',
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      packageList: [],
      selectedRow: null,
      isLoading: false,
      headers: ['Nama', 'Jenjang', 'Kelas', 'Status'],
      showModal: false,
      showBab: true,
      detailBimbel: {
        name: '',
        description: '',
        jenjang: '',
        grade: '',
        kurikulum: '',
        start_date: '',
        end_date: '',
        mapel: []
      }
    };
  },
  mounted: function mounted() {
    this.fetchData();
    this.$store.commit('video_reset');
  },
  methods: {
    fetchData: function fetchData() {
      this.packageList = [];
      var context = this;
      __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].getListBimbel(function (result) {
        if (result.success) {
          result.data.forEach(function (packRow) {
            var row = {
              id: packRow.id,
              data: [packRow.name, packRow.jenjang, packRow.grade, packRow.status],
              status: packRow.status
              // context.pagination.totalPages = group.page
            };context.packageList.push(row);
          });
        }
      });
    },
    createVideo: function createVideo() {
      this.$router.push({ path: '/paket-bimbel/form' });
    },
    editPackage: function editPackage() {
      var context = this;
      var packageId = this.selectedRow.id;
      this.$router.push({ path: '/paket-bimbel/' + packageId });
    },
    showDetail: function showDetail(item) {
      // var packageId = this.selectedRow
      // console.log(this.selectedRow.id)
      var context = this;
      __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].getbimbelDetailById(this.selectedRow.id, function (result) {
        context.detailBimbel = {
          name: result.data.name,
          description: result.data.description,
          jenjang: result.data.grade < 7 ? 'SD' : result.data.grade < 10 ? 'SMP' : 'SMA',
          grade: result.data.grade,
          kurikulum: result.data.curriculum.name,
          start_date: __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(result.data.start_date).format("YYYY-MM-DD HH:mm:ss"),
          end_date: __WEBPACK_IMPORTED_MODULE_3_moment___default.a.utc(result.data.end_date).format("YYYY-MM-DD HH:mm:ss"),
          mapel: result.data.block_packages
        };
      });
      $('#myModal').modal('show');
    },
    deletePackage: function deletePackage(item) {
      var context = this;
      var itemid = item.id;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
      if (confirmed) {
        // this.isLoading = true
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].deleteBimbel(itemid, function (result) {
          if (result.success) {
            // context.isLoading = false
            alert('Data Terhapus');
            context.fetchData();
          }
        });
      }
    },
    publish: function publish(item) {
      var context = this;
      var itemid = item.id;
      var confirmed = window.confirm("Apakah anda yakin akan publish data ini?");
      if (confirmed) {
        // this.isLoading = true
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].publishBimbel(itemid, function (result) {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah dipublish');
            context.fetchData();
          }
        });
      }
    },
    unpublish: function unpublish(item) {
      var context = this;
      var itemid = item.id;
      var confirmed = window.confirm("Apakah anda yakin akan unpublish data ini?");
      if (confirmed) {
        // this.isLoading = true
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].publishBimbel(itemid, function (result) {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah di unpublish');
            context.fetchData();
          }
        });
      }
    }
  }
});

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_bimbel_js__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tryoutgroup-chooser',
    props: ['params'],
    components: {
        'app-spinner': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a,
        'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a
    },
    data: function data() {
        return {
            isLoading: false,
            showModal: false,
            headers: ['Mata Pelajaran', 'Nama', 'Kelas'],
            rows: []
        };
    },
    methods: {
        openGroupModal: function openGroupModal() {
            this.isLoading = true;
            this.showModal = true;

            var context = this;
            __WEBPACK_IMPORTED_MODULE_3__services_bimbel_js__["a" /* default */].getListPackage(function (response) {
                if (response.success) {
                    context.rows = [];
                    response.data.forEach(function (data) {
                        var row = {
                            id: data.id,
                            data: [data.mapel_name, data.name, data.grade]
                        };

                        context.rows.push(row);
                    });
                }

                context.isLoading = false;
            }, this.grade, null).catch(function (error) {
                context.isLoading = false;
            });
        },
        onMapelChoosen: function onMapelChoosen(item) {
            this.showModal = false;
            this.$emit('dblClicked', item);
        }
    }
});

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_bimbel_bab_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tryout_group_TryoutGroupChooser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tryout_group_TryoutGroupChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tryout_group_TryoutGroupChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Autocomplete__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_plugins_Autocomplete__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'bab-components',
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_0_vuedraggable___default.a,
    'app-tryoutgroupchooser': __WEBPACK_IMPORTED_MODULE_3__components_tryout_group_TryoutGroupChooser___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default.a,
    'app-autocomplete': __WEBPACK_IMPORTED_MODULE_5__components_plugins_Autocomplete___default.a
  },
  props: {
    datalist: { type: Object, default: [''] },
    mapelid: { type: Object, default: null },
    indexProp: { type: Number, default: null }
  },
  data: function data() {
    return {
      errorVideo: [],
      errorMateri: [],
      errorSoal: [],
      errorTryout: [],
      errorTerjadwal: [],
      list: [],
      list2: [],
      editable: true,
      isDragging: false,
      delayedDragging: false,
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      babList: [],
      subBabList: [],
      jenjang: this.mapelid.jenjang,
      kelas: this.mapelid.grade,
      listVideo: [],
      updateState: 0,
      video_judul: '',
      video_judul_alt: '',
      materi_judul: '',
      type_id: 1,
      file: '',
      file_url: '',
      validFile: 0,
      babSelected: '',
      subBabSelected: '',
      typeTO: 'SBMPTN',
      variant: 'SCHEDULED',
      showModal: false,
      TOSelected: [],
      dependencyName: '',
      idContent: null,
      updateSwitch: null,
      autoValueSubBab: '',
      autoValueBab: '',
      TOFromEdit: ''
    };
  },

  methods: {
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;
      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },
    addContentButton: function addContentButton(sectionid) {
      this.$router.push('?section=' + sectionid);
      this.$emit('addingcontent', '');
    },

    deleteContent: function deleteContent(id) {
      var context = this;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
      if (confirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__["a" /* default */].deleteContent(id, function (result) {
          if (result.success) {
            context.isLoading = false;
            context.$emit('reload', '');
            setTimeout(function () {
              alert('Data Terhapus');
            }, 1200);
          }
        });
      }
    },
    editContent: function editContent(item) {
      this.$router.push('?section=' + this.datalist.id);
      this.$emit('throwEdit', item);
    },
    deleteBab: function deleteBab(id) {
      var context = this;
      // this.isLoading = true
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
      if (confirmed) {
        // context.isLoading = false
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_bab_js__["a" /* default */].deleteBab(id, function (result) {
          if (result.success) {
            alert('Data Terhapus');
            context.$emit('reload', '');
          }
        });
      }
    },
    updateKontenOrder: function updateKontenOrder(id) {
      var reorder = [];
      for (var i = 0; i < this.list.length; i++) {
        reorder.push({
          id: this.list[i].id,
          sequence: i + 1
        });
      }
      var context = this;
      var confirmed = window.confirm("Apakah anda yakin akan mengubah susunan konten bab ini?");
      if (confirmed) {
        // this.isLoading = true
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_bab_js__["a" /* default */].reOrderKonten([reorder, id], function (result) {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah disusun ulang');
            context.updateState = 0;
            context.$emit('reload', '');
          }
        });
      }
    }
  },
  computed: {
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost"
      };
    }
  },
  created: function created() {
    this.list = this.datalist.details;
    console.log(this.datalist);
  },

  watch: {
    isDragging: function isDragging(newValue) {
      var _this = this;

      if (newValue) {
        this.delayedDragging = true;
        this.updateState = 1;
        return;
      }
      this.$nextTick(function () {
        _this.delayedDragging = false;
      });
    }
  }
});

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_bimbel_js__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapel-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      isInitContent: false,
      isLoading: false,
      showModal: false,
      errors: [],
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      kurikulumList: JSON.parse(localStorage.getItem('kurikulum')),
      jenjang: null,
      interest: 'DEFAULT'
    };
  },
  computed: {
    name: {
      get: function get() {
        return this.$store.state.bimbel.mapel_name;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_mapel_name', value);
      }
    },
    kelas: {
      get: function get() {
        return this.$store.state.bimbel.mapel_grade;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_mapel_grade', value);
      }
    },
    mapel: {
      get: function get() {
        return this.$store.state.bimbel.mapel_mapel;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_mapel_mapel', value);
      }
    },
    semester: {
      get: function get() {
        return this.$store.state.bimbel.mapel_semester;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_mapel_semester', value);
      }
    },
    kurikulum: {
      get: function get() {
        return this.$store.state.bimbel.mapel_kurikulum;
      },
      set: function set(value) {
        this.$store.commit('bimbel_set_mapel_kurikulum', value);
      }
    }
  },
  methods: {
    resetKelas: function resetKelas() {
      this.kelas = [];
      this.interest = 'ALL';
    },

    validateForm: function validateForm() {
      this.errors = [];
      if (this.name == '') this.errors.push('Judul wajib diisi');
      if (this.jenjang == null) this.errors.push('Jenjang wajib diisi');
      if (this.kelas == '') this.errors.push('Kelas wajib diisi');
      if (this.kurikulum == '') this.errors.push('kurikulum wajib diisi');
      if (this.semester == '') this.errors.push('Semester wajib diisi');
      if (this.mapel == '') this.errors.push('Mata Pelajaran wajib diisi');
      return this.errors.length == 0;
    },
    saveData: function saveData() {
      if (!this.validateForm()) {
        return;
      }
      this.isLoading = true;
      var context = this;
      var body = {
        name: this.name,
        semester: this.semester,
        mapel_id: this.mapel.id,
        mapel_code: this.mapel.code,
        mapel_name: this.mapel.nama,
        mapel_picture: this.mapel.picture,
        jenjang: this.jenjang,
        grade: this.kelas,
        curriculum_id: this.kurikulum,
        interest: this.interest,
        init_content: this.isInitContent
      };

      if (this.isInitContent) {
        __WEBPACK_IMPORTED_MODULE_4__services_bimbel_js__["a" /* default */].initializeBlockPackage(body, function (result) {
          context.isLoading = false;
          context.$store.commit('mapel_reset', result.data);
          context.$router.push({ path: '/paket-mapel' });
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__services_bimbel_js__["a" /* default */].addMapelPackage(body, function (result) {
          context.isLoading = false;
          context.$store.commit('mapel_reset', result.data);
          context.$router.push({ path: '/paket-mapel' });
        });
      }
    },
    editData: function editData() {
      if (!this.validateForm()) {
        return;
      }
      this.isLoading = true;
      var context = this;
      var body = {
        name: this.name,
        semester: this.semester,
        mapel_id: this.mapel.id,
        mapel_code: this.mapel.code,
        mapel_name: this.mapel.nama,
        mapel_picture: this.mapel.picture,
        jenjang: this.jenjang,
        grade: this.kelas,
        interest: this.interest,
        curriculum_id: this.kurikulum
      };
      __WEBPACK_IMPORTED_MODULE_4__services_bimbel_js__["a" /* default */].editMapelPackage([body, this.$route.params.id], function (result) {
        context.isLoading = false;
        context.$store.commit('mapel_reset', result.data);
        context.$router.push({ path: '/paket-mapel' });
      });
    }
  },
  mounted: function mounted() {
    var context = this;

    if (this.$route.params.id) {
      var context = this;
      this.changeUrl = false;
      __WEBPACK_IMPORTED_MODULE_4__services_bimbel_js__["a" /* default */].getMapelDetailById(this.$route.params.id, function (result) {
        context.name = result.data.name;
        context.jenjang = result.data.jenjang;
        context.kelas = result.data.grade;
        context.semester = result.data.semester;
        context.interest = result.interest;

        var kurikulumWrap = context.kurikulumList.find(function (element) {
          return element.name == result.data.curriculum;
        });
        context.kurikulum = kurikulumWrap.id;
        var mapelWrap = context.mapelList.find(function (element) {
          return element.id == result.data.mapel_id;
        });
        context.mapel = mapelWrap;
      });
    } else {
      context.name = '';
      context.jenjang = null;
      context.kelas = '';
      context.kurikulum = '';
      context.semester = '';
      context.mapel = '';
    }
  }
});

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout-group',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      packageList: [],
      selectedRow: null,
      isLoading: false,
      headers: ['Nama', 'Jenjang', 'Kelas', 'Kurikulum', 'Status', 'Mata Pelajaran', 'Semester'],
      showModal: false
    };
  },
  mounted: function mounted() {
    this.fetchData();
    this.$store.commit('video_reset');
  },
  methods: {
    fetchData: function fetchData() {
      this.packageList = [];
      var context = this;
      __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].getListPackage(function (result) {
        if (result.success) {
          result.data.forEach(function (packRow) {
            var row = {
              id: packRow.id,
              data: [packRow.name, packRow.jenjang, packRow.grade, packRow.curriculum, packRow.status, packRow.mapel_name, packRow.semester],
              status: packRow.status
              // context.pagination.totalPages = group.page
            };context.packageList.push(row);
          });
        }
      });
    },
    createVideo: function createVideo() {
      this.$router.push({ path: '/paket-mapel/form' });
    },
    editPackage: function editPackage(item) {
      this.$router.push({ path: '/paket-mapel/form/' + item.id });
    },
    showBab: function showBab(item) {
      this.$router.push({ path: '/paket-mapel/' + item.id });
    },
    deletePackage: function deletePackage(item) {
      var context = this;
      var itemid = item.id;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
      if (confirmed) {
        // this.isLoading = true
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].deleteMapelPackage(itemid, function (result) {
          if (result.success) {
            // context.isLoading = false
            context.fetchData();
            setTimeout(function () {
              alert('Data Terhapus');
            }, 1200);
          }
        });
      }
    },
    publish: function publish(item) {
      var context = this;
      var itemid = item.id;
      var confirmed = window.confirm("Apakah anda yakin akan publish data ini?");
      if (confirmed) {
        // this.isLoading = true
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].publishMapel(itemid, function (result) {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah dipublish');
            context.fetchData();
          }
        });
      }
    },
    unpublish: function unpublish(item) {
      var context = this;
      var itemid = item.id;
      var confirmed = window.confirm("Apakah anda yakin akan unpublish data ini?");
      if (confirmed) {
        // this.isLoading = true
        __WEBPACK_IMPORTED_MODULE_1__services_bimbel_js__["a" /* default */].publishMapel(itemid, function (result) {
          if (result.success) {
            // context.isLoading = false
            alert('Data telah di unpublish');
            context.fetchData();
          }
        });
      }
    }
  }
});

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_bimbel_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_bimbel_bab_js__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Autocomplete__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Bab__ = __webpack_require__(1163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Bab___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Bab__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tryout_group_TryoutGroupChooser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_tryout_group_TryoutGroupChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_tryout_group_TryoutGroupChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_loading_gif__ = __webpack_require__(1146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assets_loading_gif___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assets_loading_gif__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'paket-mapel',
  components: {
    bab: __WEBPACK_IMPORTED_MODULE_6__Bab___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a,
    'app-tryoutgroupchooser': __WEBPACK_IMPORTED_MODULE_7__components_tryout_group_TryoutGroupChooser___default.a,
    'app-autocomplete': __WEBPACK_IMPORTED_MODULE_4__components_plugins_Autocomplete___default.a
  },
  data: function data() {
    return {
      loading: __WEBPACK_IMPORTED_MODULE_8__assets_loading_gif___default.a,
      showLoader: false,
      errorVideo: [],
      errorMateri: [],
      errorSoal: [],
      errorTryout: [],
      errorTerjadwal: [],
      errors: [],
      block: [],
      params: '',
      packData: [],
      showBab: false,
      idBab: '',
      name: '',
      block_package: '',
      bab_name: '',
      start_date: '',
      end_date: '',
      start_time: '',
      end_time: '',
      is_free: '',
      listBlockPackage: [],
      listBab: [],
      postState: 0,
      mapelId: '',

      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      babList: [],
      subBabList: [],
      jenjang: '',
      kelas: '',
      listVideo: [],
      updateState: 0,
      video_judul: '',
      video_judul_alt: '',
      materi_judul: '',
      type_id: 1,
      file: '',
      file_url: '',
      validFile: 0,
      babSelected: '',
      subBabSelected: '',
      subBabTitle: '',
      typeTO: 'SBMPTN',
      variant: 'SCHEDULED',
      showModal: false,
      TOSelected: [],
      dependencyName: '',
      idContent: null,
      updateSwitch: null,
      autoValueSubBab: '',
      autoValueBab: '',
      TOFromEdit: ''
    };
  },
  methods: {
    rectre: function rectre(to) {
      this.$router.push(to);
    },
    loadData: function loadData() {
      this.items = [];
      this.packData = [];
      var context = this;
      this.params = this.$route.params.id;
      __WEBPACK_IMPORTED_MODULE_0__services_bimbel_js__["a" /* default */].getAllBlock(this.params, function (result) {
        if (result.success) {
          context.packData = result.data;
          context.jenjang = result.data.jenjang;
          context.kelas = result.data.grade;
          context.mapelId = result.data.mapel_id;
          context.getVideo();
          context.getBab();
          __WEBPACK_IMPORTED_MODULE_1__services_bimbel_bab_js__["a" /* default */].getItemBab(result.data.mapel_code, function (result) {
            if (result.success) {
              context.listBab = result.data;
            }
          });
        }
      });
      __WEBPACK_IMPORTED_MODULE_0__services_bimbel_js__["a" /* default */].getListPackage(function (result) {
        if (result.success) {
          context.listBlockPackage = result.data;
        }
      });
    },
    showForm: function showForm() {
      this.emptyForm();
      $('#addBabModal').modal('show');
    },
    emptyForm: function emptyForm() {
      this.postState = 0;
      this.idBab = '';
      this.name = '';
      this.block_package = '';
      this.bab_name = '';
      this.start_date = '';
      this.end_date = '';
      this.start_time = '';
      this.end_time = '';
      this.is_free = false;
    },
    validateFormBab: function validateFormBab() {
      this.errors = [];
      if (this.name == '') this.errors.push('Nama wajib diisi');
      // if (this.block_package == '') this.errors.push('Bab wajib diisi')
      if (this.bab_name == '') this.errors.push('Pilihan Bab wajib diisi');
      if (this.start_date == '') this.errors.push('Start Date wajib diisi');
      if (this.start_time == '') this.errors.push('Start Time Pelajaran wajib diisi');
      if (this.end_time == '') this.errors.push('End Time Pelajaran wajib diisi');
      if (this.end_date == '') this.errors.push('End Date Pelajaran wajib diisi');

      return this.errors.length == 0;
    },
    saveDataBab: function saveDataBab() {
      if (!this.validateFormBab()) {
        return;
      }
      this.isLoading = true;
      var context = this;
      var body = {
        name: this.name,
        start_date: this.start_date + ' ' + this.start_time,
        bab_name: this.bab_name,
        is_free_access: this.is_free,
        block_package_id: this.$route.params.id,
        end_date: this.end_date + ' ' + this.end_time
      };
      __WEBPACK_IMPORTED_MODULE_1__services_bimbel_bab_js__["a" /* default */].addBab(body, function (result) {
        context.isLoading = false;
        context.loadData();
        $('#addBabModal').modal('hide');
        alert('data berhasil disimpan');
      });
    },
    editDataBab: function editDataBab() {
      if (!this.validateFormBab()) {
        return;
      }
      // this.isLoading = true
      var context = this;
      var body = {
        name: this.name,
        start_date: this.start_date + ' ' + this.start_time,
        bab_name: this.bab_name,
        is_free_access: this.is_free,
        block_package_id: this.$route.params.id,
        end_date: this.end_date + ' ' + this.end_time
      };
      __WEBPACK_IMPORTED_MODULE_1__services_bimbel_bab_js__["a" /* default */].editBab([body, this.idBab], function (result) {
        context.loadData();
        context.postState = 0;
        $('#addBabModal').modal('hide');
        alert('data berhasil diubah');
      });
    },
    detailBab: function detailBab(item) {
      this.postState = 1;
      this.idBab = item.id;
      this.name = item.name;
      this.block_package = this.$route.params.id;
      this.bab_name = item.bab_name;
      this.start_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.start_date).format("YYYY-MM-DD");
      this.end_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.end_date).format("YYYY-MM-DD");
      this.start_time = __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.start_date).format("hh:mm:ss");
      this.end_time = __WEBPACK_IMPORTED_MODULE_5_moment___default()(item.end_date).format("hh:mm:ss");
      this.is_free = item.is_free_access;
    },
    addContentButton: function addContentButton(sectionid) {
      this.idContent = null;
      this.$store.commit('tryout_group_set_dependency_id', null);
      this.showFormContent();
    },
    showFormContent: function showFormContent() {
      this.emptyFormContent();
      $('#kontenmodal').modal('show');
    },
    hideFormContent: function hideFormContent() {
      this.emptyFormContent();
      $('#kontenmodal').modal('hide');
    },
    emptyFormContent: function emptyFormContent() {
      this.video_judul = '';
      this.video_judul_alt = '';
      this.file_url = '';
      this.autoValueBab = '';
      this.autoValueSubBab = '';
      this.subBabList = [];
      this.TOFromEdit = '';
      this.materi_judul = '';
      this.idContent = null;
      this.type_id = 1;
      this.validFile = 0;
      this.babSelected = '';
      this.subBabSelected = '';
      // this.$refs.autocomplete.refresh()
      // this.$refs.subbabautocomplete.refresh()
    },
    openTO: function openTO() {
      this.$refs.groupChooser.openGroupModal();
    },

    assignBab: function assignBab(result) {
      console.log(result);
      var injectSubbab = this.babList.find(function (element) {
        return element.id == result.data[0];
      });
      this.babSelected = injectSubbab;
    },
    assignSubBab: function assignSubBab(result) {
      var selectSubbab = this.babSelected.subs.find(function (element) {
        return element.id == result.data[0];
      });
      this.subBabSelected = selectSubbab.kode;
      this.subBabTitle = selectSubbab.nama;
    },
    handleFileUpload: function handleFileUpload() {
      this.file = this.$refs.file.files[0];
      this.showLoader = true;
      if (this.file.type === 'application/pdf') this.processUpload();else this.validFile = 2;
    },
    convertURL: function convertURL(value) {
      if (value === '') return '';
      var b = value.split('/');
      return b[5];
    },
    processUpload: function processUpload() {
      this.validFile = false;
      var context = this;
      var formData = new FormData();
      formData.append('file', this.file);
      formData.append('request', '{"block_package_id":"' + this.$route.params.id + '"}');
      __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__["a" /* default */].uploadFile(formData, function (result) {
        if (result.success) {
          context.file_url = result.data.value;
          context.validFile = 1;
        } else {
          context.validFile = 2;
        }
        context.showLoader = false;
      });
    },
    resetKelas: function resetKelas() {
      this.kelas = '';
    },

    addDependency: function addDependency(group) {
      this.TOFromEdit = '';
      this.TOSelected = group;
      this.dependencyName = group.data[0];
      this.$store.commit('tryout_group_set_dependency_id', group.id);
    },
    removeDependency: function removeDependency() {
      this.showModal = false;
      this.dependencyName = '';
      this.TOSelected = [];
      this.$store.commit('tryout_group_set_dependency_id', null);
    },
    getVideo: function getVideo() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__["a" /* default */].getListVideo({ grade: this.packData.grade, mapel_id: this.packData.mapel_id }, function (result) {
        if (result.success) {
          context.listVideo = result.data;
        }
      });
    },
    getBab: function getBab() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__["a" /* default */].getBabSubbab(this.packData.mapel_code, function (result) {
        if (result.success) {
          context.babList = result.data;
        }
      });
    },
    validateForm: function validateForm(body) {
      this.errorVideo = [];
      this.errorMateri = [];
      this.errorSoal = [];
      this.errorTryout = [];
      this.errorTerjadwal = [];

      if (body.type_id === 1) {
        if (!body.title || body.title == '') this.errorVideo.push('Judul wajib diisi');
        if (!body.value) this.errorVideo.push('Judul Video wajib dipilih');
        if (!body.reference_id) this.errorVideo.push('Video wajib diisi');
        return this.errorVideo.length == 0;
      }
      if (body.type_id === 2) {
        if (!body.title || body.title == '') this.errorMateri.push('Judul wajib diisi');
        if (!body.value) this.errorMateri.push('File tidak terisi atau tidak sesuai');
        return this.errorMateri.length == 0;
      }
      if (body.type_id === 3) {
        if (this.babSelected == '') this.errorSoal.push('Bab wajib diisi');
        if (this.subBabSelected == '') this.errorSoal.push('Sub Bab wajib diisi');
        return this.errorSoal.length == 0;
      }
      if (body.type_id === 4) {
        if (!body.title || body.title == '') this.errorTerjadwal.push('Tryout wajib Dipilih');
        return this.errorTerjadwal.length == 0;
      }
      if (body.type_id === 5) {
        if (!body.title || body.title == '') this.errorTryout.push('Tryout wajib Dipilih');
        return this.errorTryout.length == 0;
      }
    },
    saveContent: function saveContent(type) {
      var body = {};
      var context = this;
      this.isLoading = false;
      if (type === 1) body = {
        title: this.video_judul_alt !== '' ? this.video_judul_alt : this.video_judul.title,
        value: this.video_judul.youtube_url,
        jenjang: this.jenjang,
        grade: this.kelas,
        reference_id: this.video_judul.id,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 2) body = {
        title: this.materi_judul,
        value: this.file_url,
        jenjang: this.jenjang,
        grade: this.kelas,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 3) body = {
        title: this.babSelected.nama + ' - ' + this.subBabTitle,
        jenjang: this.jenjang,
        grade: this.kelas,
        reference_id: this.packData.mapel_code + this.babSelected.kode + this.subBabSelected,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 4) body = {
        title: this.TOSelected.data[0],
        jenjang: this.jenjang,
        grade: this.kelas,
        reference_id: this.TOSelected.id,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 5) body = {
        title: this.TOSelected.data[0],
        jenjang: this.jenjang,
        grade: this.kelas,
        type_id: type,
        reference_id: this.TOSelected.id,
        section_id: parseInt(this.$route.query.section)
      };

      if (!this.validateForm(body)) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__["a" /* default */].addContent(body, function (result) {
        if (result.success) {
          context.isLoading = false;
          alert('Data telah disimpan');
          $('#kontenmodal').modal('hide');
          context.loadData();
        }
      });
    },
    editContent: function editContent(item) {
      var _this = this;

      var context = this;
      this.updateSwitch = item.type.type;
      this.idContent = item.id;
      this.$store.commit('tryout_group_set_dependency_id', null);
      var contentTab = '';
      __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__["a" /* default */].getOneContent(item.id, function (result) {
        console.log(result);
        if (result.success) {
          if (result.data.type.type === 'VIDEO') {
            _this.type_id = 1;
            contentTab = 'video';
            _this.kelas = result.data.grade;
            _this.jenjang = result.data.jenjang;
            setTimeout(function () {
              context.video_judul = context.listVideo.find(function (element) {
                return element.id == parseInt(result.data.reference_id);
              });
            }, 2000);
            if (result.data.title !== null) _this.video_judul_alt = result.data.title;
          }

          if (result.data.type.type === 'LESSON') {
            contentTab = 'materi';
            _this.type_id = 2;
            _this.kelas = result.data.grade;
            _this.jenjang = result.data.jenjang;
            _this.file_url = result.data.value;
            _this.materi_judul = result.data.title;
          }
          if (result.data.type.type === 'ITEM') {
            contentTab = 'latihan';
            _this.type_id = 3;
            _this.kelas = result.data.grade;
            _this.jenjang = result.data.jenjang;
            var bab = result.data.reference_id.substring(2, 4);
            context.babSelected = context.babList.find(function (element) {
              return element.kode == bab;
            });
            context.subBabSelected = result.data.reference_id.substring(4, 6);
            context.autoValueBab = context.babSelected.nama;
            var setSubBab = context.babSelected.subs.find(function (element) {
              return element.kode == context.subBabSelected;
            });
            context.autoValueSubBab = setSubBab.nama;
            context.$nextTick(function () {
              context.$refs.autocomplete.refill(context.babSelected.nama);
              context.$refs.subbabautocomplete.refill(setSubBab.nama);
            });
          }
          if (result.data.type.type === 'INSTANT') {
            _this.type_id = 5;
            _this.variant = 'INSTANT_COMPLETE';
            _this.kelas = result.data.grade;
            _this.jenjang = result.data.jenjang;
            _this.TOFromEdit = result.data.title;
            _this.TOSelected = {
              id: parseInt(result.data.reference_id),
              data: [result.data.title, '', result.data.grade]
            };
          }
          if (result.data.type.type === 'SCHEDULED') {
            contentTab = 'terjadwal';
            _this.type_id = 4;
            _this.variant = 'SCHEDULED';
            _this.kelas = result.data.grade;
            _this.jenjang = result.data.jenjang;
            _this.TOFromEdit = result.data.title;
            _this.TOSelected = {
              id: parseInt(result.data.reference_id),
              data: [result.data.title, '', result.data.grade]
            };
          }
          setTimeout(function () {
            $('#kontenmodal').modal('show');
            // $('#myTab a[href="#'+contentTab+'"]').tab('show')
          }, 1200);
        }
      });
    },
    updateKonten: function updateKonten(type) {
      var body = {};
      var context = this;
      this.isLoading = true;
      if (type === 1) body = {
        title: this.video_judul_alt !== '' ? this.video_judul_alt : this.video_judul.title,
        value: this.video_judul.youtube_url,
        jenjang: this.jenjang,
        grade: this.kelas,
        reference_id: this.video_judul.id,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 2) body = {
        title: this.materi_judul,
        value: this.file_url,
        jenjang: this.jenjang,
        grade: this.kelas,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 3) body = {
        title: this.babSelected.nama + ' - ' + this.subBabTitle,
        jenjang: this.jenjang,
        grade: this.kelas,
        reference_id: this.packData.mapel_code + this.babSelected.kode + this.subBabSelected,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 4) body = {
        title: this.TOSelected.data[0],
        jenjang: this.jenjang,
        grade: this.kelas,
        reference_id: this.TOSelected.id,
        type_id: type,
        section_id: parseInt(this.$route.query.section)
      };
      if (type === 5) body = {
        title: this.TOSelected.data[0],
        jenjang: this.jenjang,
        grade: this.kelas,
        type_id: type,
        reference_id: this.TOSelected.id,
        section_id: parseInt(this.$route.query.section)
      };

      if (!this.validateForm(body)) {
        return;
      }

      __WEBPACK_IMPORTED_MODULE_2__services_bimbel_materi_js__["a" /* default */].updateContent({ body: body, id: this.idContent }, function (result) {
        if (result.success) {
          context.isLoading = false;
          alert('Data telah diupdate');
          context.idContent = null;
          $('#kontenmodal').modal('hide');
          context.loadData();
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
    var context = this;
    DatepickerPlugin.init("#startDate", function (value) {
      context.start_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    DatepickerPlugin.init("#endDate", function (value) {
      context.end_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    ClockpickerPlugin.init("#startTime", function (value) {
      context.start_time = value + ":00";
    });

    ClockpickerPlugin.init("#endTime", function (value) {
      context.end_time = value + ":00";
    });
  },

  watch: {
    babSelected: function babSelected() {
      var context = this;
      if (this.babList.length > 0) {
        var findSubbab = this.babList.find(function (element) {
          return element.kode == context.babSelected.kode;
        });
        if (findSubbab) this.subBabList = findSubbab.subs;
      }
    },
    type_id: function type_id(to, from) {
      if (to === 1) $('#my-tab a[href="#video"]').tab('show');
      if (to === 2) $('#my-tab a[href="#materi"]').tab('show');
      if (to === 3) $('#my-tab a[href="#latihan"]').tab('show');
      if (to === 5) {
        $('#my-tab a[href="#tryout"]').tab('show');
        this.variant = 'INSTANT_COMPLETE';
      }
      if (to === 4) {
        $('#my-tab a[href="#terjadwal"]').tab('show');
        this.variant = 'SCHEDULED';
      }
    }
  }
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_config_service__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'config-management',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      configs: [],
      editRow: -1,
      editValue: null,
      isLoading: false
    };
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_0__services_config_service__["a" /* default */].getApplicationConfig(function (response) {
        if (response.success) {
          context.configs = response.data;
        }
      });
    },
    edit: function edit(index) {
      this.editRow = index;
      this.editValue = this.configs[index].value;
    },
    confirm: function confirm(index) {
      this.configs[index].value = this.editValue;
      this.editValue = null;
      this.editRow = -1;
    },
    save: function save() {
      var context = this;

      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__services_config_service__["a" /* default */].saveApplicationConfig(this.configs, function (response) {
        context.isLoading = false;
        alert("Konfig berhasil disimpan");
      });
    }
  },
  mounted: function mounted() {
    this.fetchData();
  }
});

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'config-management-nav'
});

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'duel-nav'
});

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'liga-personal-menu',
	components: {
		"bracket": __WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket___default.a
	},
	data: function data() {
		return {
			rounds: [
			//Semi finals
			{
				games: [{
					player1: { id: "1", name: "Competitor 1", winner: false },
					player2: { id: "4", name: "Competitor 4", winner: true }
				}, {
					player1: { id: "3", name: "Competitor 5", winner: false },
					player2: { id: "9", name: "Competitor 8", winner: true }
				}, {
					player1: { id: "6", name: "Competitor 5", winner: false },
					player2: { id: "2", name: "Competitor 8", winner: true }
				}]
			},
			//Final
			{
				games: [{
					player1: { id: "4", name: "Competitor 4", winner: false },
					player2: { id: "8", name: "Competitor 8", winner: true }
				}, {
					player1: { id: "3", name: "Competitor 4", winner: false },
					player2: { id: "6", name: "Competitor 8", winner: true }
				}]
			}]
		};
	}
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'liga-personal-menu'
});

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'liga-sekolah-menu',
	components: {
		"bracket": __WEBPACK_IMPORTED_MODULE_0_vue_tournament_bracket___default.a
	},
	data: function data() {
		return {
			rounds: [
			//Semi finals
			{
				games: [{
					player1: { id: "1", name: "Competitor 1", winner: false },
					player2: { id: "4", name: "Competitor 4", winner: true }
				}, {
					player1: { id: "3", name: "Competitor 5", winner: false },
					player2: { id: "9", name: "Competitor 8", winner: true }
				}, {
					player1: { id: "6", name: "Competitor 5", winner: false },
					player2: { id: "2", name: "Competitor 8", winner: true }
				}]
			},
			//Final
			{
				games: [{
					player1: { id: "4", name: "Competitor 4", winner: false },
					player2: { id: "8", name: "Competitor 8", winner: true }
				}, {
					player1: { id: "3", name: "Competitor 4", winner: false },
					player2: { id: "6", name: "Competitor 8", winner: true }
				}]
			}]
		};
	}
});

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'liga-sekolah-menu'
});

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_duel_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'register-liga',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			isLoading: false,
			registerLigaList: [],
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			headers: ['Name', 'Started At', 'Ended At', 'Is Active']
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	methods: {
		fetchData: function fetchData() {
			var _this = this;

			var datas = [{
				id: 1,
				name: 'Budi Setiawan',
				started_at: 1589353552000,
				ended_at: 1589353552000,
				is_active: 'True'
			}, {
				id: 2,
				name: 'Budi Setiawan',
				started_at: 1589353552000,
				ended_at: 1589353552000,
				is_active: 'True'
			}];

			datas.forEach(function (data) {
				var row = {
					id: data.id,
					data: [data.name, __WEBPACK_IMPORTED_MODULE_3_moment___default()(data.started_at).format('YYYY-MM-DD'), __WEBPACK_IMPORTED_MODULE_3_moment___default()(data.ended_at).format('YYYY-MM-DD'), data.is_active]
				};

				_this.registerLigaList.push(row);
			});
		},
		createRegisterLiga: function createRegisterLiga() {
			this.$router.push({ path: '/register-liga/form' });
		},
		updateRegisterLiga: function updateRegisterLiga() {
			var registerLigaId = this.selectedRow.id;
			this.$router.push({ path: '/register-liga/form/', query: { id: registerLigaId } });
		},
		deleteRegisterLiga: function deleteRegisterLiga(register) {
			var registerLigaId = register.id;
			var context = this;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_duel_js__["a" /* default */].deleteRegisterLiga(registerLigaId, function (result) {
					if (result.success) {
						alert('Data Terhapus');
						context.fetchData();
						context.isLoading = false;
					}
				});
			}
		}
	}
});

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_duel_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'season-form',
	components: {
		'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
		'app-editor': __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor___default.a
	},
	data: function data() {
		return {
			queryId: null,
			errors: [],
			isLoading: false,
			selectedPicture: null,
			data: {
				name: null,
				description: null
			}
		};
	}
});

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_duel_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'season',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			isLoading: false,
			seasonList: [],
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			headers: ['Name', 'Started At', 'Ended At', 'Status']
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_1__services_duel_js__["a" /* default */].getSeason(function (response) {
				context.seasonList = [];
				context.isLoading = false;

				if (response.success) {
					response.data.forEach(function (item) {
						var row = {
							id: item.id,
							data: [item.name || '-', __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.started_at).format('YYYY-MM-DD') || '-', __WEBPACK_IMPORTED_MODULE_0_moment___default()(item.ended_at).format('YYYY-MM-DD') || '-', item.status || '-']
						};

						context.seasonList.push(row);
					});
				} else {
					alert('Terjadi Kesalahan : ' + response.message);
				}
			});
		},
		createSeason: function createSeason() {
			this.$router.push({ path: '/season/form' });
		},
		updateSeason: function updateSeason() {
			var seasonId = this.selectedRow.id;
			this.$router.push({ path: '/season/form/', query: { id: seasonId } });
		},
		deleteSeason: function deleteSeason(season) {
			var seasonId = season.id;
			var context = this;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
			if (confirmed) {
				if (season.data[3] !== 'not active') {
					alert('Season masih aktif');
				} else {
					this.isLoading = true;
					__WEBPACK_IMPORTED_MODULE_1__services_duel_js__["a" /* default */].deleteSeason(seasonId, function (result) {
						if (result.success) {
							alert('Data Terhapus');
							context.fetchData();
							context.isLoading = false;
						} else {
							alert('Terjadi Kesalahan : ' + response.message);
						}
					});
				}
			}
		}
	}
});

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_duel_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_FileUpload__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_FileUpload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'season-form',
	components: {
		'app-spinner': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default.a,
		'file-upload': __WEBPACK_IMPORTED_MODULE_4__components_plugins_FileUpload___default.a
	},
	data: function data() {
		return {
			queryId: null,
			errors: [],
			isLoading: false,
			selectedPicture: null,
			data: {
				name: null,
				description: null,
				picture: null,
				started_at: null,
				ended_at: null
			},
			editor: __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default.a,
			editorConfig: {
				toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'outdent', 'indent']
			}
		};
	},
	mounted: function mounted() {
		this.getDatePickerPlugin();

		if (this.$route.query.id) {
			this.queryId = this.$route.query.id;
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var queryId = this.queryId;
			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_2__services_duel_js__["a" /* default */].getSeasonDetail(queryId, function (result) {
				context.isLoading = false;

				if (result.success) {
					context.data.name = result.data.name;
					context.data.description = result.data.description;
					context.data.picture = result.data.picture;
					context.data.started_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(result.data.started_at).format("D MMMM YYYY");
					context.data.ended_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(result.data.ended_at).format("D MMMM YYYY");
				} else {
					alert('Terjadi kesalahan : ' + result.message);
				}
			});
		},
		saveData: function saveData() {
			var context = this;
			var data = this.data;
			this.isLoading = true;

			data.started_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.started_at).format('YYYY-MM-DD');
			data.ended_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.ended_at).format('YYYY-MM-DD');

			if (this.validateForm()) {
				__WEBPACK_IMPORTED_MODULE_2__services_duel_js__["a" /* default */].addSeason(data, function (result) {
					context.isLoading = false;
					if (result.success) context.$router.push({ path: '/season' });else {
						if (result.data) alert("Waktu Mulai Season dan Akhir Season tidak diizinkan");else alert("Terjadi Kesalahan : " + result.message);
					}
				});
			} else {
				this.isLoading = false;
				$(window).scrollTop(0);
			}
		},
		editData: function editData() {
			var context = this;
			var id = this.queryId;
			var data = this.data;
			this.isLoading = true;

			data.started_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.started_at).format('YYYY-MM-DD');
			data.ended_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(data.ended_at).format('YYYY-MM-DD');

			if (this.validateForm()) {
				__WEBPACK_IMPORTED_MODULE_2__services_duel_js__["a" /* default */].updateSeason(id, data, function (result) {
					if (result.success) context.$router.push({ path: '/season' });else {
						if (result.data) alert("Waktu Mulai Season dan Akhir Season tidak diizinkan");else alert("Terjadi Kesalahan : " + result.message);
						context.isLoading = false;
					}
				});
			} else {
				this.isLoading = false;
				$(window).scrollTop(0);
			}
		},
		validateForm: function validateForm() {
			this.errors = [];
			if (!this.data.name) this.errors.push('Nama Season wajib diisi');
			if (!this.data.description) this.errors.push('Deskripsi wajib diisi');
			if (this.data.description) {
				if (this.characterCounter(this.data.description) > 1000) {
					this.errors.push('Deskripsi tidak boleh lebih dari 1000 karakter');
				}
			}
			if (!this.data.started_at) this.errors.push('Tanggal Mulai wajib diisi');
			if (!this.data.ended_at) this.errors.push('Tanggal Selesai wajib diisi');
			return this.errors.length == 0;
		},
		characterCounter: function characterCounter(text) {
			text = text.replace(/<[^>]*>/g, '');
			text = text.replace(/\&nbsp;/g, ' ');
			return text.length;
		},
		getDatePickerPlugin: function getDatePickerPlugin() {
			var context = this;

			DatepickerPlugin.init("#startDate", function (value) {
				context.data.started_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, "DD/MM/YYYY").format("D MMMM YYYY");
			});

			DatepickerPlugin.init("#endDate", function (value) {
				context.data.ended_at = __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, "DD/MM/YYYY").format("D MMMM YYYY");
			});
		}
	}
});

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_js__ = __webpack_require__(35);
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  beforeCreate: function beforeCreate() {
    if (!this.$store.state.auth.loggedIn) {
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_bimbel_js__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import SubNavigation from '@/components/itembank/SubNavigation'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-nav',
  components: {
    // 'subnavigation': SubNavigation
  },
  data: function data() {
    return { items: [] };
  },
  mounted: function mounted() {
    var context = this;
    __WEBPACK_IMPORTED_MODULE_1__services_itembank_js__["a" /* default */].getListMataPelajaran(function (result) {
      if (result.success) {
        localStorage.setItem('mapels', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data));
        result.data.forEach(function (item) {
          context.items.push(item);
        });
      }
    });
  }
});

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'katalog-tiket',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			isLoading: false,
			KontenList: [],
			fullData: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			type: {
				// SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
				// INSTANT_TRYOUT: 'INSTANT_TRYOUT',
				// CONSULTATION: 'CONSULTATION',
				// DUEL: 'DUEL',
				// ITEM_BANK: 'ITEM_BANK',
				// VIDEO: 'VIDEO'
			},
			headers: ['Section Name', 'Judul', 'Link', 'Status'],
			headersKey: ['name', 'description', 'status']
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode,
				type: 'ARTICLE'
			};

			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getContentDetailList(pagination, search, function (result) {
				context.KontenList = [];
				context.isLoading = false;

				if (result.success) {
					if (pagination.currentPage > 1 && result.data.length < 1) {
						context.pagination.currentPage = parseInt(pagination.currentPage) - 1;
						alert('Data hanya sampai halaman ' + context.pagination.currentPage);
						context.fetchData();
					} else if (pagination.currentPage === 1 && result.data.length === 0) {
						alert('Maaf, data belum ada ');
					}
					result.data.forEach(function (content) {
						context.fullData.push(content);
						var conv = JSON.parse(content.content);
						var row = {
							id: content.id,
							data: [content.section.name, conv.title.length > 45 ? conv.title.substr(0, 45) + ' ...' : conv.title, conv.link.length > 40 ? conv.link.substr(0, 40) + ' ...' : conv.link, content.status],
							status: content.status
						};
						context.pagination.totalPages = content.total_page;
						context.KontenList.push(row);
						console.log(context.KontenList);
					});
				} else {
					alert('Terjadi Kesalahan : ' + result.data.message);
				}
			});
		},
		createContentArticle: function createContentArticle() {
			this.$router.push({ path: '/content/article-form' });
		},
		updateArticle: function updateArticle() {
			var _this = this;

			var selected = this.fullData.find(function (element) {
				return element.id == _this.selectedRow.id;
			});
			this.$store.commit('setEditDataContent', selected);
			this.$router.push({ path: '/content/article-form', query: { id: this.selectedRow.id } });
		},
		updateContentBtn: function updateContentBtn(data) {
			console.log(this.fullData);
			var selected = this.fullData.find(function (element) {
				return element.id == data.id;
			});
			this.$store.commit('setEditDataContent', selected);
			this.$router.push({ path: '/content/article-form', query: { id: data.id }
			});
		},
		deleteArticle: function deleteArticle(content) {
			var context = this;
			var contentID = content.id;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus Artikel ini?");
			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].deleteContentDetail(contentID, function (result) {
					context.isLoading = false;
					if (result.success) {
						alert('Data Terhapus');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		}
	}
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_url_validator_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-article-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default.a,
    'app-imagecropper': __WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper___default.a
  },
  data: function data() {
    return {
      compiledContent: '',
      labelQuery: '',
      isLoading: false,
      listSection: [],
      form: {
        id: 0,
        name: null,
        description: null,
        link: null,
        picture: null,
        status: null,
        section_id: null
      },
      selectedPicture: null,
      errors: [],
      is_url_valid: false
    };
  },
  mounted: function mounted() {
    this.loadSection();
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id;
      this.fetchData();
    }
  },
  watch: {
    'form.link': function formLink(val) {
      if (val.length == 0) return;
      this.is_url_valid = __WEBPACK_IMPORTED_MODULE_2__services_url_validator_js__["a" /* default */].validate(val);
    }
  },
  methods: {
    fetchData: function fetchData() {
      var data = this.$store.state.content.editContent;
      var content = JSON.parse(data.content);
      this.form = {
        id: data.id,
        name: content.title,
        description: content.description,
        link: content.link,
        picture: content.image_url,
        status: data.status,
        section_id: data.section.id
      };
    },
    loadSection: function loadSection() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].getContentDetailByType('ARTICLE', function (result) {
        if (result.success) context.listSection = result.data;else alert('pengambilan section list gagal');
      });
    },
    save: function save() {
      var context = this;

      if (!this.isDeeplink && !this.form.link.includes('http')) {
        var httpLink = 'http://' + this.form.link;
        this.form.link = httpLink;
      }

      if (this.validateForm()) {
        context.isLoading = true;
        if (this.selectedPicture !== null) {
          var strJSON = {
            title: this.form.name,
            description: this.form.description,
            link: this.form.link
          };
        } else {
          var strJSON = {
            title: this.form.name,
            description: this.form.description,
            link: this.form.link,
            image_url: this.form.picture
          };
        }

        var conStr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(strJSON);
        var context = this;
        var picture = this.selectedPicture;
        var formData = new FormData();
        var dataReq = {
          action: this.form.link,
          content: conStr.replace(/'/g, "\\'"),
          is_active: true,
          section_id: parseInt(this.form.section_id),
          status: this.form.status
        };

        if (!this.$route.query.id) {
          formData.append('req', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataReq));
          formData.append('file', picture);

          __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].createContentDetail(formData, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/article' });else alert('Gagal simpan data');
            console.log(result);
          });
        } else {
          formData.append('req', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(dataReq));
          if (picture !== null) formData.append('file', picture);

          __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].updateContentDetail(this.$route.query.id, formData, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/article' });else alert('Gagal ubah data');
          });
        }
      }
    },
    handleChangePicture: function handleChangePicture(event) {
      this.selectedPicture = event.blob;
      this.form.picture = event.url;
      console.log(event);
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.form.name) this.errors.push('Judul wajib diisi');
      if (!this.form.link) this.errors.push('Link wajib diisi');
      if (!this.form.picture) this.errors.push('Gambar wajib diisi');
      if (!this.form.status) this.errors.push('Status wajib diisi');
      if (!this.form.description) this.errors.push('Deskripsi wajib diisi');
      if (!this.form.section_id) this.errors.push('Pilih section wajib diisi');
      if (!this.is_url_valid) this.errors.push('URL Web tidak valid');

      if (this.errors.length == 0) return true;

      return false;
    }
  }
});

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'katalog-tiket',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			isLoading: false,
			BannerList: [],
			fullData: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			type: {
				// SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
				// INSTANT_TRYOUT: 'INSTANT_TRYOUT',
				// CONSULTATION: 'CONSULTATION',
				// DUEL: 'DUEL',
				// ITEM_BANK: 'ITEM_BANK',
				// VIDEO: 'VIDEO'
			},
			headers: ['Title', 'Type', 'Link', 'Link Web', 'Konten', 'Status'],
			headersKey: ['title', 'type', 'link', 'link_web', 'konten', 'status']
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode,
				isbanner: true
			};

			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getContentDetailList(pagination, search, function (result) {
				context.BannerList = [];
				context.isLoading = false;
				if (result.success) {
					if (pagination.currentPage > 1 && result.data.length < 1) {
						context.pagination.currentPage = parseInt(pagination.currentPage) - 1;
						//alert('Data hanya sampai halaman ' + context.pagination.currentPage)
						//context.fetchData()
					} else if (pagination.currentPage === 1 && result.data.length === 0) {
						alert('Maaf, data belum ada ');
					}

					result.data.forEach(function (content) {
						context.pagination.totalPages = content.total_pages;
						context.fullData.push(content);
						var conv = JSON.parse(content.content);
						var row = {
							id: content.id,
							data: [conv.title, content.section.type, conv.link.length > 50 ? conv.link.substr(0, 50) + '...' : conv.link, conv.link_web.length > 50 ? conv.link_web.substr(0, 50) + '...' : conv.link_web, content.section.name, content.status],
							status: content.status
						};
						context.pagination.totalPages = content.total_page;
						context.BannerList.push(row);
					});
				} else {
					alert('Terjadi Kesalahan : ' + result.data.message);
				}
			});
		},
		createContentSection: function createContentSection() {
			this.$router.push({ path: '/content/banner-form' });
		},
		updateContent: function updateContent() {
			var _this = this;

			var selected = this.fullData.find(function (element) {
				return element.id == _this.selectedRow.id;
			});
			this.$store.commit('setEditDataContent', selected);
			this.$router.push({ path: '/content/banner-form', query: { id: this.selectedRow.id } });
		},
		updateContentBtn: function updateContentBtn(data) {
			var selected = this.fullData.find(function (element) {
				return element.id == data.id;
			});
			this.$store.commit('setEditDataContent', selected);
			this.$router.push({ path: '/content/banner-form', query: { id: data.id }
			});
		},
		deleteContentBanner: function deleteContentBanner(content) {
			var context = this;
			var contentID = content.id;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus Banner ini?");
			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].deleteContentDetail(contentID, function (result) {
					context.isLoading = false;
					if (result.success) {
						alert('Data Terhapus');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		}
	}
});

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_url_validator_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_applink_validator_js__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plugins_ImageCropper__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plugins_ImageCropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_plugins_ImageCropper__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-banner-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_6__components_plugins_Modal___default.a,
    'app-imagecropper': __WEBPACK_IMPORTED_MODULE_7__components_plugins_ImageCropper___default.a
  },
  data: function data() {
    return {
      compiledContent: '',
      labelQuery: '',
      isLoading: false,
      step: 0,
      listSection: [],
      isDeeplink: true,
      deeplinks: [],
      selectedDeeplink: null,
      deeplinkParam: null,
      preventSingleBanner: false,
      form: {
        id: 0,
        name: null,
        link_web: null,
        link: null,
        picture: null,
        status: null,
        section_id: null
      },
      selectedPicture: null,
      errors: [],
      url: null,
      toastAlert: false,
      exceedFileSize: false,
      invalidFileType: false,
      file: null,
      showCropModal: false,
      previewImageUrl: null,
      croppr: null,
      is_applink_valid: false,
      is_url_valid: false
    };
  },
  mounted: function mounted() {
    this.loadSection();
    var context = this;

    __WEBPACK_IMPORTED_MODULE_2__services_content_js__["a" /* default */].getAllDeeplinks(function (response) {
      if (response.success) {
        context.deeplinks = response.data;
      }

      if (context.$route.query.id) {
        context.queryId = context.$route.query.id;
        context.fetchData();
      }
    });
  },
  watch: {
    'form.link': function formLink(val) {
      if (val.length == 0) return;

      if (this.isDeeplink) this.is_applink_valid = __WEBPACK_IMPORTED_MODULE_4__services_applink_validator_js__["a" /* default */].validate(val);else this.is_applink_valid = __WEBPACK_IMPORTED_MODULE_3__services_url_validator_js__["a" /* default */].validate(val);
    },
    'form.link_web': function formLink_web(val) {
      if (val.length == 0) return;
      this.is_url_valid = __WEBPACK_IMPORTED_MODULE_3__services_url_validator_js__["a" /* default */].validate(val);
    },
    'selectedDeeplink': function selectedDeeplink(val) {
      if (val == null) return;

      var paramPattern = /\{.*?\}/g;
      var params = val.match(paramPattern);
      if (params != null) this.deeplinkParam = { name: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(params[0]), value: '' };else this.deeplinkParam = null;

      this.form.link = val;
    }
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var data = this.$store.state.content.editContent;
      var content = JSON.parse(data.content);
      this.form = {
        id: data.id,
        name: content.title,
        link_web: content.link_web,
        link: content.link,
        picture: content.image_url,
        status: data.status,
        section_id: data.section.id
      };

      this.url = content.image_url;
      this.isDeeplink = __WEBPACK_IMPORTED_MODULE_4__services_applink_validator_js__["a" /* default */].validate(this.form.link) ? true : false;
      if (this.isDeeplink) {
        var segments = this.form.link.split('/');
        var isParameterized = false;

        this.deeplinks.forEach(function (deeplink) {
          if (deeplink.link.split('/').length === segments.length && deeplink.link.includes(segments[segments.length - 2]) && deeplink.link.includes("{")) {
            context.selectedDeeplink = deeplink.link;
            context.form.link = deeplink.link;
            context.deeplinkParam.value = segments[segments.length - 1];
            isParameterized = true;
          }
        });

        if (!isParameterized) this.selectedDeeplink = this.form.link;
      }
    },
    loadSection: function loadSection() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_content_js__["a" /* default */].getContentDetailByType('SINGLE_BANNER', function (result) {
        var _context$listSection;

        var tmpData = [];
        for (var i = 0; i < result.data.length; i++) {
          var name = 'SINGLE | ' + result.data[i].name;
          result.data[i].name = name;

          if (context.$route.query.id || result.data[i].details.length == 0) tmpData.push(result.data[i]);
        }

        if (result.success) (_context$listSection = context.listSection).push.apply(_context$listSection, tmpData);else alert('pengambilan section list gagal');
      });
      __WEBPACK_IMPORTED_MODULE_2__services_content_js__["a" /* default */].getContentDetailByType('MULTIPLE_BANNER', function (result) {
        var _context$listSection2;

        for (var i = 0; i < result.data.length; i++) {
          var name = 'MULTIPLE | ' + result.data[i].name;
          result.data[i].name = name;
        }
        if (result.success) (_context$listSection2 = context.listSection).push.apply(_context$listSection2, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(result.data));else alert('pengambilan section list gagal');
      });
    },
    save: function save() {
      var context = this;
      if (this.isDeeplink && this.deeplinkParam != null) {
        var parameterizedLink = this.form.link.replace(JSON.parse(this.deeplinkParam.name), this.deeplinkParam.value);
        this.form.link = parameterizedLink;
      }

      if (!this.isDeeplink && !this.form.link.includes('http')) {
        var httpLink = 'http://' + this.form.link;
        this.form.link = httpLink;
      }

      if (this.validateForm()) {
        context.isLoading = true;
        if (this.selectedPicture !== null) {
          var strJSON = {
            title: this.form.name,
            link_web: this.form.link_web,
            link: this.form.link
          };
        } else {
          var strJSON = {
            title: this.form.name,
            link_web: this.form.link_web,
            link: this.form.link,
            image_url: this.form.picture
          };
        }

        var conStr = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(strJSON);
        var context = this;
        var picture = this.selectedPicture;
        var formData = new FormData();
        var dataReq = {
          action: this.form.link,
          content: conStr.replace(/'/g, "\\'"),
          is_active: true,
          section_id: parseInt(this.form.section_id),
          status: this.form.status
        };

        if (!this.$route.query.id) {
          formData.append('req', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataReq));
          formData.append('file', picture);

          __WEBPACK_IMPORTED_MODULE_2__services_content_js__["a" /* default */].createContentDetail(formData, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/banner' });else alert('ada kesalahan');
          });
        } else {
          formData.append('req', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(dataReq));
          if (picture !== null) formData.append('file', picture);

          __WEBPACK_IMPORTED_MODULE_2__services_content_js__["a" /* default */].updateContentDetail(this.$route.query.id, formData, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/banner' });else alert('ada kesalahan');
          });
        }
      }
    },
    onFileChanged: function onFileChanged(event) {
      this.url = event.url;
      this.selectedPicture = event.blob;
    },

    validateForm: function validateForm() {
      this.errors = [];
      if (!this.form.name) this.errors.push('Judul wajib diisi');
      if (!this.form.link) this.errors.push('Link wajib diisi');
      if (!this.url) this.errors.push('Gambar wajib diisi');
      if (!this.form.status) this.errors.push('Status wajib diisi');
      if (!this.form.link_web) this.errors.push('Link Web wajib diisi');
      if (!this.form.section_id) this.errors.push('Pilih section wajib diisi');
      if (!this.is_applink_valid) this.errors.push('App link tidak valid');
      if (!this.is_url_valid) this.errors.push('Web URL tidak valid');
      if (this.deeplinkParam != null && this.deeplinkParam.value == '') this.errors.push('Parameter deeplink harus diisi');
      if (this.errors.length == 0) return true;

      return false;
    },
    nextStep: function nextStep() {
      if (this.form.section_id !== null) {
        this.step = 1;
      } else {
        alert('Pilih section wajib di isi');
      }
    },
    resetDeeplink: function resetDeeplink() {
      this.form.link = '';
      this.is_applink_valid = false;
      this.deeplinkParam = null;
      this.selectedDeeplink = null;
    }
  }
});

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'katalog-tiket',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			isLoading: false,
			KontenList: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			type: {
				// SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
				// INSTANT_TRYOUT: 'INSTANT_TRYOUT',
				// CONSULTATION: 'CONSULTATION',
				// DUEL: 'DUEL',
				// ITEM_BANK: 'ITEM_BANK',
				// VIDEO: 'VIDEO'
			},
			headers: ['Judul', 'Type', 'Removeable?', 'Status'],
			headersKey: ['judul', 'type', 'is_removeable', 'status'],
			totalPage: 0
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			};

			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getContentSectionList(pagination, search, function (result) {
				context.KontenList = [];
				context.isLoading = false;

				if (result.success) {
					if (pagination.currentPage > 1 && result.data.length < 1) {
						context.pagination.currentPage = parseInt(pagination.currentPage) - 1;
						alert('Data hanya sampai halaman ' + context.pagination.currentPage);
						context.fetchData();
					} else if (pagination.currentPage === 1 && result.data.length === 0) {
						alert('Maaf, data belum ada ');
					}
					result.data.forEach(function (content) {
						var isRemovable = content.is_removable ? '' : '<i class="fa fa-times">';
						var row = {
							id: content.id,
							data: [content.name, content.type, isRemovable, content.status],
							status: content.status,
							order_number: content.order_number
						};
						context.pagination.totalPages = content.total_page;
						context.KontenList.push(row);
					});
				} else {
					alert('Terjadi Kesalahan : ' + result.data.message);
				}
			});
		},
		createContentSection: function createContentSection() {
			this.$router.push({ path: '/content/section-form' });
		},
		updateContent: function updateContent() {
			var contentid = this.selectedRow.id;
			this.$store.commit('setEditDataContent', this.selectedRow);
			this.$router.push({ path: '/content/section-form', query: { id: contentid } });
		},
		updateContentBtn: function updateContentBtn(data) {
			var contentid = data.id;
			this.$store.commit('setEditDataContent', data);
			this.$router.push({ path: '/content/section-form', query: { id: contentid } });
		},
		deleteContent: function deleteContent(content) {
			var context = this;
			var contentID = content.id;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus konten section ini?");
			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].deleteContentSection(contentID, function (result) {
					context.isLoading = false;
					if (result.success) {
						alert('Data Terhapus');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		},
		publish: function publish(content) {
			var context = this;
			var confirmed = window.confirm("Apakah anda yakin akan PUBLISH konten section ini?");
			if (confirmed) {
				var form = {
					name: content.data[0],
					type: content.data[1],
					is_active: false,
					order_number: content.order_number,
					status: 'PUBLISHED'
				};
				__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].contentSectionUpdate(content.id, form, function (result) {
					if (result.success) {
						alert('data telah dipublish');
						// this.fetchData()
						location.reload();
					}
				});
			}
		},
		unpublish: function unpublish(content) {
			var context = this;
			var confirmed = window.confirm("Apakah anda yakin akan HIDDEN/UNPUBLISH konten section ini?");
			if (confirmed) {
				var form = {
					name: content.data[0],
					type: content.data[1],
					is_active: false,
					order_number: content.order_number,
					status: 'HIDDEN'
				};
				__WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].contentSectionUpdate(content.id, form, function (result) {
					if (result.success) {
						alert('data telah disembunyikan');
						location.reload();
						// this.fetchData()
					}
				});
			}
		}
	}
});

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-article-form',
  components: {},
  data: function data() {
    return {
      compiledContent: '',
      labelQuery: '',
      form: {
        id: 0,
        name: null,
        type: null,
        is_active: true,
        status: null,
        order_number: 0
      },
      errors: []
    };
  },
  mounted: function mounted() {
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id;
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var data = this.$store.state.content.editContent;
      this.form = {
        id: 0,
        name: data.data[0],
        type: data.data[1],
        is_active: false,
        status: 'HIDDEN',
        order_number: 0
      };
    },
    save: function save() {
      var context = this;
      if (this.validateForm()) {

        if (!this.$route.query.id) {
          this.form.status = 'HIDDEN';
          this.form.order_number = 0;
          __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].contentSectionCreate(this.form, function (result) {
            if (result.success) {
              alert('data telah tersimpan');
              context.$router.push({ path: '/content/section' });
            } else {
              alert('Terjadi kesalahan: ' + result.message);
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].contentSectionUpdate(this.$route.query.id, this.form, function (result) {
            if (result.success) {
              alert('data telah diubah');
              context.$router.push({ path: '/content/section' });
            } else {
              alert('Terjadi kesalahan: ' + result.message);
            }
          });
        }
      }
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.form.name) this.errors.push('Judul konten wajib diisi');
      if (!this.form.type) this.errors.push('Type konten wajib diisi');

      if (this.errors.length == 0) return true;

      return false;
    }
  }
});

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_setting_free_itembank_FreeWacana__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home_setting_free_itembank_FreeWacana___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_home_setting_free_itembank_FreeWacana__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_freeitembank_js__ = __webpack_require__(160);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itembank-form',
  components: {
    'app-labelAutocomplete': __WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete___default.a,
    'app-autocomplete': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete___default.a,
    'app-editor': __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor___default.a,
    'app-wacana': __WEBPACK_IMPORTED_MODULE_4__components_home_setting_free_itembank_FreeWacana___default.a
  },
  data: function data() {
    var mapelId = this.$route.query.mapel;
    var mapels = JSON.parse(localStorage.getItem('mapels'));
    var found = mapels.find(function (element) {
      return element.id == mapelId;
    });

    return {
      compiledContent: '',
      labelQuery: '',
      mapel: found.nama,
      types: [],
      levels: [],
      topics: [],
      errors: [],
      grades: [],
      form: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({
        id: 0,
        wacana: null,
        mapelId: this.$route.query.mapel,
        // sumber: '',
        // topic: '',
        jenjang: null,
        grades: [],
        // jenis: 1,
        // babId: 0,
        // subBabId: 0,
        // subSubBabId: 0,
        soal: '',
        opsiA: '',
        opsiB: '',
        opsiC: '',
        opsiD: '',
        opsiE: '',
        jawaban: '',
        pembahasan: ''
      }, 'pembahasan', '')
    };
  },
  watch: {
    "grades": function grades(val) {
      this.form.grades = val;
    }
  },
  mounted: function mounted() {
    var context = this;
    __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].getListOfItemType(function (result) {
      if (result.success) {
        context.types = result.data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].getListOfSchoolGrade(function (result) {
      if (result.success) {
        context.levels = result.data;
      }
    });

    var mapelId = this.$route.query.mapel;
    var mapel = this.getMapelById(mapelId);
    __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].getListOfTopic(mapel.code, function (result) {
      context.topics = result.data;
    });

    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_6__services_freeitembank_js__["a" /* default */].getItemById(this.form.id, function (result) {
        if (result.success) {
          var item = result.data;
          // context.form.jenjang = item.jenjang[0].id
          context.form.soal = item.isi;
          context.form.opsiA = item.pilihan_1;
          context.form.opsiB = item.pilihan_2;
          context.form.opsiC = item.pilihan_3;
          context.form.opsiD = item.pilihan_4;
          context.form.opsiE = item.pilihan_5;
          context.form.jawaban = item.jawaban;
          // context.form.eigen = item.nilai_eigen
          context.form.pembahasan = item.pembahasan;

          item.grades.forEach(function (grade) {
            context.grades.push(grade.grade);
            if (grade.jenjang === 'SMA') context.form.jenjang = 3;
            if (grade.jenjang === 'SMP') context.form.jenjang = 2;
            if (grade.jenjang === 'SD') context.form.jenjang = 1;
          });

          context.form.grades = context.grades;
          if (item.wacana) context.form.wacana = item.wacana;
        }
      });
    }
  },
  methods: {
    getMapelById: function getMapelById(mapelId) {
      var mapel = JSON.parse(localStorage.getItem('mapels'));
      var found = mapel.find(function (element) {
        return element.id == mapelId;
      });

      return found;
    },
    save: function save() {
      var context = this;
      if (this.validateForm()) {

        if (!this.form.id) {
          if (this.form.wacana.content) this.form.wacana = this.form.wacana.content;
          __WEBPACK_IMPORTED_MODULE_6__services_freeitembank_js__["a" /* default */].createItem(this.form, function (result) {
            if (result.success) {
              context.$router.push({ path: '/content/itembank', query: { mapel: context.$route.query.mapel } });
            }
          });
        } else {
          if (this.form.wacana.content) this.form.wacana = this.form.wacana.content;
          __WEBPACK_IMPORTED_MODULE_6__services_freeitembank_js__["a" /* default */].updateItem(this.form.id, this.form, function (result) {
            if (result.success) {
              context.$router.push({ path: '/content/itembank', query: { mapel: context.$route.query.mapel } });
            }
          });
        }
      }
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.form.jenjang) this.errors.push('jenjang');
      // if(!this.form.jenis) this.errors.push('jenis')
      // if(!this.form.babId) this.errors.push('topic')
      if (!this.form.soal) this.errors.push('soal');
      if (!this.form.opsiA) this.errors.push('opsiA');
      if (!this.form.opsiB) this.errors.push('opsiB');
      if (!this.form.opsiC) this.errors.push('opsiC');
      if (!this.form.opsiD) this.errors.push('opsiD');
      if (!this.form.jawaban) this.errors.push('jawaban');
      if (this.grades.length === 0) this.errors.push('grades');

      if (this.errors.length == 0) return true;

      return false;
    },
    assignTopic: function assignTopic(result) {
      var topicIds = result.data;
      this.form.babId = topicIds[0];
      this.form.subBabId = topicIds[1];
      this.form.subSubBabId = topicIds[2];
    },
    onLabelSelected: function onLabelSelected(label) {
      this.form.label = label;
      this.labelQuery = '';
    },
    resetGrades: function resetGrades() {
      this.grades = [];
    }
  }
});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_freeitembank_js__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "itembank",
  components: {
    "app-datatable": __WEBPACK_IMPORTED_MODULE_3__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      mapel: "",
      headers: ["Mapel", "Isi", "Grade",
      // "Is Active",
      "Created At", "Updated At"],
      items: [],
      selectedItem: null,
      maxPage: 0,
      currentPage: 1,
      query: "",
      field: "",
      params: {
        mapelId: this.$route.query.mapel,
        page: 1,
        itemCode: "",
        label: "",
        babName: "",
        subbabName: "",
        subsubabName: "",
        jenjang: "",
        jenis: "",
        kelas: ""
      }
    };
  },
  watch: {
    "$route.query.mapel": function $routeQueryMapel(mapelId) {
      var context = this;
      this.mapel = this.getMapelNameById(mapelId);
      this.clearFilter();
    }
  },
  methods: {
    getMapelNameById: function getMapelNameById(mapelId) {
      var mapels = JSON.parse(localStorage.getItem("mapels"));
      var found = mapels.find(function (element) {
        return element.id == mapelId;
      });
      return found.nama;
    },
    editSoal: function editSoal() {
      this.$router.push({
        path: "/content/itembank-form",
        query: {
          id: this.selectedItem.id,
          mapel: this.$route.query.mapel,
          edit: true
        }
      });
    },
    editSoalNewTab: function editSoalNewTab(value) {
      this.$router.push({
        path: "/content/itembank-form",
        query: {
          id: value.id,
          mapel: this.$route.query.mapel,
          edit: true
        }
      });
    },
    deleteSoal: function deleteSoal(data) {
      var context = this;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus soal ini?");
      if (confirmed) {
        __WEBPACK_IMPORTED_MODULE_1__services_freeitembank_js__["a" /* default */].deleteItem(data.id, function (result) {
          if (result.success) {
            var targetIndex = context.items.findIndex(function (item) {
              return item.id == data.id;
            });

            context.items.splice(targetIndex, 1);
          }
        });
      }
    },
    doFilter: function doFilter() {
      this.params.page = 1;
      if (this.field === "code") this.params.itemCode = this.query;
      if (this.field === "label") this.params.label = this.query;
      if (this.field === "babName") this.params.babName = this.query;
      if (this.field === "subbabName") this.params.subbabName = this.query;
      if (this.field === "subsubabName") this.params.subsubabName = this.query;
      if (this.field === "jenjang") this.params.jenjang = this.query;
      if (this.field === "jenis") this.params.jenis = this.query;
      if (this.field === "kelas") this.params.kelas = this.query;
      this.loadData(this.$route.query.mapel);
      this.query = "";
    },
    delByOneFilter: function delByOneFilter(keys) {
      this.params[keys] = "";
      this.loadData(this.$route.query.mapel);
    },
    clearFilter: function clearFilter() {
      this.params = {
        mapelId: this.$route.query.mapel,
        page: 1,
        itemCode: "",
        label: "",
        babName: "",
        subbabName: "",
        subsubabName: "",
        jenjang: "",
        jenis: "",
        kelas: ""
      };
      this.query = "";
      this.field = "";
      this.loadData(this.params.mapelId);
    },
    goToPage: function goToPage(p) {
      // if (p > this.maxPage) {
      //   alert("Data hanya sampai " + this.maxPage + " Halaman");
      // } else {
      this.params.page = p;
      this.loadData(this.$route.query.mapel);
      // }
    },

    loadData: function loadData(mapelId) {
      this.items = [];
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_content_js__["a" /* default */].getFreeItems(this.params, function (result) {
        if (result.data.length === 0) alert('Maaf, belum ada data yang tersedia');
        if (result.success) {
          result.data.forEach(function (item) {
            var createdAt = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.created_at).fromNow();
            var updatedAt = __WEBPACK_IMPORTED_MODULE_4_moment___default()(item.updated_at).fromNow();
            var grades = [];
            item.grades.forEach(function (grade) {
              grades.push(grade.grade);
            });
            var row = {
              id: item.id,
              data: [item.mapel.nama, item.isi.length > 30 ? item.isi.substr(0, 30) + '...' : item.isi, grades.length > 0 ? grades.sort().join(",") : "-",
              // item.is_active,
              createdAt, updatedAt]
            };
            // context.maxPage = 1000;
            context.items.push(row);
          });
        }
      });
    },
    submitImport: function submitImport() {
      this.$router.push("/content/itembank-import");
    }
  },
  mounted: function mounted() {
    if (this.$store.state.auth.loggedIn) {
      var context = this;
      var mapelId = this.$route.query.mapel;
      this.mapel = this.getMapelNameById(mapelId);
      this.loadData(mapelId);
    } else {
      this.$router.push("/login");
    }
  }
});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wacana',
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-editor': __WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor___default.a
  },
  props: ['value'],
  data: function data() {
    return {
      showModal: false,
      showConfirmation: false,
      showCreateWacanaModal: false,
      headers: ['Konten', 'Created At'],
      wacanas: [],
      wacana: '',
      oldWacana: {},
      editing: false
    };
  },
  computed: {
    previewWacana: function previewWacana() {
      if (this.wacana.content) {
        return __WEBPACK_IMPORTED_MODULE_4_marked___default()(this.wacana.content);
      } else {
        return __WEBPACK_IMPORTED_MODULE_4_marked___default()(this.wacana);
      }
    }
  },
  methods: {
    resetWacana: function resetWacana() {
      this.wacana = '';
      this.showConfirmation = false;
    },
    saveWacana: function saveWacana() {
      this.showCreateWacanaModal = false;
      if (this.editing) {
        this.showCreateWacanaModal = false;
        this.editing = false;
      } else {
        this.showCreateWacanaModal = false;
        this.editing = false;
        var postData = {
          mapelId: this.$route.query.mapel,
          wacana: this.wacana
        };
        __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].createWacana(postData, function (result) {
          if (result.success) {
            context.wacana = result.data.isi;
            context.loadData();
          }
        });
      }

      // var context = this
      // if(!this.oldWacana.id) {

      // } else {
      //   itembankService.updateWacana(this.oldWacana.id, postData, function(result) {
      //     if(result.success) {
      //       context.loadData()
      //     }
      //   })
      // }
    },
    makeNew: function makeNew() {
      this.showCreateWacanaModal = true;
    },
    editWacana: function editWacana() {
      this.showCreateWacanaModal = true;
      this.editing = true;
    },
    loadData: function loadData() {
      var context = this;
      var mapelId = this.$route.query.mapel;
      __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].getListWacana(mapelId, function (result) {
        if (result.success) {
          context.wacanas = [];
          result.data.forEach(function (wacana) {
            var createdAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(wacana.created_at).fromNow();
            context.wacanas.push({ id: wacana.id, data: [wacana.isi, createdAt] });
          });
        }
      });
    },
    cancel: function cancel() {
      this.wacana = '';
      this.showModal = false;
    }
  },
  watch: {
    'wacana': function wacana(val) {
      this.$emit('selected', val);
    },
    'value': function value(val) {
      this.wacana = val;
      this.oldWacana = val;
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      itembanks: [],
      selectedRow: null,
      search: null,
      exportModal: false,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc'
      },
      headers: ['Isi', 'Kelas'],
      headersKey: ['isi', 'grade'], // camel case for matching search with API

      isReadable: true,
      errorParse: false,
      previewJSONData: [],
      importFile: null,
      viewJenjang: null,
      viewMapel: null
    };
  },
  watch: {
    pagination: function pagination() {}
  },
  mounted: function mounted() {},
  methods: {
    fetchData: function fetchData(data) {
      try {
        var item = data;
        var context = this;
        context.tryouts = [];
        item.forEach(function (soal) {
          context.viewJenjang = soal.grades[0].jenjang.nama;
          context.viewMapel = soal.mapel.nama;
          var kelas = [];
          var count = 0;
          var jenjang = '';
          soal.grades.forEach(function (grade) {
            kelas.push(grade.grade);
            jenjang = grade.jenjang.nama;
          });
          var row = {
            index: soal.id,
            data: [soal.isi.substr(0, 100) + '...', kelas]
          };
          context.itembanks.push(row);
        });
      } catch (e) {
        alert('Preview data tidak bisa dilakukan, mohon periksa kembali data kamu');
      }
    },
    submitImport: function submitImport() {
      this.isLoading = true;
      var context = this;
      var formData = this.previewJSONData;
      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].importItems(formData, function (result) {
        context.isLoading = false;
        if (result.success) {
          alert('Berhasil diupload');
          context.$router.push('/content/itembank?mapel=1');
        } else {
          alert('Gagal Upload');
        }
      });
    },

    previewJSON: function previewJSON() {
      this.fetchData(this.previewJSONData);
    },
    onFileChange: function onFileChange(e) {
      var files = this.$refs.file.files;
      if (!files.length) return;
      this.importFile = files[0];
      this.readFile(files[0]);
    },
    readFile: function readFile(file) {
      var _this = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          _this.previewJSONData = JSON.parse(e.target.result);
          _this.isReadable = false;
          _this.errorParse = false;
          _this.tryouts = [];
        } catch (e) {
          _this.isReadable = true;
          _this.errorParse = true;
          _this.tryouts = [];
        }
      };
      reader.readAsText(file);
    },

    createTryout: function createTryout() {
      this.$store.commit('tryout_reset');
      this.$router.push({ path: '/tryout-form' });
    },
    importTryout: function importTryout() {
      this.$router.push({ path: '/tryout-import' });
    },
    exportTryout: function exportTryout() {
      this.$router.push({ path: '/tryout-export' });
    },
    cancelImport: function cancelImport() {
      this.itembanks = [];
      this.isReadable = true;
      this.importFile = null;
      var input = this.$refs.file;
      input.type = 'text';
      input.type = 'file';
    },
    deleteItem: function deleteItem(content) {
      var confirmed = window.confirm("Apakah anda yakin akan menghapus Soal Gratis ini?");
      if (confirmed) {
        for (var i = 0; i < this.previewJSONData.length; i++) {
          if (this.previewJSONData[i].id === content.index) {
            this.previewJSONData.splice(i, 1);
            alert('Data berhasil dihapus');
          }
        }
        this.itembanks = [];
        this.fetchData(this.previewJSONData);
      }
    }
  }
});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_video_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryoutgroup-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      modul: null,
      isLoading: false,
      showModal: false,
      errors: [],
      section_id: null,
      listSection: [],
      videoId: null,
      judulalt: null,
      changeUrl: true,
      altTitle: false,
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mapelList: [],
      mapel_code: null,
      jenjang: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null,
      status: 'HIDDEN'

    };
  },
  created: function created() {},

  watch: {
    altTitle: function altTitle(val, oldval) {
      if (!val) {
        this.judulalt = this.judul;
      }
    }
  },
  computed: {
    player: function player() {
      return this.$refs.youtube.player;
    },

    url: {
      get: function get() {
        return this.$store.state.video.url;
      },
      set: function set(value) {
        this.$store.commit('video_set_url', value);
      }
    },
    judul: {
      get: function get() {
        return this.$store.state.video.title;
      },
      set: function set(value) {
        this.$store.commit('video_set_title', value);
      }
    },
    kelas: {
      get: function get() {
        return this.$store.state.video.grade;
      },
      set: function set(value) {
        this.$store.commit('video_set_grade', value);
      }
    },
    mapel: {
      get: function get() {
        return this.$store.state.video.mapel;
      },
      set: function set(value) {
        this.$store.commit('video_set_mapel', value);
      }
    },
    interest: {
      get: function get() {
        return this.$store.state.video.interest;
      },
      set: function set(value) {
        this.$store.commit('video_set_interest', value);
      }
    },
    description: {
      get: function get() {
        return this.$store.state.video.description;
      },
      set: function set(value) {
        this.$store.commit('video_set_description', value);
      }
    },
    thumbnail: {
      get: function get() {
        return this.$store.state.video.thumbnail;
      },
      set: function set(value) {
        this.$store.commit('video_set_thumbnail', value);
      }
    },
    source: {
      get: function get() {
        return this.$store.state.video.source;
      },
      set: function set(value) {
        this.$store.commit('video_set_source', value);
      }
    },
    duration: {
      get: function get() {
        return this.$store.state.video.duration;
      },
      set: function set(value) {
        this.$store.commit('video_set_duration', value);
      }
    }
  },
  methods: {
    playVideo: function playVideo() {
      this.player.playVideo();
    },
    playing: function playing() {
      console.log('\o/ we are watching!!!');
    },
    hideForm: function hideForm() {
      this.changeUrl = true;
    },
    resetKelas: function resetKelas() {
      this.kelas = [];
      this.interest = 'ALL';
    },
    checkURL: function checkURL() {
      if (this.url) {
        var context = this;
        if (this.url.indexOf('embed') > -1) {
          alert('video url tidak valid');
          return;
        } else {
          this.videoId = this.url.substring(this.url.indexOf('=') + 1);
        }
        __WEBPACK_IMPORTED_MODULE_1__services_video_js__["a" /* default */].getVideoDetail(this.videoId, function (response) {
          if (response.success) {
            context.changeUrl = false;
            context.judul = response.data.title;
            context.judulalt = response.data.title;
            context.source = response.data.source;
            context.thumbnail = response.data.thumbnail;
            context.description = response.data.description;
            context.duration = response.data.duration_in_sec;
          } else {
            return;
          }
        });
      } else {
        alert('URL diperlukan');
      }
    },

    validateForm: function validateForm() {
      this.errors = [];
      if (this.judul == '') this.errors.push('Judul wajib diisi');
      if (this.source == '') this.errors.push('Source wajib diisi');
      if (this.kelas.length < 1) this.errors.push('Kelas wajib diisi');
      if (this.judulalt == '') this.errors.push('Judul wajib diisi');
      if (this.jenjang == '' || this.jenjang == null) this.errors.push('Jenjang wajib diisi');
      if (this.status == '' || this.status == null) this.errors.push('Status wajib diisi');
      if (this.mapel_code == '' || this.mapel_code == null) this.errors.push('Mata Pelajaran wajib diisi');
      return this.errors.length == 0;
    },
    saveData: function saveData() {
      var context = this;

      if (this.validateForm()) {
        context.isLoading = true;
        var kel = this.kelas.map(function (x) {
          return parseInt(x, 10);
        });
        var strJSON = {
          youtube_url: this.url,
          // source: this.source,
          title: this.altTitle ? this.judulalt : this.judul,
          // jenjang: this.jenjang,
          grades: kel,
          description: this.description,
          duration: this.duration,
          thumbnail: this.thumbnail,
          mapel_code: this.mapel_code,
          status: this.status
        };

        if (!this.$route.query.id) {
          __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].createContentVideo(strJSON, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/video' });else alert('Gagal simpan data');
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].updateContentVideo(this.$route.query.id, strJSON, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/video' });else alert('Gagal ubah data');
          });
        }
      }
    },
    loadDataUpdate: function loadDataUpdate() {
      var context = this;
      var data = this.$store.state.content.editContent;
      var gradeWrap = [];
      var jenjangWrap = '';
      if (data.grades.length > 0) {
        for (var i = 0; i < data.grades.length; i++) {
          gradeWrap.push('' + data.grades[i].grade);
          jenjangWrap = data.grades[i].jenjang;
        }
      }
      context.judul = data.title;
      context.url = data.youtube_url;
      context.jenjang = jenjangWrap;
      context.kelas = gradeWrap;
      context.source = 'youtube';
      context.duration = data.duration;
      context.description = data.description;
      context.mapel_code = data.mapel.code;
      context.status = data.status;
      var params = data.youtube_url.substring(data.youtube_url.indexOf('=') + 1);
      context.videoId = params.split('&')[0];
    }
  },
  mounted: function mounted() {
    var context = this;
    __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getMapels(function (response) {
      if (response.success) {
        context.mapelList = response.data;
      }
    });

    if (this.$route.query.id) {
      this.changeUrl = false;
      this.loadDataUpdate();
    } else {
      this.url = '';
    }
  }
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "katalog-tiket",
  components: {
    "app-datatable": __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    "app-spinner": __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      VideoList: [],
      fullData: [],
      status: {
        PUBLISH: "PUBLISHED",
        UNPUBLISH: "UNPUBLISHED"
      },
      selectedRow: null,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: "desc"
      },
      type: {
        // SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
        // INSTANT_TRYOUT: 'INSTANT_TRYOUT',
        // CONSULTATION: 'CONSULTATION',
        // DUEL: 'DUEL',
        // ITEM_BANK: 'ITEM_BANK',
        // VIDEO: 'VIDEO'
      },
      headers: ["Judul Video", "Kelas", "Duration"],
      headersKey: ["title", "grade", "duration"]
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  watch: {
    pagination: function pagination() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode
      };

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getContentVideoList(pagination, search, function (result) {
        context.VideoList = [];
        context.isLoading = false;

        if (result.success) {
          if (pagination.currentPage > 1 && result.data.length < 1) {
            context.pagination.currentPage = parseInt(pagination.currentPage) - 1;
            alert("Data hanya sampai halaman " + context.pagination.currentPage);
            context.fetchData();
          } else if (pagination.currentPage === 1 && result.data.length === 0) {
            alert("Maaf, data belum ada ");
          }
          result.data.forEach(function (content) {
            var grades = [];
            content.grades.forEach(function (detailed) {
              grades += " " + detailed.grade;
            });
            var row = {
              id: content.id,
              data: [content.title, grades, content.duration]
            };
            context.pagination.totalPages = content.total_page;
            context.VideoList.push(row);
            context.fullData.push(content);
          });
        } else {
          alert("Terjadi Kesalahan : " + result.data.message);
        }
      });
    },
    createContentVideo: function createContentVideo() {
      this.$router.push({ path: "/content/video-form" });
    },
    updateVideo: function updateVideo() {
      var _this = this;

      var selected = this.fullData.find(function (element) {
        return element.id == _this.selectedRow.id;
      });
      this.$store.commit("setEditDataContent", selected);
      this.$router.push({
        path: "/content/video-form",
        query: { id: this.selectedRow.id }
      });
    },
    deleteVideo: function deleteVideo(content) {
      var context = this;
      var contentID = content.id;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus Konten Video Gratis ini?");
      if (confirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].deleteContentVideo(contentID, function (result) {
          context.isLoading = false;
          if (result.success) {
            alert("Data Terhapus");
            context.fetchData();
          } else {
            alert("Terjadi Kesalahan : " + result.message);
          }
        });
      }
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'content-article-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      compiledContent: '',
      labelQuery: '',
      isLoading: false,
      listSection: [],
      form: {
        id: 0,
        name: null,
        description: null,
        information: null,
        picture: null,
        status: 'HIDDEN',
        type_id: null,
        status_tag: null
      },
      selectedPicture: null,
      menuTypes: [],
      errors: []
    };
  },
  mounted: function mounted() {
    this.loadSection();
    this.loadMenuTypes();
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id;
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var data = this.$store.state.content.editContent;
      this.form = {
        id: data.id,
        name: data.name,
        description: data.description,
        display_name: data.display_name,
        picture: data.picture,
        status: data.status,
        status_tag: data.status_tag,
        type_id: data.type.id
      };
    },
    loadSection: function loadSection() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].getContentDetailByType('ARTICLE', function (result) {
        if (result.success) context.listSection = result.data;else alert('pengambilan section list gagal');
      });
    },
    loadMenuTypes: function loadMenuTypes() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].getMenuTypes(function (result) {
        if (result.success) context.menuTypes = result.data;
      });
    },
    save: function save() {
      var context = this;

      if (this.validateForm()) {
        context.isLoading = true;
        var strJSON = {
          action: 'action',
          description: this.form.description,
          status: this.form.status,
          order_number: 0,
          type_id: this.form.type_id,
          status_tag: this.form.status_tag
        };

        var context = this;
        var picture = this.selectedPicture;
        var formData = new FormData();

        if (!this.$route.query.id) {
          formData.append('req', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(strJSON));
          formData.append('file', picture);

          __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].menuHomeCreate(formData, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/menu' });else alert('Gagal simpan data');
            console.log(result);
          });
        } else {
          formData.append('req', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(strJSON));
          if (picture !== null) formData.append('file', picture);

          __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].updateMenu(this.$route.query.id, formData, function (result) {
            context.isLoading = false;
            if (result.success) context.$router.push({ path: '/content/menu' });else alert('Gagal ubah data');
          });
        }
      }
    },
    handleChangePicture: function handleChangePicture(event) {
      var file = event.target.files[0];
      this.selectedPicture = file;
      this.form.picture = URL.createObjectURL(file);
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.form.picture) this.errors.push('Gambar wajib diisi');
      if (!this.form.status) this.errors.push('Status wajib diisi');
      if (!this.form.description) this.errors.push('Keterangan wajib diisi');
      if (!this.form.type_id) this.errors.push('Type wajib diisi');

      if (this.errors.length == 0) return true;

      return false;
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "katalog-tiket",
  components: {
    "app-datatable": __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    "app-spinner": __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      MenuList: [],
      fullData: [],
      status: {
        PUBLISH: "PUBLISHED",
        UNPUBLISH: "UNPUBLISHED"
      },
      selectedRow: null,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: "desc"
      },
      type: {
        // SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
        // INSTANT_TRYOUT: 'INSTANT_TRYOUT',
        // CONSULTATION: 'CONSULTATION',
        // DUEL: 'DUEL',
        // ITEM_BANK: 'ITEM_BANK',
        // VIDEO: 'VIDEO'
      },
      headers: ["Nama", "Judul", "Status"],
      headersKey: ["name", "description", "status"]
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  watch: {
    pagination: function pagination() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode
      };

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getMenuList(pagination, search, function (result) {
        context.MenuList = [];
        context.isLoading = false;

        if (result.success) {
          if (pagination.currentPage > 1 && result.data.length < 1) {
            context.pagination.currentPage = parseInt(pagination.currentPage) - 1;
            alert("Data hanya sampai halaman " + context.pagination.currentPage);
            context.fetchData();
          } else if (pagination.currentPage === 1 && result.data.length === 0) {
            alert("Maaf, data belum ada ");
          }
          result.data.forEach(function (content) {
            var row = {
              id: content.id,
              data: [content.name, content.description, content.status]
            };
            context.pagination.totalPages = content.total_page;
            context.MenuList.push(row);
            context.fullData.push(content);
          });
        } else {
          alert("Terjadi Kesalahan : " + result.data.message);
        }
      });
    },
    createMenu: function createMenu() {
      this.$router.push({ path: "/content/menu-form" });
    },
    updateMenu: function updateMenu() {
      var _this = this;

      var selected = this.fullData.find(function (element) {
        return element.id == _this.selectedRow.id;
      });
      this.$store.commit("setEditDataContent", selected);
      this.$router.push({
        path: "/content/menu-form",
        query: { id: this.selectedRow.id }
      });
    },
    updateMenuBtn: function updateMenuBtn(value) {
      // console.log(value)
      var selected = this.fullData.find(function (element) {
        return element.id == value.id;
      });
      this.$store.commit("setEditDataContent", selected);
      this.$router.push({
        path: "/content/menu-form",
        query: { id: value.id }
      });
    },
    deleteMenu: function deleteMenu(content) {
      var context = this;
      var contentID = content.id;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus Menu ini?");
      if (confirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].deleteMenu(contentID, function (result) {
          context.isLoading = false;
          if (result.success) {
            alert("Data Terhapus");
            context.fetchData();
          } else {
            alert("Terjadi Kesalahan : " + result.message);
          }
        });
      }
    }
  }
});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_phone_frame_png__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_img_phone_frame_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_img_phone_frame_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_no_image_png__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__assets_img_no_image_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__assets_img_no_image_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_playbtn_png__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_img_playbtn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_img_playbtn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_previewsetting_ticket_svg__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__assets_img_previewsetting_ticket_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__assets_img_previewsetting_ticket_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_previewsetting_pp_svg__ = __webpack_require__(1144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assets_img_previewsetting_pp_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__assets_img_previewsetting_pp_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_marked__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_marked__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: "itembank",
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_8_vuedraggable___default.a,
    "app-datatable": __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      menuMode: false,
      logo: __WEBPACK_IMPORTED_MODULE_3__assets_img_phone_frame_png___default.a,
      ticket: __WEBPACK_IMPORTED_MODULE_6__assets_img_previewsetting_ticket_svg___default.a,
      pp: __WEBPACK_IMPORTED_MODULE_7__assets_img_previewsetting_pp_svg___default.a,
      noimg: __WEBPACK_IMPORTED_MODULE_4__assets_img_no_image_png___default.a,
      play: __WEBPACK_IMPORTED_MODULE_5__assets_img_playbtn_png___default.a,
      mapel: "",
      headers: ["Nama", "Judul", "Tampilkan", "Status"],
      items: [],
      selectedItem: null,
      maxPage: 0,
      currentPage: 1,
      query: "",
      field: "",
      disableStatus: null,
      modeTab: "section",
      mapelExercise: null,
      params: {
        status: null
      },
      sectionList: [{
        id: 1,
        name: "Loading data..."
      }],
      submitList: [],
      menuList: [{
        id: 1,
        name: "Loading data..."
      }],
      submitMenu: []
    };
  },
  watch: {
    $route: function $route(to, from) {
      alert("asdfsadf");
      console.log(to);
    }
  },
  computed: {
    dragOptions: function dragOptions() {
      return {
        animation: 0,
        group: "section",
        disabled: false,
        ghostClass: "ghost"
      };
    },
    dragOptionsMenu: function dragOptionsMenu() {
      return {
        animation: 0,
        group: "menu",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },
  filters: {
    parsingContentIMG: function parsingContentIMG(val) {
      var a = JSON.parse(val);
      return a.image_url;
    },
    parsingTITLE: function parsingTITLE(val) {
      var a = JSON.parse(val);
      var b = a.title.length > 50 ? a.title.substr(0, 50) + "..." : a.title;
      if (a.title === "" || a.title === null) return "null";else return b;
    },
    parsingDESCRIPTION: function parsingDESCRIPTION(val) {
      var a = JSON.parse(val);
      var b = a.description.length > 70 ? a.description.substr(0, 70) + "..." : a.description;
      if (a.description === "" || a.description === null) return "null";else return b;
    },
    parsingTOType: function parsingTOType(val) {
      var a = JSON.parse(val);
      var b = a.type;
      return b;
    },
    parsingTOName: function parsingTOName(val) {
      var a = JSON.parse(val);
      var b = a.name;
      return b;
    },
    parsingTOTime: function parsingTOTime(val) {
      var a = JSON.parse(val);
      var b = __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.opened_at).format("DD MMMM") + " " + __WEBPACK_IMPORTED_MODULE_2_moment___default()(a.closed_at).format("DD MMMM");
      return b;
    },
    parsingThumbnail: function parsingThumbnail(val) {
      var a = JSON.parse(val);
      var b = null;
      if (a.thumbnail !== "" || a.thumbnail !== null) {
        b = a.thumbnail;
      } else {
        b = "https://upload.wikimedia.org/wikipedia/commons/thumb/9/90/No_image_available_600_x_400.svg/1024px-No_image_available_600_x_400.svg.png";
      }
      return b;
    }
  },
  methods: {
    onMove: function onMove(_ref) {
      var relatedContext = _ref.relatedContext,
          draggedContext = _ref.draggedContext;

      var relatedElement = relatedContext.element;
      var draggedElement = draggedContext.element;

      return (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed;
    },

    onMenuAdd: function onMenuAdd(event) {
      var newIndex = event.newDraggableIndex;
      var menu = this.submitMenu[newIndex];
      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].togglePublishMenu(menu.id, function (response) {
        if (!response.success) alert("Terjadi kesalahan: " + response.message);
      });
    },
    onMenuRemove: function onMenuRemove(event) {
      var newIndex = event.newDraggableIndex;
      var oldIndex = event.oldDraggableIndex;
      var menu = this.menuList[newIndex];

      if (!menu.is_removable) {
        this.menuList.splice(newIndex, 1);
        this.submitMenu.splice(oldIndex, 0, menu);
        alert("Menu " + menu.display_name + " tidak dapat dinon-aktifkan");
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].togglePublishMenu(menu.id, function (response) {
          if (!response.success) alert("Terjadi kesalahan: " + response.message);
        });
      }
    },
    onSectionAdd: function onSectionAdd(event) {
      var newIndex = event.newDraggableIndex;
      var section = this.submitList[newIndex];
      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].togglePublishSection(section.id, function (response) {
        if (!response.success) alert("Terjadi kesalahan: " + response.message);
      });
    },
    onSectionRemove: function onSectionRemove(event) {
      var newIndex = event.newDraggableIndex;
      var oldIndex = event.oldDraggableIndex;
      var section = this.sectionList[newIndex];
      console.log(section);

      if (!section.is_removable) {
        this.sectionList.splice(newIndex, 1);
        this.submitList.splice(oldIndex, 0, section);
        alert("Section " + section.name + " tidak dapat dinon-aktifkan");
      } else {
        __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].togglePublishSection(section.id, function (response) {
          if (!response.success) alert("Terjadi kesalahan: " + response.message);
        });
      }
    },
    loadData: function loadData() {
      this.publishedLoad();
      this.hiddenLoad();
    },
    publishedLoad: function publishedLoad() {
      this.items = [];
      var context = this;
      this.params.status = "PUBLISHED";
      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getHomeContent(this.params, function (result) {
        if (result.success) {
          context.submitList = result.data;
          context.submitList.sort(function (a, b) {
            return a.order_number > b.order_number ? 1 : -1;
          });
        }
      });

      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getMenuPreview(this.params, function (result) {
        if (result.success) {
          context.submitMenu = result.data;
          context.submitMenu.sort(function (a, b) {
            return a.order_number > b.order_number ? 1 : -1;
          });
        }
      });
    },
    hiddenLoad: function hiddenLoad() {
      this.items = [];
      var context = this;
      this.params.status = "HIDDEN";
      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getHomeContent(this.params, function (result) {
        if (result.success) {
          context.sectionList = result.data;
        }
      });
      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].getMenuPreview(this.params, function (result) {
        if (result.success) {
          context.menuList = result.data;
        }
      });
    },
    changeFormat: function changeFormat(isi) {
      try {
        var content = JSON.parse(isi);
        this.mapelExercise = content.mapel.nama;
        var text = this.compileInlineLatex(content.isi);
        text = this.compileBlockLatex(text);
        text = __WEBPACK_IMPORTED_MODULE_9_marked___default()(text, { sanitize: false });

        return text;
      } catch (e) {
        return "Error Parsing Soal";
      }
    },

    compileInlineLatex: function compileInlineLatex(content) {
      var pattern = /\\\\\((.*?)\\\\\)/g;
      var compiledContent = content;
      var match;
      while (match = pattern.exec(compiledContent)) {
        var index = match.index;
        var length = match[0].length;
        var formula = katex.renderToString(match[1]);
        compiledContent = compiledContent.substr(0, index) + formula + compiledContent.substr(index + length);
      }

      return compiledContent;
    },
    compileBlockLatex: function compileBlockLatex(content) {
      var pattern = /\$\$(.*?)\$\$/g;
      var compiledContent = content;
      var match;
      while (match = pattern.exec(compiledContent)) {
        var index = match.index;
        var length = match[0].length;
        var formula = '<p class="text-center">' + katex.renderToString(match[1]) + "</p>";
        compiledContent = compiledContent.substr(0, index) + formula + compiledContent.substr(index + length);
      }

      return compiledContent;
    },
    saveSort: function saveSort() {
      var section = this.submitList;
      var menu = this.submitMenu;

      var hidSection = this.sectionList;
      var hidMenu = this.menuList;

      var bodySection = [];
      var bodyMenu = [];
      for (var i = 0; i < section.length; i++) {
        bodySection.push({
          section_id: section[i].id,
          order_number: i + 1,
          status: "PUBLISHED"
        });
      }

      for (var i = 0; i < hidSection.length; i++) {
        bodySection.push({
          section_id: hidSection[i].id,
          order_number: i + 1,
          status: "HIDDEN"
        });
      }

      for (var i = 0; i < menu.length; i++) {
        bodyMenu.push({
          menu_id: menu[i].id,
          order_number: i + 1,
          status: "PUBLISHED"
        });
      }

      for (var i = 0; i < hidMenu.length; i++) {
        bodyMenu.push({
          menu_id: hidMenu[i].id,
          order_number: i + 1,
          status: "HIDDEN"
        });
      }

      var successR = 0;
      __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].updateMenuSort(bodyMenu, function (result) {
        if (result.success) {
          __WEBPACK_IMPORTED_MODULE_0__services_content_js__["a" /* default */].updateSectionSort(bodySection, function (result) {
            if (result.success) {
              alert("Pengaturan Home dan Menu telah berhasil di simpan");
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_ads_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_file_js__ = __webpack_require__(49);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "form-iklan",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      step: 1,
      adsStatus: true,
      showSave: false,
      googleTargeted: [],
      minQ: 0,
      maxQ: 0,
      listKelas: [4, 5, 6, 7, 8, 9, 10, 11, 12],
      internalSelectedClass: [],
      mInternalAdsData: [{
        grades: [],
        title: "",
        description: "",
        image: ""
      }],
      isLoading: false,
      url: "",
      selectedUploadRow: "",
      file: "",
      indexSelectedUploadRow: null
    };
  },
  watch: {
    mInternalAdsData: {
      // This will let Vue know to look inside the array
      deep: true,
      // We have to move our method to a handler field
      handler: function handler(val, oldVal) {
        var context = this;
        context.revalidateGrades();
        // context.showSave = true;
      }
    }
  },
  mounted: function mounted() {
    this.getGeneralSetting();
    this.getInternalSetting();
  },

  methods: {
    addRow: function addRow() {
      var datas = this.mInternalAdsData[this.mInternalAdsData.length - 1];
      if (datas.grades.length != 0 && datas.title !== "" && datas.description !== "" && datas.image !== "") {
        this.mInternalAdsData.push({
          grades: [],
          title: "",
          description: "",
          image: ""
        });
      } else {
        alert("Data row ini tidak lengkap");
      }
    },
    hideClass: function hideClass(v, arr) {
      var a = arr.find(function (el) {
        return el === v;
      });
      if (a) return false;else return true;
    },
    getGeneralSetting: function getGeneralSetting() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3__services_ads_js__["a" /* default */].getGeneralAds(function (result) {
        context.isLoading = false;
        if (result.success) {
          var res = result.data;
          context.googleTargeted = res.google_ads_targets;
          context.adsStatus = res.is_ads_active;
          context.minQ = res.minimum_test_range;
          context.maxQ = res.maximum_test_range;
        }
      });
    },
    revalidateGrades: function revalidateGrades() {
      var context = this;
      var merged = [];
      for (var i = 0; i < context.mInternalAdsData.length; i++) {
        merged.push.apply(merged, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(context.mInternalAdsData[i].grades));
      }
      context.internalSelectedClass = merged;
    },
    removeGrade: function removeGrade(i, ig) {
      this.mInternalAdsData[i].grades.splice(ig, 1);
      if (this.mInternalAdsData[i].id) this.saveInternalSetting(this.mInternalAdsData[i], i);
      this.$forceUpdate();
    },
    addGrade: function addGrade(i, g) {
      this.mInternalAdsData[i].grades.push(g);
      if (this.mInternalAdsData[i].id) this.saveInternalSetting(this.mInternalAdsData[i], i);
    },
    getInternalSetting: function getInternalSetting() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3__services_ads_js__["a" /* default */].getInternalAds(function (result) {
        context.isLoading = false;
        if (result.success) {
          var re = result.data;
          context.mInternalAdsData = re;
          context.revalidateGrades();
          context.mInternalAdsData.push({
            grades: [],
            title: "",
            description: "",
            image: ""
          });
        }
      });
    },
    saveData: function saveData() {
      if (this.minQ > this.maxQ || this.minQ < 1 || this.maxQ < 1 || this.minQ === "" || this.maxQ === "") {
        alert("Trigger Ads tidak valid");
        return false;
      } else {
        this.updateGeneralSetting();
      }
    },
    updateGeneralSetting: function updateGeneralSetting() {
      var body = {
        is_ads_active: this.adsStatus,
        minimum_test_range: this.minQ,
        maximum_test_range: this.maxQ,
        google_ads_targets: this.googleTargeted
      };
      __WEBPACK_IMPORTED_MODULE_3__services_ads_js__["a" /* default */].saveGeneralAdsSetting(body, function (result) {
        console.log(result);
        if (result.success) {
          alert("Data general ads berhasil di simpan");
        }
      });
    },
    saveInternalSetting: function saveInternalSetting(bod, i) {
      var context = this;
      if (context.indexSelectedUploadRow !== null) {
        bod.image = context.mInternalAdsData[i].image;
      }

      if (bod.title.length > 225) {
        alert("judul terlalu panjang");
        return false;
      }
      if (bod.grades.length != 0 && bod.title !== "" && bod.description !== "" && bod.image !== "") {
        if (bod.id) {
          __WEBPACK_IMPORTED_MODULE_3__services_ads_js__["a" /* default */].updateInternalAdsSetting(bod, function (result) {
            console.log(result);
            if (result.success) {
              alert("Data internal ads berhasil di ubah");
              context.indexSelectedUploadRow = null;
              context.getInternalSetting();
              context.$forceUpdate();
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_3__services_ads_js__["a" /* default */].saveInternalAdsSetting(bod, function (result) {
            console.log(result);
            if (result.success) {
              alert("Data internal ads berhasil di simpan");
              context.indexSelectedUploadRow = null;
              context.getInternalSetting();
              context.$forceUpdate();
            }
          });
        }
      } else {
        alert("Data Belum lengkap");
      }
    },
    deleteAds: function deleteAds(i) {
      var context = this;
      var txt;
      if (confirm("Apa kamu yakin menghapus iklan ini?")) {
        __WEBPACK_IMPORTED_MODULE_3__services_ads_js__["a" /* default */].deleteInternalAds(i, function (result) {
          console.log(result);
          if (result.success) {
            alert("Ads berhasil di hapus");
            context.getInternalSetting();
            context.$forceUpdate();
          }
        });
      } else {
        txt = "berhasil di batalkan!";
      }
      document.getElementById("msg").innerHTML = txt;
    },
    chooseFiles: function chooseFiles(d, i) {
      this.selectedUploadRow = d;
      this.indexSelectedUploadRow = i;
      document.getElementById("fileUpload").click();
    },
    onFileChange: function onFileChange(e) {
      var file = e.target.files[0];
      var fileType = file["type"];
      var validImageTypes = ["image/gif", "image/jpeg", "image/png", "image/svg+xml", "image/gif"];
      if (!validImageTypes.includes(fileType)) {
        alert("file type not valid");
      } else {
        var _this = this;
        var fileObj = file;
        var reader = new FileReader();
        reader.readAsDataURL(fileObj);
        reader.onload = function (e) {
          var image = new Image();
          image.src = e.target.result;
          image.onload = function () {
            _this.url = URL.createObjectURL(fileObj);
            _this.file = fileObj;
            _this.uploadPicture(_this.file);
          };
        };
      }
    },
    uploadPicture: function uploadPicture(item) {
      var path = "sales/internal_ads/" + Date.now() + ".jpg";
      var context = this;
      var imageData = item;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_4__services_file_js__["a" /* default */].upload(imageData, path, function (response) {
        console.log(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response));
        if (response.success) {
          var imageUrl = "https://" + "nfjuara" + "." + "oss-ap-southeast-5.aliyuncs.com" + "/" + response.data;
          context.selectedUploadRow.image = imageUrl;
          context.mInternalAdsData[context.indexSelectedUploadRow].image = imageUrl;
          context.isLoading = false;
          context.$forceUpdate();
        } else {
          context.isLoading = false;
          alert("Gagal Upload gambar, periksa kembali size gambar (max: 2mb) atau type file yang diupload");
          context.getInternalSetting();
          context.$forceUpdate();
        }
      });
    }
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

// import itembankService from '@/services/itembank.js'
// import bimbelService from '@/services/bimbel.js'
// import SubNavigation from '@/components/itembank/SubNavigation'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "iklan-nav",
  components: {
    // 'subnavigation': SubNavigation
  },
  data: function data() {
    return { items: [] };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_itembank_Wacana__ = __webpack_require__(1201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_itembank_Wacana___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_itembank_Wacana__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__ = __webpack_require__(14);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itembank-form',
  components: {
    'app-labelAutocomplete': __WEBPACK_IMPORTED_MODULE_1__components_plugins_LabelAutocomplete___default.a,
    'app-autocomplete': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Autocomplete___default.a,
    'app-editor': __WEBPACK_IMPORTED_MODULE_3__components_plugins_MarkdownEditor___default.a,
    'app-wacana': __WEBPACK_IMPORTED_MODULE_4__components_itembank_Wacana___default.a
  },
  data: function data() {
    var _form;

    var mapelId = this.$route.query.mapel;
    var mapels = JSON.parse(localStorage.getItem('mapels'));
    var found = mapels.find(function (element) {
      return element.id == mapelId;
    });

    return {
      compiledContent: '',
      labelQuery: '',
      mapel: found.nama,
      types: [],
      levels: [],
      topics: [],
      errors: [],
      grades: [],
      form: (_form = {
        id: 0,
        wacana: null,
        mapelId: this.$route.query.mapel,
        sumber: '',
        topic: '',
        jenjang: 3,
        grades: [],
        jenis: 1,
        babId: 0,
        subBabId: 0,
        subSubBabId: 0,
        soal: '',
        opsiA: '',
        opsiB: '',
        opsiC: '',
        opsiD: '',
        opsiE: '',
        jawaban: '',
        pembahasan: '',
        is_restricted: false,
        label: '',
        eigen: 0.00
      }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_form, 'sumber', ''), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_form, 'pembahasan', ''), _form)
    };
  },
  watch: {
    "grades": function grades(val) {
      this.form.grades = val;
    }
  },
  mounted: function mounted() {
    var context = this;
    __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].getListOfItemType(function (result) {
      if (result.success) {
        context.types = result.data;
      }
    });

    __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].getListOfSchoolGrade(function (result) {
      if (result.success) {
        context.levels = result.data;
      }
    });

    var mapelId = this.$route.query.mapel;
    var mapel = this.getMapelById(mapelId);
    __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].getListOfTopic(mapel.code, function (result) {
      context.topics = result.data;
    });

    if (this.$route.query.id) {
      this.form.id = this.$route.query.id;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].getItemById(this.form.id, function (result) {
        if (result.success) {
          var item = result.data;
          context.form.jenjang = item.jenjang.id;
          context.form.jenis = item.jenis_soal.id;
          context.form.sumber = item.sumber;
          context.form.soal = item.isi;
          context.form.opsiA = item.pilihan_1;
          context.form.opsiB = item.pilihan_2;
          context.form.opsiC = item.pilihan_3;
          context.form.opsiD = item.pilihan_4;
          context.form.opsiE = item.pilihan_5;
          context.form.jawaban = item.jawaban;
          context.form.eigen = item.nilai_eigen;
          context.form.pembahasan = item.pembahasan;
          context.form.is_restricted = item.is_restricted;
          context.form.label = item.label;

          item.grades.forEach(function (grade) {
            context.grades.push(grade.grade);
          });

          context.form.grades = context.grades;

          if (item.wacana) context.form.wacana = { id: item.wacana.id, content: item.wacana.isi };

          if (item.bab) {
            context.form.babId = item.bab.id;
            context.form.topic += item.bab.nama;
          }

          if (item.sub_bab) {
            context.form.subBabId = item.sub_bab.id;
            context.form.topic += '/ ' + item.sub_bab.nama;
          }

          if (item.sub_sub_bab) {
            context.form.subSubBabId = item.sub_sub_bab.id;
            context.form.topic += '/ ' + item.sub_sub_bab.nama;
          }
        }
      });
    }
  },
  methods: {
    getMapelById: function getMapelById(mapelId) {
      var mapel = JSON.parse(localStorage.getItem('mapels'));
      var found = mapel.find(function (element) {
        return element.id == mapelId;
      });

      return found;
    },
    save: function save() {
      var context = this;
      if (this.validateForm()) {

        if (!this.form.id) {
          __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].createItem(this.form, function (result) {
            if (result.success) {
              context.$router.push({ path: '/items', query: { mapel: context.$route.query.mapel } });
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_5__services_itembank_js__["a" /* default */].updateItem(this.form.id, this.form, function (result) {
            if (result.success) {
              context.$router.push({ path: '/items', query: { mapel: context.$route.query.mapel } });
            }
          });
        }
      }
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.form.jenjang) this.errors.push('jenjang');
      if (!this.form.jenis) this.errors.push('jenis');
      if (!this.form.babId) this.errors.push('topic');
      if (!this.form.soal) this.errors.push('soal');
      if (!this.form.opsiA) this.errors.push('opsiA');
      if (!this.form.opsiB) this.errors.push('opsiB');
      if (!this.form.opsiC) this.errors.push('opsiC');
      if (!this.form.opsiD) this.errors.push('opsiD');
      if (!this.form.jawaban) this.errors.push('jawaban');
      if (this.grades.length === 0) this.errors.push('grades');

      if (this.errors.length == 0) return true;

      return false;
    },
    assignTopic: function assignTopic(result) {
      var topicIds = result.data;
      this.form.babId = topicIds[0];
      this.form.subBabId = topicIds[1];
      this.form.subSubBabId = topicIds[2];
    },
    onLabelSelected: function onLabelSelected(label) {
      this.form.label = label;
      this.labelQuery = '';
    },
    resetGrades: function resetGrades() {
      this.grades = [];
    }
  }
});

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_content_js__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itembank',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      mapel: '',
      headers: ['Kode', 'Kelas', 'Bab', 'Sub Bab', 'Sub Sub Bab', 'Jenjang', 'Jenis', 'Eigen Score', 'Label', 'Status Dimunculkan', 'Created At'],
      items: [],
      selectedItem: null,
      maxPage: 0,
      currentPage: 1,
      query: '',
      field: '',
      params: {
        mapelId: this.$route.query.mapel,
        page: 1,
        itemCode: '',
        label: '',
        babName: '',
        subbabName: '',
        subsubabName: '',
        jenjang: '',
        jenis: '',
        kelas: ''
      }
    };
  },
  watch: {
    '$route.query.mapel': function $routeQueryMapel(mapelId) {
      var context = this;
      this.mapel = this.getMapelNameById(mapelId);
      this.clearFilter();
    }
  },
  methods: {
    getMapelNameById: function getMapelNameById(mapelId) {
      var mapels = JSON.parse(localStorage.getItem('mapels'));
      var found = mapels.find(function (element) {
        return element.id == mapelId;
      });
      return found.nama;
    },
    editSoal: function editSoal() {
      this.$router.push({ path: '/item-form', query: {
          id: this.selectedItem.id,
          mapel: this.$route.query.mapel,
          edit: true }
      });
    },
    editSoalNewTab: function editSoalNewTab(value) {
      var routeData = this.$router.resolve({ path: '/item-form', query: {
          id: value.id,
          mapel: this.$route.query.mapel,
          edit: true }
      });
      window.open(routeData.href, '_blank');
    },
    deleteSoal: function deleteSoal(data) {
      var context = this;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus soal ini?");
      if (confirmed) {
        __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].deleteItem(data.id, function (result) {
          if (result.success) {
            var targetIndex = context.items.findIndex(function (item) {
              return item.id == data.id;
            });

            context.items.splice(targetIndex, 1);
          }
        });
      }
    },
    doFilter: function doFilter() {
      this.params.page = 1;
      if (this.field === 'code') this.params.itemCode = this.query;
      if (this.field === 'label') this.params.label = this.query;
      if (this.field === 'babName') this.params.babName = this.query;
      if (this.field === 'subbabName') this.params.subbabName = this.query;
      if (this.field === 'subsubabName') this.params.subsubabName = this.query;
      if (this.field === 'jenjang') this.params.jenjang = this.query;
      if (this.field === 'jenis') this.params.jenis = this.query;
      if (this.field === 'kelas') this.params.kelas = this.query;
      this.loadData(this.$route.query.mapel);
      this.query = '';
    },
    delByOneFilter: function delByOneFilter(keys) {
      this.params[keys] = '';
      this.loadData(this.$route.query.mapel);
    },
    clearFilter: function clearFilter() {
      this.params = {
        mapelId: this.$route.query.mapel,
        page: 1,
        itemCode: '',
        label: '',
        babName: '',
        subbabName: '',
        subsubabName: '',
        jenjang: '',
        jenis: '',
        kelas: ''
      };
      this.query = '';
      this.field = '';
      this.loadData(this.params.mapelId);
    },
    goToPage: function goToPage(p) {
      if (p > this.maxPage) {
        alert('Data hanya sampai ' + this.maxPage + ' Halaman');
      } else {
        this.params.page = p;
        this.loadData(this.$route.query.mapel);
      }
    },

    loadData: function loadData(mapelId) {
      this.items = [];
      var context = this;
      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getItemsByMataPelajaran(this.params, function (result) {
        if (result.success) {
          result.data.forEach(function (item) {
            var subBab = !item.sub_bab ? '-' : item.sub_bab.nama;
            var subSubBab = !item.sub_sub_bab ? '-' : item.sub_sub_bab.nama;
            var createdAt = __WEBPACK_IMPORTED_MODULE_3_moment___default()(item.created_at).fromNow();
            var grades = [];

            item.grades.forEach(function (grade) {
              grades.push(grade.grade);
            });
            var row = {
              id: item.id,
              data: [item.kode, grades.length > 0 ? grades.sort().join(',') : '-', item.bab.nama, subBab, subSubBab, item.jenjang.nama, item.jenis_soal.nama, item.nilai_eigen, item.label, item.is_restricted ? '-' : '<i class="fa fa-check"></i>', createdAt]
            };
            context.maxPage = item.pages;
            context.items.push(row);
          });
        }
      });
    },
    submitExport: function submitExport() {
      var context = this;
      if (this.$store.state.tryout.selectedTO.length < 1) {
        alert('tidak ada item yang dipilih');
      } else {
        __WEBPACK_IMPORTED_MODULE_1__services_content_js__["a" /* default */].exportItemBank({ "ids": this.$store.state.tryout.selectedTO }, function (result) {
          alert('Data sukses diexport akan otomatis terdownload');
          context.$nextTick(function () {
            context.$store.commit('tryoutSelected', []);
          });
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.$store.state.auth.loggedIn) {
      var context = this;
      var mapelId = this.$route.query.mapel;
      this.mapel = this.getMapelNameById(mapelId);
      this.loadData(mapelId);
    } else {
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_bimbel_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_itembank_SubNavigation__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_itembank_SubNavigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_itembank_SubNavigation__);

//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itembank-nav',
  components: {
    'subnavigation': __WEBPACK_IMPORTED_MODULE_3__components_itembank_SubNavigation___default.a
  },
  data: function data() {
    return { items: [] };
  },
  mounted: function mounted() {
    var context = this;
    __WEBPACK_IMPORTED_MODULE_1__services_itembank_js__["a" /* default */].getListMataPelajaran(function (result) {
      if (result.success) {
        localStorage.setItem('mapels', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data));
        result.data.forEach(function (item) {
          context.items.push(item);
        });
      }
    });
    __WEBPACK_IMPORTED_MODULE_2__services_bimbel_js__["a" /* default */].getListKurikulum(function (result) {
      if (result.success) {
        localStorage.setItem('kurikulum', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(result.data));
        result.data.forEach(function (item) {
          context.items.push(item);
        });
      }
    });
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itembank-subnav',
  props: ['item']
});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'wacana',
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-editor': __WEBPACK_IMPORTED_MODULE_2__components_plugins_MarkdownEditor___default.a
  },
  props: ['value'],
  data: function data() {
    return {
      showModal: false,
      showConfirmation: false,
      showCreateWacanaModal: false,
      headers: ['Konten', 'Created At'],
      wacanas: [],
      wacana: { id: 0, content: '' }
    };
  },
  computed: {
    previewWacana: function previewWacana() {
      return __WEBPACK_IMPORTED_MODULE_4_marked___default()(this.wacana.content);
    }
  },
  methods: {
    resetWacana: function resetWacana() {
      this.wacana = { id: 0, content: '' };
      this.showConfirmation = false;
    },
    saveWacana: function saveWacana() {
      this.showCreateWacanaModal = false;
      var postData = {
        mapelId: this.$route.query.mapel,
        wacana: this.wacana.content
      };

      var context = this;
      if (this.wacana.id == 0) {
        __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].createWacana(postData, function (result) {
          if (result.success) {
            context.wacana = { id: result.data.id, content: result.data.isi };
            context.loadData();
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].updateWacana(this.wacana.id, postData, function (result) {
          if (result.success) {
            context.loadData();
          }
        });
      }
    },
    editWacana: function editWacana() {
      this.showCreateWacanaModal = true;
    },
    loadData: function loadData() {
      var context = this;
      var mapelId = this.$route.query.mapel;
      __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].getListWacana(mapelId, function (result) {
        if (result.success) {
          context.wacanas = [];
          result.data.forEach(function (wacana) {
            var createdAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(wacana.created_at).fromNow();
            context.wacanas.push({ id: wacana.id, data: [wacana.isi, createdAt] });
          });
        }
      });
    }
  },
  watch: {
    'wacana': function wacana(val) {
      this.$emit('selected', val);
    },
    'value': function value(val) {
      this.wacana = val;
    }
  },
  mounted: function mounted() {
    this.loadData();
  }
});

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_itembank_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapping-modal',
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Modal___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      mapels: [],
      cards: [],
      filteredCards: [],
      topics: null,
      isLoading: false,
      mapelId: null,
      babId: null,
      subBabId: null,
      selectedCard: null,
      query: ''
    };
  },
  mounted: function mounted() {
    var mapels = JSON.parse(localStorage.mapels);
    this.mapels = mapels;

    var context = this;
    this.mapels.forEach(function (mapel) {
      var card = {
        id: mapel.id,
        type: 'mapel',
        picture: mapel.picture != null ? mapel.picture : 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
        code: mapel.code,
        name: mapel.nama
      };

      context.cards.push(card);
    });

    this.filteredCards = this.cards;
  },
  watch: {
    query: function query(val) {
      var filtered = this.cards.filter(function (card) {
        return card.name.toLowerCase().includes(val.toLowerCase());
      });

      this.filteredCards = filtered;
    },
    cards: function cards(val) {
      this.filteredCards = val;
      this.query = '';
    }
  },
  methods: {
    onCardSelected: function onCardSelected(card) {
      var context = this;
      this.selectedCard = card;

      if (!this.topics) {
        this.cards = [];
        this.mapelId = card.id;
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2__services_itembank_js__["a" /* default */].getListOfTopic(card.code, function (response) {
          if (response.success) {
            context.topics = response.data;
            context.topics.forEach(function (topic) {
              var card = {
                id: topic.id,
                type: 'bab',
                picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
                code: topic.code,
                name: topic.nama
              };
              context.cards.push(card);
            });
          }
          context.isLoading = false;
        });
      } else {
        this.isLoading = true;
        if (card.type === 'bab') this.babId = card.id;else if (card.type === 'sub_bab') this.subBabId = card.id;else if (card.type === 'sub_sub_bab') this.subSubBabId = card.id;

        var context = this;
        var data = [];

        if (this.babId) {
          data = this.topics.find(function (topic) {
            return topic.id === context.babId;
          });
        }

        if (this.subBabId) {
          var tmp = data.subs.find(function (d) {
            return d.id === context.subBabId;
          });

          data = tmp;
        }

        if (this.subSubBabId) {
          this.cards = [];
          this.isLoading = false;
          return;
        }

        this.cards = [];
        var cardType = 'bab';
        if (this.babId) cardType = 'sub_bab';
        if (this.subBabId) cardType = 'sub_sub_bab';

        data.subs.forEach(function (d) {
          var card = {
            id: d.id,
            type: cardType,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            code: d.code,
            name: d.nama
          };
          context.cards.push(card);
        });

        this.isLoading = false;
      }
    },
    submitData: function submitData() {
      this.isLoading = true;
      var gradeId = this.$route.query.grade_id;
      var interest = this.$route.query.interest;

      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_itembank_js__["a" /* default */].createTopicMapping(this.mapelId, this.babId, this.subBabId, this.subSubBabId, gradeId, interest, function (response) {
        context.isLoading = false;
        if (response.success) {
          context.$emit('finish');
        }
      });
    },
    reset: function reset() {
      this.topics = null;
      this.mapelId = null;
      this.babId = null;
      this.subBabId = null;
      this.$emit('cancel');
    }
  }
});

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation-nav'
});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'subject-management',
  data: function data() {
    return {
      subjects: [],
      bgColors: ['bg-green', 'bg-blue', 'bg-purple', 'bg-red']
    };
  },
  methods: {
    bgColor: function bgColor(id) {
      var index = id % 4;
      return this.bgColors[index];
    }
  },
  mounted: function mounted() {
    var context = this;
    __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getListMataPelajaran(function (response) {
      response.data.forEach(function (subject) {
        var data = {
          id: subject.id,
          code: subject.code,
          picture: !subject.picture ? 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png' : subject.picture,
          name: subject.nama.length > 20 ? subject.nama.substring(0, 19) + '...' : subject.nama
        };

        context.subjects.push(data);
      });
    });
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topic-management-detail',
  data: function data() {
    return {
      subject: null,
      topic: null,
      subTopic: null,
      subSubTopic: null,
      cards: [],
      filteredCards: [],
      topics: [],
      bgColors: ['bg-green', 'bg-blue', 'bg-purple', 'bg-red'],
      searchQuery: '',
      showModal: false,
      showConfirmationModal: false,
      selectedTopic: null,
      isLoading: false,
      formTopicName: '',
      showNewTopicDialog: false,
      errors: []
    };
  },
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  watch: {
    '$route.query.topic_id': function $routeQueryTopic_id(val) {
      var context = this;
      context.searchQuery = '';

      if (!val) {
        context.topic = null;
        context.cards = context.topics;
        context.filteredCards = context.cards;
      } else {
        var topicId = parseInt(val);
        var found = context.cards.find(function (card) {
          return card.id === topicId;
        });

        context.topic = found;
        context.cards = context.topic.subs;
        context.filteredCards = context.cards;
      }
    },
    '$route.query.sub_topic_id': function $routeQuerySub_topic_id(val) {
      var context = this;
      context.searchQuery = '';

      if (!val) {
        context.subTopic = null;
        if (context.topic) {
          context.cards = context.topic.subs;
          context.filteredCards = context.cards;
        }
      } else {
        var subTopicId = parseInt(val);
        var found = context.cards.find(function (card) {
          return card.id === subTopicId;
        });

        context.subTopic = found;
        context.cards = context.subTopic.subs;
        context.filteredCards = context.cards;
      }
    },
    searchQuery: function searchQuery(val) {
      if (val.length === 0) this.filteredCards = this.cards;
      if (val.length < 3) return;

      this.filteredCards = this.cards.filter(function (card) {
        return card.nama.toLowerCase().includes(val.toLowerCase());
      });
    }
  },
  computed: {
    topicParentName: function topicParentName() {
      if (this.topic) return this.topic.nama;
      if (this.subTopic) return this.subTopic.nama;

      return this.subject.nama;
    }
  },
  methods: {
    bgColor: function bgColor(id) {
      var index = id % 4;
      return this.bgColors[index];
    },
    renderPicture: function renderPicture(path) {
      return !path ? 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png' : path;
    },
    truncateText: function truncateText(text, length) {
      if (text.length <= length) return text;

      return text.substring(0, length) + '...';
    },
    updateSelectedTopic: function updateSelectedTopic(card) {
      var parentName = this.subject.nama;
      var parentId = this.subject.id;

      if (this.topic) {
        parentId = this.topic.id;
        parentName = this.topic.nama;
      }

      if (this.subTopic) {
        parentId = this.subTopic.id;
        parentName = this.subTopic.nama;
      }

      var selectedTopic = {
        id: card.id,
        parentId: parentId,
        parentName: parentName,
        name: card.nama,
        code: card.kode
      };

      this.selectedTopic = selectedTopic;
    },
    showDetail: function showDetail(card) {
      this.updateSelectedTopic(card);
      this.showModal = true;
    },
    showDeleteConfirmation: function showDeleteConfirmation(card) {
      this.updateSelectedTopic(card);
      this.showConfirmationModal = true;
    },
    updateTopic: function updateTopic() {
      if (this.selectedTopic.name.length === 0) {
        this.errors = { formTopicName: 'Field nama harus diisi' };
        return;
      }

      if (this.subTopic) this.doUpdateSubSubBab();else if (this.topic) this.doUpdateSubBab();else this.doUpdateBab();
    },
    doUpdateBab: function doUpdateBab() {
      var data = {
        mapel_id: this.subject.id,
        name: this.selectedTopic.name
      };

      var context = this;
      var babId = this.selectedTopic.id;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].updateBab(babId, data, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === babId;
          });

          var card = context.cards[index];
          card.nama = response.data.nama;

          context.$set(context.cards, index, card);
          context.isLoading = false;
          context.showModal = false;
        }
      });
    },
    doUpdateSubBab: function doUpdateSubBab() {
      var data = {
        bab_id: this.selectedTopic.parentId,
        name: this.selectedTopic.name
      };

      var context = this;
      var id = this.selectedTopic.id;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].updateSubBab(id, data, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id;
          });

          var card = context.cards[index];
          card.nama = response.data.nama;

          context.$set(context.cards, index, card);
          context.isLoading = false;
          context.showModal = false;
        }
      });
    },
    doUpdateSubSubBab: function doUpdateSubSubBab() {
      var data = {
        subbab_id: this.selectedTopic.parentId,
        name: this.selectedTopic.name
      };

      var context = this;
      var id = this.selectedTopic.id;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].updateSubSubBab(id, data, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id;
          });

          var card = context.cards[index];
          card.nama = response.data.nama;

          context.$set(context.cards, index, card);
          context.isLoading = false;
          context.showModal = false;
        }
      });
    },
    deleteTopic: function deleteTopic() {
      if (this.subTopic) this.doDeleteSubSubBab();else if (this.topic) this.doDeleteSubBab();else this.doDeleteBab();
    },
    doDeleteBab: function doDeleteBab() {
      var context = this;
      var id = this.selectedTopic.id;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].deleteBab(id, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id;
          });

          context.$delete(context.cards, index);
        } else {
          context.$store.commit('error_show', 'Tidak dapat menghapus bab, pastikan bab tidak termapping dengan soal');
        }

        context.showConfirmationModal = false;
        context.isLoading = false;
      });
    },
    doDeleteSubBab: function doDeleteSubBab() {
      var context = this;
      var id = this.selectedTopic.id;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].deleteSubBab(id, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id;
          });

          context.$delete(context.cards, index);
        } else {
          context.$store.commit('error_show', 'Tidak dapat menghapus bab, pastikan bab tidak termapping dengan soal');
        }

        context.showConfirmationModal = false;
        context.isLoading = false;
      });
    },
    doDeleteSubSubBab: function doDeleteSubSubBab() {
      var context = this;
      var id = this.selectedTopic.id;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].deleteSubSubBab(id, function (response) {
        if (response.success) {
          var index = context.cards.findIndex(function (card) {
            return card.id === id;
          });

          context.$delete(context.cards, index);
        } else {
          context.$store.commit('error_show', 'Tidak dapat menghapus bab, pastikan bab tidak termapping dengan soal');
        }

        context.showConfirmationModal = false;
        context.isLoading = false;
      });
    },
    addNewTopic: function addNewTopic() {
      if (this.formTopicName === '') {
        this.errors = { formTopicName: 'Field nama harus diisi' };
        return false;
      }

      if (this.subTopic) this.doAddSubSubBab();else if (this.topic) this.doAddSubBab();else this.doAddBab();
    },
    doAddBab: function doAddBab() {
      var data = {
        mapel_id: this.subject.id,
        name: this.formTopicName
      };

      var context = this;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].addBab(data, function (response) {
        if (response.success) {
          var card = {
            id: response.data.id,
            nama: response.data.nama,
            kode: response.data.kode
          };

          context.cards.push(card);
          context.formTopicName = '';
          context.isLoading = false;
          context.showNewTopicDialog = false;
        }
      });
    },
    doAddSubBab: function doAddSubBab() {
      var data = {
        bab_id: this.topic.id,
        name: this.formTopicName
      };

      var context = this;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].addSubBab(data, function (response) {
        if (response.success) {
          var card = {
            id: response.data.id,
            nama: response.data.nama,
            kode: response.data.kode
          };

          context.cards.push(card);
          context.formTopicName = '';
          context.isLoading = false;
          context.showNewTopicDialog = false;
        }
      });
    },
    doAddSubSubBab: function doAddSubSubBab() {
      var data = {
        subbab_id: this.subTopic.id,
        name: this.formTopicName
      };

      var context = this;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].addSubSubBab(data, function (response) {
        if (response.success) {
          var card = {
            id: response.data.id,
            nama: response.data.nama,
            kode: response.data.kode
          };

          context.cards.push(card);
          context.formTopicName = '';
          context.isLoading = false;
          context.showNewTopicDialog = false;
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    var subjectId = this.$route.query.subject_id;
    var subjects = JSON.parse(window.localStorage.getItem('mapels'));
    var found = subjects.find(function (subject) {
      return subject.id === subjectId;
    });

    this.subject = found;
  },
  mounted: function mounted() {
    var context = this;
    __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getListOfTopic(this.subject.code, function (response) {
      if (response.success) {
        response.data.forEach(function (topic) {
          context.topics.push(topic);
        });

        context.cards = context.topics;
        context.filteredCards = context.cards;
      }
    });
  }
});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topic-mapping',
  data: function data() {
    return {
      groups: [],
      showModal: false,
      isLoading: false,
      selectedGrade: null
    };
  },
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  methods: {
    getPicture: function getPicture(grade) {
      if (grade.jenjang.nama === 'SD') return '@/static/assets/images/grade_sd.png';else if (grade.jenjang.nama === 'SMP') return '@/static/assets/images/grade_smp.png';else if (grade.jenjang.nama === 'SMA') return '@/static/assets/images/grade_sma.png';

      return '@/static/assets/images/grade_sma.png';
    },
    bgColor: function bgColor(grade) {
      if (grade.jenjang.nama === 'SD') return 'bg-red';else if (grade.jenjang.nama === 'SMP') return 'bg-blue';else if (grade.jenjang.nama === 'SMA') return 'bg-grey';

      return 'bg-grey';
    },
    mappingDetail: function mappingDetail(grade) {
      this.selectedGrade = grade;
      if (grade.jenjang.nama === 'SMA') this.showModal = true;
    }
  },
  mounted: function mounted() {
    var context = this;
    var groups = [];
    this.isLoading = true;
    __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getListOfTopicGrade(function (response) {
      if (response.success) {
        var groups = [];
        response.data.forEach(function (data) {
          var groupName = data.jenjang.nama;
          var index = groups.findIndex(function (group) {
            return group.name === groupName;
          });

          if (index < 0) {
            var group = {
              name: groupName,
              grades: [data]
            };

            groups.push(group);
          } else {
            groups[index].grades.push(data);
          }
        });

        context.groups = groups;
        context.isLoading = false;
        context.$ls.set('grades', response.data);
      }
    });
  }
});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_kodifikasi_MappingModal__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_kodifikasi_MappingModal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_kodifikasi_MappingModal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'topic-mapping-detail',
  data: function data() {
    return {
      grade: null,
      cards: [],
      filteredCards: [],
      selectedCard: null,
      deletedCard: null,
      bgColors: ['bg-green', 'bg-blue', 'bg-purple', 'bg-red'],
      showMappingModal: false,
      showConfirmationModal: false,
      isLoading: false,
      mapelId: null,
      babId: null,
      subBabId: null,
      subSubBabId: null,
      breadcrumbs: [],
      query: ''
    };
  },
  components: {
    'topic-mapping-modal': __WEBPACK_IMPORTED_MODULE_1__components_kodifikasi_MappingModal___default.a,
    'confirmation-modal': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default.a
  },
  methods: {
    resetCards: function resetCards() {
      this.mapelId = null;
      this.babId = null;
      this.subBabId = null;
      this.cards = [];
      this.breadcrumbs = [];

      var mappings = this.$ls.get('mappings');
      var context = this;
      mappings.forEach(function (data) {
        var card = {
          id: data.mapel_id,
          type: 'mapel',
          code: data.mapel_code,
          picture: data.mapel_picture,
          name: data.mapel_name,
          subs: data.babs
        };

        context.cards.push(card);
      });
    },
    goTo: function goTo(crumbIndex) {
      this.mapelId = null;
      this.babId = null;
      this.subBabId = null;

      var context = this;
      this.breadcrumbs.splice(crumbIndex + 1);
      this.breadcrumbs.forEach(function (crumb) {
        if (crumb.type === 'mapel') context.mapelId = crumb.id;
        if (crumb.type === 'bab') context.babId = crumb.id;
        if (crumb.type === 'sub_bab') context.subBabId = crumb.id;
      });

      this.selectedCard = this.breadcrumbs[this.breadcrumbs.length - 1];
    },
    bgColor: function bgColor(id) {
      var index = id % 4;
      return this.bgColors[index];
    },
    onMappingFinished: function onMappingFinished(mappings) {
      var interest = this.$route.query.interest;
      var gradeId = parseInt(this.$route.query.grade_id, 10);
      var context = this;
      this.cards = [];
      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getTopicMappings(this.grade.id, interest, function (response) {
        if (response.success) {
          context.$ls.set('mappings', response.data);
          response.data.forEach(function (data) {
            var card = {
              id: data.mapel_id,
              type: 'mapel',
              code: data.mapel_code,
              picture: data.mapel_picture,
              name: data.mapel_name,
              subs: data.babs
            };

            context.cards.push(card);
          });
        }

        context.showMappingModal = false;
      });
    },
    confirmDeletion: function confirmDeletion(card) {
      this.showConfirmationModal = true;
      this.deletedCard = card;

      if (this.deletedCard.type === 'sub_bab') this.subBabId = card.id;
      if (this.deletedCard.type === 'sub_sub_bab') this.subSubBabId = card.id;
    },
    allowDeletion: function allowDeletion(card) {
      if (card.type === 'sub_bab') return true;
      if (card.type === 'sub_sub_bab') return true;

      return false;
    },
    deleteMapping: function deleteMapping() {
      this.showConfirmationModal = false;
      this.isloading = true;
      var context = this;

      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].deleteTopicMapping(this.mapelId, this.babId, this.subBabId, this.subSubBabId, this.$route.query.grade_id, this.$route.query.interest, function (response) {
        if (response.success) {
          var removeIndex = context.cards.findIndex(function (card) {
            return card.id === context.deletedCard.id;
          });

          context.cards.splice(removeIndex, 1);
        }

        context.isLoading = false;
      });
    },
    updateBreadcrumbs: function updateBreadcrumbs(card) {
      if (this.breadcrumbs.length > 0) {
        var last = this.breadcrumbs[this.breadcrumbs.length - 1];
        if (card.type !== last.type) this.breadcrumbs.push(card);
      } else {
        this.breadcrumbs.push(card);
      }
    }
  },
  watch: {
    query: function query(val) {
      var filteredCards = this.cards.filter(function (card) {
        return card.name.toLowerCase().includes(val.toLowerCase());
      });

      this.filteredCards = filteredCards;
    },
    cards: function cards(val) {
      this.filteredCards = val;
      this.query = '';
    },
    selectedCard: function selectedCard(val) {
      this.updateBreadcrumbs(val);
      this.cards = [];
      var context = this;
      if (val.type === 'mapel') this.mapelId = val.id;else if (val.type === 'bab') this.babId = val.id;else if (val.type === 'sub_bab') this.subBabId = val.id;else if (val.type === 'sub_sub_bab') this.subSubBabId = val.id;

      val.subs.forEach(function (sub) {
        if (val.type == 'mapel') {
          var card = {
            id: sub.bab_id,
            type: 'bab',
            code: sub.bab_code,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            name: sub.bab_name,
            subs: sub.sub_babs
          };

          context.cards.push(card);
        } else if (val.type == 'bab') {
          var card = {
            id: sub.sub_bab_id,
            type: 'sub_bab',
            code: sub.sub_bab_code,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            name: sub.sub_bab_name,
            subs: sub.sub_sub_babs
          };

          context.cards.push(card);
        } else if (val.type == 'sub_bab') {
          var card = {
            id: sub.sub_sub_bab_id,
            type: 'sub_sub_bab',
            code: sub.sub_sub_bab_code,
            picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png',
            name: sub.sub_sub_bab_name,
            subs: []
          };

          context.cards.push(card);
        }
      });
    }
  },
  beforeMount: function beforeMount() {
    var interest = this.$route.query.interest;
    var gradeId = parseInt(this.$route.query.grade_id, 10);
    var grades = this.$ls.get('grades');
    var found = grades.find(function (grade) {
      return grade.id === gradeId;
    });

    if (found) this.grade = found;
    var context = this;
    __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getTopicMappings(this.grade.id, interest, function (response) {
      if (response.success) {
        context.$ls.set('mappings', response.data);
        response.data.forEach(function (data) {
          var card = {
            id: data.mapel_id,
            type: 'mapel',
            code: data.mapel_code,
            picture: data.mapel_picture,
            name: data.mapel_name,
            subs: data.babs
          };

          context.cards.push(card);
        });
      }
    });
  }
});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Alert',
  props: ['isError', 'message']
});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-footer'
});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_auth_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-header',
  data: function data() {
    return {
      title: 'NFJuara Admin',
      logo: __WEBPACK_IMPORTED_MODULE_1__assets_img_launcher_png___default.a,
      th: sessionStorage.getItem('theme') ? sessionStorage.getItem('theme') : 'old'
    };
  },

  computed: {
    picture: function picture() {
      return this.$ls.get('profiles').picture;
    },
    username: function username() {
      return this.$ls.get('profiles').email;
    }
  },
  methods: {
    changeTheme: function changeTheme() {
      if (sessionStorage.getItem('theme') === 'new') sessionStorage.setItem('theme', 'old');else sessionStorage.setItem('theme', 'new');
      location.reload();
    },
    handleLogout: function handleLogout() {
      var token = localStorage.getItem('jwtToken');
      var context = this;
      __WEBPACK_IMPORTED_MODULE_0__services_auth_js__["a" /* default */].doLogout(token, function (result) {
        if (result.success) {
          context.$ls.clear();
          context.$store.commit('auth_destroyed');
          context.$router.push('/');
        }
      });
    }
  }
});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_itembank_Navigation__ = __webpack_require__(1199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_itembank_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_itembank_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_Navigation__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tryout_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tryout_group_Navigation__ = __webpack_require__(1260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tryout_group_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tryout_group_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_usman_Navigation__ = __webpack_require__(1262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_usman_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_usman_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_kodifikasi_Navigation__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_kodifikasi_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_kodifikasi_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_serial_Navigation__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_serial_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_serial_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vd_pembelajaran_Navigation__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_vd_pembelajaran_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_vd_pembelajaran_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modul_pembelajaran_Navigation__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_modul_pembelajaran_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_modul_pembelajaran_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pembayaran_Navigation__ = __webpack_require__(1228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pembayaran_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_pembayaran_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_duel_Navigation__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_duel_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_duel_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_bimbel_online_Navigation__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_bimbel_online_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_bimbel_online_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_home_setting_Navigation__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_home_setting_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_home_setting_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_organizations_Navigation__ = __webpack_require__(1217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_organizations_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_organizations_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_config_management_Navigation__ = __webpack_require__(1168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_config_management_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_config_management_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sbmptn_Navigation__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_sbmptn_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_sbmptn_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_voucher_Navigation__ = __webpack_require__(1270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_voucher_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_voucher_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_iklan_Navigation__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_iklan_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_iklan_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_affiliate_Navigation__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_affiliate_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_affiliate_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_push_notif_Navigation__ = __webpack_require__(1236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_push_notif_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_push_notif_Navigation__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_teacher_Navigation__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_teacher_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_teacher_Navigation__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






















/* harmony default export */ __webpack_exports__["default"] = ({
  name: "sidebar",
  components: {
    "itembank-nav": __WEBPACK_IMPORTED_MODULE_0__components_itembank_Navigation___default.a,
    "tryout-nav": __WEBPACK_IMPORTED_MODULE_1__components_tryout_Navigation___default.a,
    "tryoutgroup-nav": __WEBPACK_IMPORTED_MODULE_2__components_tryout_group_Navigation___default.a,
    "usman-nav": __WEBPACK_IMPORTED_MODULE_3__components_usman_Navigation___default.a,
    "kodifikasi-nav": __WEBPACK_IMPORTED_MODULE_4__components_kodifikasi_Navigation___default.a,
    "serial-nav": __WEBPACK_IMPORTED_MODULE_5__components_serial_Navigation___default.a,
    "video-nav": __WEBPACK_IMPORTED_MODULE_6__components_vd_pembelajaran_Navigation___default.a,
    "modulbelajar-nav": __WEBPACK_IMPORTED_MODULE_7__components_modul_pembelajaran_Navigation___default.a,
    "pembayaran-nav": __WEBPACK_IMPORTED_MODULE_8__components_pembayaran_Navigation___default.a,
    "duel-nav": __WEBPACK_IMPORTED_MODULE_9__components_duel_Navigation___default.a,
    "bimbel-nav": __WEBPACK_IMPORTED_MODULE_10__components_bimbel_online_Navigation___default.a,
    "content-nav": __WEBPACK_IMPORTED_MODULE_11__components_home_setting_Navigation___default.a,
    "organizations-nav": __WEBPACK_IMPORTED_MODULE_12__components_organizations_Navigation___default.a,
    "config-management-nav": __WEBPACK_IMPORTED_MODULE_13__components_config_management_Navigation___default.a,
    "sbmptn-nav": __WEBPACK_IMPORTED_MODULE_14__components_sbmptn_Navigation___default.a,
    "voucher-nav": __WEBPACK_IMPORTED_MODULE_15__components_voucher_Navigation___default.a,
    "iklan-nav": __WEBPACK_IMPORTED_MODULE_16__components_iklan_Navigation___default.a,
    "affiliate-nav": __WEBPACK_IMPORTED_MODULE_17__components_affiliate_Navigation___default.a,
    "pushnotif-nav": __WEBPACK_IMPORTED_MODULE_18__components_push_notif_Navigation___default.a,
    "teacher-nav": __WEBPACK_IMPORTED_MODULE_19__components_teacher_Navigation___default.a
  },

  data: function data() {
    return {
      scopes: []
    };
  },
  mounted: function mounted() {
    App.init();
  }
});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_itembank_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modul-belajar-form',
  components: {
    'file-upload': __WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      title: '',
      description: '',
      joinCode: '',
      picture: 'https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_english.png',
      isLoading: false,
      errors: []
    };
  },
  methods: {
    generateRandomCode: function generateRandomCode(length) {
      var code = '';
      var possibleChar = 'abcdefghijklmnopqrstuvwxyz1234567890';
      for (var i = 0; i < length; i++) {
        code += possibleChar.charAt(Math.floor(Math.random() * possibleChar.length));
      }

      return code.toUpperCase();
    },
    onSubmitBtnClicked: function onSubmitBtnClicked() {
      if (this.validateForm()) {
        var data = {
          join_code: this.joinCode,
          name: this.title,
          picture: this.picture,
          description: this.description
        };

        this.isLoading = true;
        var context = this;
        if (this.$route.query.id) {
          var modulId = this.$route.query.id;
          __WEBPACK_IMPORTED_MODULE_2__services_itembank_js__["a" /* default */].updateModulBelajar(modulId, data, function (response) {
            context.isLoading = false;
            if (response.success) {
              alert("Modul berhasil di update");
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_2__services_itembank_js__["a" /* default */].createModulBelajar(data, function (response) {
            context.isLoading = false;
            if (response.success) {
              context.$router.push({ path: '/modul-belajar' });
            }
          });
        }
      }
    },
    onManageMaterialBtnClicked: function onManageMaterialBtnClicked() {
      var modulId = this.$route.query.id;
      this.$router.push({ path: '/modul-belajar/materials', query: { modul_id: modulId } });
    },
    onManageLiveStreamBtnClicked: function onManageLiveStreamBtnClicked() {
      var modulId = this.$route.query.id;
      this.$router.push({ path: '/modul-belajar/live-stream', query: { modul_id: modulId } });
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.title) this.errors.push('title');
      if (!this.joinCode) this.errors.push('join_code');
      if (!this.picture) this.errors.push('picture');

      return this.errors.length == 0;
    }
  },
  mounted: function mounted() {
    if (this.$route.query.id) {
      this.isLoading = true;
      var modulId = this.$route.query.id;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_itembank_js__["a" /* default */].getModulBelajar(modulId, function (response) {
        context.isLoading = false;
        if (response.success) {
          context.title = response.data.name;
          context.description = response.data.description;
          context.joinCode = response.data.join_code;
          context.picture = response.data.picture;
        }
      });
    }
  }
});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_itembank_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modul-belajar',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      selectedRow: null,
      headers: ['gambar', 'nama', 'kode join'],
      modules: []
    };
  },
  methods: {
    createModul: function createModul() {
      this.$router.push({ path: '/modul-belajar/form' });
    },
    loadModulData: function loadModulData() {
      this.modules = [];
      var context = this;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_4__services_itembank_js__["a" /* default */].getListModulBelajar(function (response) {
        context.isLoading = false;
        if (response.success) {
          response.data.forEach(function (modul) {
            var row = {
              id: modul.id,
              data: ['<img src="' + modul.picture + '" class="rounded-corner height-50 width-50">', modul.name, modul.join_code]
            };

            context.modules.push(row);
          });
        }
      });
    },
    editModulBelajar: function editModulBelajar() {
      var modulId = this.selectedRow.id;
      this.$router.push({ path: '/modul-belajar/form', query: { id: modulId } });
    },
    deleteModulBelajar: function deleteModulBelajar(modul) {
      var confirmed = window.confirm("Apakah anda yakin akan menghapus modul ini?");
      if (confirmed) {
        this.isLoading = true;
        var context = this;
        __WEBPACK_IMPORTED_MODULE_4__services_itembank_js__["a" /* default */].deleteModulBelajar(modul.id, function (response) {
          context.isLoading = false;
          if (response.success) {
            context.loadModulData();
          }
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadModulData();
  }
});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_video_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modul-material',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      showModal: false,
      modul: null,
      jenjang: 'SD',
      kelas: 1,
      headers: ['judul', 'mata pelajaran', 'mulai', 'selesai'],
      rows: [],
      materials: [],
      selectedRow: null
    };
  },
  methods: {
    createMaterial: function createMaterial() {
      var modulId = this.$route.query.modul_id;
      this.$router.push({ path: '/video/material/live-stream/form', query: { modul_id: modulId } });
    },
    editMaterial: function editMaterial() {
      var modulId = this.selectedRow.id;
      this.$router.push({ path: '/video/material/live-stream/form', query: { liveId: modulId, module: this.$route.query.modul_id } });
    },
    publish: function publish(item) {
      var context = this;
      var data = item.bodyPublish;
      var grades = [];
      var forgrade = item.bodyPublish.grades.forEach(function (item) {
        grades.push(item.grade);
      });
      var body = {
        "title": data.title,
        "description": data.description,
        "start_date": data.start_date,
        "end_date": data.end_date,
        "start_time": data.start_time,
        "end_time": data.end_time,
        "source": data.source,
        "interest": data.interest,
        "youtube_url": data.youtube_url,
        "mapel_id": data.mapel.id,
        "grades": grades
        // console.log(body)
      };__WEBPACK_IMPORTED_MODULE_3__services_video_js__["a" /* default */].setPublishing(item.id, body, function (response) {
        alert('data telah diubah');
        context.rows = [];
        context.materials = [];
        context.kelas = 1;
        context.jenjang = 'SD';
        context.loadData();
      });
    },
    unpublish: function unpublish(item) {
      var context = this;
      var data = item.bodyPublish;
      var grades = [];
      var forgrade = item.bodyPublish.grades.forEach(function (item) {
        grades.push(item.grade);
      });
      var body = {
        "title": data.title,
        "description": data.description,
        "start_date": data.start_date,
        "end_date": data.end_date,
        "start_time": data.start_time,
        "end_time": data.end_time,
        "source": data.source,
        "interest": data.interest,
        "youtube_url": data.youtube_url,
        "mapel_id": data.mapel.id,
        "grades": grades
      };

      __WEBPACK_IMPORTED_MODULE_3__services_video_js__["a" /* default */].editVideoLiveStreaming(item.id, body, function (response) {
        alert('data telah diubah');
        context.rows = [];
        context.materials = [];
        context.kelas = 1;
        context.jenjang = 'SD';
        context.loadData();
      });
    },

    filterRow: function filterRow() {
      this.rows = [];
      var context = this;
      this.materials.forEach(function (material) {
        material.grades.forEach(function (grade) {
          if (grade.grade == context.kelas) {
            var duration = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(material.duration, 'seconds');
            var durationString = duration.hours() + ':' + duration.minutes() + ':' + duration.seconds();
            var data = {
              id: material.id,
              url: material.youtube_url,
              bodyPublish: material,
              status: material.status,
              data: [material.title, material.mapel.nama, material.start_date + ' ' + material.start_time, material.end_date + ' ' + material.end_time]
            };

            context.rows.push(data);
            return;
          }
        });
      });
    },
    loadData: function loadData() {
      var modulId = this.$route.query.modul_id;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3__services_video_js__["a" /* default */].getListVideoLiveStreamByModuleId(modulId, function (response) {
        if (response.success) {
          response.data.forEach(function (data) {
            context.materials.push(data);
          });
          context.filterRow();
        }
      });
    },

    deleteItem: function deleteItem(data) {
      var confirmed = window.confirm('Apakah anda yakin akan menghapus video ini?');
      if (confirmed) {
        var context = this;
        __WEBPACK_IMPORTED_MODULE_3__services_video_js__["a" /* default */].deleteVideoStreaming(data.id, function (response) {
          if (response.success) {
            var foundIndex = context.materials.findIndex(function (row) {
              return materials.id == data.id;
            });
            context.loadData();
            context.materials.splice(foundIndex, 1);
          }
        });
      }
    }
  },
  watch: {
    kelas: function kelas(newVal) {
      this.filterRow();
    }
  },
  mounted: function mounted() {
    if (this.$route.query.modul_id) {
      var modulId = this.$route.query.modul_id;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3__services_video_js__["a" /* default */].getListVideoLiveStreamByModuleId(modulId, function (response) {
        if (response.success) {
          response.data.forEach(function (data) {
            context.materials.push(data);
          });
          context.filterRow();
        }
      });
    }
  }
});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_video_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modul-material',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      showModal: false,
      modul: null,
      jenjang: 'SD',
      kelas: 1,
      headers: ['thumbnail', 'judul', 'mata pelajaran', 'duration'],
      rows: [],
      materials: [],
      selectedRow: null
    };
  },
  methods: {
    createMaterial: function createMaterial() {
      var modulId = this.$route.query.modul_id;
      this.$router.push({ path: '/video/form', query: { modul_id: modulId } });
    },
    editMaterial: function editMaterial() {
      var modulId = this.selectedRow.id;
      // console.log(modulId)
      this.$router.push({ path: '/video/material/form', query: { id: modulId, module: this.$route.query.modul_id } });
    },
    filterRow: function filterRow() {
      this.rows = [];
      var context = this;
      this.materials.forEach(function (material) {
        material.grades.forEach(function (grade) {
          if (grade.grade == context.kelas) {
            var duration = __WEBPACK_IMPORTED_MODULE_4_moment___default.a.duration(material.duration, 'seconds');
            var hours = duration.hours() < 10 ? '0' + duration.hours() : duration.hours();
            var minutes = duration.minutes() < 10 ? '0' + duration.minutes() : duration.minutes();
            var seconds = duration.seconds() < 10 ? '0' + duration.seconds() : duration.seconds();
            var durationString = hours + ':' + minutes + ':' + seconds;
            var data = {
              id: material.id,
              url: material.youtube_url,
              data: ["<img src='" + material.thumbnail + "' class='width-100'>", material.title, material.mapel.nama, durationString]
            };

            context.rows.push(data);
            console.log(context.rows);
            return;
          }
        });
      });
    },
    deleteItem: function deleteItem(data) {
      var confirmed = window.confirm('Apakah anda yakin akan menghapus video ini?');
      if (confirmed) {
        var context = this;
        __WEBPACK_IMPORTED_MODULE_3__services_video_js__["a" /* default */].deleteVideo(data.id, function (response) {
          if (response.success) {
            var foundIndex = context.rows.findIndex(function (row) {
              return row.id == data.id;
            });

            context.rows.splice(foundIndex, 1);
          }
        });
      }
    }
  },
  watch: {
    kelas: function kelas(newVal) {
      this.filterRow();
    }
  },
  mounted: function mounted() {
    if (this.$route.query.modul_id) {
      var modulId = this.$route.query.modul_id;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3__services_video_js__["a" /* default */].getListVideoByModuleId(modulId, function (response) {
        if (response.success) {
          response.data.forEach(function (data) {
            context.materials.push(data);
          });

          context.filterRow();
        }
      });
    }
  }
});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'module-nav'
});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation-nav'
});

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organizations_OrganizationsBulk__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_organizations_OrganizationsBulk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_organizations_OrganizationsBulk__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-detail',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
    'organizations-bulk': __WEBPACK_IMPORTED_MODULE_2__components_organizations_OrganizationsBulk___default.a
  },
  data: function data() {
    return {
      organization: {},
      listCabang: [],
      students: [],
      studentMaps: [],
      isLoading: true,
      pageNumber: 1,
      query: '',
      isMapping: false,
      isBulkModal: false,
      ossEndpoint: "oss-ap-southeast-5.aliyuncs.com",
      ossBucketName: "nfjuara",
      organizationId: this.$route.params.id,
      isDisabledNextBtn: false
    };
  },
  methods: {
    loadStudentData: function loadStudentData() {
      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/usman/users';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {
        params: {
          page: this.pageNumber,
          query: this.query,
          organization_id: this.organizationId
        }
      }).then(function (response) {
        if (response.data.length < 25) {
          context.isDisabledNextBtn = true;
        } else {
          context.isDisabledNextBtn = false;
        }

        context.students = response.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    loadDetailData: function loadDetailData() {
      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/v2/organization/' + context.$route.params.id;

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url).then(function (response) {
        context.organization = response.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    loadListDaftarCabang: function loadListDaftarCabang() {
      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/v2/organization/' + context.$route.params.id + '/childs';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url).then(function (response) {
        context.listCabang = response.data.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    submitMapping: function submitMapping(duration) {
      var _this = this;

      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/b2b_mapping';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.post(url, {
        organization_id: this.$route.params.id,
        features: 'SCHEDULED_TRYOUT',
        duration: duration,
        user_ids: this.studentMaps
      }).then(function () {
        alert('mapping berhasil');
        _this.isLoading = false;
        _this.isBulkModal = false;
        _this.mappingToggle();
      }).catch(function () {
        alert('mapping error');
        _this.isLoading = false;
      });
    },
    mappingToggle: function mappingToggle() {
      if (this.isMapping) {
        this.isMapping = false;
        this.organizationId = this.$route.params.id;
      } else {
        this.isMapping = true;
        this.organizationId = '';
      }

      this.loadStudentData();
    }
  },
  mounted: function mounted() {
    this.loadDetailData();
    // this.loadStudentData()
    this.loadListDaftarCabang();
  },
  watch: {
    pageNumber: function pageNumber(newVal) {
      this.loadStudentData(newVal);
    }
  }
});

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_FileUpload__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_FileUpload__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'season-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
    'file-upload': __WEBPACK_IMPORTED_MODULE_2__components_plugins_FileUpload___default.a
  },
  data: function data() {
    return {
      queryId: null,
      errors: [],
      isLoading: false,
      selectedPicture: null,
      setPass: false,
      pictureurl: '',
      data: {
        name: '',
        address: '',
        contact: '',
        picture: 'assets/organization/kpw31g3x.jpg',
        email: '',
        province: '',
        city: '',
        // npsn: 0,
        password: null
      },
      provinceList: ["Aceh", "Bali", "Banten", "Bengkulu", "DKI Yogyakarta", "DKI Jakarta", "Gorontalo", "Jambi", "Jawa Barat", "Jawa Tengah", "Jawa Timur", "Kalimantan Barat", "Kalimantan Selatan", "Kalimantan Tengah", "Kalimantan Timur", "Kalimantan Utara", "Kepulauan Bangka Belitung", "Kepulauan Riau", "Lampung", "Maluku", "Maluku Utara", "Nusa Tenggara Barat", "Nusa Tenggara Timur", "Papua", "Papua Barat", "Riau", "Sulawesi Barat", "Sulawesi Selatan", "Sulawesi Tengah", "Sulawesi Tenggara", "Sulawesi Utara", "Sumatera Barat", "Sumatera Selatan", "Sumatera Utara"],
      ossEndpoint: "oss-ap-southeast-5.aliyuncs.com",
      ossBucketName: "nfjuara"
    };
  },
  mounted: function mounted() {
    var context = this;
    this.data.picture = 'https://' + context.ossBucketName + '.' + context.ossEndpoint + '/' + context.data.picture;
    if (this.$route.params.id) {
      this.queryId = this.$route.params.id;
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var queryId = this.queryId;
      this.isLoading = true;

      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/organization/' + queryId;

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });
      http.get(url).then(function (response) {
        context.data = response.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    saveData: function saveData() {
      var context = this;
      var data = this.data;
      var token = this.$ls.get('token');
      this.isLoading = true;
      var url = "https://api.nfjuara.id" + '/account/v2/organization';

      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });
      if (this.validateForm()) {
        http.post(url, data).then(function (response) {
          context.isLoading = false;
          context.$router.push('/organizations');
        }).catch(function (error) {
          context.isLoading = false;
          alert("Gagal simpan data : " + error.response.data.message);
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    editData: function editData() {
      var context = this;
      var id = this.$route.params.id;
      // var data = this.data
      var token = this.$ls.get('token');
      this.isLoading = true;
      var url = "https://api.nfjuara.id" + '/account/v2/organization/' + context.$route.params.id;

      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });
      var data = {
        // "head_id": this.data.id,
        "name": this.data.name,
        "city": this.data.city,
        "province": this.data.province,
        "address": this.data.address,
        "contact": this.data.contact,
        "picture": this.data.picture,
        "password": this.data.password
      };
      if (this.validateForm()) {
        http.put(url, data).then(function (response) {
          context.isLoading = false;
          alert("Update data berhasil");
          context.$router.push('/organization/' + context.$route.params.id);
        }).catch(function (error) {
          context.isLoading = false;
          alert("Gagal simpan data : " + error.response.data.message);
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    fileUploaded: function fileUploaded(value) {
      var context = this;
      this.data.picture = 'https://' + context.ossBucketName + '.' + context.ossEndpoint + '/' + value.key;
    },
    validateForm: function validateForm() {
      var emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      var isEmailValidate = emailRegex.test(this.data.email);

      var isNumberValidate = /^[0-9]+$/.test(this.data.contact);

      this.errors = [];
      if (!this.data.name) this.errors.push('Nama wajib diisi');
      if (!this.data.email) this.errors.push('Email wajib diisi');
      // if (!this.data.npsn) this.errors.push('NPSN wajib diisi')
      if (!this.data.password && this.setPass === true) this.errors.push('Password wajib diisi');
      if (this.data.password && this.data.password.length < 6) this.errors.push('Password minimum 6 karakter');
      if (!isEmailValidate) this.errors.push('Format email salah');
      if (!this.data.address) this.errors.push('Alamat wajib diisi');
      if (!this.data.contact) this.errors.push('No. Telpon wajib diisi');
      if (!isNumberValidate) this.errors.push('Format telpon salah');
      return this.errors.length == 0;
    }
  }
});

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-management',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      query: '',
      isLoading: false,
      pageNumber: 1,
      organizations: [],
      total_page: 0,
      isDisabledNextBtn: false
    };
  },
  watch: {
    pageNumber: function pageNumber(newVal) {
      this.loadOrganizationsData(newVal);
    }
  },
  methods: {
    loadOrganizationsData: function loadOrganizationsData() {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/v2/organizations';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {
        params: {
          page: pageNumber,
          name: this.query
        }
      }).then(function (response) {
        if (response.data.length < 25) {
          context.isDisabledNextBtn = true;
        } else {
          context.isDisabledNextBtn = false;
        }
        context.organizations = response.data.data;
        context.total_page = response.data.total_page;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    goToDetail: function goToDetail(id) {
      this.$router.push('organization/' + id);
    }
  },
  mounted: function mounted() {
    this.loadOrganizationsData();
  }
});

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      ossTemplate: __webpack_require__.i({"NODE_ENV":"production","API_BASE_URL":"https://api.nfjuara.id","OSS_ENDPOINT":"oss-ap-southeast-5.aliyuncs.com","OSS_KEY":"LTAI4GADj6URzXKuwTePhKSG","OSS_SECRET":"7jtZqmIolrrGrj3MR1BTP9XKqC3CO2","OSS_BUCKET_NAME":"nfjuara","NOTIFICATION_AUTH":"AAAAjnwSLyg:APA91bFey72DPW8lCC3gSzx3O1svSS5BLu99VJ9PxpBlZJzW9CybvRoV_sdDkdNjt0tbPEgks8asO3uw9hbbLdrJ1fX8VSU1K3pVb3zkQrW879KUSGdyi4wKkReZux5PwoF3yralnhmI"}).OSS_TEMPLATE
    };
  }
});

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aws_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_aws_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uniqid__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uniqid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uniqid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_FileUpload__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_FileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_bimbel_js__ = __webpack_require__(26);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'OrganizationsBulk',
  components: {
    FileUpload: __WEBPACK_IMPORTED_MODULE_3__components_plugins_FileUpload___default.a,
    AppSpinner: __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default.a
  },
  props: {
    isMapping: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      filename: '',
      data: {
        key_name: '',
        organization_id: this.$route.params.id,
        duration: 1,
        features: '',
        grade: 0,
        default_password: ''
      },

      ossTemplate: 'https://' + "nfjuara" + '.' + "oss-ap-southeast-5.aliyuncs.com" + '/assets/organizations/template.csv',
      isLoadActivationAsyncProgress: false,

      jenjangList: [],
      jenjang: '',
      grade: 0,
      hidePass: true,
      // boolean modelnya checkbox bimbel
      featBimbel: false,
      // variable yang menyimpan list bimbel yang di get dri api
      bimbelList: [],
      // daftar bimbel yg dipilih masuk ke variable ini
      bimbels: [],
      // bimbel di pisah karena punya behavior yang berbeda
      featureList: ['SCHEDULED_TRYOUT', 'INSTANT_TRYOUT',
      //    'DUEL',
      //    'CONSULTATION',
      'ITEM_BANK', 'VIDEO'],
      features: []
    };
  },

  watch: {
    jenjang: function jenjang(to, from) {
      if (to === 'SD') this.jenjangList = [4, 5, 6];
      if (to === 'SMP') this.jenjangList = [7, 8, 9];
      if (to === 'SMA') this.jenjangList = [10, 11, 12];
    },
    featBimbel: function featBimbel(to, from) {
      if (to) {
        this.getBimbel();
      } else {
        this.bimbelList = [];
        this.bimbels = [];
      }
    },
    grade: function grade(to, from) {
      // console.log(to)
      this.data.features = [];
      this.featBimbel = false;
    },
    isLoadActivationAsyncProgress: function isLoadActivationAsyncProgress(value) {
      if (value === false) {
        clearInterval(this.interval);
        this.$emit('close');
      }
    }
  },
  methods: {
    getBimbel: function getBimbel() {
      var context = this;
      if (this.grade === 0) this.grade = 12;
      __WEBPACK_IMPORTED_MODULE_5__services_bimbel_js__["a" /* default */].statPublishedBimbel(this.grade, function (result) {
        context.bimbelList = result.data;
      });
    },
    upload: function upload(e) {
      console.log(e);
      var file = e.target.files[0];

      console.log('file: ', file);

      if (!file) return;
      // if(file.type.indexOf('csv') == -1 &&
      //    file.type.indexOf('ms-excel') == -1) {
      //   alert('file type not supported')
      //   return
      // }

      __WEBPACK_IMPORTED_MODULE_1_aws_sdk___default.a.config.accessKeyId = "LTAI4GADj6URzXKuwTePhKSG";
      __WEBPACK_IMPORTED_MODULE_1_aws_sdk___default.a.config.secretAccessKey = "7jtZqmIolrrGrj3MR1BTP9XKqC3CO2";
      var spaceEndpoint = "oss-ap-southeast-5.aliyuncs.com";
      var bucket = new __WEBPACK_IMPORTED_MODULE_1_aws_sdk___default.a.S3({
        endpoint: spaceEndpoint
      });

      var fileExt = file.name.substr(-4);
      var filename = __WEBPACK_IMPORTED_MODULE_2_uniqid___default()() + fileExt;
      var params = {
        Bucket: "nfjuara",
        Key: 'assets/organizations/' + filename,
        Body: file,
        ContentType: file.type,
        ACL: 'public-read'
      };

      var context = this;
      bucket.upload(params, function (error, data) {
        if (error) {
          console.error(error);
        } else {
          context.filename = file.name;
          context.data.key_name = data.key;
        }
      });
    },
    submitBulkActivation: function submitBulkActivation() {
      var _this = this;

      var token = this.$ls.get('token');
      var context = this;
      var url = "https://api.nfjuara.id" + '/account/register/bulk';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      if (this.featBimbel && this.bimbels.length > 0) {
        var bbl = ',';
        this.bimbels.forEach(function (element) {
          bbl += element + ',';
        });
        this.features.push('BIMBEL' + bbl);
      }
      if (this.features.length > 0) {
        this.features.forEach(function (element) {
          _this.data.features += element + ',';
        });
      }
      this.data.grade = this.grade;
      this.data.features = this.data.features.slice(0, -1);
      this.data.organization_id = parseInt(this.data.organization_id);
      if (this.data.features.length == 0) this.data.features = null;
      http.post(url, context.data).then(function (response) {
        var activationId = response.data.id;
        _this.loadActivationAsyncProgress(activationId);
      }).catch(function (error) {
        return console.log(error.response.data);
      });
    },
    loadActivationAsyncProgress: function loadActivationAsyncProgress(activationId) {
      var _this2 = this;

      this.isLoadActivationAsyncProgress = true;

      this.interval = setInterval(function () {
        var token = JSON.parse(localStorage.getItem('token'));
        var url = "https://api.nfjuara.id" + '/account/job/' + activationId;

        var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token.value
          }
        });

        http.get(url).then(function (response) {
          var data = response.data;

          if (data.status.toLowerCase() === 'finished') {
            _this2.isLoadActivationAsyncProgress = false;
            _this2.$emit('reload');
            alert('Bulk Activation Success');
          }

          if (data.status.toLowerCase() === 'failed') {
            _this2.isLoadActivationAsyncProgress = false;
            alert('Bulk Activation Error!');
          }
        }).catch(function () {
          _this2.isLoadActivationAsyncProgress = false;
          alert('Bulk Activation Error!');
        });
      }, 10000);
    }
  }
});

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_auth_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_file_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "manual-input",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a,
    "app-imagecropper": __WEBPACK_IMPORTED_MODULE_4__components_plugins_ImageCropper___default.a
  },
  data: function data() {
    return {
      isUserValidated: false,
      isLoading: false,
      userData: null,
      products: [],
      paymentMethods: [],
      email: null,
      selectedPicture: null,
      form: {
        user_id: null,
        product_id: null,
        payment_id: null,
        bank_name: null,
        account_name: null,
        payment_slip_url: null
      }
    };
  },
  methods: {
    doQueryUser: function doQueryUser() {
      var data = { email: this.email };
      var context = this;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_1__services_auth_js__["a" /* default */].queryUser(data, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.userData = result.data;
          context.isUserValidated = true;
          context.form.user_id = result.data.id;
          context.loadProductData();
          context.loadPaymentMethodData();
        } else {
          window.alert("Data user tidak ditemukan");
        }
      });
    },
    loadProductData: function loadProductData() {
      var grade = this.userData.profile.grade;
      var context = this;

      var pagination = { currentPage: 1, perPage: 100 };
      var search = { by: "grade", query: grade };
      __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].getProdukList(pagination, search, function (result) {
        if (result.success) {
          context.products = result.data;
        }
      });
    },
    loadPaymentMethodData: function loadPaymentMethodData() {
      var context = this;
      var pagination = { currentPage: 1, perPage: 100 };
      var search = null;
      __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].getMetodePembayaranList(pagination, search, function (result) {
        if (result.success) {
          context.paymentMethods = result.data;
        }
      });
    },
    onFileChanged: function onFileChanged(event) {
      var fileName = event.url.split("/")[3] + ".jpg";
      var path = "sales/transactions/user_" + this.userData.id + "/" + fileName;
      var context = this;
      var imageData = event.blob;
      this.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_3__services_file_js__["a" /* default */].upload(imageData, path, function (response) {
        if (response.success) {
          var imageUrl = "https://" + "nfjuara" + "." + "oss-ap-southeast-5.aliyuncs.com" + "/" + response.data;

          context.form.payment_slip_url = imageUrl;
        }

        context.isLoading = false;
      });
    },
    save: function save() {
      var context = this;
      var isConfirmed = window.confirm("Apakah anda yakin data ini sudah benar?");
      if (isConfirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].createManualTransaction(this.form, function (response) {
          if (response.success) {
            context.$router.push("/pembayaran");
          }

          context.isLoading = false;
        });
      }
    }
  },
  computed: {
    txtUserInfo: function txtUserInfo() {
      return "[" + this.userData.id + "]" + " " + this.userData.profile.name + " - " + this.userData.profile.school;
    }
  }
});

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'katalog-tiket',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			isLoading: false,
			katalogTiketList: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			type: {
				SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
				INSTANT_TRYOUT: 'INSTANT_TRYOUT',
				CONSULTATION: 'CONSULTATION',
				DUEL: 'DUEL',
				ITEM_BANK: 'ITEM_BANK',
				VIDEO: 'VIDEO'
			},
			headers: ['Title', 'Type', 'Ticket', 'Value', 'Status', 'Created At'],
			headersKey: ['title', 'type', 'ticket', 'value', 'status', 'createdAt']
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			};

			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].getKatalogTiketList(pagination, search, function (result) {
				context.katalogTiketList = [];
				context.isLoading = false;

				if (result.success) {
					result.data.forEach(function (content) {
						var value = content.value;

						if (content.type === context.type.SCHEDULED_TRYOUT) value += ' TO';
						if (content.type === context.type.DUEL) value = '-';
						if (content.type === context.type.INSTANT_TRYOUT || content.type === context.type.ITEM_BANK || content.type === context.type.VIDEO) {
							value += ' bulan';
						}

						var row = {
							id: content.id,
							data: [content.title, content.type, content.ticket, value, content.status, __WEBPACK_IMPORTED_MODULE_3_moment___default()(content.created_at).format('YYYY-MM-DD') || '-']
						};

						context.pagination.totalPages = content.page;
						context.katalogTiketList.push(row);
					});
				} else {
					alert('Terjadi Kesalahan : ' + result.data.message);
				}
			});
		},
		createKatalogTiket: function createKatalogTiket() {
			this.$router.push({ path: '/katalog-tiket/form' });
		},
		updateKatalogTiket: function updateKatalogTiket() {
			var katalogId = this.selectedRow.id;
			this.$router.push({ path: '/katalog-tiket/form', query: { id: katalogId } });
		},
		updateAllKatalogTiketStatus: function updateAllKatalogTiketStatus(status) {
			var context = this;
			var confirmed = window.confirm("Apakah anda yakin akan mengupdate semua status katalog?");
			if (confirmed) {

				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].updateAllKatalogTiketStatus(status, function (result) {
					context.isLoading = false;
					if (result.success) {
						alert('Data Terupdate');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		},
		deleteKatalogTiket: function deleteKatalogTiket(katalog) {
			var context = this;
			var katalogId = katalog.id;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus katalog ini?");
			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].deleteKatalogTiket(katalogId, function (result) {
					context.isLoading = false;
					if (result.success) {
						alert('Data Terhapus');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		}
	}
});

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'katalog-tiket-form',
	components: {
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			errors: [],
			queryId: null,
			isLoading: false,
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			types: [{
				key: 'SCHEDULED_TRYOUT',
				title: 'SCHEDULED TRYOUT',
				value: 'Jumlah TO'
			}, {
				key: 'INSTANT_TRYOUT',
				title: 'INSTANT TRYOUT',
				value: 'Bulan'
			}, {
				key: 'CONSULTATION',
				title: 'CONSULTATION',
				value: 'Jumlah'
			}, {
				key: 'DUEL',
				title: 'DUEL',
				value: null
			}, {
				key: 'ITEM_BANK',
				title: 'ITEM BANK',
				value: 'Bulan'
			}, {
				key: 'VIDEO',
				title: 'VIDEO',
				value: 'Bulan'
			}],
			selectedPicture: null,
			data: {
				type: "",
				title: null,
				value: null,
				description: null,
				ticket: null,
				picture: null,
				status: null,
				is_subscription: true
			},
			editor: __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default.a,
			editorConfig: {
				toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'outdent', 'indent']
			}
		};
	},
	mounted: function mounted() {
		if (this.$route.query.id) {
			this.queryId = this.$route.query.id;
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var queryId = this.queryId;
			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].getKatalogTiketDetail(queryId, function (result) {
				context.isLoading = false;
				if (result.success) {
					context.data.title = result.data.title;
					context.data.type = result.data.type;
					context.data.ticket = result.data.ticket;
					context.data.value = result.data.value;
					context.data.picture = result.data.picture;
					context.data.description = result.data.description;
					context.data.status = result.data.status;
					context.data.is_subscription = result.data.is_subscription;
				} else {
					alert('Terjadi Kesalahan : ' + result.message);
				}
			});
		},
		saveData: function saveData() {
			var context = this;
			var data = this.data;
			this.isLoading = true;
			if (this.data.type === 'DUEL' || this.data.type === 'CONSULTATION') {
				this.data.is_subscription = false;
				this.data.value = 1;
			} else if (this.data.type === 'INSTANT_TRYOUT' || this.data.type === 'VIDEO' || this.data.type === 'ITEM_BANK') {
				this.data.is_subscription = true;
			} else if (this.data.type === 'SCHEDULED_TRYOUT' && this.data.is_subscription === false) {
				this.data.value = 1;
			}
			if (this.validateForm()) {
				__WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].addKatalogTiket(data, function (result) {
					context.isLoading = false;
					if (result.success) context.doUploadPicture(result.data.id);else alert('Terjadi Kesalahan : ' + result.message);
				});
			} else {
				this.isLoading = false;
				$(window).scrollTop(0);
			}
		},
		editData: function editData() {
			var context = this;
			var id = this.queryId;
			var data = this.data;
			this.isLoading = true;
			if (this.data.type === 'DUEL' || this.data.type === 'CONSULTATION') {
				this.data.is_subscription = false;
				this.data.value = 1;
			} else if (this.data.type === 'INSTANT_TRYOUT' || this.data.type === 'VIDEO' || this.data.type === 'ITEM_BANK') {
				this.data.is_subscription = true;
			} else if (this.data.type === 'SCHEDULED_TRYOUT' && this.data.is_subscription === false) {
				this.data.value = 1;
			}
			if (this.validateForm()) {
				__WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].updateKatalogTiket(id, data, function (result) {
					context.isLoading = false;
					if (result.success) context.doUploadPicture(id);else alert('Terjadi Kesalahan : ' + result.message);
				});
			} else {
				this.isLoading = false;
				$(window).scrollTop(0);
			}
		},
		validateForm: function validateForm() {
			var _this = this;

			this.errors = [];
			if (!this.data.type) {
				this.errors.push('Tipe produk wajib diisi');
			} else {
				if (!this.data.title) this.errors.push('Judul wajib diisi');

				// if value is null and type !== DUEL
				if (!this.data.value && this.data.type !== this.types[3].key && this.data.type !== this.types[2].key && this.data.type !== this.types[0].key) {
					this.types.map(function (type, index) {
						if (_this.data.type === type.key) _this.errors.push(type.value + ' wajib diisi');
					});
				}
				if (!this.data.picture) this.errors.push('Gambar wajib diisi');
				if (!this.data.description) this.errors.push('Deskripsi wajib diisi');
				if (this.data.description) {
					if (this.characterCounter(this.data.description) > 1000) {
						this.errors.push('Deskripsi tidak boleh lebih dari 1000 karakter');
					}
				}
				if (!this.data.ticket) this.errors.push('Ticket wajib diisi');
				if (!this.data.status) this.errors.push('Status wajib diisi');
				if (this.selectedPicture) {
					if (this.selectedPicture.size > 1000000) this.errors.push('Gambar tidak boleh lebih dari 1MB');
				}
			}
			return this.errors.length == 0;
		},
		handleChangePicture: function handleChangePicture(event) {
			var file = event.target.files[0];
			this.selectedPicture = file;
			this.data.picture = URL.createObjectURL(file);
		},
		characterCounter: function characterCounter(text) {
			text = text.replace(/<[^>]*>/g, '');
			text = text.replace(/\&nbsp;/g, ' ');
			return text.length;
		},
		doUploadPicture: function doUploadPicture(id) {
			var context = this;
			var picture = this.selectedPicture;
			var formData = new FormData();

			if (picture) {
				formData.append('name', picture.name);
				formData.append('file', picture);

				__WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].uploadKatalogTiketPicture(id, formData, function (result) {
					context.isLoading = false;
					if (result.success) context.$router.push({ path: '/katalog-tiket' });else alert('Gagal Upload Picture');
				});
			} else {
				context.$router.push({ path: '/katalog-tiket' });
			}
		}
	}
});

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'metode-pembayaran',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			metodePembayaranList: [],
			isLoading: false,
			selectedRow: null,
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			headers: ['Nama', 'Tipe', 'Atas Nama', 'Nomor Rekening', 'Status'],
			headersKey: ['bankName', 'type', 'accountName', 'accountNumber', 'status'] // camel case for matching search with API
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			};

			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].getMetodePembayaranList(pagination, search, function (result) {
				context.metodePembayaranList = [];
				context.isLoading = false;

				if (result.success) {
					result.data.forEach(function (content) {
						var row = {
							id: content.id,
							data: [content.bank_name, content.type, content.account_name, content.account_number, content.status]
						};
						context.pagination.totalPages = content.page;
						context.metodePembayaranList.push(row);
					});
				} else {
					alert('Terjadi Kesalahan : ' + result.message);
				}
			});
		},
		createMetodePembayaran: function createMetodePembayaran() {
			this.$router.push({ path: '/metode-pembayaran/form' });
		},
		updateMetodePembayaran: function updateMetodePembayaran() {
			var metodePembayaranId = this.selectedRow.id;
			this.$router.push({ path: '/metode-pembayaran/form', query: { id: metodePembayaranId } });
		},
		updateAllMetodePembayaranStatus: function updateAllMetodePembayaranStatus(status) {
			var context = this;
			var confirmed = window.confirm("Apakah anda yakin akan mengupdate semua status metode pembayaran?");

			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].updateAllMetodePembayaranStatus(status, function (result) {
					context.isLoading = false;
					if (result.success) {
						alert('Data Terupdate');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		},
		deleteMetodePembayaran: function deleteMetodePembayaran(metodePembayaran) {
			var context = this;
			var metodePembayaranId = metodePembayaran.id;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");

			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].deleteMetodePembayaran(metodePembayaranId, function (result) {
					context.isLoading = false;
					if (result.success) {
						alert('Data Terhapus');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		}
	}
});

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_ImageCropper__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_ImageCropper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_ImageCropper__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'metode-pembayaran-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
    'app-imagecropper': __WEBPACK_IMPORTED_MODULE_3__components_plugins_ImageCropper___default.a
  },
  data: function data() {
    return {
      errors: [],
      queryId: null,
      isLoading: false,
      isBankPayment: true,
      status: {
        PUBLISH: 'PUBLISHED',
        UNPUBLISH: 'UNPUBLISHED'
      },
      selectedBankLogo: null,
      data: {
        "bank_name": "",
        "account_number": "",
        "account_name": "",
        "platform": "",
        "description": "",
        "terms": "",
        "notes": "",
        "expiration_time": null,
        "is_phonenumber_required": false,
        "fee_percentage": null,
        "order_number": null,
        "status": "",
        "type": "",
        "bank_logo": ""
      },
      editor: __WEBPACK_IMPORTED_MODULE_0__ckeditor_ckeditor5_build_classic___default.a,
      editorConfig: {
        toolbar: ['heading', '|', 'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|', 'outdent', 'indent']
      }
    };
  },
  mounted: function mounted() {
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id;
      this.fetchData();
    }
  },
  watch: {
    // isBankPayment: function (val) {
    //   if (val === false) {
    //     this.data.account_name = ''
    //     this.data.account_number = ''
    //   }
    // },
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var queryId = this.queryId;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].getMetodePembayaranDetail(queryId, function (result) {
        context.isLoading = false;
        if (result.success) {
          context.data.bank_name = result.data.bank_name;
          context.data.account_name = result.data.account_name;
          context.data.account_number = result.data.account_number;
          context.data.description = result.data.description;
          context.data.bank_logo = result.data.bank_logo;
          context.data.status = result.data.status;
          context.data.type = result.data.type;
          context.data.fee_percentage = result.data.fee_percentage;
          context.data.notes = result.data.notes;
          context.data.terms = result.data.terms;
          context.data.expiration_time = result.data.expiration_time;
          context.data.platform = result.data.platform;
          context.data.order_number = result.data.order_number;
          context.data.is_phonenumber_required = result.data.is_phonenumber_required;

          // context.isBankPayment = result.data.type == 'NFJUARA' ? true : false
        } else {
          alert('Terjadi Kesalahan : ' + result.message);
        }
      });
    },
    saveData: function saveData() {
      var data = this.data;
      var context = this;
      this.isLoading = true;
      this.data.fee_percentage = parseFloat(this.data.fee_percentage);
      if (this.validateForm()) {
        __WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].addMetodePembayaranV2(data, function (result) {
          if (result.success) context.doUploadBankLogo(result.data.id);else {
            alert('Terjadi Kesalahan : ' + result.message);
            context.isLoading = false;
          }
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    editData: function editData() {
      var data = this.data;
      var id = this.queryId;
      var context = this;
      this.isLoading = true;

      if (this.validateForm()) {
        __WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].updateMetodePembayaranV2(id, data, function (result) {
          context.isLoading = false;
          if (result.success) context.doUploadBankLogo(id);else alert('Terjadi Kesalahan : ' + result.message);
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    handleChangeBankLogo: function handleChangeBankLogo(event) {
      this.selectedBankLogo = event.blob;
      this.data.bank_logo = event.url;
    },
    doUploadBankLogo: function doUploadBankLogo(id) {
      var context = this;
      var bankLogo = this.selectedBankLogo;
      var formData = new FormData();

      if (bankLogo) {
        formData.append('name', bankLogo.name);
        formData.append('file', bankLogo);

        __WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].uploadMetodePembayaranBankLogo(id, formData, function (result) {
          if (result.success) context.$router.push({ path: '/metode-pembayaran' });else {
            alert('Gagal Upload Bank Logo : ' + result.message);
            context.isLoading = false;
          }
        });
      } else {
        context.$router.push({ path: '/metode-pembayaran' });
      }
    },
    validateForm: function validateForm() {
      // // if(this.isBankPayment) this.data.type = 'NFJUARA'
      // else if (!this.isBankPayment && this.data.type == 'NFJUARA') this.data.type = null

      this.errors = [];
      if (!this.data.bank_name) this.errors.push('Nama Bank / Pembayaran wajib diisi');
      // if (!this.data.description) this.errors.push('Deskripsi wajib diisi')

      if (this.data.description) {
        if (this.characterCounter(this.data.description) > 1000) {
          this.errors.push('Deskripsi tidak boleh lebih dari 1000 karakter');
        }
      }
      if (!this.data.bank_logo) this.errors.push('Gambar wajib diisi');
      if (!this.data.platform) this.errors.push('Platform wajib diisi');
      if (!this.data.status) this.errors.push('Status wajib diisi');
      if (!this.data.order_number) this.errors.push('Nomor Urutan wajib diisi');
      if (!this.data.account_number) this.errors.push('Gambar wajib diisi');
      if (!this.data.account_name) this.errors.push('Gambar wajib diisi');
      if (this.selectedBankLogo) {
        if (this.selectedBankLogo.size > 1000000) this.errors.push('Gambar tidak boleh lebih dari 1MB');
      }
      return this.errors.length == 0;
    },

    characterCounter: function characterCounter(text) {
      text = text.replace(/<[^>]*>/g, '');
      text = text.replace(/\&nbsp;/g, ' ');
      return text.length;
    }
  }
});

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pembayaran-nav'
});

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "list-pembayaran",
  components: {
    "app-datatable": __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    "app-spinner": __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      pembayaranList: [],
      isLoading: false,
      selectedRow: null,
      headers: ["Order Id", "Username", "NoTelp", "Email", "Tipe", "Dari Rekening", "Ke Rekening", "Tanggal Transfer"],
      headersKey: ["code", "userName", "phoneNumber", "userEmail", "type", "bankName", "paymentBankName", "transferDatetime", "status"], // camel case for matching search with API
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: "desc"
      }
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  watch: {
    pagination: function pagination() {
      this.fetchData();
    },
    search: function search() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode
      };

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].getPembayaranList(pagination, search, function (result) {
        context.pembayaranList = [];
        context.isLoading = false;

        if (result.success) {
          if (result.data.length > 0) {
            result.data.forEach(function (content) {
              var row = {
                id: content.id,
                data: [content.code || "-", content.user_name || "-", content.phone_number || "-", content.user_email || "-", content.type || "-", content.bank_name || "-", content.payment_bank_name || "-", _this.convert(content.transfer_datetime) || "-"],
                status: [content.status || "-"]
              };

              context.pagination.totalPages = content.page;
              context.pembayaranList.push(row);
            });
          }
        } else {
          alert("Terjadi Kesalahan : " + result.message);
        }
      });
    },
    detailPembayaran: function detailPembayaran() {
      var queryId = this.selectedRow.id;
      this.$router.push({ path: "/pembayaran/detail", query: { id: queryId } });
    },
    convert: function convert(val) {
      __WEBPACK_IMPORTED_MODULE_3_moment___default.a.locale("id");
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(val).format("dddd, DD/MM/YYY HH:mm:ss");
    },

    doManualInputTransaction: function doManualInputTransaction() {
      this.$router.push({ path: '/pembayaran/form' });
    }
  }
});

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'pembayaran-detail',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      queryId: null,
      errors: [],
      isLoading: false,
      status: {
        CHECKOUT: 'CHECKOUT',
        CONFIRMED: 'CONFIRMED',
        EXPIRED: 'EXPIRED',
        REJECTED: 'REJECTED',
        ACTIVATED: 'ACTIVATED',
        REFUND: 'REFUND'
      },
      statusAction: {
        REJECTED: 'Reject',
        ACTIVATED: 'Activate',
        REFUND: 'Refund'
      },
      data: {
        code: null,
        user_name: null,
        title: null,
        type: null,
        phone_number: null,
        user_email: null,
        bank_name: null,
        payment_bank_name: null,
        transfer_datetime: null,
        receipt_img: null,
        status: null,
        unique_price: null
      }
    };
  },
  mounted: function mounted() {
    this.queryId = this.$route.query.id;
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var id = this.queryId;
      var context = this;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].getPembayaranDetail(id, function (result) {
        context.isLoading = false;

        if (result.success) {
          context.data.code = result.data.code;
          context.data.user_name = result.data.user_name;
          context.data.user_email = result.data.user_email;
          context.data.title = result.data.title;
          context.data.type = result.data.type;
          context.data.phone_number = result.data.phone_number;
          context.data.bank_name = result.data.bank_name;
          context.data.payment_bank_name = result.data.payment_bank_name;
          context.data.transfer_datetime = __WEBPACK_IMPORTED_MODULE_2_moment___default()(result.data.transfer_datetime).format("dddd, DD-MM-YYYY hh:mm:ss");
          context.data.receipt_img = result.data.receipt_img;
          context.data.status = result.data.status;
          context.data.unique_price = context.convertToRupiah(result.data.unique_price);
        } else {
          alert('Terjadi kesalahan : ' + result.message);
        }
      });
    },
    convertToRupiah: function convertToRupiah(value) {
      var rupiah = '';
      var angkarev = value.toString().split('').reverse().join('');
      for (var i = 0; i < angkarev.length; i++) {
        if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + '.';
      }return 'Rp ' + rupiah.split('', rupiah.length - 1).reverse().join('');
    },
    updatePembayaranStatus: function updatePembayaranStatus(status) {
      var context = this;
      var id = this.queryId;
      var confirmed = window.confirm("Apakah anda yakin akan mengubah status ini menjadi " + status + " ?");

      if (confirmed) {
        this.isLoading = true;

        __WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].updatePembayaranStatus(id, status, function (result) {
          if (result.success) context.$router.push('/pembayaran');else {
            context.isLoading = false;
            alert('Terjadi kesalahan : ' + result.message);
          }
        });
      }
    }
  }
});

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'produk',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
	},
	data: function data() {
		return {
			isLoading: false,
			produkList: [],
			status: {
				PUBLISH: 'PUBLISHED',
				UNPUBLISH: 'UNPUBLISHED'
			},
			selectedRow: null,
			search: null,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			headers: ['Nama', 'Tipe', 'Durasi', 'Tiket', 'Harga', 'Status'],
			headersKey: ['title', 'type', 'value', 'value', 'netPrice', 'status']
		};
	},
	mounted: function mounted() {
		this.fetchData();
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			};

			this.isLoading = true;

			__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].getProdukList(pagination, search, function (result) {
				context.produkList = [];
				context.isLoading = false;

				if (result.success) {
					result.data.forEach(function (content) {
						var row = {
							id: content.id,
							data: [content.title, content.type, content.type === 'SUBSCRIPTION' ? content.value + ' bulan' : '-', content.type === 'TICKET' ? content.value : '-', context.convertToRupiah(content.net_price), content.status]
						};

						context.pagination.totalPages = content.page;
						context.produkList.push(row);
					});
				} else {
					alert('Terjadi kesalahan : ' + result.message);
				}
			});
		},
		createProduk: function createProduk() {
			this.$router.push({ path: '/produk/form' });
		},
		updateProduk: function updateProduk() {
			var produkId = this.selectedRow.id;
			this.$router.push({ path: '/produk/form', query: { id: produkId } });
		},
		updateAllProdukStatus: function updateAllProdukStatus(status) {
			var context = this;
			var confirmed = window.confirm("Apakah anda yakin akan mengupdate semua status produk?");

			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].updateAllProdukStatus(status, function (result) {
					context.isLoading = false;

					if (result.success) {
						alert('Data Terupdate');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		},
		deleteProduk: function deleteProduk(produk) {
			var context = this;
			var produkId = produk.id;
			var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
			if (confirmed) {
				this.isLoading = true;
				__WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].deleteProduk(produkId, function (result) {
					context.isLoading = false;

					if (result.success) {
						alert('Data Terhapus');
						context.fetchData();
					} else {
						alert('Terjadi Kesalahan : ' + result.message);
					}
				});
			}
		},
		convertToRupiah: function convertToRupiah(value) {
			var rupiah = '';
			var angkarev = value.toString().split('').reverse().join('');
			for (var i = 0; i < angkarev.length; i++) {
				if (i % 3 == 0) rupiah += angkarev.substr(i, 3) + '.';
			}return 'Rp ' + rupiah.split('', rupiah.length - 1).reverse().join('');
		}
	}
});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_bimbel_js__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "produk-form",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      errors: [],
      isLoading: false,
      status: {
        PUBLISH: "PUBLISHED",
        UNPUBLISH: "UNPUBLISHED"
      },
      type: {
        SUBSCRIPTION: "SUBSCRIPTION",
        TICKET: "TICKET",
        KUOTA: "CONSULTATION_CREDIT"
      },
      queryId: null,
      selectedPicture: null,
      data: {
        type: "",
        title: null,
        picture: null,
        value: 1,
        bonus_value: 0,
        description: null,
        currency: "RUPIAH",
        price: 0,
        net_price: 0,
        status: "",
        platform: "",
        grade: 0,
        features: ""
      },
      jenjangList: [],
      jenjang: "",
      grade: 0,
      //boolean modelnya checkbox bimbel
      featBimbel: false,
      // variable yang menyimpan list bimbel yang di get dri api
      bimbelList: [],
      // daftar bimbel yg dipilih masuk ke variable ini
      bimbels: [],
      // bimbel di pisah karena punya behavior yang berbeda
      featureList: ["SCHEDULED_TRYOUT", "INSTANT_TRYOUT",
      // 'DUEL',
      // 'CONSULTATION',
      "ITEM_BANK", "VIDEO"],
      features: [],
      editor: __WEBPACK_IMPORTED_MODULE_1__ckeditor_ckeditor5_build_classic___default.a,
      editorConfig: {
        toolbar: ["heading", "|", "bold", "italic", "link", "bulletedList", "numberedList", "blockQuote", "|", "outdent", "indent"]
      }
    };
  },
  watch: {
    jenjang: function jenjang(to, from) {
      if (to === "SD") this.jenjangList = [4, 5, 6];
      if (to === "SMP") this.jenjangList = [7, 8, 9];
      if (to === "SMA") this.jenjangList = [10, 11, 12];
    },
    featBimbel: function featBimbel(to, from) {
      if (to) {
        this.getBimbel();
      } else {
        this.bimbelList = [];
        this.bimbels = [];
      }
    },
    grade: function grade(to, from) {
      // console.log(to)
      this.data.features = [];
      this.featBimbel = false;
    }
  },
  mounted: function mounted() {
    if (this.$route.query.id) {
      this.queryId = this.$route.query.id;
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var queryId = this.queryId;
      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].getProdukDetail(queryId, function (result) {
        context.isLoading = false;

        if (result.success) {
          context.data.type = result.data.type;
          context.data.title = result.data.title;
          context.data.picture = result.data.picture;
          context.data.value = result.data.value;
          context.data.bonus_value = result.data.bonus_value;
          context.data.description = result.data.description;
          context.data.currency = result.data.currency;
          context.data.price = result.data.price;
          context.data.net_price = result.data.net_price;
          context.data.status = result.data.status;
          context.data.platform = result.data.platform;
          context.data.grade = result.data.grade;
          context.grade = result.data.grade;
          // context.features = result.data.features
          context.data.features = result.data.features;
          if (result.data.features !== null) {
            var res = result.data.features;
            var sp = res.split(",");
            var format = /[;]/;
            sp.forEach(function (element) {
              if (format.test(element)) {
                element = element.slice(0, -1);
                var getbbid = element.split(";");
                for (var i = 1; i < getbbid.length; i++) {
                  context.bimbels.push(parseInt(getbbid[i]));
                }
              } else {
                context.features.push(element);
              }
            });

            //force re-render
            if (context.bimbels.length > 0) {
              context.$nextTick(function () {
                context.featBimbel = true;
              });
            }
          }
          if (context.data.grade < 7) context.jenjang = "SD";
          if (context.data.grade > 6 && context.data.grade < 10) context.jenjang = "SMP";
          if (context.data.grade > 9) context.jenjang = "SMA";
        } else {
          alert("Terjadi Kesalahan : " + result.message);
        }
      });
    },
    getBimbel: function getBimbel() {
      var context = this;
      if (this.data.grade === 0) this.data.grade = 12;
      __WEBPACK_IMPORTED_MODULE_3__services_bimbel_js__["a" /* default */].statPublishedBimbel(this.grade, function (result) {
        context.bimbelList = result.data;
      });
    },
    saveData: function saveData() {
      var _this = this;

      var context = this;
      var data = this.data;
      this.isLoading = true;
      if (this.validateForm()) {
        this.data.grade = this.grade;
        if (this.featBimbel && this.bimbels.length > 0) {
          var bbl = ";";
          this.bimbels.forEach(function (element) {
            bbl += element + ";";
          });
          this.features.push("BIMBEL" + bbl);
        }
        if (this.features.length > 0) {
          this.features.forEach(function (element) {
            _this.data.features += element + ",";
          });
        }
        this.data.features = this.data.features.slice(0, -1);
        if (this.data.features.length === 0) this.data.features = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data.features);
        __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].addProduk(data, function (result) {
          if (result.success) context.doUploadPicture(result.data.id);else {
            alert("Terjadi Kesalahan : " + result.message);
            context.isLoading = false;
          }
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    editData: function editData() {
      var _this2 = this;

      var context = this;
      var id = this.queryId;
      var data = this.data;
      this.isLoading = true;

      if (this.validateForm()) {
        this.data.grade = this.grade;
        this.data.features = "";
        if (this.featBimbel && this.bimbels.length > 0) {
          var bbl = ";";
          this.bimbels.forEach(function (element) {
            bbl += element + ";";
          });
          this.features.push("BIMBEL" + bbl);
        }
        if (this.features.length > 0) {
          this.features.forEach(function (element) {
            _this2.data.features += element + ",";
          });
        }
        this.data.features = this.data.features.slice(0, -1);
        if (this.data.features.length === 0) this.data.features = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.data.features);
        __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].updateProduk(id, data, function (result) {
          if (result.success) context.doUploadPicture(id);else {
            context.isLoading = false;
            alert("Terjadi Kesalahan : " + result.message);
            context.data.features = "";
            context.features = [];
            context.fetchData();
          }
        });
      } else {
        this.isLoading = false;
        $(window).scrollTop(0);
      }
    },
    handleChangePicture: function handleChangePicture(event) {
      var file = event.target.files[0];
      this.selectedPicture = file;
      this.data.picture = URL.createObjectURL(file);
    },
    doUploadPicture: function doUploadPicture(id) {
      var context = this;
      var picture = this.selectedPicture;
      var formData = new FormData();

      if (picture) {
        formData.append("name", picture.name);
        formData.append("file", picture);

        __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].uploadProdukPicture(id, formData, function (result) {
          if (result.success) context.$router.push({ path: "/produk" });else {
            alert("Gagal Upload Picture : " + result.message);
            context.isLoading = false;
            context.data.features = "";
            context.features = [];
            context.fetchData();
          }
        });
      } else {
        context.$router.push({ path: "/produk" });
      }
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (!this.data.type) {
        this.errors.push("Tipe produk wajib diisi");
      } else {
        if (!this.data.title) this.errors.push("Judul wajib diisi");
        if (!this.data.value) {
          this.data.type === this.type.TICKET ? this.errors.push("Jumlah tiket wajib diisi") : this.errors.push("Durasi wajib diisi");
        }
        if (this.data.value < 1) {
          this.data.type === this.type.TICKET ? this.errors.push("Jumlah tiket tidak memenuhi batas minimum") : this.errors.push("Durasi tidak memenuhi batas minimum");
        }
        if (this.data.value > 9999) {
          this.data.type === this.type.TICKET ? this.errors.push("Jumlah tiket melebihi batas maksimum") : this.errors.push("Durasi melebihi batas maksimum");
        }
        if (!this.data.picture) this.errors.push("Gambar wajib diisi");
        if (!this.data.description) this.errors.push("Deskripsi wajib diisi");
        if (this.data.description) {
          if (this.characterCounter(this.data.description) > 1000) {
            this.errors.push("Deskripsi tidak boleh lebih dari 1000 karakter");
          }
        }
        if (!this.data.net_price) this.errors.push("Harga wajib diisi");
        if (this.data.net_price < 1) this.errors.push("Harga tidak memenuhi batas minimum");
        if (this.data.price < 1 && this.data.type === this.type.SUBSCRIPTION) this.errors.push("Harga Coret tidak memenuhi batas minimum");
        if (this.data.price) {
          if (this.data.price <= this.data.net_price) this.errors.push("Harga coret tidak kurang dari atau sama dengan harga normal");
        }
        if (!this.data.status) this.errors.push("Status wajib diisi");
        if (this.selectedPicture) {
          if (this.selectedPicture.size > 1000000) this.errors.push("Gambar tidak boleh lebih dari 1MB");
        }
        if (this.data.type === this.type.SUBSCRIPTION && this.features.length === 0 && this.featBimbel === false) this.errors.push("Fitur wajib diisi");
        if (this.data.type === this.type.SUBSCRIPTION && this.featBimbel === true && this.bimbels.length === 0) this.errors.push("Daftar Bimbel wajib diisi apabila memilih fitur bimbel");
      }
      return this.errors.length == 0;
    },

    characterCounter: function characterCounter(text) {
      text = text.replace(/<[^>]*>/g, "");
      text = text.replace(/\&nbsp;/g, " ");
      return text.length;
    }
  }
});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ticket-usage',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      ticketUsageList: [],
      selectedRow: null,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc'
      },
      headers: ['Title', 'Type', 'Username', 'Email', 'Ticket', 'Used Ticket', 'Created At'],
      headersKey: ['title', 'type', 'userName', 'userEmail', 'ticket', 'value', 'createdAt']
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  watch: {
    pagination: function pagination() {
      this.fetchData();
    },
    search: function search() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode
      };

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].getTicketUsageList(pagination, search, function (result) {
        context.ticketUsageList = [];
        context.isLoading = false;

        if (result.success) {
          if (result.data.length > 0) {
            result.data.forEach(function (content) {
              var row = {
                id: content.id,
                data: [content.title || '-', content.type || '-', content.user_name || '-', content.user_email || '-', content.ticket || '-', content.value || '-', __WEBPACK_IMPORTED_MODULE_3_moment___default()(content.created_at).format('YYYY-MM-DD') || '-'],
                status: [content.status || '-']
              };

              context.pagination.totalPages = content.page;
              context.ticketUsageList.push(row);
            });
          }
        } else {
          alert('Terjadi Kesalahan : ' + result.message);
        }
      });
    },
    detailTicketUsage: function detailTicketUsage() {
      var queryId = this.selectedRow.id;
      this.$router.push({ path: '/ticket-usage/detail', query: { id: queryId } });
    }
  }
});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ticket-usage-detail',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      queryId: null,
      errors: [],
      isLoading: false,
      data: {
        user_id: null,
        title: null,
        type: null,
        user_name: null,
        user_email: null,
        ticket: null,
        value: null,
        description: null,
        picture: null
      }
    };
  },
  mounted: function mounted() {
    this.queryId = this.$route.query.id;
    this.fetchData();
  },
  methods: {
    fetchData: function fetchData() {
      var id = this.queryId;
      var context = this;

      this.isLoading = true;

      __WEBPACK_IMPORTED_MODULE_0__services_sales_js__["a" /* default */].getTicketUsageDetail(id, function (result) {
        context.isLoading = false;

        if (result.success) {
          context.data.user_id = result.data.user_id;
          context.data.title = result.data.title;
          context.data.type = result.data.type;
          context.data.user_name = result.data.user_name;
          context.data.user_email = result.data.user_email;
          context.data.ticket = result.data.ticket;
          context.data.value = result.data.value;
          context.data.description = result.data.description;
          context.data.picture = result.data.picture;
        } else {
          alert('Terjadi Kesalahan : ' + result.message);
        }
      });
    }
  }
});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'autocomplete',
  props: ['placeholder', 'data', 'value', 'resetable', 'depth', 'sourcetype'],
  data: function data() {
    return {
      suggestions: [],
      index: [],
      query: ''
    };
  },
  watch: {
    'value': function value(val) {
      this.query = val;
    }
  },
  methods: {
    choose: function choose(selected) {
      if (this.sourcetype === 'INTERNAL') {
        this.query = selected.name;
        this.suggestions = [];

        var result = {
          test: '',
          data: [0, 0, 0]
        };

        var index = 0;
        selected.parents.forEach(function (topic) {
          result.data[index] = topic.name;
          index++;
        });

        result.data[index] = selected.name;
        result.text = selected.name;
        this.$emit('selected', result);
        if (this.resetable) this.query = '';
      } else {
        this.query = selected.nama;
        this.suggestions = [];

        var result = {
          test: '',
          data: [0, 0, 0]
        };

        var index = 0;
        selected.parents.forEach(function (topic) {
          result.data[index] = topic.id;
          index++;
        });

        result.data[index] = selected.id;
        result.text = selected.nama;
        this.$emit('selected', result);
        if (this.resetable) this.query = '';
      }
    },
    search: function search() {
      this.suggestions = [];
      if (this.query.length > 0) {
        var context = this;
        this.data.forEach(function (node) {
          context.traverse(context.query, node, [], 1);
        });
      }
    },
    traverse: function traverse(query, node, parents, level) {
      if (this.sourcetype === 'INTERNAL') {
        if (query.length > 3 && node.name.toLowerCase().indexOf(this.query.toLowerCase()) >= 0) {
          var nodepath = '';
          parents.forEach(function (parent) {
            nodepath += parent.name + ' >> ';
          });

          this.suggestions.push({ id: node.name, name: nodepath + node.name, parents: parents });
        }

        if (parseInt(this.depth) && level === parseInt(this.depth)) {
          return;
        }

        if (node.subs.length === 0) {
          return;
        }

        for (var i = 0; i < node.subs.length; i++) {
          this.traverse(query, node.subs[i], parents.concat(node), level + 1);
        }
      } else {
        if (query.length > 3 && node.nama.toLowerCase().indexOf(this.query.toLowerCase()) >= 0) {
          var nodepath = '';
          parents.forEach(function (parent) {
            nodepath += parent.nama + ' >> ';
          });

          this.suggestions.push({ id: node.id, nama: nodepath + node.nama, parents: parents });
        }

        if (parseInt(this.depth) && level === parseInt(this.depth)) {
          return;
        }

        if (node.subs.length === 0) {
          return;
        }

        for (var i = 0; i < node.subs.length; i++) {
          this.traverse(query, node.subs[i], parents.concat(node), level + 1);
        }
      }
    },
    refresh: function refresh() {
      this.query = '';
    },
    refill: function refill(val) {
      this.query = val;
    }
  }
});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "datatable",
  props: {
    items: { type: Array, default: [] },
    headers: { type: Array, default: [] },
    hasAction: { type: Boolean, default: true },
    hasExport: { type: Boolean, default: false },
    hasGenerate: { type: Boolean, default: false },
    hasPreview: { type: Boolean, default: false },
    hasPublish: { type: Boolean, default: false },
    hasCheckbox: { type: Boolean, default: false },
    hasPaymentStatus: { type: Boolean, default: false },
    hasDelete: { type: Boolean, default: true },
    hasAddQuota: { type: Boolean, default: false },
    hasGrading: { type: Boolean, default: false },
    hasRanking: { type: Boolean, default: false },
    hasCustomPagination: { type: Boolean, default: false },
    hasCustomSearch: { type: Boolean, default: false },
    hasEdit: { type: Boolean, default: false },
    hasSoldoutWarning: { type: Boolean, default: false },
    hasEditA: { type: Boolean, default: false },
    hasFilterStatus: { type: Boolean, default: false },
    hasSearchPower: { type: Boolean, default: true },
    persistFilter: { type: Boolean, default: true },
    currentPageProp: { type: Number, default: 1 },
    customPaginationCurrentPage: { type: Number, default: 1 },
    customPaginationPerPage: { type: Number, default: 0 },
    customPaginationTotalItems: { type: Number, default: 0 },
    customPaginationTotalPages: { type: Number, default: 0 },
    customPaginationSortMode: { type: String, default: "desc" }
  },
  data: function data() {
    return {
      currentPageItems: [],
      selectedRow: -1,
      filteredItems: [],
      query: null,
      field: null,
      videoId: null,
      disableStatus: null,
      selectedCheckbox: [],
      selectAll: false
    };
  },
  computed: {
    player: function player() {
      return this.$refs.youtube.player;
    },

    currentPage: {
      get: function get() {
        if (this.hasCustomPagination) {
          return this.customPaginationCurrentPage;
        }

        return parseInt(this.$store.state.datatable.currentPage);
      },
      set: function set(val) {
        if (this.hasCustomPagination) {
          this.goToPage(val);
        } else {
          this.$store.commit('datatable_currentPage', val);
        }
      }
    },
    pageStart: function pageStart() {
      return this.$store.state.datatable.pageStart;
    },
    pageSize: function pageSize() {
      return this.customPaginationPerPage || this.$store.state.datatable.pageSize;
    },
    pageEnd: function pageEnd() {
      return this.$store.state.datatable.pageEnd;
    },
    orderBy: function orderBy() {
      if (this.hasCustomPagination) return this.customPaginationSortMode;
      return this.$store.state.datatable.orderBy;
    },
    maxPage: function maxPage() {
      return this.hasCustomPagination ? this.customPaginationTotalPages ? this.customPaginationTotalPages : Math.ceil(this.customPaginationTotalItems / this.pageSize) : Math.ceil(this.filteredItems.length / this.pageSize);
    },
    startNumber: function startNumber() {
      if (this.$route.name === 'ItemBank' || this.$route.name === 'FreeItemBank') {
        return (this.currentPageProp - 1) * this.pageSize;
      } else {
        return (this.currentPage - 1) * this.pageSize;
      }
    },

    filterCriteria: function filterCriteria() {
      var result = [];
      var filters = [];
      if (this.persistFilter) filters = this.$store.state.datatable.filter;

      for (var i = 0; i < filters.length; i++) {
        var filter = filters[i];
        var criteria = this.headers[filter.key] + " = " + filter.value;
        result.push(criteria);
      }

      return result;
    }
  },
  methods: {
    filterByStatus: function filterByStatus(val) {
      this.disableStatus = val;
      this.$emit("filterByStatus", val);
    },
    updateOrderBy: function updateOrderBy(e) {
      if (this.hasCustomPagination) this.$emit('changeSortMode', e.target.value);else this.$store.commit('datatable_orderby', e.target.value);
    },
    goToPage: function goToPage(page) {
      if (page > 0 && page <= this.maxPage) {
        if (this.hasCustomPagination) this.$emit('changePage', page);else this.$store.commit('datatable_currentPage', page);
      } else if (page > this.maxPage) {
        alert('Data hanya sampai ' + this.maxPage + ' Halaman');
      }
    },
    publishing: function publishing(item) {
      this.$emit("publishing", item);
    },
    unpublishing: function unpublishing(item) {
      this.$emit("unpublishing", item);
    },

    getItemsInPage: function getItemsInPage(page) {
      page = this.hasCustomPagination ? 1 : page;
      var start = (page - 1) * this.pageSize;
      var end = start + this.pageSize;

      if (end > this.filteredItems.length - 1) {
        return this.filteredItems.slice(start);
      }

      return this.filteredItems.slice(start, end);
    },
    deleteItem: function deleteItem(index) {
      var realIndex = index + (this.currentPage - 1) * this.pageSize;
      var selectedRow = this.hasCustomPagination ? this.selectRow(index) : this.filteredItems[realIndex];
      this.$emit("deleted", selectedRow);
    },
    previewVideo: function previewVideo(index) {
      if (index.url.indexOf('embed') > -1) {
        this.videoId = index.url.split('/')[4];
      } else {
        this.videoId = index.url.substring(index.url.indexOf('=') + 1);
      }
    },
    selectRow: function selectRow(index) {
      var realIndex = this.hasCustomPagination ? index : index + (this.currentPage - 1) * this.pageSize;
      var selectedRow = this.filteredItems[realIndex];
      this.$emit("selected", selectedRow);

      return selectedRow;
    },
    selectRowAndFinish: function selectRowAndFinish(index) {
      var selectedRow = this.selectRow(index);
      this.$emit("dblClicked", selectedRow);
    },
    editItem: function editItem(index) {
      var realIndex = index;
      if (!this.hasCustomPagination) realIndex = index + (this.currentPage - 1) * this.pageSize;

      var selectedRow = this.filteredItems[realIndex];
      this.$emit("editNewTab", selectedRow);
    },
    editItemContent: function editItemContent(index) {
      var selectedRow = this.selectRow(index);
      this.$emit("editNewTab", selectedRow);
    },

    doFilter: function doFilter() {
      if (this.field != null) {
        this.query = this.query !== null ? this.query.trim() : "";
        var criteria = { key: this.field, value: this.query };

        if (this.hasCustomSearch) {
          this.goToPage(1);
          this.$emit("doSearch", criteria);
        } else {
          this.$store.commit('datatable_push_filter', criteria);
          var filters = this.$store.state.datatable.filter;

          for (var i = 0; i < filters.length; i++) {
            var filter = filters[i];
            this.doBasicFilter(filter);
          }

          this.query = null;
          this.field = null;
        }
      }
    },
    doBasicFilter: function doBasicFilter(filter) {
      var context = this;
      var result = this.filteredItems.filter(function (item) {
        if (!item.data[filter.key]) return false;

        var index = item.data[filter.key].toLowerCase().indexOf(filter.value.toLowerCase());
        return index > -1;
      });

      this.filteredItems = result;
    },
    clearFilter: function clearFilter() {
      this.query = null;
      this.field = null;
      this.filteredItems = this.items;
      this.$store.commit('datatable_pageStart', 1);
      this.$store.commit('datatable_pageEnd', 10);
      this.$store.commit('datatable_clear_filter');
      if (this.hasCustomSearch) {
        this.goToPage(1);
        this.$emit('doSearch', { value: null, key: null });
      }
    },
    doOrder: function doOrder() {
      var tmp = this.filteredItems.slice(0);
      if (this.$store.state.datatable.orderBy == 'asc') {
        tmp.sort(function (a, b) {
          return a.id - b.id;
        });
      } else {
        tmp.sort(function (a, b) {
          return b.id - a.id;
        });
      }

      this.filteredItems = tmp;
    },
    playVideo: function playVideo() {
      this.player.playVideo();
    },
    playing: function playing() {
      console.log('\o/ we are watching!!!');
    },
    checkboxSelectAll: function checkboxSelectAll() {
      this.selectedCheckbox = this.$store.state.tryout.selectedTO;
      if (!this.selectAll) {
        this.unselectAtPage();
        for (var i in this.items) {
          this.selectedCheckbox.push(this.currentPageItems[i].id);
        }
      } else {
        this.unselectAtPage();
      }
    },
    unselectAtPage: function unselectAtPage() {
      var _this = this;

      for (var i = 0; i < this.items.length; i++) {
        var finding = this.selectedCheckbox.find(function (element) {
          return parseInt(element) == parseInt(_this.items[i].id);
        });
        if (finding) {
          var index = this.selectedCheckbox.indexOf(finding);
          if (index !== -1) {
            this.selectedCheckbox.splice(index, 1);
          }
        }
      }
    },

    checkIsAll: function checkIsAll() {
      var _this2 = this;

      for (var i = 0; i < this.items.length; i++) {
        var finding = this.selectedCheckbox.find(function (element) {
          return parseInt(element) == parseInt(_this2.items[i].id);
        });
        if (!finding) {
          return false;
        }
      }
      return true;
    }
  },
  watch: {
    currentPage: function currentPage(page) {
      this.currentPageItems = this.getItemsInPage(page);
      this.selectedCheckbox = this.$store.state.tryout.selectedTO;
    },
    selectedCheckbox: function selectedCheckbox(to, from) {
      this.$store.commit('tryoutSelected', to);
    },
    items: function items(val) {
      this.filteredItems = val;
      var fullPath = this.$route.fullPath;
      var datatableContext = this.$store.state.datatable.context;
      if (fullPath == datatableContext) {
        var filters = this.$store.state.datatable.filter;
        for (var i = 0; i < filters.length; i++) {
          var filter = filters[i];
          this.doBasicFilter(filter);
        }
      } else {
        this.$store.commit('datatable_context', fullPath);
        this.clearFilter();
      }

      this.selectAll = this.checkIsAll();
      // console.log(this.checkIsAll())
    },
    filteredItems: function filteredItems(val) {
      this.$store.commit('datatable_currentPage', 1);
      this.currentPageItems = this.getItemsInPage(this.currentPage);
    },
    orderBy: function orderBy(val) {
      this.$store.commit('datatable_orderby', val);
      this.doOrder();
    }
  },
  mounted: function mounted() {
    this.filteredItems = this.items;
    this.currentPageItems = this.getItemsInPage(1);
  }
});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_aws_sdk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_aws_sdk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uniqid__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uniqid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uniqid__);
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'fileupload',
  methods: {
    upload: function upload(e) {
      var file = e.target.files[0];

      if (!file) return;
      if (file.type.indexOf('image') == -1) return;

      __WEBPACK_IMPORTED_MODULE_0_aws_sdk___default.a.config.accessKeyId = "LTAI4GADj6URzXKuwTePhKSG";
      __WEBPACK_IMPORTED_MODULE_0_aws_sdk___default.a.config.secretAccessKey = "7jtZqmIolrrGrj3MR1BTP9XKqC3CO2";
      var spaceEndpoint = "oss-ap-southeast-5.aliyuncs.com";
      var bucket = new __WEBPACK_IMPORTED_MODULE_0_aws_sdk___default.a.S3({
        endpoint: spaceEndpoint
      });

      var fileExt = file.name.substr(-4);
      var filename = __WEBPACK_IMPORTED_MODULE_1_uniqid___default()() + fileExt;
      var params = {
        Bucket: "nfjuara",
        Key: this.type + '/' + this.context + '/' + filename,
        Body: file,
        ContentType: file.type,
        ACL: 'public-read'
      };

      var context = this;
      bucket.upload(params, function (error, data) {
        if (error) {
          console.error(error);
        } else {
          context.$emit('uploaded', data.Location);
          context.$emit('uploadedData', data);
        }
      });
    }
  },
  props: {
    accept: String,
    context: String,
    type: {
      type: String,
      default: 'gallery'
    }
  }
});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_croppr__ = __webpack_require__(1033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_croppr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_croppr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-imagecropper',
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default.a
  },
  props: {
    aspectRatio: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      url: null,
      showCropModal: false,
      previewImageUrl: null
    };
  },
  methods: {
    chooseFiles: function chooseFiles() {
      document.getElementById('fileUpload').click();
    },

    cropImage: function cropImage() {
      var _this = this;
      var target = this.$refs.previewImage;
      this.croppr = new __WEBPACK_IMPORTED_MODULE_0_croppr___default.a(target, {
        aspectRatio: null
      });
    },
    cancelCrop: function cancelCrop() {
      this.croppr = null;
      this.showCropModal = false;
    },
    confirmCrop: function confirmCrop() {
      var _this = this;
      var cropValue = this.croppr.getValue();
      var srcImage = this.$refs.previewImage;

      var resizeRatio = 1;
      if (cropValue.width > 1024) {
        resizeRatio = 1024 / cropValue.width;
      }

      var canvas = document.createElement("canvas");
      canvas.height = cropValue.height * resizeRatio;
      canvas.width = cropValue.width * resizeRatio;

      var context = canvas.getContext('2d');
      context.drawImage(srcImage, cropValue.x, cropValue.y, cropValue.width, cropValue.height, 0, 0, canvas.width, canvas.height);

      canvas.toBlob(function (blob) {
        var url = URL.createObjectURL(blob);
        _this.$emit('finished', { url: url, blob: blob });
      }, 'image/png');

      this.showCropModal = false;
      this.croppr = null;
    },
    onFileChange: function onFileChange(e) {
      var file = e.target.files[0];
      var fileType = file['type'];
      var validImageTypes = ['image/gif', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/gif'];
      if (!validImageTypes.includes(fileType)) {
        alert('hanya menerima tipe file gambar');
        this.selectedPicture = null;
      } else {
        var _this = this;
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function (e) {
          if (e.target.readyState == 2) {
            _this.showCropModal = true;
            _this.previewImageUrl = e.target.result;
          }
        };
      }
    }
  }
});

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app-itemchooser",
  props: {
    subject: {
      type: Object,
      required: true,
      default: function _default() {
        return {};
      }
    },
    topiclist: {
      required: false,
      default: null
    },
    sourcetype: {
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: true,
      default: "Cari Soal..."
    }
  },
  components: {
    "app-datatable": __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      headers: ["Kode Soal", "Bab", "Sub Bab", "Sub Sub Bab", "eigen", "label"],
      showModal: false,
      chapterIndex: "",
      subChapterIndex: "",
      topics: [],
      items: [],
      selectedItem: null,
      allFilterToggle: false
    };
  },
  watch: {
    subject: function subject(val) {
      this.topics = [];
      this.loadTopicData();
    },
    showModal: function showModal(to, from) {
      // console.log(this.sourcetype);
      if (to) {
        if (this.sourcetype === "INTERNAL") this.search();
      } else {
        this.chapterIndex = "";
        this.subChapterIndex = "";
        this.items = [];
        this.headers = ["Kode Soal", "Bab", "Sub Bab", "Sub Sub Bab", "eigen", "label"];
      }
    }
  },
  methods: {
    loadTopicData: function loadTopicData() {
      var context = this;
      if (context.topiclist == null) {
        __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getListOfTopic(this.subject.code, function (result) {
          if (result.success) {
            result.data.forEach(function (topic) {
              context.topics.push(topic);
            });
            context.$store.commit("tryoutRevisiMapelList", [context.subject_code, context.topics]);
          }
        });
      } else {
        context.topics = context.topiclist;
      }
    },
    search: function search() {
      var context = this;
      if (this.sourcetype === "INTERNAL") {
        var params = {
          level: context.$store.state.tryout.level,
          mapel_code: context.subject.code,
          item_type: context.$store.state.tryout.type
        };
        __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].searchRandomItemByItemNameV2(params, function (result) {
          context.headers.push("Tipe");
          if (result.success) {
            result.data.forEach(function (item) {
              var subChapter = "-";
              var subSubChapter = "-";

              if (item.subbab_name != null) subChapter = item.subbab_name;
              if (item.subsubbab_name != null) subSubChapter = item.subsubbab_name;

              var row = {
                id: item.id,
                data: [item.code, item.bab_name, subChapter, subSubChapter, item.eigen, "-", item.question_type]
              };
              context.items.push(row);
            });
          }
        });
      } else {
        this.items.splice(0, this.items.length);
        var itemCode = this.getItemCode();
        __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].searchItemByItemCode(itemCode, function (result) {
          if (result.success) {
            result.data.forEach(function (item) {
              var subChapter = "-";
              var subSubChapter = "-";
              if (item.sub_bab != null) subChapter = item.sub_bab.nama;
              if (item.sub_sub_bab != null) subSubChapter = item.sub_sub_bab.nama;

              var row = {
                id: item.id,
                data: [item.kode, item.bab.nama, subChapter, subSubChapter, item.nilai_eigen, item.label]
              };
              context.items.push(row);
            });
          }
        });
      }
    },
    getItemCode: function getItemCode() {
      var chapter = null;
      var subChapter = null;

      var itemCode = "";
      switch (this.$store.state.tryout.level) {
        case "SMA":
          itemCode += "3";
          break;
        case "SMP":
          itemCode += "2";
          break;
        case "SD":
          itemCode += "1";
          break;
        default:
          itemCode += "3";
      }

      if (this.allFilterToggle) {
        itemCode += "4";
      } else {
        switch (this.$store.state.tryout.type) {
          case "SBMPTN":
            itemCode += "1";
            break;
          case "UJIAN_MANDIRI":
            itemCode += "1";
            break;
          case "UJIAN_AKHIR_NASIONAL":
            itemCode += "2";
            break;
          case "UJIAN_AKHIR_SEKOLAH":
            itemCode += "3";
            break;
          default:
            itemCode += "4";
        }
      }

      itemCode += this.subject.code;
      chapter = this.topics[this.chapterIndex];
      itemCode += chapter.kode;

      subChapter = null;
      if (this.subChapterIndex != "") {
        subChapter = chapter.subs[this.subChapterIndex];
        itemCode += subChapter.kode;
      }

      return itemCode;
    },
    confirmSelectedItem: function confirmSelectedItem() {
      this.showModal = false;
      this.$emit("selected", this.selectedItem);
    }
  },
  mounted: function mounted() {
    // console.log(this.topiclist)
    this.loadTopicData();
  }
});

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'label-autocomplete',
  data: function data() {
    return {
      labels: []
    };
  },
  props: {
    query: {
      type: String,
      default: ''
    }
  },
  computed: {
    filteredLabels: function filteredLabels() {
      if (this.query === null || this.query.length < 3) return [];

      var results = [];
      var context = this;
      this.labels.forEach(function (label) {
        var query = context.query.toUpperCase();
        var target = label.toUpperCase();

        if (target.indexOf(query) != -1) results.push(label);
      });

      return results;
    }
  },
  beforeMount: function beforeMount() {
    var url = "https://api.nfjuara.id" + '/itembank/labels';
    var authToken = JSON.parse(localStorage.getItem('token')).value;
    var options = {
      headers: {
        'Authorization': authToken
      }
    };

    var context = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url, options).then(function (response) {
      if (response.status === 200) {
        response.data.forEach(function (d) {
          context.labels.push(d);
        });
      }
    });
  }
});

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_PodbeanExplorer__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_PodbeanExplorer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_PodbeanExplorer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_marked__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'markdown-editor',
  components: {
    'app-modal': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Modal___default.a,
    'app-fileupload': __WEBPACK_IMPORTED_MODULE_0__components_plugins_FileUpload___default.a,
    'app-podbean-explorer': __WEBPACK_IMPORTED_MODULE_1__components_plugins_PodbeanExplorer___default.a
  },
  props: ['rows', 'readOnly', 'value', 'context'],
  data: function data() {
    return {
      math: null,
      compiledContent: '',
      showModal: false,
      content: ''
    };
  },
  methods: {
    preview: function preview() {
      var text = this.compileInlineLatex(this.content);
      text = this.compileBlockLatex(text);
      text = __WEBPACK_IMPORTED_MODULE_3_marked___default()(text, { sanitize: false });

      this.compiledContent = text;
      this.showModal = true;
    },
    compileInlineLatex: function compileInlineLatex(content) {
      var pattern = /\\\\\((.*?)\\\\\)/g;
      var compiledContent = content;
      var match;
      while (match = pattern.exec(compiledContent)) {
        var index = match.index;
        var length = match[0].length;
        var formula = katex.renderToString(match[1]);
        compiledContent = compiledContent.substr(0, index) + formula + compiledContent.substr(index + length);
      }

      return compiledContent;
    },
    compileBlockLatex: function compileBlockLatex(content) {
      var pattern = /\$\$(.*?)\$\$/g;
      var compiledContent = content;
      var match;
      while (match = pattern.exec(compiledContent)) {
        var index = match.index;
        var length = match[0].length;
        var formula = '<p class="text-center">' + katex.renderToString(match[1]) + '</p>';
        compiledContent = compiledContent.substr(0, index) + formula + compiledContent.substr(index + length);
      }

      return compiledContent;
    },
    imageUploaded: function imageUploaded(url) {
      this.content += '\n![Alt](' + url + ')';
    },
    itemSelected: function itemSelected(content) {
      this.content += content;
    }
  },
  watch: {
    'content': function content(input) {
      this.$emit('content-updated', input);
    },
    'value': function value(val) {
      this.content = this.value;
    }
  },
  mounted: function mounted() {
    this.content = this.value;
  }
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal',
  props: ['showModal', 'withCancel', 'cancelOnly']
});

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'podbean-explorer',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      showModal: false,
      isLoading: false,
      headers: ['Filename', 'Date', 'Preview'],
      rows: [],
      items: []
    };
  },
  methods: {
    explore: function explore() {
      var context = this;
      var url = 'https://anchor.fm/s/f78dcdc/podcast/rss';

      this.isLoading = true;
      this.rows = [];
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(url).then(function (response) {
        if (response.status === 200) {
          var domParser = new DOMParser();
          var xmlDoc = domParser.parseFromString(response.data, "text/xml");
          var items = xmlDoc.getElementsByTagName("item");

          for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var url = item.getElementsByTagName("enclosure")[0].getAttribute("url");
            var row = {
              id: i,
              data: [item.getElementsByTagName("title")[0].textContent, item.getElementsByTagName("pubDate")[0].textContent, '<a href="#" onClick="' + "window.open('" + url + "','MyWindow','width=350,height=50'); return false;" + '">Preview</a>']
            };

            context.rows.push(row);
            context.items.push(item);
          }

          context.isLoading = false;
          context.showModal = true;
        }
      });
    },
    selectItem: function selectItem(item) {
      var item = this.items[item.id];
      var title = item.getElementsByTagName("title")[0].textContent;
      var resourceId = item.getElementsByTagName("link")[0].textContent.split('/')[5];
      var link = 'https://anchor.fm/nfjuara/embed/episodes/' + resourceId;
      var context = this;
      var iframeString = '<iframe src="' + link + '" height="102px" width="100%" frameborder="0" scrolling="no"></iframe>';

      this.showModal = false;
      this.$emit('selected', iframeString);
    }
  }
});

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-spinner'
});

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sbmptn-nav'
});

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_search_select_dist_VueSearchSelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_notification_js__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import { ModelSelect } from 'vue-search-select'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: "content-article-form",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
    "app-datatable": __WEBPACK_IMPORTED_MODULE_4__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      inputMode: "1",
      form: {
        title: null,
        text: null,
        imageurl: null,
        content: null,
        link: null,
        cta: null
      },
      pagination: {
        current_page: 1,
        total_page: 0
      },
      scheduledDate: '',
      scheduledTime: '',
      fcmtoken: null,
      modeDialogForm: "1",
      databody: null,
      errors: [],
      headers: ["Channel", "Judul Notifikasi", "Tanggal Push", "Created At"],
      listPush: []
    };
  },
  watch: {},
  filters: {
    convertDate: function convertDate(v) {
      return __WEBPACK_IMPORTED_MODULE_6_moment___default.a.unix(v / 1000).format("DD/MMMM/YYYY HH:mm:ss");
    }
  },
  mounted: function mounted() {
    var context = this;
    if (localStorage.pushnotif) {
      var bb = JSON.parse(localStorage.pushnotif);
      this.form = bb;
    }
    DatepickerPlugin.init("#scheduledDate", function (value) {
      context.scheduledDate = value;
    });

    ClockpickerPlugin.init("#scheduledTime", function (value) {
      context.scheduledTime = value;
    });
    this.getListNotif();
  },
  methods: {
    nextButton: function nextButton() {
      if (this.validateForm(this.inputMode)) {
        this.modeDialogForm = "1";
        $("#konfirmpushnotif").modal("show");
      }
    },
    closeModal: function closeModal() {
      this.modeDialogForm = "1";
      $("#konfirmpushnotif").modal("hide");
    },
    paging: function paging(pg) {
      this.pagination.current_page = this.pagination.current_page + pg;
      this.getListNotif();
    },
    getListNotif: function getListNotif() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_5__services_notification_js__["a" /* default */].getNotifSchedules(this.pagination, function (result) {
        context.listPush = result.data.data;
        context.pagination.total_page = result.data.total_page;
      });
    },

    // preparingBody(mode) {
    //   var context = this;
    //   context.databody = {
    //     // d5ccCN0LRyK9Rkr-hn9wuF:APA91bF_I_Fbmnu9Dhu3q2aK8kNcOheYvnbfXj0foml5vBWuZrYqxa1a_qKmW37l3albSP1gwoYFB1m7ZLONinudHWtbWbSaxMb1g9RHsk-i97dzlhIrPUeZrYN6qTvld_m9URn9hccq
    //     to: mode === "test" ? context.fcmtoken : "/topics/global",
    //   };
    //   if (context.inputMode == "1") {
    //     context.databody.notification = {
    //       title: context.form.title,
    //       body: context.form.text,
    //       type: "ANNOUNCEMENT",
    //       channel: "CHANNEL_GLOBAL",
    //     };
    //   } else {
    //     let payload =
    //       '{"image_url": "' +
    //       context.form.imageurl +
    //       ' ","description": "' +
    //       context.form.content +
    //       '","button_url": "' +
    //       context.form.link +
    //       '","button_text": "' +
    //       context.form.cta +
    //       '"}';
    //     context.databody.data = {
    //       title: context.form.title,
    //       body: context.form.text,
    //       type: "ANNOUNCEMENT",
    //       channel: "CHANNEL_GLOBAL",
    //       payload: payload,
    //     };
    //   }

    //   localStorage.setItem("pushnotif", JSON.stringify(context.form));
    // },
    // sendButtonTest(m) {
    //   // console.log(m);
    //   if (this.fcmtoken === null || this.fcmtoken === "") {
    //     alert("fcm wajib diisi");
    //     return false;
    //   } else if (this.fcmtoken !== null && this.fcmtoken !== "") {
    //     var context = this;
    //     this.isLoading = true;
    //     this.preparingBody(m);
    //     var url = "https://fcm.googleapis.com/fcm/send";

    //     var http = axios.create({
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "key=" + process.env.NOTIFICATION_AUTH,
    //       },
    //     });
    //     http
    //       .post(url, context.databody)
    //       .then((response) => {
    //         if (response.data.failure === 1) {
    //           alert("data gagal dikirim: " + response.data.results[0].error);
    //         } else {
    //           context.modeDialogForm = m === "all" ? "3" : "2";
    //         }
    //         context.isLoading = false;
    //       })
    //       .catch((err) => {
    //         alert("Error Push Notif");
    //         context.isLoading = false;
    //       });
    //   }
    // },
    // sendButtonAll(m) {
    //   if (
    //     confirm("Apakah anda yakin akan mengirim notifikasi keseluruh user?") ==
    //     true
    //   ) {
    //     var context = this;
    //     this.isLoading = true;
    //     this.preparingBody(m);
    //     var url = "https://fcm.googleapis.com/fcm/send";

    //     var http = axios.create({
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "key=" + process.env.NOTIFICATION_AUTH,
    //       },
    //     });
    //     http
    //       .post(url, context.databody)
    //       .then((response) => {
    //         if (response.data.failure === 1) {
    //           alert("data gagal dikirim: " + response.data.results[0].error);
    //         } else {
    //           context.modeDialogForm = m === "all" ? "3" : "2";
    //         }
    //         context.isLoading = false;
    //       })
    //       .catch((err) => {
    //         alert("Error Push Notif");
    //         context.isLoading = false;
    //       });
    //   } else {
    //     return false;
    //   }
    // },

    submitNotification: function submitNotification(m) {
      var context = this;
      context.isLoading = true;
      var scheduledEpoch = __WEBPACK_IMPORTED_MODULE_6_moment___default()(context.scheduledDate + ' ' + context.scheduledTime, "DD/MM/YYYY HH:mm").valueOf();
      var form = context.form;
      if (context.inputMode === '1') {
        form.content = null;
        form.imageurl = null;
        form.cta = null;
        form.link = null;
      }
      var body = {
        "title": form.title,
        "body": form.text,
        "description": form.content,
        "image_url": form.imageurl,
        "button_url": form.link,
        "button_text": form.cta,
        "scheduled_at": isNaN(scheduledEpoch) ? null : scheduledEpoch,
        "fcm_token": context.fcmtoken
      };
      localStorage.setItem("pushnotif", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.form));
      __WEBPACK_IMPORTED_MODULE_5__services_notification_js__["a" /* default */].submitNotification(body, function (response) {
        console.log(response);
        if (response.success) {
          context.modeDialogForm = m === "all" ? "3" : "2";
        } else {
          alert("data gagal dikirim: " + response.message);
        }
        context.isLoading = false;
      });
    },

    validateForm: function validateForm(m) {
      this.errors = [];
      if (m === "1") {
        if (this.form.title === "" || this.form.title === null) this.errors.push("Judul wajib diisi");
        if (this.form.text === "" || this.form.text === null) this.errors.push("Pesan wajib diisi");
      } else {
        if (this.form.title === "" || this.form.title === null) this.errors.push("Judul wajib diisi");
        if (this.form.text === "" || this.form.text === null) this.errors.push("Pesan wajib diisi");
        if (this.form.imageurl === "" || this.form.imageurl === null) this.errors.push("Gambar wajib diisi");
        if (this.form.content === "" || this.form.content === null) this.errors.push("Konten wajib diisi");
        if (this.form.cta === "" || this.form.cta === null) this.errors.push("Call to action wajib diisi");
      }
      return this.errors.length == 0;
    }
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-management',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      query: '',
      isLoading: false,
      pageNumber: 1,
      organizations: [],
      total_page: 0,
      isDisabledNextBtn: false,
      totalItem: 0,
      showConfirmationModal: false,
      filter: {
        start_date: null,
        end_date: null,
        state: 'STARTED'
      }
    };
  },
  watch: {
    pageNumber: function pageNumber(newVal) {
      this.loadOrganizationsData(newVal);
    }
  },
  filters: {
    convertDate: function convertDate(v) {
      return __WEBPACK_IMPORTED_MODULE_3_moment___default()(v).format("DD MMMM YYYY");
    }
  },
  methods: {
    loadOrganizationsData: function loadOrganizationsData() {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var context = this;
      var token = this.$ls.get('token');
      var filterstate = '';
      if (context.filter.state === 'STARTED') filterstate = '&state=STARTED&is_ended=true';else filterstate = '&state=FINISHED';
      var url = "https://api.nfjuara.id" + '/tryout-service/tryout/participants?page=' + pageNumber + '&page_size=25' + filterstate + '&started_at=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(context.filter.start_date + ' 00:00:01', 'DD/MM/YYYY HH:mm:ss').valueOf() + '&ended_at=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(context.filter.end_date + " 23:59:59", 'DD/MM/YYYY HH:mm:ss').valueOf();

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {
        params: {
          page: pageNumber
          // name: this.query
        }
      }).then(function (response) {
        // console.log(response)
        if (response.data.length < 25) {
          context.isDisabledNextBtn = true;
        } else {
          context.isDisabledNextBtn = false;
        }
        context.organizations = response.data.data;
        context.total_page = response.data.total_page;
        //   console.log(context.total_page)
        context.totalItem = response.data.total_item;
        context.isLoading = false;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    submitRegrading: function submitRegrading() {
      var context = this;
      var data = this.data;
      var token = this.$ls.get('token');
      this.isLoading = true;
      var filterstate = '';
      if (context.filter.state === 'STARTED') filterstate = 'state=STARTED&is_ended=true';else filterstate = 'state=FINISHED';
      var url = "https://api.nfjuara.id" + '/tryout-service/tryout/participants/grading?' + filterstate + '&started_at=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(context.filter.start_date + ' 00:00:01', 'DD/MM/YYYY HH:mm:ss').valueOf() + '&ended_at=' + __WEBPACK_IMPORTED_MODULE_3_moment___default()(context.filter.end_date + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss').valueOf();

      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });
      // if (this.validateForm()) {
      http.post(url, data).then(function (response) {
        context.isLoading = false;
        context.loadOrganizationsData(1);
        context.showConfirmationModal = false;
        // context.$router.push('/organizations')
      }).catch(function (error) {
        context.isLoading = false;
        context.showConfirmationModal = false;
        alert("Gagal grading data : " + error.response.data.message);
      });
      // }
    },

    goToDetail: function goToDetail(id) {
      this.$router.push('organization/' + id);
    }
  },
  mounted: function mounted() {
    // this.loadOrganizationsData()
    var context = this;
    DatepickerPlugin.init("#filterStart", function (value) {
      context.filter.start_date = value;
    });
    DatepickerPlugin.init("#filterEnd", function (value) {
      context.filter.end_date = value;
    });
  }
});

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'sbmptn-nav'
});

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-management',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      tryoutGroups: [],
      isLoading: false,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc'
      },
      headers: ['Nama', 'Tipe', 'Jenjang', 'Opened At', 'Closed At'],
      headersKey: ['name', 'type', 'level', 'openedAt', 'closedAt'],
      showModal: false
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  watch: {
    pagination: function pagination() {
      this.fetchData();
    },
    search: function search() {
      console.log(this.search);
    }
  },
  methods: {
    fetchData: function fetchData() {
      var params = {
        type: 'SBMPTN',
        variant: 'SCHEDULED',
        status: 'PUBLISHED'
      };

      var context = this;
      __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getListOfTryoutGroups(this.pagination, this.search, params, function (result) {
        context.tryoutGroups = [];
        if (result.success) {
          result.data.forEach(function (group) {
            var openedAt = __WEBPACK_IMPORTED_MODULE_4_moment___default()(group.opened_at).format('YYYY-MM-DD');
            var closedAt = __WEBPACK_IMPORTED_MODULE_4_moment___default()(group.closed_at).format('YYYY-MM-DD');

            var row = {
              id: group.id,
              data: [group.name, group.type, group.level, openedAt, closedAt]
            };

            context.pagination.totalPages = group.page;
            context.tryoutGroups.push(row);
          });
        }
      });
    },
    gradingTryout: function gradingTryout(row) {
      var todayMilis = new Date().getTime();
      var closedAtMilis = Date.parse(row.data[4]);
      var diff = closedAtMilis - todayMilis;

      if (diff > 0) {
        window.alert("Tryout belum lewat masa berakhir");
        return;
      }

      var confirmed = window.confirm('Lakukan grading tryout ' + row.data[0] + ' ?');
      if (confirmed) {
        var context = this;
        context.isLoading = true;

        __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].gradingUtbkScore(row.id, function (result) {
          setTimeout(function () {
            var message = "Proses grading ";
            message += result.success ? "berhasil" : "gagal";
            alert(message);
            context.isLoading = false;
          }, 3000);
        });
      }
    },
    rankingTryout: function rankingTryout(row) {
      localStorage.setItem('rank_tryoutGroup_name', row.data[0]);
      this.$router.push({ path: '/sbmptn/top10?group_id=' + row.id });
    }
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'top10utbk',
  components: {},
  data: function data() {
    return {
      top10ipa: [],
      top10ips: [],
      activeTab: '',
      activeList: []
    };
  },
  mounted: function mounted() {
    var groupId = this.$route.query.group_id;
    var context = this;
    __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getTop10UtbkRank(groupId, function (result) {
      if (result.success) {
        context.top10ipa = result.data.ipa;
        context.top10ips = result.data.ips;
        context.activeList = context.top10ipa;
        context.activeTab = 'IPA';
      }
    });
  },
  computed: {
    tryoutGroupName: {
      get: function get() {
        return localStorage.getItem('rank_tryoutGroup_name');
      }
    }
  },
  methods: {
    loadData: function loadData(category) {
      if (category == 'IPA') this.activeList = this.top10ipa;else this.activeList = this.top10ips;

      this.activeTab = category;
    }
  }
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'serial-form',
    components: {
        'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
        'app-tryoutgroupchooser': __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser___default.a,
        'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
    },
    data: function data() {
        return {
            id: null,
            title: null,
            description: null,
            grade: 12,
            isLoading: false,
            errors: [],
            groups: [],
            stack: [],
            showUnAttachModal: false,
            selectedGroup: null
        };
    },
    methods: {
        validateForm: function validateForm() {
            this.errors = [];
            if (!this.title) this.errors.push('Judul harus diisi');

            return this.errors.length == 0;
        },
        save: function save() {
            var context = this;
            this.isLoading = true;
            if (this.validateForm()) {
                var data = {
                    title: this.title,
                    description: this.description,
                    grade: this.grade
                };

                __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].createTryoutSeries(data, function (response) {
                    if (response.success) {
                        context.id = response.data.id;
                        context.title = response.data.title;
                        context.description = response.data.description;
                        context.grade = response.data.grade;
                        context.$router.push({ path: '/serial/form', query: { id: response.data.id } });
                    }

                    context.isLoading = false;
                });
            } else {
                this.isLoading = false;
            }
        },
        onGroupSelected: function onGroupSelected(group) {
            this.getGroupDetail(group.id);
        },
        getGroupDetail: function getGroupDetail(groupId) {
            this.isLoading = true;
            var context = this;

            __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getTryoutGroup(groupId, function (response) {
                if (response.success) {
                    context.stack.push(response.data);

                    if (response.data.dependency_id === null) context.processAttachGroups();else context.getGroupDetail(response.data.dependency_id);
                }

                context.isLoading = false;
            });
        },
        processAttachGroups: function processAttachGroups() {
            if (this.stack.length == 0) {
                this.getListOfAttachedGroups();
            } else {
                this.isLoading = true;

                var context = this;
                var group = this.stack.pop();
                __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].attachGroupIntoSeries(group.id, this.id, function (response) {
                    if (response.success) {
                        context.isLoading = false;
                        context.processAttachGroups();
                    } else {
                        this.isLoading = false;
                    }
                });
            }
        },
        confirmUnAttachGroup: function confirmUnAttachGroup(group) {
            this.selectedGroup = group;
            this.showUnAttachModal = true;
        },
        processUnAttachGroup: function processUnAttachGroup() {
            var _this = this;

            var found = this.groups.find(function (g) {
                return g.dependency_id === _this.selectedGroup.id;
            });
            if (found) {
                var message = 'Tidak dapat menghapus group dikarenakan menjadi prasyarat: ' + found.name;
                this.$store.commit('error_show', message);
                this.showUnAttachModal = false;
            } else {
                var context = this;
                var groupId = this.selectedGroup.id;
                var seriesId = this.id;

                this.isLoading = true;
                __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].dettachGroupFromSeries(groupId, seriesId, function (response) {
                    if (response.success) {
                        context.groups = [];
                        var params = { series_id: context.id };
                        __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getListOfTryoutGroups(null, null, params, function (response) {
                            if (response.success) {
                                response.data.forEach(function (group) {
                                    context.groups.push(group);
                                });

                                context.groups.sort(function (a, b) {
                                    return a.series_sequence - b.series_sequence;
                                });
                            }

                            context.isLoading = false;
                            context.showUnAttachModal = false;
                        }, context.grade, context.id);
                    }
                });
            }
        },
        getListOfAttachedGroups: function getListOfAttachedGroups() {
            var context = this;
            var params = { series_id: this.id };
            __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getListOfTryoutGroups(null, null, params, function (response) {
                if (response.success) {
                    context.groups = [];
                    response.data.forEach(function (group) {
                        context.groups.push(group);
                    });

                    context.groups.sort(function (a, b) {
                        return a.series_sequence - b.series_sequence;
                    });
                }
            }, context.grade, context.id);
        }
    },
    mounted: function mounted() {
        var context = this;
        var seriesId = this.$route.query.id;
        if (this.$route.query.id) {
            this.isLoading = true;
            __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getTryoutSeries(seriesId, function (response) {
                if (response.success) {
                    context.id = response.data.id;
                    context.title = response.data.title;
                    context.description = response.data.description;
                    context.grade = response.data.grade;
                    context.getListOfAttachedGroups();
                }

                context.isLoading = false;
            });
        } else {
            this.isLoading = false;
        }
    }
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'serial-nav'
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-serial',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      rows: [],
      headers: ['Nama', 'Kelas', 'Tipe', 'Open', 'Close']
    };
  },
  methods: {
    editRow: function editRow(row) {
      this.$router.push({ path: '/serial/form', query: { id: row.id } });
    },
    createSerial: function createSerial() {
      this.$router.push({ path: '/serial/form' });
    },
    deleteSerial: function deleteSerial(data) {
      var context = this;
      var dataid = data.id;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
      if (confirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].deleteTryoutSerial(dataid, function (result) {
          if (result.success) {
            alert('Data Terhapus');
            context.isLoading = false;
            context.fetchData();
            this.$router.push({ path: '/serial' });
          }
        });
      }
    },
    fetchData: function fetchData() {
      var context = this;
      this.isLoading = true;
      this.rows = [];
      __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].getListOfTryoutSeries(function (response) {
        if (response.success) {
          response.data.forEach(function (groupSeries) {
            var openedAt = groupSeries.opened_at != null ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(groupSeries.opened_at).format('DD/MM/YYYY, hh:mm:ss') : '-';
            var closedAt = groupSeries.closed_at != null ? __WEBPACK_IMPORTED_MODULE_3_moment___default()(groupSeries.closed_at).format('DD/MM/YYYY, hh:mm:ss') : '-';

            var row = {
              id: groupSeries.id,
              data: [groupSeries.title, groupSeries.grade, groupSeries.type, openedAt, closedAt]
            };

            context.rows.push(row);
          });

          context.isLoading = false;
        }
      }).catch(function (error) {
        context.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    this.fetchData();
  }
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation-nav'
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-detail',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_2_vue2_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      teacher: {},
      isLoading: true,
      pageNumber: 1,
      query: '',
      isMapping: false,
      isBulkModal: false,
      ossEndpoint: "oss-ap-southeast-5.aliyuncs.com",
      ossBucketName: "nfjuara",
      listMapelScope: [],
      expiredAtModel: null,
      mapels: []
    };
  },
  methods: {
    loadDetailData: function loadDetailData() {
      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/teacher/' + context.$route.params.id;

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url).then(function (response) {
        context.teacher = response.data;
        context.listMapelScope = response.data.scopes;
        context.expiredAtModel = response.data.expired_at;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    loadMapels: function loadMapels() {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/teacher/scopes';

      // this.isLoading = true
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url).then(function (response) {
        context.mapels = response.data;
        for (var index = 0; index < context.mapels.length; index++) {
          context.mapels[index].display_name = context.mapels[index].displayName;
        }
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        // context.isLoading = false
      });
    },

    updateTanggalScope: function updateTanggalScope() {
      var context = this;
      if (__WEBPACK_IMPORTED_MODULE_4_moment___default()(context.expiredAtModel + ' 23:59:59').unix() < __WEBPACK_IMPORTED_MODULE_4_moment___default()().unix()) {
        alert('Tanggal tidak valid');
        context.loadDetailData();
      } else if (context.expiredAtModel === null || context.expiredAtModel === '') {
        alert('Tanggal Expired wajib diisi');
      } else {
        if (confirm("Anda yakin akan mengubah data ini?") == true) {
          var token = this.$ls.get('token');
          var url = "https://api.nfjuara.id" + '/account/teacher/' + context.$route.params.id;

          this.isLoading = true;
          var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
            }
          });

          var convertIdMapelScope = [];
          context.teacher.scopes.forEach(function (element) {
            convertIdMapelScope.push(element.id);
          });
          http.put(url, { 'expired_at': __WEBPACK_IMPORTED_MODULE_4_moment___default()(context.expiredAtModel + ' 23:59:59').unix(), 'scope_ids': convertIdMapelScope }).then(function (response) {
            console.log(response);
            alert('Data berhasil diperbaharui');
            context.loadDetailData();
            context.$router.push('/teachers');
          }).catch(function (error) {
            console.log(error.message);
            alert('Data gagal diperbaharui');
            context.loadDetailData();
          }).then(function () {
            context.isLoading = false;
          });
        }
      }
    },
    addMapel: function addMapel(v) {
      console.log(v);
      var aa = this.teacher.scopes.find(function (element) {
        return element.id == v.id;
      });
      if (!aa) this.teacher.scopes.push(v);
    },
    removeMapel: function removeMapel(v) {
      for (var index = 0; index < this.teacher.scopes.length; index++) {
        var element = this.teacher.scopes[index];
        if (element.id === v.id) this.teacher.scopes.splice(index, 1);
      }
    }
  },
  mounted: function mounted() {
    this.loadDetailData();
    this.loadMapels();
  }

});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_datepicker_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-management',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
    'app-datatable': __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_3_vue2_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      reportType: 'report',
      query: '',
      filter: {
        mapel: '',
        status: ''
      },
      isLoading: false,
      pageNumber: 1,
      teachers: [],
      total_page: 0,
      isDisabledNextBtn: false,
      mapels: [],
      consul: {
        started_at: null,
        ended_at: null
      }
    };
  },
  watch: {
    // pageNumber: function(newVal) {
    //   this.loadTeachersData(newVal)
    // }
  },
  methods: {
    loadTeachersData: function loadTeachersData() {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.pageNumber = pageNumber;
      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/teachers';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });
      var objParams = '{"order": "DESC","page_size": 15, "page": ' + pageNumber;
      if (this.query !== '') objParams += ', "search": "' + this.query + '"';
      if (this.filter.mapel !== '') objParams += ', "mapel_scope_id": ' + this.filter.mapel;
      if (this.filter.status !== '') objParams += ', "is_active": "' + this.filter.status + '"';

      objParams += '}';

      http.get(url, {
        params: JSON.parse(objParams)
      }).then(function (response) {
        context.teachers = response.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    loadMapels: function loadMapels() {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/teacher/scopes';

      // this.isLoading = true
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url).then(function (response) {
        context.mapels = response.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        // context.isLoading = false
      });
    },

    goToDetail: function goToDetail(id) {
      this.$router.push('teacher-detail/' + id);
    },
    downloadKonsul: function downloadKonsul() {
      var context = this;
      var token = this.$ls.get('token');
      context.isLoading = true;
      var url = "https://api.nfjuara.id" + '/konsul/consultations/' + this.reportType + '?started_at=' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(context.consul.started_at + ' 00:00:00').unix() + '&ended_at=' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(context.consul.ended_at + ' 23:59:59').unix() + '&status=finished';

      // this.isLoading = true
      var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {
        responseType: 'blob'
      }).then(function (response) {
        var filename = context.reportType == 'report' ? 'Data Konsul ' : 'Rekap Konsul ';
        filename += __WEBPACK_IMPORTED_MODULE_5_moment___default()(context.consul.started_at).format('DD MMM YYYY') + ' - ' + __WEBPACK_IMPORTED_MODULE_5_moment___default()(context.consul.ended_at).format('DD MMM YYYY') + '.xlsx';

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          // IE variant
          window.navigator.msSaveOrOpenBlob(new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }), filename);
        } else {
          var _url = window.URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }));
          var link = document.createElement('a');
          link.href = _url;
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }
      }).catch(function (error) {
        alert('Download file gagal');
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    deleteTeacher: function deleteTeacher(item) {
      var context = this;
      if (confirm("Apakah anda yakin akan menghapus data guru ini") == true) {
        var token = this.$ls.get('token');
        var url = "https://api.nfjuara.id" + '/account/teacher/' + item.user_id;

        // this.isLoading = true
        var http = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        });

        http.delete(url).then(function (response) {
          alert('Hapus data guru berhasil');
          context.loadTeachersData(1);
        }).catch(function (error) {
          alert('Hapus data guru gagal');
          console.log(error.message);
        }).then(function () {
          // context.isLoading = false
        });
      } else {}
    },
    showDownloadKonsul: function showDownloadKonsul(reportType) {
      this.reportType = reportType;
      $('#modalDownloadKonsul').modal('show');
    }
  },
  mounted: function mounted() {
    this.loadTeachersData();
    this.loadMapels();
  }
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Autocomplete__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Autocomplete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Autocomplete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_ItemChooser__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_ItemChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_ItemChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tryout_models_SubtestDetail_js__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-assemble-subtest',
  components: {
    'app-autocomplete': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Autocomplete___default.a,
    'app-itemchooser': __WEBPACK_IMPORTED_MODULE_1__components_plugins_ItemChooser___default.a
  },
  props: {
    subject: null
  },
  data: function data() {
    return {
      showModal: false,
      details: [],
      sourceType: null,
      questionType: null,
      topics: [],
      lastSequence: 0,
      subtestType: 'normal'
    };
  },
  computed: {
    selectedSubject: function selectedSubject() {
      if (this.$store.getters.selectedSubtest) {
        var subject = {
          nama: this.$store.getters.selectedSubtest.subject_name,
          code: this.$store.getters.selectedSubtest.subject_code,
          picture: this.$store.getters.selectedSubtest.subject_picture
        };
        return subject;
      }

      return this.subject;
    }
  },
  methods: {
    getTopicText: function getTopicText(subtestDetail) {
      try {
        console.log(subtestDetail);
        if (this.topics.length == 0) return;

        var text = '';
        var chapter = this.topics.find(function (element) {
          return element.kode == parseInt(subtestDetail.bab_code);
        });

        console.log(chapter);
        text += chapter.nama;

        if (subtestDetail.sub_bab_code) {
          var subChapter = chapter.subs.find(function (element) {
            return element.kode == parseInt(subtestDetail.sub_bab_code);
          });

          console.log(subChapter);
          text += ' >> ' + subChapter.nama;
        }

        return text;
      } catch (err) {
        console.log(err);
        return subtestDetail.text;
      }
    },
    assignTopic: function assignTopic(selectedTopic) {
      var context = this;
      if (this.sourceType === 'EXTERNAL') {
        var chapterId = selectedTopic.data[0];
        var chapter = this.topics.find(function (element) {
          return element.id == chapterId;
        });

        var detail = {};
        detail.sequence = this.lastSequence + 1;
        detail.is_anchor = false;
        detail.bab_code = chapter.kode;

        if (selectedTopic.data[1] != 0) {
          var subChapterId = selectedTopic.data[1];
          var subChapter = chapter.subs.find(function (element) {
            return element.id == subChapterId;
          });
          detail.sub_bab_code = subChapter.kode;
        }

        detail.text = selectedTopic.text;
        detail.source = 'EXTERNAL';
        detail.question_type = 'PG';
        var level = this.$store.state.tryout.level;
        var type = this.$store.state.tryout.type;
        var code = this.generateItemCode(detail.bab_code, detail.sub_bab_code, type, level);

        // console.log(level)
        __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].searchRandomItemByItemCodeAndGrade(code, function (result) {
          if (result.success) {
            context.details.push(detail);
            context.lastSequence++;
          } else {
            var altCode = code.substring(0, 1) + '4' + code.substring(2);
            __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].searchRandomItemByItemCodeAndGrade(altCode, function (altResult) {
              if (altResult.success) {
                context.details.push(detail);
                context.lastSequence++;
              } else {
                window.alert('Topik "' + detail.text + '" tidak memiliki soal');
              }
            });
          }
        });
      } else {
        // console.log(selectedTopic)
        var chapterId = selectedTopic.data[0];
        var chapter = this.topics.find(function (element) {
          return element.name == chapterId;
        });
        // console.log(chapter)
        var detail = {};
        detail.sequence = this.lastSequence + 1;
        detail.is_anchor = false;
        detail.bab_code = chapter.name;

        if (selectedTopic.data[1] != 0) {
          var subChapterId = selectedTopic.data[1].split(" >> ");

          var subChapter = chapter.subs.find(function (element) {
            return element.name == subChapterId[1];
          });
          // console.log(subChapter)
          detail.sub_bab_code = subChapter.name;
        }

        detail.text = selectedTopic.text;
        detail.source = 'INTERNAL';
        detail.question_type = context.questionType;
        // console.log(context.subject)
        var params = {
          level: context.$store.state.tryout.level,
          mapel_code: context.subject.code,
          bab_name: detail.bab_code,
          subbab_name: detail.sub_bab_code,
          subsubbab_name: null,
          question_type: detail.question_type,
          item_type: context.$store.state.tryout.type
        };
        __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].searchRandomItemByItemNameV2(params, function (result) {
          // console.log(result)
          if (result.data && result.data.length > 0) {
            detail.item_code = result.data[0].code;
            context.details.push(detail);
            context.lastSequence++;
          } else {
            window.alert('Topik "' + detail.text + '" tidak memiliki soal');
          }
        });
      }
    },
    generateItemCode: function generateItemCode(babCode, subBabCode, type, level) {
      var code = '';
      switch (level) {
        case 'SMA':
          code += '3';
          break;
        case 'SMP':
          code += '2';
          break;
        case 'SD':
          code += '1';
          break;
        default:
          code += '3';
      }

      switch (type) {
        case 'UAS':
          code += '3';
          break;
        case 'UJIAN_AKHIR_SEKOLAH':
          code += '3';
          break;
        case 'UJIAN_SEKOLAH':
          code += '3';
          break;
        case 'PENILAIAN_TENGAH_SEMESTER':
          code += '3';
          break;
        case 'PENILAIAN_AKHIR_SEMESTER':
          code += '3';
          break;
        case 'UN':
          code += '2';
          break;
        case 'UJIAN_AKHIR_NASIONAL':
          code += '2';
          break;
        case 'SBMPTN':
          code += '1';
          break;
        case 'UJIAN_MANDIRI':
          code += '1';
          break;
        default:
          code += '4';
      }

      code += this.subject.code;
      code += babCode;

      if (subBabCode) code += subBabCode;

      return code;
    },
    assignAnchor: function assignAnchor(anchorItem) {
      var detail = {};
      detail.sequence = this.lastSequence + 1;
      detail.is_anchor = true;
      detail.item_code = anchorItem.data[0];
      detail.source = this.sourceType;
      if (this.sourceType === 'INTERNAL') detail.question_type = anchorItem.data[6];else detail.question_type = 'PG';
      var found = this.details.find(function (d) {
        return d.item_code == detail.item_code;
      });
      if (!found) {
        this.details.push(detail);
        this.lastSequence++;
      }
    },
    moveUp: function moveUp(subtestDetail) {
      if (currentIndex === 0) return;
      var currentIndex = subtestDetail.sequence - 1;
      var element = this.details.splice(currentIndex, 1)[0];
      this.details.splice(currentIndex - 1, 0, element);
      this.reOrderingSequence();
    },
    moveDown: function moveDown(subtestDetail) {
      if (currentIndex === this.details.length - 1) return;
      var currentIndex = subtestDetail.sequence - 1;
      var element = this.details.splice(currentIndex, 1)[0];
      this.details.splice(currentIndex + 1, 0, element);
      this.reOrderingSequence();
    },
    remove: function remove(subtestDetail) {
      var confirmed = window.confirm('Apakah anda yakin akan menghapus soal ini?');
      if (confirmed) {
        var index = subtestDetail.sequence - 1;
        this.details.splice(index, 1);
        this.reOrderingSequence();
      }
    },
    reOrderingSequence: function reOrderingSequence() {
      var context = this;
      this.lastSequence = 0;
      this.details.forEach(function (detail) {
        detail.sequence = context.lastSequence + 1;
        context.lastSequence++;
      });
    },
    loadTopics: function loadTopics() {
      var context = this;
      context.topics = [];
      __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].getListOfTopic(this.subject.code, function (result) {
        if (result.success) {
          result.data.forEach(function (topic) {
            context.topics.push(topic);
            // console.log(topic)
          });
        }
      });
    },
    loadTopicsV2: function loadTopicsV2() {
      var context = this;
      context.topics = [];
      __WEBPACK_IMPORTED_MODULE_3__services_itembank_js__["a" /* default */].getListOfTopicV2(this.subject.code, function (result) {
        if (result.success) {
          result.data.forEach(function (topic) {
            context.topics.push(topic);
            // console.log(topic)
          });
        }
      });
    }
  },
  watch: {
    'subject': function subject(val) {
      // this.loadTopics()
      this.sourceType = null;
      this.questionType = null;
    },
    'details': function details(val) {
      this.$emit('updated', this.details);
    },
    'sourceType': function sourceType(to, from) {

      if (to === 'INTERNAL') this.loadTopicsV2();
      if (to === 'EXTERNAL') this.loadTopics();
    }
  },
  mounted: function mounted() {
    this.loadTopics();
    if (this.$store.getters.selectedSubtest) {

      var context = this;
      this.$store.getters.selectedSubtest.details.forEach(function (detail) {
        context.details.push(detail);
      });

      this.details.sort(function (a, b) {
        return a.sequence - b.sequence;
      });

      this.lastSequence = this.details.length;
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app-choosemapel',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      selectedMapel: null,
      isLoading: false,
      showMapelModal: false,
      mapels: []
    };
  },
  methods: {
    showMapels: function showMapels() {
      var context = this;
      context.isLoading = true;
      __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__["a" /* default */].getListMataPelajaran(function (result) {
        if (result.success) {
          context.mapels = result.data;
          context.showMapelModal = true;
        }

        context.isLoading = false;
      });
    },
    selectMapel: function selectMapel(index) {
      this.selectedMapel = this.mapels[index];
      this.showMapelModal = false;
      this.$emit('selected', this.selectedMapel);
    }
  },
  mounted: function mounted() {
    if (this.$store.getters.selectedSubtest) {
      var mapel = {
        nama: this.$store.getters.selectedSubtest.subject_name,
        kode: this.$store.getters.selectedSubtest.subject_code,
        picture: this.$store.getters.selectedSubtest.subject_picture
      };

      this.selectedMapel = mapel;
    }
  }
});

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_TryoutForm__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_TryoutForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tryout_TryoutForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_SubtestForm__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_SubtestForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tryout_SubtestForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tryout_SubtestList__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tryout_SubtestList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_tryout_SubtestList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tryout_Review__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_tryout_Review___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_tryout_Review__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_tryout_models_TryoutSample_js__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_tryout_js__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout-wizard',
  components: {
    'app-tryoutform': __WEBPACK_IMPORTED_MODULE_0__components_tryout_TryoutForm___default.a,
    'app-subtestform': __WEBPACK_IMPORTED_MODULE_1__components_tryout_SubtestForm___default.a,
    'app-subtestlist': __WEBPACK_IMPORTED_MODULE_2__components_tryout_SubtestList___default.a,
    'app-tryoutreview': __WEBPACK_IMPORTED_MODULE_3__components_tryout_Review___default.a
  },
  data: function data() {
    return {
      step: 1,
      stepName: ['Membuat Tryout', 'Membuat Subtest', 'Review Tryout']
    };
  },
  methods: {
    goToNextStep: function goToNextStep() {
      this.step++;
    }
  }
});

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout-nav'
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout-review',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false
    };
  },
  computed: {
    isDraft: function isDraft() {
      return this.$store.state.tryout.status == 'DRAFT';
    },
    isReviewed: function isReviewed() {
      return this.$store.state.tryout.status == 'REVIEW';
    }
  },
  methods: {
    confirmReview: function confirmReview() {
      var confirmed = confirm("Apakah anda yakin untuk mengubah status Tryout ini menjadi 'REVIEW' ?");
      if (confirmed) {
        this.isLoading = true;
        var context = this;
        var id = this.$store.state.tryout.id;
        __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].reviewTryout(id, function (result) {
          context.isLoading = false;
          if (result.success) {
            context.$store.commit('tryout_init', result.data);
          }
        });
      }
    },
    confirmPublish: function confirmPublish() {
      var confirmed = confirm("Apakah anda yakin untuk mengubah status Tryout ini menjadi 'PUBLISH' ?");
      if (confirmed) {
        this.isLoading = true;
        var context = this;
        var id = this.$store.state.tryout.id;
        __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].publishTryout(id, function (result) {
          context.isLoading = false;
          if (result.success) {
            context.$store.commit('tryout_init', result.data);
          }
        });
      }
    },
    confirmDraft: function confirmDraft() {
      var confirmed = confirm("Apakah anda yakin untuk mengubah status Tryout ini menjadi 'DRAFT' ?");
      if (confirmed) {
        this.isLoading = true;
        var context = this;
        var id = this.$store.state.tryout.id;
        __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].draftTryout(id, function (result) {
          context.isLoading = false;
          if (result.success) {
            context.$store.commit('tryout_init', result.data);
          }
        });
      }
    }

  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_file_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_marked___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_marked__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_ItemChooser__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_ItemChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_plugins_ItemChooser__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'revisi-tryout',
  components: {
    'app-itemchooser': __WEBPACK_IMPORTED_MODULE_5__components_plugins_ItemChooser___default.a
  },
  data: function data() {
    return {
      subtests: [],
      subjectData: null,
      subjectPicture: null,
      items: [],
      subtestCode: '',
      bundleFileData: null,
      keyFileData: null,
      tryout: null,
      showItemChooser: false,
      topics: null
    };
  },
  methods: {
    initData: function initData() {
      var context = this;
      var code = this.$store.state.tryout.code;
      var category = this.$store.state.tryout.category;
      var bundleFileName = code + '_01001_' + category + '.json';
      var keyFileName = 'KEY_' + bundleFileName;

      var bundleFilePath = 'bundles/' + code + '/' + bundleFileName;
      var keyFilePath = 'bundles/' + code + '/keys/' + keyFileName;

      __WEBPACK_IMPORTED_MODULE_1__services_file_js__["a" /* default */].download(bundleFilePath, function (response) {
        if (response.success) {
          context.subtests = response.data.subtests;
          context.bundleFileData = response.data;
        }
      });

      __WEBPACK_IMPORTED_MODULE_1__services_file_js__["a" /* default */].download(keyFilePath, function (response) {
        if (response.success) context.keyFileData = response.data;
      });
    },
    updateItem: function updateItem(index, newItem) {
      var context = this;
      var itemId = newItem.id;
      __WEBPACK_IMPORTED_MODULE_4__services_itembank_js__["a" /* default */].getItemById(itemId, function (response) {
        if (response.success) {
          try {
            var soal = __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.isi, { sanitize: false });
            var wacana = response.data.wacana != null ? __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.wacana.isi, { sanitize: false }) : null;
            var pilihan1 = response.data.pilihan_1 != null ? __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.pilihan_1, { sanitize: false }) : null;
            var pilihan2 = response.data.pilihan_2 != null ? __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.pilihan_2, { sanitize: false }) : null;
            var pilihan3 = response.data.pilihan_3 != null ? __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.pilihan_3, { sanitize: false }) : null;
            var pilihan4 = response.data.pilihan_4 != null ? __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.pilihan_4, { sanitize: false }) : null;
            var pilihan5 = response.data.pilihan_5 != null ? __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.pilihan_5, { sanitize: false }) : null;

            var itemCode = context.$store.state.tryout.code + '_' + response.data.kode;
            var itemData = {
              isAnchor: true,
              item_code: itemCode,
              sequence: index + 1,
              soal: soal,
              wacana: wacana,
              pilihan: [{ key: 'A', value: pilihan1 }, { key: 'B', value: pilihan2 }, { key: 'C', value: pilihan3 }, { key: 'D', value: pilihan4 }, { key: 'E', value: pilihan5 }]
            };

            var oldItem = context.items[index];
            context.items[index] = itemData;

            var explanation = response.data.pembahasan != null ? __WEBPACK_IMPORTED_MODULE_3_marked___default()(response.data.pembahasan, { sanitize: false }) : null;
            var keyData = {
              eigen_score: response.data.nilai_eigen,
              explanation: explanation,
              item_code: itemCode,
              key: response.data.jawaban,
              weight_score: 1
            };

            var keyIndex = context.keyFileData.findIndex(function (key) {
              return key.item_code === oldItem.item_code;
            });

            context.keyFileData[keyIndex] = keyData;
            context.$forceUpdate();
            window.alert('Soal No. ' + (index + 1) + ' : ' + oldItem.item_code + ' berhasil diganti dengan: ' + itemData.item_code);
          } catch (e) {
            console.log(e);
          }
        }
      });
    },
    save: function save() {
      var confirmed = window.confirm("Apakah anda yakin untuk menyimpan perubahan ini?");
      if (confirmed) {
        var context = this;
        var index = this.bundleFileData.subtests.findIndex(function (subtest) {
          return subtest.subtest_code == context.subtestCode;
        });

        this.bundleFileData.subtests[index].items = this.items;

        var file = new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.bundleFileData)], { type: 'application/octet-stream' });
        var code = this.$store.state.tryout.code;
        var category = this.$store.state.tryout.category;
        var path = code + '/' + code + '_01001_' + category + '.json';
        __WEBPACK_IMPORTED_MODULE_1__services_file_js__["a" /* default */].adminBundleUpload(file, path, function (response) {
          console.log(response);
          if (response.success) window.alert("Data berhasil di simpan!");
        });

        var keyFile = new Blob([__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.keyFileData)], { type: 'application/octet-stream' });
        var keyPath = code + '/keys/KEY_' + code + '_01001_' + category + '.json';
        __WEBPACK_IMPORTED_MODULE_1__services_file_js__["a" /* default */].adminBundleUpload(keyFile, keyPath, function (response) {
          console.log(response);
        });
      }
    },
    loadTopicData: function loadTopicData(newVal) {
      var context = this;
      var selectedSubtest = context.bundleFileData.subtests.filter(function (subtest) {
        return subtest.subtest_code == newVal;
      })[0];
      __WEBPACK_IMPORTED_MODULE_4__services_itembank_js__["a" /* default */].getListOfTopic(selectedSubtest.subtest_code.split('_')[1], function (result) {
        context.topics = [];
        if (result.success) {
          result.data.forEach(function (topic) {
            context.topics.push(topic);
          });
        }

        context.subjectData = {
          name: selectedSubtest.subject_name,
          code: selectedSubtest.subtest_code.split('_')[1],
          picture: selectedSubtest.subject_picture
        };
        context.items = selectedSubtest.items;
        context.subjectPicture = selectedSubtest.subject_picture;
      });
    }
  },
  watch: {
    subtestCode: function subtestCode(newVal, oldVal) {
      this.loadTopicData(newVal);
    }
  },
  mounted: function mounted() {
    var context = this;
    var tryoutId = this.$route.query.id;
    __WEBPACK_IMPORTED_MODULE_2__services_tryout_js__["a" /* default */].getTryoutById(tryoutId, function (response) {
      if (response.success) {
        context.$store.commit('tryout_init', response.data);
        context.initData();
      }
    });
  }
});

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_ChooseMapel__ = __webpack_require__(1249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_ChooseMapel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tryout_ChooseMapel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_AssembleSubTest__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_AssembleSubTest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tryout_AssembleSubTest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_tryout_models_Subtest_js__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: "subtest-form",
  components: {
    "app-choosemapel": __WEBPACK_IMPORTED_MODULE_0__components_tryout_ChooseMapel___default.a,
    "app-assemblesubtest": __WEBPACK_IMPORTED_MODULE_1__components_tryout_AssembleSubTest___default.a,
    "app-spinner": __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      subtest: {
        id: 0,
        tryout_id: 0,
        subject_code: '',
        subject_name: '',
        subject_picture: '',
        duration: 35,
        item_count: 0,
        details: []
      },
      subject: null,
      isLoading: false
    };
  },
  methods: {
    mapelSelected: function mapelSelected(data) {
      this.subject = data;
      this.subtest.subject_code = this.subject.code;
      this.subtest.subject_name = this.subject.nama;
      this.subtest.subject_picture = this.subject.picture;
    },
    detailsUpdated: function detailsUpdated(data) {
      this.subtest.tryout_id = this.$store.state.tryout.id;
      this.subtest.details = data;
      this.subtest.item_count = data.length;
    },
    save: function save() {
      this.isLoading = true;
      var context = this;

      if (this.subtest.id != 0) {
        __WEBPACK_IMPORTED_MODULE_3__services_tryout_js__["a" /* default */].updateSubtest(this.subtest, function (result) {
          context.isLoading = false;
          if (result.success) {
            context.$store.commit('tryout_edit_subtest', result.data);
            context.$emit('completed');
          }
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_3__services_tryout_js__["a" /* default */].saveSubtest(this.subtest, function (result) {
          context.isLoading = false;
          if (result.success) {
            context.$store.commit("tryout_add_subtest", result.data);
            context.$emit('completed');
          }
        });
      }
    }
  },
  mounted: function mounted() {
    if (this.$store.getters.selectedSubtest) {
      this.subtest = this.$store.getters.selectedSubtest;
      this.subject = {
        nama: this.subtest.subject_name,
        code: this.subtest.subject_code,
        picture: this.subtest.subject_picture
      };
    }
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_SubtestForm__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_SubtestForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tryout_SubtestForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "subtest-list",
  components: {
    'app-subtestform': __WEBPACK_IMPORTED_MODULE_0__components_tryout_SubtestForm___default.a
  },
  data: function data() {
    return {
      showForm: false,
      selectedSubtest: null
    };
  },
  methods: {
    editSubtest: function editSubtest(index) {
      this.$store.commit('tryout_select_subtest', index);
      this.showForm = true;
    },
    createSubtest: function createSubtest() {
      this.$store.commit('tryout_reset_selected_subtest');
      this.showForm = true;
    }
  }
});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tryout',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_2__components_plugins_DataTable___default.a,
		'app-modal': __WEBPACK_IMPORTED_MODULE_4__components_plugins_Modal___default.a
	},
	data: function data() {
		return {
			tryouts: [],
			selectedRow: null,
			search: null,
			exportModal: false,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			headers: ['Code', 'Nama', 'Jenis', 'Jenjang', 'Tipe', 'Kategori', 'Subtests', 'Jml. Soal', 'Durasi (Menit)', 'Status', 'Created At', 'Action'],
			headersKey: ['code', 'name', 'isRepeated', 'level', 'type', 'category', 'subtests', 'itemCount', 'duration', 'status', 'createdAt'] // camel case for matching search with API
		};
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	mounted: function mounted() {
		this.fetchData();
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			};

			__WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].getListTryout(pagination, search, function (result) {
				context.tryouts = [];

				if (result.success) {

					result.data.forEach(function (tryout) {
						var subtests = [];
						var count = 0;
						tryout.subtests.forEach(function (subtest) {
							subtests.push(subtest.subject_name);
							count += subtest.item_count;
						});

						var createdAt = __WEBPACK_IMPORTED_MODULE_3_moment___default()(tryout.created_at).format('YYYY-MM-DD');
						var jenis = tryout.is_repeated ? "INSTANT" : "BERAGENDA";
						var row = {
							id: tryout.id,
							data: [tryout.code, tryout.name, jenis, tryout.level, tryout.type, tryout.category, subtests.join(', '), count, tryout.duration, tryout.status, createdAt],
							actions: [{ text: 'Export', command: 'export', style: 'btn-danger' }]
						};

						if (tryout.status == 'REVIEW') {
							row.actions.push({ text: 'Generate TO', command: 'generateTO', style: 'btn-primary' });
							row.actions.push({ text: 'Revisi', command: 'revisiTO', style: 'btn-success' });
						}

						context.pagination.totalPages = tryout.page;
						context.tryouts.push(row);
					});
				}
			});
		},
		editTryout: function editTryout() {
			var tryoutId = this.selectedRow.id;
			var context = this;
			__WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].getTryoutById(tryoutId, function (result) {
				if (result.success) {
					context.$store.commit('tryout_init', result.data);
					context.$router.push({ path: 'tryout-form', query: { id: context.selectedRow.id } });
				}
			});
		},
		createTryout: function createTryout() {
			this.$store.commit('tryout_reset');
			this.$router.push({ path: '/tryout-form' });
		},
		importTryout: function importTryout() {
			this.$router.push({ path: '/tryout-import' });
		},
		exportTryout: function exportTryout(event) {
			var tryoutId = event.id;
			__WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].getTryoutById(tryoutId, function (result) {
				if (result.success) {
					delete result.data.id;
					delete result.data.code;
					delete result.data.group_id;
					delete result.data.created_at;
					delete result.data.updated_at;
					delete result.data.page;
					delete result.data.state;
					delete result.data.bundle_code;
					delete result.data.started_at;
					delete result.data.ended_at;
					delete result.data.completed_at;
					delete result.data.completion_time;
					delete result.data.correct;
					delete result.data.wrong;
					delete result.data.empty;
					delete result.data.member_count;
					delete result.data.display_name;

					var subt = result.data.subtests;
					if (subt.length > 0) {
						for (var i = 0; i < subt.length; i++) {
							delete subt[i].id;
							delete subt[i].created_at;
							delete subt[i].updated_at;
							delete subt[i].subtest_code;
							if (subt[i].details.length > 0) {
								var det = subt[i].details;
								for (var b = 0; b < det.length; b++) {
									delete det[b].id;
									delete det[b].created_at;
									delete det[b].updated_at;
								}
							}
						}
					}
					result.data.status = "DRAFT";
					var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()([result.data]);
					var blob = new Blob([data]);
					var link = document.createElement('a');
					link.href = window.URL.createObjectURL(blob);
					link.download = 'tryout_export_' + new Date().getTime() + '.json';
					link.click();
				}
			});
		},
		generateTryout: function generateTryout(event) {
			__WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].generateTryout(event.id, function (result) {
				if (result.success) {
					alert('Generate tryout berhasil');
				} else if (result.message === 'Request failed with status code 404') {
					alert('Generate tryout gagal, data tidak ditemukan');
				} else if (result.message === 'Request failed with status code 406') {
					alert('Generate tryout gagal, set tryout telah mencapai batas maksimal (99)');
				}
			});
		},
		revisiTryout: function revisiTryout(event) {
			this.$router.push({ path: 'tryout-revisi', query: { id: event.id } });
		}
	}
});

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
	name: 'tryout',
	components: {
		'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
		'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
	},
	data: function data() {
		return {
			tryouts: [],
			selectedRow: null,
			search: null,
			exportModal: false,
			pagination: {
				perPage: 25,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc'
			},
			headers: ['Nama', 'Jenis', 'Jenjang', 'Tipe', 'Subtests'],
			headersKey: ['name', 'isRepeated', 'level', 'type', 'subtests'] // camel case for matching search with API
		};
	},
	watch: {
		pagination: function pagination() {
			this.fetchData();
		}
	},
	mounted: function mounted() {
		this.$store.commit('tryoutSelected', []);
		this.fetchData();
	},
	methods: {
		fetchData: function fetchData() {
			var context = this;
			var search = this.search;
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			};

			__WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getListTryout(pagination, search, function (result) {
				context.tryouts = [];

				if (result.success) {

					result.data.forEach(function (tryout) {
						var subtests = [];
						var count = 0;
						tryout.subtests.forEach(function (subtest) {
							subtests.push(subtest.subject_name);
							count += subtest.item_count;
						});

						var createdAt = __WEBPACK_IMPORTED_MODULE_2_moment___default()(tryout.created_at).format('YYYY-MM-DD');
						var jenis = tryout.is_repeated ? "INSTANT" : "BERAGENDA";
						var row = {
							id: tryout.id,
							data: [
							// tryout.code,
							tryout.name, jenis, tryout.level, tryout.type, subtests.join(', ')]
						};

						context.pagination.totalPages = tryout.page;
						context.tryouts.push(row);
					});
				}
			});
		},
		submitExport: function submitExport() {
			if (this.$store.state.tryout.selectedTO.length < 1) {
				alert('tidak ada tryout yang dipilih');
			} else {
				__WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].exportTryout({ "ids": this.$store.state.tryout.selectedTO }, function (result) {});
			}
		},

		createTryout: function createTryout() {
			this.$store.commit('tryout_reset');
			this.$router.push({ path: '/tryout-form' });
		},
		importTryout: function importTryout() {
			this.$router.push({ path: '/tryout-import' });
		},
		exportTryout: function exportTryout() {
			this.$router.push({ path: '/tryout-export' });
		}
	}
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_models_Tryout_js__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "tryout-form",
  components: {
    "app-spinner": __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      errors: [],
      tryout: { id: 0, is_repeated: false, is_free_access: false, category: 'OTHER' },
      selectLevel: null,
      gradeList: [],
      tryout_grade: null
    };
  },
  methods: {
    submit: function submit() {
      var context = this;

      if (this.validateForm()) {
        context.isLoading = true;
        if (context.tryout.is_repeated) context.tryout.description += ' || ' + context.tryout_grade;
        if (this.tryout.id == 0) {
          __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].saveTryout(this.tryout, function (result) {
            context.isLoading = false;
            if (result.success) {
              context.storeTryoutAndCompleteTransaction(result.data);
            }
          });
        } else {
          __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].updateTryout(this.tryout, function (result) {
            context.isLoading = false;
            if (result.success) {
              context.storeTryoutAndCompleteTransaction(result.data);
            }
          });
        }
      } else {
        $(window).scrollTop(0);
      }
    },
    storeTryoutAndCompleteTransaction: function storeTryoutAndCompleteTransaction(data) {
      this.$store.commit('tryout_init', data);
      this.$emit('completed');
    },
    validateForm: function validateForm() {
      this.errors = [];

      var startTimeFull = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tryout.start_date + " " + this.tryout.start_time).format();
      var endTimeFull = __WEBPACK_IMPORTED_MODULE_3_moment___default()(this.tryout.end_date + " " + this.tryout.end_time).format();

      if (this.tryout.is_repeated && this.tryout_grade === null) this.errors.push('Tryout Instan wajib mengisi kelas');

      /**
       * di takeout atas request pak gatra bisa bikin tryout dengan tanggal yang sudah lewat
       * biar bisa langsung muncul TO nya. (Biasanya untuk TO coba-coba)
       *
       * if (moment(startTimeFull).isBefore(moment().format())) {
       *     this.errors.push('tanggal dan waktu mulai sudah lewat')
       * } else {
       *   if (!moment(endTimeFull).isAfter(startTimeFull)) {
       *     this.errors.push('tanggal dan waktu mulai harus melebihi tanggal dan waktu berakhir')
       *   }
       * }
       */

      if (!__WEBPACK_IMPORTED_MODULE_3_moment___default()(endTimeFull).isAfter(startTimeFull)) {
        this.errors.push('tanggal dan waktu mulai harus melebihi tanggal dan waktu berakhir');
      }

      return this.errors.length == 0;
    },
    selectingLevel: function selectingLevel() {
      if (this.tryout.level === 'SD') this.gradeList = [4, 5, 6];
      if (this.tryout.level === 'SMP') this.gradeList = [7, 8, 9];
      if (this.tryout.level === 'SMA') this.gradeList = [10, 11, 12];
      var des = this.tryout.description;
      var res = des.split("||");
      this.tryout_grade = parseInt(res[1]);
      this.tryout.description = res[0];
    }
  },
  mounted: function mounted() {
    if (this.$store.state.tryout.id > 0) this.tryout = this.$store.state.tryout;
    var context = this;
    DatepickerPlugin.init("#startDate", function (value) {
      context.tryout.start_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    DatepickerPlugin.init("#endDate", function (value) {
      context.tryout.end_date = __WEBPACK_IMPORTED_MODULE_3_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    ClockpickerPlugin.init("#startTime", function (value) {
      context.tryout.start_time = value + ":00";
    });

    ClockpickerPlugin.init("#endTime", function (value) {
      context.tryout.end_time = value + ":00";
    });
    this.selectingLevel();
  },
  watch: {
    'tryout.type': function tryoutType(val) {
      // if (val != 'SBMPTN') this.tryout.category = 'OTHER'
    }
  }
});

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_4__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      tryouts: [],
      selectedRow: null,
      search: null,
      exportModal: false,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc'
      },
      headers: ['Nama', 'Jenis', 'Jenjang', 'Tipe', 'Subtests'],
      headersKey: ['name', 'isRepeated', 'level', 'type', 'subtests'], // camel case for matching search with API

      isReadable: true,
      errorParse: false,
      previewJSONData: [],
      importFile: null
    };
  },
  watch: {
    pagination: function pagination() {
      // this.fetchData()
    }
  },
  mounted: function mounted() {
    // this.fetchData()
  },
  methods: {
    fetchData: function fetchData(data) {
      // try {
      var item = data;
      console.log(data);
      var context = this;
      context.tryouts = [];
      item.forEach(function (tryout) {
        var subtests = [];
        var count = 0;
        tryout.subtests.forEach(function (subtest) {
          subtests.push(subtest.subject_name);
          count += subtest.item_count;
        });

        var jenis = tryout.is_repeated ? "INSTANT" : "BERAGENDA";
        var row = {
          id: null,
          data: [tryout.name, jenis, tryout.level, tryout.type, subtests.join(', ')]
        };
        context.tryouts.push(row);
      });
      // } catch (e) {
      //   alert('Preview data tidak bisa dilakukan, mohon periksa kembali data kamu')
      // }
    },
    submitImport: function submitImport() {
      this.isLoading = true;
      var context = this;
      var formData = new FormData();
      formData.append('file', context.importFile);
      __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].importTryout(formData, function (result) {
        context.isLoading = false;
        if (result.success) {
          alert('Berhasil diupload');
          context.$router.push('/tryouts');
        } else {
          alert('Gagal Upload');
        }
      });
    },

    previewJSON: function previewJSON() {
      this.fetchData(this.previewJSONData);
    },
    onFileChange: function onFileChange(e) {
      var files = this.$refs.file.files;
      if (!files.length) return;
      this.importFile = files[0];
      this.readFile(files[0]);
    },
    readFile: function readFile(file) {
      var _this = this;

      var reader = new FileReader();
      reader.onload = function (e) {
        try {
          _this.previewJSONData = JSON.parse(e.target.result);
          _this.isReadable = false;
          _this.errorParse = false;
          _this.tryouts = [];
        } catch (e) {
          _this.isReadable = true;
          _this.errorParse = true;
          _this.tryouts = [];
        }
      };
      reader.readAsText(file);
    },

    createTryout: function createTryout() {
      this.$store.commit('tryout_reset');
      this.$router.push({ path: '/tryout-form' });
    },
    importTryout: function importTryout() {
      this.$router.push({ path: '/tryout-import' });
    },
    exportTryout: function exportTryout() {
      this.$router.push({ path: '/tryout-export' });
    },
    cancelImport: function cancelImport() {
      this.tryouts = [];
      this.isReadable = true;
      this.importFile = null;
      var input = this.$refs.file;
      input.type = 'text';
      input.type = 'file';
    }
  }
});

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryoutgroup-form',
  components: {
    'app-tryoutchooser': __WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser___default.a,
    'app-tryoutgroupchooser': __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      discussionDate: null,
      discussionTime: null,
      discussionSpecialDate: null,
      discussionSpecialTime: null,
      openedAt: null,
      openedAtTime: null,
      closedAt: null,
      closedAtTime: null,
      isLoading: false,
      showModal: false,
      dependencyName: '',
      listTryoutSource: [],
      errors: []
    };
  },
  computed: {
    isPublished: function isPublished() {
      return this.$store.state.tryoutgroup.status == 'PUBLISHED';
    },
    groupId: function groupId() {
      return this.$store.state.tryoutgroup.id;
    },
    name: {
      get: function get() {
        return this.$store.state.tryoutgroup.name;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_name', value);
      }
    },
    description: {
      get: function get() {
        return this.$store.state.tryoutgroup.description;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_description', value);
      }
    },
    type: {
      get: function get() {
        return this.$store.state.tryoutgroup.type;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_type', value);
      }
    },
    variant: {
      get: function get() {
        return this.$store.state.tryoutgroup.variant;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_variant', value);
      }
    },
    source_id: {
      get: function get() {
        return this.$store.state.tryoutgroup.source_id;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_source_id', value);
      }
    },
    grade: {
      get: function get() {
        return this.$store.state.tryoutgroup.grade;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_grade', value);
      }
    },
    joinCode: {
      get: function get() {
        return this.$store.state.tryoutgroup.joinCode;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_join_code', value);
      }
    },
    isPrivate: {
      get: function get() {
        return this.$store.state.tryoutgroup.isPrivate;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_is_private', value);
      }
    },
    isSticky: {
      get: function get() {
        return this.$store.state.tryoutgroup.isSticky;
      },
      set: function set(value) {
        this.$store.commit('tryout_group_set_is_sticky', value);
      }
    },
    tryouts: function tryouts() {
      return this.$store.state.tryoutgroup.tryouts;
    }
    // openedAt: {
    //   get: function () {
    //     var time = this.$store.getters.openedAt
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     console.log(value)
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   }
    // },
    // openedAtTime: {
    //   get: function () {
    //     var time = this.$store.getters.openedAt
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     console.log(value)
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   }
    // },
    // closedAt: {
    //   get: function () {
    //     var time = this.$store.getters.closedAt
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     return time > 0 ? Moment(time).format('DD/MM/YYYY') : '-'
    //   }
    // },
    // closedAtTime: {
    //   get: function () {
    //     var time = this.$store.getters.closedAt
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   },
    //   set: function (value) {
    //     var time = value
    //     return time > 0 ? Moment(time).format('HH:mm') : '-'
    //   }
    // }
  },
  methods: {
    addTryoutIntoGroup: function addTryoutIntoGroup(tryout) {
      this.isLoading = true;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].addTryoutIntoGroup(tryout.id, this.groupId, function (result) {
        if (result.success) {
          context.$store.commit('tryout_group_add_tryout', result.data);
        }

        context.isLoading = false;
      });
    },
    removeTryoutFromGroup: function removeTryoutFromGroup(tryout) {
      var context = this;
      var confirmed = window.confirm("Apakah anda yakin akan melepas tryout ini?");

      if (confirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].removeTryoutFromGroup(tryout.id, this.groupId, function (result) {
          if (result.success) {
            context.$store.commit('tryout_group_remove_tryout', result.data);
          }

          context.isLoading = false;
        });
      }
    },
    saveTryoutGroup: function saveTryoutGroup() {
      if (!this.validateForm()) {
        return;
      }

      this.isLoading = true;
      var context = this;
      var timestamp = this.discussionDate + " " + this.discussionTime;
      var discussionOpenedAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestamp, "DD/MM/YYYY HH:mm").valueOf();

      var timestampSpecial = this.discussionSpecialDate + " " + this.discussionSpecialTime;
      var discussionSpecialAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampSpecial, "DD/MM/YYYY HH:mm").valueOf();

      var timestampOpened = this.openedAt + " " + this.openedAtTime;
      var customedOpenedAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampOpened, "DD/MM/YYYY HH:mm").valueOf();

      var timestampClosed = this.closedAt + " " + this.closedAtTime;
      var customedClosedAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampClosed, "DD/MM/YYYY HH:mm").valueOf();

      var tryoutGroup = {
        name: this.$store.state.tryoutgroup.name,
        description: this.$store.state.tryoutgroup.description,
        type: this.$store.state.tryoutgroup.type,
        variant: this.$store.state.tryoutgroup.variant,
        discussion_opened_at: discussionOpenedAt,
        discussion_special_at: discussionSpecialAt,
        grades: this.$store.state.tryoutgroup.grade,
        join_code: this.$store.state.tryoutgroup.joinCode,
        is_sticky: this.$store.state.tryoutgroup.isSticky,
        is_private: this.$store.state.tryoutgroup.isPrivate,
        dependency_id: this.$store.state.tryoutgroup.dependency_id,
        source_id: this.$store.state.tryoutgroup.source_id,
        opened_at: customedOpenedAt,
        closed_at: customedClosedAt
      };

      var groupId = this.$store.state.tryoutgroup.id;
      if (groupId) {
        __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].editTryoutGroup(groupId, tryoutGroup, function (result) {
          context.isLoading = false;
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].createTryoutGroup(tryoutGroup, function (result) {
          if (result.success) {
            window.alert("Tryout Group berhasil dibuat :)");
            context.$store.commit('tryout_group_set_id', result.data.id);
          }
          context.isLoading = false;
        });
      }
    },
    publishTryoutGroup: function publishTryoutGroup() {
      /**
       * di takeout karena ada request dari pak gatra biar bisa edit dan publish tryout
       * dadakan walaupun masa tryout sudah dimulai (untuk tryout coba-coba)
       *
      if (this.checkIfTryoutGroupIsOnGoing()) {
        window.alert('Tidak dapat mem-publish tryout group yang sudah lewat waktu mulainya')
        return
      }
      **/

      // if (this.checkIfTryoutGroupIsExpired()) {
      //   window.alert('Tidak dapat mem-publish tryout group yang sudah lewat waktu berakhirnya')
      //   return
      // }

      var tryoutCount = this.$store.state.tryoutgroup.tryouts.length;
      if (tryoutCount == 0) {
        window.alert("Tidak dapat publish tryout group kosong");
        return;
      }

      var confirmed = window.confirm("Apakah anda yakin akan PUBLISH group ini?");
      if (confirmed) {
        this.isLoading = true;
        var context = this;
        __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].publishTryoutGroup(this.groupId, function (result) {
          if (result.success) {
            context.$store.commit('tryout_group_set_status', result.data.status);
          }

          context.isLoading = false;
        });
      }
    },
    unPublishTryoutGroup: function unPublishTryoutGroup() {
      // if (this.checkIfTryoutGroupIsOnGoing()) {
      //   window.alert('Tidak dapat mengubah status group tryout yang sedang berlangsung')
      //   return
      // }

      var confirmed = window.confirm('Apakah anda yakin akan mengembalikan group ini ke DRAFT?');
      if (confirmed) {
        this.isLoading = true;
        var context = this;
        __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].unPublishTryoutGroup(this.groupId, function (result) {
          if (result.success) {
            context.$store.commit('tryout_group_set_status', result.data.status);
          }

          context.isLoading = false;
        });
      }
    },
    checkIfTryoutGroupIsOnGoing: function checkIfTryoutGroupIsOnGoing() {
      if (this.variant !== 'SCHEDULED') return false;

      var startTime = this.$store.getters.openedAt;
      var endTime = this.$store.getters.closedAt;
      var nowTime = new Date().valueOf();

      return nowTime > startTime && nowTime < endTime;
    },
    checkIfTryoutGroupIsExpired: function checkIfTryoutGroupIsExpired() {
      if (this.variant !== 'SCHEDULED') return false;

      var endTime = this.$store.getters.closedAt;
      var nowTime = new Date().valueOf();

      return nowTime > endTime;
    },
    validateForm: function validateForm() {
      this.errors = [];
      if (this.name == '') this.errors.push('Nama wajib diisi');
      if (this.description == '') this.errors.push('Deskripsi wajib diisi');
      if (this.discussionDate == null) this.errors.push('Tanggal pembahasan untuk umum wajib diisi');
      if (this.discussionTime == null) this.errors.push('Waktu pembahasan untuk umum wajib diisi');
      if (this.discussionSpecialDate == null) this.errors.push('Tanggal pembahasan untuk siswa NF wajib diisi');
      if (this.discussionSpecialTime == null) this.errors.push('Waktu pembahasan untuk siswa NF wajib diisi');

      return this.errors.length == 0;
    },
    addDependency: function addDependency(group) {
      this.dependencyName = group.data[0];
      this.$store.commit('tryout_group_set_dependency_id', group.id);
    },
    removeDependency: function removeDependency() {
      this.showModal = false;
      this.dependencyName = '';
      this.$store.commit('tryout_group_set_dependency_id', null);
    },
    getTryoutListSource: function getTryoutListSource() {
      var context = this;
      __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].listTryoutSource(function (result) {
        if (result.success) {
          // context.$store.commit('tryout_group_set_status', result.data.status)
          // console.log(result)
          context.listTryoutSource = result.data;
        }

        context.isLoading = false;
      });
      // console.log(context.$route)
      __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].getTryoutGroup(context.$route.query.id, function (result) {
        if (result.success) {
          var tryoutGroup = result.data;
          context.$store.commit('tryout_group_init', tryoutGroup);
          // context.$router.push({ path: '/tryout-group/form', query: { id: groupId } })
        }
      });
    }
  },
  mounted: function mounted() {
    var context = this;
    this.getTryoutListSource();
    DatepickerPlugin.init("#discussionDate", function (value) {
      context.discussionDate = value;
    });

    ClockpickerPlugin.init("#discussionTime", function (value) {
      context.discussionTime = value;
    });

    DatepickerPlugin.init("#discussionSpecialDate", function (value) {
      context.discussionSpecialDate = value;
    });

    ClockpickerPlugin.init("#discussionSpecialTime", function (value) {
      context.discussionSpecialTime = value;
    });

    DatepickerPlugin.init("#openedAtDate", function (value) {
      context.openedAt = value;
    });

    ClockpickerPlugin.init("#openedAtTime", function (value) {
      context.openedAtTime = value;
    });

    DatepickerPlugin.init("#closedAtDate", function (value) {
      context.closedAt = value;
    });

    ClockpickerPlugin.init("#closedAtTime", function (value) {
      context.closedAtTime = value;
    });

    if (this.$route.query.id) {
      // console.log(this.$store.state.tryoutgroup)
      var timestampMilis = this.$store.state.tryoutgroup.discussion_opened_at;
      this.discussionDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilis).format('DD/MM/YYYY');
      this.discussionTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilis).format('HH:mm');

      var timestampMilisSpecial = this.$store.state.tryoutgroup.discussion_special_at;
      this.discussionSpecialDate = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilisSpecial).format('DD/MM/YYYY');
      this.discussionSpecialTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilisSpecial).format('HH:mm');

      var timestampMilisOpenedAt = this.$store.state.tryoutgroup.opened_at;
      this.openedAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilisOpenedAt).format('DD/MM/YYYY');
      this.openedAtTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilisOpenedAt).format('HH:mm');

      var timestampMilisClosedAt = this.$store.state.tryoutgroup.closed_at;
      this.closedAt = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilisClosedAt).format('DD/MM/YYYY');
      this.closedAtTime = __WEBPACK_IMPORTED_MODULE_5_moment___default()(timestampMilisClosedAt).format('HH:mm');

      if (this.$store.state.tryoutgroup.dependency_id) {
        var context = this;
        var groupId = this.$store.state.tryoutgroup.dependency_id;
        __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__["a" /* default */].getTryoutGroup(groupId, function (response) {
          context.dependencyName = response.data.name;
        });
      }
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_itembank_js__ = __webpack_require__(14);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itembank-nav',
  components: {},
  data: function data() {
    return { items: [] };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout-chooser',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  props: ['isInstant'],
  data: function data() {
    return {
      isLoading: false,
      showModal: false,
      headers: ['Judul', 'Level', 'Durasi', 'Jml. Soal', 'Mata Pelajaran', 'Mulai', 'Berakhir'],
      headersKey: ['name', 'level', 'duration', 'itemCount', 'subtests', 'startDate', 'endDate'], // camel case for matching search with API
      rows: [],
      selectedRow: null,
      search: null,
      pagination: {
        perPage: 15,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc'
      }
    };
  },
  watch: {
    pagination: function pagination() {
      this.reloadDataAndOpenModal();
    }
  },
  methods: {
    tryoutSelected: function tryoutSelected(tryout) {
      this.$emit('selected', tryout);
      this.showModal = false;
    },
    newInitData: function newInitData() {
      this.search = null;
      this.pagination = {
        perPage: 15,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc'
      };
      this.reloadDataAndOpenModal();
    },
    reloadDataAndOpenModal: function reloadDataAndOpenModal() {
      this.isLoading = true;
      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode
      };
      __WEBPACK_IMPORTED_MODULE_0__services_tryout_js__["a" /* default */].getListPublishedTryout(pagination, search, function (result) {
        context.rows.splice(0, context.rows.length);
        if (result.success) {
          result.data.forEach(function (tryout) {
            if (context.isInstant && !tryout.is_repeated) return;

            if (!tryout.group_id) {
              var subjects = '';
              var jmlSoal = 0;
              tryout.subtests.forEach(function (subtest) {
                subjects += subtest.subject_name + ',';
                jmlSoal += subtest.item_count;
              });

              var start = tryout.start_date + ' ' + tryout.start_time;
              var end = tryout.end_date + ' ' + tryout.end_time;
              var row = {
                id: tryout.id,
                data: [tryout.name, tryout.level, tryout.duration, jmlSoal, subjects, start, end]
              };
              context.pagination.totalPages = tryout.page;
              context.rows.push(row);
            }
          });

          context.isLoading = false;
          context.showModal = true;
        }
      });
    }
  }
});

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout-group',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      tryoutGroups: [],
      selectedRow: null,
      isLoading: false,
      search: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        totalPages: 0,
        sortMode: 'desc'
      },
      headers: ['Nama', 'Tipe', 'Jenjang', 'Kelas', 'Status', 'Content', 'Created At', 'Join Code'],
      headersKey: ['name', 'type', 'level', 'grade', 'status', 'category', 'createdAt', 'joinCode'] // camel case for matching search with API
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },
  watch: {
    pagination: function pagination() {
      this.fetchData();
    }
  },
  methods: {
    fetchData: function fetchData() {
      var context = this;
      var search = this.search;
      var pagination = {
        perPage: this.pagination.perPage,
        currentPage: this.pagination.currentPage,
        sortMode: this.pagination.sortMode
      };

      console.log('search', search);

      __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].getListOfTryoutGroups(pagination, search, null, function (result) {
        context.tryoutGroups = [];

        if (result.success) {
          result.data.forEach(function (group) {
            var level = group.level ? group.level : '-';
            var contents = '';

            if (group.tryouts) {
              group.tryouts.forEach(function (tryout) {
                contents += tryout.category + ", ";
              });
            }

            var createdAt = __WEBPACK_IMPORTED_MODULE_3_moment___default()(group.created_at).format('YYYY-MM-DD');
            var row = {
              id: group.id,
              data: [group.name, group.type,
              // group.variant,
              level, group.grade == null ? group.grades.toString() : group.grade, group.status, contents, createdAt, group.join_code]
            };

            context.pagination.totalPages = group.page;
            context.tryoutGroups.push(row);
          });
        }
      });
    },
    createTryoutGroup: function createTryoutGroup() {
      this.$store.commit('tryout_group_reset');
      this.$router.push({ path: '/tryout-group/form' });
    },
    editTryoutGroup: function editTryoutGroup() {
      var context = this;
      var groupId = this.selectedRow.id;
      __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].getTryoutGroup(groupId, function (result) {
        if (result.success) {
          var tryoutGroup = result.data;
          context.$store.commit('tryout_group_init', tryoutGroup);
          context.$router.push({ path: '/tryout-group/form', query: { id: groupId } });
        }
      });
    },
    deleteTryoutGroup: function deleteTryoutGroup(tryout) {
      var context = this;
      var groupId = tryout.id;
      var status = tryout.data[3];

      if (status == 'PUBLISHED') {
        window.alert("Tidak dapat menghapus Tryout Group dengan status PUBLISHED");
        return;
      }

      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
      if (confirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__["a" /* default */].deleteTryoutGroup(groupId, function (result) {
          if (result.success) {
            var targetIndex = context.tryoutGroups.findIndex(function (group) {
              return group.id == groupId;
            });

            context.tryoutGroups.splice(targetIndex, 1);
            context.isLoading = false;
          }
        });
      }
    }
  }
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_tryout_js__ = __webpack_require__(15);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'tryoutgroup-chooser',
    props: ['params'],
    components: {
        'app-spinner': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a,
        'app-datatable': __WEBPACK_IMPORTED_MODULE_1__components_plugins_DataTable___default.a
    },
    data: function data() {
        return {
            isLoading: false,
            showModal: false,
            headers: ['Tryout Group', 'Tipe', 'Kelas'],
            rows: []
        };
    },
    methods: {
        openGroupModal: function openGroupModal() {
            var date = new Date();
            var timestamp = date.getTime();

            this.isLoading = true;
            this.showModal = true;

            var context = this;
            __WEBPACK_IMPORTED_MODULE_2__services_tryout_js__["a" /* default */].getListOfTryoutGroups(null, null, this.params, function (response) {
                if (response.success) {
                    context.rows = [];
                    response.data.forEach(function (data) {
                        // console.log(data)
                        var row = {
                            id: data.id,
                            data: [data.name, data.type, data.grade]
                        };
                        if (context.$route.name === 'DetailPaketMapel' && data.closed_at > timestamp) {
                            console.log(data.closed_at);
                            console.log(timestamp);
                            context.rows.push(row);
                        }
                    });
                }

                context.isLoading = false;
            }, this.grade, null).catch(function (error) {
                context.isLoading = false;
            });
        },
        onTryoutGroupChoosen: function onTryoutGroupChoosen(group) {
            this.showModal = false;
            this.$emit('dblClicked', group);
        }
    }
});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'itembank-nav',
  components: {},
  data: function data() {
    return { items: [] };
  },
  mounted: function mounted() {}
});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_usman_js__ = __webpack_require__(162);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mapel-form',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      isLoading: false,
      showModal: false,
      errors: [],
      featureList: ['SCHEDULED_TRYOUT', 'INSTANT_TRYOUT', 'ITEM_BANK', 'VIDEO'],
      file: null,
      features: []
    };
  },
  computed: {
    fitur: {
      get: function get() {
        return this.$store.state.usman.fitur;
      },
      set: function set(value) {
        this.$store.commit('usman_set_fitur', value);
      }
    },
    period: {
      get: function get() {
        return this.$store.state.usman.period;
      },
      set: function set(value) {
        this.$store.commit('usman_set_period', value);
      }
    }
  },
  methods: {
    validateForm: function validateForm() {
      this.errors = [];

      if (this.file == null) this.errors.push('File wajib diisi');

      if (this.file !== null) {
        var lastChar = this.file.name.substr(this.file.name.length - 3);
        if (lastChar !== 'csv') this.errors.push('Tipe File wajib CSV');
      }

      if (this.features.length < 1) this.errors.push('Fitur wajib diisi');
      if (this.period < 1) this.errors.push('Masa Berlaku tidak boleh kosong');
      return this.errors.length == 0;
    },
    handleFile: function handleFile() {
      this.file = this.$refs.file.files[0];
    },
    saveData: function saveData() {
      if (!this.validateForm()) {
        return;
      }
      var fit = "";
      for (var i = 0; i < this.features.length; i++) {
        fit += this.features[i] + ',';
      }
      this.isLoading = true;
      var context = this;
      var formData = new FormData();
      formData.append('file', context.file);
      formData.append('request', '{"duration":"' + context.period + '", "features":"' + fit.slice(0, -1) + '"}');
      __WEBPACK_IMPORTED_MODULE_4__services_usman_js__["a" /* default */].uploadFile(formData, function (result) {
        context.isLoading = false;
        if (result.success) {
          alert('Berhasil diupload');
          context.$router.push('/user-management');
        } else {
          alert('Gagal Upload');
        }
      });
    }
  },
  mounted: function mounted() {
    var context = this;
    context.features = [];
    context.period = 0;
    context.file = null;
  }
});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-management',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      query: '',
      isLoading: false,
      pageNumber: 1,
      users: [],
      userData: {
        name: null,
        id: null
      },
      newPassword: null,
      confirmPassword: null,
      seeNewPass: false,
      seeConfirmPass: false,
      filter: {
        grade: '',
        npsn: '',
        type: '',
        order: 'DESC',
        orderby: 'id'
      }
    };
  },
  watch: {
    pageNumber: function pageNumber(newVal) {
      this.loadUserData(newVal);
    }
  },
  methods: {
    loadUserData: function loadUserData() {
      var pageNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/usman/users';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      var objParams = '{"page": ' + pageNumber;
      if (this.query !== '') objParams += ', "query": "' + this.query + '"';
      if (this.filter.grade !== '') objParams += ', "grade": ' + parseInt(this.filter.grade);
      if (this.filter.npsn !== '') objParams += ', "npsn": "' + this.filter.npsn + '"';
      if (this.filter.type !== '') objParams += ', "school_type": "' + this.filter.type + '"';
      if (this.filter.order !== '') objParams += ', "order": "' + this.filter.order + '"';
      if (this.filter.orderby !== '') objParams += ', "order_by": "' + this.filter.orderby + '"';

      objParams += '}';
      http.get(url, {
        params: JSON.parse(objParams)
      }).then(function (response) {
        context.users = response.data;
        sessionStorage.setItem('filter', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(context.filter));
        $('#modalFilter').modal('hide');
      }).catch(function (error) {
        console.log(error.message);
        $('#modalFilter').modal('hide');
      }).then(function () {
        context.isLoading = false;
      });
    },
    goToDetail: function goToDetail(index) {
      this.$store.commit('usman_init', this.users[index]);
      sessionStorage.setItem('usman_init', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.users[index]));
      this.$router.push('user-detail');
    },
    submitChangePassword: function submitChangePassword() {
      console.log(this.userData);
      var context = this;
      if (context.newPassword === null || context.confirmPassword === null) {
        alert('password wajib diisi');
      } else if (context.newPassword !== context.confirmPassword) {
        alert('Password konfirmasi tidak valid');
      } else {
        if (confirm("Anda yakin akan mengubah password data ini?") == true) {
          var token = this.$ls.get('token');
          var url = "https://api.nfjuara.id" + '/account/usman/user/' + context.userData.user_id + '/password';

          context.isLoading = true;
          var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
            }
          });

          http.put(url, { 'password': context.confirmPassword }).then(function (response) {
            $('#modalChangepassword').modal('hide');
            alert('Password berhasil diperbaharui');
          }).catch(function (error) {
            alert('Password gagal diperbaharui');
          }).then(function () {
            context.isLoading = false;
          });
        }
      }
    },
    showFilter: function showFilter() {
      $('#modalFilter').modal('show');
    },
    applyFilter: function applyFilter() {
      this.pageNumber = 1;
      this.loadUserData();
    },
    eraseFilter: function eraseFilter(k) {
      this.filter[k] = '';
      this.applyFilter();
    },
    showChangePassword: function showChangePassword(v) {
      this.userData = v;
      $('#modalChangepassword').modal('show');
    }
  },
  mounted: function mounted() {
    if (sessionStorage.filter) this.filter = JSON.parse(sessionStorage.filter);
    this.loadUserData();
  }
});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_auth_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_usman_js__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_datepicker_index_css__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_datepicker_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_datepicker_index_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'user-detail',
  components: {
    'app-spinner': __WEBPACK_IMPORTED_MODULE_5__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_7__components_plugins_Modal___default.a,
    DatePicker: __WEBPACK_IMPORTED_MODULE_8_vue2_datepicker__["a" /* default */]
  },
  data: function data() {
    return {
      memberships: [],
      emailSIP: null,
      nomorIndukNF: null,
      isLoading: false,
      provinceList: [],
      cityList: [],
      showSuggestion: false,
      users_consul_session: 0,
      users_ticket: 0,
      schoolList: [],
      query: '',
      scopeModel: [],
      detailUser: false,
      newEmail: null,
      listEmailSigned: null,
      formUpdateSekolah: {
        jenisSekolah: null,
        provinsi: null,
        kota: null,
        namaSekolah: null,
        npsn: null,
        akreditasi: null
      },
      userData: {
        picture: null,
        name: null,
        school: null,
        email: null,
        phone_number: null,
        student_number: null
      },
      querySchool: [],
      scopeList: null
    };
  },
  computed: {
    isActive: function isActive() {
      var now = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a();
      var expiredAt = new __WEBPACK_IMPORTED_MODULE_2_moment___default.a(this.userData.expired_at, "YYYY-MM-DD");
      var diff = expiredAt.valueOf() - now.valueOf();

      return diff > 0;
    },
    grade: {
      get: function get() {
        return this.userData.grade;
      },
      set: function set(newVal) {
        var context = this;
        var userId = this.userData.user_id;
        __WEBPACK_IMPORTED_MODULE_4__services_usman_js__["a" /* default */].updateUserGrade({ user_id: userId, grade: newVal }, function (response) {
          if (response.success) {
            context.$store.commit('usman_set_grade', newVal);
            window.alert('Berhasil mengubah data kelas siswa');
          } else {
            window.alert('Gagal mengubah data kelas siswa');
          }
        });
      }
    }
  },
  watch: {
    'formUpdateSekolah.provinsi': function formUpdateSekolahProvinsi(to, from) {
      this.cityList = [];
      this.getCity(to);
    },
    'formUpdateSekolah.kota': function formUpdateSekolahKota(to, from) {
      this.schoolList = [];
      this.getSchoolData(to);
    },
    newEmail: function newEmail(to, from) {
      if (to === '') this.listEmailSigned = null;
    }
  },
  methods: {
    loadDetailData: function loadDetailData() {
      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/tryout-service/membership';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {
        params: {
          email: this.userData.email
        }
      }).then(function (response) {
        context.memberships = response.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    loadDetailUser: function loadDetailUser() {
      var context = this;
      var token = this.$ls.get('token');
      var uid = JSON.parse(sessionStorage.usman_init);
      var url = "https://api.nfjuara.id" + '/account/usman/user/' + uid.user_id;

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {}).then(function (response) {
        context.scopeModel = [];
        response.data.scopes.forEach(function (element) {
          console.log(element);
          if (element.name !== 'app_basic') context.scopeModel.push(element);
        });
        // context.scopeModel = response.data.scopes
        context.scopeModel.sort(function (a, b) {
          return parseFloat(a.id) - parseFloat(b.id);
        });
        context.detailUser = response.data;
        sessionStorage.setItem('usman_init', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
        context.userData = JSON.parse(sessionStorage.usman_init);
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    loadTicketUser: function loadTicketUser() {
      var context = this;
      var token = this.$ls.get('token');
      var uid = JSON.parse(sessionStorage.usman_init);
      var url = "https://api.nfjuara.id" + '/sales/check-user-ticket?user_id=' + uid.user_id;

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {}).then(function (response) {
        context.users_ticket = response.data.ticket_value;
        console.log(response);
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    loadQuotaConsulUser: function loadQuotaConsulUser() {
      var context = this;
      var token = this.$ls.get('token');
      var uid = JSON.parse(sessionStorage.usman_init);
      var url = "https://api.nfjuara.id" + '/konsul/v2/student-credit/' + uid.user_id;

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      http.get(url, {}).then(function (response) {
        context.users_consul_session = response.data.consultation_credit;
        console.log(response);
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    displayTimestamp: function displayTimestamp(timeInMilis) {
      if (!timeInMilis) return '-';
      return __WEBPACK_IMPORTED_MODULE_2_moment___default()(timeInMilis).format('D MMM YYYY HH:mm');
    },
    getItemCount: function getItemCount(tryout) {
      var total = 0;
      tryout.subtests.forEach(function (subtest) {
        total += subtest.item_count;
      });

      return total;
    },
    activateUser: function activateUser() {
      var userId = this.userData.user_id;
      var cleanString = this.nomorIndukNF.replace(/-/g, '');
      var formattedNoInduk = this.nomorIndukNF;

      if (cleanString.length === 10) {
        formattedNoInduk = cleanString.substring(0, 3) + '-' + cleanString.substring(3, 5) + '-' + cleanString.substring(5);
      }

      this.isLoading = true;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_3__services_auth_js__["a" /* default */].userActivation(userId, this.emailSIP, formattedNoInduk, function (response) {
        if (response.success) {
          var userData = response.data;
          context.$store.commit('usman_init', userData);
          context.$store.commit('error_dismiss');
        } else {
          context.$store.commit('error_show', 'Gagal melakukan aktivasi user');
        }

        context.isLoading = false;
      });
    },
    resetState: function resetState(bundle_code, email) {
      if (confirm("apakah anda yakin mengembalikan status pengerjaan try out ini menjadi Bergabung?")) {
        var body = {
          bundle_code: bundle_code,
          email: email
          // console.log(bundle_code)
        };var context = this;
        __WEBPACK_IMPORTED_MODULE_6__services_tryout_js__["a" /* default */].resetStateTryout(body, function (result) {
          if (result.success) {
            context.loadDetailData();
            alert('Reset Sukses!');
          }
        });
      }
    },
    gradingState: function gradingState(bundle_code, email) {
      if (confirm("apakah anda yakin akan mengubah status try out ini menjadi Dinilai?")) {
        var body = {
          bundle_code: bundle_code,
          email: email
          // console.log(bundle_code)
        };var context = this;
        __WEBPACK_IMPORTED_MODULE_6__services_tryout_js__["a" /* default */].gradingStateTryout(body, function (result) {
          if (result.success) {
            context.loadDetailData();
            alert('Grading Sukses!');
          }
        });
      }
    },
    showEditForm: function showEditForm() {
      $('#modalEditSekolah').modal('show');
      this.getProvince();
      this.formUpdateSekolah = {
        jenisSekolah: this.userData.school_type,
        provinsi: this.userData.province,
        kota: this.userData.city,
        namaSekolah: this.userData.school,
        npsn: this.userData.school_npsn,
        akreditasi: this.userData.school_acreditation
      };
    },
    showEditEmail: function showEditEmail() {
      this.listEmailSigned = null;

      $('#modalEditEmail').modal('show');
    },

    getProvince: function getProvince() {
      var _this = this;

      var queryStr = "q=*:*&";
      // if (this.params.search !== null) queryStr = "q=" + this.params.search + "&";
      // if(this.params.search == '') this.params.page = 0
      __WEBPACK_IMPORTED_MODULE_1_axios___default()("https://api.nfjuara.id/search/nfj_districts/select?" + queryStr + "fl=province_name_t%20province_code_i&rows=100&group=true&group.field=province_code_i", {
        auth: {
          username: "webapp",
          password: "8B^eduHKUu"
        }
      }).then(function (response) {
        var list = response.data.grouped.province_code_i.groups;
        list.forEach(function (element) {
          _this.provinceList.push({
            text: element.doclist.docs[0].province_name_t,
            value: element.doclist.docs[0].province_name_t
          });
        });
      });
    },
    getCity: function getCity(v) {
      var _this2 = this;

      // var queryStr = "q=*:*&";
      // if (this.params.search !== null)
      var queryStr = "q=province_name_t%3A%22" + encodeURIComponent(v) + "%22&";
      // if(this.params.search == '') this.params.page = 0
      __WEBPACK_IMPORTED_MODULE_1_axios___default()("https://api.nfjuara.id//search/nfj_districts/select?" + queryStr + "fl=city_name_t,city_code_i&rows=1000&start=0",
      // &fq=province_name_t:" +
      // encodeURIComponent(v),
      {
        auth: {
          username: "webapp",
          password: "8B^eduHKUu"
        }
      }).then(function (response) {
        var list = response.data.response.docs;
        list.forEach(function (element) {
          _this2.cityList.push({
            text: element.city_name_t,
            value: element.city_name_t
          });
        });
        // console.log(this.cityList)
      });
    },
    getSchoolData: function getSchoolData(v) {
      var _this3 = this;

      var queryStr = 'q=city_name_s:"' + v + '"&';
      var jenjang = "";
      if (this.userData.grade < 7) jenjang = "SD";else if (this.userData.grade < 10) jenjang = "SMP";else jenjang = "SMA";
      // if (this.params.search !== '') queryStr = 'q=' + this.params.search + '&'
      // if(this.params.search == '') this.params.page = 0
      __WEBPACK_IMPORTED_MODULE_1_axios___default()("https://api.nfjuara.id/search/nfj_schools/select?" + queryStr + "defType=edismax&fq=jenjang_s:" + jenjang + "&qf=school_s&wt=json&rows=1000", {
        auth: {
          username: "webapp",
          password: "8B^eduHKUu"
        }
      }).then(function (response) {
        var list = response.data.response.docs;
        list.forEach(function (element) {
          _this3.schoolList.push({
            text: element.school_t,
            value: element.school_t,
            npsn: element.npsn_s,
            akreditasi: element.akreditasi_s
          });
        });
        // console.log(this.schoolList)
        _this3.$forceUpdate();
      });
    },
    autoCompleteSearch: function autoCompleteSearch() {
      this.showSuggestion = true;
      var objects = this.schoolList;
      var queried = [];
      for (var i = 0; i < objects.length; i++) {
        for (var key in objects[i]) {
          if (objects[i][key].indexOf(this.formUpdateSekolah.namaSekolah) != -1) {
            queried.push(objects[i]);
          }
        }
      }
      this.querySchool = queried.filter(function (v, i, a) {
        return a.findIndex(function (v2) {
          return v2.npsn === v.npsn;
        }) === i;
      });
      this.$forceUpdate();
    },
    selectingSchool: function selectingSchool(val) {
      this.showSuggestion = false;
      this.formUpdateSekolah.namaSekolah = val.text;
      this.formUpdateSekolah.npsn = val.npsn;
      this.formUpdateSekolah.akreditasi = val.akreditasi;
      this.showSuggestion = false;
      this.$forceUpdate();
    },
    commitSearch: function commitSearch() {
      this.showSuggestion = true;
      this.querySchool = [];
      this.autoCompleteSearch();
    },
    updateDataSekolah: function updateDataSekolah() {
      var context = this;
      var userId = this.userData.user_id;
      var datbod = {
        user_id: userId,
        grade: this.userData.grade,
        province: this.formUpdateSekolah.provinsi,
        school: this.formUpdateSekolah.namaSekolah,
        school_npsn: this.formUpdateSekolah.npsn,
        city: this.formUpdateSekolah.kota,
        school_acreditation: this.formUpdateSekolah.akreditasi,
        school_type: this.formUpdateSekolah.jenisSekolah
      };
      __WEBPACK_IMPORTED_MODULE_4__services_usman_js__["a" /* default */].updateUserSchool(datbod, function (response) {
        if (response.success) {
          sessionStorage.setItem('usman_init', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(response.data));
          context.userData = response.data;
          context.$forceUpdate();
          $('#modalEditSekolah').modal('hide');
          // context.$store.commit('usman_set_grade', newVal)
          window.alert('Berhasil mengubah data kelas siswa');
        } else {
          window.alert('Gagal mengubah data kelas siswa');
        }
      });
    },
    updateTanggalScope: function updateTanggalScope(item, i) {
      var context = this;
      if (item.expired_at !== null) {
        if (confirm("Anda yakin akan mengubah tanggal kadaluwarsa scope ini?") == true) {
          console.log(__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.expired_at + ' 23:59:59').unix());
          if (__WEBPACK_IMPORTED_MODULE_2_moment___default()(item.expired_at + ' 23:59:59').unix() < __WEBPACK_IMPORTED_MODULE_2_moment___default()().unix()) {
            alert('Tanggal tidak valid');
            context.loadDetailUser();
          } else {
            var token = this.$ls.get('token');
            var uid = JSON.parse(sessionStorage.usman_init);
            var url = "https://api.nfjuara.id" + '/account/usman/user/' + uid.user_id + '/scope/' + item.id;

            this.isLoading = true;
            var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            });

            http.put(url, { 'expired_at': __WEBPACK_IMPORTED_MODULE_2_moment___default()(item.expired_at + ' 23:59:59').unix() }).then(function (response) {
              console.log(response);
              alert('tanggal expired scope berhasil diperbaharui');
              context.loadDetailUser();
            }).catch(function (error) {
              console.log(error.message);
              alert('tanggal expired scope gagal diperbaharui');
              context.loadDetailUser();
            }).then(function () {
              context.isLoading = false;
            });
          }
        } else {
          context.loadDetailUser();
        }
      }
    },
    deleteScope: function deleteScope(item, i) {
      var text = void 0;
      if (confirm("Anda yakin akan menghapus scope dari user ini?") == true) {
        var context = this;
        var token = this.$ls.get('token');
        var uid = JSON.parse(sessionStorage.usman_init);
        var url = "https://api.nfjuara.id" + '/account/usman/user/' + uid.user_id + '/scope/' + item.id;

        this.isLoading = true;
        var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
          }
        });

        http.delete(url, {}).then(function (response) {
          console.log(response);
          alert('scope berhasil dihapus');
          context.loadDetailUser();
        }).catch(function (error) {
          console.log(error.message);
          alert('scope gagal dihapus');
        }).then(function () {
          context.isLoading = false;
        });
      } else {}
    },
    checkEmail: function checkEmail() {
      var context = this;
      var token = this.$ls.get('token');
      var url = "https://api.nfjuara.id" + '/account/usman/users';
      var query = null;
      var filter = { order: '', orderby: '' };
      context.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });

      var objParams = '{"page": ' + 1;
      if (query !== '') objParams += ', "query": "' + context.newEmail + '"';
      if (filter.order !== '') objParams += ', "order": "DESC"';
      if (filter.orderby !== '') objParams += ', "order_by": "id"';

      objParams += '}';
      http.get(url, {
        params: JSON.parse(objParams)
      }).then(function (response) {
        context.listEmailSigned = response.data;
      }).catch(function (error) {
        console.log(error.message);
      }).then(function () {
        context.isLoading = false;
      });
    },
    updateEmail: function updateEmail() {
      var validateEmail = function validateEmail(email) {
        return email.match(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
      };
      if (validateEmail(this.newEmail)) {
        if (confirm("apakah anda yakin akan mengubah email untuk user ini menjadi (" + this.newEmail + ")?")) {
          this.commitChangeEmail();
        }
      } else {
        alert('email baru tidak valid');
      }
    },
    commitChangeEmail: function commitChangeEmail() {
      var context = this;
      var token = this.$ls.get('token');
      var uid = JSON.parse(sessionStorage.usman_init);
      var url = "https://api.nfjuara.id" + '/account/usman/user/' + uid.user_id + '/update-or-swap-email';

      this.isLoading = true;
      var http = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      });
      http.put(url, { 'email': this.newEmail }).then(function (response) {
        alert('email user berhasil diubah');
        $('#modalEditEmail').modal('hide');
        context.loadDetailUser();
      }).catch(function (error) {
        console.log(error.message);
        alert('gagal ubah email user');
      }).then(function () {
        context.isLoading = false;
      });
    }
  },
  mounted: function mounted() {
    var context = this;
    context.userData = JSON.parse(sessionStorage.usman_init);
    context.loadDetailData();
    context.loadDetailUser();
    context.loadTicketUser();
    context.loadQuotaConsulUser();
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_itembank_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_video_js__ = __webpack_require__(50);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryoutgroup-form',
  components: {
    'app-tryoutchooser': __WEBPACK_IMPORTED_MODULE_0__components_tryout_group_TryoutChooser___default.a,
    'app-tryoutgroupchooser': __WEBPACK_IMPORTED_MODULE_1__components_tryout_group_TryoutGroupChooser___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_2__components_plugins_Spinner___default.a,
    'app-modal': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Modal___default.a
  },
  data: function data() {
    return {
      modul: null,
      isLoading: false,
      showModal: false,
      errors: [],
      videoId: null,
      judulalt: null,
      changeUrl: true,
      altTitle: false,
      jenjangList: ['SD', 'SMP', 'SMA'],
      gradeList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      mapelList: JSON.parse(localStorage.getItem('mapels')),
      jenjang: null,
      start_date: null,
      start_time: null,
      end_date: null,
      end_time: null

    };
  },
  created: function created() {},

  watch: {
    altTitle: function altTitle(val, oldval) {
      if (!val) {
        this.judulalt = this.judul;
      }
    }
  },
  computed: {
    player: function player() {
      return this.$refs.youtube.player;
    },

    url: {
      get: function get() {
        return this.$store.state.video.url;
      },
      set: function set(value) {
        this.$store.commit('video_set_url', value);
      }
    },
    judul: {
      get: function get() {
        return this.$store.state.video.title;
      },
      set: function set(value) {
        this.$store.commit('video_set_title', value);
      }
    },
    kelas: {
      get: function get() {
        return this.$store.state.video.grade;
      },
      set: function set(value) {
        this.$store.commit('video_set_grade', value);
      }
    },
    mapel: {
      get: function get() {
        return this.$store.state.video.mapel;
      },
      set: function set(value) {
        this.$store.commit('video_set_mapel', value);
      }
    },
    interest: {
      get: function get() {
        return this.$store.state.video.interest;
      },
      set: function set(value) {
        this.$store.commit('video_set_interest', value);
      }
    },
    description: {
      get: function get() {
        return this.$store.state.video.description;
      },
      set: function set(value) {
        this.$store.commit('video_set_description', value);
      }
    },
    thumbnail: {
      get: function get() {
        return this.$store.state.video.thumbnail;
      },
      set: function set(value) {
        this.$store.commit('video_set_thumbnail', value);
      }
    },
    source: {
      get: function get() {
        return this.$store.state.video.source;
      },
      set: function set(value) {
        this.$store.commit('video_set_source', value);
      }
    },
    duration: {
      get: function get() {
        return this.$store.state.video.duration;
      },
      set: function set(value) {
        this.$store.commit('video_set_duration', value);
      }
    }
  },
  methods: {
    playVideo: function playVideo() {
      this.player.playVideo();
    },
    playing: function playing() {
      console.log('\o/ we are watching!!!');
    },
    hideForm: function hideForm() {
      this.changeUrl = true;
    },
    resetKelas: function resetKelas() {
      this.kelas = [];
      this.interest = 'ALL';
    },
    checkURL: function checkURL() {
      if (this.url) {
        var context = this;
        if (this.url.indexOf('embed') > -1) {
          alert('video url tidak valid');
          return;
        } else {
          this.videoId = this.url.substring(this.url.indexOf('=') + 1);
        }
        __WEBPACK_IMPORTED_MODULE_8__services_video_js__["a" /* default */].getVideoDetail(this.videoId, function (response) {
          if (response.success) {
            context.changeUrl = false;
            context.judul = response.data.title;
            context.judulalt = response.data.title;
            context.source = response.data.source;
            context.thumbnail = response.data.thumbnail;
            context.description = response.data.description;
            context.duration = response.data.duration_in_sec;
          } else {
            return;
          }
        });
      } else {
        alert('URL diperlukan');
      }
    },

    validateForm: function validateForm() {
      this.errors = [];
      if (this.judul == '') this.errors.push('Judul wajib diisi');
      if (this.source == '') this.errors.push('Source wajib diisi');
      if (this.kelas.length < 1) this.errors.push('Kelas wajib diisi');
      if (this.mapel == '') this.errors.push('Mata Pelajaran wajib diisi');
      if (this.judulalt == '') this.errors.push('Judul wajib diisi');
      if (this.kelas > 9 && this.interest == '') this.errors.push('Jurusan wajib diisi');
      if (this.kelas < 10) this.interest = 'ALL';
      return this.errors.length == 0;
    },
    saveData: function saveData() {
      if (!this.validateForm()) {
        return;
      }
      if (this.$route.name === 'VideoMaterialLiveStream') {
        this.isLoading = true;
        var context = this;
        var body = {
          title: this.judulalt,
          description: this.description,
          interest: this.interest,
          source: this.source,
          youtube_url: this.url,
          grades: this.kelas,
          mapel_id: this.mapel,
          start_date: this.start_date,
          end_date: this.end_date,
          start_time: this.start_time,
          end_time: this.end_time,
          module_id: this.modul != null ? this.modul.id : null
        };
        __WEBPACK_IMPORTED_MODULE_8__services_video_js__["a" /* default */].addVideoLiveStreaming(body, function (result) {
          context.isLoading = false;
          context.$store.commit('video_reset', result.data);
          context.start_date = '';
          context.start_time = '';
          context.end_date = '';
          context.end_time = '';
          if (context.modul != null) context.$router.push({ path: '/modul-belajar/live-stream', query: { modul_id: context.modul.id } });else context.$router.push({ path: '/video' });
        });
      } else {
        this.isLoading = true;
        var context = this;
        var body = {
          title: this.judulalt,
          description: this.description,
          interest: this.interest,
          source: this.source,
          youtube_url: this.url,
          grades: this.kelas,
          mapel_id: this.mapel,
          duration: this.duration,
          thumbnail: this.thumbnail,
          module_id: this.modul != null ? this.modul.id : null
        };
        __WEBPACK_IMPORTED_MODULE_8__services_video_js__["a" /* default */].addVideo(body, function (result) {
          context.isLoading = false;
          context.$store.commit('video_reset', result.data);

          if (context.modul != null) context.$router.push({ path: '/modul-belajar/materials', query: { modul_id: context.modul.id } });else context.$router.push({ path: '/video' });
        });
      }
    },
    editData: function editData() {
      if (!this.validateForm()) {
        return;
      }
      if (this.$route.name === 'VideoMaterialLiveStream') {
        this.isLoading = true;
        var context = this;
        var body = {
          title: this.$store.state.video.title,
          description: this.$store.state.video.description,
          interest: this.$store.state.video.interest,
          source: this.$store.state.video.source,
          youtube_url: this.$store.state.video.url,
          grades: this.$store.state.video.grade,
          mapel_id: this.$store.state.video.mapel,
          start_date: this.start_date,
          end_date: this.end_date,
          start_time: this.start_time,
          end_time: this.end_time,
          module_id: this.modul != null ? this.modul.id : null
        };
        __WEBPACK_IMPORTED_MODULE_8__services_video_js__["a" /* default */].editVideoLiveStreaming(this.$route.query.liveId, body, function (result) {
          context.isLoading = false;
          context.$store.commit('video_reset', result.data);
          context.start_date = '';
          context.start_time = '';
          context.end_date = '';
          context.end_time = '';
          if (context.modul != null) context.$router.push({ path: '/modul-belajar/live-stream', query: { modul_id: context.$route.query.module } });else context.$router.push({ path: '/video' });
        });
      } else {
        this.isLoading = true;
        var context = this;
        var body = {
          title: this.$store.state.video.title,
          description: this.$store.state.video.description,
          interest: this.$store.state.video.interest,
          source: this.$store.state.video.source,
          youtube_url: this.$store.state.video.url,
          grades: this.$store.state.video.grade,
          mapel_id: this.$store.state.video.mapel,
          duration: this.$store.state.video.duration,
          thumbnail: this.$store.state.video.thumbnail,
          module_id: this.modul != null ? this.modul.id : null
        };
        __WEBPACK_IMPORTED_MODULE_8__services_video_js__["a" /* default */].editVideo(this.$route.query.id, body, function (result) {
          context.isLoading = false;
          context.$store.commit('video_reset', result.data);
          // context.$router.push({path: '/video'})
          if (context.$route.name === 'VideoMaterial') {
            context.$router.push({ path: '/modul-belajar/materials', query: { modul_id: context.$route.query.module } });
          } else {
            context.$router.push({ path: '/video' });
          }
        });
      }
    }
  },
  mounted: function mounted() {
    var context = this;
    DatepickerPlugin.init("#startDate", function (value) {
      context.start_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    DatepickerPlugin.init("#endDate", function (value) {
      context.end_date = __WEBPACK_IMPORTED_MODULE_5_moment___default()(value, "DD/MM/YYYY").format("YYYY-MM-DD");
    });

    ClockpickerPlugin.init("#startTime", function (value) {
      context.start_time = value + ":00";
    });

    ClockpickerPlugin.init("#endTime", function (value) {
      context.end_time = value + ":00";
    });

    if (this.$route.query.id) {
      var context = this;
      this.changeUrl = false;
      __WEBPACK_IMPORTED_MODULE_8__services_video_js__["a" /* default */].getVideoDetailById(this.$route.query.id, function (result) {
        var gradeWrap = [];
        var jenjangWrap = '';
        if (result.data.grades.length > 0) {
          for (var i = 0; i < result.data.grades.length; i++) {
            gradeWrap.push(result.data.grades[i].grade);
            jenjangWrap = result.data.grades[i].jenjang.nama;
          }
        }
        context.judul = result.data.title;
        context.url = result.data.youtube_url;
        context.jenjang = jenjangWrap;
        context.kelas = gradeWrap;
        context.source = result.data.source;
        context.mapel = result.data.mapel.id;
        context.interest = result.data.interest === 'OTHER' ? 'ALL' : result.data.interest;
        context.duration = result.data.duration;
        context.description = result.data.description;
        context.videoId = result.data.youtube_url.substring(result.data.youtube_url.indexOf('=') + 1);
      });
    }

    if (this.$route.query.modul_id) {
      var modulId = this.$route.query.modul_id;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_7__services_itembank_js__["a" /* default */].getModulBelajar(modulId, function (response) {
        if (response.success) {
          context.modul = response.data;
        }
      });
    }

    if (this.$route.query.liveId) {
      var liveId = this.$route.query.liveId;
      var context = this;
      __WEBPACK_IMPORTED_MODULE_7__services_itembank_js__["a" /* default */].getLiveStream(liveId, function (result) {
        if (result.success) {
          context.changeUrl = false;
          context.modul = {
            name: result.data.module.name
          };
          var gradeWrap = [];
          var jenjangWrap = '';
          if (result.data.grades.length > 0) {
            for (var i = 0; i < result.data.grades.length; i++) {
              gradeWrap.push(result.data.grades[i].grade);
              jenjangWrap = result.data.grades[i].jenjang.nama;
            }
          }
          context.start_date = result.data.start_date;
          context.start_time = result.data.start_time;
          context.end_date = result.data.end_date;
          context.end_time = result.data.end_time;
          context.judul = result.data.title;
          context.url = result.data.youtube_url;
          context.jenjang = jenjangWrap;
          context.kelas = gradeWrap;
          context.source = result.data.source;
          context.mapel = result.data.mapel.id;
          context.interest = result.data.interest === 'OTHER' ? 'ALL' : result.data.interest;
          context.duration = result.data.duration;
          context.description = result.data.description;
          context.videoId = result.data.youtube_url.substring(result.data.youtube_url.indexOf('=') + 1);
        }
      });
    }
  }
});

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'video-nav'
});

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_tryout_js__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_video_js__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Modal__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_plugins_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_plugins_Modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tryout-group',
  components: {
    'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
    'app-spinner': __WEBPACK_IMPORTED_MODULE_3__components_plugins_Spinner___default.a
  },
  data: function data() {
    return {
      videoList: [],
      selectedRow: null,
      isLoading: false,
      headers: ['Judul', 'Kelas', 'Mata Pelajaran'],
      showModal: false
    };
  },
  mounted: function mounted() {
    this.fetchData();
    this.$store.commit('video_reset');
  },
  methods: {
    fetchData: function fetchData() {
      this.videoList = [];
      var context = this;
      __WEBPACK_IMPORTED_MODULE_2__services_video_js__["a" /* default */].getListVideo(function (result) {
        if (result.success) {
          result.data.forEach(function (video) {
            var gradeWrap = '';
            if (video.grades.length > 0) {
              for (var i = 0; i < video.grades.length; i++) {
                gradeWrap += ' ' + video.grades[i].grade;
              }
            } else {
              gradeWrap = '';
            }
            var row = {
              id: video.id,
              url: video.youtube_url,
              data: [video.title, gradeWrap, video.mapel.nama]
            };
            context.videoList.push(row);
          });
        }
      });
    },
    createVideo: function createVideo() {
      this.$router.push({ path: '/video/form' });
    },
    editVideo: function editVideo() {
      var context = this;
      var videoId = this.selectedRow.id;
      this.$router.push({ path: '/video/form', query: { id: videoId } });
    },
    deleteVideo: function deleteVideo(video) {
      var context = this;
      var videoId = video.id;
      var confirmed = window.confirm("Apakah anda yakin akan menghapus group ini?");
      if (confirmed) {
        this.isLoading = true;
        __WEBPACK_IMPORTED_MODULE_2__services_video_js__["a" /* default */].deleteVideo(videoId, function (result) {
          if (result.success) {
            alert('Data Terhapus');
            context.isLoading = false;
            context.fetchData();
          }
        });
      }
    }
  }
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_voucher_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_file_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_search_select_dist_VueSearchSelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'content-article-form',
    components: {
        'app-spinner': __WEBPACK_IMPORTED_MODULE_0__components_plugins_Spinner___default.a,
        'model-select': __WEBPACK_IMPORTED_MODULE_5_vue_search_select__["ModelSelect"]
    },
    data: function data() {
        return {
            isLoading: false,
            compiledContent: '',
            labelQuery: '',
            productList: [],
            listChannel: [],
            channelSelected: '',
            productSelected: '',
            form: {
                channel_id: null,
                products: [{
                    product_id: null,
                    amount: null
                }]
            },
            errors: []
        };
    },
    mounted: function mounted() {
        this.getProdukList();
    },
    methods: {
        getProdukList: function getProdukList() {
            var context = this;
            var search = {
                query: 'PUBLISHED',
                by: 'status'
            };

            var pagination = {
                perPage: 1000,
                currentPage: 1,
                sortMode: 'ASC'
            };

            context.isLoading = true;
            __WEBPACK_IMPORTED_MODULE_2__services_voucher_js__["a" /* default */].getListChannels(pagination, '', function (result) {
                context.listChannel = result.data;
            });
            __WEBPACK_IMPORTED_MODULE_1__services_sales_js__["a" /* default */].getProdukList(pagination, search, function (result) {
                // context.produkList = []
                context.isLoading = false;

                if (result.success) {
                    result.data.forEach(function (content) {
                        var row = {
                            text: content.title.toLowerCase(),
                            value: content.id
                        };
                        context.productList.push(row);
                    });
                    context.productList.sort(function (a, b) {
                        if (a.text < b.text) return -1;
                        if (a.text > b.text) return 1;
                        return 0;
                    });
                } else {
                    alert('Terjadi kesalahan : ' + result.message);
                }
            });
        },
        downloadGeneratedFile: function downloadGeneratedFile(path) {
            var context = this;
            __WEBPACK_IMPORTED_MODULE_3__services_file_js__["a" /* default */].download2(path, function (response) {
                console.log(response);
            });
            context.$router.push({
                path: '/voucher'
            });
            context.loading = false;
        },
        save: function save() {
            var context = this;
            context.isLoading = true;
            if (this.validateForm()) {
                __WEBPACK_IMPORTED_MODULE_2__services_voucher_js__["a" /* default */].generateVoucher(this.form, function (result) {
                    if (result.success) {
                        context.downloadGeneratedFile(result.data.directory);
                        alert('voucher berhasil di generate');
                    } else {
                        alert('Terjadi kesalahan: ' + result.message);
                    }
                });
            } else {
                context.isLoading = false;
            }
        },
        pushProduct: function pushProduct(ind) {
            // if(ind > 1) {
            if (this.form.products[ind].product_id == null || this.form.products[ind].product_id == '') {
                alert('lengkapi produk sebelumnya terlebih dahulu');
                return false;
            }
            if (this.form.products[ind].amount == null || this.form.products[ind].amount == '' || this.form.products[ind].amount < 1) {
                alert('data tidak valid atau tidak boleh kosong');
                return false;
            }
            // }
            this.form.products.push({ product_id: null, amount: null });
        },
        validateForm: function validateForm() {
            this.errors = [];
            if (!this.form.channel_id) this.errors.push('Channel wajib diisi');
            // if (!this.form.products[0].product_id) this.errors.push('Produk wajib diisi')
            for (var i = 0; i < this.form.products.length; i++) {
                if (this.form.products[i].product_id == null || this.form.products[i].product_id == '') this.errors.push('Produk wajib diisi');
                if (this.form.products[i].amount == null || this.form.products[i].amount == '' || this.form.products[i].amount < 1) this.errors.push('Jumlah Kuota wajib diisi atau nilai tidak valid');
            }
            if (this.errors.length == 0) return true;

            return false;
        }
    }
});

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'voucher-nav'
});

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_sales_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_voucher_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_file_js__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select_dist_VueSearchSelect_css__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_search_select_dist_VueSearchSelect_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_search_select_dist_VueSearchSelect_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_search_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_search_select__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'katalog-tiket',
    components: {
        'app-datatable': __WEBPACK_IMPORTED_MODULE_0__components_plugins_DataTable___default.a,
        'app-spinner': __WEBPACK_IMPORTED_MODULE_1__components_plugins_Spinner___default.a,
        'model-select': __WEBPACK_IMPORTED_MODULE_6_vue_search_select__["ModelSelect"]
    },
    data: function data() {
        return {
            isLoading: false,
            productList: [],
            productSelected: '',
            voucherList: [],
            listChannel: '',
            quota: 0,
            channelSelected: '',
            voucherSelected: {
                data: ['', '', '']
            },
            sortSelected: '',
            selectedRow: null,
            search: null,
            pagination: {
                perPage: 25,
                currentPage: 1,
                totalPages: 0,
                sortMode: 'ASC'
            },
            paging: {
                limit: 0,
                page: 0,
                total_data: 0,
                total_page: 0
            },
            currentPage: 1,
            maxPage: null,
            type: {
                // SCHEDULED_TRYOUT: 'SCHEDULED_TRYOUT',
                // INSTANT_TRYOUT: 'INSTANT_TRYOUT',
                // CONSULTATION: 'CONSULTATION',
                // DUEL: 'DUEL',
                // ITEM_BANK: 'ITEM_BANK',
                // VIDEO: 'VIDEO'
            },
            headers: ['E-Commerce Channel', 'Product', 'Inventori'],
            headersKey: ['judul', 'type', 'status'],
            totalPage: 0
        };
    },
    mounted: function mounted() {
        this.fetchData();
        this.getProdukList();
    },
    watch: {
        pagination: function pagination() {
            this.currentPage = 1;
            this.fetchData();
        },
        channelSelected: function channelSelected() {
            this.currentPage = 1;
            this.fetchData();
        },
        productSelected: function productSelected() {
            this.currentPage = 1;
            this.fetchData();
        },
        sortSelected: function sortSelected() {
            this.currentPage = 1;
            this.fetchData();
        }
    },
    methods: {
        clearFilter: function clearFilter() {
            var context = this;
            if (context.channelSelected != '') context.channelSelected = '';
            if (context.productSelected != '') context.productSelected = '';
            if (context.sortSelected != '') context.sortSelected = '';
        },
        addQuota: function addQuota(item) {
            var context = this;
            context.voucherSelected = item;
            $('#myModal').modal('show');
        },
        changePage: function changePage(v) {
            var context = this;
            context.currentPage = context.currentPage + v;
            context.fetchData();
        },
        fetchData: function fetchData() {
            var context = this;
            var search = {};
            if (context.channelSelected != '') search.channel_id = context.channelSelected;
            if (context.productSelected != '') search.product_id = context.productSelected;
            var pagination = {
                perPage: 25,
                currentPage: context.currentPage,
                sortMode: context.sortSelected
            };

            this.isLoading = true;

            __WEBPACK_IMPORTED_MODULE_3__services_voucher_js__["a" /* default */].getListVoucher(pagination, search, function (result) {
                context.voucherList = [];
                context.isLoading = false;
                if (result.success) {
                    var pg = result.pagination;
                    context.paging = {
                        limit: pg.limit,
                        page: pg.page,
                        total_data: pg.total_data,
                        total_page: pg.total_page
                    };
                    result.data.forEach(function (content) {
                        var row = {
                            data: [content.channel_name, content.product_name, content.total_voucher],
                            channel_id: content.channel_id,
                            product_id: content.product_id
                            // context.pagination.totalPages = content.total_page
                        };context.voucherList.push(row);
                    });
                } else {
                    alert('Terjadi Kesalahan : ' + result.data.message);
                }
            });
        },
        getProdukList: function getProdukList() {
            var context = this;
            var search = { query: 'PUBLISHED', by: 'status' };
            var pagination = {
                perPage: 1000,
                currentPage: 1,
                sortMode: 'ASC'

                // this.isLoading = true
            };__WEBPACK_IMPORTED_MODULE_3__services_voucher_js__["a" /* default */].getListChannels(pagination, '', function (result) {
                context.listChannel = result.data;
            });
            __WEBPACK_IMPORTED_MODULE_2__services_sales_js__["a" /* default */].getProdukList(pagination, search, function (result) {
                // context.produkList = []
                // context.isLoading = false

                if (result.success) {
                    result.data.forEach(function (content) {
                        var row = {
                            text: content.title.toLowerCase(),
                            value: content.id
                        };
                        context.productList.push(row);
                    });
                    context.productList.sort(function (a, b) {
                        if (a.text < b.text) return -1;
                        if (a.text > b.text) return 1;
                        return 0;
                    });
                } else {
                    alert('Terjadi kesalahan : ' + result.message);
                }
            });
        },
        downloadGeneratedFile: function downloadGeneratedFile(path) {
            var context = this;
            __WEBPACK_IMPORTED_MODULE_4__services_file_js__["a" /* default */].download2(path, function (response) {
                console.log(response);
            });
            context.fetchData();
            context.loading = false;
        },
        changeQuota: function changeQuota() {
            var context = this;

            if (context.quota < 1) {
                alert('Jumlah kuota tidak valid');
                return false;
            } else {
                context.isLoading = true;
                $('#myModal').modal('hide');
                var body = {
                    channel_id: context.voucherSelected.channel_id,
                    products: [{
                        product_id: context.voucherSelected.product_id,
                        amount: context.quota
                    }]
                };
                __WEBPACK_IMPORTED_MODULE_3__services_voucher_js__["a" /* default */].generateVoucher(body, function (result) {

                    if (result.success) {
                        context.downloadGeneratedFile(result.data.directory);
                        alert('voucher berhasil di generate');
                    } else {
                        alert('Terjadi kesalahan: ' + result.message);
                    }
                    context.isLoading = false;
                });
            }
        }
    }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Subtest = {
  id: 0,
  tryout_id: 0,
  subject_code: '',
  subject_name: '',
  subject_picture: '',
  duration: 35,
  item_count: 0,
  details: []
};

/* unused harmony default export */ var _unused_webpack_default_export = (Subtest);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SubtestDetail = {
  sequence: 0,
  is_anchor: false,
  item_code: null,
  bab_code: null,
  sub_bab_code: null,
  text: ''
};

/* unused harmony default export */ var _unused_webpack_default_export = (SubtestDetail);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Tryout = {
  id: 0,
  name: '',
  description: '',
  category: 'OTHER',
  level: '',
  type: '',
  is_repeated: false,
  is_free_access: false,
  start_date: '',
  start_time: '',
  end_date: '',
  end_time: '',
  duration: 0,
  repeatitions: [],
  subtests: [],
  is_active: false,
  created_at: 0,
  updated_at: 0
};

/* unused harmony default export */ var _unused_webpack_default_export = (Tryout);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var tryout = {
  "id": 1,
  "code": "JIO1ZA64",
  "name": "Tryout SBMPTN periode 3",
  "description": "Tryout SBMPTN periode 3",
  "level": "SMA",
  "is_repeated": false,
  "start_date": "2018-06-21",
  "end_date": "2018-06-28",
  "start_time": "15:00:00",
  "end_time": "23:00:00",
  "duration": 120,
  "status": "REVIEW",
  "type": "SBMPTN",
  "repeatitions": [],
  "subtests": [],
  "is_active": true,
  "is_free_access": false,
  "created_at": 1529555713000,
  "updated_at": 1529555744000,
  "state": null,
  "bundle_code": null,
  "started_at": null,
  "ended_at": null
};

/* unused harmony default export */ var _unused_webpack_default_export = (tryout);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_ls___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_ls__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_youtube__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_youtube___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_youtube__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_numeric__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ckeditor_ckeditor5_vue__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ckeditor_ckeditor5_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ckeditor_ckeditor5_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_croppr_dist_croppr_css__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_croppr_dist_croppr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_croppr_dist_croppr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_viewer__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_v_viewer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_v_viewer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__router__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(380);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_ls___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_youtube___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_numeric___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4__ckeditor_ckeditor5_vue___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_v_viewer___default.a);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_8__App___default.a
  },
  router: __WEBPACK_IMPORTED_MODULE_9__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */]
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_loader__);





// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

//user manajemen

function getGeneralAds(callback) {
  var config = getConfig();

  http.get('/promotion/config-ads', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getInternalAds(callback) {
  var config = getConfig();

  http.get('/promotion/internal-ads', config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function saveGeneralAdsSetting(dataBody, callback) {
  var config = getConfig();

  http.put('/promotion/config-ads', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function saveInternalAdsSetting(dataBody, callback) {
  var config = getConfig();

  http.post('/promotion/internal-ads', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function updateInternalAdsSetting(dataBody, callback) {
  var config = getConfig();

  http.put('/promotion/internal-ads/' + dataBody.id, dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function deleteInternalAds(dataBody, callback) {
  var config = getConfig();

  http.delete('/promotion/internal-ads/' + dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getGeneralAds: getGeneralAds,
  getInternalAds: getInternalAds,
  saveGeneralAdsSetting: saveGeneralAdsSetting,
  deleteInternalAds: deleteInternalAds,
  saveInternalAdsSetting: saveInternalAdsSetting,
  updateInternalAdsSetting: updateInternalAdsSetting
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function validate(text) {
  var pattern = /(app:\/\/id\.co\.nurulfikri\.nfjuara\/)\b([-a-zA-Z0-9@:%._\+~#=\/]*)/;
  return pattern.test(text);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  validate: validate
});

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

function getApplicationConfig(callback) {
  var config = getConfig();
  var url = '/promotion/configs';
  http.get(url, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function saveApplicationConfig(data, callback) {
  var config = getConfig();
  var url = '/promotion/configs';
  http.put(url, data, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getApplicationConfig: getApplicationConfig,
  saveApplicationConfig: saveApplicationConfig
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_file_loader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_file_loader__);





// var callback;

var http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'application/json' }
});

var httpupload = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: "https://api.nfjuara.id",
  headers: { 'Content-Type': 'multipart/form-data' }
});

http.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status !== 401) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);

  var refreshAndRetry = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default.a.post("https://api.nfjuara.id" + '/account/refresh_token', {
      'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
    }, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
      }
    }).then(function (response) {
      localStorage.setItem('refresh_token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.refresh_token,
        expire: null
      }));

      localStorage.setItem('token', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        value: response.data.token,
        expire: null
      }));

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).then(function (response) {
      var failedRequest = error.config;
      failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value;
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.request(failedRequest).then(function (retryResponse) {
        resolve(retryResponse);
      });
    });
  });

  return refreshAndRetry;
});

function getConfig() {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  };
}

//user manajemen

function getNotifSchedules(pagination, callback) {
  var config = getConfig();

  http.get('/promotion/notifications?page=' + pagination.current_page, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function getDetailNotif(id, callback) {
  var config = getConfig();

  http.get('/promotion/notification/' + id, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

function submitNotification(dataBody, callback) {
  var config = getConfig();

  http.post('/promotion/notification', dataBody, config).then(function (response) {
    callback({
      success: true,
      data: response.data
    });
  }).catch(function (error) {
    callback({
      success: false,
      message: error.message
    });
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  submitNotification: submitNotification,
  getDetailNotif: getDetailNotif,
  getNotifSchedules: getNotifSchedules
});

/***/ }),
/* 956 */
/***/ (function(module, exports) {



/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  loggedIn: false,
  scopes: []
};

var mutations = {
  auth_authenticated: function auth_authenticated(state, payload) {
    state.loggedIn = true;
    state.scopes = payload;
  },
  auth_destroyed: function auth_destroyed(state) {
    state.loggedIn = false;
    state.scopes = [];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations });

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import moment from 'moment'

var state = {
  id: 0,
  bimbel_kelas: '',
  bimbel_kurikulum: '',
  bimbel_mapel: '',
  bimbel_name: '',
  bimbel_start: '',
  bimbel_end: '',
  bimbel_description: '',
  picture_url: null,

  //paket mapel
  mapel_name: '',
  mapel_grade: '',
  mapel_semester: '',
  mapel_kurikulum: '',
  mapel_mapel: ''
};

var mutations = {
  bimbel_reset: function bimbel_reset(state) {
    state.id = 0;
    state.bimbel_kelas = '';
    state.bimbel_kurikulum = '';
    state.bimbel_mapel = [];
    state.bimbel_name = '';
    state.bimbel_start = '';
    state.bimbel_end = '';
    state.bimbel_description = '';
  },
  bimbel_init: function bimbel_init(state, payload) {
    state.id = 0;
    state.bimbel_kelas = '';
    state.bimbel_kurikulum = '';
    state.bimbel_mapel = [];
    state.bimbel_name = '';
    state.bimbel_start = '';
    state.bimbel_end = '';
    state.bimbel_description = '';
  },
  bimbel_set_id: function bimbel_set_id(state, payload) {
    state.id = payload;
  },
  bimbel_set_bimbel_kelas: function bimbel_set_bimbel_kelas(state, payload) {
    state.bimbel_kelas = payload;
  },
  bimbel_set_bimbel_description: function bimbel_set_bimbel_description(state, payload) {
    state.bimbel_description = payload;
  },
  bimbel_set_bimbel_kurikulum: function bimbel_set_bimbel_kurikulum(state, payload) {
    state.bimbel_kurikulum = payload;
  },
  bimbel_set_bimbel_name: function bimbel_set_bimbel_name(state, payload) {
    state.bimbel_name = payload;
  },
  bimbel_set_bimbel_mapel: function bimbel_set_bimbel_mapel(state, payload) {
    state.bimbel_mapel = payload;
  },
  bimbel_set_bimbel_start: function bimbel_set_bimbel_start(state, payload) {
    state.bimbel_start = payload;
  },
  bimbel_set_bimbel_end: function bimbel_set_bimbel_end(state, payload) {
    state.bimbel_end = payload;
  },
  bimbel_set_picture_url: function bimbel_set_picture_url(state, payload) {
    state.picture_url = payload;
  },

  //paket mapel
  mapel_reset: function mapel_reset(state) {
    state.id = 0;
    state.mapel_grade = '';
    state.mapel_kurikulum = '';
    state.mapel_mapel = [];
    state.mapel_name = '';
    state.mapel_semester = '';
  },
  bimbel_set_mapel_name: function bimbel_set_mapel_name(state, payload) {
    state.mapel_name = payload;
  },
  bimbel_set_mapel_kurikulum: function bimbel_set_mapel_kurikulum(state, payload) {
    state.mapel_kurikulum = payload;
  },
  bimbel_set_mapel_grade: function bimbel_set_mapel_grade(state, payload) {
    state.mapel_grade = payload;
  },
  bimbel_set_mapel_mapel: function bimbel_set_mapel_mapel(state, payload) {
    state.mapel_mapel = payload;
  },
  bimbel_set_mapel_semester: function bimbel_set_mapel_semester(state, payload) {
    state.mapel_semester = payload;
  }
};

var getters = {
  //   openedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutStartTime = moment(tryout.start_date + ' ' + tryout.start_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutStartTime < time) time = Number(tryoutStartTime)
  //     })

  //     return time
  //   },
  //   closedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutEndTime = moment(tryout.end_date + ' ' + tryout.end_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime)
  //     })

  //     return time
  //   }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations, getters: getters });

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import moment from 'moment'

var state = {
  id: 0,
  url: '',
  description: '',
  title: '',
  grade: [],
  interest: 'ALL',
  mapel: '',
  thumbnail: '',
  source: '',
  duration: '',
  editContent: []
};

var mutations = {
  video_reset: function video_reset(state) {
    state.id = 0;
    state.url = '';
    state.description = '';
    state.title = '';
    state.grade = [];
    state.interest = 'ALL';
    state.mapel = '';
    state.thumnail = '';
    state.source = '';
    state.duration = '';
  },
  setEditDataContent: function setEditDataContent(state, data) {
    state.editContent = data;
  }
};

var getters = {
  //   openedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutStartTime = moment(tryout.start_date + ' ' + tryout.start_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutStartTime < time) time = Number(tryoutStartTime)
  //     })

  //     return time
  //   },
  //   closedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutEndTime = moment(tryout.end_date + ' ' + tryout.end_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime)
  //     })

  //     return time
  //   }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations, getters: getters });

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  filter: [],
  pageSize: 25,
  currentPage: 1,
  pageStart: 1,
  pageEnd: 10,
  maxPage: 1,
  orderBy: 'asc',
  context: ''
};

var mutations = {
  datatable_currentPage: function datatable_currentPage(state, payload) {
    state.currentPage = payload;
  },
  datatable_pageSize: function datatable_pageSize(state, payload) {
    state.pageSize = payload;
  },
  datatable_maxPage: function datatable_maxPage(state, payload) {
    state.maxPage = payload;
  },
  datatable_orderby: function datatable_orderby(state, payload) {
    state.orderBy = payload;
  },
  datatable_push_filter: function datatable_push_filter(state, payload) {
    state.filter.push(payload);
  },
  datatable_clear_filter: function datatable_clear_filter(state) {
    state.filter = [];
  },
  datatable_context: function datatable_context(state, payload) {
    state.context = payload;
  },
  datatable_pageStart: function datatable_pageStart(state, payload) {
    state.pageStart = payload;
  },
  datatable_pageEnd: function datatable_pageEnd(state, payload) {
    state.pageEnd = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  mutations: mutations
});

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  visible: false,
  message: ''
};

var mutations = {
  error_show: function error_show(state, payload) {
    state.message = payload;
    state.visible = true;
    window.scrollTo(0, 0);
  },
  error_dismiss: function error_dismiss(state) {
    state.message = '';
    state.visible = false;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations });

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  id: 0,
  code: '',
  name: '',
  category: 'OTHER',
  description: '',
  level: '',
  is_repeated: false,
  start_date: '',
  start_time: '',
  end_date: '',
  end_time: '',
  duration: 0,
  status: '',
  type: '',
  repeatitions: [],
  subtests: [],
  is_active: false,
  is_free_access: false,
  created_at: 0,
  updated_at: 0,
  subtestIndex: -1,
  selectedTO: []
};

var mutations = {
  tryout_init: function tryout_init(state, payload) {
    state.id = payload.id;
    state.code = payload.code;
    state.name = payload.name;
    state.description = payload.description;
    state.level = payload.level;
    state.is_repeated = payload.is_repeated;
    state.start_date = payload.start_date;
    state.start_time = payload.start_time;
    state.end_date = payload.end_date;
    state.end_time = payload.end_time;
    state.duration = payload.duration;
    state.status = payload.status;
    state.type = payload.type;

    var repeatitions = [];
    payload.repeatitions.forEach(function (element) {
      repeatitions.push(element.day);
    });

    state.repeatitions = repeatitions;
    state.subtests = payload.subtests;
    state.is_active = payload.is_active;
    state.is_free_access = payload.is_free_access;
    state.created_at = payload.created_at;
    state.updated_at = payload.updated_at;
    state.subtestIndex = -1;
    state.category = payload.category;
  },
  tryout_add_subtest: function tryout_add_subtest(state, payload) {
    var subtest = {
      id: payload.id,
      subject_code: payload.subject_code,
      subject_name: payload.subject_name,
      subject_picture: payload.subject_picture,
      duration: payload.duration,
      item_count: payload.item_count,
      details: payload.details
    };

    if (state.subtests == null) state.subtests = [];
    state.subtests.push(subtest);
  },
  tryout_edit_subtest: function tryout_edit_subtest(state, payload) {
    var subtest = {
      id: payload.id,
      subject_code: payload.subject_code,
      subject_name: payload.subject_name,
      subject_picture: payload.subject_picture,
      duration: payload.duration,
      item_count: payload.item_count,
      details: payload.details
    };

    var index = state.subtestIndex;
    state.subtests[index] = subtest;
  },
  tryout_select_subtest: function tryout_select_subtest(state, subtestIndex) {
    state.subtestIndex = subtestIndex;
  },
  tryout_reset_selected_subtest: function tryout_reset_selected_subtest(state) {
    state.subtestIndex = -1;
  },
  tryout_reset: function tryout_reset(state) {
    state.id = 0;
    state.code = '';
    state.name = '';
    state.description = '';
    state.level = '';
    state.is_repeated = false;
    state.start_date = '';
    state.start_time = '';
    state.end_date = '';
    state.end_time = '';
    state.duration = 0;
    state.status = '';
    state.type = '';
    state.repeatitions = [];
    state.subtests = [];
    state.is_active = false;
    state.is_free_access = false;
    state.created_at = 0;
    state.updated_at = 0;
    state.subtestIndex = -1;
    state.category = 'OTHER';
  },
  tryoutSelected: function tryoutSelected(state, payload) {
    state.selectedTO = payload;
  }
};

var getters = {
  selectedSubtest: function selectedSubtest(state) {
    if (state.subtestIndex < 0) return null;

    return state.subtests[state.subtestIndex];
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations, getters: getters });

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);


var state = {
  id: 0,
  name: '',
  description: '',
  level: '',
  status: 'DRAFT',
  type: 'SBMPTN',
  variant: 'SCHEDULED',
  tryouts: [],
  joinCode: '',
  opened_at: 0,
  closed_at: 0,
  created_at: 0,
  discussion_opened_at: 0,
  discussion_special_at: 0,
  isSticky: false,
  isPrivate: false,
  grade: [],
  dependency_id: null,
  source_id: null
};

var mutations = {
  tryout_group_reset: function tryout_group_reset(state) {
    state.id = 0;
    state.name = '';
    state.description = '';
    state.level = '';
    state.type = 'SBMPTN';
    state.variant = 'SCHEDULED';
    state.created_at = 0;
    state.status = 'DRAFT';
    state.tryouts = [], state.joinCode = '', state.opened_at = 0;
    state.closed_at = 0;
    state.discussion_opened_at = 0, state.discussion_special_at = 0, state.grade = [];
    state.isSticky = false, state.isPrivate = false, state.dependency_id = null;
    state.source_id = null;
  },
  tryout_group_init: function tryout_group_init(state, payload) {
    state.id = payload.id;
    state.name = payload.name;
    state.description = payload.description;
    state.level = payload.level;
    state.type = payload.type;
    state.variant = payload.variant;
    state.created_at = payload.type;
    state.status = payload.status;
    state.tryouts = payload.tryouts;
    state.joinCode = payload.join_code;
    state.opened_at = payload.opened_at;
    state.closed_at = payload.closed_at;
    state.discussion_opened_at = payload.discussion_opened_at;
    state.discussion_special_at = payload.discussion_special_at;
    state.grade = payload.grade == null ? payload.grades : [payload.grade], state.isSticky = payload.is_sticky, state.isPrivate = payload.is_private, state.source_id = payload.source !== null ? payload.source.id : null;
    state.dependency_id = payload.dependency_id;
  },
  tryout_group_set_id: function tryout_group_set_id(state, payload) {
    state.id = payload;
  },
  tryout_group_set_name: function tryout_group_set_name(state, payload) {
    state.name = payload;
  },
  tryout_group_set_description: function tryout_group_set_description(state, payload) {
    state.description = payload;
  },
  tryout_group_set_type: function tryout_group_set_type(state, payload) {
    state.type = payload;
  },
  tryout_group_set_variant: function tryout_group_set_variant(state, payload) {
    state.variant = payload;
  },
  tryout_group_set_join_code: function tryout_group_set_join_code(state, payload) {
    state.joinCode = payload;
  },
  tryout_group_add_tryout: function tryout_group_add_tryout(state, payload) {
    state.tryouts.push(payload);
  },
  tryout_group_remove_tryout: function tryout_group_remove_tryout(state, payload) {
    var index = state.tryouts.findIndex(function (element) {
      return element.id == payload.id;
    });

    if (index != -1) state.tryouts.splice(index, 1);
  },
  tryout_group_set_status: function tryout_group_set_status(state, payload) {
    state.status = payload;
  },
  tryout_group_set_grade: function tryout_group_set_grade(state, payload) {
    state.grade = payload;
  },
  tryout_group_set_is_sticky: function tryout_group_set_is_sticky(state, payload) {
    state.isSticky = payload;
  },
  tryout_group_set_is_private: function tryout_group_set_is_private(state, payload) {
    state.isPrivate = payload;
  },
  tryout_group_set_source_id: function tryout_group_set_source_id(state, payload) {
    state.source_id = payload;
  },
  tryout_group_set_dependency_id: function tryout_group_set_dependency_id(state, payload) {
    state.dependency_id = payload;
  }
};

var getters = {
  openedAt: function openedAt(state) {
    var time = 0;
    state.tryouts.forEach(function (tryout) {
      var tryoutStartTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(tryout.start_date + ' ' + tryout.start_time, 'YYYY-MM-DD HH:mm').format('x');
      if (time == 0 || tryoutStartTime < time) time = Number(tryoutStartTime);
    });

    return time;
  },
  closedAt: function closedAt(state) {
    var time = 0;
    state.tryouts.forEach(function (tryout) {
      var tryoutEndTime = __WEBPACK_IMPORTED_MODULE_0_moment___default()(tryout.end_date + ' ' + tryout.end_time, 'YYYY-MM-DD HH:mm').format('x');
      if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime);
    });

    return time;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations, getters: getters });

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  user_id: 0,
  name: '',
  email: '',
  picture: '',
  phone_number: '',
  school: '',
  student_number: '',
  birth_date: '',
  grade: '',
  is_active: false,
  is_nf_student: false,
  expired_at: null,
  fitur: null,
  period: []
};

var mutations = {
  usman_init: function usman_init(state, payload) {
    state.user_id = payload.user_id;
    state.name = payload.name;
    state.email = payload.email;
    state.picture = payload.picture;
    state.phone_number = payload.phone_number;
    state.school = payload.school;
    state.student_number = payload.student_number;
    state.birth_date = payload.birth_date;
    state.grade = payload.grade;
    state.is_active = payload.is_active;
    state.is_nf_student = payload.is_nf_student, state.expired_at = payload.expired_at;
  },
  usman_set_fitur: function usman_set_fitur(state, payload) {
    state.fitur = payload;
  },
  usman_set_period: function usman_set_period(state, payload) {
    state.period = payload;
  },
  usman_set_grade: function usman_set_grade(state, payload) {
    state.grade = payload;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations });

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// import moment from 'moment'

var state = {
  id: 0,
  url: '',
  description: '',
  title: '',
  grade: [],
  interest: 'ALL',
  mapel: '',
  thumbnail: '',
  source: '',
  duration: ''
};

var mutations = {
  video_reset: function video_reset(state) {
    state.id = 0;
    state.url = '';
    state.description = '';
    state.title = '';
    state.grade = [];
    state.interest = 'ALL';
    state.mapel = '';
    state.thumnail = '';
    state.source = '';
    state.duration = '';
  },
  video_init: function video_init(state, payload) {
    state.id = payload.id;
    state.url = payload.url;
    state.description = payload.description;
    state.title = payload.title;
    state.grade = payload.grade;
    state.interest = payload.interest;
    state.mapel = payload.mapel;
    state.thumbnail = payload.thumbnail;
    state.source = payload.source;
    state.duration = payload.duration;
  },
  video_set_id: function video_set_id(state, payload) {
    state.id = payload;
  },
  video_set_url: function video_set_url(state, payload) {
    state.url = payload;
  },
  video_set_description: function video_set_description(state, payload) {
    state.description = payload;
  },
  video_set_title: function video_set_title(state, payload) {
    state.title = payload;
  },
  video_set_grade: function video_set_grade(state, payload) {
    state.grade = payload;
  },
  video_set_interest: function video_set_interest(state, payload) {
    state.interest = payload;
  },
  video_set_mapel: function video_set_mapel(state, payload) {
    state.mapel = payload;
  },
  video_set_thumbnail: function video_set_thumbnail(state, payload) {
    state.thumbnail = payload;
  },
  video_set_source: function video_set_source(state, payload) {
    state.source = payload;
  },
  video_set_duration: function video_set_duration(state, payload) {
    state.duration = payload;
  }
};

var getters = {
  //   openedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutStartTime = moment(tryout.start_date + ' ' + tryout.start_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutStartTime < time) time = Number(tryoutStartTime)
  //     })

  //     return time
  //   },
  //   closedAt: function(state) {
  //     var time = 0
  //     state.tryouts.forEach(function(tryout) {
  //       var tryoutEndTime = moment(tryout.end_date + ' ' + tryout.end_time, 'YYYY-MM-DD HH:mm').format('x')
  //       if (time == 0 || tryoutEndTime > time) time = Number(tryoutEndTime)
  //     })

  //     return time
  //   }
};

/* harmony default export */ __webpack_exports__["a"] = ({ state: state, mutations: mutations, getters: getters });

/***/ }),
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */,
/* 970 */,
/* 971 */,
/* 972 */,
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */,
/* 986 */,
/* 987 */,
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */,
/* 997 */,
/* 998 */,
/* 999 */,
/* 1000 */,
/* 1001 */,
/* 1002 */,
/* 1003 */,
/* 1004 */,
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */,
/* 1021 */,
/* 1022 */,
/* 1023 */,
/* 1024 */,
/* 1025 */,
/* 1026 */,
/* 1027 */,
/* 1028 */,
/* 1029 */,
/* 1030 */,
/* 1031 */,
/* 1032 */,
/* 1033 */,
/* 1034 */,
/* 1035 */,
/* 1036 */,
/* 1037 */,
/* 1038 */,
/* 1039 */,
/* 1040 */,
/* 1041 */,
/* 1042 */,
/* 1043 */,
/* 1044 */,
/* 1045 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 1046 */,
/* 1047 */,
/* 1048 */,
/* 1049 */,
/* 1050 */,
/* 1051 */,
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.5.4","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}

/***/ }),
/* 1057 */,
/* 1058 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1059 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1060 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1063 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1064 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1072 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1075 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1076 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1079 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1080 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */,
/* 1087 */,
/* 1088 */,
/* 1089 */,
/* 1090 */,
/* 1091 */,
/* 1092 */,
/* 1093 */,
/* 1094 */,
/* 1095 */,
/* 1096 */,
/* 1097 */,
/* 1098 */,
/* 1099 */,
/* 1100 */,
/* 1101 */,
/* 1102 */,
/* 1103 */,
/* 1104 */,
/* 1105 */,
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 218,
	"./af.js": 218,
	"./ar": 225,
	"./ar-dz": 219,
	"./ar-dz.js": 219,
	"./ar-kw": 220,
	"./ar-kw.js": 220,
	"./ar-ly": 221,
	"./ar-ly.js": 221,
	"./ar-ma": 222,
	"./ar-ma.js": 222,
	"./ar-sa": 223,
	"./ar-sa.js": 223,
	"./ar-tn": 224,
	"./ar-tn.js": 224,
	"./ar.js": 225,
	"./az": 226,
	"./az.js": 226,
	"./be": 227,
	"./be.js": 227,
	"./bg": 228,
	"./bg.js": 228,
	"./bm": 229,
	"./bm.js": 229,
	"./bn": 231,
	"./bn-bd": 230,
	"./bn-bd.js": 230,
	"./bn.js": 231,
	"./bo": 232,
	"./bo.js": 232,
	"./br": 233,
	"./br.js": 233,
	"./bs": 234,
	"./bs.js": 234,
	"./ca": 235,
	"./ca.js": 235,
	"./cs": 236,
	"./cs.js": 236,
	"./cv": 237,
	"./cv.js": 237,
	"./cy": 238,
	"./cy.js": 238,
	"./da": 239,
	"./da.js": 239,
	"./de": 242,
	"./de-at": 240,
	"./de-at.js": 240,
	"./de-ch": 241,
	"./de-ch.js": 241,
	"./de.js": 242,
	"./dv": 243,
	"./dv.js": 243,
	"./el": 244,
	"./el.js": 244,
	"./en-au": 245,
	"./en-au.js": 245,
	"./en-ca": 246,
	"./en-ca.js": 246,
	"./en-gb": 247,
	"./en-gb.js": 247,
	"./en-ie": 248,
	"./en-ie.js": 248,
	"./en-il": 249,
	"./en-il.js": 249,
	"./en-in": 250,
	"./en-in.js": 250,
	"./en-nz": 251,
	"./en-nz.js": 251,
	"./en-sg": 252,
	"./en-sg.js": 252,
	"./eo": 253,
	"./eo.js": 253,
	"./es": 257,
	"./es-do": 254,
	"./es-do.js": 254,
	"./es-mx": 255,
	"./es-mx.js": 255,
	"./es-us": 256,
	"./es-us.js": 256,
	"./es.js": 257,
	"./et": 258,
	"./et.js": 258,
	"./eu": 259,
	"./eu.js": 259,
	"./fa": 260,
	"./fa.js": 260,
	"./fi": 261,
	"./fi.js": 261,
	"./fil": 262,
	"./fil.js": 262,
	"./fo": 263,
	"./fo.js": 263,
	"./fr": 266,
	"./fr-ca": 264,
	"./fr-ca.js": 264,
	"./fr-ch": 265,
	"./fr-ch.js": 265,
	"./fr.js": 266,
	"./fy": 267,
	"./fy.js": 267,
	"./ga": 268,
	"./ga.js": 268,
	"./gd": 269,
	"./gd.js": 269,
	"./gl": 270,
	"./gl.js": 270,
	"./gom-deva": 271,
	"./gom-deva.js": 271,
	"./gom-latn": 272,
	"./gom-latn.js": 272,
	"./gu": 273,
	"./gu.js": 273,
	"./he": 274,
	"./he.js": 274,
	"./hi": 275,
	"./hi.js": 275,
	"./hr": 276,
	"./hr.js": 276,
	"./hu": 277,
	"./hu.js": 277,
	"./hy-am": 278,
	"./hy-am.js": 278,
	"./id": 279,
	"./id.js": 279,
	"./is": 280,
	"./is.js": 280,
	"./it": 282,
	"./it-ch": 281,
	"./it-ch.js": 281,
	"./it.js": 282,
	"./ja": 283,
	"./ja.js": 283,
	"./jv": 284,
	"./jv.js": 284,
	"./ka": 285,
	"./ka.js": 285,
	"./kk": 286,
	"./kk.js": 286,
	"./km": 287,
	"./km.js": 287,
	"./kn": 288,
	"./kn.js": 288,
	"./ko": 289,
	"./ko.js": 289,
	"./ku": 290,
	"./ku.js": 290,
	"./ky": 291,
	"./ky.js": 291,
	"./lb": 292,
	"./lb.js": 292,
	"./lo": 293,
	"./lo.js": 293,
	"./lt": 294,
	"./lt.js": 294,
	"./lv": 295,
	"./lv.js": 295,
	"./me": 296,
	"./me.js": 296,
	"./mi": 297,
	"./mi.js": 297,
	"./mk": 298,
	"./mk.js": 298,
	"./ml": 299,
	"./ml.js": 299,
	"./mn": 300,
	"./mn.js": 300,
	"./mr": 301,
	"./mr.js": 301,
	"./ms": 303,
	"./ms-my": 302,
	"./ms-my.js": 302,
	"./ms.js": 303,
	"./mt": 304,
	"./mt.js": 304,
	"./my": 305,
	"./my.js": 305,
	"./nb": 306,
	"./nb.js": 306,
	"./ne": 307,
	"./ne.js": 307,
	"./nl": 309,
	"./nl-be": 308,
	"./nl-be.js": 308,
	"./nl.js": 309,
	"./nn": 310,
	"./nn.js": 310,
	"./oc-lnc": 311,
	"./oc-lnc.js": 311,
	"./pa-in": 312,
	"./pa-in.js": 312,
	"./pl": 313,
	"./pl.js": 313,
	"./pt": 315,
	"./pt-br": 314,
	"./pt-br.js": 314,
	"./pt.js": 315,
	"./ro": 316,
	"./ro.js": 316,
	"./ru": 317,
	"./ru.js": 317,
	"./sd": 318,
	"./sd.js": 318,
	"./se": 319,
	"./se.js": 319,
	"./si": 320,
	"./si.js": 320,
	"./sk": 321,
	"./sk.js": 321,
	"./sl": 322,
	"./sl.js": 322,
	"./sq": 323,
	"./sq.js": 323,
	"./sr": 325,
	"./sr-cyrl": 324,
	"./sr-cyrl.js": 324,
	"./sr.js": 325,
	"./ss": 326,
	"./ss.js": 326,
	"./sv": 327,
	"./sv.js": 327,
	"./sw": 328,
	"./sw.js": 328,
	"./ta": 329,
	"./ta.js": 329,
	"./te": 330,
	"./te.js": 330,
	"./tet": 331,
	"./tet.js": 331,
	"./tg": 332,
	"./tg.js": 332,
	"./th": 333,
	"./th.js": 333,
	"./tk": 334,
	"./tk.js": 334,
	"./tl-ph": 335,
	"./tl-ph.js": 335,
	"./tlh": 336,
	"./tlh.js": 336,
	"./tr": 337,
	"./tr.js": 337,
	"./tzl": 338,
	"./tzl.js": 338,
	"./tzm": 340,
	"./tzm-latn": 339,
	"./tzm-latn.js": 339,
	"./tzm.js": 340,
	"./ug-cn": 341,
	"./ug-cn.js": 341,
	"./uk": 342,
	"./uk.js": 342,
	"./ur": 343,
	"./ur.js": 343,
	"./uz": 345,
	"./uz-latn": 344,
	"./uz-latn.js": 344,
	"./uz.js": 345,
	"./vi": 346,
	"./vi.js": 346,
	"./x-pseudo": 347,
	"./x-pseudo.js": 347,
	"./yo": 348,
	"./yo.js": 348,
	"./zh-cn": 349,
	"./zh-cn.js": 349,
	"./zh-hk": 350,
	"./zh-hk.js": 350,
	"./zh-mo": 351,
	"./zh-mo.js": 351,
	"./zh-tw": 352,
	"./zh-tw.js": 352
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1106;

/***/ }),
/* 1107 */,
/* 1108 */,
/* 1109 */,
/* 1110 */,
/* 1111 */,
/* 1112 */,
/* 1113 */,
/* 1114 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 1115 */,
/* 1116 */,
/* 1117 */,
/* 1118 */,
/* 1119 */,
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */,
/* 1125 */,
/* 1126 */,
/* 1127 */,
/* 1128 */,
/* 1129 */,
/* 1130 */,
/* 1131 */,
/* 1132 */,
/* 1133 */,
/* 1134 */,
/* 1135 */,
/* 1136 */,
/* 1137 */,
/* 1138 */,
/* 1139 */,
/* 1140 */,
/* 1141 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAhwAAAEsCAMAAAC/spp+AAAA0lBMVEXIy9L////+/v7t7vHO0dfs7fDQ09nt7vDf4eXv8PLJzNP7+/zk5en29vf09fb9/f3Z2+D4+PnJzNLh4+fKzdPc3uL7/PzW2d739/jr7O7LzdTq6+7KzdTa3OHY2t/c3eL8/P3U1tze4OT19ff6+/vZ29/X2d7n6OvP0tjV193p6+3Mz9Xy8vTp6u39/f7x8fPw8fPMztX3+Pnb3eL6+vru7/HNz9bP0dfq7O7j5Ojz8/Xd3+PV19zl5urR1Nn5+frW2N709Pb8/Pzb3eHl5+re3+T6wXOtAAADdklEQVR4XuzAMQEAAADCIPunNsU+WAwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADj79rXjNhJFUfSeIkUxiApW6uBOznGcw+T8/780FmSJ3VLJgNEkMGTt9QH1tIHzUjdOs7LQLRVllsbWLUgi1SZKrEMwcKqRG1hXYBapZtHMugGRahdZJ2CgBnRiWZA4NcAl1l2MCsOCWA2Jre2QqiGptR0ybQ2XJ3YrJ8uhtjJrO5RVG7ndWl7VUVrbodDG0mqw1EZhbQdtnVgNTrRl3UEc/4P3QBwgjs4ijvzpfJqOY+LYRRzJ8UIrGt4jjuuII3/stHV0RRxbxPHmha4bXRDHV8SRv9BN7pw41ojjsXYtYuIgjkO/f46JY4U4jrXPPSEO4jDLF/KYEgdxmD2VzyviIA6zuXwmxEEcZlP5jIiDOMxS+TwgDuIwG8vnPnEQx6FbhVPiII4vhvJ4SBxfEMc97ZvkxEEcK0faM7cV4iCOq9F3Hb4++jx5e5qEEQdx2IXTDcO7dlD+TCuX4zDiIA47X6ii6Btt3PmgNTcOIw7isPjY6avJ3A67E2njh3EocXCa8GT6ajJ6cP/0Yf6tNvrStTqIo8LdSl/XuTFxEIe/DcmdEccacfS0y/1NHMThb0Nyc+IgDn8bkhNxEEdPfsRBHD35EQdx9EQcxPF9bRAHcfQUehzE8S5bvH/50ddG6HEQR18rk0+eNgKPgzheau3ouaeNoOMgjh+18dPM00bAcRDHz6pkO1sTdhzEce78Ryt9hR4Hcfwy0g2/Vm0EHgdx/FZoR1r9+wo6DuKIf9cud1a1EXAcxPH8SPtGf1RtBBsHcdz9Uz5/vVbocRBHfjCC4OMgjr78iIM4nsmPOIjjH/kRB3FM5UccxPGv/IiDOM4ccfgRx6OR/IiDOC51A3FAFeIAcYA4QBwgDhAHiKMNUKghhbUdSjWktLZDpoZk1nZI1ZDU2g6xGhJb6yFSIyJrPyRODXCJdQAGasDAuo1hYVQwq72OaGZdgYFTjVynNgVJpNpEiXUL4jQrC91SUWZp/F87cEADAACAMMj+qe3xwToAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOCDXSmxdiXFSAAAAABJRU5ErkJggg=="

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/phone_frame.98a46d3.png";

/***/ }),
/* 1143 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAdCAYAAAC5UQwxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGbSURBVHgBvZdBTsJAFIbfjBXjjiPgDVgSggkbE1KiCTcoR+AE0hOoJwBPAJsKO5pAiDu5gRyhKxAo83xTQaS2hLbT/kmbJm8m3/yTv29aBjtVe9X85uraQGSOWAv7vTGcQwpi8la29CIHNgLA/G+FQ9v9Eq+qwdy7IescwaQEtC9yfESLMUChPIcVS8dTg6g4p8uc1t+6kAXwMBptd4XNJNvMI41GVtVy/PPW0julXq0AMRTN4f/J3c1amFEcR3PoE63SkMGqDPTHc+ckcuiDnxUsZcC/YCZEc3I/tIPqibY0SOSgAJyPwoKl3GEA4ChYyh36JYNFr9JH2borZgLcKc+Z9pQl0Gsa2QIBZ1kCHbYFUz5okLaQGv7m0PDTAxKILtPfAJQDEXDOt9AaPwz6QXWVQIe+El4u3eWz3bCdsEEqgB5IcxcnQUqAcc7DeMBdIMYhJ4JK4AyEaE1igKICHQGiNa0Pu5BQ+04zCwNRIExtvbhRAZP6cUjbJA/No4pASt6yfU7yoojtH0qDWkFzuYEX6GxX2E/r3+IbttHIi6+Ri6gAAAAASUVORK5CYII="

/***/ }),
/* 1144 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1145 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1146 */
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),
/* 1147 */,
/* 1148 */,
/* 1149 */,
/* 1150 */,
/* 1151 */,
/* 1152 */,
/* 1153 */,
/* 1154 */,
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(817),
  /* template */
  __webpack_require__(1292),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(818),
  /* template */
  __webpack_require__(1364),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(819),
  /* template */
  __webpack_require__(1322),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(820),
  /* template */
  __webpack_require__(1390),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(822),
  /* template */
  __webpack_require__(1343),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1059)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(823),
  /* template */
  __webpack_require__(1283),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1060)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(824),
  /* template */
  __webpack_require__(1287),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-163a96cf",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1076)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(1385),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-af7309b2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1063)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(826),
  /* template */
  __webpack_require__(1313),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2bce549a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(827),
  /* template */
  __webpack_require__(1297),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(1294),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1075)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(829),
  /* template */
  __webpack_require__(1382),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(830),
  /* template */
  __webpack_require__(1369),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(831),
  /* template */
  __webpack_require__(1326),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(832),
  /* template */
  __webpack_require__(1275),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(833),
  /* template */
  __webpack_require__(1392),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(1380),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(835),
  /* template */
  __webpack_require__(1368),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(836),
  /* template */
  __webpack_require__(1363),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(837),
  /* template */
  __webpack_require__(1401),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(1288),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(839),
  /* template */
  __webpack_require__(1321),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(840),
  /* template */
  __webpack_require__(1373),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(841),
  /* template */
  __webpack_require__(1296),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(842),
  /* template */
  __webpack_require__(1293),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(1318),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(844),
  /* template */
  __webpack_require__(1273),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(845),
  /* template */
  __webpack_require__(1300),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(1357),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(847),
  /* template */
  __webpack_require__(1312),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(848),
  /* template */
  __webpack_require__(1320),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(1323),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(850),
  /* template */
  __webpack_require__(1348),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(1327),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(852),
  /* template */
  __webpack_require__(1378),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(1342),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(1365),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(1381),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(856),
  /* template */
  __webpack_require__(1366),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1070)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(857),
  /* template */
  __webpack_require__(1356),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(1386),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(859),
  /* template */
  __webpack_require__(1295),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(860),
  /* template */
  __webpack_require__(1358),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(861),
  /* template */
  __webpack_require__(1337),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(1285),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(1394),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(1277),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(865),
  /* template */
  __webpack_require__(1383),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(866),
  /* template */
  __webpack_require__(1339),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(1306),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(1317),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(869),
  /* template */
  __webpack_require__(1301),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(1344),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(871),
  /* template */
  __webpack_require__(1325),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(872),
  /* template */
  __webpack_require__(1351),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(873),
  /* template */
  __webpack_require__(1374),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(874),
  /* template */
  __webpack_require__(1304),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(1310),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(876),
  /* template */
  __webpack_require__(1308),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(877),
  /* template */
  __webpack_require__(1395),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(1336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(879),
  /* template */
  __webpack_require__(1280),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(880),
  /* template */
  __webpack_require__(1370),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(881),
  /* template */
  __webpack_require__(1299),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(882),
  /* template */
  __webpack_require__(1379),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(883),
  /* template */
  __webpack_require__(1305),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(1360),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1079)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(885),
  /* template */
  __webpack_require__(1400),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f16ccf88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(886),
  /* template */
  __webpack_require__(1289),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(1332),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(888),
  /* template */
  __webpack_require__(1302),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(889),
  /* template */
  __webpack_require__(1278),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1062)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(890),
  /* template */
  __webpack_require__(1311),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(891),
  /* template */
  __webpack_require__(1279),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(892),
  /* template */
  __webpack_require__(1349),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1067)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(893),
  /* template */
  __webpack_require__(1340),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(894),
  /* template */
  __webpack_require__(1353),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1064)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(1319),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(896),
  /* template */
  __webpack_require__(1359),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(1274),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(1361),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(908),
  /* template */
  __webpack_require__(1352),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(909),
  /* template */
  __webpack_require__(1398),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(1389),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(911),
  /* template */
  __webpack_require__(1388),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(912),
  /* template */
  __webpack_require__(1347),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(913),
  /* template */
  __webpack_require__(1350),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(1371),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(915),
  /* template */
  __webpack_require__(1331),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(916),
  /* template */
  __webpack_require__(1272),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(917),
  /* template */
  __webpack_require__(1298),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(918),
  /* template */
  __webpack_require__(1281),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(919),
  /* template */
  __webpack_require__(1384),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(920),
  /* template */
  __webpack_require__(1316),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(1355),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(922),
  /* template */
  __webpack_require__(1330),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(923),
  /* template */
  __webpack_require__(1387),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(924),
  /* template */
  __webpack_require__(1290),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(925),
  /* template */
  __webpack_require__(1314),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1072)
}
var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(927),
  /* template */
  __webpack_require__(1367),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(928),
  /* template */
  __webpack_require__(1291),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(929),
  /* template */
  __webpack_require__(1303),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(1341),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(931),
  /* template */
  __webpack_require__(1397),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(1354),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(933),
  /* template */
  __webpack_require__(1345),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(935),
  /* template */
  __webpack_require__(1376),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(937),
  /* template */
  __webpack_require__(1309),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(938),
  /* template */
  __webpack_require__(1333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(939),
  /* template */
  __webpack_require__(1315),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(940),
  /* template */
  __webpack_require__(1329),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(941),
  /* template */
  __webpack_require__(1377),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(942),
  /* template */
  __webpack_require__(1324),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(1334),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(944),
  /* template */
  __webpack_require__(1335),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(945),
  /* template */
  __webpack_require__(1396),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(946),
  /* template */
  __webpack_require__(1284),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1272 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Tryout")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar Tryout Serial")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Tryout Serial")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createSerial()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tryout Serial")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Tryout Group")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.rows,
      "has-action": true,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editRow($event)
      },
      "deleted": function($event) {
        return _vm.deleteSerial($event)
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1273 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content Article")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Artikel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('section_id') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Section *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.section_id),
      expression: "form.section_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listSection), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('name') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('description') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('link') >= 0 || !_vm.is_url_valid, 'has-success': _vm.is_url_valid
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link),
      expression: "form.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload Gambar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.form.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.form.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('app-imagecropper', {
    attrs: {
      "aspectRatio": 0.5
    },
    on: {
      "finished": function($event) {
        return _vm.handleChangePicture($event)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('status') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PUBLISHED"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HIDDEN"
    }
  }, [_vm._v("Hidden")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Artikel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-text"
  }, [_vm._v("must start with "), _c('strong', [_vm._v("http://")]), _vm._v(" or "), _c('strong', [_vm._v("https://")])])
}]}

/***/ }),
/* 1274 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/ticket-usage'
      }
    }
  }, [_vm._v("List Ticket Usage")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Detail Ticket Usage")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Detail Ticket Usage")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("User ID : " + _vm._s(_vm.data.user_id))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "type", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_name),
      expression: "data.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "user_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_email),
      expression: "data.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "user_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tiket Tersisa")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ticket),
      expression: "data.ticket"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.ticket)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "ticket", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tiket yang Digunakan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.value),
      expression: "data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.description),
      expression: "data.description"
    }],
    staticClass: "form-control",
    attrs: {
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Picture")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.data.picture) ? _c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.picture
    }
  }) : _vm._e()])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1275 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/register-liga"
    }
  }, [_vm._v("Register Liga")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/season"
    }
  }, [_vm._v("Season")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/liga-personal"
    }
  }, [_vm._v("Liga Personal")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/liga-sekolah"
    }
  }, [_vm._v("Liga Sekolah")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trophy"
  }), _vm._v(" "), _c('span', [_vm._v("Duel")])])
}]}

/***/ }),
/* 1276 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "labelAutocomplete"
    }
  }, [_c('ul', {
    staticClass: "list-group",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "z-index": "999"
    }
  }, _vm._l((_vm.filteredLabels), function(label, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.$emit('selected', label)
        }
      }
    }, [_vm._v(_vm._s(label))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1277 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-wacana"
    }
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCreateWacanaModal = true
      }
    }
  }, [_vm._v("Buat Baru")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Pilih")]), _vm._v(" "), (_vm.wacana.id != 0) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editWacana
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.wacana.id != 0) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmation = true
      }
    }
  }, [_vm._v("\n    Reset\n  ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.wacana.id != 0) ? _c('blockquote', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewWacana)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    on: {
      "ok": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cari Wacana")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('app-datatable', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.wacanas,
      "numbered": false
    },
    on: {
      "selected": function($event) {
        _vm.wacana = {
          id: $event.id,
          content: $event.data[0]
        }
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showConfirmation) ? _c('app-modal', {
    on: {
      "ok": _vm.resetWacana
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Perhatian")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', [_vm._v("Apakah anda yakin ingin melepas wacana ini dari soal?")])])]) : _vm._e(), _vm._v(" "), (_vm.showCreateWacanaModal) ? _c('app-modal', {
    on: {
      "ok": _vm.saveWacana
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Buat Wacana Baru")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.wacana.content
    },
    on: {
      "content-updated": function($event) {
        _vm.wacana.content = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveWacana()
      }
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCreateWacanaModal = false
      }
    }
  }, [_vm._v("Batal")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1278 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "metode-pembayaran"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Metode Pembayaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("List Metode Pembayaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createMetodePembayaran()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Metode Pembayaran")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateAllMetodePembayaranStatus(_vm.status.PUBLISH)
      }
    }
  }, [_vm._v("Publish All")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateAllMetodePembayaranStatus(_vm.status.UNPUBLISH)
      }
    }
  }, [_vm._v("Unpublish All")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Metode Pembayaran")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.metodePembayaranList,
      "has-action": true,
      "headers": _vm.headers,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-items": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateMetodePembayaran()
      },
      "deleted": function($event) {
        return _vm.deleteMetodePembayaran($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAction "), _c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 1279 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/pembayaran"
    }
  }, [_vm._v("Pembayaran User")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/produk"
    }
  }, [_vm._v("Produk")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/metode-pembayaran"
    }
  }, [_vm._v("Metode Pembayaran")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/ticket-usage"
    }
  }, [_vm._v("Ticket Usage")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/katalog-tiket"
    }
  }, [_vm._v("Katalog Tiket")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" "), _c('span', [_vm._v("Pembayaran")])])
}]}

/***/ }),
/* 1280 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/modul-belajar",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-book"
  }), _c('span', [_vm._v("Modul Belajar")])])])
},staticRenderFns: []}

/***/ }),
/* 1281 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/teachers'
    }
  }, [_vm._v("Aktivasi Guru")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Guru Detail")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Informasi Detail Guru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.teacher.name))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v("\n                      " + _vm._s(_vm.teacher.employee_id) + "\n                      ")])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.teacher.email))])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [(_vm.teacher.is_verified) ? _c('span', [_vm._v("Aktif")]) : _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("Terdaftar")])])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_c('date-picker', {
    attrs: {
      "value-type": "timestamp",
      "valueType": "format"
    },
    model: {
      value: (_vm.expiredAtModel),
      callback: function($$v) {
        _vm.expiredAtModel = $$v
      },
      expression: "expiredAtModel"
    }
  })], 1)]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_vm._l((_vm.teacher.scopes), function(item, index) {
    return _c('button', {
      key: index,
      staticClass: "btn btn-info",
      staticStyle: {
        "margin": "0px 5px 5px 5px"
      },
      on: {
        "click": function($event) {
          return _vm.removeMapel(item)
        }
      }
    }, [_vm._v("\n                        " + _vm._s(item.display_name) + " "), _c('i', {
      staticClass: "fa fa-close"
    })])
  }), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    staticStyle: {
      "max-height": "300px",
      "overflow": "auto !important"
    }
  }, _vm._l((_vm.mapels), function(item, index) {
    return _c('li', {
      key: index,
      on: {
        "click": function($event) {
          return _vm.addMapel(item)
        }
      }
    }, [_c('a', [_vm._v(_vm._s(item.displayName))])])
  }), 0)], 2)]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        return _vm.updateTanggalScope(_vm.teacher)
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.teacher.is_verified ? 'Simpan' : 'Aktifkan') + "\n                      ")])])])])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Guru Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Nama Guru")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("No Pegawai")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Tanggal Expired")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Mata Pelajaran")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])
}]}

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modal"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow-y": "scroll",
      "max-height": "250px"
    }
  }, [_vm._t("body")], 2), _vm._v(" "), (!_vm.cancelOnly) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.$emit('ok')
        }
      }
    }, [_vm._v("OK")]), _vm._v(" "), (_vm.withCancel) ? _c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          return _vm.$emit('cancel')
        }
      }
    }, [_vm._v("Cancel")]) : _vm._e()]
  })], 2) : _vm._e(), _vm._v(" "), (_vm.cancelOnly) ? _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-danger",
      on: {
        "click": function($event) {
          return _vm.$emit('cancel')
        }
      }
    }, [_vm._v("Cancel")])]
  })], 2) : _vm._e()])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/bimbel'
      }
    }
  }, [_vm._v("Paket Bimbel")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Tambah Paket Bimbel")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Paket Bimbel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Paket*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticStyle: {
      "min-width": "350px",
      "border": "solid lightgray 1px"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("URL Gambar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.picture_url),
      expression: "picture_url"
    }],
    staticStyle: {
      "min-width": "450px",
      "border": "solid lightgray 1px"
    },
    domProps: {
      "value": (_vm.picture_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.picture_url = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kurikulum*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kurikulum),
      expression: "kurikulum"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kurikulum = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.kurikulumList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Start Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_time),
      expression: "start_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "startTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "start_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("End Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_time),
      expression: "end_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mata Pelajaran*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-xs-12",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('button', {
    staticClass: "btn btn-success pull-left mb-3",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openMapel()
      }
    }
  }, [_vm._v("Pilih")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative"
    }
  }, _vm._l((_vm.selectedMapel), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "border": "1px solid lightgray",
        "padding": "5px",
        "width": "fit-content",
        "margin-bottom": "5px"
      }
    }, [_vm._v("\n                      " + _vm._s(item.data[1]) + "\n                        "), _c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.deleteMapel(index)
        }
      }
    })])
  }), 0)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.params.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "mapelmodal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLongTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "list-group"
  }, _vm._l((_vm.listMapelPackage), function(item, index) {
    return _c('a', {
      key: index,
      staticClass: "list-group-item list-group-item-action",
      attrs: {
        "data-dismiss": "modal",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          return _vm.selectMapel(item)
        }
      }
    }, [_vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }), 0)])])])]), _vm._v(" "), _c('app-mapelchooser', {
    ref: "mapelChooser",
    attrs: {
      "params": {
        grade: '',
        status: 'PUBLISHED',
        type: '',
        variant: ''
      }
    },
    on: {
      "dblClicked": function($event) {
        return _vm.mapelSelected($event)
      }
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Paket Bimbel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Pilih Paket Mata Pelajaran")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),
/* 1284 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Voucher")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Kode Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/voucher/form')
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Voucher")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Kode Voucher")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.channelSelected),
      expression: "channelSelected"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.channelSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Filter By Channel")]), _vm._v(" "), _vm._l((_vm.listChannel), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('model-select', {
    attrs: {
      "options": _vm.productList,
      "placeholder": "Filter By Product"
    },
    model: {
      value: (_vm.productSelected),
      callback: function($$v) {
        _vm.productSelected = $$v
      },
      expression: "productSelected"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortSelected),
      expression: "sortSelected"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("Sort By Inventori")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v("Ascending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v("Descending")])])]), _vm._v(" "), (_vm.channelSelected || _vm.productSelected || _vm.sortSelected) ? _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-md",
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Clear Filter")])]) : _vm._e()])]), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "has-soldout-warning": true,
      "items": _vm.voucherList,
      "has-action": true,
      "has-add-quota": true,
      "has-search-power": false,
      "has-delete": false,
      "has-custom-pagination": true,
      "custom-pagination-current-page": _vm.currentPage,
      "custom-pagination-per-page": _vm.paging.limit,
      "custom-pagination-total-pages": _vm.paging.total_page,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "addQuota": function($event) {
        return _vm.addQuota($event)
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" " + _vm._s(_vm.paging.total_page) + " ")])]), _vm._v(" "), (_vm.paging.total_page > 1) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage == 1
    },
    on: {
      "click": function($event) {
        return _vm.changePage(-1)
      }
    }
  }, [_vm._v("\n                          Previous\n                        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "readonly": "",
      "max": _vm.paging.total_page
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button",
      "disabled": _vm.currentPage == _vm.paging.total_page
    },
    on: {
      "click": function($event) {
        return _vm.changePage(1)
      }
    }
  }, [_vm._v("\n                          Next\n                        ")])]) : _vm._e()])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "myModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Nama Channel")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.voucherSelected.data[0]) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Nama Product")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', {
    staticStyle: {
      "word-break": "break-all !important"
    }
  }, [_vm._v(_vm._s(_vm.voucherSelected.data[1]) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_vm._v("Tambah Kuota (Kuota Saat ini: " + _vm._s(_vm.voucherSelected.data[2]) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quota),
      expression: "quota"
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-width": "100px",
      "margin-top": "10px"
    },
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.quota)
    },
    on: {
      "click": function($event) {
        _vm.quota = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quota = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeQuota()
      }
    }
  }, [_vm._v("Tambah Kuota")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.$('#myModal').modal('hide')
      }
    }
  }, [_vm._v("Batal")])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLabel"
    }
  }, [_vm._v("Tambah Kuota")])])
}]}

/***/ }),
/* 1285 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('subnavigation', {
      key: index,
      attrs: {
        "item": item
      }
    })
  }), 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', [_vm._v("Bank Soal")])])
}]}

/***/ }),
/* 1286 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-imagecropper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    attrs: {
      "id": "fileUpload",
      "type": "file",
      "hidden": "",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.chooseFiles()
      }
    }
  }, [_vm._v("Pilih Gambar")])])]), _vm._v(" "), (_vm.showCropModal) ? _c('app-modal', {
    attrs: {
      "withCancel": "true"
    },
    on: {
      "cancel": function($event) {
        return _vm.cancelCrop()
      },
      "ok": function($event) {
        return _vm.confirmCrop()
      },
      "hook:mounted": function($event) {
        return _vm.cropImage()
      }
    }
  }, [_c('img', {
    ref: "previewImage",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "slot": "body",
      "src": _vm.previewImageUrl,
      "alt": "previewImage"
    },
    slot: "body"
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1287 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Paket Bimbel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Paket Bimbel")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Paket Bimbel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createVideo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Buat Paket")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Paket Bimbel")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.packageList,
      "has-action": true,
      "has-publish": true,
      "has-edit": true,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.showDetail($event)
      },
      "editNewTab": function($event) {
        return _vm.editPackage($event)
      },
      "deleted": function($event) {
        return _vm.deletePackage($event)
      },
      "publishing": function($event) {
        return _vm.publish($event)
      },
      "unpublishing": function($event) {
        return _vm.unpublish($event)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "myModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Nama Paket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.detailBimbel.name) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', {
    staticStyle: {
      "word-break": "break-all !important"
    }
  }, [_vm._v(_vm._s(_vm.detailBimbel.description) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Jenjang")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.detailBimbel.jenjang) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.detailBimbel.grade) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Kurikulum")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.detailBimbel.kurikulum) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.detailBimbel.start_date) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("End Date")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_vm._v(": "), _c('b', [_vm._v(_vm._s(_vm.detailBimbel.end_date) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row m-5"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "position": "relative"
    }
  }, _vm._l((_vm.detailBimbel.mapel), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "border": "1px solid lightgray",
        "padding": "5px",
        "width": "fit-content",
        "margin-bottom": "5px",
        "color": "black"
      }
    }, [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLabel"
    }
  }, [_vm._v("DETAIL PAKET BIMBEL")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")])])
}]}

/***/ }),
/* 1288 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "season-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/register-liga'
      }
    }
  }, [_vm._v("List Register Liga")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Register Liga")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Register Liga")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Register Liga")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Register Liga")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.name),
      expression: "data.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.data.description,
      "context": _vm.data.description
    },
    on: {
      "content-updated": function($event) {
        _vm.data.description = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1289 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/pembayaran'
      }
    }
  }, [_vm._v("List Pembayaran User")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Manual Input")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Manual Input Transaksi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _c('br'), _vm._v(" "), (_vm.isUserValidated) ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.txtUserInfo),
      expression: "txtUserInfo"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "rows": "2",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.txtUserInfo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.txtUserInfo = $event.target.value
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.doQueryUser()
      }
    }
  }, [_vm._v("\n                    Check\n                  ")])])]), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Product")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.product_id),
      expression: "form.product_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "product_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.products), function(product) {
    return _c('option', {
      key: product.id,
      domProps: {
        "value": product.id
      }
    }, [_vm._v("\n                      [" + _vm._s(product.type) + "] " + _vm._s(product.title) + "\n                    ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Payment Method")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payment_id),
      expression: "form.payment_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "payment_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.paymentMethods), function(paymentMethod) {
    return _c('option', {
      key: paymentMethod.id,
      domProps: {
        "value": paymentMethod.id
      }
    }, [_vm._v("\n                      [" + _vm._s(paymentMethod.type) + "] " + _vm._s(paymentMethod.bank_name) + "\n                    ")])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("User Bank Name")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.bank_name),
      expression: "form.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "bank_name", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("User Bank Account")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.account_name),
      expression: "form.account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "account_name", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Payment Slip")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.form.payment_slip_url) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    ref: "banner",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.form.payment_slip_url,
      "alt": "avatar"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('app-imagecropper', {
    attrs: {
      "aspectRatio": 2
    },
    on: {
      "finished": function($event) {
        return _vm.onFileChanged($event)
      }
    }
  })], 1)])])]) : _vm._e()])])]), _vm._v(" "), (_vm.isUserValidated) ? _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("\n                SIMPAN\n              ")]), _c('br')])])]) : _vm._e()])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Input Transaksi")])])
}]}

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-review"
    }
  }, [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kode Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.code))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenis Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$store.state.tryout.is_repeated) ? _c('strong', [_vm._v("INSTANT")]) : _c('strong', [_vm._v("BERJANGKA")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang / Jenis")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.level) + " / " + _vm._s(_vm.$store.state.tryout.type))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Durasi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.duration) + " menit")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Opsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$store.state.tryout.is_free_access) ? _c('strong', [_vm._v("Akses Gratis")]) : _vm._e(), _c('br'), _vm._v(" "), (_vm.$store.state.tryout.is_repeated) ? _c('strong', [_vm._v("Tryout Berulang")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.start_date) + " " + _vm._s(_vm.$store.state.tryout.start_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Berakhir")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.end_date) + " " + _vm._s(_vm.$store.state.tryout.end_time))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Subtests")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.tryout.subtests), function(subtest, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "subject-picture",
      attrs: {
        "src": subtest.subject_picture
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subtest.subject_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subtest.details.length))])])
  }), 0)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(_vm.isDraft) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmReview()
      }
    }
  }, [_vm._v("Ubah Status Ke REVIEW")]) : _vm._e(), _vm._v(" "), (_vm.isReviewed) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmDraft()
      }
    }
  }, [_vm._v("Kembali ke DRAFT")]) : _vm._e(), _vm._v(" "), (_vm.isReviewed) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.confirmPublish()
      }
    }
  }, [_vm._v("Ubah Status ke PUBLISHED")]) : _vm._e()]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("#")]), _vm._v(" "), _c('td', [_vm._v("Gambar")]), _vm._v(" "), _c('td', [_vm._v("Mata Pelajaran")]), _vm._v(" "), _c('td', [_vm._v("Jumlah Soal")])])])
}]}

/***/ }),
/* 1291 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Tryout")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar Tryout")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.importTryout()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Import Tryout")]), _vm._v("\n\t\t\t\t \n              \t"), _c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createTryout()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tryout")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Tryout")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.tryouts,
      "headers": _vm.headers,
      "has-action": false,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editTryout()
      },
      "export": function($event) {
        return _vm.exportTryout($event)
      },
      "generateTO": function($event) {
        return _vm.generateTryout($event)
      },
      "revisiTO": function($event) {
        return _vm.revisiTryout($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1292 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/affiliate-dashboard"
    }
  }, [_vm._v("Dashboard")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/affiliate-redeem"
    }
  }, [_vm._v("Redeem")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/affiliate-setting"
    }
  }, [_vm._v("Setting")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-dollar"
  }), _vm._v(" "), _c('span', [_vm._v("Affiliate")])])
}]}

/***/ }),
/* 1293 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/content/section'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Konten")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/article'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Artikel")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/video'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Video Gratis")])]), _vm._v(" "), _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, _vm._l((_vm.items), function(menu, index) {
    return _c('router-link', {
      key: index,
      attrs: {
        "to": {
          path: '/content/itembank?mapel=' + menu.id
        },
        "tag": "li"
      }
    }, [_c('a', [_vm._v(_vm._s(menu.nama))])])
  }), 1)]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/banner'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Banner")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/menu'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Menu")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/content/preview'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Pengaturan & Preview")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/config'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Pengaturan Aplikasi ")])]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/ads-setting'
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v("Pengaturan Iklan ")])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-gear"
  }), _vm._v(" "), _c('span', [_vm._v("Konfigurasi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('span', [_vm._v("Soal Gratis")])])
}]}

/***/ }),
/* 1294 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Paket Mata Pelajaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Paket Mata Pelajaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Paket Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createVideo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Paket")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Paket Mata Pelajaran")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.packageList,
      "has-action": true,
      "has-publish": true,
      "has-edit": true,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.showBab($event)
      },
      "editNewTab": function($event) {
        return _vm.editPackage($event)
      },
      "deleted": function($event) {
        return _vm.deletePackage($event)
      },
      "publishing": function($event) {
        return _vm.publish($event)
      },
      "unpublishing": function($event) {
        return _vm.unpublish($event)
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1295 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/ads-setting",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-gear"
  }), _c('span', [_vm._v("Konfigurasi Iklan")])])])
},staticRenderFns: []}

/***/ }),
/* 1296 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Dashboard")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Dashboard")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Dashboard "), _c('small', [_vm._v("this is an example of dashboard page...")])])])
}]}

/***/ }),
/* 1297 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/paket-mapel'
      }
    }
  }, [_vm._v("Paket Mata Pelajaran")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Tambah Paket Mata")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Paket Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Peminatan *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interest),
      expression: "interest"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "DEFAULT"
    }
  }, [_vm._v("ALL")]), _vm._v(" "), (_vm.kelas >= 10) ? _c('option', {
    attrs: {
      "value": "SAINTEK"
    }
  }, [_vm._v("IPA")]) : _vm._e(), _vm._v(" "), (_vm.kelas >= 10) ? _c('option', {
    attrs: {
      "value": "SOSHUM"
    }
  }, [_vm._v("IPS")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Semester")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.semester),
      expression: "semester"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.semester = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "GANJIL"
    }
  }, [_vm._v("Ganjil")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GENAP"
    }
  }, [_vm._v("Genap")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GANJILGENAP"
    }
  }, [_vm._v("Ganjil Genap")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kurikulum")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kurikulum),
      expression: "kurikulum"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kurikulum = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.kurikulumList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mapel),
      expression: "mapel"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mapel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.mapelList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.nama))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Initialize Content")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isInitContent),
      expression: "isInitContent"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isInitContent) ? _vm._i(_vm.isInitContent, null) > -1 : (_vm.isInitContent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isInitContent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isInitContent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isInitContent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isInitContent = $$c
        }
      }
    }
  }), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("(Optional)")]), _vm._v(" Dengan mencentang opsi ini maka sistem akan mengisi kontent video dan bank soal\n                  secara otomatis berdasarkan kelas dan mata pelajaran yang dipilih.\n                ")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.params.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Paket Mata Pelajaran")])])
}]}

/***/ }),
/* 1298 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/teachers",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Aktivasi Guru")])])])
},staticRenderFns: []}

/***/ }),
/* 1299 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/organizations'
    }
  }, [_vm._v("Organisasi")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Organisasi Detail")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Informasi Detail Organisasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('a', {
    staticClass: "media-left",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": _vm.organization.picture,
      "alt": "profile_picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.name))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', _vm._l((_vm.organization.admin_data), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(item.name) + ",\n                      ")])
  }), 0)]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.province))])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.city))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.npsn))])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.address))])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.contact))])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', _vm._l((_vm.organization.admin_data), function(item, index) {
    return _c('span', {
      key: index
    }, [_vm._v("\n                        " + _vm._s(item.email) + ",\n                      ")])
  }), 0)]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.organization.child_count))])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "to": {
        name: 'OrganizationForm',
        params: {
          id: _vm.organization.id
        }
      }
    }
  }, [_vm._v("\n                        Edit\n                      ")])], 1)])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(11), _vm._v(" "), _c('tbody', _vm._l((_vm.listCabang), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', [_vm._v("\n                  " + _vm._s(index + 1) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(item.name) + "\n                ")]), _vm._v(" "), _c('th', [_vm._v("\n                  " + _vm._s(item.student_count) + "\n                ")])])
  }), 0)])])])])]), _vm._v(" "), (_vm.isBulkModal) ? _c('organizations-bulk', {
    attrs: {
      "isMapping": _vm.isMapping
    },
    on: {
      "submitMapping": _vm.submitMapping,
      "reload": _vm.loadStudentData,
      "close": function($event) {
        _vm.isBulkModal = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Organisasi Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Nama Organisasi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Nama Admin")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Provinsi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kota/Kabupaten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("NPSN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Alamat")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("No. Telpon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Email Admin ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Jumlah Cabang")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Cabang\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Nama Cabang")]), _vm._v(" "), _c('th', [_vm._v("Jumlah Siswa")])])])
}]}

/***/ }),
/* 1300 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Content Banner")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Banner")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createContentSection()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Banner")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Content Banner")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.BannerList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "has-edit": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": 10,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateContent()
      },
      "editNewTab": function($event) {
        return _vm.updateContentBtn($event)
      },
      "deleted": function($event) {
        return _vm.deleteContentBanner($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1301 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic-mapping"
    }
  }, [_vm._l((_vm.groups), function(group, index) {
    return _c('div', {
      key: index
    }, [_c('h1', {
      staticClass: "page-header"
    }, [_vm._v(_vm._s(group.name))]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, _vm._l((group.grades), function(grade, gradeIndex) {
      return _c('div', {
        key: gradeIndex,
        staticClass: "col-md-4 col-sm-12"
      }, [_c('div', {
        staticClass: "widget widget-stats",
        class: _vm.bgColor(grade)
      }, [_c('div', {
        staticClass: "stats-icon"
      }), _vm._v(" "), _c('div', {
        staticClass: "stats-info"
      }, [_c('h4', [_vm._v(_vm._s(grade.jenjang.nama))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(grade.display_name))])]), _vm._v(" "), _c('div', {
        staticClass: "stats-link"
      }, [(grade.jenjang.nama !== 'SMA') ? _c('router-link', {
        attrs: {
          "to": {
            path: '/topic-mapping/detail',
            query: {
              interest: 'DEFAULT',
              grade_id: grade.id
            }
          }
        }
      }, [_vm._v("Lihat Detail "), _c('i', {
        staticClass: "fa fa-arrow-circle-o-right"
      })]) : _c('a', {
        attrs: {
          "href": "#"
        },
        on: {
          "click": function($event) {
            return _vm.mappingDetail(grade)
          }
        }
      }, [_vm._v("Lihat Detail "), _c('i', {
        staticClass: "fa fa-arrow-circle-o-right"
      })])], 1)])])
    }), 0)])
  }), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "cancelOnly": true
    },
    on: {
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Pilih Peminatan")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('router-link', {
    staticClass: "btn btn-lg btn-inverse",
    attrs: {
      "to": {
        path: '/topic-mapping/detail',
        query: {
          interest: 'SAINTEK',
          grade_id: _vm.selectedGrade.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-flask fa-2x pull-left"
  }), _vm._v("\n        " + _vm._s(_vm.selectedGrade.display_name)), _c('br'), _vm._v(" "), _c('small', [_vm._v("IPA")])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-lg btn-inverse",
    attrs: {
      "to": {
        path: '/topic-mapping/detail',
        query: {
          interest: 'SOSHUM',
          grade_id: _vm.selectedGrade.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-child fa-2x pull-left"
  }), _vm._v("\n        " + _vm._s(_vm.selectedGrade.display_name)), _c('br'), _vm._v(" "), _c('small', [_vm._v("IPS")])])], 1)]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1302 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/katalog-tiket'
      }
    }
  }, [_vm._v("List Katalog Tiket")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Katalog Tiket")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Katalog Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Katalog Tiket")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Tipe Katalog --")]), _vm._v(" "), _vm._l((_vm.types), function(katalogType) {
    return _c('option', {
      key: katalogType.key,
      domProps: {
        "value": katalogType.key
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(katalogType.title) + "\n\t\t\t\t\t\t\t\t\t\t\t")])
  })], 2)])]), _vm._v(" "), (_vm.data.type) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Title")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.types), function(katalogType) {
    return (_vm.data.type === katalogType.key && katalogType.key !== 'DUEL' && katalogType.key !== 'CONSULTATION' && katalogType.key !== 'SCHEDULED_TRYOUT') ? _c('div', {
      key: katalogType.key,
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(katalogType.value) + "\n\t\t\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12"
    }, [_c('vue-numeric', {
      staticClass: "form-control",
      attrs: {
        "separator": "."
      },
      model: {
        value: (_vm.data.value),
        callback: function($$v) {
          _vm.$set(_vm.data, "value", $$v)
        },
        expression: "data.value"
      }
    })], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.data.type === 'SCHEDULED_TRYOUT') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Apakah Langganan ?")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.is_subscription),
      expression: "data.is_subscription"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.is_subscription) ? _vm._i(_vm.data.is_subscription, null) > -1 : (_vm.data.is_subscription)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.is_subscription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "is_subscription", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "is_subscription", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "is_subscription", $$c)
        }
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.data.type === 'SCHEDULED_TRYOUT' && _vm.data.is_subscription) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bulan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": "."
    },
    model: {
      value: (_vm.data.value),
      callback: function($$v) {
        _vm.$set(_vm.data, "value", $$v)
      },
      expression: "data.value"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": "."
    },
    model: {
      value: (_vm.data.ticket),
      callback: function($$v) {
        _vm.$set(_vm.data, "ticket", $$v)
      },
      expression: "data.ticket"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.description) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.description)) + " karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.handleChangePicture($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Status --")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.PUBLISH
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.UNPUBLISH
    }
  }, [_vm._v("Unpublish")])])])])], 2) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar"), _c('br'), _vm._v("(Max 1MB)")])
}]}

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryouts'
      }
    }
  }, [_vm._v("Tryout")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Export Tryout")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Export Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('span', [_vm._v("Tryout yang dipilih: " + _vm._s(_vm.$store.state.tryout.selectedTO.length))]), _vm._v("   \n\t\t\t\t"), _c('button', {
    staticClass: "btn btn-success btn-xs",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitExport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export to JSON")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Export Tryout")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.tryouts,
      "headers": _vm.headers,
      "has-action": false,
      "has-custom-pagination": true,
      "has-checkbox": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1304 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    attrs: {
      "data-scrollbar": "true",
      "data-height": "100%"
    }
  }, [_c('ul', {
    staticClass: "nav"
  }, [_c('li', {
    staticClass: "nav-header"
  }, [_vm._v("Navigation")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-tachometer"
  }), _c('span', [_vm._v("Dashboard")])])]), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_userman')) ? _c('usman-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('sbmptn-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('tryoutgroup-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_userman')) ? _c('organizations-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_sales')) ? _c('affiliate-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('itembank-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('kodifikasi-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_modul_belajar')) ? _c('modulbelajar-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_userman')) ? _c('teacher-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('duel-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_sales')) ? _c('pembayaran-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_sales')) ? _c('voucher-nav') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('video-nav') : _vm._e(), _vm._v(" "), _c('pushnotif-nav'), _vm._v(" "), (_vm.$store.state.auth.scopes.includes('admin_itembank')) ? _c('bimbel-nav') : _vm._e(), _vm._v(" "), _c('content-nav'), _vm._v(" "), _vm._m(0)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "sidebar-minify-btn",
    attrs: {
      "href": "javascript:;",
      "data-click": "sidebar-minify"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-double-left"
  })])])
}]}

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Organisasi")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar Organisasi")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Organizations Management")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Organisasi\n          ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/organizations/form')
      }
    }
  }, [_vm._v("Buat Organisasi")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "searchbox",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan kata kunci dan tekan enter"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadOrganizationsData(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.organizations), function(organization, key) {
    return _c('tr', {
      key: key,
      on: {
        "dblclick": function($event) {
          return _vm.goToDetail(organization.id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s((25 * (_vm.pageNumber - 1)) + (key + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(organization.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(organization.child_count))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.pageNumber === 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadOrganizationsData(--_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Previous\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.pageNumber + ' / ' + _vm.total_page
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.isDisabledNextBtn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadOrganizationsData(++_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Next\n            ")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Nama Organisasi")]), _vm._v(" "), _c('th', [_vm._v("Jumlah Cabang")])])])
}]}

/***/ }),
/* 1306 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subject"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.subjects), function(subject) {
    return _c('div', {
      key: subject.id,
      staticClass: "col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "widget widget-stats",
      class: _vm.bgColor(subject.id)
    }, [_c('div', {
      staticClass: "stats-icon"
    }, [_c('img', {
      staticStyle: {
        "max-width": "80px"
      },
      attrs: {
        "src": subject.picture,
        "alt": "subject-logo"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "stats-info"
    }, [_c('h4', [_vm._v("Kode: " + _vm._s(subject.code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(subject.name))])]), _vm._v(" "), _c('div', {
      staticClass: "stats-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/topic-management/detail',
          query: {
            subject_id: subject.id
          }
        }
      }
    }, [_vm._v("Lihat Bab "), _c('i', {
      staticClass: "fa fa-arrow-circle-o-right"
    })])], 1)])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1307 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fileupload"
    }
  }, [_c('label', {
    staticClass: "btn btn-white"
  }, [_c('i', {
    staticClass: "fa fa-paperclip"
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.upload
    }
  })])])])
},staticRenderFns: []}

/***/ }),
/* 1308 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modulbelajar"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Modul Belajar")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Modul Belajar")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createModul()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Modul")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Video Pembelajaran")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.modules,
      "has-action": true,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editModulBelajar()
      },
      "deleted": function($event) {
        return _vm.deleteModulBelajar($event)
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1309 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/user-management",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user"
  }), _c('span', [_vm._v("User Management")])])])
},staticRenderFns: []}

/***/ }),
/* 1310 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modul-belajar-from"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/modul-belajar'
      }
    }
  }, [_vm._v("Modul Belajar")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Form")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Tryout Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('title') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('title') != -1) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Judul / nama modul",
      "required": ""
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('join_code') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Join Code *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('join_code') != -1) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.joinCode),
      expression: "joinCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Generate / Ketik kode join sendiri",
      "required": ""
    },
    domProps: {
      "value": (_vm.joinCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.joinCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-inverse",
    on: {
      "click": function($event) {
        _vm.joinCode = _vm.generateRandomCode(6)
      }
    }
  }, [_vm._v("Generate")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Deksripsi modul",
      "required": ""
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('picture') != -1
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Picture *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('picture') != -1) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('file-upload', {
    attrs: {
      "context": "modul_belajar"
    },
    on: {
      "uploaded": function($event) {
        _vm.picture = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [(_vm.picture != null) ? _c('img', {
    staticClass: "rounded-corner height-100 width-100",
    attrs: {
      "src": _vm.picture
    }
  }) : _vm._e()])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmitBtnClicked()
      }
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right m-1"
  }, [_c('li', {
    staticClass: "dropdown navbar-user dropleft"
  }, [_vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated fadeInLeft"
  }, [_c('li', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onManageMaterialBtnClicked()
      }
    }
  }, [_vm._v("Kelola Materi")])]), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.onManageLiveStreamBtnClicked()
      }
    }
  }, [_vm._v("Live Streaming")])])])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Buat Modul Belajar")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                  Kelola\n                  "), _c('span', {
    staticClass: "hidden-xs"
  }), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 1311 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "metode-pembayaran-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/metode-pembayaran'
      }
    }
  }, [_vm._v("List Metode Pembayaran")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Metode Pembayaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Metode Pembayaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Metode Pembayaran")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Section")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "LINKAJA"
    }
  }, [_vm._v("Link Aja")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NFJUARA"
    }
  }, [_vm._v("By Manual (Transfer NFJuara)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MARKETPLACE"
    }
  }, [_vm._v("Marketplace")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ORGANIZATION"
    }
  }, [_vm._v("By Pantau")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OY_EWALLET"
    }
  }, [_vm._v("OY! EWALLET")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OY_PAYMENT_ROUTING"
    }
  }, [_vm._v("OY! Payment Routing")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.isBankPayment) ? _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Bank")]) : _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Pembayaran")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bank_name),
      expression: "data.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bank_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Atas Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.account_name),
      expression: "data.account_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.account_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "account_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nomor Rekening")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.account_number),
      expression: "data.account_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.account_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "account_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.description) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.description)) + " karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Terms")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.terms),
      callback: function($$v) {
        _vm.$set(_vm.data, "terms", $$v)
      },
      expression: "data.terms"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.terms) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.terms)) + " karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Notes")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.notes),
      callback: function($$v) {
        _vm.$set(_vm.data, "notes", $$v)
      },
      expression: "data.notes"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.notes) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.notes)) + " karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Fee Percentage")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.fee_percentage),
      expression: "data.fee_percentage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.fee_percentage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "fee_percentage", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Phone Required")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.is_phonenumber_required),
      expression: "data.is_phonenumber_required"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "20px",
      "width": "24px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.is_phonenumber_required) ? _vm._i(_vm.data.is_phonenumber_required, null) > -1 : (_vm.data.is_phonenumber_required)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.is_phonenumber_required,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "is_phonenumber_required", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "is_phonenumber_required", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "is_phonenumber_required", $$c)
        }
      }
    }
  }), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Waktu Kadaluarsa Pembelian (Detik)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.expiration_time),
      expression: "data.expiration_time"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.expiration_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "expiration_time", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Platform")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.platform),
      expression: "data.platform"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "platform", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEB"
    }
  }, [_vm._v("Web")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ANDROID"
    }
  }, [_vm._v("Android")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar (Max 1MB)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.bank_logo) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.bank_logo
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('app-imagecropper', {
    on: {
      "finished": function($event) {
        return _vm.handleChangeBankLogo($event)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nomor Urut")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.order_number),
      expression: "data.order_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.order_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "order_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Status --")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.PUBLISH
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.UNPUBLISH
    }
  }, [_vm._v("Unpublish")])])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1312 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Content Section")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Konten")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createContentSection()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Konten")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Content Section")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.KontenList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "has-edit": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": 10,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateContent()
      },
      "editNewTab": function($event) {
        return _vm.updateContentBtn($event)
      },
      "deleted": function($event) {
        return _vm.deleteContent($event)
      },
      "publishing": function($event) {
        return _vm.publish($event)
      },
      "unpublishing": function($event) {
        return _vm.unpublish($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1313 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "id": "bab-content"
    }
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.deleteBab(_vm.datalist.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.datalist.bab_name) + " \n              "), (_vm.datalist.name !== '') ? _c('span', [_vm._v(" - " + _vm._s(_vm.datalist.name))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "button-group"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "width": "100%",
      "padding": "10px"
    }
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-info btn-xs",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#addBabModal"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('editBab', _vm.datalist)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v("\n                        Edit Bab\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs",
    on: {
      "click": function($event) {
        return _vm.addContentButton(_vm.datalist.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("\n                        Tambah Konten\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3"
  }, [_c('button', {
    class: _vm.updateState === 1 ? 'btn btn-warning btn-xs' : 'btn btn-light btn-xs',
    attrs: {
      "disabled": _vm.updateState === 1 ? false : true
    },
    on: {
      "click": function($event) {
        return _vm.updateKontenOrder(_vm.datalist.id)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("\n                        Update\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "drag-content"
  }, [(_vm.list.length === 0) ? _c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_vm._v("\n                Belum Ada Konten\n              ")]) : _vm._e(), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "list-group",
    attrs: {
      "tag": "ul",
      "move": _vm.onMove
    },
    on: {
      "start": function($event) {
        _vm.isDragging = true
      },
      "end": function($event) {
        _vm.isDragging = false
      }
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "type": "transition",
      "name": 'flip-list'
    }
  }, _vm._l((_vm.list), function(element) {
    return _c('li', {
      key: element.id,
      staticClass: "list-group-item"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('img', {
      attrs: {
        "src": element.type.picture,
        "width": "50"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('h6', [_c('b', [_vm._v(_vm._s(element.type.type) + " - " + _vm._s(element.title))])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.deleteContent(element.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-close"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-info btn-xs",
      on: {
        "click": function($event) {
          return _vm.editContent(element)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])])])
  }), 0)], 1)], 1)]), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.removeDependency()
      },
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Pra-Syarat")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan menghapus pra-syarat "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.dependencyName))]), _vm._v(" ?")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1314 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "revisi"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryouts'
      }
    }
  }, [_vm._v("Tryout")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Revisi")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Revisi Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Simpan")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.$store.state.tryout.name) + " (" + _vm._s(_vm.$store.state.tryout.code) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subtestCode),
      expression: "subtestCode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subtestCode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "value": ""
    }
  }, [_vm._v("-- Pilih Subtest --")]), _vm._v(" "), _vm._l((_vm.subtests), function(subtest) {
    return _c('option', {
      key: subtest.bundle_code,
      domProps: {
        "value": subtest.subtest_code
      }
    }, [_vm._v(_vm._s(subtest.subject_name))])
  })], 2)])]), _vm._v(" "), (_vm.subtestCode != '') ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('img', {
      attrs: {
        "src": _vm.subjectPicture,
        "height": "25px"
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.sequence))]), _vm._v(" "), _c('td', [_c('app-itemchooser', {
      attrs: {
        "subject": _vm.subjectData,
        "topiclist": _vm.topics,
        "placeholder": item.item_code
      },
      on: {
        "selected": function($event) {
          return _vm.updateItem(index, $event)
        }
      }
    })], 1)])
  }), 0)])])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Kode")])])])
}]}

/***/ }),
/* 1315 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("User Management")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar User")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("User Management")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "searchbox",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan kata kunci dan tekan enter"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadUserData(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "height": "34px",
      "padding": "5px 15px 5px 15px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.loadUserData(1)
      }
    }
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "height": "34px",
      "padding": "5px 15px 5px 15px",
      "font-size": "11px",
      "margin": "0px 10px 0px 10px"
    },
    on: {
      "click": function($event) {
        return _vm.showFilter()
      }
    }
  }, [_vm._v("Filter")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v("\n            FILTER : \n              "), _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("\n                Order: " + _vm._s(this.filter.order) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info"
  }, [_vm._v("\n                Order By: " + _vm._s(this.filter.orderby) + "\n              ")]), _vm._v(" "), (_vm.filter.grade !== '') ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.eraseFilter('grade')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("\n                Kelas: " + _vm._s(this.filter.grade) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.filter.npsn !== '') ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.eraseFilter('npsn')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("\n                NPSN: " + _vm._s(this.filter.npsn) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.filter.type !== '') ? _c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.eraseFilter('type')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _vm._v("\n                Jenis Sekolah: " + _vm._s(this.filter.type) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.users), function(row, key) {
    return _c('tr', {
      key: key,
      on: {
        "dblclick": function($event) {
          return _vm.goToDetail(key)
        }
      }
    }, [_c('td', [_vm._v(_vm._s((25 * (_vm.pageNumber - 1)) + (key + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.name.toUpperCase()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.email.toUpperCase()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.phone_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.school ? row.school.toUpperCase() : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.grade))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-info",
      on: {
        "click": function($event) {
          return _vm.showChangePassword(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-key"
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadUserData(--_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Previous\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.pageNumber),
      expression: "pageNumber"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.pageNumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.pageNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadUserData(++_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Next\n            ")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalFilter",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "300px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Order")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.order),
      expression: "filter.order"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "order", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ASC"
    }
  }, [_vm._v("Ascending")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DESC"
    }
  }, [_vm._v("Descending")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Order By")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.orderby),
      expression: "filter.orderby"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "orderby", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "id"
    }
  }, [_vm._v("ID")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "name"
    }
  }, [_vm._v("Nama")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.grade),
      expression: "filter.grade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "grade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_vm._l(([4, 5, 6, 7, 8, 9, 10, 11, 12]), function(i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": i
      }
    }, [_vm._v("Kelas " + _vm._s(i))])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Kelas")])], 2)]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("NPSN")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.npsn),
      expression: "filter.npsn"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "npsn", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "NOT_NULL"
    }
  }, [_vm._v("Ada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NULL"
    }
  }, [_vm._v("Tidak Ada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("Semua")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Jenis Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.type),
      expression: "filter.type"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FORMAL"
    }
  }, [_vm._v("Formal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INFORMAL"
    }
  }, [_vm._v("Informal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua")])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.applyFilter()
      }
    }
  }, [_vm._v("Aktifkan Filter")])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalChangepassword",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "300px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Anda akan mengubah password untuk ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "15px",
      "color": "black"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.userData.name + ' - ' + _vm.userData.email))])]), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Masukkan password baru")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [((_vm.seeNewPass ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.newPassword) ? _vm._i(_vm.newPassword, null) > -1 : (_vm.newPassword)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.newPassword = $$c
        }
      }
    }
  }) : ((_vm.seeNewPass ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newPassword, null)
    },
    on: {
      "change": function($event) {
        _vm.newPassword = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newPassword),
      expression: "newPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": _vm.seeNewPass ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.newPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(!_vm.seeNewPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeNewPass = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]) : _vm._e(), _vm._v(" "), (_vm.seeNewPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeNewPass = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  })]) : _vm._e()])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Konfirmasi password baru")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [((_vm.seeConfirmPass ? 'text' : 'password') === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.confirmPassword) ? _vm._i(_vm.confirmPassword, null) > -1 : (_vm.confirmPassword)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.confirmPassword,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.confirmPassword = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.confirmPassword = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.confirmPassword = $$c
        }
      }
    }
  }) : ((_vm.seeConfirmPass ? 'text' : 'password') === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.confirmPassword, null)
    },
    on: {
      "change": function($event) {
        _vm.confirmPassword = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confirmPassword),
      expression: "confirmPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Masukkan password baru",
      "type": _vm.seeConfirmPass ? 'text' : 'password'
    },
    domProps: {
      "value": (_vm.confirmPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confirmPassword = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [(!_vm.seeConfirmPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeConfirmPass = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]) : _vm._e(), _vm._v(" "), (_vm.seeConfirmPass) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.seeConfirmPass = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  })]) : _vm._e()])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitChangePassword()
      }
    }
  }, [_vm._v("Ubah Password")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar User\n          ")]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Phone Number")]), _vm._v(" "), _c('th', [_vm._v("School")]), _vm._v(" "), _c('th', [_vm._v("Kelas")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Filter Data User")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ubah password user")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),
/* 1316 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "assembleSubtest"
    }
  }, [_c('div', [(_vm.$store.state.tryout.status != 'PUBLISHED') ? _c('table', [_c('tr', [_c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sourceType),
      expression: "sourceType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sourceType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "INTERNAL"
    }
  }, [_vm._v("Internal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EXTERNAL"
    }
  }, [_vm._v("External")])])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subtestType),
      expression: "subtestType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subtestType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "normal"
    }
  }, [_vm._v("Normal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "anchor"
    }
  }, [_vm._v("Anchor")])])]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.questionType),
      expression: "questionType"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.questionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PG"
    }
  }, [_vm._v("Pilihan Ganda")]), _vm._v(" "), (_vm.sourceType === 'INTERNAL') ? _c('option', {
    attrs: {
      "value": "TUR"
    }
  }, [_vm._v("TUR")]) : _vm._e(), _vm._v(" "), (_vm.sourceType === 'INTERNAL') ? _c('option', {
    attrs: {
      "value": "MTF"
    }
  }, [_vm._v("MTF")]) : _vm._e()])]), _vm._v(" "), _c('td', [(_vm.subtestType == 'normal') ? _c('app-autocomplete', {
    attrs: {
      "sourcetype": _vm.sourceType,
      "data": _vm.topics,
      "depth": "2",
      "placeholder": "Cari bab / sub bab ...",
      "resetable": "true"
    },
    on: {
      "selected": function($event) {
        return _vm.assignTopic($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subtestType == 'anchor') ? _c('app-itemchooser', {
    attrs: {
      "subject": _vm.selectedSubject,
      "sourcetype": _vm.sourceType
    },
    on: {
      "selected": function($event) {
        return _vm.assignAnchor($event)
      }
    }
  }) : _vm._e()], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "table table-hover"
  }, _vm._l((_vm.details), function(subtestDetail, index) {
    return _c('tr', {
      key: index
    }, [(subtestDetail.source === 'EXTERNAL') ? _c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%",
        "flex-flow": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(subtestDetail.sequence))]), _vm._v(" "), (subtestDetail.is_anchor) ? _c('td', [_vm._v("Kode Soal: " + _vm._s(subtestDetail.item_code) + "\n            "), _c('p', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.source))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.question_type))])])]) : _c('td', [_vm._v("Topik: " + _vm._s(_vm.getTopicText(subtestDetail)) + "\n              "), _vm._v(" "), _c('p', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.source))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.question_type))])])]), _vm._v(" "), (_vm.$store.state.tryout.status != 'PUBLISHED') ? _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-success btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-caret-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-caret-up"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.remove(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-times"
    })])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (subtestDetail.source === 'INTERNAL') ? _c('div', {
      staticStyle: {
        "display": "flex",
        "width": "100%",
        "flex-flow": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(subtestDetail.sequence))]), _vm._v(" "), (subtestDetail.is_anchor) ? _c('td', [_vm._v("\n              Kode Soal: " + _vm._s(subtestDetail.item_code) + "\n              "), _c('p', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.source))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.question_type))])])]) : _c('td', [_vm._v("\n              Topik: " + _vm._s(_vm.getTopicText(subtestDetail)) + "\n              "), _c('p', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.source))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "margin": "5px",
        "background": "lightgray",
        "border-radius": "8px",
        "padding": "5px"
      }
    }, [_vm._v(_vm._s(subtestDetail.question_type))])])]), _vm._v(" "), (_vm.$store.state.tryout.status != 'PUBLISHED') ? _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-success btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveDown(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-caret-down"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-success btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.moveUp(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-caret-up"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-small",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.remove(subtestDetail)
        }
      }
    }, [_c('span', {
      staticClass: "fa fa-times"
    })])]) : _vm._e()]) : _vm._e()])
  }), 0)])])
},staticRenderFns: []}

/***/ }),
/* 1317 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic-management-detail"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80px",
      "margin-right": "10px"
    },
    attrs: {
      "src": _vm.renderPicture(_vm.subject.picture)
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        path: '/topic-management/detail',
        query: {
          subject_id: _vm.subject.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.subject.nama))]), _vm._v(" "), (_vm.topic) ? _c('span', [_vm._v(" →\n      "), _c('router-link', {
    attrs: {
      "to": {
        path: '/topic-management/detail',
        query: {
          subject_id: _vm.subject.id,
          topic_id: _vm.topic.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.topic.nama))])], 1) : _vm._e(), _vm._v(" "), (_vm.subTopic) ? _c('span', [_vm._v(" →\n      "), _c('router-link', {
    attrs: {
      "to": {
        path: '/topic-management/detail',
        query: {
          subject_id: _vm.subject.id,
          topic_id: _vm.topic.id,
          sub_topic_id: _vm.subTopic.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.subTopic.nama))])], 1) : _vm._e(), _vm._v(" "), (_vm.subSubTopic) ? _c('span', [_vm._v(_vm._s(_vm.subSubTopic.nama))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group m-b-10 col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchQuery),
      expression: "searchQuery"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukan kata kunci pencarian ..."
    },
    domProps: {
      "value": (_vm.searchQuery)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        _vm.showNewTopicDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Topik")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.cards.length == 0) ? _c('h4', {
    staticStyle: {
      "margin-left": "30%"
    }
  }, [_vm._v("Tidak ada data untuk kategori ini ...")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredCards), function(card) {
    return _c('div', {
      key: card.id,
      staticClass: "col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "text-align": "right",
        "padding": "5px"
      }
    }, [_c('a', {
      staticClass: "btn btn btn-icon btn-primary",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.showDetail(card)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn btn-icon btn-danger",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.showDeleteConfirmation(card)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])]), _vm._v(" "), _c('div', {
      staticClass: "widget widget-stats",
      class: _vm.bgColor(card.id)
    }, [_c('div', {
      staticClass: "stats-icon"
    }, [_c('img', {
      staticStyle: {
        "max-width": "80px"
      },
      attrs: {
        "src": _vm.renderPicture(card.picture),
        "alt": "subject-logo"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "stats-info"
    }, [_c('h4', [_vm._v("Kode: " + _vm._s(card.kode))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.truncateText(card.nama, 20)))])]), _vm._v(" "), (!_vm.topic) ? _c('div', {
      staticClass: "stats-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/topic-management/detail',
          query: {
            subject_id: _vm.subject.id,
            topic_id: card.id
          }
        }
      }
    }, [_vm._v("Lihat Sub Bab "), _c('i', {
      staticClass: "fa fa-arrow-circle-o-right"
    })])], 1) : _vm._e(), _vm._v(" "), (_vm.topic && !_vm.subTopic) ? _c('div', {
      staticClass: "stats-link"
    }, [_c('router-link', {
      attrs: {
        "to": {
          path: '/topic-management/detail',
          query: {
            subject_id: _vm.subject.id,
            topic_id: _vm.topic.id,
            sub_topic_id: card.id
          }
        }
      }
    }, [_vm._v("Lihat Sub Sub Bab "), _c('i', {
      staticClass: "fa fa-arrow-circle-o-right"
    })])], 1) : _vm._e()])])
  })], 2), _vm._v(" "), (_vm.showNewTopicDialog) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "cancel": function($event) {
        _vm.showNewTopicDialog = false;
        _vm.errors = []
      },
      "ok": function($event) {
        return _vm.addNewTopic()
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Tambah Topik Baru")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "topic_parent"
    }
  }, [_vm._v("Induk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.topicParentName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.formTopicName, 'has-feedback': _vm.errors.formTopicName
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "topic_parent"
    }
  }, [_vm._v("Nama *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formTopicName),
      expression: "formTopicName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.formTopicName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formTopicName = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.showConfirmationModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "cancel": function($event) {
        _vm.showConfirmationModal = false
      },
      "ok": function($event) {
        return _vm.deleteTopic()
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Konfirmasi")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah ada yakin akan menghapus topik "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.selectedTopic.name) + " ?")])])]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "cancel": function($event) {
        _vm.showModal = false
      },
      "ok": function($event) {
        return _vm.updateTopic()
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Topic Detail")]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "topic_parent"
    }
  }, [_vm._v("Induk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.selectedTopic.parentName
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "topic_code"
    }
  }, [_vm._v("Kode")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.selectedTopic.code
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.formTopicName, 'has-feedback': _vm.errors.formTopicName
    }
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "topic_name"
    }
  }, [_vm._v("Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTopic.name),
      expression: "selectedTopic.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.selectedTopic.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedTopic, "name", $event.target.value)
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 1318 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Content Article")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Artikel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createContentArticle()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Artikel")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Content Article")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.KontenList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "has-edit-a": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": 10,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateArticle()
      },
      "editNewTab": function($event) {
        return _vm.updateContentBtn($event)
      },
      "deleted": function($event) {
        return _vm.deleteArticle($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1319 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/produk'
      }
    }
  }, [_vm._v("Produk")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Produk")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n      " + _vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Produk\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("\n              " + _vm._s(!_vm.$route.query.id ? "Buat" : "Update") + " Produk\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                  " + _vm._s(message) + "\n                ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$route.query.id
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Tipe Produk --")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.type.SUBSCRIPTION
    }
  }, [_vm._v("Subscription")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.type.TICKET
    }
  }, [_vm._v("Tiket")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.type.KUOTA
    }
  }, [_vm._v("Kuota")])])])]), _vm._v(" "), (_vm.data.type) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Platform")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.platform),
      expression: "data.platform"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "platform", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ANDROID"
    }
  }, [_vm._v("Android")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WEB"
    }
  }, [_vm._v("Web")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("Semua")])])])]), _vm._v(" "), (_vm.data.type === _vm.type.SUBSCRIPTION) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SD"
    }
  }, [_vm._v("SD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SMP"
    }
  }, [_vm._v("SMP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SMA"
    }
  }, [_vm._v("SMA")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.jenjangList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v("\n                            " + _vm._s(item) + "\n                          ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Fitur")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_vm._l((_vm.featureList), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.features),
        expression: "features"
      }],
      staticClass: "checkbox m-r-5",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.features) ? _vm._i(_vm.features, item) > -1 : (_vm.features)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.features,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.features = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.features = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.features = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "f-s-14 f-w-700 m-r-10"
    }, [_vm._v("\n                            " + _vm._s(item === "INSTANT_TRYOUT" ?
      "Tryout Instan" :
      item === "CONSULTATION" ?
      "Konsultasi" :
      item === "DUEL" ?
      "Duel" :
      item === "ITEM_BANK" ?
      "Bank Soal" :
      item === "SCHEDULED_TRYOUT" ?
      "Tryout Terjadwal" :
      item === "VIDEO" ?
      "Video Pembelajaran" :
      "") + "\n                          ")])])
  }), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.featBimbel),
      expression: "featBimbel"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.featBimbel) ? _vm._i(_vm.featBimbel, "true") > -1 : (_vm.featBimbel)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.featBimbel,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.featBimbel = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.featBimbel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.featBimbel = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("Bimbel")])])], 2), _vm._v(" "), (_vm.featBimbel) ? _c('div', {
    staticClass: "col-md-5 col-xs-12",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column",
      "max-height": "200px",
      "overflow": "auto"
    }
  }, [_vm._m(0), _vm._v(" "), (_vm.bimbelList.length === 0) ? _c('span', [_vm._v("Tidak ada bimbel yang bisa dipilih "), _c('br'), _vm._v("Silahkan\n                          pilih kelas lain atau buat bimbel baru")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bimbelList), function(item, index) {
    return _c('span', {
      key: index
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.bimbels),
        expression: "bimbels"
      }],
      staticClass: "checkbox m-r-5",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item.id,
        "checked": Array.isArray(_vm.bimbels) ? _vm._i(_vm.bimbels, item.id) > -1 : (_vm.bimbels)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.bimbels,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.bimbels = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.bimbels = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.bimbels = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "f-s-14 f-w-700 m-r-10"
    }, [_vm._v(_vm._s(item.name))])])
  })], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Durasi (Bulan)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.value),
      expression: "data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "1",
      "max": "9999"
    },
    domProps: {
      "value": (_vm.data.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bonus Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_vm._v("\n                        " + _vm._s(_vm.data.bonus) + "\n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bonus_value),
      expression: "data.bonus_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.bonus_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bonus_value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.net_price),
      callback: function($$v) {
        _vm.$set(_vm.data, "net_price", $$v)
      },
      expression: "data.net_price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga Coret")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.price),
      callback: function($$v) {
        _vm.$set(_vm.data, "price", $$v)
      },
      expression: "data.price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])])]) : _vm._e(), _vm._v(" "), (_vm.data.type === _vm.type.TICKET || _vm.data.type === _vm.type.KUOTA) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("\n\t\t\t\t\t  " + _vm._s(_vm.data.type === _vm.type.KUOTA ? 'Jumlah Kuota' : 'Jumlah Tiket') + "\n\t\t\t\t\t  ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.value),
      expression: "data.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bonus Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bonus_value),
      expression: "data.bonus_value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.data.bonus_value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bonus_value", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.net_price),
      callback: function($$v) {
        _vm.$set(_vm.data, "net_price", $$v)
      },
      expression: "data.net_price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Harga Coret")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Rp")]), _vm._v(" "), _c('vue-numeric', {
    staticClass: "form-control",
    attrs: {
      "separator": ","
    },
    model: {
      value: (_vm.data.price),
      callback: function($$v) {
        _vm.$set(_vm.data, "price", $$v)
      },
      expression: "data.price"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(".00")])], 1)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.description) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.description)) + "\n                          karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.handleChangePicture($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- Pilih Status --")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.PUBLISH
    }
  }, [_vm._v("Publish")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": _vm.status.UNPUBLISH
    }
  }, [_vm._v("Unpublish")])])])])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.data.type) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                Simpan\n              ")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("\n                Update\n              ")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('h5', [_vm._v("Pilih Daftar Bimbel")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar"), _c('br'), _vm._v("(Max 1MB)")])
}]}

/***/ }),
/* 1320 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content Section")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Konten")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('type') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type),
      expression: "form.type"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.$route.query.id ? true : false
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SINGLE_BANNER"
    }
  }, [_vm._v("Single Banner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MULTIPLE_BANNER"
    }
  }, [_vm._v("Multiple Banner")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EXERCISE"
    }
  }, [_vm._v("Latihan Soal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ONGOING_TRYOUT"
    }
  }, [_vm._v("Tryout Berlangsung")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TRYOUT_RESULT"
    }
  }, [_vm._v("Hasil Tryout")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VIDEO"
    }
  }, [_vm._v("Video")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ARTICLE"
    }
  }, [_vm._v("Artikel")])]), _vm._v(" "), (_vm.form.type === 'VIDEO') ? _c('div', {
    staticClass: "alert alert-warning mt-2",
    attrs: {
      "role": "alert"
    }
  }, [_c('b', [_vm._v("Perhatian!")]), _vm._v(" semua konten dengan type 'Video' akan diisi video/detail yang sama secara otomatis oleh sistem")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('name') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Content")])])
}]}

/***/ }),
/* 1321 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "season"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Season")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("List Season")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createSeason()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Season")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Season")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.seasonList,
      "headers": _vm.headers
    },
    on: {
      "dblClicked": function($event) {
        return _vm.updateSeason()
      },
      "deleted": function($event) {
        return _vm.deleteSeason($event)
      },
      "selected": function($event) {
        _vm.selectedRow = $event
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1322 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Redeem Affiliate")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Redeem Affiliate")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-10",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.search),
      expression: "filter.search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search",
      "aria-describedby": "basic-addon1"
    },
    domProps: {
      "value": (_vm.filter.search)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "search", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Start Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.start_date),
      expression: "filter.start_date"
    }],
    staticClass: "form-control datepicker",
    staticStyle: {
      "max-width": "100px",
      "color": "black !important",
      "background": "white !important"
    },
    attrs: {
      "id": "filterStart",
      "type": "text",
      "name": "discussion_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.filter.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('label', [_vm._v("End Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.end_date),
      expression: "filter.end_date"
    }],
    staticClass: "form-control datepicker",
    staticStyle: {
      "max-width": "100px",
      "color": "black !important",
      "background": "white !important"
    },
    attrs: {
      "id": "filterEnd",
      "type": "text",
      "name": "discussion_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.filter.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "end_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-top": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Status")]), _vm._v(" "), _vm._l((_vm.listStatus), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.type
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-top": "10px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.wallet_type),
      expression: "filter.wallet_type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "wallet_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Tipe E-wallet")]), _vm._v(" "), _vm._l((_vm.listWallet), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.type
      }
    }, [_vm._v(_vm._s(item.title))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-top": "10px"
    }
  }, [(_vm.filter.sort_mode == 'DESC') ? _c('button', {
    staticClass: "btn btn-success btn-md",
    on: {
      "click": function($event) {
        return _vm.submitFilter('sort_mode', 'ASC')
      }
    }
  }, [_vm._v("sort : DESC")]) : _vm._e(), _vm._v(" "), (_vm.filter.sort_mode == 'ASC') ? _c('button', {
    staticClass: "btn btn-success btn-md",
    on: {
      "click": function($event) {
        return _vm.submitFilter('sort_mode', 'DESC')
      }
    }
  }, [_vm._v("sort : ASC")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "padding-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-md",
    on: {
      "click": function($event) {
        return _vm.applyFilter()
      }
    }
  }, [_vm._v("Apply")]), _vm._v("  \n                  "), _c('button', {
    staticClass: "btn btn-danger btn-md",
    on: {
      "click": function($event) {
        return _vm.resetFilter()
      }
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    staticClass: "list-group"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.redeemList), function(item) {
    return _c('a', {
      key: item,
      staticClass: "list-group-item",
      staticStyle: {
        "display": "flex",
        "flex-flow": "row"
      },
      on: {
        "click": function($event) {
          item.status !== 'REFUND' ? _vm.showDetail(item) : ''
        }
      }
    }, [_c('div', {
      staticClass: "col-md-2 col-xs-4"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("convertDate")(item.created_at)) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-4"
    }, [_vm._v(_vm._s(item.member_name))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v("\n                      " + _vm._s(_vm._f("currency")(item.coin)) + " koin\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v(_vm._s(item.wallet_type))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3 col-xs-2"
    }, [(item.status === 'FAILED') ? _c('button', {
      staticClass: "btn btn-danger btn-sm"
    }, [_vm._v("\n                        Gagal\n                      ")]) : _vm._e(), _vm._v(" "), (item.status === 'REFUND') ? _c('button', {
      staticClass: "btn btn-default btn-sm"
    }, [_vm._v("\n                        Dikembalikan\n                      ")]) : _vm._e(), _vm._v(" "), (item.status === 'ONPROGRESS') ? _c('button', {
      staticClass: "btn btn-warning btn-sm"
    }, [_vm._v("\n                        Proses\n                      ")]) : _vm._e(), _vm._v(" "), (item.status === 'SUCCESSED') ? _c('button', {
      staticClass: "btn btn-success btn-sm"
    }, [_vm._v("\n                        Berhasil\n                      ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "display": "flex",
      "flex-flow": "row",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-white dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                     " + _vm._s(_vm.filter.page_size) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.submitFilter('page_size', 10)
      }
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.submitFilter('page_size', 15)
      }
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.submitFilter('page_size', 25)
      }
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.filter.page > 1) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitFilter('page', _vm.filter.page - 1)
      }
    }
  }, [_vm._v("Previous")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.page),
      expression: "filter.page"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter.page)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "page", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitFilter('page', _vm.filter.page + 1)
      }
    }
  }, [_vm._v("Next")])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "redeemModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Tanggal Redeem")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                :   " + _vm._s(_vm._f("convertDate")(_vm.redeemDetail.created_at)) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(":   " + _vm._s(_vm.redeemDetail.member_name))])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(":   " + _vm._s(_vm.redeemDetail.member_email))])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Akun Ewallet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(":   " + _vm._s(_vm.redeemDetail.wallet_account))])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("E Wallet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(":   " + _vm._s(_vm.redeemDetail.wallet_type))])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("No E Wallet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v(":   " + _vm._s(_vm.redeemDetail.wallet_number))])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Jumlah cashout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_vm._v("\n                :   Rp. " + _vm._s(_vm._f("currency")(_vm.redeemDetail.rupiah)) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "display": "flex",
      "flex-flow": "row"
    }
  }, [_vm._v("\n                :  \n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listStatus), function(item, index) {
    return _c('option', {
      key: index,
      attrs: {
        "disabled": item.type === 'REFUND' || item.type === 'ONPROGRESS'
      },
      domProps: {
        "value": item.type
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_vm._v("Notes (optional)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "display": "flex",
      "flex-flow": "row"
    }
  }, [_vm._v("\n                :  \n                "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.note),
      expression: "form.note"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "5"
    },
    domProps: {
      "value": (_vm.form.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "note", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.hideDetail()
      }
    }
  }, [_vm._v("\n                  Cancel\n                ")]), _vm._v(" "), (_vm.varstate !== 'FAILED') ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.saveChanges(_vm.redeemDetail.id)
      }
    }
  }, [_vm._v("\n                  Simpan\n                ")]) : _vm._e()])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "msg"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Redeem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list-group-item",
    staticStyle: {
      "display": "flex",
      "flex-flow": "row"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-4"
  }, [_vm._v("Tanggal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_vm._v("Jumlah redeem")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_vm._v("E-Wallet")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-2"
  }, [_vm._v("Status Redeem")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "exampleModalLabel"
    }
  }, [_vm._v("DETAIL REDEEM")])])
}]}

/***/ }),
/* 1323 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Bank Soal")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/items',
        query: {
          mapel: _vm.$route.query.mapel
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.mapel))])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Soal Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [_c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jenjang') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jenis') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jenjang),
      expression: "form.jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jenjang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetGrades()
      }]
    }
  }, _vm._l((_vm.levels), function(level) {
    return _c('option', {
      key: level.id,
      domProps: {
        "value": level.id
      }
    }, [_vm._v("\n                    " + _vm._s(level.nama) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('grades') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('grades') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 3) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 10,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 10) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 10,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("10")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 11,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 11) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 11,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("11")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 12,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 12) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 12,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("12")])]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 2) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 7,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 7) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 7,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 8,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 8) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 8,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("8")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 9,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 9) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 9,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("9")])]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 1) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 4) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("4")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 5,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 5) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 5,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 6) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("6")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Wacana")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-wacana', {
    attrs: {
      "value": _vm.form.wacana
    },
    on: {
      "selected": function($event) {
        _vm.form.wacana = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('soal') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Soal *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('soal') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.form.soal,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.soal = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Opsi *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiA') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("A")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiA,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiA = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiA') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiB') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("B")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiB,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiB = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiB') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiC') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("C")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiC,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiC = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiC') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiD') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("D")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiD,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiD = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiD') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Optional:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("E")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiE,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiE = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jawaban') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jawaban *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jawaban') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jawaban),
      expression: "form.jawaban"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "A",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jawaban", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "A"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "E"
    }
  }, [_vm._v("E")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pembahasan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.form.pembahasan,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.pembahasan = $event
      }
    }
  })], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1324 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/video",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-video-camera"
  }), _c('span', [_vm._v("Video Pembelajaran")])])])
},staticRenderFns: []}

/***/ }),
/* 1325 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert fade in m-b-15",
    class: {
      'alert-danger': _vm.isError, 'alert-success': !_vm.isError
    }
  }, [_vm._v("\n  " + _vm._s(_vm.message) + "\n  "), _c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closed')
      }
    }
  }, [_vm._v("×")])])
},staticRenderFns: []}

/***/ }),
/* 1326 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/config",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-gear"
  }), _c('span', [_vm._v("Konfigurasi Aplikasi")])])])
},staticRenderFns: []}

/***/ }),
/* 1327 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "search-wacana"
    }
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.makeNew()
      }
    }
  }, [_vm._v("Buat Baru")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("Pilih")]), _vm._v(" "), (_vm.wacana != '') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editWacana
    }
  }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.wacana != '') ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmation = true
      }
    }
  }, [_vm._v("\n    Reset\n  ")]) : _vm._e(), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.wacana.id != 0) ? _c('blockquote', [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.previewWacana)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        _vm.showModal = false
      },
      "cancel": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cari Wacana")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('app-datatable', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.wacanas,
      "numbered": false
    },
    on: {
      "selected": function($event) {
        _vm.wacana = $event.data[0]
      }
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.showConfirmation) ? _c('app-modal', {
    on: {
      "ok": _vm.resetWacana
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Perhatian")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('p', [_vm._v("Apakah anda yakin ingin melepas wacana ini dari soal?")])])]) : _vm._e(), _vm._v(" "), (_vm.showCreateWacanaModal) ? _c('app-modal', {
    on: {
      "ok": _vm.saveWacana
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Buat Wacana Baru")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.wacana
    },
    on: {
      "content-updated": function($event) {
        _vm.wacana = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveWacana()
      }
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showCreateWacanaModal = false
      }
    }
  }, [_vm._v("Batal")])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1328 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subtest-form"
    }
  }, [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kode Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.code))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.level) + " / " + _vm._s(_vm.$store.state.tryout.type) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('strong', [_vm._v(_vm._s(_vm.$store.state.tryout.name))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Durasi (Menit)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subtest.duration),
      expression: "subtest.duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.5"
    },
    domProps: {
      "value": (_vm.subtest.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.subtest, "duration", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mata Pelajaran *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$store.state.tryout.status) ? _c('app-choosemapel', {
    on: {
      "selected": function($event) {
        return _vm.mapelSelected($event)
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Perakitan Test *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.subject) ? _c('app-assemblesubtest', {
    attrs: {
      "subject": _vm.subject
    },
    on: {
      "updated": function($event) {
        return _vm.detailsUpdated($event)
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1329 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("User Management")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("User Detail")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Informasi Detail User")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-body"
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "margin": "10px"
    }
  }, [_c('img', {
    staticClass: "media-object",
    attrs: {
      "src": _vm.userData.picture,
      "alt": "profile_picture"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px",
      "border": "1px solid green",
      "padding": "15px",
      "margin": "10px",
      "text-align": "center",
      "border-radius": "5px"
    }
  }, [_vm._v("\n            Jumlah Tiket\n            "), _c('h3', {
    staticStyle: {
      "line-height": "0"
    }
  }, [_vm._v(_vm._s(_vm.users_ticket))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "150px",
      "border": "1px solid green",
      "padding": "15px",
      "margin": "10px",
      "text-align": "center",
      "border-radius": "5px"
    }
  }, [_vm._v("\n            Jumlah Kuota Konsul\n            "), _c('h3', {
    staticStyle: {
      "line-height": "0"
    }
  }, [_vm._v(_vm._s(_vm.users_consul_session))])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_vm._m(1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.name))])]), _vm._v(" "), _c('tr', [_vm._m(2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.student_number))])]), _vm._v(" "), _c('tr', [_vm._m(3), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.email) + "\n                      "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "font-size": "11px",
      "padding": "5px 7px 5px 7px",
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.showEditEmail()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('tr', [_vm._m(4), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.phone_number))])]), _vm._v(" "), _c('tr', [_vm._m(5), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.province))])]), _vm._v(" "), _c('tr', [_vm._m(6), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.city))])]), _vm._v(" "), _c('tr', [_vm._m(7), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.school_type))])]), _vm._v(" "), _c('tr', [_vm._m(8), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.userData.school ? _vm.userData.school : '') + "\n                      "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "font-size": "11px",
      "padding": "5px 7px 5px 7px",
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.showEditForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil"
  })])])]), _vm._v(" "), _c('tr', [_vm._m(9), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("0")]), _vm._v(" "), _vm._l((12), function(n) {
    return _c('option', {
      key: n,
      domProps: {
        "value": n
      }
    }, [_vm._v(_vm._s(n))])
  })], 2)])])])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(11), _vm._v(" "), _vm._l((_vm.scopeModel), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "row",
      staticStyle: {
        "margin-bottom": "10px"
      }
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_vm._v("\n              " + _vm._s(item.display_name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "display": "flex",
        "flex-flow": "row"
      }
    }, [_c('date-picker', {
      attrs: {
        "value-type": "timestamp",
        "valueType": "format"
      },
      on: {
        "change": function($event) {
          return _vm.updateTanggalScope(item, index)
        }
      },
      model: {
        value: (_vm.scopeModel[index].expired_at),
        callback: function($$v) {
          _vm.$set(_vm.scopeModel[index], "expired_at", $$v)
        },
        expression: "scopeModel[index].expired_at"
      }
    }), _vm._v(" "), _c('button', {
      staticClass: "btn btn-danger btn-xl",
      staticStyle: {
        "margin-left": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.deleteScope(item, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])], 1)])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.memberships), function(membership, key) {
    return _c('div', {
      key: key,
      staticClass: "tryout-section",
      staticStyle: {
        "margin-bottom": "50px"
      }
    }, [_c('h4', [_vm._v(_vm._s(membership.name))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("(" + _vm._s(_vm.displayTimestamp(membership.opened_at)) + " - " + _vm._s(_vm.displayTimestamp(membership.closed_at)) + ")")])]), _vm._v(" "), _c('table', {
      staticClass: "table"
    }, [_vm._m(13, true), _vm._v(" "), _vm._l((membership.tryouts), function(tryout, key) {
      return _c('tr', {
        key: key
      }, [_c('td', [_vm._v(_vm._s(tryout.name))]), _vm._v(" "), _c('td', [(tryout.state === 'JOINED') ? _c('div', {
        staticClass: "tryout-state"
      }, [_c('button', {
        staticClass: "btn btn-default btn-xs"
      }, [_vm._v("BERGABUNG")])]) : _vm._e(), _vm._v(" "), (tryout.state === 'STARTED') ? _c('div', {
        staticClass: "tryout-state text-center"
      }, [_vm._v(" \n                    "), _c('button', {
        staticClass: "btn btn-warning btn-xs mb-1"
      }, [_vm._v("MENGERJAKAN")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.displayTimestamp(tryout.started_at)) + ")")])]) : _vm._e(), _vm._v(" "), (tryout.state === 'FINISHED') ? _c('div', {
        staticClass: "tryout-state text-center"
      }, [_vm._v(" \n                    "), _c('button', {
        staticClass: "btn btn-warning btn-xs mb-1"
      }, [_vm._v("MENGUMPULKAN")]), _c('br'), _vm._v(" "), _c('span', [_vm._v("(" + _vm._s(_vm.displayTimestamp(tryout.completed_at)) + ")")])]) : _vm._e(), _vm._v(" "), (tryout.state === 'GRADED') ? _c('div', {
        staticClass: "tryout-state"
      }, [_c('button', {
        staticClass: "btn btn-success btn-xs"
      }, [_vm._v("DINILAI")])]) : _vm._e()]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.completion_time ? Math.ceil(tryout.completion_time / 60) : '-'))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(_vm.getItemCount(tryout)))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.correct))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.wrong))]), _vm._v(" "), _c('td', {
        staticClass: "text-center"
      }, [_vm._v(_vm._s(tryout.empty))]), _vm._v(" "), _c('td', {
        staticClass: "text-center d-flex"
      }, [_c('button', {
        staticClass: "btn btn-warning btn-xs mr-1",
        attrs: {
          "disabled": tryout.state === 'JOINED'
        },
        on: {
          "click": function($event) {
            return _vm.resetState(tryout.bundle_code, _vm.$store.state.usman.email)
          }
        }
      }, [_vm._v("RESET")]), _vm._v(" "), _c('button', {
        staticClass: "btn btn-success btn-xs",
        attrs: {
          "disabled": tryout.state === 'JOINED'
        },
        on: {
          "click": function($event) {
            return _vm.gradingState(tryout.bundle_code, _vm.$store.state.usman.email)
          }
        }
      }, [_vm._v("GRADING")])])])
    })], 2)])
  }), 0)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalEditEmail",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "400px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(14), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Email Saat Ini")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.detailUser.email))])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Masukkan email baru")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newEmail),
      expression: "newEmail"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan email baru"
    },
    domProps: {
      "value": (_vm.newEmail)
    },
    on: {
      "focus": function($event) {
        _vm.newEmail = ''
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newEmail = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.listEmailSigned != null && _vm.listEmailSigned.length > 0) ? _c('div', _vm._l((_vm.listEmailSigned), function(item, index) {
    return _c('div', {
      key: index,
      staticStyle: {
        "padding-bottom": "7px",
        "padding-top": "7px",
        "border-bottom": "1px solid"
      }
    }, [_c('p', [_vm._v("Nama: " + _vm._s(item.name))]), _vm._v(" "), _c('p', [_vm._v("No Handphone: " + _vm._s(item.phone_number))]), _vm._v(" "), _c('p', [_vm._v("Tanggal Lahir: " + _vm._s(item.birth_date))])])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.listEmailSigned && _vm.listEmailSigned.length === 0) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', [_vm._v("Email baru belum terdaftar dalam sistem")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkEmail()
      }
    }
  }, [_vm._v("\n              Cek Email Baru\n            ")]), _vm._v(" "), (_vm.listEmailSigned && _vm.listEmailSigned.length === 0) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateEmail()
      }
    }
  }, [_vm._v("\n              Update Email\n            ")]) : _vm._e(), _vm._v(" "), (_vm.listEmailSigned && _vm.listEmailSigned.length === 1) ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateEmail()
      }
    }
  }, [_vm._v("\n              Swap Email\n            ")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalEditSekolah",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "400px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(15), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Jenis Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.jenisSekolah),
      expression: "formUpdateSekolah.jenisSekolah"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formUpdateSekolah, "jenisSekolah", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FORMAL"
    }
  }, [_vm._v("Formal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INFORMAL"
    }
  }, [_vm._v("Informal")])])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Provinsi")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.provinsi),
      expression: "formUpdateSekolah.provinsi"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formUpdateSekolah, "provinsi", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.provinceList), function(province, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": province.value
      }
    }, [_vm._v(_vm._s(province.text))])
  }), 0)]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Kota/Kabupaten")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.kota),
      expression: "formUpdateSekolah.kota"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formUpdateSekolah, "kota", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.cityList), function(city, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": city.value
      }
    }, [_vm._v(_vm._s(city.text))])
  }), 0)]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Nama Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px",
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formUpdateSekolah.namaSekolah),
      expression: "formUpdateSekolah.namaSekolah"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": 'nama sekolah'
    },
    domProps: {
      "value": (_vm.formUpdateSekolah.namaSekolah)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        return _vm.commitSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formUpdateSekolah, "namaSekolah", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px 15px 5px 15px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.commitSearch()
      }
    }
  }, [_vm._v("Cari")])]), _vm._v(" "), (_vm.formUpdateSekolah.namaSekolah !== '' && _vm.showSuggestion) ? _c('ul', {
    staticClass: "list-group",
    staticStyle: {
      "max-height": "250px",
      "overflow": "auto"
    }
  }, [_vm._l((_vm.querySchool), function(suggestion, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.selectingSchool(suggestion)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(suggestion.text))])])
  }), _vm._v(" "), (_vm.formUpdateSekolah.namaSekolah !== '' && _vm.showSuggestion && _vm.querySchool.length === 0) ? _c('li', {
    staticClass: "list-group-item"
  }, [_vm._v("\n                    Data tidak ditemukan, perhatikan huruf besar kecil dan spasi!\n                  ")]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateDataSekolah()
      }
    }
  }, [_vm._v("Update Data Siswa")])])])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("User Info")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticStyle: {
      "width": "15%"
    }
  }, [_c('strong', [_vm._v("Nama")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("No. Siswa")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Email")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("No. Telpon")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Provinsi")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kota/Kabupaten")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Jenis Sekolah")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Sekolah")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Kelas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Scope")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('b', [_vm._v("Nama Fitur")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('b', [_vm._v("Tanggal Expired")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Riwayat Pengerjaan Tryout (Beragenda)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Pengerjaan (Menit)")]), _vm._v(" "), _c('th', [_vm._v("Jml. Soal")]), _vm._v(" "), _c('th', [_vm._v("Benar")]), _vm._v(" "), _c('th', [_vm._v("Salah")]), _vm._v(" "), _c('th', [_vm._v("Kosong")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ubah Email User")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Ubah Data Sekolah User")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),
/* 1330 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryouts'
      }
    }
  }, [_vm._v("Tryout")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Tryout Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Langkah " + _vm._s(_vm.step) + " ( " + _vm._s(_vm.stepName[_vm.step - 1]) + " )")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.step == 1) ? _c('app-tryoutform', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.step == 2) ? _c('app-subtestlist', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.step == 3) ? _c('app-tryoutreview', {
    on: {
      "completed": function($event) {
        return _vm.goToNextStep()
      }
    }
  }) : _vm._e()], 1)], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1331 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/serial",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("Tryout Serial")])])])
},staticRenderFns: []}

/***/ }),
/* 1332 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Katalog Tiket")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Katalog Tiket")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createKatalogTiket()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Katalog Tiket")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateAllKatalogTiketStatus(_vm.status.PUBLISH)
      }
    }
  }, [_vm._v("Publish All")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateAllKatalogTiketStatus(_vm.status.UNPUBLISH)
      }
    }
  }, [_vm._v("Unpublish All")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Katalog Tiket")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.katalogTiketList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateKatalogTiket()
      },
      "deleted": function($event) {
        return _vm.deleteKatalogTiket($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAction "), _c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 1333 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/user-management'
      }
    }
  }, [_vm._v("User Management")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Aktivasi User")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Aktivasi User")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload File .CSV")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.handleFile()
      }
    }
  }), _c('br'), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Masa Berlaku")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.period),
      expression: "period"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.period)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.period = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Fitur")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-4"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.featureList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-6"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.features),
        expression: "features"
      }],
      staticClass: "checkbox m-r-5",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.features) ? _vm._i(_vm.features, item) > -1 : (_vm.features)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.features,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.features = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.features = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.features = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "f-s-14 f-w-700 m-r-10"
    }, [_vm._v("\n                            " + _vm._s(item === 'INSTANT_TRYOUT' ? 'Tryout Instan' : item === 'ITEM_BANK' ? 'Bank Soal' : item === 'SCHEDULED_TRYOUT' ? 'Tryout Terjadwal' : item === 'VIDEO' ? 'Video Pembelajaran' : '') + "\n                          ")])])
  }), 0)])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.params.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Aktivasi User")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticStyle: {
      "margin": "10px",
      "font-size": "13px"
    },
    attrs: {
      "href": "data:application/csv;base64,ZW1haWwKZmFraHJ5YXNhZHNzaTI5MDNAZ21haWwuY29tCmJhZ3VzYWxkeWNreUBnbWFpbC5jb20K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\nbQpzYWdpdGhhbnVyYWluaUBnbWFpbC5jb20K",
      "download": "example.csv"
    }
  }, [_vm._v("Download contoh file disini "), _c('i', {
    staticClass: "fa fa-download"
  })])
}]}

/***/ }),
/* 1334 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Video Pembelajaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar Video")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Video")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createVideo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Video")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Video Pembelajaran")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.videoList,
      "has-action": true,
      "has-preview": true,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editVideo()
      },
      "deleted": function($event) {
        return _vm.deleteVideo($event)
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1335 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/voucher'
      }
    }
  }, [_vm._v("Kode Voucer")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Voucher")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('channel') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("E Commerce Channel")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.channel_id),
      expression: "form.channel_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "channel_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listChannel), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('name') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Product")]), _vm._v(" "), _vm._l((_vm.form.products), function(item, i) {
    return _c('div', {
      key: i,
      staticClass: "row",
      staticStyle: {
        "padding-bottom": "5px"
      }
    }, [_c('div', {
      staticClass: "col-md-6"
    }, [_c('model-select', {
      attrs: {
        "options": _vm.productList,
        "placeholder": "Pilih Produk"
      },
      model: {
        value: (_vm.form.products[i].product_id),
        callback: function($$v) {
          _vm.$set(_vm.form.products[i], "product_id", $$v)
        },
        expression: "form.products[i].product_id"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-1"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.products[i].amount),
        expression: "form.products[i].amount"
      }],
      staticClass: "form-control",
      staticStyle: {
        "height": "100%"
      },
      attrs: {
        "type": "number",
        "min": "1"
      },
      domProps: {
        "value": (_vm.form.products[i].amount)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form.products[i], "amount", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [(_vm.form.products.length >= 1 && i == _vm.form.products.length - 1) ? _c('button', {
      staticClass: "btn btn-success btn-md m-1",
      attrs: {
        "type": "buttom"
      },
      on: {
        "click": function($event) {
          return _vm.pushProduct(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-plus"
    })]) : _vm._e(), _vm._v(" "), (_vm.form.products.length > 1 && i != _vm.form.products.length - 1) ? _c('button', {
      staticClass: "btn btn-danger btn-md m-1",
      attrs: {
        "type": "buttom"
      },
      on: {
        "click": function($event) {
          return _vm.form.products.splice(i, 1)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Buat Voucher")])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Voucher")])])
}]}

/***/ }),
/* 1336 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modul-material"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/modul-belajar'
      }
    }
  }, [_vm._v("Modul Belajar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/modul-belajar/form'
      }
    }
  }, [_vm._v("Informasi Umum")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Materi")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Kelola Materi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createMaterial()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Materi")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Daftar Materi")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.jenjang == 'SD'
    },
    on: {
      "click": function($event) {
        _vm.jenjang = 'SD'
      }
    }
  }, [_vm._v("SD")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.jenjang == 'SMP'
    },
    on: {
      "click": function($event) {
        _vm.jenjang = 'SMP'
      }
    }
  }, [_vm._v("SMP")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.jenjang == 'SMA'
    },
    on: {
      "click": function($event) {
        _vm.jenjang = 'SMA'
      }
    }
  }, [_vm._v("SMA")])]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 1
    },
    on: {
      "click": function($event) {
        _vm.kelas = 1
      }
    }
  }, [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 2
    },
    on: {
      "click": function($event) {
        _vm.kelas = 2
      }
    }
  }, [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 3
    },
    on: {
      "click": function($event) {
        _vm.kelas = 3
      }
    }
  }, [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 4
    },
    on: {
      "click": function($event) {
        _vm.kelas = 4
      }
    }
  }, [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 5
    },
    on: {
      "click": function($event) {
        _vm.kelas = 5
      }
    }
  }, [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 6
    },
    on: {
      "click": function($event) {
        _vm.kelas = 6
      }
    }
  }, [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMP') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 7
    },
    on: {
      "click": function($event) {
        _vm.kelas = 7
      }
    }
  }, [_vm._v("7")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMP') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 8
    },
    on: {
      "click": function($event) {
        _vm.kelas = 8
      }
    }
  }, [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMP') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 9
    },
    on: {
      "click": function($event) {
        _vm.kelas = 9
      }
    }
  }, [_vm._v("9")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMA') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 10
    },
    on: {
      "click": function($event) {
        _vm.kelas = 10
      }
    }
  }, [_vm._v("10")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMA') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 11
    },
    on: {
      "click": function($event) {
        _vm.kelas = 11
      }
    }
  }, [_vm._v("11")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMA') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 12
    },
    on: {
      "click": function($event) {
        _vm.kelas = 12
      }
    }
  }, [_vm._v("12")]) : _vm._e()]), _c('hr'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.rows,
      "has-preview": true
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editMaterial()
      },
      "deleted": function($event) {
        return _vm.deleteItem($event)
      }
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1337 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Bank Soal")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Bank Soal")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('span', [_vm._v("Item yang dipilih: " + _vm._s(_vm.$store.state.tryout.selectedTO.length))]), _vm._v("   \n            "), _c('button', {
    staticClass: "btn btn-success btn-xs",
    staticStyle: {
      "max-width": "200px",
      "margin-right": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitExport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Export to JSON")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/item-form',
          query: {
            mapel: _vm.$route.query.mapel
          }
        })
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Soal Baru")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-inline pull-right"
  }, [_c('div', {
    staticClass: "form-group m-r-10"
  }, [(_vm.params.itemCode !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Kode => " + _vm._s(_vm.params.itemCode) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('itemCode')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _vm._v(" "), (_vm.params.label !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Label => " + _vm._s(_vm.params.label) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('label')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _vm._v(" "), (_vm.params.babName !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Bab => " + _vm._s(_vm.params.babName) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('babName')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _vm._v(" "), (_vm.params.subbabName !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Sub Bab => " + _vm._s(_vm.params.subbabName) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('subbabName')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _vm._v(" "), (_vm.params.subsubabName !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Sub sub bab => " + _vm._s(_vm.params.subsubabName) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('subsubabName')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _vm._v(" "), (_vm.params.jenjang !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Jenjang => " + _vm._s(_vm.params.jenjang) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('jenjang')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _vm._v(" "), (_vm.params.jenis !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Jenis => " + _vm._s(_vm.params.jenis) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('jenis')
      }
    }
  }, [_vm._v("X")])]) : _vm._e(), _vm._v(" "), (_vm.params.kelas !== '') ? _c('span', {
    staticClass: "qry label label-info m-r-5",
    staticStyle: {
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("Kelas => " + _vm._s(_vm.params.kelas) + " "), _c('b', {
    staticStyle: {
      "cursor": "pointer",
      "color": "red"
    },
    on: {
      "click": function($event) {
        return _vm.delByOneFilter('kelas')
      }
    }
  }, [_vm._v("X")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Kata kunci"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field),
      expression: "field"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.field = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "code"
    }
  }, [_vm._v("Kode")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "label"
    }
  }, [_vm._v("Label")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "babName"
    }
  }, [_vm._v("Bab")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "subbabName"
    }
  }, [_vm._v("Sub bab")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "subsubabName"
    }
  }, [_vm._v("Sub sub bab")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jenjang"
    }
  }, [_vm._v("Jenjang")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jenis"
    }
  }, [_vm._v("Jenis")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "kelas"
    }
  }, [_vm._v("Kelas")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doFilter()
      }
    }
  }, [_vm._v("Filter")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Hapus Filter")])])]), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "items": _vm.items,
      "headers": _vm.headers,
      "hasEdit": true,
      "currentPageProp": this.params.page,
      "hasAction": true,
      "has-checkbox": true
    },
    on: {
      "selected": function($event) {
        _vm.selectedItem = $event
      },
      "editNewTab": function($event) {
        return _vm.editSoalNewTab($event)
      },
      "dblClicked": function($event) {
        return _vm.editSoal()
      },
      "deleted": function($event) {
        return _vm.deleteSoal($event)
      }
    }
  }), _vm._v(" "), (_vm.$route.name === 'ItemBank') ? _c('div', [_c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(this.maxPage))])]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.params.page - 1)
      }
    }
  }, [_vm._v("\n                Previous\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.page),
      expression: "params.page"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxPage
    },
    domProps: {
      "value": (_vm.params.page)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.goToPage(_vm.params.page)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "page", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.params.page + 1)
      }
    }
  }, [_vm._v("\n                Next\n              ")])]) : _vm._e()]) : _vm._e()], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1338 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fade page-sidebar-fixed page-header-fixed in",
    attrs: {
      "id": "page-container"
    }
  }, [(_vm.$store.state.auth.loggedIn) ? _c('app-header') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.loggedIn) ? _c('app-sidebar') : _vm._e(), _vm._v(" "), (_vm.$store.state.auth.loggedIn) ? _c('div', {
    staticClass: "sidebar-bg"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content",
    attrs: {
      "id": "content"
    }
  }, [(_vm.$store.state.error.visible) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_vm._v("\n      " + _vm._s(_vm.$store.state.error.message) + "\n      "), _c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    },
    on: {
      "click": function($event) {
        return _vm.$store.commit('error_dismiss')
      }
    }
  }, [_vm._v("×")])]) : _vm._e(), _vm._v(" "), _c('router-view')], 1), _vm._v(" "), (_vm.$store.state.auth.loggedIn) ? _c('app-footer') : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn btn-icon btn-circle btn-success btn-scroll-to-top fade",
    attrs: {
      "href": "javascript:;",
      "data-click": "scroll-top"
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-up"
  })])
}]}

/***/ }),
/* 1339 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/topic-management"
    }
  }, [_c('a', [_vm._v("Pengaturan Bab")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/topic-mapping"
    }
  }, [_vm._v("Mapping")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" "), _c('span', [_vm._v("Kodifikasi")])])
}]}

/***/ }),
/* 1340 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran-detail"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/pembayaran'
      }
    }
  }, [_vm._v("List Pembayaran User")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Detail Pembayaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Detail Pembayaran")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.data.status === _vm.status.CONFIRMED) ? _c('div', {
    staticClass: "pull-right"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((this.statusAction), function(value, key) {
    return _c('li', {
      key: key
    }, [_c('a', {
      on: {
        "click": function($event) {
          return _vm.updatePembayaranStatus(key)
        }
      }
    }, [_vm._v(_vm._s(value))])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.data.status === _vm.status.EXPIRED) ? _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updatePembayaranStatus('CONFIRMED')
      }
    }
  }, [_vm._v(" Reset ")])]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Order ID : " + _vm._s(_vm.data.code))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_name),
      expression: "data.user_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.user_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "user_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.user_email),
      expression: "data.user_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.user_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "user_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nomor Telepon")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.phone_number),
      expression: "data.phone_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.phone_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "phone_number", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.title),
      expression: "data.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe Produk")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.type),
      expression: "data.type"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.type)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "type", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Dari Rekening")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.bank_name),
      expression: "data.bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "bank_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Ke Rekening")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.payment_bank_name),
      expression: "data.payment_bank_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.payment_bank_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "payment_bank_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Total Bayar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.unique_price),
      expression: "data.unique_price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.unique_price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "unique_price", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tanggal Transfer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.transfer_datetime),
      expression: "data.transfer_datetime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.transfer_datetime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "transfer_datetime", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.data.status !== _vm.status.CHECKOUT && _vm.data.status !== _vm.status.EXPIRED) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bukti Transfer")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('viewer', {
    attrs: {
      "images": [_vm.data.receipt_img],
      "options": {
        navbar: false
      }
    }
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.receipt_img
    }
  })])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.status),
      expression: "data.status"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.data.status)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "status", $event.target.value)
      }
    }
  })])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAction "), _c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 1341 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.name),
      expression: "tryout.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "name",
      "placeholder": "Judul Tryout"
    },
    domProps: {
      "value": (_vm.tryout.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.description),
      expression: "tryout.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "description",
      "placeholder": "Deskripsi Tryout"
    },
    domProps: {
      "value": (_vm.tryout.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tryout Instan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.is_repeated),
      expression: "tryout.is_repeated"
    }],
    attrs: {
      "type": "checkbox",
      "value": "is_repeated"
    },
    domProps: {
      "checked": Array.isArray(_vm.tryout.is_repeated) ? _vm._i(_vm.tryout.is_repeated, "is_repeated") > -1 : (_vm.tryout.is_repeated)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.tryout.is_repeated,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "is_repeated",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.tryout, "is_repeated", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.tryout, "is_repeated", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.tryout, "is_repeated", $$c)
        }
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.level),
      expression: "tryout.level"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "level"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "level", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.selectingLevel()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "SMA"
    }
  }, [_vm._v("SMA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SMP"
    }
  }, [_vm._v("SMP")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SD"
    }
  }, [_vm._v("SD")])])])]), _vm._v(" "), (_vm.tryout.is_repeated) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout_grade),
      expression: "tryout_grade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "level"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tryout_grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.gradeList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 0)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenis *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.type),
      expression: "tryout.type"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SBMPTN"
    }
  }, [_vm._v("SNBT")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_NASIONAL"
    }
  }, [_vm._v("Ujian Nasional (UN)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_SEKOLAH"
    }
  }, [_vm._v("Ujian Akhir Sekolah (UAS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_SEKOLAH"
    }
  }, [_vm._v("Ujian Sekolah")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PENILAIAN_TENGAH_SEMESTER"
    }
  }, [_vm._v("Penilaian Tengah Semester (PTS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PENILAIAN_AKHIR_SEMESTER"
    }
  }, [_vm._v("Penilaian Akhir Semester (PAS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_MANDIRI"
    }
  }, [_vm._v("Ujian Mandiri (UM)")])])])]), _vm._v(" "), (_vm.tryout.type == 'SBMPTN' && _vm.tryout.level == 'SMA') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kategori *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.category),
      expression: "tryout.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "TPS"
    }
  }, [_vm._v("TPS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LITERASI"
    }
  }, [_vm._v("LITERASI")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SAINTEK"
    }
  }, [_vm._v("SAINTEK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOSHUM"
    }
  }, [_vm._v("SOSHUM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TKPA"
    }
  }, [_vm._v("TKPA (Sudah Tidak Berlaku)")])])])]) : (_vm.tryout.type != 'SBMPTN' && _vm.tryout.level == 'SMA') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kategori *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.category),
      expression: "tryout.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SAINTEK"
    }
  }, [_vm._v("SAINTEK")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOSHUM"
    }
  }, [_vm._v("SOSHUM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")])])])]) : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kategori *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.category),
      expression: "tryout.category"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "category"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.tryout, "category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "OTHER"
    }
  }, [_vm._v("OTHER")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Durasi (Menit) *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.duration),
      expression: "tryout.duration"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "name": "name"
    },
    domProps: {
      "value": (_vm.tryout.duration)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "duration", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.start_date),
      expression: "tryout.start_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.start_time),
      expression: "tryout.start_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "startTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "start_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.start_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "start_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(0)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Berakhir")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.end_date),
      expression: "tryout.end_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "end_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "end_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tryout.end_time),
      expression: "tryout.end_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.tryout.end_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.tryout, "end_time", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("Selanjutnya")])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}

/***/ }),
/* 1342 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_vm._v("\n    " + _vm._s(_vm.source ? '' : '') + "\n    "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/content'
      }
    }
  }, [_vm._v("Content")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/content/video'
      }
    }
  }, [_vm._v("Video Gratis")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Tambah Video Gratis")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Video Gratis")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("URL Video *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan URL Video dan tekan enter",
      "required": ""
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keydown": function($event) {
        return _vm.hideForm()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.changeUrl) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.changeUrl) ? _c('button', {
    staticClass: "btn btn-success pull-left mb-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkURL()
      }
    }
  }, [_vm._v("Preview URL")]) : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('youtube', {
    ref: "youtube",
    attrs: {
      "video-id": _vm.videoId
    },
    on: {
      "playing": _vm.playing
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (!_vm.changeUrl) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.source),
      expression: "source"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.source = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "youtube"
    }
  }, [_vm._v("Youtube")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul Video *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.judul),
      expression: "judul"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": !_vm.$route.query.id,
      "placeholder": "Judul Video"
    },
    domProps: {
      "value": (_vm.judul)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.judul = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$route.query.id) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.altTitle),
      expression: "altTitle"
    }],
    attrs: {
      "type": "checkbox",
      "name": "alt-title",
      "value": "Bike"
    },
    domProps: {
      "checked": Array.isArray(_vm.altTitle) ? _vm._i(_vm.altTitle, "Bike") > -1 : (_vm.altTitle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.altTitle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Bike",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.altTitle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.altTitle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.altTitle = $$c
        }
      }
    }
  }), _vm._v(" Judul Alternatif\n                          ")]) : _vm._e()]), _vm._v(" "), (_vm.altTitle) ? _c('div', {
    staticClass: "offset-2 col-md-8 col-xs-12 pt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.judulalt),
      expression: "judulalt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Judul Alternatif",
      "required": _vm.altTitle
    },
    domProps: {
      "value": (_vm.judulalt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.judulalt = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "1") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  1\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "2") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  2\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "3") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  3\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "4") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  4\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "5") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  5\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "6") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  6\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "7") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  7\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "8"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "8") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  8\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "9"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "9") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "9",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  9\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "10"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "10") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "10",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  10\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "11"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "11") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "11",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  11\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "12"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "12") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "12",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  12\n                          ")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mata Pelajaran *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mapel_code),
      expression: "mapel_code"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mapel_code = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.mapelList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.nama))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PUBLISHED"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HIDDEN"
    }
  }, [_vm._v("Hidden")])])])])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.changeUrl) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Update")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Tambah Video Gratis")])])
}]}

/***/ }),
/* 1343 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/paket-mapel"
    }
  }, [_vm._v("Paket Mata Pelajaran")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/paket-bimbel"
    }
  }, [_vm._v("Paket Bimbel")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-podcast"
  }), _vm._v(" "), _c('span', [_vm._v("Bimbel Online")])])
}]}

/***/ }),
/* 1344 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic-mapping-detail"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("\n    Maping Detail\n  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-inverse m-r-10 m-b-15",
    on: {
      "click": function($event) {
        return _vm.resetCards()
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.grade.display_name) + "\n    "), (_vm.grade.jenjang.nama === 'SMA') ? _c('span', [(_vm.$route.query.interest === 'SAINTEK') ? _c('span', [_vm._v("(IPA)")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.interest === 'SOSHUM') ? _c('span', [_vm._v("(IPS)")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.breadcrumbs), function(breadcrumb, index) {
    return _c('span', {
      key: index
    }, [_c('button', {
      staticClass: "btn btn-inverse m-r-10 m-b-15",
      on: {
        "click": function($event) {
          return _vm.goTo(index)
        }
      }
    }, [_vm._v(_vm._s(breadcrumb.name))])])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "input-group m-b-10 col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukan kata kunci pencarian ..."
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    on: {
      "click": function($event) {
        _vm.showMappingModal = true
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Mapping")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.filteredCards), function(card, index) {
    return _c('div', {
      key: index,
      staticClass: "col-md-4 col-sm-12"
    }, [_c('div', {
      staticClass: "card-header",
      staticStyle: {
        "text-align": "right",
        "padding": "5px"
      }
    }, [(_vm.allowDeletion(card)) ? _c('a', {
      staticClass: "btn btn btn-icon btn-danger",
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.confirmDeletion(card)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "widget widget-stats",
      class: _vm.bgColor(index)
    }, [_c('div', {
      staticClass: "stats-icon"
    }, [_c('img', {
      staticStyle: {
        "max-width": "100px"
      },
      attrs: {
        "src": card.picture,
        "alt": "subject-logo"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "stats-info",
      staticStyle: {
        "height": "80px"
      }
    }, [_c('h4', [_vm._v("Kode: " + _vm._s(card.code))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(card.name))])]), _vm._v(" "), (card.subs.length > 0) ? _c('div', {
      staticClass: "stats-link"
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          _vm.selectedCard = card
        }
      }
    }, [_vm._v("Lihat Detail "), _c('i', {
      staticClass: "fa fa-arrow-circle-o-right"
    })])]) : _vm._e()])])
  }), 0), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.deletedCard && _vm.showConfirmationModal) ? _c('confirmation-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "cancel": function($event) {
        _vm.showConfirmationModal = false
      },
      "ok": function($event) {
        return _vm.deleteMapping()
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Konfirmasi Penghapusan Mapping")]), _vm._v(" "), _c('p', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan melakukan penghapusan mapping "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.deletedCard.name))]), _vm._v(" beserta sub bab / sub sub bab turunannya ?")])]) : _vm._e(), _vm._v(" "), (_vm.showMappingModal) ? _c('topic-mapping-modal', {
    attrs: {
      "topic": _vm.selectedCard
    },
    on: {
      "finish": function($event) {
        return _vm.onMappingFinished($event)
      },
      "cancel": function($event) {
        _vm.showMappingModal = false
      }
    }
  }) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 1345 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "has-sub"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "sub-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/tryouts"
    }
  }, [_vm._v("Tryout")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tryout-groups"
    }
  }, [_vm._v("Tryout Group")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/serial"
    }
  }, [_vm._v("Tryout Serial")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/tryout-regrading"
    }
  }, [_vm._v("Regrading Tryout")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('b', {
    staticClass: "caret pull-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-pencil"
  }), _vm._v(" "), _c('span', [_vm._v("Tryout")])])
}]}

/***/ }),
/* 1346 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.th === 'old' ? 'login bg-black animated fadeInDown' : 'login-new animated fadeInDown'
  }, [_c('div', {
    staticClass: "login-header"
  }, [(_vm.th === 'old') ? _c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticStyle: {
      "width": "45px"
    },
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" NFJuara Admin\n        ")]) : _vm._e(), _vm._v(" "), (_vm.th === 'new') ? _c('div', {
    staticClass: "brand",
    staticStyle: {
      "margin": "40px 0px 40px 0px"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "src": 'https://www.nfjuara.id/wp-content/uploads/2021/08/logo-nf.png'
    }
  }), _vm._v(" Admin\n        ")]) : _vm._e(), _vm._v(" "), (_vm.th === 'old') ? _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-sign-in"
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "login-content"
  }, [(this.hasError) ? _c('app-alert', {
    attrs: {
      "message": _vm.errorMessage,
      "isError": "true"
    },
    on: {
      "closed": function($event) {
        _vm.hasError = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "margin-bottom-0",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleLogin()
      }
    }
  }, [_c('div', {
    staticClass: "form-group m-b-20"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    class: _vm.th === 'new' ? 'form-control input-lg m-t-20 brd-new' : 'form-control input-lg inverse-mode no-border',
    attrs: {
      "type": "text",
      "placeholder": "Email Address",
      "required": ""
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-b-20"
  }, [(_vm.th === 'old') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.th === 'new' ? 'form-control input-lg brd-new' : 'form-control input-lg inverse-mode no-border',
    attrs: {
      "type": "password",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.th === 'new') ? _c('div', {
    staticClass: "input-group"
  }, [((_vm.typpss) === 'checkbox') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.th === 'new' ? 'form-control input-lg brd-new' : 'form-control input-lg inverse-mode no-border',
    attrs: {
      "placeholder": "Password",
      "required": "",
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.password) ? _vm._i(_vm.password, null) > -1 : (_vm.password)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.password,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.password = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.password = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.password = $$c
        }
      }
    }
  }) : ((_vm.typpss) === 'radio') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.th === 'new' ? 'form-control input-lg brd-new' : 'form-control input-lg inverse-mode no-border',
    attrs: {
      "placeholder": "Password",
      "required": "",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.password, null)
    },
    on: {
      "change": function($event) {
        _vm.password = null
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: _vm.th === 'new' ? 'form-control input-lg brd-new' : 'form-control input-lg inverse-mode no-border',
    attrs: {
      "placeholder": "Password",
      "required": "",
      "type": _vm.typpss
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.typpss == 'password') ? _c('div', {
    staticClass: "input-group-addon hint-ic",
    on: {
      "click": function($event) {
        _vm.typpss = 'text'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]) : _vm._e(), _vm._v(" "), (_vm.typpss == 'text') ? _c('div', {
    staticClass: "input-group-addon hint-ic",
    on: {
      "click": function($event) {
        _vm.typpss = 'password'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye-slash"
  })]) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.th === 'old') ? _c('div', {
    staticClass: "checkbox m-b-20"
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "login-buttons"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.handleLogin()
      }
    }
  }, [_vm._v("Sign me in")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('input', {
    attrs: {
      "type": "checkbox"
    }
  }), _vm._v(" Remember Me\n                ")])
}]}

/***/ }),
/* 1347 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "sbmptn"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("SBMPTN")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar Tryout Group SNBT")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tryout Group SNBT")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.tryoutGroups,
      "has-grading": true,
      "has-ranking": true,
      "has-delete": false,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      },
      "gradingTryout": function($event) {
        return _vm.gradingTryout($event)
      },
      "rankingTryout": function($event) {
        return _vm.rankingTryout($event)
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n              Daftar Tryout Group SNBT\n            ")])])
}]}

/***/ }),
/* 1348 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content Bank Soal Gratis")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Content Soal Gratis")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    staticStyle: {
      "max-width": "200px",
      "margin-right": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Import Soal\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/content/itembank-form',
          query: {
            mapel: _vm.$route.query.mapel
          }
        })
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Soal Baru\n            ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.items,
      "headers": _vm.headers,
      "hasEdit": true,
      "currentPageProp": this.params.page,
      "hasAction": true
    },
    on: {
      "selected": function($event) {
        _vm.selectedItem = $event
      },
      "editNewTab": function($event) {
        return _vm.editSoalNewTab($event)
      },
      "dblClicked": function($event) {
        return _vm.editSoal()
      },
      "deleted": function($event) {
        return _vm.deleteSoal($event)
      }
    }
  }), _vm._v(" "), (_vm.$route.name === 'FreeItemBank') ? _c('div', [_c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                " + _vm._s(this.maxPage) + "\n              ")])]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.params.page - 1)
      }
    }
  }, [_vm._v("\n                Previous\n              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.params.page),
      expression: "params.page"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxPage
    },
    domProps: {
      "value": (_vm.params.page)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.goToPage(_vm.params.page)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.params, "page", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.params.page + 1)
      }
    }
  }, [_vm._v("\n                Next\n              ")])]) : _vm._e()]) : _vm._e()], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1349 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Pembayaran User")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Pembayaran User")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doManualInputTransaction()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-edit"
  }), _vm._v(" Manual Input\n            ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Pembayaran User")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.pembayaranList,
      "headers": _vm.headers,
      "has-action": false,
      "has-filter-status": true,
      "has-payment-status": true,
      "has-custom-search": true,
      "has-custom-pagination": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.detailPembayaran()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      },
      "filterByStatus": function($event) {
        _vm.search = {
          query: $event,
          by: 'status'
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1350 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "top10-ranking"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/sbmptn'
      }
    }
  }, [_vm._v("SBMPTN")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Top 10")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.tryoutGroupName))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    class: {
      active: _vm.activeTab == 'IPA'
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$router.fullpath
    },
    on: {
      "click": function($event) {
        return _vm.loadData('IPA')
      }
    }
  }, [_vm._v("IPA")])]), _vm._v(" "), _c('li', {
    class: {
      active: _vm.activeTab == 'IPS'
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.$router.fullpath
    },
    on: {
      "click": function($event) {
        return _vm.loadData('IPS')
      }
    }
  }, [_vm._v("IPS")])])]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.activeList), function(data) {
    return _c('tr', {
      key: data.id
    }, [_c('td', [_vm._v(_vm._s(data.rank))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fullname.toUpperCase()))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.school))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(Math.round(data.score * 100) / 100))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.prodi_1))])])
  }), 0)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Siswa Top 10 UTBK\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Rank")]), _vm._v(" "), _c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("School")]), _vm._v(" "), _c('th', [_vm._v("Score")]), _vm._v(" "), _c('th', [_vm._v("Prodi 1")])])
}]}

/***/ }),
/* 1351 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer",
    attrs: {
      "id": "footer"
    }
  })
},staticRenderFns: []}

/***/ }),
/* 1352 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/push-notification",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-bell"
  }), _c('span', [_vm._v("Push Notification")])])])
},staticRenderFns: []}

/***/ }),
/* 1353 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "produk"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Produk")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Produk")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createProduk()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Produk")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateAllProdukStatus(_vm.status.PUBLISH)
      }
    }
  }, [_vm._v("Publish All")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.updateAllProdukStatus(_vm.status.UNPUBLISH)
      }
    }
  }, [_vm._v("Unpublish All")])])])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Produk")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.produkList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateProduk()
      },
      "deleted": function($event) {
        return _vm.deleteProduk($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-success btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\tAction "), _c('span', {
    staticClass: "caret"
  })])
}]}

/***/ }),
/* 1354 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryout-groups'
      }
    }
  }, [_vm._v("Tryout Group")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Tryout Group Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [(_vm.groupId) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [(!_vm.isPublished) ? _c('button', {
    staticClass: "btn btn-danger btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.publishTryoutGroup()
      }
    }
  }, [_vm._v("Belum Publish")]) : _c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.unPublishTryoutGroup()
      }
    }
  }, [_vm._v("Terpublish")])]) : _vm._e(), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Buat Tryout Group")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nama tryout group"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, _vm._l((12), function(item) {
    return _c('div', {
      key: item
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.grade),
        expression: "grade"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": item,
        "checked": Array.isArray(_vm.grade) ? _vm._i(_vm.grade, item) > -1 : (_vm.grade)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.grade,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = item,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.grade = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.grade = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.grade = $$c
          }
        }
      }
    }), _vm._v("\n                    " + _vm._s(item) + "\n                    (" + _vm._s(item <= 6 ? 'SD' : item > 6 && item < 10 ? 'SMP' : 'SMA') + ")\n                  ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Deskripsi tryout group"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SBMPTN"
    }
  }, [_vm._v("SBMPTN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_NASIONAL"
    }
  }, [_vm._v("UJIAN AKHIR NASIONAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_SEKOLAH"
    }
  }, [_vm._v("UJIAN AKHIR SEKOLAH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_SEKOLAH"
    }
  }, [_vm._v("UJIAN SEKOLAH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PENILAIAN_TENGAH_SEMESTER"
    }
  }, [_vm._v("Penilaian Tengah Semester (PTS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PENILAIAN_AKHIR_SEMESTER"
    }
  }, [_vm._v("Penilaian Akhir Semester (PAS)")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_MANDIRI"
    }
  }, [_vm._v("Ujian Mandiri (UM)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Varian *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variant),
      expression: "variant"
    }],
    attrs: {
      "name": "variant"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.variant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SCHEDULED"
    }
  }, [_vm._v("BERAGENDA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INSTANT_COMPLETE"
    }
  }, [_vm._v("INSTANT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Sumber *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.source_id),
      expression: "source_id"
    }],
    attrs: {
      "name": "variant"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.source_id = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.listTryoutSource), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pra-Syarat")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-tryoutgroupchooser', {
    attrs: {
      "params": {
        grade: _vm.grade,
        status: 'PUBLISHED',
        type: _vm.type,
        variant: _vm.variant
      }
    },
    on: {
      "dblClicked": function($event) {
        return _vm.addDependency($event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id) ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.dependencyName))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("hapus")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Options")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isSticky),
      expression: "isSticky"
    }],
    attrs: {
      "type": "checkbox",
      "name": "isSticky"
    },
    domProps: {
      "checked": Array.isArray(_vm.isSticky) ? _vm._i(_vm.isSticky, null) > -1 : (_vm.isSticky)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isSticky,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isSticky = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isSticky = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isSticky = $$c
        }
      }
    }
  }), _vm._v(" Sticky "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isPrivate),
      expression: "isPrivate"
    }],
    attrs: {
      "type": "checkbox",
      "name": "isPrivate"
    },
    domProps: {
      "checked": Array.isArray(_vm.isPrivate) ? _vm._i(_vm.isPrivate, null) > -1 : (_vm.isPrivate)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isPrivate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isPrivate = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isPrivate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isPrivate = $$c
        }
      }
    }
  }), _vm._v(" Private\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Join Code (max 10 char, opsional)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    staticClass: "form form-control",
    attrs: {
      "type": "text",
      "maxlength": "10"
    },
    domProps: {
      "value": _vm.joinCode.toUpperCase()
    },
    on: {
      "input": function($event) {
        _vm.joinCode = $event.target.value.toUpperCase()
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tgl. Pembahasan Umum*")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discussionDate),
      expression: "discussionDate"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "discussionDate",
      "type": "text",
      "placeholder": "Tanggal Pembahasan Untuk Umum",
      "name": "discussion_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.discussionDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discussionDate = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discussionTime),
      expression: "discussionTime"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "discussionTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.discussionTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discussionTime = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tgl. Pembahasan Siswa NF *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discussionSpecialDate),
      expression: "discussionSpecialDate"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "discussionSpecialDate",
      "type": "text",
      "placeholder": "Tanggal Pembahasan Khusus Siswa NF",
      "name": "discussion_special_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.discussionSpecialDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discussionSpecialDate = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discussionSpecialTime),
      expression: "discussionSpecialTime"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "discussionSpecialTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_special_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.discussionSpecialTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.discussionSpecialTime = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(3)])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.variant === 'SCHEDULED') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openedAt),
      expression: "openedAt"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "openedAtDate",
      "type": "text",
      "placeholder": "Tanggal Dimulai Tryout",
      "name": "opened_at",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.openedAt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openedAt = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.openedAtTime),
      expression: "openedAtTime"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "openedAtTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "opened_at_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.openedAtTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.openedAtTime = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(5)])])]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Berakhir")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.variant === 'SCHEDULED') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closedAt),
      expression: "closedAt"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "closedAtDate",
      "type": "text",
      "placeholder": "Tanggal Berakhir Tryout",
      "name": "opened_at",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.closedAt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closedAt = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.closedAtTime),
      expression: "closedAtTime"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "closedAtTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_special_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.closedAtTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.closedAtTime = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(7)])])]) : _c('span', [_vm._v("-")])])]), _vm._v(" "), (_vm.groupId) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-tryoutchooser', {
    attrs: {
      "isInstant": _vm.$store.state.tryoutgroup.variant !== 'SCHEDULED'
    },
    on: {
      "selected": function($event) {
        return _vm.addTryoutIntoGroup($event)
      }
    }
  }), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(8), _vm._v(" "), _c('tbody', _vm._l((_vm.tryouts), function(tryout, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(tryout.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tryout.type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(tryout.category))]), _vm._v(" "), _c('td', _vm._l((tryout.subtests), function(subtest, index) {
      return _c('span', {
        key: index
      }, [_vm._v(_vm._s(subtest.subject_name) + ",")])
    }), 0), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.removeTryoutFromGroup(tryout)
        }
      }
    }, [_vm._v("Hapus")])])])
  }), 0)])], 1)]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveTryoutGroup()
      }
    }
  }, [_vm._v("Simpan")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.removeDependency()
      },
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Pra-Syarat")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan menghapus pra-syarat "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.dependencyName))]), _vm._v(" ?")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nama Tryout")]), _vm._v(" "), _c('th', [_vm._v("Tipe")]), _vm._v(" "), _c('th', [_vm._v("Kategori")]), _vm._v(" "), _c('th', [_vm._v("Mata Pelajaran")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
}]}

/***/ }),
/* 1355 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "chooseMapel"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.selectedMapel) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "mapel-picture",
    attrs: {
      "src": _vm.selectedMapel.picture
    }
  }), _vm._v(" " + _vm._s(_vm.selectedMapel.nama) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [(_vm.$store.state.tryout.status != 'PUBLISHED') ? _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showMapels()
      }
    }
  }, [_vm._v("Pilih ...")]) : _vm._e()])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1), _vm._v(" "), (_vm.showMapelModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "id": "mapelModal"
    }
  }, [_c('div', {
    staticClass: "modal-header "
  }, [_c('h3', [_vm._v("Pilih Mata Pelajaran")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.mapels), function(mapel, index) {
    return _c('li', {
      key: mapel.id,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.selectMapel(index)
        }
      }
    }, [_c('img', {
      staticClass: "mapel-picture",
      attrs: {
        "src": mapel.picture
      }
    }), _vm._v(" " + _vm._s(mapel.nama) + "\n              ")])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showMapelModal = false
      }
    }
  }, [_vm._v("Tutup")])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1356 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', [_c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Preview & Setting")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Preview")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-xs btn-edit",
    staticStyle: {
      "margin-left": "15px"
    },
    on: {
      "click": function($event) {
        return _vm.saveSort()
      }
    }
  }, [_vm._v("\n                Simpan Perubahan\n              ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Preview Konten")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "preview-content"
  }, [_c('div', {
    staticClass: "listdrag"
  }, [_c('span', {
    staticClass: "titleSection"
  }, [_vm._v("List Section")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "move": _vm.onMove,
      "id": "dragAreaSectionContent"
    },
    model: {
      value: (_vm.sectionList),
      callback: function($$v) {
        _vm.sectionList = $$v
      },
      expression: "sectionList"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "id": "transGroupSection"
    }
  }, _vm._l((_vm.sectionList), function(element) {
    return _c('div', {
      key: element.id
    }, [_c('div', {
      staticClass: "dragItem"
    }, [(element.type === 'VIDEO') ? _c('i', {
      staticClass: "fa fa-play",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'SINGLE_BANNER') ? _c('i', {
      staticClass: "fa fa-picture-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'MULTIPLE_BANNER') ? _c('i', {
      staticClass: "fa fa-clone",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'EXERCISE') ? _c('i', {
      staticClass: "fa fa-pencil-square-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'ARTICLE') ? _c('i', {
      staticClass: "fa fa-newspaper-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'TRYOUT_RESULT') ? _c('i', {
      staticClass: "fa fa-check-square-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), (element.type === 'ONGOING_TRYOUT') ? _c('i', {
      staticClass: "fa fa-clock-o",
      attrs: {
        "id": "iconItem"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n                          " + _vm._s(element.name)), _c('br'), _vm._v("\n                          " + _vm._s(element.type) + "\n                        ")])])])
  }), 0)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "phone",
    style: ({
      backgroundImage: 'url(' + _vm.logo + ')'
    }),
    attrs: {
      "id": "phoneArea"
    }
  }, [_c('div', {
    staticClass: "menu",
    attrs: {
      "id": "menuDrag"
    },
    on: {
      "click": function($event) {
        _vm.menuMode = true
      }
    }
  }, [_c('div', {
    staticClass: "menuRow"
  }, _vm._l((_vm.submitMenu.slice(0, 4)), function(element) {
    return _c('div', {
      key: element.id,
      staticClass: "menuIteration"
    }, [_c('img', {
      staticClass: "iconMenu",
      attrs: {
        "src": element.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "captionMenu"
    }, [_vm._v("\n                        " + _vm._s(element.display_name) + "\n                      ")])])
  }), 0)]), _vm._v(" "), (!_vm.menuMode) ? _c('div', {
    staticClass: "listdragPhoneArea"
  }, [_c('div', {
    staticClass: "dumHeader"
  }, [_c('div', {
    staticClass: "dumWrapper"
  }, [_c('div', {
    staticClass: "centerFlex"
  }, [_c('img', {
    staticClass: "ticketIcon",
    attrs: {
      "src": _vm.ticket
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "ticketInteger"
  }, [_c('b', [_vm._v("315")])]), _vm._v(" "), _c('p', {
    staticClass: "dumSeeMore"
  }, [_vm._v("lihat detail >")])])]), _vm._v(" "), _c('div', {
    staticClass: "centerFlex"
  }, [_c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "haiFulan"
  }, [_c('b', [_vm._v("Hai Fulan,")])]), _vm._v(" "), _c('p', {
    staticClass: "gradeCapt"
  }, [_vm._v("Kelas 12")])]), _vm._v(" "), _c('img', {
    staticClass: "imagePP",
    attrs: {
      "src": _vm.pp
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "package-list"
  }, [_c('div', {
    staticClass: "alertTicket"
  }, [_c('span', [_vm._v("Kamu punya\n                        "), _c('b', {
    staticStyle: {
      "color": "#355eab"
    }
  }, [_vm._v("100 Paket Belajar")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#3cb54a"
    }
  })])]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "draggable-1",
    attrs: {
      "move": _vm.onMove,
      "id": "dragAreaSection"
    },
    on: {
      "add": function($event) {
        return _vm.onSectionAdd($event)
      },
      "remove": function($event) {
        return _vm.onSectionRemove($event)
      }
    },
    model: {
      value: (_vm.submitList),
      callback: function($$v) {
        _vm.submitList = $$v
      },
      expression: "submitList"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('transition-group', {
    attrs: {
      "id": "transAreaSection"
    }
  }, _vm._l((_vm.submitList), function(element) {
    return _c('div', {
      key: element.id,
      staticClass: "draggable-3"
    }, [(element.type === 'SINGLE_BANNER') ? _c('div', {
      staticClass: "banner"
    }, [_c('div', {
      staticClass: "nameSingleBanner"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', [_c('img', {
      staticClass: "imgSingleBanner",
      attrs: {
        "src": _vm._f("parsingContentIMG")(element.details[0].content)
      }
    })])]) : _vm._e(), _vm._v(" "), (element.type === 'MULTIPLE_BANNER') ? _c('div', {
      staticClass: "banner"
    }, [_c('div', {
      staticClass: "nameMultiBanner"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "fl"
      }, [_c('img', {
        staticClass: "imgMultiBanner",
        attrs: {
          "src": _vm._f("parsingContentIMG")(item.content)
        }
      })])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'ARTICLE') ? _c('div', {
      staticClass: "articleItem"
    }, [_c('div', {
      staticClass: "nameArticle"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "articleIteration"
      }, [_c('div', {
        staticClass: "articleWrapper"
      }, [_c('img', {
        staticClass: "imgArticle",
        attrs: {
          "src": _vm._f("parsingContentIMG")(item.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "articleText"
      }, [_c('p', {
        staticClass: "articleTitle"
      }, [_vm._v("\n                                    " + _vm._s(_vm._f("parsingTITLE")(item.content)) + "\n                                  ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(_vm._f("parsingDESCRIPTION")(item.content)) + "\n                                  ")])])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'VIDEO') ? _c('div', {
      staticClass: "videoItem"
    }, [_c('div', {
      staticClass: "nameVideo"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "videoIteration"
      }, [_c('div', {
        staticClass: "videoWrapper"
      }, [_c('div', {
        staticClass: "videoThumbnail",
        style: ({
          backgroundImage: 'url(' + _vm.play + ')',
          height: '100px',
          width: '100px',
          backgroundRepeat: 'no-repeat',
          zIndex: 1,
          left: '45%',
          top: '15%',
          position: 'absolute',
        })
      }), _vm._v(" "), _c('img', {
        staticClass: "imgVideo",
        attrs: {
          "src": _vm._f("parsingThumbnail")(item.content)
        }
      }), _vm._v(" "), _c('div', {
        staticClass: "videoText"
      }, [_c('p', {
        staticClass: "videoTItle"
      }, [_vm._v("\n                                    " + _vm._s(_vm._f("parsingTITLE")(item.content)) + "\n                                  ")]), _vm._v(" "), _c('p', [_vm._v("\n                                    " + _vm._s(_vm._f("parsingDESCRIPTION")(item.content)) + "\n                                  ")])])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'ONGOING_TRYOUT') ? _c('div', {
      staticClass: "onTryoutItem"
    }, [_c('div', {
      staticClass: "onTryoutWrapper"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "onTryoutIteration"
      }, [_c('div', {
        staticClass: "onTryoutText"
      }, [_c('p', {
        staticClass: "onTryoutType"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOType")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "onTryoutName"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOName")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', [_c('i', {
        staticClass: "fa fa-calendar"
      }), _vm._v("  " + _vm._s(_vm._f("parsingTOTime")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "seeMoreOnTryout"
      }, [_vm._v("Lihat Detail")])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'TRYOUT_RESULT') ? _c('div', {
      staticClass: "resultItem"
    }, [_c('div', {
      staticClass: "resultWrapper"
    }, [_c('b', [_vm._v(_vm._s(element.name))])]), _vm._v(" "), _c('div', {
      staticStyle: {
        "width": "5000px"
      }
    }, _vm._l((element.details), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "resultIteration"
      }, [_c('div', {
        staticClass: "resultText"
      }, [_c('p', {
        staticClass: "resultType"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOType")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "resultName"
      }, [_vm._v("\n                                  " + _vm._s(_vm._f("parsingTOName")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', [_c('i', {
        staticClass: "fa fa-calendar"
      }), _vm._v("  " + _vm._s(_vm._f("parsingTOTime")(item.content)) + "\n                                ")]), _vm._v(" "), _c('p', {
        staticClass: "resultSeeMore"
      }, [_vm._v("Lihat Hasil")])])])
    }), 0)]) : _vm._e(), _vm._v(" "), (element.type === 'EXERCISE') ? _c('div', {
      staticClass: "exerciseItem"
    }, [_c('div', {
      staticClass: "exerciseName"
    }, [_c('b', [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('button', {
      staticClass: "exerciseIPA"
    }, [_vm._v("IPA")]), _vm._v(" "), _c('button', {
      staticClass: "exerciseIPS"
    }, [_vm._v("IPS")])]), _vm._v(" "), _vm._l((element.details.slice(
      0,
      1
    )), function(item, index) {
      return _c('div', {
        key: index,
        staticClass: "cardExerciseIteration"
      }, [_c('div', {
        staticClass: "exerciseContent"
      }, [_c('p', {
        staticClass: "exerciseMapel"
      }, [_vm._v(_vm._s(_vm.mapelExercise))]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.changeFormat(item.content))
        }
      }), _vm._v(" "), _c('p', {
        staticClass: "exerciseButtonYuk"
      }, [_vm._v("\n                                Kerjakan Soal Yuk\n                              ")])])])
    })], 2) : _vm._e()])
  }), 0)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.menuMode) ? _c('div', {
    staticClass: "listdragMenu"
  }, [_c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "dumHeader"
  }, [_c('div', {
    staticClass: "dumWrapper"
  }, [_c('div', {
    staticClass: "centerFlex"
  }, [_c('img', {
    staticClass: "ticketIcon",
    attrs: {
      "src": _vm.ticket
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "ticketInteger"
  }, [_c('b', [_vm._v("315")])]), _vm._v(" "), _c('p', {
    staticClass: "dumSeeMore"
  }, [_vm._v("lihat detail >")])])]), _vm._v(" "), _c('div', {
    staticClass: "centerFlex"
  }, [_c('div', {
    staticClass: "ticketCount"
  }, [_c('span', {
    staticClass: "haiFulan"
  }, [_c('b', [_vm._v("Hai Fulan,")])]), _vm._v(" "), _c('p', {
    staticClass: "gradeCapt"
  }, [_vm._v("Kelas 12")])]), _vm._v(" "), _c('img', {
    staticClass: "imagePP",
    attrs: {
      "src": _vm.pp
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "package-list"
  }, [_c('div', {
    staticClass: "alertTicket"
  }, [_c('span', [_vm._v("Kamu punya\n                          "), _c('b', {
    staticStyle: {
      "color": "#355eab"
    }
  }, [_vm._v("100 Paket Belajar")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "#3cb54a"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dragmenuarea",
    attrs: {
      "id": "dragMenuSubmit"
    }
  }, [_c('div', {
    staticClass: "icDragMenu",
    on: {
      "click": function($event) {
        _vm.menuMode = false
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-down",
    staticStyle: {
      "color": "#3cb54a"
    }
  })]), _vm._v(" "), _c('draggable', _vm._b({
    staticClass: "draggableMenuSubmit",
    attrs: {
      "move": _vm.onMove
    },
    on: {
      "add": function($event) {
        return _vm.onMenuAdd($event)
      },
      "remove": function($event) {
        return _vm.onMenuRemove($event)
      }
    },
    model: {
      value: (_vm.submitMenu),
      callback: function($$v) {
        _vm.submitMenu = $$v
      },
      expression: "submitMenu"
    }
  }, 'draggable', _vm.dragOptionsMenu, false), [_c('transition-group', {
    staticClass: "transDragmenu"
  }, _vm._l((_vm.submitMenu), function(element) {
    return _c('div', {
      key: element.id
    }, [_c('div', {
      staticClass: "menuPreviewWrapper"
    }, [_c('img', {
      staticClass: "imgMenuPreview",
      attrs: {
        "src": element.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "menuPreviewText"
    }, [_c('p', {
      staticClass: "menuPreviewName"
    }, [_vm._v("\n                                  " + _vm._s(element.name) + "\n                                ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "11px"
      }
    }, [_vm._v(_vm._s(element.description))])])])])
  }), 0)], 1)], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "listdragMenuSection"
  }, [_c('span', {
    staticClass: "listmenuCapt"
  }, [_vm._v("List Menu")]), _vm._v(" "), _c('draggable', _vm._b({
    attrs: {
      "id": "draggableMenuSection",
      "move": _vm.onMove
    },
    model: {
      value: (_vm.menuList),
      callback: function($$v) {
        _vm.menuList = $$v
      },
      expression: "menuList"
    }
  }, 'draggable', _vm.dragOptionsMenu, false), [_c('transition-group', {
    staticClass: "transgrouplistdragmenusection"
  }, _vm._l((_vm.menuList), function(element) {
    return _c('div', {
      key: element.id
    }, [_c('div', {
      staticClass: "menuSectionWrapper"
    }, [_c('img', {
      staticClass: "imgMenuSection",
      attrs: {
        "src": element.picture
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "menuSectionText"
    }, [_c('p', {
      staticClass: "menuSectionName"
    }, [_vm._v(_vm._s(element.name))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(element.description))])])])])
  }), 0)], 1)], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1357 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content Banner")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Konten")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), (_vm.step == 0) ? _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Section *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.section_id),
      expression: "form.section_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "section_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.listSection), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextStep()
      }
    }
  }, [_vm._v("Selanjutnya")])])])])]) : _vm._e(), _vm._v(" "), (_vm.step == 1) ? _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.name),
      expression: "form.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.is_applink_valid, 'has-success': _vm.is_applink_valid
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('span', {
    staticClass: "btn btn-xs",
    class: {
      'btn-primary': _vm.isDeeplink
    },
    on: {
      "click": function($event) {
        _vm.isDeeplink = true
      }
    }
  }, [_vm._v("DEEPLINK")]), _vm._v(" "), _c('span', {
    staticClass: "btn btn-xs",
    class: {
      'btn-primary': !_vm.isDeeplink
    },
    on: {
      "click": function($event) {
        _vm.isDeeplink = false;
        _vm.resetDeeplink()
      }
    }
  }, [_vm._v("WEB LINK")]), _c('br'), _c('br'), _vm._v(" "), (!_vm.isDeeplink) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link),
      expression: "form.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link", $event.target.value)
      }
    }
  }) : _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedDeeplink),
      expression: "selectedDeeplink"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedDeeplink = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((this.deeplinks), function(deeplink) {
    return _c('option', {
      key: deeplink.id,
      domProps: {
        "value": deeplink.link
      }
    }, [_vm._v(_vm._s(deeplink.name.toUpperCase()))])
  }), 0), _vm._v(" "), (_vm.deeplinkParam != null) ? _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon input-group-xs"
  }, [_vm._v(_vm._s(_vm.deeplinkParam.name))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deeplinkParam.value),
      expression: "deeplinkParam.value"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.deeplinkParam.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.deeplinkParam, "value", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.isDeeplink) ? _c('span', {
    staticClass: "help-text"
  }, [_vm._v("must start with "), _c('strong', [_vm._v("http://")]), _vm._v(" or "), _c('strong', [_vm._v("https:// ")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': !_vm.is_url_valid, 'has-success': _vm.is_url_valid
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Link Web")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link_web),
      expression: "form.link_web"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.link_web)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link_web", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload Asset")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.url) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    ref: "banner",
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "src": _vm.url,
      "alt": "avatar"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('app-imagecropper', {
    attrs: {
      "aspectRatio": 0.5
    },
    on: {
      "finished": function($event) {
        return _vm.onFileChanged($event)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status),
      expression: "form.status"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PUBLISHED"
    }
  }, [_vm._v("Published")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HIDDEN"
    }
  }, [_vm._v("Hidden")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])]) : _vm._e()])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Banner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "help-text"
  }, [_vm._v("must start with "), _c('strong', [_vm._v("http://")]), _vm._v(" or "), _c('strong', [_vm._v("https://")])])
}]}

/***/ }),
/* 1358 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Bank Soal")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/items',
        query: {
          mapel: _vm.$route.query.mapel
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.mapel))])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Soal Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(_vm.mapel))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [_c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jenjang') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jenis') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jenjang),
      expression: "form.jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jenjang", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.resetGrades()
      }]
    }
  }, _vm._l((_vm.levels), function(level) {
    return _c('option', {
      key: level.id,
      domProps: {
        "value": level.id
      }
    }, [_vm._v("\n                    " + _vm._s(level.nama) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('grades') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('grades') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 3) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 10,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 10) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 10,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("10")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 11,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 11) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 11,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("11")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 12,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 12) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 12,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("12")])]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 2) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 7,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 7) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 7,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("7")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 8,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 8) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 8,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("8")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 9,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 9) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 9,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("9")])]) : _vm._e(), _vm._v(" "), (_vm.form.jenjang === 1) ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 4,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 4) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 4,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("4")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 5,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 5) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 5,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("5")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grades),
      expression: "grades"
    }],
    staticClass: "checkbox m-r-5",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 6,
      "checked": Array.isArray(_vm.grades) ? _vm._i(_vm.grades, 6) > -1 : (_vm.grades)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.grades,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 6,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.grades = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.grades = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.grades = $$c
        }
      }
    }
  }), _c('span', {
    staticClass: "f-s-14 f-w-700 m-r-10"
  }, [_vm._v("6")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jenis') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenis *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jenis') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jenis),
      expression: "form.jenis"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jenis", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('option', {
      key: type.id,
      domProps: {
        "value": type.id
      }
    }, [_vm._v("\n                    " + _vm._s(type.nama) + "\n                  ")])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('topic') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Topik *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('topic') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('app-autocomplete', {
    attrs: {
      "placeholder": "Cari Bab / (Sub) Sub Bab",
      "data": _vm.topics,
      "value": _vm.form.topic
    },
    on: {
      "selected": function($event) {
        return _vm.assignTopic($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Sumber")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.sumber),
      expression: "form.sumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.sumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "sumber", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Label")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.label),
      expression: "form.label"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-transform": "uppercase"
    },
    attrs: {
      "type": "text",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.form.label)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "label", $event.target.value)
      }, function($event) {
        _vm.labelQuery = _vm.form.label
      }]
    }
  }), _vm._v(" "), _c('app-labelAutocomplete', {
    attrs: {
      "query": _vm.labelQuery
    },
    on: {
      "selected": _vm.onLabelSelected
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bank Soal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.is_restricted),
      expression: "form.is_restricted"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.form.is_restricted) ? _vm._i(_vm.form.is_restricted, null) > -1 : (_vm.form.is_restricted)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.form.is_restricted,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.form, "is_restricted", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.form, "is_restricted", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.form, "is_restricted", $$c)
        }
      }
    }
  }), _vm._v("\n                    Tidak dimunculkan\n                  ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Wacana")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-wacana', {
    attrs: {
      "value": _vm.form.wacana
    },
    on: {
      "selected": function($event) {
        _vm.form.wacana = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('soal') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Soal *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('soal') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.form.soal,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.soal = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Opsi *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiA') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("A")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiA,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiA = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiA') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiB') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("B")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiB,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiB = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiB') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiC') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("C")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiC,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiC = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiC') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    class: {
      'has-error': _vm.errors.indexOf('opsiD') >= 0
    }
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("D")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiD,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiD = $event
      }
    }
  }), _vm._v(" "), (_vm.errors.indexOf('opsiD') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e()], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('p', [_vm._v("Optional:")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("E")]), _vm._v(" "), _c('app-editor', {
    attrs: {
      "rows": 2,
      "value": _vm.form.opsiE,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.opsiE = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('jawaban') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jawaban *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.errors.indexOf('jawaban') >= 0) ? _c('span', {
    staticClass: "help-block"
  }, [_vm._v("field ini wajib diisi")]) : _vm._e(), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.jawaban),
      expression: "form.jawaban"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "A",
      "type": "text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "jawaban", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "A"
    }
  }, [_vm._v("A")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "B"
    }
  }, [_vm._v("B")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "C"
    }
  }, [_vm._v("C")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "D"
    }
  }, [_vm._v("D")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "E"
    }
  }, [_vm._v("E")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Eigen")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.eigen),
      expression: "form.eigen"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "2.55",
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": (_vm.form.eigen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "eigen", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pembahasan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-editor', {
    attrs: {
      "rows": 8,
      "value": _vm.form.pembahasan,
      "context": _vm.mapel
    },
    on: {
      "content-updated": function($event) {
        _vm.form.pembahasan = $event
      }
    }
  })], 1)])])])])])])])
},staticRenderFns: []}

/***/ }),
/* 1359 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "pembayaran"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Pembayaran")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Ticket Usage")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("List Ticket Usage")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.ticketUsageList,
      "headers": _vm.headers,
      "has-action": false,
      "has-custom-search": true,
      "has-custom-pagination": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.detailTicketUsage()
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Ticket Usage")])])
}]}

/***/ }),
/* 1360 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subject"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Aktivasi Organisasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-blue"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('a', {
    attrs: {
      "href": _vm.ossTemplate,
      "download": ""
    }
  }, [_vm._v("\n            Download "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-blue"
  }, [_c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Bulk Activation / Registration Upload .CSV")])]), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Upload "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Download Example csv")])])
}]}

/***/ }),
/* 1361 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "podbean-explorer"
    }
  }, [_c('button', {
    staticClass: "btn btn-white",
    on: {
      "click": function($event) {
        return _vm.explore()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-podcast"
  })]), _vm._v(" "), (_vm.showModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "id": "mapelModal"
    }
  }, [_c('div', {
    staticClass: "modal-header "
  }, [_c('h3', [_vm._v("Pilih File Audio")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.rows,
      "headers": _vm.headers,
      "hasAction": false
    },
    on: {
      "dblClicked": function($event) {
        return _vm.selectItem($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Tutup")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1362 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "datatable"
    }
  }, [(_vm.hasSearchPower) ? _c('div', [(_vm.$route.name !== 'ItemBank') ? _c('form', {
    staticClass: "form-inline pull-right"
  }, [(_vm.filterCriteria.length > 0) ? _c('div', {
    staticClass: "form-group m-r-10"
  }, _vm._l((_vm.filterCriteria), function(criteria, index) {
    return _c('span', {
      key: index,
      staticClass: "label label-info m-r-5"
    }, [_vm._v(_vm._s(criteria))])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Kata kunci"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.field),
      expression: "field"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.field = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.headers), function(value, key) {
    return _c('option', {
      key: key,
      domProps: {
        "value": key
      }
    }, [_vm._v(_vm._s(value))])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.doFilter()
      }
    }
  }, [_vm._v("Filter")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Hapus Filter")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group m-r-10"
  }, [_c('select', {
    staticClass: "form-control",
    domProps: {
      "value": _vm.orderBy
    },
    on: {
      "change": _vm.updateOrderBy
    }
  }, [_c('option', {
    attrs: {
      "value": "desc"
    }
  }, [_vm._v("Baru ke Lama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "asc"
    }
  }, [_vm._v("Lama ke Baru")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.hasFilterStatus) ? _c('div', {
    staticClass: "hasfilterstatus"
  }, [_c('div', {
    staticClass: "flex-disp"
  }, [_c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus(null)
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === null ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        ALL\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === null ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('CHECKOUT')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CHECKOUT' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Checkout\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CHECKOUT' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('CONFIRMED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CONFIRMED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Confirmed\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CONFIRMED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('ACTIVATED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'ACTIVATED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Activated\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'ACTIVATED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('REJECTED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REJECTED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Rejected\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REJECTED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('EXPIRED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'EXPIRED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Expired\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'EXPIRED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('REFUND')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REFUND' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Refund\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'REFUND' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-disp",
    on: {
      "click": function($event) {
        return _vm.filterByStatus('CANCELED')
      }
    }
  }, [_c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CANCELED' ? 'tabstatus-active' : 'tabstatus'
    }
  }, [_vm._v("\n        Canceled\n        ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": _vm.disableStatus === 'CANCELED' ? 'tabtriangle-active' : 'tabtriangle'
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [(_vm.hasCheckbox) ? _c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox",
      "value": "All"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, "All") > -1 : (_vm.selectAll)
    },
    on: {
      "click": function($event) {
        return _vm.checkboxSelectAll()
      },
      "change": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "All",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("No.")]), _vm._v(" "), _vm._l((_vm.headers), function(header, index) {
    return _c('th', {
      key: index
    }, [_vm._v(_vm._s(header))])
  }), _vm._v(" "), (_vm.hasAction || _vm.hasExport) ? _c('th', [_vm._v("Action")]) : _vm._e(), _vm._v(" "), (_vm.hasPaymentStatus) ? _c('th', [_vm._v("Status")]) : _vm._e()], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.currentPageItems), function(values, key) {
    return _c('tr', {
      key: key,
      class: {
        'success': _vm.selectedRow == key
      },
      on: {
        "dblclick": function($event) {
          return _vm.selectRowAndFinish(key)
        },
        "click": function($event) {
          return _vm.selectRow(key)
        }
      }
    }, [(_vm.hasCheckbox) ? _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedCheckbox),
        expression: "selectedCheckbox"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": values.id,
        "checked": Array.isArray(_vm.selectedCheckbox) ? _vm._i(_vm.selectedCheckbox, values.id) > -1 : (_vm.selectedCheckbox)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.selectedCheckbox,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = values.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedCheckbox = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedCheckbox = $$c
          }
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.startNumber + key + 1))]), _vm._v(" "), _vm._l((values.data), function(value, index) {
      return _c('td', {
        key: index,
        class: _vm.hasSoldoutWarning && values.data[2] < 50 ? 'sold-out' : '',
        staticStyle: {
          "word-break": "break-all"
        }
      }, [_c('span', {
        domProps: {
          "innerHTML": _vm._s(value)
        }
      }, [_vm._v(_vm._s(index))])])
    }), _vm._v(" "), (_vm.hasPaymentStatus) ? _c('td', _vm._l((values.status), function(values, index) {
      return _c('div', {
        key: index
      }, [_c('span', {
        staticClass: "label",
        class: {
          'label-warning': (values === 'CHECKOUT'),
          'label-primary': (values === 'CONFIRMED'),
          'label-danger': (values === 'EXPIRED' || values === 'REJECTED' || values === 'CANCELED'),
          'label-success': (values === 'ACTIVATED'),
          'label-default': (values === 'REFUND')
        },
        staticStyle: {
          "font-size": "0.9em"
        }
      }, [_vm._v("\n              " + _vm._s(values) + "\n            ")])])
    }), 0) : _vm._e(), _vm._v(" "), (values.actions) ? _c('td', _vm._l((values.actions), function(action) {
      return _c('button', {
        key: action.command,
        staticClass: "btn btn-xs btn-edit m-1",
        class: action.style,
        on: {
          "click": function($event) {
            _vm.$emit(action.command, _vm.selectRow(key))
          }
        }
      }, [_vm._v(_vm._s(action.text))])
    }), 0) : _vm._e(), _vm._v(" "), (_vm.hasAction) ? _c('td', {
      staticStyle: {
        "display": "flex",
        "flex-flow": "row",
        "justify-content": "flex-start",
        "align-items": "baseline"
      }
    }, [(_vm.hasGrading) ? _c('button', {
      staticClass: "btn btn-info btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          _vm.$emit('gradingTryout', _vm.selectRow(key))
        }
      }
    }, [_vm._v("Grading")]) : _vm._e(), _vm._v(" "), (_vm.hasRanking) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          _vm.$emit('rankingTryout', _vm.selectRow(key))
        }
      }
    }, [_vm._v("Top 10")]) : _vm._e(), _vm._v(" "), (_vm.hasEdit) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          return _vm.editItem(key)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.hasEditA) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-edit m-1",
      on: {
        "click": function($event) {
          return _vm.editItemContent(key)
        }
      }
    }, [_vm._v("Edit")]) : _vm._e(), _vm._v(" "), (_vm.hasPreview) ? _c('button', {
      staticClass: "btn btn-primary btn-xs btn-preview m-1",
      attrs: {
        "data-toggle": "modal",
        "data-target": ".bd-example-modal-sm"
      },
      on: {
        "click": function($event) {
          return _vm.previewVideo(values)
        }
      }
    }, [_vm._v("Preview")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'DRAFT') ? _c('button', {
      staticClass: "btn btn-success btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.publishing(values)
        }
      }
    }, [_vm._v("Publish")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'HIDDEN') ? _c('button', {
      staticClass: "btn btn-success btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.publishing(values)
        }
      }
    }, [_vm._v("Publish")]) : _vm._e(), _vm._v(" "), (_vm.hasPublish && values.status === 'PUBLISHED') ? _c('button', {
      staticClass: "btn btn-danger btn-xs btn-preview m-1",
      on: {
        "click": function($event) {
          return _vm.unpublishing(values)
        }
      }
    }, [_vm._v("Unpublish")]) : _vm._e(), _vm._v(" "), (_vm.hasDelete) ? _c('button', {
      staticClass: "btn btn-danger btn-xs m-1",
      on: {
        "click": function($event) {
          return _vm.deleteItem(key)
        }
      }
    }, [_vm._v("Hapus")]) : _vm._e(), _vm._v(" "), (_vm.hasAddQuota) ? _c('button', {
      class: _vm.hasSoldoutWarning && values.data[2] < 50 ? 'btn btn-danger btn-xs m-1' : 'btn btn-success btn-xs m-1',
      on: {
        "click": function($event) {
          return _vm.$emit('addQuota', values)
        }
      }
    }, [_vm._v("Tambah Kuota")]) : _vm._e(), _vm._v(" "), (_vm.hasPreview) ? _c('div', {
      staticClass: "modal fade bd-example-modal-sm",
      attrs: {
        "tabindex": "-1",
        "role": "dialog",
        "aria-labelledby": "mySmallModalLabel",
        "aria-hidden": "true"
      }
    }, [_c('div', {
      staticClass: "modal-dialog modal-sm"
    }, [_c('div', {
      staticClass: "modal-content"
    }, [_c('youtube', {
      ref: "youtube",
      refInFor: true,
      attrs: {
        "video-id": _vm.videoId
      },
      on: {
        "playing": _vm.playing
      }
    })], 1)])]) : _vm._e()]) : _vm._e()], 2)
  }), 0)]), _vm._v(" "), (_vm.$route.name !== 'ItemBank' && _vm.$route.name !== 'FreeItemBank') ? _c('div', [(_vm.hasSearchPower) ? _c('div', {
    staticClass: "btn-group pull-left"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Total Page:")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(this.maxPage))])]) : _vm._e(), _vm._v(" "), (_vm.items.length > 0 && _vm.hasSearchPower) ? _c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("\n        Previous\n      ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentPage),
      expression: "currentPage"
    }],
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.maxPage
    },
    domProps: {
      "value": (_vm.currentPage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.currentPage = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.currentPage < _vm.maxPage) ? _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.goToPage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("\n        Next\n      ")]) : _vm._e()]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 1363 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liga-sekolah-menu"
    }
  }, [_c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Pilih Menu Liga Sekolah")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-purple"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-sekolah/schedule'
      }
    }
  }, [_vm._v("Lihat Jadwal "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-blue"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-sekolah/brackets'
      }
    }
  }, [_vm._v("Lihat Brackets "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-icon"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "src": "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
      "alt": "liga-schedule-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Schedule")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-icon"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "src": "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_physics.png",
      "alt": "liga-brackets-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Brackets")])])
}]}

/***/ }),
/* 1364 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Dashboard Affiliate")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Dashboard Affiliate")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Start Date*")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.start_date),
      expression: "filter.start_date"
    }],
    staticClass: "form-control datepicker",
    staticStyle: {
      "color": "black !important",
      "background": "white !important"
    },
    attrs: {
      "id": "filterStart",
      "type": "text",
      "name": "discussion_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.filter.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "start_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("End Date*")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.end_date),
      expression: "filter.end_date"
    }],
    staticClass: "form-control datepicker",
    staticStyle: {
      "color": "black !important",
      "background": "white !important"
    },
    attrs: {
      "id": "filterEnd",
      "type": "text",
      "name": "discussion_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.filter.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter, "end_date", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [(_vm.filter.start_date !== null || _vm.filter.end_date !== null) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    on: {
      "click": function($event) {
        return _vm.submitFilter()
      }
    }
  }, [_vm._v("Apply")]) : _vm._e(), _vm._v(" "), (_vm.filter.start_date !== null || _vm.filter.end_date !== null) ? _c('button', {
    staticClass: "btn btn-danger btn-md",
    on: {
      "click": function($event) {
        return _vm.clearFilter()
      }
    }
  }, [_vm._v("Delete Filter")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center",
      "border-radius": "8px",
      "border": "1px solid green"
    }
  }, [_c('h5', [_vm._v("Affiliate Expense")]), _vm._v(" "), _c('h4', [_vm._v("Rp. " + _vm._s(_vm._f("currency")(_vm.dataDash.total_expanse)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center",
      "border-radius": "8px",
      "border": "1px solid green"
    }
  }, [_c('h5', [_vm._v("Total Akumulasi Koin")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm._f("currency")(_vm.dataDash.total_accumulate_coin)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center",
      "border-radius": "8px",
      "border": "1px solid green"
    }
  }, [_c('h5', [_vm._v("Affiliate Income")]), _vm._v(" "), _c('h4', [_vm._v("Rp. " + _vm._s(_vm._f("currency")(_vm.dataDash.total_income)))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "100%",
      "text-align": "center",
      "border-radius": "8px",
      "border": "1px solid green"
    }
  }, [_c('h5', [_vm._v("Affiliator Aktif")]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.dataDash.total_active_member) + " User")]), _vm._v(" "), _c('span', [_vm._v("/ " + _vm._s(_vm.dataDash.total_member) + " Total ")])])])]), _vm._v(" "), _c('h4', [_vm._v("List Affiliate :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "padding-bottom": "15px",
      "padding-left": "0px"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_affiliator.search),
      expression: "filter_affiliator.search"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Search",
      "aria-describedby": "basic-addon1"
    },
    domProps: {
      "value": (_vm.filter_affiliator.search)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitFilterAffiliator('search', _vm.filter_affiliator.search)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter_affiliator, "search", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, [_c('li', {
    staticClass: "list-group-item",
    staticStyle: {
      "display": "flex",
      "flex-flow": "row"
    }
  }, [_c('div', {
    staticClass: "col-md-2 col-xs-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Username")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                    Sisa Koin\n                     "), _c('i', {
    staticClass: "fa fa-sort",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sort('total_coin')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                    Total Koin \n                     "), _c('i', {
    staticClass: "fa fa-sort",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sort('accumulation_coin')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                    Click\n                     "), _c('i', {
    staticClass: "fa fa-sort",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sort('total_click')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("\n                    Telah diredem\n                     "), _c('i', {
    staticClass: "fa fa-sort",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.sort('accumulation_redeem')
      }
    }
  })])]), _vm._v(" "), _vm._l((_vm.listAffiliator.data), function(item) {
    return _c('li', {
      key: item,
      staticClass: "list-group-item",
      staticStyle: {
        "display": "flex",
        "flex-flow": "row"
      }
    }, [_c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v("\n                    " + _vm._s(item.email) + "\n                  ")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v(_vm._s(item.username))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v(_vm._s(_vm._f("currency")(item.total_coin)))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v(_vm._s(_vm._f("currency")(item.accumulation_coin)))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v(_vm._s(_vm._f("currency")(item.total_click)))]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [_vm._v(_vm._s(_vm._f("currency")(item.accumulation_redeem)))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-3",
    staticStyle: {
      "display": "flex",
      "flex-flow": "row",
      "padding-top": "20px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('button', {
    staticClass: "btn btn-white dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("\n                   " + _vm._s(_vm.filter_affiliator.page_size) + " "), _c('span', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.submitFilterAffiliator('page_size', 10)
      }
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.submitFilterAffiliator('page_size', 15)
      }
    }
  }, [_vm._v("15")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.submitFilterAffiliator('page_size', 25)
      }
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [(_vm.filter_affiliator.page > 1) ? _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitFilterAffiliator('page', _vm.filter_affiliator.page - 1)
      }
    }
  }, [_vm._v("Previous")])]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter_affiliator.page),
      expression: "filter_affiliator.page"
    }],
    staticClass: "form-control",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "readonly": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.filter_affiliator.page)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.filter_affiliator, "page", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitFilterAffiliator('page', _vm.filter_affiliator.page + 1)
      }
    }
  }, [_vm._v("Next")])])])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "msg"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Dashboard")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])
}]}

/***/ }),
/* 1365 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Content")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Content Video Gratis")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Video Gratis")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createContentVideo()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Video\n              ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Content Video")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.VideoList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "has-publish": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": 10,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateVideo()
      },
      "deleted": function($event) {
        return _vm.deleteVideo($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1366 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "katalog-tiket"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Menu")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Menu")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Menu")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createMenu()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Menu\n            ")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Menu")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.MenuList,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "has-publish": true,
      "has-edit-a": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": 10,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.updateMenu()
      },
      "editNewTab": function($event) {
        return _vm.updateMenuBtn($event)
      },
      "deleted": function($event) {
        return _vm.deleteMenu($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1367 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "subtest-list"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [(!_vm.showForm && _vm.$store.state.tryout.status != 'PUBLISHED') ? _c('button', {
    staticClass: "btn btn-success pull-right",
    on: {
      "click": function($event) {
        return _vm.createSubtest()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  })]) : _vm._e(), _vm._v(" "), (!_vm.showForm) ? _c('table', {
    staticClass: "table table-hover"
  }, [_c('thead', [_c('tr', [_c('td', [_vm._v("#")]), _vm._v(" "), _c('td', [_vm._v("Gambar")]), _vm._v(" "), _c('td', [_vm._v("Mata Pelajaran")]), _vm._v(" "), _c('td', [_vm._v("Jumlah Soal")]), _vm._v(" "), _c('td', [_vm._v("Durasi")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.$store.state.tryout.subtests), function(subtest, index) {
    return _c('tr', {
      key: subtest.id,
      on: {
        "dblclick": function($event) {
          return _vm.editSubtest(index)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('img', {
      staticClass: "subject-picture",
      attrs: {
        "src": subtest.subject_picture
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subtest.subject_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subtest.details.length))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(subtest.duration))])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), (_vm.showForm) ? _c('app-subtestform', {
    attrs: {
      "subtest": _vm.selectedSubtest
    },
    on: {
      "completed": function($event) {
        _vm.showForm = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.showForm) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('completed')
      }
    }
  }, [_vm._v("Selanjutnya")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liga-sekolah-brackets"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-sekolah'
      }
    }
  }, [_vm._v("Menu Liga Sekolah")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Brackets")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Bracket")]), _vm._v(" "), _c('div', [_c('bracket', {
    attrs: {
      "rounds": _vm.rounds
    },
    scopedSlots: _vm._u([{
      key: "player",
      fn: function(ref) {
        var player = ref.player;

        return [_vm._v("\n\t\t\t\t\t" + _vm._s(player.name) + "\n\t\t\t\t")]
      }
    }, {
      key: "player-extension-bottom",
      fn: function(ref) {
        var match = ref.match;

        return [_vm._v("\n\t\t\t\t\tExtra info: " + _vm._s(match.title) + "\n\t\t\t\t")]
      }
    }])
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1369 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "config-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Config Management")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Kelola Konfigurasi Aplikasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Konfig Aplikasi\n          ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(0), _vm._v(" "), _c('table', {
    staticClass: "table table-stripped"
  }, _vm._l((_vm.configs), function(config, index) {
    return _c('tr', {
      key: config.id
    }, [_c('td', [_c('strong', [_vm._v(_vm._s(config.key))])]), _vm._v(" "), _c('td', [(_vm.editRow == index) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.editValue),
        expression: "editValue"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.editValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.editValue = $event.target.value
        }
      }
    }) : _c('span', [_vm._v(_vm._s(config.value))])]), _vm._v(" "), _c('td', [(_vm.editRow != index) ? _c('span', {
      staticClass: "btn btn-primary btn-xs"
    }, [_c('i', {
      staticClass: "fa fa-edit",
      on: {
        "click": function($event) {
          return _vm.edit(index)
        }
      }
    })]) : _c('div', [_c('span', {
      staticClass: "btn btn-success btn-xs"
    }, [_c('i', {
      staticClass: "fa fa-check",
      on: {
        "click": function($event) {
          return _vm.confirm(index)
        }
      }
    })]), _vm._v(" "), _c('span', {
      staticClass: "btn btn-danger btn-xs"
    }, [_c('i', {
      staticClass: "fa fa-times",
      on: {
        "click": function($event) {
          _vm.editRow = -1
        }
      }
    })])])])])
  }), 0)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Perhatian!")]), _vm._v(" Jangan lupa mengklik tombol \"Simpan\" untuk menyimpan perubahan konfig ke server")])
}]}

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/organizations",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-users"
  }), _c('span', [_vm._v("Kerjasama")])])])
},staticRenderFns: []}

/***/ }),
/* 1371 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "serial-form"
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryout-groups'
      }
    }
  }, [_vm._v("Tryout Serial")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Buat Tryout Serial Baru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Nama tryout serial"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Deskripsi tryout serial"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((9), function(n) {
    return _c('option', {
      key: n,
      domProps: {
        "value": n + 3
      }
    }, [_vm._v(_vm._s(n + 3))])
  }), 0)])]), _vm._v(" "), (_vm.id != null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Serial")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('app-tryoutgroupchooser', {
    attrs: {
      "params": {
        grade: _vm.grade,
        attached: false
      }
    },
    on: {
      "dblClicked": function($event) {
        return _vm.onGroupSelected($event)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('div', {
      key: group.series_sequence,
      staticClass: "panel panel-inverse"
    }, [_c('div', {
      staticClass: "panel-heading"
    }, [_c('div', {
      staticClass: "btn-group pull-right"
    }, [_c('button', {
      staticClass: "btn btn-xs btn-danger btn-icon btn-circle",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.confirmUnAttachGroup(group)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times"
    })])]), _vm._v(" "), _c('h4', {
      staticClass: "panel-title"
    }, [_vm._v("group id: " + _vm._s(group.id))])]), _vm._v(" "), _c('div', {
      staticClass: "panel-body bg-silver-lighter m-b-5"
    }, [_c('h4', [_c('a', {
      staticClass: "btn btn-inverse btn-icon btn-circle text-white m-r-10"
    }, [_vm._v(_vm._s(group.series_sequence))]), _vm._v("\n                                            " + _vm._s(group.name) + "\n                                        ")])])])
  })], 2)]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showUnAttachModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.processUnAttachGroup()
      },
      "cancel": function($event) {
        _vm.showUnAttachModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Tryout Group")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan menghapus Tryout Group "), _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.selectedGroup.name))]), _vm._v("\n        dari Serial "), _c('strong', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" ?")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Buat Tryout Serial")])])
}]}

/***/ }),
/* 1372 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "id": "autocomplete"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }, _vm.search]
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "list-group",
    staticStyle: {
      "position": "absolute",
      "width": "100%",
      "z-index": "9999999"
    }
  }, _vm._l((_vm.suggestions), function(suggestion, index) {
    return _c('li', {
      key: index,
      staticClass: "list-group-item",
      on: {
        "click": function($event) {
          return _vm.choose(suggestion)
        }
      }
    }, [(_vm.sourcetype === 'INTERNAL') ? _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(suggestion.name))]) : _c('a', {
      attrs: {
        "href": "javascript:;"
      }
    }, [_vm._v(_vm._s(suggestion.nama))])])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 1373 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "season-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/season'
      }
    }
  }, [_vm._v("List Season")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Season")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Season")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(!_vm.$route.query.id ? 'Buat' : 'Update') + " Season")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.name),
      expression: "data.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('ckeditor', {
    attrs: {
      "editor": _vm.editor,
      "config": _vm.editorConfig
    },
    model: {
      value: (_vm.data.description),
      callback: function($$v) {
        _vm.$set(_vm.data, "description", $$v)
      },
      expression: "data.description"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.data.description) ? _c('span', [_c('i', [_vm._v("(" + _vm._s(_vm.characterCounter(_vm.data.description)) + " karakter)")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.data.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('file-upload', {
    attrs: {
      "context": "season"
    },
    on: {
      "uploaded": function($event) {
        _vm.data.picture = $event
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.started_at),
      expression: "data.started_at"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "placeholder": "Tanggal Mulai",
      "name": "started_at"
    },
    domProps: {
      "value": (_vm.data.started_at)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "started_at", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(3)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.ended_at),
      expression: "data.ended_at"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal Selesai",
      "name": "ended_at"
    },
    domProps: {
      "value": (_vm.data.ended_at)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "ended_at", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._m(5)])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Season "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai Season "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\tAkhir Season "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _c('br'), _vm._v("(Berakhir pada jam 23:59)\n\t\t\t\t\t\t\t\t\t")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
}]}

/***/ }),
/* 1374 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header navbar navbar-default navbar-fixed-top",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.th === 'old') ? _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" " + _vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.th === 'new') ? _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": 'https://www.nfjuara.id/wp-content/uploads/2021/08/logo-nf.png'
    }
  }), _vm._v("  Admin")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown navbar-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    attrs: {
      "src": this.picture,
      "alt": "avatar"
    },
    on: {
      "error": function($event) {
        this.src = '~@/assets/img/avatar-default.svg'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated fadeInLeft"
  }, [_c('li', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.changeTheme
    }
  }, [_vm._v("Change Theme")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v("Log Out")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-click": "sidebar-toggled"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-click": "sidebar-toggled"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}

/***/ }),
/* 1375 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-chooser"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [(_vm.$route.name !== 'DetailPaketMapel') ? _c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openGroupModal
    }
  }, [_vm._v("Pilih ...")]) : _vm._e()]), _vm._v(" "), (_vm.showModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "id": "modal"
    }
  }, [(_vm.$route.name !== 'DetailPaketMapel') ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Pilih Prasyarat")]) : _vm._e(), _vm._v(" "), (_vm.$route.name === 'DetailPaketMapel') ? _c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Pilih Tryout")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.rows,
      "headers": _vm.headers,
      "hasAction": false
    },
    on: {
      "dblClicked": function($event) {
        return _vm.onTryoutGroupChoosen($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Close")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1376 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-group"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Tryout")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Daftar Tryout Group")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Daftar Tryout Group")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createTryoutGroup()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tryout Group")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Tryout Group")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.tryoutGroups,
      "has-action": true,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editTryoutGroup()
      },
      "deleted": function($event) {
        return _vm.deleteTryoutGroup($event)
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1377 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_vm._v("\n    " + _vm._s(_vm.source ? '' : '') + "\n    "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/video'
      }
    }
  }, [_vm._v("Video Pembelajaran")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Upload")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Upload Video")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [(_vm.modul != null) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Modul Name *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.modul.name
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("URL Video *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.url),
      expression: "url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan URL Video dan tekan enter",
      "required": ""
    },
    domProps: {
      "value": (_vm.url)
    },
    on: {
      "keydown": function($event) {
        return _vm.hideForm()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.url = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.changeUrl) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.changeUrl) ? _c('button', {
    staticClass: "btn btn-success pull-left mb-3",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.checkURL()
      }
    }
  }, [_vm._v("Preview URL")]) : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('youtube', {
    ref: "youtube",
    attrs: {
      "video-id": _vm.videoId
    },
    on: {
      "playing": _vm.playing
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.$route.name === 'VideoMaterialLiveStream') ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mulai")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_time),
      expression: "start_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "startTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "start_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Berakhir")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "end_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_time),
      expression: "end_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])])], 1)]) : _vm._e(), _vm._v(" "), (!_vm.changeUrl) ? _c('div', [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Source")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.source),
      expression: "source"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.source = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "youtube"
    }
  }, [_vm._v("Youtube")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul Video *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.judul),
      expression: "judul"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": !_vm.$route.query.id && !_vm.$route.query.liveId,
      "placeholder": "Judul Video"
    },
    domProps: {
      "value": (_vm.judul)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.judul = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.altTitle),
      expression: "altTitle"
    }],
    attrs: {
      "type": "checkbox",
      "name": "alt-title",
      "value": "Bike"
    },
    domProps: {
      "checked": Array.isArray(_vm.altTitle) ? _vm._i(_vm.altTitle, "Bike") > -1 : (_vm.altTitle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.altTitle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Bike",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.altTitle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.altTitle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.altTitle = $$c
        }
      }
    }
  }), _vm._v(" Judul Alternatif\n                          ")]) : _vm._e()]), _vm._v(" "), (_vm.altTitle) ? _c('div', {
    staticClass: "offset-2 col-md-8 col-xs-12 pt-0"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.judulalt),
      expression: "judulalt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Judul Alternatif",
      "required": _vm.altTitle
    },
    domProps: {
      "value": (_vm.judulalt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.judulalt = $event.target.value
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "1"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "1") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "1",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  1\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "2"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "2") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "2",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  2\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "3"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "3") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "3",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  3\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "4"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "4") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "4",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  4\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "5"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "5") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "5",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  5\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "6"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "6") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "6",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  6\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "7"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "7") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "7",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  7\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "8"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "8") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "8",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  8\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "9"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "9") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "9",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  9\n                          ")])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "10"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "10") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "10",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  10\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "11"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "11") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "11",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  11\n                          ")]), _vm._v(" "), _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    attrs: {
      "type": "checkbox",
      "value": "12"
    },
    domProps: {
      "checked": Array.isArray(_vm.kelas) ? _vm._i(_vm.kelas, "12") > -1 : (_vm.kelas)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.kelas,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "12",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.kelas = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.kelas = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.kelas = $$c
        }
      }
    }
  }), _vm._v("  12\n                          ")])]) : _vm._e()]), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', {
    staticClass: "col-md-6 class-type"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interest),
      expression: "interest"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interest = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SAINTEK"
    }
  }, [_vm._v("IPA")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOSHUM"
    }
  }, [_vm._v("IPS")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ALL"
    }
  }, [_vm._v("Semua")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Mata Pelajaran *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mapel),
      expression: "mapel"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.mapel = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.mapelList), function(item) {
    return _c('option', {
      key: item.id,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nama))])
  }), 0)])])]) : _vm._e()])]), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.changeUrl) ? _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.query.id && !_vm.$route.query.liveId) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])]) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "ok": function($event) {
        return _vm.removeDependency()
      },
      "cancel": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Hapus Pra-Syarat")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah anda yakin akan menghapus pra-syarat "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.dependencyName))]), _vm._v(" ?")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Upload Video Pembelajaran")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}

/***/ }),
/* 1378 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/content/itembank'
      }
    }
  }, [_vm._v("Content")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Import Itembank Gratis")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Import Itembank")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorParse) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_vm._v("Upload File JSON")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md",
    staticStyle: {
      "max-width": "200px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.file.click()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file"
  }), _vm._v(" Pilih File JSON")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Masukkan file dalam format JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(!_vm.isReadable) ? _c('button', {
    staticClass: "btn btn-info btn-md pull-right",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.itembanks.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.previewJSON()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-table"
  }), _vm._v(" Preview")]) : _vm._e()])]), _vm._v(" "), (_vm.itembanks.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v(_vm._s(_vm.viewMapel))])])]) : _vm._e(), _vm._v(" "), (_vm.itembanks.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('b', [_vm._v(_vm._s(_vm.viewJenjang))])])]) : _vm._e(), _vm._v(" "), (_vm.itembanks.length > 0) ? _c('div', {
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "10px"
    }
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.itembanks,
      "headers": _vm.headers,
      "has-action": true,
      "has-custom-pagination": false,
      "has-custom-search": false,
      "has-search-power": false
    },
    on: {
      "deleted": function($event) {
        return _vm.deleteItem($event)
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    staticStyle: {
      "max-width": "300px",
      "float": "right",
      "margin": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Import")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    staticStyle: {
      "max-width": "300px",
      "float": "right",
      "margin": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-close"
  }), _vm._v(" Batal")])], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Import Itembank")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "text-decoration": "none"
    }
  }, [_c('li', [_vm._v("File tidak bisa dibaca")]), _vm._v(" "), _c('li', [_vm._v("Pastikan jenis file (.JSON / .json)")]), _vm._v(" "), _c('li', [_vm._v("Format JSON tidak valid")]), _vm._v(" "), _c('li', [_vm._v("Atau "), _c('a', {
    staticStyle: {
      "color": "red",
      "text-decoration": "revert"
    },
    attrs: {
      "href": "https://codebeautify.org/jsonviewer",
      "target": "_blank"
    }
  }, [_vm._v("Periksa text JSON anda disini")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v(" Mapel : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-1"
  }, [_c('b', [_vm._v("Jenjang: ")])])
}]}

/***/ }),
/* 1379 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "season-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": '/organization/' + _vm.$route.params.id
    }
  }, [_vm._v("Organisasi")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Organisasi Form")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(!_vm.$route.params.id ? 'Buat' : 'Update') + " Organisasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v(_vm._s(!_vm.$route.params.id ? 'Buat' : 'Update') + " Organisasi")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.name),
      expression: "data.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (!_vm.$route.params.id) ? _c('div', {
    staticClass: "form-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.email),
      expression: "data.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.data.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "email", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "margin": "10px 0px 10px 0px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.setPass),
      expression: "setPass"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.setPass) ? _vm._i(_vm.setPass, null) > -1 : (_vm.setPass)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.setPass,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.setPass = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.setPass = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.setPass = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Set Password")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.password),
      expression: "data.password"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": !_vm.setPass,
      "type": "password"
    },
    domProps: {
      "value": (_vm.data.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "password", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.province),
      expression: "data.province"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.data, "province", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.provinceList), function(item, index) {
    return _c('option', {
      key: index
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.city),
      expression: "data.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email"
    },
    domProps: {
      "value": (_vm.data.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.address),
      expression: "data.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.contact),
      expression: "data.contact"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.data.contact)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "contact", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Gambar")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.data.picture
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('file-upload', {
    attrs: {
      "type": "assets",
      "context": "organization"
    },
    on: {
      "uploadedData": _vm.fileUploaded
    }
  })], 1)])])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [(!_vm.$route.params.id) ? _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("Simpan")]) : _c('button', {
    staticClass: "btn btn-success pull-right",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editData()
      }
    }
  }, [_vm._v("Update")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama Organisasi "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Email Organisasi "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Password "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Provinsi "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kota/Kabupaten "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Alamat "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("No. Telpon "), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])])
}]}

/***/ }),
/* 1380 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liga-personal-menu"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Menu Liga Personal")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Pilih Menu Liga Personal")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-purple"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-personal/schedule'
      }
    }
  }, [_vm._v("Lihat Jadwal "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('div', {
    staticClass: "widget widget-stats bg-blue"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "stats-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-personal/brackets'
      }
    }
  }, [_vm._v("Lihat Brackets "), _c('i', {
    staticClass: "fa fa-arrow-circle-o-right"
  })])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-icon"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "src": "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_tpa_verbal.png",
      "alt": "liga-schedule-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Schedule")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-icon"
  }, [_c('img', {
    staticStyle: {
      "max-width": "80px"
    },
    attrs: {
      "src": "https://bonf-files.sgp1.digitaloceanspaces.com/assets/ic_physics.png",
      "alt": "liga-brackets-logo"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "stats-info"
  }, [_c('p', [_vm._v("Brackets")])])
}]}

/***/ }),
/* 1381 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Menu")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Create")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Tambah Menu")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('type_id') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Type *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.type_id),
      expression: "form.type_id"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.menuTypes), function(menuType) {
    return _c('option', {
      key: menuType.id,
      domProps: {
        "value": menuType.id
      }
    }, [_vm._v(_vm._s(menuType.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('information') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Deskripsi")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.description),
      expression: "form.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('status_tag') >= 0
    }
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Status Tag (Optional)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.status_tag),
      expression: "form.status_tag"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.status_tag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "status_tag", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload Asset")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.form.picture) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": _vm.form.picture
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        return _vm.handleChangePicture($event)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.$route.query.id) ? _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan Perubahan")]) : _c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Simpan")])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Menu")])])
}]}

/***/ }),
/* 1382 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.rectre('/')
      }
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.rectre('/paket-mapel')
      }
    }
  }, [_vm._v("Bimbel Online")])]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Paket Mata Pelajaran")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.packData.name))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 mb-3"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.showForm()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" "), _c('b', [_vm._v("Tambah Bab")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row-bab"
  }, [_c('div', {
    staticClass: "row flex-nowrap"
  }, _vm._l((_vm.packData.sections), function(item, index) {
    return _c('bab', {
      key: index,
      attrs: {
        "indexProp": index,
        "datalist": item,
        "mapelid": _vm.packData
      },
      on: {
        "editBab": function($event) {
          return _vm.detailBab($event)
        },
        "throwEdit": function($event) {
          return _vm.editContent($event)
        },
        "reload": function($event) {
          return _vm.loadData()
        },
        "addingcontent": function($event) {
          return _vm.addContentButton($event)
        }
      }
    })
  }), 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addBabModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "addBabModalTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.postState === 0) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "addBabModalTitle"
    }
  }, [_c('b', [_vm._v("Tambah Bab")])]) : _vm._e(), _vm._v(" "), (_vm.postState === 1) ? _c('h5', {
    staticClass: "modal-title",
    attrs: {
      "id": "addBabModalTitle"
    }
  }, [_c('b', [_vm._v("Update Bab")])]) : _vm._e(), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Nama")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Bab")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bab_name),
      expression: "bab_name"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.bab_name = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listBab), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.nama
      }
    }, [_vm._v(_vm._s(item.nama))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Start Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_date),
      expression: "start_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "startDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "start_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.start_time),
      expression: "start_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "startTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "start_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.start_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.start_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("End Date*")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_date),
      expression: "end_date"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "endDate",
      "type": "text",
      "placeholder": "Tanggal",
      "name": "end_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_date)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_date = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-xs-4"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.end_time),
      expression: "end_time"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "endTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "end_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.end_time)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.end_time = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2 col-xs-2"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.is_free),
      expression: "is_free"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.is_free) ? _vm._i(_vm.is_free, null) > -1 : (_vm.is_free)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.is_free,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.is_free = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.is_free = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.is_free = $$c
        }
      }
    }
  }), _vm._v("  "), _c('b', [_vm._v("Gratis")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.postState === 0) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveDataBab()
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e(), _vm._v(" "), (_vm.postState === 1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.editDataBab()
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": 'kontenmodal',
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "exampleModalLongTitle",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.idContent === null) ? _c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_c('b', [_vm._v("Tambah Konten ")])]) : _vm._e(), _vm._v(" "), (_vm.idContent !== null) ? _c('h5', {
    staticClass: "modal-title",
    staticStyle: {
      "float": "left"
    },
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_c('b', [_vm._v("Update Konten ")])]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.hideFormContent()
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('ul', {
    staticClass: "nav nav-tabs",
    attrs: {
      "id": "myTab",
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 1 ? 'nav-link active' : _vm.type_id !== 1 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "video-tab",
      "data-toggle": "tab",
      "href": "#video",
      "role": "tab",
      "aria-controls": "video",
      "aria-selected": "true"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 1 : ''
      }
    }
  }, [_vm._v("Video")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 2 ? 'nav-link active' : _vm.type_id !== 2 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "materi-tab",
      "data-toggle": "tab",
      "href": "#materi",
      "role": "tab",
      "aria-controls": "materi",
      "aria-selected": "false"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 2 : ''
      }
    }
  }, [_vm._v("Materi")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 3 ? 'nav-link active' : _vm.type_id !== 3 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "latihan-tab",
      "data-toggle": "tab",
      "href": "#latihan",
      "role": "tab",
      "aria-controls": "latihan",
      "aria-selected": "false"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 3 : ''
      }
    }
  }, [_vm._v("Latihan Soal")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    class: _vm.type_id === 4 ? 'nav-link active' : _vm.type_id !== 4 && _vm.idContent !== null ? 'nav-link disabled' : 'nav-link',
    attrs: {
      "id": "terjadwal-tab",
      "data-toggle": "tab",
      "href": "#terjadwal",
      "role": "tab",
      "aria-controls": "terjadwal",
      "aria-selected": "false"
    },
    on: {
      "click": function($event) {
        _vm.idContent === null ? _vm.type_id = 4 : ''
      }
    }
  }, [_vm._v("Tryout Terjadwal")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content",
    attrs: {
      "id": "myTabContent"
    }
  }, [(_vm.type_id === 1) ? _c('div', [(this.errorVideo.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorVideo), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video_judul),
      expression: "video_judul"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.video_judul = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.listVideo), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul Alternatif")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video_judul_alt),
      expression: "video_judul_alt"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.video_judul_alt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video_judul_alt = $event.target.value
      }
    }
  })])])])])])]) : _vm._e(), _vm._v(" "), (_vm.type_id === 2) ? _c('div', [(this.errorMateri.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorMateri), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materi_judul),
      expression: "materi_judul"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.materi_judul)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.materi_judul = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Upload")]), _vm._v(" "), (_vm.showLoader) ? _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('img', {
    attrs: {
      "src": _vm.loading
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.showLoader) ? _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.file_url !== '') ? _c('a', {
    staticStyle: {
      "margin": "10px"
    },
    attrs: {
      "href": _vm.file_url,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file"
  }), _vm._v("  " + _vm._s(_vm.convertURL(_vm.file_url)))]) : _vm._e(), _vm._v(" "), (_vm.file_url !== '') ? _c('br') : _vm._e(), _vm._v(" "), (_vm.file_url !== '') ? _c('br') : _vm._e(), _vm._v(" "), _c('span', [_c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "id": "file",
      "placeholder": [
        ['ganti file']
      ]
    },
    on: {
      "change": function($event) {
        return _vm.handleFileUpload()
      }
    }
  })]), _vm._v(" "), (_vm.validFile === 1) ? _c('div', {
    staticStyle: {
      "color": "green",
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("File is Valid and uploaded!")]) : _vm._e(), _vm._v(" "), (_vm.validFile === 2) ? _c('div', {
    staticStyle: {
      "color": "red",
      "font-size": "12px",
      "padding": "5px"
    }
  }, [_vm._v("upload gagal, pastikan jenis file yang dipilih adalah pdf")]) : _vm._e()]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), (_vm.type_id === 3) ? _c('div', [(this.errorSoal.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorSoal), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Bab")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('app-autocomplete', {
    ref: "autocomplete",
    attrs: {
      "placeholder": "Cari Bab",
      "data": _vm.babList,
      "value": _vm.autoValueBab
    },
    on: {
      "selected": function($event) {
        return _vm.assignBab($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Sub Bab")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('app-autocomplete', {
    ref: "subbabautocomplete",
    attrs: {
      "placeholder": "Cari Sub Bab",
      "data": _vm.subBabList,
      "value": _vm.autoValueSubBab
    },
    on: {
      "selected": function($event) {
        return _vm.assignSubBab($event)
      }
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "tryout",
      "role": "tabpanel",
      "aria-labelledby": "tryout-tab"
    }
  }, [(this.errorTryout.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorTryout), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeTO),
      expression: "typeTO"
    }],
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeTO = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SBMPTN"
    }
  }, [_vm._v("SBMPTN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_NASIONAL"
    }
  }, [_vm._v("UJIAN AKHIR NASIONAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_SEKOLAH"
    }
  }, [_vm._v("UJIAN AKHIR SEKOLAH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_SEKOLAH"
    }
  }, [_vm._v("UJIAN SEKOLAH")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Varian *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variant),
      expression: "variant"
    }],
    attrs: {
      "name": "variant"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.variant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "INSTANT_COMPLETE"
    }
  }, [_vm._v("INSTANT")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openTO
    }
  }, [_vm._v("Klik Untuk Pilih Tryout")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id && _vm.TOFromEdit === '') ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.dependencyName))])]) : _vm._e(), _vm._v(" "), (_vm.TOFromEdit !== '' && _vm.idContent !== null) ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.TOFromEdit))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("hapus")]) : _vm._e()])])])])]), _vm._v(" "), (_vm.type_id === 4) ? _c('div', [(this.errorTerjadwal.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errorTerjadwal), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v(_vm._s(message))])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "form-horizontal form-bordered"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Jenjang *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.jenjang),
      expression: "jenjang"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetKelas()
      }]
    }
  }, _vm._l((_vm.jenjangList), function(item) {
    return _c('option', {
      key: item
    }, [_vm._v(_vm._s(item))])
  }), 0)])]), _vm._v(" "), (_vm.jenjang) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelas *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-6"
  }, [(_vm.jenjang === 'SD') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMP') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("9")])])]) : _vm._e(), _vm._v(" "), (_vm.jenjang === 'SMA') ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.kelas),
      expression: "kelas"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.kelas = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("12")])])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Tipe *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.typeTO),
      expression: "typeTO"
    }],
    attrs: {
      "name": "type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.typeTO = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SBMPTN"
    }
  }, [_vm._v("SBMPTN")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_NASIONAL"
    }
  }, [_vm._v("UJIAN AKHIR NASIONAL")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_AKHIR_SEKOLAH"
    }
  }, [_vm._v("UJIAN AKHIR SEKOLAH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UJIAN_SEKOLAH"
    }
  }, [_vm._v("UJIAN SEKOLAH")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Varian *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variant),
      expression: "variant"
    }],
    attrs: {
      "name": "variant"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.variant = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "SCHEDULED"
    }
  }, [_vm._v("BERAGENDA")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Pilih Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [(_vm.idContent === null) ? _c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openTO
    }
  }, [_vm._v("Klik Untuk Pilih Tryout")]) : _vm._e(), _vm._v(" "), (_vm.idContent !== null) ? _c('button', {
    staticClass: "btn btn-inverse",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openTO
    }
  }, [_vm._v("Ubah TO ...")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id && _vm.TOFromEdit === '') ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.dependencyName))])]) : _vm._e(), _vm._v(" "), (_vm.TOFromEdit !== '' && _vm.idContent !== null) ? _c('div', {
    staticClass: "note note-info"
  }, [_c('h4', [_vm._v(_vm._s(_vm.TOFromEdit))])]) : _vm._e(), _vm._v(" "), (_vm.$store.state.tryoutgroup.dependency_id) ? _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }, [_vm._v("hapus")]) : _vm._e()])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [(_vm.idContent === null) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.saveContent(_vm.type_id)
      }
    }
  }, [_vm._v("Simpan")]) : _vm._e(), _vm._v(" "), (_vm.idContent !== null) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.updateKonten(_vm.type_id)
      }
    }
  }, [_vm._v("Update")]) : _vm._e()])])])]), _vm._v(" "), _c('app-tryoutgroupchooser', {
    ref: "groupChooser",
    attrs: {
      "params": {
        grade: _vm.kelas,
        status: 'PUBLISHED',
        type: _vm.typeTO,
        variant: _vm.variant
      }
    },
    on: {
      "dblClicked": function($event) {
        return _vm.addDependency($event)
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}

/***/ }),
/* 1383 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mapping-modal"
  }, [_c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "cancel": function($event) {
        return _vm.reset()
      },
      "ok": function($event) {
        return _vm.submitData()
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Pilih Topik: "), (_vm.selectedCard !== null) ? _c('strong', [_vm._v(_vm._s(_vm.selectedCard.name))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "input-group m-b-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukan kata kunci pencarian ..."
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), (_vm.filteredCards.length === 0 && _vm.selectedCard !== null) ? _c('p', [_vm._v("Tidak ada data lagi di bawah topik ini")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredCards), function(card, index) {
    return _c('button', {
      key: index,
      staticClass: "btn btn-lg btn-inverse btn-block col-md-12 p-10",
      on: {
        "click": function($event) {
          return _vm.onCardSelected(card)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "max-width": "50px",
        "align": "left"
      },
      attrs: {
        "src": card.picture
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(card.name))])])
  })], 2)]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1384 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Guru")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Guru")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Aktivasi Guru")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Guru\n          ")]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.showDownloadKonsul('report')
      }
    }
  }, [_vm._v("Unduh Data Konsul")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    on: {
      "click": function($event) {
        return _vm.showDownloadKonsul('recap_report')
      }
    }
  }, [_vm._v("Unduh Rekap Konsul")])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "searchbox",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Masukkan kata kunci dan tekan enter"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.loadTeachersData(1)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.mapel),
      expression: "filter.mapel"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "mapel", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Mata Pelajaran")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _vm._l((_vm.mapels), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.displayName))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.status),
      expression: "filter.status"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": "",
      "hidden": ""
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "true"
    }
  }, [_vm._v("Aktif")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "false"
    }
  }, [_vm._v("Terdaftar")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadTeachersData(1)
      }
    }
  }, [_vm._v("Apply")])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.teachers), function(teacher, key) {
    return _c('tr', {
      key: key,
      on: {
        "dblclick": function($event) {
          return _vm.goToDetail(teacher.user_id)
        }
      }
    }, [_c('td', [_vm._v(_vm._s((15 * (_vm.pageNumber - 1)) + (key + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(teacher.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(teacher.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(teacher.expired_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(teacher.employee_id))]), _vm._v(" "), _c('td', [(teacher.is_verified) ? _c('span', [_vm._v("Aktif")]) : _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Terdaftar")])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-danger btn-xl",
      on: {
        "click": function($event) {
          return _vm.deleteTeacher(teacher)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })])])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.pageNumber === 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadTeachersData(--_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Previous\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "50px",
      "text-align": "center"
    },
    attrs: {
      "type": "text",
      "readonly": ""
    },
    domProps: {
      "value": _vm.pageNumber
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.isDisabledNextBtn,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadTeachersData(++_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Next\n            ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade bs-example-modal-sm",
    attrs: {
      "id": "modalDownloadKonsul",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "FilterModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm",
    staticStyle: {
      "max-width": "300px !important"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "list-group"
  }, [_c('form', {
    attrs: {
      "action": "submit"
    }
  }, [_c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Tanggal Mulai")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('date-picker', {
    attrs: {
      "value-type": "timestamp",
      "valueType": "format"
    },
    model: {
      value: (_vm.consul.started_at),
      callback: function($$v) {
        _vm.$set(_vm.consul, "started_at", $$v)
      },
      expression: "consul.started_at"
    }
  })], 1), _vm._v(" "), _c('label', {
    attrs: {
      "for": "basic-url"
    }
  }, [_vm._v("Tanggal Akhir")]), _vm._v(" "), _c('div', {
    staticClass: "input-group",
    staticStyle: {
      "margin-bottom": "20px"
    }
  }, [_c('date-picker', {
    attrs: {
      "value-type": "timestamp",
      "valueType": "format"
    },
    model: {
      value: (_vm.consul.ended_at),
      callback: function($$v) {
        _vm.$set(_vm.consul, "ended_at", $$v)
      },
      expression: "consul.ended_at"
    }
  })], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "11px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.downloadKonsul()
      }
    }
  }, [_vm._v("Unduh File")])])])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Nama Guru")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Expired Date")]), _vm._v(" "), _c('th', [_vm._v("Nomor Pegawai")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between"
    }
  }, [_c('h4', {
    attrs: {
      "id": "exampleModalLongTitle"
    }
  }, [_vm._v("Download Rekap Konsul")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "position": "absolute",
      "right": "15px"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])
}]}

/***/ }),
/* 1385 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryoutgroup-chooser"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }), _vm._v(" "), (_vm.showModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("Pilih Mata Pelajaran")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "overflow": "auto !important"
    }
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.rows,
      "headers": _vm.headers,
      "hasAction": false
    },
    on: {
      "dblClicked": function($event) {
        return _vm.onMapelChoosen($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Close")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1386 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Pengaturan Iklan")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Pengaturan Iklan")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', [_vm._v("General")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Status Ads")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-xs-12"
  }, [_c('div', {
    staticClass: "btn-group btn-toggle"
  }, [_c('button', {
    class: _vm.adsStatus ?
      'btn btn-xs btn-success active' :
      'btn btn-xs btn-default',
    on: {
      "click": function($event) {
        _vm.adsStatus = true
      }
    }
  }, [_vm._v("\n                        ON\n                      ")]), _vm._v(" "), _c('button', {
    class: !_vm.adsStatus ?
      'btn btn-xs btn-danger active' :
      'btn btn-xs btn-default',
    on: {
      "click": function($event) {
        _vm.adsStatus = false
      }
    }
  }, [_vm._v("\n                        OFF\n                      ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label",
    staticStyle: {
      "padding-top": "18px"
    }
  }, [_vm._v("Trigger Ads")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_vm._v("\n                      Minimum Soal\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minQ),
      expression: "minQ"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.minQ)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.minQ = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_vm._v("\n                      Maximum Soal\n                      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxQ),
      expression: "maxQ"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0"
    },
    domProps: {
      "value": (_vm.maxQ)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxQ = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('h4', [_vm._v("Google Ads")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-4 control-label"
  }, [_vm._v("Target Kelas")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-4"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-selecting dropdown-toggle",
    staticStyle: {
      "padding": "10px",
      "display": "flex",
      "align-items": "center",
      "background": "white",
      "border": "solid 1px lightgray"
    },
    attrs: {
      "type": "button",
      "id": "dropdownMenu2",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-right": "10px"
    }
  }, [_vm._v("Pilih Kelas")]), _vm._v(" "), (_vm.googleTargeted.length > 0) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": "wrap"
    }
  }, _vm._l((_vm.googleTargeted), function(item, i) {
    return _c('span', {
      key: item + 'a',
      staticStyle: {
        "color": "white",
        "border-radius": "4px",
        "padding": "5px",
        "background": "gray",
        "border": "gray solid 1px",
        "margin": "4px"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.googleTargeted.splice(i, 1)
        }
      }
    }, [_vm._v("\n                            Kelas " + _vm._s(item) + " "), _c('i', {
      staticClass: "fa fa-close"
    })])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.googleTargeted.length == 0) ? _c('span', {
    staticClass: "caret"
  }) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu2"
    }
  }, _vm._l((_vm.listKelas), function(item) {
    return _c('div', {
      key: item,
      on: {
        "click": function($event) {
          return _vm.googleTargeted.push(item)
        }
      }
    }, [(_vm.hideClass(item, _vm.googleTargeted)) ? _c('li', {
      staticStyle: {
        "padding": "10px"
      }
    }, [_c('a', [_vm._v("Kelas " + _vm._s(item))])]) : _vm._e()])
  }), 0)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white",
      "font-weight": "bold",
      "margin": "10px"
    }
  }, [_vm._v("Tekan untuk menyimpan semua perubahan data!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-large",
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                Simpan\n              ")])])]), _vm._v(" "), _c('h4', [_vm._v("Internal Ads")]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.mInternalAdsData), function(d, i) {
    return _c('div', {
      key: i,
      staticClass: "row",
      staticStyle: {
        "padding": "10px 0px 10px 0px",
        "border-bottom": "1px solid lightgray"
      }
    }, [_c('div', {
      staticClass: "col-md-2"
    }, [_c('div', [_c('button', {
      staticClass: "btn btn-selecting dropdown-toggle",
      staticStyle: {
        "padding": "10px",
        "display": "flex",
        "align-items": "center",
        "background": "white",
        "border": "solid 1px lightgray",
        "flex-flow": "column"
      },
      attrs: {
        "type": "button",
        "id": "dropdownMenu2",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [_c('div', {
      staticStyle: {
        "margin-right": "10px"
      }
    }, [_vm._v("Pilih Kelas")]), _vm._v(" "), (d.grades.length > 0) ? _c('div', {
      staticStyle: {
        "display": "flex",
        "flex-wrap": "wrap"
      }
    }, _vm._l((d.grades), function(item, it) {
      return _c('button', {
        key: item + 'a',
        staticStyle: {
          "color": "white",
          "border-radius": "4px",
          "padding": "5px",
          "background": "gray",
          "border": "gray solid 1px",
          "margin": "4px"
        },
        on: {
          "click": function($event) {
            $event.preventDefault();
            return _vm.removeGrade(i, it)
          }
        }
      }, [_vm._v("\n                        Kelas " + _vm._s(item) + " "), _c('i', {
        staticClass: "fa fa-close"
      })])
    }), 0) : _vm._e()]), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu",
      attrs: {
        "aria-labelledby": "dropdownMenu2"
      }
    }, _vm._l((_vm.listKelas), function(item) {
      return _c('div', {
        key: item,
        on: {
          "click": function($event) {
            return _vm.addGrade(i, item)
          }
        }
      }, [(_vm.hideClass(item, _vm.internalSelectedClass)) ? _c('li', {
        staticStyle: {
          "padding": "10px"
        }
      }, [_c('a', [_vm._v("Kelas " + _vm._s(item))])]) : _vm._e()])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (d.title),
        expression: "d.title"
      }],
      staticClass: "form-control",
      attrs: {
        "maxlength": "220",
        "cols": "30",
        "rows": "5"
      },
      domProps: {
        "value": (d.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(d, "title", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-3"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (d.description),
        expression: "d.description"
      }],
      staticClass: "form-control",
      attrs: {
        "id": "",
        "cols": "30",
        "rows": "5"
      },
      domProps: {
        "value": (d.description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(d, "description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2",
      staticStyle: {
        "display": "flex",
        "flex-flow": "column",
        "justify-content": "center"
      }
    }, [_c('input', {
      attrs: {
        "id": "fileUpload",
        "type": "file",
        "hidden": "",
        "accept": "image/*"
      },
      on: {
        "change": _vm.onFileChange
      }
    }), _vm._v(" "), (d.image == '') ? _c('button', {
      staticClass: "btn btn-warning",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.chooseFiles(d, i)
        }
      }
    }, [_vm._v("\n                  Pilih Gambar "), _c('i', {
      staticClass: "fa fa-image"
    })]) : _vm._e(), _vm._v(" "), (d.image !== '') ? _c('img', {
      staticStyle: {
        "height": "100px"
      },
      attrs: {
        "src": d.image + '?rnd=' + Math.random(1231231)
      }
    }) : _vm._e(), _vm._v(" "), (d.image !== '') ? _c('button', {
      staticClass: "btn btn-info btn-xs",
      staticStyle: {
        "margin-top": "10px"
      },
      on: {
        "click": function($event) {
          _vm.mInternalAdsData[i].image = ''
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2",
      staticStyle: {
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
        "flex-flow": "row"
      }
    }, [_c('button', {
      staticClass: "btn btn-success btn-xl",
      staticStyle: {
        "margin-right": "10px"
      },
      on: {
        "click": function($event) {
          return _vm.saveInternalSetting(d, i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-save"
    })]), _vm._v(" "), (i + 1 !== _vm.mInternalAdsData.length) ? _c('button', {
      staticClass: "btn btn-danger btn-xl",
      on: {
        "click": function($event) {
          return _vm.deleteAds(d.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])
  })], 2)])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "msg"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Pengaturan")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('h5', [_vm._v("Kelas")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Judul")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('h5', [_vm._v("Deskripsi")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('h5', [_vm._v("Image")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })])
}]}

/***/ }),
/* 1387 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/tryouts",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("Tryout")])])])
},staticRenderFns: []}

/***/ }),
/* 1388 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/sbmptn",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-pencil"
  }), _c('span', [_vm._v("SNBT")])])])
},staticRenderFns: []}

/***/ }),
/* 1389 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "user-management"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Tryout")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Tryout Regrading")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("List Tryout Participants")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "searchbox",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Start Date*")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control datepicker",
    staticStyle: {
      "color": "black !important",
      "background": "white !important"
    },
    attrs: {
      "id": "filterStart",
      "type": "text",
      "name": "discussion_date",
      "readonly": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("End Date*")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-xs-12",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    staticClass: "form-control datepicker",
    staticStyle: {
      "color": "black !important",
      "background": "white !important"
    },
    attrs: {
      "id": "filterEnd",
      "type": "text",
      "name": "discussion_date",
      "readonly": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter.state),
      expression: "filter.state"
    }],
    staticClass: "form-control",
    staticStyle: {
      "width": "100px",
      "margin-left": "10px"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filter, "state", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "FINISHED"
    }
  }, [_vm._v("FINISHED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "STARTED"
    }
  }, [_vm._v("STARTED")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "font-size": "14px",
      "margin-left": "10px"
    },
    on: {
      "click": function($event) {
        return _vm.loadOrganizationsData(1)
      }
    }
  }, [_vm._v("Apply")])])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 text-left"
  }, [_c('button', {
    staticClass: "btn btn-success",
    staticStyle: {
      "padding": "5px",
      "margin-right": "15px"
    },
    attrs: {
      "disabled": _vm.filter.start_date == null && _vm.filter.end_date == null && _vm.organizations.length == 0
    },
    on: {
      "click": function($event) {
        _vm.showConfirmationModal = true
      }
    }
  }, [_vm._v("Grading Ulang")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "15px",
      "color": "black",
      "font-weight": "bold"
    }
  }, [_vm._v("Total Item: " + _vm._s(_vm.totalItem))])])]), _vm._v(" "), _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.organizations), function(organization, key) {
    return _c('tr', {
      key: key
    }, [_c('td', [_vm._v(_vm._s((25 * (_vm.pageNumber - 1)) + (key + 1)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(organization.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(organization.email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(organization.tryout.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("convertDate")(organization.created_at)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-footer"
  }, [_c('div', {
    staticClass: "btn-group",
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.pageNumber === 1,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadOrganizationsData(--_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Previous\n            ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "width": "80px",
      "text-align": "center"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm.pageNumber + ' / ' + _vm.total_page
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-white",
    attrs: {
      "disabled": _vm.pageNumber === _vm.total_page,
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.loadOrganizationsData(++_vm.pageNumber)
      }
    }
  }, [_vm._v("\n              Next\n            ")])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), (_vm.showConfirmationModal) ? _c('app-modal', {
    attrs: {
      "withCancel": true
    },
    on: {
      "cancel": function($event) {
        _vm.showConfirmationModal = false
      },
      "ok": function($event) {
        return _vm.submitRegrading()
      }
    }
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Konfirmasi")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v("Apakah ada yakin akan regrading untuk  "), _c('strong', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.totalItem) + " siswa ?")])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading",
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "50%"
    }
  }, [_vm._v("\n            Daftar Partisipan\n          ")]), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("No.")]), _vm._v(" "), _c('th', [_vm._v("Nama Siswa")]), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Nama Tryout")]), _vm._v(" "), _c('th', [_vm._v("Tanggal Mulai")])])])
}]}

/***/ }),
/* 1390 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Setting Affiliate")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Setting Affiliate")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h4', [_vm._v("Configuration Affiliate")]), _vm._v(" "), _c('div', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("1 Rupiah (Sama dengan)")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.coin_to_rupiah),
      expression: "formConfig.coin_to_rupiah"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam koin"
    },
    domProps: {
      "value": (_vm.formConfig.coin_to_rupiah)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "coin_to_rupiah", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Minimum cash withdrawal")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": ""
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.minimum_coin_withdraw),
      expression: "formConfig.minimum_coin_withdraw"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam Rupiah"
    },
    domProps: {
      "value": (_vm.formConfig.minimum_coin_withdraw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "minimum_coin_withdraw", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Rupiah")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "250px",
      "display": "flex",
      "align-items": "center",
      "padding-left": "20px"
    }
  }, [_vm._v("=  "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.formConfig.minimum_coin_withdraw * _vm.formConfig.coin_to_rupiah)))]), _vm._v("  Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Biaya admin")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": ""
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.admin_coin_fee),
      expression: "formConfig.admin_coin_fee"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam Rupiah"
    },
    domProps: {
      "value": (_vm.formConfig.admin_coin_fee)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "admin_coin_fee", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Rupiah")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "250px",
      "display": "flex",
      "align-items": "center",
      "padding-left": "20px"
    }
  }, [_vm._v("=  "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.formConfig.admin_coin_fee * _vm.formConfig.coin_to_rupiah)))]), _vm._v("  Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Kelipatan")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-flow": ""
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.multiple_coin_withdraw),
      expression: "formConfig.multiple_coin_withdraw"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Bilangan dalam Rupiah"
    },
    domProps: {
      "value": (_vm.formConfig.multiple_coin_withdraw)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "multiple_coin_withdraw", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    }
  }, [_vm._v("Rupiah")])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "width": "250px",
      "display": "flex",
      "align-items": "center",
      "padding-left": "20px"
    }
  }, [_vm._v("=  "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.formConfig.multiple_coin_withdraw *
    _vm.formConfig.coin_to_rupiah)))]), _vm._v("  Koin")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-2 control-label"
  }, [_vm._v("Captions Share Link")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-xs-12"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formConfig.affiliate_message),
      expression: "formConfig.affiliate_message"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Caption Share Product"
    },
    domProps: {
      "value": (_vm.formConfig.affiliate_message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formConfig, "affiliate_message", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "background": "white",
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "white",
      "font-weight": "bold",
      "margin": "10px"
    }
  }, [_vm._v("Tekan untuk menyimpan semua perubahan\n                        data!")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-large",
    on: {
      "click": function($event) {
        return _vm.saveData()
      }
    }
  }, [_vm._v("\n                        Simpan\n                      ")])])])])]), _vm._v(" "), _c('h4', [_vm._v("Persentase Komisi :")]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-bottom": "15px",
      "padding-left": "0px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.grade),
      expression: "grade"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeClass()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Kelas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("Kelas 4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("Kelas 5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("Kelas 6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("Kelas 7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("Kelas 8")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("Kelas 9")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("Kelas 10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("Kelas 11")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("Kelas 12")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-bottom": "15px",
      "padding-left": "0px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.state),
      expression: "state"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.state = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeState()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Semua Status")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SUBSCRIPTION"
    }
  }, [_vm._v("SUBSCRIPTION")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TICKET"
    }
  }, [_vm._v("TICKET")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PUBLISHED"
    }
  }, [_vm._v("PUBLISHED")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UNPUBLISHED"
    }
  }, [_vm._v("UNPUBLISHED")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchText),
      expression: "searchText"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "cari nama produk"
    },
    domProps: {
      "value": (_vm.searchText)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchfunction()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchText = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon2"
    },
    on: {
      "click": function($event) {
        return _vm.searchfunction()
      }
    }
  }, [_vm._v("Search")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "btn-group",
    attrs: {
      "role": "group",
      "aria-label": "..."
    }
  }, [(_vm.pagination.currentPage !== 1) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.previous()
      }
    }
  }, [_vm._v("Previous")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.pagination.currentPage + ' / ' +
    _vm.listProduk[0].page))]), _vm._v(" "), (_vm.pagination.currentPage < _vm.listProduk[0].page) ? _c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v("Next")]) : _vm._e()])]), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.listProduk), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "list-group-item",
      staticStyle: {
        "display": "flex",
        "flex-flow": "row"
      }
    }, [_c('div', {
      staticClass: "col-md-2 col-xs-6"
    }, [_c('img', {
      staticStyle: {
        "width": "120px"
      },
      attrs: {
        "src": item.picture
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-4"
    }, [_c('h4', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "font-size": "15px",
        "color": "green"
      }
    }, [_vm._v("Rp " + _vm._s(_vm._f("currency")(item.net_price)))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin": "15px 15px 15px 0px"
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.short_description),
        expression: "item.short_description"
      }],
      staticClass: "form-control",
      attrs: {
        "disabled": item.edit === false,
        "placeholder": "Meta Tag Sosmed"
      },
      domProps: {
        "value": (item.short_description)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "short_description", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "input-group",
      staticStyle: {
        "width": "100px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.persentate_commission),
        expression: "item.persentate_commission"
      }],
      staticClass: "form-control",
      staticStyle: {
        "border": "2px solid green"
      },
      attrs: {
        "disabled": item.edit === false,
        "type": "number",
        "placeholder": "Dalam persen"
      },
      domProps: {
        "value": (item.persentate_commission)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(item, "persentate_commission", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "input-group-addon",
      attrs: {
        "id": "basic-addon2"
      }
    }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 col-xs-2"
    }, [(item.edit === false) ? _c('button', {
      staticClass: "btn btn-warning btn-large",
      on: {
        "click": function($event) {
          item.edit = true
        }
      }
    }, [_vm._v("\n                      Edit\n                    ")]) : _vm._e(), _vm._v(" "), (item.edit === true) ? _c('button', {
      staticClass: "btn btn-success btn-large",
      attrs: {
        "disabled": item.status === 'UNPUBLISHED'
      },
      on: {
        "click": function($event) {
          return _vm.updateProduct(item)
        }
      }
    }, [_vm._v("\n                      Simpan\n                    ")]) : _vm._e()])])
  }), 0)])])])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e(), _vm._v(" "), _c('p', {
    attrs: {
      "id": "msg"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Setting")])])
}]}

/***/ }),
/* 1391 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "markdown-editor"
    }
  }, [_c('div', {
    staticClass: "panel panel-default",
    attrs: {
      "data-sortable-id": "ui-widget-8"
    }
  }, [_c('div', {
    staticClass: "panel-toolbar"
  }, [_c('div', {
    staticClass: "btn-group m-r-5"
  }, [_c('a', {
    staticClass: "btn btn-white",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Markdown")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-white",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.preview
    }
  }, [_vm._v("Preview")]), _vm._v(" "), _c('app-fileupload', {
    attrs: {
      "context": _vm.context
    },
    on: {
      "uploaded": function($event) {
        return _vm.imageUploaded($event)
      }
    }
  }), _vm._v(" "), _c('app-podbean-explorer', {
    on: {
      "selected": function($event) {
        return _vm.itemSelected($event)
      }
    }
  })], 1)]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "form-control no-rounded-corner",
    attrs: {
      "rows": _vm.rows,
      "readOnly": _vm.readOnly
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.showModal) ? _c('app-modal', {
    on: {
      "ok": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('h4', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Markdown Preview")]), _vm._v(" "), _c('div', {
    ref: "test",
    attrs: {
      "slot": "body"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.compiledContent)
    },
    slot: "body"
  })]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1392 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "liga-personal-brackets"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: '/liga-personal'
      }
    }
  }, [_vm._v("Menu Liga Personal")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Brackets")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Bracket")]), _vm._v(" "), _c('div', [_c('bracket', {
    attrs: {
      "rounds": _vm.rounds
    },
    scopedSlots: _vm._u([{
      key: "player",
      fn: function(ref) {
        var player = ref.player;

        return [_vm._v("\n\t\t\t\t\t" + _vm._s(player.name) + "\n\t\t\t\t")]
      }
    }, {
      key: "player-extension-bottom",
      fn: function(ref) {
        var match = ref.match;

        return [_vm._v("\n\t\t\t\t\tExtra info: " + _vm._s(match.title) + "\n\t\t\t\t")]
      }
    }])
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 1393 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itemChooser"
    }
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    on: {
      "click": function($event) {
        _vm.showModal = true
      }
    }
  }), _vm._v(" "), (_vm.showModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [(_vm.sourcetype === 'EXTERNAL' || _vm.sourcetype === null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Bab:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chapterIndex),
      expression: "chapterIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.chapterIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("-- PILIH BAB --")]), _vm._v(" "), _vm._l((_vm.topics), function(chapter, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                    " + _vm._s(chapter.nama) + "\n                  ")])
  })], 2)]), _vm._v(" "), (
    _vm.chapterIndex !== '' && _vm.topics[_vm.chapterIndex].subs.length > 0
  ) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Sub Bab (Optional):")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subChapterIndex),
      expression: "subChapterIndex"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.subChapterIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("-- PILIH SUB BAB --")]), _vm._v(" "), _vm._l((_vm.topics[_vm.chapterIndex].subs), function(sub, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": index
      }
    }, [_vm._v("\n                    " + _vm._s(sub.nama) + "\n                  ")])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.chapterIndex !== '') ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Gunakan tipe semua")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allFilterToggle),
      expression: "allFilterToggle"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allFilterToggle) ? _vm._i(_vm.allFilterToggle, null) > -1 : (_vm.allFilterToggle)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.allFilterToggle,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allFilterToggle = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allFilterToggle = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allFilterToggle = $$c
        }
      }
    }
  }), _vm._v(" Tipe semua\n                (4)\n              ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row m-t-10"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.search()
      }
    }
  }, [_vm._v("\n                  Cari\n                ")])])]), _vm._v(" "), (_vm.items.length > 0) ? _c('div', {
    staticClass: "row m-t-10"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.items,
      "headers": _vm.headers
    },
    on: {
      "selected": function($event) {
        _vm.selectedItem = $event
      },
      "dblClicked": function($event) {
        return _vm.confirmSelectedItem()
      }
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("\n              Tutup\n            ")])])])])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": {
        path: '/items',
        query: {
          mapel: _vm.item.id
        }
      },
      "tag": "li"
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.item.nama))])])
},staticRenderFns: []}

/***/ }),
/* 1395 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "modul-material"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/modul-belajar'
      }
    }
  }, [_vm._v("Modul Belajar")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/modul-belajar/form'
      }
    }
  }, [_vm._v("Informasi Umum")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Live Stream")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Kelola Live Stream")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createMaterial()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Live Stream")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Daftar Live Stream")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.jenjang == 'SD'
    },
    on: {
      "click": function($event) {
        _vm.jenjang = 'SD'
      }
    }
  }, [_vm._v("SD")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.jenjang == 'SMP'
    },
    on: {
      "click": function($event) {
        _vm.jenjang = 'SMP'
      }
    }
  }, [_vm._v("SMP")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.jenjang == 'SMA'
    },
    on: {
      "click": function($event) {
        _vm.jenjang = 'SMA'
      }
    }
  }, [_vm._v("SMA")])]), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [(_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 1
    },
    on: {
      "click": function($event) {
        _vm.kelas = 1
      }
    }
  }, [_vm._v("1")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 2
    },
    on: {
      "click": function($event) {
        _vm.kelas = 2
      }
    }
  }, [_vm._v("2")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 3
    },
    on: {
      "click": function($event) {
        _vm.kelas = 3
      }
    }
  }, [_vm._v("3")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 4
    },
    on: {
      "click": function($event) {
        _vm.kelas = 4
      }
    }
  }, [_vm._v("4")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 5
    },
    on: {
      "click": function($event) {
        _vm.kelas = 5
      }
    }
  }, [_vm._v("5")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SD') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 6
    },
    on: {
      "click": function($event) {
        _vm.kelas = 6
      }
    }
  }, [_vm._v("6")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMP') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 7
    },
    on: {
      "click": function($event) {
        _vm.kelas = 7
      }
    }
  }, [_vm._v("7")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMP') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 8
    },
    on: {
      "click": function($event) {
        _vm.kelas = 8
      }
    }
  }, [_vm._v("8")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMP') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 9
    },
    on: {
      "click": function($event) {
        _vm.kelas = 9
      }
    }
  }, [_vm._v("9")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMA') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 10
    },
    on: {
      "click": function($event) {
        _vm.kelas = 10
      }
    }
  }, [_vm._v("10")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMA') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 11
    },
    on: {
      "click": function($event) {
        _vm.kelas = 11
      }
    }
  }, [_vm._v("11")]) : _vm._e(), _vm._v(" "), (_vm.jenjang == 'SMA') ? _c('button', {
    staticClass: "btn btn-sm m-r-5",
    class: {
      'btn-inverse': _vm.kelas == 12
    },
    on: {
      "click": function($event) {
        _vm.kelas = 12
      }
    }
  }, [_vm._v("12")]) : _vm._e()]), _c('hr'), _vm._v(" "), _c('app-datatable', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.rows,
      "has-preview": true,
      "has-publish": true
    },
    on: {
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "dblClicked": function($event) {
        return _vm.editMaterial()
      },
      "deleted": function($event) {
        return _vm.deleteItem($event)
      },
      "publishing": function($event) {
        return _vm.publish($event)
      },
      "unpublishing": function($event) {
        return _vm.unpublish($event)
      }
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 1396 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": "/voucher",
      "tag": "li"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-ticket"
  }), _c('span', [_vm._v("Kode Voucher")])])])
},staticRenderFns: []}

/***/ }),
/* 1397 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/tryouts'
      }
    }
  }, [_vm._v("Tryout")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Import Tryout")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Import Tryout")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body",
    staticStyle: {
      "display": "flex",
      "flex-flow": "column"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorParse) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _vm._m(1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_vm._v("Upload File JSON")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('input', {
    ref: "file",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        return _vm.onFileChange()
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-info btn-md",
    staticStyle: {
      "max-width": "200px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.file.click()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-file"
  }), _vm._v(" Pilih File JSON")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Masukkan file dalam format JSON")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [(!_vm.isReadable) ? _c('button', {
    staticClass: "btn btn-info btn-md pull-right",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.previewJSON()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-table"
  }), _vm._v(" Preview")]) : _vm._e()])]), _vm._v(" "), (_vm.tryouts.length > 0) ? _c('div', {
    staticStyle: {
      "padding-top": "20px",
      "padding-bottom": "10px"
    }
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.tryouts,
      "headers": _vm.headers,
      "has-action": false,
      "has-custom-pagination": false,
      "has-custom-search": false,
      "has-search-power": false
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    staticStyle: {
      "max-width": "300px",
      "float": "right",
      "margin": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-download"
  }), _vm._v(" Import")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success btn-md",
    staticStyle: {
      "max-width": "300px",
      "float": "right",
      "margin": "10px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.cancelImport()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-close"
  }), _vm._v(" Batal")])], 1) : _vm._e()])])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Import Tryout")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticStyle: {
      "text-decoration": "none"
    }
  }, [_c('li', [_vm._v("File tidak bisa dibaca")]), _vm._v(" "), _c('li', [_vm._v("Pastikan jenis file (.JSON / .json)")]), _vm._v(" "), _c('li', [_vm._v("Format JSON tidak valid")]), _vm._v(" "), _c('li', [_vm._v("Atau "), _c('a', {
    staticStyle: {
      "color": "red",
      "text-decoration": "revert"
    },
    attrs: {
      "href": "https://codebeautify.org/jsonviewer",
      "target": "_blank"
    }
  }, [_vm._v("Periksa text JSON anda disini")])])])
}]}

/***/ }),
/* 1398 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "itembank-form"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("Push Notification")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("Push Notification")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary-outline",
    attrs: {
      "data-toggle": "collapse",
      "data-target": "#demo"
    }
  }, [_vm._v("\n                List Push Notif\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "collapse",
    attrs: {
      "id": "demo"
    }
  }, [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', _vm._l((_vm.headers), function(item, index) {
    return _c('th', {
      key: index
    }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
  }), 0), _vm._v(" "), _c('tbody', _vm._l((_vm.listPush), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(item.channel))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("convertDate")(item.scheduled_at)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("convertDate")(item.created_at)))])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 text-right",
    staticStyle: {
      "display": "flex",
      "justify-content": "flex-end",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.pagination.current_page === 1
    },
    on: {
      "click": function($event) {
        return _vm.paging(-1)
      }
    }
  }, [_vm._v("\n                    Previous\n                  ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px",
      "font-size": "18px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.pagination.current_page + '/' + _vm.pagination.total_page) + "\n                  ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": _vm.pagination.current_page === _vm.pagination.total_page
    },
    on: {
      "click": function($event) {
        return _vm.paging(1)
      }
    }
  }, [_vm._v("\n                    Next\n                  ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body panel-form"
  }, [(this.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger fade in m-b-15"
  }, [_c('span', {
    staticClass: "close",
    attrs: {
      "data-dismiss": "alert"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('strong', [_vm._v("Terjadi kesalahan!")]), _vm._v(" "), _c('ul', _vm._l((this.errors), function(message, key) {
    return _c('li', {
      key: key
    }, [_vm._v("\n                " + _vm._s(message) + "\n              ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _c('form', {
    staticStyle: {
      "margin-top": "20px",
      "margin-left": "20px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Mode Notifikasi")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputMode),
      expression: "inputMode"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.inputMode = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Notifikasi Umum")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("Notifikasi Dengan Konten")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Jadwalkan Push Notif")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7 col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduledDate),
      expression: "scheduledDate"
    }],
    staticClass: "form-control datepicker",
    attrs: {
      "id": "scheduledDate",
      "type": "text",
      "placeholder": "Tanggal Notif akan dipush",
      "name": "scheduled_date",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.scheduledDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scheduledDate = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-xs-12"
  }, [_c('div', {
    staticClass: "input-group clockpicker"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scheduledTime),
      expression: "scheduledTime"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "scheduledTime",
      "type": "text",
      "placeholder": "Jam : Menit",
      "name": "scheduled_time",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.scheduledTime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.scheduledTime = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('title') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Judul")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.title),
      expression: "form.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "title", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('text') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Pesan")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.text),
      expression: "form.text"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "cols": "130",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.form.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "text", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('imageurl') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Gambar")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.imageurl),
      expression: "form.imageurl"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.imageurl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "imageurl", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('content') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Konten")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.content),
      expression: "form.content"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "",
      "id": "",
      "cols": "130",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.form.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "content", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Link (opsional)")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.link),
      expression: "form.link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "link", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), (_vm.inputMode === '2') ? _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.indexOf('cta') >= 0
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Call to Action")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.cta),
      expression: "form.cta"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.cta)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "cta", $event.target.value)
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.nextButton()
      }
    }
  }, [_vm._v("\n                Selanjutnya\n              ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "konfirmpushnotif",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModal",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [(_vm.modeDialogForm == '1') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            FCM Token\n            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fcmtoken),
      expression: "fcmtoken"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.fcmtoken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.fcmtoken = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        return _vm.submitNotification('test')
      }
    }
  }, [_vm._v("\n                Kirim Test\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.submitNotification('all')
      }
    }
  }, [_vm._v("\n                Kirim Semua\n              ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modeDialogForm == '2') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Data testing berhasil terkirim")]), _vm._v(" "), _c('p', [_vm._v("Harap periksa apakah notifikasi sudah berhasil diterima")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n                Edit Pesan\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.submitNotification('all')
      }
    }
  }, [_vm._v("\n                Kirim Semua\n              ")])])])]) : _vm._e(), _vm._v(" "), (_vm.modeDialogForm == '3') ? _c('div', {
    staticClass: "modal-body"
  }, [_c('p', [_vm._v("Data berhasil terkirim ke seluruh user")]), _vm._v(" "), _c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v("\n                OK\n              ")])])])]) : _vm._e()])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("Form Push Notif")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-calendar"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  })])])
}]}

/***/ }),
/* 1399 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app-spinner"
    }
  }, [_c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    staticStyle: {
      "max-width": "25%",
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "fa fa-spinner",
    attrs: {
      "id": "spinner"
    }
  }), _vm._v("   Loading...\n        ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1400 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [(_vm.isMapping) ? _c('h3', [_vm._v("\n            Mapping Siswa\n          ")]) : _c('h3', [_vm._v("\n            Bulk Activation / Registration Upload .CSV\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._t("body", function() {
    return [_c('form', [_c('div', {
      staticClass: "form-horizontal form-bordered"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Duration (bulan) "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.duration),
        expression: "data.duration"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.data, "duration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', [_vm._v("1")]), _vm._v(" "), _c('option', [_vm._v("2")]), _vm._v(" "), _c('option', [_vm._v("3")]), _vm._v(" "), _c('option', [_vm._v("4")]), _vm._v(" "), _c('option', [_vm._v("5")]), _vm._v(" "), _c('option', [_vm._v("6")]), _vm._v(" "), _c('option', [_vm._v("7")]), _vm._v(" "), _c('option', [_vm._v("8")]), _vm._v(" "), _c('option', [_vm._v("9")]), _vm._v(" "), _c('option', [_vm._v("10")]), _vm._v(" "), _c('option', [_vm._v("11")]), _vm._v(" "), _c('option', [_vm._v("12")])])])]), _vm._v(" "), (!_vm.isMapping) ? _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("File "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12"
    }, [_c('div', {
      staticClass: "row"
    }, [(_vm.filename) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('p', [_vm._v(_vm._s(_vm.filename))])]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('div', {
      attrs: {
        "id": "fileupload"
      }
    }, [_c('label', {
      staticClass: "btn btn-white"
    }, [_c('i', {
      staticClass: "fa fa-paperclip"
    }, [_c('input', {
      staticStyle: {
        "display": "none"
      },
      attrs: {
        "type": "file",
        "accept": ".csv"
      },
      on: {
        "change": _vm.upload
      }
    })])])])])])])]) : _vm._e(), _vm._v(" "), (!_vm.isMapping) ? _c('section', [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Password")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8 col-xs-12",
      staticStyle: {
        "position": "relative"
      }
    }, [(_vm.hidePass) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.default_password),
        expression: "data.default_password"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "password"
      },
      domProps: {
        "value": (_vm.data.default_password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "default_password", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.hidePass) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.data.default_password),
        expression: "data.default_password"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (_vm.data.default_password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.data, "default_password", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.hidePass) ? _c('i', {
      staticClass: "fa fa-eye eyeicon",
      on: {
        "click": function($event) {
          _vm.hidePass = false
        }
      }
    }) : _vm._e(), _vm._v(" "), (!_vm.hidePass) ? _c('i', {
      staticClass: "fa fa-eye-slash eyeicon",
      on: {
        "click": function($event) {
          _vm.hidePass = true
        }
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Kelas")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.jenjang),
        expression: "jenjang"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.jenjang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, [_c('option', {
      attrs: {
        "value": "SD"
      }
    }, [_vm._v("SD")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "SMP"
      }
    }, [_vm._v("SMP")]), _vm._v(" "), _c('option', {
      attrs: {
        "value": "SMA"
      }
    }, [_vm._v("SMA")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.grade),
        expression: "grade"
      }],
      staticClass: "form-control",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.grade = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }
      }
    }, _vm._l((_vm.jenjangList), function(item, index) {
      return _c('option', {
        key: index,
        domProps: {
          "value": item
        }
      }, [_vm._v("\n                          " + _vm._s(item) + "\n                        ")])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      staticClass: "col-md-2 control-label"
    }, [_vm._v("Fitur")]), _vm._v(" "), _c('div', {
      staticClass: "col-md-4 col-xs-12",
      staticStyle: {
        "display": "flex",
        "flex-flow": "column"
      }
    }, [_vm._l((_vm.featureList), function(item, index) {
      return _c('span', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.features),
          expression: "features"
        }],
        staticClass: "checkbox m-r-5",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": item,
          "checked": Array.isArray(_vm.features) ? _vm._i(_vm.features, item) > -1 : (_vm.features)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.features,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = item,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.features = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.features = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.features = $$c
            }
          }
        }
      }), _c('span', {
        staticClass: "f-s-14 f-w-700 m-r-10"
      }, [_vm._v("\n                          " + _vm._s(item === 'INSTANT_TRYOUT' ? 'Tryout Instan' : item === 'CONSULTATION' ? 'Konsultasi' : item === 'DUEL' ? 'Duel' : item === 'ITEM_BANK' ? 'Bank Soal' : item === 'SCHEDULED_TRYOUT' ? 'Tryout Terjadwal' : item === 'VIDEO' ? 'Video Pembelajaran' : item === 'BIMBEL' ? 'Bimbel' : '') + "\n                        ")])])
    }), _vm._v(" "), _c('span', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.featBimbel),
        expression: "featBimbel"
      }],
      staticClass: "checkbox m-r-5",
      attrs: {
        "type": "checkbox",
        "value": "true"
      },
      domProps: {
        "checked": Array.isArray(_vm.featBimbel) ? _vm._i(_vm.featBimbel, "true") > -1 : (_vm.featBimbel)
      },
      on: {
        "change": function($event) {
          var $$a = _vm.featBimbel,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "true",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.featBimbel = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.featBimbel = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.featBimbel = $$c
          }
        }
      }
    }), _c('span', {
      staticClass: "f-s-14 f-w-700 m-r-10"
    }, [_vm._v("Bimbel")])])], 2), _vm._v(" "), (_vm.featBimbel) ? _c('div', {
      staticClass: "col-md-6 col-xs-12",
      staticStyle: {
        "display": "flex",
        "flex-flow": "column",
        "max-height": "200px",
        "overflow": "auto"
      }
    }, [_c('span', [_c('h5', [_vm._v("Pilih Daftar Bimbel")])]), _vm._v(" "), (_vm.bimbelList.length === 0) ? _c('span', [_vm._v("Tidak ada bimbel yang bisa dipilih "), _c('br'), _vm._v("Silahkan pilih kelas lain atau buat bimbel baru")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bimbelList), function(item, index) {
      return _c('span', {
        key: index
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.bimbels),
          expression: "bimbels"
        }],
        staticClass: "checkbox m-r-5",
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "value": item.id,
          "checked": Array.isArray(_vm.bimbels) ? _vm._i(_vm.bimbels, item.id) > -1 : (_vm.bimbels)
        },
        on: {
          "change": function($event) {
            var $$a = _vm.bimbels,
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = item.id,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.bimbels = $$a.concat([$$v]))
              } else {
                $$i > -1 && (_vm.bimbels = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
              }
            } else {
              _vm.bimbels = $$c
            }
          }
        }
      }), _c('span', {
        staticClass: "f-s-14 f-w-700 m-r-10"
      }, [_vm._v(_vm._s(item.name))])])
    })], 2) : _vm._e()])]) : _vm._e()])])]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_vm._t("footer", function() {
    return [_c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          return _vm.$emit('close')
        }
      }
    }, [_vm._v("\n              Cancel\n            ")]), _vm._v(" "), (!_vm.isMapping) ? _c('a', {
      staticClass: "btn btn-success",
      attrs: {
        "href": _vm.ossTemplate,
        "target": "_blank"
      }
    }, [_vm._v("\n              Download Example CSV\n            ")]) : _vm._e(), _vm._v(" "), (_vm.isMapping) ? _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": !_vm.data.duration
      },
      on: {
        "click": function($event) {
          return _vm.$emit('submitMapping', _vm.data.duration)
        }
      }
    }, [_vm._v("\n              Submit\n            ")]) : _c('button', {
      staticClass: "btn btn-success",
      attrs: {
        "disabled": !_vm.data.duration || !_vm.filename
      },
      on: {
        "click": _vm.submitBulkActivation
      }
    }, [_vm._v("\n              Submit\n            ")])]
  })], 2), _vm._v(" "), (_vm.isLoadActivationAsyncProgress) ? _c('app-spinner') : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 1401 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "register-liga"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Register Liga")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("List Register Liga")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createRegisterLiga()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Register Liga")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Register Liga")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.registerLigaList,
      "headers": _vm.headers
    },
    on: {
      "dblClicked": function($event) {
        return _vm.updateRegisterLiga()
      },
      "deleted": function($event) {
        return _vm.deleteRegisterLiga($event)
      },
      "selected": function($event) {
        _vm.selectedRow = $event
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1402 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "tryout-chooser"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.newInitData()
      }
    }
  }, [_vm._v("Pilih")]), _vm._v(" "), (_vm.showModal) ? _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container",
    attrs: {
      "id": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.rows,
      "headers": _vm.headers,
      "has-action": false,
      "has-custom-pagination": true,
      "has-custom-search": true,
      "custom-pagination-current-page": _vm.pagination.currentPage,
      "custom-pagination-per-page": _vm.pagination.perPage,
      "custom-pagination-total-pages": _vm.pagination.totalPages,
      "custom-pagination-sort-mode": _vm.pagination.sortMode
    },
    on: {
      "dblClicked": function($event) {
        return _vm.tryoutSelected($event)
      },
      "selected": function($event) {
        _vm.selectedRow = $event
      },
      "changePage": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {currentPage: $event})
      },
      "changeSortMode": function($event) {
        _vm.pagination = Object.assign({}, _vm.pagination,
          {sortMode: $event})
      },
      "doSearch": function($event) {
        _vm.search = {
          query: $event.value,
          by: _vm.headersKey[$event.key]
        }
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_vm._v("Close")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1414 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1415 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1416 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1417 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1418 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1419 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1420 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1421 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1422 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[951]);


// WEBPACK FOOTER //
// static/js/app.21f2a6d381f852751778.js